webpackJsonp([1,0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.26.0
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(870)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged and will be removed in an upcoming major release. Please refer to ' +
	            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.26.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(126)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(36);
	var hide = __webpack_require__(25);
	var redefine = __webpack_require__(26);
	var ctx = __webpack_require__(37);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = function normalizeComponent (
	  rawScriptExports,
	  compiledTemplate,
	  scopeId,
	  cssModules
	) {
	  var esModule
	  var scriptExports = rawScriptExports = rawScriptExports || {}
	
	  // ES6 modules interop
	  var type = typeof rawScriptExports.default
	  if (type === 'object' || type === 'function') {
	    esModule = rawScriptExports
	    scriptExports = rawScriptExports.default
	  }
	
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (compiledTemplate) {
	    options.render = compiledTemplate.render
	    options.staticRenderFns = compiledTemplate.staticRenderFns
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = scopeId
	  }
	
	  // inject cssModules
	  if (cssModules) {
	    var computed = options.computed || (options.computed = {})
	    Object.keys(cssModules).forEach(function (key) {
	      var module = cssModules[key]
	      computed[key] = function () { return module }
	    })
	  }
	
	  return {
	    esModule: esModule,
	    exports: scriptExports,
	    options: options
	  }
	}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(99)('wks');
	var uid = __webpack_require__(72);
	var Symbol = __webpack_require__(5).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(203);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(878);


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(39);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(6)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(4);
	var IE8_DOM_DEFINE = __webpack_require__(233);
	var toPrimitive = __webpack_require__(44);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(14) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warning = undefined;
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(103);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.format = format;
	exports.isEmptyValue = isEmptyValue;
	exports.isEmptyObject = isEmptyObject;
	exports.asyncMap = asyncMap;
	exports.complementError = complementError;
	exports.deepMerge = deepMerge;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var formatRegExp = /%[sdj%]/g;
	
	var warning = exports.warning = function warning() {};
	
	// don't print warning message when in production env or node runtime
	if (false) {
	  exports.warning = warning = function warning(type, errors) {
	    if (typeof console !== 'undefined' && console.warn) {
	      if (errors.every(function (e) {
	        return typeof e === 'string';
	      })) {
	        console.warn(type, errors);
	      }
	    }
	  };
	}
	
	function format() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var i = 1;
	  var f = args[0];
	  var len = args.length;
	  if (typeof f === 'function') {
	    return f.apply(null, args.slice(1));
	  }
	  if (typeof f === 'string') {
	    var str = String(f).replace(formatRegExp, function (x) {
	      if (x === '%%') {
	        return '%';
	      }
	      if (i >= len) {
	        return x;
	      }
	      switch (x) {
	        case '%s':
	          return String(args[i++]);
	        case '%d':
	          return Number(args[i++]);
	        case '%j':
	          try {
	            return JSON.stringify(args[i++]);
	          } catch (_) {
	            return '[Circular]';
	          }
	          break;
	        default:
	          return x;
	      }
	    });
	    for (var arg = args[i]; i < len; arg = args[++i]) {
	      str += ' ' + arg;
	    }
	    return str;
	  }
	  return f;
	}
	
	function isNativeStringType(type) {
	  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
	}
	
	function isEmptyValue(value, type) {
	  if (value === undefined || value === null) {
	    return true;
	  }
	  if (type === 'array' && Array.isArray(value) && !value.length) {
	    return true;
	  }
	  if (isNativeStringType(type) && typeof value === 'string' && !value) {
	    return true;
	  }
	  return false;
	}
	
	function isEmptyObject(obj) {
	  return Object.keys(obj).length === 0;
	}
	
	function asyncParallelArray(arr, func, callback) {
	  var results = [];
	  var total = 0;
	  var arrLength = arr.length;
	
	  function count(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === arrLength) {
	      callback(results);
	    }
	  }
	
	  arr.forEach(function (a) {
	    func(a, count);
	  });
	}
	
	function asyncSerialArray(arr, func, callback) {
	  var index = 0;
	  var arrLength = arr.length;
	
	  function next(errors) {
	    if (errors && errors.length) {
	      callback(errors);
	      return;
	    }
	    var original = index;
	    index = index + 1;
	    if (original < arrLength) {
	      func(arr[original], next);
	    } else {
	      callback([]);
	    }
	  }
	
	  next([]);
	}
	
	function flattenObjArr(objArr) {
	  var ret = [];
	  Object.keys(objArr).forEach(function (k) {
	    ret.push.apply(ret, objArr[k]);
	  });
	  return ret;
	}
	
	function asyncMap(objArr, option, func, callback) {
	  if (option.first) {
	    var flattenArr = flattenObjArr(objArr);
	    return asyncSerialArray(flattenArr, func, callback);
	  }
	  var firstFields = option.firstFields || [];
	  if (firstFields === true) {
	    firstFields = Object.keys(objArr);
	  }
	  var objArrKeys = Object.keys(objArr);
	  var objArrLength = objArrKeys.length;
	  var total = 0;
	  var results = [];
	  var next = function next(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === objArrLength) {
	      callback(results);
	    }
	  };
	  objArrKeys.forEach(function (key) {
	    var arr = objArr[key];
	    if (firstFields.indexOf(key) !== -1) {
	      asyncSerialArray(arr, func, next);
	    } else {
	      asyncParallelArray(arr, func, next);
	    }
	  });
	}
	
	function complementError(rule) {
	  return function (oe) {
	    if (oe && oe.message) {
	      oe.field = oe.field || rule.fullField;
	      return oe;
	    }
	    return {
	      message: oe,
	      field: oe.field || rule.fullField
	    };
	  };
	}
	
	function deepMerge(target, source) {
	  if (source) {
	    for (var s in source) {
	      if (source.hasOwnProperty(s)) {
	        var value = source[s];
	        if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) === 'object' && (0, _typeof3['default'])(target[s]) === 'object') {
	          target[s] = (0, _extends3['default'])({}, target[s], value);
	        } else {
	          target[s] = value;
	        }
	      }
	    }
	  }
	  return target;
	}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(42);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	  module.exports = __webpack_require__(1043)
	} else {
	  module.exports = require('./vue.common.dev.js')
	}


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(21);
	var core = __webpack_require__(17);
	var ctx = __webpack_require__(53);
	var hide = __webpack_require__(54);
	var has = __webpack_require__(61);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(143)('wks');
	var uid = __webpack_require__(107);
	var Symbol = __webpack_require__(21).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _required = __webpack_require__(193);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _whitespace = __webpack_require__(428);
	
	var _whitespace2 = _interopRequireDefault(_whitespace);
	
	var _type = __webpack_require__(427);
	
	var _type2 = _interopRequireDefault(_type);
	
	var _range = __webpack_require__(426);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _enum = __webpack_require__(424);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	var _pattern = __webpack_require__(425);
	
	var _pattern2 = _interopRequireDefault(_pattern);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  required: _required2['default'],
	  whitespace: _whitespace2['default'],
	  type: _type2['default'],
	  range: _range2['default'],
	  'enum': _enum2['default'],
	  pattern: _pattern2['default']
	};
	module.exports = exports['default'];

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(15);
	var createDesc = __webpack_require__(68);
	module.exports = __webpack_require__(14) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var hide = __webpack_require__(25);
	var has = __webpack_require__(29);
	var SRC = __webpack_require__(72)('src');
	var $toString = __webpack_require__(613);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(36).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var fails = __webpack_require__(6);
	var defined = __webpack_require__(42);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(60)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(98);
	var createDesc = __webpack_require__(68);
	var toIObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(44);
	var has = __webpack_require__(29);
	var IE8_DOM_DEFINE = __webpack_require__(233);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(14) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(29);
	var toObject = __webpack_require__(18);
	var IE_PROTO = __webpack_require__(168)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(97);
	var defined = __webpack_require__(42);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(47);
	var IE8_DOM_DEFINE = __webpack_require__(208);
	var toPrimitive = __webpack_require__(145);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(28) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(23);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(37);
	var IObject = __webpack_require__(97);
	var toObject = __webpack_require__(18);
	var toLength = __webpack_require__(12);
	var asc = __webpack_require__(152);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(2);
	var core = __webpack_require__(36);
	var fails = __webpack_require__(6);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(7);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isEmpty = exports.isEqual = exports.arrayEquals = exports.looseEqual = exports.capitalize = exports.kebabCase = exports.autoprefixer = exports.isFirefox = exports.isEdge = exports.isIE = exports.coerceTruthyValueToArray = exports.arrayFind = exports.arrayFindIndex = exports.escapeRegexpString = exports.valueEquals = exports.generateId = exports.getValueByPath = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.noop = noop;
	exports.hasOwn = hasOwn;
	exports.toObject = toObject;
	exports.getPropByPath = getPropByPath;
	exports.rafThrottle = rafThrottle;
	exports.objToArray = objToArray;
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _types = __webpack_require__(267);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function noop() {};
	
	function hasOwn(obj, key) {
	  return hasOwnProperty.call(obj, key);
	};
	
	function extend(to, _from) {
	  for (var key in _from) {
	    to[key] = _from[key];
	  }
	  return to;
	};
	
	function toObject(arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i]) {
	      extend(res, arr[i]);
	    }
	  }
	  return res;
	};
	
	var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
	  prop = prop || '';
	  var paths = prop.split('.');
	  var current = object;
	  var result = null;
	  for (var i = 0, j = paths.length; i < j; i++) {
	    var path = paths[i];
	    if (!current) break;
	
	    if (i === j - 1) {
	      result = current[path];
	      break;
	    }
	    current = current[path];
	  }
	  return result;
	};
	
	function getPropByPath(obj, path, strict) {
	  var tempObj = obj;
	  path = path.replace(/\[(\w+)\]/g, '.$1');
	  path = path.replace(/^\./, '');
	
	  var keyArr = path.split('.');
	  var i = 0;
	  for (var len = keyArr.length; i < len - 1; ++i) {
	    if (!tempObj && !strict) break;
	    var key = keyArr[i];
	    if (key in tempObj) {
	      tempObj = tempObj[key];
	    } else {
	      if (strict) {
	        throw new Error('please transfer a valid prop path to form item!');
	      }
	      break;
	    }
	  }
	  return {
	    o: tempObj,
	    k: keyArr[i],
	    v: tempObj ? tempObj[keyArr[i]] : null
	  };
	};
	
	var generateId = exports.generateId = function generateId() {
	  return Math.floor(Math.random() * 10000);
	};
	
	var valueEquals = exports.valueEquals = function valueEquals(a, b) {
	  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
	  if (a === b) return true;
	  if (!(a instanceof Array)) return false;
	  if (!(b instanceof Array)) return false;
	  if (a.length !== b.length) return false;
	  for (var i = 0; i !== a.length; ++i) {
	    if (a[i] !== b[i]) return false;
	  }
	  return true;
	};
	
	var escapeRegexpString = exports.escapeRegexpString = function escapeRegexpString() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
	};
	
	// TODO: use native Array.find, Array.findIndex when IE support is dropped
	var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
	  for (var i = 0; i !== arr.length; ++i) {
	    if (pred(arr[i])) {
	      return i;
	    }
	  }
	  return -1;
	};
	
	var arrayFind = exports.arrayFind = function arrayFind(arr, pred) {
	  var idx = arrayFindIndex(arr, pred);
	  return idx !== -1 ? arr[idx] : undefined;
	};
	
	// coerce truthy value to array
	var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
	  if (Array.isArray(val)) {
	    return val;
	  } else if (val) {
	    return [val];
	  } else {
	    return [];
	  }
	};
	
	var isIE = exports.isIE = function isIE() {
	  return !_vue2.default.prototype.$isServer && !isNaN(Number(document.documentMode));
	};
	
	var isEdge = exports.isEdge = function isEdge() {
	  return !_vue2.default.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
	};
	
	var isFirefox = exports.isFirefox = function isFirefox() {
	  return !_vue2.default.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
	};
	
	var autoprefixer = exports.autoprefixer = function autoprefixer(style) {
	  if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') return style;
	  var rules = ['transform', 'transition', 'animation'];
	  var prefixes = ['ms-', 'webkit-'];
	  rules.forEach(function (rule) {
	    var value = style[rule];
	    if (rule && value) {
	      prefixes.forEach(function (prefix) {
	        style[prefix + rule] = value;
	      });
	    }
	  });
	  return style;
	};
	
	var kebabCase = exports.kebabCase = function kebabCase(str) {
	  var hyphenateRE = /([^-])([A-Z])/g;
	  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
	};
	
	var capitalize = exports.capitalize = function capitalize(str) {
	  if (!(0, _types.isString)(str)) return str;
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	var looseEqual = exports.looseEqual = function looseEqual(a, b) {
	  var isObjectA = (0, _types.isObject)(a);
	  var isObjectB = (0, _types.isObject)(b);
	  if (isObjectA && isObjectB) {
	    return JSON.stringify(a) === JSON.stringify(b);
	  } else if (!isObjectA && !isObjectB) {
	    return String(a) === String(b);
	  } else {
	    return false;
	  }
	};
	
	var arrayEquals = exports.arrayEquals = function arrayEquals(arrayA, arrayB) {
	  arrayA = arrayA || [];
	  arrayB = arrayB || [];
	
	  if (arrayA.length !== arrayB.length) {
	    return false;
	  }
	
	  for (var i = 0; i < arrayA.length; i++) {
	    if (!looseEqual(arrayA[i], arrayB[i])) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var isEqual = exports.isEqual = function isEqual(value1, value2) {
	  if (Array.isArray(value1) && Array.isArray(value2)) {
	    return arrayEquals(value1, value2);
	  }
	  return looseEqual(value1, value2);
	};
	
	var isEmpty = exports.isEmpty = function isEmpty(val) {
	  // null or undefined
	  if (val == null) return true;
	
	  if (typeof val === 'boolean') return false;
	
	  if (typeof val === 'number') return !val;
	
	  if (val instanceof Error) return val.message === '';
	
	  switch (Object.prototype.toString.call(val)) {
	    // String or Array
	    case '[object String]':
	    case '[object Array]':
	      return !val.length;
	
	    // Map or Set or File
	    case '[object File]':
	    case '[object Map]':
	    case '[object Set]':
	      {
	        return !val.size;
	      }
	    // Plain Object
	    case '[object Object]':
	      {
	        return !Object.keys(val).length;
	      }
	  }
	
	  return false;
	};
	
	function rafThrottle(fn) {
	  var locked = false;
	  return function () {
	    var _this = this;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (locked) return;
	    locked = true;
	    window.requestAnimationFrame(function (_) {
	      fn.apply(_this, args);
	      locked = false;
	    });
	  };
	}
	
	function objToArray(obj) {
	  if (Array.isArray(obj)) {
	    return obj;
	  }
	  return isEmpty(obj) ? [] : [obj];
	}

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(40);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(255);
	var $export = __webpack_require__(2);
	var shared = __webpack_require__(99)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(259))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(14)) {
	  var LIBRARY = __webpack_require__(56);
	  var global = __webpack_require__(5);
	  var fails = __webpack_require__(6);
	  var $export = __webpack_require__(2);
	  var $typed = __webpack_require__(120);
	  var $buffer = __webpack_require__(173);
	  var ctx = __webpack_require__(37);
	  var anInstance = __webpack_require__(63);
	  var propertyDesc = __webpack_require__(68);
	  var hide = __webpack_require__(25);
	  var redefineAll = __webpack_require__(69);
	  var toInteger = __webpack_require__(39);
	  var toLength = __webpack_require__(12);
	  var toIndex = __webpack_require__(253);
	  var toAbsoluteIndex = __webpack_require__(71);
	  var toPrimitive = __webpack_require__(44);
	  var has = __webpack_require__(29);
	  var classof = __webpack_require__(81);
	  var isObject = __webpack_require__(7);
	  var toObject = __webpack_require__(18);
	  var isArrayIter = __webpack_require__(159);
	  var create = __webpack_require__(65);
	  var getPrototypeOf = __webpack_require__(31);
	  var gOPN = __webpack_require__(66).f;
	  var getIterFn = __webpack_require__(175);
	  var uid = __webpack_require__(72);
	  var wks = __webpack_require__(9);
	  var createArrayMethod = __webpack_require__(41);
	  var createArrayIncludes = __webpack_require__(108);
	  var speciesConstructor = __webpack_require__(100);
	  var ArrayIterators = __webpack_require__(176);
	  var Iterators = __webpack_require__(82);
	  var $iterDetect = __webpack_require__(113);
	  var setSpecies = __webpack_require__(70);
	  var arrayFill = __webpack_require__(151);
	  var arrayCopyWithin = __webpack_require__(225);
	  var $DP = __webpack_require__(15);
	  var $GOPD = __webpack_require__(30);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isInContainer = exports.getScrollContainer = exports.isScroll = exports.getStyle = exports.once = exports.off = exports.on = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* istanbul ignore next */
	
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.setStyle = setStyle;
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isServer = _vue2.default.prototype.$isServer;
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var ieVersion = isServer ? 0 : Number(document.documentMode);
	
	/* istanbul ignore next */
	var trim = function trim(string) {
	  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
	};
	/* istanbul ignore next */
	var camelCase = function camelCase(name) {
	  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
	    return offset ? letter.toUpperCase() : letter;
	  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
	};
	
	/* istanbul ignore next */
	var on = exports.on = function () {
	  if (!isServer && document.addEventListener) {
	    return function (element, event, handler) {
	      if (element && event && handler) {
	        element.addEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function (element, event, handler) {
	      if (element && event && handler) {
	        element.attachEvent('on' + event, handler);
	      }
	    };
	  }
	}();
	
	/* istanbul ignore next */
	var off = exports.off = function () {
	  if (!isServer && document.removeEventListener) {
	    return function (element, event, handler) {
	      if (element && event) {
	        element.removeEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function (element, event, handler) {
	      if (element && event) {
	        element.detachEvent('on' + event, handler);
	      }
	    };
	  }
	}();
	
	/* istanbul ignore next */
	var once = exports.once = function once(el, event, fn) {
	  var listener = function listener() {
	    if (fn) {
	      fn.apply(this, arguments);
	    }
	    off(el, event, listener);
	  };
	  on(el, event, listener);
	};
	
	/* istanbul ignore next */
	function hasClass(el, cls) {
	  if (!el || !cls) return false;
	  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
	  if (el.classList) {
	    return el.classList.contains(cls);
	  } else {
	    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
	  }
	};
	
	/* istanbul ignore next */
	function addClass(el, cls) {
	  if (!el) return;
	  var curClass = el.className;
	  var classes = (cls || '').split(' ');
	
	  for (var i = 0, j = classes.length; i < j; i++) {
	    var clsName = classes[i];
	    if (!clsName) continue;
	
	    if (el.classList) {
	      el.classList.add(clsName);
	    } else if (!hasClass(el, clsName)) {
	      curClass += ' ' + clsName;
	    }
	  }
	  if (!el.classList) {
	    el.className = curClass;
	  }
	};
	
	/* istanbul ignore next */
	function removeClass(el, cls) {
	  if (!el || !cls) return;
	  var classes = cls.split(' ');
	  var curClass = ' ' + el.className + ' ';
	
	  for (var i = 0, j = classes.length; i < j; i++) {
	    var clsName = classes[i];
	    if (!clsName) continue;
	
	    if (el.classList) {
	      el.classList.remove(clsName);
	    } else if (hasClass(el, clsName)) {
	      curClass = curClass.replace(' ' + clsName + ' ', ' ');
	    }
	  }
	  if (!el.classList) {
	    el.className = trim(curClass);
	  }
	};
	
	/* istanbul ignore next */
	var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
	  if (isServer) return;
	  if (!element || !styleName) return null;
	  styleName = camelCase(styleName);
	  if (styleName === 'float') {
	    styleName = 'styleFloat';
	  }
	  try {
	    switch (styleName) {
	      case 'opacity':
	        try {
	          return element.filters.item('alpha').opacity / 100;
	        } catch (e) {
	          return 1.0;
	        }
	      default:
	        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
	    }
	  } catch (e) {
	    return element.style[styleName];
	  }
	} : function (element, styleName) {
	  if (isServer) return;
	  if (!element || !styleName) return null;
	  styleName = camelCase(styleName);
	  if (styleName === 'float') {
	    styleName = 'cssFloat';
	  }
	  try {
	    var computed = document.defaultView.getComputedStyle(element, '');
	    return element.style[styleName] || computed ? computed[styleName] : null;
	  } catch (e) {
	    return element.style[styleName];
	  }
	};
	
	/* istanbul ignore next */
	function setStyle(element, styleName, value) {
	  if (!element || !styleName) return;
	
	  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
	    for (var prop in styleName) {
	      if (styleName.hasOwnProperty(prop)) {
	        setStyle(element, prop, styleName[prop]);
	      }
	    }
	  } else {
	    styleName = camelCase(styleName);
	    if (styleName === 'opacity' && ieVersion < 9) {
	      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
	    } else {
	      element.style[styleName] = value;
	    }
	  }
	};
	
	var isScroll = exports.isScroll = function isScroll(el, vertical) {
	  if (isServer) return;
	
	  var determinedDirection = vertical !== null || vertical !== undefined;
	  var overflow = determinedDirection ? vertical ? getStyle(el, 'overflow-y') : getStyle(el, 'overflow-x') : getStyle(el, 'overflow');
	
	  return overflow.match(/(scroll|auto)/);
	};
	
	var getScrollContainer = exports.getScrollContainer = function getScrollContainer(el, vertical) {
	  if (isServer) return;
	
	  var parent = el;
	  while (parent) {
	    if ([window, document, document.documentElement].includes(parent)) {
	      return window;
	    }
	    if (isScroll(parent, vertical)) {
	      return parent;
	    }
	    parent = parent.parentNode;
	  }
	
	  return parent;
	};
	
	var isInContainer = exports.isInContainer = function isInContainer(el, container) {
	  if (isServer || !el || !container) return false;
	
	  var elRect = el.getBoundingClientRect();
	  var containerRect = void 0;
	
	  if ([window, document, document.documentElement, null, undefined].includes(container)) {
	    containerRect = {
	      top: 0,
	      right: window.innerWidth,
	      bottom: window.innerHeight,
	      left: 0
	    };
	  } else {
	    containerRect = container.getBoundingClientRect();
	  }
	
	  return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(556), __esModule: true };

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(200);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(88);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(34);
	var createDesc = __webpack_require__(93);
	module.exports = __webpack_require__(28) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(9)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(25)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(72)('meta');
	var isObject = __webpack_require__(7);
	var has = __webpack_require__(29);
	var setDesc = __webpack_require__(15).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(6)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(808);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    return exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (typeof process !== 'undefined' && 'env' in process) {
	    return ({"NODE_ENV":"production","IS_ENTERPRISE":0}).DEBUG;
	  }
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(406)))

/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(135);
	var defined = __webpack_require__(132);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(37);
	var call = __webpack_require__(236);
	var isArrayIter = __webpack_require__(159);
	var anObject = __webpack_require__(4);
	var toLength = __webpack_require__(12);
	var getIterFn = __webpack_require__(175);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(4);
	var dPs = __webpack_require__(242);
	var enumBugKeys = __webpack_require__(155);
	var IE_PROTO = __webpack_require__(168)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(154)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(157).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(244);
	var hiddenKeys = __webpack_require__(155).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(244);
	var enumBugKeys = __webpack_require__(155);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(26);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var dP = __webpack_require__(15);
	var DESCRIPTORS = __webpack_require__(14);
	var SPECIES = __webpack_require__(9)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function _broadcast(componentName, eventName, params) {
	  this.$children.forEach(function (child) {
	    var name = child.$options.componentName;
	
	    if (name === componentName) {
	      child.$emit.apply(child, [eventName].concat(params));
	    } else {
	      _broadcast.apply(child, [componentName, eventName].concat([params]));
	    }
	  });
	}
	exports.default = {
	  methods: {
	    dispatch: function dispatch(componentName, eventName, params) {
	      var parent = this.$parent || this.$root;
	      var name = parent.$options.componentName;
	
	      while (parent && (!name || name !== componentName)) {
	        parent = parent.$parent;
	
	        if (parent) {
	          name = parent.$options.componentName;
	        }
	      }
	      if (parent) {
	        parent.$emit.apply(parent, [eventName].concat(params));
	      }
	    },
	    broadcast: function broadcast(componentName, eventName, params) {
	      _broadcast.call(this, componentName, eventName, params);
	    }
	  }
	};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.15';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
	      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      // Like with sourceURL, we take care to not check the option's prototype,
	      // as this configuration is a code injection vector.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(126)(module)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(555), __esModule: true };

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(215);
	var enumBugKeys = __webpack_require__(134);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(132);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(587)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(136)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(35);
	var TAG = __webpack_require__(9)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(15).f;
	var has = __webpack_require__(29);
	var TAG = __webpack_require__(9)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var defined = __webpack_require__(42);
	var fails = __webpack_require__(6);
	var spaces = __webpack_require__(171);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.i18n = exports.use = exports.t = undefined;
	
	var _zhCN = __webpack_require__(821);
	
	var _zhCN2 = _interopRequireDefault(_zhCN);
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _deepmerge = __webpack_require__(809);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _format = __webpack_require__(820);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = (0, _format2.default)(_vue2.default);
	var lang = _zhCN2.default;
	var merged = false;
	var i18nHandler = function i18nHandler() {
	  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
	  if (typeof vuei18n === 'function' && !!_vue2.default.locale) {
	    if (!merged) {
	      merged = true;
	      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, { clone: true }));
	    }
	    return vuei18n.apply(this, arguments);
	  }
	};
	
	var t = exports.t = function t(path, options) {
	  var value = i18nHandler.apply(this, arguments);
	  if (value !== null && value !== undefined) return value;
	
	  var array = path.split('.');
	  var current = lang;
	
	  for (var i = 0, j = array.length; i < j; i++) {
	    var property = array[i];
	    value = current[property];
	    if (i === j - 1) return format(value, options);
	    if (!value) return '';
	    current = value;
	  }
	  return '';
	};
	
	var use = exports.use = function use(l) {
	  lang = l || lang;
	};
	
	var i18n = exports.i18n = function i18n(fn) {
	  i18nHandler = fn || i18nHandler;
	};
	
	exports.default = { use: use, t: t, i18n: i18n };

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(840);
	var hasBinary = __webpack_require__(270);
	var sliceBuffer = __webpack_require__(421);
	var after = __webpack_require__(420);
	var utf8 = __webpack_require__(1047);
	
	var base64encoder;
	if (global && global.ArrayBuffer) {
	  base64encoder = __webpack_require__(547);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(548);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if ('function' == typeof supportsBinary) {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if ('function' == typeof utf8encode) {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (Blob && data instanceof global.Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    packet.data = fr.result;
	    exports.encodePacket(packet, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (Blob && packet.data instanceof global.Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += global.btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data == 'string') {
	    if (data.charAt(0) == 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data);
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary == 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data != 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data == '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = ''
	    , n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (':' != chr) {
	      length += chr;
	    } else {
	      if ('' == length || (length != (n = Number(length)))) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      msg = data.substr(i + 1, n);
	
	      if (length != msg.length) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      if (msg.length) {
	        packet = exports.decodePacket(msg, binaryType, true);
	
	        if (err.type == packet.type && err.data == packet.data) {
	          // parser error in individual packet - ignoring payload
	          return callback(err, 0, 1);
	        }
	
	        var ret = callback(packet, i + n, l);
	        if (false === ret) return;
	      }
	
	      // advance cursor
	      i += n;
	      length = '';
	    }
	  }
	
	  if (length != '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  var numberTooLong = false;
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] == 255) break;
	
	      if (msgLength.length > 310) {
	        numberTooLong = true;
	        break;
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    if(numberTooLong) return callback(err, 0, 1);
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(53);
	var call = __webpack_require__(211);
	var isArrayIter = __webpack_require__(209);
	var anObject = __webpack_require__(47);
	var toLength = __webpack_require__(106);
	var getIterFn = __webpack_require__(148);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(34).f;
	var has = __webpack_require__(61);
	var TAG = __webpack_require__(22)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(593);
	var global = __webpack_require__(21);
	var hide = __webpack_require__(54);
	var Iterators = __webpack_require__(77);
	var TO_STRING_TAG = __webpack_require__(22)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(4);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(35);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(36);
	var global = __webpack_require__(5);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(56) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(4);
	var aFunction = __webpack_require__(23);
	var SPECIES = __webpack_require__(9)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(539);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(538);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(543);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(542);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(89);
	var TAG = __webpack_require__(22)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(144);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(32);
	var toLength = __webpack_require__(12);
	var toAbsoluteIndex = __webpack_require__(71);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(26);
	var redefineAll = __webpack_require__(69);
	var meta = __webpack_require__(57);
	var forOf = __webpack_require__(64);
	var anInstance = __webpack_require__(63);
	var isObject = __webpack_require__(7);
	var fails = __webpack_require__(6);
	var $iterDetect = __webpack_require__(113);
	var setToStringTag = __webpack_require__(83);
	var inheritIfRequired = __webpack_require__(158);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(256);
	var redefine = __webpack_require__(26);
	var hide = __webpack_require__(25);
	var fails = __webpack_require__(6);
	var defined = __webpack_require__(42);
	var wks = __webpack_require__(9);
	var regexpExec = __webpack_require__(166);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(35);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(7);
	var cof = __webpack_require__(35);
	var MATCH = __webpack_require__(9)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(9)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(56) || !__webpack_require__(6)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(5)[K];
	});


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(81);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(23);
	var ctx = __webpack_require__(37);
	var forOf = __webpack_require__(64);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39);
	var defined = __webpack_require__(42);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var hide = __webpack_require__(25);
	var uid = __webpack_require__(72);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (target) {
	  for (var i = 1, j = arguments.length; i < j; i++) {
	    var source = arguments[i] || {};
	    for (var prop in source) {
	      if (source.hasOwnProperty(prop)) {
	        var value = source[prop];
	        if (value !== undefined) {
	          target[prop] = value;
	        }
	      }
	    }
	  }
	
	  return target;
	};
	
	;

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isDef = isDef;
	exports.isKorean = isKorean;
	function isDef(val) {
	  return val !== undefined && val !== null;
	}
	function isKorean(text) {
	  var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
	  return reg.test(text);
	}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _popup = __webpack_require__(266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopperJS = _vue2.default.prototype.$isServer ? function () {} : __webpack_require__(831);
	var stop = function stop(e) {
	  return e.stopPropagation();
	};
	
	/**
	 * @param {HTMLElement} [reference=$refs.reference] - The reference element used to position the popper.
	 * @param {HTMLElement} [popper=$refs.popper] - The HTML element used as popper, or a configuration used to generate the popper.
	 * @param {String} [placement=button] - Placement of the popper accepted values: top(-start, -end), right(-start, -end), bottom(-start, -end), left(-start, -end)
	 * @param {Number} [offset=0] - Amount of pixels the popper will be shifted (can be negative).
	 * @param {Boolean} [visible=false] Visibility of the popup element.
	 * @param {Boolean} [visible-arrow=false] Visibility of the arrow, no style.
	 */
	exports.default = {
	  props: {
	    transformOrigin: {
	      type: [Boolean, String],
	      default: true
	    },
	    placement: {
	      type: String,
	      default: 'bottom'
	    },
	    boundariesPadding: {
	      type: Number,
	      default: 5
	    },
	    reference: {},
	    popper: {},
	    offset: {
	      default: 0
	    },
	    value: Boolean,
	    visibleArrow: Boolean,
	    arrowOffset: {
	      type: Number,
	      default: 35
	    },
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    popperOptions: {
	      type: Object,
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      showPopper: false,
	      currentPlacement: ''
	    };
	  },
	
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(val) {
	        this.showPopper = val;
	        this.$emit('input', val);
	      }
	    },
	
	    showPopper: function showPopper(val) {
	      if (this.disabled) return;
	      val ? this.updatePopper() : this.destroyPopper();
	      this.$emit('input', val);
	    }
	  },
	
	  methods: {
	    createPopper: function createPopper() {
	      var _this = this;
	
	      if (this.$isServer) return;
	      this.currentPlacement = this.currentPlacement || this.placement;
	      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement)) {
	        return;
	      }
	
	      var options = this.popperOptions;
	      var popper = this.popperElm = this.popperElm || this.popper || this.$refs.popper;
	      var reference = this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;
	
	      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	        reference = this.referenceElm = this.$slots.reference[0].elm;
	      }
	
	      if (!popper || !reference) return;
	      if (this.visibleArrow) this.appendArrow(popper);
	      if (this.appendToBody) document.body.appendChild(this.popperElm);
	      if (this.popperJS && this.popperJS.destroy) {
	        this.popperJS.destroy();
	      }
	
	      options.placement = this.currentPlacement;
	      options.offset = this.offset;
	      options.arrowOffset = this.arrowOffset;
	      this.popperJS = new PopperJS(reference, popper, options);
	      this.popperJS.onCreate(function (_) {
	        _this.$emit('created', _this);
	        _this.resetTransformOrigin();
	        _this.$nextTick(_this.updatePopper);
	      });
	      if (typeof options.onUpdate === 'function') {
	        this.popperJS.onUpdate(options.onUpdate);
	      }
	      this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
	      this.popperElm.addEventListener('click', stop);
	    },
	    updatePopper: function updatePopper() {
	      var popperJS = this.popperJS;
	      if (popperJS) {
	        popperJS.update();
	        if (popperJS._popper) {
	          popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
	        }
	      } else {
	        this.createPopper();
	      }
	    },
	    doDestroy: function doDestroy(forceDestroy) {
	      /* istanbul ignore if */
	      if (!this.popperJS || this.showPopper && !forceDestroy) return;
	      this.popperJS.destroy();
	      this.popperJS = null;
	    },
	    destroyPopper: function destroyPopper() {
	      if (this.popperJS) {
	        this.resetTransformOrigin();
	      }
	    },
	    resetTransformOrigin: function resetTransformOrigin() {
	      if (!this.transformOrigin) return;
	      var placementMap = {
	        top: 'bottom',
	        bottom: 'top',
	        left: 'right',
	        right: 'left'
	      };
	      var placement = this.popperJS._popper.getAttribute('x-placement').split('-')[0];
	      var origin = placementMap[placement];
	      this.popperJS._popper.style.transformOrigin = typeof this.transformOrigin === 'string' ? this.transformOrigin : ['top', 'bottom'].indexOf(placement) > -1 ? 'center ' + origin : origin + ' center';
	    },
	    appendArrow: function appendArrow(element) {
	      var hash = void 0;
	      if (this.appended) {
	        return;
	      }
	
	      this.appended = true;
	
	      for (var item in element.attributes) {
	        if (/^_v-/.test(element.attributes[item].name)) {
	          hash = element.attributes[item].name;
	          break;
	        }
	      }
	
	      var arrow = document.createElement('div');
	
	      if (hash) {
	        arrow.setAttribute(hash, '');
	      }
	      arrow.setAttribute('x-arrow', '');
	      arrow.className = 'popper__arrow';
	      element.appendChild(arrow);
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.doDestroy(true);
	    if (this.popperElm && this.popperElm.parentNode === document.body) {
	      this.popperElm.removeEventListener('click', stop);
	      document.body.removeChild(this.popperElm);
	    }
	  },
	
	
	  // call destroy in keep-alive mode
	  deactivated: function deactivated() {
	    this.$options.beforeDestroy[0].call(this);
	  }
	};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable no-undefined */
	
	var throttle = __webpack_require__(190);
	
	/**
	 * Debounce execution of a function. Debouncing, unlike throttling,
	 * guarantees that a function is only executed a single time, either at the
	 * very beginning of a series of calls, or at the very end.
	 *
	 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
	 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
	 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
	 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                  to `callback` when the debounced-function is executed.
	 *
	 * @return {Function} A new, debounced function.
	 */
	module.exports = function ( delay, atBegin, callback ) {
		return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
	};


/***/ }),
/* 126 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(40);
	var document = __webpack_require__(21).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(89);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(91);
	var $export = __webpack_require__(20);
	var redefine = __webpack_require__(219);
	var hide = __webpack_require__(54);
	var Iterators = __webpack_require__(77);
	var $iterCreate = __webpack_require__(577);
	var setToStringTag = __webpack_require__(94);
	var getPrototypeOf = __webpack_require__(583);
	var ITERATOR = __webpack_require__(22)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(107)('meta');
	var isObject = __webpack_require__(40);
	var has = __webpack_require__(61);
	var setDesc = __webpack_require__(34).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(60)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(88);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(47);
	var dPs = __webpack_require__(580);
	var enumBugKeys = __webpack_require__(134);
	var IE_PROTO = __webpack_require__(142)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(133)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(207).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(54);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(143)('keys');
	var uid = __webpack_require__(107);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(17);
	var global = __webpack_require__(21);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(91) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 144 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(40);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(21);
	var core = __webpack_require__(17);
	var LIBRARY = __webpack_require__(91);
	var wksExt = __webpack_require__(147);
	var defineProperty = __webpack_require__(34).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(22);


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(105);
	var ITERATOR = __webpack_require__(22)('iterator');
	var Iterators = __webpack_require__(77);
	module.exports = __webpack_require__(17).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 149 */
/***/ (function(module, exports) {



/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(119)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(18);
	var toAbsoluteIndex = __webpack_require__(71);
	var toLength = __webpack_require__(12);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(609);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(15);
	var createDesc = __webpack_require__(68);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	var document = __webpack_require__(5).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 155 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(9)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(5).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	var setPrototypeOf = __webpack_require__(167).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(82);
	var ITERATOR = __webpack_require__(9)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(65);
	var descriptor = __webpack_require__(68);
	var setToStringTag = __webpack_require__(83);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(25)(IteratorPrototype, __webpack_require__(9)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(56);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(26);
	var hide = __webpack_require__(25);
	var Iterators = __webpack_require__(82);
	var $iterCreate = __webpack_require__(160);
	var setToStringTag = __webpack_require__(83);
	var getPrototypeOf = __webpack_require__(31);
	var ITERATOR = __webpack_require__(9)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var macrotask = __webpack_require__(172).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(35)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(23);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(96);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(7);
	var anObject = __webpack_require__(4);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(37)(Function.call, __webpack_require__(30).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(99)('keys');
	var uid = __webpack_require__(72);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(112);
	var defined = __webpack_require__(42);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(39);
	var defined = __webpack_require__(42);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 171 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(37);
	var invoke = __webpack_require__(234);
	var html = __webpack_require__(157);
	var cel = __webpack_require__(154);
	var global = __webpack_require__(5);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(35)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var DESCRIPTORS = __webpack_require__(14);
	var LIBRARY = __webpack_require__(56);
	var $typed = __webpack_require__(120);
	var hide = __webpack_require__(25);
	var redefineAll = __webpack_require__(69);
	var fails = __webpack_require__(6);
	var anInstance = __webpack_require__(63);
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(12);
	var toIndex = __webpack_require__(253);
	var gOPN = __webpack_require__(66).f;
	var dP = __webpack_require__(15).f;
	var arrayFill = __webpack_require__(151);
	var setToStringTag = __webpack_require__(83);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(36);
	var LIBRARY = __webpack_require__(56);
	var wksExt = __webpack_require__(254);
	var defineProperty = __webpack_require__(15).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(81);
	var ITERATOR = __webpack_require__(9)('iterator');
	var Iterators = __webpack_require__(82);
	module.exports = __webpack_require__(36).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(55);
	var step = __webpack_require__(237);
	var Iterators = __webpack_require__(82);
	var toIObject = __webpack_require__(32);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(161)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 76);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 11:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(261);
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(123);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(74);
	
	/***/ }),
	
	/***/ 76:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        _vm.type === "textarea" ? "el-textarea" : "el-input",
	        _vm.inputSize ? "el-input--" + _vm.inputSize : "",
	        {
	          "is-disabled": _vm.inputDisabled,
	          "is-exceed": _vm.inputExceed,
	          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
	          "el-input-group--append": _vm.$slots.append,
	          "el-input-group--prepend": _vm.$slots.prepend,
	          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
	          "el-input--suffix":
	            _vm.$slots.suffix ||
	            _vm.suffixIcon ||
	            _vm.clearable ||
	            _vm.showPassword
	        }
	      ],
	      on: {
	        mouseenter: function($event) {
	          _vm.hovering = true
	        },
	        mouseleave: function($event) {
	          _vm.hovering = false
	        }
	      }
	    },
	    [
	      _vm.type !== "textarea"
	        ? [
	            _vm.$slots.prepend
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__prepend" },
	                  [_vm._t("prepend")],
	                  2
	                )
	              : _vm._e(),
	            _vm.type !== "textarea"
	              ? _c(
	                  "input",
	                  _vm._b(
	                    {
	                      ref: "input",
	                      staticClass: "el-input__inner",
	                      attrs: {
	                        tabindex: _vm.tabindex,
	                        type: _vm.showPassword
	                          ? _vm.passwordVisible
	                            ? "text"
	                            : "password"
	                          : _vm.type,
	                        disabled: _vm.inputDisabled,
	                        readonly: _vm.readonly,
	                        autocomplete: _vm.autoComplete || _vm.autocomplete,
	                        "aria-label": _vm.label
	                      },
	                      on: {
	                        compositionstart: _vm.handleCompositionStart,
	                        compositionupdate: _vm.handleCompositionUpdate,
	                        compositionend: _vm.handleCompositionEnd,
	                        input: _vm.handleInput,
	                        focus: _vm.handleFocus,
	                        blur: _vm.handleBlur,
	                        change: _vm.handleChange
	                      }
	                    },
	                    "input",
	                    _vm.$attrs,
	                    false
	                  )
	                )
	              : _vm._e(),
	            _vm.$slots.prefix || _vm.prefixIcon
	              ? _c(
	                  "span",
	                  { staticClass: "el-input__prefix" },
	                  [
	                    _vm._t("prefix"),
	                    _vm.prefixIcon
	                      ? _c("i", {
	                          staticClass: "el-input__icon",
	                          class: _vm.prefixIcon
	                        })
	                      : _vm._e()
	                  ],
	                  2
	                )
	              : _vm._e(),
	            _vm.getSuffixVisible()
	              ? _c("span", { staticClass: "el-input__suffix" }, [
	                  _c(
	                    "span",
	                    { staticClass: "el-input__suffix-inner" },
	                    [
	                      !_vm.showClear ||
	                      !_vm.showPwdVisible ||
	                      !_vm.isWordLimitVisible
	                        ? [
	                            _vm._t("suffix"),
	                            _vm.suffixIcon
	                              ? _c("i", {
	                                  staticClass: "el-input__icon",
	                                  class: _vm.suffixIcon
	                                })
	                              : _vm._e()
	                          ]
	                        : _vm._e(),
	                      _vm.showClear
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-circle-close el-input__clear",
	                            on: {
	                              mousedown: function($event) {
	                                $event.preventDefault()
	                              },
	                              click: _vm.clear
	                            }
	                          })
	                        : _vm._e(),
	                      _vm.showPwdVisible
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-view el-input__clear",
	                            on: { click: _vm.handlePasswordVisible }
	                          })
	                        : _vm._e(),
	                      _vm.isWordLimitVisible
	                        ? _c("span", { staticClass: "el-input__count" }, [
	                            _c(
	                              "span",
	                              { staticClass: "el-input__count-inner" },
	                              [
	                                _vm._v(
	                                  "\n            " +
	                                    _vm._s(_vm.textLength) +
	                                    "/" +
	                                    _vm._s(_vm.upperLimit) +
	                                    "\n          "
	                                )
	                              ]
	                            )
	                          ])
	                        : _vm._e()
	                    ],
	                    2
	                  ),
	                  _vm.validateState
	                    ? _c("i", {
	                        staticClass: "el-input__icon",
	                        class: ["el-input__validateIcon", _vm.validateIcon]
	                      })
	                    : _vm._e()
	                ])
	              : _vm._e(),
	            _vm.$slots.append
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__append" },
	                  [_vm._t("append")],
	                  2
	                )
	              : _vm._e()
	          ]
	        : _c(
	            "textarea",
	            _vm._b(
	              {
	                ref: "textarea",
	                staticClass: "el-textarea__inner",
	                style: _vm.textareaStyle,
	                attrs: {
	                  tabindex: _vm.tabindex,
	                  disabled: _vm.inputDisabled,
	                  readonly: _vm.readonly,
	                  autocomplete: _vm.autoComplete || _vm.autocomplete,
	                  "aria-label": _vm.label
	                },
	                on: {
	                  compositionstart: _vm.handleCompositionStart,
	                  compositionupdate: _vm.handleCompositionUpdate,
	                  compositionend: _vm.handleCompositionEnd,
	                  input: _vm.handleInput,
	                  focus: _vm.handleFocus,
	                  blur: _vm.handleBlur,
	                  change: _vm.handleChange
	                }
	              },
	              "textarea",
	              _vm.$attrs,
	              false
	            )
	          ),
	      _vm.isWordLimitVisible && _vm.type === "textarea"
	        ? _c("span", { staticClass: "el-input__count" }, [
	            _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
	          ])
	        : _vm._e()
	    ],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
	var migrating_ = __webpack_require__(11);
	var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);
	
	// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
	var hiddenTextarea = void 0;
	
	var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	
	var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	
	function calculateNodeStyling(targetElement) {
	  var style = window.getComputedStyle(targetElement);
	
	  var boxSizing = style.getPropertyValue('box-sizing');
	
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	
	  var contextStyle = CONTEXT_STYLE.map(function (name) {
	    return name + ':' + style.getPropertyValue(name);
	  }).join(';');
	
	  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
	}
	
	function calcTextareaHeight(targetElement) {
	  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  }
	
	  var _calculateNodeStyling = calculateNodeStyling(targetElement),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      contextStyle = _calculateNodeStyling.contextStyle;
	
	  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
	  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';
	
	  var height = hiddenTextarea.scrollHeight;
	  var result = {};
	
	  if (boxSizing === 'border-box') {
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    height = height - paddingSize;
	  }
	
	  hiddenTextarea.value = '';
	  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	  if (minRows !== null) {
	    var minHeight = singleRowHeight * minRows;
	    if (boxSizing === 'border-box') {
	      minHeight = minHeight + paddingSize + borderSize;
	    }
	    height = Math.max(minHeight, height);
	    result.minHeight = minHeight + 'px';
	  }
	  if (maxRows !== null) {
	    var maxHeight = singleRowHeight * maxRows;
	    if (boxSizing === 'border-box') {
	      maxHeight = maxHeight + paddingSize + borderSize;
	    }
	    height = Math.min(maxHeight, height);
	  }
	  result.height = height + 'px';
	  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
	  hiddenTextarea = null;
	  return result;
	};
	// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
	var merge_ = __webpack_require__(9);
	var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(21);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	/* harmony default export */ var inputvue_type_script_lang_js_ = ({
	  name: 'ElInput',
	
	  componentName: 'ElInput',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  inheritAttrs: false,
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      textareaCalcStyle: {},
	      hovering: false,
	      focused: false,
	      isComposing: false,
	      passwordVisible: false
	    };
	  },
	
	
	  props: {
	    value: [String, Number],
	    size: String,
	    resize: String,
	    form: String,
	    disabled: Boolean,
	    readonly: Boolean,
	    type: {
	      type: String,
	      default: 'text'
	    },
	    autosize: {
	      type: [Boolean, Object],
	      default: false
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    validateEvent: {
	      type: Boolean,
	      default: true
	    },
	    suffixIcon: String,
	    prefixIcon: String,
	    label: String,
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	    showPassword: {
	      type: Boolean,
	      default: false
	    },
	    showWordLimit: {
	      type: Boolean,
	      default: false
	    },
	    tabindex: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    validateState: function validateState() {
	      return this.elFormItem ? this.elFormItem.validateState : '';
	    },
	    needStatusIcon: function needStatusIcon() {
	      return this.elForm ? this.elForm.statusIcon : false;
	    },
	    validateIcon: function validateIcon() {
	      return {
	        validating: 'el-icon-loading',
	        success: 'el-icon-circle-check',
	        error: 'el-icon-circle-close'
	      }[this.validateState];
	    },
	    textareaStyle: function textareaStyle() {
	      return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
	    },
	    inputSize: function inputSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputDisabled: function inputDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    nativeInputValue: function nativeInputValue() {
	      return this.value === null || this.value === undefined ? '' : String(this.value);
	    },
	    showClear: function showClear() {
	      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
	    },
	    showPwdVisible: function showPwdVisible() {
	      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
	    },
	    isWordLimitVisible: function isWordLimitVisible() {
	      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
	    },
	    upperLimit: function upperLimit() {
	      return this.$attrs.maxlength;
	    },
	    textLength: function textLength() {
	      if (typeof this.value === 'number') {
	        return String(this.value).length;
	      }
	
	      return (this.value || '').length;
	    },
	    inputExceed: function inputExceed() {
	      // show exceed style if length of initial value greater then maxlength
	      return this.isWordLimitVisible && this.textLength > this.upperLimit;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.$nextTick(this.resizeTextarea);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', [val]);
	      }
	    },
	
	    // native input value is set explicitly
	    // do not use v-model / :value in template
	    // see: https://github.com/ElemeFE/element/issues/14521
	    nativeInputValue: function nativeInputValue() {
	      this.setNativeInputValue();
	    },
	
	    // when change between <input> and <textarea>,
	    // update DOM dependent value and styles
	    // https://github.com/ElemeFE/element/issues/14857
	    type: function type() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.setNativeInputValue();
	        _this.resizeTextarea();
	        _this.updateIconOffset();
	      });
	    }
	  },
	
	  methods: {
	    focus: function focus() {
	      this.getInput().focus();
	    },
	    blur: function blur() {
	      this.getInput().blur();
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
	          'on-icon-click': 'on-icon-click is removed.'
	        },
	        events: {
	          'click': 'click is removed.'
	        }
	      };
	    },
	    handleBlur: function handleBlur(event) {
	      this.focused = false;
	      this.$emit('blur', event);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
	      }
	    },
	    select: function select() {
	      this.getInput().select();
	    },
	    resizeTextarea: function resizeTextarea() {
	      if (this.$isServer) return;
	      var autosize = this.autosize,
	          type = this.type;
	
	      if (type !== 'textarea') return;
	      if (!autosize) {
	        this.textareaCalcStyle = {
	          minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
	        };
	        return;
	      }
	      var minRows = autosize.minRows;
	      var maxRows = autosize.maxRows;
	
	      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
	    },
	    setNativeInputValue: function setNativeInputValue() {
	      var input = this.getInput();
	      if (!input) return;
	      if (input.value === this.nativeInputValue) return;
	      input.value = this.nativeInputValue;
	    },
	    handleFocus: function handleFocus(event) {
	      this.focused = true;
	      this.$emit('focus', event);
	    },
	    handleCompositionStart: function handleCompositionStart() {
	      this.isComposing = true;
	    },
	    handleCompositionUpdate: function handleCompositionUpdate(event) {
	      var text = event.target.value;
	      var lastCharacter = text[text.length - 1] || '';
	      this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
	    },
	    handleCompositionEnd: function handleCompositionEnd(event) {
	      if (this.isComposing) {
	        this.isComposing = false;
	        this.handleInput(event);
	      }
	    },
	    handleInput: function handleInput(event) {
	      // should not emit input during composition
	      // see: https://github.com/ElemeFE/element/issues/10516
	      if (this.isComposing) return;
	
	      // hack for https://github.com/ElemeFE/element/issues/8548
	      // should remove the following line when we don't support IE
	      if (event.target.value === this.nativeInputValue) return;
	
	      this.$emit('input', event.target.value);
	
	      // ensure native input value is controlled
	      // see: https://github.com/ElemeFE/element/issues/12850
	      this.$nextTick(this.setNativeInputValue);
	    },
	    handleChange: function handleChange(event) {
	      this.$emit('change', event.target.value);
	    },
	    calcIconOffset: function calcIconOffset(place) {
	      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
	      if (!elList.length) return;
	      var el = null;
	      for (var i = 0; i < elList.length; i++) {
	        if (elList[i].parentNode === this.$el) {
	          el = elList[i];
	          break;
	        }
	      }
	      if (!el) return;
	      var pendantMap = {
	        suffix: 'append',
	        prefix: 'prepend'
	      };
	
	      var pendant = pendantMap[place];
	      if (this.$slots[pendant]) {
	        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
	      } else {
	        el.removeAttribute('style');
	      }
	    },
	    updateIconOffset: function updateIconOffset() {
	      this.calcIconOffset('prefix');
	      this.calcIconOffset('suffix');
	    },
	    clear: function clear() {
	      this.$emit('input', '');
	      this.$emit('change', '');
	      this.$emit('clear');
	    },
	    handlePasswordVisible: function handlePasswordVisible() {
	      this.passwordVisible = !this.passwordVisible;
	      this.focus();
	    },
	    getInput: function getInput() {
	      return this.$refs.input || this.$refs.textarea;
	    },
	    getSuffixVisible: function getSuffixVisible() {
	      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
	    }
	  },
	
	  created: function created() {
	    this.$on('inputSelect', this.select);
	  },
	  mounted: function mounted() {
	    this.setNativeInputValue();
	    this.resizeTextarea();
	    this.updateIconOffset();
	  },
	  updated: function updated() {
	    this.$nextTick(this.updateIconOffset);
	  }
	});
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/input/src/input.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_inputvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/input/src/input.vue"
	/* harmony default export */ var input = (component.exports);
	// CONCATENATED MODULE: ./packages/input/index.js
	
	
	/* istanbul ignore next */
	input.install = function (Vue) {
	  Vue.component(input.name, input);
	};
	
	/* harmony default export */ var packages_input = __webpack_exports__["default"] = (input);
	
	/***/ }),
	
	/***/ 9:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(122);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (ref) {
	  return {
	    methods: {
	      focus: function focus() {
	        this.$refs[ref].focus();
	      }
	    }
	  };
	};
	
	;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__(85);
	
	exports.default = {
	  methods: {
	    t: function t() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _locale.t.apply(this, args);
	    }
	  }
	};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 127);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 127:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
	var resize_event_ = __webpack_require__(16);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
	var scrollbar_width_ = __webpack_require__(39);
	var scrollbar_width_default = /*#__PURE__*/__webpack_require__.n(scrollbar_width_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(2);
	
	// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
	var BAR_MAP = {
	  vertical: {
	    offset: 'offsetHeight',
	    scroll: 'scrollTop',
	    scrollSize: 'scrollHeight',
	    size: 'height',
	    key: 'vertical',
	    axis: 'Y',
	    client: 'clientY',
	    direction: 'top'
	  },
	  horizontal: {
	    offset: 'offsetWidth',
	    scroll: 'scrollLeft',
	    scrollSize: 'scrollWidth',
	    size: 'width',
	    key: 'horizontal',
	    axis: 'X',
	    client: 'clientX',
	    direction: 'left'
	  }
	};
	
	function renderThumbStyle(_ref) {
	  var move = _ref.move,
	      size = _ref.size,
	      bar = _ref.bar;
	
	  var style = {};
	  var translate = 'translate' + bar.axis + '(' + move + '%)';
	
	  style[bar.size] = size;
	  style.transform = translate;
	  style.msTransform = translate;
	  style.webkitTransform = translate;
	
	  return style;
	};
	// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var src_bar = ({
	  name: 'Bar',
	
	  props: {
	    vertical: Boolean,
	    size: String,
	    move: Number
	  },
	
	  computed: {
	    bar: function bar() {
	      return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
	    },
	    wrap: function wrap() {
	      return this.$parent.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var size = this.size,
	        move = this.move,
	        bar = this.bar;
	
	
	    return h(
	      'div',
	      {
	        'class': ['el-scrollbar__bar', 'is-' + bar.key],
	        on: {
	          'mousedown': this.clickTrackHandler
	        }
	      },
	      [h('div', {
	        ref: 'thumb',
	        'class': 'el-scrollbar__thumb',
	        on: {
	          'mousedown': this.clickThumbHandler
	        },
	
	        style: renderThumbStyle({ size: size, move: move, bar: bar }) })]
	    );
	  },
	
	
	  methods: {
	    clickThumbHandler: function clickThumbHandler(e) {
	      // prevent click event of right button
	      if (e.ctrlKey || e.button === 2) {
	        return;
	      }
	      this.startDrag(e);
	      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
	    },
	    clickTrackHandler: function clickTrackHandler(e) {
	      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
	      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
	      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    startDrag: function startDrag(e) {
	      e.stopImmediatePropagation();
	      this.cursorDown = true;
	
	      Object(dom_["on"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      Object(dom_["on"])(document, 'mouseup', this.mouseUpDocumentHandler);
	      document.onselectstart = function () {
	        return false;
	      };
	    },
	    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
	      if (this.cursorDown === false) return;
	      var prevPage = this[this.bar.axis];
	
	      if (!prevPage) return;
	
	      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
	      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
	      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
	      this.cursorDown = false;
	      this[this.bar.axis] = 0;
	      Object(dom_["off"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      document.onselectstart = null;
	    }
	  },
	
	  destroyed: function destroyed() {
	    Object(dom_["off"])(document, 'mouseup', this.mouseUpDocumentHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
	// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js
	
	
	
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var main = ({
	  name: 'ElScrollbar',
	
	  components: { Bar: src_bar },
	
	  props: {
	    native: Boolean,
	    wrapStyle: {},
	    wrapClass: {},
	    viewClass: {},
	    viewStyle: {},
	    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
	    tag: {
	      type: String,
	      default: 'div'
	    }
	  },
	
	  data: function data() {
	    return {
	      sizeWidth: '0',
	      sizeHeight: '0',
	      moveX: 0,
	      moveY: 0
	    };
	  },
	
	
	  computed: {
	    wrap: function wrap() {
	      return this.$refs.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var gutter = scrollbar_width_default()();
	    var style = this.wrapStyle;
	
	    if (gutter) {
	      var gutterWith = '-' + gutter + 'px';
	      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';
	
	      if (Array.isArray(this.wrapStyle)) {
	        style = Object(util_["toObject"])(this.wrapStyle);
	        style.marginRight = style.marginBottom = gutterWith;
	      } else if (typeof this.wrapStyle === 'string') {
	        style += gutterStyle;
	      } else {
	        style = gutterStyle;
	      }
	    }
	    var view = h(this.tag, {
	      class: ['el-scrollbar__view', this.viewClass],
	      style: this.viewStyle,
	      ref: 'resize'
	    }, this.$slots.default);
	    var wrap = h(
	      'div',
	      {
	        ref: 'wrap',
	        style: style,
	        on: {
	          'scroll': this.handleScroll
	        },
	
	        'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] },
	      [[view]]
	    );
	    var nodes = void 0;
	
	    if (!this.native) {
	      nodes = [wrap, h(src_bar, {
	        attrs: {
	          move: this.moveX,
	          size: this.sizeWidth }
	      }), h(src_bar, {
	        attrs: {
	          vertical: true,
	          move: this.moveY,
	          size: this.sizeHeight }
	      })];
	    } else {
	      nodes = [h(
	        'div',
	        {
	          ref: 'wrap',
	          'class': [this.wrapClass, 'el-scrollbar__wrap'],
	          style: style },
	        [[view]]
	      )];
	    }
	    return h('div', { class: 'el-scrollbar' }, nodes);
	  },
	
	
	  methods: {
	    handleScroll: function handleScroll() {
	      var wrap = this.wrap;
	
	      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
	      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
	    },
	    update: function update() {
	      var heightPercentage = void 0,
	          widthPercentage = void 0;
	      var wrap = this.wrap;
	      if (!wrap) return;
	
	      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
	      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
	
	      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
	      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.native) return;
	    this.$nextTick(this.update);
	    !this.noresize && Object(resize_event_["addResizeListener"])(this.$refs.resize, this.update);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.native) return;
	    !this.noresize && Object(resize_event_["removeResizeListener"])(this.$refs.resize, this.update);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/index.js
	
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.component(main.name, main);
	};
	
	/* harmony default export */ var scrollbar = __webpack_exports__["default"] = (main);
	
	/***/ }),
	
	/***/ 16:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(182);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(50);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(45);
	
	/***/ }),
	
	/***/ 39:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(184);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var aria = aria || {};
	
	aria.Utils = aria.Utils || {};
	
	/**
	 * @desc Set focus on descendant nodes until the first focusable element is
	 *       found.
	 * @param element
	 *          DOM node for which to find the first focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	aria.Utils.focusFirstDescendant = function (element) {
	  for (var i = 0; i < element.childNodes.length; i++) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Find the last descendant node that is focusable.
	 * @param element
	 *          DOM node for which to find the last focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	
	aria.Utils.focusLastDescendant = function (element) {
	  for (var i = element.childNodes.length - 1; i >= 0; i--) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Set Attempt to set focus on the current node.
	 * @param element
	 *          The node to attempt to focus on.
	 * @returns
	 *  true if element is focused.
	 */
	aria.Utils.attemptFocus = function (element) {
	  if (!aria.Utils.isFocusable(element)) {
	    return false;
	  }
	  aria.Utils.IgnoreUtilFocusChanges = true;
	  try {
	    element.focus();
	  } catch (e) {}
	  aria.Utils.IgnoreUtilFocusChanges = false;
	  return document.activeElement === element;
	};
	
	aria.Utils.isFocusable = function (element) {
	  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
	    return true;
	  }
	
	  if (element.disabled) {
	    return false;
	  }
	
	  switch (element.nodeName) {
	    case 'A':
	      return !!element.href && element.rel !== 'ignore';
	    case 'INPUT':
	      return element.type !== 'hidden' && element.type !== 'file';
	    case 'BUTTON':
	    case 'SELECT':
	    case 'TEXTAREA':
	      return true;
	    default:
	      return false;
	  }
	};
	
	/**
	 * 触发一个事件
	 * mouseenter, mouseleave, mouseover, keyup, change, click 等
	 * @param  {Element} elm
	 * @param  {String} name
	 * @param  {*} opts
	 */
	aria.Utils.triggerEvent = function (elm, name) {
	  var eventName = void 0;
	
	  if (/^mouse|click/.test(name)) {
	    eventName = 'MouseEvents';
	  } else if (/^key/.test(name)) {
	    eventName = 'KeyboardEvent';
	  } else {
	    eventName = 'HTMLEvents';
	  }
	  var evt = document.createEvent(eventName);
	
	  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    opts[_key - 2] = arguments[_key];
	  }
	
	  evt.initEvent.apply(evt, [name].concat(opts));
	  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);
	
	  return elm;
	};
	
	aria.Utils.keys = {
	  tab: 9,
	  enter: 13,
	  space: 32,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  esc: 27
	};
	
	exports.default = aria.Utils;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.removeResizeListener = exports.addResizeListener = undefined;
	
	var _resizeObserverPolyfill = __webpack_require__(880);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isServer = typeof window === 'undefined';
	
	/* istanbul ignore next */
	var resizeHandler = function resizeHandler(entries) {
	  for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var entry = _ref;
	
	    var listeners = entry.target.__resizeListeners__ || [];
	    if (listeners.length) {
	      listeners.forEach(function (fn) {
	        fn();
	      });
	    }
	  }
	};
	
	/* istanbul ignore next */
	var addResizeListener = exports.addResizeListener = function addResizeListener(element, fn) {
	  if (isServer) return;
	  if (!element.__resizeListeners__) {
	    element.__resizeListeners__ = [];
	    element.__ro__ = new _resizeObserverPolyfill2.default(resizeHandler);
	    element.__ro__.observe(element);
	  }
	  element.__resizeListeners__.push(fn);
	};
	
	/* istanbul ignore next */
	var removeResizeListener = exports.removeResizeListener = function removeResizeListener(element, fn) {
	  if (!element || !element.__resizeListeners__) return;
	  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	  if (!element.__resizeListeners__.length) {
	    element.__ro__.disconnect();
	  }
	};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = scrollIntoView;
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollIntoView(container, selected) {
	  if (_vue2.default.prototype.$isServer) return;
	
	  if (!selected) {
	    container.scrollTop = 0;
	    return;
	  }
	
	  var offsetParents = [];
	  var pointer = selected.offsetParent;
	  while (pointer && container !== pointer && container.contains(pointer)) {
	    offsetParents.push(pointer);
	    pointer = pointer.offsetParent;
	  }
	  var top = selected.offsetTop + offsetParents.reduce(function (prev, curr) {
	    return prev + curr.offsetTop;
	  }, 0);
	  var bottom = top + selected.offsetHeight;
	  var viewRectTop = container.scrollTop;
	  var viewRectBottom = viewRectTop + container.clientHeight;
	
	  if (top < viewRectTop) {
	    container.scrollTop = top;
	  } else if (bottom > viewRectBottom) {
	    container.scrollTop = bottom - container.clientHeight;
	  }
	}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  if (_vue2.default.prototype.$isServer) return 0;
	  if (scrollBarWidth !== undefined) return scrollBarWidth;
	
	  var outer = document.createElement('div');
	  outer.className = 'el-scrollbar__wrap';
	  outer.style.visibility = 'hidden';
	  outer.style.width = '100px';
	  outer.style.position = 'absolute';
	  outer.style.top = '-9999px';
	  document.body.appendChild(outer);
	
	  var widthNoScroll = outer.offsetWidth;
	  outer.style.overflow = 'scroll';
	
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  outer.appendChild(inner);
	
	  var widthWithScroll = inner.offsetWidth;
	  outer.parentNode.removeChild(outer);
	  scrollBarWidth = widthNoScroll - widthWithScroll;
	
	  return scrollBarWidth;
	};
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scrollBarWidth = void 0;
	
	;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(86);
	var Emitter = __webpack_require__(187);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(868);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 188 */
/***/ (function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(885)('socket.io-parser');
	var json = __webpack_require__(869);
	var Emitter = __webpack_require__(550);
	var binary = __webpack_require__(884);
	var isBuf = __webpack_require__(411);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    encodeAsBinary(obj, callback);
	  }
	  else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	  var str = '';
	  var nsp = false;
	
	  // first is type
	  str += obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    str += obj.attachments;
	    str += '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' != obj.nsp) {
	    nsp = true;
	    str += obj.nsp;
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    if (nsp) {
	      str += ',';
	      nsp = false;
	    }
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    if (nsp) str += ',';
	    str += json.stringify(obj.data);
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an ecoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if ('string' == typeof obj) {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  }
	  else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  }
	  else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var p = {};
	  var i = 0;
	
	  // look up type
	  p.type = Number(str.charAt(0));
	  if (null == exports.types[p.type]) return error();
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
	    var buf = '';
	    while (str.charAt(++i) != '-') {
	      buf += str.charAt(i);
	      if (i == str.length) break;
	    }
	    if (buf != Number(buf) || str.charAt(i) != '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' == str.charAt(i + 1)) {
	    p.nsp = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' == c) break;
	      p.nsp += c;
	      if (i == str.length) break;
	    }
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    p.id = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      p.id += str.charAt(i);
	      if (i == str.length) break;
	    }
	    p.id = Number(p.id);
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    p = tryParse(p, str.substr(i));
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(p, str) {
	  try {
	    p.data = json.parse(str);
	  } catch(e){
	    return error();
	  }
	  return p; 
	};
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error(data){
	  return {
	    type: exports.ERROR,
	    data: 'parser error'
	  };
	}


/***/ }),
/* 190 */
/***/ (function(module, exports) {

	/* eslint-disable no-undefined,no-param-reassign,no-shadow */
	
	/**
	 * Throttle execution of a function. Especially useful for rate limiting
	 * execution of handlers on events like resize and scroll.
	 *
	 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
	 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
	 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
	 *                                    the internal counter is reset)
	 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                    to `callback` when the throttled-function is executed.
	 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
	 *                                    schedule `callback` to execute after `delay` ms.
	 *
	 * @return {Function}  A new, throttled, function.
	 */
	module.exports = function ( delay, noTrailing, callback, debounceMode ) {
	
		// After wrapper has stopped being called, this timeout ensures that
		// `callback` is executed at the proper times in `throttle` and `end`
		// debounce modes.
		var timeoutID;
	
		// Keep track of the last time `callback` was executed.
		var lastExec = 0;
	
		// `noTrailing` defaults to falsy.
		if ( typeof noTrailing !== 'boolean' ) {
			debounceMode = callback;
			callback = noTrailing;
			noTrailing = undefined;
		}
	
		// The `wrapper` function encapsulates all of the throttling / debouncing
		// functionality and when executed will limit the rate at which `callback`
		// is executed.
		function wrapper () {
	
			var self = this;
			var elapsed = Number(new Date()) - lastExec;
			var args = arguments;
	
			// Execute `callback` and update the `lastExec` timestamp.
			function exec () {
				lastExec = Number(new Date());
				callback.apply(self, args);
			}
	
			// If `debounceMode` is true (at begin) this is used to clear the flag
			// to allow future `callback` executions.
			function clear () {
				timeoutID = undefined;
			}
	
			if ( debounceMode && !timeoutID ) {
				// Since `wrapper` is being called for the first time and
				// `debounceMode` is true (at begin), execute `callback`.
				exec();
			}
	
			// Clear any existing timeout.
			if ( timeoutID ) {
				clearTimeout(timeoutID);
			}
	
			if ( debounceMode === undefined && elapsed > delay ) {
				// In throttle mode, if `delay` time has been exceeded, execute
				// `callback`.
				exec();
	
			} else if ( noTrailing !== true ) {
				// In trailing throttle mode, since `delay` time has not been
				// exceeded, schedule `callback` to execute `delay` ms after most
				// recent execution.
				//
				// If `debounceMode` is true (at begin), schedule `clear` to execute
				// after `delay` ms.
				//
				// If `debounceMode` is false (at end), schedule `callback` to
				// execute after `delay` ms.
				timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
			}
	
		}
	
		// Return the wrapper function.
		return wrapper;
	
	};


/***/ }),
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(16);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating required fields.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function required(rule, value, source, errors, options, type) {
	  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
	    errors.push(util.format(options.messages.required, rule.fullField));
	  }
	}
	
	exports['default'] = required;
	module.exports = exports['default'];

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/
	
	module.exports = function mergeJSXProps (objs) {
	  return objs.reduce(function (a, b) {
	    var aa, bb, key, nestedKey, temp
	    for (key in b) {
	      aa = a[key]
	      bb = b[key]
	      if (aa && nestRE.test(key)) {
	        // normalize class
	        if (key === 'class') {
	          if (typeof aa === 'string') {
	            temp = aa
	            a[key] = aa = {}
	            aa[temp] = true
	          }
	          if (typeof bb === 'string') {
	            temp = bb
	            b[key] = bb = {}
	            bb[temp] = true
	          }
	        }
	        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
	          // merge functions
	          for (nestedKey in bb) {
	            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey])
	          }
	        } else if (Array.isArray(aa)) {
	          a[key] = aa.concat(bb)
	        } else if (Array.isArray(bb)) {
	          a[key] = [aa].concat(bb)
	        } else {
	          for (nestedKey in bb) {
	            aa[nestedKey] = bb[nestedKey]
	          }
	        }
	      } else {
	        a[key] = b[key]
	      }
	    }
	    return a
	  }, {})
	}
	
	function mergeFn (a, b) {
	  return function () {
	    a && a.apply(this, arguments)
	    b && b.apply(this, arguments)
	  }
	}


/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(552), __esModule: true };

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(557), __esModule: true };

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(558), __esModule: true };

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(559), __esModule: true };

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(561), __esModule: true };

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(199);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(21).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(28) && !__webpack_require__(60)(function () {
	  return Object.defineProperty(__webpack_require__(133)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(77);
	var ITERATOR = __webpack_require__(22)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(89);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(47);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(22)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 213 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(215);
	var hiddenKeys = __webpack_require__(134).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(61);
	var toIObject = __webpack_require__(62);
	var arrayIndexOf = __webpack_require__(567)(false);
	var IE_PROTO = __webpack_require__(142)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(28);
	var getKeys = __webpack_require__(78);
	var toIObject = __webpack_require__(62);
	var isEnum = __webpack_require__(92).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(47);
	var isObject = __webpack_require__(40);
	var newPromiseCapability = __webpack_require__(138);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(54);


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(21);
	var core = __webpack_require__(17);
	var dP = __webpack_require__(34);
	var DESCRIPTORS = __webpack_require__(28);
	var SPECIES = __webpack_require__(22)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(47);
	var aFunction = __webpack_require__(88);
	var SPECIES = __webpack_require__(22)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(53);
	var invoke = __webpack_require__(576);
	var html = __webpack_require__(207);
	var cel = __webpack_require__(133);
	var global = __webpack_require__(21);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(89)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(40);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(35);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(18);
	var toAbsoluteIndex = __webpack_require__(71);
	var toLength = __webpack_require__(12);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(64);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(23);
	var toObject = __webpack_require__(18);
	var IObject = __webpack_require__(97);
	var toLength = __webpack_require__(12);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(23);
	var isObject = __webpack_require__(7);
	var invoke = __webpack_require__(234);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(15).f;
	var create = __webpack_require__(65);
	var redefineAll = __webpack_require__(69);
	var ctx = __webpack_require__(37);
	var anInstance = __webpack_require__(63);
	var forOf = __webpack_require__(64);
	var $iterDefine = __webpack_require__(161);
	var step = __webpack_require__(237);
	var setSpecies = __webpack_require__(70);
	var DESCRIPTORS = __webpack_require__(14);
	var fastKey = __webpack_require__(57).fastKey;
	var validate = __webpack_require__(73);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(81);
	var from = __webpack_require__(226);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(69);
	var getWeak = __webpack_require__(57).getWeak;
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var anInstance = __webpack_require__(63);
	var forOf = __webpack_require__(64);
	var createArrayMethod = __webpack_require__(41);
	var $has = __webpack_require__(29);
	var validate = __webpack_require__(73);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(111);
	var isObject = __webpack_require__(7);
	var toLength = __webpack_require__(12);
	var ctx = __webpack_require__(37);
	var IS_CONCAT_SPREADABLE = __webpack_require__(9)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(14) && !__webpack_require__(6)(function () {
	  return Object.defineProperty(__webpack_require__(154)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(7);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(4);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 237 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(163);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 239 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 240 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(14);
	var getKeys = __webpack_require__(67);
	var gOPS = __webpack_require__(115);
	var pIE = __webpack_require__(98);
	var toObject = __webpack_require__(18);
	var IObject = __webpack_require__(97);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(6)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(15);
	var anObject = __webpack_require__(4);
	var getKeys = __webpack_require__(67);
	
	module.exports = __webpack_require__(14) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(32);
	var gOPN = __webpack_require__(66).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(29);
	var toIObject = __webpack_require__(32);
	var arrayIndexOf = __webpack_require__(108)(false);
	var IE_PROTO = __webpack_require__(168)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(14);
	var getKeys = __webpack_require__(67);
	var toIObject = __webpack_require__(32);
	var isEnum = __webpack_require__(98).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(66);
	var gOPS = __webpack_require__(115);
	var anObject = __webpack_require__(4);
	var Reflect = __webpack_require__(5).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(5).parseFloat;
	var $trim = __webpack_require__(84).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(171) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(5).parseInt;
	var $trim = __webpack_require__(84).trim;
	var ws = __webpack_require__(171);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 249 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var newPromiseCapability = __webpack_require__(165);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(12);
	var repeat = __webpack_require__(170);
	var defined = __webpack_require__(42);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(12);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(9);


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(229);
	var validate = __webpack_require__(73);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(109)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(166);
	__webpack_require__(2)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(14) && /./g.flags != 'g') __webpack_require__(15).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(96)
	});


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(229);
	var validate = __webpack_require__(73);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(109)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var each = __webpack_require__(41)(0);
	var redefine = __webpack_require__(26);
	var meta = __webpack_require__(57);
	var assign = __webpack_require__(241);
	var weak = __webpack_require__(231);
	var isObject = __webpack_require__(7);
	var validate = __webpack_require__(73);
	var NATIVE_WEAK_MAP = __webpack_require__(73);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(109)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 83);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(74);
	
	/***/ }),
	
	/***/ 83:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-checkbox",
	      class: [
	        _vm.border && _vm.checkboxSize
	          ? "el-checkbox--" + _vm.checkboxSize
	          : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.isChecked }
	      ],
	      attrs: { id: _vm.id }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-checkbox__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.isChecked,
	            "is-indeterminate": _vm.indeterminate,
	            "is-focus": _vm.focus
	          },
	          attrs: {
	            tabindex: _vm.indeterminate ? 0 : false,
	            role: _vm.indeterminate ? "checkbox" : false,
	            "aria-checked": _vm.indeterminate ? "mixed" : false
	          }
	        },
	        [
	          _c("span", { staticClass: "el-checkbox__inner" }),
	          _vm.trueLabel || _vm.falseLabel
	            ? _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  name: _vm.name,
	                  disabled: _vm.isDisabled,
	                  "true-value": _vm.trueLabel,
	                  "false-value": _vm.falseLabel
	                },
	                domProps: {
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, null) > -1
	                    : _vm._q(_vm.model, _vm.trueLabel)
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
	                      if (Array.isArray($$a)) {
	                        var $$v = null,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	            : _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  disabled: _vm.isDisabled,
	                  name: _vm.name
	                },
	                domProps: {
	                  value: _vm.label,
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, _vm.label) > -1
	                    : _vm.model
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? true : false
	                      if (Array.isArray($$a)) {
	                        var $$v = _vm.label,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	        ]
	      ),
	      _vm.$slots.default || _vm.label
	        ? _c(
	            "span",
	            { staticClass: "el-checkbox__label" },
	            [
	              _vm._t("default"),
	              !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
	  name: 'ElCheckbox',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElCheckbox',
	
	  data: function data() {
	    return {
	      selfModel: false,
	      focus: false,
	      isLimitExceeded: false
	    };
	  },
	
	
	  computed: {
	    model: {
	      get: function get() {
	        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.isLimitExceeded = false;
	          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
	
	          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
	
	          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	          this.selfModel = val;
	        }
	      }
	    },
	
	    isChecked: function isChecked() {
	      if ({}.toString.call(this.model) === '[object Boolean]') {
	        return this.model;
	      } else if (Array.isArray(this.model)) {
	        return this.model.indexOf(this.label) > -1;
	      } else if (this.model !== null && this.model !== undefined) {
	        return this.model === this.trueLabel;
	      }
	    },
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElCheckboxGroup') {
	          parent = parent.$parent;
	        } else {
	          this._checkboxGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	    store: function store() {
	      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
	    },
	
	
	    /* used to make the isDisabled judgment under max/min props */
	    isLimitDisabled: function isLimitDisabled() {
	      var _checkboxGroup = this._checkboxGroup,
	          max = _checkboxGroup.max,
	          min = _checkboxGroup.min;
	
	      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxSize: function checkboxSize() {
	      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
	    }
	  },
	
	  props: {
	    value: {},
	    label: {},
	    indeterminate: Boolean,
	    disabled: Boolean,
	    checked: Boolean,
	    name: String,
	    trueLabel: [String, Number],
	    falseLabel: [String, Number],
	    id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    border: Boolean,
	    size: String
	  },
	
	  methods: {
	    addToStore: function addToStore() {
	      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
	        this.model.push(this.label);
	      } else {
	        this.model = this.trueLabel || true;
	      }
	    },
	    handleChange: function handleChange(ev) {
	      var _this = this;
	
	      if (this.isLimitExceeded) return;
	      var value = void 0;
	      if (ev.target.checked) {
	        value = this.trueLabel === undefined ? true : this.trueLabel;
	      } else {
	        value = this.falseLabel === undefined ? false : this.falseLabel;
	      }
	      this.$emit('change', value, ev);
	      this.$nextTick(function () {
	        if (_this.isGroup) {
	          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
	        }
	      });
	    }
	  },
	
	  created: function created() {
	    this.checked && this.addToStore();
	  },
	  mounted: function mounted() {
	    // 为indeterminate元素 添加aria-controls 属性
	    if (this.indeterminate) {
	      this.$el.setAttribute('aria-controls', this.controls);
	    }
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', _value);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_checkboxvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/checkbox/src/checkbox.vue"
	/* harmony default export */ var src_checkbox = (component.exports);
	// CONCATENATED MODULE: ./packages/checkbox/index.js
	
	
	/* istanbul ignore next */
	src_checkbox.install = function (Vue) {
	  Vue.component(src_checkbox.name, src_checkbox);
	};
	
	/* harmony default export */ var packages_checkbox = __webpack_exports__["default"] = (src_checkbox);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _util = __webpack_require__(45);
	
	/**
	 * Show migrating guide in browser console.
	 *
	 * Usage:
	 * import Migrating from 'element-ui/src/mixins/migrating';
	 *
	 * mixins: [Migrating]
	 *
	 * add getMigratingConfig method for your component.
	 *  getMigratingConfig() {
	 *    return {
	 *      props: {
	 *        'allow-no-selection': 'allow-no-selection is removed.',
	 *        'selection-mode': 'selection-mode is removed.'
	 *      },
	 *      events: {
	 *        selectionchange: 'selectionchange is renamed to selection-change.'
	 *      }
	 *    };
	 *  },
	 */
	exports.default = {
	  mounted: function mounted() {
	    if (true) return;
	    if (!this.$vnode) return;
	
	    var _getMigratingConfig = this.getMigratingConfig(),
	        _getMigratingConfig$p = _getMigratingConfig.props,
	        props = _getMigratingConfig$p === undefined ? {} : _getMigratingConfig$p,
	        _getMigratingConfig$e = _getMigratingConfig.events,
	        events = _getMigratingConfig$e === undefined ? {} : _getMigratingConfig$e;
	
	    var _$vnode = this.$vnode,
	        data = _$vnode.data,
	        componentOptions = _$vnode.componentOptions;
	
	    var definedProps = data.attrs || {};
	    var definedEvents = componentOptions.listeners || {};
	
	    for (var propName in definedProps) {
	      propName = (0, _util.kebabCase)(propName); // compatible with camel case
	      if (props[propName]) {
	        console.warn('[Element Migrating][' + this.$options.name + '][Attribute]: ' + props[propName]);
	      }
	    }
	
	    for (var eventName in definedEvents) {
	      eventName = (0, _util.kebabCase)(eventName); // compatible with camel case
	      if (events[eventName]) {
	        console.warn('[Element Migrating][' + this.$options.name + '][Event]: ' + events[eventName]);
	      }
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {},
	        events: {}
	      };
	    }
	  }
	};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 116);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 116:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-radio",
	      class: [
	        _vm.border && _vm.radioSize ? "el-radio--" + _vm.radioSize : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-focus": _vm.focus },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.model === _vm.label }
	      ],
	      attrs: {
	        role: "radio",
	        "aria-checked": _vm.model === _vm.label,
	        "aria-disabled": _vm.isDisabled,
	        tabindex: _vm.tabIndex
	      },
	      on: {
	        keydown: function($event) {
	          if (
	            !("button" in $event) &&
	            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
	          ) {
	            return null
	          }
	          $event.stopPropagation()
	          $event.preventDefault()
	          _vm.model = _vm.isDisabled ? _vm.model : _vm.label
	        }
	      }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.model === _vm.label
	          }
	        },
	        [
	          _c("span", { staticClass: "el-radio__inner" }),
	          _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            ref: "radio",
	            staticClass: "el-radio__original",
	            attrs: {
	              type: "radio",
	              "aria-hidden": "true",
	              name: _vm.name,
	              disabled: _vm.isDisabled,
	              tabindex: "-1"
	            },
	            domProps: {
	              value: _vm.label,
	              checked: _vm._q(_vm.model, _vm.label)
	            },
	            on: {
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              },
	              change: [
	                function($event) {
	                  _vm.model = _vm.label
	                },
	                _vm.handleChange
	              ]
	            }
	          })
	        ]
	      ),
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__label",
	          on: {
	            keydown: function($event) {
	              $event.stopPropagation()
	            }
	          }
	        },
	        [
	          _vm._t("default"),
	          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var radiovue_type_script_lang_js_ = ({
	  name: 'ElRadio',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElRadio',
	
	  props: {
	    value: {},
	    label: {},
	    disabled: Boolean,
	    name: String,
	    border: Boolean,
	    size: String
	  },
	
	  data: function data() {
	    return {
	      focus: false
	    };
	  },
	
	  computed: {
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElRadioGroup') {
	          parent = parent.$parent;
	        } else {
	          this._radioGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	
	    model: {
	      get: function get() {
	        return this.isGroup ? this._radioGroup.value : this.value;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.dispatch('ElRadioGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	        }
	        this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
	      }
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    radioSize: function radioSize() {
	      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    tabIndex: function tabIndex() {
	      return this.isDisabled || this.isGroup && this.model !== this.label ? -1 : 0;
	    }
	  },
	
	  methods: {
	    handleChange: function handleChange() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.$emit('change', _this.model);
	        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_radiovue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/radio/src/radio.vue"
	/* harmony default export */ var src_radio = (component.exports);
	// CONCATENATED MODULE: ./packages/radio/index.js
	
	
	/* istanbul ignore next */
	src_radio.install = function (Vue) {
	  Vue.component(src_radio.name, src_radio);
	};
	
	/* harmony default export */ var packages_radio = __webpack_exports__["default"] = (src_radio);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(74);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 124);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 124:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var tagvue_type_script_lang_js_ = ({
	  name: 'ElTag',
	  props: {
	    text: String,
	    closable: Boolean,
	    type: String,
	    hit: Boolean,
	    disableTransitions: Boolean,
	    color: String,
	    size: String,
	    effect: {
	      type: String,
	      default: 'light',
	      validator: function validator(val) {
	        return ['dark', 'light', 'plain'].indexOf(val) !== -1;
	      }
	    }
	  },
	  methods: {
	    handleClose: function handleClose(event) {
	      event.stopPropagation();
	      this.$emit('close', event);
	    },
	    handleClick: function handleClick(event) {
	      this.$emit('click', event);
	    }
	  },
	  computed: {
	    tagSize: function tagSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    }
	  },
	  render: function render(h) {
	    var type = this.type,
	        tagSize = this.tagSize,
	        hit = this.hit,
	        effect = this.effect;
	
	    var classes = ['el-tag', type ? 'el-tag--' + type : '', tagSize ? 'el-tag--' + tagSize : '', effect ? 'el-tag--' + effect : '', hit && 'is-hit'];
	    var tagEl = h(
	      'span',
	      {
	        'class': classes,
	        style: { backgroundColor: this.color },
	        on: {
	          'click': this.handleClick
	        }
	      },
	      [this.$slots.default, this.closable && h('i', { 'class': 'el-tag__close el-icon-close', on: {
	          'click': this.handleClose
	        }
	      })]
	    );
	
	    return this.disableTransitions ? tagEl : h(
	      'transition',
	      {
	        attrs: { name: 'el-zoom-in-center' }
	      },
	      [tagEl]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue
	var render, staticRenderFns
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_tagvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/tag/src/tag.vue"
	/* harmony default export */ var tag = (component.exports);
	// CONCATENATED MODULE: ./packages/tag/index.js
	
	
	/* istanbul ignore next */
	tag.install = function (Vue) {
	  Vue.component(tag.name, tag);
	};
	
	/* harmony default export */ var packages_tag = __webpack_exports__["default"] = (tag);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _dom = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nodeList = [];
	var ctx = '@@clickoutsideContext';
	
	var startClick = void 0;
	var seed = 0;
	
	!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mousedown', function (e) {
	  return startClick = e;
	});
	
	!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mouseup', function (e) {
	  nodeList.forEach(function (node) {
	    return node[ctx].documentHandler(e, startClick);
	  });
	});
	
	function createDocumentHandler(el, binding, vnode) {
	  return function () {
	    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;
	
	    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
	      vnode.context[el[ctx].methodName]();
	    } else {
	      el[ctx].bindingFn && el[ctx].bindingFn();
	    }
	  };
	}
	
	/**
	 * v-clickoutside
	 * @desc 点击元素外面才会触发的事件
	 * @example
	 * ```vue
	 * <div v-element-clickoutside="handleClose">
	 * ```
	 */
	exports.default = {
	  bind: function bind(el, binding, vnode) {
	    nodeList.push(el);
	    var id = seed++;
	    el[ctx] = {
	      id: id,
	      documentHandler: createDocumentHandler(el, binding, vnode),
	      methodName: binding.expression,
	      bindingFn: binding.value
	    };
	  },
	  update: function update(el, binding, vnode) {
	    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
	    el[ctx].methodName = binding.expression;
	    el[ctx].bindingFn = binding.value;
	  },
	  unbind: function unbind(el) {
	    var len = nodeList.length;
	
	    for (var i = 0; i < len; i++) {
	      if (nodeList[i][ctx].id === el[ctx].id) {
	        nodeList.splice(i, 1);
	        break;
	      }
	    }
	    delete el[ctx];
	  }
	};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/* Modified from https://github.com/taylorhakes/fecha
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2015 Taylor Hakes
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 *     The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 *     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 *     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	
	/*eslint-disable*/
	// 把 YYYY-MM-DD 改成了 yyyy-MM-dd
	(function (main) {
	  'use strict';
	
	  /**
	   * Parse or format dates
	   * @class fecha
	   */
	
	  var fecha = {};
	  var token = /d{1,4}|M{1,4}|yy(?:yy)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
	  var twoDigits = '\\d\\d?';
	  var threeDigits = '\\d{3}';
	  var fourDigits = '\\d{4}';
	  var word = '[^\\s]+';
	  var literal = /\[([^]*?)\]/gm;
	  var noop = function noop() {};
	
	  function regexEscape(str) {
	    return str.replace(/[|\\{()[^$+*?.-]/g, '\\$&');
	  }
	
	  function shorten(arr, sLen) {
	    var newArr = [];
	    for (var i = 0, len = arr.length; i < len; i++) {
	      newArr.push(arr[i].substr(0, sLen));
	    }
	    return newArr;
	  }
	
	  function monthUpdate(arrName) {
	    return function (d, v, i18n) {
	      var index = i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());
	      if (~index) {
	        d.month = index;
	      }
	    };
	  }
	
	  function pad(val, len) {
	    val = String(val);
	    len = len || 2;
	    while (val.length < len) {
	      val = '0' + val;
	    }
	    return val;
	  }
	
	  var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	  var monthNamesShort = shorten(monthNames, 3);
	  var dayNamesShort = shorten(dayNames, 3);
	  fecha.i18n = {
	    dayNamesShort: dayNamesShort,
	    dayNames: dayNames,
	    monthNamesShort: monthNamesShort,
	    monthNames: monthNames,
	    amPm: ['am', 'pm'],
	    DoFn: function DoFn(D) {
	      return D + ['th', 'st', 'nd', 'rd'][D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10];
	    }
	  };
	
	  var formatFlags = {
	    D: function D(dateObj) {
	      return dateObj.getDay();
	    },
	    DD: function DD(dateObj) {
	      return pad(dateObj.getDay());
	    },
	    Do: function Do(dateObj, i18n) {
	      return i18n.DoFn(dateObj.getDate());
	    },
	    d: function d(dateObj) {
	      return dateObj.getDate();
	    },
	    dd: function dd(dateObj) {
	      return pad(dateObj.getDate());
	    },
	    ddd: function ddd(dateObj, i18n) {
	      return i18n.dayNamesShort[dateObj.getDay()];
	    },
	    dddd: function dddd(dateObj, i18n) {
	      return i18n.dayNames[dateObj.getDay()];
	    },
	    M: function M(dateObj) {
	      return dateObj.getMonth() + 1;
	    },
	    MM: function MM(dateObj) {
	      return pad(dateObj.getMonth() + 1);
	    },
	    MMM: function MMM(dateObj, i18n) {
	      return i18n.monthNamesShort[dateObj.getMonth()];
	    },
	    MMMM: function MMMM(dateObj, i18n) {
	      return i18n.monthNames[dateObj.getMonth()];
	    },
	    yy: function yy(dateObj) {
	      return pad(String(dateObj.getFullYear()), 4).substr(2);
	    },
	    yyyy: function yyyy(dateObj) {
	      return pad(dateObj.getFullYear(), 4);
	    },
	    h: function h(dateObj) {
	      return dateObj.getHours() % 12 || 12;
	    },
	    hh: function hh(dateObj) {
	      return pad(dateObj.getHours() % 12 || 12);
	    },
	    H: function H(dateObj) {
	      return dateObj.getHours();
	    },
	    HH: function HH(dateObj) {
	      return pad(dateObj.getHours());
	    },
	    m: function m(dateObj) {
	      return dateObj.getMinutes();
	    },
	    mm: function mm(dateObj) {
	      return pad(dateObj.getMinutes());
	    },
	    s: function s(dateObj) {
	      return dateObj.getSeconds();
	    },
	    ss: function ss(dateObj) {
	      return pad(dateObj.getSeconds());
	    },
	    S: function S(dateObj) {
	      return Math.round(dateObj.getMilliseconds() / 100);
	    },
	    SS: function SS(dateObj) {
	      return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
	    },
	    SSS: function SSS(dateObj) {
	      return pad(dateObj.getMilliseconds(), 3);
	    },
	    a: function a(dateObj, i18n) {
	      return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
	    },
	    A: function A(dateObj, i18n) {
	      return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
	    },
	    ZZ: function ZZ(dateObj) {
	      var o = dateObj.getTimezoneOffset();
	      return (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
	    }
	  };
	
	  var parseFlags = {
	    d: [twoDigits, function (d, v) {
	      d.day = v;
	    }],
	    Do: [twoDigits + word, function (d, v) {
	      d.day = parseInt(v, 10);
	    }],
	    M: [twoDigits, function (d, v) {
	      d.month = v - 1;
	    }],
	    yy: [twoDigits, function (d, v) {
	      var da = new Date(),
	          cent = +('' + da.getFullYear()).substr(0, 2);
	      d.year = '' + (v > 68 ? cent - 1 : cent) + v;
	    }],
	    h: [twoDigits, function (d, v) {
	      d.hour = v;
	    }],
	    m: [twoDigits, function (d, v) {
	      d.minute = v;
	    }],
	    s: [twoDigits, function (d, v) {
	      d.second = v;
	    }],
	    yyyy: [fourDigits, function (d, v) {
	      d.year = v;
	    }],
	    S: ['\\d', function (d, v) {
	      d.millisecond = v * 100;
	    }],
	    SS: ['\\d{2}', function (d, v) {
	      d.millisecond = v * 10;
	    }],
	    SSS: [threeDigits, function (d, v) {
	      d.millisecond = v;
	    }],
	    D: [twoDigits, noop],
	    ddd: [word, noop],
	    MMM: [word, monthUpdate('monthNamesShort')],
	    MMMM: [word, monthUpdate('monthNames')],
	    a: [word, function (d, v, i18n) {
	      var val = v.toLowerCase();
	      if (val === i18n.amPm[0]) {
	        d.isPm = false;
	      } else if (val === i18n.amPm[1]) {
	        d.isPm = true;
	      }
	    }],
	    ZZ: ['[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z', function (d, v) {
	      var parts = (v + '').match(/([+-]|\d\d)/gi),
	          minutes;
	
	      if (parts) {
	        minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
	        d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
	      }
	    }]
	  };
	  parseFlags.dd = parseFlags.d;
	  parseFlags.dddd = parseFlags.ddd;
	  parseFlags.DD = parseFlags.D;
	  parseFlags.mm = parseFlags.m;
	  parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
	  parseFlags.MM = parseFlags.M;
	  parseFlags.ss = parseFlags.s;
	  parseFlags.A = parseFlags.a;
	
	  // Some common format strings
	  fecha.masks = {
	    default: 'ddd MMM dd yyyy HH:mm:ss',
	    shortDate: 'M/D/yy',
	    mediumDate: 'MMM d, yyyy',
	    longDate: 'MMMM d, yyyy',
	    fullDate: 'dddd, MMMM d, yyyy',
	    shortTime: 'HH:mm',
	    mediumTime: 'HH:mm:ss',
	    longTime: 'HH:mm:ss.SSS'
	  };
	
	  /***
	   * Format a date
	   * @method format
	   * @param {Date|number} dateObj
	   * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
	   */
	  fecha.format = function (dateObj, mask, i18nSettings) {
	    var i18n = i18nSettings || fecha.i18n;
	
	    if (typeof dateObj === 'number') {
	      dateObj = new Date(dateObj);
	    }
	
	    if (Object.prototype.toString.call(dateObj) !== '[object Date]' || isNaN(dateObj.getTime())) {
	      throw new Error('Invalid Date in fecha.format');
	    }
	
	    mask = fecha.masks[mask] || mask || fecha.masks['default'];
	
	    var literals = [];
	
	    // Make literals inactive by replacing them with ??
	    mask = mask.replace(literal, function ($0, $1) {
	      literals.push($1);
	      return '@@@';
	    });
	    // Apply formatting rules
	    mask = mask.replace(token, function ($0) {
	      return $0 in formatFlags ? formatFlags[$0](dateObj, i18n) : $0.slice(1, $0.length - 1);
	    });
	    // Inline literal values back into the formatted value
	    return mask.replace(/@@@/g, function () {
	      return literals.shift();
	    });
	  };
	
	  /**
	   * Parse a date string into an object, changes - into /
	   * @method parse
	   * @param {string} dateStr Date string
	   * @param {string} format Date parse format
	   * @returns {Date|boolean}
	   */
	  fecha.parse = function (dateStr, format, i18nSettings) {
	    var i18n = i18nSettings || fecha.i18n;
	
	    if (typeof format !== 'string') {
	      throw new Error('Invalid format in fecha.parse');
	    }
	
	    format = fecha.masks[format] || format;
	
	    // Avoid regular expression denial of service, fail early for really long strings
	    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
	    if (dateStr.length > 1000) {
	      return null;
	    }
	
	    var dateInfo = {};
	    var parseInfo = [];
	    var literals = [];
	    format = format.replace(literal, function ($0, $1) {
	      literals.push($1);
	      return '@@@';
	    });
	    var newFormat = regexEscape(format).replace(token, function ($0) {
	      if (parseFlags[$0]) {
	        var info = parseFlags[$0];
	        parseInfo.push(info[1]);
	        return '(' + info[0] + ')';
	      }
	
	      return $0;
	    });
	    newFormat = newFormat.replace(/@@@/g, function () {
	      return literals.shift();
	    });
	    var matches = dateStr.match(new RegExp(newFormat, 'i'));
	    if (!matches) {
	      return null;
	    }
	
	    for (var i = 1; i < matches.length; i++) {
	      parseInfo[i - 1](dateInfo, matches[i], i18n);
	    }
	
	    var today = new Date();
	    if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
	      dateInfo.hour = +dateInfo.hour + 12;
	    } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
	      dateInfo.hour = 0;
	    }
	
	    var date;
	    if (dateInfo.timezoneOffset != null) {
	      dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
	      date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
	    } else {
	      date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
	    }
	    return date;
	  };
	
	  /* istanbul ignore next */
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = fecha;
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return fecha;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    main.fecha = fecha;
	  }
	})(undefined);

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PopupManager = undefined;
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _merge = __webpack_require__(122);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _popupManager = __webpack_require__(832);
	
	var _popupManager2 = _interopRequireDefault(_popupManager);
	
	var _scrollbarWidth = __webpack_require__(184);
	
	var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);
	
	var _dom = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var idSeed = 1;
	
	var scrollBarWidth = void 0;
	
	exports.default = {
	  props: {
	    visible: {
	      type: Boolean,
	      default: false
	    },
	    openDelay: {},
	    closeDelay: {},
	    zIndex: {},
	    modal: {
	      type: Boolean,
	      default: false
	    },
	    modalFade: {
	      type: Boolean,
	      default: true
	    },
	    modalClass: {},
	    modalAppendToBody: {
	      type: Boolean,
	      default: false
	    },
	    lockScroll: {
	      type: Boolean,
	      default: true
	    },
	    closeOnPressEscape: {
	      type: Boolean,
	      default: false
	    },
	    closeOnClickModal: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  beforeMount: function beforeMount() {
	    this._popupId = 'popup-' + idSeed++;
	    _popupManager2.default.register(this._popupId, this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _popupManager2.default.deregister(this._popupId);
	    _popupManager2.default.closeModal(this._popupId);
	
	    this.restoreBodyStyle();
	  },
	  data: function data() {
	    return {
	      opened: false,
	      bodyPaddingRight: null,
	      computedBodyPaddingRight: 0,
	      withoutHiddenClass: true,
	      rendered: false
	    };
	  },
	
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        if (this._opening) return;
	        if (!this.rendered) {
	          this.rendered = true;
	          _vue2.default.nextTick(function () {
	            _this.open();
	          });
	        } else {
	          this.open();
	        }
	      } else {
	        this.close();
	      }
	    }
	  },
	
	  methods: {
	    open: function open(options) {
	      var _this2 = this;
	
	      if (!this.rendered) {
	        this.rendered = true;
	      }
	
	      var props = (0, _merge2.default)({}, this.$props || this, options);
	
	      if (this._closeTimer) {
	        clearTimeout(this._closeTimer);
	        this._closeTimer = null;
	      }
	      clearTimeout(this._openTimer);
	
	      var openDelay = Number(props.openDelay);
	      if (openDelay > 0) {
	        this._openTimer = setTimeout(function () {
	          _this2._openTimer = null;
	          _this2.doOpen(props);
	        }, openDelay);
	      } else {
	        this.doOpen(props);
	      }
	    },
	    doOpen: function doOpen(props) {
	      if (this.$isServer) return;
	      if (this.willOpen && !this.willOpen()) return;
	      if (this.opened) return;
	
	      this._opening = true;
	
	      var dom = this.$el;
	
	      var modal = props.modal;
	
	      var zIndex = props.zIndex;
	      if (zIndex) {
	        _popupManager2.default.zIndex = zIndex;
	      }
	
	      if (modal) {
	        if (this._closing) {
	          _popupManager2.default.closeModal(this._popupId);
	          this._closing = false;
	        }
	        _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
	        if (props.lockScroll) {
	          this.withoutHiddenClass = !(0, _dom.hasClass)(document.body, 'el-popup-parent--hidden');
	          if (this.withoutHiddenClass) {
	            this.bodyPaddingRight = document.body.style.paddingRight;
	            this.computedBodyPaddingRight = parseInt((0, _dom.getStyle)(document.body, 'paddingRight'), 10);
	          }
	          scrollBarWidth = (0, _scrollbarWidth2.default)();
	          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
	          var bodyOverflowY = (0, _dom.getStyle)(document.body, 'overflowY');
	          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
	            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px';
	          }
	          (0, _dom.addClass)(document.body, 'el-popup-parent--hidden');
	        }
	      }
	
	      if (getComputedStyle(dom).position === 'static') {
	        dom.style.position = 'absolute';
	      }
	
	      dom.style.zIndex = _popupManager2.default.nextZIndex();
	      this.opened = true;
	
	      this.onOpen && this.onOpen();
	
	      this.doAfterOpen();
	    },
	    doAfterOpen: function doAfterOpen() {
	      this._opening = false;
	    },
	    close: function close() {
	      var _this3 = this;
	
	      if (this.willClose && !this.willClose()) return;
	
	      if (this._openTimer !== null) {
	        clearTimeout(this._openTimer);
	        this._openTimer = null;
	      }
	      clearTimeout(this._closeTimer);
	
	      var closeDelay = Number(this.closeDelay);
	
	      if (closeDelay > 0) {
	        this._closeTimer = setTimeout(function () {
	          _this3._closeTimer = null;
	          _this3.doClose();
	        }, closeDelay);
	      } else {
	        this.doClose();
	      }
	    },
	    doClose: function doClose() {
	      this._closing = true;
	
	      this.onClose && this.onClose();
	
	      if (this.lockScroll) {
	        setTimeout(this.restoreBodyStyle, 200);
	      }
	
	      this.opened = false;
	
	      this.doAfterClose();
	    },
	    doAfterClose: function doAfterClose() {
	      _popupManager2.default.closeModal(this._popupId);
	      this._closing = false;
	    },
	    restoreBodyStyle: function restoreBodyStyle() {
	      if (this.modal && this.withoutHiddenClass) {
	        document.body.style.paddingRight = this.bodyPaddingRight;
	        (0, _dom.removeClass)(document.body, 'el-popup-parent--hidden');
	      }
	      this.withoutHiddenClass = true;
	    }
	  }
	};
	exports.PopupManager = _popupManager2.default;

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isString = isString;
	exports.isObject = isObject;
	exports.isHtmlElement = isHtmlElement;
	function isString(obj) {
	  return Object.prototype.toString.call(obj) === '[object String]';
	}
	
	function isObject(obj) {
	  return Object.prototype.toString.call(obj) === '[object Object]';
	}
	
	function isHtmlElement(node) {
	  return node && node.nodeType === Node.ELEMENT_NODE;
	}
	
	var isFunction = exports.isFunction = function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	};
	
	var isUndefined = exports.isUndefined = function isUndefined(val) {
	  return val === void 0;
	};
	
	var isDefined = exports.isDefined = function isDefined(val) {
	  return val !== undefined && val !== null;
	};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(186);
	var XHR = __webpack_require__(838);
	var JSONP = __webpack_require__(837);
	var websocket = __webpack_require__(839);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(185);
	var parseqs = __webpack_require__(188);
	var parser = __webpack_require__(86);
	var inherit = __webpack_require__(104);
	var yeast = __webpack_require__(419);
	var debug = __webpack_require__(58)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(186);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(272);
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Right now only Buffer and ArrayBuffer are supported..
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary(data) {
	
	  function _hasBinary(obj) {
	    if (!obj) return false;
	
	    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
	         (global.Blob && obj instanceof Blob) ||
	         (global.File && obj instanceof File)
	        ) {
	      return true;
	    }
	
	    if (isArray(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	          if (_hasBinary(obj[i])) {
	              return true;
	          }
	      }
	    } else if (obj && 'object' == typeof obj) {
	      // see: https://github.com/Automattic/has-binary/pull/4
	      if (obj.toJSON && 'function' == typeof obj.toJSON) {
	        obj = obj.toJSON();
	      }
	
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  return _hasBinary(data);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '1',
	            '2': '2',
	            '3': '3',
	            '4': '4',
	            '5': '5',
	            '6': '6',
	            '7': '7',
	            '8': '8',
	            '9': '9',
	            '0': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '١',
	            '2': '٢',
	            '3': '٣',
	            '4': '٤',
	            '5': '٥',
	            '6': '٦',
	            '7': '٧',
	            '8': '٨',
	            '9': '٩',
	            '0': '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '١',
	            '2': '٢',
	            '3': '٣',
	            '4': '٤',
	            '5': '٥',
	            '6': '٦',
	            '7': '٧',
	            '8': '٨',
	            '9': '٩',
	            '0': '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'birneçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '১',
	            '2': '২',
	            '3': '৩',
	            '4': '৪',
	            '5': '৫',
	            '6': '৬',
	            '7': '৭',
	            '8': '৮',
	            '9': '৯',
	            '0': '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '༡',
	            '2': '༢',
	            '3': '༣',
	            '4': '༤',
	            '5': '༥',
	            '6': '༦',
	            '7': '༧',
	            '8': '༨',
	            '9': '༩',
	            '0': '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha invalida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '۱',
	            '2': '۲',
	            '3': '۳',
	            '4': '۴',
	            '5': '۵',
	            '6': '۶',
	            '7': '۷',
	            '8': '۸',
	            '9': '۹',
	            '0': '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '१',
	            '2': '२',
	            '3': '३',
	            '4': '४',
	            '5': '५',
	            '6': '६',
	            '7': '७',
	            '8': '८',
	            '9': '९',
	            '0': '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var hi = moment.defineLocale('hi', {
	        months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split(
	            '_'
	        ),
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '១',
	            '2': '២',
	            '3': '៣',
	            '4': '៤',
	            '5': '៥',
	            '6': '៦',
	            '7': '៧',
	            '8': '៨',
	            '9': '៩',
	            '0': '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '೧',
	            '2': '೨',
	            '3': '೩',
	            '4': '೪',
	            '5': '೫',
	            '6': '೬',
	            '7': '೭',
	            '8': '೮',
	            '9': '೯',
	            '0': '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '١',
	            '2': '٢',
	            '3': '٣',
	            '4': '٤',
	            '5': '٥',
	            '6': '٦',
	            '7': '٧',
	            '8': '٨',
	            '9': '٩',
	            '0': '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '१',
	            '2': '२',
	            '3': '३',
	            '4': '४',
	            '5': '५',
	            '6': '६',
	            '7': '७',
	            '8': '८',
	            '9': '९',
	            '0': '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '၁',
	            '2': '၂',
	            '3': '၃',
	            '4': '၄',
	            '5': '၅',
	            '6': '၆',
	            '7': '၇',
	            '8': '၈',
	            '9': '၉',
	            '0': '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '१',
	            '2': '२',
	            '3': '३',
	            '4': '४',
	            '5': '५',
	            '6': '६',
	            '7': '७',
	            '8': '८',
	            '9': '९',
	            '0': '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '੧',
	            '2': '੨',
	            '3': '੩',
	            '4': '੪',
	            '5': '੫',
	            '6': '੬',
	            '7': '੭',
	            '8': '੮',
	            '9': '੯',
	            '0': '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        );
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return (
	                    '(' +
	                    monthsSubjective[momentToFormat.month()] +
	                    '|' +
	                    monthsNominative[momentToFormat.month()] +
	                    ')'
	                );
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '௧',
	            '2': '௨',
	            '3': '௩',
	            '4': '௪',
	            '5': '௫',
	            '6': '௬',
	            '7': '௭',
	            '8': '௮',
	            '9': '௯',
	            '0': '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Пагоҳ соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js language configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 405 */
/***/ (function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    return uri;
	};


/***/ }),
/* 406 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(834);
	var Socket = __webpack_require__(409);
	var Emitter = __webpack_require__(410);
	var parser = __webpack_require__(189);
	var on = __webpack_require__(408);
	var bind = __webpack_require__(206);
	var debug = __webpack_require__(58)('socket.io-client:manager');
	var indexOf = __webpack_require__(271);
	var Backoff = __webpack_require__(546);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  this.encoder = new parser.Encoder();
	  this.decoder = new parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.engine.id;
	    }
	  }
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.engine.id;
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting evnet is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ }),
/* 408 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(189);
	var Emitter = __webpack_require__(410);
	var toArray = __webpack_require__(890);
	var on = __webpack_require__(408);
	var bind = __webpack_require__(206);
	var debug = __webpack_require__(58)('socket.io-client:socket');
	var hasBin = __webpack_require__(270);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var parserType = parser.EVENT; // default
	  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
	  var packet = { type: parserType, data: args };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  delete this.flags;
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      this.packet({type: parser.CONNECT, query: this.query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  if (packet.nsp !== this.nsp) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
	    self.packet({
	      type: type,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags = this.flags || {};
	  this.flags.compress = compress;
	  return this;
	};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 411 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	module.exports = isBuf;
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * vuex v2.5.0
	 * (c) 2017 Evan You
	 * @license MIT
	 */
	'use strict';
	
	var applyMixin = function (Vue) {
	  var version = Number(Vue.version.split('.')[0]);
	
	  if (version >= 2) {
	    Vue.mixin({ beforeCreate: vuexInit });
	  } else {
	    // override init and inject vuex init procedure
	    // for 1.x backwards compatibility.
	    var _init = Vue.prototype._init;
	    Vue.prototype._init = function (options) {
	      if ( options === void 0 ) options = {};
	
	      options.init = options.init
	        ? [vuexInit].concat(options.init)
	        : vuexInit;
	      _init.call(this, options);
	    };
	  }
	
	  /**
	   * Vuex init hook, injected into each instances init hooks list.
	   */
	
	  function vuexInit () {
	    var options = this.$options;
	    // store injection
	    if (options.store) {
	      this.$store = typeof options.store === 'function'
	        ? options.store()
	        : options.store;
	    } else if (options.parent && options.parent.$store) {
	      this.$store = options.parent.$store;
	    }
	  }
	};
	
	var devtoolHook =
	  typeof window !== 'undefined' &&
	  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	function devtoolPlugin (store) {
	  if (!devtoolHook) { return }
	
	  store._devtoolHook = devtoolHook;
	
	  devtoolHook.emit('vuex:init', store);
	
	  devtoolHook.on('vuex:travel-to-state', function (targetState) {
	    store.replaceState(targetState);
	  });
	
	  store.subscribe(function (mutation, state) {
	    devtoolHook.emit('vuex:mutation', mutation, state);
	  });
	}
	
	/**
	 * Get the first item that pass the test
	 * by second argument function
	 *
	 * @param {Array} list
	 * @param {Function} f
	 * @return {*}
	 */
	/**
	 * Deep copy the given object considering circular structure.
	 * This function caches all nested objects and its copies.
	 * If it detects circular structure, use cached copy to avoid infinite loop.
	 *
	 * @param {*} obj
	 * @param {Array<Object>} cache
	 * @return {*}
	 */
	
	
	/**
	 * forEach for object
	 */
	function forEachValue (obj, fn) {
	  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
	}
	
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	function isPromise (val) {
	  return val && typeof val.then === 'function'
	}
	
	function assert (condition, msg) {
	  if (!condition) { throw new Error(("[vuex] " + msg)) }
	}
	
	var Module = function Module (rawModule, runtime) {
	  this.runtime = runtime;
	  this._children = Object.create(null);
	  this._rawModule = rawModule;
	  var rawState = rawModule.state;
	  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
	};
	
	var prototypeAccessors$1 = { namespaced: { configurable: true } };
	
	prototypeAccessors$1.namespaced.get = function () {
	  return !!this._rawModule.namespaced
	};
	
	Module.prototype.addChild = function addChild (key, module) {
	  this._children[key] = module;
	};
	
	Module.prototype.removeChild = function removeChild (key) {
	  delete this._children[key];
	};
	
	Module.prototype.getChild = function getChild (key) {
	  return this._children[key]
	};
	
	Module.prototype.update = function update (rawModule) {
	  this._rawModule.namespaced = rawModule.namespaced;
	  if (rawModule.actions) {
	    this._rawModule.actions = rawModule.actions;
	  }
	  if (rawModule.mutations) {
	    this._rawModule.mutations = rawModule.mutations;
	  }
	  if (rawModule.getters) {
	    this._rawModule.getters = rawModule.getters;
	  }
	};
	
	Module.prototype.forEachChild = function forEachChild (fn) {
	  forEachValue(this._children, fn);
	};
	
	Module.prototype.forEachGetter = function forEachGetter (fn) {
	  if (this._rawModule.getters) {
	    forEachValue(this._rawModule.getters, fn);
	  }
	};
	
	Module.prototype.forEachAction = function forEachAction (fn) {
	  if (this._rawModule.actions) {
	    forEachValue(this._rawModule.actions, fn);
	  }
	};
	
	Module.prototype.forEachMutation = function forEachMutation (fn) {
	  if (this._rawModule.mutations) {
	    forEachValue(this._rawModule.mutations, fn);
	  }
	};
	
	Object.defineProperties( Module.prototype, prototypeAccessors$1 );
	
	var ModuleCollection = function ModuleCollection (rawRootModule) {
	  // register root module (Vuex.Store options)
	  this.register([], rawRootModule, false);
	};
	
	ModuleCollection.prototype.get = function get (path) {
	  return path.reduce(function (module, key) {
	    return module.getChild(key)
	  }, this.root)
	};
	
	ModuleCollection.prototype.getNamespace = function getNamespace (path) {
	  var module = this.root;
	  return path.reduce(function (namespace, key) {
	    module = module.getChild(key);
	    return namespace + (module.namespaced ? key + '/' : '')
	  }, '')
	};
	
	ModuleCollection.prototype.update = function update$1 (rawRootModule) {
	  update([], this.root, rawRootModule);
	};
	
	ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
	    var this$1 = this;
	    if ( runtime === void 0 ) runtime = true;
	
	  if (false) {
	    assertRawModule(path, rawModule);
	  }
	
	  var newModule = new Module(rawModule, runtime);
	  if (path.length === 0) {
	    this.root = newModule;
	  } else {
	    var parent = this.get(path.slice(0, -1));
	    parent.addChild(path[path.length - 1], newModule);
	  }
	
	  // register nested modules
	  if (rawModule.modules) {
	    forEachValue(rawModule.modules, function (rawChildModule, key) {
	      this$1.register(path.concat(key), rawChildModule, runtime);
	    });
	  }
	};
	
	ModuleCollection.prototype.unregister = function unregister (path) {
	  var parent = this.get(path.slice(0, -1));
	  var key = path[path.length - 1];
	  if (!parent.getChild(key).runtime) { return }
	
	  parent.removeChild(key);
	};
	
	function update (path, targetModule, newModule) {
	  if (false) {
	    assertRawModule(path, newModule);
	  }
	
	  // update target module
	  targetModule.update(newModule);
	
	  // update nested modules
	  if (newModule.modules) {
	    for (var key in newModule.modules) {
	      if (!targetModule.getChild(key)) {
	        if (false) {
	          console.warn(
	            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
	            'manual reload is needed'
	          );
	        }
	        return
	      }
	      update(
	        path.concat(key),
	        targetModule.getChild(key),
	        newModule.modules[key]
	      );
	    }
	  }
	}
	
	var functionAssert = {
	  assert: function (value) { return typeof value === 'function'; },
	  expected: 'function'
	};
	
	var objectAssert = {
	  assert: function (value) { return typeof value === 'function' ||
	    (typeof value === 'object' && typeof value.handler === 'function'); },
	  expected: 'function or object with "handler" function'
	};
	
	var assertTypes = {
	  getters: functionAssert,
	  mutations: functionAssert,
	  actions: objectAssert
	};
	
	function assertRawModule (path, rawModule) {
	  Object.keys(assertTypes).forEach(function (key) {
	    if (!rawModule[key]) { return }
	
	    var assertOptions = assertTypes[key];
	
	    forEachValue(rawModule[key], function (value, type) {
	      assert(
	        assertOptions.assert(value),
	        makeAssertionMessage(path, key, type, value, assertOptions.expected)
	      );
	    });
	  });
	}
	
	function makeAssertionMessage (path, key, type, value, expected) {
	  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
	  if (path.length > 0) {
	    buf += " in module \"" + (path.join('.')) + "\"";
	  }
	  buf += " is " + (JSON.stringify(value)) + ".";
	  return buf
	}
	
	var Vue; // bind on install
	
	var Store = function Store (options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = {};
	
	  // Auto install if it is not done yet and `window` has `Vue`.
	  // To allow users to avoid auto-installation in some cases,
	  // this code should be placed here. See #731
	  if (!Vue && typeof window !== 'undefined' && window.Vue) {
	    install(window.Vue);
	  }
	
	  if (false) {
	    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
	    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
	    assert(this instanceof Store, "Store must be called with the new operator.");
	  }
	
	  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
	  var strict = options.strict; if ( strict === void 0 ) strict = false;
	
	  var state = options.state; if ( state === void 0 ) state = {};
	  if (typeof state === 'function') {
	    state = state() || {};
	  }
	
	  // store internal state
	  this._committing = false;
	  this._actions = Object.create(null);
	  this._actionSubscribers = [];
	  this._mutations = Object.create(null);
	  this._wrappedGetters = Object.create(null);
	  this._modules = new ModuleCollection(options);
	  this._modulesNamespaceMap = Object.create(null);
	  this._subscribers = [];
	  this._watcherVM = new Vue();
	
	  // bind commit and dispatch to self
	  var store = this;
	  var ref = this;
	  var dispatch = ref.dispatch;
	  var commit = ref.commit;
	  this.dispatch = function boundDispatch (type, payload) {
	    return dispatch.call(store, type, payload)
	  };
	  this.commit = function boundCommit (type, payload, options) {
	    return commit.call(store, type, payload, options)
	  };
	
	  // strict mode
	  this.strict = strict;
	
	  // init root module.
	  // this also recursively registers all sub-modules
	  // and collects all module getters inside this._wrappedGetters
	  installModule(this, state, [], this._modules.root);
	
	  // initialize the store vm, which is responsible for the reactivity
	  // (also registers _wrappedGetters as computed properties)
	  resetStoreVM(this, state);
	
	  // apply plugins
	  plugins.forEach(function (plugin) { return plugin(this$1); });
	
	  if (Vue.config.devtools) {
	    devtoolPlugin(this);
	  }
	};
	
	var prototypeAccessors = { state: { configurable: true } };
	
	prototypeAccessors.state.get = function () {
	  return this._vm._data.$$state
	};
	
	prototypeAccessors.state.set = function (v) {
	  if (false) {
	    assert(false, "Use store.replaceState() to explicit replace store state.");
	  }
	};
	
	Store.prototype.commit = function commit (_type, _payload, _options) {
	    var this$1 = this;
	
	  // check object-style commit
	  var ref = unifyObjectStyle(_type, _payload, _options);
	    var type = ref.type;
	    var payload = ref.payload;
	    var options = ref.options;
	
	  var mutation = { type: type, payload: payload };
	  var entry = this._mutations[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown mutation type: " + type));
	    }
	    return
	  }
	  this._withCommit(function () {
	    entry.forEach(function commitIterator (handler) {
	      handler(payload);
	    });
	  });
	  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });
	
	  if (
	    false
	  ) {
	    console.warn(
	      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
	      'Use the filter functionality in the vue-devtools'
	    );
	  }
	};
	
	Store.prototype.dispatch = function dispatch (_type, _payload) {
	    var this$1 = this;
	
	  // check object-style dispatch
	  var ref = unifyObjectStyle(_type, _payload);
	    var type = ref.type;
	    var payload = ref.payload;
	
	  var action = { type: type, payload: payload };
	  var entry = this._actions[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown action type: " + type));
	    }
	    return
	  }
	
	  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });
	
	  return entry.length > 1
	    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
	    : entry[0](payload)
	};
	
	Store.prototype.subscribe = function subscribe (fn) {
	  return genericSubscribe(fn, this._subscribers)
	};
	
	Store.prototype.subscribeAction = function subscribeAction (fn) {
	  return genericSubscribe(fn, this._actionSubscribers)
	};
	
	Store.prototype.watch = function watch (getter, cb, options) {
	    var this$1 = this;
	
	  if (false) {
	    assert(typeof getter === 'function', "store.watch only accepts a function.");
	  }
	  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
	};
	
	Store.prototype.replaceState = function replaceState (state) {
	    var this$1 = this;
	
	  this._withCommit(function () {
	    this$1._vm._data.$$state = state;
	  });
	};
	
	Store.prototype.registerModule = function registerModule (path, rawModule, options) {
	    if ( options === void 0 ) options = {};
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	    assert(path.length > 0, 'cannot register the root module by using registerModule.');
	  }
	
	  this._modules.register(path, rawModule);
	  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
	  // reset store to update getters...
	  resetStoreVM(this, this.state);
	};
	
	Store.prototype.unregisterModule = function unregisterModule (path) {
	    var this$1 = this;
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	  }
	
	  this._modules.unregister(path);
	  this._withCommit(function () {
	    var parentState = getNestedState(this$1.state, path.slice(0, -1));
	    Vue.delete(parentState, path[path.length - 1]);
	  });
	  resetStore(this);
	};
	
	Store.prototype.hotUpdate = function hotUpdate (newOptions) {
	  this._modules.update(newOptions);
	  resetStore(this, true);
	};
	
	Store.prototype._withCommit = function _withCommit (fn) {
	  var committing = this._committing;
	  this._committing = true;
	  fn();
	  this._committing = committing;
	};
	
	Object.defineProperties( Store.prototype, prototypeAccessors );
	
	function genericSubscribe (fn, subs) {
	  if (subs.indexOf(fn) < 0) {
	    subs.push(fn);
	  }
	  return function () {
	    var i = subs.indexOf(fn);
	    if (i > -1) {
	      subs.splice(i, 1);
	    }
	  }
	}
	
	function resetStore (store, hot) {
	  store._actions = Object.create(null);
	  store._mutations = Object.create(null);
	  store._wrappedGetters = Object.create(null);
	  store._modulesNamespaceMap = Object.create(null);
	  var state = store.state;
	  // init all modules
	  installModule(store, state, [], store._modules.root, true);
	  // reset vm
	  resetStoreVM(store, state, hot);
	}
	
	function resetStoreVM (store, state, hot) {
	  var oldVm = store._vm;
	
	  // bind store public getters
	  store.getters = {};
	  var wrappedGetters = store._wrappedGetters;
	  var computed = {};
	  forEachValue(wrappedGetters, function (fn, key) {
	    // use computed to leverage its lazy-caching mechanism
	    computed[key] = function () { return fn(store); };
	    Object.defineProperty(store.getters, key, {
	      get: function () { return store._vm[key]; },
	      enumerable: true // for local getters
	    });
	  });
	
	  // use a Vue instance to store the state tree
	  // suppress warnings just in case the user has added
	  // some funky global mixins
	  var silent = Vue.config.silent;
	  Vue.config.silent = true;
	  store._vm = new Vue({
	    data: {
	      $$state: state
	    },
	    computed: computed
	  });
	  Vue.config.silent = silent;
	
	  // enable strict mode for new vm
	  if (store.strict) {
	    enableStrictMode(store);
	  }
	
	  if (oldVm) {
	    if (hot) {
	      // dispatch changes in all subscribed watchers
	      // to force getter re-evaluation for hot reloading.
	      store._withCommit(function () {
	        oldVm._data.$$state = null;
	      });
	    }
	    Vue.nextTick(function () { return oldVm.$destroy(); });
	  }
	}
	
	function installModule (store, rootState, path, module, hot) {
	  var isRoot = !path.length;
	  var namespace = store._modules.getNamespace(path);
	
	  // register in namespace map
	  if (module.namespaced) {
	    store._modulesNamespaceMap[namespace] = module;
	  }
	
	  // set state
	  if (!isRoot && !hot) {
	    var parentState = getNestedState(rootState, path.slice(0, -1));
	    var moduleName = path[path.length - 1];
	    store._withCommit(function () {
	      Vue.set(parentState, moduleName, module.state);
	    });
	  }
	
	  var local = module.context = makeLocalContext(store, namespace, path);
	
	  module.forEachMutation(function (mutation, key) {
	    var namespacedType = namespace + key;
	    registerMutation(store, namespacedType, mutation, local);
	  });
	
	  module.forEachAction(function (action, key) {
	    var type = action.root ? key : namespace + key;
	    var handler = action.handler || action;
	    registerAction(store, type, handler, local);
	  });
	
	  module.forEachGetter(function (getter, key) {
	    var namespacedType = namespace + key;
	    registerGetter(store, namespacedType, getter, local);
	  });
	
	  module.forEachChild(function (child, key) {
	    installModule(store, rootState, path.concat(key), child, hot);
	  });
	}
	
	/**
	 * make localized dispatch, commit, getters and state
	 * if there is no namespace, just use root ones
	 */
	function makeLocalContext (store, namespace, path) {
	  var noNamespace = namespace === '';
	
	  var local = {
	    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      return store.dispatch(type, payload)
	    },
	
	    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      store.commit(type, payload, options);
	    }
	  };
	
	  // getters and state object must be gotten lazily
	  // because they will be changed by vm update
	  Object.defineProperties(local, {
	    getters: {
	      get: noNamespace
	        ? function () { return store.getters; }
	        : function () { return makeLocalGetters(store, namespace); }
	    },
	    state: {
	      get: function () { return getNestedState(store.state, path); }
	    }
	  });
	
	  return local
	}
	
	function makeLocalGetters (store, namespace) {
	  var gettersProxy = {};
	
	  var splitPos = namespace.length;
	  Object.keys(store.getters).forEach(function (type) {
	    // skip if the target getter is not match this namespace
	    if (type.slice(0, splitPos) !== namespace) { return }
	
	    // extract local getter type
	    var localType = type.slice(splitPos);
	
	    // Add a port to the getters proxy.
	    // Define as getter property because
	    // we do not want to evaluate the getters in this time.
	    Object.defineProperty(gettersProxy, localType, {
	      get: function () { return store.getters[type]; },
	      enumerable: true
	    });
	  });
	
	  return gettersProxy
	}
	
	function registerMutation (store, type, handler, local) {
	  var entry = store._mutations[type] || (store._mutations[type] = []);
	  entry.push(function wrappedMutationHandler (payload) {
	    handler.call(store, local.state, payload);
	  });
	}
	
	function registerAction (store, type, handler, local) {
	  var entry = store._actions[type] || (store._actions[type] = []);
	  entry.push(function wrappedActionHandler (payload, cb) {
	    var res = handler.call(store, {
	      dispatch: local.dispatch,
	      commit: local.commit,
	      getters: local.getters,
	      state: local.state,
	      rootGetters: store.getters,
	      rootState: store.state
	    }, payload, cb);
	    if (!isPromise(res)) {
	      res = Promise.resolve(res);
	    }
	    if (store._devtoolHook) {
	      return res.catch(function (err) {
	        store._devtoolHook.emit('vuex:error', err);
	        throw err
	      })
	    } else {
	      return res
	    }
	  });
	}
	
	function registerGetter (store, type, rawGetter, local) {
	  if (store._wrappedGetters[type]) {
	    if (false) {
	      console.error(("[vuex] duplicate getter key: " + type));
	    }
	    return
	  }
	  store._wrappedGetters[type] = function wrappedGetter (store) {
	    return rawGetter(
	      local.state, // local state
	      local.getters, // local getters
	      store.state, // root state
	      store.getters // root getters
	    )
	  };
	}
	
	function enableStrictMode (store) {
	  store._vm.$watch(function () { return this._data.$$state }, function () {
	    if (false) {
	      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
	    }
	  }, { deep: true, sync: true });
	}
	
	function getNestedState (state, path) {
	  return path.length
	    ? path.reduce(function (state, key) { return state[key]; }, state)
	    : state
	}
	
	function unifyObjectStyle (type, payload, options) {
	  if (isObject(type) && type.type) {
	    options = payload;
	    payload = type;
	    type = type.type;
	  }
	
	  if (false) {
	    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
	  }
	
	  return { type: type, payload: payload, options: options }
	}
	
	function install (_Vue) {
	  if (Vue && _Vue === Vue) {
	    if (false) {
	      console.error(
	        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
	      );
	    }
	    return
	  }
	  Vue = _Vue;
	  applyMixin(Vue);
	}
	
	var mapState = normalizeNamespace(function (namespace, states) {
	  var res = {};
	  normalizeMap(states).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedState () {
	      var state = this.$store.state;
	      var getters = this.$store.getters;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
	        if (!module) {
	          return
	        }
	        state = module.context.state;
	        getters = module.context.getters;
	      }
	      return typeof val === 'function'
	        ? val.call(this, state, getters)
	        : state[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapMutations = normalizeNamespace(function (namespace, mutations) {
	  var res = {};
	  normalizeMap(mutations).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedMutation () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var commit = this.$store.commit;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
	        if (!module) {
	          return
	        }
	        commit = module.context.commit;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [commit].concat(args))
	        : commit.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var mapGetters = normalizeNamespace(function (namespace, getters) {
	  var res = {};
	  normalizeMap(getters).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val;
	    res[key] = function mappedGetter () {
	      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
	        return
	      }
	      if (false) {
	        console.error(("[vuex] unknown getter: " + val));
	        return
	      }
	      return this.$store.getters[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapActions = normalizeNamespace(function (namespace, actions) {
	  var res = {};
	  normalizeMap(actions).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedAction () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var dispatch = this.$store.dispatch;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
	        if (!module) {
	          return
	        }
	        dispatch = module.context.dispatch;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [dispatch].concat(args))
	        : dispatch.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var createNamespacedHelpers = function (namespace) { return ({
	  mapState: mapState.bind(null, namespace),
	  mapGetters: mapGetters.bind(null, namespace),
	  mapMutations: mapMutations.bind(null, namespace),
	  mapActions: mapActions.bind(null, namespace)
	}); };
	
	function normalizeMap (map) {
	  return Array.isArray(map)
	    ? map.map(function (key) { return ({ key: key, val: key }); })
	    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
	}
	
	function normalizeNamespace (fn) {
	  return function (namespace, map) {
	    if (typeof namespace !== 'string') {
	      map = namespace;
	      namespace = '';
	    } else if (namespace.charAt(namespace.length - 1) !== '/') {
	      namespace += '/';
	    }
	    return fn(namespace, map)
	  }
	}
	
	function getModuleByNamespace (store, helper, namespace) {
	  var module = store._modulesNamespaceMap[namespace];
	  if (false) {
	    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
	  }
	  return module
	}
	
	var index = {
	  Store: Store,
	  install: install,
	  version: '2.5.0',
	  mapState: mapState,
	  mapMutations: mapMutations,
	  mapGetters: mapGetters,
	  mapActions: mapActions,
	  createNamespacedHelpers: createNamespacedHelpers
	};
	
	module.exports = index;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ }),
/* 420 */
/***/ (function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ }),
/* 421 */
/***/ (function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(103);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _util = __webpack_require__(16);
	
	var _validator = __webpack_require__(434);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _messages2 = __webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Encapsulates a validation schema.
	 *
	 *  @param descriptor An object declaring validation rules
	 *  for this schema.
	 */
	function Schema(descriptor) {
	  this.rules = null;
	  this._messages = _messages2.messages;
	  this.define(descriptor);
	}
	
	Schema.prototype = {
	  messages: function messages(_messages) {
	    if (_messages) {
	      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
	    }
	    return this._messages;
	  },
	  define: function define(rules) {
	    if (!rules) {
	      throw new Error('Cannot configure a schema with no rules');
	    }
	    if ((typeof rules === 'undefined' ? 'undefined' : (0, _typeof3['default'])(rules)) !== 'object' || Array.isArray(rules)) {
	      throw new Error('Rules must be an object');
	    }
	    this.rules = {};
	    var z = void 0;
	    var item = void 0;
	    for (z in rules) {
	      if (rules.hasOwnProperty(z)) {
	        item = rules[z];
	        this.rules[z] = Array.isArray(item) ? item : [item];
	      }
	    }
	  },
	  validate: function validate(source_) {
	    var _this = this;
	
	    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var oc = arguments[2];
	
	    var source = source_;
	    var options = o;
	    var callback = oc;
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!this.rules || Object.keys(this.rules).length === 0) {
	      if (callback) {
	        callback();
	      }
	      return;
	    }
	    function complete(results) {
	      var i = void 0;
	      var field = void 0;
	      var errors = [];
	      var fields = {};
	
	      function add(e) {
	        if (Array.isArray(e)) {
	          errors = errors.concat.apply(errors, e);
	        } else {
	          errors.push(e);
	        }
	      }
	
	      for (i = 0; i < results.length; i++) {
	        add(results[i]);
	      }
	      if (!errors.length) {
	        errors = null;
	        fields = null;
	      } else {
	        for (i = 0; i < errors.length; i++) {
	          field = errors[i].field;
	          fields[field] = fields[field] || [];
	          fields[field].push(errors[i]);
	        }
	      }
	      callback(errors, fields);
	    }
	
	    if (options.messages) {
	      var messages = this.messages();
	      if (messages === _messages2.messages) {
	        messages = (0, _messages2.newMessages)();
	      }
	      (0, _util.deepMerge)(messages, options.messages);
	      options.messages = messages;
	    } else {
	      options.messages = this.messages();
	    }
	    var arr = void 0;
	    var value = void 0;
	    var series = {};
	    var keys = options.keys || Object.keys(this.rules);
	    keys.forEach(function (z) {
	      arr = _this.rules[z];
	      value = source[z];
	      arr.forEach(function (r) {
	        var rule = r;
	        if (typeof rule.transform === 'function') {
	          if (source === source_) {
	            source = (0, _extends3['default'])({}, source);
	          }
	          value = source[z] = rule.transform(value);
	        }
	        if (typeof rule === 'function') {
	          rule = {
	            validator: rule
	          };
	        } else {
	          rule = (0, _extends3['default'])({}, rule);
	        }
	        rule.validator = _this.getValidationMethod(rule);
	        rule.field = z;
	        rule.fullField = rule.fullField || z;
	        rule.type = _this.getType(rule);
	        if (!rule.validator) {
	          return;
	        }
	        series[z] = series[z] || [];
	        series[z].push({
	          rule: rule,
	          value: value,
	          source: source,
	          field: z
	        });
	      });
	    });
	    var errorFields = {};
	    (0, _util.asyncMap)(series, options, function (data, doIt) {
	      var rule = data.rule;
	      var deep = (rule.type === 'object' || rule.type === 'array') && ((0, _typeof3['default'])(rule.fields) === 'object' || (0, _typeof3['default'])(rule.defaultField) === 'object');
	      deep = deep && (rule.required || !rule.required && data.value);
	      rule.field = data.field;
	      function addFullfield(key, schema) {
	        return (0, _extends3['default'])({}, schema, {
	          fullField: rule.fullField + '.' + key
	        });
	      }
	
	      function cb() {
	        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        var errors = e;
	        if (!Array.isArray(errors)) {
	          errors = [errors];
	        }
	        if (errors.length) {
	          (0, _util.warning)('async-validator:', errors);
	        }
	        if (errors.length && rule.message) {
	          errors = [].concat(rule.message);
	        }
	
	        errors = errors.map((0, _util.complementError)(rule));
	
	        if (options.first && errors.length) {
	          errorFields[rule.field] = 1;
	          return doIt(errors);
	        }
	        if (!deep) {
	          doIt(errors);
	        } else {
	          // if rule is required but the target object
	          // does not exist fail at the rule level and don't
	          // go deeper
	          if (rule.required && !data.value) {
	            if (rule.message) {
	              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
	            } else if (options.error) {
	              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
	            } else {
	              errors = [];
	            }
	            return doIt(errors);
	          }
	
	          var fieldsSchema = {};
	          if (rule.defaultField) {
	            for (var k in data.value) {
	              if (data.value.hasOwnProperty(k)) {
	                fieldsSchema[k] = rule.defaultField;
	              }
	            }
	          }
	          fieldsSchema = (0, _extends3['default'])({}, fieldsSchema, data.rule.fields);
	          for (var f in fieldsSchema) {
	            if (fieldsSchema.hasOwnProperty(f)) {
	              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
	              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
	            }
	          }
	          var schema = new Schema(fieldsSchema);
	          schema.messages(options.messages);
	          if (data.rule.options) {
	            data.rule.options.messages = options.messages;
	            data.rule.options.error = options.error;
	          }
	          schema.validate(data.value, data.rule.options || options, function (errs) {
	            doIt(errs && errs.length ? errors.concat(errs) : errs);
	          });
	        }
	      }
	
	      var res = rule.validator(rule, data.value, cb, data.source, options);
	      if (res && res.then) {
	        res.then(function () {
	          return cb();
	        }, function (e) {
	          return cb(e);
	        });
	      }
	    }, function (results) {
	      complete(results);
	    });
	  },
	  getType: function getType(rule) {
	    if (rule.type === undefined && rule.pattern instanceof RegExp) {
	      rule.type = 'pattern';
	    }
	    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
	      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
	    }
	    return rule.type || 'string';
	  },
	  getValidationMethod: function getValidationMethod(rule) {
	    if (typeof rule.validator === 'function') {
	      return rule.validator;
	    }
	    var keys = Object.keys(rule);
	    var messageIndex = keys.indexOf('message');
	    if (messageIndex !== -1) {
	      keys.splice(messageIndex, 1);
	    }
	    if (keys.length === 1 && keys[0] === 'required') {
	      return _validator2['default'].required;
	    }
	    return _validator2['default'][this.getType(rule)] || false;
	  }
	};
	
	Schema.register = function register(type, validator) {
	  if (typeof validator !== 'function') {
	    throw new Error('Cannot register a validator by type, validator is not a function');
	  }
	  _validator2['default'][type] = validator;
	};
	
	Schema.messages = _messages2.messages;
	
	exports['default'] = Schema;
	module.exports = exports['default'];

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newMessages = newMessages;
	function newMessages() {
	  return {
	    'default': 'Validation error on field %s',
	    required: '%s is required',
	    'enum': '%s must be one of %s',
	    whitespace: '%s cannot be empty',
	    date: {
	      format: '%s date %s is invalid for format %s',
	      parse: '%s date could not be parsed, %s is invalid ',
	      invalid: '%s date %s is invalid'
	    },
	    types: {
	      string: '%s is not a %s',
	      method: '%s is not a %s (function)',
	      array: '%s is not an %s',
	      object: '%s is not an %s',
	      number: '%s is not a %s',
	      date: '%s is not a %s',
	      boolean: '%s is not a %s',
	      integer: '%s is not an %s',
	      float: '%s is not a %s',
	      regexp: '%s is not a valid %s',
	      email: '%s is not a valid %s',
	      url: '%s is not a valid %s',
	      hex: '%s is not a valid %s'
	    },
	    string: {
	      len: '%s must be exactly %s characters',
	      min: '%s must be at least %s characters',
	      max: '%s cannot be longer than %s characters',
	      range: '%s must be between %s and %s characters'
	    },
	    number: {
	      len: '%s must equal %s',
	      min: '%s cannot be less than %s',
	      max: '%s cannot be greater than %s',
	      range: '%s must be between %s and %s'
	    },
	    array: {
	      len: '%s must be exactly %s in length',
	      min: '%s cannot be less than %s in length',
	      max: '%s cannot be greater than %s in length',
	      range: '%s must be between %s and %s in length'
	    },
	    pattern: {
	      mismatch: '%s value %s does not match pattern %s'
	    },
	    clone: function clone() {
	      var cloned = JSON.parse(JSON.stringify(this));
	      cloned.clone = this.clone;
	      return cloned;
	    }
	  };
	}
	
	var messages = exports.messages = newMessages();

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(16);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var ENUM = 'enum';
	
	/**
	 *  Rule for validating a value exists in an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, source, errors, options) {
	  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
	  if (rule[ENUM].indexOf(value) === -1) {
	    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
	  }
	}
	
	exports['default'] = enumerable;
	module.exports = exports['default'];

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(16);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating a regular expression pattern.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, source, errors, options) {
	  if (rule.pattern) {
	    if (rule.pattern instanceof RegExp) {
	      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
	      // flag is accidentally set to `true`, which in a validation scenario
	      // is not necessary and the result might be misleading
	      rule.pattern.lastIndex = 0;
	      if (!rule.pattern.test(value)) {
	        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	      }
	    } else if (typeof rule.pattern === 'string') {
	      var _pattern = new RegExp(rule.pattern);
	      if (!_pattern.test(value)) {
	        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	      }
	    }
	  }
	}
	
	exports['default'] = pattern;
	module.exports = exports['default'];

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(16);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating minimum and maximum allowed values.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function range(rule, value, source, errors, options) {
	  var len = typeof rule.len === 'number';
	  var min = typeof rule.min === 'number';
	  var max = typeof rule.max === 'number';
	  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
	  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	  var val = value;
	  var key = null;
	  var num = typeof value === 'number';
	  var str = typeof value === 'string';
	  var arr = Array.isArray(value);
	  if (num) {
	    key = 'number';
	  } else if (str) {
	    key = 'string';
	  } else if (arr) {
	    key = 'array';
	  }
	  // if the value is not of a supported type for range validation
	  // the validation rule rule should use the
	  // type property to also test for a particular type
	  if (!key) {
	    return false;
	  }
	  if (arr) {
	    val = value.length;
	  }
	  if (str) {
	    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
	    val = value.replace(spRegexp, '_').length;
	  }
	  if (len) {
	    if (val !== rule.len) {
	      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
	    }
	  } else if (min && !max && val < rule.min) {
	    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
	  } else if (max && !min && val > rule.max) {
	    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
	  } else if (min && max && (val < rule.min || val > rule.max)) {
	    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
	  }
	}
	
	exports['default'] = range;
	module.exports = exports['default'];

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(103);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _util = __webpack_require__(16);
	
	var util = _interopRequireWildcard(_util);
	
	var _required = __webpack_require__(193);
	
	var _required2 = _interopRequireDefault(_required);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint max-len:0 */
	
	var pattern = {
	  // http://emailregex.com/
	  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
	  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
	};
	
	var types = {
	  integer: function integer(value) {
	    return types.number(value) && parseInt(value, 10) === value;
	  },
	  float: function float(value) {
	    return types.number(value) && !types.integer(value);
	  },
	  array: function array(value) {
	    return Array.isArray(value);
	  },
	  regexp: function regexp(value) {
	    if (value instanceof RegExp) {
	      return true;
	    }
	    try {
	      return !!new RegExp(value);
	    } catch (e) {
	      return false;
	    }
	  },
	  date: function date(value) {
	    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
	  },
	  number: function number(value) {
	    if (isNaN(value)) {
	      return false;
	    }
	    return typeof value === 'number';
	  },
	  object: function object(value) {
	    return (typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) === 'object' && !types.array(value);
	  },
	  method: function method(value) {
	    return typeof value === 'function';
	  },
	  email: function email(value) {
	    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
	  },
	  url: function url(value) {
	    return typeof value === 'string' && !!value.match(pattern.url);
	  },
	  hex: function hex(value) {
	    return typeof value === 'string' && !!value.match(pattern.hex);
	  }
	};
	
	/**
	 *  Rule for validating the type of a value.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function type(rule, value, source, errors, options) {
	  if (rule.required && value === undefined) {
	    (0, _required2['default'])(rule, value, source, errors, options);
	    return;
	  }
	  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
	  var ruleType = rule.type;
	  if (custom.indexOf(ruleType) > -1) {
	    if (!types[ruleType](value)) {
	      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	    }
	    // straight typeof check
	  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) !== rule.type) {
	    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	  }
	}
	
	exports['default'] = type;
	module.exports = exports['default'];

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(16);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating whitespace.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function whitespace(rule, value, source, errors, options) {
	  if (/^\s+$/.test(value) || value === '') {
	    errors.push(util.format(options.messages.whitespace, rule.fullField));
	  }
	}
	
	exports['default'] = whitespace;
	module.exports = exports['default'];

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates an array.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function array(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, 'array');
	    if (!(0, _util.isEmptyValue)(value, 'array')) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = array;
	module.exports = exports['default'];

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(16);
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a boolean.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function boolean(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = boolean;
	module.exports = exports['default'];

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function date(rule, value, callback, source, options) {
	  // console.log('integer rule called %j', rule);
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  // console.log('validate on %s value', value);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      var dateObject = void 0;
	
	      if (typeof value === 'number') {
	        dateObject = new Date(value);
	      } else {
	        dateObject = value;
	      }
	
	      _rule2['default'].type(rule, dateObject, source, errors, options);
	      if (dateObject) {
	        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = date;
	module.exports = exports['default'];

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ENUM = 'enum';
	
	/**
	 *  Validates an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value) {
	      _rule2['default'][ENUM](rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = enumerable;
	module.exports = exports['default'];

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number is a floating point number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function floatFn(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = floatFn;
	module.exports = exports['default'];

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _string = __webpack_require__(442);
	
	var _string2 = _interopRequireDefault(_string);
	
	var _method = __webpack_require__(436);
	
	var _method2 = _interopRequireDefault(_method);
	
	var _number = __webpack_require__(437);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _boolean = __webpack_require__(430);
	
	var _boolean2 = _interopRequireDefault(_boolean);
	
	var _regexp = __webpack_require__(440);
	
	var _regexp2 = _interopRequireDefault(_regexp);
	
	var _integer = __webpack_require__(435);
	
	var _integer2 = _interopRequireDefault(_integer);
	
	var _float = __webpack_require__(433);
	
	var _float2 = _interopRequireDefault(_float);
	
	var _array = __webpack_require__(429);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _object = __webpack_require__(438);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _enum = __webpack_require__(432);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	var _pattern = __webpack_require__(439);
	
	var _pattern2 = _interopRequireDefault(_pattern);
	
	var _date = __webpack_require__(431);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _required = __webpack_require__(441);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _type = __webpack_require__(443);
	
	var _type2 = _interopRequireDefault(_type);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  string: _string2['default'],
	  method: _method2['default'],
	  number: _number2['default'],
	  boolean: _boolean2['default'],
	  regexp: _regexp2['default'],
	  integer: _integer2['default'],
	  float: _float2['default'],
	  array: _array2['default'],
	  object: _object2['default'],
	  'enum': _enum2['default'],
	  pattern: _pattern2['default'],
	  date: _date2['default'],
	  url: _type2['default'],
	  hex: _type2['default'],
	  email: _type2['default'],
	  required: _required2['default']
	};
	module.exports = exports['default'];

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number is an integer.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function integer(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = integer;
	module.exports = exports['default'];

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a function.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function method(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = method;
	module.exports = exports['default'];

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function number(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = number;
	module.exports = exports['default'];

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates an object.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function object(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = object;
	module.exports = exports['default'];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a regular expression pattern.
	 *
	 *  Performs validation when a rule only contains
	 *  a pattern property but is not declared as a string type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2['default'].pattern(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = pattern;
	module.exports = exports['default'];

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates the regular expression type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function regexp(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = regexp;
	module.exports = exports['default'];

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(103);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function required(rule, value, callback, source, options) {
	  var errors = [];
	  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value);
	  _rule2['default'].required(rule, value, source, errors, options, type);
	  callback(errors);
	}
	
	exports['default'] = required;
	module.exports = exports['default'];

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Performs validation for string types.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function string(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, 'string');
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	      _rule2['default'].pattern(rule, value, source, errors, options);
	      if (rule.whitespace === true) {
	        _rule2['default'].whitespace(rule, value, source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = string;
	module.exports = exports['default'];

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(24);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function type(rule, value, callback, source, options) {
	  var ruleType = rule.type;
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, ruleType);
	    if (!(0, _util.isEmptyValue)(value, ruleType)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = type;
	module.exports = exports['default'];

/***/ }),
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(807);
	
	__webpack_require__(537);
	
	__webpack_require__(551);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(553), __esModule: true };

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(554), __esModule: true };

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(560), __esModule: true };

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(562), __esModule: true };

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(563), __esModule: true };

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(564), __esModule: true };

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(200);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ }),
/* 547 */
/***/ (function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(){
	  "use strict";
	
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	
	  // Use a lookup table to find the index.
	  var lookup = new Uint8Array(256);
	  for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	  }
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = lookup[base64.charCodeAt(i)];
	      encoded2 = lookup[base64.charCodeAt(i+1)];
	      encoded3 = lookup[base64.charCodeAt(i+2)];
	      encoded4 = lookup[base64.charCodeAt(i+3)];
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})();


/***/ }),
/* 548 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = global.BlobBuilder
	  || global.WebKitBlobBuilder
	  || global.MSBlobBuilder
	  || global.MozBlobBuilder;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  for (var i = 0; i < ary.length; i++) {
	    var chunk = ary[i];
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      ary[i] = buf;
	    }
	  }
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary);
	
	  for (var i = 0; i < ary.length; i++) {
	    bb.append(ary[i]);
	  }
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  mapArrayBufferViews(ary);
	  return new Blob(ary, options || {});
	};
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chart.js v2.9.3
	 * https://www.chartjs.org
	 * (c) 2019 Chart.js Contributors
	 * Released under the MIT License
	 */
	(function (global, factory) {
	 true ? module.exports = factory(function() { try { return __webpack_require__(1); } catch(e) { } }()) :
	typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
	(global = global || self, global.Chart = factory(global.moment));
	}(this, (function (moment) { 'use strict';
	
	moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	function getCjsExportFromNamespace (n) {
		return n && n['default'] || n;
	}
	
	var colorName = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	var conversions = createCommonjsModule(function (module) {
	/* MIT license */
	
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in colorName) {
		if (colorName.hasOwnProperty(key)) {
			reverseKeywords[colorName[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;
	
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};
	
		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);
	
			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}
	
		return [
			h * 360,
			s * 100,
			v * 100
		];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in colorName) {
			if (colorName.hasOwnProperty(keyword)) {
				var value = colorName[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return colorName[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};
	});
	var conversions_1 = conversions.rgb;
	var conversions_2 = conversions.hsl;
	var conversions_3 = conversions.hsv;
	var conversions_4 = conversions.hwb;
	var conversions_5 = conversions.cmyk;
	var conversions_6 = conversions.xyz;
	var conversions_7 = conversions.lab;
	var conversions_8 = conversions.lch;
	var conversions_9 = conversions.hex;
	var conversions_10 = conversions.keyword;
	var conversions_11 = conversions.ansi16;
	var conversions_12 = conversions.ansi256;
	var conversions_13 = conversions.hcg;
	var conversions_14 = conversions.apple;
	var conversions_15 = conversions.gray;
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	var route = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	var colorConvert = convert;
	
	var colorName$1 = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	/* MIT license */
	
	
	var colorString = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	};
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorName$1[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorName$1) {
	   reverseNames[colorName$1[name]] = name;
	}
	
	/* MIT license */
	
	
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = colorString.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = colorString.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = colorString.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return colorString.hexString(this.values.rgb);
		},
		rgbString: function () {
			return colorString.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return colorString.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return colorString.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return colorString.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return colorString.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return colorString.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return colorString.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = colorConvert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	var chartjsColor = Color;
	
	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},
	
		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),
	
		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},
	
		/**
		 * Returns true if `value` is an array (including typed arrays), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @function
		 */
		isArray: function(value) {
			if (Array.isArray && Array.isArray(value)) {
				return true;
			}
			var type = Object.prototype.toString.call(value);
			if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
				return true;
			}
			return false;
		},
	
		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},
	
		/**
		 * Returns true if `value` is a finite number, else returns false
		 * @param {*} value  - The value to test.
		 * @returns {boolean}
		 */
		isFinite: function(value) {
			return (typeof value === 'number' || value instanceof Number) && isFinite(value);
		},
	
		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},
	
		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},
	
		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},
	
		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {object|Array} loopable - The object or array to be iterated.
		 * @param {function} fn - The function to call for each item.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},
	
		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see https://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		},
	
		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}
	
			if (helpers.isObject(source)) {
				var target = {};
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;
	
				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}
	
				return target;
			}
	
			return source;
		},
	
		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @param {object} [options] - Merging options:
		 * @param {function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;
	
			if (!helpers.isObject(target)) {
				return target;
			}
	
			options = options || {};
			merge = options.merger || helpers._merger;
	
			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}
	
				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}
	
			return target;
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @returns {object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},
	
		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {object} target - The target object in which all objects are merged into.
		 * @param {object} arg1 - Object containing additional properties to merge in target.
		 * @param {object} argN - Additional objects containing properties to merge in target.
		 * @returns {object} The `target` object.
		 */
		extend: Object.assign || function(target) {
			return helpers.merge(target, [].slice.call(arguments, 1), {
				merger: function(key, dst, src) {
					dst[key] = src[key];
				}
			});
		},
	
		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
	
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
			return ChartElement;
		},
	
		_deprecated: function(scope, value, previous, current) {
			if (value !== undefined) {
				console.warn(scope + ': "' + previous +
					'" is deprecated. Please use "' + current + '" instead');
			}
		}
	};
	
	var helpers_core = helpers;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;
	
	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
	
	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},
	
		easeInQuad: function(t) {
			return t * t;
		},
	
		easeOutQuad: function(t) {
			return -t * (t - 2);
		},
	
		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},
	
		easeInCubic: function(t) {
			return t * t * t;
		},
	
		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},
	
		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},
	
		easeInQuart: function(t) {
			return t * t * t * t;
		},
	
		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},
	
		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},
	
		easeInQuint: function(t) {
			return t * t * t * t * t;
		},
	
		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},
	
		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},
	
		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},
	
		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},
	
		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},
	
		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},
	
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},
	
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},
	
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},
	
		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},
	
		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
	
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},
	
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},
	
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},
	
		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},
	
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
	
		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},
	
		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},
	
		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};
	
	var helpers_easing = {
		effects: effects
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.easingEffects = effects;
	
	var PI = Math.PI;
	var RAD_PER_DEG = PI / 180;
	var DOUBLE_PI = PI * 2;
	var HALF_PI = PI / 2;
	var QUARTER_PI = PI / 4;
	var TWO_THIRDS_PI = PI * 2 / 3;
	
	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports$1 = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},
	
		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {number} width - The rectangle's width.
		 * @param {number} height - The rectangle's height.
		 * @param {number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var r = Math.min(radius, height / 2, width / 2);
				var left = x + r;
				var top = y + r;
				var right = x + width - r;
				var bottom = y + height - r;
	
				ctx.moveTo(x, top);
				if (left < right && top < bottom) {
					ctx.arc(left, top, r, -PI, -HALF_PI);
					ctx.arc(right, top, r, -HALF_PI, 0);
					ctx.arc(right, bottom, r, 0, HALF_PI);
					ctx.arc(left, bottom, r, HALF_PI, PI);
				} else if (left < right) {
					ctx.moveTo(left, y);
					ctx.arc(right, top, r, -HALF_PI, HALF_PI);
					ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
				} else if (top < bottom) {
					ctx.arc(left, top, r, -PI, 0);
					ctx.arc(left, bottom, r, 0, PI);
				} else {
					ctx.arc(left, top, r, -PI, PI);
				}
				ctx.closePath();
				ctx.moveTo(x, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},
	
		drawPoint: function(ctx, style, radius, x, y, rotation) {
			var type, xOffset, yOffset, size, cornerRadius;
			var rad = (rotation || 0) * RAD_PER_DEG;
	
			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.save();
					ctx.translate(x, y);
					ctx.rotate(rad);
					ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
					ctx.restore();
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			ctx.beginPath();
	
			switch (style) {
			// Default includes circle
			default:
				ctx.arc(x, y, radius, 0, DOUBLE_PI);
				ctx.closePath();
				break;
			case 'triangle':
				ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				ctx.closePath();
				break;
			case 'rectRounded':
				// NOTE: the rounded rect implementation changed to use `arc` instead of
				// `quadraticCurveTo` since it generates better results when rect is
				// almost a circle. 0.516 (instead of 0.5) produces results with visually
				// closer proportion to the previous impl and it is inscribed in the
				// circle with `radius`. For more details, see the following PRs:
				// https://github.com/chartjs/Chart.js/issues/5597
				// https://github.com/chartjs/Chart.js/issues/5858
				cornerRadius = radius * 0.516;
				size = radius - cornerRadius;
				xOffset = Math.cos(rad + QUARTER_PI) * size;
				yOffset = Math.sin(rad + QUARTER_PI) * size;
				ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
				ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
				ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
				ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
				ctx.closePath();
				break;
			case 'rect':
				if (!rotation) {
					size = Math.SQRT1_2 * radius;
					ctx.rect(x - size, y - size, 2 * size, 2 * size);
					break;
				}
				rad += QUARTER_PI;
				/* falls through */
			case 'rectRot':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + yOffset, y - xOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				ctx.closePath();
				break;
			case 'crossRot':
				rad += QUARTER_PI;
				/* falls through */
			case 'cross':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'star':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				rad += QUARTER_PI;
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'line':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				break;
			case 'dash':
				ctx.moveTo(x, y);
				ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
				break;
			}
	
			ctx.fill();
			ctx.stroke();
		},
	
		/**
		 * Returns true if the point is inside the rectangle
		 * @param {object} point - The point to test
		 * @param {object} area - The rectangle
		 * @returns {boolean}
		 * @private
		 */
		_isPointInArea: function(point, area) {
			var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	
			return point.x > area.left - epsilon && point.x < area.right + epsilon &&
				point.y > area.top - epsilon && point.y < area.bottom + epsilon;
		},
	
		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},
	
		unclipArea: function(ctx) {
			ctx.restore();
		},
	
		lineTo: function(ctx, previous, target, flip) {
			var stepped = target.steppedLine;
			if (stepped) {
				if (stepped === 'middle') {
					var midpoint = (previous.x + target.x) / 2.0;
					ctx.lineTo(midpoint, flip ? target.y : previous.y);
					ctx.lineTo(midpoint, flip ? previous.y : target.y);
				} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};
	
	var helpers_canvas = exports$1;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.clear = exports$1.clear;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports$1.roundedRect.apply(exports$1, arguments);
	};
	
	var defaults = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers_core.merge(this[scope] || (this[scope] = {}), values);
		}
	};
	
	// TODO(v3): remove 'global' from namespace.  all default are global and
	// there's inconsistency around which options are under 'global'
	defaults._set('global', {
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		defaultLineHeight: 1.2,
		showLines: true
	});
	
	var core_defaults = defaults;
	
	var valueOrDefault = helpers_core.valueOrDefault;
	
	/**
	 * Converts the given font object into a CSS font string.
	 * @param {object} font - A font object.
	 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
	 * @private
	 */
	function toFontString(font) {
		if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
			return null;
		}
	
		return (font.style ? font.style + ' ' : '')
			+ (font.weight ? font.weight + ' ' : '')
			+ font.size + 'px '
			+ font.family;
	}
	
	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	var helpers_options = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}
	
			value = +matches[2];
	
			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			}
	
			return size * value;
		},
	
		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {number|object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;
	
			if (helpers_core.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}
	
			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},
	
		/**
		 * Parses font options and returns the font object.
		 * @param {object} options - A object that contains font options to be parsed.
		 * @return {object} The font object.
		 * @todo Support font.* options and renamed to toFont().
		 * @private
		 */
		_parseFont: function(options) {
			var globalDefaults = core_defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var font = {
				family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
				lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
				size: size,
				style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
				weight: null,
				string: ''
			};
	
			font.string = toFontString(font);
			return font;
		},
	
		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array} inputs - An array of values, falling back to the last value.
		 * @param {object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @param {object} [info] - object to return information about resolution in
		 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index, info) {
			var cacheable = true;
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
					cacheable = false;
				}
				if (index !== undefined && helpers_core.isArray(value)) {
					value = value[index];
					cacheable = false;
				}
				if (value !== undefined) {
					if (info && !cacheable) {
						info.cacheable = false;
					}
					return value;
				}
			}
		}
	};
	
	/**
	 * @alias Chart.helpers.math
	 * @namespace
	 */
	var exports$2 = {
		/**
		 * Returns an array of factors sorted from 1 to sqrt(value)
		 * @private
		 */
		_factorize: function(value) {
			var result = [];
			var sqrt = Math.sqrt(value);
			var i;
	
			for (i = 1; i < sqrt; i++) {
				if (value % i === 0) {
					result.push(i);
					result.push(value / i);
				}
			}
			if (sqrt === (sqrt | 0)) { // if value is a square number
				result.push(sqrt);
			}
	
			result.sort(function(a, b) {
				return a - b;
			}).pop();
			return result;
		},
	
		log10: Math.log10 || function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);
	
			return isPowerOf10 ? powerOf10 : exponent;
		}
	};
	
	var helpers_math = exports$2;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
	 * @namespace Chart.helpers.log10
	 * @deprecated since version 2.9.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.log10 = exports$2.log10;
	
	var getRtlAdapter = function(rectX, width) {
		return {
			x: function(x) {
				return rectX + rectX + width - x;
			},
			setWidth: function(w) {
				width = w;
			},
			textAlign: function(align) {
				if (align === 'center') {
					return align;
				}
				return align === 'right' ? 'left' : 'right';
			},
			xPlus: function(x, value) {
				return x - value;
			},
			leftForLtr: function(x, itemWidth) {
				return x - itemWidth;
			},
		};
	};
	
	var getLtrAdapter = function() {
		return {
			x: function(x) {
				return x;
			},
			setWidth: function(w) { // eslint-disable-line no-unused-vars
			},
			textAlign: function(align) {
				return align;
			},
			xPlus: function(x, value) {
				return x + value;
			},
			leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
				return x;
			},
		};
	};
	
	var getAdapter = function(rtl, rectX, width) {
		return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
	};
	
	var overrideTextDirection = function(ctx, direction) {
		var style, original;
		if (direction === 'ltr' || direction === 'rtl') {
			style = ctx.canvas.style;
			original = [
				style.getPropertyValue('direction'),
				style.getPropertyPriority('direction'),
			];
	
			style.setProperty('direction', direction, 'important');
			ctx.prevTextDirection = original;
		}
	};
	
	var restoreTextDirection = function(ctx) {
		var original = ctx.prevTextDirection;
		if (original !== undefined) {
			delete ctx.prevTextDirection;
			ctx.canvas.style.setProperty('direction', original[0], original[1]);
		}
	};
	
	var helpers_rtl = {
		getRtlAdapter: getAdapter,
		overrideTextDirection: overrideTextDirection,
		restoreTextDirection: restoreTextDirection,
	};
	
	var helpers$1 = helpers_core;
	var easing = helpers_easing;
	var canvas = helpers_canvas;
	var options = helpers_options;
	var math = helpers_math;
	var rtl = helpers_rtl;
	helpers$1.easing = easing;
	helpers$1.canvas = canvas;
	helpers$1.options = options;
	helpers$1.math = math;
	helpers$1.rtl = rtl;
	
	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;
	
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
	
			target = model[key];
	
			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}
	
			actual = view[key];
	
			if (actual === target || key[0] === '_') {
				continue;
			}
	
			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}
	
			origin = start[key];
	
			type = typeof target;
	
			if (type === typeof origin) {
				if (type === 'string') {
					c0 = chartjsColor(origin);
					if (c0.valid) {
						c1 = chartjsColor(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}
	
			view[key] = target;
		}
	}
	
	var Element = function(configuration) {
		helpers$1.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};
	
	helpers$1.extend(Element.prototype, {
		_type: undefined,
	
		initialize: function() {
			this.hidden = false;
		},
	
		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers$1.extend({}, me._model);
			}
			me._start = {};
			return me;
		},
	
		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;
	
			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = helpers$1.extend({}, model);
				me._start = null;
				return me;
			}
	
			if (!view) {
				view = me._view = {};
			}
	
			if (!start) {
				start = me._start = {};
			}
	
			interpolate(start, view, model, ease);
	
			return me;
		},
	
		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},
	
		hasValue: function() {
			return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
		}
	});
	
	Element.extend = helpers$1.inherits;
	
	var core_element = Element;
	
	var exports$3 = core_element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service
	
		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});
	
	var core_animation = exports$3;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});
	
	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});
	
	core_defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers$1.noop,
			onComplete: helpers$1.noop
		}
	});
	
	var core_animations = {
		animations: [],
		request: null,
	
		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {number} duration - The animation duration in ms.
		 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;
	
			animation.chart = chart;
			animation.startTime = Date.now();
			animation.duration = duration;
	
			if (!lazy) {
				chart.animating = true;
			}
	
			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}
	
			animations.push(animation);
	
			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},
	
		cancelAnimation: function(chart) {
			var index = helpers$1.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});
	
			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},
	
		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers$1.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},
	
		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
	
			me.advance();
	
			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},
	
		/**
		 * @private
		 */
		advance: function() {
			var animations = this.animations;
			var animation, chart, numSteps, nextStep;
			var i = 0;
	
			// 1 animation per chart, so we are looping charts here
			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;
				numSteps = animation.numSteps;
	
				// Make sure that currentStep starts at 1
				// https://github.com/chartjs/Chart.js/issues/6104
				nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
				animation.currentStep = Math.min(nextStep, numSteps);
	
				helpers$1.callback(animation.render, [chart, animation], chart);
				helpers$1.callback(animation.onAnimationProgress, [animation], chart);
	
				if (animation.currentStep >= numSteps) {
					helpers$1.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};
	
	var resolve = helpers$1.options.resolve;
	
	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}
	
		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});
	
		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];
	
			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);
	
					helpers$1.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});
	
					return res;
				}
			});
		});
	}
	
	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}
	
		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}
	
		if (listeners.length > 0) {
			return;
		}
	
		arrayEvents.forEach(function(key) {
			delete array[key];
		});
	
		delete array._chartjs;
	}
	
	// Base class for all dataset controllers (line, bar, etc)
	var DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};
	
	helpers$1.extend(DatasetController.prototype, {
	
		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,
	
		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,
	
		/**
		 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth'
		],
	
		/**
		 * Data element option keys to be resolved in _resolveDataElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'pointStyle'
		],
	
		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
			me._type = me.getMeta().type;
		},
	
		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},
	
		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var chart = me.chart;
			var scales = chart.scales;
			var dataset = me.getDataset();
			var scalesOpts = chart.options.scales;
	
			if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
				meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
				meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
			}
		},
	
		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},
	
		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},
	
		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getValueScale: function() {
			return this.getScaleForId(this._getValueScaleId());
		},
	
		/**
		 * @private
		 */
		_getIndexScale: function() {
			return this.getScaleForId(this._getIndexScaleId());
		},
	
		reset: function() {
			this._update(true);
		},
	
		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},
	
		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},
	
		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},
	
		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;
	
			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}
	
			meta.dataset = meta.dataset || me.createMetaDataset();
		},
	
		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},
	
		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);
	
			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}
	
				if (data && Object.isExtensible(data)) {
					listenArrayEvents(data, me);
				}
				me._data = data;
			}
	
			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},
	
		/**
		 * Returns the merged user-supplied and default dataset-level options
		 * @private
		 */
		_configure: function() {
			var me = this;
			me._config = helpers$1.merge({}, [
				me.chart.options.datasets[me._type],
				me.getDataset(),
			], {
				merger: function(key, target, source) {
					if (key !== '_meta' && key !== 'data') {
						helpers$1._merger(key, target, source);
					}
				}
			});
		},
	
		_update: function(reset) {
			var me = this;
			me._configure();
			me._cachedDataOpts = null;
			me.update(reset);
		},
	
		update: helpers$1.noop,
	
		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}
	
			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},
	
		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			if (meta.dataset) {
				meta.dataset.draw();
			}
	
			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},
	
		/**
		 * Returns a set of predefined style properties that should be used to represent the dataset
		 * or the data if the index is specified
		 * @param {number} index - data index
		 * @return {IStyleInterface} style object
		 */
		getStyle: function(index) {
			var me = this;
			var meta = me.getMeta();
			var dataset = meta.dataset;
			var style;
	
			me._configure();
			if (dataset && index === undefined) {
				style = me._resolveDatasetElementOptions(dataset || {});
			} else {
				index = index || 0;
				style = me._resolveDataElementOptions(meta.data[index] || {}, index);
			}
	
			if (style.fill === false || style.fill === null) {
				style.backgroundColor = style.borderColor;
			}
	
			return style;
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element, hover) {
			var me = this;
			var chart = me.chart;
			var datasetOpts = me._config;
			var custom = element.custom || {};
			var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
			var elementOptions = me._datasetElementOptions;
			var values = {};
			var i, ilen, key, readKey;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataset: me.getDataset(),
				datasetIndex: me.index,
				hover: hover
			};
	
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
				values[key] = resolve([
					custom[readKey],
					datasetOpts[readKey],
					options[readKey]
				], context);
			}
	
			return values;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(element, index) {
			var me = this;
			var custom = element && element.custom;
			var cached = me._cachedDataOpts;
			if (cached && !custom) {
				return cached;
			}
			var chart = me.chart;
			var datasetOpts = me._config;
			var options = chart.options.elements[me.dataElementType.prototype._type] || {};
			var elementOptions = me._dataElementOptions;
			var values = {};
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: me.getDataset(),
				datasetIndex: me.index
			};
	
			// `resolve` sets cacheable to `false` if any option is indexed or scripted
			var info = {cacheable: !custom};
	
			var keys, i, ilen, key;
	
			custom = custom || {};
	
			if (helpers$1.isArray(elementOptions)) {
				for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
					key = elementOptions[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			} else {
				keys = Object.keys(elementOptions);
				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[elementOptions[key]],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			}
	
			if (info.cacheable) {
				me._cachedDataOpts = Object.freeze(values);
			}
	
			return values;
		},
	
		removeHoverStyle: function(element) {
			helpers$1.merge(element._model, element.$previousStyle || {});
			delete element.$previousStyle;
		},
	
		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var model = element._model;
			var getHoverColor = helpers$1.getHoverColor;
	
			element.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};
	
			model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
			model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
			model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
		},
	
		/**
		 * @private
		 */
		_removeDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
	
			if (element) {
				this.removeHoverStyle(element);
			}
		},
	
		/**
		 * @private
		 */
		_setDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
			var prev = {};
			var i, ilen, key, keys, hoverOptions, model;
	
			if (!element) {
				return;
			}
	
			model = element._model;
			hoverOptions = this._resolveDatasetElementOptions(element, true);
	
			keys = Object.keys(hoverOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				prev[key] = model[key];
				model[key] = hoverOptions[key];
			}
	
			element.$previousStyle = prev;
		},
	
		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;
	
			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},
	
		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},
	
		/**
		 * @private
		 */
		onDataPush: function() {
			var count = arguments.length;
			this.insertElements(this.getDataset().data.length - count, count);
		},
	
		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},
	
		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},
	
		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},
	
		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});
	
	DatasetController.extend = helpers$1.inherits;
	
	var core_datasetController = DatasetController;
	
	var TAU = Math.PI * 2;
	
	core_defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: core_defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2,
				borderAlign: 'center'
			}
		}
	});
	
	function clipArc(ctx, arc) {
		var startAngle = arc.startAngle;
		var endAngle = arc.endAngle;
		var pixelMargin = arc.pixelMargin;
		var angleMargin = pixelMargin / arc.outerRadius;
		var x = arc.x;
		var y = arc.y;
	
		// Draw an inner border by cliping the arc and drawing a double-width border
		// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
		ctx.beginPath();
		ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
		if (arc.innerRadius > pixelMargin) {
			angleMargin = pixelMargin / arc.innerRadius;
			ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
		} else {
			ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
		}
		ctx.closePath();
		ctx.clip();
	}
	
	function drawFullCircleBorders(ctx, vm, arc, inner) {
		var endAngle = arc.endAngle;
		var i;
	
		if (inner) {
			arc.endAngle = arc.startAngle + TAU;
			clipArc(ctx, arc);
			arc.endAngle = endAngle;
			if (arc.endAngle === arc.startAngle && arc.fullCircles) {
				arc.endAngle += TAU;
				arc.fullCircles--;
			}
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	}
	
	function drawBorder(ctx, vm, arc) {
		var inner = vm.borderAlign === 'inner';
	
		if (inner) {
			ctx.lineWidth = vm.borderWidth * 2;
			ctx.lineJoin = 'round';
		} else {
			ctx.lineWidth = vm.borderWidth;
			ctx.lineJoin = 'bevel';
		}
	
		if (arc.fullCircles) {
			drawFullCircleBorders(ctx, vm, arc, inner);
		}
	
		if (inner) {
			clipArc(ctx, arc);
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.stroke();
	}
	
	var element_arc = core_element.extend({
		_type: 'arc',
	
		inLabelRange: function(mouseX) {
			var vm = this._view;
	
			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
	
		inRange: function(chartX, chartY) {
			var vm = this._view;
	
			if (vm) {
				var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;
	
				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += TAU;
				}
				while (angle > endAngle) {
					angle -= TAU;
				}
				while (angle < startAngle) {
					angle += TAU;
				}
	
				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
				return (betweenAngles && withinRadius);
			}
			return false;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
	
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
			var arc = {
				x: vm.x,
				y: vm.y,
				innerRadius: vm.innerRadius,
				outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
				pixelMargin: pixelMargin,
				startAngle: vm.startAngle,
				endAngle: vm.endAngle,
				fullCircles: Math.floor(vm.circumference / TAU)
			};
			var i;
	
			ctx.save();
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
	
			if (arc.fullCircles) {
				arc.endAngle = arc.startAngle + TAU;
				ctx.beginPath();
				ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
				ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
				ctx.closePath();
				for (i = 0; i < arc.fullCircles; ++i) {
					ctx.fill();
				}
				arc.endAngle = arc.startAngle + vm.circumference % TAU;
			}
	
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			ctx.fill();
	
			if (vm.borderWidth) {
				drawBorder(ctx, vm, arc);
			}
	
			ctx.restore();
		}
	});
	
	var valueOrDefault$1 = helpers$1.valueOrDefault;
	
	var defaultColor = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: defaultColor,
				borderWidth: 3,
				borderColor: defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});
	
	var element_line = core_element.extend({
		_type: 'line',
	
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalDefaults = core_defaults.global;
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var closePath = me._loop;
			var index, previous, currentVM;
	
			if (!points.length) {
				return;
			}
	
			if (me._loop) {
				for (index = 0; index < points.length; ++index) {
					previous = helpers$1.previousItem(points, index);
					// If the line has an open path, shift the point array
					if (!points[index]._view.skip && previous._view.skip) {
						points = points.slice(index).concat(points.slice(0, index));
						closePath = spanGaps;
						break;
					}
				}
				// If the line has a close path, add the first point again
				if (closePath) {
					points.push(points[0]);
				}
			}
	
			ctx.save();
	
			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}
	
			ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
			// Stroke Line
			ctx.beginPath();
	
			// First point moves to it's starting position no matter what
			currentVM = points[0]._view;
			if (!currentVM.skip) {
				ctx.moveTo(currentVM.x, currentVM.y);
				lastDrawnIndex = 0;
			}
	
			for (index = 1; index < points.length; ++index) {
				currentVM = points[index]._view;
				previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
	
				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
					}
					lastDrawnIndex = index;
				}
			}
	
			if (closePath) {
				ctx.closePath();
			}
	
			ctx.stroke();
			ctx.restore();
		}
	});
	
	var valueOrDefault$2 = helpers$1.valueOrDefault;
	
	var defaultColor$1 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor$1,
				borderColor: defaultColor$1,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});
	
	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
	}
	
	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
	}
	
	var element_point = core_element.extend({
		_type: 'point',
	
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},
	
		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,
	
		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
	
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
	
		draw: function(chartArea) {
			var vm = this._view;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var rotation = vm.rotation;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
	
			if (vm.skip) {
				return;
			}
	
			// Clipping for Points.
			if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
				helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
			}
		}
	});
	
	var defaultColor$2 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaultColor$2,
				borderColor: defaultColor$2,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});
	
	function isVertical(vm) {
		return vm && vm.width !== undefined;
	}
	
	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(vm) {
		var x1, x2, y1, y2, half;
	
		if (isVertical(vm)) {
			half = vm.width / 2;
			x1 = vm.x - half;
			x2 = vm.x + half;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			half = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - half;
			y2 = vm.y + half;
		}
	
		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}
	
	function swap(orig, v1, v2) {
		return orig === v1 ? v2 : orig === v2 ? v1 : orig;
	}
	
	function parseBorderSkipped(vm) {
		var edge = vm.borderSkipped;
		var res = {};
	
		if (!edge) {
			return res;
		}
	
		if (vm.horizontal) {
			if (vm.base > vm.x) {
				edge = swap(edge, 'left', 'right');
			}
		} else if (vm.base < vm.y) {
			edge = swap(edge, 'bottom', 'top');
		}
	
		res[edge] = true;
		return res;
	}
	
	function parseBorderWidth(vm, maxW, maxH) {
		var value = vm.borderWidth;
		var skip = parseBorderSkipped(vm);
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}
	
		return {
			t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
			r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
			b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
			l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
		};
	}
	
	function boundingRects(vm) {
		var bounds = getBarBounds(vm);
		var width = bounds.right - bounds.left;
		var height = bounds.bottom - bounds.top;
		var border = parseBorderWidth(vm, width / 2, height / 2);
	
		return {
			outer: {
				x: bounds.left,
				y: bounds.top,
				w: width,
				h: height
			},
			inner: {
				x: bounds.left + border.l,
				y: bounds.top + border.t,
				w: width - border.l - border.r,
				h: height - border.t - border.b
			}
		};
	}
	
	function inRange(vm, x, y) {
		var skipX = x === null;
		var skipY = y === null;
		var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);
	
		return bounds
			&& (skipX || x >= bounds.left && x <= bounds.right)
			&& (skipY || y >= bounds.top && y <= bounds.bottom);
	}
	
	var element_rectangle = core_element.extend({
		_type: 'rectangle',
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var rects = boundingRects(vm);
			var outer = rects.outer;
			var inner = rects.inner;
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
	
			if (outer.w === inner.w && outer.h === inner.h) {
				return;
			}
	
			ctx.save();
			ctx.beginPath();
			ctx.rect(outer.x, outer.y, outer.w, outer.h);
			ctx.clip();
			ctx.fillStyle = vm.borderColor;
			ctx.rect(inner.x, inner.y, inner.w, inner.h);
			ctx.fill('evenodd');
			ctx.restore();
		},
	
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
	
		inRange: function(mouseX, mouseY) {
			return inRange(this._view, mouseX, mouseY);
		},
	
		inLabelRange: function(mouseX, mouseY) {
			var vm = this._view;
			return isVertical(vm)
				? inRange(vm, mouseX, null)
				: inRange(vm, null, mouseY);
		},
	
		inXRange: function(mouseX) {
			return inRange(this._view, mouseX, null);
		},
	
		inYRange: function(mouseY) {
			return inRange(this._view, null, mouseY);
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(vm)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}
	
			return {x: x, y: y};
		},
	
		getArea: function() {
			var vm = this._view;
	
			return isVertical(vm)
				? vm.width * Math.abs(vm.y - vm.base)
				: vm.height * Math.abs(vm.x - vm.base);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});
	
	var elements = {};
	var Arc = element_arc;
	var Line = element_line;
	var Point = element_point;
	var Rectangle = element_rectangle;
	elements.Arc = Arc;
	elements.Line = Line;
	elements.Point = Point;
	elements.Rectangle = Rectangle;
	
	var deprecated = helpers$1._deprecated;
	var valueOrDefault$3 = helpers$1.valueOrDefault;
	
	core_defaults._set('bar', {
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}],
	
			yAxes: [{
				type: 'linear'
			}]
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			bar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	/**
	 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
	 * @private
	 */
	function computeMinSampleSize(scale, pixels) {
		var min = scale._length;
		var prev, curr, i, ilen;
	
		for (i = 1, ilen = pixels.length; i < ilen; ++i) {
			min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
		}
	
		for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
			curr = scale.getPixelForTick(i);
			min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
			prev = curr;
		}
	
		return min;
	}
	
	/**
	 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
	 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
	 * mode currently always generates bars equally sized (until we introduce scriptable options?).
	 * @private
	 */
	function computeFitCategoryTraits(index, ruler, options) {
		var thickness = options.barThickness;
		var count = ruler.stackCount;
		var curr = ruler.pixels[index];
		var min = helpers$1.isNullOrUndef(thickness)
			? computeMinSampleSize(ruler.scale, ruler.pixels)
			: -1;
		var size, ratio;
	
		if (helpers$1.isNullOrUndef(thickness)) {
			size = min * options.categoryPercentage;
			ratio = options.barPercentage;
		} else {
			// When bar thickness is enforced, category and bar percentages are ignored.
			// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
			// and deprecate barPercentage since this value is ignored when thickness is absolute.
			size = thickness * count;
			ratio = 1;
		}
	
		return {
			chunk: size / count,
			ratio: ratio,
			start: curr - (size / 2)
		};
	}
	
	/**
	 * Computes an "optimal" category that globally arranges bars side by side (no gap when
	 * percentage options are 1), based on the previous and following categories. This mode
	 * generates bars with different widths when data are not evenly spaced.
	 * @private
	 */
	function computeFlexCategoryTraits(index, ruler, options) {
		var pixels = ruler.pixels;
		var curr = pixels[index];
		var prev = index > 0 ? pixels[index - 1] : null;
		var next = index < pixels.length - 1 ? pixels[index + 1] : null;
		var percent = options.categoryPercentage;
		var start, size;
	
		if (prev === null) {
			// first data: its size is double based on the next point or,
			// if it's also the last data, we use the scale size.
			prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
		}
	
		if (next === null) {
			// last data: its size is also double based on the previous point.
			next = curr + curr - prev;
		}
	
		start = curr - (curr - Math.min(prev, next)) / 2 * percent;
		size = Math.abs(next - prev) / 2 * percent;
	
		return {
			chunk: size / ruler.stackCount,
			ratio: options.barPercentage,
			start: start
		};
	}
	
	var controller_bar = core_datasetController.extend({
	
		dataElementType: elements.Rectangle,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderSkipped',
			'borderWidth',
			'barPercentage',
			'barThickness',
			'categoryPercentage',
			'maxBarThickness',
			'minBarLength'
		],
	
		initialize: function() {
			var me = this;
			var meta, scaleOpts;
	
			core_datasetController.prototype.initialize.apply(me, arguments);
	
			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
	
			scaleOpts = me._getIndexScale().options;
			deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
			deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
			deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
			deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
			deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
		},
	
		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;
	
			me._ruler = me.getRuler();
	
			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},
	
		updateElement: function(rectangle, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var options = me._resolveDataElementOptions(rectangle, index);
	
			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;
			rectangle._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderSkipped: options.borderSkipped,
				borderWidth: options.borderWidth,
				datasetLabel: dataset.label,
				label: me.chart.data.labels[index]
			};
	
			if (helpers$1.isArray(dataset.data[index])) {
				rectangle._model.borderSkipped = null;
			}
	
			me._updateElementGeometry(rectangle, index, reset, options);
	
			rectangle.pivot();
		},
	
		/**
		 * @private
		 */
		_updateElementGeometry: function(rectangle, index, reset, options) {
			var me = this;
			var model = rectangle._model;
			var vscale = me._getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index, options);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
	
			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},
	
		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {number} [last] - The dataset index
		 * @returns {string[]} The list of stack IDs
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var scale = me._getIndexScale();
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var stacked = scale.options.stacked;
			var ilen = metasets.length;
			var stacks = [];
			var i, meta;
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				// stacked   | meta.stack
				//           | found | not found | undefined
				// false     |   x   |     x     |     x
				// true      |       |     x     |
				// undefined |       |     x     |     x
				if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
					(stacked === undefined && meta.stack === undefined)) {
					stacks.push(meta.stack);
				}
				if (meta.index === last) {
					break;
				}
			}
	
			return stacks;
		},
	
		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},
	
		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {number} [datasetIndex] - The dataset index
		 * @param {string} [name] - The stack name to find
		 * @returns {number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present
	
			return (index === -1)
				? stacks.length - 1
				: index;
		},
	
		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me._getIndexScale();
			var pixels = [];
			var i, ilen;
	
			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, me.index));
			}
	
			return {
				pixels: pixels,
				start: scale._startPixel,
				end: scale._endPixel,
				stackCount: me.getStackCount(),
				scale: scale
			};
		},
	
		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index, options) {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var isHorizontal = scale.isHorizontal();
			var datasets = chart.data.datasets;
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var value = scale._parseValue(datasets[datasetIndex].data[index]);
			var minBarLength = options.minBarLength;
			var stacked = scale.options.stacked;
			var stack = me.getMeta().stack;
			var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
			var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
			var ilen = metasets.length;
			var i, imeta, ivalue, base, head, size, stackLength;
	
			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < ilen; ++i) {
					imeta = metasets[i];
	
					if (imeta.index === datasetIndex) {
						break;
					}
	
					if (imeta.stack === stack) {
						stackLength = scale._parseValue(datasets[imeta.index].data[index]);
						ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
	
						if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}
	
			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + length);
			size = head - base;
	
			if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
				size = minBarLength;
				if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
					head = base - minBarLength;
				} else {
					head = base + minBarLength;
				}
			}
	
			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},
	
		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
			var me = this;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);
	
			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				valueOrDefault$3(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);
	
			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;
	
			helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
	
			for (; i < ilen; ++i) {
				var val = scale._parseValue(dataset.data[i]);
				if (!isNaN(val.min) && !isNaN(val.max)) {
					rects[i].draw();
				}
			}
	
			helpers$1.canvas.unclipArea(chart.ctx);
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function() {
			var me = this;
			var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
			var indexOpts = me._getIndexScale().options;
			var valueOpts = me._getValueScale().options;
	
			values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
			values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
			values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
			values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
			values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
	
			return values;
		}
	
	});
	
	var valueOrDefault$4 = helpers$1.valueOrDefault;
	var resolve$1 = helpers$1.options.resolve;
	
	core_defaults._set('bubble', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});
	
	var controller_bubble = core_datasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
			'hoverRadius',
			'hitRadius',
			'pointStyle',
			'rotation'
		],
	
		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;
	
			// Update Points
			helpers$1.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},
	
		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveDataElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;
	
			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
	
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};
	
			point.pivot();
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var custom = point.custom || {};
			var data = dataset.data[index] || {};
			var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			// In case values were cached (and thus frozen), we need to clone the values
			if (me._cachedDataOpts === values) {
				values = helpers$1.extend({}, values);
			}
	
			// Custom radius resolution
			values.radius = resolve$1([
				custom.radius,
				data.r,
				me._config.radius,
				chart.options.elements.point.radius
			], context, index);
	
			return values;
		}
	});
	
	var valueOrDefault$5 = helpers$1.valueOrDefault;
	
	var PI$1 = Math.PI;
	var DOUBLE_PI$1 = PI$1 * 2;
	var HALF_PI$1 = PI$1 / 2;
	
	core_defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}
	
				chart.update();
			}
		},
	
		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,
	
		// The rotation of the chart, where the first data arc begins.
		rotation: -HALF_PI$1,
	
		// The total circumference of the chart.
		circumference: DOUBLE_PI$1,
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
					if (helpers$1.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}
	
					return dataLabel;
				}
			}
		}
	});
	
	var controller_doughnut = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;
	
			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}
	
			return ringIndex;
		},
	
		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var ratioX = 1;
			var ratioY = 1;
			var offsetX = 0;
			var offsetY = 0;
			var meta = me.getMeta();
			var arcs = meta.data;
			var cutout = opts.cutoutPercentage / 100 || 0;
			var circumference = opts.circumference;
			var chartWeight = me._getRingWeight(me.index);
			var maxWidth, maxHeight, i, ilen;
	
			// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
			if (circumference < DOUBLE_PI$1) {
				var startAngle = opts.rotation % DOUBLE_PI$1;
				startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
				var endAngle = startAngle + circumference;
				var startX = Math.cos(startAngle);
				var startY = Math.sin(startAngle);
				var endX = Math.cos(endAngle);
				var endY = Math.sin(endAngle);
				var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
				var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
				var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
				var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
				var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
				var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
				var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
				var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
				ratioX = (maxX - minX) / 2;
				ratioY = (maxY - minY) / 2;
				offsetX = -(maxX + minX) / 2;
				offsetY = -(maxY + minY) / 2;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			}
	
			chart.borderWidth = me.getMaxBorderWidth();
			maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
			maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
			chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
			chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
			chart.offsetX = offsetX * chart.outerRadius;
			chart.offsetY = offsetY * chart.outerRadius;
	
			meta.total = me.calculateTotal();
	
			me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});
	
			var model = arc._model;
	
			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}
	
				model.endAngle = model.startAngle + model.circumference;
			}
	
			arc.pivot();
		},
	
		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;
	
			helpers$1.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});
	
			/* if (total === 0) {
				total = NaN;
			}*/
	
			return total;
		},
	
		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return DOUBLE_PI$1 * (Math.abs(value) / total);
			}
			return 0;
		},
	
		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var me = this;
			var max = 0;
			var chart = me.chart;
			var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
	
			if (!arcs) {
				// Find the outmost visible dataset
				for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						meta = chart.getDatasetMeta(i);
						arcs = meta.data;
						if (i !== me.index) {
							controller = meta.controller;
						}
						break;
					}
				}
			}
	
			if (!arcs) {
				return 0;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arc = arcs[i];
				if (controller) {
					controller._configure();
					options = controller._resolveDataElementOptions(arc, i);
				} else {
					options = arc._options;
				}
				if (options.borderAlign !== 'inner') {
					borderWidth = options.borderWidth;
					hoverWidth = options.hoverBorderWidth;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
			}
			return max;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
		 * @private
		 */
		_getRingWeightOffset: function(datasetIndex) {
			var ringWeightOffset = 0;
	
			for (var i = 0; i < datasetIndex; ++i) {
				if (this.chart.isDatasetVisible(i)) {
					ringWeightOffset += this._getRingWeight(i);
				}
			}
	
			return ringWeightOffset;
		},
	
		/**
		 * @private
		 */
		_getRingWeight: function(dataSetIndex) {
			return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
		},
	
		/**
		 * Returns the sum of all visibile data set weights.  This value can be 0.
		 * @private
		 */
		_getVisibleDatasetWeightTotal: function() {
			return this._getRingWeightOffset(this.chart.data.datasets.length);
		}
	});
	
	core_defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},
	
		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
	
			yAxes: [{
				type: 'category',
				position: 'left',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
	
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
	
		tooltips: {
			mode: 'index',
			axis: 'y'
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			horizontalBar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	var controller_horizontalBar = controller_bar.extend({
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
	
	var valueOrDefault$6 = helpers$1.valueOrDefault;
	var resolve$2 = helpers$1.options.resolve;
	var isPointInArea = helpers$1.canvas._isPointInArea;
	
	core_defaults._set('line', {
		showLines: true,
		spanGaps: false,
	
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});
	
	function scaleClip(scale, halfBorderWidth) {
		var tickOpts = scale && scale.options.ticks || {};
		var reverse = tickOpts.reverse;
		var min = tickOpts.min === undefined ? halfBorderWidth : 0;
		var max = tickOpts.max === undefined ? halfBorderWidth : 0;
		return {
			start: reverse ? max : min,
			end: reverse ? min : max
		};
	}
	
	function defaultClip(xScale, yScale, borderWidth) {
		var halfBorderWidth = borderWidth / 2;
		var x = scaleClip(xScale, halfBorderWidth);
		var y = scaleClip(yScale, halfBorderWidth);
	
		return {
			top: y.end,
			right: x.end,
			bottom: y.start,
			left: x.start
		};
	}
	
	function toClip(value) {
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = value.top;
			r = value.right;
			b = value.bottom;
			l = value.left;
		} else {
			t = r = b = l = value;
		}
	
		return {
			top: t,
			right: r,
			bottom: b,
			left: l
		};
	}
	
	
	var controller_line = core_datasetController.extend({
	
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth',
			'cubicInterpolationMode',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var config = me._config;
			var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
			var i, ilen;
	
			me._xScale = me.getScaleForId(meta.xAxisID);
			me._yScale = me.getScaleForId(meta.yAxisID);
	
			// Update Line
			if (showLine) {
				// Compatibility: If the properties are defined with only the old name, use those values
				if (config.tension !== undefined && config.lineTension === undefined) {
					config.lineTension = config.tension;
				}
	
				// Utility
				line._scale = me._yScale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = me._resolveDatasetElementOptions(line);
	
				line.pivot();
			}
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var xScale = me._xScale;
			var yScale = me._yScale;
			var lineModel = meta.dataset._model;
			var x, y;
	
			var options = me._resolveDataElementOptions(point, index);
	
			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = datasetIndex;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
				steppedLine: lineModel ? lineModel.steppedLine : false,
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element) {
			var me = this;
			var config = me._config;
			var custom = element.custom || {};
			var options = me.chart.options;
			var lineOptions = options.elements.line;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			// The default behavior of lines is to break at null values, according
			// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
			// This option gives lines the ability to span gaps
			values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
			values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
			values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
	
			return values;
		},
	
		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var yScale = me._yScale;
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
	
			if (yScale.options.stacked) {
				rightValue = +yScale.getRightValue(value);
				metasets = chart._getSortedVisibleDatasetMetas();
				ilen = metasets.length;
	
				for (i = 0; i < ilen; ++i) {
					dsMeta = metasets[i];
					if (dsMeta.index === datasetIndex) {
						break;
					}
	
					ds = chart.data.datasets[dsMeta.index];
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
						stackedRightValue = +yScale.getRightValue(ds.data[index]);
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}
	
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}
			return yScale.getPixelForValue(value);
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var lineModel = meta.dataset._model;
			var area = chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (lineModel.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			if (lineModel.cubicInterpolationMode === 'monotone') {
				helpers$1.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					controlPoints = helpers$1.splineCurve(
						helpers$1.previousItem(points, i)._model,
						model,
						helpers$1.nextItem(points, i)._model,
						lineModel.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}
	
			if (chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					if (isPointInArea(model, area)) {
						if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
							model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
							model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						}
						if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
							model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
							model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
						}
					}
				}
			}
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var canvas = chart.canvas;
			var i = 0;
			var ilen = points.length;
			var clip;
	
			if (me._showLine) {
				clip = meta.dataset._model.clip;
	
				helpers$1.canvas.clipArea(chart.ctx, {
					left: clip.left === false ? 0 : area.left - clip.left,
					right: clip.right === false ? canvas.width : area.right + clip.right,
					top: clip.top === false ? 0 : area.top - clip.top,
					bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
				});
	
				meta.dataset.draw();
	
				helpers$1.canvas.unclipArea(chart.ctx);
			}
	
			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
		},
	});
	
	var resolve$3 = helpers$1.options.resolve;
	
	core_defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},
	
		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},
	
		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}
	
				chart.update();
			}
		},
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});
	
	var controller_polarArea = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var dataset = me.getDataset();
			var meta = me.getMeta();
			var start = me.chart.options.startAngle || 0;
			var starts = me._starts = [];
			var angles = me._angles = [];
			var arcs = meta.data;
			var i, ilen, angle;
	
			me._updateRadius();
	
			meta.count = me.countVisibleElements();
	
			for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
				starts[i] = start;
				angle = me._computeAngle(i);
				angles[i] = angle;
				start += angle;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		/**
		 * @private
		 */
		_updateRadius: function() {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
	
			chart.outerRadius = Math.max(minSize / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;
	
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;
	
			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = me._starts[index];
			var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
	
			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});
	
			arc.pivot();
		},
	
		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;
	
			helpers$1.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});
	
			return count;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
			var valueOrDefault = helpers$1.valueOrDefault;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * @private
		 */
		_computeAngle: function(index) {
			var me = this;
			var count = this.getMeta().count;
			var dataset = me.getDataset();
			var meta = me.getMeta();
	
			if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
				return 0;
			}
	
			// Scriptable options
			var context = {
				chart: me.chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			return resolve$3([
				me.chart.options.elements.arc.angle,
				(2 * Math.PI) / count
			], context, index);
		}
	});
	
	core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
	core_defaults._set('pie', {
		cutoutPercentage: 0
	});
	
	// Pie charts are Doughnut chart with different defaults
	var controller_pie = controller_doughnut;
	
	var valueOrDefault$7 = helpers$1.valueOrDefault;
	
	core_defaults._set('radar', {
		spanGaps: false,
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				fill: 'start',
				tension: 0 // no bezier in radar
			}
		}
	});
	
	var controller_radar = core_datasetController.extend({
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderWidth',
			'borderColor',
			'borderCapStyle',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var scale = me.chart.scale;
			var config = me._config;
			var i, ilen;
	
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}
	
			// Utility
			line._scale = scale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			line._loop = true;
			// Model
			line._model = me._resolveDatasetElementOptions(line);
	
			line.pivot();
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			// Update bezier control points
			me.updateBezierControlPoints();
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
			var options = me._resolveDataElementOptions(point, index);
			var lineModel = me.getMeta().dataset._model;
			var x = reset ? scale.xCenter : pointPosition.x;
			var y = reset ? scale.yCenter : pointPosition.y;
	
			// Utility
			point._scale = scale;
			point._options = options;
			point._datasetIndex = me.index;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x, // value not used in dataset scale, but we want a consistent API between scales
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
	
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function() {
			var me = this;
			var config = me._config;
			var options = me.chart.options;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
	
			return values;
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i, true)._model,
					model,
					helpers$1.nextItem(points, i, true)._model,
					model.tension
				);
	
				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
				model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
				model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
				model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
			}
		},
	
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
		}
	});
	
	core_defaults._set('scatter', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			scatter: {
				showLine: false
			}
		}
	});
	
	// Scatter charts use line controllers
	var controller_scatter = controller_line;
	
	// NOTE export a map in which the key represents the controller type, not
	// the class, and so must be CamelCase in order to be correctly retrieved
	// by the controller in core.controller.js (`controllers[meta.type]`).
	
	var controllers = {
		bar: controller_bar,
		bubble: controller_bubble,
		doughnut: controller_doughnut,
		horizontalBar: controller_horizontalBar,
		line: controller_line,
		polarArea: controller_polarArea,
		pie: controller_pie,
		radar: controller_radar,
		scatter: controller_scatter
	};
	
	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {object} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}
	
		return helpers$1.getRelativePosition(e, chart);
	}
	
	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param {Chart} chart - the chart
	 * @param {function} handler - the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var metadata, i, j, ilen, jlen, element;
	
		for (i = 0, ilen = metasets.length; i < ilen; ++i) {
			metadata = metasets[i].data;
			for (j = 0, jlen = metadata.length; j < jlen; ++j) {
				element = metadata[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}
	
	/**
	 * Helper function to get the items that intersect the event position
	 * @param {ChartElement[]} items - elements to filter
	 * @param {object} position - the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];
	
		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param {Chart} chart - the chart to look at elements from
	 * @param {object} position - the point to be nearest to
	 * @param {boolean} intersect - if true, only consider items that intersect the position
	 * @param {function} distanceMetric - function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];
	
		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}
	
			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});
	
		return nearestItems;
	}
	
	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {string} axis - the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;
	
		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}
	
	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];
	
		if (!items.length) {
			return [];
		}
	
		chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
			var element = meta.data[items[0]._index];
	
			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */
	
	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	var core_interaction = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];
	
				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});
	
				return elements.slice(0, 1);
			},
	
			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,
	
			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,
	
			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	
				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}
	
				return items;
			},
	
			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},
	
			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},
	
			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				return getNearestItems(chart, position, options.intersect, distanceMetric);
			},
	
			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},
	
			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};
	
	var extend = helpers$1.extend;
	
	function filterByPosition(array, position) {
		return helpers$1.where(array, function(v) {
			return v.pos === position;
		});
	}
	
	function sortByWeight(array, reverse) {
		return array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0.index - v1.index :
				v0.weight - v1.weight;
		});
	}
	
	function wrapBoxes(boxes) {
		var layoutBoxes = [];
		var i, ilen, box;
	
		for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
			box = boxes[i];
			layoutBoxes.push({
				index: i,
				box: box,
				pos: box.position,
				horizontal: box.isHorizontal(),
				weight: box.weight
			});
		}
		return layoutBoxes;
	}
	
	function setLayoutDims(layouts, params) {
		var i, ilen, layout;
		for (i = 0, ilen = layouts.length; i < ilen; ++i) {
			layout = layouts[i];
			// store width used instead of chartArea.w in fitBoxes
			layout.width = layout.horizontal
				? layout.box.fullWidth && params.availableWidth
				: params.vBoxMaxWidth;
			// store height used instead of chartArea.h in fitBoxes
			layout.height = layout.horizontal && params.hBoxMaxHeight;
		}
	}
	
	function buildLayoutBoxes(boxes) {
		var layoutBoxes = wrapBoxes(boxes);
		var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
		var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
		var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
		var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
	
		return {
			leftAndTop: left.concat(top),
			rightAndBottom: right.concat(bottom),
			chartArea: filterByPosition(layoutBoxes, 'chartArea'),
			vertical: left.concat(right),
			horizontal: top.concat(bottom)
		};
	}
	
	function getCombinedMax(maxPadding, chartArea, a, b) {
		return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
	}
	
	function updateDims(chartArea, params, layout) {
		var box = layout.box;
		var maxPadding = chartArea.maxPadding;
		var newWidth, newHeight;
	
		if (layout.size) {
			// this layout was already counted for, lets first reduce old size
			chartArea[layout.pos] -= layout.size;
		}
		layout.size = layout.horizontal ? box.height : box.width;
		chartArea[layout.pos] += layout.size;
	
		if (box.getPadding) {
			var boxPadding = box.getPadding();
			maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
			maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
			maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
			maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
		}
	
		newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
		newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
	
		if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
			chartArea.w = newWidth;
			chartArea.h = newHeight;
	
			// return true if chart area changed in layout's direction
			return layout.horizontal ? newWidth !== chartArea.w : newHeight !== chartArea.h;
		}
	}
	
	function handleMaxPadding(chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function updatePos(pos) {
			var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
			chartArea[pos] += change;
			return change;
		}
		chartArea.y += updatePos('top');
		chartArea.x += updatePos('left');
		updatePos('right');
		updatePos('bottom');
	}
	
	function getMargins(horizontal, chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function marginForPositions(positions) {
			var margin = {left: 0, top: 0, right: 0, bottom: 0};
			positions.forEach(function(pos) {
				margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
			});
			return margin;
		}
	
		return horizontal
			? marginForPositions(['left', 'right'])
			: marginForPositions(['top', 'bottom']);
	}
	
	function fitBoxes(boxes, chartArea, params) {
		var refitBoxes = [];
		var i, ilen, layout, box, refit, changed;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
	
			box.update(
				layout.width || chartArea.w,
				layout.height || chartArea.h,
				getMargins(layout.horizontal, chartArea)
			);
			if (updateDims(chartArea, params, layout)) {
				changed = true;
				if (refitBoxes.length) {
					// Dimensions changed and there were non full width boxes before this
					// -> we have to refit those
					refit = true;
				}
			}
			if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
				refitBoxes.push(layout);
			}
		}
	
		return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
	}
	
	function placeBoxes(boxes, chartArea, params) {
		var userPadding = params.padding;
		var x = chartArea.x;
		var y = chartArea.y;
		var i, ilen, layout, box;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
			if (layout.horizontal) {
				box.left = box.fullWidth ? userPadding.left : chartArea.left;
				box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
				box.top = y;
				box.bottom = y + box.height;
				box.width = box.right - box.left;
				y = box.bottom;
			} else {
				box.left = x;
				box.right = x + box.width;
				box.top = chartArea.top;
				box.bottom = chartArea.top + chartArea.h;
				box.height = box.bottom - box.top;
				x = box.right;
			}
		}
	
		chartArea.x = x;
		chartArea.y = y;
	}
	
	core_defaults._set('global', {
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});
	
	/**
	 * @interface ILayoutItem
	 * @prop {string} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {function} getPadding -  Returns an object with padding on the edges
	 * @prop {number} width - Width of item. Must be valid after update()
	 * @prop {number} height - Height of item. Must be valid after update()
	 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */
	
	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	var core_layouts = {
		defaults: {},
	
		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}
	
			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;
			item._layers = item._layers || function() {
				return [{
					z: 0,
					draw: function() {
						item.draw.apply(item, arguments);
					}
				}];
			};
	
			chart.boxes.push(item);
		},
	
		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {ILayoutItem} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},
	
		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {ILayoutItem} item - the item to configure with the given options
		 * @param {object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;
	
			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},
	
		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {number} width - the width to fit into
		 * @param {number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}
	
			var layoutOptions = chart.options.layout || {};
			var padding = helpers$1.options.toPadding(layoutOptions.padding);
	
			var availableWidth = width - padding.width;
			var availableHeight = height - padding.height;
			var boxes = buildLayoutBoxes(chart.boxes);
			var verticalBoxes = boxes.vertical;
			var horizontalBoxes = boxes.horizontal;
	
			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
	
			var params = Object.freeze({
				outerWidth: width,
				outerHeight: height,
				padding: padding,
				availableWidth: availableWidth,
				vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
				hBoxMaxHeight: availableHeight / 2
			});
			var chartArea = extend({
				maxPadding: extend({}, padding),
				w: availableWidth,
				h: availableHeight,
				x: padding.left,
				y: padding.top
			}, padding);
	
			setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
	
			// First fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
	
			// Then fit horizontal boxes
			if (fitBoxes(horizontalBoxes, chartArea, params)) {
				// if the area changed, re-fit vertical boxes
				fitBoxes(verticalBoxes, chartArea, params);
			}
	
			handleMaxPadding(chartArea);
	
			// Finally place the boxes to correct coordinates
			placeBoxes(boxes.leftAndTop, chartArea, params);
	
			// Move to opposite side of chart
			chartArea.x += chartArea.w;
			chartArea.y += chartArea.h;
	
			placeBoxes(boxes.rightAndBottom, chartArea, params);
	
			chart.chartArea = {
				left: chartArea.left,
				top: chartArea.top,
				right: chartArea.left + chartArea.w,
				bottom: chartArea.top + chartArea.h
			};
	
			// Finally update boxes in chartArea (radial scale for example)
			helpers$1.each(boxes.chartArea, function(layout) {
				var box = layout.box;
				extend(box, chart.chartArea);
				box.update(chartArea.w, chartArea.h);
			});
		}
	};
	
	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */
	
	var platform_basic = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			return item && item.getContext('2d') || null;
		}
	};
	
	var platform_dom = "/*\n * DOM element rendering detection\n * https://davidwalsh.name/detect-node-insertion\n */\n@keyframes chartjs-render-animation {\n\tfrom { opacity: 0.99; }\n\tto { opacity: 1; }\n}\n\n.chartjs-render-monitor {\n\tanimation: chartjs-render-animation 0.001s;\n}\n\n/*\n * DOM element resizing detection\n * https://github.com/marcj/css-element-queries\n */\n.chartjs-size-monitor,\n.chartjs-size-monitor-expand,\n.chartjs-size-monitor-shrink {\n\tposition: absolute;\n\tdirection: ltr;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tpointer-events: none;\n\tvisibility: hidden;\n\tz-index: -1;\n}\n\n.chartjs-size-monitor-expand > div {\n\tposition: absolute;\n\twidth: 1000000px;\n\theight: 1000000px;\n\tleft: 0;\n\ttop: 0;\n}\n\n.chartjs-size-monitor-shrink > div {\n\tposition: absolute;\n\twidth: 200%;\n\theight: 200%;\n\tleft: 0;\n\ttop: 0;\n}\n";
	
	var platform_dom$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': platform_dom
	});
	
	var stylesheet = getCjsExportFromNamespace(platform_dom$1);
	
	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
	
	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};
	
	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers$1.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}
	
	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;
	
		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');
	
		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};
	
		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';
	
		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}
	
		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}
	
		return canvas;
	}
	
	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line getter-return
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());
	
	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
	
	function addListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}
	
	function removeListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}
	
	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}
	
	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers$1.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}
	
	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];
	
		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;
	
			if (!ticking) {
				ticking = true;
				helpers$1.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}
	
	function createDiv(cls) {
		var el = document.createElement('div');
		el.className = cls || '';
		return el;
	}
	
	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var maxSize = 1000000;
	
		// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
		// https://github.com/chartjs/Chart.js/issues/5902
		var resizer = createDiv(CSS_SIZE_MONITOR);
		var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
		var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
	
		expand.appendChild(createDiv());
		shrink.appendChild(createDiv());
	
		resizer.appendChild(expand);
		resizer.appendChild(shrink);
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
	
		var onScroll = function() {
			resizer._reset();
			handler();
		};
	
		addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
	
		return resizer;
	}
	
	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};
	
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			addListener(node, type, proxy);
		});
	
		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;
	
		node.classList.add(CSS_RENDER_MONITOR);
	}
	
	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;
	
		if (proxy) {
			helpers$1.each(ANIMATION_START_EVENTS, function(type) {
				removeListener(node, type, proxy);
			});
	
			delete expando.renderProxy;
		}
	
		node.classList.remove(CSS_RENDER_MONITOR);
	}
	
	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	
		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				var container = chart.options.maintainAspectRatio && node.parentNode;
				var w = container ? container.clientWidth : 0;
				listener(createEvent('resize', chart));
				if (container && container.clientWidth < w && chart.canvas) {
					// If the container size shrank during chart resize, let's assume
					// scrollbar appeared. So we resize again with the scrollbar visible -
					// effectively making chart smaller and the scrollbar hidden again.
					// Because we are inside `throttled`, and currently `ticking`, scroll
					// events are ignored during this whole 2 resize process.
					// If we assumed wrong and something else happened, we are resizing
					// twice in a frame (potential performance issue)
					listener(createEvent('resize', chart));
				}
			}
		}));
	
		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}
	
				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}
	
	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;
	
		delete expando.resizer;
		unwatchForRender(node);
	
		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}
	
	/**
	 * Injects CSS styles inline if the styles are not already present.
	 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
	 * @param {string} css - the CSS to be injected.
	 */
	function injectCSS(rootNode, css) {
		// https://stackoverflow.com/q/3922139
		var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
		if (!expando.containsStyles) {
			expando.containsStyles = true;
			css = '/* Chart.js */\n' + css;
			var style = document.createElement('style');
			style.setAttribute('type', 'text/css');
			style.appendChild(document.createTextNode(css));
			rootNode.appendChild(style);
		}
	}
	
	var platform_dom$2 = {
		/**
		 * When `true`, prevents the automatic injection of the stylesheet required to
		 * correctly detect when the chart is added to the DOM and then resized. This
		 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
		 * to be manually imported to make this library compatible with any CSP.
		 * See https://github.com/chartjs/Chart.js/issues/5208
		 */
		disableCSSInjection: false,
	
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
	
		/**
		 * Initializes resources that depend on platform options.
		 * @param {HTMLCanvasElement} canvas - The Canvas element.
		 * @private
		 */
		_ensureLoaded: function(canvas) {
			if (!this.disableCSSInjection) {
				// If the canvas is in a shadow DOM, then the styles must also be inserted
				// into the same shadow DOM.
				// https://github.com/chartjs/Chart.js/issues/5763
				var root = canvas.getRootNode ? canvas.getRootNode() : document;
				var targetNode = root.host ? root : document.head;
				injectCSS(targetNode, stylesheet);
			}
		},
	
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}
	
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');
	
			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				// Load platform resources on first chart creation, to make it possible to
				// import the library before setting platform options.
				this._ensureLoaded(item);
				initCanvas(item, config);
				return context;
			}
	
			return null;
		},
	
		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}
	
			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers$1.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});
	
			helpers$1.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});
	
			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			// eslint-disable-next-line no-self-assign
			canvas.width = canvas.width;
	
			delete canvas[EXPANDO_KEY];
		},
	
		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};
	
			addListener(canvas, type, proxy);
		},
	
		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}
	
			removeListener(canvas, type, proxy);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.addEvent = addListener;
	
	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.removeEvent = removeListener;
	
	// @TODO Make possible to select another platform at build time.
	var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
	
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	var platform = helpers$1.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},
	
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},
	
		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},
	
		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {string} type - The ({@link IEvent}) type to listen for
		 * @param {function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},
	
		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart - Chart from which to remove the listener
		 * @param {string} type - The ({@link IEvent}) type to remove
		 * @param {function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	
	}, implementation);
	
	core_defaults._set('global', {
		plugins: {}
	});
	
	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	var core_plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],
	
		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,
	
		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},
	
		/**
		 * Returns the number of registered plugins?
		 * @returns {number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},
	
		/**
		 * Returns all registered plugin instances.
		 * @returns {IPlugin[]} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},
	
		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Chart} chart - The chart instance for which plugins should be called.
		 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;
	
			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}
	
			return true;
		},
	
		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {object[]} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart.$plugins || (chart.$plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}
	
			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};
	
			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}
	
				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}
	
				if (opts === true) {
					opts = helpers$1.clone(core_defaults.global.plugins[id]);
				}
	
				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});
	
			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		},
	
		/**
		 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
		 * but in some cases, this reference can be changed by the user when updating options.
		 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		 * @private
		 */
		_invalidate: function(chart) {
			delete chart.$plugins;
		}
	};
	
	var core_scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers
	
		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers$1.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers$1.merge({}, [core_defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers$1.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				core_layouts.addBox(chart, scale);
			});
		}
	};
	
	var valueOrDefault$8 = helpers$1.valueOrDefault;
	var getRtlHelper = helpers$1.rtl.getRtlAdapter;
	
	core_defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers$1.noop,
				title: function(tooltipItems, data) {
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
						if (item.label) {
							title = item.label;
						} else if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers$1.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers$1.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
						label += tooltipItem.value;
					} else {
						label += tooltipItem.yLabel;
					}
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers$1.noop,
				footer: helpers$1.noop,
				afterFooter: helpers$1.noop
			}
		}
	});
	
	var positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {object} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}
	
			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}
	
			return {
				x: x / count,
				y: y / count
			};
		},
	
		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {object} the position of the event in canvas coordinates
		 * @returns {object} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers$1.distanceBetweenPoints(eventPosition, center);
	
					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}
	
			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}
	
			return {
				x: x,
				y: y
			};
		}
	};
	
	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers$1.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}
	
		return base;
	}
	
	/**
	 * Returns array of strings split by newline
	 * @param {string} value - The value to split by newline.
	 * @returns {string[]} value if newline present - Returned from String split() method
	 * @function
	 */
	function splitNewlines(str) {
		if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
			return str.split('\n');
		}
		return str;
	}
	
	
	/**
	 * Private helper to create a tooltip item model
	 * @param element - the chart element (point, arc, bar) to create the tooltip item for
	 * @return new tooltip item
	 */
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;
		var controller = element._chart.getDatasetMeta(datasetIndex).controller;
		var indexScale = controller._getIndexScale();
		var valueScale = controller._getValueScale();
	
		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
			value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}
	
	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = core_defaults.global;
	
		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,
	
			// Drawing direction and text direction
			rtl: tooltipOpts.rtl,
			textDirection: tooltipOpts.textDirection,
	
			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,
	
			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,
	
			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,
	
			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}
	
	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;
	
		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;
	
		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;
	
		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};
	
		ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers$1.each(model.title, maxLineWidth);
	
		// Body width
		ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers$1.each(body, function(bodyItem) {
			helpers$1.each(bodyItem.before, maxLineWidth);
			helpers$1.each(bodyItem.lines, maxLineWidth);
			helpers$1.each(bodyItem.after, maxLineWidth);
		});
	
		// Reset back to 0
		widthPadding = 0;
	
		// Footer width
		ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers$1.each(model.footer, maxLineWidth);
	
		// Add padding
		width += 2 * model.xPadding;
	
		return {
			width: width,
			height: height
		};
	}
	
	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';
	
		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}
	
		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;
	
		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}
	
		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};
	
		if (lf(model.x)) {
			xAlign = 'left';
	
			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';
	
			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}
	
		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}
	
	/**
	 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;
	
		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;
	
		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}
	
		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}
	
		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}
	
		return {
			x: x,
			y: y
		};
	}
	
	function getAlignedX(vm, align) {
		return align === 'center'
			? vm.x + vm.width / 2
			: align === 'right'
				? vm.x + vm.width - vm.xPadding
				: vm.x + vm.xPadding;
	}
	
	/**
	 * Helper to build before and after body lines
	 */
	function getBeforeAfterBodyLines(callback) {
		return pushOrConcat([], splitNewlines(callback));
	}
	
	var exports$4 = core_element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},
	
		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;
	
			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeTitle));
			lines = pushOrConcat(lines, splitNewlines(title));
			lines = pushOrConcat(lines, splitNewlines(afterTitle));
	
			return lines;
		},
	
		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
		},
	
		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];
	
			helpers$1.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
	
				bodyItems.push(bodyItem);
			});
	
			return bodyItems;
		},
	
		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
		},
	
		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;
	
			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeFooter));
			lines = pushOrConcat(lines, splitNewlines(footer));
			lines = pushOrConcat(lines, splitNewlines(afterFooter));
	
			return lines;
		},
	
		update: function(changed) {
			var me = this;
			var opts = me._options;
	
			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;
	
			var data = me._data;
	
			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};
	
			var i, len;
	
			if (active.length) {
				model.opacity = 1;
	
				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
	
				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}
	
				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}
	
				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}
	
				// Determine colors for boxes
				helpers$1.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});
	
	
				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);
	
				// Initial positioning and colors
				model.x = tooltipPosition.x;
				model.y = tooltipPosition.y;
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;
	
				// data points
				model.dataPoints = tooltipItems;
	
				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}
	
			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;
	
			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;
	
			me._model = model;
	
			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}
	
			return me;
		},
	
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;
	
			if (yAlign === 'center') {
				y2 = ptY + (height / 2);
	
				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;
	
					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;
	
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
	
		drawTitle: function(pt, vm, ctx) {
			var title = vm.title;
			var length = title.length;
			var titleFontSize, titleSpacing, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._titleAlign);
	
				ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
				ctx.textBaseline = 'middle';
	
				titleFontSize = vm.titleFontSize;
				titleSpacing = vm.titleSpacing;
	
				ctx.fillStyle = vm.titleFontColor;
				ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
					if (i + 1 === length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
	
		drawBody: function(pt, vm, ctx) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var bodyAlign = vm._bodyAlign;
			var body = vm.body;
			var drawColorBoxes = vm.displayColors;
			var xLinePadding = 0;
			var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
	
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
			var fillLineOfText = function(line) {
				ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
				pt.y += bodyFontSize + bodySpacing;
			};
	
			var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
			var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
	
			ctx.textAlign = bodyAlign;
			ctx.textBaseline = 'middle';
			ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
			pt.x = getAlignedX(vm, bodyAlignForCalculation);
	
			// Before body lines
			ctx.fillStyle = vm.bodyFontColor;
			helpers$1.each(vm.beforeBody, fillLineOfText);
	
			xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
				? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
				: 0;
	
			// Draw body lines now
			for (i = 0, ilen = body.length; i < ilen; ++i) {
				bodyItem = body[i];
				textColor = vm.labelTextColors[i];
				labelColors = vm.labelColors[i];
	
				ctx.fillStyle = textColor;
				helpers$1.each(bodyItem.before, fillLineOfText);
	
				lines = bodyItem.lines;
				for (j = 0, jlen = lines.length; j < jlen; ++j) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						var rtlColorX = rtlHelper.x(colorX);
	
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = vm.legendColorBackground;
						ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = labelColors.borderColor;
						ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Inner square
						ctx.fillStyle = labelColors.backgroundColor;
						ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}
	
					fillLineOfText(lines[j]);
				}
	
				helpers$1.each(bodyItem.after, fillLineOfText);
			}
	
			// Reset back to 0 for after body
			xLinePadding = 0;
	
			// After body lines
			helpers$1.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
	
		drawFooter: function(pt, vm, ctx) {
			var footer = vm.footer;
			var length = footer.length;
			var footerFontSize, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._footerAlign);
				pt.y += vm.footerMarginTop;
	
				ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
				ctx.textBaseline = 'middle';
	
				footerFontSize = vm.footerFontSize;
	
				ctx.fillStyle = vm.footerFontColor;
				ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
					pt.y += footerFontSize + vm.footerSpacing;
				}
			}
		},
	
		drawBackground: function(pt, vm, ctx, tooltipSize) {
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;
	
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
	
			ctx.fill();
	
			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
	
			if (vm.opacity === 0) {
				return;
			}
	
			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};
	
			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
			if (this._options.enabled && hasTooltipContent) {
				ctx.save();
				ctx.globalAlpha = opacity;
	
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize);
	
				// Draw Title, Body, and Footer
				pt.y += vm.yPadding;
	
				helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
	
				// Titles
				this.drawTitle(pt, vm, ctx);
	
				// Body
				this.drawBody(pt, vm, ctx);
	
				// Footer
				this.drawFooter(pt, vm, ctx);
	
				helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
	
				ctx.restore();
			}
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;
	
			me._lastActive = me._lastActive || [];
	
			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				if (options.reverse) {
					me._active.reverse();
				}
			}
	
			// Remember Last Actives
			changed = !helpers$1.arrayEquals(me._active, me._lastActive);
	
			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					me.update(true);
					me.pivot();
				}
			}
	
			return changed;
		}
	});
	
	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	var positioners_1 = positioners;
	
	var core_tooltip = exports$4;
	core_tooltip.positioners = positioners_1;
	
	var valueOrDefault$9 = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		elements: {},
		events: [
			'mousemove',
			'mouseout',
			'click',
			'touchstart',
			'touchmove'
		],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		maintainAspectRatio: true,
		responsive: true,
		responsiveAnimationDuration: 0
	});
	
	/**
	 * Recursively merge the given config objects representing the `scales` option
	 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
	 * returns a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeScaleConfig(/* config objects ... */) {
		return helpers$1.merge({}, [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;
	
					if (!target[key]) {
						target[key] = [];
					}
	
					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
	
						if (i >= target[key].length) {
							target[key].push({});
						}
	
						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers$1.merge(target[key][i], scale);
						}
					}
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	/**
	 * Recursively merge the given config objects as the root options by handling
	 * default scale options for the `scales` and `scale` properties, then returns
	 * a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeConfig(/* config objects ... */) {
		return helpers$1.merge({}, [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				var tval = target[key] || {};
				var sval = source[key];
	
				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = mergeScaleConfig(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	function initConfig(config) {
		config = config || {};
	
		// Do NOT use mergeConfig for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];
	
		config.options = mergeConfig(
			core_defaults.global,
			core_defaults[config.type],
			config.options || {});
	
		return config;
	}
	
	function updateConfig(chart) {
		var newOptions = chart.options;
	
		helpers$1.each(chart.scales, function(scale) {
			core_layouts.removeBox(chart, scale);
		});
	
		newOptions = mergeConfig(
			core_defaults.global,
			core_defaults[chart.config.type],
			newOptions);
	
		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();
	
		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}
	
	function nextAvailableScaleId(axesOpts, prefix, index) {
		var id;
		var hasId = function(obj) {
			return obj.id === id;
		};
	
		do {
			id = prefix + index++;
		} while (helpers$1.findIndex(axesOpts, hasId) >= 0);
	
		return id;
	}
	
	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}
	
	function compare2Level(l1, l2) {
		return function(a, b) {
			return a[l1] === b[l1]
				? a[l2] - b[l2]
				: a[l1] - b[l1];
		};
	}
	
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};
	
	helpers$1.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;
	
			config = initConfig(config);
	
			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;
	
			me.id = helpers$1.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;
			me._layers = [];
	
			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception
	
			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;
	
			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});
	
			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}
	
			me.initialize();
			me.update();
		},
	
		/**
		 * @private
		 */
		initialize: function() {
			var me = this;
	
			// Before init plugin notification
			core_plugins.notify(me, 'beforeInit');
	
			helpers$1.retinaScale(me, me.options.devicePixelRatio);
	
			me.bindEvents();
	
			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}
	
			me.initToolTip();
	
			// After init plugin notification
			core_plugins.notify(me, 'afterInit');
	
			return me;
		},
	
		clear: function() {
			helpers$1.canvas.clear(this);
			return this;
		},
	
		stop: function() {
			// Stops any current animation loop occurring
			core_animations.cancelAnimation(this);
			return this;
		},
	
		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.
	
			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
			var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
	
			if (me.width === newWidth && me.height === newHeight) {
				return;
			}
	
			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';
	
			helpers$1.retinaScale(me, options.devicePixelRatio);
	
			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				core_plugins.notify(me, 'resize', [newSize]);
	
				// Notify of resize
				if (options.onResize) {
					options.onResize(me, newSize);
				}
	
				me.stop();
				me.update({
					duration: options.responsiveAnimationDuration
				});
			}
		},
	
		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;
	
			helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				if (!xAxisOptions.id) {
					xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
				}
			});
	
			helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				if (!yAxisOptions.id) {
					yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
				}
			});
	
			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},
	
		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});
	
			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}
	
			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}
	
			helpers$1.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
	
				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}
	
				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = core_scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}
	
				scale.mergeTicksOptions();
	
				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers$1.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});
	
			me.scales = scales;
	
			core_scaleService.addScalesToLayout(this);
		},
	
		buildOrUpdateControllers: function() {
			var me = this;
			var newControllers = [];
			var datasets = me.data.datasets;
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				var dataset = datasets[i];
				var meta = me.getDatasetMeta(i);
				var type = dataset.type || me.config.type;
	
				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(i);
					meta = me.getDatasetMeta(i);
				}
				meta.type = type;
				meta.order = dataset.order || 0;
				meta.index = i;
	
				if (meta.controller) {
					meta.controller.updateIndex(i);
					meta.controller.linkScales();
				} else {
					var ControllerClass = controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}
	
					meta.controller = new ControllerClass(me, i);
					newControllers.push(meta.controller);
				}
			}
	
			return newControllers;
		},
	
		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},
	
		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},
	
		update: function(config) {
			var me = this;
			var i, ilen;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			updateConfig(me);
	
			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			core_plugins._invalidate(me);
	
			if (core_plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}
	
			// In case the entire data object changed
			me.tooltip._data = me.data;
	
			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();
	
			// Make sure all dataset controllers have correct meta data counts
			for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
				me.getDatasetMeta(i).controller.buildOrUpdateElements();
			}
	
			me.updateLayout();
	
			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers$1.each(newControllers, function(controller) {
					controller.reset();
				});
			}
	
			me.updateDatasets();
	
			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();
	
			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];
	
			// Do this before render so that any plugins that need final scale updates can use it
			core_plugins.notify(me, 'afterUpdate');
	
			me._layers.sort(compare2Level('z', '_idx'));
	
			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},
	
		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeLayout') === false) {
				return;
			}
	
			core_layouts.update(this, this.width, this.height);
	
			me._layers = [];
			helpers$1.each(me.boxes, function(box) {
				// _configure is called twice, once in core.scale.update and once here.
				// Here the boxes are fully updated and at their final positions.
				if (box._configure) {
					box._configure();
				}
				me._layers.push.apply(me._layers, box._layers());
			}, me);
	
			me._layers.forEach(function(item, index) {
				item._idx = index;
			});
	
			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			core_plugins.notify(me, 'afterScaleUpdate');
			core_plugins.notify(me, 'afterLayout');
		},
	
		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}
	
			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}
	
			core_plugins.notify(me, 'afterDatasetsUpdate');
		},
	
		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};
	
			if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}
	
			meta.controller._update();
	
			core_plugins.notify(me, 'afterDatasetUpdate', [args]);
		},
	
		render: function(config) {
			var me = this;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			var animationOptions = me.options.animation;
			var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
			var lazy = config.lazy;
	
			if (core_plugins.notify(me, 'beforeRender') === false) {
				return;
			}
	
			var onComplete = function(animation) {
				core_plugins.notify(me, 'afterRender');
				helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};
	
			if (animationOptions && duration) {
				var animation = new core_animation({
					numSteps: duration / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,
	
					render: function(chart, animationObject) {
						var easingFunction = helpers$1.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;
	
						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},
	
					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});
	
				core_animations.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();
	
				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new core_animation({numSteps: 0, chart: me}));
			}
	
			return me;
		},
	
		draw: function(easingValue) {
			var me = this;
			var i, layers;
	
			me.clear();
	
			if (helpers$1.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}
	
			me.transition(easingValue);
	
			if (me.width <= 0 || me.height <= 0) {
				return;
			}
	
			if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}
	
			// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
			// currently be part of layers. Instead, we draw
			// layers <= 0 before(default, backward compat), and the rest after
			layers = me._layers;
			for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me.drawDatasets(easingValue);
	
			// Rest of layers
			for (; i < layers.length; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me._drawTooltip(easingValue);
	
			core_plugins.notify(me, 'afterDraw', [easingValue]);
		},
	
		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;
	
			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}
	
			me.tooltip.transition(easingValue);
		},
	
		/**
		 * @private
		 */
		_getSortedDatasetMetas: function(filterVisible) {
			var me = this;
			var datasets = me.data.datasets || [];
			var result = [];
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; ++i) {
				if (!filterVisible || me.isDatasetVisible(i)) {
					result.push(me.getDatasetMeta(i));
				}
			}
	
			result.sort(compare2Level('order', 'index'));
	
			return result;
		},
	
		/**
		 * @private
		 */
		_getSortedVisibleDatasetMetas: function() {
			return this._getSortedDatasetMetas(true);
		},
	
		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;
			var metasets, i;
	
			if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}
	
			metasets = me._getSortedVisibleDatasetMetas();
			for (i = metasets.length - 1; i >= 0; --i) {
				me.drawDataset(metasets[i], easingValue);
			}
	
			core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},
	
		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(meta, easingValue) {
			var me = this;
			var args = {
				meta: meta,
				index: meta.index,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}
	
			meta.controller.draw(easingValue);
	
			core_plugins.notify(me, 'afterDatasetDraw', [args]);
		},
	
		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}
	
			tooltip.draw();
	
			core_plugins.notify(me, 'afterTooltipDraw', [args]);
		},
	
		/**
		 * Get the single element that was clicked on
		 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		 */
		getElementAtEvent: function(e) {
			return core_interaction.modes.single(this, e);
		},
	
		getElementsAtEvent: function(e) {
			return core_interaction.modes.label(this, e, {intersect: true});
		},
	
		getElementsAtXAxis: function(e) {
			return core_interaction.modes['x-axis'](this, e, {intersect: true});
		},
	
		getElementsAtEventForMode: function(e, mode, options) {
			var method = core_interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}
	
			return [];
		},
	
		getDatasetAtEvent: function(e) {
			return core_interaction.modes.dataset(this, e, {intersect: true});
		},
	
		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}
	
			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null,
					order: dataset.order || 0,
					index: datasetIndex
				};
			}
	
			return meta;
		},
	
		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},
	
		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);
	
			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},
	
		generateLegend: function() {
			return this.options.legendCallback(this);
		},
	
		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];
	
			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},
	
		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;
	
			me.stop();
	
			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}
	
			if (canvas) {
				me.unbindEvents();
				helpers$1.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}
	
			core_plugins.notify(me, 'destroy');
	
			delete Chart.instances[me.id];
		},
	
		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},
	
		initToolTip: function() {
			var me = this;
			me.tooltip = new core_tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},
	
		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};
	
			helpers$1.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});
	
			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};
	
				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},
	
		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}
	
			delete me._listeners;
			helpers$1.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},
	
		updateHoverStyle: function(elements, mode, enabled) {
			var prefix = enabled ? 'set' : 'remove';
			var element, i, ilen;
	
			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
				}
			}
	
			if (mode === 'dataset') {
				this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
			}
		},
	
		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;
	
			if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}
	
			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;
	
			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}
	
			core_plugins.notify(me, 'afterEvent', [e]);
	
			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();
	
				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render({
					duration: me.options.hover.animationDuration,
					lazy: true
				});
			}
	
			me._bufferedRender = false;
			me._bufferedRequest = null;
	
			return me;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;
	
			me.lastActive = me.lastActive || [];
	
			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}
	
			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);
	
			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}
	
			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}
	
			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}
	
			changed = !helpers$1.arrayEquals(me.active, me.lastActive);
	
			// Remember Last Actives
			me.lastActive = me.active;
	
			return changed;
		}
	});
	
	/**
	 * NOTE(SB) We actually don't use this container anymore but we need to keep it
	 * for backward compatibility. Though, it can still be useful for plugins that
	 * would need to work on multiple charts?!
	 */
	Chart.instances = {};
	
	var core_controller = Chart;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	Chart.types = {};
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.configMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.configMerge = mergeConfig;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.scaleMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.scaleMerge = mergeScaleConfig;
	
	var core_helpers = function() {
	
		// -- Basic js utility methods
	
		helpers$1.where = function(collection, filterCallback) {
			if (helpers$1.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers$1.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers$1.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
	
		// -- Math methods
		helpers$1.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers$1.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers$1.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
		};
		helpers$1.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers$1.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers$1.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers$1.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers$1.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
	
		/**
		 * Returns the number of decimal places
		 * i.e. the number of digits after the decimal point, of the value of this Number.
		 * @param {number} x - A number.
		 * @returns {number} The number of decimal places.
		 * @private
		 */
		helpers$1._decimalPlaces = function(x) {
			if (!helpers$1.isFinite(x)) {
				return;
			}
			var e = 1;
			var p = 0;
			while (Math.round(x * e) / e !== x) {
				e *= 10;
				p++;
			}
			return p;
		};
	
		// Gets the angle from vertical upright to the point about a centre.
		helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers$1.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.helpers.aliasPixel
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		helpers$1.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
	
		/**
		 * Returns the aligned pixel value to avoid anti-aliasing blur
		 * @param {Chart} chart - The chart instance.
		 * @param {number} pixel - A pixel value.
		 * @param {number} width - The width of the element.
		 * @returns {number} The aligned pixel value.
		 * @private
		 */
		helpers$1._alignPixel = function(chart, pixel, width) {
			var devicePixelRatio = chart.currentDevicePixelRatio;
			var halfWidth = width / 2;
			return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
		};
	
		helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers$1.EPSILON = Number.EPSILON || 1e-14;
		helpers$1.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers$1.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers$1.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers$1.niceNum = function(range, round) {
			var exponent = Math.floor(helpers$1.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers$1.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers$1.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.target || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		/**
		 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
		 * @param {HTMLElement} domNode - the node to check the constraint on
		 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
		 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
		 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
		 */
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = helpers$1._getParentNode(domNode);
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers$1.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers$1.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		/**
		 * @private
	 	 */
		helpers$1._calculatePadding = function(container, padding, parentDimension) {
			padding = helpers$1.getStyle(container, padding);
	
			return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
		};
		/**
		 * @private
		 */
		helpers$1._getParentNode = function(domNode) {
			var parent = domNode.parentNode;
			if (parent && parent.toString() === '[object ShadowRoot]') {
				parent = parent.host;
			}
			return parent;
		};
		helpers$1.getMaximumWidth = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientWidth;
			}
	
			var clientWidth = container.clientWidth;
			var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
			var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
	
			var w = clientWidth - paddingLeft - paddingRight;
			var cw = helpers$1.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers$1.getMaximumHeight = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientHeight;
			}
	
			var clientHeight = container.clientHeight;
			var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
			var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
	
			var h = clientHeight - paddingTop - paddingBottom;
			var ch = helpers$1.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers$1.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers$1.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			if (!canvas.style.height && !canvas.style.width) {
				canvas.style.height = height + 'px';
				canvas.style.width = width + 'px';
			}
		};
		// -- Canvas methods
		helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			var ilen = arrayOfThings.length;
			var i, j, jlen, thing, nestedThing;
			for (i = 0; i < ilen; i++) {
				thing = arrayOfThings[i];
	
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
					longest = helpers$1.measureText(ctx, data, gc, longest, thing);
				} else if (helpers$1.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					for (j = 0, jlen = thing.length; j < jlen; j++) {
						nestedThing = thing[j];
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
							longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
						}
					}
				}
			}
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers$1.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
	
		/**
		 * @deprecated
		 */
		helpers$1.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers$1.each(arrayOfThings, function(thing) {
				if (helpers$1.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
	
		helpers$1.color = !chartjsColor ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = core_defaults.global.defaultColor;
				}
	
				return chartjsColor(value);
			};
	
		helpers$1.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
				colorValue :
				helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};
	
	function abstract() {
		throw new Error(
			'This method is not implemented: either no adapter can ' +
			'be found or an incomplete integration was provided.'
		);
	}
	
	/**
	 * Date adapter (current used by the time scale)
	 * @namespace Chart._adapters._date
	 * @memberof Chart._adapters
	 * @private
	 */
	
	/**
	 * Currently supported unit string values.
	 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
	 * @memberof Chart._adapters._date
	 * @name Unit
	 */
	
	/**
	 * @class
	 */
	function DateAdapter(options) {
		this.options = options || {};
	}
	
	helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
		/**
		 * Returns a map of time formats for the supported formatting units defined
		 * in Unit as well as 'datetime' representing a detailed date/time string.
		 * @returns {{string: string}}
		 */
		formats: abstract,
	
		/**
		 * Parses the given `value` and return the associated timestamp.
		 * @param {any} value - the value to parse (usually comes from the data)
		 * @param {string} [format] - the expected data format
		 * @returns {(number|null)}
		 * @function
		 */
		parse: abstract,
	
		/**
		 * Returns the formatted date in the specified `format` for a given `timestamp`.
		 * @param {number} timestamp - the timestamp to format
		 * @param {string} format - the date/time token
		 * @return {string}
		 * @function
		 */
		format: abstract,
	
		/**
		 * Adds the specified `amount` of `unit` to the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {number} amount - the amount to add
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		add: abstract,
	
		/**
		 * Returns the number of `unit` between the given timestamps.
		 * @param {number} max - the input timestamp (reference)
		 * @param {number} min - the timestamp to substract
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		diff: abstract,
	
		/**
		 * Returns start of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
		 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
		 * @function
		 */
		startOf: abstract,
	
		/**
		 * Returns end of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @function
		 */
		endOf: abstract,
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility for scale.getValueForPixel(),
		 * this method should be overridden only by the moment adapter.
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(value) {
			return value;
		}
	});
	
	DateAdapter.override = function(members) {
		helpers$1.extend(DateAdapter.prototype, members);
	};
	
	var _date = DateAdapter;
	
	var core_adapters = {
		_date: _date
	};
	
	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	var core_ticks = {
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {string|string[]} the label to display
			 */
			values: function(value) {
				return helpers$1.isArray(value) ? value : '' + value;
			},
	
			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {number} the value to be formatted
			 * @param index {number} the position of the tickValue parameter in the ticks array
			 * @param ticks {number[]} the list of ticks being converted
			 * @return {string} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}
	
				var logDelta = helpers$1.log10(Math.abs(delta));
				var tickString = '';
	
				if (tickValue !== 0) {
					var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
					if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
						var logTick = helpers$1.log10(Math.abs(tickValue));
						var numExponential = Math.floor(logTick) - Math.floor(logDelta);
						numExponential = Math.max(Math.min(numExponential, 20), 0);
						tickString = tickValue.toExponential(numExponential);
					} else {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					}
				} else {
					tickString = '0'; // never show decimal places for 0
				}
	
				return tickString;
			},
	
			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));
	
				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};
	
	var isArray = helpers$1.isArray;
	var isNullOrUndef = helpers$1.isNullOrUndef;
	var valueOrDefault$a = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
	
	core_defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,
	
		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		// scale label
		scaleLabel: {
			// display property
			display: false,
	
			// actual label
			labelString: '',
	
			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},
	
		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: core_ticks.formatters.values,
			minor: {},
			major: {}
		}
	});
	
	/** Returns a new array containing numItems from arr */
	function sample(arr, numItems) {
		var result = [];
		var increment = arr.length / numItems;
		var i = 0;
		var len = arr.length;
	
		for (; i < len; i += increment) {
			result.push(arr[Math.floor(i)]);
		}
		return result;
	}
	
	function getPixelForGridLine(scale, index, offsetGridLines) {
		var length = scale.getTicks().length;
		var validIndex = Math.min(index, length - 1);
		var lineValue = scale.getPixelForTick(validIndex);
		var start = scale._startPixel;
		var end = scale._endPixel;
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
		var offset;
	
		if (offsetGridLines) {
			if (length === 1) {
				offset = Math.max(lineValue - start, end - lineValue);
			} else if (index === 0) {
				offset = (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
			}
			lineValue += validIndex < index ? offset : -offset;
	
			// Return undefined if the pixel is out of the range
			if (lineValue < start - epsilon || lineValue > end + epsilon) {
				return;
			}
		}
		return lineValue;
	}
	
	function garbageCollect(caches, length) {
		helpers$1.each(caches, function(cache) {
			var gc = cache.gc;
			var gcLen = gc.length / 2;
			var i;
			if (gcLen > length) {
				for (i = 0; i < gcLen; ++i) {
					delete cache.data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
		});
	}
	
	/**
	 * Returns {width, height, offset} objects for the first, last, widest, highest tick
	 * labels where offset indicates the anchor point offset from the top in pixels.
	 */
	function computeLabelSizes(ctx, tickFonts, ticks, caches) {
		var length = ticks.length;
		var widths = [];
		var heights = [];
		var offsets = [];
		var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
	
		for (i = 0; i < length; ++i) {
			label = ticks[i].label;
			tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
			ctx.font = fontString = tickFont.string;
			cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
			lineHeight = tickFont.lineHeight;
			width = height = 0;
			// Undefined labels and arrays should not be measured
			if (!isNullOrUndef(label) && !isArray(label)) {
				width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
				height = lineHeight;
			} else if (isArray(label)) {
				// if it is an array let's measure each element
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					nestedLabel = label[j];
					// Undefined labels and arrays should not be measured
					if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
						width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
						height += lineHeight;
					}
				}
			}
			widths.push(width);
			heights.push(height);
			offsets.push(lineHeight / 2);
		}
		garbageCollect(caches, length);
	
		widest = widths.indexOf(Math.max.apply(null, widths));
		highest = heights.indexOf(Math.max.apply(null, heights));
	
		function valueAt(idx) {
			return {
				width: widths[idx] || 0,
				height: heights[idx] || 0,
				offset: offsets[idx] || 0
			};
		}
	
		return {
			first: valueAt(0),
			last: valueAt(length - 1),
			widest: valueAt(widest),
			highest: valueAt(highest)
		};
	}
	
	function getTickMarkLength(options) {
		return options.drawTicks ? options.tickMarkLength : 0;
	}
	
	function getScaleLabelHeight(options) {
		var font, padding;
	
		if (!options.display) {
			return 0;
		}
	
		font = helpers$1.options._parseFont(options);
		padding = helpers$1.options.toPadding(options.padding);
	
		return font.lineHeight + padding.height;
	}
	
	function parseFontOptions(options, nestedOpts) {
		return helpers$1.extend(helpers$1.options._parseFont({
			fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
			fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
			fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
			lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
		}), {
			color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
		});
	}
	
	function parseTickFontOptions(options) {
		var minor = parseFontOptions(options, options.minor);
		var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
	
		return {minor: minor, major: major};
	}
	
	function nonSkipped(ticksToFilter) {
		var filtered = [];
		var item, index, len;
		for (index = 0, len = ticksToFilter.length; index < len; ++index) {
			item = ticksToFilter[index];
			if (typeof item._index !== 'undefined') {
				filtered.push(item);
			}
		}
		return filtered;
	}
	
	function getEvenSpacing(arr) {
		var len = arr.length;
		var i, diff;
	
		if (len < 2) {
			return false;
		}
	
		for (diff = arr[0], i = 1; i < len; ++i) {
			if (arr[i] - arr[i - 1] !== diff) {
				return false;
			}
		}
		return diff;
	}
	
	function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
		var evenMajorSpacing = getEvenSpacing(majorIndices);
		var spacing = (ticks.length - 1) / ticksLimit;
		var factors, factor, i, ilen;
	
		// If the major ticks are evenly spaced apart, place the minor ticks
		// so that they divide the major ticks into even chunks
		if (!evenMajorSpacing) {
			return Math.max(spacing, 1);
		}
	
		factors = helpers$1.math._factorize(evenMajorSpacing);
		for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
			factor = factors[i];
			if (factor > spacing) {
				return factor;
			}
		}
		return Math.max(spacing, 1);
	}
	
	function getMajorIndices(ticks) {
		var result = [];
		var i, ilen;
		for (i = 0, ilen = ticks.length; i < ilen; i++) {
			if (ticks[i].major) {
				result.push(i);
			}
		}
		return result;
	}
	
	function skipMajors(ticks, majorIndices, spacing) {
		var count = 0;
		var next = majorIndices[0];
		var i, tick;
	
		spacing = Math.ceil(spacing);
		for (i = 0; i < ticks.length; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = majorIndices[count * spacing];
			} else {
				delete tick.label;
			}
		}
	}
	
	function skip(ticks, spacing, majorStart, majorEnd) {
		var start = valueOrDefault$a(majorStart, 0);
		var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
		var count = 0;
		var length, i, tick, next;
	
		spacing = Math.ceil(spacing);
		if (majorEnd) {
			length = majorEnd - majorStart;
			spacing = length / Math.floor(length / spacing);
		}
	
		next = start;
	
		while (next < 0) {
			count++;
			next = Math.round(start + count * spacing);
		}
	
		for (i = Math.max(start, 0); i < end; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = Math.round(start + count * spacing);
			} else {
				delete tick.label;
			}
		}
	}
	
	var Scale = core_element.extend({
	
		zeroLineIndex: 0,
	
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},
	
		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},
	
		/**
		* @private
		*/
		_getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
		},
	
		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.Scale.mergeTicksOptions
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		mergeTicksOptions: function() {
			// noop
		},
	
		beforeUpdate: function() {
			helpers$1.callback(this.options.beforeUpdate, [this]);
		},
	
		/**
		 * @param {number} maxWidth - the max width in pixels
		 * @param {number} maxHeight - the max height in pixels
		 * @param {object} margins - the space between the edge of the other scales and edge of the chart
		 *   This space comes from two sources:
		 *     - padding - space that's required to show the labels at the edges of the scale
		 *     - thickness of scales or legends in another orientation
		 */
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var tickOpts = me.options.ticks;
			var sampleSize = tickOpts.sampleSize;
			var i, ilen, labels, ticks, samplingEnabled;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers$1.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
	
			me._ticks = null;
			me.ticks = null;
			me._labelSizes = null;
			me._maxLabelLines = 0;
			me.longestLabelWidth = 0;
			me.longestTextCache = me.longestTextCache || {};
			me._gridLineItems = null;
			me._labelItems = null;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
	
			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();
	
			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.
	
			me.beforeBuildTicks();
	
			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];
	
			// Allow modification of ticks in callback.
			ticks = me.afterBuildTicks(ticks) || ticks;
	
			// Ensure ticks contains ticks in new tick format
			if ((!ticks || !ticks.length) && me.ticks) {
				ticks = [];
				for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
					ticks.push({
						value: me.ticks[i],
						major: false
					});
				}
			}
	
			me._ticks = ticks;
	
			// Compute tick rotation and fit using a sampled subset of labels
			// We generally don't need to compute the size of every single label for determining scale size
			samplingEnabled = sampleSize < ticks.length;
			labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
	
			// _configure is called twice, once here, once from core.controller.updateLayout.
			// Here we haven't been positioned yet, but dimensions are correct.
			// Variables set in _configure are needed for calculateTickRotation, and
			// it's ok that coordinates are not correct there, only dimensions matter.
			me._configure();
	
			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
	
			me.beforeFit();
			me.fit();
			me.afterFit();
	
			// Auto-skip
			me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
	
			if (samplingEnabled) {
				// Generate labels using all non-skipped ticks
				labels = me._convertTicksToLabels(me._ticksToDraw);
			}
	
			me.ticks = labels;   // BACKWARD COMPATIBILITY
	
			// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
	
			me.afterUpdate();
	
			// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
			// make maxWidth and maxHeight private
			return me.minSize;
		},
	
		/**
		 * @private
		 */
		_configure: function() {
			var me = this;
			var reversePixels = me.options.ticks.reverse;
			var startPixel, endPixel;
	
			if (me.isHorizontal()) {
				startPixel = me.left;
				endPixel = me.right;
			} else {
				startPixel = me.top;
				endPixel = me.bottom;
				// by default vertical scales are from bottom to top, so pixels are reversed
				reversePixels = !reversePixels;
			}
			me._startPixel = startPixel;
			me._endPixel = endPixel;
			me._reversePixels = reversePixels;
			me._length = endPixel - startPixel;
		},
	
		afterUpdate: function() {
			helpers$1.callback(this.options.afterUpdate, [this]);
		},
	
		//
	
		beforeSetDimensions: function() {
			helpers$1.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers$1.callback(this.options.afterSetDimensions, [this]);
		},
	
		// Data limits
		beforeDataLimits: function() {
			helpers$1.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers$1.noop,
		afterDataLimits: function() {
			helpers$1.callback(this.options.afterDataLimits, [this]);
		},
	
		//
		beforeBuildTicks: function() {
			helpers$1.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers$1.noop,
		afterBuildTicks: function(ticks) {
			var me = this;
			// ticks is empty for old axis implementations here
			if (isArray(ticks) && ticks.length) {
				return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
			}
			// Support old implementations (that modified `this.ticks` directly in buildTicks)
			me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
			return ticks;
		},
	
		beforeTickToLabelConversion: function() {
			helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
		},
	
		//
	
		beforeCalculateTickRotation: function() {
			helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var options = me.options;
			var tickOpts = options.ticks;
			var numTicks = me.getTicks().length;
			var minRotation = tickOpts.minRotation || 0;
			var maxRotation = tickOpts.maxRotation;
			var labelRotation = minRotation;
			var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
	
			if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
				me.labelRotation = minRotation;
				return;
			}
	
			labelSizes = me._getLabelSizes();
			maxLabelWidth = labelSizes.widest.width;
			maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
	
			// Estimate the width of each grid based on the canvas width, the maximum
			// label width and the number of tick intervals
			maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
			tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
	
			// Allow 3 pixels x2 padding either side for label readability
			if (maxLabelWidth + 6 > tickWidth) {
				tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
				maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
					- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
				maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
				labelRotation = helpers$1.toDegrees(Math.min(
					Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
					Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
				));
				labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
			}
	
			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
		},
	
		//
	
		beforeFit: function() {
			helpers$1.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};
	
			var chart = me.chart;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = me._isVisible();
			var isBottom = opts.position === 'bottom';
			var isHorizontal = me.isHorizontal();
	
			// Width
			if (isHorizontal) {
				minSize.width = me.maxWidth;
			} else if (display) {
				minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// height
			if (!isHorizontal) {
				minSize.height = me.maxHeight; // fill all the height
			} else if (display) {
				minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// Don't bother fitting the ticks if we are not showing the labels
			if (tickOpts.display && display) {
				var tickFonts = parseTickFontOptions(tickOpts);
				var labelSizes = me._getLabelSizes();
				var firstLabelSize = labelSizes.first;
				var lastLabelSize = labelSizes.last;
				var widestLabelSize = labelSizes.widest;
				var highestLabelSize = labelSizes.highest;
				var lineSpace = tickFonts.minor.lineHeight * 0.4;
				var tickPadding = tickOpts.padding;
	
				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					var isRotated = me.labelRotation !== 0;
					var angleRadians = helpers$1.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);
	
					var labelHeight = sinRotation * widestLabelSize.width
						+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
						+ (isRotated ? 0 : lineSpace); // padding
	
					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
	
					var offsetLeft = me.getPixelForTick(0) - me.left;
					var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
					var paddingLeft, paddingRight;
	
					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (isRotated) {
						paddingLeft = isBottom ?
							cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
							sinRotation * (firstLabelSize.height - firstLabelSize.offset);
						paddingRight = isBottom ?
							sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
							cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
					} else {
						paddingLeft = firstLabelSize.width / 2;
						paddingRight = lastLabelSize.width / 2;
					}
	
					// Adjust padding taking into account changes in offsets
					// and add 3 px to move away from canvas edges
					me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
					me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					var labelWidth = tickOpts.mirror ? 0 :
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						widestLabelSize.width + tickPadding + lineSpace;
	
					minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
	
					me.paddingTop = firstLabelSize.height / 2;
					me.paddingBottom = lastLabelSize.height / 2;
				}
			}
	
			me.handleMargins();
	
			if (isHorizontal) {
				me.width = me._length = chart.width - me.margins.left - me.margins.right;
				me.height = minSize.height;
			} else {
				me.width = minSize.width;
				me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
			}
		},
	
		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.margins.left = Math.max(me.paddingLeft, me.margins.left);
				me.margins.top = Math.max(me.paddingTop, me.margins.top);
				me.margins.right = Math.max(me.paddingRight, me.margins.right);
				me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
			}
		},
	
		afterFit: function() {
			helpers$1.callback(this.options.afterFit, [this]);
		},
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
		isFullWidth: function() {
			return this.options.fullWidth;
		},
	
		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
				return NaN;
			}
	
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}
	
			// Value is good, return it
			return rawValue;
		},
	
		_convertTicksToLabels: function(ticks) {
			var me = this;
			var labels, i, ilen;
	
			me.ticks = ticks.map(function(tick) {
				return tick.value;
			});
	
			me.beforeTickToLabelConversion();
	
			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;
	
			me.afterTickToLabelConversion();
	
			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				ticks[i].label = labels[i];
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		_getLabelSizes: function() {
			var me = this;
			var labelSizes = me._labelSizes;
	
			if (!labelSizes) {
				me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
				me.longestLabelWidth = labelSizes.widest.width;
			}
	
			return labelSizes;
		},
	
		/**
		 * @private
		 */
		_parseValue: function(value) {
			var start, end, min, max;
	
			if (isArray(value)) {
				start = +this.getRightValue(value[0]);
				end = +this.getRightValue(value[1]);
				min = Math.min(start, end);
				max = Math.max(start, end);
			} else {
				value = +this.getRightValue(value);
				start = undefined;
				end = value;
				min = value;
				max = value;
			}
	
			return {
				min: min,
				max: max,
				start: start,
				end: end
			};
		},
	
		/**
		* @private
		*/
		_getScaleLabel: function(rawValue) {
			var v = this._parseValue(rawValue);
			if (v.start !== undefined) {
				return '[' + v.start + ', ' + v.end + ']';
			}
	
			return +this.getRightValue(rawValue);
		},
	
		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers$1.noop,
	
		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers$1.noop,
	
		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers$1.noop,
	
		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			var numTicks = me._ticks.length;
			var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
	
			return index < 0 || index > numTicks - 1
				? null
				: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
		},
	
		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
	
			if (me._reversePixels) {
				decimal = 1 - decimal;
			}
	
			return me._startPixel + decimal * me._length;
		},
	
		getDecimalForPixel: function(pixel) {
			var decimal = (pixel - this._startPixel) / this._length;
			return this._reversePixels ? 1 - decimal : decimal;
		},
	
		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},
	
		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},
	
		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var me = this;
			var tickOpts = me.options.ticks;
			var axisLength = me._length;
			var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
			var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
			var numMajorIndices = majorIndices.length;
			var first = majorIndices[0];
			var last = majorIndices[numMajorIndices - 1];
			var i, ilen, spacing, avgMajorSpacing;
	
			// If there are too many major ticks to display them all
			if (numMajorIndices > ticksLimit) {
				skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
				return nonSkipped(ticks);
			}
	
			spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
	
			if (numMajorIndices > 0) {
				for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
					skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
				}
				avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
				skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
				skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
				return nonSkipped(ticks);
			}
			skip(ticks, spacing);
			return nonSkipped(ticks);
		},
	
		/**
		 * @private
		 */
		_tickSize: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			// Calculate space needed by label in axis direction.
			var rot = helpers$1.toRadians(me.labelRotation);
			var cos = Math.abs(Math.cos(rot));
			var sin = Math.abs(Math.sin(rot));
	
			var labelSizes = me._getLabelSizes();
			var padding = optionTicks.autoSkipPadding || 0;
			var w = labelSizes ? labelSizes.widest.width + padding : 0;
			var h = labelSizes ? labelSizes.highest.height + padding : 0;
	
			// Calculate space needed for 1 tick in axis direction.
			return me.isHorizontal()
				? h * cos > w * sin ? w / cos : h / sin
				: h * sin < w * cos ? h / cos : w / sin;
		},
	
		/**
		 * @private
		 */
		_isVisible: function() {
			var me = this;
			var chart = me.chart;
			var display = me.options.display;
			var i, ilen, meta;
	
			if (display !== 'auto') {
				return !!display;
			}
	
			// When 'auto', the scale is visible if at least one associated dataset is visible.
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
						return true;
					}
				}
			}
	
			return false;
		},
	
		/**
		 * @private
		 */
		_computeGridLineItems: function(chartArea) {
			var me = this;
			var chart = me.chart;
			var options = me.options;
			var gridLines = options.gridLines;
			var position = options.position;
			var offsetGridLines = gridLines.offsetGridLines;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
	
			var tl = getTickMarkLength(gridLines);
			var items = [];
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var axisHalfWidth = axisWidth / 2;
			var alignPixel = helpers$1._alignPixel;
			var alignBorderValue = function(pixel) {
				return alignPixel(chart, pixel, axisWidth);
			};
			var borderValue, i, tick, lineValue, alignedLineValue;
			var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
	
			if (position === 'top') {
				borderValue = alignBorderValue(me.bottom);
				ty1 = me.bottom - tl;
				ty2 = borderValue - axisHalfWidth;
				y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
				y2 = chartArea.bottom;
			} else if (position === 'bottom') {
				borderValue = alignBorderValue(me.top);
				y1 = chartArea.top;
				y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
				ty1 = borderValue + axisHalfWidth;
				ty2 = me.top + tl;
			} else if (position === 'left') {
				borderValue = alignBorderValue(me.right);
				tx1 = me.right - tl;
				tx2 = borderValue - axisHalfWidth;
				x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
				x2 = chartArea.right;
			} else {
				borderValue = alignBorderValue(me.left);
				x1 = chartArea.left;
				x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
				tx1 = borderValue + axisHalfWidth;
				tx2 = me.left + tl;
			}
	
			for (i = 0; i < ticksLength; ++i) {
				tick = ticks[i] || {};
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(tick.label) && i < ticks.length) {
					continue;
				}
	
				if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash || [];
					borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
				} else {
					lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
					lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
					borderDash = gridLines.borderDash || [];
					borderDashOffset = gridLines.borderDashOffset || 0.0;
				}
	
				lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
	
				// Skip if the pixel is out of the range
				if (lineValue === undefined) {
					continue;
				}
	
				alignedLineValue = alignPixel(chart, lineValue, lineWidth);
	
				if (isHorizontal) {
					tx1 = tx2 = x1 = x2 = alignedLineValue;
				} else {
					ty1 = ty2 = y1 = y2 = alignedLineValue;
				}
	
				items.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					width: lineWidth,
					color: lineColor,
					borderDash: borderDash,
					borderDashOffset: borderDashOffset,
				});
			}
	
			items.ticksLength = ticksLength;
			items.borderValue = borderValue;
	
			return items;
		},
	
		/**
		 * @private
		 */
		_computeLabelItems: function() {
			var me = this;
			var options = me.options;
			var optionTicks = options.ticks;
			var position = options.position;
			var isMirrored = optionTicks.mirror;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var fonts = parseTickFontOptions(optionTicks);
			var tickPadding = optionTicks.padding;
			var tl = getTickMarkLength(options.gridLines);
			var rotation = -helpers$1.toRadians(me.labelRotation);
			var items = [];
			var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
	
			if (position === 'top') {
				y = me.bottom - tl - tickPadding;
				textAlign = !rotation ? 'center' : 'left';
			} else if (position === 'bottom') {
				y = me.top + tl + tickPadding;
				textAlign = !rotation ? 'center' : 'right';
			} else if (position === 'left') {
				x = me.right - (isMirrored ? 0 : tl) - tickPadding;
				textAlign = isMirrored ? 'left' : 'right';
			} else {
				x = me.left + (isMirrored ? 0 : tl) + tickPadding;
				textAlign = isMirrored ? 'right' : 'left';
			}
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				tick = ticks[i];
				label = tick.label;
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(label)) {
					continue;
				}
	
				pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
				font = tick.major ? fonts.major : fonts.minor;
				lineHeight = font.lineHeight;
				lineCount = isArray(label) ? label.length : 1;
	
				if (isHorizontal) {
					x = pixel;
					textOffset = position === 'top'
						? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
						: (!rotation ? 0.5 : 0) * lineHeight;
				} else {
					y = pixel;
					textOffset = (1 - lineCount) * lineHeight / 2;
				}
	
				items.push({
					x: x,
					y: y,
					rotation: rotation,
					label: label,
					font: font,
					textOffset: textOffset,
					textAlign: textAlign
				});
			}
	
			return items;
		},
	
		/**
		 * @private
		 */
		_drawGrid: function(chartArea) {
			var me = this;
			var gridLines = me.options.gridLines;
	
			if (!gridLines.display) {
				return;
			}
	
			var ctx = me.ctx;
			var chart = me.chart;
			var alignPixel = helpers$1._alignPixel;
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
			var width, color, i, ilen, item;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				width = item.width;
				color = item.color;
	
				if (width && color) {
					ctx.save();
					ctx.lineWidth = width;
					ctx.strokeStyle = color;
					if (ctx.setLineDash) {
						ctx.setLineDash(item.borderDash);
						ctx.lineDashOffset = item.borderDashOffset;
					}
	
					ctx.beginPath();
	
					if (gridLines.drawTicks) {
						ctx.moveTo(item.tx1, item.ty1);
						ctx.lineTo(item.tx2, item.ty2);
					}
	
					if (gridLines.drawOnChartArea) {
						ctx.moveTo(item.x1, item.y1);
						ctx.lineTo(item.x2, item.y2);
					}
	
					ctx.stroke();
					ctx.restore();
				}
			}
	
			if (axisWidth) {
				// Draw the line at the edge of the axis
				var firstLineWidth = axisWidth;
				var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
				var borderValue = items.borderValue;
				var x1, x2, y1, y2;
	
				if (me.isHorizontal()) {
					x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
					x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
					y1 = y2 = borderValue;
				} else {
					y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
					y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
					x1 = x2 = borderValue;
				}
	
				ctx.lineWidth = axisWidth;
				ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.stroke();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			if (!optionTicks.display) {
				return;
			}
	
			var ctx = me.ctx;
			var items = me._labelItems || (me._labelItems = me._computeLabelItems());
			var i, j, ilen, jlen, item, tickFont, label, y;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				tickFont = item.font;
	
				// Make sure we draw text in the correct color and font
				ctx.save();
				ctx.translate(item.x, item.y);
				ctx.rotate(item.rotation);
				ctx.font = tickFont.string;
				ctx.fillStyle = tickFont.color;
				ctx.textBaseline = 'middle';
				ctx.textAlign = item.textAlign;
	
				label = item.label;
				y = item.textOffset;
				if (isArray(label)) {
					for (j = 0, jlen = label.length; j < jlen; ++j) {
						// We just make sure the multiline element is a string here..
						ctx.fillText('' + label[j], 0, y);
						y += tickFont.lineHeight;
					}
				} else {
					ctx.fillText(label, 0, y);
				}
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawTitle: function() {
			var me = this;
			var ctx = me.ctx;
			var options = me.options;
			var scaleLabel = options.scaleLabel;
	
			if (!scaleLabel.display) {
				return;
			}
	
			var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
			var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
			var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
			var halfLineHeight = scaleLabelFont.lineHeight / 2;
			var position = options.position;
			var rotation = 0;
			var scaleLabelX, scaleLabelY;
	
			if (me.isHorizontal()) {
				scaleLabelX = me.left + me.width / 2; // midpoint of the width
				scaleLabelY = position === 'bottom'
					? me.bottom - halfLineHeight - scaleLabelPadding.bottom
					: me.top + halfLineHeight + scaleLabelPadding.top;
			} else {
				var isLeft = position === 'left';
				scaleLabelX = isLeft
					? me.left + halfLineHeight + scaleLabelPadding.top
					: me.right - halfLineHeight - scaleLabelPadding.top;
				scaleLabelY = me.top + me.height / 2;
				rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
			}
	
			ctx.save();
			ctx.translate(scaleLabelX, scaleLabelY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
			ctx.fillStyle = scaleLabelFontColor; // render in correct colour
			ctx.font = scaleLabelFont.string;
			ctx.fillText(scaleLabel.labelString, 0, 0);
			ctx.restore();
		},
	
		draw: function(chartArea) {
			var me = this;
	
			if (!me._isVisible()) {
				return;
			}
	
			me._drawGrid(chartArea);
			me._drawTitle();
			me._drawLabels();
		},
	
		/**
		 * @private
		 */
		_layers: function() {
			var me = this;
			var opts = me.options;
			var tz = opts.ticks && opts.ticks.z || 0;
			var gz = opts.gridLines && opts.gridLines.z || 0;
	
			if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
				// backward compatibility: draw has been overridden by custom scale
				return [{
					z: tz,
					draw: function() {
						me.draw.apply(me, arguments);
					}
				}];
			}
	
			return [{
				z: gz,
				draw: function() {
					me._drawGrid.apply(me, arguments);
					me._drawTitle.apply(me, arguments);
				}
			}, {
				z: tz,
				draw: function() {
					me._drawLabels.apply(me, arguments);
				}
			}];
		},
	
		/**
		 * @private
		 */
		_getMatchingVisibleMetas: function(type) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			return me.chart._getSortedVisibleDatasetMetas()
				.filter(function(meta) {
					return (!type || meta.type === type)
						&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
				});
		}
	});
	
	Scale.prototype._draw = Scale.prototype.draw;
	
	var core_scale = Scale;
	
	var isNullOrUndef$1 = helpers$1.isNullOrUndef;
	
	var defaultConfig = {
		position: 'bottom'
	};
	
	var scale_category = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var labels = me._getLabels();
			var ticksOpts = me.options.ticks;
			var min = ticksOpts.min;
			var max = ticksOpts.max;
			var minIndex = 0;
			var maxIndex = labels.length - 1;
			var findIndex;
	
			if (min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(min);
				if (findIndex >= 0) {
					minIndex = findIndex;
				}
			}
	
			if (max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(max);
				if (findIndex >= 0) {
					maxIndex = findIndex;
				}
			}
	
			me.minIndex = minIndex;
			me.maxIndex = maxIndex;
			me.min = labels[minIndex];
			me.max = labels[maxIndex];
		},
	
		buildTicks: function() {
			var me = this;
			var labels = me._getLabels();
			var minIndex = me.minIndex;
			var maxIndex = me.maxIndex;
	
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var chart = me.chart;
	
			if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
				return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
			}
	
			return me._getLabels()[index];
		},
	
		_configure: function() {
			var me = this;
			var offset = me.options.offset;
			var ticks = me.ticks;
	
			core_scale.prototype._configure.call(me);
	
			if (!me.isHorizontal()) {
				// For backward compatibility, vertical category scale reverse is inverted.
				me._reversePixels = !me._reversePixels;
			}
	
			if (!ticks) {
				return;
			}
	
			me._startValue = me.minIndex - (offset ? 0.5 : 0);
			me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
		},
	
		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var valueCategory, labels, idx;
	
			if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
				value = me.chart.data.datasets[datasetIndex].data[index];
			}
	
			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			if (!isNullOrUndef$1(value)) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				labels = me._getLabels();
				value = helpers$1.valueOrDefault(valueCategory, value);
				idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
				if (isNaN(index)) {
					index = value;
				}
			}
			return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticks;
			return index < 0 || index > ticks.length - 1
				? null
				: this.getPixelForValue(ticks[index], index + this.minIndex);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
			return Math.min(Math.max(value, 0), me.ticks.length - 1);
		},
	
		getBasePixel: function() {
			return this.bottom;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults = defaultConfig;
	scale_category._defaults = _defaults;
	
	var noop = helpers$1.noop;
	var isNullOrUndef$2 = helpers$1.isNullOrUndef;
	
	/**
	 * Generate a set of linear ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		// To get a "nice" value for the tick spacing, we will use the appropriately named
		// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
		// for details.
	
		var MIN_SPACING = 1e-14;
		var stepSize = generationOptions.stepSize;
		var unit = stepSize || 1;
		var maxNumSpaces = generationOptions.maxTicks - 1;
		var min = generationOptions.min;
		var max = generationOptions.max;
		var precision = generationOptions.precision;
		var rmin = dataRange.min;
		var rmax = dataRange.max;
		var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
		var factor, niceMin, niceMax, numSpaces;
	
		// Beyond MIN_SPACING floating point numbers being to lose precision
		// such that we can't do the math necessary to generate ticks
		if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
			return [rmin, rmax];
		}
	
		numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
		if (numSpaces > maxNumSpaces) {
			// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
			spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
		}
	
		if (stepSize || isNullOrUndef$2(precision)) {
			// If a precision is not specified, calculate factor based on spacing
			factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
		} else {
			// If the user specified a precision, round to that number of decimal places
			factor = Math.pow(10, precision);
			spacing = Math.ceil(spacing * factor) / factor;
		}
	
		niceMin = Math.floor(rmin / spacing) * spacing;
		niceMax = Math.ceil(rmax / spacing) * spacing;
	
		// If min, max and stepSize is set and they make an evenly spaced scale use it.
		if (stepSize) {
			// If very close to our whole number, use it.
			if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
				niceMin = min;
			}
			if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
				niceMax = max;
			}
		}
	
		numSpaces = (niceMax - niceMin) / spacing;
		// If very close to our rounded value, use it.
		if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
			numSpaces = Math.round(numSpaces);
		} else {
			numSpaces = Math.ceil(numSpaces);
		}
	
		niceMin = Math.round(niceMin * factor) / factor;
		niceMax = Math.round(niceMax * factor) / factor;
		ticks.push(isNullOrUndef$2(min) ? niceMin : min);
		for (var j = 1; j < numSpaces; ++j) {
			ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
		}
		ticks.push(isNullOrUndef$2(max) ? niceMax : max);
	
		return ticks;
	}
	
	var scale_linearbase = core_scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return core_scale.prototype.getRightValue.call(this, value);
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers$1.sign(me.min);
				var maxSign = helpers$1.sign(me.max);
	
				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}
	
			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
	
			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}
	
			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}
	
			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}
	
			if (me.min === me.max) {
				me.max++;
	
				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
	
		getTickLimit: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var stepSize = tickOpts.stepSize;
			var maxTicksLimit = tickOpts.maxTicksLimit;
			var maxTicks;
	
			if (stepSize) {
				maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
			} else {
				maxTicks = me._computeTickLimit();
				maxTicksLimit = maxTicksLimit || 11;
			}
	
			if (maxTicksLimit) {
				maxTicks = Math.min(maxTicksLimit, maxTicks);
			}
	
			return maxTicks;
		},
	
		_computeTickLimit: function() {
			return Number.POSITIVE_INFINITY;
		},
	
		handleDirectionalChanges: noop,
	
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);
	
			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				precision: tickOpts.precision,
				stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
	
			me.handleDirectionalChanges();
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				ticks.reverse();
	
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
	
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);
	
			core_scale.prototype.convertTicksToLabels.call(me);
		},
	
		_configure: function() {
			var me = this;
			var ticks = me.getTicks();
			var start = me.min;
			var end = me.max;
			var offset;
	
			core_scale.prototype._configure.call(me);
	
			if (me.options.offset && ticks.length) {
				offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
				start -= offset;
				end += offset;
			}
			me._startValue = start;
			me._endValue = end;
			me._valueRange = end - start;
		}
	});
	
	var defaultConfig$1 = {
		position: 'left',
		ticks: {
			callback: core_ticks.formatters.linear
		}
	};
	
	var DEFAULT_MIN = 0;
	var DEFAULT_MAX = 1;
	
	function getOrCreateStack(stacks, stacked, meta) {
		var key = [
			meta.type,
			// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
			stacked === undefined && meta.stack === undefined ? meta.index : '',
			meta.stack
		].join('.');
	
		if (stacks[key] === undefined) {
			stacks[key] = {
				pos: [],
				neg: []
			};
		}
	
		return stacks[key];
	}
	
	function stackData(scale, stacks, meta, data) {
		var opts = scale.options;
		var stacked = opts.stacked;
		var stack = getOrCreateStack(stacks, stacked, meta);
		var pos = stack.pos;
		var neg = stack.neg;
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			pos[i] = pos[i] || 0;
			neg[i] = neg[i] || 0;
	
			if (opts.relativePoints) {
				pos[i] = 100;
			} else if (value.min < 0 || value.max < 0) {
				neg[i] += value.min;
			} else {
				pos[i] += value.max;
			}
		}
	}
	
	function updateMinMax(scale, meta, data) {
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			scale.min = Math.min(scale.min, value.min);
			scale.max = Math.max(scale.max, value.max);
		}
	}
	
	var scale_linear = scale_linearbase.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var metasets = me._getMatchingVisibleMetas();
			var hasStacks = opts.stacked;
			var stacks = {};
			var ilen = metasets.length;
			var i, meta, data, values;
	
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
	
			if (hasStacks === undefined) {
				for (i = 0; !hasStacks && i < ilen; ++i) {
					meta = metasets[i];
					hasStacks = meta.stack !== undefined;
				}
			}
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				data = datasets[meta.index].data;
				if (hasStacks) {
					stackData(me, stacks, meta, data);
				} else {
					updateMinMax(me, meta, data);
				}
			}
	
			helpers$1.each(stacks, function(stackValues) {
				values = stackValues.pos.concat(stackValues.neg);
				me.min = Math.min(me.min, helpers$1.min(values));
				me.max = Math.max(me.max, helpers$1.max(values));
			});
	
			me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			var me = this;
			var tickFont;
	
			if (me.isHorizontal()) {
				return Math.ceil(me.width / 40);
			}
			tickFont = helpers$1.options._parseFont(me.options.ticks);
			return Math.ceil(me.height / tickFont.lineHeight);
		},
	
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		// Utils
		getPixelForValue: function(value) {
			var me = this;
			return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
		},
	
		getValueForPixel: function(pixel) {
			return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticksAsNumbers;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$1 = defaultConfig$1;
	scale_linear._defaults = _defaults$1;
	
	var valueOrDefault$b = helpers$1.valueOrDefault;
	var log10 = helpers$1.math.log10;
	
	/**
	 * Generate a set of logarithmic ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks$1(generationOptions, dataRange) {
		var ticks = [];
	
		var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
	
		var endExp = Math.floor(log10(dataRange.max));
		var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
		var exp, significand;
	
		if (tickVal === 0) {
			exp = Math.floor(log10(dataRange.minNotZero));
			significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
			ticks.push(tickVal);
			tickVal = significand * Math.pow(10, exp);
		} else {
			exp = Math.floor(log10(tickVal));
			significand = Math.floor(tickVal / Math.pow(10, exp));
		}
		var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
	
		do {
			ticks.push(tickVal);
	
			++significand;
			if (significand === 10) {
				significand = 1;
				++exp;
				precision = exp >= 0 ? 1 : precision;
			}
	
			tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
		} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
		var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
		ticks.push(lastTick);
	
		return ticks;
	}
	
	var defaultConfig$2 = {
		position: 'left',
	
		// label settings
		ticks: {
			callback: core_ticks.formatters.logarithmic
		}
	};
	
	// TODO(v3): change this to positiveOrDefault
	function nonNegativeOrDefault(value, defaultValue) {
		return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
	}
	
	var scale_logarithmic = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}
			var datasetIndex, meta, value, data, i, ilen;
	
			// Calculate Range
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
			me.minNotZero = Number.POSITIVE_INFINITY;
	
			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
						break;
					}
				}
			}
	
			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};
	
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');
	
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}
	
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							var values = valuesPerStack[key];
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
							values[i] = values[i] || 0;
							values[i] += value.max;
						}
					}
				}
	
				helpers$1.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers$1.min(valuesForType);
						var maxVal = helpers$1.max(valuesForType);
						me.min = Math.min(me.min, minVal);
						me.max = Math.max(me.max, maxVal);
					}
				});
	
			} else {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
	
							me.min = Math.min(value.min, me.min);
							me.max = Math.max(value.max, me.max);
	
							if (value.min !== 0) {
								me.minNotZero = Math.min(value.min, me.minNotZero);
							}
						}
					}
				}
			}
	
			me.min = helpers$1.isFinite(me.min) ? me.min : null;
			me.max = helpers$1.isFinite(me.max) ? me.max : null;
			me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
	
			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;
	
			me.min = nonNegativeOrDefault(tickOpts.min, me.min);
			me.max = nonNegativeOrDefault(tickOpts.max, me.max);
	
			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},
	
		buildTicks: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = !me.isHorizontal();
	
			var generationOptions = {
				min: nonNegativeOrDefault(tickOpts.min),
				max: nonNegativeOrDefault(tickOpts.max)
			};
			var ticks = me.ticks = generateTicks$1(generationOptions, me);
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},
	
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();
	
			core_scale.prototype.convertTicksToLabels.call(this);
		},
	
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.tickValues;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		},
	
		/**
		 * Returns the value of the first tick.
		 * @param {number} value - The minimum not zero value.
		 * @return {number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));
	
			return significand * Math.pow(10, exp);
		},
	
		_configure: function() {
			var me = this;
			var start = me.min;
			var offset = 0;
	
			core_scale.prototype._configure.call(me);
	
			if (start === 0) {
				start = me._getFirstTickValue(me.minNotZero);
				offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
			}
	
			me._startValue = log10(start);
			me._valueOffset = offset;
			me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
		},
	
		getPixelForValue: function(value) {
			var me = this;
			var decimal = 0;
	
			value = +me.getRightValue(value);
	
			if (value > me.min && value > 0) {
				decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
			}
			return me.getPixelForDecimal(decimal);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var decimal = me.getDecimalForPixel(pixel);
			return decimal === 0 && me.min === 0
				? 0
				: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$2 = defaultConfig$2;
	scale_logarithmic._defaults = _defaults$2;
	
	var valueOrDefault$c = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
	var resolve$4 = helpers$1.options.resolve;
	
	var defaultConfig$3 = {
		display: true,
	
		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',
	
		angleLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		gridLines: {
			circular: false
		},
	
		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,
	
			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',
	
			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,
	
			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,
	
			callback: core_ticks.formatters.linear
		},
	
		pointLabels: {
			// Boolean - if true, show point labels
			display: true,
	
			// Number - Point label font size in pixels
			fontSize: 10,
	
			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};
	
	function getTickBackdropHeight(opts) {
		var tickOpts = opts.ticks;
	
		if (tickOpts.display && opts.display) {
			return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
		}
		return 0;
	}
	
	function measureLabelSize(ctx, lineHeight, label) {
		if (helpers$1.isArray(label)) {
			return {
				w: helpers$1.longestText(ctx, ctx.font, label),
				h: label.length * lineHeight
			};
		}
	
		return {
			w: ctx.measureText(label).width,
			h: lineHeight
		};
	}
	
	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size,
				end: pos
			};
		}
	
		return {
			start: pos,
			end: pos + size
		};
	}
	
	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
	
		// Right, this is really confusing and there is a lot of maths going on here
		// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		//
		// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		//
		// Solution:
		//
		// We assume the radius of the polygon is half the size of the canvas at first
		// at each index we check if the text overlaps.
		//
		// Where it does, we store that angle and that index.
		//
		// After finding the largest index and angle we calculate how much we need to remove
		// from the shape radius to move the point inwards by that x.
		//
		// We average the left and right distances to get the maximum shape radius that can fit in the box
		// along with labels.
		//
		// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		// on each side, removing that from the size, halving it and adding the left x protrusion width.
		//
		// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		// and position it in the most space efficient manner
		//
		// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
	
		var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
	
		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var furthestLimits = {
			l: 0,
			r: scale.width,
			t: 0,
			b: scale.height - scale.paddingTop
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;
	
		scale.ctx.font = plFont.string;
		scale._pointLabelSizes = [];
	
		var valueCount = scale.chart.data.labels.length;
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
			textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
			scale._pointLabelSizes[i] = textSize;
	
			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}
	
			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}
	
			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}
	
			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}
	
		scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
	}
	
	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}
	
		return 'right';
	}
	
	function fillText(ctx, text, position, lineHeight) {
		var y = position.y + lineHeight / 2;
		var i, ilen;
	
		if (helpers$1.isArray(text)) {
			for (i = 0, ilen = text.length; i < ilen; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, position.x, y);
		}
	}
	
	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}
	
	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var pointLabelOpts = opts.pointLabels;
		var tickBackdropHeight = getTickBackdropHeight(opts);
		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
		var plFont = helpers$1.options._parseFont(pointLabelOpts);
	
		ctx.save();
	
		ctx.font = plFont.string;
		ctx.textBaseline = 'middle';
	
		for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
			// Extra pixels out for some label spacing
			var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
			var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
	
			// Keep this in loop since we may support array properties here
			var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
			ctx.fillStyle = pointLabelFontColor;
	
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians);
			ctx.textAlign = getTextAlignForAngle(angle);
			adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
			fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
		}
		ctx.restore();
	}
	
	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		var circular = gridLineOpts.circular;
		var valueCount = scale.chart.data.labels.length;
		var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
		var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
		var pointPosition;
	
		if ((!circular && !valueCount) || !lineColor || !lineWidth) {
			return;
		}
	
		ctx.save();
		ctx.strokeStyle = lineColor;
		ctx.lineWidth = lineWidth;
		if (ctx.setLineDash) {
			ctx.setLineDash(gridLineOpts.borderDash || []);
			ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
		}
	
		ctx.beginPath();
		if (circular) {
			// Draw circular arcs between the points
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
		} else {
			// Draw straight lines connecting each index
			pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);
	
			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}
		}
		ctx.closePath();
		ctx.stroke();
		ctx.restore();
	}
	
	function numberOrZero(param) {
		return helpers$1.isNumber(param) ? param : 0;
	}
	
	var scale_radialLinear = scale_linearbase.extend({
		setDimensions: function() {
			var me = this;
	
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.paddingTop = getTickBackdropHeight(me.options) / 2;
			me.xCenter = Math.floor(me.width / 2);
			me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
			me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;
	
			helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);
	
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}
	
						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});
	
			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
		},
	
		convertTicksToLabels: function() {
			var me = this;
	
			scale_linearbase.prototype.convertTicksToLabels.call(me);
	
			// Point labels
			me.pointLabels = me.chart.data.labels.map(function() {
				var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
				return label || label === 0 ? label : '';
			});
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		fit: function() {
			var me = this;
			var opts = me.options;
	
			if (opts.display && opts.pointLabels.display) {
				fitWithPointLabels(me);
			} else {
				me.setCenterPoint(0, 0, 0, 0);
			}
		},
	
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
	
			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
			me.drawingArea = Math.min(
				Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
	
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;
	
			me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
		},
	
		getIndexAngle: function(index) {
			var chart = this.chart;
			var angleMultiplier = 360 / chart.data.labels.length;
			var options = chart.options || {};
			var startAngle = options.startAngle || 0;
	
			// Start from the top instead of right, so remove a quarter of the circle
			var angle = (index * angleMultiplier + startAngle) % 360;
	
			return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
		},
	
		getDistanceFromCenterForValue: function(value) {
			var me = this;
	
			if (helpers$1.isNullOrUndef(value)) {
				return NaN;
			}
	
			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
	
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
				y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
			};
		},
	
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},
	
		getBasePosition: function(index) {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.getPointPositionForValue(index || 0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},
	
		/**
		 * @private
		 */
		_drawGrid: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var angleLineOpts = opts.angleLines;
			var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
			var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
			var i, offset, position;
	
			if (opts.pointLabels.display) {
				drawPointLabels(me);
			}
	
			if (gridLineOpts.display) {
				helpers$1.each(me.ticks, function(label, index) {
					if (index !== 0) {
						offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
						drawRadiusLine(me, gridLineOpts, offset, index);
					}
				});
			}
	
			if (angleLineOpts.display && lineWidth && lineColor) {
				ctx.save();
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = lineColor;
				if (ctx.setLineDash) {
					ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
					ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
				}
	
				for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
					offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
					position = me.getPointPosition(i, offset);
					ctx.beginPath();
					ctx.moveTo(me.xCenter, me.yCenter);
					ctx.lineTo(position.x, position.y);
					ctx.stroke();
				}
	
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			if (!tickOpts.display) {
				return;
			}
	
			var startAngle = me.getIndexAngle(0);
			var tickFont = helpers$1.options._parseFont(tickOpts);
			var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
			var offset, width;
	
			ctx.save();
			ctx.font = tickFont.string;
			ctx.translate(me.xCenter, me.yCenter);
			ctx.rotate(startAngle);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			helpers$1.each(me.ticks, function(label, index) {
				if (index === 0 && !tickOpts.reverse) {
					return;
				}
	
				offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
	
				if (tickOpts.showLabelBackdrop) {
					width = ctx.measureText(label).width;
					ctx.fillStyle = tickOpts.backdropColor;
	
					ctx.fillRect(
						-width / 2 - tickOpts.backdropPaddingX,
						-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
						width + tickOpts.backdropPaddingX * 2,
						tickFont.size + tickOpts.backdropPaddingY * 2
					);
				}
	
				ctx.fillStyle = tickFontColor;
				ctx.fillText(label, 0, -offset);
			});
	
			ctx.restore();
		},
	
		/**
		 * @private
		 */
		_drawTitle: helpers$1.noop
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$3 = defaultConfig$3;
	scale_radialLinear._defaults = _defaults$3;
	
	var deprecated$1 = helpers$1._deprecated;
	var resolve$5 = helpers$1.options.resolve;
	var valueOrDefault$d = helpers$1.valueOrDefault;
	
	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: 1000
		},
		second: {
			common: true,
			size: 1000,
			steps: 60
		},
		minute: {
			common: true,
			size: 60000,
			steps: 60
		},
		hour: {
			common: true,
			size: 3600000,
			steps: 24
		},
		day: {
			common: true,
			size: 86400000,
			steps: 30
		},
		week: {
			common: false,
			size: 604800000,
			steps: 4
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: 12
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: 4
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};
	
	var UNITS = Object.keys(INTERVALS);
	
	function sorter(a, b) {
		return a - b;
	}
	
	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}
	
		return out;
	}
	
	function getMin(options) {
		return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
	}
	
	function getMax(options) {
		return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
	}
	
	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}
	
		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;
	
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}
	
		items.push(max);
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];
	
			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}
	
		return table;
	}
	
	// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;
	
		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];
	
			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}
	
		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}
	
	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate$1(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);
	
		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
	
		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;
	
		return prev[tkey] + offset;
	}
	
	function toTimestamp(scale, input) {
		var adapter = scale._adapter;
		var options = scale.options.time;
		var parser = options.parser;
		var format = parser || options.format;
		var value = input;
	
		if (typeof parser === 'function') {
			value = parser(value);
		}
	
		// Only parse if its not a timestamp already
		if (!helpers$1.isFinite(value)) {
			value = typeof format === 'string'
				? adapter.parse(value, format)
				: adapter.parse(value);
		}
	
		if (value !== null) {
			return +value;
		}
	
		// Labels are in an incompatible format and no `parser` has been provided.
		// The user might still use the deprecated `format` option for parsing.
		if (!parser && typeof format === 'function') {
			value = format(input);
	
			// `format` could return something else than a timestamp, if so, parse it
			if (!helpers$1.isFinite(value)) {
				value = adapter.parse(value);
			}
		}
	
		return value;
	}
	
	function parse(scale, input) {
		if (helpers$1.isNullOrUndef(input)) {
			return null;
		}
	
		var options = scale.options.time;
		var value = toTimestamp(scale, scale.getRightValue(input));
		if (value === null) {
			return value;
		}
	
		if (options.round) {
			value = +scale._adapter.startOf(value, options.round);
		}
	
		return value;
	}
	
	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;
	
		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps : MAX_INTEGER;
	
			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}
	
		return UNITS[ilen - 1];
	}
	
	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
		var i, unit;
	
		for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
				return unit;
			}
		}
	
		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}
	
	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}
	
	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(scale, min, max, capacity) {
		var adapter = scale._adapter;
		var options = scale.options;
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var first = min;
		var ticks = [];
		var time;
	
		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = +adapter.startOf(first, 'isoWeek', weekday);
		}
	
		// Align first ticks on unit
		first = +adapter.startOf(first, weekday ? 'day' : minor);
	
		// Prevent browser from freezing in case user options request millions of milliseconds
		if (adapter.diff(max, min, minor) > 100000 * stepSize) {
			throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
		}
	
		for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
			ticks.push(time);
		}
	
		if (time === max || options.bounds === 'ticks') {
			ticks.push(time);
		}
	
		return ticks;
	}
	
	/**
	 * Returns the start and end offsets from edges in the form of {start, end}
	 * where each value is a relative width to the scale and ranges between 0 and 1.
	 * They add extra margins on the both sides by scaling down the original scale.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var start = 0;
		var end = 0;
		var first, last;
	
		if (options.offset && ticks.length) {
			first = interpolate$1(table, 'time', ticks[0], 'pos');
			if (ticks.length === 1) {
				start = 1 - first;
			} else {
				start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
			}
			last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
			if (ticks.length === 1) {
				end = last;
			} else {
				end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
			}
		}
	
		return {start: start, end: end, factor: 1 / (start + 1 + end)};
	}
	
	function setMajorTicks(scale, ticks, map, majorUnit) {
		var adapter = scale._adapter;
		var first = +adapter.startOf(ticks[0].value, majorUnit);
		var last = ticks[ticks.length - 1].value;
		var major, index;
	
		for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
			index = map[major];
			if (index >= 0) {
				ticks[index].major = true;
			}
		}
		return ticks;
	}
	
	function ticksFromTimestamps(scale, values, majorUnit) {
		var ticks = [];
		var map = {};
		var ilen = values.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = values[i];
			map[value] = i;
	
			ticks.push({
				value: value,
				major: false
			});
		}
	
		// We set the major ticks separately from the above loop because calling startOf for every tick
		// is expensive when there is a large number of ticks
		return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
	}
	
	var defaultConfig$4 = {
		position: 'bottom',
	
		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',
	
		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',
	
		adapters: {},
		time: {
			parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',
			displayFormats: {}
		},
		ticks: {
			autoSkip: false,
	
			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',
	
			major: {
				enabled: false
			}
		}
	};
	
	var scale_time = core_scale.extend({
		initialize: function() {
			this.mergeTicksOptions();
			core_scale.prototype.initialize.call(this);
		},
	
		update: function() {
			var me = this;
			var options = me.options;
			var time = options.time || (options.time = {});
			var adapter = me._adapter = new core_adapters._date(options.adapters.date);
	
			// DEPRECATIONS: output a message only one time per update
			deprecated$1('time scale', time.format, 'time.format', 'time.parser');
			deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
			deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
	
			// Backward compatibility: before introducing adapter, `displayFormats` was
			// supposed to contain *all* unit/string pairs but this can't be resolved
			// when loading the scale (adapters are loaded afterward), so let's populate
			// missing formats on update
			helpers$1.mergeIf(time.displayFormats, adapter.formats());
	
			return core_scale.prototype.update.apply(me, arguments);
		},
	
		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return core_scale.prototype.getRightValue.call(this, rawValue);
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var adapter = me._adapter;
			var options = me.options;
			var unit = options.time.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp, labelsAdded;
			var dataLabels = me._getLabels();
	
			for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
				labels.push(parse(me, dataLabels[i]));
			}
	
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;
	
					// Let's consider that all data have the same format.
					if (helpers$1.isObject(data[0])) {
						datasets[i] = [];
	
						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(me, data[j]);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						datasets[i] = labels.slice(0);
						if (!labelsAdded) {
							timestamps = timestamps.concat(labels);
							labelsAdded = true;
						}
					}
				} else {
					datasets[i] = [];
				}
			}
	
			if (labels.length) {
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}
	
			if (timestamps.length) {
				timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}
	
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
			max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
	
			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);
	
			// PRIVATE
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},
	
		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var tickOpts = options.ticks;
			var timeOpts = options.time;
			var timestamps = me._timestamps;
			var ticks = [];
			var capacity = me.getLabelCapacity(min);
			var source = tickOpts.source;
			var distribution = options.distribution;
			var i, ilen, timestamp;
	
			if (source === 'data' || (source === 'auto' && distribution === 'series')) {
				timestamps = timestamps.data;
			} else if (source === 'labels') {
				timestamps = timestamps.labels;
			} else {
				timestamps = generate(me, min, max, capacity);
			}
	
			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}
	
			// Enforce limits with user min/max options
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}
	
			me.min = min;
			me.max = max;
	
			// PRIVATE
			// determineUnitForFormatting relies on the number of ticks so we don't use it when
			// autoSkip is enabled because we don't yet know what the final number of ticks will be
			me._unit = timeOpts.unit || (tickOpts.autoSkip
				? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
				: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
			me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
				: determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);
	
			if (tickOpts.reverse) {
				ticks.reverse();
			}
	
			return ticksFromTimestamps(me, ticks, me._majorUnit);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var adapter = me._adapter;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];
	
			if (helpers$1.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}
			return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
		},
	
		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(time, index, ticks, format) {
			var me = this;
			var adapter = me._adapter;
			var options = me.options;
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var tick = ticks[index];
			var tickOpts = options.ticks;
			var major = majorUnit && majorFormat && tick && tick.major;
			var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
			var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
			var formatter = resolve$5([
				nestedTickOpts.callback,
				nestedTickOpts.userCallback,
				tickOpts.callback,
				tickOpts.userCallback
			]);
	
			return formatter ? formatter(label, index, ticks) : label;
		},
	
		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var offsets = me._offsets;
			var pos = interpolate$1(me._table, 'time', time, 'pos');
			return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
		},
	
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;
	
			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}
	
			if (time === null) {
				time = parse(me, value);
			}
	
			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},
	
		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var offsets = me._offsets;
			var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
			var time = interpolate$1(me._table, 'pos', pos, 'time');
	
			// DEPRECATION, we should return time directly
			return me._adapter._create(time);
		},
	
		/**
		 * @private
		 */
		_getLabelSize: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
	
			return {
				w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
				h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
			};
		},
	
		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			return this._getLabelSize(label).w;
		},
	
		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;
			var timeOpts = me.options.time;
			var displayFormats = timeOpts.displayFormats;
	
			// pick the longest format (milliseconds) for guestimation
			var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
			var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
			var size = me._getLabelSize(exampleLabel);
			var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
	
			if (me.options.offset) {
				capacity--;
			}
	
			return capacity > 0 ? capacity : 1;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$4 = defaultConfig$4;
	scale_time._defaults = _defaults$4;
	
	var scales = {
		category: scale_category,
		linear: scale_linear,
		logarithmic: scale_logarithmic,
		radialLinear: scale_radialLinear,
		time: scale_time
	};
	
	var FORMATS = {
		datetime: 'MMM D, YYYY, h:mm:ss a',
		millisecond: 'h:mm:ss.SSS a',
		second: 'h:mm:ss a',
		minute: 'h:mm a',
		hour: 'hA',
		day: 'MMM D',
		week: 'll',
		month: 'MMM YYYY',
		quarter: '[Q]Q - YYYY',
		year: 'YYYY'
	};
	
	core_adapters._date.override(typeof moment === 'function' ? {
		_id: 'moment', // DEBUG ONLY
	
		formats: function() {
			return FORMATS;
		},
	
		parse: function(value, format) {
			if (typeof value === 'string' && typeof format === 'string') {
				value = moment(value, format);
			} else if (!(value instanceof moment)) {
				value = moment(value);
			}
			return value.isValid() ? value.valueOf() : null;
		},
	
		format: function(time, format) {
			return moment(time).format(format);
		},
	
		add: function(time, amount, unit) {
			return moment(time).add(amount, unit).valueOf();
		},
	
		diff: function(max, min, unit) {
			return moment(max).diff(moment(min), unit);
		},
	
		startOf: function(time, unit, weekday) {
			time = moment(time);
			if (unit === 'isoWeek') {
				return time.isoWeekday(weekday).valueOf();
			}
			return time.startOf(unit).valueOf();
		},
	
		endOf: function(time, unit) {
			return moment(time).endOf(unit).valueOf();
		},
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility with scale.getValueForPixel().
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(time) {
			return moment(time);
		},
	} : {});
	
	core_defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});
	
	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;
	
			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},
	
		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;
	
			if (helpers$1.isArray(boundary)) {
				return function(point, i) {
					return boundary[i];
				};
			}
	
			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};
	
	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;
	
		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}
	
		if (fill === false || fill === null) {
			return false;
		}
	
		if (fill === true) {
			return 'origin';
		}
	
		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}
	
			if (target === index || target < 0 || target >= count) {
				return false;
			}
	
			return target;
		}
	
		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}
	
	function computeLinearBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;
	
		if (isFinite(fill)) {
			return null;
		}
	
		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).
	
		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}
	
		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}
	
			if (helpers$1.isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}
	
		return null;
	}
	
	function computeCircularBoundary(source) {
		var scale = source.el._scale;
		var options = scale.options;
		var length = scale.chart.data.labels.length;
		var fill = source.fill;
		var target = [];
		var start, end, center, i, point;
	
		if (!length) {
			return null;
		}
	
		start = options.ticks.reverse ? scale.max : scale.min;
		end = options.ticks.reverse ? scale.min : scale.max;
		center = scale.getPointPositionForValue(0, start);
		for (i = 0; i < length; ++i) {
			point = fill === 'start' || fill === 'end'
				? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
				: scale.getBasePosition(i);
			if (options.gridLines.circular) {
				point.cx = center.x;
				point.cy = center.y;
				point.angle = scale.getIndexAngle(i) - Math.PI / 2;
			}
			target.push(point);
		}
		return target;
	}
	
	function computeBoundary(source) {
		var scale = source.el._scale || {};
	
		if (scale.getPointPositionForValue) {
			return computeCircularBoundary(source);
		}
		return computeLinearBoundary(source);
	}
	
	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;
	
		if (!propagate) {
			return fill;
		}
	
		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}
	
			target = sources[fill];
			if (!target) {
				return false;
			}
	
			if (target.visible) {
				return fill;
			}
	
			visited.push(fill);
			fill = target.fill;
		}
	
		return false;
	}
	
	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';
	
		if (fill === false) {
			return null;
		}
	
		if (!isFinite(fill)) {
			type = 'boundary';
		}
	
		return mappers[type](source);
	}
	
	function isDrawable(point) {
		return point && !point.skip;
	}
	
	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i, cx, cy, r;
	
		if (!len0 || !len1) {
			return;
		}
	
		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}
	
		if (curve1[0].angle !== undefined) {
			cx = curve1[0].cx;
			cy = curve1[0].cy;
			r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
			for (i = len1 - 1; i > 0; --i) {
				ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
			}
			return;
		}
	
		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
	
		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}
	
	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1, loopOffset;
	
		ctx.beginPath();
	
		for (i = 0, ilen = count; i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);
	
			if (loop && loopOffset === undefined && d0) {
				loopOffset = i + 1;
				ilen = count + loopOffset;
			}
	
			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}
	
		drawArea(ctx, curve0, curve1, len0, len1);
	
		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}
	
	var plugin_filler = {
		id: 'filler',
	
		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;
	
			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;
	
				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}
	
				meta.$filler = source;
				sources.push(source);
			}
	
			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}
	
				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},
	
		beforeDatasetsDraw: function(chart) {
			var metasets = chart._getSortedVisibleDatasetMetas();
			var ctx = chart.ctx;
			var meta, i, el, view, points, mapper, color;
	
			for (i = metasets.length - 1; i >= 0; --i) {
				meta = metasets[i].$filler;
	
				if (!meta || !meta.visible) {
					continue;
				}
	
				el = meta.el;
				view = el._view;
				points = el._children || [];
				mapper = meta.mapper;
				color = view.backgroundColor || core_defaults.global.defaultColor;
	
				if (mapper && color && points.length) {
					helpers$1.canvas.clipArea(ctx, chart.chartArea);
					doFill(ctx, points, mapper, view, color, el._loop);
					helpers$1.canvas.unclipArea(ctx);
				}
			}
		}
	};
	
	var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
	var noop$1 = helpers$1.noop;
	var valueOrDefault$e = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			align: 'center',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
			onLeave: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var datasets = chart.data.datasets;
					var options = chart.options.legend || {};
					var usePointStyle = options.labels && options.labels.usePointStyle;
	
					return chart._getSortedDatasetMetas().map(function(meta) {
						var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
	
						return {
							text: datasets[meta.index].label,
							fillStyle: style.backgroundColor,
							hidden: !chart.isDatasetVisible(meta.index),
							lineCap: style.borderCapStyle,
							lineDash: style.borderDash,
							lineDashOffset: style.borderDashOffset,
							lineJoin: style.borderJoinStyle,
							lineWidth: style.borderWidth,
							strokeStyle: style.borderColor,
							pointStyle: style.pointStyle,
							rotation: style.rotation,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: meta.index
						};
					}, this);
				}
			}
		},
	
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var datasets = chart.data.datasets;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
				if (datasets[i].label) {
					listItem.appendChild(document.createTextNode(datasets[i].label));
				}
			}
	
			return list.outerHTML;
		}
	});
	
	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param {object} labelopts - the label options on the legend
	 * @param {number} fontSize - the label font size
	 * @return {number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
			fontSize :
			labelOpts.boxWidth;
	}
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Legend = core_element.extend({
	
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
	
			/**
	 		 * @private
	 		 */
			me._hoveredItem = null;
	
			// Are we in doughnut mode which has a different data type
			me.doughnutMode = false;
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type
	
		beforeUpdate: noop$1,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
		},
		afterUpdate: noop$1,
	
		//
	
		beforeSetDimensions: noop$1,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$1,
	
		//
	
		beforeBuildLabels: noop$1,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
	
			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}
	
			if (me.options.reverse) {
				legendItems.reverse();
			}
	
			me.legendItems = legendItems;
		},
		afterBuildLabels: noop$1,
	
		//
	
		beforeFit: noop$1,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;
	
			var ctx = me.ctx;
	
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
	
			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];
	
			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();
	
			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}
	
			// Increase sizes here
			if (!display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
			ctx.font = labelFont.string;
	
			if (isHorizontal) {
				// Labels
	
				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = 0;
	
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
						totalHeight += fontSize + labelOpts.padding;
						lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
					}
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};
	
					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});
	
				minSize.height += totalHeight;
	
			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var columnHeights = me.columnHeights = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					// If too tall, go to new column
					if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width
						columnHeights.push(currentColHeight);
						currentColWidth = 0;
						currentColHeight = 0;
					}
	
					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += fontSize + vPadding;
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});
	
				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				columnHeights.push(currentColHeight);
				minSize.width += totalWidth;
			}
	
			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop$1,
	
		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
	
		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor;
			var lineDefault = globalDefaults.elements.line;
			var legendHeight = me.height;
			var columnHeights = me.columnHeights;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;
	
			if (!opts.display) {
				return;
			}
	
			var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
			var ctx = me.ctx;
			var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
			var cursor;
	
			// Canvas setup
			ctx.textAlign = rtlHelper.textAlign('left');
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont.string;
	
			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;
	
			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}
	
				// Set the ctx for the box
				ctx.save();
	
				var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
				ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
	
				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
				}
	
				if (labelOpts && labelOpts.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = boxWidth * Math.SQRT2 / 2;
					var centerX = rtlHelper.xPlus(x, boxWidth / 2);
					var centerY = y + fontSize / 2;
	
					// Draw pointStyle as legend symbol
					helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
				} else {
					// Draw box as legend symbol
					ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					if (lineWidth !== 0) {
						ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					}
				}
	
				ctx.restore();
			};
	
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
				var yMiddle = y + halfFontSize;
	
				ctx.fillText(legendItem.text, xLeft, yMiddle);
	
				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
					ctx.stroke();
				}
			};
	
			var alignmentOffset = function(dimension, blockSize) {
				switch (opts.align) {
				case 'start':
					return labelOpts.padding;
				case 'end':
					return dimension - blockSize;
				default: // center
					return (dimension - blockSize + labelOpts.padding) / 2;
				}
			};
	
			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
					line: 0
				};
			}
	
			helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
	
			var itemHeight = fontSize + labelOpts.padding;
			helpers$1.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;
	
				rtlHelper.setWidth(me.minSize.width);
	
				// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
				// instead of me.right and me.bottom because me.width and me.height
				// may have been changed since me.minSize was calculated
				if (isHorizontal) {
					if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
					}
				} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					cursor.line++;
					y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
				}
	
				var realX = rtlHelper.x(x);
	
				drawLegendBox(realX, y, legendItem);
	
				hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
				hitboxes[i].top = y;
	
				// Fill the actual label
				fillText(realX, y, legendItem, textWidth);
	
				if (isHorizontal) {
					cursor.x += width + labelOpts.padding;
				} else {
					cursor.y += itemHeight;
				}
			});
	
			helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
		},
	
		/**
		 * @private
		 */
		_getLegendItemAt: function(x, y) {
			var me = this;
			var i, hitBox, lh;
	
			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				lh = me.legendHitBoxes;
				for (i = 0; i < lh.length; ++i) {
					hitBox = lh[i];
	
					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						return me.legendItems[i];
					}
				}
			}
	
			return null;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var hoveredItem;
	
			if (type === 'mousemove') {
				if (!opts.onHover && !opts.onLeave) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}
	
			// Chart event already has relative position in it
			hoveredItem = me._getLegendItemAt(e.x, e.y);
	
			if (type === 'click') {
				if (hoveredItem && opts.onClick) {
					// use e.native for backwards compatibility
					opts.onClick.call(me, e.native, hoveredItem);
				}
			} else {
				if (opts.onLeave && hoveredItem !== me._hoveredItem) {
					if (me._hoveredItem) {
						opts.onLeave.call(me, e.native, me._hoveredItem);
					}
					me._hoveredItem = hoveredItem;
				}
	
				if (opts.onHover && hoveredItem) {
					// use e.native for backwards compatibility
					opts.onHover.call(me, e.native, hoveredItem);
				}
			}
		}
	});
	
	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, legend, legendOpts);
		core_layouts.addBox(chart, legend);
		chart.legend = legend;
	}
	
	var plugin_legend = {
		id: 'legend',
	
		/**
		 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
		 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Legend,
	
		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;
	
			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;
	
			if (legendOpts) {
				helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
	
				if (legend) {
					core_layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				core_layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},
	
		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
	
	var noop$2 = helpers$1.noop;
	
	core_defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Title = core_element.extend({
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
	
		beforeUpdate: noop$2,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
	
		},
		afterUpdate: noop$2,
	
		//
	
		beforeSetDimensions: noop$2,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$2,
	
		//
	
		beforeBuildLabels: noop$2,
		buildLabels: noop$2,
		afterBuildLabels: noop$2,
	
		//
	
		beforeFit: noop$2,
		fit: function() {
			var me = this;
			var opts = me.options;
			var minSize = me.minSize = {};
			var isHorizontal = me.isHorizontal();
			var lineCount, textSize;
	
			if (!opts.display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
	
			lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
			textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
	
			me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
			me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
		},
		afterFit: noop$2,
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
	
		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
	
			if (!opts.display) {
				return;
			}
	
			var fontOpts = helpers$1.options._parseFont(opts);
			var lineHeight = fontOpts.lineHeight;
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;
	
			ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
			ctx.font = fontOpts.string;
	
			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}
	
			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			var text = opts.text;
			if (helpers$1.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}
	
			ctx.restore();
		}
	});
	
	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, title, titleOpts);
		core_layouts.addBox(chart, title);
		chart.titleBlock = title;
	}
	
	var plugin_title = {
		id: 'title',
	
		/**
		 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
		 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Title,
	
		beforeInit: function(chart) {
			var titleOpts = chart.options.title;
	
			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;
	
			if (titleOpts) {
				helpers$1.mergeIf(titleOpts, core_defaults.global.title);
	
				if (titleBlock) {
					core_layouts.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				core_layouts.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
	
	var plugins = {};
	var filler = plugin_filler;
	var legend = plugin_legend;
	var title = plugin_title;
	plugins.filler = filler;
	plugins.legend = legend;
	plugins.title = title;
	
	/**
	 * @namespace Chart
	 */
	
	
	core_controller.helpers = helpers$1;
	
	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	core_helpers();
	
	core_controller._adapters = core_adapters;
	core_controller.Animation = core_animation;
	core_controller.animationService = core_animations;
	core_controller.controllers = controllers;
	core_controller.DatasetController = core_datasetController;
	core_controller.defaults = core_defaults;
	core_controller.Element = core_element;
	core_controller.elements = elements;
	core_controller.Interaction = core_interaction;
	core_controller.layouts = core_layouts;
	core_controller.platform = platform;
	core_controller.plugins = core_plugins;
	core_controller.Scale = core_scale;
	core_controller.scaleService = core_scaleService;
	core_controller.Ticks = core_ticks;
	core_controller.Tooltip = core_tooltip;
	
	// Register built-in scales
	
	core_controller.helpers.each(scales, function(scale, type) {
		core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
	});
	
	// Load to register built-in adapters (as side effects)
	
	
	// Loading built-in plugins
	
	for (var k in plugins) {
		if (plugins.hasOwnProperty(k)) {
			core_controller.plugins.register(plugins[k]);
		}
	}
	
	core_controller.platform.initialize();
	
	var src = core_controller;
	if (typeof window !== 'undefined') {
		window.Chart = core_controller;
	}
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Chart
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Chart = core_controller;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Legend
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Legend = plugins.legend._element;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Title
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Title = plugins.title._element;
	
	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.pluginService = core_controller.plugins;
	
	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.PluginBase = core_controller.Element.extend({});
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.canvasHelpers = core_controller.helpers.canvas;
	
	/**
	 * Provided for backward compatibility, use Chart.layouts instead.
	 * @namespace Chart.layoutService
	 * @deprecated since version 2.7.3
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.layoutService = core_controller.layouts;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.LinearScaleBase
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.LinearScaleBase = scale_linearbase;
	
	/**
	 * Provided for backward compatibility, instead we should create a new Chart
	 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	core_controller.helpers.each(
		[
			'Bar',
			'Bubble',
			'Doughnut',
			'Line',
			'PolarArea',
			'Radar',
			'Scatter'
		],
		function(klass) {
			core_controller[klass] = function(ctx, cfg) {
				return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
					type: klass.charAt(0).toLowerCase() + klass.slice(1)
				}));
			};
		}
	);
	
	return src;
	
	})));


/***/ }),
/* 550 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(615);
	module.exports = __webpack_require__(36).RegExp.escape;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(80);
	__webpack_require__(592);
	module.exports = __webpack_require__(17).Array.from;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(95);
	__webpack_require__(80);
	module.exports = __webpack_require__(590);


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(95);
	__webpack_require__(80);
	module.exports = __webpack_require__(591);


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(17);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(594);
	module.exports = __webpack_require__(17).Object.assign;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(595);
	var $Object = __webpack_require__(17).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(600);
	module.exports = __webpack_require__(17).Object.entries;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(596);
	module.exports = __webpack_require__(17).Object.keys;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(601);
	module.exports = __webpack_require__(17).Object.values;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(149);
	__webpack_require__(80);
	__webpack_require__(95);
	__webpack_require__(597);
	__webpack_require__(602);
	__webpack_require__(603);
	module.exports = __webpack_require__(17).Promise;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(149);
	__webpack_require__(80);
	__webpack_require__(95);
	__webpack_require__(598);
	__webpack_require__(606);
	__webpack_require__(605);
	__webpack_require__(604);
	module.exports = __webpack_require__(17).Set;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(599);
	__webpack_require__(149);
	__webpack_require__(607);
	__webpack_require__(608);
	module.exports = __webpack_require__(17).Symbol;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(80);
	__webpack_require__(95);
	module.exports = __webpack_require__(147).f('iterator');


/***/ }),
/* 565 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(90);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(62);
	var toLength = __webpack_require__(106);
	var toAbsoluteIndex = __webpack_require__(588);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(53);
	var IObject = __webpack_require__(135);
	var toObject = __webpack_require__(79);
	var toLength = __webpack_require__(106);
	var asc = __webpack_require__(570);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(40);
	var isArray = __webpack_require__(210);
	var SPECIES = __webpack_require__(22)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(569);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(34).f;
	var create = __webpack_require__(139);
	var redefineAll = __webpack_require__(141);
	var ctx = __webpack_require__(53);
	var anInstance = __webpack_require__(131);
	var forOf = __webpack_require__(90);
	var $iterDefine = __webpack_require__(136);
	var step = __webpack_require__(213);
	var setSpecies = __webpack_require__(220);
	var DESCRIPTORS = __webpack_require__(28);
	var fastKey = __webpack_require__(137).fastKey;
	var validate = __webpack_require__(223);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(105);
	var from = __webpack_require__(566);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(21);
	var $export = __webpack_require__(20);
	var meta = __webpack_require__(137);
	var fails = __webpack_require__(60);
	var hide = __webpack_require__(54);
	var redefineAll = __webpack_require__(141);
	var forOf = __webpack_require__(90);
	var anInstance = __webpack_require__(131);
	var isObject = __webpack_require__(40);
	var setToStringTag = __webpack_require__(94);
	var dP = __webpack_require__(34).f;
	var each = __webpack_require__(568)(0);
	var DESCRIPTORS = __webpack_require__(28);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(34);
	var createDesc = __webpack_require__(93);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(78);
	var gOPS = __webpack_require__(140);
	var pIE = __webpack_require__(92);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 576 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(139);
	var descriptor = __webpack_require__(93);
	var setToStringTag = __webpack_require__(94);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(54)(IteratorPrototype, __webpack_require__(22)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(21);
	var macrotask = __webpack_require__(222).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(89)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(28);
	var getKeys = __webpack_require__(78);
	var gOPS = __webpack_require__(140);
	var pIE = __webpack_require__(92);
	var toObject = __webpack_require__(79);
	var IObject = __webpack_require__(135);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(60)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(34);
	var anObject = __webpack_require__(47);
	var getKeys = __webpack_require__(78);
	
	module.exports = __webpack_require__(28) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(92);
	var createDesc = __webpack_require__(93);
	var toIObject = __webpack_require__(62);
	var toPrimitive = __webpack_require__(145);
	var has = __webpack_require__(61);
	var IE8_DOM_DEFINE = __webpack_require__(208);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(28) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(62);
	var gOPN = __webpack_require__(214).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(61);
	var toObject = __webpack_require__(79);
	var IE_PROTO = __webpack_require__(142)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(20);
	var core = __webpack_require__(17);
	var fails = __webpack_require__(60);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(20);
	var aFunction = __webpack_require__(88);
	var ctx = __webpack_require__(53);
	var forOf = __webpack_require__(90);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(20);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(144);
	var defined = __webpack_require__(132);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(144);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(21);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(47);
	var get = __webpack_require__(148);
	module.exports = __webpack_require__(17).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(105);
	var ITERATOR = __webpack_require__(22)('iterator');
	var Iterators = __webpack_require__(77);
	module.exports = __webpack_require__(17).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(53);
	var $export = __webpack_require__(20);
	var toObject = __webpack_require__(79);
	var call = __webpack_require__(211);
	var isArrayIter = __webpack_require__(209);
	var toLength = __webpack_require__(106);
	var createProperty = __webpack_require__(574);
	var getIterFn = __webpack_require__(148);
	
	$export($export.S + $export.F * !__webpack_require__(212)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(565);
	var step = __webpack_require__(213);
	var Iterators = __webpack_require__(77);
	var toIObject = __webpack_require__(62);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(136)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(20);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(579) });


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(20);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(28), 'Object', { defineProperty: __webpack_require__(34).f });


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(79);
	var $keys = __webpack_require__(78);
	
	__webpack_require__(584)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(91);
	var global = __webpack_require__(21);
	var ctx = __webpack_require__(53);
	var classof = __webpack_require__(105);
	var $export = __webpack_require__(20);
	var isObject = __webpack_require__(40);
	var aFunction = __webpack_require__(88);
	var anInstance = __webpack_require__(131);
	var forOf = __webpack_require__(90);
	var speciesConstructor = __webpack_require__(221);
	var task = __webpack_require__(222).set;
	var microtask = __webpack_require__(578)();
	var newPromiseCapabilityModule = __webpack_require__(138);
	var perform = __webpack_require__(217);
	var userAgent = __webpack_require__(589);
	var promiseResolve = __webpack_require__(218);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(22)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(141)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(94)($Promise, PROMISE);
	__webpack_require__(220)(PROMISE);
	Wrapper = __webpack_require__(17)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(212)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(571);
	var validate = __webpack_require__(223);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(573)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(21);
	var has = __webpack_require__(61);
	var DESCRIPTORS = __webpack_require__(28);
	var $export = __webpack_require__(20);
	var redefine = __webpack_require__(219);
	var META = __webpack_require__(137).KEY;
	var $fails = __webpack_require__(60);
	var shared = __webpack_require__(143);
	var setToStringTag = __webpack_require__(94);
	var uid = __webpack_require__(107);
	var wks = __webpack_require__(22);
	var wksExt = __webpack_require__(147);
	var wksDefine = __webpack_require__(146);
	var enumKeys = __webpack_require__(575);
	var isArray = __webpack_require__(210);
	var anObject = __webpack_require__(47);
	var isObject = __webpack_require__(40);
	var toObject = __webpack_require__(79);
	var toIObject = __webpack_require__(62);
	var toPrimitive = __webpack_require__(145);
	var createDesc = __webpack_require__(93);
	var _create = __webpack_require__(139);
	var gOPNExt = __webpack_require__(582);
	var $GOPD = __webpack_require__(581);
	var $GOPS = __webpack_require__(140);
	var $DP = __webpack_require__(34);
	var $keys = __webpack_require__(78);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(214).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(92).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(91)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(54)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(20);
	var $entries = __webpack_require__(216)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(20);
	var $values = __webpack_require__(216)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(20);
	var core = __webpack_require__(17);
	var global = __webpack_require__(21);
	var speciesConstructor = __webpack_require__(221);
	var promiseResolve = __webpack_require__(218);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(20);
	var newPromiseCapability = __webpack_require__(138);
	var perform = __webpack_require__(217);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(585)('Set');


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(586)('Set');


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(20);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(572)('Set') });


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(146)('asyncIterator');


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(146)('observable');


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	var isArray = __webpack_require__(111);
	var SPECIES = __webpack_require__(9)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(6);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(4);
	var toPrimitive = __webpack_require__(44);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(67);
	var gOPS = __webpack_require__(115);
	var pIE = __webpack_require__(98);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(99)('native-function-to-string', Function.toString);


/***/ }),
/* 614 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(2);
	var $re = __webpack_require__(614)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(225) });
	
	__webpack_require__(55)('copyWithin');


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $every = __webpack_require__(41)(4);
	
	$export($export.P + $export.F * !__webpack_require__(38)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { fill: __webpack_require__(151) });
	
	__webpack_require__(55)('fill');


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $filter = __webpack_require__(41)(2);
	
	$export($export.P + $export.F * !__webpack_require__(38)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(41)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(55)(KEY);


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(41)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(55)(KEY);


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $forEach = __webpack_require__(41)(0);
	var STRICT = __webpack_require__(38)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(37);
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(18);
	var call = __webpack_require__(236);
	var isArrayIter = __webpack_require__(159);
	var toLength = __webpack_require__(12);
	var createProperty = __webpack_require__(153);
	var getIterFn = __webpack_require__(175);
	
	$export($export.S + $export.F * !__webpack_require__(113)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $indexOf = __webpack_require__(108)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(38)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(111) });


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(32);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(97) != Object || !__webpack_require__(38)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(32);
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(12);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(38)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $map = __webpack_require__(41)(1);
	
	$export($export.P + $export.F * !__webpack_require__(38)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var createProperty = __webpack_require__(153);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(6)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(227);
	
	$export($export.P + $export.F * !__webpack_require__(38)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(227);
	
	$export($export.P + $export.F * !__webpack_require__(38)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var html = __webpack_require__(157);
	var cof = __webpack_require__(35);
	var toAbsoluteIndex = __webpack_require__(71);
	var toLength = __webpack_require__(12);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(6)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $some = __webpack_require__(41)(3);
	
	$export($export.P + $export.F * !__webpack_require__(38)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(23);
	var toObject = __webpack_require__(18);
	var fails = __webpack_require__(6);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(38)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70)('Array');


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(2);
	var toISOString = __webpack_require__(610);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(18);
	var toPrimitive = __webpack_require__(44);
	
	$export($export.P + $export.F * __webpack_require__(6)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(9)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(25)(proto, TO_PRIMITIVE, __webpack_require__(611));


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(26)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Function', { bind: __webpack_require__(228) });


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(7);
	var getPrototypeOf = __webpack_require__(31);
	var HAS_INSTANCE = __webpack_require__(9)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(15).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(15).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(14) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(2);
	var log1p = __webpack_require__(239);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(2);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(2);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(2);
	var sign = __webpack_require__(163);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(2);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(2);
	var $expm1 = __webpack_require__(162);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { fround: __webpack_require__(238) });


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(2);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(2);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(6)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(239) });


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { sign: __webpack_require__(163) });


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(162);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(6)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(162);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var has = __webpack_require__(29);
	var cof = __webpack_require__(35);
	var inheritIfRequired = __webpack_require__(158);
	var toPrimitive = __webpack_require__(44);
	var fails = __webpack_require__(6);
	var gOPN = __webpack_require__(66).f;
	var gOPD = __webpack_require__(30).f;
	var dP = __webpack_require__(15).f;
	var $trim = __webpack_require__(84).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(65)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(14) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(26)(global, NUMBER, $Number);
	}


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(2);
	var _isFinite = __webpack_require__(5).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(235) });


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(2);
	var isInteger = __webpack_require__(235);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(247);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(248);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toInteger = __webpack_require__(39);
	var aNumberValue = __webpack_require__(224);
	var repeat = __webpack_require__(170);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(6)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $fails = __webpack_require__(6);
	var aNumberValue = __webpack_require__(224);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(2);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(241) });


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(65) });


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperties: __webpack_require__(242) });


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperty: __webpack_require__(15).f });


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(7);
	var meta = __webpack_require__(57).onFreeze;
	
	__webpack_require__(43)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(32);
	var $getOwnPropertyDescriptor = __webpack_require__(30).f;
	
	__webpack_require__(43)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(43)('getOwnPropertyNames', function () {
	  return __webpack_require__(243).f;
	});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(18);
	var $getPrototypeOf = __webpack_require__(31);
	
	__webpack_require__(43)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(7);
	
	__webpack_require__(43)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(7);
	
	__webpack_require__(43)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(7);
	
	__webpack_require__(43)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { is: __webpack_require__(251) });


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(18);
	var $keys = __webpack_require__(67);
	
	__webpack_require__(43)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(7);
	var meta = __webpack_require__(57).onFreeze;
	
	__webpack_require__(43)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(7);
	var meta = __webpack_require__(57).onFreeze;
	
	__webpack_require__(43)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(167).set });


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(81);
	var test = {};
	test[__webpack_require__(9)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(26)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(247);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(248);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(56);
	var global = __webpack_require__(5);
	var ctx = __webpack_require__(37);
	var classof = __webpack_require__(81);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(7);
	var aFunction = __webpack_require__(23);
	var anInstance = __webpack_require__(63);
	var forOf = __webpack_require__(64);
	var speciesConstructor = __webpack_require__(100);
	var task = __webpack_require__(172).set;
	var microtask = __webpack_require__(164)();
	var newPromiseCapabilityModule = __webpack_require__(165);
	var perform = __webpack_require__(249);
	var userAgent = __webpack_require__(121);
	var promiseResolve = __webpack_require__(250);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(9)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(69)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(83)($Promise, PROMISE);
	__webpack_require__(70)(PROMISE);
	Wrapper = __webpack_require__(36)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(113)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(23);
	var anObject = __webpack_require__(4);
	var rApply = (__webpack_require__(5).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(6)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(2);
	var create = __webpack_require__(65);
	var aFunction = __webpack_require__(23);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var fails = __webpack_require__(6);
	var bind = __webpack_require__(228);
	var rConstruct = (__webpack_require__(5).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(15);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(4);
	var toPrimitive = __webpack_require__(44);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(6)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(2);
	var gOPD = __webpack_require__(30).f;
	var anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(4);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(160)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(30);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(2);
	var getProto = __webpack_require__(31);
	var anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(30);
	var getPrototypeOf = __webpack_require__(31);
	var has = __webpack_require__(29);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(7);
	var anObject = __webpack_require__(4);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(4);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(246) });


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(4);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(2);
	var setProto = __webpack_require__(167);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(15);
	var gOPD = __webpack_require__(30);
	var getPrototypeOf = __webpack_require__(31);
	var has = __webpack_require__(29);
	var $export = __webpack_require__(2);
	var createDesc = __webpack_require__(68);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var inheritIfRequired = __webpack_require__(158);
	var dP = __webpack_require__(15).f;
	var gOPN = __webpack_require__(66).f;
	var isRegExp = __webpack_require__(112);
	var $flags = __webpack_require__(96);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(14) && (!CORRECT_NEW || __webpack_require__(6)(function () {
	  re2[__webpack_require__(9)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(26)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(70)('RegExp');


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(4);
	var toLength = __webpack_require__(12);
	var advanceStringIndex = __webpack_require__(150);
	var regExpExec = __webpack_require__(116);
	
	// @@match logic
	__webpack_require__(110)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(4);
	var toObject = __webpack_require__(18);
	var toLength = __webpack_require__(12);
	var toInteger = __webpack_require__(39);
	var advanceStringIndex = __webpack_require__(150);
	var regExpExec = __webpack_require__(116);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(110)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(4);
	var sameValue = __webpack_require__(251);
	var regExpExec = __webpack_require__(116);
	
	// @@search logic
	__webpack_require__(110)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(112);
	var anObject = __webpack_require__(4);
	var speciesConstructor = __webpack_require__(100);
	var advanceStringIndex = __webpack_require__(150);
	var toLength = __webpack_require__(12);
	var callRegExpExec = __webpack_require__(116);
	var regexpExec = __webpack_require__(166);
	var fails = __webpack_require__(6);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(110)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(257);
	var anObject = __webpack_require__(4);
	var $flags = __webpack_require__(96);
	var DESCRIPTORS = __webpack_require__(14);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(26)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(6)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(27)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(27)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(27)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(27)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(119)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(12);
	var context = __webpack_require__(169);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(156)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(27)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(27)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(27)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toAbsoluteIndex = __webpack_require__(71);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(2);
	var context = __webpack_require__(169);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(156)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(27)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(119)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(161)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(27)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(32);
	var toLength = __webpack_require__(12);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(170)
	});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(27)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(12);
	var context = __webpack_require__(169);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(156)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(27)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(27)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(27)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(84)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(5);
	var has = __webpack_require__(29);
	var DESCRIPTORS = __webpack_require__(14);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(26);
	var META = __webpack_require__(57).KEY;
	var $fails = __webpack_require__(6);
	var shared = __webpack_require__(99);
	var setToStringTag = __webpack_require__(83);
	var uid = __webpack_require__(72);
	var wks = __webpack_require__(9);
	var wksExt = __webpack_require__(254);
	var wksDefine = __webpack_require__(174);
	var enumKeys = __webpack_require__(612);
	var isArray = __webpack_require__(111);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var toObject = __webpack_require__(18);
	var toIObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(44);
	var createDesc = __webpack_require__(68);
	var _create = __webpack_require__(65);
	var gOPNExt = __webpack_require__(243);
	var $GOPD = __webpack_require__(30);
	var $GOPS = __webpack_require__(115);
	var $DP = __webpack_require__(15);
	var $keys = __webpack_require__(67);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(66).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(98).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(56)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(25)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $typed = __webpack_require__(120);
	var buffer = __webpack_require__(173);
	var anObject = __webpack_require__(4);
	var toAbsoluteIndex = __webpack_require__(71);
	var toLength = __webpack_require__(12);
	var isObject = __webpack_require__(7);
	var ArrayBuffer = __webpack_require__(5).ArrayBuffer;
	var speciesConstructor = __webpack_require__(100);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(6)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(70)(ARRAY_BUFFER);


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	$export($export.G + $export.W + $export.F * !__webpack_require__(120).ABV, {
	  DataView: __webpack_require__(173).DataView
	});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(231);
	var validate = __webpack_require__(73);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(109)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(232);
	var toObject = __webpack_require__(18);
	var toLength = __webpack_require__(12);
	var aFunction = __webpack_require__(23);
	var arraySpeciesCreate = __webpack_require__(152);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(55)('flatMap');


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(232);
	var toObject = __webpack_require__(18);
	var toLength = __webpack_require__(12);
	var toInteger = __webpack_require__(39);
	var arraySpeciesCreate = __webpack_require__(152);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(55)('flatten');


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(2);
	var $includes = __webpack_require__(108)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(55)('includes');


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(2);
	var microtask = __webpack_require__(164)();
	var process = __webpack_require__(5).process;
	var isNode = __webpack_require__(35)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(2);
	var cof = __webpack_require__(35);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.G, { global: __webpack_require__(5) });


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(117)('Map');


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(118)('Map');


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(230)('Map') });


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var scale = __webpack_require__(240);
	var fround = __webpack_require__(238);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { scale: __webpack_require__(240) });


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(18);
	var aFunction = __webpack_require__(23);
	var $defineProperty = __webpack_require__(15);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(14) && $export($export.P + __webpack_require__(114), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(18);
	var aFunction = __webpack_require__(23);
	var $defineProperty = __webpack_require__(15);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(14) && $export($export.P + __webpack_require__(114), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $entries = __webpack_require__(245)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(2);
	var ownKeys = __webpack_require__(246);
	var toIObject = __webpack_require__(32);
	var gOPD = __webpack_require__(30);
	var createProperty = __webpack_require__(153);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(18);
	var toPrimitive = __webpack_require__(44);
	var getPrototypeOf = __webpack_require__(31);
	var getOwnPropertyDescriptor = __webpack_require__(30).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(14) && $export($export.P + __webpack_require__(114), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(18);
	var toPrimitive = __webpack_require__(44);
	var getPrototypeOf = __webpack_require__(31);
	var getOwnPropertyDescriptor = __webpack_require__(30).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(14) && $export($export.P + __webpack_require__(114), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $values = __webpack_require__(245)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(2);
	var global = __webpack_require__(5);
	var core = __webpack_require__(36);
	var microtask = __webpack_require__(164)();
	var OBSERVABLE = __webpack_require__(9)('observable');
	var aFunction = __webpack_require__(23);
	var anObject = __webpack_require__(4);
	var anInstance = __webpack_require__(63);
	var redefineAll = __webpack_require__(69);
	var hide = __webpack_require__(25);
	var forOf = __webpack_require__(64);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(70)('Observable');


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(2);
	var core = __webpack_require__(36);
	var global = __webpack_require__(5);
	var speciesConstructor = __webpack_require__(100);
	var promiseResolve = __webpack_require__(250);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(2);
	var newPromiseCapability = __webpack_require__(165);
	var perform = __webpack_require__(249);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(4);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(4);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(258);
	var from = __webpack_require__(226);
	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(4);
	var getPrototypeOf = __webpack_require__(31);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(4);
	var getPrototypeOf = __webpack_require__(31);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(4);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(4);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(4);
	var getPrototypeOf = __webpack_require__(31);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(4);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(48);
	var anObject = __webpack_require__(4);
	var aFunction = __webpack_require__(23);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(117)('Set');


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(118)('Set');


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(230)('Set') });


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(119)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(2);
	var defined = __webpack_require__(42);
	var toLength = __webpack_require__(12);
	var isRegExp = __webpack_require__(112);
	var getFlags = __webpack_require__(96);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(160)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(252);
	var userAgent = __webpack_require__(121);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(252);
	var userAgent = __webpack_require__(121);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(84)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(84)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(174)('asyncIterator');


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(174)('observable');


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.S, 'System', { global: __webpack_require__(5) });


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(117)('WeakMap');


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(118)('WeakMap');


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(117)('WeakSet');


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(118)('WeakSet');


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(176);
	var getKeys = __webpack_require__(67);
	var redefine = __webpack_require__(26);
	var global = __webpack_require__(5);
	var hide = __webpack_require__(25);
	var Iterators = __webpack_require__(82);
	var wks = __webpack_require__(9);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $task = __webpack_require__(172);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(5);
	var $export = __webpack_require__(2);
	var userAgent = __webpack_require__(121);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(735);
	__webpack_require__(674);
	__webpack_require__(676);
	__webpack_require__(675);
	__webpack_require__(678);
	__webpack_require__(680);
	__webpack_require__(685);
	__webpack_require__(679);
	__webpack_require__(677);
	__webpack_require__(687);
	__webpack_require__(686);
	__webpack_require__(682);
	__webpack_require__(683);
	__webpack_require__(681);
	__webpack_require__(673);
	__webpack_require__(684);
	__webpack_require__(688);
	__webpack_require__(689);
	__webpack_require__(641);
	__webpack_require__(643);
	__webpack_require__(642);
	__webpack_require__(691);
	__webpack_require__(690);
	__webpack_require__(661);
	__webpack_require__(671);
	__webpack_require__(672);
	__webpack_require__(662);
	__webpack_require__(663);
	__webpack_require__(664);
	__webpack_require__(665);
	__webpack_require__(666);
	__webpack_require__(667);
	__webpack_require__(668);
	__webpack_require__(669);
	__webpack_require__(670);
	__webpack_require__(644);
	__webpack_require__(645);
	__webpack_require__(646);
	__webpack_require__(647);
	__webpack_require__(648);
	__webpack_require__(649);
	__webpack_require__(650);
	__webpack_require__(651);
	__webpack_require__(652);
	__webpack_require__(653);
	__webpack_require__(654);
	__webpack_require__(655);
	__webpack_require__(656);
	__webpack_require__(657);
	__webpack_require__(658);
	__webpack_require__(659);
	__webpack_require__(660);
	__webpack_require__(722);
	__webpack_require__(727);
	__webpack_require__(734);
	__webpack_require__(725);
	__webpack_require__(717);
	__webpack_require__(718);
	__webpack_require__(723);
	__webpack_require__(728);
	__webpack_require__(730);
	__webpack_require__(713);
	__webpack_require__(714);
	__webpack_require__(715);
	__webpack_require__(716);
	__webpack_require__(719);
	__webpack_require__(720);
	__webpack_require__(721);
	__webpack_require__(724);
	__webpack_require__(726);
	__webpack_require__(729);
	__webpack_require__(731);
	__webpack_require__(732);
	__webpack_require__(733);
	__webpack_require__(636);
	__webpack_require__(638);
	__webpack_require__(637);
	__webpack_require__(640);
	__webpack_require__(639);
	__webpack_require__(625);
	__webpack_require__(623);
	__webpack_require__(629);
	__webpack_require__(626);
	__webpack_require__(632);
	__webpack_require__(634);
	__webpack_require__(622);
	__webpack_require__(628);
	__webpack_require__(619);
	__webpack_require__(633);
	__webpack_require__(617);
	__webpack_require__(631);
	__webpack_require__(630);
	__webpack_require__(624);
	__webpack_require__(627);
	__webpack_require__(616);
	__webpack_require__(618);
	__webpack_require__(621);
	__webpack_require__(620);
	__webpack_require__(635);
	__webpack_require__(176);
	__webpack_require__(707);
	__webpack_require__(256);
	__webpack_require__(712);
	__webpack_require__(257);
	__webpack_require__(708);
	__webpack_require__(709);
	__webpack_require__(710);
	__webpack_require__(711);
	__webpack_require__(692);
	__webpack_require__(255);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(747);
	__webpack_require__(736);
	__webpack_require__(737);
	__webpack_require__(742);
	__webpack_require__(745);
	__webpack_require__(746);
	__webpack_require__(740);
	__webpack_require__(743);
	__webpack_require__(741);
	__webpack_require__(744);
	__webpack_require__(738);
	__webpack_require__(739);
	__webpack_require__(693);
	__webpack_require__(694);
	__webpack_require__(695);
	__webpack_require__(696);
	__webpack_require__(697);
	__webpack_require__(700);
	__webpack_require__(698);
	__webpack_require__(699);
	__webpack_require__(701);
	__webpack_require__(702);
	__webpack_require__(703);
	__webpack_require__(704);
	__webpack_require__(706);
	__webpack_require__(705);
	__webpack_require__(750);
	__webpack_require__(748);
	__webpack_require__(749);
	__webpack_require__(791);
	__webpack_require__(794);
	__webpack_require__(793);
	__webpack_require__(795);
	__webpack_require__(796);
	__webpack_require__(792);
	__webpack_require__(797);
	__webpack_require__(798);
	__webpack_require__(772);
	__webpack_require__(775);
	__webpack_require__(771);
	__webpack_require__(769);
	__webpack_require__(770);
	__webpack_require__(773);
	__webpack_require__(774);
	__webpack_require__(756);
	__webpack_require__(790);
	__webpack_require__(755);
	__webpack_require__(789);
	__webpack_require__(801);
	__webpack_require__(803);
	__webpack_require__(754);
	__webpack_require__(788);
	__webpack_require__(800);
	__webpack_require__(802);
	__webpack_require__(753);
	__webpack_require__(799);
	__webpack_require__(752);
	__webpack_require__(757);
	__webpack_require__(758);
	__webpack_require__(759);
	__webpack_require__(760);
	__webpack_require__(761);
	__webpack_require__(763);
	__webpack_require__(762);
	__webpack_require__(764);
	__webpack_require__(765);
	__webpack_require__(766);
	__webpack_require__(768);
	__webpack_require__(767);
	__webpack_require__(777);
	__webpack_require__(778);
	__webpack_require__(779);
	__webpack_require__(780);
	__webpack_require__(782);
	__webpack_require__(781);
	__webpack_require__(784);
	__webpack_require__(783);
	__webpack_require__(785);
	__webpack_require__(786);
	__webpack_require__(787);
	__webpack_require__(751);
	__webpack_require__(776);
	__webpack_require__(806);
	__webpack_require__(805);
	__webpack_require__(804);
	module.exports = __webpack_require__(36);


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug.debug = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(871);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting
	    args = exports.formatArgs.apply(self, args);
	
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 809 */
/***/ (function(module, exports) {

	'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function(key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function(key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var sourceIsArray = Array.isArray(source);
	    var targetIsArray = Array.isArray(target);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
	    if (!sourceAndTargetTypesMatch) {
	        return cloneIfNecessary(source, optionsArgument)
	    } else if (sourceIsArray) {
	        var arrayMerge = options.arrayMerge || defaultArrayMerge;
	        return arrayMerge(target, source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	var deepmerge_1 = deepmerge;
	
	module.exports = deepmerge_1;


/***/ }),
/* 810 */
/***/ (function(module, exports) {

	module.exports = function dequal(foo, bar) {
		var ctor, len;
		if (foo === bar) return true;
		if (foo && bar && (ctor=foo.constructor) === bar.constructor) {
			if (ctor === Date) return foo.getTime() === bar.getTime();
			if (ctor === RegExp) return foo.toString() === bar.toString();
			if (ctor === Array && (len=foo.length) === bar.length) {
				while (len-- && dequal(foo[len], bar[len]));
				return len === -1;
			}
			if (ctor === Object) {
				if (Object.keys(foo).length !== Object.keys(bar).length) return false;
				for (len in foo) if (!(len in bar) || !dequal(foo[len], bar[len])) return false;
				return true;
			}
		}
		return foo !== foo && bar !== bar;
	}


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	var detectBrowser = __webpack_require__(812);
	
	var agent;
	
	if (typeof navigator !== 'undefined' && navigator) {
	  agent = navigator.userAgent;
	}
	
	module.exports = detectBrowser(agent);


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	var detectOS = __webpack_require__(813);
	
	module.exports = function detectBrowser(userAgentString) {
	  if (!userAgentString) return null;
	
	  var browsers = [
	    [ 'edge', /Edge\/([0-9\._]+)/ ],
	    [ 'yandexbrowser', /YaBrowser\/([0-9\._]+)/ ],
	    [ 'vivaldi', /Vivaldi\/([0-9\.]+)/ ],
	    [ 'kakaotalk', /KAKAOTALK\s([0-9\.]+)/ ],
	    [ 'chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'crios', /CriOS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'firefox', /Firefox\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'fxios', /FxiOS\/([0-9\.]+)/ ],
	    [ 'opera', /Opera\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'opera', /OPR\/([0-9\.]+)(:?\s|$)$/ ],
	    [ 'ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/ ],
	    [ 'ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/ ],
	    [ 'ie', /MSIE\s(7\.0)/ ],
	    [ 'bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/ ],
	    [ 'android', /Android\s([0-9\.]+)/ ],
	    [ 'ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/ ],
	    [ 'safari', /Version\/([0-9\._]+).*Safari/ ]
	  ];
	
	  return browsers.map(function (rule) {
	      if (rule[1].test(userAgentString)) {
	          var match = rule[1].exec(userAgentString);
	          var version = match && match[1].split(/[._]/).slice(0,3);
	
	          if (version && version.length < 3) {
	              Array.prototype.push.apply(version, (version.length == 1) ? [0, 0] : [0]);
	          }
	
	          return {
	              name: rule[0],
	              version: version.join('.'),
	              os: detectOS(userAgentString)
	          };
	      }
	  }).filter(Boolean).shift();
	};


/***/ }),
/* 813 */
/***/ (function(module, exports) {

	module.exports = function detectOS(userAgentString) {
	  var operatingSystems = [
	    {
	      name: 'iOS',
	      rule: /iP(hone|od|ad)/
	    },
	    {
	      name: 'Android OS',
	      rule: /Android/
	    },
	    {
	      name: 'BlackBerry OS',
	      rule: /BlackBerry|BB10/
	    },
	    {
	      name: 'Windows Mobile',
	      rule: /IEMobile/
	    },
	    {
	      name: 'Amazon OS',
	      rule: /Kindle/
	    },
	    {
	      name: 'Windows 3.11',
	      rule: /Win16/
	    },
	    {
	      name: 'Windows 95',
	      rule: /(Windows 95)|(Win95)|(Windows_95)/
	    },
	    {
	      name: 'Windows 98',
	      rule: /(Windows 98)|(Win98)/
	    },
	    {
	      name: 'Windows 2000',
	      rule: /(Windows NT 5.0)|(Windows 2000)/
	    },
	    {
	      name: 'Windows XP',
	      rule: /(Windows NT 5.1)|(Windows XP)/
	    },
	    {
	      name: 'Windows Server 2003',
	      rule: /(Windows NT 5.2)/
	    },
	    {
	      name: 'Windows Vista',
	      rule: /(Windows NT 6.0)/
	    },
	    {
	      name: 'Windows 7',
	      rule: /(Windows NT 6.1)/
	    },
	    {
	      name: 'Windows 8',
	      rule: /(Windows NT 6.2)/
	    },
	    {
	      name: 'Windows 8.1',
	      rule: /(Windows NT 6.3)/
	    },
	    {
	      name: 'Windows 10',
	      rule: /(Windows NT 10.0)/
	    },
	    {
	      name: 'Windows ME',
	      rule: /Windows ME/
	    },
	    {
	      name: 'Open BSD',
	      rule: /OpenBSD/
	    },
	    {
	      name: 'Sun OS',
	      rule: /SunOS/
	    },
	    {
	      name: 'Linux',
	      rule: /(Linux)|(X11)/
	    },
	    {
	      name: 'Mac OS',
	      rule: /(Mac_PowerPC)|(Macintosh)/
	    },
	    {
	      name: 'QNX',
	      rule: /QNX/
	    },
	    {
	      name: 'BeOS',
	      rule: /BeOS/
	    },
	    {
	      name: 'OS/2',
	      rule: /OS\/2/
	    },
	    {
	      name: 'Search Bot',
	      rule: /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/
	    }
	  ];
	
	  var detected = operatingSystems.filter(function (os) {
	    if (userAgentString.match(os.rule)) {
	      return true;
	    }
	  });
	
	  return detected && detected[0] ? detected[0].name : null;
	};


/***/ }),
/* 814 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 99);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 99:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-button-group" }, [_vm._t("default")], 2)
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var button_groupvue_type_script_lang_js_ = ({
	  name: 'ElButtonGroup'
	});
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_button_groupvue_type_script_lang_js_ = (button_groupvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_button_groupvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/button/src/button-group.vue"
	/* harmony default export */ var button_group = (component.exports);
	// CONCATENATED MODULE: ./packages/button-group/index.js
	
	
	/* istanbul ignore next */
	button_group.install = function (Vue) {
	  Vue.component(button_group.name, button_group);
	};
	
	/* harmony default export */ var packages_button_group = __webpack_exports__["default"] = (button_group);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 97);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 97:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "button",
	    {
	      staticClass: "el-button",
	      class: [
	        _vm.type ? "el-button--" + _vm.type : "",
	        _vm.buttonSize ? "el-button--" + _vm.buttonSize : "",
	        {
	          "is-disabled": _vm.buttonDisabled,
	          "is-loading": _vm.loading,
	          "is-plain": _vm.plain,
	          "is-round": _vm.round,
	          "is-circle": _vm.circle
	        }
	      ],
	      attrs: {
	        disabled: _vm.buttonDisabled || _vm.loading,
	        autofocus: _vm.autofocus,
	        type: _vm.nativeType
	      },
	      on: { click: _vm.handleClick }
	    },
	    [
	      _vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(),
	      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
	      _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
	  name: 'ElButton',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    size: String,
	    icon: {
	      type: String,
	      default: ''
	    },
	    nativeType: {
	      type: String,
	      default: 'button'
	    },
	    loading: Boolean,
	    disabled: Boolean,
	    plain: Boolean,
	    autofocus: Boolean,
	    round: Boolean,
	    circle: Boolean
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    buttonSize: function buttonSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    buttonDisabled: function buttonDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(evt) {
	      this.$emit('click', evt);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/button/src/button.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_buttonvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/button/src/button.vue"
	/* harmony default export */ var src_button = (component.exports);
	// CONCATENATED MODULE: ./packages/button/index.js
	
	
	/* istanbul ignore next */
	src_button.install = function (Vue) {
	  Vue.component(src_button.name, src_button);
	};
	
	/* harmony default export */ var packages_button = __webpack_exports__["default"] = (src_button);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 59);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 14:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(180);
	
	/***/ }),
	
	/***/ 18:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(260);
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(123);
	
	/***/ }),
	
	/***/ 26:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(194);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(45);
	
	/***/ }),
	
	/***/ 31:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(183);
	
	/***/ }),
	
	/***/ 32:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(181);
	
	/***/ }),
	
	/***/ 51:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(262);
	
	/***/ }),
	
	/***/ 59:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	var cascader_panelvue_type_template_id_34932346_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: ["el-cascader-panel", _vm.border && "is-bordered"],
	      on: { keydown: _vm.handleKeyDown }
	    },
	    _vm._l(_vm.menus, function(menu, index) {
	      return _c("cascader-menu", {
	        key: index,
	        ref: "menu",
	        refInFor: true,
	        attrs: { index: index, nodes: menu }
	      })
	    }),
	    1
	  )
	}
	var staticRenderFns = []
	cascader_panelvue_type_template_id_34932346_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	
	// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
	var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(26);
	var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);
	
	// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
	var scrollbar_ = __webpack_require__(14);
	var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);
	
	// EXTERNAL MODULE: external "element-ui/lib/checkbox"
	var checkbox_ = __webpack_require__(18);
	var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);
	
	// EXTERNAL MODULE: external "element-ui/lib/radio"
	var radio_ = __webpack_require__(51);
	var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	
	/* harmony default export */ var cascader_nodevue_type_script_lang_js_ = ({
	  inject: ['panel'],
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElRadio: radio_default.a
	  },
	
	  props: {
	    node: {
	      required: true
	    },
	    nodeId: String
	  },
	
	  computed: {
	    config: function config() {
	      return this.panel.config;
	    },
	    isLeaf: function isLeaf() {
	      return this.node.isLeaf;
	    },
	    isDisabled: function isDisabled() {
	      return this.node.isDisabled;
	    },
	    checkedValue: function checkedValue() {
	      return this.panel.checkedValue;
	    },
	    isChecked: function isChecked() {
	      return this.node.isSameNode(this.checkedValue);
	    },
	    inActivePath: function inActivePath() {
	      return this.isInPath(this.panel.activePath);
	    },
	    inCheckedPath: function inCheckedPath() {
	      var _this = this;
	
	      if (!this.config.checkStrictly) return false;
	
	      return this.panel.checkedNodePaths.some(function (checkedPath) {
	        return _this.isInPath(checkedPath);
	      });
	    },
	    value: function value() {
	      return this.node.getValueByOption();
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand() {
	      var _this2 = this;
	
	      var panel = this.panel,
	          node = this.node,
	          isDisabled = this.isDisabled,
	          config = this.config;
	      var multiple = config.multiple,
	          checkStrictly = config.checkStrictly;
	
	
	      if (!checkStrictly && isDisabled || node.loading) return;
	
	      if (config.lazy && !node.loaded) {
	        panel.lazyLoad(node, function () {
	          // do not use cached leaf value here, invoke this.isLeaf to get new value.
	          var isLeaf = _this2.isLeaf;
	
	
	          if (!isLeaf) _this2.handleExpand();
	          if (multiple) {
	            // if leaf sync checked state, else clear checked state
	            var checked = isLeaf ? node.checked : false;
	            _this2.handleMultiCheckChange(checked);
	          }
	        });
	      } else {
	        panel.handleExpand(node);
	      }
	    },
	    handleCheckChange: function handleCheckChange() {
	      var panel = this.panel,
	          value = this.value,
	          node = this.node;
	
	      panel.handleCheckChange(value);
	      panel.handleExpand(node);
	    },
	    handleMultiCheckChange: function handleMultiCheckChange(checked) {
	      this.node.doCheck(checked);
	      this.panel.calculateMultiCheckedValue();
	    },
	    isInPath: function isInPath(pathNodes) {
	      var node = this.node;
	
	      var selectedPathNode = pathNodes[node.level - 1] || {};
	      return selectedPathNode.uid === node.uid;
	    },
	    renderPrefix: function renderPrefix(h) {
	      var isLeaf = this.isLeaf,
	          isChecked = this.isChecked,
	          config = this.config;
	      var checkStrictly = config.checkStrictly,
	          multiple = config.multiple;
	
	
	      if (multiple) {
	        return this.renderCheckbox(h);
	      } else if (checkStrictly) {
	        return this.renderRadio(h);
	      } else if (isLeaf && isChecked) {
	        return this.renderCheckIcon(h);
	      }
	
	      return null;
	    },
	    renderPostfix: function renderPostfix(h) {
	      var node = this.node,
	          isLeaf = this.isLeaf;
	
	
	      if (node.loading) {
	        return this.renderLoadingIcon(h);
	      } else if (!isLeaf) {
	        return this.renderExpandIcon(h);
	      }
	
	      return null;
	    },
	    renderCheckbox: function renderCheckbox(h) {
	      var node = this.node,
	          config = this.config,
	          isDisabled = this.isDisabled;
	
	      var events = {
	        on: { change: this.handleMultiCheckChange },
	        nativeOn: {}
	      };
	
	      if (config.checkStrictly) {
	        // when every node is selectable, click event should not trigger expand event.
	        events.nativeOn.click = stopPropagation;
	      }
	
	      return h('el-checkbox', external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          value: node.checked,
	          indeterminate: node.indeterminate,
	          disabled: isDisabled
	        }
	      }, events]));
	    },
	    renderRadio: function renderRadio(h) {
	      var checkedValue = this.checkedValue,
	          value = this.value,
	          isDisabled = this.isDisabled;
	
	      // to keep same reference if value cause radio's checked state is calculated by reference comparision;
	
	      if (Object(util_["isEqual"])(value, checkedValue)) {
	        value = checkedValue;
	      }
	
	      return h(
	        'el-radio',
	        {
	          attrs: {
	            value: checkedValue,
	            label: value,
	            disabled: isDisabled
	          },
	          on: {
	            'change': this.handleCheckChange
	          },
	          nativeOn: {
	            'click': stopPropagation
	          }
	        },
	        [h('span')]
	      );
	    },
	    renderCheckIcon: function renderCheckIcon(h) {
	      return h('i', { 'class': 'el-icon-check el-cascader-node__prefix' });
	    },
	    renderLoadingIcon: function renderLoadingIcon(h) {
	      return h('i', { 'class': 'el-icon-loading el-cascader-node__postfix' });
	    },
	    renderExpandIcon: function renderExpandIcon(h) {
	      return h('i', { 'class': 'el-icon-arrow-right el-cascader-node__postfix' });
	    },
	    renderContent: function renderContent(h) {
	      var panel = this.panel,
	          node = this.node;
	
	      var render = panel.renderLabelFn;
	      var vnode = render ? render({ node: node, data: node.data }) : null;
	
	      return h(
	        'span',
	        { 'class': 'el-cascader-node__label' },
	        [vnode || node.label]
	      );
	    }
	  },
	
	  render: function render(h) {
	    var _this3 = this;
	
	    var inActivePath = this.inActivePath,
	        inCheckedPath = this.inCheckedPath,
	        isChecked = this.isChecked,
	        isLeaf = this.isLeaf,
	        isDisabled = this.isDisabled,
	        config = this.config,
	        nodeId = this.nodeId;
	    var expandTrigger = config.expandTrigger,
	        checkStrictly = config.checkStrictly,
	        multiple = config.multiple;
	
	    var disabled = !checkStrictly && isDisabled;
	    var events = { on: {} };
	
	    if (expandTrigger === 'click') {
	      events.on.click = this.handleExpand;
	    } else {
	      events.on.mouseenter = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	      events.on.focus = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	    }
	    if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
	      events.on.click = this.handleCheckChange;
	    }
	
	    return h(
	      'li',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          role: 'menuitem',
	          id: nodeId,
	          'aria-expanded': inActivePath,
	          tabindex: disabled ? null : -1
	        },
	        'class': {
	          'el-cascader-node': true,
	          'is-selectable': checkStrictly,
	          'in-active-path': inActivePath,
	          'in-checked-path': inCheckedPath,
	          'is-active': isChecked,
	          'is-disabled': disabled
	        }
	      }, events]),
	      [this.renderPrefix(h), this.renderContent(h), this.renderPostfix(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_nodevue_type_script_lang_js_ = (cascader_nodevue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
	var cascader_node_render, cascader_node_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_cascader_nodevue_type_script_lang_js_,
	  cascader_node_render,
	  cascader_node_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/cascader-panel/src/cascader-node.vue"
	/* harmony default export */ var cascader_node = (component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
	var locale_ = __webpack_require__(6);
	var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	/* harmony default export */ var cascader_menuvue_type_script_lang_js_ = ({
	  name: 'ElCascaderMenu',
	
	  mixins: [locale_default.a],
	
	  inject: ['panel'],
	
	  components: {
	    ElScrollbar: scrollbar_default.a,
	    CascaderNode: cascader_node
	  },
	
	  props: {
	    nodes: {
	      type: Array,
	      required: true
	    },
	    index: Number
	  },
	
	  data: function data() {
	    return {
	      activeNode: null,
	      hoverTimer: null,
	      id: Object(util_["generateId"])()
	    };
	  },
	
	
	  computed: {
	    isEmpty: function isEmpty() {
	      return !this.nodes.length;
	    },
	    menuId: function menuId() {
	      return 'cascader-menu-' + this.id + '-' + this.index;
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand(e) {
	      this.activeNode = e.target;
	    },
	    handleMouseMove: function handleMouseMove(e) {
	      var activeNode = this.activeNode,
	          hoverTimer = this.hoverTimer;
	      var hoverZone = this.$refs.hoverZone;
	
	
	      if (!activeNode || !hoverZone) return;
	
	      if (activeNode.contains(e.target)) {
	        clearTimeout(hoverTimer);
	
	        var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
	            left = _$el$getBoundingClien.left;
	
	        var startX = e.clientX - left;
	        var _$el = this.$el,
	            offsetWidth = _$el.offsetWidth,
	            offsetHeight = _$el.offsetHeight;
	
	        var top = activeNode.offsetTop;
	        var bottom = top + activeNode.offsetHeight;
	
	        hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + top + ' L' + offsetWidth + ' 0 V' + top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + bottom + ' L' + offsetWidth + ' ' + offsetHeight + ' V' + bottom + ' Z" />\n        ';
	      } else if (!hoverTimer) {
	        this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold);
	      }
	    },
	    clearHoverZone: function clearHoverZone() {
	      var hoverZone = this.$refs.hoverZone;
	
	      if (!hoverZone) return;
	      hoverZone.innerHTML = '';
	    },
	    renderEmptyText: function renderEmptyText(h) {
	      return h(
	        'div',
	        { 'class': 'el-cascader-menu__empty-text' },
	        [this.t('el.cascader.noData')]
	      );
	    },
	    renderNodeList: function renderNodeList(h) {
	      var menuId = this.menuId;
	      var isHoverMenu = this.panel.isHoverMenu;
	
	      var events = { on: {} };
	
	      if (isHoverMenu) {
	        events.on.expand = this.handleExpand;
	      }
	
	      var nodes = this.nodes.map(function (node, index) {
	        var hasChildren = node.hasChildren;
	
	        return h('cascader-node', external_babel_helper_vue_jsx_merge_props_default()([{
	          key: node.uid,
	          attrs: { node: node,
	            'node-id': menuId + '-' + index,
	            'aria-haspopup': hasChildren,
	            'aria-owns': hasChildren ? menuId : null
	          }
	        }, events]));
	      });
	
	      return [].concat(nodes, [isHoverMenu ? h('svg', { ref: 'hoverZone', 'class': 'el-cascader-menu__hover-zone' }) : null]);
	    }
	  },
	
	  render: function render(h) {
	    var isEmpty = this.isEmpty,
	        menuId = this.menuId;
	
	    var events = { nativeOn: {} };
	
	    // optimize hover to expand experience (#8010)
	    if (this.panel.isHoverMenu) {
	      events.nativeOn.mousemove = this.handleMouseMove;
	      // events.nativeOn.mouseleave = this.clearHoverZone;
	    }
	
	    return h(
	      'el-scrollbar',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          tag: 'ul',
	          role: 'menu',
	          id: menuId,
	
	          'wrap-class': 'el-cascader-menu__wrap',
	          'view-class': {
	            'el-cascader-menu__list': true,
	            'is-empty': isEmpty
	          }
	        },
	        'class': 'el-cascader-menu' }, events]),
	      [isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_menuvue_type_script_lang_js_ = (cascader_menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
	var cascader_menu_render, cascader_menu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var cascader_menu_component = Object(componentNormalizer["a" /* default */])(
	  src_cascader_menuvue_type_script_lang_js_,
	  cascader_menu_render,
	  cascader_menu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_menu_api; }
	cascader_menu_component.options.__file = "packages/cascader-panel/src/cascader-menu.vue"
	/* harmony default export */ var cascader_menu = (cascader_menu_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(21);
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var uid = 0;
	
	var node_Node = function () {
	  function Node(data, config, parentNode) {
	    _classCallCheck(this, Node);
	
	    this.data = data;
	    this.config = config;
	    this.parent = parentNode || null;
	    this.level = !this.parent ? 1 : this.parent.level + 1;
	    this.uid = uid++;
	
	    this.initState();
	    this.initChildren();
	  }
	
	  Node.prototype.initState = function initState() {
	    var _config = this.config,
	        valueKey = _config.value,
	        labelKey = _config.label;
	
	
	    this.value = this.data[valueKey];
	    this.label = this.data[labelKey];
	    this.pathNodes = this.calculatePathNodes();
	    this.path = this.pathNodes.map(function (node) {
	      return node.value;
	    });
	    this.pathLabels = this.pathNodes.map(function (node) {
	      return node.label;
	    });
	
	    // lazy load
	    this.loading = false;
	    this.loaded = false;
	  };
	
	  Node.prototype.initChildren = function initChildren() {
	    var _this = this;
	
	    var config = this.config;
	
	    var childrenKey = config.children;
	    var childrenData = this.data[childrenKey];
	    this.hasChildren = Array.isArray(childrenData);
	    this.children = (childrenData || []).map(function (child) {
	      return new Node(child, config, _this);
	    });
	  };
	
	  Node.prototype.calculatePathNodes = function calculatePathNodes() {
	    var nodes = [this];
	    var parent = this.parent;
	
	    while (parent) {
	      nodes.unshift(parent);
	      parent = parent.parent;
	    }
	
	    return nodes;
	  };
	
	  Node.prototype.getPath = function getPath() {
	    return this.path;
	  };
	
	  Node.prototype.getValue = function getValue() {
	    return this.value;
	  };
	
	  Node.prototype.getValueByOption = function getValueByOption() {
	    return this.config.emitPath ? this.getPath() : this.getValue();
	  };
	
	  Node.prototype.getText = function getText(allLevels, separator) {
	    return allLevels ? this.pathLabels.join(separator) : this.label;
	  };
	
	  Node.prototype.isSameNode = function isSameNode(checkedValue) {
	    var value = this.getValueByOption();
	    return this.config.multiple && Array.isArray(checkedValue) ? checkedValue.some(function (val) {
	      return Object(util_["isEqual"])(val, value);
	    }) : Object(util_["isEqual"])(checkedValue, value);
	  };
	
	  Node.prototype.broadcast = function broadcast(event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var handlerName = 'onParent' + Object(util_["capitalize"])(event);
	
	    this.children.forEach(function (child) {
	      if (child) {
	        // bottom up
	        child.broadcast.apply(child, [event].concat(args));
	        child[handlerName] && child[handlerName].apply(child, args);
	      }
	    });
	  };
	
	  Node.prototype.emit = function emit(event) {
	    var parent = this.parent;
	
	    var handlerName = 'onChild' + Object(util_["capitalize"])(event);
	    if (parent) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      parent[handlerName] && parent[handlerName].apply(parent, args);
	      parent.emit.apply(parent, [event].concat(args));
	    }
	  };
	
	  Node.prototype.onParentCheck = function onParentCheck(checked) {
	    if (!this.isDisabled) {
	      this.setCheckState(checked);
	    }
	  };
	
	  Node.prototype.onChildCheck = function onChildCheck() {
	    var children = this.children;
	
	    var validChildren = children.filter(function (child) {
	      return !child.isDisabled;
	    });
	    var checked = validChildren.length ? validChildren.every(function (child) {
	      return child.checked;
	    }) : false;
	
	    this.setCheckState(checked);
	  };
	
	  Node.prototype.setCheckState = function setCheckState(checked) {
	    var totalNum = this.children.length;
	    var checkedNum = this.children.reduce(function (c, p) {
	      var num = p.checked ? 1 : p.indeterminate ? 0.5 : 0;
	      return c + num;
	    }, 0);
	
	    this.checked = checked;
	    this.indeterminate = checkedNum !== totalNum && checkedNum > 0;
	  };
	
	  Node.prototype.syncCheckState = function syncCheckState(checkedValue) {
	    var value = this.getValueByOption();
	    var checked = this.isSameNode(checkedValue, value);
	
	    this.doCheck(checked);
	  };
	
	  Node.prototype.doCheck = function doCheck(checked) {
	    if (this.checked !== checked) {
	      if (this.config.checkStrictly) {
	        this.checked = checked;
	      } else {
	        // bottom up to unify the calculation of the indeterminate state
	        this.broadcast('check', checked);
	        this.setCheckState(checked);
	        this.emit('check');
	      }
	    }
	  };
	
	  _createClass(Node, [{
	    key: 'isDisabled',
	    get: function get() {
	      var data = this.data,
	          parent = this.parent,
	          config = this.config;
	
	      var disabledKey = config.disabled;
	      var checkStrictly = config.checkStrictly;
	
	      return data[disabledKey] || !checkStrictly && parent && parent.isDisabled;
	    }
	  }, {
	    key: 'isLeaf',
	    get: function get() {
	      var data = this.data,
	          loaded = this.loaded,
	          hasChildren = this.hasChildren,
	          children = this.children;
	      var _config2 = this.config,
	          lazy = _config2.lazy,
	          leafKey = _config2.leaf;
	
	      if (lazy) {
	        var isLeaf = Object(shared_["isDef"])(data[leafKey]) ? data[leafKey] : loaded ? !children.length : false;
	        this.hasChildren = !isLeaf;
	        return isLeaf;
	      }
	      return !hasChildren;
	    }
	  }]);
	
	  return Node;
	}();
	
	/* harmony default export */ var src_node = (node_Node);
	// CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
	function store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var flatNodes = function flatNodes(data, leafOnly) {
	  return data.reduce(function (res, node) {
	    if (node.isLeaf) {
	      res.push(node);
	    } else {
	      !leafOnly && res.push(node);
	      res = res.concat(flatNodes(node.children, leafOnly));
	    }
	    return res;
	  }, []);
	};
	
	var store_Store = function () {
	  function Store(data, config) {
	    store_classCallCheck(this, Store);
	
	    this.config = config;
	    this.initNodes(data);
	  }
	
	  Store.prototype.initNodes = function initNodes(data) {
	    var _this = this;
	
	    data = Object(util_["coerceTruthyValueToArray"])(data);
	    this.nodes = data.map(function (nodeData) {
	      return new src_node(nodeData, _this.config);
	    });
	    this.flattedNodes = this.getFlattedNodes(false, false);
	    this.leafNodes = this.getFlattedNodes(true, false);
	  };
	
	  Store.prototype.appendNode = function appendNode(nodeData, parentNode) {
	    var node = new src_node(nodeData, this.config, parentNode);
	    var children = parentNode ? parentNode.children : this.nodes;
	
	    children.push(node);
	  };
	
	  Store.prototype.appendNodes = function appendNodes(nodeDataList, parentNode) {
	    var _this2 = this;
	
	    nodeDataList = Object(util_["coerceTruthyValueToArray"])(nodeDataList);
	    nodeDataList.forEach(function (nodeData) {
	      return _this2.appendNode(nodeData, parentNode);
	    });
	  };
	
	  Store.prototype.getNodes = function getNodes() {
	    return this.nodes;
	  };
	
	  Store.prototype.getFlattedNodes = function getFlattedNodes(leafOnly) {
	    var cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var cachedNodes = leafOnly ? this.leafNodes : this.flattedNodes;
	    return cached ? cachedNodes : flatNodes(this.nodes, leafOnly);
	  };
	
	  Store.prototype.getNodeByValue = function getNodeByValue(value) {
	    if (value) {
	      var nodes = this.getFlattedNodes(false, !this.config.lazy).filter(function (node) {
	        return Object(util_["valueEquals"])(node.path, value) || node.value === value;
	      });
	      return nodes && nodes.length ? nodes[0] : null;
	    }
	    return null;
	  };
	
	  return Store;
	}();
	
	/* harmony default export */ var src_store = (store_Store);
	// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
	var merge_ = __webpack_require__(9);
	var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
	var aria_utils_ = __webpack_require__(32);
	var aria_utils_default = /*#__PURE__*/__webpack_require__.n(aria_utils_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
	var scroll_into_view_ = __webpack_require__(31);
	var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var KeyCode = aria_utils_default.a.keys;
	
	var DefaultProps = {
	  expandTrigger: 'click', // or hover
	  multiple: false,
	  checkStrictly: false, // whether all nodes can be selected
	  emitPath: true, // wether to emit an array of all levels value in which node is located
	  lazy: false,
	  lazyLoad: util_["noop"],
	  value: 'value',
	  label: 'label',
	  children: 'children',
	  leaf: 'leaf',
	  disabled: 'disabled',
	  hoverThreshold: 500
	};
	
	var cascader_panelvue_type_script_lang_js_isLeaf = function isLeaf(el) {
	  return !el.getAttribute('aria-owns');
	};
	
	var getSibling = function getSibling(el, distance) {
	  var parentNode = el.parentNode;
	
	  if (parentNode) {
	    var siblings = parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');
	    var index = Array.prototype.indexOf.call(siblings, el);
	    return siblings[index + distance] || null;
	  }
	  return null;
	};
	
	var getMenuIndex = function getMenuIndex(el, distance) {
	  if (!el) return;
	  var pieces = el.id.split('-');
	  return Number(pieces[pieces.length - 2]);
	};
	
	var focusNode = function focusNode(el) {
	  if (!el) return;
	  el.focus();
	  !cascader_panelvue_type_script_lang_js_isLeaf(el) && el.click();
	};
	
	var checkNode = function checkNode(el) {
	  if (!el) return;
	
	  var input = el.querySelector('input');
	  if (input) {
	    input.click();
	  } else if (cascader_panelvue_type_script_lang_js_isLeaf(el)) {
	    el.click();
	  }
	};
	
	/* harmony default export */ var cascader_panelvue_type_script_lang_js_ = ({
	  name: 'ElCascaderPanel',
	
	  components: {
	    CascaderMenu: cascader_menu
	  },
	
	  props: {
	    value: {},
	    options: Array,
	    props: Object,
	    border: {
	      type: Boolean,
	      default: true
	    },
	    renderLabel: Function
	  },
	
	  provide: function provide() {
	    return {
	      panel: this
	    };
	  },
	  data: function data() {
	    return {
	      checkedValue: null,
	      checkedNodePaths: [],
	      store: [],
	      menus: [],
	      activePath: [],
	      loadCount: 0
	    };
	  },
	
	
	  computed: {
	    config: function config() {
	      return merge_default()(_extends({}, DefaultProps), this.props || {});
	    },
	    multiple: function multiple() {
	      return this.config.multiple;
	    },
	    checkStrictly: function checkStrictly() {
	      return this.config.checkStrictly;
	    },
	    leafOnly: function leafOnly() {
	      return !this.checkStrictly;
	    },
	    isHoverMenu: function isHoverMenu() {
	      return this.config.expandTrigger === 'hover';
	    },
	    renderLabelFn: function renderLabelFn() {
	      return this.renderLabel || this.$scopedSlots.default;
	    }
	  },
	
	  watch: {
	    options: {
	      handler: function handler() {
	        this.initStore();
	      },
	      immediate: true,
	      deep: true
	    },
	    value: function value() {
	      this.syncCheckedValue();
	      this.checkStrictly && this.calculateCheckedNodePaths();
	    },
	    checkedValue: function checkedValue(val) {
	      if (!Object(util_["isEqual"])(val, this.value)) {
	        this.checkStrictly && this.calculateCheckedNodePaths();
	        this.$emit('input', val);
	        this.$emit('change', val);
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    if (!Object(util_["isEmpty"])(this.value)) {
	      this.syncCheckedValue();
	    }
	  },
	
	
	  methods: {
	    initStore: function initStore() {
	      var config = this.config,
	          options = this.options;
	
	      if (config.lazy && Object(util_["isEmpty"])(options)) {
	        this.lazyLoad();
	      } else {
	        this.store = new src_store(options, config);
	        this.menus = [this.store.getNodes()];
	        this.syncMenuState();
	      }
	    },
	    syncCheckedValue: function syncCheckedValue() {
	      var value = this.value,
	          checkedValue = this.checkedValue;
	
	      if (!Object(util_["isEqual"])(value, checkedValue)) {
	        this.checkedValue = value;
	        this.syncMenuState();
	      }
	    },
	    syncMenuState: function syncMenuState() {
	      var multiple = this.multiple,
	          checkStrictly = this.checkStrictly;
	
	      this.syncActivePath();
	      multiple && this.syncMultiCheckState();
	      checkStrictly && this.calculateCheckedNodePaths();
	      this.$nextTick(this.scrollIntoView);
	    },
	    syncMultiCheckState: function syncMultiCheckState() {
	      var _this = this;
	
	      var nodes = this.getFlattedNodes(this.leafOnly);
	
	      nodes.forEach(function (node) {
	        node.syncCheckState(_this.checkedValue);
	      });
	    },
	    syncActivePath: function syncActivePath() {
	      var _this2 = this;
	
	      var store = this.store,
	          multiple = this.multiple,
	          activePath = this.activePath,
	          checkedValue = this.checkedValue;
	
	
	      if (!Object(util_["isEmpty"])(activePath)) {
	        var nodes = activePath.map(function (node) {
	          return _this2.getNodeByValue(node.getValue());
	        });
	        this.expandNodes(nodes);
	      } else if (!Object(util_["isEmpty"])(checkedValue)) {
	        var value = multiple ? checkedValue[0] : checkedValue;
	        var checkedNode = this.getNodeByValue(value) || {};
	        var _nodes = (checkedNode.pathNodes || []).slice(0, -1);
	        this.expandNodes(_nodes);
	      } else {
	        this.activePath = [];
	        this.menus = [store.getNodes()];
	      }
	    },
	    expandNodes: function expandNodes(nodes) {
	      var _this3 = this;
	
	      nodes.forEach(function (node) {
	        return _this3.handleExpand(node, true /* silent */);
	      });
	    },
	    calculateCheckedNodePaths: function calculateCheckedNodePaths() {
	      var _this4 = this;
	
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      var checkedValues = multiple ? Object(util_["coerceTruthyValueToArray"])(checkedValue) : [checkedValue];
	      this.checkedNodePaths = checkedValues.map(function (v) {
	        var checkedNode = _this4.getNodeByValue(v);
	        return checkedNode ? checkedNode.pathNodes : [];
	      });
	    },
	    handleKeyDown: function handleKeyDown(e) {
	      var target = e.target,
	          keyCode = e.keyCode;
	
	
	      switch (keyCode) {
	        case KeyCode.up:
	          var prev = getSibling(target, -1);
	          focusNode(prev);
	          break;
	        case KeyCode.down:
	          var next = getSibling(target, 1);
	          focusNode(next);
	          break;
	        case KeyCode.left:
	          var preMenu = this.$refs.menu[getMenuIndex(target) - 1];
	          if (preMenu) {
	            var expandedNode = preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
	            focusNode(expandedNode);
	          }
	          break;
	        case KeyCode.right:
	          var nextMenu = this.$refs.menu[getMenuIndex(target) + 1];
	          if (nextMenu) {
	            var firstNode = nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');
	            focusNode(firstNode);
	          }
	          break;
	        case KeyCode.enter:
	          checkNode(target);
	          break;
	        case KeyCode.esc:
	        case KeyCode.tab:
	          this.$emit('close');
	          break;
	        default:
	          return;
	      }
	    },
	    handleExpand: function handleExpand(node, silent) {
	      var activePath = this.activePath;
	      var level = node.level;
	
	      var path = activePath.slice(0, level - 1);
	      var menus = this.menus.slice(0, level);
	
	      if (!node.isLeaf) {
	        path.push(node);
	        menus.push(node.children);
	      }
	
	      this.activePath = path;
	      this.menus = menus;
	
	      if (!silent) {
	        var pathValues = path.map(function (node) {
	          return node.getValue();
	        });
	        var activePathValues = activePath.map(function (node) {
	          return node.getValue();
	        });
	        if (!Object(util_["valueEquals"])(pathValues, activePathValues)) {
	          this.$emit('active-item-change', pathValues); // Deprecated
	          this.$emit('expand-change', pathValues);
	        }
	      }
	    },
	    handleCheckChange: function handleCheckChange(value) {
	      this.checkedValue = value;
	    },
	    lazyLoad: function lazyLoad(node, onFullfiled) {
	      var _this5 = this;
	
	      var config = this.config;
	
	      if (!node) {
	        node = node || { root: true, level: 0 };
	        this.store = new src_store([], config);
	        this.menus = [this.store.getNodes()];
	      }
	      node.loading = true;
	      var resolve = function resolve(dataList) {
	        var parent = node.root ? null : node;
	        dataList && dataList.length && _this5.store.appendNodes(dataList, parent);
	        node.loading = false;
	        node.loaded = true;
	
	        // dispose default value on lazy load mode
	        if (Array.isArray(_this5.checkedValue)) {
	          var nodeValue = _this5.checkedValue[_this5.loadCount++];
	          var valueKey = _this5.config.value;
	          var leafKey = _this5.config.leaf;
	
	          if (Array.isArray(dataList) && dataList.filter(function (item) {
	            return item[valueKey] === nodeValue;
	          }).length > 0) {
	            var checkedNode = _this5.store.getNodeByValue(nodeValue);
	
	            if (!checkedNode.data[leafKey]) {
	              _this5.lazyLoad(checkedNode, function () {
	                _this5.handleExpand(checkedNode);
	              });
	            }
	
	            if (_this5.loadCount === _this5.checkedValue.length) {
	              _this5.$parent.computePresentText();
	            }
	          }
	        }
	
	        onFullfiled && onFullfiled(dataList);
	      };
	      config.lazyLoad(node, resolve);
	    },
	
	
	    /**
	     * public methods
	    */
	    calculateMultiCheckedValue: function calculateMultiCheckedValue() {
	      this.checkedValue = this.getCheckedNodes(this.leafOnly).map(function (node) {
	        return node.getValueByOption();
	      });
	    },
	    scrollIntoView: function scrollIntoView() {
	      if (this.$isServer) return;
	
	      var menus = this.$refs.menu || [];
	      menus.forEach(function (menu) {
	        var menuElement = menu.$el;
	        if (menuElement) {
	          var container = menuElement.querySelector('.el-scrollbar__wrap');
	          var activeNode = menuElement.querySelector('.el-cascader-node.is-active') || menuElement.querySelector('.el-cascader-node.in-active-path');
	          scroll_into_view_default()(container, activeNode);
	        }
	      });
	    },
	    getNodeByValue: function getNodeByValue(val) {
	      return this.store.getNodeByValue(val);
	    },
	    getFlattedNodes: function getFlattedNodes(leafOnly) {
	      var cached = !this.config.lazy;
	      return this.store.getFlattedNodes(leafOnly, cached);
	    },
	    getCheckedNodes: function getCheckedNodes(leafOnly) {
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      if (multiple) {
	        var nodes = this.getFlattedNodes(leafOnly);
	        return nodes.filter(function (node) {
	          return node.checked;
	        });
	      } else {
	        return Object(util_["isEmpty"])(checkedValue) ? [] : [this.getNodeByValue(checkedValue)];
	      }
	    },
	    clearCheckedNodes: function clearCheckedNodes() {
	      var config = this.config,
	          leafOnly = this.leafOnly;
	      var multiple = config.multiple,
	          emitPath = config.emitPath;
	
	      if (multiple) {
	        this.getCheckedNodes(leafOnly).filter(function (node) {
	          return !node.isDisabled;
	        }).forEach(function (node) {
	          return node.doCheck(false);
	        });
	        this.calculateMultiCheckedValue();
	      } else {
	        this.checkedValue = emitPath ? [] : null;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_panelvue_type_script_lang_js_ = (cascader_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var cascader_panel_component = Object(componentNormalizer["a" /* default */])(
	  src_cascader_panelvue_type_script_lang_js_,
	  cascader_panelvue_type_template_id_34932346_render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_panel_api; }
	cascader_panel_component.options.__file = "packages/cascader-panel/src/cascader-panel.vue"
	/* harmony default export */ var cascader_panel = (cascader_panel_component.exports);
	// CONCATENATED MODULE: ./packages/cascader-panel/index.js
	
	
	/* istanbul ignore next */
	cascader_panel.install = function (Vue) {
	  Vue.component(cascader_panel.name, cascader_panel);
	};
	
	/* harmony default export */ var packages_cascader_panel = __webpack_exports__["default"] = (cascader_panel);
	
	/***/ }),
	
	/***/ 6:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(179);
	
	/***/ }),
	
	/***/ 9:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(122);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 86);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(74);
	
	/***/ }),
	
	/***/ 86:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-checkbox-group",
	      attrs: { role: "group", "aria-label": "checkbox-group" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	
	
	
	/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
	  name: 'ElCheckboxGroup',
	
	  componentName: 'ElCheckboxGroup',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    value: {},
	    disabled: Boolean,
	    min: Number,
	    max: Number,
	    size: String,
	    fill: String,
	    textColor: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxGroupSize: function checkboxGroupSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', [_value]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_checkbox_groupvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/checkbox/src/checkbox-group.vue"
	/* harmony default export */ var checkbox_group = (component.exports);
	// CONCATENATED MODULE: ./packages/checkbox-group/index.js
	
	
	/* istanbul ignore next */
	checkbox_group.install = function (Vue) {
	  Vue.component(checkbox_group.name, checkbox_group);
	};
	
	/* harmony default export */ var packages_checkbox_group = __webpack_exports__["default"] = (checkbox_group);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 45);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(830);
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(50);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(45);
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(74);
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(179);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(124);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(19);
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(122);
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(177);
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(261);
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(264);
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(85);
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(815);
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(182);
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(266);
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(125);
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(260);
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(180);
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(267);
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(123);
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(265);
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(827);
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(178);
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(833);
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(194);
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(190);
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(826);
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(183);
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(181);
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(814);
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(263);
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(184);
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(817);
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(828);
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(824);
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(888);
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(825);
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(822);
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(872);
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(829);
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(422);
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(819);
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(816);
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(262);
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(823);
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(46);
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
	var pagervue_type_template_id_7274f267_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "ul",
	    { staticClass: "el-pager", on: { click: _vm.onPagerClick } },
	    [
	      _vm.pageCount > 0
	        ? _c(
	            "li",
	            {
	              staticClass: "number",
	              class: { active: _vm.currentPage === 1, disabled: _vm.disabled }
	            },
	            [_vm._v("1")]
	          )
	        : _vm._e(),
	      _vm.showPrevMore
	        ? _c("li", {
	            staticClass: "el-icon more btn-quickprev",
	            class: [_vm.quickprevIconClass, { disabled: _vm.disabled }],
	            on: {
	              mouseenter: function($event) {
	                _vm.onMouseenter("left")
	              },
	              mouseleave: function($event) {
	                _vm.quickprevIconClass = "el-icon-more"
	              }
	            }
	          })
	        : _vm._e(),
	      _vm._l(_vm.pagers, function(pager) {
	        return _c(
	          "li",
	          {
	            key: pager,
	            staticClass: "number",
	            class: { active: _vm.currentPage === pager, disabled: _vm.disabled }
	          },
	          [_vm._v(_vm._s(pager))]
	        )
	      }),
	      _vm.showNextMore
	        ? _c("li", {
	            staticClass: "el-icon more btn-quicknext",
	            class: [_vm.quicknextIconClass, { disabled: _vm.disabled }],
	            on: {
	              mouseenter: function($event) {
	                _vm.onMouseenter("right")
	              },
	              mouseleave: function($event) {
	                _vm.quicknextIconClass = "el-icon-more"
	              }
	            }
	          })
	        : _vm._e(),
	      _vm.pageCount > 1
	        ? _c(
	            "li",
	            {
	              staticClass: "number",
	              class: {
	                active: _vm.currentPage === _vm.pageCount,
	                disabled: _vm.disabled
	              }
	            },
	            [_vm._v(_vm._s(_vm.pageCount))]
	          )
	        : _vm._e()
	    ],
	    2
	  )
	}
	var staticRenderFns = []
	pagervue_type_template_id_7274f267_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var pagervue_type_script_lang_js_ = ({
	  name: 'ElPager',
	
	  props: {
	    currentPage: Number,
	
	    pageCount: Number,
	
	    pagerCount: Number,
	
	    disabled: Boolean
	  },
	
	  watch: {
	    showPrevMore: function showPrevMore(val) {
	      if (!val) this.quickprevIconClass = 'el-icon-more';
	    },
	    showNextMore: function showNextMore(val) {
	      if (!val) this.quicknextIconClass = 'el-icon-more';
	    }
	  },
	
	  methods: {
	    onPagerClick: function onPagerClick(event) {
	      var target = event.target;
	      if (target.tagName === 'UL' || this.disabled) {
	        return;
	      }
	
	      var newPage = Number(event.target.textContent);
	      var pageCount = this.pageCount;
	      var currentPage = this.currentPage;
	      var pagerCountOffset = this.pagerCount - 2;
	
	      if (target.className.indexOf('more') !== -1) {
	        if (target.className.indexOf('quickprev') !== -1) {
	          newPage = currentPage - pagerCountOffset;
	        } else if (target.className.indexOf('quicknext') !== -1) {
	          newPage = currentPage + pagerCountOffset;
	        }
	      }
	
	      /* istanbul ignore if */
	      if (!isNaN(newPage)) {
	        if (newPage < 1) {
	          newPage = 1;
	        }
	
	        if (newPage > pageCount) {
	          newPage = pageCount;
	        }
	      }
	
	      if (newPage !== currentPage) {
	        this.$emit('change', newPage);
	      }
	    },
	    onMouseenter: function onMouseenter(direction) {
	      if (this.disabled) return;
	      if (direction === 'left') {
	        this.quickprevIconClass = 'el-icon-d-arrow-left';
	      } else {
	        this.quicknextIconClass = 'el-icon-d-arrow-right';
	      }
	    }
	  },
	
	  computed: {
	    pagers: function pagers() {
	      var pagerCount = this.pagerCount;
	      var halfPagerCount = (pagerCount - 1) / 2;
	
	      var currentPage = Number(this.currentPage);
	      var pageCount = Number(this.pageCount);
	
	      var showPrevMore = false;
	      var showNextMore = false;
	
	      if (pageCount > pagerCount) {
	        if (currentPage > pagerCount - halfPagerCount) {
	          showPrevMore = true;
	        }
	
	        if (currentPage < pageCount - halfPagerCount) {
	          showNextMore = true;
	        }
	      }
	
	      var array = [];
	
	      if (showPrevMore && !showNextMore) {
	        var startPage = pageCount - (pagerCount - 2);
	        for (var i = startPage; i < pageCount; i++) {
	          array.push(i);
	        }
	      } else if (!showPrevMore && showNextMore) {
	        for (var _i = 2; _i < pagerCount; _i++) {
	          array.push(_i);
	        }
	      } else if (showPrevMore && showNextMore) {
	        var offset = Math.floor(pagerCount / 2) - 1;
	        for (var _i2 = currentPage - offset; _i2 <= currentPage + offset; _i2++) {
	          array.push(_i2);
	        }
	      } else {
	        for (var _i3 = 2; _i3 < pageCount; _i3++) {
	          array.push(_i3);
	        }
	      }
	
	      this.showPrevMore = showPrevMore;
	      this.showNextMore = showNextMore;
	
	      return array;
	    }
	  },
	
	  data: function data() {
	    return {
	      current: null,
	      showPrevMore: false,
	      showNextMore: false,
	      quicknextIconClass: 'el-icon-more',
	      quickprevIconClass: 'el-icon-more'
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_pagervue_type_script_lang_js_ = (pagervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	// CONCATENATED MODULE: ./packages/pagination/src/pager.vue
	
	
	
	
	
	/* normalize component */
	
	var component = normalizeComponent(
	  src_pagervue_type_script_lang_js_,
	  pagervue_type_template_id_7274f267_render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/pagination/src/pager.vue"
	/* harmony default export */ var pager = (component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/select"
	var select_ = __webpack_require__(36);
	var select_default = /*#__PURE__*/__webpack_require__.n(select_);
	
	// EXTERNAL MODULE: external "element-ui/lib/option"
	var option_ = __webpack_require__(37);
	var option_default = /*#__PURE__*/__webpack_require__.n(option_);
	
	// EXTERNAL MODULE: external "element-ui/lib/input"
	var input_ = __webpack_require__(8);
	var input_default = /*#__PURE__*/__webpack_require__.n(input_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
	var locale_ = __webpack_require__(4);
	var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(2);
	
	// CONCATENATED MODULE: ./packages/pagination/src/pagination.js
	
	
	
	
	
	
	
	/* harmony default export */ var pagination = ({
	  name: 'ElPagination',
	
	  props: {
	    pageSize: {
	      type: Number,
	      default: 10
	    },
	
	    small: Boolean,
	
	    total: Number,
	
	    pageCount: Number,
	
	    pagerCount: {
	      type: Number,
	      validator: function validator(value) {
	        return (value | 0) === value && value > 4 && value < 22 && value % 2 === 1;
	      },
	
	      default: 7
	    },
	
	    currentPage: {
	      type: Number,
	      default: 1
	    },
	
	    layout: {
	      default: 'prev, pager, next, jumper, ->, total'
	    },
	
	    pageSizes: {
	      type: Array,
	      default: function _default() {
	        return [10, 20, 30, 40, 50, 100];
	      }
	    },
	
	    popperClass: String,
	
	    prevText: String,
	
	    nextText: String,
	
	    background: Boolean,
	
	    disabled: Boolean,
	
	    hideOnSinglePage: Boolean
	  },
	
	  data: function data() {
	    return {
	      internalCurrentPage: 1,
	      internalPageSize: 0,
	      lastEmittedPage: -1,
	      userChangePageSize: false
	    };
	  },
	  render: function render(h) {
	    var layout = this.layout;
	    if (!layout) return null;
	    if (this.hideOnSinglePage && (!this.internalPageCount || this.internalPageCount === 1)) return null;
	
	    var template = h('div', { 'class': ['el-pagination', {
	        'is-background': this.background,
	        'el-pagination--small': this.small
	      }] });
	    var TEMPLATE_MAP = {
	      prev: h('prev'),
	      jumper: h('jumper'),
	      pager: h('pager', {
	        attrs: { currentPage: this.internalCurrentPage, pageCount: this.internalPageCount, pagerCount: this.pagerCount, disabled: this.disabled },
	        on: {
	          'change': this.handleCurrentChange
	        }
	      }),
	      next: h('next'),
	      sizes: h('sizes', {
	        attrs: { pageSizes: this.pageSizes }
	      }),
	      slot: h('slot', [this.$slots.default ? this.$slots.default : '']),
	      total: h('total')
	    };
	    var components = layout.split(',').map(function (item) {
	      return item.trim();
	    });
	    var rightWrapper = h('div', { 'class': 'el-pagination__rightwrapper' });
	    var haveRightWrapper = false;
	
	    template.children = template.children || [];
	    rightWrapper.children = rightWrapper.children || [];
	    components.forEach(function (compo) {
	      if (compo === '->') {
	        haveRightWrapper = true;
	        return;
	      }
	
	      if (!haveRightWrapper) {
	        template.children.push(TEMPLATE_MAP[compo]);
	      } else {
	        rightWrapper.children.push(TEMPLATE_MAP[compo]);
	      }
	    });
	
	    if (haveRightWrapper) {
	      template.children.unshift(rightWrapper);
	    }
	
	    return template;
	  },
	
	
	  components: {
	    Prev: {
	      render: function render(h) {
	        return h(
	          'button',
	          {
	            attrs: {
	              type: 'button',
	
	              disabled: this.$parent.disabled || this.$parent.internalCurrentPage <= 1
	            },
	            'class': 'btn-prev', on: {
	              'click': this.$parent.prev
	            }
	          },
	          [this.$parent.prevText ? h('span', [this.$parent.prevText]) : h('i', { 'class': 'el-icon el-icon-arrow-left' })]
	        );
	      }
	    },
	
	    Next: {
	      render: function render(h) {
	        return h(
	          'button',
	          {
	            attrs: {
	              type: 'button',
	
	              disabled: this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0
	            },
	            'class': 'btn-next', on: {
	              'click': this.$parent.next
	            }
	          },
	          [this.$parent.nextText ? h('span', [this.$parent.nextText]) : h('i', { 'class': 'el-icon el-icon-arrow-right' })]
	        );
	      }
	    },
	
	    Sizes: {
	      mixins: [locale_default.a],
	
	      props: {
	        pageSizes: Array
	      },
	
	      watch: {
	        pageSizes: {
	          immediate: true,
	          handler: function handler(newVal, oldVal) {
	            if (Object(util_["valueEquals"])(newVal, oldVal)) return;
	            if (Array.isArray(newVal)) {
	              this.$parent.internalPageSize = newVal.indexOf(this.$parent.pageSize) > -1 ? this.$parent.pageSize : this.pageSizes[0];
	            }
	          }
	        }
	      },
	
	      render: function render(h) {
	        var _this = this;
	
	        return h(
	          'span',
	          { 'class': 'el-pagination__sizes' },
	          [h(
	            'el-select',
	            {
	              attrs: {
	                value: this.$parent.internalPageSize,
	                popperClass: this.$parent.popperClass || '',
	                size: 'mini',
	
	                disabled: this.$parent.disabled },
	              on: {
	                'input': this.handleChange
	              }
	            },
	            [this.pageSizes.map(function (item) {
	              return h('el-option', {
	                attrs: {
	                  value: item,
	                  label: item + _this.t('el.pagination.pagesize') }
	              });
	            })]
	          )]
	        );
	      },
	
	
	      components: {
	        ElSelect: select_default.a,
	        ElOption: option_default.a
	      },
	
	      methods: {
	        handleChange: function handleChange(val) {
	          if (val !== this.$parent.internalPageSize) {
	            this.$parent.internalPageSize = val = parseInt(val, 10);
	            this.$parent.userChangePageSize = true;
	            this.$parent.$emit('update:pageSize', val);
	            this.$parent.$emit('size-change', val);
	          }
	        }
	      }
	    },
	
	    Jumper: {
	      mixins: [locale_default.a],
	
	      components: { ElInput: input_default.a },
	
	      data: function data() {
	        return {
	          userInput: null
	        };
	      },
	
	
	      watch: {
	        '$parent.internalCurrentPage': function $parentInternalCurrentPage() {
	          this.userInput = null;
	        }
	      },
	
	      methods: {
	        handleKeyup: function handleKeyup(_ref) {
	          var keyCode = _ref.keyCode,
	              target = _ref.target;
	
	          // Chrome, Safari, Firefox triggers change event on Enter
	          // Hack for IE: https://github.com/ElemeFE/element/issues/11710
	          // Drop this method when we no longer supports IE
	          if (keyCode === 13) {
	            this.handleChange(target.value);
	          }
	        },
	        handleInput: function handleInput(value) {
	          this.userInput = value;
	        },
	        handleChange: function handleChange(value) {
	          this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(value);
	          this.$parent.emitChange();
	          this.userInput = null;
	        }
	      },
	
	      render: function render(h) {
	        return h(
	          'span',
	          { 'class': 'el-pagination__jump' },
	          [this.t('el.pagination.goto'), h('el-input', {
	            'class': 'el-pagination__editor is-in-pagination',
	            attrs: { min: 1,
	              max: this.$parent.internalPageCount,
	              value: this.userInput !== null ? this.userInput : this.$parent.internalCurrentPage,
	              type: 'number',
	              disabled: this.$parent.disabled
	            },
	            nativeOn: {
	              'keyup': this.handleKeyup
	            },
	            on: {
	              'input': this.handleInput,
	              'change': this.handleChange
	            }
	          }), this.t('el.pagination.pageClassifier')]
	        );
	      }
	    },
	
	    Total: {
	      mixins: [locale_default.a],
	
	      render: function render(h) {
	        return typeof this.$parent.total === 'number' ? h(
	          'span',
	          { 'class': 'el-pagination__total' },
	          [this.t('el.pagination.total', { total: this.$parent.total })]
	        ) : '';
	      }
	    },
	
	    Pager: pager
	  },
	
	  methods: {
	    handleCurrentChange: function handleCurrentChange(val) {
	      this.internalCurrentPage = this.getValidCurrentPage(val);
	      this.userChangePageSize = true;
	      this.emitChange();
	    },
	    prev: function prev() {
	      if (this.disabled) return;
	      var newVal = this.internalCurrentPage - 1;
	      this.internalCurrentPage = this.getValidCurrentPage(newVal);
	      this.$emit('prev-click', this.internalCurrentPage);
	      this.emitChange();
	    },
	    next: function next() {
	      if (this.disabled) return;
	      var newVal = this.internalCurrentPage + 1;
	      this.internalCurrentPage = this.getValidCurrentPage(newVal);
	      this.$emit('next-click', this.internalCurrentPage);
	      this.emitChange();
	    },
	    getValidCurrentPage: function getValidCurrentPage(value) {
	      value = parseInt(value, 10);
	
	      var havePageCount = typeof this.internalPageCount === 'number';
	
	      var resetValue = void 0;
	      if (!havePageCount) {
	        if (isNaN(value) || value < 1) resetValue = 1;
	      } else {
	        if (value < 1) {
	          resetValue = 1;
	        } else if (value > this.internalPageCount) {
	          resetValue = this.internalPageCount;
	        }
	      }
	
	      if (resetValue === undefined && isNaN(value)) {
	        resetValue = 1;
	      } else if (resetValue === 0) {
	        resetValue = 1;
	      }
	
	      return resetValue === undefined ? value : resetValue;
	    },
	    emitChange: function emitChange() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        if (_this2.internalCurrentPage !== _this2.lastEmittedPage || _this2.userChangePageSize) {
	          _this2.$emit('current-change', _this2.internalCurrentPage);
	          _this2.lastEmittedPage = _this2.internalCurrentPage;
	          _this2.userChangePageSize = false;
	        }
	      });
	    }
	  },
	
	  computed: {
	    internalPageCount: function internalPageCount() {
	      if (typeof this.total === 'number') {
	        return Math.max(1, Math.ceil(this.total / this.internalPageSize));
	      } else if (typeof this.pageCount === 'number') {
	        return Math.max(1, this.pageCount);
	      }
	      return null;
	    }
	  },
	
	  watch: {
	    currentPage: {
	      immediate: true,
	      handler: function handler(val) {
	        this.internalCurrentPage = this.getValidCurrentPage(val);
	      }
	    },
	
	    pageSize: {
	      immediate: true,
	      handler: function handler(val) {
	        this.internalPageSize = isNaN(val) ? 10 : val;
	      }
	    },
	
	    internalCurrentPage: {
	      immediate: true,
	      handler: function handler(newVal) {
	        this.$emit('update:currentPage', newVal);
	        this.lastEmittedPage = -1;
	      }
	    },
	
	    internalPageCount: function internalPageCount(newVal) {
	      /* istanbul ignore if */
	      var oldPage = this.internalCurrentPage;
	      if (newVal > 0 && oldPage === 0) {
	        this.internalCurrentPage = 1;
	      } else if (oldPage > newVal) {
	        this.internalCurrentPage = newVal === 0 ? 1 : newVal;
	        this.userChangePageSize && this.emitChange();
	      }
	      this.userChangePageSize = false;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/pagination/index.js
	
	
	/* istanbul ignore next */
	pagination.install = function (Vue) {
	  Vue.component(pagination.name, pagination);
	};
	
	/* harmony default export */ var packages_pagination = (pagination);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
	var componentvue_type_template_id_60140e62_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "dialog-fade" },
	      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-dialog__wrapper",
	          on: {
	            click: function($event) {
	              if ($event.target !== $event.currentTarget) {
	                return null
	              }
	              return _vm.handleWrapperClick($event)
	            }
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              key: _vm.key,
	              ref: "dialog",
	              class: [
	                "el-dialog",
	                {
	                  "is-fullscreen": _vm.fullscreen,
	                  "el-dialog--center": _vm.center
	                },
	                _vm.customClass
	              ],
	              style: _vm.style,
	              attrs: {
	                role: "dialog",
	                "aria-modal": "true",
	                "aria-label": _vm.title || "dialog"
	              }
	            },
	            [
	              _c(
	                "div",
	                { staticClass: "el-dialog__header" },
	                [
	                  _vm._t("title", [
	                    _c("span", { staticClass: "el-dialog__title" }, [
	                      _vm._v(_vm._s(_vm.title))
	                    ])
	                  ]),
	                  _vm.showClose
	                    ? _c(
	                        "button",
	                        {
	                          staticClass: "el-dialog__headerbtn",
	                          attrs: { type: "button", "aria-label": "Close" },
	                          on: { click: _vm.handleClose }
	                        },
	                        [
	                          _c("i", {
	                            staticClass:
	                              "el-dialog__close el-icon el-icon-close"
	                          })
	                        ]
	                      )
	                    : _vm._e()
	                ],
	                2
	              ),
	              _vm.rendered
	                ? _c(
	                    "div",
	                    { staticClass: "el-dialog__body" },
	                    [_vm._t("default")],
	                    2
	                  )
	                : _vm._e(),
	              _vm.$slots.footer
	                ? _c(
	                    "div",
	                    { staticClass: "el-dialog__footer" },
	                    [_vm._t("footer")],
	                    2
	                  )
	                : _vm._e()
	            ]
	          )
	        ]
	      )
	    ]
	  )
	}
	var componentvue_type_template_id_60140e62_staticRenderFns = []
	componentvue_type_template_id_60140e62_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/popup"
	var popup_ = __webpack_require__(14);
	var popup_default = /*#__PURE__*/__webpack_require__.n(popup_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
	var migrating_ = __webpack_require__(9);
	var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(3);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var componentvue_type_script_lang_js_ = ({
	  name: 'ElDialog',
	
	  mixins: [popup_default.a, emitter_default.a, migrating_default.a],
	
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	
	    modal: {
	      type: Boolean,
	      default: true
	    },
	
	    modalAppendToBody: {
	      type: Boolean,
	      default: true
	    },
	
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	
	    lockScroll: {
	      type: Boolean,
	      default: true
	    },
	
	    closeOnClickModal: {
	      type: Boolean,
	      default: true
	    },
	
	    closeOnPressEscape: {
	      type: Boolean,
	      default: true
	    },
	
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	
	    width: String,
	
	    fullscreen: Boolean,
	
	    customClass: {
	      type: String,
	      default: ''
	    },
	
	    top: {
	      type: String,
	      default: '15vh'
	    },
	    beforeClose: Function,
	    center: {
	      type: Boolean,
	      default: false
	    },
	
	    destroyOnClose: Boolean
	  },
	
	  data: function data() {
	    return {
	      closed: false,
	      key: 0
	    };
	  },
	
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.closed = false;
	        this.$emit('open');
	        this.$el.addEventListener('scroll', this.updatePopper);
	        this.$nextTick(function () {
	          _this.$refs.dialog.scrollTop = 0;
	        });
	        if (this.appendToBody) {
	          document.body.appendChild(this.$el);
	        }
	      } else {
	        this.$el.removeEventListener('scroll', this.updatePopper);
	        if (!this.closed) this.$emit('close');
	        if (this.destroyOnClose) {
	          this.$nextTick(function () {
	            _this.key++;
	          });
	        }
	      }
	    }
	  },
	
	  computed: {
	    style: function style() {
	      var style = {};
	      if (!this.fullscreen) {
	        style.marginTop = this.top;
	        if (this.width) {
	          style.width = this.width;
	        }
	      }
	      return style;
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'size': 'size is removed.'
	        }
	      };
	    },
	    handleWrapperClick: function handleWrapperClick() {
	      if (!this.closeOnClickModal) return;
	      this.handleClose();
	    },
	    handleClose: function handleClose() {
	      if (typeof this.beforeClose === 'function') {
	        this.beforeClose(this.hide);
	      } else {
	        this.hide();
	      }
	    },
	    hide: function hide(cancel) {
	      if (cancel !== false) {
	        this.$emit('update:visible', false);
	        this.$emit('close');
	        this.closed = true;
	      }
	    },
	    updatePopper: function updatePopper() {
	      this.broadcast('ElSelectDropdown', 'updatePopper');
	      this.broadcast('ElDropdownMenu', 'updatePopper');
	    },
	    afterEnter: function afterEnter() {
	      this.$emit('opened');
	    },
	    afterLeave: function afterLeave() {
	      this.$emit('closed');
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.visible) {
	      this.rendered = true;
	      this.open();
	      if (this.appendToBody) {
	        document.body.appendChild(this.$el);
	      }
	    }
	  },
	  destroyed: function destroyed() {
	    // if appendToBody is true, remove DOM node after destroy
	    if (this.appendToBody && this.$el && this.$el.parentNode) {
	      this.$el.parentNode.removeChild(this.$el);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_componentvue_type_script_lang_js_ = (componentvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dialog/src/component.vue
	
	
	
	
	
	/* normalize component */
	
	var component_component = normalizeComponent(
	  src_componentvue_type_script_lang_js_,
	  componentvue_type_template_id_60140e62_render,
	  componentvue_type_template_id_60140e62_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var component_api; }
	component_component.options.__file = "packages/dialog/src/component.vue"
	/* harmony default export */ var src_component = (component_component.exports);
	// CONCATENATED MODULE: ./packages/dialog/index.js
	
	
	/* istanbul ignore next */
	src_component.install = function (Vue) {
	  Vue.component(src_component.name, src_component);
	};
	
	/* harmony default export */ var dialog = (src_component);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
	var autocompletevue_type_template_id_152f2ee6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.close,
	          expression: "close"
	        }
	      ],
	      staticClass: "el-autocomplete",
	      attrs: {
	        "aria-haspopup": "listbox",
	        role: "combobox",
	        "aria-expanded": _vm.suggestionVisible,
	        "aria-owns": _vm.id
	      }
	    },
	    [
	      _c(
	        "el-input",
	        _vm._b(
	          {
	            ref: "input",
	            on: {
	              input: _vm.handleInput,
	              change: _vm.handleChange,
	              focus: _vm.handleFocus,
	              blur: _vm.handleBlur,
	              clear: _vm.handleClear
	            },
	            nativeOn: {
	              keydown: [
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "up", 38, $event.key, [
	                      "Up",
	                      "ArrowUp"
	                    ])
	                  ) {
	                    return null
	                  }
	                  $event.preventDefault()
	                  _vm.highlight(_vm.highlightedIndex - 1)
	                },
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "down", 40, $event.key, [
	                      "Down",
	                      "ArrowDown"
	                    ])
	                  ) {
	                    return null
	                  }
	                  $event.preventDefault()
	                  _vm.highlight(_vm.highlightedIndex + 1)
	                },
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.handleKeyEnter($event)
	                },
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                  ) {
	                    return null
	                  }
	                  return _vm.close($event)
	                }
	              ]
	            }
	          },
	          "el-input",
	          [_vm.$props, _vm.$attrs],
	          false
	        ),
	        [
	          _vm.$slots.prepend
	            ? _c("template", { slot: "prepend" }, [_vm._t("prepend")], 2)
	            : _vm._e(),
	          _vm.$slots.append
	            ? _c("template", { slot: "append" }, [_vm._t("append")], 2)
	            : _vm._e(),
	          _vm.$slots.prefix
	            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
	            : _vm._e(),
	          _vm.$slots.suffix
	            ? _c("template", { slot: "suffix" }, [_vm._t("suffix")], 2)
	            : _vm._e()
	        ],
	        2
	      ),
	      _c(
	        "el-autocomplete-suggestions",
	        {
	          ref: "suggestions",
	          class: [_vm.popperClass ? _vm.popperClass : ""],
	          attrs: {
	            "visible-arrow": "",
	            "popper-options": _vm.popperOptions,
	            "append-to-body": _vm.popperAppendToBody,
	            placement: _vm.placement,
	            id: _vm.id
	          }
	        },
	        _vm._l(_vm.suggestions, function(item, index) {
	          return _c(
	            "li",
	            {
	              key: index,
	              class: { highlighted: _vm.highlightedIndex === index },
	              attrs: {
	                id: _vm.id + "-item-" + index,
	                role: "option",
	                "aria-selected": _vm.highlightedIndex === index
	              },
	              on: {
	                click: function($event) {
	                  _vm.select(item)
	                }
	              }
	            },
	            [
	              _vm._t(
	                "default",
	                [
	                  _vm._v("\n        " + _vm._s(item[_vm.valueKey]) + "\n      ")
	                ],
	                { item: item }
	              )
	            ],
	            2
	          )
	        }),
	        0
	      )
	    ],
	    1
	  )
	}
	var autocompletevue_type_template_id_152f2ee6_staticRenderFns = []
	autocompletevue_type_template_id_152f2ee6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
	
	// EXTERNAL MODULE: external "throttle-debounce/debounce"
	var debounce_ = __webpack_require__(15);
	var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
	var clickoutside_ = __webpack_require__(10);
	var clickoutside_default = /*#__PURE__*/__webpack_require__.n(clickoutside_);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
	var autocomplete_suggestionsvue_type_template_id_cd10dcf0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.showPopper,
	              expression: "showPopper"
	            }
	          ],
	          staticClass: "el-autocomplete-suggestion el-popper",
	          class: {
	            "is-loading": !_vm.parent.hideLoading && _vm.parent.loading
	          },
	          style: { width: _vm.dropdownWidth },
	          attrs: { role: "region" }
	        },
	        [
	          _c(
	            "el-scrollbar",
	            {
	              attrs: {
	                tag: "ul",
	                "wrap-class": "el-autocomplete-suggestion__wrap",
	                "view-class": "el-autocomplete-suggestion__list"
	              }
	            },
	            [
	              !_vm.parent.hideLoading && _vm.parent.loading
	                ? _c("li", [_c("i", { staticClass: "el-icon-loading" })])
	                : _vm._t("default")
	            ],
	            2
	          )
	        ],
	        1
	      )
	    ]
	  )
	}
	var autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns = []
	autocomplete_suggestionsvue_type_template_id_cd10dcf0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
	var scrollbar_ = __webpack_require__(17);
	var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var autocomplete_suggestionsvue_type_script_lang_js_ = ({
	  components: { ElScrollbar: scrollbar_default.a },
	  mixins: [vue_popper_default.a, emitter_default.a],
	
	  componentName: 'ElAutocompleteSuggestions',
	
	  data: function data() {
	    return {
	      parent: this.$parent,
	      dropdownWidth: ''
	    };
	  },
	
	
	  props: {
	    options: {
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    },
	    id: String
	  },
	
	  methods: {
	    select: function select(item) {
	      this.dispatch('ElAutocomplete', 'item-click', item);
	    }
	  },
	
	  updated: function updated() {
	    var _this = this;
	
	    this.$nextTick(function (_) {
	      _this.popperJS && _this.updatePopper();
	    });
	  },
	  mounted: function mounted() {
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.referenceElm = this.$parent.$refs.input.$refs.input || this.$parent.$refs.input.$refs.textarea;
	    this.referenceList = this.$el.querySelector('.el-autocomplete-suggestion__list');
	    this.referenceList.setAttribute('role', 'listbox');
	    this.referenceList.setAttribute('id', this.id);
	  },
	  created: function created() {
	    var _this2 = this;
	
	    this.$on('visible', function (val, inputWidth) {
	      _this2.dropdownWidth = inputWidth + 'px';
	      _this2.showPopper = val;
	    });
	  }
	});
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_autocomplete_suggestionsvue_type_script_lang_js_ = (autocomplete_suggestionsvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue
	
	
	
	
	
	/* normalize component */
	
	var autocomplete_suggestions_component = normalizeComponent(
	  src_autocomplete_suggestionsvue_type_script_lang_js_,
	  autocomplete_suggestionsvue_type_template_id_cd10dcf0_render,
	  autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var autocomplete_suggestions_api; }
	autocomplete_suggestions_component.options.__file = "packages/autocomplete/src/autocomplete-suggestions.vue"
	/* harmony default export */ var autocomplete_suggestions = (autocomplete_suggestions_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
	var focus_ = __webpack_require__(22);
	var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var autocompletevue_type_script_lang_js_ = ({
	  name: 'ElAutocomplete',
	
	  mixins: [emitter_default.a, focus_default()('input'), migrating_default.a],
	
	  inheritAttrs: false,
	
	  componentName: 'ElAutocomplete',
	
	  components: {
	    ElInput: input_default.a,
	    ElAutocompleteSuggestions: autocomplete_suggestions
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  props: {
	    valueKey: {
	      type: String,
	      default: 'value'
	    },
	    popperClass: String,
	    popperOptions: Object,
	    placeholder: String,
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	    disabled: Boolean,
	    name: String,
	    size: String,
	    value: String,
	    maxlength: Number,
	    minlength: Number,
	    autofocus: Boolean,
	    fetchSuggestions: Function,
	    triggerOnFocus: {
	      type: Boolean,
	      default: true
	    },
	    customItem: String,
	    selectWhenUnmatched: {
	      type: Boolean,
	      default: false
	    },
	    prefixIcon: String,
	    suffixIcon: String,
	    label: String,
	    debounce: {
	      type: Number,
	      default: 300
	    },
	    placement: {
	      type: String,
	      default: 'bottom-start'
	    },
	    hideLoading: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: true
	    },
	    highlightFirstItem: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      activated: false,
	      suggestions: [],
	      loading: false,
	      highlightedIndex: -1,
	      suggestionDisabled: false
	    };
	  },
	
	  computed: {
	    suggestionVisible: function suggestionVisible() {
	      var suggestions = this.suggestions;
	      var isValidData = Array.isArray(suggestions) && suggestions.length > 0;
	      return (isValidData || this.loading) && this.activated;
	    },
	    id: function id() {
	      return 'el-autocomplete-' + Object(util_["generateId"])();
	    }
	  },
	  watch: {
	    suggestionVisible: function suggestionVisible(val) {
	      var $input = this.getInput();
	      if ($input) {
	        this.broadcast('ElAutocompleteSuggestions', 'visible', [val, $input.offsetWidth]);
	      }
	    }
	  },
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'custom-item': 'custom-item is removed, use scoped slot instead.',
	          'props': 'props is removed, use value-key instead.'
	        }
	      };
	    },
	    getData: function getData(queryString) {
	      var _this = this;
	
	      if (this.suggestionDisabled) {
	        return;
	      }
	      this.loading = true;
	      this.fetchSuggestions(queryString, function (suggestions) {
	        _this.loading = false;
	        if (_this.suggestionDisabled) {
	          return;
	        }
	        if (Array.isArray(suggestions)) {
	          _this.suggestions = suggestions;
	          _this.highlightedIndex = _this.highlightFirstItem ? 0 : -1;
	        } else {
	          console.error('[Element Error][Autocomplete]autocomplete suggestions must be an array');
	        }
	      });
	    },
	    handleInput: function handleInput(value) {
	      this.$emit('input', value);
	      this.suggestionDisabled = false;
	      if (!this.triggerOnFocus && !value) {
	        this.suggestionDisabled = true;
	        this.suggestions = [];
	        return;
	      }
	      this.debouncedGetData(value);
	    },
	    handleChange: function handleChange(value) {
	      this.$emit('change', value);
	    },
	    handleFocus: function handleFocus(event) {
	      this.activated = true;
	      this.$emit('focus', event);
	      if (this.triggerOnFocus) {
	        this.debouncedGetData(this.value);
	      }
	    },
	    handleBlur: function handleBlur(event) {
	      this.$emit('blur', event);
	    },
	    handleClear: function handleClear() {
	      this.activated = false;
	      this.$emit('clear');
	    },
	    close: function close(e) {
	      this.activated = false;
	    },
	    handleKeyEnter: function handleKeyEnter(e) {
	      var _this2 = this;
	
	      if (this.suggestionVisible && this.highlightedIndex >= 0 && this.highlightedIndex < this.suggestions.length) {
	        e.preventDefault();
	        this.select(this.suggestions[this.highlightedIndex]);
	      } else if (this.selectWhenUnmatched) {
	        this.$emit('select', { value: this.value });
	        this.$nextTick(function (_) {
	          _this2.suggestions = [];
	          _this2.highlightedIndex = -1;
	        });
	      }
	    },
	    select: function select(item) {
	      var _this3 = this;
	
	      this.$emit('input', item[this.valueKey]);
	      this.$emit('select', item);
	      this.$nextTick(function (_) {
	        _this3.suggestions = [];
	        _this3.highlightedIndex = -1;
	      });
	    },
	    highlight: function highlight(index) {
	      if (!this.suggestionVisible || this.loading) {
	        return;
	      }
	      if (index < 0) {
	        this.highlightedIndex = -1;
	        return;
	      }
	      if (index >= this.suggestions.length) {
	        index = this.suggestions.length - 1;
	      }
	      var suggestion = this.$refs.suggestions.$el.querySelector('.el-autocomplete-suggestion__wrap');
	      var suggestionList = suggestion.querySelectorAll('.el-autocomplete-suggestion__list li');
	
	      var highlightItem = suggestionList[index];
	      var scrollTop = suggestion.scrollTop;
	      var offsetTop = highlightItem.offsetTop;
	
	      if (offsetTop + highlightItem.scrollHeight > scrollTop + suggestion.clientHeight) {
	        suggestion.scrollTop += highlightItem.scrollHeight;
	      }
	      if (offsetTop < scrollTop) {
	        suggestion.scrollTop -= highlightItem.scrollHeight;
	      }
	      this.highlightedIndex = index;
	      var $input = this.getInput();
	      $input.setAttribute('aria-activedescendant', this.id + '-item-' + this.highlightedIndex);
	    },
	    getInput: function getInput() {
	      return this.$refs.input.getInput();
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.debouncedGetData = debounce_default()(this.debounce, this.getData);
	    this.$on('item-click', function (item) {
	      _this4.select(item);
	    });
	    var $input = this.getInput();
	    $input.setAttribute('role', 'textbox');
	    $input.setAttribute('aria-autocomplete', 'list');
	    $input.setAttribute('aria-controls', 'id');
	    $input.setAttribute('aria-activedescendant', this.id + '-item-' + this.highlightedIndex);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.$refs.suggestions.$destroy();
	  }
	});
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_autocompletevue_type_script_lang_js_ = (autocompletevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue
	
	
	
	
	
	/* normalize component */
	
	var autocomplete_component = normalizeComponent(
	  src_autocompletevue_type_script_lang_js_,
	  autocompletevue_type_template_id_152f2ee6_render,
	  autocompletevue_type_template_id_152f2ee6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var autocomplete_api; }
	autocomplete_component.options.__file = "packages/autocomplete/src/autocomplete.vue"
	/* harmony default export */ var autocomplete = (autocomplete_component.exports);
	// CONCATENATED MODULE: ./packages/autocomplete/index.js
	
	
	/* istanbul ignore next */
	autocomplete.install = function (Vue) {
	  Vue.component(autocomplete.name, autocomplete);
	};
	
	/* harmony default export */ var packages_autocomplete = (autocomplete);
	// EXTERNAL MODULE: external "element-ui/lib/button"
	var button_ = __webpack_require__(12);
	var button_default = /*#__PURE__*/__webpack_require__.n(button_);
	
	// EXTERNAL MODULE: external "element-ui/lib/button-group"
	var button_group_ = __webpack_require__(29);
	var button_group_default = /*#__PURE__*/__webpack_require__.n(button_group_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	
	/* harmony default export */ var dropdownvue_type_script_lang_js_ = ({
	  name: 'ElDropdown',
	
	  componentName: 'ElDropdown',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  components: {
	    ElButton: button_default.a,
	    ElButtonGroup: button_group_default.a
	  },
	
	  provide: function provide() {
	    return {
	      dropdown: this
	    };
	  },
	
	
	  props: {
	    trigger: {
	      type: String,
	      default: 'hover'
	    },
	    type: String,
	    size: {
	      type: String,
	      default: ''
	    },
	    splitButton: Boolean,
	    hideOnClick: {
	      type: Boolean,
	      default: true
	    },
	    placement: {
	      type: String,
	      default: 'bottom-end'
	    },
	    visibleArrow: {
	      default: true
	    },
	    showTimeout: {
	      type: Number,
	      default: 250
	    },
	    hideTimeout: {
	      type: Number,
	      default: 150
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      timeout: null,
	      visible: false,
	      triggerElm: null,
	      menuItems: null,
	      menuItemsArray: null,
	      dropdownElm: null,
	      focusing: false,
	      listId: 'dropdown-menu-' + Object(util_["generateId"])()
	    };
	  },
	
	
	  computed: {
	    dropdownSize: function dropdownSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  mounted: function mounted() {
	    this.$on('menu-item-click', this.handleMenuItemClick);
	  },
	
	
	  watch: {
	    visible: function visible(val) {
	      this.broadcast('ElDropdownMenu', 'visible', val);
	      this.$emit('visible-change', val);
	    },
	    focusing: function focusing(val) {
	      var selfDefine = this.$el.querySelector('.el-dropdown-selfdefine');
	      if (selfDefine) {
	        // 自定义
	        if (val) {
	          selfDefine.className += ' focusing';
	        } else {
	          selfDefine.className = selfDefine.className.replace('focusing', '');
	        }
	      }
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'menu-align': 'menu-align is renamed to placement.'
	        }
	      };
	    },
	    show: function show() {
	      var _this = this;
	
	      if (this.triggerElm.disabled) return;
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this.visible = true;
	      }, this.trigger === 'click' ? 0 : this.showTimeout);
	    },
	    hide: function hide() {
	      var _this2 = this;
	
	      if (this.triggerElm.disabled) return;
	      this.removeTabindex();
	      if (this.tabindex >= 0) {
	        this.resetTabindex(this.triggerElm);
	      }
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this2.visible = false;
	      }, this.trigger === 'click' ? 0 : this.hideTimeout);
	    },
	    handleClick: function handleClick() {
	      if (this.triggerElm.disabled) return;
	      if (this.visible) {
	        this.hide();
	      } else {
	        this.show();
	      }
	    },
	    handleTriggerKeyDown: function handleTriggerKeyDown(ev) {
	      var keyCode = ev.keyCode;
	      if ([38, 40].indexOf(keyCode) > -1) {
	        // up/down
	        this.removeTabindex();
	        this.resetTabindex(this.menuItems[0]);
	        this.menuItems[0].focus();
	        ev.preventDefault();
	        ev.stopPropagation();
	      } else if (keyCode === 13) {
	        // space enter选中
	        this.handleClick();
	      } else if ([9, 27].indexOf(keyCode) > -1) {
	        // tab || esc
	        this.hide();
	      }
	    },
	    handleItemKeyDown: function handleItemKeyDown(ev) {
	      var keyCode = ev.keyCode;
	      var target = ev.target;
	      var currentIndex = this.menuItemsArray.indexOf(target);
	      var max = this.menuItemsArray.length - 1;
	      var nextIndex = void 0;
	      if ([38, 40].indexOf(keyCode) > -1) {
	        // up/down
	        if (keyCode === 38) {
	          // up
	          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
	        } else {
	          // down
	          nextIndex = currentIndex < max ? currentIndex + 1 : max;
	        }
	        this.removeTabindex();
	        this.resetTabindex(this.menuItems[nextIndex]);
	        this.menuItems[nextIndex].focus();
	        ev.preventDefault();
	        ev.stopPropagation();
	      } else if (keyCode === 13) {
	        // enter选中
	        this.triggerElmFocus();
	        target.click();
	        if (this.hideOnClick) {
	          // click关闭
	          this.visible = false;
	        }
	      } else if ([9, 27].indexOf(keyCode) > -1) {
	        // tab // esc
	        this.hide();
	        this.triggerElmFocus();
	      }
	    },
	    resetTabindex: function resetTabindex(ele) {
	      // 下次tab时组件聚焦元素
	      this.removeTabindex();
	      ele.setAttribute('tabindex', '0'); // 下次期望的聚焦元素
	    },
	    removeTabindex: function removeTabindex() {
	      this.triggerElm.setAttribute('tabindex', '-1');
	      this.menuItemsArray.forEach(function (item) {
	        item.setAttribute('tabindex', '-1');
	      });
	    },
	    initAria: function initAria() {
	      this.dropdownElm.setAttribute('id', this.listId);
	      this.triggerElm.setAttribute('aria-haspopup', 'list');
	      this.triggerElm.setAttribute('aria-controls', this.listId);
	
	      if (!this.splitButton) {
	        // 自定义
	        this.triggerElm.setAttribute('role', 'button');
	        this.triggerElm.setAttribute('tabindex', this.tabindex);
	        this.triggerElm.setAttribute('class', (this.triggerElm.getAttribute('class') || '') + ' el-dropdown-selfdefine'); // 控制
	      }
	    },
	    initEvent: function initEvent() {
	      var _this3 = this;
	
	      var trigger = this.trigger,
	          show = this.show,
	          hide = this.hide,
	          handleClick = this.handleClick,
	          splitButton = this.splitButton,
	          handleTriggerKeyDown = this.handleTriggerKeyDown,
	          handleItemKeyDown = this.handleItemKeyDown;
	
	      this.triggerElm = splitButton ? this.$refs.trigger.$el : this.$slots.default[0].elm;
	
	      var dropdownElm = this.dropdownElm;
	
	      this.triggerElm.addEventListener('keydown', handleTriggerKeyDown); // triggerElm keydown
	      dropdownElm.addEventListener('keydown', handleItemKeyDown, true); // item keydown
	      // 控制自定义元素的样式
	      if (!splitButton) {
	        this.triggerElm.addEventListener('focus', function () {
	          _this3.focusing = true;
	        });
	        this.triggerElm.addEventListener('blur', function () {
	          _this3.focusing = false;
	        });
	        this.triggerElm.addEventListener('click', function () {
	          _this3.focusing = false;
	        });
	      }
	      if (trigger === 'hover') {
	        this.triggerElm.addEventListener('mouseenter', show);
	        this.triggerElm.addEventListener('mouseleave', hide);
	        dropdownElm.addEventListener('mouseenter', show);
	        dropdownElm.addEventListener('mouseleave', hide);
	      } else if (trigger === 'click') {
	        this.triggerElm.addEventListener('click', handleClick);
	      }
	    },
	    handleMenuItemClick: function handleMenuItemClick(command, instance) {
	      if (this.hideOnClick) {
	        this.visible = false;
	      }
	      this.$emit('command', command, instance);
	    },
	    triggerElmFocus: function triggerElmFocus() {
	      this.triggerElm.focus && this.triggerElm.focus();
	    },
	    initDomOperation: function initDomOperation() {
	      this.dropdownElm = this.popperElm;
	      this.menuItems = this.dropdownElm.querySelectorAll("[tabindex='-1']");
	      this.menuItemsArray = [].slice.call(this.menuItems);
	
	      this.initEvent();
	      this.initAria();
	    }
	  },
	
	  render: function render(h) {
	    var _this4 = this;
	
	    var hide = this.hide,
	        splitButton = this.splitButton,
	        type = this.type,
	        dropdownSize = this.dropdownSize;
	
	
	    var handleMainButtonClick = function handleMainButtonClick(event) {
	      _this4.$emit('click', event);
	      hide();
	    };
	
	    var triggerElm = !splitButton ? this.$slots.default : h('el-button-group', [h(
	      'el-button',
	      {
	        attrs: { type: type, size: dropdownSize },
	        nativeOn: {
	          'click': handleMainButtonClick
	        }
	      },
	      [this.$slots.default]
	    ), h(
	      'el-button',
	      { ref: 'trigger', attrs: { type: type, size: dropdownSize },
	        'class': 'el-dropdown__caret-button' },
	      [h('i', { 'class': 'el-dropdown__icon el-icon-arrow-down' })]
	    )]);
	
	    return h(
	      'div',
	      { 'class': 'el-dropdown', directives: [{
	          name: 'clickoutside',
	          value: hide
	        }]
	      },
	      [triggerElm, this.$slots.dropdown]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_dropdownvue_type_script_lang_js_ = (dropdownvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue
	var dropdown_render, dropdown_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var dropdown_component = normalizeComponent(
	  src_dropdownvue_type_script_lang_js_,
	  dropdown_render,
	  dropdown_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var dropdown_api; }
	dropdown_component.options.__file = "packages/dropdown/src/dropdown.vue"
	/* harmony default export */ var dropdown = (dropdown_component.exports);
	// CONCATENATED MODULE: ./packages/dropdown/index.js
	
	
	/* istanbul ignore next */
	dropdown.install = function (Vue) {
	  Vue.component(dropdown.name, dropdown);
	};
	
	/* harmony default export */ var packages_dropdown = (dropdown);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
	var dropdown_menuvue_type_template_id_0da6b714_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
	    [
	      _c(
	        "ul",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.showPopper,
	              expression: "showPopper"
	            }
	          ],
	          staticClass: "el-dropdown-menu el-popper",
	          class: [_vm.size && "el-dropdown-menu--" + _vm.size]
	        },
	        [_vm._t("default")],
	        2
	      )
	    ]
	  )
	}
	var dropdown_menuvue_type_template_id_0da6b714_staticRenderFns = []
	dropdown_menuvue_type_template_id_0da6b714_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var dropdown_menuvue_type_script_lang_js_ = ({
	  name: 'ElDropdownMenu',
	
	  componentName: 'ElDropdownMenu',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    visibleArrow: {
	      type: Boolean,
	      default: true
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      size: this.dropdown.dropdownSize
	    };
	  },
	
	
	  inject: ['dropdown'],
	
	  created: function created() {
	    var _this = this;
	
	    this.$on('updatePopper', function () {
	      if (_this.showPopper) _this.updatePopper();
	    });
	    this.$on('visible', function (val) {
	      _this.showPopper = val;
	    });
	  },
	  mounted: function mounted() {
	    this.dropdown.popperElm = this.popperElm = this.$el;
	    this.referenceElm = this.dropdown.$el;
	    // compatible with 2.6 new v-slot syntax
	    // issue link https://github.com/ElemeFE/element/issues/14345
	    this.dropdown.initDomOperation();
	  },
	
	
	  watch: {
	    'dropdown.placement': {
	      immediate: true,
	      handler: function handler(val) {
	        this.currentPlacement = val;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_dropdown_menuvue_type_script_lang_js_ = (dropdown_menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue
	
	
	
	
	
	/* normalize component */
	
	var dropdown_menu_component = normalizeComponent(
	  src_dropdown_menuvue_type_script_lang_js_,
	  dropdown_menuvue_type_template_id_0da6b714_render,
	  dropdown_menuvue_type_template_id_0da6b714_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var dropdown_menu_api; }
	dropdown_menu_component.options.__file = "packages/dropdown/src/dropdown-menu.vue"
	/* harmony default export */ var dropdown_menu = (dropdown_menu_component.exports);
	// CONCATENATED MODULE: ./packages/dropdown-menu/index.js
	
	
	/* istanbul ignore next */
	dropdown_menu.install = function (Vue) {
	  Vue.component(dropdown_menu.name, dropdown_menu);
	};
	
	/* harmony default export */ var packages_dropdown_menu = (dropdown_menu);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
	var dropdown_itemvue_type_template_id_6359102a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      staticClass: "el-dropdown-menu__item",
	      class: {
	        "is-disabled": _vm.disabled,
	        "el-dropdown-menu__item--divided": _vm.divided
	      },
	      attrs: {
	        "aria-disabled": _vm.disabled,
	        tabindex: _vm.disabled ? null : -1
	      },
	      on: { click: _vm.handleClick }
	    },
	    [_vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(), _vm._t("default")],
	    2
	  )
	}
	var dropdown_itemvue_type_template_id_6359102a_staticRenderFns = []
	dropdown_itemvue_type_template_id_6359102a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var dropdown_itemvue_type_script_lang_js_ = ({
	  name: 'ElDropdownItem',
	
	  mixins: [emitter_default.a],
	
	  props: {
	    command: {},
	    disabled: Boolean,
	    divided: Boolean,
	    icon: String
	  },
	
	  methods: {
	    handleClick: function handleClick(e) {
	      this.dispatch('ElDropdown', 'menu-item-click', [this.command, this]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_dropdown_itemvue_type_script_lang_js_ = (dropdown_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue
	
	
	
	
	
	/* normalize component */
	
	var dropdown_item_component = normalizeComponent(
	  src_dropdown_itemvue_type_script_lang_js_,
	  dropdown_itemvue_type_template_id_6359102a_render,
	  dropdown_itemvue_type_template_id_6359102a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var dropdown_item_api; }
	dropdown_item_component.options.__file = "packages/dropdown/src/dropdown-item.vue"
	/* harmony default export */ var dropdown_item = (dropdown_item_component.exports);
	// CONCATENATED MODULE: ./packages/dropdown-item/index.js
	
	
	/* istanbul ignore next */
	dropdown_item.install = function (Vue) {
	  Vue.component(dropdown_item.name, dropdown_item);
	};
	
	/* harmony default export */ var packages_dropdown_item = (dropdown_item);
	// CONCATENATED MODULE: ./src/utils/aria-utils.js
	var aria = aria || {};
	
	aria.Utils = aria.Utils || {};
	
	/**
	 * @desc Set focus on descendant nodes until the first focusable element is
	 *       found.
	 * @param element
	 *          DOM node for which to find the first focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	aria.Utils.focusFirstDescendant = function (element) {
	  for (var i = 0; i < element.childNodes.length; i++) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Find the last descendant node that is focusable.
	 * @param element
	 *          DOM node for which to find the last focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	
	aria.Utils.focusLastDescendant = function (element) {
	  for (var i = element.childNodes.length - 1; i >= 0; i--) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Set Attempt to set focus on the current node.
	 * @param element
	 *          The node to attempt to focus on.
	 * @returns
	 *  true if element is focused.
	 */
	aria.Utils.attemptFocus = function (element) {
	  if (!aria.Utils.isFocusable(element)) {
	    return false;
	  }
	  aria.Utils.IgnoreUtilFocusChanges = true;
	  try {
	    element.focus();
	  } catch (e) {}
	  aria.Utils.IgnoreUtilFocusChanges = false;
	  return document.activeElement === element;
	};
	
	aria.Utils.isFocusable = function (element) {
	  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
	    return true;
	  }
	
	  if (element.disabled) {
	    return false;
	  }
	
	  switch (element.nodeName) {
	    case 'A':
	      return !!element.href && element.rel !== 'ignore';
	    case 'INPUT':
	      return element.type !== 'hidden' && element.type !== 'file';
	    case 'BUTTON':
	    case 'SELECT':
	    case 'TEXTAREA':
	      return true;
	    default:
	      return false;
	  }
	};
	
	/**
	 * 触发一个事件
	 * mouseenter, mouseleave, mouseover, keyup, change, click 等
	 * @param  {Element} elm
	 * @param  {String} name
	 * @param  {*} opts
	 */
	aria.Utils.triggerEvent = function (elm, name) {
	  var eventName = void 0;
	
	  if (/^mouse|click/.test(name)) {
	    eventName = 'MouseEvents';
	  } else if (/^key/.test(name)) {
	    eventName = 'KeyboardEvent';
	  } else {
	    eventName = 'HTMLEvents';
	  }
	  var evt = document.createEvent(eventName);
	
	  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    opts[_key - 2] = arguments[_key];
	  }
	
	  evt.initEvent.apply(evt, [name].concat(opts));
	  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);
	
	  return elm;
	};
	
	aria.Utils.keys = {
	  tab: 9,
	  enter: 13,
	  space: 32,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  esc: 27
	};
	
	/* harmony default export */ var aria_utils = (aria.Utils);
	// CONCATENATED MODULE: ./src/utils/menu/aria-submenu.js
	
	
	var SubMenu = function SubMenu(parent, domNode) {
	  this.domNode = domNode;
	  this.parent = parent;
	  this.subMenuItems = [];
	  this.subIndex = 0;
	  this.init();
	};
	
	SubMenu.prototype.init = function () {
	  this.subMenuItems = this.domNode.querySelectorAll('li');
	  this.addListeners();
	};
	
	SubMenu.prototype.gotoSubIndex = function (idx) {
	  if (idx === this.subMenuItems.length) {
	    idx = 0;
	  } else if (idx < 0) {
	    idx = this.subMenuItems.length - 1;
	  }
	  this.subMenuItems[idx].focus();
	  this.subIndex = idx;
	};
	
	SubMenu.prototype.addListeners = function () {
	  var _this = this;
	
	  var keys = aria_utils.keys;
	  var parentNode = this.parent.domNode;
	  Array.prototype.forEach.call(this.subMenuItems, function (el) {
	    el.addEventListener('keydown', function (event) {
	      var prevDef = false;
	      switch (event.keyCode) {
	        case keys.down:
	          _this.gotoSubIndex(_this.subIndex + 1);
	          prevDef = true;
	          break;
	        case keys.up:
	          _this.gotoSubIndex(_this.subIndex - 1);
	          prevDef = true;
	          break;
	        case keys.tab:
	          aria_utils.triggerEvent(parentNode, 'mouseleave');
	          break;
	        case keys.enter:
	        case keys.space:
	          prevDef = true;
	          event.currentTarget.click();
	          break;
	      }
	      if (prevDef) {
	        event.preventDefault();
	        event.stopPropagation();
	      }
	      return false;
	    });
	  });
	};
	
	/* harmony default export */ var aria_submenu = (SubMenu);
	// CONCATENATED MODULE: ./src/utils/menu/aria-menuitem.js
	
	
	
	var MenuItem = function MenuItem(domNode) {
	  this.domNode = domNode;
	  this.submenu = null;
	  this.init();
	};
	
	MenuItem.prototype.init = function () {
	  this.domNode.setAttribute('tabindex', '0');
	  var menuChild = this.domNode.querySelector('.el-menu');
	  if (menuChild) {
	    this.submenu = new aria_submenu(this, menuChild);
	  }
	  this.addListeners();
	};
	
	MenuItem.prototype.addListeners = function () {
	  var _this = this;
	
	  var keys = aria_utils.keys;
	  this.domNode.addEventListener('keydown', function (event) {
	    var prevDef = false;
	    switch (event.keyCode) {
	      case keys.down:
	        aria_utils.triggerEvent(event.currentTarget, 'mouseenter');
	        _this.submenu && _this.submenu.gotoSubIndex(0);
	        prevDef = true;
	        break;
	      case keys.up:
	        aria_utils.triggerEvent(event.currentTarget, 'mouseenter');
	        _this.submenu && _this.submenu.gotoSubIndex(_this.submenu.subMenuItems.length - 1);
	        prevDef = true;
	        break;
	      case keys.tab:
	        aria_utils.triggerEvent(event.currentTarget, 'mouseleave');
	        break;
	      case keys.enter:
	      case keys.space:
	        prevDef = true;
	        event.currentTarget.click();
	        break;
	    }
	    if (prevDef) {
	      event.preventDefault();
	    }
	  });
	};
	
	/* harmony default export */ var aria_menuitem = (MenuItem);
	// CONCATENATED MODULE: ./src/utils/menu/aria-menubar.js
	
	
	var Menu = function Menu(domNode) {
	  this.domNode = domNode;
	  this.init();
	};
	
	Menu.prototype.init = function () {
	  var menuChildren = this.domNode.childNodes;
	  [].filter.call(menuChildren, function (child) {
	    return child.nodeType === 1;
	  }).forEach(function (child) {
	    new aria_menuitem(child); // eslint-disable-line
	  });
	};
	/* harmony default export */ var aria_menubar = (Menu);
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(1);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	/* harmony default export */ var menuvue_type_script_lang_js_ = ({
	  name: 'ElMenu',
	
	  render: function render(h) {
	    var component = h(
	      'ul',
	      {
	        attrs: {
	          role: 'menubar'
	        },
	        key: +this.collapse,
	        style: { backgroundColor: this.backgroundColor || '' },
	        'class': {
	          'el-menu--horizontal': this.mode === 'horizontal',
	          'el-menu--collapse': this.collapse,
	          "el-menu": true
	        }
	      },
	      [this.$slots.default]
	    );
	
	    if (this.collapseTransition) {
	      return h('el-menu-collapse-transition', [component]);
	    } else {
	      return component;
	    }
	  },
	
	
	  componentName: 'ElMenu',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  provide: function provide() {
	    return {
	      rootMenu: this
	    };
	  },
	
	
	  components: {
	    'el-menu-collapse-transition': {
	      functional: true,
	      render: function render(createElement, context) {
	        var data = {
	          props: {
	            mode: 'out-in'
	          },
	          on: {
	            beforeEnter: function beforeEnter(el) {
	              el.style.opacity = 0.2;
	            },
	            enter: function enter(el) {
	              Object(dom_["addClass"])(el, 'el-opacity-transition');
	              el.style.opacity = 1;
	            },
	            afterEnter: function afterEnter(el) {
	              Object(dom_["removeClass"])(el, 'el-opacity-transition');
	              el.style.opacity = '';
	            },
	            beforeLeave: function beforeLeave(el) {
	              if (!el.dataset) el.dataset = {};
	
	              if (Object(dom_["hasClass"])(el, 'el-menu--collapse')) {
	                Object(dom_["removeClass"])(el, 'el-menu--collapse');
	                el.dataset.oldOverflow = el.style.overflow;
	                el.dataset.scrollWidth = el.clientWidth;
	                Object(dom_["addClass"])(el, 'el-menu--collapse');
	              } else {
	                Object(dom_["addClass"])(el, 'el-menu--collapse');
	                el.dataset.oldOverflow = el.style.overflow;
	                el.dataset.scrollWidth = el.clientWidth;
	                Object(dom_["removeClass"])(el, 'el-menu--collapse');
	              }
	
	              el.style.width = el.scrollWidth + 'px';
	              el.style.overflow = 'hidden';
	            },
	            leave: function leave(el) {
	              Object(dom_["addClass"])(el, 'horizontal-collapse-transition');
	              el.style.width = el.dataset.scrollWidth + 'px';
	            }
	          }
	        };
	        return createElement('transition', data, context.children);
	      }
	    }
	  },
	
	  props: {
	    mode: {
	      type: String,
	      default: 'vertical'
	    },
	    defaultActive: {
	      type: String,
	      default: ''
	    },
	    defaultOpeneds: Array,
	    uniqueOpened: Boolean,
	    router: Boolean,
	    menuTrigger: {
	      type: String,
	      default: 'hover'
	    },
	    collapse: Boolean,
	    backgroundColor: String,
	    textColor: String,
	    activeTextColor: String,
	    collapseTransition: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      activeIndex: this.defaultActive,
	      openedMenus: this.defaultOpeneds && !this.collapse ? this.defaultOpeneds.slice(0) : [],
	      items: {},
	      submenus: {}
	    };
	  },
	
	  computed: {
	    hoverBackground: function hoverBackground() {
	      return this.backgroundColor ? this.mixColor(this.backgroundColor, 0.2) : '';
	    },
	    isMenuPopup: function isMenuPopup() {
	      return this.mode === 'horizontal' || this.mode === 'vertical' && this.collapse;
	    }
	  },
	  watch: {
	    defaultActive: function defaultActive(value) {
	      if (!this.items[value]) {
	        this.activeIndex = null;
	      }
	      this.updateActiveIndex(value);
	    },
	    defaultOpeneds: function defaultOpeneds(value) {
	      if (!this.collapse) {
	        this.openedMenus = value;
	      }
	    },
	    collapse: function collapse(value) {
	      if (value) this.openedMenus = [];
	      this.broadcast('ElSubmenu', 'toggle-collapse', value);
	    }
	  },
	  methods: {
	    updateActiveIndex: function updateActiveIndex(val) {
	      var item = this.items[val] || this.items[this.activeIndex] || this.items[this.defaultActive];
	      if (item) {
	        this.activeIndex = item.index;
	        this.initOpenedMenu();
	      } else {
	        this.activeIndex = null;
	      }
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'theme': 'theme is removed.'
	        }
	      };
	    },
	    getColorChannels: function getColorChannels(color) {
	      color = color.replace('#', '');
	      if (/^[0-9a-fA-F]{3}$/.test(color)) {
	        color = color.split('');
	        for (var i = 2; i >= 0; i--) {
	          color.splice(i, 0, color[i]);
	        }
	        color = color.join('');
	      }
	      if (/^[0-9a-fA-F]{6}$/.test(color)) {
	        return {
	          red: parseInt(color.slice(0, 2), 16),
	          green: parseInt(color.slice(2, 4), 16),
	          blue: parseInt(color.slice(4, 6), 16)
	        };
	      } else {
	        return {
	          red: 255,
	          green: 255,
	          blue: 255
	        };
	      }
	    },
	    mixColor: function mixColor(color, percent) {
	      var _getColorChannels = this.getColorChannels(color),
	          red = _getColorChannels.red,
	          green = _getColorChannels.green,
	          blue = _getColorChannels.blue;
	
	      if (percent > 0) {
	        // shade given color
	        red *= 1 - percent;
	        green *= 1 - percent;
	        blue *= 1 - percent;
	      } else {
	        // tint given color
	        red += (255 - red) * percent;
	        green += (255 - green) * percent;
	        blue += (255 - blue) * percent;
	      }
	      return 'rgb(' + Math.round(red) + ', ' + Math.round(green) + ', ' + Math.round(blue) + ')';
	    },
	    addItem: function addItem(item) {
	      this.$set(this.items, item.index, item);
	    },
	    removeItem: function removeItem(item) {
	      delete this.items[item.index];
	    },
	    addSubmenu: function addSubmenu(item) {
	      this.$set(this.submenus, item.index, item);
	    },
	    removeSubmenu: function removeSubmenu(item) {
	      delete this.submenus[item.index];
	    },
	    openMenu: function openMenu(index, indexPath) {
	      var openedMenus = this.openedMenus;
	      if (openedMenus.indexOf(index) !== -1) return;
	      // 将不在该菜单路径下的其余菜单收起
	      // collapse all menu that are not under current menu item
	      if (this.uniqueOpened) {
	        this.openedMenus = openedMenus.filter(function (index) {
	          return indexPath.indexOf(index) !== -1;
	        });
	      }
	      this.openedMenus.push(index);
	    },
	    closeMenu: function closeMenu(index) {
	      var i = this.openedMenus.indexOf(index);
	      if (i !== -1) {
	        this.openedMenus.splice(i, 1);
	      }
	    },
	    handleSubmenuClick: function handleSubmenuClick(submenu) {
	      var index = submenu.index,
	          indexPath = submenu.indexPath;
	
	      var isOpened = this.openedMenus.indexOf(index) !== -1;
	
	      if (isOpened) {
	        this.closeMenu(index);
	        this.$emit('close', index, indexPath);
	      } else {
	        this.openMenu(index, indexPath);
	        this.$emit('open', index, indexPath);
	      }
	    },
	    handleItemClick: function handleItemClick(item) {
	      var _this = this;
	
	      var index = item.index,
	          indexPath = item.indexPath;
	
	      var oldActiveIndex = this.activeIndex;
	      var hasIndex = item.index !== null;
	
	      if (hasIndex) {
	        this.activeIndex = item.index;
	      }
	
	      this.$emit('select', index, indexPath, item);
	
	      if (this.mode === 'horizontal' || this.collapse) {
	        this.openedMenus = [];
	      }
	
	      if (this.router && hasIndex) {
	        this.routeToItem(item, function (error) {
	          _this.activeIndex = oldActiveIndex;
	          if (error) {
	            // vue-router 3.1.0+ push/replace cause NavigationDuplicated error 
	            // https://github.com/ElemeFE/element/issues/17044
	            if (error.name === 'NavigationDuplicated') return;
	            console.error(error);
	          }
	        });
	      }
	    },
	
	    // 初始化展开菜单
	    // initialize opened menu
	    initOpenedMenu: function initOpenedMenu() {
	      var _this2 = this;
	
	      var index = this.activeIndex;
	      var activeItem = this.items[index];
	      if (!activeItem || this.mode === 'horizontal' || this.collapse) return;
	
	      var indexPath = activeItem.indexPath;
	
	      // 展开该菜单项的路径上所有子菜单
	      // expand all submenus of the menu item
	      indexPath.forEach(function (index) {
	        var submenu = _this2.submenus[index];
	        submenu && _this2.openMenu(index, submenu.indexPath);
	      });
	    },
	    routeToItem: function routeToItem(item, onError) {
	      var route = item.route || item.index;
	      try {
	        this.$router.push(route, function () {}, onError);
	      } catch (e) {
	        console.error(e);
	      }
	    },
	    open: function open(index) {
	      var _this3 = this;
	
	      var indexPath = this.submenus[index.toString()].indexPath;
	
	      indexPath.forEach(function (i) {
	        return _this3.openMenu(i, indexPath);
	      });
	    },
	    close: function close(index) {
	      this.closeMenu(index);
	    }
	  },
	  mounted: function mounted() {
	    this.initOpenedMenu();
	    this.$on('item-click', this.handleItemClick);
	    this.$on('submenu-click', this.handleSubmenuClick);
	    if (this.mode === 'horizontal') {
	      new aria_menubar(this.$el); // eslint-disable-line
	    }
	    this.$watch('items', this.updateActiveIndex);
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_menuvue_type_script_lang_js_ = (menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/menu.vue
	var menu_render, menu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var menu_component = normalizeComponent(
	  src_menuvue_type_script_lang_js_,
	  menu_render,
	  menu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var menu_api; }
	menu_component.options.__file = "packages/menu/src/menu.vue"
	/* harmony default export */ var src_menu = (menu_component.exports);
	// CONCATENATED MODULE: ./packages/menu/index.js
	
	
	/* istanbul ignore next */
	src_menu.install = function (Vue) {
	  Vue.component(src_menu.name, src_menu);
	};
	
	/* harmony default export */ var packages_menu = (src_menu);
	// EXTERNAL MODULE: external "element-ui/lib/transitions/collapse-transition"
	var collapse_transition_ = __webpack_require__(21);
	var collapse_transition_default = /*#__PURE__*/__webpack_require__.n(collapse_transition_);
	
	// CONCATENATED MODULE: ./packages/menu/src/menu-mixin.js
	/* harmony default export */ var menu_mixin = ({
	  inject: ['rootMenu'],
	  computed: {
	    indexPath: function indexPath() {
	      var path = [this.index];
	      var parent = this.$parent;
	      while (parent.$options.componentName !== 'ElMenu') {
	        if (parent.index) {
	          path.unshift(parent.index);
	        }
	        parent = parent.$parent;
	      }
	      return path;
	    },
	    parentMenu: function parentMenu() {
	      var parent = this.$parent;
	      while (parent && ['ElMenu', 'ElSubmenu'].indexOf(parent.$options.componentName) === -1) {
	        parent = parent.$parent;
	      }
	      return parent;
	    },
	    paddingStyle: function paddingStyle() {
	      if (this.rootMenu.mode !== 'vertical') return {};
	
	      var padding = 20;
	      var parent = this.$parent;
	
	      if (this.rootMenu.collapse) {
	        padding = 20;
	      } else {
	        while (parent && parent.$options.componentName !== 'ElMenu') {
	          if (parent.$options.componentName === 'ElSubmenu') {
	            padding += 20;
	          }
	          parent = parent.$parent;
	        }
	      }
	      return { paddingLeft: padding + 'px' };
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/submenu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	var poperMixins = {
	  props: {
	    transformOrigin: {
	      type: [Boolean, String],
	      default: false
	    },
	    offset: vue_popper_default.a.props.offset,
	    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
	    popperOptions: vue_popper_default.a.props.popperOptions
	  },
	  data: vue_popper_default.a.data,
	  methods: vue_popper_default.a.methods,
	  beforeDestroy: vue_popper_default.a.beforeDestroy,
	  deactivated: vue_popper_default.a.deactivated
	};
	
	/* harmony default export */ var submenuvue_type_script_lang_js_ = ({
	  name: 'ElSubmenu',
	
	  componentName: 'ElSubmenu',
	
	  mixins: [menu_mixin, emitter_default.a, poperMixins],
	
	  components: { ElCollapseTransition: collapse_transition_default.a },
	
	  props: {
	    index: {
	      type: String,
	      required: true
	    },
	    showTimeout: {
	      type: Number,
	      default: 300
	    },
	    hideTimeout: {
	      type: Number,
	      default: 300
	    },
	    popperClass: String,
	    disabled: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: undefined
	    }
	  },
	
	  data: function data() {
	    return {
	      popperJS: null,
	      timeout: null,
	      items: {},
	      submenus: {},
	      mouseInChild: false
	    };
	  },
	
	  watch: {
	    opened: function opened(val) {
	      var _this = this;
	
	      if (this.isMenuPopup) {
	        this.$nextTick(function (_) {
	          _this.updatePopper();
	        });
	      }
	    }
	  },
	  computed: {
	    // popper option
	    appendToBody: function appendToBody() {
	      return this.popperAppendToBody === undefined ? this.isFirstLevel : this.popperAppendToBody;
	    },
	    menuTransitionName: function menuTransitionName() {
	      return this.rootMenu.collapse ? 'el-zoom-in-left' : 'el-zoom-in-top';
	    },
	    opened: function opened() {
	      return this.rootMenu.openedMenus.indexOf(this.index) > -1;
	    },
	    active: function active() {
	      var isActive = false;
	      var submenus = this.submenus;
	      var items = this.items;
	
	      Object.keys(items).forEach(function (index) {
	        if (items[index].active) {
	          isActive = true;
	        }
	      });
	
	      Object.keys(submenus).forEach(function (index) {
	        if (submenus[index].active) {
	          isActive = true;
	        }
	      });
	
	      return isActive;
	    },
	    hoverBackground: function hoverBackground() {
	      return this.rootMenu.hoverBackground;
	    },
	    backgroundColor: function backgroundColor() {
	      return this.rootMenu.backgroundColor || '';
	    },
	    activeTextColor: function activeTextColor() {
	      return this.rootMenu.activeTextColor || '';
	    },
	    textColor: function textColor() {
	      return this.rootMenu.textColor || '';
	    },
	    mode: function mode() {
	      return this.rootMenu.mode;
	    },
	    isMenuPopup: function isMenuPopup() {
	      return this.rootMenu.isMenuPopup;
	    },
	    titleStyle: function titleStyle() {
	      if (this.mode !== 'horizontal') {
	        return {
	          color: this.textColor
	        };
	      }
	      return {
	        borderBottomColor: this.active ? this.rootMenu.activeTextColor ? this.activeTextColor : '' : 'transparent',
	        color: this.active ? this.activeTextColor : this.textColor
	      };
	    },
	    isFirstLevel: function isFirstLevel() {
	      var isFirstLevel = true;
	      var parent = this.$parent;
	      while (parent && parent !== this.rootMenu) {
	        if (['ElSubmenu', 'ElMenuItemGroup'].indexOf(parent.$options.componentName) > -1) {
	          isFirstLevel = false;
	          break;
	        } else {
	          parent = parent.$parent;
	        }
	      }
	      return isFirstLevel;
	    }
	  },
	  methods: {
	    handleCollapseToggle: function handleCollapseToggle(value) {
	      if (value) {
	        this.initPopper();
	      } else {
	        this.doDestroy();
	      }
	    },
	    addItem: function addItem(item) {
	      this.$set(this.items, item.index, item);
	    },
	    removeItem: function removeItem(item) {
	      delete this.items[item.index];
	    },
	    addSubmenu: function addSubmenu(item) {
	      this.$set(this.submenus, item.index, item);
	    },
	    removeSubmenu: function removeSubmenu(item) {
	      delete this.submenus[item.index];
	    },
	    handleClick: function handleClick() {
	      var rootMenu = this.rootMenu,
	          disabled = this.disabled;
	
	      if (rootMenu.menuTrigger === 'hover' && rootMenu.mode === 'horizontal' || rootMenu.collapse && rootMenu.mode === 'vertical' || disabled) {
	        return;
	      }
	      this.dispatch('ElMenu', 'submenu-click', this);
	    },
	    handleMouseenter: function handleMouseenter(event) {
	      var _this2 = this;
	
	      var showTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.showTimeout;
	
	
	      if (!('ActiveXObject' in window) && event.type === 'focus' && !event.relatedTarget) {
	        return;
	      }
	      var rootMenu = this.rootMenu,
	          disabled = this.disabled;
	
	      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical' || disabled) {
	        return;
	      }
	      this.dispatch('ElSubmenu', 'mouse-enter-child');
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this2.rootMenu.openMenu(_this2.index, _this2.indexPath);
	      }, showTimeout);
	
	      if (this.appendToBody) {
	        this.$parent.$el.dispatchEvent(new MouseEvent('mouseenter'));
	      }
	    },
	    handleMouseleave: function handleMouseleave() {
	      var _this3 = this;
	
	      var deepDispatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var rootMenu = this.rootMenu;
	
	      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical') {
	        return;
	      }
	      this.dispatch('ElSubmenu', 'mouse-leave-child');
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        !_this3.mouseInChild && _this3.rootMenu.closeMenu(_this3.index);
	      }, this.hideTimeout);
	
	      if (this.appendToBody && deepDispatch) {
	        if (this.$parent.$options.name === 'ElSubmenu') {
	          this.$parent.handleMouseleave(true);
	        }
	      }
	    },
	    handleTitleMouseenter: function handleTitleMouseenter() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      var title = this.$refs['submenu-title'];
	      title && (title.style.backgroundColor = this.rootMenu.hoverBackground);
	    },
	    handleTitleMouseleave: function handleTitleMouseleave() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      var title = this.$refs['submenu-title'];
	      title && (title.style.backgroundColor = this.rootMenu.backgroundColor || '');
	    },
	    updatePlacement: function updatePlacement() {
	      this.currentPlacement = this.mode === 'horizontal' && this.isFirstLevel ? 'bottom-start' : 'right-start';
	    },
	    initPopper: function initPopper() {
	      this.referenceElm = this.$el;
	      this.popperElm = this.$refs.menu;
	      this.updatePlacement();
	    }
	  },
	  created: function created() {
	    var _this4 = this;
	
	    this.$on('toggle-collapse', this.handleCollapseToggle);
	    this.$on('mouse-enter-child', function () {
	      _this4.mouseInChild = true;
	      clearTimeout(_this4.timeout);
	    });
	    this.$on('mouse-leave-child', function () {
	      _this4.mouseInChild = false;
	      clearTimeout(_this4.timeout);
	    });
	  },
	  mounted: function mounted() {
	    this.parentMenu.addSubmenu(this);
	    this.rootMenu.addSubmenu(this);
	    this.initPopper();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.parentMenu.removeSubmenu(this);
	    this.rootMenu.removeSubmenu(this);
	  },
	  render: function render(h) {
	    var _this5 = this;
	
	    var active = this.active,
	        opened = this.opened,
	        paddingStyle = this.paddingStyle,
	        titleStyle = this.titleStyle,
	        backgroundColor = this.backgroundColor,
	        rootMenu = this.rootMenu,
	        currentPlacement = this.currentPlacement,
	        menuTransitionName = this.menuTransitionName,
	        mode = this.mode,
	        disabled = this.disabled,
	        popperClass = this.popperClass,
	        $slots = this.$slots,
	        isFirstLevel = this.isFirstLevel;
	
	
	    var popupMenu = h(
	      'transition',
	      {
	        attrs: { name: menuTransitionName }
	      },
	      [h(
	        'div',
	        {
	          ref: 'menu',
	          directives: [{
	            name: 'show',
	            value: opened
	          }],
	
	          'class': ['el-menu--' + mode, popperClass],
	          on: {
	            'mouseenter': function mouseenter($event) {
	              return _this5.handleMouseenter($event, 100);
	            },
	            'mouseleave': function mouseleave() {
	              return _this5.handleMouseleave(true);
	            },
	            'focus': function focus($event) {
	              return _this5.handleMouseenter($event, 100);
	            }
	          }
	        },
	        [h(
	          'ul',
	          {
	            attrs: {
	              role: 'menu'
	            },
	            'class': ['el-menu el-menu--popup', 'el-menu--popup-' + currentPlacement],
	            style: { backgroundColor: rootMenu.backgroundColor || '' } },
	          [$slots.default]
	        )]
	      )]
	    );
	
	    var inlineMenu = h('el-collapse-transition', [h(
	      'ul',
	      {
	        attrs: {
	          role: 'menu'
	        },
	        'class': 'el-menu el-menu--inline',
	        directives: [{
	          name: 'show',
	          value: opened
	        }],
	
	        style: { backgroundColor: rootMenu.backgroundColor || '' } },
	      [$slots.default]
	    )]);
	
	    var submenuTitleIcon = rootMenu.mode === 'horizontal' && isFirstLevel || rootMenu.mode === 'vertical' && !rootMenu.collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-right';
	
	    return h(
	      'li',
	      {
	        'class': {
	          'el-submenu': true,
	          'is-active': active,
	          'is-opened': opened,
	          'is-disabled': disabled
	        },
	        attrs: { role: 'menuitem',
	          'aria-haspopup': 'true',
	          'aria-expanded': opened
	        },
	        on: {
	          'mouseenter': this.handleMouseenter,
	          'mouseleave': function mouseleave() {
	            return _this5.handleMouseleave(false);
	          },
	          'focus': this.handleMouseenter
	        }
	      },
	      [h(
	        'div',
	        {
	          'class': 'el-submenu__title',
	          ref: 'submenu-title',
	          on: {
	            'click': this.handleClick,
	            'mouseenter': this.handleTitleMouseenter,
	            'mouseleave': this.handleTitleMouseleave
	          },
	
	          style: [paddingStyle, titleStyle, { backgroundColor: backgroundColor }]
	        },
	        [$slots.title, h('i', { 'class': ['el-submenu__icon-arrow', submenuTitleIcon] })]
	      ), this.isMenuPopup ? popupMenu : inlineMenu]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/submenu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_submenuvue_type_script_lang_js_ = (submenuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/submenu.vue
	var submenu_render, submenu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var submenu_component = normalizeComponent(
	  src_submenuvue_type_script_lang_js_,
	  submenu_render,
	  submenu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var submenu_api; }
	submenu_component.options.__file = "packages/menu/src/submenu.vue"
	/* harmony default export */ var submenu = (submenu_component.exports);
	// CONCATENATED MODULE: ./packages/submenu/index.js
	
	
	/* istanbul ignore next */
	submenu.install = function (Vue) {
	  Vue.component(submenu.name, submenu);
	};
	
	/* harmony default export */ var packages_submenu = (submenu);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
	var menu_itemvue_type_template_id_2a5dbfea_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      staticClass: "el-menu-item",
	      class: {
	        "is-active": _vm.active,
	        "is-disabled": _vm.disabled
	      },
	      style: [
	        _vm.paddingStyle,
	        _vm.itemStyle,
	        { backgroundColor: _vm.backgroundColor }
	      ],
	      attrs: { role: "menuitem", tabindex: "-1" },
	      on: {
	        click: _vm.handleClick,
	        mouseenter: _vm.onMouseEnter,
	        focus: _vm.onMouseEnter,
	        blur: _vm.onMouseLeave,
	        mouseleave: _vm.onMouseLeave
	      }
	    },
	    [
	      _vm.parentMenu.$options.componentName === "ElMenu" &&
	      _vm.rootMenu.collapse &&
	      _vm.$slots.title
	        ? _c("el-tooltip", { attrs: { effect: "dark", placement: "right" } }, [
	            _c(
	              "div",
	              { attrs: { slot: "content" }, slot: "content" },
	              [_vm._t("title")],
	              2
	            ),
	            _c(
	              "div",
	              {
	                staticStyle: {
	                  position: "absolute",
	                  left: "0",
	                  top: "0",
	                  height: "100%",
	                  width: "100%",
	                  display: "inline-block",
	                  "box-sizing": "border-box",
	                  padding: "0 20px"
	                }
	              },
	              [_vm._t("default")],
	              2
	            )
	          ])
	        : [_vm._t("default"), _vm._t("title")]
	    ],
	    2
	  )
	}
	var menu_itemvue_type_template_id_2a5dbfea_staticRenderFns = []
	menu_itemvue_type_template_id_2a5dbfea_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
	
	// EXTERNAL MODULE: external "element-ui/lib/tooltip"
	var tooltip_ = __webpack_require__(26);
	var tooltip_default = /*#__PURE__*/__webpack_require__.n(tooltip_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var menu_itemvue_type_script_lang_js_ = ({
	  name: 'ElMenuItem',
	
	  componentName: 'ElMenuItem',
	
	  mixins: [menu_mixin, emitter_default.a],
	
	  components: { ElTooltip: tooltip_default.a },
	
	  props: {
	    index: {
	      default: null,
	      validator: function validator(val) {
	        return typeof val === 'string' || val === null;
	      }
	    },
	    route: [String, Object],
	    disabled: Boolean
	  },
	  computed: {
	    active: function active() {
	      return this.index === this.rootMenu.activeIndex;
	    },
	    hoverBackground: function hoverBackground() {
	      return this.rootMenu.hoverBackground;
	    },
	    backgroundColor: function backgroundColor() {
	      return this.rootMenu.backgroundColor || '';
	    },
	    activeTextColor: function activeTextColor() {
	      return this.rootMenu.activeTextColor || '';
	    },
	    textColor: function textColor() {
	      return this.rootMenu.textColor || '';
	    },
	    mode: function mode() {
	      return this.rootMenu.mode;
	    },
	    itemStyle: function itemStyle() {
	      var style = {
	        color: this.active ? this.activeTextColor : this.textColor
	      };
	      if (this.mode === 'horizontal' && !this.isNested) {
	        style.borderBottomColor = this.active ? this.rootMenu.activeTextColor ? this.activeTextColor : '' : 'transparent';
	      }
	      return style;
	    },
	    isNested: function isNested() {
	      return this.parentMenu !== this.rootMenu;
	    }
	  },
	  methods: {
	    onMouseEnter: function onMouseEnter() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      this.$el.style.backgroundColor = this.hoverBackground;
	    },
	    onMouseLeave: function onMouseLeave() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      this.$el.style.backgroundColor = this.backgroundColor;
	    },
	    handleClick: function handleClick() {
	      if (!this.disabled) {
	        this.dispatch('ElMenu', 'item-click', this);
	        this.$emit('click', this);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.parentMenu.addItem(this);
	    this.rootMenu.addItem(this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.parentMenu.removeItem(this);
	    this.rootMenu.removeItem(this);
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_menu_itemvue_type_script_lang_js_ = (menu_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue
	
	
	
	
	
	/* normalize component */
	
	var menu_item_component = normalizeComponent(
	  src_menu_itemvue_type_script_lang_js_,
	  menu_itemvue_type_template_id_2a5dbfea_render,
	  menu_itemvue_type_template_id_2a5dbfea_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var menu_item_api; }
	menu_item_component.options.__file = "packages/menu/src/menu-item.vue"
	/* harmony default export */ var menu_item = (menu_item_component.exports);
	// CONCATENATED MODULE: ./packages/menu-item/index.js
	
	
	/* istanbul ignore next */
	menu_item.install = function (Vue) {
	  Vue.component(menu_item.name, menu_item);
	};
	
	/* harmony default export */ var packages_menu_item = (menu_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
	var menu_item_groupvue_type_template_id_543b7bdc_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("li", { staticClass: "el-menu-item-group" }, [
	    _c(
	      "div",
	      {
	        staticClass: "el-menu-item-group__title",
	        style: { paddingLeft: _vm.levelPadding + "px" }
	      },
	      [!_vm.$slots.title ? [_vm._v(_vm._s(_vm.title))] : _vm._t("title")],
	      2
	    ),
	    _c("ul", [_vm._t("default")], 2)
	  ])
	}
	var menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns = []
	menu_item_groupvue_type_template_id_543b7bdc_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var menu_item_groupvue_type_script_lang_js_ = ({
	  name: 'ElMenuItemGroup',
	
	  componentName: 'ElMenuItemGroup',
	
	  inject: ['rootMenu'],
	  props: {
	    title: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      paddingLeft: 20
	    };
	  },
	
	  computed: {
	    levelPadding: function levelPadding() {
	      var padding = 20;
	      var parent = this.$parent;
	      if (this.rootMenu.collapse) return 20;
	      while (parent && parent.$options.componentName !== 'ElMenu') {
	        if (parent.$options.componentName === 'ElSubmenu') {
	          padding += 20;
	        }
	        parent = parent.$parent;
	      }
	      return padding;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_menu_item_groupvue_type_script_lang_js_ = (menu_item_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue
	
	
	
	
	
	/* normalize component */
	
	var menu_item_group_component = normalizeComponent(
	  src_menu_item_groupvue_type_script_lang_js_,
	  menu_item_groupvue_type_template_id_543b7bdc_render,
	  menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var menu_item_group_api; }
	menu_item_group_component.options.__file = "packages/menu/src/menu-item-group.vue"
	/* harmony default export */ var menu_item_group = (menu_item_group_component.exports);
	// CONCATENATED MODULE: ./packages/menu-item-group/index.js
	
	
	/* istanbul ignore next */
	menu_item_group.install = function (Vue) {
	  Vue.component(menu_item_group.name, menu_item_group);
	};
	
	/* harmony default export */ var packages_menu_item_group = (menu_item_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
	var inputvue_type_template_id_343dd774_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        _vm.type === "textarea" ? "el-textarea" : "el-input",
	        _vm.inputSize ? "el-input--" + _vm.inputSize : "",
	        {
	          "is-disabled": _vm.inputDisabled,
	          "is-exceed": _vm.inputExceed,
	          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
	          "el-input-group--append": _vm.$slots.append,
	          "el-input-group--prepend": _vm.$slots.prepend,
	          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
	          "el-input--suffix":
	            _vm.$slots.suffix ||
	            _vm.suffixIcon ||
	            _vm.clearable ||
	            _vm.showPassword
	        }
	      ],
	      on: {
	        mouseenter: function($event) {
	          _vm.hovering = true
	        },
	        mouseleave: function($event) {
	          _vm.hovering = false
	        }
	      }
	    },
	    [
	      _vm.type !== "textarea"
	        ? [
	            _vm.$slots.prepend
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__prepend" },
	                  [_vm._t("prepend")],
	                  2
	                )
	              : _vm._e(),
	            _vm.type !== "textarea"
	              ? _c(
	                  "input",
	                  _vm._b(
	                    {
	                      ref: "input",
	                      staticClass: "el-input__inner",
	                      attrs: {
	                        tabindex: _vm.tabindex,
	                        type: _vm.showPassword
	                          ? _vm.passwordVisible
	                            ? "text"
	                            : "password"
	                          : _vm.type,
	                        disabled: _vm.inputDisabled,
	                        readonly: _vm.readonly,
	                        autocomplete: _vm.autoComplete || _vm.autocomplete,
	                        "aria-label": _vm.label
	                      },
	                      on: {
	                        compositionstart: _vm.handleCompositionStart,
	                        compositionupdate: _vm.handleCompositionUpdate,
	                        compositionend: _vm.handleCompositionEnd,
	                        input: _vm.handleInput,
	                        focus: _vm.handleFocus,
	                        blur: _vm.handleBlur,
	                        change: _vm.handleChange
	                      }
	                    },
	                    "input",
	                    _vm.$attrs,
	                    false
	                  )
	                )
	              : _vm._e(),
	            _vm.$slots.prefix || _vm.prefixIcon
	              ? _c(
	                  "span",
	                  { staticClass: "el-input__prefix" },
	                  [
	                    _vm._t("prefix"),
	                    _vm.prefixIcon
	                      ? _c("i", {
	                          staticClass: "el-input__icon",
	                          class: _vm.prefixIcon
	                        })
	                      : _vm._e()
	                  ],
	                  2
	                )
	              : _vm._e(),
	            _vm.getSuffixVisible()
	              ? _c("span", { staticClass: "el-input__suffix" }, [
	                  _c(
	                    "span",
	                    { staticClass: "el-input__suffix-inner" },
	                    [
	                      !_vm.showClear ||
	                      !_vm.showPwdVisible ||
	                      !_vm.isWordLimitVisible
	                        ? [
	                            _vm._t("suffix"),
	                            _vm.suffixIcon
	                              ? _c("i", {
	                                  staticClass: "el-input__icon",
	                                  class: _vm.suffixIcon
	                                })
	                              : _vm._e()
	                          ]
	                        : _vm._e(),
	                      _vm.showClear
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-circle-close el-input__clear",
	                            on: {
	                              mousedown: function($event) {
	                                $event.preventDefault()
	                              },
	                              click: _vm.clear
	                            }
	                          })
	                        : _vm._e(),
	                      _vm.showPwdVisible
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-view el-input__clear",
	                            on: { click: _vm.handlePasswordVisible }
	                          })
	                        : _vm._e(),
	                      _vm.isWordLimitVisible
	                        ? _c("span", { staticClass: "el-input__count" }, [
	                            _c(
	                              "span",
	                              { staticClass: "el-input__count-inner" },
	                              [
	                                _vm._v(
	                                  "\n            " +
	                                    _vm._s(_vm.textLength) +
	                                    "/" +
	                                    _vm._s(_vm.upperLimit) +
	                                    "\n          "
	                                )
	                              ]
	                            )
	                          ])
	                        : _vm._e()
	                    ],
	                    2
	                  ),
	                  _vm.validateState
	                    ? _c("i", {
	                        staticClass: "el-input__icon",
	                        class: ["el-input__validateIcon", _vm.validateIcon]
	                      })
	                    : _vm._e()
	                ])
	              : _vm._e(),
	            _vm.$slots.append
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__append" },
	                  [_vm._t("append")],
	                  2
	                )
	              : _vm._e()
	          ]
	        : _c(
	            "textarea",
	            _vm._b(
	              {
	                ref: "textarea",
	                staticClass: "el-textarea__inner",
	                style: _vm.textareaStyle,
	                attrs: {
	                  tabindex: _vm.tabindex,
	                  disabled: _vm.inputDisabled,
	                  readonly: _vm.readonly,
	                  autocomplete: _vm.autoComplete || _vm.autocomplete,
	                  "aria-label": _vm.label
	                },
	                on: {
	                  compositionstart: _vm.handleCompositionStart,
	                  compositionupdate: _vm.handleCompositionUpdate,
	                  compositionend: _vm.handleCompositionEnd,
	                  input: _vm.handleInput,
	                  focus: _vm.handleFocus,
	                  blur: _vm.handleBlur,
	                  change: _vm.handleChange
	                }
	              },
	              "textarea",
	              _vm.$attrs,
	              false
	            )
	          ),
	      _vm.isWordLimitVisible && _vm.type === "textarea"
	        ? _c("span", { staticClass: "el-input__count" }, [
	            _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
	          ])
	        : _vm._e()
	    ],
	    2
	  )
	}
	var inputvue_type_template_id_343dd774_staticRenderFns = []
	inputvue_type_template_id_343dd774_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&
	
	// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
	var hiddenTextarea = void 0;
	
	var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	
	var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	
	function calculateNodeStyling(targetElement) {
	  var style = window.getComputedStyle(targetElement);
	
	  var boxSizing = style.getPropertyValue('box-sizing');
	
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	
	  var contextStyle = CONTEXT_STYLE.map(function (name) {
	    return name + ':' + style.getPropertyValue(name);
	  }).join(';');
	
	  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
	}
	
	function calcTextareaHeight(targetElement) {
	  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  }
	
	  var _calculateNodeStyling = calculateNodeStyling(targetElement),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      contextStyle = _calculateNodeStyling.contextStyle;
	
	  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
	  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';
	
	  var height = hiddenTextarea.scrollHeight;
	  var result = {};
	
	  if (boxSizing === 'border-box') {
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    height = height - paddingSize;
	  }
	
	  hiddenTextarea.value = '';
	  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	  if (minRows !== null) {
	    var minHeight = singleRowHeight * minRows;
	    if (boxSizing === 'border-box') {
	      minHeight = minHeight + paddingSize + borderSize;
	    }
	    height = Math.max(minHeight, height);
	    result.minHeight = minHeight + 'px';
	  }
	  if (maxRows !== null) {
	    var maxHeight = singleRowHeight * maxRows;
	    if (boxSizing === 'border-box') {
	      maxHeight = maxHeight + paddingSize + borderSize;
	    }
	    height = Math.min(maxHeight, height);
	  }
	  result.height = height + 'px';
	  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
	  hiddenTextarea = null;
	  return result;
	};
	// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
	var merge_ = __webpack_require__(7);
	var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(19);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	/* harmony default export */ var inputvue_type_script_lang_js_ = ({
	  name: 'ElInput',
	
	  componentName: 'ElInput',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  inheritAttrs: false,
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      textareaCalcStyle: {},
	      hovering: false,
	      focused: false,
	      isComposing: false,
	      passwordVisible: false
	    };
	  },
	
	
	  props: {
	    value: [String, Number],
	    size: String,
	    resize: String,
	    form: String,
	    disabled: Boolean,
	    readonly: Boolean,
	    type: {
	      type: String,
	      default: 'text'
	    },
	    autosize: {
	      type: [Boolean, Object],
	      default: false
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    validateEvent: {
	      type: Boolean,
	      default: true
	    },
	    suffixIcon: String,
	    prefixIcon: String,
	    label: String,
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	    showPassword: {
	      type: Boolean,
	      default: false
	    },
	    showWordLimit: {
	      type: Boolean,
	      default: false
	    },
	    tabindex: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    validateState: function validateState() {
	      return this.elFormItem ? this.elFormItem.validateState : '';
	    },
	    needStatusIcon: function needStatusIcon() {
	      return this.elForm ? this.elForm.statusIcon : false;
	    },
	    validateIcon: function validateIcon() {
	      return {
	        validating: 'el-icon-loading',
	        success: 'el-icon-circle-check',
	        error: 'el-icon-circle-close'
	      }[this.validateState];
	    },
	    textareaStyle: function textareaStyle() {
	      return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
	    },
	    inputSize: function inputSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputDisabled: function inputDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    nativeInputValue: function nativeInputValue() {
	      return this.value === null || this.value === undefined ? '' : String(this.value);
	    },
	    showClear: function showClear() {
	      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
	    },
	    showPwdVisible: function showPwdVisible() {
	      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
	    },
	    isWordLimitVisible: function isWordLimitVisible() {
	      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
	    },
	    upperLimit: function upperLimit() {
	      return this.$attrs.maxlength;
	    },
	    textLength: function textLength() {
	      if (typeof this.value === 'number') {
	        return String(this.value).length;
	      }
	
	      return (this.value || '').length;
	    },
	    inputExceed: function inputExceed() {
	      // show exceed style if length of initial value greater then maxlength
	      return this.isWordLimitVisible && this.textLength > this.upperLimit;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.$nextTick(this.resizeTextarea);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', [val]);
	      }
	    },
	
	    // native input value is set explicitly
	    // do not use v-model / :value in template
	    // see: https://github.com/ElemeFE/element/issues/14521
	    nativeInputValue: function nativeInputValue() {
	      this.setNativeInputValue();
	    },
	
	    // when change between <input> and <textarea>,
	    // update DOM dependent value and styles
	    // https://github.com/ElemeFE/element/issues/14857
	    type: function type() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.setNativeInputValue();
	        _this.resizeTextarea();
	        _this.updateIconOffset();
	      });
	    }
	  },
	
	  methods: {
	    focus: function focus() {
	      this.getInput().focus();
	    },
	    blur: function blur() {
	      this.getInput().blur();
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
	          'on-icon-click': 'on-icon-click is removed.'
	        },
	        events: {
	          'click': 'click is removed.'
	        }
	      };
	    },
	    handleBlur: function handleBlur(event) {
	      this.focused = false;
	      this.$emit('blur', event);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
	      }
	    },
	    select: function select() {
	      this.getInput().select();
	    },
	    resizeTextarea: function resizeTextarea() {
	      if (this.$isServer) return;
	      var autosize = this.autosize,
	          type = this.type;
	
	      if (type !== 'textarea') return;
	      if (!autosize) {
	        this.textareaCalcStyle = {
	          minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
	        };
	        return;
	      }
	      var minRows = autosize.minRows;
	      var maxRows = autosize.maxRows;
	
	      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
	    },
	    setNativeInputValue: function setNativeInputValue() {
	      var input = this.getInput();
	      if (!input) return;
	      if (input.value === this.nativeInputValue) return;
	      input.value = this.nativeInputValue;
	    },
	    handleFocus: function handleFocus(event) {
	      this.focused = true;
	      this.$emit('focus', event);
	    },
	    handleCompositionStart: function handleCompositionStart() {
	      this.isComposing = true;
	    },
	    handleCompositionUpdate: function handleCompositionUpdate(event) {
	      var text = event.target.value;
	      var lastCharacter = text[text.length - 1] || '';
	      this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
	    },
	    handleCompositionEnd: function handleCompositionEnd(event) {
	      if (this.isComposing) {
	        this.isComposing = false;
	        this.handleInput(event);
	      }
	    },
	    handleInput: function handleInput(event) {
	      // should not emit input during composition
	      // see: https://github.com/ElemeFE/element/issues/10516
	      if (this.isComposing) return;
	
	      // hack for https://github.com/ElemeFE/element/issues/8548
	      // should remove the following line when we don't support IE
	      if (event.target.value === this.nativeInputValue) return;
	
	      this.$emit('input', event.target.value);
	
	      // ensure native input value is controlled
	      // see: https://github.com/ElemeFE/element/issues/12850
	      this.$nextTick(this.setNativeInputValue);
	    },
	    handleChange: function handleChange(event) {
	      this.$emit('change', event.target.value);
	    },
	    calcIconOffset: function calcIconOffset(place) {
	      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
	      if (!elList.length) return;
	      var el = null;
	      for (var i = 0; i < elList.length; i++) {
	        if (elList[i].parentNode === this.$el) {
	          el = elList[i];
	          break;
	        }
	      }
	      if (!el) return;
	      var pendantMap = {
	        suffix: 'append',
	        prefix: 'prepend'
	      };
	
	      var pendant = pendantMap[place];
	      if (this.$slots[pendant]) {
	        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
	      } else {
	        el.removeAttribute('style');
	      }
	    },
	    updateIconOffset: function updateIconOffset() {
	      this.calcIconOffset('prefix');
	      this.calcIconOffset('suffix');
	    },
	    clear: function clear() {
	      this.$emit('input', '');
	      this.$emit('change', '');
	      this.$emit('clear');
	    },
	    handlePasswordVisible: function handlePasswordVisible() {
	      this.passwordVisible = !this.passwordVisible;
	      this.focus();
	    },
	    getInput: function getInput() {
	      return this.$refs.input || this.$refs.textarea;
	    },
	    getSuffixVisible: function getSuffixVisible() {
	      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
	    }
	  },
	
	  created: function created() {
	    this.$on('inputSelect', this.select);
	  },
	  mounted: function mounted() {
	    this.setNativeInputValue();
	    this.resizeTextarea();
	    this.updateIconOffset();
	  },
	  updated: function updated() {
	    this.$nextTick(this.updateIconOffset);
	  }
	});
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/input/src/input.vue
	
	
	
	
	
	/* normalize component */
	
	var input_component = normalizeComponent(
	  src_inputvue_type_script_lang_js_,
	  inputvue_type_template_id_343dd774_render,
	  inputvue_type_template_id_343dd774_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var input_api; }
	input_component.options.__file = "packages/input/src/input.vue"
	/* harmony default export */ var src_input = (input_component.exports);
	// CONCATENATED MODULE: ./packages/input/index.js
	
	
	/* istanbul ignore next */
	src_input.install = function (Vue) {
	  Vue.component(src_input.name, src_input);
	};
	
	/* harmony default export */ var packages_input = (src_input);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	var input_numbervue_type_template_id_42f8cf66_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        "el-input-number",
	        _vm.inputNumberSize ? "el-input-number--" + _vm.inputNumberSize : "",
	        { "is-disabled": _vm.inputNumberDisabled },
	        { "is-without-controls": !_vm.controls },
	        { "is-controls-right": _vm.controlsAtRight }
	      ],
	      on: {
	        dragstart: function($event) {
	          $event.preventDefault()
	        }
	      }
	    },
	    [
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.decrease,
	                  expression: "decrease"
	                }
	              ],
	              staticClass: "el-input-number__decrease",
	              class: { "is-disabled": _vm.minDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.decrease($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class:
	                  "el-icon-" + (_vm.controlsAtRight ? "arrow-down" : "minus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.increase,
	                  expression: "increase"
	                }
	              ],
	              staticClass: "el-input-number__increase",
	              class: { "is-disabled": _vm.maxDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.increase($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class: "el-icon-" + (_vm.controlsAtRight ? "arrow-up" : "plus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _c("el-input", {
	        ref: "input",
	        attrs: {
	          value: _vm.displayValue,
	          placeholder: _vm.placeholder,
	          disabled: _vm.inputNumberDisabled,
	          size: _vm.inputNumberSize,
	          max: _vm.max,
	          min: _vm.min,
	          name: _vm.name,
	          label: _vm.label
	        },
	        on: {
	          blur: _vm.handleBlur,
	          focus: _vm.handleFocus,
	          input: _vm.handleInput,
	          change: _vm.handleInputChange
	        },
	        nativeOn: {
	          keydown: [
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.increase($event)
	            },
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "down", 40, $event.key, [
	                  "Down",
	                  "ArrowDown"
	                ])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.decrease($event)
	            }
	          ]
	        }
	      })
	    ],
	    1
	  )
	}
	var input_numbervue_type_template_id_42f8cf66_staticRenderFns = []
	input_numbervue_type_template_id_42f8cf66_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	
	// CONCATENATED MODULE: ./src/directives/repeat-click.js
	
	
	/* harmony default export */ var repeat_click = ({
	  bind: function bind(el, binding, vnode) {
	    var interval = null;
	    var startTime = void 0;
	    var handler = function handler() {
	      return vnode.context[binding.expression].apply();
	    };
	    var clear = function clear() {
	      if (Date.now() - startTime < 100) {
	        handler();
	      }
	      clearInterval(interval);
	      interval = null;
	    };
	
	    Object(dom_["on"])(el, 'mousedown', function (e) {
	      if (e.button !== 0) return;
	      startTime = Date.now();
	      Object(dom_["once"])(document, 'mouseup', clear);
	      clearInterval(interval);
	      interval = setInterval(handler, 100);
	    });
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var input_numbervue_type_script_lang_js_ = ({
	  name: 'ElInputNumber',
	  mixins: [focus_default()('input')],
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	  directives: {
	    repeatClick: repeat_click
	  },
	  components: {
	    ElInput: input_default.a
	  },
	  props: {
	    step: {
	      type: Number,
	      default: 1
	    },
	    stepStrictly: {
	      type: Boolean,
	      default: false
	    },
	    max: {
	      type: Number,
	      default: Infinity
	    },
	    min: {
	      type: Number,
	      default: -Infinity
	    },
	    value: {},
	    disabled: Boolean,
	    size: String,
	    controls: {
	      type: Boolean,
	      default: true
	    },
	    controlsPosition: {
	      type: String,
	      default: ''
	    },
	    name: String,
	    label: String,
	    placeholder: String,
	    precision: {
	      type: Number,
	      validator: function validator(val) {
	        return val >= 0 && val === parseInt(val, 10);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: 0,
	      userInput: null
	    };
	  },
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(value) {
	        var newVal = value === undefined ? value : Number(value);
	        if (newVal !== undefined) {
	          if (isNaN(newVal)) {
	            return;
	          }
	
	          if (this.stepStrictly) {
	            var stepPrecision = this.getPrecision(this.step);
	            var precisionFactor = Math.pow(10, stepPrecision);
	            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
	          }
	
	          if (this.precision !== undefined) {
	            newVal = this.toPrecision(newVal, this.precision);
	          }
	        }
	        if (newVal >= this.max) newVal = this.max;
	        if (newVal <= this.min) newVal = this.min;
	        this.currentValue = newVal;
	        this.userInput = null;
	        this.$emit('input', newVal);
	      }
	    }
	  },
	  computed: {
	    minDisabled: function minDisabled() {
	      return this._decrease(this.value, this.step) < this.min;
	    },
	    maxDisabled: function maxDisabled() {
	      return this._increase(this.value, this.step) > this.max;
	    },
	    numPrecision: function numPrecision() {
	      var value = this.value,
	          step = this.step,
	          getPrecision = this.getPrecision,
	          precision = this.precision;
	
	      var stepPrecision = getPrecision(step);
	      if (precision !== undefined) {
	        if (stepPrecision > precision) {
	          console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
	        }
	        return precision;
	      } else {
	        return Math.max(getPrecision(value), stepPrecision);
	      }
	    },
	    controlsAtRight: function controlsAtRight() {
	      return this.controls && this.controlsPosition === 'right';
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    inputNumberSize: function inputNumberSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputNumberDisabled: function inputNumberDisabled() {
	      return this.disabled || !!(this.elForm || {}).disabled;
	    },
	    displayValue: function displayValue() {
	      if (this.userInput !== null) {
	        return this.userInput;
	      }
	
	      var currentValue = this.currentValue;
	
	      if (typeof currentValue === 'number') {
	        if (this.stepStrictly) {
	          var stepPrecision = this.getPrecision(this.step);
	          var precisionFactor = Math.pow(10, stepPrecision);
	          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
	        }
	
	        if (this.precision !== undefined) {
	          currentValue = currentValue.toFixed(this.precision);
	        }
	      }
	
	      return currentValue;
	    }
	  },
	  methods: {
	    toPrecision: function toPrecision(num, precision) {
	      if (precision === undefined) precision = this.numPrecision;
	      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
	    },
	    getPrecision: function getPrecision(value) {
	      if (value === undefined) return 0;
	      var valueString = value.toString();
	      var dotPosition = valueString.indexOf('.');
	      var precision = 0;
	      if (dotPosition !== -1) {
	        precision = valueString.length - dotPosition - 1;
	      }
	      return precision;
	    },
	    _increase: function _increase(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
	      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
	    },
	    _decrease: function _decrease(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	
	      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
	    },
	    increase: function increase() {
	      if (this.inputNumberDisabled || this.maxDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._increase(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    decrease: function decrease() {
	      if (this.inputNumberDisabled || this.minDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._decrease(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    handleBlur: function handleBlur(event) {
	      this.$emit('blur', event);
	    },
	    handleFocus: function handleFocus(event) {
	      this.$emit('focus', event);
	    },
	    setCurrentValue: function setCurrentValue(newVal) {
	      var oldVal = this.currentValue;
	      if (typeof newVal === 'number' && this.precision !== undefined) {
	        newVal = this.toPrecision(newVal, this.precision);
	      }
	      if (newVal >= this.max) newVal = this.max;
	      if (newVal <= this.min) newVal = this.min;
	      if (oldVal === newVal) return;
	      this.userInput = null;
	      this.$emit('input', newVal);
	      this.$emit('change', newVal, oldVal);
	      this.currentValue = newVal;
	    },
	    handleInput: function handleInput(value) {
	      this.userInput = value;
	    },
	    handleInputChange: function handleInputChange(value) {
	      var newVal = value === '' ? undefined : Number(value);
	      if (!isNaN(newVal) || value === '') {
	        this.setCurrentValue(newVal);
	      }
	      this.userInput = null;
	    },
	    select: function select() {
	      this.$refs.input.select();
	    }
	  },
	  mounted: function mounted() {
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('role', 'spinbutton');
	    innerInput.setAttribute('aria-valuemax', this.max);
	    innerInput.setAttribute('aria-valuemin', this.min);
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
	  },
	  updated: function updated() {
	    if (!this.$refs || !this.$refs.input) return;
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	  }
	});
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_input_numbervue_type_script_lang_js_ = (input_numbervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue
	
	
	
	
	
	/* normalize component */
	
	var input_number_component = normalizeComponent(
	  src_input_numbervue_type_script_lang_js_,
	  input_numbervue_type_template_id_42f8cf66_render,
	  input_numbervue_type_template_id_42f8cf66_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var input_number_api; }
	input_number_component.options.__file = "packages/input-number/src/input-number.vue"
	/* harmony default export */ var input_number = (input_number_component.exports);
	// CONCATENATED MODULE: ./packages/input-number/index.js
	
	
	/* istanbul ignore next */
	input_number.install = function (Vue) {
	  Vue.component(input_number.name, input_number);
	};
	
	/* harmony default export */ var packages_input_number = (input_number);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	var radiovue_type_template_id_69cd6268_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-radio",
	      class: [
	        _vm.border && _vm.radioSize ? "el-radio--" + _vm.radioSize : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-focus": _vm.focus },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.model === _vm.label }
	      ],
	      attrs: {
	        role: "radio",
	        "aria-checked": _vm.model === _vm.label,
	        "aria-disabled": _vm.isDisabled,
	        tabindex: _vm.tabIndex
	      },
	      on: {
	        keydown: function($event) {
	          if (
	            !("button" in $event) &&
	            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
	          ) {
	            return null
	          }
	          $event.stopPropagation()
	          $event.preventDefault()
	          _vm.model = _vm.isDisabled ? _vm.model : _vm.label
	        }
	      }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.model === _vm.label
	          }
	        },
	        [
	          _c("span", { staticClass: "el-radio__inner" }),
	          _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            ref: "radio",
	            staticClass: "el-radio__original",
	            attrs: {
	              type: "radio",
	              "aria-hidden": "true",
	              name: _vm.name,
	              disabled: _vm.isDisabled,
	              tabindex: "-1"
	            },
	            domProps: {
	              value: _vm.label,
	              checked: _vm._q(_vm.model, _vm.label)
	            },
	            on: {
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              },
	              change: [
	                function($event) {
	                  _vm.model = _vm.label
	                },
	                _vm.handleChange
	              ]
	            }
	          })
	        ]
	      ),
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__label",
	          on: {
	            keydown: function($event) {
	              $event.stopPropagation()
	            }
	          }
	        },
	        [
	          _vm._t("default"),
	          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var radiovue_type_template_id_69cd6268_staticRenderFns = []
	radiovue_type_template_id_69cd6268_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var radiovue_type_script_lang_js_ = ({
	  name: 'ElRadio',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElRadio',
	
	  props: {
	    value: {},
	    label: {},
	    disabled: Boolean,
	    name: String,
	    border: Boolean,
	    size: String
	  },
	
	  data: function data() {
	    return {
	      focus: false
	    };
	  },
	
	  computed: {
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElRadioGroup') {
	          parent = parent.$parent;
	        } else {
	          this._radioGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	
	    model: {
	      get: function get() {
	        return this.isGroup ? this._radioGroup.value : this.value;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.dispatch('ElRadioGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	        }
	        this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
	      }
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    radioSize: function radioSize() {
	      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    tabIndex: function tabIndex() {
	      return this.isDisabled || this.isGroup && this.model !== this.label ? -1 : 0;
	    }
	  },
	
	  methods: {
	    handleChange: function handleChange() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.$emit('change', _this.model);
	        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue
	
	
	
	
	
	/* normalize component */
	
	var radio_component = normalizeComponent(
	  src_radiovue_type_script_lang_js_,
	  radiovue_type_template_id_69cd6268_render,
	  radiovue_type_template_id_69cd6268_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var radio_api; }
	radio_component.options.__file = "packages/radio/src/radio.vue"
	/* harmony default export */ var src_radio = (radio_component.exports);
	// CONCATENATED MODULE: ./packages/radio/index.js
	
	
	/* istanbul ignore next */
	src_radio.install = function (Vue) {
	  Vue.component(src_radio.name, src_radio);
	};
	
	/* harmony default export */ var packages_radio = (src_radio);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
	var radio_groupvue_type_template_id_818a704c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    _vm._elTag,
	    {
	      tag: "component",
	      staticClass: "el-radio-group",
	      attrs: { role: "radiogroup" },
	      on: { keydown: _vm.handleKeydown }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var radio_groupvue_type_template_id_818a704c_staticRenderFns = []
	radio_groupvue_type_template_id_818a704c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	var keyCode = Object.freeze({
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40
	});
	/* harmony default export */ var radio_groupvue_type_script_lang_js_ = ({
	  name: 'ElRadioGroup',
	
	  componentName: 'ElRadioGroup',
	
	  inject: {
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  mixins: [emitter_default.a],
	
	  props: {
	    value: {},
	    size: String,
	    fill: String,
	    textColor: String,
	    disabled: Boolean
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    _elTag: function _elTag() {
	      return (this.$vnode.data || {}).tag || 'div';
	    },
	    radioGroupSize: function radioGroupSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.$on('handleChange', function (value) {
	      _this.$emit('change', value);
	    });
	  },
	  mounted: function mounted() {
	    // 当radioGroup没有默认选项时，第一个可以选中Tab导航
	    var radios = this.$el.querySelectorAll('[type=radio]');
	    var firstLabel = this.$el.querySelectorAll('[role=radio]')[0];
	    if (![].some.call(radios, function (radio) {
	      return radio.checked;
	    }) && firstLabel) {
	      firstLabel.tabIndex = 0;
	    }
	  },
	
	  methods: {
	    handleKeydown: function handleKeydown(e) {
	      // 左右上下按键 可以在radio组内切换不同选项
	      var target = e.target;
	      var className = target.nodeName === 'INPUT' ? '[type=radio]' : '[role=radio]';
	      var radios = this.$el.querySelectorAll(className);
	      var length = radios.length;
	      var index = [].indexOf.call(radios, target);
	      var roleRadios = this.$el.querySelectorAll('[role=radio]');
	      switch (e.keyCode) {
	        case keyCode.LEFT:
	        case keyCode.UP:
	          e.stopPropagation();
	          e.preventDefault();
	          if (index === 0) {
	            roleRadios[length - 1].click();
	            roleRadios[length - 1].focus();
	          } else {
	            roleRadios[index - 1].click();
	            roleRadios[index - 1].focus();
	          }
	          break;
	        case keyCode.RIGHT:
	        case keyCode.DOWN:
	          if (index === length - 1) {
	            e.stopPropagation();
	            e.preventDefault();
	            roleRadios[0].click();
	            roleRadios[0].focus();
	          } else {
	            roleRadios[index + 1].click();
	            roleRadios[index + 1].focus();
	          }
	          break;
	        default:
	          break;
	      }
	    }
	  },
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', [this.value]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radio_groupvue_type_script_lang_js_ = (radio_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue
	
	
	
	
	
	/* normalize component */
	
	var radio_group_component = normalizeComponent(
	  src_radio_groupvue_type_script_lang_js_,
	  radio_groupvue_type_template_id_818a704c_render,
	  radio_groupvue_type_template_id_818a704c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var radio_group_api; }
	radio_group_component.options.__file = "packages/radio/src/radio-group.vue"
	/* harmony default export */ var radio_group = (radio_group_component.exports);
	// CONCATENATED MODULE: ./packages/radio-group/index.js
	
	
	/* istanbul ignore next */
	radio_group.install = function (Vue) {
	  Vue.component(radio_group.name, radio_group);
	};
	
	/* harmony default export */ var packages_radio_group = (radio_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
	var radio_buttonvue_type_template_id_18a77a32_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-radio-button",
	      class: [
	        _vm.size ? "el-radio-button--" + _vm.size : "",
	        { "is-active": _vm.value === _vm.label },
	        { "is-disabled": _vm.isDisabled },
	        { "is-focus": _vm.focus }
	      ],
	      attrs: {
	        role: "radio",
	        "aria-checked": _vm.value === _vm.label,
	        "aria-disabled": _vm.isDisabled,
	        tabindex: _vm.tabIndex
	      },
	      on: {
	        keydown: function($event) {
	          if (
	            !("button" in $event) &&
	            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
	          ) {
	            return null
	          }
	          $event.stopPropagation()
	          $event.preventDefault()
	          _vm.value = _vm.isDisabled ? _vm.value : _vm.label
	        }
	      }
	    },
	    [
	      _c("input", {
	        directives: [
	          {
	            name: "model",
	            rawName: "v-model",
	            value: _vm.value,
	            expression: "value"
	          }
	        ],
	        staticClass: "el-radio-button__orig-radio",
	        attrs: {
	          type: "radio",
	          name: _vm.name,
	          disabled: _vm.isDisabled,
	          tabindex: "-1"
	        },
	        domProps: { value: _vm.label, checked: _vm._q(_vm.value, _vm.label) },
	        on: {
	          change: [
	            function($event) {
	              _vm.value = _vm.label
	            },
	            _vm.handleChange
	          ],
	          focus: function($event) {
	            _vm.focus = true
	          },
	          blur: function($event) {
	            _vm.focus = false
	          }
	        }
	      }),
	      _c(
	        "span",
	        {
	          staticClass: "el-radio-button__inner",
	          style: _vm.value === _vm.label ? _vm.activeStyle : null,
	          on: {
	            keydown: function($event) {
	              $event.stopPropagation()
	            }
	          }
	        },
	        [
	          _vm._t("default"),
	          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var radio_buttonvue_type_template_id_18a77a32_staticRenderFns = []
	radio_buttonvue_type_template_id_18a77a32_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var radio_buttonvue_type_script_lang_js_ = ({
	  name: 'ElRadioButton',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    label: {},
	    disabled: Boolean,
	    name: String
	  },
	  data: function data() {
	    return {
	      focus: false
	    };
	  },
	
	  computed: {
	    value: {
	      get: function get() {
	        return this._radioGroup.value;
	      },
	      set: function set(value) {
	        this._radioGroup.$emit('input', value);
	      }
	    },
	    _radioGroup: function _radioGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElRadioGroup') {
	          parent = parent.$parent;
	        } else {
	          return parent;
	        }
	      }
	      return false;
	    },
	    activeStyle: function activeStyle() {
	      return {
	        backgroundColor: this._radioGroup.fill || '',
	        borderColor: this._radioGroup.fill || '',
	        boxShadow: this._radioGroup.fill ? '-1px 0 0 0 ' + this._radioGroup.fill : '',
	        color: this._radioGroup.textColor || ''
	      };
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    size: function size() {
	      return this._radioGroup.radioGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    isDisabled: function isDisabled() {
	      return this.disabled || this._radioGroup.disabled || (this.elForm || {}).disabled;
	    },
	    tabIndex: function tabIndex() {
	      return this.isDisabled || this._radioGroup && this.value !== this.label ? -1 : 0;
	    }
	  },
	
	  methods: {
	    handleChange: function handleChange() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.dispatch('ElRadioGroup', 'handleChange', _this.value);
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radio_buttonvue_type_script_lang_js_ = (radio_buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue
	
	
	
	
	
	/* normalize component */
	
	var radio_button_component = normalizeComponent(
	  src_radio_buttonvue_type_script_lang_js_,
	  radio_buttonvue_type_template_id_18a77a32_render,
	  radio_buttonvue_type_template_id_18a77a32_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var radio_button_api; }
	radio_button_component.options.__file = "packages/radio/src/radio-button.vue"
	/* harmony default export */ var radio_button = (radio_button_component.exports);
	// CONCATENATED MODULE: ./packages/radio-button/index.js
	
	
	/* istanbul ignore next */
	radio_button.install = function (Vue) {
	  Vue.component(radio_button.name, radio_button);
	};
	
	/* harmony default export */ var packages_radio_button = (radio_button);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	var checkboxvue_type_template_id_d0387074_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-checkbox",
	      class: [
	        _vm.border && _vm.checkboxSize
	          ? "el-checkbox--" + _vm.checkboxSize
	          : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.isChecked }
	      ],
	      attrs: { id: _vm.id }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-checkbox__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.isChecked,
	            "is-indeterminate": _vm.indeterminate,
	            "is-focus": _vm.focus
	          },
	          attrs: {
	            tabindex: _vm.indeterminate ? 0 : false,
	            role: _vm.indeterminate ? "checkbox" : false,
	            "aria-checked": _vm.indeterminate ? "mixed" : false
	          }
	        },
	        [
	          _c("span", { staticClass: "el-checkbox__inner" }),
	          _vm.trueLabel || _vm.falseLabel
	            ? _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  name: _vm.name,
	                  disabled: _vm.isDisabled,
	                  "true-value": _vm.trueLabel,
	                  "false-value": _vm.falseLabel
	                },
	                domProps: {
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, null) > -1
	                    : _vm._q(_vm.model, _vm.trueLabel)
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
	                      if (Array.isArray($$a)) {
	                        var $$v = null,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	            : _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  disabled: _vm.isDisabled,
	                  name: _vm.name
	                },
	                domProps: {
	                  value: _vm.label,
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, _vm.label) > -1
	                    : _vm.model
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? true : false
	                      if (Array.isArray($$a)) {
	                        var $$v = _vm.label,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	        ]
	      ),
	      _vm.$slots.default || _vm.label
	        ? _c(
	            "span",
	            { staticClass: "el-checkbox__label" },
	            [
	              _vm._t("default"),
	              !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var checkboxvue_type_template_id_d0387074_staticRenderFns = []
	checkboxvue_type_template_id_d0387074_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
	  name: 'ElCheckbox',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElCheckbox',
	
	  data: function data() {
	    return {
	      selfModel: false,
	      focus: false,
	      isLimitExceeded: false
	    };
	  },
	
	
	  computed: {
	    model: {
	      get: function get() {
	        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.isLimitExceeded = false;
	          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
	
	          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
	
	          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	          this.selfModel = val;
	        }
	      }
	    },
	
	    isChecked: function isChecked() {
	      if ({}.toString.call(this.model) === '[object Boolean]') {
	        return this.model;
	      } else if (Array.isArray(this.model)) {
	        return this.model.indexOf(this.label) > -1;
	      } else if (this.model !== null && this.model !== undefined) {
	        return this.model === this.trueLabel;
	      }
	    },
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElCheckboxGroup') {
	          parent = parent.$parent;
	        } else {
	          this._checkboxGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	    store: function store() {
	      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
	    },
	
	
	    /* used to make the isDisabled judgment under max/min props */
	    isLimitDisabled: function isLimitDisabled() {
	      var _checkboxGroup = this._checkboxGroup,
	          max = _checkboxGroup.max,
	          min = _checkboxGroup.min;
	
	      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxSize: function checkboxSize() {
	      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
	    }
	  },
	
	  props: {
	    value: {},
	    label: {},
	    indeterminate: Boolean,
	    disabled: Boolean,
	    checked: Boolean,
	    name: String,
	    trueLabel: [String, Number],
	    falseLabel: [String, Number],
	    id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    border: Boolean,
	    size: String
	  },
	
	  methods: {
	    addToStore: function addToStore() {
	      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
	        this.model.push(this.label);
	      } else {
	        this.model = this.trueLabel || true;
	      }
	    },
	    handleChange: function handleChange(ev) {
	      var _this = this;
	
	      if (this.isLimitExceeded) return;
	      var value = void 0;
	      if (ev.target.checked) {
	        value = this.trueLabel === undefined ? true : this.trueLabel;
	      } else {
	        value = this.falseLabel === undefined ? false : this.falseLabel;
	      }
	      this.$emit('change', value, ev);
	      this.$nextTick(function () {
	        if (_this.isGroup) {
	          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
	        }
	      });
	    }
	  },
	
	  created: function created() {
	    this.checked && this.addToStore();
	  },
	  mounted: function mounted() {
	    // 为indeterminate元素 添加aria-controls 属性
	    if (this.indeterminate) {
	      this.$el.setAttribute('aria-controls', this.controls);
	    }
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', _value);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue
	
	
	
	
	
	/* normalize component */
	
	var checkbox_component = normalizeComponent(
	  src_checkboxvue_type_script_lang_js_,
	  checkboxvue_type_template_id_d0387074_render,
	  checkboxvue_type_template_id_d0387074_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var checkbox_api; }
	checkbox_component.options.__file = "packages/checkbox/src/checkbox.vue"
	/* harmony default export */ var src_checkbox = (checkbox_component.exports);
	// CONCATENATED MODULE: ./packages/checkbox/index.js
	
	
	/* istanbul ignore next */
	src_checkbox.install = function (Vue) {
	  Vue.component(src_checkbox.name, src_checkbox);
	};
	
	/* harmony default export */ var packages_checkbox = (src_checkbox);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
	var checkbox_buttonvue_type_template_id_478e906e_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-checkbox-button",
	      class: [
	        _vm.size ? "el-checkbox-button--" + _vm.size : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-checked": _vm.isChecked },
	        { "is-focus": _vm.focus }
	      ],
	      attrs: {
	        role: "checkbox",
	        "aria-checked": _vm.isChecked,
	        "aria-disabled": _vm.isDisabled
	      }
	    },
	    [
	      _vm.trueLabel || _vm.falseLabel
	        ? _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            staticClass: "el-checkbox-button__original",
	            attrs: {
	              type: "checkbox",
	              name: _vm.name,
	              disabled: _vm.isDisabled,
	              "true-value": _vm.trueLabel,
	              "false-value": _vm.falseLabel
	            },
	            domProps: {
	              checked: Array.isArray(_vm.model)
	                ? _vm._i(_vm.model, null) > -1
	                : _vm._q(_vm.model, _vm.trueLabel)
	            },
	            on: {
	              change: [
	                function($event) {
	                  var $$a = _vm.model,
	                    $$el = $event.target,
	                    $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
	                  if (Array.isArray($$a)) {
	                    var $$v = null,
	                      $$i = _vm._i($$a, $$v)
	                    if ($$el.checked) {
	                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                    } else {
	                      $$i > -1 &&
	                        (_vm.model = $$a
	                          .slice(0, $$i)
	                          .concat($$a.slice($$i + 1)))
	                    }
	                  } else {
	                    _vm.model = $$c
	                  }
	                },
	                _vm.handleChange
	              ],
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              }
	            }
	          })
	        : _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            staticClass: "el-checkbox-button__original",
	            attrs: {
	              type: "checkbox",
	              name: _vm.name,
	              disabled: _vm.isDisabled
	            },
	            domProps: {
	              value: _vm.label,
	              checked: Array.isArray(_vm.model)
	                ? _vm._i(_vm.model, _vm.label) > -1
	                : _vm.model
	            },
	            on: {
	              change: [
	                function($event) {
	                  var $$a = _vm.model,
	                    $$el = $event.target,
	                    $$c = $$el.checked ? true : false
	                  if (Array.isArray($$a)) {
	                    var $$v = _vm.label,
	                      $$i = _vm._i($$a, $$v)
	                    if ($$el.checked) {
	                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                    } else {
	                      $$i > -1 &&
	                        (_vm.model = $$a
	                          .slice(0, $$i)
	                          .concat($$a.slice($$i + 1)))
	                    }
	                  } else {
	                    _vm.model = $$c
	                  }
	                },
	                _vm.handleChange
	              ],
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              }
	            }
	          }),
	      _vm.$slots.default || _vm.label
	        ? _c(
	            "span",
	            {
	              staticClass: "el-checkbox-button__inner",
	              style: _vm.isChecked ? _vm.activeStyle : null
	            },
	            [_vm._t("default", [_vm._v(_vm._s(_vm.label))])],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var checkbox_buttonvue_type_template_id_478e906e_staticRenderFns = []
	checkbox_buttonvue_type_template_id_478e906e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var checkbox_buttonvue_type_script_lang_js_ = ({
	  name: 'ElCheckboxButton',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      selfModel: false,
	      focus: false,
	      isLimitExceeded: false
	    };
	  },
	
	
	  props: {
	    value: {},
	    label: {},
	    disabled: Boolean,
	    checked: Boolean,
	    name: String,
	    trueLabel: [String, Number],
	    falseLabel: [String, Number]
	  },
	  computed: {
	    model: {
	      get: function get() {
	        return this._checkboxGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
	      },
	      set: function set(val) {
	        if (this._checkboxGroup) {
	          this.isLimitExceeded = false;
	          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
	
	          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
	
	          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
	        } else if (this.value !== undefined) {
	          this.$emit('input', val);
	        } else {
	          this.selfModel = val;
	        }
	      }
	    },
	
	    isChecked: function isChecked() {
	      if ({}.toString.call(this.model) === '[object Boolean]') {
	        return this.model;
	      } else if (Array.isArray(this.model)) {
	        return this.model.indexOf(this.label) > -1;
	      } else if (this.model !== null && this.model !== undefined) {
	        return this.model === this.trueLabel;
	      }
	    },
	    _checkboxGroup: function _checkboxGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElCheckboxGroup') {
	          parent = parent.$parent;
	        } else {
	          return parent;
	        }
	      }
	      return false;
	    },
	    store: function store() {
	      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
	    },
	    activeStyle: function activeStyle() {
	      return {
	        backgroundColor: this._checkboxGroup.fill || '',
	        borderColor: this._checkboxGroup.fill || '',
	        color: this._checkboxGroup.textColor || '',
	        'box-shadow': '-1px 0 0 0 ' + this._checkboxGroup.fill
	
	      };
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    size: function size() {
	      return this._checkboxGroup.checkboxGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	
	
	    /* used to make the isDisabled judgment under max/min props */
	    isLimitDisabled: function isLimitDisabled() {
	      var _checkboxGroup2 = this._checkboxGroup,
	          max = _checkboxGroup2.max,
	          min = _checkboxGroup2.min;
	
	      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
	    },
	    isDisabled: function isDisabled() {
	      return this._checkboxGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	  methods: {
	    addToStore: function addToStore() {
	      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
	        this.model.push(this.label);
	      } else {
	        this.model = this.trueLabel || true;
	      }
	    },
	    handleChange: function handleChange(ev) {
	      var _this = this;
	
	      if (this.isLimitExceeded) return;
	      var value = void 0;
	      if (ev.target.checked) {
	        value = this.trueLabel === undefined ? true : this.trueLabel;
	      } else {
	        value = this.falseLabel === undefined ? false : this.falseLabel;
	      }
	      this.$emit('change', value, ev);
	      this.$nextTick(function () {
	        if (_this._checkboxGroup) {
	          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
	        }
	      });
	    }
	  },
	
	  created: function created() {
	    this.checked && this.addToStore();
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkbox_buttonvue_type_script_lang_js_ = (checkbox_buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue
	
	
	
	
	
	/* normalize component */
	
	var checkbox_button_component = normalizeComponent(
	  src_checkbox_buttonvue_type_script_lang_js_,
	  checkbox_buttonvue_type_template_id_478e906e_render,
	  checkbox_buttonvue_type_template_id_478e906e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var checkbox_button_api; }
	checkbox_button_component.options.__file = "packages/checkbox/src/checkbox-button.vue"
	/* harmony default export */ var checkbox_button = (checkbox_button_component.exports);
	// CONCATENATED MODULE: ./packages/checkbox-button/index.js
	
	
	/* istanbul ignore next */
	checkbox_button.install = function (Vue) {
	  Vue.component(checkbox_button.name, checkbox_button);
	};
	
	/* harmony default export */ var packages_checkbox_button = (checkbox_button);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	var checkbox_groupvue_type_template_id_7289a290_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-checkbox-group",
	      attrs: { role: "group", "aria-label": "checkbox-group" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var checkbox_groupvue_type_template_id_7289a290_staticRenderFns = []
	checkbox_groupvue_type_template_id_7289a290_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	
	
	
	/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
	  name: 'ElCheckboxGroup',
	
	  componentName: 'ElCheckboxGroup',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    value: {},
	    disabled: Boolean,
	    min: Number,
	    max: Number,
	    size: String,
	    fill: String,
	    textColor: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxGroupSize: function checkboxGroupSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', [_value]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue
	
	
	
	
	
	/* normalize component */
	
	var checkbox_group_component = normalizeComponent(
	  src_checkbox_groupvue_type_script_lang_js_,
	  checkbox_groupvue_type_template_id_7289a290_render,
	  checkbox_groupvue_type_template_id_7289a290_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var checkbox_group_api; }
	checkbox_group_component.options.__file = "packages/checkbox/src/checkbox-group.vue"
	/* harmony default export */ var checkbox_group = (checkbox_group_component.exports);
	// CONCATENATED MODULE: ./packages/checkbox-group/index.js
	
	
	/* istanbul ignore next */
	checkbox_group.install = function (Vue) {
	  Vue.component(checkbox_group.name, checkbox_group);
	};
	
	/* harmony default export */ var packages_checkbox_group = (checkbox_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
	var componentvue_type_template_id_2dcd8fbb_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-switch",
	      class: { "is-disabled": _vm.switchDisabled, "is-checked": _vm.checked },
	      attrs: {
	        role: "switch",
	        "aria-checked": _vm.checked,
	        "aria-disabled": _vm.switchDisabled
	      },
	      on: {
	        click: function($event) {
	          $event.preventDefault()
	          return _vm.switchValue($event)
	        }
	      }
	    },
	    [
	      _c("input", {
	        ref: "input",
	        staticClass: "el-switch__input",
	        attrs: {
	          type: "checkbox",
	          id: _vm.id,
	          name: _vm.name,
	          "true-value": _vm.activeValue,
	          "false-value": _vm.inactiveValue,
	          disabled: _vm.switchDisabled
	        },
	        on: {
	          change: _vm.handleChange,
	          keydown: function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	            ) {
	              return null
	            }
	            return _vm.switchValue($event)
	          }
	        }
	      }),
	      _vm.inactiveIconClass || _vm.inactiveText
	        ? _c(
	            "span",
	            {
	              class: [
	                "el-switch__label",
	                "el-switch__label--left",
	                !_vm.checked ? "is-active" : ""
	              ]
	            },
	            [
	              _vm.inactiveIconClass
	                ? _c("i", { class: [_vm.inactiveIconClass] })
	                : _vm._e(),
	              !_vm.inactiveIconClass && _vm.inactiveText
	                ? _c("span", { attrs: { "aria-hidden": _vm.checked } }, [
	                    _vm._v(_vm._s(_vm.inactiveText))
	                  ])
	                : _vm._e()
	            ]
	          )
	        : _vm._e(),
	      _c("span", {
	        ref: "core",
	        staticClass: "el-switch__core",
	        style: { width: _vm.coreWidth + "px" }
	      }),
	      _vm.activeIconClass || _vm.activeText
	        ? _c(
	            "span",
	            {
	              class: [
	                "el-switch__label",
	                "el-switch__label--right",
	                _vm.checked ? "is-active" : ""
	              ]
	            },
	            [
	              _vm.activeIconClass
	                ? _c("i", { class: [_vm.activeIconClass] })
	                : _vm._e(),
	              !_vm.activeIconClass && _vm.activeText
	                ? _c("span", { attrs: { "aria-hidden": !_vm.checked } }, [
	                    _vm._v(_vm._s(_vm.activeText))
	                  ])
	                : _vm._e()
	            ]
	          )
	        : _vm._e()
	    ]
	  )
	}
	var componentvue_type_template_id_2dcd8fbb_staticRenderFns = []
	componentvue_type_template_id_2dcd8fbb_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var switch_src_componentvue_type_script_lang_js_ = ({
	  name: 'ElSwitch',
	  mixins: [focus_default()('input'), migrating_default.a, emitter_default.a],
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	  props: {
	    value: {
	      type: [Boolean, String, Number],
	      default: false
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    width: {
	      type: Number,
	      default: 40
	    },
	    activeIconClass: {
	      type: String,
	      default: ''
	    },
	    inactiveIconClass: {
	      type: String,
	      default: ''
	    },
	    activeText: String,
	    inactiveText: String,
	    activeColor: {
	      type: String,
	      default: ''
	    },
	    inactiveColor: {
	      type: String,
	      default: ''
	    },
	    activeValue: {
	      type: [Boolean, String, Number],
	      default: true
	    },
	    inactiveValue: {
	      type: [Boolean, String, Number],
	      default: false
	    },
	    name: {
	      type: String,
	      default: ''
	    },
	    validateEvent: {
	      type: Boolean,
	      default: true
	    },
	    id: String
	  },
	  data: function data() {
	    return {
	      coreWidth: this.width
	    };
	  },
	  created: function created() {
	    if (!~[this.activeValue, this.inactiveValue].indexOf(this.value)) {
	      this.$emit('input', this.inactiveValue);
	    }
	  },
	
	  computed: {
	    checked: function checked() {
	      return this.value === this.activeValue;
	    },
	    switchDisabled: function switchDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	  watch: {
	    checked: function checked() {
	      this.$refs.input.checked = this.checked;
	      if (this.activeColor || this.inactiveColor) {
	        this.setBackgroundColor();
	      }
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', [this.value]);
	      }
	    }
	  },
	  methods: {
	    handleChange: function handleChange(event) {
	      var _this = this;
	
	      var val = this.checked ? this.inactiveValue : this.activeValue;
	      this.$emit('input', val);
	      this.$emit('change', val);
	      this.$nextTick(function () {
	        // set input's checked property
	        // in case parent refuses to change component's value
	        _this.$refs.input.checked = _this.checked;
	      });
	    },
	    setBackgroundColor: function setBackgroundColor() {
	      var newColor = this.checked ? this.activeColor : this.inactiveColor;
	      this.$refs.core.style.borderColor = newColor;
	      this.$refs.core.style.backgroundColor = newColor;
	    },
	    switchValue: function switchValue() {
	      !this.switchDisabled && this.handleChange();
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'on-color': 'on-color is renamed to active-color.',
	          'off-color': 'off-color is renamed to inactive-color.',
	          'on-text': 'on-text is renamed to active-text.',
	          'off-text': 'off-text is renamed to inactive-text.',
	          'on-value': 'on-value is renamed to active-value.',
	          'off-value': 'off-value is renamed to inactive-value.',
	          'on-icon-class': 'on-icon-class is renamed to active-icon-class.',
	          'off-icon-class': 'off-icon-class is renamed to inactive-icon-class.'
	        }
	      };
	    }
	  },
	  mounted: function mounted() {
	    /* istanbul ignore if */
	    this.coreWidth = this.width || 40;
	    if (this.activeColor || this.inactiveColor) {
	      this.setBackgroundColor();
	    }
	    this.$refs.input.checked = this.checked;
	  }
	});
	// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_switch_src_componentvue_type_script_lang_js_ = (switch_src_componentvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/switch/src/component.vue
	
	
	
	
	
	/* normalize component */
	
	var src_component_component = normalizeComponent(
	  packages_switch_src_componentvue_type_script_lang_js_,
	  componentvue_type_template_id_2dcd8fbb_render,
	  componentvue_type_template_id_2dcd8fbb_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_component_api; }
	src_component_component.options.__file = "packages/switch/src/component.vue"
	/* harmony default export */ var switch_src_component = (src_component_component.exports);
	// CONCATENATED MODULE: ./packages/switch/index.js
	
	
	/* istanbul ignore next */
	switch_src_component.install = function (Vue) {
	  Vue.component(switch_src_component.name, switch_src_component);
	};
	
	/* harmony default export */ var packages_switch = (switch_src_component);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	var selectvue_type_template_id_0e4aade6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.handleClose,
	          expression: "handleClose"
	        }
	      ],
	      staticClass: "el-select",
	      class: [_vm.selectSize ? "el-select--" + _vm.selectSize : ""],
	      on: {
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.toggleMenu($event)
	        }
	      }
	    },
	    [
	      _vm.multiple
	        ? _c(
	            "div",
	            {
	              ref: "tags",
	              staticClass: "el-select__tags",
	              style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
	            },
	            [
	              _vm.collapseTags && _vm.selected.length
	                ? _c(
	                    "span",
	                    [
	                      _c(
	                        "el-tag",
	                        {
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: _vm.selected[0].hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, _vm.selected[0])
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(_vm.selected[0].currentLabel))
	                          ])
	                        ]
	                      ),
	                      _vm.selected.length > 1
	                        ? _c(
	                            "el-tag",
	                            {
	                              attrs: {
	                                closable: false,
	                                size: _vm.collapseTagSize,
	                                type: "info",
	                                "disable-transitions": ""
	                              }
	                            },
	                            [
	                              _c(
	                                "span",
	                                { staticClass: "el-select__tags-text" },
	                                [_vm._v("+ " + _vm._s(_vm.selected.length - 1))]
	                              )
	                            ]
	                          )
	                        : _vm._e()
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              !_vm.collapseTags
	                ? _c(
	                    "transition-group",
	                    { on: { "after-leave": _vm.resetInputHeight } },
	                    _vm._l(_vm.selected, function(item) {
	                      return _c(
	                        "el-tag",
	                        {
	                          key: _vm.getValueKey(item),
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: item.hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, item)
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(item.currentLabel))
	                          ])
	                        ]
	                      )
	                    }),
	                    1
	                  )
	                : _vm._e(),
	              _vm.filterable
	                ? _c("input", {
	                    directives: [
	                      {
	                        name: "model",
	                        rawName: "v-model",
	                        value: _vm.query,
	                        expression: "query"
	                      }
	                    ],
	                    ref: "input",
	                    staticClass: "el-select__input",
	                    class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
	                    style: {
	                      "flex-grow": "1",
	                      width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
	                      "max-width": _vm.inputWidth - 42 + "px"
	                    },
	                    attrs: {
	                      type: "text",
	                      disabled: _vm.selectDisabled,
	                      autocomplete: _vm.autoComplete || _vm.autocomplete
	                    },
	                    domProps: { value: _vm.query },
	                    on: {
	                      focus: _vm.handleFocus,
	                      blur: function($event) {
	                        _vm.softFocus = false
	                      },
	                      keyup: _vm.managePlaceholder,
	                      keydown: [
	                        _vm.resetInputState,
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "down", 40, $event.key, [
	                              "Down",
	                              "ArrowDown"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("next")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "up", 38, $event.key, [
	                              "Up",
	                              "ArrowUp"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("prev")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "enter",
	                              13,
	                              $event.key,
	                              "Enter"
	                            )
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          return _vm.selectOption($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "esc", 27, $event.key, [
	                              "Esc",
	                              "Escape"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.stopPropagation()
	                          $event.preventDefault()
	                          _vm.visible = false
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "delete",
	                              [8, 46],
	                              $event.key,
	                              ["Backspace", "Delete", "Del"]
	                            )
	                          ) {
	                            return null
	                          }
	                          return _vm.deletePrevTag($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                          ) {
	                            return null
	                          }
	                          _vm.visible = false
	                        }
	                      ],
	                      compositionstart: _vm.handleComposition,
	                      compositionupdate: _vm.handleComposition,
	                      compositionend: _vm.handleComposition,
	                      input: [
	                        function($event) {
	                          if ($event.target.composing) {
	                            return
	                          }
	                          _vm.query = $event.target.value
	                        },
	                        _vm.debouncedQueryChange
	                      ]
	                    }
	                  })
	                : _vm._e()
	            ],
	            1
	          )
	        : _vm._e(),
	      _c(
	        "el-input",
	        {
	          ref: "reference",
	          class: { "is-focus": _vm.visible },
	          attrs: {
	            type: "text",
	            placeholder: _vm.currentPlaceholder,
	            name: _vm.name,
	            id: _vm.id,
	            autocomplete: _vm.autoComplete || _vm.autocomplete,
	            size: _vm.selectSize,
	            disabled: _vm.selectDisabled,
	            readonly: _vm.readonly,
	            "validate-event": false,
	            tabindex: _vm.multiple && _vm.filterable ? "-1" : null
	          },
	          on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
	          nativeOn: {
	            keyup: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            keydown: [
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "down", 40, $event.key, [
	                    "Down",
	                    "ArrowDown"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("next")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "up", 38, $event.key, [
	                    "Up",
	                    "ArrowUp"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("prev")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                ) {
	                  return null
	                }
	                $event.preventDefault()
	                return _vm.selectOption($event)
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "esc", 27, $event.key, [
	                    "Esc",
	                    "Escape"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.visible = false
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                ) {
	                  return null
	                }
	                _vm.visible = false
	              }
	            ],
	            paste: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            mouseenter: function($event) {
	              _vm.inputHovering = true
	            },
	            mouseleave: function($event) {
	              _vm.inputHovering = false
	            }
	          },
	          model: {
	            value: _vm.selectedLabel,
	            callback: function($$v) {
	              _vm.selectedLabel = $$v
	            },
	            expression: "selectedLabel"
	          }
	        },
	        [
	          _vm.$slots.prefix
	            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
	            : _vm._e(),
	          _c("template", { slot: "suffix" }, [
	            _c("i", {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.showClose,
	                  expression: "!showClose"
	                }
	              ],
	              class: [
	                "el-select__caret",
	                "el-input__icon",
	                "el-icon-" + _vm.iconClass
	              ]
	            }),
	            _vm.showClose
	              ? _c("i", {
	                  staticClass:
	                    "el-select__caret el-input__icon el-icon-circle-close",
	                  on: { click: _vm.handleClearClick }
	                })
	              : _vm._e()
	          ])
	        ],
	        2
	      ),
	      _c(
	        "transition",
	        {
	          attrs: { name: "el-zoom-in-top" },
	          on: {
	            "before-enter": _vm.handleMenuEnter,
	            "after-leave": _vm.doDestroy
	          }
	        },
	        [
	          _c(
	            "el-select-menu",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.visible && _vm.emptyText !== false,
	                  expression: "visible && emptyText !== false"
	                }
	              ],
	              ref: "popper",
	              attrs: { "append-to-body": _vm.popperAppendToBody }
	            },
	            [
	              _c(
	                "el-scrollbar",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.options.length > 0 && !_vm.loading,
	                      expression: "options.length > 0 && !loading"
	                    }
	                  ],
	                  ref: "scrollbar",
	                  class: {
	                    "is-empty":
	                      !_vm.allowCreate &&
	                      _vm.query &&
	                      _vm.filteredOptionsCount === 0
	                  },
	                  attrs: {
	                    tag: "ul",
	                    "wrap-class": "el-select-dropdown__wrap",
	                    "view-class": "el-select-dropdown__list"
	                  }
	                },
	                [
	                  _vm.showNewOption
	                    ? _c("el-option", {
	                        attrs: { value: _vm.query, created: "" }
	                      })
	                    : _vm._e(),
	                  _vm._t("default")
	                ],
	                2
	              ),
	              _vm.emptyText &&
	              (!_vm.allowCreate ||
	                _vm.loading ||
	                (_vm.allowCreate && _vm.options.length === 0))
	                ? [
	                    _vm.$slots.empty
	                      ? _vm._t("empty")
	                      : _c("p", { staticClass: "el-select-dropdown__empty" }, [
	                          _vm._v(
	                            "\n          " +
	                              _vm._s(_vm.emptyText) +
	                              "\n        "
	                          )
	                        ])
	                  ]
	                : _vm._e()
	            ],
	            2
	          )
	        ],
	        1
	      )
	    ],
	    1
	  )
	}
	var selectvue_type_template_id_0e4aade6_staticRenderFns = []
	selectvue_type_template_id_0e4aade6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	var select_dropdownvue_type_template_id_06828748_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-select-dropdown el-popper",
	      class: [{ "is-multiple": _vm.$parent.multiple }, _vm.popperClass],
	      style: { minWidth: _vm.minWidth }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var select_dropdownvue_type_template_id_06828748_staticRenderFns = []
	select_dropdownvue_type_template_id_06828748_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var select_dropdownvue_type_script_lang_js_ = ({
	  name: 'ElSelectDropdown',
	
	  componentName: 'ElSelectDropdown',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    placement: {
	      default: 'bottom-start'
	    },
	
	    boundariesPadding: {
	      default: 0
	    },
	
	    popperOptions: {
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    },
	
	    visibleArrow: {
	      default: true
	    },
	
	    appendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      minWidth: ''
	    };
	  },
	
	
	  computed: {
	    popperClass: function popperClass() {
	      return this.$parent.popperClass;
	    }
	  },
	
	  watch: {
	    '$parent.inputWidth': function $parentInputWidth() {
	      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.referenceElm = this.$parent.$refs.reference.$el;
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.$on('updatePopper', function () {
	      if (_this.$parent.visible) _this.updatePopper();
	    });
	    this.$on('destroyPopper', this.destroyPopper);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_select_dropdownvue_type_script_lang_js_ = (select_dropdownvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue
	
	
	
	
	
	/* normalize component */
	
	var select_dropdown_component = normalizeComponent(
	  src_select_dropdownvue_type_script_lang_js_,
	  select_dropdownvue_type_template_id_06828748_render,
	  select_dropdownvue_type_template_id_06828748_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var select_dropdown_api; }
	select_dropdown_component.options.__file = "packages/select/src/select-dropdown.vue"
	/* harmony default export */ var select_dropdown = (select_dropdown_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	var optionvue_type_template_id_7a44c642_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-dropdown__item",
	      class: {
	        selected: _vm.itemSelected,
	        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
	        hover: _vm.hover
	      },
	      on: {
	        mouseenter: _vm.hoverItem,
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.selectOptionClick($event)
	        }
	      }
	    },
	    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
	    2
	  )
	}
	var optionvue_type_template_id_7a44c642_staticRenderFns = []
	optionvue_type_template_id_7a44c642_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var optionvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOption',
	
	  componentName: 'ElOption',
	
	  inject: ['select'],
	
	  props: {
	    value: {
	      required: true
	    },
	    label: [String, Number],
	    created: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      groupDisabled: false,
	      visible: true,
	      hitState: false,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    isObject: function isObject() {
	      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
	    },
	    currentLabel: function currentLabel() {
	      return this.label || (this.isObject ? '' : this.value);
	    },
	    currentValue: function currentValue() {
	      return this.value || this.label || '';
	    },
	    itemSelected: function itemSelected() {
	      if (!this.select.multiple) {
	        return this.isEqual(this.value, this.select.value);
	      } else {
	        return this.contains(this.select.value, this.value);
	      }
	    },
	    limitReached: function limitReached() {
	      if (this.select.multiple) {
	        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
	      } else {
	        return false;
	      }
	    }
	  },
	
	  watch: {
	    currentLabel: function currentLabel() {
	      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
	    },
	    value: function value(val, oldVal) {
	      var _select = this.select,
	          remote = _select.remote,
	          valueKey = _select.valueKey;
	
	      if (!this.created && !remote) {
	        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
	          return;
	        }
	        this.dispatch('ElSelect', 'setSelected');
	      }
	    }
	  },
	
	  methods: {
	    isEqual: function isEqual(a, b) {
	      if (!this.isObject) {
	        return a === b;
	      } else {
	        var valueKey = this.select.valueKey;
	        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
	      }
	    },
	    contains: function contains() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var target = arguments[1];
	
	      if (!this.isObject) {
	        return arr && arr.indexOf(target) > -1;
	      } else {
	        var valueKey = this.select.valueKey;
	        return arr && arr.some(function (item) {
	          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
	        });
	      }
	    },
	    handleGroupDisabled: function handleGroupDisabled(val) {
	      this.groupDisabled = val;
	    },
	    hoverItem: function hoverItem() {
	      if (!this.disabled && !this.groupDisabled) {
	        this.select.hoverIndex = this.select.options.indexOf(this);
	      }
	    },
	    selectOptionClick: function selectOptionClick() {
	      if (this.disabled !== true && this.groupDisabled !== true) {
	        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
	      }
	    },
	    queryChange: function queryChange(query) {
	      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
	      if (!this.visible) {
	        this.select.filteredOptionsCount--;
	      }
	    }
	  },
	
	  created: function created() {
	    this.select.options.push(this);
	    this.select.cachedOptions.push(this);
	    this.select.optionsCount++;
	    this.select.filteredOptionsCount++;
	
	    this.$on('queryChange', this.queryChange);
	    this.$on('handleGroupDisabled', this.handleGroupDisabled);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _select2 = this.select,
	        selected = _select2.selected,
	        multiple = _select2.multiple;
	
	    var selectedOptions = multiple ? selected : [selected];
	    var index = this.select.cachedOptions.indexOf(this);
	    var selectedIndex = selectedOptions.indexOf(this);
	
	    // if option is not selected, remove it from cache
	    if (index > -1 && selectedIndex < 0) {
	      this.select.cachedOptions.splice(index, 1);
	    }
	    this.select.onOptionDestroy(this.select.options.indexOf(this));
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/option.vue
	
	
	
	
	
	/* normalize component */
	
	var option_component = normalizeComponent(
	  src_optionvue_type_script_lang_js_,
	  optionvue_type_template_id_7a44c642_render,
	  optionvue_type_template_id_7a44c642_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var option_api; }
	option_component.options.__file = "packages/select/src/option.vue"
	/* harmony default export */ var src_option = (option_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/tag"
	var tag_ = __webpack_require__(30);
	var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
	var resize_event_ = __webpack_require__(13);
	
	// EXTERNAL MODULE: external "element-ui/lib/locale"
	var lib_locale_ = __webpack_require__(11);
	var lib_locale_default = /*#__PURE__*/__webpack_require__.n(lib_locale_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
	var scroll_into_view_ = __webpack_require__(27);
	var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);
	
	// CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
	/* harmony default export */ var navigation_mixin = ({
	  data: function data() {
	    return {
	      hoverOption: -1
	    };
	  },
	
	
	  computed: {
	    optionsAllDisabled: function optionsAllDisabled() {
	      return this.options.filter(function (option) {
	        return option.visible;
	      }).every(function (option) {
	        return option.disabled;
	      });
	    }
	  },
	
	  watch: {
	    hoverIndex: function hoverIndex(val) {
	      var _this = this;
	
	      if (typeof val === 'number' && val > -1) {
	        this.hoverOption = this.options[val] || {};
	      }
	      this.options.forEach(function (option) {
	        option.hover = _this.hoverOption === option;
	      });
	    }
	  },
	
	  methods: {
	    navigateOptions: function navigateOptions(direction) {
	      var _this2 = this;
	
	      if (!this.visible) {
	        this.visible = true;
	        return;
	      }
	      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
	      if (!this.optionsAllDisabled) {
	        if (direction === 'next') {
	          this.hoverIndex++;
	          if (this.hoverIndex === this.options.length) {
	            this.hoverIndex = 0;
	          }
	        } else if (direction === 'prev') {
	          this.hoverIndex--;
	          if (this.hoverIndex < 0) {
	            this.hoverIndex = this.options.length - 1;
	          }
	        }
	        var option = this.options[this.hoverIndex];
	        if (option.disabled === true || option.groupDisabled === true || !option.visible) {
	          this.navigateOptions(direction);
	        }
	        this.$nextTick(function () {
	          return _this2.scrollToOption(_this2.hoverOption);
	        });
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var selectvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a, locale_default.a, focus_default()('reference'), navigation_mixin],
	
	  name: 'ElSelect',
	
	  componentName: 'ElSelect',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  provide: function provide() {
	    return {
	      'select': this
	    };
	  },
	
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    readonly: function readonly() {
	      return !this.filterable || this.multiple || !Object(util_["isIE"])() && !Object(util_["isEdge"])() && !this.visible;
	    },
	    showClose: function showClose() {
	      var hasValue = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
	      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && hasValue;
	      return criteria;
	    },
	    iconClass: function iconClass() {
	      return this.remote && this.filterable ? '' : this.visible ? 'arrow-up is-reverse' : 'arrow-up';
	    },
	    debounce: function debounce() {
	      return this.remote ? 300 : 0;
	    },
	    emptyText: function emptyText() {
	      if (this.loading) {
	        return this.loadingText || this.t('el.select.loading');
	      } else {
	        if (this.remote && this.query === '' && this.options.length === 0) return false;
	        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
	          return this.noMatchText || this.t('el.select.noMatch');
	        }
	        if (this.options.length === 0) {
	          return this.noDataText || this.t('el.select.noData');
	        }
	      }
	      return null;
	    },
	    showNewOption: function showNewOption() {
	      var _this = this;
	
	      var hasExistingOption = this.options.filter(function (option) {
	        return !option.created;
	      }).some(function (option) {
	        return option.currentLabel === _this.query;
	      });
	      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
	    },
	    selectSize: function selectSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    selectDisabled: function selectDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    collapseTagSize: function collapseTagSize() {
	      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElSelectMenu: select_dropdown,
	    ElOption: src_option,
	    ElTag: tag_default.a,
	    ElScrollbar: scrollbar_default.a
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  props: {
	    name: String,
	    id: String,
	    value: {
	      required: true
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    automaticDropdown: Boolean,
	    size: String,
	    disabled: Boolean,
	    clearable: Boolean,
	    filterable: Boolean,
	    allowCreate: Boolean,
	    loading: Boolean,
	    popperClass: String,
	    remote: Boolean,
	    loadingText: String,
	    noMatchText: String,
	    noDataText: String,
	    remoteMethod: Function,
	    filterMethod: Function,
	    multiple: Boolean,
	    multipleLimit: {
	      type: Number,
	      default: 0
	    },
	    placeholder: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.select.placeholder');
	      }
	    },
	    defaultFirstOption: Boolean,
	    reserveKeyword: Boolean,
	    valueKey: {
	      type: String,
	      default: 'value'
	    },
	    collapseTags: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      options: [],
	      cachedOptions: [],
	      createdLabel: null,
	      createdSelected: false,
	      selected: this.multiple ? [] : {},
	      inputLength: 20,
	      inputWidth: 0,
	      initialInputHeight: 0,
	      cachedPlaceHolder: '',
	      optionsCount: 0,
	      filteredOptionsCount: 0,
	      visible: false,
	      softFocus: false,
	      selectedLabel: '',
	      hoverIndex: -1,
	      query: '',
	      previousQuery: null,
	      inputHovering: false,
	      currentPlaceholder: '',
	      menuVisibleOnFocus: false,
	      isOnComposition: false,
	      isSilentBlur: false
	    };
	  },
	
	
	  watch: {
	    selectDisabled: function selectDisabled() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.resetInputHeight();
	      });
	    },
	    placeholder: function placeholder(val) {
	      this.cachedPlaceHolder = this.currentPlaceholder = val;
	    },
	    value: function value(val, oldVal) {
	      if (this.multiple) {
	        this.resetInputHeight();
	        if (val && val.length > 0 || this.$refs.input && this.query !== '') {
	          this.currentPlaceholder = '';
	        } else {
	          this.currentPlaceholder = this.cachedPlaceHolder;
	        }
	        if (this.filterable && !this.reserveKeyword) {
	          this.query = '';
	          this.handleQueryChange(this.query);
	        }
	      }
	      this.setSelected();
	      if (this.filterable && !this.multiple) {
	        this.inputLength = 20;
	      }
	      if (!Object(util_["valueEquals"])(val, oldVal)) {
	        this.dispatch('ElFormItem', 'el.form.change', val);
	      }
	    },
	    visible: function visible(val) {
	      var _this3 = this;
	
	      if (!val) {
	        this.broadcast('ElSelectDropdown', 'destroyPopper');
	        if (this.$refs.input) {
	          this.$refs.input.blur();
	        }
	        this.query = '';
	        this.previousQuery = null;
	        this.selectedLabel = '';
	        this.inputLength = 20;
	        this.menuVisibleOnFocus = false;
	        this.resetHoverIndex();
	        this.$nextTick(function () {
	          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
	            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
	          }
	        });
	        if (!this.multiple) {
	          if (this.selected) {
	            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
	              this.selectedLabel = this.createdLabel;
	            } else {
	              this.selectedLabel = this.selected.currentLabel;
	            }
	            if (this.filterable) this.query = this.selectedLabel;
	          }
	
	          if (this.filterable) {
	            this.currentPlaceholder = this.cachedPlaceHolder;
	          }
	        }
	      } else {
	        this.broadcast('ElSelectDropdown', 'updatePopper');
	        if (this.filterable) {
	          this.query = this.remote ? '' : this.selectedLabel;
	          this.handleQueryChange(this.query);
	          if (this.multiple) {
	            this.$refs.input.focus();
	          } else {
	            if (!this.remote) {
	              this.broadcast('ElOption', 'queryChange', '');
	              this.broadcast('ElOptionGroup', 'queryChange');
	            }
	
	            if (this.selectedLabel) {
	              this.currentPlaceholder = this.selectedLabel;
	              this.selectedLabel = '';
	            }
	          }
	        }
	      }
	      this.$emit('visible-change', val);
	    },
	    options: function options() {
	      var _this4 = this;
	
	      if (this.$isServer) return;
	      this.$nextTick(function () {
	        _this4.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      if (this.multiple) {
	        this.resetInputHeight();
	      }
	      var inputs = this.$el.querySelectorAll('input');
	      if ([].indexOf.call(inputs, document.activeElement) === -1) {
	        this.setSelected();
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    }
	  },
	
	  methods: {
	    handleComposition: function handleComposition(event) {
	      var _this5 = this;
	
	      var text = event.target.value;
	      if (event.type === 'compositionend') {
	        this.isOnComposition = false;
	        this.$nextTick(function (_) {
	          return _this5.handleQueryChange(text);
	        });
	      } else {
	        var lastCharacter = text[text.length - 1] || '';
	        this.isOnComposition = !Object(shared_["isKorean"])(lastCharacter);
	      }
	    },
	    handleQueryChange: function handleQueryChange(val) {
	      var _this6 = this;
	
	      if (this.previousQuery === val || this.isOnComposition) return;
	      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
	        this.previousQuery = val;
	        return;
	      }
	      this.previousQuery = val;
	      this.$nextTick(function () {
	        if (_this6.visible) _this6.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      this.hoverIndex = -1;
	      if (this.multiple && this.filterable) {
	        this.$nextTick(function () {
	          var length = _this6.$refs.input.value.length * 15 + 20;
	          _this6.inputLength = _this6.collapseTags ? Math.min(50, length) : length;
	          _this6.managePlaceholder();
	          _this6.resetInputHeight();
	        });
	      }
	      if (this.remote && typeof this.remoteMethod === 'function') {
	        this.hoverIndex = -1;
	        this.remoteMethod(val);
	      } else if (typeof this.filterMethod === 'function') {
	        this.filterMethod(val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      } else {
	        this.filteredOptionsCount = this.optionsCount;
	        this.broadcast('ElOption', 'queryChange', val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    },
	    scrollToOption: function scrollToOption(option) {
	      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
	      if (this.$refs.popper && target) {
	        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
	        scroll_into_view_default()(menu, target);
	      }
	      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
	    },
	    handleMenuEnter: function handleMenuEnter() {
	      var _this7 = this;
	
	      this.$nextTick(function () {
	        return _this7.scrollToOption(_this7.selected);
	      });
	    },
	    emitChange: function emitChange(val) {
	      if (!Object(util_["valueEquals"])(this.value, val)) {
	        this.$emit('change', val);
	      }
	    },
	    getOption: function getOption(value) {
	      var option = void 0;
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
	      var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';
	
	      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
	        var cachedOption = this.cachedOptions[i];
	        var isEqual = isObject ? Object(util_["getValueByPath"])(cachedOption.value, this.valueKey) === Object(util_["getValueByPath"])(value, this.valueKey) : cachedOption.value === value;
	        if (isEqual) {
	          option = cachedOption;
	          break;
	        }
	      }
	      if (option) return option;
	      var label = !isObject && !isNull && !isUndefined ? value : '';
	      var newOption = {
	        value: value,
	        currentLabel: label
	      };
	      if (this.multiple) {
	        newOption.hitState = false;
	      }
	      return newOption;
	    },
	    setSelected: function setSelected() {
	      var _this8 = this;
	
	      if (!this.multiple) {
	        var option = this.getOption(this.value);
	        if (option.created) {
	          this.createdLabel = option.currentLabel;
	          this.createdSelected = true;
	        } else {
	          this.createdSelected = false;
	        }
	        this.selectedLabel = option.currentLabel;
	        this.selected = option;
	        if (this.filterable) this.query = this.selectedLabel;
	        return;
	      }
	      var result = [];
	      if (Array.isArray(this.value)) {
	        this.value.forEach(function (value) {
	          result.push(_this8.getOption(value));
	        });
	      }
	      this.selected = result;
	      this.$nextTick(function () {
	        _this8.resetInputHeight();
	      });
	    },
	    handleFocus: function handleFocus(event) {
	      if (!this.softFocus) {
	        if (this.automaticDropdown || this.filterable) {
	          this.visible = true;
	          if (this.filterable) {
	            this.menuVisibleOnFocus = true;
	          }
	        }
	        this.$emit('focus', event);
	      } else {
	        this.softFocus = false;
	      }
	    },
	    blur: function blur() {
	      this.visible = false;
	      this.$refs.reference.blur();
	    },
	    handleBlur: function handleBlur(event) {
	      var _this9 = this;
	
	      setTimeout(function () {
	        if (_this9.isSilentBlur) {
	          _this9.isSilentBlur = false;
	        } else {
	          _this9.$emit('blur', event);
	        }
	      }, 50);
	      this.softFocus = false;
	    },
	    handleClearClick: function handleClearClick(event) {
	      this.deleteSelected(event);
	    },
	    doDestroy: function doDestroy() {
	      this.$refs.popper && this.$refs.popper.doDestroy();
	    },
	    handleClose: function handleClose() {
	      this.visible = false;
	    },
	    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
	      if (!Array.isArray(this.selected)) return;
	      var option = this.selected[this.selected.length - 1];
	      if (!option) return;
	
	      if (hit === true || hit === false) {
	        option.hitState = hit;
	        return hit;
	      }
	
	      option.hitState = !option.hitState;
	      return option.hitState;
	    },
	    deletePrevTag: function deletePrevTag(e) {
	      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
	        var value = this.value.slice();
	        value.pop();
	        this.$emit('input', value);
	        this.emitChange(value);
	      }
	    },
	    managePlaceholder: function managePlaceholder() {
	      if (this.currentPlaceholder !== '') {
	        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
	      }
	    },
	    resetInputState: function resetInputState(e) {
	      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
	      this.inputLength = this.$refs.input.value.length * 15 + 20;
	      this.resetInputHeight();
	    },
	    resetInputHeight: function resetInputHeight() {
	      var _this10 = this;
	
	      if (this.collapseTags && !this.filterable) return;
	      this.$nextTick(function () {
	        if (!_this10.$refs.reference) return;
	        var inputChildNodes = _this10.$refs.reference.$el.childNodes;
	        var input = [].filter.call(inputChildNodes, function (item) {
	          return item.tagName === 'INPUT';
	        })[0];
	        var tags = _this10.$refs.tags;
	        var sizeInMap = _this10.initialInputHeight || 40;
	        input.style.height = _this10.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
	        if (_this10.visible && _this10.emptyText !== false) {
	          _this10.broadcast('ElSelectDropdown', 'updatePopper');
	        }
	      });
	    },
	    resetHoverIndex: function resetHoverIndex() {
	      var _this11 = this;
	
	      setTimeout(function () {
	        if (!_this11.multiple) {
	          _this11.hoverIndex = _this11.options.indexOf(_this11.selected);
	        } else {
	          if (_this11.selected.length > 0) {
	            _this11.hoverIndex = Math.min.apply(null, _this11.selected.map(function (item) {
	              return _this11.options.indexOf(item);
	            }));
	          } else {
	            _this11.hoverIndex = -1;
	          }
	        }
	      }, 300);
	    },
	    handleOptionSelect: function handleOptionSelect(option, byClick) {
	      var _this12 = this;
	
	      if (this.multiple) {
	        var value = (this.value || []).slice();
	        var optionIndex = this.getValueIndex(value, option.value);
	        if (optionIndex > -1) {
	          value.splice(optionIndex, 1);
	        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
	          value.push(option.value);
	        }
	        this.$emit('input', value);
	        this.emitChange(value);
	        if (option.created) {
	          this.query = '';
	          this.handleQueryChange('');
	          this.inputLength = 20;
	        }
	        if (this.filterable) this.$refs.input.focus();
	      } else {
	        this.$emit('input', option.value);
	        this.emitChange(option.value);
	        this.visible = false;
	      }
	      this.isSilentBlur = byClick;
	      this.setSoftFocus();
	      if (this.visible) return;
	      this.$nextTick(function () {
	        _this12.scrollToOption(option);
	      });
	    },
	    setSoftFocus: function setSoftFocus() {
	      this.softFocus = true;
	      var input = this.$refs.input || this.$refs.reference;
	      if (input) {
	        input.focus();
	      }
	    },
	    getValueIndex: function getValueIndex() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var value = arguments[1];
	
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      if (!isObject) {
	        return arr.indexOf(value);
	      } else {
	        var valueKey = this.valueKey;
	        var index = -1;
	        arr.some(function (item, i) {
	          if (Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(value, valueKey)) {
	            index = i;
	            return true;
	          }
	          return false;
	        });
	        return index;
	      }
	    },
	    toggleMenu: function toggleMenu() {
	      if (!this.selectDisabled) {
	        if (this.menuVisibleOnFocus) {
	          this.menuVisibleOnFocus = false;
	        } else {
	          this.visible = !this.visible;
	        }
	        if (this.visible) {
	          (this.$refs.input || this.$refs.reference).focus();
	        }
	      }
	    },
	    selectOption: function selectOption() {
	      if (!this.visible) {
	        this.toggleMenu();
	      } else {
	        if (this.options[this.hoverIndex]) {
	          this.handleOptionSelect(this.options[this.hoverIndex]);
	        }
	      }
	    },
	    deleteSelected: function deleteSelected(event) {
	      event.stopPropagation();
	      var value = this.multiple ? [] : '';
	      this.$emit('input', value);
	      this.emitChange(value);
	      this.visible = false;
	      this.$emit('clear');
	    },
	    deleteTag: function deleteTag(event, tag) {
	      var index = this.selected.indexOf(tag);
	      if (index > -1 && !this.selectDisabled) {
	        var value = this.value.slice();
	        value.splice(index, 1);
	        this.$emit('input', value);
	        this.emitChange(value);
	        this.$emit('remove-tag', tag.value);
	      }
	      event.stopPropagation();
	    },
	    onInputChange: function onInputChange() {
	      if (this.filterable && this.query !== this.selectedLabel) {
	        this.query = this.selectedLabel;
	        this.handleQueryChange(this.query);
	      }
	    },
	    onOptionDestroy: function onOptionDestroy(index) {
	      if (index > -1) {
	        this.optionsCount--;
	        this.filteredOptionsCount--;
	        this.options.splice(index, 1);
	      }
	    },
	    resetInputWidth: function resetInputWidth() {
	      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
	    },
	    handleResize: function handleResize() {
	      this.resetInputWidth();
	      if (this.multiple) this.resetInputHeight();
	    },
	    checkDefaultFirstOption: function checkDefaultFirstOption() {
	      this.hoverIndex = -1;
	      // highlight the created option
	      var hasCreated = false;
	      for (var i = this.options.length - 1; i >= 0; i--) {
	        if (this.options[i].created) {
	          hasCreated = true;
	          this.hoverIndex = i;
	          break;
	        }
	      }
	      if (hasCreated) return;
	      for (var _i = 0; _i !== this.options.length; ++_i) {
	        var option = this.options[_i];
	        if (this.query) {
	          // highlight first options that passes the filter
	          if (!option.disabled && !option.groupDisabled && option.visible) {
	            this.hoverIndex = _i;
	            break;
	          }
	        } else {
	          // highlight currently selected option
	          if (option.itemSelected) {
	            this.hoverIndex = _i;
	            break;
	          }
	        }
	      }
	    },
	    getValueKey: function getValueKey(item) {
	      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
	        return item.value;
	      } else {
	        return Object(util_["getValueByPath"])(item.value, this.valueKey);
	      }
	    }
	  },
	
	  created: function created() {
	    var _this13 = this;
	
	    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;
	    if (this.multiple && !Array.isArray(this.value)) {
	      this.$emit('input', []);
	    }
	    if (!this.multiple && Array.isArray(this.value)) {
	      this.$emit('input', '');
	    }
	
	    this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
	      _this13.onInputChange();
	    });
	
	    this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
	      _this13.handleQueryChange(e.target.value);
	    });
	
	    this.$on('handleOptionClick', this.handleOptionSelect);
	    this.$on('setSelected', this.setSelected);
	  },
	  mounted: function mounted() {
	    var _this14 = this;
	
	    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
	      this.currentPlaceholder = '';
	    }
	    Object(resize_event_["addResizeListener"])(this.$el, this.handleResize);
	
	    var reference = this.$refs.reference;
	    if (reference && reference.$el) {
	      var sizeMap = {
	        medium: 36,
	        small: 32,
	        mini: 28
	      };
	      var input = reference.$el.querySelector('input');
	      this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
	    }
	    if (this.remote && this.multiple) {
	      this.resetInputHeight();
	    }
	    this.$nextTick(function () {
	      if (reference && reference.$el) {
	        _this14.inputWidth = reference.$el.getBoundingClientRect().width;
	      }
	    });
	    this.setSelected();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.handleResize) Object(resize_event_["removeResizeListener"])(this.$el, this.handleResize);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/select.vue
	
	
	
	
	
	/* normalize component */
	
	var select_component = normalizeComponent(
	  src_selectvue_type_script_lang_js_,
	  selectvue_type_template_id_0e4aade6_render,
	  selectvue_type_template_id_0e4aade6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var select_api; }
	select_component.options.__file = "packages/select/src/select.vue"
	/* harmony default export */ var src_select = (select_component.exports);
	// CONCATENATED MODULE: ./packages/select/index.js
	
	
	/* istanbul ignore next */
	src_select.install = function (Vue) {
	  Vue.component(src_select.name, src_select);
	};
	
	/* harmony default export */ var packages_select = (src_select);
	// CONCATENATED MODULE: ./packages/option/index.js
	
	
	/* istanbul ignore next */
	src_option.install = function (Vue) {
	  Vue.component(src_option.name, src_option);
	};
	
	/* harmony default export */ var packages_option = (src_option);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
	var option_groupvue_type_template_id_6685e5de_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "ul",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-group__wrap"
	    },
	    [
	      _c("li", { staticClass: "el-select-group__title" }, [
	        _vm._v(_vm._s(_vm.label))
	      ]),
	      _c("li", [
	        _c("ul", { staticClass: "el-select-group" }, [_vm._t("default")], 2)
	      ])
	    ]
	  )
	}
	var option_groupvue_type_template_id_6685e5de_staticRenderFns = []
	option_groupvue_type_template_id_6685e5de_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var option_groupvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOptionGroup',
	
	  componentName: 'ElOptionGroup',
	
	  props: {
	    label: String,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      visible: true
	    };
	  },
	
	
	  watch: {
	    disabled: function disabled(val) {
	      this.broadcast('ElOption', 'handleGroupDisabled', val);
	    }
	  },
	
	  methods: {
	    queryChange: function queryChange() {
	      this.visible = this.$children && Array.isArray(this.$children) && this.$children.some(function (option) {
	        return option.visible === true;
	      });
	    }
	  },
	
	  created: function created() {
	    this.$on('queryChange', this.queryChange);
	  },
	  mounted: function mounted() {
	    if (this.disabled) {
	      this.broadcast('ElOption', 'handleGroupDisabled', this.disabled);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_option_groupvue_type_script_lang_js_ = (option_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/option-group.vue
	
	
	
	
	
	/* normalize component */
	
	var option_group_component = normalizeComponent(
	  src_option_groupvue_type_script_lang_js_,
	  option_groupvue_type_template_id_6685e5de_render,
	  option_groupvue_type_template_id_6685e5de_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var option_group_api; }
	option_group_component.options.__file = "packages/select/src/option-group.vue"
	/* harmony default export */ var option_group = (option_group_component.exports);
	// CONCATENATED MODULE: ./packages/option-group/index.js
	
	
	/* istanbul ignore next */
	option_group.install = function (Vue) {
	  Vue.component(option_group.name, option_group);
	};
	
	/* harmony default export */ var packages_option_group = (option_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	var buttonvue_type_template_id_ca859fb4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "button",
	    {
	      staticClass: "el-button",
	      class: [
	        _vm.type ? "el-button--" + _vm.type : "",
	        _vm.buttonSize ? "el-button--" + _vm.buttonSize : "",
	        {
	          "is-disabled": _vm.buttonDisabled,
	          "is-loading": _vm.loading,
	          "is-plain": _vm.plain,
	          "is-round": _vm.round,
	          "is-circle": _vm.circle
	        }
	      ],
	      attrs: {
	        disabled: _vm.buttonDisabled || _vm.loading,
	        autofocus: _vm.autofocus,
	        type: _vm.nativeType
	      },
	      on: { click: _vm.handleClick }
	    },
	    [
	      _vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(),
	      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
	      _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()
	    ]
	  )
	}
	var buttonvue_type_template_id_ca859fb4_staticRenderFns = []
	buttonvue_type_template_id_ca859fb4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
	  name: 'ElButton',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    size: String,
	    icon: {
	      type: String,
	      default: ''
	    },
	    nativeType: {
	      type: String,
	      default: 'button'
	    },
	    loading: Boolean,
	    disabled: Boolean,
	    plain: Boolean,
	    autofocus: Boolean,
	    round: Boolean,
	    circle: Boolean
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    buttonSize: function buttonSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    buttonDisabled: function buttonDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(evt) {
	      this.$emit('click', evt);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/button/src/button.vue
	
	
	
	
	
	/* normalize component */
	
	var button_component = normalizeComponent(
	  src_buttonvue_type_script_lang_js_,
	  buttonvue_type_template_id_ca859fb4_render,
	  buttonvue_type_template_id_ca859fb4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var button_api; }
	button_component.options.__file = "packages/button/src/button.vue"
	/* harmony default export */ var src_button = (button_component.exports);
	// CONCATENATED MODULE: ./packages/button/index.js
	
	
	/* istanbul ignore next */
	src_button.install = function (Vue) {
	  Vue.component(src_button.name, src_button);
	};
	
	/* harmony default export */ var packages_button = (src_button);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	var button_groupvue_type_template_id_3d8661d0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-button-group" }, [_vm._t("default")], 2)
	}
	var button_groupvue_type_template_id_3d8661d0_staticRenderFns = []
	button_groupvue_type_template_id_3d8661d0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var button_groupvue_type_script_lang_js_ = ({
	  name: 'ElButtonGroup'
	});
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_button_groupvue_type_script_lang_js_ = (button_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue
	
	
	
	
	
	/* normalize component */
	
	var button_group_component = normalizeComponent(
	  src_button_groupvue_type_script_lang_js_,
	  button_groupvue_type_template_id_3d8661d0_render,
	  button_groupvue_type_template_id_3d8661d0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var button_group_api; }
	button_group_component.options.__file = "packages/button/src/button-group.vue"
	/* harmony default export */ var button_group = (button_group_component.exports);
	// CONCATENATED MODULE: ./packages/button-group/index.js
	
	
	/* istanbul ignore next */
	button_group.install = function (Vue) {
	  Vue.component(button_group.name, button_group);
	};
	
	/* harmony default export */ var packages_button_group = (button_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=template&id=493fe34e&
	var tablevue_type_template_id_493fe34e_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-table",
	      class: [
	        {
	          "el-table--fit": _vm.fit,
	          "el-table--striped": _vm.stripe,
	          "el-table--border": _vm.border || _vm.isGroup,
	          "el-table--hidden": _vm.isHidden,
	          "el-table--group": _vm.isGroup,
	          "el-table--fluid-height": _vm.maxHeight,
	          "el-table--scrollable-x": _vm.layout.scrollX,
	          "el-table--scrollable-y": _vm.layout.scrollY,
	          "el-table--enable-row-hover": !_vm.store.states.isComplex,
	          "el-table--enable-row-transition":
	            (_vm.store.states.data || []).length !== 0 &&
	            (_vm.store.states.data || []).length < 100
	        },
	        _vm.tableSize ? "el-table--" + _vm.tableSize : ""
	      ],
	      on: {
	        mouseleave: function($event) {
	          _vm.handleMouseLeave($event)
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        { ref: "hiddenColumns", staticClass: "hidden-columns" },
	        [_vm._t("default")],
	        2
	      ),
	      _vm.showHeader
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleHeaderFooterMousewheel,
	                  expression: "handleHeaderFooterMousewheel"
	                }
	              ],
	              ref: "headerWrapper",
	              staticClass: "el-table__header-wrapper"
	            },
	            [
	              _c("table-header", {
	                ref: "tableHeader",
	                style: {
	                  width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + "px" : ""
	                },
	                attrs: {
	                  store: _vm.store,
	                  border: _vm.border,
	                  "default-sort": _vm.defaultSort
	                }
	              })
	            ],
	            1
	          )
	        : _vm._e(),
	      _c(
	        "div",
	        {
	          ref: "bodyWrapper",
	          staticClass: "el-table__body-wrapper",
	          class: [
	            _vm.layout.scrollX
	              ? "is-scrolling-" + _vm.scrollPosition
	              : "is-scrolling-none"
	          ],
	          style: [_vm.bodyHeight]
	        },
	        [
	          _c("table-body", {
	            style: {
	              width: _vm.bodyWidth
	            },
	            attrs: {
	              context: _vm.context,
	              store: _vm.store,
	              stripe: _vm.stripe,
	              "row-class-name": _vm.rowClassName,
	              "row-style": _vm.rowStyle,
	              highlight: _vm.highlightCurrentRow
	            }
	          }),
	          !_vm.data || _vm.data.length === 0
	            ? _c(
	                "div",
	                {
	                  ref: "emptyBlock",
	                  staticClass: "el-table__empty-block",
	                  style: _vm.emptyBlockStyle
	                },
	                [
	                  _c(
	                    "span",
	                    { staticClass: "el-table__empty-text" },
	                    [
	                      _vm._t("empty", [
	                        _vm._v(
	                          _vm._s(_vm.emptyText || _vm.t("el.table.emptyText"))
	                        )
	                      ])
	                    ],
	                    2
	                  )
	                ]
	              )
	            : _vm._e(),
	          _vm.$slots.append
	            ? _c(
	                "div",
	                {
	                  ref: "appendWrapper",
	                  staticClass: "el-table__append-wrapper"
	                },
	                [_vm._t("append")],
	                2
	              )
	            : _vm._e()
	        ],
	        1
	      ),
	      _vm.showSummary
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.data && _vm.data.length > 0,
	                  expression: "data && data.length > 0"
	                },
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleHeaderFooterMousewheel,
	                  expression: "handleHeaderFooterMousewheel"
	                }
	              ],
	              ref: "footerWrapper",
	              staticClass: "el-table__footer-wrapper"
	            },
	            [
	              _c("table-footer", {
	                style: {
	                  width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + "px" : ""
	                },
	                attrs: {
	                  store: _vm.store,
	                  border: _vm.border,
	                  "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
	                  "summary-method": _vm.summaryMethod,
	                  "default-sort": _vm.defaultSort
	                }
	              })
	            ],
	            1
	          )
	        : _vm._e(),
	      _vm.fixedColumns.length > 0
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleFixedMousewheel,
	                  expression: "handleFixedMousewheel"
	                }
	              ],
	              ref: "fixedWrapper",
	              staticClass: "el-table__fixed",
	              style: [
	                {
	                  width: _vm.layout.fixedWidth
	                    ? _vm.layout.fixedWidth + "px"
	                    : ""
	                },
	                _vm.fixedHeight
	              ]
	            },
	            [
	              _vm.showHeader
	                ? _c(
	                    "div",
	                    {
	                      ref: "fixedHeaderWrapper",
	                      staticClass: "el-table__fixed-header-wrapper"
	                    },
	                    [
	                      _c("table-header", {
	                        ref: "fixedTableHeader",
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "left",
	                          border: _vm.border,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              _c(
	                "div",
	                {
	                  ref: "fixedBodyWrapper",
	                  staticClass: "el-table__fixed-body-wrapper",
	                  style: [
	                    {
	                      top: _vm.layout.headerHeight + "px"
	                    },
	                    _vm.fixedBodyHeight
	                  ]
	                },
	                [
	                  _c("table-body", {
	                    style: {
	                      width: _vm.bodyWidth
	                    },
	                    attrs: {
	                      fixed: "left",
	                      store: _vm.store,
	                      stripe: _vm.stripe,
	                      highlight: _vm.highlightCurrentRow,
	                      "row-class-name": _vm.rowClassName,
	                      "row-style": _vm.rowStyle
	                    }
	                  }),
	                  _vm.$slots.append
	                    ? _c("div", {
	                        staticClass: "el-table__append-gutter",
	                        style: { height: _vm.layout.appendHeight + "px" }
	                      })
	                    : _vm._e()
	                ],
	                1
	              ),
	              _vm.showSummary
	                ? _c(
	                    "div",
	                    {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.data && _vm.data.length > 0,
	                          expression: "data && data.length > 0"
	                        }
	                      ],
	                      ref: "fixedFooterWrapper",
	                      staticClass: "el-table__fixed-footer-wrapper"
	                    },
	                    [
	                      _c("table-footer", {
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "left",
	                          border: _vm.border,
	                          "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
	                          "summary-method": _vm.summaryMethod,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e()
	            ]
	          )
	        : _vm._e(),
	      _vm.rightFixedColumns.length > 0
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleFixedMousewheel,
	                  expression: "handleFixedMousewheel"
	                }
	              ],
	              ref: "rightFixedWrapper",
	              staticClass: "el-table__fixed-right",
	              style: [
	                {
	                  width: _vm.layout.rightFixedWidth
	                    ? _vm.layout.rightFixedWidth + "px"
	                    : "",
	                  right: _vm.layout.scrollY
	                    ? (_vm.border
	                        ? _vm.layout.gutterWidth
	                        : _vm.layout.gutterWidth || 0) + "px"
	                    : ""
	                },
	                _vm.fixedHeight
	              ]
	            },
	            [
	              _vm.showHeader
	                ? _c(
	                    "div",
	                    {
	                      ref: "rightFixedHeaderWrapper",
	                      staticClass: "el-table__fixed-header-wrapper"
	                    },
	                    [
	                      _c("table-header", {
	                        ref: "rightFixedTableHeader",
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "right",
	                          border: _vm.border,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              _c(
	                "div",
	                {
	                  ref: "rightFixedBodyWrapper",
	                  staticClass: "el-table__fixed-body-wrapper",
	                  style: [
	                    {
	                      top: _vm.layout.headerHeight + "px"
	                    },
	                    _vm.fixedBodyHeight
	                  ]
	                },
	                [
	                  _c("table-body", {
	                    style: {
	                      width: _vm.bodyWidth
	                    },
	                    attrs: {
	                      fixed: "right",
	                      store: _vm.store,
	                      stripe: _vm.stripe,
	                      "row-class-name": _vm.rowClassName,
	                      "row-style": _vm.rowStyle,
	                      highlight: _vm.highlightCurrentRow
	                    }
	                  }),
	                  _vm.$slots.append
	                    ? _c("div", {
	                        staticClass: "el-table__append-gutter",
	                        style: { height: _vm.layout.appendHeight + "px" }
	                      })
	                    : _vm._e()
	                ],
	                1
	              ),
	              _vm.showSummary
	                ? _c(
	                    "div",
	                    {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.data && _vm.data.length > 0,
	                          expression: "data && data.length > 0"
	                        }
	                      ],
	                      ref: "rightFixedFooterWrapper",
	                      staticClass: "el-table__fixed-footer-wrapper"
	                    },
	                    [
	                      _c("table-footer", {
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "right",
	                          border: _vm.border,
	                          "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
	                          "summary-method": _vm.summaryMethod,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e()
	            ]
	          )
	        : _vm._e(),
	      _vm.rightFixedColumns.length > 0
	        ? _c("div", {
	            ref: "rightFixedPatch",
	            staticClass: "el-table__fixed-right-patch",
	            style: {
	              width: _vm.layout.scrollY ? _vm.layout.gutterWidth + "px" : "0",
	              height: _vm.layout.headerHeight + "px"
	            }
	          })
	        : _vm._e(),
	      _c("div", {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.resizeProxyVisible,
	            expression: "resizeProxyVisible"
	          }
	        ],
	        ref: "resizeProxy",
	        staticClass: "el-table__column-resize-proxy"
	      })
	    ]
	  )
	}
	var tablevue_type_template_id_493fe34e_staticRenderFns = []
	tablevue_type_template_id_493fe34e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=template&id=493fe34e&
	
	// EXTERNAL MODULE: external "element-ui/lib/checkbox"
	var checkbox_ = __webpack_require__(16);
	var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);
	
	// EXTERNAL MODULE: external "throttle-debounce"
	var external_throttle_debounce_ = __webpack_require__(35);
	
	// EXTERNAL MODULE: external "normalize-wheel"
	var external_normalize_wheel_ = __webpack_require__(38);
	var external_normalize_wheel_default = /*#__PURE__*/__webpack_require__.n(external_normalize_wheel_);
	
	// CONCATENATED MODULE: ./src/directives/mousewheel.js
	
	
	var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	
	var mousewheel_mousewheel = function mousewheel(element, callback) {
	  if (element && element.addEventListener) {
	    element.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', function (event) {
	      var normalized = external_normalize_wheel_default()(event);
	      callback && callback.apply(this, [event, normalized]);
	    });
	  }
	};
	
	/* harmony default export */ var directives_mousewheel = ({
	  bind: function bind(el, binding) {
	    mousewheel_mousewheel(el, binding.value);
	  }
	});
	// EXTERNAL MODULE: external "vue"
	var external_vue_ = __webpack_require__(6);
	var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
	
	// CONCATENATED MODULE: ./packages/table/src/util.js
	var util_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	
	
	var getCell = function getCell(event) {
	  var cell = event.target;
	
	  while (cell && cell.tagName.toUpperCase() !== 'HTML') {
	    if (cell.tagName.toUpperCase() === 'TD') {
	      return cell;
	    }
	    cell = cell.parentNode;
	  }
	
	  return null;
	};
	
	var util_isObject = function isObject(obj) {
	  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : util_typeof(obj)) === 'object';
	};
	
	var util_orderBy = function orderBy(array, sortKey, reverse, sortMethod, sortBy) {
	  if (!sortKey && !sortMethod && (!sortBy || Array.isArray(sortBy) && !sortBy.length)) {
	    return array;
	  }
	  if (typeof reverse === 'string') {
	    reverse = reverse === 'descending' ? -1 : 1;
	  } else {
	    reverse = reverse && reverse < 0 ? -1 : 1;
	  }
	  var getKey = sortMethod ? null : function (value, index) {
	    if (sortBy) {
	      if (!Array.isArray(sortBy)) {
	        sortBy = [sortBy];
	      }
	      return sortBy.map(function (by) {
	        if (typeof by === 'string') {
	          return Object(util_["getValueByPath"])(value, by);
	        } else {
	          return by(value, index, array);
	        }
	      });
	    }
	    if (sortKey !== '$key') {
	      if (util_isObject(value) && '$value' in value) value = value.$value;
	    }
	    return [util_isObject(value) ? Object(util_["getValueByPath"])(value, sortKey) : value];
	  };
	  var compare = function compare(a, b) {
	    if (sortMethod) {
	      return sortMethod(a.value, b.value);
	    }
	    for (var i = 0, len = a.key.length; i < len; i++) {
	      if (a.key[i] < b.key[i]) {
	        return -1;
	      }
	      if (a.key[i] > b.key[i]) {
	        return 1;
	      }
	    }
	    return 0;
	  };
	  return array.map(function (value, index) {
	    return {
	      value: value,
	      index: index,
	      key: getKey ? getKey(value, index) : null
	    };
	  }).sort(function (a, b) {
	    var order = compare(a, b);
	    if (!order) {
	      // make stable https://en.wikipedia.org/wiki/Sorting_algorithm#Stability
	      order = a.index - b.index;
	    }
	    return order * reverse;
	  }).map(function (item) {
	    return item.value;
	  });
	};
	
	var getColumnById = function getColumnById(table, columnId) {
	  var column = null;
	  table.columns.forEach(function (item) {
	    if (item.id === columnId) {
	      column = item;
	    }
	  });
	  return column;
	};
	
	var getColumnByKey = function getColumnByKey(table, columnKey) {
	  var column = null;
	  for (var i = 0; i < table.columns.length; i++) {
	    var item = table.columns[i];
	    if (item.columnKey === columnKey) {
	      column = item;
	      break;
	    }
	  }
	  return column;
	};
	
	var getColumnByCell = function getColumnByCell(table, cell) {
	  var matches = (cell.className || '').match(/el-table_[^\s]+/gm);
	  if (matches) {
	    return getColumnById(table, matches[0]);
	  }
	  return null;
	};
	
	var getRowIdentity = function getRowIdentity(row, rowKey) {
	  if (!row) throw new Error('row is required when get row identity');
	  if (typeof rowKey === 'string') {
	    if (rowKey.indexOf('.') < 0) {
	      return row[rowKey];
	    }
	    var key = rowKey.split('.');
	    var current = row;
	    for (var i = 0; i < key.length; i++) {
	      current = current[key[i]];
	    }
	    return current;
	  } else if (typeof rowKey === 'function') {
	    return rowKey.call(null, row);
	  }
	};
	
	var getKeysMap = function getKeysMap(array, rowKey) {
	  var arrayMap = {};
	  (array || []).forEach(function (row, index) {
	    arrayMap[getRowIdentity(row, rowKey)] = { row: row, index: index };
	  });
	  return arrayMap;
	};
	
	function hasOwn(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	function mergeOptions(defaults, config) {
	  var options = {};
	  var key = void 0;
	  for (key in defaults) {
	    options[key] = defaults[key];
	  }
	  for (key in config) {
	    if (hasOwn(config, key)) {
	      var value = config[key];
	      if (typeof value !== 'undefined') {
	        options[key] = value;
	      }
	    }
	  }
	  return options;
	}
	
	function parseWidth(width) {
	  if (width !== undefined) {
	    width = parseInt(width, 10);
	    if (isNaN(width)) {
	      width = null;
	    }
	  }
	  return width;
	}
	
	function parseMinWidth(minWidth) {
	  if (typeof minWidth !== 'undefined') {
	    minWidth = parseWidth(minWidth);
	    if (isNaN(minWidth)) {
	      minWidth = 80;
	    }
	  }
	  return minWidth;
	};
	
	function parseHeight(height) {
	  if (typeof height === 'number') {
	    return height;
	  }
	  if (typeof height === 'string') {
	    if (/^\d+(?:px)?$/.test(height)) {
	      return parseInt(height, 10);
	    } else {
	      return height;
	    }
	  }
	  return null;
	}
	
	// https://github.com/reduxjs/redux/blob/master/src/compose.js
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}
	
	function toggleRowStatus(statusArr, row, newVal) {
	  var changed = false;
	  var index = statusArr.indexOf(row);
	  var included = index !== -1;
	
	  var addRow = function addRow() {
	    statusArr.push(row);
	    changed = true;
	  };
	  var removeRow = function removeRow() {
	    statusArr.splice(index, 1);
	    changed = true;
	  };
	
	  if (typeof newVal === 'boolean') {
	    if (newVal && !included) {
	      addRow();
	    } else if (!newVal && included) {
	      removeRow();
	    }
	  } else {
	    if (included) {
	      removeRow();
	    } else {
	      addRow();
	    }
	  }
	  return changed;
	}
	
	function walkTreeNode(root, cb) {
	  var childrenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
	  var lazyKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'hasChildren';
	
	  var isNil = function isNil(array) {
	    return !(Array.isArray(array) && array.length);
	  };
	
	  function _walker(parent, children, level) {
	    cb(parent, children, level);
	    children.forEach(function (item) {
	      if (item[lazyKey]) {
	        cb(item, null, level + 1);
	        return;
	      }
	      var children = item[childrenKey];
	      if (!isNil(children)) {
	        _walker(item, children, level + 1);
	      }
	    });
	  }
	
	  root.forEach(function (item) {
	    if (item[lazyKey]) {
	      cb(item, null, 0);
	      return;
	    }
	    var children = item[childrenKey];
	    if (!isNil(children)) {
	      _walker(item, children, 0);
	    }
	  });
	}
	// CONCATENATED MODULE: ./packages/table/src/store/expand.js
	
	
	/* harmony default export */ var expand = ({
	  data: function data() {
	    return {
	      states: {
	        defaultExpandAll: false,
	        expandRows: []
	      }
	    };
	  },
	
	
	  methods: {
	    updateExpandRows: function updateExpandRows() {
	      var _states = this.states,
	          _states$data = _states.data,
	          data = _states$data === undefined ? [] : _states$data,
	          rowKey = _states.rowKey,
	          defaultExpandAll = _states.defaultExpandAll,
	          expandRows = _states.expandRows;
	
	      if (defaultExpandAll) {
	        this.states.expandRows = data.slice();
	      } else if (rowKey) {
	        // TODO：这里的代码可以优化
	        var expandRowsMap = getKeysMap(expandRows, rowKey);
	        this.states.expandRows = data.reduce(function (prev, row) {
	          var rowId = getRowIdentity(row, rowKey);
	          var rowInfo = expandRowsMap[rowId];
	          if (rowInfo) {
	            prev.push(row);
	          }
	          return prev;
	        }, []);
	      } else {
	        this.states.expandRows = [];
	      }
	    },
	    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
	      var changed = toggleRowStatus(this.states.expandRows, row, expanded);
	      if (changed) {
	        this.table.$emit('expand-change', row, this.states.expandRows.slice());
	        this.scheduleLayout();
	      }
	    },
	    setExpandRowKeys: function setExpandRowKeys(rowKeys) {
	      this.assertRowKey();
	      // TODO：这里的代码可以优化
	      var _states2 = this.states,
	          data = _states2.data,
	          rowKey = _states2.rowKey;
	
	      var keysMap = getKeysMap(data, rowKey);
	      this.states.expandRows = rowKeys.reduce(function (prev, cur) {
	        var info = keysMap[cur];
	        if (info) {
	          prev.push(info.row);
	        }
	        return prev;
	      }, []);
	    },
	    isRowExpanded: function isRowExpanded(row) {
	      var _states3 = this.states,
	          _states3$expandRows = _states3.expandRows,
	          expandRows = _states3$expandRows === undefined ? [] : _states3$expandRows,
	          rowKey = _states3.rowKey;
	
	      if (rowKey) {
	        var expandMap = getKeysMap(expandRows, rowKey);
	        return !!expandMap[getRowIdentity(row, rowKey)];
	      }
	      return expandRows.indexOf(row) !== -1;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/store/current.js
	
	
	
	/* harmony default export */ var current = ({
	  data: function data() {
	    return {
	      states: {
	        // 不可响应的，设置 currentRowKey 时，data 不一定存在，也许无法算出正确的 currentRow
	        // 把该值缓存一下，当用户点击修改 currentRow 时，把该值重置为 null
	        _currentRowKey: null,
	        currentRow: null
	      }
	    };
	  },
	
	
	  methods: {
	    setCurrentRowKey: function setCurrentRowKey(key) {
	      this.assertRowKey();
	      this.states._currentRowKey = key;
	      this.setCurrentRowByKey(key);
	    },
	    restoreCurrentRowKey: function restoreCurrentRowKey() {
	      this.states._currentRowKey = null;
	    },
	    setCurrentRowByKey: function setCurrentRowByKey(key) {
	      var states = this.states;
	      var _states$data = states.data,
	          data = _states$data === undefined ? [] : _states$data,
	          rowKey = states.rowKey;
	
	      var currentRow = null;
	      if (rowKey) {
	        currentRow = Object(util_["arrayFind"])(data, function (item) {
	          return getRowIdentity(item, rowKey) === key;
	        });
	      }
	      states.currentRow = currentRow;
	    },
	    updateCurrentRow: function updateCurrentRow(currentRow) {
	      var states = this.states,
	          table = this.table;
	
	      var oldCurrentRow = states.currentRow;
	      if (currentRow && currentRow !== oldCurrentRow) {
	        states.currentRow = currentRow;
	        table.$emit('current-change', currentRow, oldCurrentRow);
	        return;
	      }
	      if (!currentRow && oldCurrentRow) {
	        states.currentRow = null;
	        table.$emit('current-change', null, oldCurrentRow);
	      }
	    },
	    updateCurrentRowData: function updateCurrentRowData() {
	      var states = this.states,
	          table = this.table;
	      var rowKey = states.rowKey,
	          _currentRowKey = states._currentRowKey;
	      // data 为 null 时，解构时的默认值会被忽略
	
	      var data = states.data || [];
	      var oldCurrentRow = states.currentRow;
	
	      // 当 currentRow 不在 data 中时尝试更新数据
	      if (data.indexOf(oldCurrentRow) === -1 && oldCurrentRow) {
	        if (rowKey) {
	          var currentRowKey = getRowIdentity(oldCurrentRow, rowKey);
	          this.setCurrentRowByKey(currentRowKey);
	        } else {
	          states.currentRow = null;
	        }
	        if (states.currentRow === null) {
	          table.$emit('current-change', null, oldCurrentRow);
	        }
	      } else if (_currentRowKey) {
	        // 把初始时下设置的 rowKey 转化成 rowData
	        this.setCurrentRowByKey(_currentRowKey);
	        this.restoreCurrentRowKey();
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/store/tree.js
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	/* harmony default export */ var tree = ({
	  data: function data() {
	    return {
	      states: {
	        // defaultExpandAll 存在于 expand.js 中，这里不重复添加
	        // 在展开行中，expandRowKeys 会被转化成 expandRows，expandRowKeys 这个属性只是记录了 TreeTable 行的展开
	        // TODO: 拆分为独立的 TreeTable，统一用法
	        expandRowKeys: [],
	        treeData: {},
	        indent: 16,
	        lazy: false,
	        lazyTreeNodeMap: {},
	        lazyColumnIdentifier: 'hasChildren',
	        childrenColumnName: 'children'
	      }
	    };
	  },
	
	
	  computed: {
	    // 嵌入型的数据，watch 无法是检测到变化 https://github.com/ElemeFE/element/issues/14998
	    // TODO: 使用 computed 解决该问题，是否会造成性能问题？
	    // @return { id: { level, children } }
	    normalizedData: function normalizedData() {
	      if (!this.states.rowKey) return {};
	      var data = this.states.data || [];
	      return this.normalize(data);
	    },
	
	    // @return { id: { children } }
	    // 针对懒加载的情形，不处理嵌套数据
	    normalizedLazyNode: function normalizedLazyNode() {
	      var _states = this.states,
	          rowKey = _states.rowKey,
	          lazyTreeNodeMap = _states.lazyTreeNodeMap,
	          lazyColumnIdentifier = _states.lazyColumnIdentifier;
	
	      var keys = Object.keys(lazyTreeNodeMap);
	      var res = {};
	      if (!keys.length) return res;
	      keys.forEach(function (key) {
	        if (lazyTreeNodeMap[key].length) {
	          var item = { children: [] };
	          lazyTreeNodeMap[key].forEach(function (row) {
	            var currentRowKey = getRowIdentity(row, rowKey);
	            item.children.push(currentRowKey);
	            if (row[lazyColumnIdentifier] && !res[currentRowKey]) {
	              res[currentRowKey] = { children: [] };
	            }
	          });
	          res[key] = item;
	        }
	      });
	      return res;
	    }
	  },
	
	  watch: {
	    normalizedData: 'updateTreeData',
	    normalizedLazyNode: 'updateTreeData'
	  },
	
	  methods: {
	    normalize: function normalize(data) {
	      var _states2 = this.states,
	          childrenColumnName = _states2.childrenColumnName,
	          lazyColumnIdentifier = _states2.lazyColumnIdentifier,
	          rowKey = _states2.rowKey,
	          lazy = _states2.lazy;
	
	      var res = {};
	      walkTreeNode(data, function (parent, children, level) {
	        var parentId = getRowIdentity(parent, rowKey);
	        if (Array.isArray(children)) {
	          res[parentId] = {
	            children: children.map(function (row) {
	              return getRowIdentity(row, rowKey);
	            }),
	            level: level
	          };
	        } else if (lazy) {
	          // 当 children 不存在且 lazy 为 true，该节点即为懒加载的节点
	          res[parentId] = {
	            children: [],
	            lazy: true,
	            level: level
	          };
	        }
	      }, childrenColumnName, lazyColumnIdentifier);
	      return res;
	    },
	    updateTreeData: function updateTreeData() {
	      var nested = this.normalizedData;
	      var normalizedLazyNode = this.normalizedLazyNode;
	      var keys = Object.keys(nested);
	      var newTreeData = {};
	      if (keys.length) {
	        var _states3 = this.states,
	            oldTreeData = _states3.treeData,
	            defaultExpandAll = _states3.defaultExpandAll,
	            expandRowKeys = _states3.expandRowKeys,
	            lazy = _states3.lazy;
	
	        var rootLazyRowKeys = [];
	        var getExpanded = function getExpanded(oldValue, key) {
	          var included = defaultExpandAll || expandRowKeys && expandRowKeys.indexOf(key) !== -1;
	          return !!(oldValue && oldValue.expanded || included);
	        };
	        // 合并 expanded 与 display，确保数据刷新后，状态不变
	        keys.forEach(function (key) {
	          var oldValue = oldTreeData[key];
	          var newValue = _extends({}, nested[key]);
	          newValue.expanded = getExpanded(oldValue, key);
	          if (newValue.lazy) {
	            var _ref = oldValue || {},
	                _ref$loaded = _ref.loaded,
	                loaded = _ref$loaded === undefined ? false : _ref$loaded,
	                _ref$loading = _ref.loading,
	                loading = _ref$loading === undefined ? false : _ref$loading;
	
	            newValue.loaded = !!loaded;
	            newValue.loading = !!loading;
	            rootLazyRowKeys.push(key);
	          }
	          newTreeData[key] = newValue;
	        });
	        // 根据懒加载数据更新 treeData
	        var lazyKeys = Object.keys(normalizedLazyNode);
	        if (lazy && lazyKeys.length && rootLazyRowKeys.length) {
	          lazyKeys.forEach(function (key) {
	            var oldValue = oldTreeData[key];
	            var lazyNodeChildren = normalizedLazyNode[key].children;
	            if (rootLazyRowKeys.indexOf(key) !== -1) {
	              // 懒加载的 root 节点，更新一下原有的数据，原来的 children 一定是空数组
	              if (newTreeData[key].children.length !== 0) {
	                throw new Error('[ElTable]children must be an empty array.');
	              }
	              newTreeData[key].children = lazyNodeChildren;
	            } else {
	              var _ref2 = oldValue || {},
	                  _ref2$loaded = _ref2.loaded,
	                  loaded = _ref2$loaded === undefined ? false : _ref2$loaded,
	                  _ref2$loading = _ref2.loading,
	                  loading = _ref2$loading === undefined ? false : _ref2$loading;
	
	              newTreeData[key] = {
	                lazy: true,
	                loaded: !!loaded,
	                loading: !!loading,
	                expanded: getExpanded(oldValue, key),
	                children: lazyNodeChildren,
	                level: ''
	              };
	            }
	          });
	        }
	      }
	      this.states.treeData = newTreeData;
	      this.updateTableScrollY();
	    },
	    updateTreeExpandKeys: function updateTreeExpandKeys(value) {
	      this.states.expandRowKeys = value;
	      this.updateTreeData();
	    },
	    toggleTreeExpansion: function toggleTreeExpansion(row, expanded) {
	      this.assertRowKey();
	
	      var _states4 = this.states,
	          rowKey = _states4.rowKey,
	          treeData = _states4.treeData;
	
	      var id = getRowIdentity(row, rowKey);
	      var data = id && treeData[id];
	      if (id && data && 'expanded' in data) {
	        var oldExpanded = data.expanded;
	        expanded = typeof expanded === 'undefined' ? !data.expanded : expanded;
	        treeData[id].expanded = expanded;
	        if (oldExpanded !== expanded) {
	          this.table.$emit('expand-change', row, expanded);
	        }
	        this.updateTableScrollY();
	      }
	    },
	    loadOrToggle: function loadOrToggle(row) {
	      this.assertRowKey();
	      var _states5 = this.states,
	          lazy = _states5.lazy,
	          treeData = _states5.treeData,
	          rowKey = _states5.rowKey;
	
	      var id = getRowIdentity(row, rowKey);
	      var data = treeData[id];
	      if (lazy && data && 'loaded' in data && !data.loaded) {
	        this.loadData(row, id, data);
	      } else {
	        this.toggleTreeExpansion(row);
	      }
	    },
	    loadData: function loadData(row, key, treeNode) {
	      var _this = this;
	
	      var load = this.table.load;
	      var _states6 = this.states,
	          lazyTreeNodeMap = _states6.lazyTreeNodeMap,
	          treeData = _states6.treeData;
	
	      if (load && !treeData[key].loaded) {
	        treeData[key].loading = true;
	        load(row, treeNode, function (data) {
	          if (!Array.isArray(data)) {
	            throw new Error('[ElTable] data must be an array');
	          }
	          treeData[key].loading = false;
	          treeData[key].loaded = true;
	          treeData[key].expanded = true;
	          if (data.length) {
	            _this.$set(lazyTreeNodeMap, key, data);
	          }
	          _this.table.$emit('expand-change', row, true);
	        });
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/store/watcher.js
	
	
	
	
	
	
	
	var watcher_sortData = function sortData(data, states) {
	  var sortingColumn = states.sortingColumn;
	  if (!sortingColumn || typeof sortingColumn.sortable === 'string') {
	    return data;
	  }
	  return util_orderBy(data, states.sortProp, states.sortOrder, sortingColumn.sortMethod, sortingColumn.sortBy);
	};
	
	var doFlattenColumns = function doFlattenColumns(columns) {
	  var result = [];
	  columns.forEach(function (column) {
	    if (column.children) {
	      result.push.apply(result, doFlattenColumns(column.children));
	    } else {
	      result.push(column);
	    }
	  });
	  return result;
	};
	
	/* harmony default export */ var watcher = (external_vue_default.a.extend({
	  data: function data() {
	    return {
	      states: {
	        // 3.0 版本后要求必须设置该属性
	        rowKey: null,
	
	        // 渲染的数据来源，是对 table 中的 data 过滤排序后的结果
	        data: [],
	
	        // 是否包含固定列
	        isComplex: false,
	
	        // 列
	        _columns: [], // 不可响应的
	        originColumns: [],
	        columns: [],
	        fixedColumns: [],
	        rightFixedColumns: [],
	        leafColumns: [],
	        fixedLeafColumns: [],
	        rightFixedLeafColumns: [],
	        leafColumnsLength: 0,
	        fixedLeafColumnsLength: 0,
	        rightFixedLeafColumnsLength: 0,
	
	        // 选择
	        isAllSelected: false,
	        selection: [],
	        reserveSelection: false,
	        selectOnIndeterminate: false,
	        selectable: null,
	
	        // 过滤
	        filters: {}, // 不可响应的
	        filteredData: null,
	
	        // 排序
	        sortingColumn: null,
	        sortProp: null,
	        sortOrder: null,
	
	        hoverRow: null
	      }
	    };
	  },
	
	
	  mixins: [expand, current, tree],
	
	  methods: {
	    // 检查 rowKey 是否存在
	    assertRowKey: function assertRowKey() {
	      var rowKey = this.states.rowKey;
	      if (!rowKey) throw new Error('[ElTable] prop row-key is required');
	    },
	
	
	    // 更新列
	    updateColumns: function updateColumns() {
	      var states = this.states;
	      var _columns = states._columns || [];
	      states.fixedColumns = _columns.filter(function (column) {
	        return column.fixed === true || column.fixed === 'left';
	      });
	      states.rightFixedColumns = _columns.filter(function (column) {
	        return column.fixed === 'right';
	      });
	
	      if (states.fixedColumns.length > 0 && _columns[0] && _columns[0].type === 'selection' && !_columns[0].fixed) {
	        _columns[0].fixed = true;
	        states.fixedColumns.unshift(_columns[0]);
	      }
	
	      var notFixedColumns = _columns.filter(function (column) {
	        return !column.fixed;
	      });
	      states.originColumns = [].concat(states.fixedColumns).concat(notFixedColumns).concat(states.rightFixedColumns);
	
	      var leafColumns = doFlattenColumns(notFixedColumns);
	      var fixedLeafColumns = doFlattenColumns(states.fixedColumns);
	      var rightFixedLeafColumns = doFlattenColumns(states.rightFixedColumns);
	
	      states.leafColumnsLength = leafColumns.length;
	      states.fixedLeafColumnsLength = fixedLeafColumns.length;
	      states.rightFixedLeafColumnsLength = rightFixedLeafColumns.length;
	
	      states.columns = [].concat(fixedLeafColumns).concat(leafColumns).concat(rightFixedLeafColumns);
	      states.isComplex = states.fixedColumns.length > 0 || states.rightFixedColumns.length > 0;
	    },
	
	
	    // 更新 DOM
	    scheduleLayout: function scheduleLayout(needUpdateColumns) {
	      if (needUpdateColumns) {
	        this.updateColumns();
	      }
	      this.table.debouncedUpdateLayout();
	    },
	
	
	    // 选择
	    isSelected: function isSelected(row) {
	      var _states$selection = this.states.selection,
	          selection = _states$selection === undefined ? [] : _states$selection;
	
	      return selection.indexOf(row) > -1;
	    },
	    clearSelection: function clearSelection() {
	      var states = this.states;
	      states.isAllSelected = false;
	      var oldSelection = states.selection;
	      if (oldSelection.length) {
	        states.selection = [];
	        this.table.$emit('selection-change', []);
	      }
	    },
	    cleanSelection: function cleanSelection() {
	      var states = this.states;
	      var data = states.data,
	          rowKey = states.rowKey,
	          selection = states.selection;
	
	      var deleted = void 0;
	      if (rowKey) {
	        deleted = [];
	        var selectedMap = getKeysMap(selection, rowKey);
	        var dataMap = getKeysMap(data, rowKey);
	        for (var key in selectedMap) {
	          if (selectedMap.hasOwnProperty(key) && !dataMap[key]) {
	            deleted.push(selectedMap[key].row);
	          }
	        }
	      } else {
	        deleted = selection.filter(function (item) {
	          return data.indexOf(item) === -1;
	        });
	      }
	      if (deleted.length) {
	        var newSelection = selection.filter(function (item) {
	          return deleted.indexOf(item) === -1;
	        });
	        states.selection = newSelection;
	        this.table.$emit('selection-change', newSelection.slice());
	      }
	    },
	    toggleRowSelection: function toggleRowSelection(row, selected) {
	      var emitChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      var changed = toggleRowStatus(this.states.selection, row, selected);
	      if (changed) {
	        var newSelection = (this.states.selection || []).slice();
	        // 调用 API 修改选中值，不触发 select 事件
	        if (emitChange) {
	          this.table.$emit('select', newSelection, row);
	        }
	        this.table.$emit('selection-change', newSelection);
	      }
	    },
	    _toggleAllSelection: function _toggleAllSelection() {
	      var states = this.states;
	      var _states$data = states.data,
	          data = _states$data === undefined ? [] : _states$data,
	          selection = states.selection;
	      // when only some rows are selected (but not all), select or deselect all of them
	      // depending on the value of selectOnIndeterminate
	
	      var value = states.selectOnIndeterminate ? !states.isAllSelected : !(states.isAllSelected || selection.length);
	      states.isAllSelected = value;
	
	      var selectionChanged = false;
	      data.forEach(function (row, index) {
	        if (states.selectable) {
	          if (states.selectable.call(null, row, index) && toggleRowStatus(selection, row, value)) {
	            selectionChanged = true;
	          }
	        } else {
	          if (toggleRowStatus(selection, row, value)) {
	            selectionChanged = true;
	          }
	        }
	      });
	
	      if (selectionChanged) {
	        this.table.$emit('selection-change', selection ? selection.slice() : []);
	      }
	      this.table.$emit('select-all', selection);
	    },
	    updateSelectionByRowKey: function updateSelectionByRowKey() {
	      var states = this.states;
	      var selection = states.selection,
	          rowKey = states.rowKey,
	          data = states.data;
	
	      var selectedMap = getKeysMap(selection, rowKey);
	      data.forEach(function (row) {
	        var rowId = getRowIdentity(row, rowKey);
	        var rowInfo = selectedMap[rowId];
	        if (rowInfo) {
	          selection[rowInfo.index] = row;
	        }
	      });
	    },
	    updateAllSelected: function updateAllSelected() {
	      var states = this.states;
	      var selection = states.selection,
	          rowKey = states.rowKey,
	          selectable = states.selectable;
	      // data 为 null 时，解构时的默认值会被忽略
	
	      var data = states.data || [];
	      if (data.length === 0) {
	        states.isAllSelected = false;
	        return;
	      }
	
	      var selectedMap = void 0;
	      if (rowKey) {
	        selectedMap = getKeysMap(selection, rowKey);
	      }
	      var isSelected = function isSelected(row) {
	        if (selectedMap) {
	          return !!selectedMap[getRowIdentity(row, rowKey)];
	        } else {
	          return selection.indexOf(row) !== -1;
	        }
	      };
	      var isAllSelected = true;
	      var selectedCount = 0;
	      for (var i = 0, j = data.length; i < j; i++) {
	        var item = data[i];
	        var isRowSelectable = selectable && selectable.call(null, item, i);
	        if (!isSelected(item)) {
	          if (!selectable || isRowSelectable) {
	            isAllSelected = false;
	            break;
	          }
	        } else {
	          selectedCount++;
	        }
	      }
	
	      if (selectedCount === 0) isAllSelected = false;
	      states.isAllSelected = isAllSelected;
	    },
	
	
	    // 过滤与排序
	    updateFilters: function updateFilters(columns, values) {
	      if (!Array.isArray(columns)) {
	        columns = [columns];
	      }
	      var states = this.states;
	      var filters = {};
	      columns.forEach(function (col) {
	        states.filters[col.id] = values;
	        filters[col.columnKey || col.id] = values;
	      });
	
	      return filters;
	    },
	    updateSort: function updateSort(column, prop, order) {
	      if (this.states.sortingColumn && this.states.sortingColumn !== column) {
	        this.states.sortingColumn.order = null;
	      }
	      this.states.sortingColumn = column;
	      this.states.sortProp = prop;
	      this.states.sortOrder = order;
	    },
	    execFilter: function execFilter() {
	      var _this = this;
	
	      var states = this.states;
	      var _data = states._data,
	          filters = states.filters;
	
	      var data = _data;
	
	      Object.keys(filters).forEach(function (columnId) {
	        var values = states.filters[columnId];
	        if (!values || values.length === 0) return;
	        var column = getColumnById(_this.states, columnId);
	        if (column && column.filterMethod) {
	          data = data.filter(function (row) {
	            return values.some(function (value) {
	              return column.filterMethod.call(null, value, row, column);
	            });
	          });
	        }
	      });
	
	      states.filteredData = data;
	    },
	    execSort: function execSort() {
	      var states = this.states;
	      states.data = watcher_sortData(states.filteredData, states);
	    },
	
	
	    // 根据 filters 与 sort 去过滤 data
	    execQuery: function execQuery(ignore) {
	      if (!(ignore && ignore.filter)) {
	        this.execFilter();
	      }
	      this.execSort();
	    },
	    clearFilter: function clearFilter(columnKeys) {
	      var states = this.states;
	      var _table$$refs = this.table.$refs,
	          tableHeader = _table$$refs.tableHeader,
	          fixedTableHeader = _table$$refs.fixedTableHeader,
	          rightFixedTableHeader = _table$$refs.rightFixedTableHeader;
	
	
	      var panels = {};
	      if (tableHeader) panels = merge_default()(panels, tableHeader.filterPanels);
	      if (fixedTableHeader) panels = merge_default()(panels, fixedTableHeader.filterPanels);
	      if (rightFixedTableHeader) panels = merge_default()(panels, rightFixedTableHeader.filterPanels);
	
	      var keys = Object.keys(panels);
	      if (!keys.length) return;
	
	      if (typeof columnKeys === 'string') {
	        columnKeys = [columnKeys];
	      }
	
	      if (Array.isArray(columnKeys)) {
	        var columns = columnKeys.map(function (key) {
	          return getColumnByKey(states, key);
	        });
	        keys.forEach(function (key) {
	          var column = columns.find(function (col) {
	            return col.id === key;
	          });
	          if (column) {
	            // TODO: 优化这里的代码
	            panels[key].filteredValue = [];
	          }
	        });
	        this.commit('filterChange', {
	          column: columns,
	          values: [],
	          silent: true,
	          multi: true
	        });
	      } else {
	        keys.forEach(function (key) {
	          // TODO: 优化这里的代码
	          panels[key].filteredValue = [];
	        });
	
	        states.filters = {};
	        this.commit('filterChange', {
	          column: {},
	          values: [],
	          silent: true
	        });
	      }
	    },
	    clearSort: function clearSort() {
	      var states = this.states;
	      if (!states.sortingColumn) return;
	
	      this.updateSort(null, null, null);
	      this.commit('changeSortCondition', {
	        silent: true
	      });
	    },
	
	
	    // 适配层，expand-row-keys 在 Expand 与 TreeTable 中都有使用
	    setExpandRowKeysAdapter: function setExpandRowKeysAdapter(val) {
	      // 这里会触发额外的计算，但为了兼容性，暂时这么做
	      this.setExpandRowKeys(val);
	      this.updateTreeExpandKeys(val);
	    },
	
	
	    // 展开行与 TreeTable 都要使用
	    toggleRowExpansionAdapter: function toggleRowExpansionAdapter(row, expanded) {
	      var hasExpandColumn = this.states.columns.some(function (_ref) {
	        var type = _ref.type;
	        return type === 'expand';
	      });
	      if (hasExpandColumn) {
	        this.toggleRowExpansion(row, expanded);
	      } else {
	        this.toggleTreeExpansion(row, expanded);
	      }
	    }
	  }
	}));
	// CONCATENATED MODULE: ./packages/table/src/store/index.js
	
	
	
	
	watcher.prototype.mutations = {
	  setData: function setData(states, data) {
	    var dataInstanceChanged = states._data !== data;
	    states._data = data;
	
	    this.execQuery();
	    // 数据变化，更新部分数据。
	    // 没有使用 computed，而是手动更新部分数据 https://github.com/vuejs/vue/issues/6660#issuecomment-331417140
	    this.updateCurrentRowData();
	    this.updateExpandRows();
	    if (states.reserveSelection) {
	      this.assertRowKey();
	      this.updateSelectionByRowKey();
	    } else {
	      if (dataInstanceChanged) {
	        this.clearSelection();
	      } else {
	        this.cleanSelection();
	      }
	    }
	    this.updateAllSelected();
	
	    this.updateTableScrollY();
	  },
	  insertColumn: function insertColumn(states, column, index, parent) {
	    var array = states._columns;
	    if (parent) {
	      array = parent.children;
	      if (!array) array = parent.children = [];
	    }
	
	    if (typeof index !== 'undefined') {
	      array.splice(index, 0, column);
	    } else {
	      array.push(column);
	    }
	
	    if (column.type === 'selection') {
	      states.selectable = column.selectable;
	      states.reserveSelection = column.reserveSelection;
	    }
	
	    if (this.table.$ready) {
	      this.updateColumns(); // hack for dynamics insert column
	      this.scheduleLayout();
	    }
	  },
	  removeColumn: function removeColumn(states, column, parent) {
	    var array = states._columns;
	    if (parent) {
	      array = parent.children;
	      if (!array) array = parent.children = [];
	    }
	    if (array) {
	      array.splice(array.indexOf(column), 1);
	    }
	
	    if (this.table.$ready) {
	      this.updateColumns(); // hack for dynamics remove column
	      this.scheduleLayout();
	    }
	  },
	  sort: function sort(states, options) {
	    var prop = options.prop,
	        order = options.order,
	        init = options.init;
	
	    if (prop) {
	      var column = Object(util_["arrayFind"])(states.columns, function (column) {
	        return column.property === prop;
	      });
	      if (column) {
	        column.order = order;
	        this.updateSort(column, prop, order);
	        this.commit('changeSortCondition', { init: init });
	      }
	    }
	  },
	  changeSortCondition: function changeSortCondition(states, options) {
	    // 修复 pr https://github.com/ElemeFE/element/pull/15012 导致的 bug
	    var column = states.sortingColumn,
	        prop = states.sortProp,
	        order = states.sortOrder;
	
	    if (order === null) {
	      states.sortingColumn = null;
	      states.sortProp = null;
	    }
	    var ingore = { filter: true };
	    this.execQuery(ingore);
	
	    if (!options || !(options.silent || options.init)) {
	      this.table.$emit('sort-change', {
	        column: column,
	        prop: prop,
	        order: order
	      });
	    }
	
	    this.updateTableScrollY();
	  },
	  filterChange: function filterChange(states, options) {
	    var column = options.column,
	        values = options.values,
	        silent = options.silent;
	
	    var newFilters = this.updateFilters(column, values);
	
	    this.execQuery();
	
	    if (!silent) {
	      this.table.$emit('filter-change', newFilters);
	    }
	
	    this.updateTableScrollY();
	  },
	  toggleAllSelection: function toggleAllSelection() {
	    this.toggleAllSelection();
	  },
	  rowSelectedChanged: function rowSelectedChanged(states, row) {
	    this.toggleRowSelection(row);
	    this.updateAllSelected();
	  },
	  setHoverRow: function setHoverRow(states, row) {
	    states.hoverRow = row;
	  },
	  setCurrentRow: function setCurrentRow(states, row) {
	    this.updateCurrentRow(row);
	  }
	};
	
	watcher.prototype.commit = function (name) {
	  var mutations = this.mutations;
	  if (mutations[name]) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    mutations[name].apply(this, [this.states].concat(args));
	  } else {
	    throw new Error('Action not found: ' + name);
	  }
	};
	
	watcher.prototype.updateTableScrollY = function () {
	  external_vue_default.a.nextTick(this.table.updateScrollY);
	};
	
	/* harmony default export */ var src_store = (watcher);
	// CONCATENATED MODULE: ./packages/table/src/store/helper.js
	
	
	
	function createStore(table) {
	  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (!table) {
	    throw new Error('Table is required.');
	  }
	
	  var store = new src_store();
	  store.table = table;
	  // fix https://github.com/ElemeFE/element/issues/14075
	  // related pr https://github.com/ElemeFE/element/pull/14146
	  store.toggleAllSelection = debounce_default()(10, store._toggleAllSelection);
	  Object.keys(initialState).forEach(function (key) {
	    store.states[key] = initialState[key];
	  });
	  return store;
	}
	
	function mapStates(mapper) {
	  var res = {};
	  Object.keys(mapper).forEach(function (key) {
	    var value = mapper[key];
	    var fn = void 0;
	    if (typeof value === 'string') {
	      fn = function fn() {
	        return this.store.states[value];
	      };
	    } else if (typeof value === 'function') {
	      fn = function fn() {
	        return value.call(this, this.store.states);
	      };
	    } else {
	      console.error('invalid value type');
	    }
	    if (fn) {
	      res[key] = fn;
	    }
	  });
	  return res;
	};
	// EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
	var scrollbar_width_ = __webpack_require__(31);
	var scrollbar_width_default = /*#__PURE__*/__webpack_require__.n(scrollbar_width_);
	
	// CONCATENATED MODULE: ./packages/table/src/table-layout.js
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	
	var table_layout_TableLayout = function () {
	  function TableLayout(options) {
	    _classCallCheck(this, TableLayout);
	
	    this.observers = [];
	    this.table = null;
	    this.store = null;
	    this.columns = null;
	    this.fit = true;
	    this.showHeader = true;
	
	    this.height = null;
	    this.scrollX = false;
	    this.scrollY = false;
	    this.bodyWidth = null;
	    this.fixedWidth = null;
	    this.rightFixedWidth = null;
	    this.tableHeight = null;
	    this.headerHeight = 44; // Table Header Height
	    this.appendHeight = 0; // Append Slot Height
	    this.footerHeight = 44; // Table Footer Height
	    this.viewportHeight = null; // Table Height - Scroll Bar Height
	    this.bodyHeight = null; // Table Height - Table Header Height
	    this.fixedBodyHeight = null; // Table Height - Table Header Height - Scroll Bar Height
	    this.gutterWidth = scrollbar_width_default()();
	
	    for (var name in options) {
	      if (options.hasOwnProperty(name)) {
	        this[name] = options[name];
	      }
	    }
	
	    if (!this.table) {
	      throw new Error('table is required for Table Layout');
	    }
	    if (!this.store) {
	      throw new Error('store is required for Table Layout');
	    }
	  }
	
	  TableLayout.prototype.updateScrollY = function updateScrollY() {
	    var height = this.height;
	    if (height === null) return false;
	    var bodyWrapper = this.table.bodyWrapper;
	    if (this.table.$el && bodyWrapper) {
	      var body = bodyWrapper.querySelector('.el-table__body');
	      var prevScrollY = this.scrollY;
	      var scrollY = body.offsetHeight > this.bodyHeight;
	      this.scrollY = scrollY;
	      return prevScrollY !== scrollY;
	    }
	    return false;
	  };
	
	  TableLayout.prototype.setHeight = function setHeight(value) {
	    var _this = this;
	
	    var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'height';
	
	    if (external_vue_default.a.prototype.$isServer) return;
	    var el = this.table.$el;
	    value = parseHeight(value);
	    this.height = value;
	
	    if (!el && (value || value === 0)) return external_vue_default.a.nextTick(function () {
	      return _this.setHeight(value, prop);
	    });
	
	    if (typeof value === 'number') {
	      el.style[prop] = value + 'px';
	      this.updateElsHeight();
	    } else if (typeof value === 'string') {
	      el.style[prop] = value;
	      this.updateElsHeight();
	    }
	  };
	
	  TableLayout.prototype.setMaxHeight = function setMaxHeight(value) {
	    this.setHeight(value, 'max-height');
	  };
	
	  TableLayout.prototype.getFlattenColumns = function getFlattenColumns() {
	    var flattenColumns = [];
	    var columns = this.table.columns;
	    columns.forEach(function (column) {
	      if (column.isColumnGroup) {
	        flattenColumns.push.apply(flattenColumns, column.columns);
	      } else {
	        flattenColumns.push(column);
	      }
	    });
	
	    return flattenColumns;
	  };
	
	  TableLayout.prototype.updateElsHeight = function updateElsHeight() {
	    var _this2 = this;
	
	    if (!this.table.$ready) return external_vue_default.a.nextTick(function () {
	      return _this2.updateElsHeight();
	    });
	    var _table$$refs = this.table.$refs,
	        headerWrapper = _table$$refs.headerWrapper,
	        appendWrapper = _table$$refs.appendWrapper,
	        footerWrapper = _table$$refs.footerWrapper;
	
	    this.appendHeight = appendWrapper ? appendWrapper.offsetHeight : 0;
	
	    if (this.showHeader && !headerWrapper) return;
	
	    // fix issue (https://github.com/ElemeFE/element/pull/16956)
	    var headerTrElm = headerWrapper ? headerWrapper.querySelector('.el-table__header tr') : null;
	    var noneHeader = this.headerDisplayNone(headerTrElm);
	
	    var headerHeight = this.headerHeight = !this.showHeader ? 0 : headerWrapper.offsetHeight;
	    if (this.showHeader && !noneHeader && headerWrapper.offsetWidth > 0 && (this.table.columns || []).length > 0 && headerHeight < 2) {
	      return external_vue_default.a.nextTick(function () {
	        return _this2.updateElsHeight();
	      });
	    }
	    var tableHeight = this.tableHeight = this.table.$el.clientHeight;
	    var footerHeight = this.footerHeight = footerWrapper ? footerWrapper.offsetHeight : 0;
	    if (this.height !== null) {
	      this.bodyHeight = tableHeight - headerHeight - footerHeight + (footerWrapper ? 1 : 0);
	    }
	    this.fixedBodyHeight = this.scrollX ? this.bodyHeight - this.gutterWidth : this.bodyHeight;
	
	    var noData = !(this.store.states.data && this.store.states.data.length);
	    this.viewportHeight = this.scrollX ? tableHeight - (noData ? 0 : this.gutterWidth) : tableHeight;
	
	    this.updateScrollY();
	    this.notifyObservers('scrollable');
	  };
	
	  TableLayout.prototype.headerDisplayNone = function headerDisplayNone(elm) {
	    if (!elm) return true;
	    var headerChild = elm;
	    while (headerChild.tagName !== 'DIV') {
	      if (getComputedStyle(headerChild).display === 'none') {
	        return true;
	      }
	      headerChild = headerChild.parentElement;
	    }
	    return false;
	  };
	
	  TableLayout.prototype.updateColumnsWidth = function updateColumnsWidth() {
	    if (external_vue_default.a.prototype.$isServer) return;
	    var fit = this.fit;
	    var bodyWidth = this.table.$el.clientWidth;
	    var bodyMinWidth = 0;
	
	    var flattenColumns = this.getFlattenColumns();
	    var flexColumns = flattenColumns.filter(function (column) {
	      return typeof column.width !== 'number';
	    });
	
	    flattenColumns.forEach(function (column) {
	      // Clean those columns whose width changed from flex to unflex
	      if (typeof column.width === 'number' && column.realWidth) column.realWidth = null;
	    });
	
	    if (flexColumns.length > 0 && fit) {
	      flattenColumns.forEach(function (column) {
	        bodyMinWidth += column.width || column.minWidth || 80;
	      });
	
	      var scrollYWidth = this.scrollY ? this.gutterWidth : 0;
	
	      if (bodyMinWidth <= bodyWidth - scrollYWidth) {
	        // DON'T HAVE SCROLL BAR
	        this.scrollX = false;
	
	        var totalFlexWidth = bodyWidth - scrollYWidth - bodyMinWidth;
	
	        if (flexColumns.length === 1) {
	          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth;
	        } else {
	          var allColumnsWidth = flexColumns.reduce(function (prev, column) {
	            return prev + (column.minWidth || 80);
	          }, 0);
	          var flexWidthPerPixel = totalFlexWidth / allColumnsWidth;
	          var noneFirstWidth = 0;
	
	          flexColumns.forEach(function (column, index) {
	            if (index === 0) return;
	            var flexWidth = Math.floor((column.minWidth || 80) * flexWidthPerPixel);
	            noneFirstWidth += flexWidth;
	            column.realWidth = (column.minWidth || 80) + flexWidth;
	          });
	
	          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth - noneFirstWidth;
	        }
	      } else {
	        // HAVE HORIZONTAL SCROLL BAR
	        this.scrollX = true;
	        flexColumns.forEach(function (column) {
	          column.realWidth = column.minWidth;
	        });
	      }
	
	      this.bodyWidth = Math.max(bodyMinWidth, bodyWidth);
	      this.table.resizeState.width = this.bodyWidth;
	    } else {
	      flattenColumns.forEach(function (column) {
	        if (!column.width && !column.minWidth) {
	          column.realWidth = 80;
	        } else {
	          column.realWidth = column.width || column.minWidth;
	        }
	
	        bodyMinWidth += column.realWidth;
	      });
	      this.scrollX = bodyMinWidth > bodyWidth;
	
	      this.bodyWidth = bodyMinWidth;
	    }
	
	    var fixedColumns = this.store.states.fixedColumns;
	
	    if (fixedColumns.length > 0) {
	      var fixedWidth = 0;
	      fixedColumns.forEach(function (column) {
	        fixedWidth += column.realWidth || column.width;
	      });
	
	      this.fixedWidth = fixedWidth;
	    }
	
	    var rightFixedColumns = this.store.states.rightFixedColumns;
	    if (rightFixedColumns.length > 0) {
	      var rightFixedWidth = 0;
	      rightFixedColumns.forEach(function (column) {
	        rightFixedWidth += column.realWidth || column.width;
	      });
	
	      this.rightFixedWidth = rightFixedWidth;
	    }
	
	    this.notifyObservers('columns');
	  };
	
	  TableLayout.prototype.addObserver = function addObserver(observer) {
	    this.observers.push(observer);
	  };
	
	  TableLayout.prototype.removeObserver = function removeObserver(observer) {
	    var index = this.observers.indexOf(observer);
	    if (index !== -1) {
	      this.observers.splice(index, 1);
	    }
	  };
	
	  TableLayout.prototype.notifyObservers = function notifyObservers(event) {
	    var _this3 = this;
	
	    var observers = this.observers;
	    observers.forEach(function (observer) {
	      switch (event) {
	        case 'columns':
	          observer.onColumnsChange(_this3);
	          break;
	        case 'scrollable':
	          observer.onScrollableChange(_this3);
	          break;
	        default:
	          throw new Error('Table Layout don\'t have event ' + event + '.');
	      }
	    });
	  };
	
	  return TableLayout;
	}();
	
	/* harmony default export */ var table_layout = (table_layout_TableLayout);
	// CONCATENATED MODULE: ./packages/table/src/layout-observer.js
	/* harmony default export */ var layout_observer = ({
	  created: function created() {
	    this.tableLayout.addObserver(this);
	  },
	  destroyed: function destroyed() {
	    this.tableLayout.removeObserver(this);
	  },
	
	
	  computed: {
	    tableLayout: function tableLayout() {
	      var layout = this.layout;
	      if (!layout && this.table) {
	        layout = this.table.layout;
	      }
	      if (!layout) {
	        throw new Error('Can not find table layout.');
	      }
	      return layout;
	    }
	  },
	
	  mounted: function mounted() {
	    this.onColumnsChange(this.tableLayout);
	    this.onScrollableChange(this.tableLayout);
	  },
	  updated: function updated() {
	    if (this.__updated__) return;
	    this.onColumnsChange(this.tableLayout);
	    this.onScrollableChange(this.tableLayout);
	    this.__updated__ = true;
	  },
	
	
	  methods: {
	    onColumnsChange: function onColumnsChange(layout) {
	      var cols = this.$el.querySelectorAll('colgroup > col');
	      if (!cols.length) return;
	      var flattenColumns = layout.getFlattenColumns();
	      var columnsMap = {};
	      flattenColumns.forEach(function (column) {
	        columnsMap[column.id] = column;
	      });
	      for (var i = 0, j = cols.length; i < j; i++) {
	        var col = cols[i];
	        var name = col.getAttribute('name');
	        var column = columnsMap[name];
	        if (column) {
	          col.setAttribute('width', column.realWidth || column.width);
	        }
	      }
	    },
	    onScrollableChange: function onScrollableChange(layout) {
	      var cols = this.$el.querySelectorAll('colgroup > col[name=gutter]');
	      for (var i = 0, j = cols.length; i < j; i++) {
	        var col = cols[i];
	        col.setAttribute('width', layout.scrollY ? layout.gutterWidth : '0');
	      }
	      var ths = this.$el.querySelectorAll('th.gutter');
	      for (var _i = 0, _j = ths.length; _i < _j; _i++) {
	        var th = ths[_i];
	        th.style.width = layout.scrollY ? layout.gutterWidth + 'px' : '0';
	        th.style.display = layout.scrollY ? '' : 'none';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/table-body.js
	var table_body_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var table_body_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var table_body = ({
	  name: 'ElTableBody',
	
	  mixins: [layout_observer],
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElTooltip: tooltip_default.a
	  },
	
	  props: {
	    store: {
	      required: true
	    },
	    stripe: Boolean,
	    context: {},
	    rowClassName: [String, Function],
	    rowStyle: [Object, Function],
	    fixed: String,
	    highlight: Boolean
	  },
	
	  render: function render(h) {
	    var _this = this;
	
	    var data = this.data || [];
	    return h(
	      'table',
	      {
	        'class': 'el-table__body',
	        attrs: { cellspacing: '0',
	          cellpadding: '0',
	          border: '0' }
	      },
	      [h('colgroup', [this.columns.map(function (column) {
	        return h('col', {
	          attrs: { name: column.id },
	          key: column.id });
	      })]), h('tbody', [data.reduce(function (acc, row) {
	        return acc.concat(_this.wrappedRowRender(row, acc.length));
	      }, []), h('el-tooltip', {
	        attrs: { effect: this.table.tooltipEffect, placement: 'top', content: this.tooltipContent },
	        ref: 'tooltip' })])]
	    );
	  },
	
	
	  computed: table_body_extends({
	    table: function table() {
	      return this.$parent;
	    }
	  }, mapStates({
	    data: 'data',
	    columns: 'columns',
	    treeIndent: 'indent',
	    leftFixedLeafCount: 'fixedLeafColumnsLength',
	    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
	    columnsCount: function columnsCount(states) {
	      return states.columns.length;
	    },
	    leftFixedCount: function leftFixedCount(states) {
	      return states.fixedColumns.length;
	    },
	    rightFixedCount: function rightFixedCount(states) {
	      return states.rightFixedColumns.length;
	    },
	    hasExpandColumn: function hasExpandColumn(states) {
	      return states.columns.some(function (_ref) {
	        var type = _ref.type;
	        return type === 'expand';
	      });
	    }
	  }), {
	    firstDefaultColumnIndex: function firstDefaultColumnIndex() {
	      return Object(util_["arrayFindIndex"])(this.columns, function (_ref2) {
	        var type = _ref2.type;
	        return type === 'default';
	      });
	    }
	  }),
	
	  watch: {
	    // don't trigger getter of currentRow in getCellClass. see https://jsfiddle.net/oe2b4hqt/
	    // update DOM manually. see https://github.com/ElemeFE/element/pull/13954/files#diff-9b450c00d0a9dec0ffad5a3176972e40
	    'store.states.hoverRow': function storeStatesHoverRow(newVal, oldVal) {
	      var _this2 = this;
	
	      if (!this.store.states.isComplex || this.$isServer) return;
	      var raf = window.requestAnimationFrame;
	      if (!raf) {
	        raf = function raf(fn) {
	          return setTimeout(fn, 16);
	        };
	      }
	      raf(function () {
	        var rows = _this2.$el.querySelectorAll('.el-table__row');
	        var oldRow = rows[oldVal];
	        var newRow = rows[newVal];
	        if (oldRow) {
	          Object(dom_["removeClass"])(oldRow, 'hover-row');
	        }
	        if (newRow) {
	          Object(dom_["addClass"])(newRow, 'hover-row');
	        }
	      });
	    }
	  },
	
	  data: function data() {
	    return {
	      tooltipContent: ''
	    };
	  },
	  created: function created() {
	    this.activateTooltip = debounce_default()(50, function (tooltip) {
	      return tooltip.handleShowPopper();
	    });
	  },
	
	
	  methods: {
	    getKeyOfRow: function getKeyOfRow(row, index) {
	      var rowKey = this.table.rowKey;
	      if (rowKey) {
	        return getRowIdentity(row, rowKey);
	      }
	      return index;
	    },
	    isColumnHidden: function isColumnHidden(index) {
	      if (this.fixed === true || this.fixed === 'left') {
	        return index >= this.leftFixedLeafCount;
	      } else if (this.fixed === 'right') {
	        return index < this.columnsCount - this.rightFixedLeafCount;
	      } else {
	        return index < this.leftFixedLeafCount || index >= this.columnsCount - this.rightFixedLeafCount;
	      }
	    },
	    getSpan: function getSpan(row, column, rowIndex, columnIndex) {
	      var rowspan = 1;
	      var colspan = 1;
	      var fn = this.table.spanMethod;
	      if (typeof fn === 'function') {
	        var result = fn({
	          row: row,
	          column: column,
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	        if (Array.isArray(result)) {
	          rowspan = result[0];
	          colspan = result[1];
	        } else if ((typeof result === 'undefined' ? 'undefined' : table_body_typeof(result)) === 'object') {
	          rowspan = result.rowspan;
	          colspan = result.colspan;
	        }
	      }
	      return { rowspan: rowspan, colspan: colspan };
	    },
	    getRowStyle: function getRowStyle(row, rowIndex) {
	      var rowStyle = this.table.rowStyle;
	      if (typeof rowStyle === 'function') {
	        return rowStyle.call(null, {
	          row: row,
	          rowIndex: rowIndex
	        });
	      }
	      return rowStyle || null;
	    },
	    getRowClass: function getRowClass(row, rowIndex) {
	      var classes = ['el-table__row'];
	      if (this.table.highlightCurrentRow && row === this.store.states.currentRow) {
	        classes.push('current-row');
	      }
	
	      if (this.stripe && rowIndex % 2 === 1) {
	        classes.push('el-table__row--striped');
	      }
	      var rowClassName = this.table.rowClassName;
	      if (typeof rowClassName === 'string') {
	        classes.push(rowClassName);
	      } else if (typeof rowClassName === 'function') {
	        classes.push(rowClassName.call(null, {
	          row: row,
	          rowIndex: rowIndex
	        }));
	      }
	
	      if (this.store.states.expandRows.indexOf(row) > -1) {
	        classes.push('expanded');
	      }
	
	      return classes;
	    },
	    getCellStyle: function getCellStyle(rowIndex, columnIndex, row, column) {
	      var cellStyle = this.table.cellStyle;
	      if (typeof cellStyle === 'function') {
	        return cellStyle.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        });
	      }
	      return cellStyle;
	    },
	    getCellClass: function getCellClass(rowIndex, columnIndex, row, column) {
	      var classes = [column.id, column.align, column.className];
	
	      if (this.isColumnHidden(columnIndex)) {
	        classes.push('is-hidden');
	      }
	
	      var cellClassName = this.table.cellClassName;
	      if (typeof cellClassName === 'string') {
	        classes.push(cellClassName);
	      } else if (typeof cellClassName === 'function') {
	        classes.push(cellClassName.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        }));
	      }
	
	      return classes.join(' ');
	    },
	    getColspanRealWidth: function getColspanRealWidth(columns, colspan, index) {
	      if (colspan < 1) {
	        return columns[index].realWidth;
	      }
	      var widthArr = columns.map(function (_ref3) {
	        var realWidth = _ref3.realWidth;
	        return realWidth;
	      }).slice(index, index + colspan);
	      return widthArr.reduce(function (acc, width) {
	        return acc + width;
	      }, -1);
	    },
	    handleCellMouseEnter: function handleCellMouseEnter(event, row) {
	      var table = this.table;
	      var cell = getCell(event);
	
	      if (cell) {
	        var column = getColumnByCell(table, cell);
	        var hoverState = table.hoverState = { cell: cell, column: column, row: row };
	        table.$emit('cell-mouse-enter', hoverState.row, hoverState.column, hoverState.cell, event);
	      }
	
	      // 判断是否text-overflow, 如果是就显示tooltip
	      var cellChild = event.target.querySelector('.cell');
	      if (!(Object(dom_["hasClass"])(cellChild, 'el-tooltip') && cellChild.childNodes.length)) {
	        return;
	      }
	      // use range width instead of scrollWidth to determine whether the text is overflowing
	      // to address a potential FireFox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1074543#c3
	      var range = document.createRange();
	      range.setStart(cellChild, 0);
	      range.setEnd(cellChild, cellChild.childNodes.length);
	      var rangeWidth = range.getBoundingClientRect().width;
	      var padding = (parseInt(Object(dom_["getStyle"])(cellChild, 'paddingLeft'), 10) || 0) + (parseInt(Object(dom_["getStyle"])(cellChild, 'paddingRight'), 10) || 0);
	      if ((rangeWidth + padding > cellChild.offsetWidth || cellChild.scrollWidth > cellChild.offsetWidth) && this.$refs.tooltip) {
	        var tooltip = this.$refs.tooltip;
	        // TODO 会引起整个 Table 的重新渲染，需要优化
	        this.tooltipContent = cell.innerText || cell.textContent;
	        tooltip.referenceElm = cell;
	        tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
	        tooltip.doDestroy();
	        tooltip.setExpectedState(true);
	        this.activateTooltip(tooltip);
	      }
	    },
	    handleCellMouseLeave: function handleCellMouseLeave(event) {
	      var tooltip = this.$refs.tooltip;
	      if (tooltip) {
	        tooltip.setExpectedState(false);
	        tooltip.handleClosePopper();
	      }
	      var cell = getCell(event);
	      if (!cell) return;
	
	      var oldHoverState = this.table.hoverState || {};
	      this.table.$emit('cell-mouse-leave', oldHoverState.row, oldHoverState.column, oldHoverState.cell, event);
	    },
	
	
	    handleMouseEnter: debounce_default()(30, function (index) {
	      this.store.commit('setHoverRow', index);
	    }),
	
	    handleMouseLeave: debounce_default()(30, function () {
	      this.store.commit('setHoverRow', null);
	    }),
	
	    handleContextMenu: function handleContextMenu(event, row) {
	      this.handleEvent(event, row, 'contextmenu');
	    },
	    handleDoubleClick: function handleDoubleClick(event, row) {
	      this.handleEvent(event, row, 'dblclick');
	    },
	    handleClick: function handleClick(event, row) {
	      this.store.commit('setCurrentRow', row);
	      this.handleEvent(event, row, 'click');
	    },
	    handleEvent: function handleEvent(event, row, name) {
	      var table = this.table;
	      var cell = getCell(event);
	      var column = void 0;
	      if (cell) {
	        column = getColumnByCell(table, cell);
	        if (column) {
	          table.$emit('cell-' + name, row, column, cell, event);
	        }
	      }
	      table.$emit('row-' + name, row, column, event);
	    },
	    rowRender: function rowRender(row, $index, treeRowData) {
	      var _this3 = this;
	
	      var h = this.$createElement;
	      var treeIndent = this.treeIndent,
	          columns = this.columns,
	          firstDefaultColumnIndex = this.firstDefaultColumnIndex;
	
	      var columnsHidden = columns.map(function (column, index) {
	        return _this3.isColumnHidden(index);
	      });
	      var rowClasses = this.getRowClass(row, $index);
	      var display = true;
	      if (treeRowData) {
	        rowClasses.push('el-table__row--level-' + treeRowData.level);
	        display = treeRowData.display;
	      }
	      // 指令 v-show 会覆盖 row-style 中 display
	      // 使用 :style 代替 v-show https://github.com/ElemeFE/element/issues/16995
	      var displayStyle = display ? null : {
	        display: 'none'
	      };
	      return h(
	        'tr',
	        {
	          style: [displayStyle, this.getRowStyle(row, $index)],
	          'class': rowClasses,
	          key: this.getKeyOfRow(row, $index),
	          on: {
	            'dblclick': function dblclick($event) {
	              return _this3.handleDoubleClick($event, row);
	            },
	            'click': function click($event) {
	              return _this3.handleClick($event, row);
	            },
	            'contextmenu': function contextmenu($event) {
	              return _this3.handleContextMenu($event, row);
	            },
	            'mouseenter': function mouseenter(_) {
	              return _this3.handleMouseEnter($index);
	            },
	            'mouseleave': this.handleMouseLeave
	          }
	        },
	        [columns.map(function (column, cellIndex) {
	          var _getSpan = _this3.getSpan(row, column, $index, cellIndex),
	              rowspan = _getSpan.rowspan,
	              colspan = _getSpan.colspan;
	
	          if (!rowspan || !colspan) {
	            return null;
	          }
	          var columnData = table_body_extends({}, column);
	          columnData.realWidth = _this3.getColspanRealWidth(columns, colspan, cellIndex);
	          var data = {
	            store: _this3.store,
	            _self: _this3.context || _this3.table.$vnode.context,
	            column: columnData,
	            row: row,
	            $index: $index
	          };
	          if (cellIndex === firstDefaultColumnIndex && treeRowData) {
	            data.treeNode = {
	              indent: treeRowData.level * treeIndent,
	              level: treeRowData.level
	            };
	            if (typeof treeRowData.expanded === 'boolean') {
	              data.treeNode.expanded = treeRowData.expanded;
	              // 表明是懒加载
	              if ('loading' in treeRowData) {
	                data.treeNode.loading = treeRowData.loading;
	              }
	              if ('noLazyChildren' in treeRowData) {
	                data.treeNode.noLazyChildren = treeRowData.noLazyChildren;
	              }
	            }
	          }
	          return h(
	            'td',
	            {
	              style: _this3.getCellStyle($index, cellIndex, row, column),
	              'class': _this3.getCellClass($index, cellIndex, row, column),
	              attrs: { rowspan: rowspan,
	                colspan: colspan
	              },
	              on: {
	                'mouseenter': function mouseenter($event) {
	                  return _this3.handleCellMouseEnter($event, row);
	                },
	                'mouseleave': _this3.handleCellMouseLeave
	              }
	            },
	            [column.renderCell.call(_this3._renderProxy, _this3.$createElement, data, columnsHidden[cellIndex])]
	          );
	        })]
	      );
	    },
	    wrappedRowRender: function wrappedRowRender(row, $index) {
	      var _this4 = this;
	
	      var h = this.$createElement;
	
	      var store = this.store;
	      var isRowExpanded = store.isRowExpanded,
	          assertRowKey = store.assertRowKey;
	      var _store$states = store.states,
	          treeData = _store$states.treeData,
	          lazyTreeNodeMap = _store$states.lazyTreeNodeMap,
	          childrenColumnName = _store$states.childrenColumnName,
	          rowKey = _store$states.rowKey;
	
	      if (this.hasExpandColumn && isRowExpanded(row)) {
	        var renderExpanded = this.table.renderExpanded;
	        var tr = this.rowRender(row, $index);
	        if (!renderExpanded) {
	          console.error('[Element Error]renderExpanded is required.');
	          return tr;
	        }
	        // 使用二维数组，避免修改 $index
	        return [[tr, h(
	          'tr',
	          { key: 'expanded-row__' + tr.key },
	          [h(
	            'td',
	            {
	              attrs: { colspan: this.columnsCount },
	              'class': 'el-table__expanded-cell' },
	            [renderExpanded(this.$createElement, { row: row, $index: $index, store: this.store })]
	          )]
	        )]];
	      } else if (Object.keys(treeData).length) {
	        assertRowKey();
	        // TreeTable 时，rowKey 必须由用户设定，不使用 getKeyOfRow 计算
	        // 在调用 rowRender 函数时，仍然会计算 rowKey，不太好的操作
	        var key = getRowIdentity(row, rowKey);
	        var cur = treeData[key];
	        var treeRowData = null;
	        if (cur) {
	          treeRowData = {
	            expanded: cur.expanded,
	            level: cur.level,
	            display: true
	          };
	          if (typeof cur.lazy === 'boolean') {
	            if (typeof cur.loaded === 'boolean' && cur.loaded) {
	              treeRowData.noLazyChildren = !(cur.children && cur.children.length);
	            }
	            treeRowData.loading = cur.loading;
	          }
	        }
	        var tmp = [this.rowRender(row, $index, treeRowData)];
	        // 渲染嵌套数据
	        if (cur) {
	          // currentRow 记录的是 index，所以还需主动增加 TreeTable 的 index
	          var i = 0;
	          var traverse = function traverse(children, parent) {
	            if (!(children && children.length && parent)) return;
	            children.forEach(function (node) {
	              // 父节点的 display 状态影响子节点的显示状态
	              var innerTreeRowData = {
	                display: parent.display && parent.expanded,
	                level: parent.level + 1
	              };
	              var childKey = getRowIdentity(node, rowKey);
	              if (childKey === undefined || childKey === null) {
	                throw new Error('for nested data item, row-key is required.');
	              }
	              cur = table_body_extends({}, treeData[childKey]);
	              // 对于当前节点，分成有无子节点两种情况。
	              // 如果包含子节点的，设置 expanded 属性。
	              // 对于它子节点的 display 属性由它本身的 expanded 与 display 共同决定。
	              if (cur) {
	                innerTreeRowData.expanded = cur.expanded;
	                // 懒加载的某些节点，level 未知
	                cur.level = cur.level || innerTreeRowData.level;
	                cur.display = !!(cur.expanded && innerTreeRowData.display);
	                if (typeof cur.lazy === 'boolean') {
	                  if (typeof cur.loaded === 'boolean' && cur.loaded) {
	                    innerTreeRowData.noLazyChildren = !(cur.children && cur.children.length);
	                  }
	                  innerTreeRowData.loading = cur.loading;
	                }
	              }
	              i++;
	              tmp.push(_this4.rowRender(node, $index + i, innerTreeRowData));
	              if (cur) {
	                var _nodes = lazyTreeNodeMap[childKey] || node[childrenColumnName];
	                traverse(_nodes, cur);
	              }
	            });
	          };
	          // 对于 root 节点，display 一定为 true
	          cur.display = true;
	          var nodes = lazyTreeNodeMap[key] || row[childrenColumnName];
	          traverse(nodes, cur);
	        }
	        return tmp;
	      } else {
	        return this.rowRender(row, $index);
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
	var filter_panelvue_type_template_id_7f2c919f_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
	    _vm.multiple
	      ? _c(
	          "div",
	          {
	            directives: [
	              {
	                name: "clickoutside",
	                rawName: "v-clickoutside",
	                value: _vm.handleOutsideClick,
	                expression: "handleOutsideClick"
	              },
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.showPopper,
	                expression: "showPopper"
	              }
	            ],
	            staticClass: "el-table-filter"
	          },
	          [
	            _c(
	              "div",
	              { staticClass: "el-table-filter__content" },
	              [
	                _c(
	                  "el-scrollbar",
	                  { attrs: { "wrap-class": "el-table-filter__wrap" } },
	                  [
	                    _c(
	                      "el-checkbox-group",
	                      {
	                        staticClass: "el-table-filter__checkbox-group",
	                        model: {
	                          value: _vm.filteredValue,
	                          callback: function($$v) {
	                            _vm.filteredValue = $$v
	                          },
	                          expression: "filteredValue"
	                        }
	                      },
	                      _vm._l(_vm.filters, function(filter) {
	                        return _c(
	                          "el-checkbox",
	                          { key: filter.value, attrs: { label: filter.value } },
	                          [_vm._v(_vm._s(filter.text))]
	                        )
	                      }),
	                      1
	                    )
	                  ],
	                  1
	                )
	              ],
	              1
	            ),
	            _c("div", { staticClass: "el-table-filter__bottom" }, [
	              _c(
	                "button",
	                {
	                  class: { "is-disabled": _vm.filteredValue.length === 0 },
	                  attrs: { disabled: _vm.filteredValue.length === 0 },
	                  on: { click: _vm.handleConfirm }
	                },
	                [_vm._v(_vm._s(_vm.t("el.table.confirmFilter")))]
	              ),
	              _c("button", { on: { click: _vm.handleReset } }, [
	                _vm._v(_vm._s(_vm.t("el.table.resetFilter")))
	              ])
	            ])
	          ]
	        )
	      : _c(
	          "div",
	          {
	            directives: [
	              {
	                name: "clickoutside",
	                rawName: "v-clickoutside",
	                value: _vm.handleOutsideClick,
	                expression: "handleOutsideClick"
	              },
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.showPopper,
	                expression: "showPopper"
	              }
	            ],
	            staticClass: "el-table-filter"
	          },
	          [
	            _c(
	              "ul",
	              { staticClass: "el-table-filter__list" },
	              [
	                _c(
	                  "li",
	                  {
	                    staticClass: "el-table-filter__list-item",
	                    class: {
	                      "is-active":
	                        _vm.filterValue === undefined ||
	                        _vm.filterValue === null
	                    },
	                    on: {
	                      click: function($event) {
	                        _vm.handleSelect(null)
	                      }
	                    }
	                  },
	                  [_vm._v(_vm._s(_vm.t("el.table.clearFilter")))]
	                ),
	                _vm._l(_vm.filters, function(filter) {
	                  return _c(
	                    "li",
	                    {
	                      key: filter.value,
	                      staticClass: "el-table-filter__list-item",
	                      class: { "is-active": _vm.isActive(filter) },
	                      attrs: { label: filter.value },
	                      on: {
	                        click: function($event) {
	                          _vm.handleSelect(filter.value)
	                        }
	                      }
	                    },
	                    [_vm._v(_vm._s(filter.text))]
	                  )
	                })
	              ],
	              2
	            )
	          ]
	        )
	  ])
	}
	var filter_panelvue_type_template_id_7f2c919f_staticRenderFns = []
	filter_panelvue_type_template_id_7f2c919f_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
	
	// CONCATENATED MODULE: ./packages/table/src/dropdown.js
	
	var dropdowns = [];
	
	!external_vue_default.a.prototype.$isServer && document.addEventListener('click', function (event) {
	  dropdowns.forEach(function (dropdown) {
	    var target = event.target;
	    if (!dropdown || !dropdown.$el) return;
	    if (target === dropdown.$el || dropdown.$el.contains(target)) {
	      return;
	    }
	    dropdown.handleOutsideClick && dropdown.handleOutsideClick(event);
	  });
	});
	
	/* harmony default export */ var src_dropdown = ({
	  open: function open(instance) {
	    if (instance) {
	      dropdowns.push(instance);
	    }
	  },
	  close: function close(instance) {
	    var index = dropdowns.indexOf(instance);
	    if (index !== -1) {
	      dropdowns.splice(instance, 1);
	    }
	  }
	});
	// EXTERNAL MODULE: external "element-ui/lib/checkbox-group"
	var checkbox_group_ = __webpack_require__(32);
	var checkbox_group_default = /*#__PURE__*/__webpack_require__.n(checkbox_group_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var filter_panelvue_type_script_lang_js_ = ({
	  name: 'ElTableFilterPanel',
	
	  mixins: [vue_popper_default.a, locale_default.a],
	
	  directives: {
	    Clickoutside: clickoutside_default.a
	  },
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElCheckboxGroup: checkbox_group_default.a,
	    ElScrollbar: scrollbar_default.a
	  },
	
	  props: {
	    placement: {
	      type: String,
	      default: 'bottom-end'
	    }
	  },
	
	  methods: {
	    isActive: function isActive(filter) {
	      return filter.value === this.filterValue;
	    },
	    handleOutsideClick: function handleOutsideClick() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.showPopper = false;
	      }, 16);
	    },
	    handleConfirm: function handleConfirm() {
	      this.confirmFilter(this.filteredValue);
	      this.handleOutsideClick();
	    },
	    handleReset: function handleReset() {
	      this.filteredValue = [];
	      this.confirmFilter(this.filteredValue);
	      this.handleOutsideClick();
	    },
	    handleSelect: function handleSelect(filterValue) {
	      this.filterValue = filterValue;
	
	      if (typeof filterValue !== 'undefined' && filterValue !== null) {
	        this.confirmFilter(this.filteredValue);
	      } else {
	        this.confirmFilter([]);
	      }
	
	      this.handleOutsideClick();
	    },
	    confirmFilter: function confirmFilter(filteredValue) {
	      this.table.store.commit('filterChange', {
	        column: this.column,
	        values: filteredValue
	      });
	      this.table.store.updateAllSelected();
	    }
	  },
	
	  data: function data() {
	    return {
	      table: null,
	      cell: null,
	      column: null
	    };
	  },
	
	
	  computed: {
	    filters: function filters() {
	      return this.column && this.column.filters;
	    },
	
	
	    filterValue: {
	      get: function get() {
	        return (this.column.filteredValue || [])[0];
	      },
	      set: function set(value) {
	        if (this.filteredValue) {
	          if (typeof value !== 'undefined' && value !== null) {
	            this.filteredValue.splice(0, 1, value);
	          } else {
	            this.filteredValue.splice(0, 1);
	          }
	        }
	      }
	    },
	
	    filteredValue: {
	      get: function get() {
	        if (this.column) {
	          return this.column.filteredValue || [];
	        }
	        return [];
	      },
	      set: function set(value) {
	        if (this.column) {
	          this.column.filteredValue = value;
	        }
	      }
	    },
	
	    multiple: function multiple() {
	      if (this.column) {
	        return this.column.filterMultiple;
	      }
	      return true;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.popperElm = this.$el;
	    this.referenceElm = this.cell;
	    this.table.bodyWrapper.addEventListener('scroll', function () {
	      _this2.updatePopper();
	    });
	
	    this.$watch('showPopper', function (value) {
	      if (_this2.column) _this2.column.filterOpened = value;
	      if (value) {
	        src_dropdown.open(_this2);
	      } else {
	        src_dropdown.close(_this2);
	      }
	    });
	  },
	
	  watch: {
	    showPopper: function showPopper(val) {
	      if (val === true && parseInt(this.popperJS._popper.style.zIndex, 10) < popup_["PopupManager"].zIndex) {
	        this.popperJS._popper.style.zIndex = popup_["PopupManager"].nextZIndex();
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_filter_panelvue_type_script_lang_js_ = (filter_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var filter_panel_component = normalizeComponent(
	  src_filter_panelvue_type_script_lang_js_,
	  filter_panelvue_type_template_id_7f2c919f_render,
	  filter_panelvue_type_template_id_7f2c919f_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var filter_panel_api; }
	filter_panel_component.options.__file = "packages/table/src/filter-panel.vue"
	/* harmony default export */ var filter_panel = (filter_panel_component.exports);
	// CONCATENATED MODULE: ./packages/table/src/table-header.js
	var table_header_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	
	
	
	var getAllColumns = function getAllColumns(columns) {
	  var result = [];
	  columns.forEach(function (column) {
	    if (column.children) {
	      result.push(column);
	      result.push.apply(result, getAllColumns(column.children));
	    } else {
	      result.push(column);
	    }
	  });
	  return result;
	};
	
	var convertToRows = function convertToRows(originColumns) {
	  var maxLevel = 1;
	  var traverse = function traverse(column, parent) {
	    if (parent) {
	      column.level = parent.level + 1;
	      if (maxLevel < column.level) {
	        maxLevel = column.level;
	      }
	    }
	    if (column.children) {
	      var colSpan = 0;
	      column.children.forEach(function (subColumn) {
	        traverse(subColumn, column);
	        colSpan += subColumn.colSpan;
	      });
	      column.colSpan = colSpan;
	    } else {
	      column.colSpan = 1;
	    }
	  };
	
	  originColumns.forEach(function (column) {
	    column.level = 1;
	    traverse(column);
	  });
	
	  var rows = [];
	  for (var i = 0; i < maxLevel; i++) {
	    rows.push([]);
	  }
	
	  var allColumns = getAllColumns(originColumns);
	
	  allColumns.forEach(function (column) {
	    if (!column.children) {
	      column.rowSpan = maxLevel - column.level + 1;
	    } else {
	      column.rowSpan = 1;
	    }
	    rows[column.level - 1].push(column);
	  });
	
	  return rows;
	};
	
	/* harmony default export */ var table_header = ({
	  name: 'ElTableHeader',
	
	  mixins: [layout_observer],
	
	  render: function render(h) {
	    var _this = this;
	
	    var originColumns = this.store.states.originColumns;
	    var columnRows = convertToRows(originColumns, this.columns);
	    // 是否拥有多级表头
	    var isGroup = columnRows.length > 1;
	    if (isGroup) this.$parent.isGroup = true;
	    return h(
	      'table',
	      {
	        'class': 'el-table__header',
	        attrs: { cellspacing: '0',
	          cellpadding: '0',
	          border: '0' }
	      },
	      [h('colgroup', [this.columns.map(function (column) {
	        return h('col', {
	          attrs: { name: column.id },
	          key: column.id });
	      }), this.hasGutter ? h('col', {
	        attrs: { name: 'gutter' }
	      }) : '']), h(
	        'thead',
	        { 'class': [{ 'is-group': isGroup, 'has-gutter': this.hasGutter }] },
	        [this._l(columnRows, function (columns, rowIndex) {
	          return h(
	            'tr',
	            {
	              style: _this.getHeaderRowStyle(rowIndex),
	              'class': _this.getHeaderRowClass(rowIndex)
	            },
	            [columns.map(function (column, cellIndex) {
	              return h(
	                'th',
	                {
	                  attrs: {
	                    colspan: column.colSpan,
	                    rowspan: column.rowSpan
	                  },
	                  on: {
	                    'mousemove': function mousemove($event) {
	                      return _this.handleMouseMove($event, column);
	                    },
	                    'mouseout': _this.handleMouseOut,
	                    'mousedown': function mousedown($event) {
	                      return _this.handleMouseDown($event, column);
	                    },
	                    'click': function click($event) {
	                      return _this.handleHeaderClick($event, column);
	                    },
	                    'contextmenu': function contextmenu($event) {
	                      return _this.handleHeaderContextMenu($event, column);
	                    }
	                  },
	
	                  style: _this.getHeaderCellStyle(rowIndex, cellIndex, columns, column),
	                  'class': _this.getHeaderCellClass(rowIndex, cellIndex, columns, column),
	                  key: column.id },
	                [h(
	                  'div',
	                  { 'class': ['cell', column.filteredValue && column.filteredValue.length > 0 ? 'highlight' : '', column.labelClassName] },
	                  [column.renderHeader ? column.renderHeader.call(_this._renderProxy, h, { column: column, $index: cellIndex, store: _this.store, _self: _this.$parent.$vnode.context }) : column.label, column.sortable ? h(
	                    'span',
	                    {
	                      'class': 'caret-wrapper',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleSortClick($event, column);
	                        }
	                      }
	                    },
	                    [h('i', { 'class': 'sort-caret ascending',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleSortClick($event, column, 'ascending');
	                        }
	                      }
	                    }), h('i', { 'class': 'sort-caret descending',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleSortClick($event, column, 'descending');
	                        }
	                      }
	                    })]
	                  ) : '', column.filterable ? h(
	                    'span',
	                    {
	                      'class': 'el-table__column-filter-trigger',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleFilterClick($event, column);
	                        }
	                      }
	                    },
	                    [h('i', { 'class': ['el-icon-arrow-down', column.filterOpened ? 'el-icon-arrow-up' : ''] })]
	                  ) : '']
	                )]
	              );
	            }), _this.hasGutter ? h('th', { 'class': 'gutter' }) : '']
	          );
	        })]
	      )]
	    );
	  },
	
	
	  props: {
	    fixed: String,
	    store: {
	      required: true
	    },
	    border: Boolean,
	    defaultSort: {
	      type: Object,
	      default: function _default() {
	        return {
	          prop: '',
	          order: ''
	        };
	      }
	    }
	  },
	
	  components: {
	    ElCheckbox: checkbox_default.a
	  },
	
	  computed: table_header_extends({
	    table: function table() {
	      return this.$parent;
	    },
	    hasGutter: function hasGutter() {
	      return !this.fixed && this.tableLayout.gutterWidth;
	    }
	  }, mapStates({
	    columns: 'columns',
	    isAllSelected: 'isAllSelected',
	    leftFixedLeafCount: 'fixedLeafColumnsLength',
	    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
	    columnsCount: function columnsCount(states) {
	      return states.columns.length;
	    },
	    leftFixedCount: function leftFixedCount(states) {
	      return states.fixedColumns.length;
	    },
	    rightFixedCount: function rightFixedCount(states) {
	      return states.rightFixedColumns.length;
	    }
	  })),
	
	  created: function created() {
	    this.filterPanels = {};
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    // nextTick 是有必要的 https://github.com/ElemeFE/element/pull/11311
	    this.$nextTick(function () {
	      var _defaultSort = _this2.defaultSort,
	          prop = _defaultSort.prop,
	          order = _defaultSort.order;
	
	      var init = true;
	      _this2.store.commit('sort', { prop: prop, order: order, init: init });
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var panels = this.filterPanels;
	    for (var prop in panels) {
	      if (panels.hasOwnProperty(prop) && panels[prop]) {
	        panels[prop].$destroy(true);
	      }
	    }
	  },
	
	
	  methods: {
	    isCellHidden: function isCellHidden(index, columns) {
	      var start = 0;
	      for (var i = 0; i < index; i++) {
	        start += columns[i].colSpan;
	      }
	      var after = start + columns[index].colSpan - 1;
	      if (this.fixed === true || this.fixed === 'left') {
	        return after >= this.leftFixedLeafCount;
	      } else if (this.fixed === 'right') {
	        return start < this.columnsCount - this.rightFixedLeafCount;
	      } else {
	        return after < this.leftFixedLeafCount || start >= this.columnsCount - this.rightFixedLeafCount;
	      }
	    },
	    getHeaderRowStyle: function getHeaderRowStyle(rowIndex) {
	      var headerRowStyle = this.table.headerRowStyle;
	      if (typeof headerRowStyle === 'function') {
	        return headerRowStyle.call(null, { rowIndex: rowIndex });
	      }
	      return headerRowStyle;
	    },
	    getHeaderRowClass: function getHeaderRowClass(rowIndex) {
	      var classes = [];
	
	      var headerRowClassName = this.table.headerRowClassName;
	      if (typeof headerRowClassName === 'string') {
	        classes.push(headerRowClassName);
	      } else if (typeof headerRowClassName === 'function') {
	        classes.push(headerRowClassName.call(null, { rowIndex: rowIndex }));
	      }
	
	      return classes.join(' ');
	    },
	    getHeaderCellStyle: function getHeaderCellStyle(rowIndex, columnIndex, row, column) {
	      var headerCellStyle = this.table.headerCellStyle;
	      if (typeof headerCellStyle === 'function') {
	        return headerCellStyle.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        });
	      }
	      return headerCellStyle;
	    },
	    getHeaderCellClass: function getHeaderCellClass(rowIndex, columnIndex, row, column) {
	      var classes = [column.id, column.order, column.headerAlign, column.className, column.labelClassName];
	
	      if (rowIndex === 0 && this.isCellHidden(columnIndex, row)) {
	        classes.push('is-hidden');
	      }
	
	      if (!column.children) {
	        classes.push('is-leaf');
	      }
	
	      if (column.sortable) {
	        classes.push('is-sortable');
	      }
	
	      var headerCellClassName = this.table.headerCellClassName;
	      if (typeof headerCellClassName === 'string') {
	        classes.push(headerCellClassName);
	      } else if (typeof headerCellClassName === 'function') {
	        classes.push(headerCellClassName.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        }));
	      }
	
	      return classes.join(' ');
	    },
	    toggleAllSelection: function toggleAllSelection(event) {
	      event.stopPropagation();
	      this.store.commit('toggleAllSelection');
	    },
	    handleFilterClick: function handleFilterClick(event, column) {
	      event.stopPropagation();
	      var target = event.target;
	      var cell = target.tagName === 'TH' ? target : target.parentNode;
	      if (Object(dom_["hasClass"])(cell, 'noclick')) return;
	      cell = cell.querySelector('.el-table__column-filter-trigger') || cell;
	      var table = this.$parent;
	
	      var filterPanel = this.filterPanels[column.id];
	
	      if (filterPanel && column.filterOpened) {
	        filterPanel.showPopper = false;
	        return;
	      }
	
	      if (!filterPanel) {
	        filterPanel = new external_vue_default.a(filter_panel);
	        this.filterPanels[column.id] = filterPanel;
	        if (column.filterPlacement) {
	          filterPanel.placement = column.filterPlacement;
	        }
	        filterPanel.table = table;
	        filterPanel.cell = cell;
	        filterPanel.column = column;
	        !this.$isServer && filterPanel.$mount(document.createElement('div'));
	      }
	
	      setTimeout(function () {
	        filterPanel.showPopper = true;
	      }, 16);
	    },
	    handleHeaderClick: function handleHeaderClick(event, column) {
	      if (!column.filters && column.sortable) {
	        this.handleSortClick(event, column);
	      } else if (column.filterable && !column.sortable) {
	        this.handleFilterClick(event, column);
	      }
	
	      this.$parent.$emit('header-click', column, event);
	    },
	    handleHeaderContextMenu: function handleHeaderContextMenu(event, column) {
	      this.$parent.$emit('header-contextmenu', column, event);
	    },
	    handleMouseDown: function handleMouseDown(event, column) {
	      var _this3 = this;
	
	      if (this.$isServer) return;
	      if (column.children && column.children.length > 0) return;
	      /* istanbul ignore if */
	      if (this.draggingColumn && this.border) {
	        this.dragging = true;
	
	        this.$parent.resizeProxyVisible = true;
	
	        var table = this.$parent;
	        var tableEl = table.$el;
	        var tableLeft = tableEl.getBoundingClientRect().left;
	        var columnEl = this.$el.querySelector('th.' + column.id);
	        var columnRect = columnEl.getBoundingClientRect();
	        var minLeft = columnRect.left - tableLeft + 30;
	
	        Object(dom_["addClass"])(columnEl, 'noclick');
	
	        this.dragState = {
	          startMouseLeft: event.clientX,
	          startLeft: columnRect.right - tableLeft,
	          startColumnLeft: columnRect.left - tableLeft,
	          tableLeft: tableLeft
	        };
	
	        var resizeProxy = table.$refs.resizeProxy;
	        resizeProxy.style.left = this.dragState.startLeft + 'px';
	
	        document.onselectstart = function () {
	          return false;
	        };
	        document.ondragstart = function () {
	          return false;
	        };
	
	        var handleMouseMove = function handleMouseMove(event) {
	          var deltaLeft = event.clientX - _this3.dragState.startMouseLeft;
	          var proxyLeft = _this3.dragState.startLeft + deltaLeft;
	
	          resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';
	        };
	
	        var handleMouseUp = function handleMouseUp() {
	          if (_this3.dragging) {
	            var _dragState = _this3.dragState,
	                startColumnLeft = _dragState.startColumnLeft,
	                startLeft = _dragState.startLeft;
	
	            var finalLeft = parseInt(resizeProxy.style.left, 10);
	            var columnWidth = finalLeft - startColumnLeft;
	            column.width = column.realWidth = columnWidth;
	            table.$emit('header-dragend', column.width, startLeft - startColumnLeft, column, event);
	
	            _this3.store.scheduleLayout();
	
	            document.body.style.cursor = '';
	            _this3.dragging = false;
	            _this3.draggingColumn = null;
	            _this3.dragState = {};
	
	            table.resizeProxyVisible = false;
	          }
	
	          document.removeEventListener('mousemove', handleMouseMove);
	          document.removeEventListener('mouseup', handleMouseUp);
	          document.onselectstart = null;
	          document.ondragstart = null;
	
	          setTimeout(function () {
	            Object(dom_["removeClass"])(columnEl, 'noclick');
	          }, 0);
	        };
	
	        document.addEventListener('mousemove', handleMouseMove);
	        document.addEventListener('mouseup', handleMouseUp);
	      }
	    },
	    handleMouseMove: function handleMouseMove(event, column) {
	      if (column.children && column.children.length > 0) return;
	      var target = event.target;
	      while (target && target.tagName !== 'TH') {
	        target = target.parentNode;
	      }
	
	      if (!column || !column.resizable) return;
	
	      if (!this.dragging && this.border) {
	        var rect = target.getBoundingClientRect();
	
	        var bodyStyle = document.body.style;
	        if (rect.width > 12 && rect.right - event.pageX < 8) {
	          bodyStyle.cursor = 'col-resize';
	          if (Object(dom_["hasClass"])(target, 'is-sortable')) {
	            target.style.cursor = 'col-resize';
	          }
	          this.draggingColumn = column;
	        } else if (!this.dragging) {
	          bodyStyle.cursor = '';
	          if (Object(dom_["hasClass"])(target, 'is-sortable')) {
	            target.style.cursor = 'pointer';
	          }
	          this.draggingColumn = null;
	        }
	      }
	    },
	    handleMouseOut: function handleMouseOut() {
	      if (this.$isServer) return;
	      document.body.style.cursor = '';
	    },
	    toggleOrder: function toggleOrder(_ref) {
	      var order = _ref.order,
	          sortOrders = _ref.sortOrders;
	
	      if (order === '') return sortOrders[0];
	      var index = sortOrders.indexOf(order || null);
	      return sortOrders[index > sortOrders.length - 2 ? 0 : index + 1];
	    },
	    handleSortClick: function handleSortClick(event, column, givenOrder) {
	      event.stopPropagation();
	      var order = column.order === givenOrder ? null : givenOrder || this.toggleOrder(column);
	
	      var target = event.target;
	      while (target && target.tagName !== 'TH') {
	        target = target.parentNode;
	      }
	
	      if (target && target.tagName === 'TH') {
	        if (Object(dom_["hasClass"])(target, 'noclick')) {
	          Object(dom_["removeClass"])(target, 'noclick');
	          return;
	        }
	      }
	
	      if (!column.sortable) return;
	
	      var states = this.store.states;
	      var sortProp = states.sortProp;
	      var sortOrder = void 0;
	      var sortingColumn = states.sortingColumn;
	
	      if (sortingColumn !== column || sortingColumn === column && sortingColumn.order === null) {
	        if (sortingColumn) {
	          sortingColumn.order = null;
	        }
	        states.sortingColumn = column;
	        sortProp = column.property;
	      }
	
	      if (!order) {
	        sortOrder = column.order = null;
	      } else {
	        sortOrder = column.order = order;
	      }
	
	      states.sortProp = sortProp;
	      states.sortOrder = sortOrder;
	
	      this.store.commit('changeSortCondition');
	    }
	  },
	
	  data: function data() {
	    return {
	      draggingColumn: null,
	      dragging: false,
	      dragState: {}
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/table-footer.js
	var table_footer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	/* harmony default export */ var table_footer = ({
	  name: 'ElTableFooter',
	
	  mixins: [layout_observer],
	
	  render: function render(h) {
	    var _this = this;
	
	    var sums = [];
	    if (this.summaryMethod) {
	      sums = this.summaryMethod({ columns: this.columns, data: this.store.states.data });
	    } else {
	      this.columns.forEach(function (column, index) {
	        if (index === 0) {
	          sums[index] = _this.sumText;
	          return;
	        }
	        var values = _this.store.states.data.map(function (item) {
	          return Number(item[column.property]);
	        });
	        var precisions = [];
	        var notNumber = true;
	        values.forEach(function (value) {
	          if (!isNaN(value)) {
	            notNumber = false;
	            var decimal = ('' + value).split('.')[1];
	            precisions.push(decimal ? decimal.length : 0);
	          }
	        });
	        var precision = Math.max.apply(null, precisions);
	        if (!notNumber) {
	          sums[index] = values.reduce(function (prev, curr) {
	            var value = Number(curr);
	            if (!isNaN(value)) {
	              return parseFloat((prev + curr).toFixed(Math.min(precision, 20)));
	            } else {
	              return prev;
	            }
	          }, 0);
	        } else {
	          sums[index] = '';
	        }
	      });
	    }
	
	    return h(
	      'table',
	      {
	        'class': 'el-table__footer',
	        attrs: { cellspacing: '0',
	          cellpadding: '0',
	          border: '0' }
	      },
	      [h('colgroup', [this.columns.map(function (column) {
	        return h('col', {
	          attrs: { name: column.id },
	          key: column.id });
	      }), this.hasGutter ? h('col', {
	        attrs: { name: 'gutter' }
	      }) : '']), h(
	        'tbody',
	        { 'class': [{ 'has-gutter': this.hasGutter }] },
	        [h('tr', [this.columns.map(function (column, cellIndex) {
	          return h(
	            'td',
	            {
	              key: cellIndex,
	              attrs: { colspan: column.colSpan,
	                rowspan: column.rowSpan
	              },
	              'class': _this.getRowClasses(column, cellIndex) },
	            [h(
	              'div',
	              { 'class': ['cell', column.labelClassName] },
	              [sums[cellIndex]]
	            )]
	          );
	        }), this.hasGutter ? h('th', { 'class': 'gutter' }) : ''])]
	      )]
	    );
	  },
	
	
	  props: {
	    fixed: String,
	    store: {
	      required: true
	    },
	    summaryMethod: Function,
	    sumText: String,
	    border: Boolean,
	    defaultSort: {
	      type: Object,
	      default: function _default() {
	        return {
	          prop: '',
	          order: ''
	        };
	      }
	    }
	  },
	
	  computed: table_footer_extends({
	    table: function table() {
	      return this.$parent;
	    },
	    hasGutter: function hasGutter() {
	      return !this.fixed && this.tableLayout.gutterWidth;
	    }
	  }, mapStates({
	    columns: 'columns',
	    isAllSelected: 'isAllSelected',
	    leftFixedLeafCount: 'fixedLeafColumnsLength',
	    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
	    columnsCount: function columnsCount(states) {
	      return states.columns.length;
	    },
	    leftFixedCount: function leftFixedCount(states) {
	      return states.fixedColumns.length;
	    },
	    rightFixedCount: function rightFixedCount(states) {
	      return states.rightFixedColumns.length;
	    }
	  })),
	
	  methods: {
	    isCellHidden: function isCellHidden(index, columns, column) {
	      if (this.fixed === true || this.fixed === 'left') {
	        return index >= this.leftFixedLeafCount;
	      } else if (this.fixed === 'right') {
	        var before = 0;
	        for (var i = 0; i < index; i++) {
	          before += columns[i].colSpan;
	        }
	        return before < this.columnsCount - this.rightFixedLeafCount;
	      } else if (!this.fixed && column.fixed) {
	        // hide cell when footer instance is not fixed and column is fixed
	        return true;
	      } else {
	        return index < this.leftFixedCount || index >= this.columnsCount - this.rightFixedCount;
	      }
	    },
	    getRowClasses: function getRowClasses(column, cellIndex) {
	      var classes = [column.id, column.align, column.labelClassName];
	      if (column.className) {
	        classes.push(column.className);
	      }
	      if (this.isCellHidden(cellIndex, this.columns, column)) {
	        classes.push('is-hidden');
	      }
	      if (!column.children) {
	        classes.push('is-leaf');
	      }
	      return classes;
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=script&lang=js&
	var tablevue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var tableIdSeed = 1;
	
	/* harmony default export */ var tablevue_type_script_lang_js_ = ({
	  name: 'ElTable',
	
	  mixins: [locale_default.a, migrating_default.a],
	
	  directives: {
	    Mousewheel: directives_mousewheel
	  },
	
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    size: String,
	
	    width: [String, Number],
	
	    height: [String, Number],
	
	    maxHeight: [String, Number],
	
	    fit: {
	      type: Boolean,
	      default: true
	    },
	
	    stripe: Boolean,
	
	    border: Boolean,
	
	    rowKey: [String, Function],
	
	    context: {},
	
	    showHeader: {
	      type: Boolean,
	      default: true
	    },
	
	    showSummary: Boolean,
	
	    sumText: String,
	
	    summaryMethod: Function,
	
	    rowClassName: [String, Function],
	
	    rowStyle: [Object, Function],
	
	    cellClassName: [String, Function],
	
	    cellStyle: [Object, Function],
	
	    headerRowClassName: [String, Function],
	
	    headerRowStyle: [Object, Function],
	
	    headerCellClassName: [String, Function],
	
	    headerCellStyle: [Object, Function],
	
	    highlightCurrentRow: Boolean,
	
	    currentRowKey: [String, Number],
	
	    emptyText: String,
	
	    expandRowKeys: Array,
	
	    defaultExpandAll: Boolean,
	
	    defaultSort: Object,
	
	    tooltipEffect: String,
	
	    spanMethod: Function,
	
	    selectOnIndeterminate: {
	      type: Boolean,
	      default: true
	    },
	
	    indent: {
	      type: Number,
	      default: 16
	    },
	
	    treeProps: {
	      type: Object,
	      default: function _default() {
	        return {
	          hasChildren: 'hasChildren',
	          children: 'children'
	        };
	      }
	    },
	
	    lazy: Boolean,
	
	    load: Function
	  },
	
	  components: {
	    TableHeader: table_header,
	    TableFooter: table_footer,
	    TableBody: table_body,
	    ElCheckbox: checkbox_default.a
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        events: {
	          expand: 'expand is renamed to expand-change'
	        }
	      };
	    },
	    setCurrentRow: function setCurrentRow(row) {
	      this.store.commit('setCurrentRow', row);
	    },
	    toggleRowSelection: function toggleRowSelection(row, selected) {
	      this.store.toggleRowSelection(row, selected, false);
	      this.store.updateAllSelected();
	    },
	    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
	      this.store.toggleRowExpansionAdapter(row, expanded);
	    },
	    clearSelection: function clearSelection() {
	      this.store.clearSelection();
	    },
	    clearFilter: function clearFilter(columnKeys) {
	      this.store.clearFilter(columnKeys);
	    },
	    clearSort: function clearSort() {
	      this.store.clearSort();
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      this.store.commit('setHoverRow', null);
	      if (this.hoverState) this.hoverState = null;
	    },
	    updateScrollY: function updateScrollY() {
	      var changed = this.layout.updateScrollY();
	      if (changed) {
	        this.layout.notifyObservers('scrollable');
	        this.layout.updateColumnsWidth();
	      }
	    },
	    handleFixedMousewheel: function handleFixedMousewheel(event, data) {
	      var bodyWrapper = this.bodyWrapper;
	      if (Math.abs(data.spinY) > 0) {
	        var currentScrollTop = bodyWrapper.scrollTop;
	        if (data.pixelY < 0 && currentScrollTop !== 0) {
	          event.preventDefault();
	        }
	        if (data.pixelY > 0 && bodyWrapper.scrollHeight - bodyWrapper.clientHeight > currentScrollTop) {
	          event.preventDefault();
	        }
	        bodyWrapper.scrollTop += Math.ceil(data.pixelY / 5);
	      } else {
	        bodyWrapper.scrollLeft += Math.ceil(data.pixelX / 5);
	      }
	    },
	    handleHeaderFooterMousewheel: function handleHeaderFooterMousewheel(event, data) {
	      var pixelX = data.pixelX,
	          pixelY = data.pixelY;
	
	      if (Math.abs(pixelX) >= Math.abs(pixelY)) {
	        this.bodyWrapper.scrollLeft += data.pixelX / 5;
	      }
	    },
	
	
	    // TODO 使用 CSS transform
	    syncPostion: Object(external_throttle_debounce_["throttle"])(20, function () {
	      var _bodyWrapper = this.bodyWrapper,
	          scrollLeft = _bodyWrapper.scrollLeft,
	          scrollTop = _bodyWrapper.scrollTop,
	          offsetWidth = _bodyWrapper.offsetWidth,
	          scrollWidth = _bodyWrapper.scrollWidth;
	      var _$refs = this.$refs,
	          headerWrapper = _$refs.headerWrapper,
	          footerWrapper = _$refs.footerWrapper,
	          fixedBodyWrapper = _$refs.fixedBodyWrapper,
	          rightFixedBodyWrapper = _$refs.rightFixedBodyWrapper;
	
	      if (headerWrapper) headerWrapper.scrollLeft = scrollLeft;
	      if (footerWrapper) footerWrapper.scrollLeft = scrollLeft;
	      if (fixedBodyWrapper) fixedBodyWrapper.scrollTop = scrollTop;
	      if (rightFixedBodyWrapper) rightFixedBodyWrapper.scrollTop = scrollTop;
	      var maxScrollLeftPosition = scrollWidth - offsetWidth - 1;
	      if (scrollLeft >= maxScrollLeftPosition) {
	        this.scrollPosition = 'right';
	      } else if (scrollLeft === 0) {
	        this.scrollPosition = 'left';
	      } else {
	        this.scrollPosition = 'middle';
	      }
	    }),
	
	    bindEvents: function bindEvents() {
	      this.bodyWrapper.addEventListener('scroll', this.syncPostion, { passive: true });
	      if (this.fit) {
	        Object(resize_event_["addResizeListener"])(this.$el, this.resizeListener);
	      }
	    },
	    unbindEvents: function unbindEvents() {
	      this.bodyWrapper.removeEventListener('scroll', this.syncPostion, { passive: true });
	      if (this.fit) {
	        Object(resize_event_["removeResizeListener"])(this.$el, this.resizeListener);
	      }
	    },
	    resizeListener: function resizeListener() {
	      if (!this.$ready) return;
	      var shouldUpdateLayout = false;
	      var el = this.$el;
	      var _resizeState = this.resizeState,
	          oldWidth = _resizeState.width,
	          oldHeight = _resizeState.height;
	
	
	      var width = el.offsetWidth;
	      if (oldWidth !== width) {
	        shouldUpdateLayout = true;
	      }
	
	      var height = el.offsetHeight;
	      if ((this.height || this.shouldUpdateHeight) && oldHeight !== height) {
	        shouldUpdateLayout = true;
	      }
	
	      if (shouldUpdateLayout) {
	        this.resizeState.width = width;
	        this.resizeState.height = height;
	        this.doLayout();
	      }
	    },
	    doLayout: function doLayout() {
	      if (this.shouldUpdateHeight) {
	        this.layout.updateElsHeight();
	      }
	      this.layout.updateColumnsWidth();
	    },
	    sort: function sort(prop, order) {
	      this.store.commit('sort', { prop: prop, order: order });
	    },
	    toggleAllSelection: function toggleAllSelection() {
	      this.store.commit('toggleAllSelection');
	    }
	  },
	
	  computed: tablevue_type_script_lang_js_extends({
	    tableSize: function tableSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    },
	    bodyWrapper: function bodyWrapper() {
	      return this.$refs.bodyWrapper;
	    },
	    shouldUpdateHeight: function shouldUpdateHeight() {
	      return this.height || this.maxHeight || this.fixedColumns.length > 0 || this.rightFixedColumns.length > 0;
	    },
	    bodyWidth: function bodyWidth() {
	      var _layout = this.layout,
	          bodyWidth = _layout.bodyWidth,
	          scrollY = _layout.scrollY,
	          gutterWidth = _layout.gutterWidth;
	
	      return bodyWidth ? bodyWidth - (scrollY ? gutterWidth : 0) + 'px' : '';
	    },
	    bodyHeight: function bodyHeight() {
	      var _layout2 = this.layout,
	          _layout2$headerHeight = _layout2.headerHeight,
	          headerHeight = _layout2$headerHeight === undefined ? 0 : _layout2$headerHeight,
	          bodyHeight = _layout2.bodyHeight,
	          _layout2$footerHeight = _layout2.footerHeight,
	          footerHeight = _layout2$footerHeight === undefined ? 0 : _layout2$footerHeight;
	
	      if (this.height) {
	        return {
	          height: bodyHeight ? bodyHeight + 'px' : ''
	        };
	      } else if (this.maxHeight) {
	        var maxHeight = parseHeight(this.maxHeight);
	        if (typeof maxHeight === 'number') {
	          return {
	            'max-height': maxHeight - footerHeight - (this.showHeader ? headerHeight : 0) + 'px'
	          };
	        }
	      }
	      return {};
	    },
	    fixedBodyHeight: function fixedBodyHeight() {
	      if (this.height) {
	        return {
	          height: this.layout.fixedBodyHeight ? this.layout.fixedBodyHeight + 'px' : ''
	        };
	      } else if (this.maxHeight) {
	        var maxHeight = parseHeight(this.maxHeight);
	        if (typeof maxHeight === 'number') {
	          maxHeight = this.layout.scrollX ? maxHeight - this.layout.gutterWidth : maxHeight;
	          if (this.showHeader) {
	            maxHeight -= this.layout.headerHeight;
	          }
	          maxHeight -= this.layout.footerHeight;
	          return {
	            'max-height': maxHeight + 'px'
	          };
	        }
	      }
	      return {};
	    },
	    fixedHeight: function fixedHeight() {
	      if (this.maxHeight) {
	        if (this.showSummary) {
	          return {
	            bottom: 0
	          };
	        }
	        return {
	          bottom: this.layout.scrollX && this.data.length ? this.layout.gutterWidth + 'px' : ''
	        };
	      } else {
	        if (this.showSummary) {
	          return {
	            height: this.layout.tableHeight ? this.layout.tableHeight + 'px' : ''
	          };
	        }
	        return {
	          height: this.layout.viewportHeight ? this.layout.viewportHeight + 'px' : ''
	        };
	      }
	    },
	    emptyBlockStyle: function emptyBlockStyle() {
	      if (this.data && this.data.length) return null;
	      var height = '100%';
	      if (this.layout.appendHeight) {
	        height = 'calc(100% - ' + this.layout.appendHeight + 'px)';
	      }
	      return {
	        width: this.bodyWidth,
	        height: height
	      };
	    }
	  }, mapStates({
	    selection: 'selection',
	    columns: 'columns',
	    tableData: 'data',
	    fixedColumns: 'fixedColumns',
	    rightFixedColumns: 'rightFixedColumns'
	  })),
	
	  watch: {
	    height: {
	      immediate: true,
	      handler: function handler(value) {
	        this.layout.setHeight(value);
	      }
	    },
	
	    maxHeight: {
	      immediate: true,
	      handler: function handler(value) {
	        this.layout.setMaxHeight(value);
	      }
	    },
	
	    currentRowKey: {
	      immediate: true,
	      handler: function handler(value) {
	        if (!this.rowKey) return;
	        this.store.setCurrentRowKey(value);
	      }
	    },
	
	    data: {
	      immediate: true,
	      handler: function handler(value) {
	        this.store.commit('setData', value);
	      }
	    },
	
	    expandRowKeys: {
	      immediate: true,
	      handler: function handler(newVal) {
	        if (newVal) {
	          this.store.setExpandRowKeysAdapter(newVal);
	        }
	      }
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.tableId = 'el-table_' + tableIdSeed++;
	    this.debouncedUpdateLayout = Object(external_throttle_debounce_["debounce"])(50, function () {
	      return _this.doLayout();
	    });
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.bindEvents();
	    this.store.updateColumns();
	    this.doLayout();
	
	    this.resizeState = {
	      width: this.$el.offsetWidth,
	      height: this.$el.offsetHeight
	    };
	
	    // init filters
	    this.store.states.columns.forEach(function (column) {
	      if (column.filteredValue && column.filteredValue.length) {
	        _this2.store.commit('filterChange', {
	          column: column,
	          values: column.filteredValue,
	          silent: true
	        });
	      }
	    });
	
	    this.$ready = true;
	  },
	  destroyed: function destroyed() {
	    this.unbindEvents();
	  },
	  data: function data() {
	    var _treeProps = this.treeProps,
	        _treeProps$hasChildre = _treeProps.hasChildren,
	        hasChildren = _treeProps$hasChildre === undefined ? 'hasChildren' : _treeProps$hasChildre,
	        _treeProps$children = _treeProps.children,
	        children = _treeProps$children === undefined ? 'children' : _treeProps$children;
	
	    this.store = createStore(this, {
	      rowKey: this.rowKey,
	      defaultExpandAll: this.defaultExpandAll,
	      selectOnIndeterminate: this.selectOnIndeterminate,
	      // TreeTable 的相关配置
	      indent: this.indent,
	      lazy: this.lazy,
	      lazyColumnIdentifier: hasChildren,
	      childrenColumnName: children
	    });
	    var layout = new table_layout({
	      store: this.store,
	      table: this,
	      fit: this.fit,
	      showHeader: this.showHeader
	    });
	    return {
	      layout: layout,
	      isHidden: false,
	      renderExpanded: null,
	      resizeProxyVisible: false,
	      resizeState: {
	        width: null,
	        height: null
	      },
	      // 是否拥有多级表头
	      isGroup: false,
	      scrollPosition: 'left'
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tablevue_type_script_lang_js_ = (tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/table/src/table.vue
	
	
	
	
	
	/* normalize component */
	
	var table_component = normalizeComponent(
	  src_tablevue_type_script_lang_js_,
	  tablevue_type_template_id_493fe34e_render,
	  tablevue_type_template_id_493fe34e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var table_api; }
	table_component.options.__file = "packages/table/src/table.vue"
	/* harmony default export */ var src_table = (table_component.exports);
	// CONCATENATED MODULE: ./packages/table/index.js
	
	
	/* istanbul ignore next */
	src_table.install = function (Vue) {
	  Vue.component(src_table.name, src_table);
	};
	
	/* harmony default export */ var packages_table = (src_table);
	// CONCATENATED MODULE: ./packages/table/src/config.js
	
	
	var cellStarts = {
	  default: {
	    order: ''
	  },
	  selection: {
	    width: 48,
	    minWidth: 48,
	    realWidth: 48,
	    order: '',
	    className: 'el-table-column--selection'
	  },
	  expand: {
	    width: 48,
	    minWidth: 48,
	    realWidth: 48,
	    order: ''
	  },
	  index: {
	    width: 48,
	    minWidth: 48,
	    realWidth: 48,
	    order: ''
	  }
	};
	
	// 这些选项不应该被覆盖
	var cellForced = {
	  selection: {
	    renderHeader: function renderHeader(h, _ref) {
	      var store = _ref.store;
	
	      return h('el-checkbox', {
	        attrs: {
	          disabled: store.states.data && store.states.data.length === 0,
	          indeterminate: store.states.selection.length > 0 && !this.isAllSelected,
	
	          value: this.isAllSelected },
	        nativeOn: {
	          'click': this.toggleAllSelection
	        }
	      });
	    },
	    renderCell: function renderCell(h, _ref2) {
	      var row = _ref2.row,
	          column = _ref2.column,
	          store = _ref2.store,
	          $index = _ref2.$index;
	
	      return h('el-checkbox', {
	        nativeOn: {
	          'click': function click(event) {
	            return event.stopPropagation();
	          }
	        },
	        attrs: {
	          value: store.isSelected(row),
	          disabled: column.selectable ? !column.selectable.call(null, row, $index) : false
	        },
	        on: {
	          'input': function input() {
	            store.commit('rowSelectedChanged', row);
	          }
	        }
	      });
	    },
	    sortable: false,
	    resizable: false
	  },
	  index: {
	    renderHeader: function renderHeader(h, _ref3) {
	      var column = _ref3.column;
	
	      return column.label || '#';
	    },
	    renderCell: function renderCell(h, _ref4) {
	      var $index = _ref4.$index,
	          column = _ref4.column;
	
	      var i = $index + 1;
	      var index = column.index;
	
	      if (typeof index === 'number') {
	        i = $index + index;
	      } else if (typeof index === 'function') {
	        i = index($index);
	      }
	
	      return h('div', [i]);
	    },
	    sortable: false
	  },
	  expand: {
	    renderHeader: function renderHeader(h, _ref5) {
	      var column = _ref5.column;
	
	      return column.label || '';
	    },
	    renderCell: function renderCell(h, _ref6) {
	      var row = _ref6.row,
	          store = _ref6.store;
	
	      var classes = ['el-table__expand-icon'];
	      if (store.states.expandRows.indexOf(row) > -1) {
	        classes.push('el-table__expand-icon--expanded');
	      }
	      var callback = function callback(e) {
	        e.stopPropagation();
	        store.toggleRowExpansion(row);
	      };
	      return h(
	        'div',
	        { 'class': classes,
	          on: {
	            'click': callback
	          }
	        },
	        [h('i', { 'class': 'el-icon el-icon-arrow-right' })]
	      );
	    },
	    sortable: false,
	    resizable: false,
	    className: 'el-table__expand-column'
	  }
	};
	
	function defaultRenderCell(h, _ref7) {
	  var row = _ref7.row,
	      column = _ref7.column,
	      $index = _ref7.$index;
	
	  var property = column.property;
	  var value = property && Object(util_["getPropByPath"])(row, property).v;
	  if (column && column.formatter) {
	    return column.formatter(row, column, value, $index);
	  }
	  return value;
	}
	
	function treeCellPrefix(h, _ref8) {
	  var row = _ref8.row,
	      treeNode = _ref8.treeNode,
	      store = _ref8.store;
	
	  if (!treeNode) return null;
	  var ele = [];
	  var callback = function callback(e) {
	    e.stopPropagation();
	    store.loadOrToggle(row);
	  };
	  if (treeNode.indent) {
	    ele.push(h('span', { 'class': 'el-table__indent', style: { 'padding-left': treeNode.indent + 'px' } }));
	  }
	  if (typeof treeNode.expanded === 'boolean' && !treeNode.noLazyChildren) {
	    var expandClasses = ['el-table__expand-icon', treeNode.expanded ? 'el-table__expand-icon--expanded' : ''];
	    var iconClasses = ['el-icon-arrow-right'];
	    if (treeNode.loading) {
	      iconClasses = ['el-icon-loading'];
	    }
	    ele.push(h(
	      'div',
	      { 'class': expandClasses,
	        on: {
	          'click': callback
	        }
	      },
	      [h('i', { 'class': iconClasses })]
	    ));
	  } else {
	    ele.push(h('span', { 'class': 'el-table__placeholder' }));
	  }
	  return ele;
	}
	// CONCATENATED MODULE: ./packages/table/src/table-column.js
	var table_column_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	var columnIdSeed = 1;
	
	/* harmony default export */ var table_column = ({
	  name: 'ElTableColumn',
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    label: String,
	    className: String,
	    labelClassName: String,
	    property: String,
	    prop: String,
	    width: {},
	    minWidth: {},
	    renderHeader: Function,
	    sortable: {
	      type: [Boolean, String],
	      default: false
	    },
	    sortMethod: Function,
	    sortBy: [String, Function, Array],
	    resizable: {
	      type: Boolean,
	      default: true
	    },
	    columnKey: String,
	    align: String,
	    headerAlign: String,
	    showTooltipWhenOverflow: Boolean,
	    showOverflowTooltip: Boolean,
	    fixed: [Boolean, String],
	    formatter: Function,
	    selectable: Function,
	    reserveSelection: Boolean,
	    filterMethod: Function,
	    filteredValue: Array,
	    filters: Array,
	    filterPlacement: String,
	    filterMultiple: {
	      type: Boolean,
	      default: true
	    },
	    index: [Number, Function],
	    sortOrders: {
	      type: Array,
	      default: function _default() {
	        return ['ascending', 'descending', null];
	      },
	      validator: function validator(val) {
	        return val.every(function (order) {
	          return ['ascending', 'descending', null].indexOf(order) > -1;
	        });
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      isSubColumn: false,
	      columns: []
	    };
	  },
	
	
	  computed: {
	    owner: function owner() {
	      var parent = this.$parent;
	      while (parent && !parent.tableId) {
	        parent = parent.$parent;
	      }
	      return parent;
	    },
	    columnOrTableParent: function columnOrTableParent() {
	      var parent = this.$parent;
	      while (parent && !parent.tableId && !parent.columnId) {
	        parent = parent.$parent;
	      }
	      return parent;
	    },
	    realWidth: function realWidth() {
	      return parseWidth(this.width);
	    },
	    realMinWidth: function realMinWidth() {
	      return parseMinWidth(this.minWidth);
	    },
	    realAlign: function realAlign() {
	      return this.align ? 'is-' + this.align : null;
	    },
	    realHeaderAlign: function realHeaderAlign() {
	      return this.headerAlign ? 'is-' + this.headerAlign : this.realAlign;
	    }
	  },
	
	  methods: {
	    getPropsData: function getPropsData() {
	      var _this = this;
	
	      for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
	        props[_key] = arguments[_key];
	      }
	
	      return props.reduce(function (prev, cur) {
	        if (Array.isArray(cur)) {
	          cur.forEach(function (key) {
	            prev[key] = _this[key];
	          });
	        }
	        return prev;
	      }, {});
	    },
	    getColumnElIndex: function getColumnElIndex(children, child) {
	      return [].indexOf.call(children, child);
	    },
	    setColumnWidth: function setColumnWidth(column) {
	      if (this.realWidth) {
	        column.width = this.realWidth;
	      }
	      if (this.realMinWidth) {
	        column.minWidth = this.realMinWidth;
	      }
	      if (!column.minWidth) {
	        column.minWidth = 80;
	      }
	      column.realWidth = column.width === undefined ? column.minWidth : column.width;
	      return column;
	    },
	    setColumnForcedProps: function setColumnForcedProps(column) {
	      // 对于特定类型的 column，某些属性不允许设置
	      var type = column.type;
	      var source = cellForced[type] || {};
	      Object.keys(source).forEach(function (prop) {
	        var value = source[prop];
	        if (value !== undefined) {
	          column[prop] = prop === 'className' ? column[prop] + ' ' + value : value;
	        }
	      });
	      return column;
	    },
	    setColumnRenders: function setColumnRenders(column) {
	      var _this2 = this;
	
	      var h = this.$createElement;
	
	      // renderHeader 属性不推荐使用。
	      if (this.renderHeader) {
	        console.warn('[Element Warn][TableColumn]Comparing to render-header, scoped-slot header is easier to use. We recommend users to use scoped-slot header.');
	      } else if (column.type !== 'selection') {
	        column.renderHeader = function (h, scope) {
	          var renderHeader = _this2.$scopedSlots.header;
	          return renderHeader ? renderHeader(scope) : column.label;
	        };
	      }
	
	      var originRenderCell = column.renderCell;
	      // TODO: 这里的实现调整
	      if (column.type === 'expand') {
	        // 对于展开行，renderCell 不允许配置的。在上一步中已经设置过，这里需要简单封装一下。
	        column.renderCell = function (h, data) {
	          return h(
	            'div',
	            { 'class': 'cell' },
	            [originRenderCell(h, data)]
	          );
	        };
	        this.owner.renderExpanded = function (h, data) {
	          return _this2.$scopedSlots.default ? _this2.$scopedSlots.default(data) : _this2.$slots.default;
	        };
	      } else {
	        originRenderCell = originRenderCell || defaultRenderCell;
	        // 对 renderCell 进行包装
	        column.renderCell = function (h, data) {
	          var children = null;
	          if (_this2.$scopedSlots.default) {
	            children = _this2.$scopedSlots.default(data);
	          } else {
	            children = originRenderCell(h, data);
	          }
	          var prefix = treeCellPrefix(h, data);
	          var props = {
	            class: 'cell',
	            style: {}
	          };
	          if (column.showOverflowTooltip) {
	            props.class += ' el-tooltip';
	            props.style = { width: (data.column.realWidth || data.column.width) - 1 + 'px' };
	          }
	          return h(
	            'div',
	            props,
	            [prefix, children]
	          );
	        };
	      }
	      return column;
	    },
	    registerNormalWatchers: function registerNormalWatchers() {
	      var _this3 = this;
	
	      var props = ['label', 'property', 'filters', 'filterMultiple', 'sortable', 'index', 'formatter', 'className', 'labelClassName', 'showOverflowTooltip'];
	      // 一些属性具有别名
	      var aliases = {
	        prop: 'property',
	        realAlign: 'align',
	        realHeaderAlign: 'headerAlign',
	        realWidth: 'width'
	      };
	      var allAliases = props.reduce(function (prev, cur) {
	        prev[cur] = cur;
	        return prev;
	      }, aliases);
	
	      Object.keys(allAliases).forEach(function (key) {
	        var columnKey = aliases[key];
	
	        _this3.$watch(key, function (newVal) {
	          _this3.columnConfig[columnKey] = newVal;
	        });
	      });
	    },
	    registerComplexWatchers: function registerComplexWatchers() {
	      var _this4 = this;
	
	      var props = ['fixed'];
	      var aliases = {
	        realWidth: 'width',
	        realMinWidth: 'minWidth'
	      };
	      var allAliases = props.reduce(function (prev, cur) {
	        prev[cur] = cur;
	        return prev;
	      }, aliases);
	
	      Object.keys(allAliases).forEach(function (key) {
	        var columnKey = aliases[key];
	
	        _this4.$watch(key, function (newVal) {
	          _this4.columnConfig[columnKey] = newVal;
	          var updateColumns = columnKey === 'fixed';
	          _this4.owner.store.scheduleLayout(updateColumns);
	        });
	      });
	    }
	  },
	
	  components: {
	    ElCheckbox: checkbox_default.a
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.row = {};
	    this.column = {};
	    this.$index = 0;
	    this.columnId = '';
	  },
	  created: function created() {
	    var parent = this.columnOrTableParent;
	    this.isSubColumn = this.owner !== parent;
	    this.columnId = (parent.tableId || parent.columnId) + '_column_' + columnIdSeed++;
	
	    var type = this.type || 'default';
	    var sortable = this.sortable === '' ? true : this.sortable;
	    var defaults = table_column_extends({}, cellStarts[type], {
	      id: this.columnId,
	      type: type,
	      property: this.prop || this.property,
	      align: this.realAlign,
	      headerAlign: this.realHeaderAlign,
	      showOverflowTooltip: this.showOverflowTooltip || this.showTooltipWhenOverflow,
	      // filter 相关属性
	      filterable: this.filters || this.filterMethod,
	      filteredValue: [],
	      filterPlacement: '',
	      isColumnGroup: false,
	      filterOpened: false,
	      // sort 相关属性
	      sortable: sortable,
	      // index 列
	      index: this.index
	    });
	
	    var basicProps = ['columnKey', 'label', 'className', 'labelClassName', 'type', 'renderHeader', 'formatter', 'fixed', 'resizable'];
	    var sortProps = ['sortMethod', 'sortBy', 'sortOrders'];
	    var selectProps = ['selectable', 'reserveSelection'];
	    var filterProps = ['filterMethod', 'filters', 'filterMultiple', 'filterOpened', 'filteredValue', 'filterPlacement'];
	
	    var column = this.getPropsData(basicProps, sortProps, selectProps, filterProps);
	    column = mergeOptions(defaults, column);
	
	    // 注意 compose 中函数执行的顺序是从右到左
	    var chains = compose(this.setColumnRenders, this.setColumnWidth, this.setColumnForcedProps);
	    column = chains(column);
	
	    this.columnConfig = column;
	
	    // 注册 watcher
	    this.registerNormalWatchers();
	    this.registerComplexWatchers();
	  },
	  mounted: function mounted() {
	    var owner = this.owner;
	    var parent = this.columnOrTableParent;
	    var children = this.isSubColumn ? parent.$el.children : parent.$refs.hiddenColumns.children;
	    var columnIndex = this.getColumnElIndex(children, this.$el);
	
	    owner.store.commit('insertColumn', this.columnConfig, columnIndex, this.isSubColumn ? parent.columnConfig : null);
	  },
	  destroyed: function destroyed() {
	    if (!this.$parent) return;
	    var parent = this.$parent;
	    this.owner.store.commit('removeColumn', this.columnConfig, this.isSubColumn ? parent.columnConfig : null);
	  },
	  render: function render(h) {
	    // slots 也要渲染，需要计算合并表头
	    return h('div', this.$slots.default);
	  }
	});
	// CONCATENATED MODULE: ./packages/table-column/index.js
	
	
	/* istanbul ignore next */
	table_column.install = function (Vue) {
	  Vue.component(table_column.name, table_column);
	};
	
	/* harmony default export */ var packages_table_column = (table_column);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
	var pickervue_type_template_id_79ae069f_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return !_vm.ranged
	    ? _c(
	        "el-input",
	        _vm._b(
	          {
	            directives: [
	              {
	                name: "clickoutside",
	                rawName: "v-clickoutside",
	                value: _vm.handleClose,
	                expression: "handleClose"
	              }
	            ],
	            ref: "reference",
	            staticClass: "el-date-editor",
	            class: "el-date-editor--" + _vm.type,
	            attrs: {
	              readonly:
	                !_vm.editable ||
	                _vm.readonly ||
	                _vm.type === "dates" ||
	                _vm.type === "week",
	              disabled: _vm.pickerDisabled,
	              size: _vm.pickerSize,
	              name: _vm.name,
	              placeholder: _vm.placeholder,
	              value: _vm.displayValue,
	              validateEvent: false
	            },
	            on: {
	              focus: _vm.handleFocus,
	              input: function(value) {
	                return (_vm.userInput = value)
	              },
	              change: _vm.handleChange
	            },
	            nativeOn: {
	              keydown: function($event) {
	                return _vm.handleKeydown($event)
	              },
	              mouseenter: function($event) {
	                return _vm.handleMouseEnter($event)
	              },
	              mouseleave: function($event) {
	                _vm.showClose = false
	              }
	            }
	          },
	          "el-input",
	          _vm.firstInputId,
	          false
	        ),
	        [
	          _c("i", {
	            staticClass: "el-input__icon",
	            class: _vm.triggerClass,
	            attrs: { slot: "prefix" },
	            on: { click: _vm.handleFocus },
	            slot: "prefix"
	          }),
	          _vm.haveTrigger
	            ? _c("i", {
	                staticClass: "el-input__icon",
	                class: [_vm.showClose ? "" + _vm.clearIcon : ""],
	                attrs: { slot: "suffix" },
	                on: { click: _vm.handleClickIcon },
	                slot: "suffix"
	              })
	            : _vm._e()
	        ]
	      )
	    : _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "clickoutside",
	              rawName: "v-clickoutside",
	              value: _vm.handleClose,
	              expression: "handleClose"
	            }
	          ],
	          ref: "reference",
	          staticClass: "el-date-editor el-range-editor el-input__inner",
	          class: [
	            "el-date-editor--" + _vm.type,
	            _vm.pickerSize ? "el-range-editor--" + _vm.pickerSize : "",
	            _vm.pickerDisabled ? "is-disabled" : "",
	            _vm.pickerVisible ? "is-active" : ""
	          ],
	          on: {
	            click: _vm.handleRangeClick,
	            mouseenter: _vm.handleMouseEnter,
	            mouseleave: function($event) {
	              _vm.showClose = false
	            },
	            keydown: _vm.handleKeydown
	          }
	        },
	        [
	          _c("i", {
	            class: ["el-input__icon", "el-range__icon", _vm.triggerClass]
	          }),
	          _c(
	            "input",
	            _vm._b(
	              {
	                staticClass: "el-range-input",
	                attrs: {
	                  autocomplete: "off",
	                  placeholder: _vm.startPlaceholder,
	                  disabled: _vm.pickerDisabled,
	                  readonly: !_vm.editable || _vm.readonly,
	                  name: _vm.name && _vm.name[0]
	                },
	                domProps: { value: _vm.displayValue && _vm.displayValue[0] },
	                on: {
	                  input: _vm.handleStartInput,
	                  change: _vm.handleStartChange,
	                  focus: _vm.handleFocus
	                }
	              },
	              "input",
	              _vm.firstInputId,
	              false
	            )
	          ),
	          _vm._t("range-separator", [
	            _c("span", { staticClass: "el-range-separator" }, [
	              _vm._v(_vm._s(_vm.rangeSeparator))
	            ])
	          ]),
	          _c(
	            "input",
	            _vm._b(
	              {
	                staticClass: "el-range-input",
	                attrs: {
	                  autocomplete: "off",
	                  placeholder: _vm.endPlaceholder,
	                  disabled: _vm.pickerDisabled,
	                  readonly: !_vm.editable || _vm.readonly,
	                  name: _vm.name && _vm.name[1]
	                },
	                domProps: { value: _vm.displayValue && _vm.displayValue[1] },
	                on: {
	                  input: _vm.handleEndInput,
	                  change: _vm.handleEndChange,
	                  focus: _vm.handleFocus
	                }
	              },
	              "input",
	              _vm.secondInputId,
	              false
	            )
	          ),
	          _vm.haveTrigger
	            ? _c("i", {
	                staticClass: "el-input__icon el-range__close-icon",
	                class: [_vm.showClose ? "" + _vm.clearIcon : ""],
	                on: { click: _vm.handleClickIcon }
	              })
	            : _vm._e()
	        ],
	        2
	      )
	}
	var pickervue_type_template_id_79ae069f_staticRenderFns = []
	pickervue_type_template_id_79ae069f_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/date-util"
	var date_util_ = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	var NewPopper = {
	  props: {
	    appendToBody: vue_popper_default.a.props.appendToBody,
	    offset: vue_popper_default.a.props.offset,
	    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
	    arrowOffset: vue_popper_default.a.props.arrowOffset
	  },
	  methods: vue_popper_default.a.methods,
	  data: function data() {
	    return merge_default()({ visibleArrow: true }, vue_popper_default.a.data);
	  },
	
	  beforeDestroy: vue_popper_default.a.beforeDestroy
	};
	
	var DEFAULT_FORMATS = {
	  date: 'yyyy-MM-dd',
	  month: 'yyyy-MM',
	  datetime: 'yyyy-MM-dd HH:mm:ss',
	  time: 'HH:mm:ss',
	  week: 'yyyywWW',
	  timerange: 'HH:mm:ss',
	  daterange: 'yyyy-MM-dd',
	  monthrange: 'yyyy-MM',
	  datetimerange: 'yyyy-MM-dd HH:mm:ss',
	  year: 'yyyy'
	};
	var HAVE_TRIGGER_TYPES = ['date', 'datetime', 'time', 'time-select', 'week', 'month', 'year', 'daterange', 'monthrange', 'timerange', 'datetimerange', 'dates'];
	var pickervue_type_script_lang_js_DATE_FORMATTER = function DATE_FORMATTER(value, format) {
	  if (format === 'timestamp') return value.getTime();
	  return Object(date_util_["formatDate"])(value, format);
	};
	var pickervue_type_script_lang_js_DATE_PARSER = function DATE_PARSER(text, format) {
	  if (format === 'timestamp') return new Date(Number(text));
	  return Object(date_util_["parseDate"])(text, format);
	};
	var RANGE_FORMATTER = function RANGE_FORMATTER(value, format) {
	  if (Array.isArray(value) && value.length === 2) {
	    var start = value[0];
	    var end = value[1];
	
	    if (start && end) {
	      return [pickervue_type_script_lang_js_DATE_FORMATTER(start, format), pickervue_type_script_lang_js_DATE_FORMATTER(end, format)];
	    }
	  }
	  return '';
	};
	var RANGE_PARSER = function RANGE_PARSER(array, format, separator) {
	  if (!Array.isArray(array)) {
	    array = array.split(separator);
	  }
	  if (array.length === 2) {
	    var range1 = array[0];
	    var range2 = array[1];
	
	    return [pickervue_type_script_lang_js_DATE_PARSER(range1, format), pickervue_type_script_lang_js_DATE_PARSER(range2, format)];
	  }
	  return [];
	};
	var TYPE_VALUE_RESOLVER_MAP = {
	  default: {
	    formatter: function formatter(value) {
	      if (!value) return '';
	      return '' + value;
	    },
	    parser: function parser(text) {
	      if (text === undefined || text === '') return null;
	      return text;
	    }
	  },
	  week: {
	    formatter: function formatter(value, format) {
	      var week = Object(date_util_["getWeekNumber"])(value);
	      var month = value.getMonth();
	      var trueDate = new Date(value);
	      if (week === 1 && month === 11) {
	        trueDate.setHours(0, 0, 0, 0);
	        trueDate.setDate(trueDate.getDate() + 3 - (trueDate.getDay() + 6) % 7);
	      }
	      var date = Object(date_util_["formatDate"])(trueDate, format);
	
	      date = /WW/.test(date) ? date.replace(/WW/, week < 10 ? '0' + week : week) : date.replace(/W/, week);
	      return date;
	    },
	    parser: function parser(text, format) {
	      // parse as if a normal date
	      return TYPE_VALUE_RESOLVER_MAP.date.parser(text, format);
	    }
	  },
	  date: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  datetime: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  daterange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  monthrange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  datetimerange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  timerange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  time: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  month: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  year: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  number: {
	    formatter: function formatter(value) {
	      if (!value) return '';
	      return '' + value;
	    },
	    parser: function parser(text) {
	      var result = Number(text);
	
	      if (!isNaN(text)) {
	        return result;
	      } else {
	        return null;
	      }
	    }
	  },
	  dates: {
	    formatter: function formatter(value, format) {
	      return value.map(function (date) {
	        return pickervue_type_script_lang_js_DATE_FORMATTER(date, format);
	      });
	    },
	    parser: function parser(value, format) {
	      return (typeof value === 'string' ? value.split(', ') : value).map(function (date) {
	        return date instanceof Date ? date : pickervue_type_script_lang_js_DATE_PARSER(date, format);
	      });
	    }
	  }
	};
	var PLACEMENT_MAP = {
	  left: 'bottom-start',
	  center: 'bottom',
	  right: 'bottom-end'
	};
	
	var parseAsFormatAndType = function parseAsFormatAndType(value, customFormat, type) {
	  var rangeSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '-';
	
	  if (!value) return null;
	  var parser = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).parser;
	  var format = customFormat || DEFAULT_FORMATS[type];
	  return parser(value, format, rangeSeparator);
	};
	
	var formatAsFormatAndType = function formatAsFormatAndType(value, customFormat, type) {
	  if (!value) return null;
	  var formatter = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).formatter;
	  var format = customFormat || DEFAULT_FORMATS[type];
	  return formatter(value, format);
	};
	
	/*
	 * Considers:
	 *   1. Date object
	 *   2. date string
	 *   3. array of 1 or 2
	 */
	var valueEquals = function valueEquals(a, b) {
	  // considers Date object and string
	  var dateEquals = function dateEquals(a, b) {
	    var aIsDate = a instanceof Date;
	    var bIsDate = b instanceof Date;
	    if (aIsDate && bIsDate) {
	      return a.getTime() === b.getTime();
	    }
	    if (!aIsDate && !bIsDate) {
	      return a === b;
	    }
	    return false;
	  };
	
	  var aIsArray = a instanceof Array;
	  var bIsArray = b instanceof Array;
	  if (aIsArray && bIsArray) {
	    if (a.length !== b.length) {
	      return false;
	    }
	    return a.every(function (item, index) {
	      return dateEquals(item, b[index]);
	    });
	  }
	  if (!aIsArray && !bIsArray) {
	    return dateEquals(a, b);
	  }
	  return false;
	};
	
	var isString = function isString(val) {
	  return typeof val === 'string' || val instanceof String;
	};
	
	var pickervue_type_script_lang_js_validator = function validator(val) {
	  // either: String, Array of String, null / undefined
	  return val === null || val === undefined || isString(val) || Array.isArray(val) && val.length === 2 && val.every(isString);
	};
	
	/* harmony default export */ var pickervue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a, NewPopper],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    size: String,
	    format: String,
	    valueFormat: String,
	    readonly: Boolean,
	    placeholder: String,
	    startPlaceholder: String,
	    endPlaceholder: String,
	    prefixIcon: String,
	    clearIcon: {
	      type: String,
	      default: 'el-icon-circle-close'
	    },
	    name: {
	      default: '',
	      validator: pickervue_type_script_lang_js_validator
	    },
	    disabled: Boolean,
	    clearable: {
	      type: Boolean,
	      default: true
	    },
	    id: {
	      default: '',
	      validator: pickervue_type_script_lang_js_validator
	    },
	    popperClass: String,
	    editable: {
	      type: Boolean,
	      default: true
	    },
	    align: {
	      type: String,
	      default: 'left'
	    },
	    value: {},
	    defaultValue: {},
	    defaultTime: {},
	    rangeSeparator: {
	      default: '-'
	    },
	    pickerOptions: {},
	    unlinkPanels: Boolean,
	    validateEvent: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  components: { ElInput: input_default.a },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  data: function data() {
	    return {
	      pickerVisible: false,
	      showClose: false,
	      userInput: null,
	      valueOnOpen: null, // value when picker opens, used to determine whether to emit change
	      unwatchPickerOptions: null
	    };
	  },
	
	
	  watch: {
	    pickerVisible: function pickerVisible(val) {
	      if (this.readonly || this.pickerDisabled) return;
	      if (val) {
	        this.showPicker();
	        this.valueOnOpen = Array.isArray(this.value) ? [].concat(this.value) : this.value;
	      } else {
	        this.hidePicker();
	        this.emitChange(this.value);
	        this.userInput = null;
	        if (this.validateEvent) {
	          this.dispatch('ElFormItem', 'el.form.blur');
	        }
	        this.$emit('blur', this);
	        this.blur();
	      }
	    },
	
	    parsedValue: {
	      immediate: true,
	      handler: function handler(val) {
	        if (this.picker) {
	          this.picker.value = val;
	        }
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      // NOTE: should eventually move to jsx style picker + panel ?
	      if (this.picker) {
	        this.picker.defaultValue = val;
	      }
	    },
	    value: function value(val, oldVal) {
	      if (!valueEquals(val, oldVal) && !this.pickerVisible && this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', val);
	      }
	    }
	  },
	
	  computed: {
	    ranged: function ranged() {
	      return this.type.indexOf('range') > -1;
	    },
	    reference: function reference() {
	      var reference = this.$refs.reference;
	      return reference.$el || reference;
	    },
	    refInput: function refInput() {
	      if (this.reference) {
	        return [].slice.call(this.reference.querySelectorAll('input'));
	      }
	      return [];
	    },
	    valueIsEmpty: function valueIsEmpty() {
	      var val = this.value;
	      if (Array.isArray(val)) {
	        for (var i = 0, len = val.length; i < len; i++) {
	          if (val[i]) {
	            return false;
	          }
	        }
	      } else {
	        if (val) {
	          return false;
	        }
	      }
	      return true;
	    },
	    triggerClass: function triggerClass() {
	      return this.prefixIcon || (this.type.indexOf('time') !== -1 ? 'el-icon-time' : 'el-icon-date');
	    },
	    selectionMode: function selectionMode() {
	      if (this.type === 'week') {
	        return 'week';
	      } else if (this.type === 'month') {
	        return 'month';
	      } else if (this.type === 'year') {
	        return 'year';
	      } else if (this.type === 'dates') {
	        return 'dates';
	      }
	
	      return 'day';
	    },
	    haveTrigger: function haveTrigger() {
	      if (typeof this.showTrigger !== 'undefined') {
	        return this.showTrigger;
	      }
	      return HAVE_TRIGGER_TYPES.indexOf(this.type) !== -1;
	    },
	    displayValue: function displayValue() {
	      var formattedValue = formatAsFormatAndType(this.parsedValue, this.format, this.type, this.rangeSeparator);
	      if (Array.isArray(this.userInput)) {
	        return [this.userInput[0] || formattedValue && formattedValue[0] || '', this.userInput[1] || formattedValue && formattedValue[1] || ''];
	      } else if (this.userInput !== null) {
	        return this.userInput;
	      } else if (formattedValue) {
	        return this.type === 'dates' ? formattedValue.join(', ') : formattedValue;
	      } else {
	        return '';
	      }
	    },
	    parsedValue: function parsedValue() {
	      if (!this.value) return this.value; // component value is not set
	      if (this.type === 'time-select') return this.value; // time-select does not require parsing, this might change in next major version
	
	      var valueIsDateObject = Object(date_util_["isDateObject"])(this.value) || Array.isArray(this.value) && this.value.every(date_util_["isDateObject"]);
	      if (valueIsDateObject) {
	        return this.value;
	      }
	
	      if (this.valueFormat) {
	        return parseAsFormatAndType(this.value, this.valueFormat, this.type, this.rangeSeparator) || this.value;
	      }
	
	      // NOTE: deal with common but incorrect usage, should remove in next major version
	      // user might provide string / timestamp without value-format, coerce them into date (or array of date)
	      return Array.isArray(this.value) ? this.value.map(function (val) {
	        return new Date(val);
	      }) : new Date(this.value);
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    pickerSize: function pickerSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    pickerDisabled: function pickerDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    firstInputId: function firstInputId() {
	      var obj = {};
	      var id = void 0;
	      if (this.ranged) {
	        id = this.id && this.id[0];
	      } else {
	        id = this.id;
	      }
	      if (id) obj.id = id;
	      return obj;
	    },
	    secondInputId: function secondInputId() {
	      var obj = {};
	      var id = void 0;
	      if (this.ranged) {
	        id = this.id && this.id[1];
	      }
	      if (id) obj.id = id;
	      return obj;
	    }
	  },
	
	  created: function created() {
	    // vue-popper
	    this.popperOptions = {
	      boundariesPadding: 0,
	      gpuAcceleration: false
	    };
	    this.placement = PLACEMENT_MAP[this.align] || PLACEMENT_MAP.left;
	
	    this.$on('fieldReset', this.handleFieldReset);
	  },
	
	
	  methods: {
	    focus: function focus() {
	      if (!this.ranged) {
	        this.$refs.reference.focus();
	      } else {
	        this.handleFocus();
	      }
	    },
	    blur: function blur() {
	      this.refInput.forEach(function (input) {
	        return input.blur();
	      });
	    },
	
	
	    // {parse, formatTo} Value deals maps component value with internal Date
	    parseValue: function parseValue(value) {
	      var isParsed = Object(date_util_["isDateObject"])(value) || Array.isArray(value) && value.every(date_util_["isDateObject"]);
	      if (this.valueFormat && !isParsed) {
	        return parseAsFormatAndType(value, this.valueFormat, this.type, this.rangeSeparator) || value;
	      } else {
	        return value;
	      }
	    },
	    formatToValue: function formatToValue(date) {
	      var isFormattable = Object(date_util_["isDateObject"])(date) || Array.isArray(date) && date.every(date_util_["isDateObject"]);
	      if (this.valueFormat && isFormattable) {
	        return formatAsFormatAndType(date, this.valueFormat, this.type, this.rangeSeparator);
	      } else {
	        return date;
	      }
	    },
	
	
	    // {parse, formatTo} String deals with user input
	    parseString: function parseString(value) {
	      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
	      return parseAsFormatAndType(value, this.format, type);
	    },
	    formatToString: function formatToString(value) {
	      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
	      return formatAsFormatAndType(value, this.format, type);
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      if (this.readonly || this.pickerDisabled) return;
	      if (!this.valueIsEmpty && this.clearable) {
	        this.showClose = true;
	      }
	    },
	    handleChange: function handleChange() {
	      if (this.userInput) {
	        var value = this.parseString(this.displayValue);
	        if (value) {
	          this.picker.value = value;
	          if (this.isValidValue(value)) {
	            this.emitInput(value);
	            this.userInput = null;
	          }
	        }
	      }
	      if (this.userInput === '') {
	        this.emitInput(null);
	        this.emitChange(null);
	        this.userInput = null;
	      }
	    },
	    handleStartInput: function handleStartInput(event) {
	      if (this.userInput) {
	        this.userInput = [event.target.value, this.userInput[1]];
	      } else {
	        this.userInput = [event.target.value, null];
	      }
	    },
	    handleEndInput: function handleEndInput(event) {
	      if (this.userInput) {
	        this.userInput = [this.userInput[0], event.target.value];
	      } else {
	        this.userInput = [null, event.target.value];
	      }
	    },
	    handleStartChange: function handleStartChange(event) {
	      var value = this.parseString(this.userInput && this.userInput[0]);
	      if (value) {
	        this.userInput = [this.formatToString(value), this.displayValue[1]];
	        var newValue = [value, this.picker.value && this.picker.value[1]];
	        this.picker.value = newValue;
	        if (this.isValidValue(newValue)) {
	          this.emitInput(newValue);
	          this.userInput = null;
	        }
	      }
	    },
	    handleEndChange: function handleEndChange(event) {
	      var value = this.parseString(this.userInput && this.userInput[1]);
	      if (value) {
	        this.userInput = [this.displayValue[0], this.formatToString(value)];
	        var newValue = [this.picker.value && this.picker.value[0], value];
	        this.picker.value = newValue;
	        if (this.isValidValue(newValue)) {
	          this.emitInput(newValue);
	          this.userInput = null;
	        }
	      }
	    },
	    handleClickIcon: function handleClickIcon(event) {
	      if (this.readonly || this.pickerDisabled) return;
	      if (this.showClose) {
	        this.valueOnOpen = this.value;
	        event.stopPropagation();
	        this.emitInput(null);
	        this.emitChange(null);
	        this.showClose = false;
	        if (this.picker && typeof this.picker.handleClear === 'function') {
	          this.picker.handleClear();
	        }
	      } else {
	        this.pickerVisible = !this.pickerVisible;
	      }
	    },
	    handleClose: function handleClose() {
	      if (!this.pickerVisible) return;
	      this.pickerVisible = false;
	
	      if (this.type === 'dates') {
	        // restore to former value
	        var oldValue = parseAsFormatAndType(this.valueOnOpen, this.valueFormat, this.type, this.rangeSeparator) || this.valueOnOpen;
	        this.emitInput(oldValue);
	      }
	    },
	    handleFieldReset: function handleFieldReset(initialValue) {
	      this.userInput = initialValue === '' ? null : initialValue;
	    },
	    handleFocus: function handleFocus() {
	      var type = this.type;
	
	      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
	        this.pickerVisible = true;
	      }
	      this.$emit('focus', this);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var _this = this;
	
	      var keyCode = event.keyCode;
	
	      // ESC
	      if (keyCode === 27) {
	        this.pickerVisible = false;
	        event.stopPropagation();
	        return;
	      }
	
	      // Tab
	      if (keyCode === 9) {
	        if (!this.ranged) {
	          this.handleChange();
	          this.pickerVisible = this.picker.visible = false;
	          this.blur();
	          event.stopPropagation();
	        } else {
	          // user may change focus between two input
	          setTimeout(function () {
	            if (_this.refInput.indexOf(document.activeElement) === -1) {
	              _this.pickerVisible = false;
	              _this.blur();
	              event.stopPropagation();
	            }
	          }, 0);
	        }
	        return;
	      }
	
	      // Enter
	      if (keyCode === 13) {
	        if (this.userInput === '' || this.isValidValue(this.parseString(this.displayValue))) {
	          this.handleChange();
	          this.pickerVisible = this.picker.visible = false;
	          this.blur();
	        }
	        event.stopPropagation();
	        return;
	      }
	
	      // if user is typing, do not let picker handle key input
	      if (this.userInput) {
	        event.stopPropagation();
	        return;
	      }
	
	      // delegate other keys to panel
	      if (this.picker && this.picker.handleKeydown) {
	        this.picker.handleKeydown(event);
	      }
	    },
	    handleRangeClick: function handleRangeClick() {
	      var type = this.type;
	
	      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
	        this.pickerVisible = true;
	      }
	      this.$emit('focus', this);
	    },
	    hidePicker: function hidePicker() {
	      if (this.picker) {
	        this.picker.resetView && this.picker.resetView();
	        this.pickerVisible = this.picker.visible = false;
	        this.destroyPopper();
	      }
	    },
	    showPicker: function showPicker() {
	      var _this2 = this;
	
	      if (this.$isServer) return;
	      if (!this.picker) {
	        this.mountPicker();
	      }
	      this.pickerVisible = this.picker.visible = true;
	
	      this.updatePopper();
	
	      this.picker.value = this.parsedValue;
	      this.picker.resetView && this.picker.resetView();
	
	      this.$nextTick(function () {
	        _this2.picker.adjustSpinners && _this2.picker.adjustSpinners();
	      });
	    },
	    mountPicker: function mountPicker() {
	      var _this3 = this;
	
	      this.picker = new external_vue_default.a(this.panel).$mount();
	      this.picker.defaultValue = this.defaultValue;
	      this.picker.defaultTime = this.defaultTime;
	      this.picker.popperClass = this.popperClass;
	      this.popperElm = this.picker.$el;
	      this.picker.width = this.reference.getBoundingClientRect().width;
	      this.picker.showTime = this.type === 'datetime' || this.type === 'datetimerange';
	      this.picker.selectionMode = this.selectionMode;
	      this.picker.unlinkPanels = this.unlinkPanels;
	      this.picker.arrowControl = this.arrowControl || this.timeArrowControl || false;
	      this.$watch('format', function (format) {
	        _this3.picker.format = format;
	      });
	
	      var updateOptions = function updateOptions() {
	        var options = _this3.pickerOptions;
	
	        if (options && options.selectableRange) {
	          var ranges = options.selectableRange;
	          var parser = TYPE_VALUE_RESOLVER_MAP.datetimerange.parser;
	          var format = DEFAULT_FORMATS.timerange;
	
	          ranges = Array.isArray(ranges) ? ranges : [ranges];
	          _this3.picker.selectableRange = ranges.map(function (range) {
	            return parser(range, format, _this3.rangeSeparator);
	          });
	        }
	
	        for (var option in options) {
	          if (options.hasOwnProperty(option) &&
	          // 忽略 time-picker 的该配置项
	          option !== 'selectableRange') {
	            _this3.picker[option] = options[option];
	          }
	        }
	
	        // main format must prevail over undocumented pickerOptions.format
	        if (_this3.format) {
	          _this3.picker.format = _this3.format;
	        }
	      };
	      updateOptions();
	      this.unwatchPickerOptions = this.$watch('pickerOptions', function () {
	        return updateOptions();
	      }, { deep: true });
	      this.$el.appendChild(this.picker.$el);
	      this.picker.resetView && this.picker.resetView();
	
	      this.picker.$on('dodestroy', this.doDestroy);
	      this.picker.$on('pick', function () {
	        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        _this3.userInput = null;
	        _this3.pickerVisible = _this3.picker.visible = visible;
	        _this3.emitInput(date);
	        _this3.picker.resetView && _this3.picker.resetView();
	      });
	
	      this.picker.$on('select-range', function (start, end, pos) {
	        if (_this3.refInput.length === 0) return;
	        if (!pos || pos === 'min') {
	          _this3.refInput[0].setSelectionRange(start, end);
	          _this3.refInput[0].focus();
	        } else if (pos === 'max') {
	          _this3.refInput[1].setSelectionRange(start, end);
	          _this3.refInput[1].focus();
	        }
	      });
	    },
	    unmountPicker: function unmountPicker() {
	      if (this.picker) {
	        this.picker.$destroy();
	        this.picker.$off();
	        if (typeof this.unwatchPickerOptions === 'function') {
	          this.unwatchPickerOptions();
	        }
	        this.picker.$el.parentNode.removeChild(this.picker.$el);
	      }
	    },
	    emitChange: function emitChange(val) {
	      // determine user real change only
	      if (!valueEquals(val, this.valueOnOpen)) {
	        this.$emit('change', val);
	        this.valueOnOpen = val;
	        if (this.validateEvent) {
	          this.dispatch('ElFormItem', 'el.form.change', val);
	        }
	      }
	    },
	    emitInput: function emitInput(val) {
	      var formatted = this.formatToValue(val);
	      if (!valueEquals(this.value, formatted)) {
	        this.$emit('input', formatted);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      if (!this.picker) {
	        this.mountPicker();
	      }
	      if (this.picker.isValidValue) {
	        return value && this.picker.isValidValue(value);
	      } else {
	        return true;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_pickervue_type_script_lang_js_ = (pickervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue
	
	
	
	
	
	/* normalize component */
	
	var picker_component = normalizeComponent(
	  src_pickervue_type_script_lang_js_,
	  pickervue_type_template_id_79ae069f_render,
	  pickervue_type_template_id_79ae069f_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var picker_api; }
	picker_component.options.__file = "packages/date-picker/src/picker.vue"
	/* harmony default export */ var picker = (picker_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
	var datevue_type_template_id_2440d4ea_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: { "after-enter": _vm.handleEnter, "after-leave": _vm.handleLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-picker-panel el-date-picker el-popper",
	          class: [
	            {
	              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts,
	              "has-time": _vm.showTime
	            },
	            _vm.popperClass
	          ]
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-picker-panel__body-wrapper" },
	            [
	              _vm._t("sidebar"),
	              _vm.shortcuts
	                ? _c(
	                    "div",
	                    { staticClass: "el-picker-panel__sidebar" },
	                    _vm._l(_vm.shortcuts, function(shortcut, key) {
	                      return _c(
	                        "button",
	                        {
	                          key: key,
	                          staticClass: "el-picker-panel__shortcut",
	                          attrs: { type: "button" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleShortcutClick(shortcut)
	                            }
	                          }
	                        },
	                        [_vm._v(_vm._s(shortcut.text))]
	                      )
	                    }),
	                    0
	                  )
	                : _vm._e(),
	              _c("div", { staticClass: "el-picker-panel__body" }, [
	                _vm.showTime
	                  ? _c("div", { staticClass: "el-date-picker__time-header" }, [
	                      _c(
	                        "span",
	                        { staticClass: "el-date-picker__editor-wrap" },
	                        [
	                          _c("el-input", {
	                            attrs: {
	                              placeholder: _vm.t("el.datepicker.selectDate"),
	                              value: _vm.visibleDate,
	                              size: "small"
	                            },
	                            on: {
	                              input: function(val) {
	                                return (_vm.userInputDate = val)
	                              },
	                              change: _vm.handleVisibleDateChange
	                            }
	                          })
	                        ],
	                        1
	                      ),
	                      _c(
	                        "span",
	                        {
	                          directives: [
	                            {
	                              name: "clickoutside",
	                              rawName: "v-clickoutside",
	                              value: _vm.handleTimePickClose,
	                              expression: "handleTimePickClose"
	                            }
	                          ],
	                          staticClass: "el-date-picker__editor-wrap"
	                        },
	                        [
	                          _c("el-input", {
	                            ref: "input",
	                            attrs: {
	                              placeholder: _vm.t("el.datepicker.selectTime"),
	                              value: _vm.visibleTime,
	                              size: "small"
	                            },
	                            on: {
	                              focus: function($event) {
	                                _vm.timePickerVisible = true
	                              },
	                              input: function(val) {
	                                return (_vm.userInputTime = val)
	                              },
	                              change: _vm.handleVisibleTimeChange
	                            }
	                          }),
	                          _c("time-picker", {
	                            ref: "timepicker",
	                            attrs: {
	                              "time-arrow-control": _vm.arrowControl,
	                              visible: _vm.timePickerVisible
	                            },
	                            on: {
	                              pick: _vm.handleTimePick,
	                              mounted: _vm.proxyTimePickerDataProperties
	                            }
	                          })
	                        ],
	                        1
	                      )
	                    ])
	                  : _vm._e(),
	                _c(
	                  "div",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value: _vm.currentView !== "time",
	                        expression: "currentView !== 'time'"
	                      }
	                    ],
	                    staticClass: "el-date-picker__header",
	                    class: {
	                      "el-date-picker__header--bordered":
	                        _vm.currentView === "year" ||
	                        _vm.currentView === "month"
	                    }
	                  },
	                  [
	                    _c("button", {
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.prevYear")
	                      },
	                      on: { click: _vm.prevYear }
	                    }),
	                    _c("button", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "date",
	                          expression: "currentView === 'date'"
	                        }
	                      ],
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.prevMonth")
	                      },
	                      on: { click: _vm.prevMonth }
	                    }),
	                    _c(
	                      "span",
	                      {
	                        staticClass: "el-date-picker__header-label",
	                        attrs: { role: "button" },
	                        on: { click: _vm.showYearPicker }
	                      },
	                      [_vm._v(_vm._s(_vm.yearLabel))]
	                    ),
	                    _c(
	                      "span",
	                      {
	                        directives: [
	                          {
	                            name: "show",
	                            rawName: "v-show",
	                            value: _vm.currentView === "date",
	                            expression: "currentView === 'date'"
	                          }
	                        ],
	                        staticClass: "el-date-picker__header-label",
	                        class: { active: _vm.currentView === "month" },
	                        attrs: { role: "button" },
	                        on: { click: _vm.showMonthPicker }
	                      },
	                      [
	                        _vm._v(
	                          _vm._s(_vm.t("el.datepicker.month" + (_vm.month + 1)))
	                        )
	                      ]
	                    ),
	                    _c("button", {
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.nextYear")
	                      },
	                      on: { click: _vm.nextYear }
	                    }),
	                    _c("button", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "date",
	                          expression: "currentView === 'date'"
	                        }
	                      ],
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.nextMonth")
	                      },
	                      on: { click: _vm.nextMonth }
	                    })
	                  ]
	                ),
	                _c(
	                  "div",
	                  { staticClass: "el-picker-panel__content" },
	                  [
	                    _c("date-table", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "date",
	                          expression: "currentView === 'date'"
	                        }
	                      ],
	                      attrs: {
	                        "selection-mode": _vm.selectionMode,
	                        "first-day-of-week": _vm.firstDayOfWeek,
	                        value: _vm.value,
	                        "default-value": _vm.defaultValue
	                          ? new Date(_vm.defaultValue)
	                          : null,
	                        date: _vm.date,
	                        "cell-class-name": _vm.cellClassName,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: { pick: _vm.handleDatePick }
	                    }),
	                    _c("year-table", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "year",
	                          expression: "currentView === 'year'"
	                        }
	                      ],
	                      attrs: {
	                        value: _vm.value,
	                        "default-value": _vm.defaultValue
	                          ? new Date(_vm.defaultValue)
	                          : null,
	                        date: _vm.date,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: { pick: _vm.handleYearPick }
	                    }),
	                    _c("month-table", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "month",
	                          expression: "currentView === 'month'"
	                        }
	                      ],
	                      attrs: {
	                        value: _vm.value,
	                        "default-value": _vm.defaultValue
	                          ? new Date(_vm.defaultValue)
	                          : null,
	                        date: _vm.date,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: { pick: _vm.handleMonthPick }
	                    })
	                  ],
	                  1
	                )
	              ])
	            ],
	            2
	          ),
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.footerVisible && _vm.currentView === "date",
	                  expression: "footerVisible && currentView === 'date'"
	                }
	              ],
	              staticClass: "el-picker-panel__footer"
	            },
	            [
	              _c(
	                "el-button",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.selectionMode !== "dates",
	                      expression: "selectionMode !== 'dates'"
	                    }
	                  ],
	                  staticClass: "el-picker-panel__link-btn",
	                  attrs: { size: "mini", type: "text" },
	                  on: { click: _vm.changeToNow }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.datepicker.now")) +
	                      "\n      "
	                  )
	                ]
	              ),
	              _c(
	                "el-button",
	                {
	                  staticClass: "el-picker-panel__link-btn",
	                  attrs: { plain: "", size: "mini" },
	                  on: { click: _vm.confirm }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.datepicker.confirm")) +
	                      "\n      "
	                  )
	                ]
	              )
	            ],
	            1
	          )
	        ]
	      )
	    ]
	  )
	}
	var datevue_type_template_id_2440d4ea_staticRenderFns = []
	datevue_type_template_id_2440d4ea_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
	var timevue_type_template_id_3d939089_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-time-panel el-popper",
	          class: _vm.popperClass
	        },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-time-panel__content",
	              class: { "has-seconds": _vm.showSeconds }
	            },
	            [
	              _c("time-spinner", {
	                ref: "spinner",
	                attrs: {
	                  "arrow-control": _vm.useArrow,
	                  "show-seconds": _vm.showSeconds,
	                  "am-pm-mode": _vm.amPmMode,
	                  date: _vm.date
	                },
	                on: {
	                  change: _vm.handleChange,
	                  "select-range": _vm.setSelectionRange
	                }
	              })
	            ],
	            1
	          ),
	          _c("div", { staticClass: "el-time-panel__footer" }, [
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn cancel",
	                attrs: { type: "button" },
	                on: { click: _vm.handleCancel }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]
	            ),
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn",
	                class: { confirm: !_vm.disabled },
	                attrs: { type: "button" },
	                on: {
	                  click: function($event) {
	                    _vm.handleConfirm()
	                  }
	                }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))]
	            )
	          ])
	        ]
	      )
	    ]
	  )
	}
	var timevue_type_template_id_3d939089_staticRenderFns = []
	timevue_type_template_id_3d939089_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
	var time_spinnervue_type_template_id_1facadeb_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-time-spinner",
	      class: { "has-seconds": _vm.showSeconds }
	    },
	    [
	      !_vm.arrowControl
	        ? [
	            _c(
	              "el-scrollbar",
	              {
	                ref: "hours",
	                staticClass: "el-time-spinner__wrapper",
	                attrs: {
	                  "wrap-style": "max-height: inherit;",
	                  "view-class": "el-time-spinner__list",
	                  noresize: "",
	                  tag: "ul"
	                },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("hours")
	                  },
	                  mousemove: function($event) {
	                    _vm.adjustCurrentSpinner("hours")
	                  }
	                }
	              },
	              _vm._l(_vm.hoursList, function(disabled, hour) {
	                return _c(
	                  "li",
	                  {
	                    key: hour,
	                    staticClass: "el-time-spinner__item",
	                    class: { active: hour === _vm.hours, disabled: disabled },
	                    on: {
	                      click: function($event) {
	                        _vm.handleClick("hours", {
	                          value: hour,
	                          disabled: disabled
	                        })
	                      }
	                    }
	                  },
	                  [
	                    _vm._v(
	                      _vm._s(
	                        ("0" + (_vm.amPmMode ? hour % 12 || 12 : hour)).slice(
	                          -2
	                        )
	                      ) + _vm._s(_vm.amPm(hour))
	                    )
	                  ]
	                )
	              }),
	              0
	            ),
	            _c(
	              "el-scrollbar",
	              {
	                ref: "minutes",
	                staticClass: "el-time-spinner__wrapper",
	                attrs: {
	                  "wrap-style": "max-height: inherit;",
	                  "view-class": "el-time-spinner__list",
	                  noresize: "",
	                  tag: "ul"
	                },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("minutes")
	                  },
	                  mousemove: function($event) {
	                    _vm.adjustCurrentSpinner("minutes")
	                  }
	                }
	              },
	              _vm._l(_vm.minutesList, function(enabled, key) {
	                return _c(
	                  "li",
	                  {
	                    key: key,
	                    staticClass: "el-time-spinner__item",
	                    class: { active: key === _vm.minutes, disabled: !enabled },
	                    on: {
	                      click: function($event) {
	                        _vm.handleClick("minutes", {
	                          value: key,
	                          disabled: false
	                        })
	                      }
	                    }
	                  },
	                  [_vm._v(_vm._s(("0" + key).slice(-2)))]
	                )
	              }),
	              0
	            ),
	            _c(
	              "el-scrollbar",
	              {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: _vm.showSeconds,
	                    expression: "showSeconds"
	                  }
	                ],
	                ref: "seconds",
	                staticClass: "el-time-spinner__wrapper",
	                attrs: {
	                  "wrap-style": "max-height: inherit;",
	                  "view-class": "el-time-spinner__list",
	                  noresize: "",
	                  tag: "ul"
	                },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("seconds")
	                  },
	                  mousemove: function($event) {
	                    _vm.adjustCurrentSpinner("seconds")
	                  }
	                }
	              },
	              _vm._l(60, function(second, key) {
	                return _c(
	                  "li",
	                  {
	                    key: key,
	                    staticClass: "el-time-spinner__item",
	                    class: { active: key === _vm.seconds },
	                    on: {
	                      click: function($event) {
	                        _vm.handleClick("seconds", {
	                          value: key,
	                          disabled: false
	                        })
	                      }
	                    }
	                  },
	                  [_vm._v(_vm._s(("0" + key).slice(-2)))]
	                )
	              }),
	              0
	            )
	          ]
	        : _vm._e(),
	      _vm.arrowControl
	        ? [
	            _c(
	              "div",
	              {
	                staticClass: "el-time-spinner__wrapper is-arrow",
	                on: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("hours")
	                  }
	                }
	              },
	              [
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.decrease,
	                      expression: "decrease"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-up"
	                }),
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.increase,
	                      expression: "increase"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-down"
	                }),
	                _c(
	                  "ul",
	                  { ref: "hours", staticClass: "el-time-spinner__list" },
	                  _vm._l(_vm.arrowHourList, function(hour, key) {
	                    return _c(
	                      "li",
	                      {
	                        key: key,
	                        staticClass: "el-time-spinner__item",
	                        class: {
	                          active: hour === _vm.hours,
	                          disabled: _vm.hoursList[hour]
	                        }
	                      },
	                      [
	                        _vm._v(
	                          _vm._s(
	                            hour === undefined
	                              ? ""
	                              : (
	                                  "0" + (_vm.amPmMode ? hour % 12 || 12 : hour)
	                                ).slice(-2) + _vm.amPm(hour)
	                          )
	                        )
	                      ]
	                    )
	                  }),
	                  0
	                )
	              ]
	            ),
	            _c(
	              "div",
	              {
	                staticClass: "el-time-spinner__wrapper is-arrow",
	                on: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("minutes")
	                  }
	                }
	              },
	              [
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.decrease,
	                      expression: "decrease"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-up"
	                }),
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.increase,
	                      expression: "increase"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-down"
	                }),
	                _c(
	                  "ul",
	                  { ref: "minutes", staticClass: "el-time-spinner__list" },
	                  _vm._l(_vm.arrowMinuteList, function(minute, key) {
	                    return _c(
	                      "li",
	                      {
	                        key: key,
	                        staticClass: "el-time-spinner__item",
	                        class: { active: minute === _vm.minutes }
	                      },
	                      [
	                        _vm._v(
	                          "\n          " +
	                            _vm._s(
	                              minute === undefined
	                                ? ""
	                                : ("0" + minute).slice(-2)
	                            ) +
	                            "\n        "
	                        )
	                      ]
	                    )
	                  }),
	                  0
	                )
	              ]
	            ),
	            _vm.showSeconds
	              ? _c(
	                  "div",
	                  {
	                    staticClass: "el-time-spinner__wrapper is-arrow",
	                    on: {
	                      mouseenter: function($event) {
	                        _vm.emitSelectRange("seconds")
	                      }
	                    }
	                  },
	                  [
	                    _c("i", {
	                      directives: [
	                        {
	                          name: "repeat-click",
	                          rawName: "v-repeat-click",
	                          value: _vm.decrease,
	                          expression: "decrease"
	                        }
	                      ],
	                      staticClass: "el-time-spinner__arrow el-icon-arrow-up"
	                    }),
	                    _c("i", {
	                      directives: [
	                        {
	                          name: "repeat-click",
	                          rawName: "v-repeat-click",
	                          value: _vm.increase,
	                          expression: "increase"
	                        }
	                      ],
	                      staticClass: "el-time-spinner__arrow el-icon-arrow-down"
	                    }),
	                    _c(
	                      "ul",
	                      { ref: "seconds", staticClass: "el-time-spinner__list" },
	                      _vm._l(_vm.arrowSecondList, function(second, key) {
	                        return _c(
	                          "li",
	                          {
	                            key: key,
	                            staticClass: "el-time-spinner__item",
	                            class: { active: second === _vm.seconds }
	                          },
	                          [
	                            _vm._v(
	                              "\n          " +
	                                _vm._s(
	                                  second === undefined
	                                    ? ""
	                                    : ("0" + second).slice(-2)
	                                ) +
	                                "\n        "
	                            )
	                          ]
	                        )
	                      }),
	                      0
	                    )
	                  ]
	                )
	              : _vm._e()
	          ]
	        : _vm._e()
	    ],
	    2
	  )
	}
	var time_spinnervue_type_template_id_1facadeb_staticRenderFns = []
	time_spinnervue_type_template_id_1facadeb_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var time_spinnervue_type_script_lang_js_ = ({
	  components: { ElScrollbar: scrollbar_default.a },
	
	  directives: {
	    repeatClick: repeat_click
	  },
	
	  props: {
	    date: {},
	    defaultValue: {}, // reserved for future use
	    showSeconds: {
	      type: Boolean,
	      default: true
	    },
	    arrowControl: Boolean,
	    amPmMode: {
	      type: String,
	      default: '' // 'a': am/pm; 'A': AM/PM
	    }
	  },
	
	  computed: {
	    hours: function hours() {
	      return this.date.getHours();
	    },
	    minutes: function minutes() {
	      return this.date.getMinutes();
	    },
	    seconds: function seconds() {
	      return this.date.getSeconds();
	    },
	    hoursList: function hoursList() {
	      return Object(date_util_["getRangeHours"])(this.selectableRange);
	    },
	    minutesList: function minutesList() {
	      return Object(date_util_["getRangeMinutes"])(this.selectableRange, this.hours);
	    },
	    arrowHourList: function arrowHourList() {
	      var hours = this.hours;
	      return [hours > 0 ? hours - 1 : undefined, hours, hours < 23 ? hours + 1 : undefined];
	    },
	    arrowMinuteList: function arrowMinuteList() {
	      var minutes = this.minutes;
	      return [minutes > 0 ? minutes - 1 : undefined, minutes, minutes < 59 ? minutes + 1 : undefined];
	    },
	    arrowSecondList: function arrowSecondList() {
	      var seconds = this.seconds;
	      return [seconds > 0 ? seconds - 1 : undefined, seconds, seconds < 59 ? seconds + 1 : undefined];
	    }
	  },
	
	  data: function data() {
	    return {
	      selectableRange: [],
	      currentScrollbar: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      !_this.arrowControl && _this.bindScrollEvent();
	    });
	  },
	
	
	  methods: {
	    increase: function increase() {
	      this.scrollDown(1);
	    },
	    decrease: function decrease() {
	      this.scrollDown(-1);
	    },
	    modifyDateField: function modifyDateField(type, value) {
	      switch (type) {
	        case 'hours':
	          this.$emit('change', Object(date_util_["modifyTime"])(this.date, value, this.minutes, this.seconds));break;
	        case 'minutes':
	          this.$emit('change', Object(date_util_["modifyTime"])(this.date, this.hours, value, this.seconds));break;
	        case 'seconds':
	          this.$emit('change', Object(date_util_["modifyTime"])(this.date, this.hours, this.minutes, value));break;
	      }
	    },
	    handleClick: function handleClick(type, _ref) {
	      var value = _ref.value,
	          disabled = _ref.disabled;
	
	      if (!disabled) {
	        this.modifyDateField(type, value);
	        this.emitSelectRange(type);
	        this.adjustSpinner(type, value);
	      }
	    },
	    emitSelectRange: function emitSelectRange(type) {
	      if (type === 'hours') {
	        this.$emit('select-range', 0, 2);
	      } else if (type === 'minutes') {
	        this.$emit('select-range', 3, 5);
	      } else if (type === 'seconds') {
	        this.$emit('select-range', 6, 8);
	      }
	      this.currentScrollbar = type;
	    },
	    bindScrollEvent: function bindScrollEvent() {
	      var _this2 = this;
	
	      var bindFuntion = function bindFuntion(type) {
	        _this2.$refs[type].wrap.onscroll = function (e) {
	          // TODO: scroll is emitted when set scrollTop programatically
	          // should find better solutions in the future!
	          _this2.handleScroll(type, e);
	        };
	      };
	      bindFuntion('hours');
	      bindFuntion('minutes');
	      bindFuntion('seconds');
	    },
	    handleScroll: function handleScroll(type) {
	      var value = Math.min(Math.round((this.$refs[type].wrap.scrollTop - (this.scrollBarHeight(type) * 0.5 - 10) / this.typeItemHeight(type) + 3) / this.typeItemHeight(type)), type === 'hours' ? 23 : 59);
	      this.modifyDateField(type, value);
	    },
	
	
	    // NOTE: used by datetime / date-range panel
	    //       renamed from adjustScrollTop
	    //       should try to refactory it
	    adjustSpinners: function adjustSpinners() {
	      this.adjustSpinner('hours', this.hours);
	      this.adjustSpinner('minutes', this.minutes);
	      this.adjustSpinner('seconds', this.seconds);
	    },
	    adjustCurrentSpinner: function adjustCurrentSpinner(type) {
	      this.adjustSpinner(type, this[type]);
	    },
	    adjustSpinner: function adjustSpinner(type, value) {
	      if (this.arrowControl) return;
	      var el = this.$refs[type].wrap;
	      if (el) {
	        el.scrollTop = Math.max(0, value * this.typeItemHeight(type));
	      }
	    },
	    scrollDown: function scrollDown(step) {
	      var _this3 = this;
	
	      if (!this.currentScrollbar) {
	        this.emitSelectRange('hours');
	      }
	
	      var label = this.currentScrollbar;
	      var hoursList = this.hoursList;
	      var now = this[label];
	
	      if (this.currentScrollbar === 'hours') {
	        var total = Math.abs(step);
	        step = step > 0 ? 1 : -1;
	        var length = hoursList.length;
	        while (length-- && total) {
	          now = (now + step + hoursList.length) % hoursList.length;
	          if (hoursList[now]) {
	            continue;
	          }
	          total--;
	        }
	        if (hoursList[now]) return;
	      } else {
	        now = (now + step + 60) % 60;
	      }
	
	      this.modifyDateField(label, now);
	      this.adjustSpinner(label, now);
	      this.$nextTick(function () {
	        return _this3.emitSelectRange(_this3.currentScrollbar);
	      });
	    },
	    amPm: function amPm(hour) {
	      var shouldShowAmPm = this.amPmMode.toLowerCase() === 'a';
	      if (!shouldShowAmPm) return '';
	      var isCapital = this.amPmMode === 'A';
	      var content = hour < 12 ? ' am' : ' pm';
	      if (isCapital) content = content.toUpperCase();
	      return content;
	    },
	    typeItemHeight: function typeItemHeight(type) {
	      return this.$refs[type].$el.querySelector('li').offsetHeight;
	    },
	    scrollBarHeight: function scrollBarHeight(type) {
	      return this.$refs[type].$el.offsetHeight;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_time_spinnervue_type_script_lang_js_ = (time_spinnervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue
	
	
	
	
	
	/* normalize component */
	
	var time_spinner_component = normalizeComponent(
	  basic_time_spinnervue_type_script_lang_js_,
	  time_spinnervue_type_template_id_1facadeb_render,
	  time_spinnervue_type_template_id_1facadeb_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_spinner_api; }
	time_spinner_component.options.__file = "packages/date-picker/src/basic/time-spinner.vue"
	/* harmony default export */ var time_spinner = (time_spinner_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var timevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  components: {
	    TimeSpinner: time_spinner
	  },
	
	  props: {
	    visible: Boolean,
	    timeArrowControl: Boolean
	  },
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.oldValue = this.value;
	        this.$nextTick(function () {
	          return _this.$refs.spinner.emitSelectRange('hours');
	        });
	      } else {
	        this.needInitAdjust = true;
	      }
	    },
	    value: function value(newVal) {
	      var _this2 = this;
	
	      var date = void 0;
	      if (newVal instanceof Date) {
	        date = Object(date_util_["limitTimeRange"])(newVal, this.selectableRange, this.format);
	      } else if (!newVal) {
	        date = this.defaultValue ? new Date(this.defaultValue) : new Date();
	      }
	
	      this.date = date;
	      if (this.visible && this.needInitAdjust) {
	        this.$nextTick(function (_) {
	          return _this2.adjustSpinners();
	        });
	        this.needInitAdjust = false;
	      }
	    },
	    selectableRange: function selectableRange(val) {
	      this.$refs.spinner.selectableRange = val;
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Object(date_util_["isDate"])(this.value)) {
	        this.date = val ? new Date(val) : new Date();
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      format: 'HH:mm:ss',
	      value: '',
	      defaultValue: null,
	      date: new Date(),
	      oldValue: new Date(),
	      selectableRange: [],
	      selectionRange: [0, 2],
	      disabled: false,
	      arrowControl: false,
	      needInitAdjust: true
	    };
	  },
	
	
	  computed: {
	    showSeconds: function showSeconds() {
	      return (this.format || '').indexOf('ss') !== -1;
	    },
	    useArrow: function useArrow() {
	      return this.arrowControl || this.timeArrowControl || false;
	    },
	    amPmMode: function amPmMode() {
	      if ((this.format || '').indexOf('A') !== -1) return 'A';
	      if ((this.format || '').indexOf('a') !== -1) return 'a';
	      return '';
	    }
	  },
	
	  methods: {
	    handleCancel: function handleCancel() {
	      this.$emit('pick', this.oldValue, false);
	    },
	    handleChange: function handleChange(date) {
	      // this.visible avoids edge cases, when use scrolls during panel closing animation
	      if (this.visible) {
	        this.date = Object(date_util_["clearMilliseconds"])(date);
	        // if date is out of range, do not emit
	        if (this.isValidValue(this.date)) {
	          this.$emit('pick', this.date, true);
	        }
	      }
	    },
	    setSelectionRange: function setSelectionRange(start, end) {
	      this.$emit('select-range', start, end);
	      this.selectionRange = [start, end];
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var first = arguments[1];
	
	      if (first) return;
	      var date = Object(date_util_["clearMilliseconds"])(Object(date_util_["limitTimeRange"])(this.date, this.selectableRange, this.format));
	      this.$emit('pick', date, visible, first);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      var mapping = { 38: -1, 40: 1, 37: -1, 39: 1 };
	
	      // Left or Right
	      if (keyCode === 37 || keyCode === 39) {
	        var step = mapping[keyCode];
	        this.changeSelectionRange(step);
	        event.preventDefault();
	        return;
	      }
	
	      // Up or Down
	      if (keyCode === 38 || keyCode === 40) {
	        var _step = mapping[keyCode];
	        this.$refs.spinner.scrollDown(_step);
	        event.preventDefault();
	        return;
	      }
	    },
	    isValidValue: function isValidValue(date) {
	      return Object(date_util_["timeWithinRange"])(date, this.selectableRange, this.format);
	    },
	    adjustSpinners: function adjustSpinners() {
	      return this.$refs.spinner.adjustSpinners();
	    },
	    changeSelectionRange: function changeSelectionRange(step) {
	      var list = [0, 3].concat(this.showSeconds ? [6] : []);
	      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
	      var index = list.indexOf(this.selectionRange[0]);
	      var next = (index + step + list.length) % list.length;
	      this.$refs.spinner.emitSelectRange(mapping[next]);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.$nextTick(function () {
	      return _this3.handleConfirm(true, true);
	    });
	    this.$emit('mounted');
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_timevue_type_script_lang_js_ = (timevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue
	
	
	
	
	
	/* normalize component */
	
	var time_component = normalizeComponent(
	  panel_timevue_type_script_lang_js_,
	  timevue_type_template_id_3d939089_render,
	  timevue_type_template_id_3d939089_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_api; }
	time_component.options.__file = "packages/date-picker/src/panel/time.vue"
	/* harmony default export */ var panel_time = (time_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
	var year_tablevue_type_template_id_c86ab5e0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "table",
	    { staticClass: "el-year-table", on: { click: _vm.handleYearTableClick } },
	    [
	      _c("tbody", [
	        _c("tr", [
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 0)
	            },
	            [_c("a", { staticClass: "cell" }, [_vm._v(_vm._s(_vm.startYear))])]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 1)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 1))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 2)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 2))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 3)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 3))
	              ])
	            ]
	          )
	        ]),
	        _c("tr", [
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 4)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 4))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 5)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 5))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 6)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 6))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 7)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 7))
	              ])
	            ]
	          )
	        ]),
	        _c("tr", [
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 8)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 8))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 9)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 9))
	              ])
	            ]
	          ),
	          _c("td"),
	          _c("td")
	        ])
	      ])
	    ]
	  )
	}
	var year_tablevue_type_template_id_c86ab5e0_staticRenderFns = []
	year_tablevue_type_template_id_c86ab5e0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var year_tablevue_type_script_lang_js_datesInYear = function datesInYear(year) {
	  var numOfDays = Object(date_util_["getDayCountOfYear"])(year);
	  var firstDay = new Date(year, 0, 1);
	  return Object(date_util_["range"])(numOfDays).map(function (n) {
	    return Object(date_util_["nextDate"])(firstDay, n);
	  });
	};
	
	/* harmony default export */ var year_tablevue_type_script_lang_js_ = ({
	  props: {
	    disabledDate: {},
	    value: {},
	    defaultValue: {
	      validator: function validator(val) {
	        // null or valid Date Object
	        return val === null || val instanceof Date && Object(date_util_["isDate"])(val);
	      }
	    },
	    date: {}
	  },
	
	  computed: {
	    startYear: function startYear() {
	      return Math.floor(this.date.getFullYear() / 10) * 10;
	    }
	  },
	
	  methods: {
	    getCellStyle: function getCellStyle(year) {
	      var style = {};
	      var today = new Date();
	
	      style.disabled = typeof this.disabledDate === 'function' ? year_tablevue_type_script_lang_js_datesInYear(year).every(this.disabledDate) : false;
	      style.current = Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value), function (date) {
	        return date.getFullYear() === year;
	      }) >= 0;
	      style.today = today.getFullYear() === year;
	      style.default = this.defaultValue && this.defaultValue.getFullYear() === year;
	
	      return style;
	    },
	    handleYearTableClick: function handleYearTableClick(event) {
	      var target = event.target;
	      if (target.tagName === 'A') {
	        if (Object(dom_["hasClass"])(target.parentNode, 'disabled')) return;
	        var year = target.textContent || target.innerText;
	        this.$emit('pick', Number(year));
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_year_tablevue_type_script_lang_js_ = (year_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue
	
	
	
	
	
	/* normalize component */
	
	var year_table_component = normalizeComponent(
	  basic_year_tablevue_type_script_lang_js_,
	  year_tablevue_type_template_id_c86ab5e0_render,
	  year_tablevue_type_template_id_c86ab5e0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var year_table_api; }
	year_table_component.options.__file = "packages/date-picker/src/basic/year-table.vue"
	/* harmony default export */ var year_table = (year_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
	var month_tablevue_type_template_id_654d4f42_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "table",
	    {
	      staticClass: "el-month-table",
	      on: { click: _vm.handleMonthTableClick, mousemove: _vm.handleMouseMove }
	    },
	    [
	      _c(
	        "tbody",
	        _vm._l(_vm.rows, function(row, key) {
	          return _c(
	            "tr",
	            { key: key },
	            _vm._l(row, function(cell, key) {
	              return _c("td", { key: key, class: _vm.getCellStyle(cell) }, [
	                _c("div", [
	                  _c("a", { staticClass: "cell" }, [
	                    _vm._v(
	                      _vm._s(
	                        _vm.t("el.datepicker.months." + _vm.months[cell.text])
	                      )
	                    )
	                  ])
	                ])
	              ])
	            }),
	            0
	          )
	        }),
	        0
	      )
	    ]
	  )
	}
	var month_tablevue_type_template_id_654d4f42_staticRenderFns = []
	month_tablevue_type_template_id_654d4f42_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	var month_tablevue_type_script_lang_js_datesInMonth = function datesInMonth(year, month) {
	  var numOfDays = Object(date_util_["getDayCountOfMonth"])(year, month);
	  var firstDay = new Date(year, month, 1);
	  return Object(date_util_["range"])(numOfDays).map(function (n) {
	    return Object(date_util_["nextDate"])(firstDay, n);
	  });
	};
	
	var clearDate = function clearDate(date) {
	  return new Date(date.getFullYear(), date.getMonth());
	};
	
	var getMonthTimestamp = function getMonthTimestamp(time) {
	  if (typeof time === 'number' || typeof time === 'string') {
	    return clearDate(new Date(time)).getTime();
	  } else if (time instanceof Date) {
	    return clearDate(time).getTime();
	  } else {
	    return NaN;
	  }
	};
	/* harmony default export */ var month_tablevue_type_script_lang_js_ = ({
	  props: {
	    disabledDate: {},
	    value: {},
	    selectionMode: {
	      default: 'month'
	    },
	    minDate: {},
	
	    maxDate: {},
	    defaultValue: {
	      validator: function validator(val) {
	        // null or valid Date Object
	        return val === null || Object(date_util_["isDate"])(val) || Array.isArray(val) && val.every(date_util_["isDate"]);
	      }
	    },
	    date: {},
	    rangeState: {
	      default: function _default() {
	        return {
	          endDate: null,
	          selecting: false
	        };
	      }
	    }
	  },
	
	  mixins: [locale_default.a],
	
	  watch: {
	    'rangeState.endDate': function rangeStateEndDate(newVal) {
	      this.markRange(this.minDate, newVal);
	    },
	    minDate: function minDate(newVal, oldVal) {
	      if (getMonthTimestamp(newVal) !== getMonthTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    },
	    maxDate: function maxDate(newVal, oldVal) {
	      if (getMonthTimestamp(newVal) !== getMonthTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      months: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
	      tableRows: [[], [], []],
	      lastRow: null,
	      lastColumn: null
	    };
	  },
	
	
	  methods: {
	    cellMatchesDate: function cellMatchesDate(cell, date) {
	      var value = new Date(date);
	      return this.date.getFullYear() === value.getFullYear() && Number(cell.text) === value.getMonth();
	    },
	    getCellStyle: function getCellStyle(cell) {
	      var _this = this;
	
	      var style = {};
	      var year = this.date.getFullYear();
	      var today = new Date();
	      var month = cell.text;
	      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];
	      style.disabled = typeof this.disabledDate === 'function' ? month_tablevue_type_script_lang_js_datesInMonth(year, month).every(this.disabledDate) : false;
	      style.current = Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value), function (date) {
	        return date.getFullYear() === year && date.getMonth() === month;
	      }) >= 0;
	      style.today = today.getFullYear() === year && today.getMonth() === month;
	      style.default = defaultValue.some(function (date) {
	        return _this.cellMatchesDate(cell, date);
	      });
	
	      if (cell.inRange) {
	        style['in-range'] = true;
	
	        if (cell.start) {
	          style['start-date'] = true;
	        }
	
	        if (cell.end) {
	          style['end-date'] = true;
	        }
	      }
	      return style;
	    },
	    getMonthOfCell: function getMonthOfCell(month) {
	      var year = this.date.getFullYear();
	      return new Date(year, month, 1);
	    },
	    markRange: function markRange(minDate, maxDate) {
	      minDate = getMonthTimestamp(minDate);
	      maxDate = getMonthTimestamp(maxDate) || minDate;
	      var _ref = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
	      minDate = _ref[0];
	      maxDate = _ref[1];
	
	      var rows = this.rows;
	      for (var i = 0, k = rows.length; i < k; i++) {
	        var row = rows[i];
	        for (var j = 0, l = row.length; j < l; j++) {
	
	          var cell = row[j];
	          var index = i * 4 + j;
	          var time = new Date(this.date.getFullYear(), index).getTime();
	
	          cell.inRange = minDate && time >= minDate && time <= maxDate;
	          cell.start = minDate && time === minDate;
	          cell.end = maxDate && time === maxDate;
	        }
	      }
	    },
	    handleMouseMove: function handleMouseMove(event) {
	      if (!this.rangeState.selecting) return;
	
	      var target = event.target;
	      if (target.tagName === 'A') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	      if (target.tagName !== 'TD') return;
	
	      var row = target.parentNode.rowIndex;
	      var column = target.cellIndex;
	      // can not select disabled date
	      if (this.rows[row][column].disabled) return;
	
	      // only update rangeState when mouse moves to a new cell
	      // this avoids frequent Date object creation and improves performance
	      if (row !== this.lastRow || column !== this.lastColumn) {
	        this.lastRow = row;
	        this.lastColumn = column;
	        this.$emit('changerange', {
	          minDate: this.minDate,
	          maxDate: this.maxDate,
	          rangeState: {
	            selecting: true,
	            endDate: this.getMonthOfCell(row * 4 + column)
	          }
	        });
	      }
	    },
	    handleMonthTableClick: function handleMonthTableClick(event) {
	      var target = event.target;
	      if (target.tagName === 'A') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	      if (target.tagName !== 'TD') return;
	      if (Object(dom_["hasClass"])(target, 'disabled')) return;
	      var column = target.cellIndex;
	      var row = target.parentNode.rowIndex;
	      var month = row * 4 + column;
	      var newDate = this.getMonthOfCell(month);
	      if (this.selectionMode === 'range') {
	        if (!this.rangeState.selecting) {
	          this.$emit('pick', { minDate: newDate, maxDate: null });
	          this.rangeState.selecting = true;
	        } else {
	          if (newDate >= this.minDate) {
	            this.$emit('pick', { minDate: this.minDate, maxDate: newDate });
	          } else {
	            this.$emit('pick', { minDate: newDate, maxDate: this.minDate });
	          }
	          this.rangeState.selecting = false;
	        }
	      } else {
	        this.$emit('pick', month);
	      }
	    }
	  },
	
	  computed: {
	    rows: function rows() {
	      var _this2 = this;
	
	      // TODO: refactory rows / getCellClasses
	      var rows = this.tableRows;
	      var disabledDate = this.disabledDate;
	      var selectedDate = [];
	      var now = getMonthTimestamp(new Date());
	
	      for (var i = 0; i < 3; i++) {
	        var row = rows[i];
	
	        var _loop = function _loop(j) {
	          var cell = row[j];
	          if (!cell) {
	            cell = { row: i, column: j, type: 'normal', inRange: false, start: false, end: false };
	          }
	
	          cell.type = 'normal';
	
	          var index = i * 4 + j;
	          var time = new Date(_this2.date.getFullYear(), index).getTime();
	          cell.inRange = time >= getMonthTimestamp(_this2.minDate) && time <= getMonthTimestamp(_this2.maxDate);
	          cell.start = _this2.minDate && time === getMonthTimestamp(_this2.minDate);
	          cell.end = _this2.maxDate && time === getMonthTimestamp(_this2.maxDate);
	          var isToday = time === now;
	
	          if (isToday) {
	            cell.type = 'today';
	          }
	          cell.text = index;
	          var cellDate = new Date(time);
	          cell.disabled = typeof disabledDate === 'function' && disabledDate(cellDate);
	          cell.selected = Object(util_["arrayFind"])(selectedDate, function (date) {
	            return date.getTime() === cellDate.getTime();
	          });
	
	          _this2.$set(row, j, cell);
	        };
	
	        for (var j = 0; j < 4; j++) {
	          _loop(j);
	        }
	      }
	      return rows;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_month_tablevue_type_script_lang_js_ = (month_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue
	
	
	
	
	
	/* normalize component */
	
	var month_table_component = normalizeComponent(
	  basic_month_tablevue_type_script_lang_js_,
	  month_tablevue_type_template_id_654d4f42_render,
	  month_tablevue_type_template_id_654d4f42_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var month_table_api; }
	month_table_component.options.__file = "packages/date-picker/src/basic/month-table.vue"
	/* harmony default export */ var month_table = (month_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
	var date_tablevue_type_template_id_5d1f3341_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "table",
	    {
	      staticClass: "el-date-table",
	      class: { "is-week-mode": _vm.selectionMode === "week" },
	      attrs: { cellspacing: "0", cellpadding: "0" },
	      on: { click: _vm.handleClick, mousemove: _vm.handleMouseMove }
	    },
	    [
	      _c(
	        "tbody",
	        [
	          _c(
	            "tr",
	            [
	              _vm.showWeekNumber
	                ? _c("th", [_vm._v(_vm._s(_vm.t("el.datepicker.week")))])
	                : _vm._e(),
	              _vm._l(_vm.WEEKS, function(week, key) {
	                return _c("th", { key: key }, [
	                  _vm._v(_vm._s(_vm.t("el.datepicker.weeks." + week)))
	                ])
	              })
	            ],
	            2
	          ),
	          _vm._l(_vm.rows, function(row, key) {
	            return _c(
	              "tr",
	              {
	                key: key,
	                staticClass: "el-date-table__row",
	                class: { current: _vm.isWeekActive(row[1]) }
	              },
	              _vm._l(row, function(cell, key) {
	                return _c("td", { key: key, class: _vm.getCellClasses(cell) }, [
	                  _c("div", [
	                    _c("span", [
	                      _vm._v("\n          " + _vm._s(cell.text) + "\n        ")
	                    ])
	                  ])
	                ])
	              }),
	              0
	            )
	          })
	        ],
	        2
	      )
	    ]
	  )
	}
	var date_tablevue_type_template_id_5d1f3341_staticRenderFns = []
	date_tablevue_type_template_id_5d1f3341_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var _WEEKS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
	var date_tablevue_type_script_lang_js_getDateTimestamp = function getDateTimestamp(time) {
	  if (typeof time === 'number' || typeof time === 'string') {
	    return Object(date_util_["clearTime"])(new Date(time)).getTime();
	  } else if (time instanceof Date) {
	    return Object(date_util_["clearTime"])(time).getTime();
	  } else {
	    return NaN;
	  }
	};
	
	// remove the first element that satisfies `pred` from arr
	// return a new array if modification occurs
	// return the original array otherwise
	var date_tablevue_type_script_lang_js_removeFromArray = function removeFromArray(arr, pred) {
	  var idx = typeof pred === 'function' ? Object(util_["arrayFindIndex"])(arr, pred) : arr.indexOf(pred);
	  return idx >= 0 ? [].concat(arr.slice(0, idx), arr.slice(idx + 1)) : arr;
	};
	
	/* harmony default export */ var date_tablevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  props: {
	    firstDayOfWeek: {
	      default: 7,
	      type: Number,
	      validator: function validator(val) {
	        return val >= 1 && val <= 7;
	      }
	    },
	
	    value: {},
	
	    defaultValue: {
	      validator: function validator(val) {
	        // either: null, valid Date object, Array of valid Date objects
	        return val === null || Object(date_util_["isDate"])(val) || Array.isArray(val) && val.every(date_util_["isDate"]);
	      }
	    },
	
	    date: {},
	
	    selectionMode: {
	      default: 'day'
	    },
	
	    showWeekNumber: {
	      type: Boolean,
	      default: false
	    },
	
	    disabledDate: {},
	
	    cellClassName: {},
	
	    minDate: {},
	
	    maxDate: {},
	
	    rangeState: {
	      default: function _default() {
	        return {
	          endDate: null,
	          selecting: false
	        };
	      }
	    }
	  },
	
	  computed: {
	    offsetDay: function offsetDay() {
	      var week = this.firstDayOfWeek;
	      // 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置
	      return week > 3 ? 7 - week : -week;
	    },
	    WEEKS: function WEEKS() {
	      var week = this.firstDayOfWeek;
	      return _WEEKS.concat(_WEEKS).slice(week, week + 7);
	    },
	    year: function year() {
	      return this.date.getFullYear();
	    },
	    month: function month() {
	      return this.date.getMonth();
	    },
	    startDate: function startDate() {
	      return Object(date_util_["getStartDateOfMonth"])(this.year, this.month);
	    },
	    rows: function rows() {
	      var _this = this;
	
	      // TODO: refactory rows / getCellClasses
	      var date = new Date(this.year, this.month, 1);
	      var day = Object(date_util_["getFirstDayOfMonth"])(date); // day of first day
	      var dateCountOfMonth = Object(date_util_["getDayCountOfMonth"])(date.getFullYear(), date.getMonth());
	      var dateCountOfLastMonth = Object(date_util_["getDayCountOfMonth"])(date.getFullYear(), date.getMonth() === 0 ? 11 : date.getMonth() - 1);
	
	      day = day === 0 ? 7 : day;
	
	      var offset = this.offsetDay;
	      var rows = this.tableRows;
	      var count = 1;
	
	      var startDate = this.startDate;
	      var disabledDate = this.disabledDate;
	      var cellClassName = this.cellClassName;
	      var selectedDate = this.selectionMode === 'dates' ? Object(util_["coerceTruthyValueToArray"])(this.value) : [];
	      var now = date_tablevue_type_script_lang_js_getDateTimestamp(new Date());
	
	      for (var i = 0; i < 6; i++) {
	        var row = rows[i];
	
	        if (this.showWeekNumber) {
	          if (!row[0]) {
	            row[0] = { type: 'week', text: Object(date_util_["getWeekNumber"])(Object(date_util_["nextDate"])(startDate, i * 7 + 1)) };
	          }
	        }
	
	        var _loop = function _loop(j) {
	          var cell = row[_this.showWeekNumber ? j + 1 : j];
	          if (!cell) {
	            cell = { row: i, column: j, type: 'normal', inRange: false, start: false, end: false };
	          }
	
	          cell.type = 'normal';
	
	          var index = i * 7 + j;
	          var time = Object(date_util_["nextDate"])(startDate, index - offset).getTime();
	          cell.inRange = time >= date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate) && time <= date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);
	          cell.start = _this.minDate && time === date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate);
	          cell.end = _this.maxDate && time === date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);
	          var isToday = time === now;
	
	          if (isToday) {
	            cell.type = 'today';
	          }
	
	          if (i >= 0 && i <= 1) {
	            var numberOfDaysFromPreviousMonth = day + offset < 0 ? 7 + day + offset : day + offset;
	
	            if (j + i * 7 >= numberOfDaysFromPreviousMonth) {
	              cell.text = count++;
	            } else {
	              cell.text = dateCountOfLastMonth - (numberOfDaysFromPreviousMonth - j % 7) + 1 + i * 7;
	              cell.type = 'prev-month';
	            }
	          } else {
	            if (count <= dateCountOfMonth) {
	              cell.text = count++;
	            } else {
	              cell.text = count++ - dateCountOfMonth;
	              cell.type = 'next-month';
	            }
	          }
	
	          var cellDate = new Date(time);
	          cell.disabled = typeof disabledDate === 'function' && disabledDate(cellDate);
	          cell.selected = Object(util_["arrayFind"])(selectedDate, function (date) {
	            return date.getTime() === cellDate.getTime();
	          });
	          cell.customClass = typeof cellClassName === 'function' && cellClassName(cellDate);
	          _this.$set(row, _this.showWeekNumber ? j + 1 : j, cell);
	        };
	
	        for (var j = 0; j < 7; j++) {
	          _loop(j);
	        }
	
	        if (this.selectionMode === 'week') {
	          var start = this.showWeekNumber ? 1 : 0;
	          var end = this.showWeekNumber ? 7 : 6;
	          var isWeekActive = this.isWeekActive(row[start + 1]);
	
	          row[start].inRange = isWeekActive;
	          row[start].start = isWeekActive;
	          row[end].inRange = isWeekActive;
	          row[end].end = isWeekActive;
	        }
	      }
	
	      return rows;
	    }
	  },
	
	  watch: {
	    'rangeState.endDate': function rangeStateEndDate(newVal) {
	      this.markRange(this.minDate, newVal);
	    },
	    minDate: function minDate(newVal, oldVal) {
	      if (date_tablevue_type_script_lang_js_getDateTimestamp(newVal) !== date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    },
	    maxDate: function maxDate(newVal, oldVal) {
	      if (date_tablevue_type_script_lang_js_getDateTimestamp(newVal) !== date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      tableRows: [[], [], [], [], [], []],
	      lastRow: null,
	      lastColumn: null
	    };
	  },
	
	
	  methods: {
	    cellMatchesDate: function cellMatchesDate(cell, date) {
	      var value = new Date(date);
	      return this.year === value.getFullYear() && this.month === value.getMonth() && Number(cell.text) === value.getDate();
	    },
	    getCellClasses: function getCellClasses(cell) {
	      var _this2 = this;
	
	      var selectionMode = this.selectionMode;
	      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];
	
	      var classes = [];
	      if ((cell.type === 'normal' || cell.type === 'today') && !cell.disabled) {
	        classes.push('available');
	        if (cell.type === 'today') {
	          classes.push('today');
	        }
	      } else {
	        classes.push(cell.type);
	      }
	
	      if (cell.type === 'normal' && defaultValue.some(function (date) {
	        return _this2.cellMatchesDate(cell, date);
	      })) {
	        classes.push('default');
	      }
	
	      if (selectionMode === 'day' && (cell.type === 'normal' || cell.type === 'today') && this.cellMatchesDate(cell, this.value)) {
	        classes.push('current');
	      }
	
	      if (cell.inRange && (cell.type === 'normal' || cell.type === 'today' || this.selectionMode === 'week')) {
	        classes.push('in-range');
	
	        if (cell.start) {
	          classes.push('start-date');
	        }
	
	        if (cell.end) {
	          classes.push('end-date');
	        }
	      }
	
	      if (cell.disabled) {
	        classes.push('disabled');
	      }
	
	      if (cell.selected) {
	        classes.push('selected');
	      }
	
	      if (cell.customClass) {
	        classes.push(cell.customClass);
	      }
	
	      return classes.join(' ');
	    },
	    getDateOfCell: function getDateOfCell(row, column) {
	      var offsetFromStart = row * 7 + (column - (this.showWeekNumber ? 1 : 0)) - this.offsetDay;
	      return Object(date_util_["nextDate"])(this.startDate, offsetFromStart);
	    },
	    isWeekActive: function isWeekActive(cell) {
	      if (this.selectionMode !== 'week') return false;
	      var newDate = new Date(this.year, this.month, 1);
	      var year = newDate.getFullYear();
	      var month = newDate.getMonth();
	
	      if (cell.type === 'prev-month') {
	        newDate.setMonth(month === 0 ? 11 : month - 1);
	        newDate.setFullYear(month === 0 ? year - 1 : year);
	      }
	
	      if (cell.type === 'next-month') {
	        newDate.setMonth(month === 11 ? 0 : month + 1);
	        newDate.setFullYear(month === 11 ? year + 1 : year);
	      }
	
	      newDate.setDate(parseInt(cell.text, 10));
	
	      if (Object(date_util_["isDate"])(this.value)) {
	        var dayOffset = (this.value.getDay() - this.firstDayOfWeek + 7) % 7 - 1;
	        var weekDate = Object(date_util_["prevDate"])(this.value, dayOffset);
	        return weekDate.getTime() === newDate.getTime();
	      }
	      return false;
	    },
	    markRange: function markRange(minDate, maxDate) {
	      minDate = date_tablevue_type_script_lang_js_getDateTimestamp(minDate);
	      maxDate = date_tablevue_type_script_lang_js_getDateTimestamp(maxDate) || minDate;
	      var _ref = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
	      minDate = _ref[0];
	      maxDate = _ref[1];
	
	
	      var startDate = this.startDate;
	      var rows = this.rows;
	      for (var i = 0, k = rows.length; i < k; i++) {
	        var row = rows[i];
	        for (var j = 0, l = row.length; j < l; j++) {
	          if (this.showWeekNumber && j === 0) continue;
	
	          var _cell = row[j];
	          var index = i * 7 + j + (this.showWeekNumber ? -1 : 0);
	          var time = Object(date_util_["nextDate"])(startDate, index - this.offsetDay).getTime();
	
	          _cell.inRange = minDate && time >= minDate && time <= maxDate;
	          _cell.start = minDate && time === minDate;
	          _cell.end = maxDate && time === maxDate;
	        }
	      }
	    },
	    handleMouseMove: function handleMouseMove(event) {
	      if (!this.rangeState.selecting) return;
	
	      var target = event.target;
	      if (target.tagName === 'SPAN') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	      if (target.tagName !== 'TD') return;
	
	      var row = target.parentNode.rowIndex - 1;
	      var column = target.cellIndex;
	
	      // can not select disabled date
	      if (this.rows[row][column].disabled) return;
	
	      // only update rangeState when mouse moves to a new cell
	      // this avoids frequent Date object creation and improves performance
	      if (row !== this.lastRow || column !== this.lastColumn) {
	        this.lastRow = row;
	        this.lastColumn = column;
	        this.$emit('changerange', {
	          minDate: this.minDate,
	          maxDate: this.maxDate,
	          rangeState: {
	            selecting: true,
	            endDate: this.getDateOfCell(row, column)
	          }
	        });
	      }
	    },
	    handleClick: function handleClick(event) {
	      var target = event.target;
	      if (target.tagName === 'SPAN') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	
	      if (target.tagName !== 'TD') return;
	
	      var row = target.parentNode.rowIndex - 1;
	      var column = this.selectionMode === 'week' ? 1 : target.cellIndex;
	      var cell = this.rows[row][column];
	
	      if (cell.disabled || cell.type === 'week') return;
	
	      var newDate = this.getDateOfCell(row, column);
	
	      if (this.selectionMode === 'range') {
	        if (!this.rangeState.selecting) {
	          this.$emit('pick', { minDate: newDate, maxDate: null });
	          this.rangeState.selecting = true;
	        } else {
	          if (newDate >= this.minDate) {
	            this.$emit('pick', { minDate: this.minDate, maxDate: newDate });
	          } else {
	            this.$emit('pick', { minDate: newDate, maxDate: this.minDate });
	          }
	          this.rangeState.selecting = false;
	        }
	      } else if (this.selectionMode === 'day') {
	        this.$emit('pick', newDate);
	      } else if (this.selectionMode === 'week') {
	        var weekNumber = Object(date_util_["getWeekNumber"])(newDate);
	        var value = newDate.getFullYear() + 'w' + weekNumber;
	        this.$emit('pick', {
	          year: newDate.getFullYear(),
	          week: weekNumber,
	          value: value,
	          date: newDate
	        });
	      } else if (this.selectionMode === 'dates') {
	        var _value = this.value || [];
	        var newValue = cell.selected ? date_tablevue_type_script_lang_js_removeFromArray(_value, function (date) {
	          return date.getTime() === newDate.getTime();
	        }) : [].concat(_value, [newDate]);
	        this.$emit('pick', newValue);
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_date_tablevue_type_script_lang_js_ = (date_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue
	
	
	
	
	
	/* normalize component */
	
	var date_table_component = normalizeComponent(
	  basic_date_tablevue_type_script_lang_js_,
	  date_tablevue_type_template_id_5d1f3341_render,
	  date_tablevue_type_template_id_5d1f3341_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var date_table_api; }
	date_table_component.options.__file = "packages/date-picker/src/basic/date-table.vue"
	/* harmony default export */ var date_table = (date_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var datevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  watch: {
	    showTime: function showTime(val) {
	      var _this = this;
	
	      /* istanbul ignore if */
	      if (!val) return;
	      this.$nextTick(function (_) {
	        var inputElm = _this.$refs.input.$el;
	        if (inputElm) {
	          _this.pickerWidth = inputElm.getBoundingClientRect().width + 10;
	        }
	      });
	    },
	    value: function value(val) {
	      if (this.selectionMode === 'dates' && this.value) return;
	      if (Object(date_util_["isDate"])(val)) {
	        this.date = new Date(val);
	      } else {
	        this.date = this.getDefaultValue();
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Object(date_util_["isDate"])(this.value)) {
	        this.date = val ? new Date(val) : new Date();
	      }
	    },
	    timePickerVisible: function timePickerVisible(val) {
	      var _this2 = this;
	
	      if (val) this.$nextTick(function () {
	        return _this2.$refs.timepicker.adjustSpinners();
	      });
	    },
	    selectionMode: function selectionMode(newVal) {
	      if (newVal === 'month') {
	        /* istanbul ignore next */
	        if (this.currentView !== 'year' || this.currentView !== 'month') {
	          this.currentView = 'month';
	        }
	      } else if (newVal === 'dates') {
	        this.currentView = 'date';
	      }
	    }
	  },
	
	  methods: {
	    proxyTimePickerDataProperties: function proxyTimePickerDataProperties() {
	      var _this3 = this;
	
	      var format = function format(timeFormat) {
	        _this3.$refs.timepicker.format = timeFormat;
	      };
	      var value = function value(_value) {
	        _this3.$refs.timepicker.value = _value;
	      };
	      var date = function date(_date) {
	        _this3.$refs.timepicker.date = _date;
	      };
	      var selectableRange = function selectableRange(_selectableRange) {
	        _this3.$refs.timepicker.selectableRange = _selectableRange;
	      };
	
	      this.$watch('value', value);
	      this.$watch('date', date);
	      this.$watch('selectableRange', selectableRange);
	
	      format(this.timeFormat);
	      value(this.value);
	      date(this.date);
	      selectableRange(this.selectableRange);
	    },
	    handleClear: function handleClear() {
	      this.date = this.getDefaultValue();
	      this.$emit('pick', null);
	    },
	    emit: function emit(value) {
	      var _this4 = this;
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      if (!value) {
	        this.$emit.apply(this, ['pick', value].concat(args));
	      } else if (Array.isArray(value)) {
	        var dates = value.map(function (date) {
	          return _this4.showTime ? Object(date_util_["clearMilliseconds"])(date) : Object(date_util_["clearTime"])(date);
	        });
	        this.$emit.apply(this, ['pick', dates].concat(args));
	      } else {
	        this.$emit.apply(this, ['pick', this.showTime ? Object(date_util_["clearMilliseconds"])(value) : Object(date_util_["clearTime"])(value)].concat(args));
	      }
	      this.userInputDate = null;
	      this.userInputTime = null;
	    },
	
	
	    // resetDate() {
	    //   this.date = new Date(this.date);
	    // },
	
	    showMonthPicker: function showMonthPicker() {
	      this.currentView = 'month';
	    },
	    showYearPicker: function showYearPicker() {
	      this.currentView = 'year';
	    },
	
	
	    // XXX: 没用到
	    // handleLabelClick() {
	    //   if (this.currentView === 'date') {
	    //     this.showMonthPicker();
	    //   } else if (this.currentView === 'month') {
	    //     this.showYearPicker();
	    //   }
	    // },
	
	    prevMonth: function prevMonth() {
	      this.date = Object(date_util_["prevMonth"])(this.date);
	    },
	    nextMonth: function nextMonth() {
	      this.date = Object(date_util_["nextMonth"])(this.date);
	    },
	    prevYear: function prevYear() {
	      if (this.currentView === 'year') {
	        this.date = Object(date_util_["prevYear"])(this.date, 10);
	      } else {
	        this.date = Object(date_util_["prevYear"])(this.date);
	      }
	    },
	    nextYear: function nextYear() {
	      if (this.currentView === 'year') {
	        this.date = Object(date_util_["nextYear"])(this.date, 10);
	      } else {
	        this.date = Object(date_util_["nextYear"])(this.date);
	      }
	    },
	    handleShortcutClick: function handleShortcutClick(shortcut) {
	      if (shortcut.onClick) {
	        shortcut.onClick(this);
	      }
	    },
	    handleTimePick: function handleTimePick(value, visible, first) {
	      if (Object(date_util_["isDate"])(value)) {
	        var newDate = this.value ? Object(date_util_["modifyTime"])(this.value, value.getHours(), value.getMinutes(), value.getSeconds()) : Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(), this.defaultTime);
	        this.date = newDate;
	        this.emit(this.date, true);
	      } else {
	        this.emit(value, true);
	      }
	      if (!first) {
	        this.timePickerVisible = visible;
	      }
	    },
	    handleTimePickClose: function handleTimePickClose() {
	      this.timePickerVisible = false;
	    },
	    handleMonthPick: function handleMonthPick(month) {
	      if (this.selectionMode === 'month') {
	        this.date = Object(date_util_["modifyDate"])(this.date, this.year, month, 1);
	        this.emit(this.date);
	      } else {
	        this.date = Object(date_util_["changeYearMonthAndClampDate"])(this.date, this.year, month);
	        // TODO: should emit intermediate value ??
	        // this.emit(this.date);
	        this.currentView = 'date';
	      }
	    },
	    handleDatePick: function handleDatePick(value) {
	      if (this.selectionMode === 'day') {
	        var newDate = this.value ? Object(date_util_["modifyDate"])(this.value, value.getFullYear(), value.getMonth(), value.getDate()) : Object(date_util_["modifyWithTimeString"])(value, this.defaultTime);
	        // change default time while out of selectableRange
	        if (!this.checkDateWithinRange(newDate)) {
	          newDate = Object(date_util_["modifyDate"])(this.selectableRange[0][0], value.getFullYear(), value.getMonth(), value.getDate());
	        }
	        this.date = newDate;
	        this.emit(this.date, this.showTime);
	      } else if (this.selectionMode === 'week') {
	        this.emit(value.date);
	      } else if (this.selectionMode === 'dates') {
	        this.emit(value, true); // set false to keep panel open
	      }
	    },
	    handleYearPick: function handleYearPick(year) {
	      if (this.selectionMode === 'year') {
	        this.date = Object(date_util_["modifyDate"])(this.date, year, 0, 1);
	        this.emit(this.date);
	      } else {
	        this.date = Object(date_util_["changeYearMonthAndClampDate"])(this.date, year, this.month);
	        // TODO: should emit intermediate value ??
	        // this.emit(this.date, true);
	        this.currentView = 'month';
	      }
	    },
	    changeToNow: function changeToNow() {
	      // NOTE: not a permanent solution
	      //       consider disable "now" button in the future
	      if ((!this.disabledDate || !this.disabledDate(new Date())) && this.checkDateWithinRange(new Date())) {
	        this.date = new Date();
	        this.emit(this.date);
	      }
	    },
	    confirm: function confirm() {
	      if (this.selectionMode === 'dates') {
	        this.emit(this.value);
	      } else {
	        // value were emitted in handle{Date,Time}Pick, nothing to update here
	        // deal with the scenario where: user opens the picker, then confirm without doing anything
	        var value = this.value ? this.value : Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(), this.defaultTime);
	        this.date = new Date(value); // refresh date
	        this.emit(value);
	      }
	    },
	    resetView: function resetView() {
	      if (this.selectionMode === 'month') {
	        this.currentView = 'month';
	      } else if (this.selectionMode === 'year') {
	        this.currentView = 'year';
	      } else {
	        this.currentView = 'date';
	      }
	    },
	    handleEnter: function handleEnter() {
	      document.body.addEventListener('keydown', this.handleKeydown);
	    },
	    handleLeave: function handleLeave() {
	      this.$emit('dodestroy');
	      document.body.removeEventListener('keydown', this.handleKeydown);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      var list = [38, 40, 37, 39];
	      if (this.visible && !this.timePickerVisible) {
	        if (list.indexOf(keyCode) !== -1) {
	          this.handleKeyControl(keyCode);
	          event.stopPropagation();
	          event.preventDefault();
	        }
	        if (keyCode === 13 && this.userInputDate === null && this.userInputTime === null) {
	          // Enter
	          this.emit(this.date, false);
	        }
	      }
	    },
	    handleKeyControl: function handleKeyControl(keyCode) {
	      var mapping = {
	        'year': {
	          38: -4, 40: 4, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setFullYear(date.getFullYear() + step);
	          }
	        },
	        'month': {
	          38: -4, 40: 4, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setMonth(date.getMonth() + step);
	          }
	        },
	        'week': {
	          38: -1, 40: 1, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setDate(date.getDate() + step * 7);
	          }
	        },
	        'day': {
	          38: -7, 40: 7, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setDate(date.getDate() + step);
	          }
	        }
	      };
	      var mode = this.selectionMode;
	      var year = 3.1536e10;
	      var now = this.date.getTime();
	      var newDate = new Date(this.date.getTime());
	      while (Math.abs(now - newDate.getTime()) <= year) {
	        var map = mapping[mode];
	        map.offset(newDate, map[keyCode]);
	        if (typeof this.disabledDate === 'function' && this.disabledDate(newDate)) {
	          continue;
	        }
	        this.date = newDate;
	        this.$emit('pick', newDate, true);
	        break;
	      }
	    },
	    handleVisibleTimeChange: function handleVisibleTimeChange(value) {
	      var time = Object(date_util_["parseDate"])(value, this.timeFormat);
	      if (time && this.checkDateWithinRange(time)) {
	        this.date = Object(date_util_["modifyDate"])(time, this.year, this.month, this.monthDate);
	        this.userInputTime = null;
	        this.$refs.timepicker.value = this.date;
	        this.timePickerVisible = false;
	        this.emit(this.date, true);
	      }
	    },
	    handleVisibleDateChange: function handleVisibleDateChange(value) {
	      var date = Object(date_util_["parseDate"])(value, this.dateFormat);
	      if (date) {
	        if (typeof this.disabledDate === 'function' && this.disabledDate(date)) {
	          return;
	        }
	        this.date = Object(date_util_["modifyTime"])(date, this.date.getHours(), this.date.getMinutes(), this.date.getSeconds());
	        this.userInputDate = null;
	        this.resetView();
	        this.emit(this.date, true);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      return value && !isNaN(value) && (typeof this.disabledDate === 'function' ? !this.disabledDate(value) : true) && this.checkDateWithinRange(value);
	    },
	    getDefaultValue: function getDefaultValue() {
	      // if default-value is set, return it
	      // otherwise, return now (the moment this method gets called)
	      return this.defaultValue ? new Date(this.defaultValue) : new Date();
	    },
	    checkDateWithinRange: function checkDateWithinRange(date) {
	      return this.selectableRange.length > 0 ? Object(date_util_["timeWithinRange"])(date, this.selectableRange, this.format || 'HH:mm:ss') : true;
	    }
	  },
	
	  components: {
	    TimePicker: panel_time, YearTable: year_table, MonthTable: month_table, DateTable: date_table, ElInput: input_default.a, ElButton: button_default.a
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      date: new Date(),
	      value: '',
	      defaultValue: null, // use getDefaultValue() for time computation
	      defaultTime: null,
	      showTime: false,
	      selectionMode: 'day',
	      shortcuts: '',
	      visible: false,
	      currentView: 'date',
	      disabledDate: '',
	      cellClassName: '',
	      selectableRange: [],
	      firstDayOfWeek: 7,
	      showWeekNumber: false,
	      timePickerVisible: false,
	      format: '',
	      arrowControl: false,
	      userInputDate: null,
	      userInputTime: null
	    };
	  },
	
	
	  computed: {
	    year: function year() {
	      return this.date.getFullYear();
	    },
	    month: function month() {
	      return this.date.getMonth();
	    },
	    week: function week() {
	      return Object(date_util_["getWeekNumber"])(this.date);
	    },
	    monthDate: function monthDate() {
	      return this.date.getDate();
	    },
	    footerVisible: function footerVisible() {
	      return this.showTime || this.selectionMode === 'dates';
	    },
	    visibleTime: function visibleTime() {
	      if (this.userInputTime !== null) {
	        return this.userInputTime;
	      } else {
	        return Object(date_util_["formatDate"])(this.value || this.defaultValue, this.timeFormat);
	      }
	    },
	    visibleDate: function visibleDate() {
	      if (this.userInputDate !== null) {
	        return this.userInputDate;
	      } else {
	        return Object(date_util_["formatDate"])(this.value || this.defaultValue, this.dateFormat);
	      }
	    },
	    yearLabel: function yearLabel() {
	      var yearTranslation = this.t('el.datepicker.year');
	      if (this.currentView === 'year') {
	        var startYear = Math.floor(this.year / 10) * 10;
	        if (yearTranslation) {
	          return startYear + ' ' + yearTranslation + ' - ' + (startYear + 9) + ' ' + yearTranslation;
	        }
	        return startYear + ' - ' + (startYear + 9);
	      }
	      return this.year + ' ' + yearTranslation;
	    },
	    timeFormat: function timeFormat() {
	      if (this.format) {
	        return Object(date_util_["extractTimeFormat"])(this.format);
	      } else {
	        return 'HH:mm:ss';
	      }
	    },
	    dateFormat: function dateFormat() {
	      if (this.format) {
	        return Object(date_util_["extractDateFormat"])(this.format);
	      } else {
	        return 'yyyy-MM-dd';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_datevue_type_script_lang_js_ = (datevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue
	
	
	
	
	
	/* normalize component */
	
	var date_component = normalizeComponent(
	  panel_datevue_type_script_lang_js_,
	  datevue_type_template_id_2440d4ea_render,
	  datevue_type_template_id_2440d4ea_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var date_api; }
	date_component.options.__file = "packages/date-picker/src/panel/date.vue"
	/* harmony default export */ var panel_date = (date_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
	var date_rangevue_type_template_id_2652849a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-picker-panel el-date-range-picker el-popper",
	          class: [
	            {
	              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts,
	              "has-time": _vm.showTime
	            },
	            _vm.popperClass
	          ]
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-picker-panel__body-wrapper" },
	            [
	              _vm._t("sidebar"),
	              _vm.shortcuts
	                ? _c(
	                    "div",
	                    { staticClass: "el-picker-panel__sidebar" },
	                    _vm._l(_vm.shortcuts, function(shortcut, key) {
	                      return _c(
	                        "button",
	                        {
	                          key: key,
	                          staticClass: "el-picker-panel__shortcut",
	                          attrs: { type: "button" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleShortcutClick(shortcut)
	                            }
	                          }
	                        },
	                        [_vm._v(_vm._s(shortcut.text))]
	                      )
	                    }),
	                    0
	                  )
	                : _vm._e(),
	              _c("div", { staticClass: "el-picker-panel__body" }, [
	                _vm.showTime
	                  ? _c(
	                      "div",
	                      { staticClass: "el-date-range-picker__time-header" },
	                      [
	                        _c(
	                          "span",
	                          { staticClass: "el-date-range-picker__editors-wrap" },
	                          [
	                            _c(
	                              "span",
	                              {
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  ref: "minInput",
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t(
	                                      "el.datepicker.startDate"
	                                    ),
	                                    value: _vm.minVisibleDate
	                                  },
	                                  on: {
	                                    input: function(val) {
	                                      return _vm.handleDateInput(val, "min")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleDateChange(val, "min")
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            ),
	                            _c(
	                              "span",
	                              {
	                                directives: [
	                                  {
	                                    name: "clickoutside",
	                                    rawName: "v-clickoutside",
	                                    value: _vm.handleMinTimeClose,
	                                    expression: "handleMinTimeClose"
	                                  }
	                                ],
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t(
	                                      "el.datepicker.startTime"
	                                    ),
	                                    value: _vm.minVisibleTime
	                                  },
	                                  on: {
	                                    focus: function($event) {
	                                      _vm.minTimePickerVisible = true
	                                    },
	                                    input: function(val) {
	                                      return _vm.handleTimeInput(val, "min")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleTimeChange(val, "min")
	                                    }
	                                  }
	                                }),
	                                _c("time-picker", {
	                                  ref: "minTimePicker",
	                                  attrs: {
	                                    "time-arrow-control": _vm.arrowControl,
	                                    visible: _vm.minTimePickerVisible
	                                  },
	                                  on: {
	                                    pick: _vm.handleMinTimePick,
	                                    mounted: function($event) {
	                                      _vm.$refs.minTimePicker.format =
	                                        _vm.timeFormat
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            )
	                          ]
	                        ),
	                        _c("span", { staticClass: "el-icon-arrow-right" }),
	                        _c(
	                          "span",
	                          {
	                            staticClass:
	                              "el-date-range-picker__editors-wrap is-right"
	                          },
	                          [
	                            _c(
	                              "span",
	                              {
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t("el.datepicker.endDate"),
	                                    value: _vm.maxVisibleDate,
	                                    readonly: !_vm.minDate
	                                  },
	                                  on: {
	                                    input: function(val) {
	                                      return _vm.handleDateInput(val, "max")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleDateChange(val, "max")
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            ),
	                            _c(
	                              "span",
	                              {
	                                directives: [
	                                  {
	                                    name: "clickoutside",
	                                    rawName: "v-clickoutside",
	                                    value: _vm.handleMaxTimeClose,
	                                    expression: "handleMaxTimeClose"
	                                  }
	                                ],
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t("el.datepicker.endTime"),
	                                    value: _vm.maxVisibleTime,
	                                    readonly: !_vm.minDate
	                                  },
	                                  on: {
	                                    focus: function($event) {
	                                      _vm.minDate &&
	                                        (_vm.maxTimePickerVisible = true)
	                                    },
	                                    input: function(val) {
	                                      return _vm.handleTimeInput(val, "max")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleTimeChange(val, "max")
	                                    }
	                                  }
	                                }),
	                                _c("time-picker", {
	                                  ref: "maxTimePicker",
	                                  attrs: {
	                                    "time-arrow-control": _vm.arrowControl,
	                                    visible: _vm.maxTimePickerVisible
	                                  },
	                                  on: {
	                                    pick: _vm.handleMaxTimePick,
	                                    mounted: function($event) {
	                                      _vm.$refs.maxTimePicker.format =
	                                        _vm.timeFormat
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            )
	                          ]
	                        )
	                      ]
	                    )
	                  : _vm._e(),
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-left"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                        attrs: { type: "button" },
	                        on: { click: _vm.leftPrevYear }
	                      }),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-arrow-left",
	                        attrs: { type: "button" },
	                        on: { click: _vm.leftPrevMonth }
	                      }),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.leftNextYear }
	                          })
	                        : _vm._e(),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-arrow-right",
	                            class: { "is-disabled": !_vm.enableMonthArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableMonthArrow
	                            },
	                            on: { click: _vm.leftNextMonth }
	                          })
	                        : _vm._e(),
	                      _c("div", [_vm._v(_vm._s(_vm.leftLabel))])
	                    ]),
	                    _c("date-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.leftDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate,
	                        "cell-class-name": _vm.cellClassName,
	                        "first-day-of-week": _vm.firstDayOfWeek
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                ),
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-right"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.rightPrevYear }
	                          })
	                        : _vm._e(),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-arrow-left",
	                            class: { "is-disabled": !_vm.enableMonthArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableMonthArrow
	                            },
	                            on: { click: _vm.rightPrevMonth }
	                          })
	                        : _vm._e(),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                        attrs: { type: "button" },
	                        on: { click: _vm.rightNextYear }
	                      }),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-arrow-right",
	                        attrs: { type: "button" },
	                        on: { click: _vm.rightNextMonth }
	                      }),
	                      _c("div", [_vm._v(_vm._s(_vm.rightLabel))])
	                    ]),
	                    _c("date-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.rightDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate,
	                        "cell-class-name": _vm.cellClassName,
	                        "first-day-of-week": _vm.firstDayOfWeek
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                )
	              ])
	            ],
	            2
	          ),
	          _vm.showTime
	            ? _c(
	                "div",
	                { staticClass: "el-picker-panel__footer" },
	                [
	                  _c(
	                    "el-button",
	                    {
	                      staticClass: "el-picker-panel__link-btn",
	                      attrs: { size: "mini", type: "text" },
	                      on: { click: _vm.handleClear }
	                    },
	                    [
	                      _vm._v(
	                        "\n        " +
	                          _vm._s(_vm.t("el.datepicker.clear")) +
	                          "\n      "
	                      )
	                    ]
	                  ),
	                  _c(
	                    "el-button",
	                    {
	                      staticClass: "el-picker-panel__link-btn",
	                      attrs: {
	                        plain: "",
	                        size: "mini",
	                        disabled: _vm.btnDisabled
	                      },
	                      on: {
	                        click: function($event) {
	                          _vm.handleConfirm(false)
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n        " +
	                          _vm._s(_vm.t("el.datepicker.confirm")) +
	                          "\n      "
	                      )
	                    ]
	                  )
	                ],
	                1
	              )
	            : _vm._e()
	        ]
	      )
	    ]
	  )
	}
	var date_rangevue_type_template_id_2652849a_staticRenderFns = []
	date_rangevue_type_template_id_2652849a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	var date_rangevue_type_script_lang_js_calcDefaultValue = function calcDefaultValue(defaultValue) {
	  if (Array.isArray(defaultValue)) {
	    return [new Date(defaultValue[0]), new Date(defaultValue[1])];
	  } else if (defaultValue) {
	    return [new Date(defaultValue), Object(date_util_["nextDate"])(new Date(defaultValue), 1)];
	  } else {
	    return [new Date(), Object(date_util_["nextDate"])(new Date(), 1)];
	  }
	};
	
	/* harmony default export */ var date_rangevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  computed: {
	    btnDisabled: function btnDisabled() {
	      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]));
	    },
	    leftLabel: function leftLabel() {
	      return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.leftDate.getMonth() + 1));
	    },
	    rightLabel: function rightLabel() {
	      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.rightDate.getMonth() + 1));
	    },
	    leftYear: function leftYear() {
	      return this.leftDate.getFullYear();
	    },
	    leftMonth: function leftMonth() {
	      return this.leftDate.getMonth();
	    },
	    leftMonthDate: function leftMonthDate() {
	      return this.leftDate.getDate();
	    },
	    rightYear: function rightYear() {
	      return this.rightDate.getFullYear();
	    },
	    rightMonth: function rightMonth() {
	      return this.rightDate.getMonth();
	    },
	    rightMonthDate: function rightMonthDate() {
	      return this.rightDate.getDate();
	    },
	    minVisibleDate: function minVisibleDate() {
	      if (this.dateUserInput.min !== null) return this.dateUserInput.min;
	      if (this.minDate) return Object(date_util_["formatDate"])(this.minDate, this.dateFormat);
	      return '';
	    },
	    maxVisibleDate: function maxVisibleDate() {
	      if (this.dateUserInput.max !== null) return this.dateUserInput.max;
	      if (this.maxDate || this.minDate) return Object(date_util_["formatDate"])(this.maxDate || this.minDate, this.dateFormat);
	      return '';
	    },
	    minVisibleTime: function minVisibleTime() {
	      if (this.timeUserInput.min !== null) return this.timeUserInput.min;
	      if (this.minDate) return Object(date_util_["formatDate"])(this.minDate, this.timeFormat);
	      return '';
	    },
	    maxVisibleTime: function maxVisibleTime() {
	      if (this.timeUserInput.max !== null) return this.timeUserInput.max;
	      if (this.maxDate || this.minDate) return Object(date_util_["formatDate"])(this.maxDate || this.minDate, this.timeFormat);
	      return '';
	    },
	    timeFormat: function timeFormat() {
	      if (this.format) {
	        return Object(date_util_["extractTimeFormat"])(this.format);
	      } else {
	        return 'HH:mm:ss';
	      }
	    },
	    dateFormat: function dateFormat() {
	      if (this.format) {
	        return Object(date_util_["extractDateFormat"])(this.format);
	      } else {
	        return 'yyyy-MM-dd';
	      }
	    },
	    enableMonthArrow: function enableMonthArrow() {
	      var nextMonth = (this.leftMonth + 1) % 12;
	      var yearOffset = this.leftMonth + 1 >= 12 ? 1 : 0;
	      return this.unlinkPanels && new Date(this.leftYear + yearOffset, nextMonth) < new Date(this.rightYear, this.rightMonth);
	    },
	    enableYearArrow: function enableYearArrow() {
	      return this.unlinkPanels && this.rightYear * 12 + this.rightMonth - (this.leftYear * 12 + this.leftMonth + 1) >= 12;
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      value: [],
	      defaultValue: null,
	      defaultTime: null,
	      minDate: '',
	      maxDate: '',
	      leftDate: new Date(),
	      rightDate: Object(date_util_["nextMonth"])(new Date()),
	      rangeState: {
	        endDate: null,
	        selecting: false,
	        row: null,
	        column: null
	      },
	      showTime: false,
	      shortcuts: '',
	      visible: '',
	      disabledDate: '',
	      cellClassName: '',
	      firstDayOfWeek: 7,
	      minTimePickerVisible: false,
	      maxTimePickerVisible: false,
	      format: '',
	      arrowControl: false,
	      unlinkPanels: false,
	      dateUserInput: {
	        min: null,
	        max: null
	      },
	      timeUserInput: {
	        min: null,
	        max: null
	      }
	    };
	  },
	
	
	  watch: {
	    minDate: function minDate(val) {
	      var _this = this;
	
	      this.dateUserInput.min = null;
	      this.timeUserInput.min = null;
	      this.$nextTick(function () {
	        if (_this.$refs.maxTimePicker && _this.maxDate && _this.maxDate < _this.minDate) {
	          var format = 'HH:mm:ss';
	          _this.$refs.maxTimePicker.selectableRange = [[Object(date_util_["parseDate"])(Object(date_util_["formatDate"])(_this.minDate, format), format), Object(date_util_["parseDate"])('23:59:59', format)]];
	        }
	      });
	      if (val && this.$refs.minTimePicker) {
	        this.$refs.minTimePicker.date = val;
	        this.$refs.minTimePicker.value = val;
	      }
	    },
	    maxDate: function maxDate(val) {
	      this.dateUserInput.max = null;
	      this.timeUserInput.max = null;
	      if (val && this.$refs.maxTimePicker) {
	        this.$refs.maxTimePicker.date = val;
	        this.$refs.maxTimePicker.value = val;
	      }
	    },
	    minTimePickerVisible: function minTimePickerVisible(val) {
	      var _this2 = this;
	
	      if (val) {
	        this.$nextTick(function () {
	          _this2.$refs.minTimePicker.date = _this2.minDate;
	          _this2.$refs.minTimePicker.value = _this2.minDate;
	          _this2.$refs.minTimePicker.adjustSpinners();
	        });
	      }
	    },
	    maxTimePickerVisible: function maxTimePickerVisible(val) {
	      var _this3 = this;
	
	      if (val) {
	        this.$nextTick(function () {
	          _this3.$refs.maxTimePicker.date = _this3.maxDate;
	          _this3.$refs.maxTimePicker.value = _this3.maxDate;
	          _this3.$refs.maxTimePicker.adjustSpinners();
	        });
	      }
	    },
	    value: function value(newVal) {
	      if (!newVal) {
	        this.minDate = null;
	        this.maxDate = null;
	      } else if (Array.isArray(newVal)) {
	        this.minDate = Object(date_util_["isDate"])(newVal[0]) ? new Date(newVal[0]) : null;
	        this.maxDate = Object(date_util_["isDate"])(newVal[1]) ? new Date(newVal[1]) : null;
	        if (this.minDate) {
	          this.leftDate = this.minDate;
	          if (this.unlinkPanels && this.maxDate) {
	            var minDateYear = this.minDate.getFullYear();
	            var minDateMonth = this.minDate.getMonth();
	            var maxDateYear = this.maxDate.getFullYear();
	            var maxDateMonth = this.maxDate.getMonth();
	            this.rightDate = minDateYear === maxDateYear && minDateMonth === maxDateMonth ? Object(date_util_["nextMonth"])(this.maxDate) : this.maxDate;
	          } else {
	            this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	          }
	        } else {
	          this.leftDate = date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	          this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	        }
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Array.isArray(this.value)) {
	        var _calcDefaultValue = date_rangevue_type_script_lang_js_calcDefaultValue(val),
	            left = _calcDefaultValue[0],
	            right = _calcDefaultValue[1];
	
	        this.leftDate = left;
	        this.rightDate = val && val[1] && this.unlinkPanels ? right : Object(date_util_["nextMonth"])(this.leftDate);
	      }
	    }
	  },
	
	  methods: {
	    handleClear: function handleClear() {
	      this.minDate = null;
	      this.maxDate = null;
	      this.leftDate = date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	      this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      this.$emit('pick', null);
	    },
	    handleChangeRange: function handleChangeRange(val) {
	      this.minDate = val.minDate;
	      this.maxDate = val.maxDate;
	      this.rangeState = val.rangeState;
	    },
	    handleDateInput: function handleDateInput(value, type) {
	      this.dateUserInput[type] = value;
	      if (value.length !== this.dateFormat.length) return;
	      var parsedValue = Object(date_util_["parseDate"])(value, this.dateFormat);
	
	      if (parsedValue) {
	        if (typeof this.disabledDate === 'function' && this.disabledDate(new Date(parsedValue))) {
	          return;
	        }
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyDate"])(this.minDate || new Date(), parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          this.leftDate = new Date(parsedValue);
	          if (!this.unlinkPanels) {
	            this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	          }
	        } else {
	          this.maxDate = Object(date_util_["modifyDate"])(this.maxDate || new Date(), parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          this.rightDate = new Date(parsedValue);
	          if (!this.unlinkPanels) {
	            this.leftDate = Object(date_util_["prevMonth"])(parsedValue);
	          }
	        }
	      }
	    },
	    handleDateChange: function handleDateChange(value, type) {
	      var parsedValue = Object(date_util_["parseDate"])(value, this.dateFormat);
	      if (parsedValue) {
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyDate"])(this.minDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          if (this.minDate > this.maxDate) {
	            this.maxDate = this.minDate;
	          }
	        } else {
	          this.maxDate = Object(date_util_["modifyDate"])(this.maxDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          if (this.maxDate < this.minDate) {
	            this.minDate = this.maxDate;
	          }
	        }
	      }
	    },
	    handleTimeInput: function handleTimeInput(value, type) {
	      var _this4 = this;
	
	      this.timeUserInput[type] = value;
	      if (value.length !== this.timeFormat.length) return;
	      var parsedValue = Object(date_util_["parseDate"])(value, this.timeFormat);
	
	      if (parsedValue) {
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyTime"])(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          this.$nextTick(function (_) {
	            return _this4.$refs.minTimePicker.adjustSpinners();
	          });
	        } else {
	          this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          this.$nextTick(function (_) {
	            return _this4.$refs.maxTimePicker.adjustSpinners();
	          });
	        }
	      }
	    },
	    handleTimeChange: function handleTimeChange(value, type) {
	      var parsedValue = Object(date_util_["parseDate"])(value, this.timeFormat);
	      if (parsedValue) {
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyTime"])(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          if (this.minDate > this.maxDate) {
	            this.maxDate = this.minDate;
	          }
	          this.$refs.minTimePicker.value = this.minDate;
	          this.minTimePickerVisible = false;
	        } else {
	          this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          if (this.maxDate < this.minDate) {
	            this.minDate = this.maxDate;
	          }
	          this.$refs.maxTimePicker.value = this.minDate;
	          this.maxTimePickerVisible = false;
	        }
	      }
	    },
	    handleRangePick: function handleRangePick(val) {
	      var _this5 = this;
	
	      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var defaultTime = this.defaultTime || [];
	      var minDate = Object(date_util_["modifyWithTimeString"])(val.minDate, defaultTime[0]);
	      var maxDate = Object(date_util_["modifyWithTimeString"])(val.maxDate, defaultTime[1]);
	
	      if (this.maxDate === maxDate && this.minDate === minDate) {
	        return;
	      }
	      this.onPick && this.onPick(val);
	      this.maxDate = maxDate;
	      this.minDate = minDate;
	
	      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
	      setTimeout(function () {
	        _this5.maxDate = maxDate;
	        _this5.minDate = minDate;
	      }, 10);
	      if (!close || this.showTime) return;
	      this.handleConfirm();
	    },
	    handleShortcutClick: function handleShortcutClick(shortcut) {
	      if (shortcut.onClick) {
	        shortcut.onClick(this);
	      }
	    },
	    handleMinTimePick: function handleMinTimePick(value, visible, first) {
	      this.minDate = this.minDate || new Date();
	      if (value) {
	        this.minDate = Object(date_util_["modifyTime"])(this.minDate, value.getHours(), value.getMinutes(), value.getSeconds());
	      }
	
	      if (!first) {
	        this.minTimePickerVisible = visible;
	      }
	
	      if (!this.maxDate || this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
	        this.maxDate = new Date(this.minDate);
	      }
	    },
	    handleMinTimeClose: function handleMinTimeClose() {
	      this.minTimePickerVisible = false;
	    },
	    handleMaxTimePick: function handleMaxTimePick(value, visible, first) {
	      if (this.maxDate && value) {
	        this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, value.getHours(), value.getMinutes(), value.getSeconds());
	      }
	
	      if (!first) {
	        this.maxTimePickerVisible = visible;
	      }
	
	      if (this.maxDate && this.minDate && this.minDate.getTime() > this.maxDate.getTime()) {
	        this.minDate = new Date(this.maxDate);
	      }
	    },
	    handleMaxTimeClose: function handleMaxTimeClose() {
	      this.maxTimePickerVisible = false;
	    },
	
	
	    // leftPrev*, rightNext* need to take care of `unlinkPanels`
	    leftPrevYear: function leftPrevYear() {
	      this.leftDate = Object(date_util_["prevYear"])(this.leftDate);
	      if (!this.unlinkPanels) {
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      }
	    },
	    leftPrevMonth: function leftPrevMonth() {
	      this.leftDate = Object(date_util_["prevMonth"])(this.leftDate);
	      if (!this.unlinkPanels) {
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      }
	    },
	    rightNextYear: function rightNextYear() {
	      if (!this.unlinkPanels) {
	        this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      } else {
	        this.rightDate = Object(date_util_["nextYear"])(this.rightDate);
	      }
	    },
	    rightNextMonth: function rightNextMonth() {
	      if (!this.unlinkPanels) {
	        this.leftDate = Object(date_util_["nextMonth"])(this.leftDate);
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      } else {
	        this.rightDate = Object(date_util_["nextMonth"])(this.rightDate);
	      }
	    },
	
	
	    // leftNext*, rightPrev* are called when `unlinkPanels` is true
	    leftNextYear: function leftNextYear() {
	      this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	    },
	    leftNextMonth: function leftNextMonth() {
	      this.leftDate = Object(date_util_["nextMonth"])(this.leftDate);
	    },
	    rightPrevYear: function rightPrevYear() {
	      this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
	    },
	    rightPrevMonth: function rightPrevMonth() {
	      this.rightDate = Object(date_util_["prevMonth"])(this.rightDate);
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.isValidValue([this.minDate, this.maxDate])) {
	        this.$emit('pick', [this.minDate, this.maxDate], visible);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      return Array.isArray(value) && value && value[0] && value[1] && Object(date_util_["isDate"])(value[0]) && Object(date_util_["isDate"])(value[1]) && value[0].getTime() <= value[1].getTime() && (typeof this.disabledDate === 'function' ? !this.disabledDate(value[0]) && !this.disabledDate(value[1]) : true);
	    },
	    resetView: function resetView() {
	      // NOTE: this is a hack to reset {min, max}Date on picker open.
	      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
	      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
	      if (this.minDate && this.maxDate == null) this.rangeState.selecting = false;
	      this.minDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[0]) : null;
	      this.maxDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[1]) : null;
	    }
	  },
	
	  components: { TimePicker: panel_time, DateTable: date_table, ElInput: input_default.a, ElButton: button_default.a }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_date_rangevue_type_script_lang_js_ = (date_rangevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue
	
	
	
	
	
	/* normalize component */
	
	var date_range_component = normalizeComponent(
	  panel_date_rangevue_type_script_lang_js_,
	  date_rangevue_type_template_id_2652849a_render,
	  date_rangevue_type_template_id_2652849a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var date_range_api; }
	date_range_component.options.__file = "packages/date-picker/src/panel/date-range.vue"
	/* harmony default export */ var date_range = (date_range_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
	var month_rangevue_type_template_id_f2645fb8_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-picker-panel el-date-range-picker el-popper",
	          class: [
	            {
	              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts
	            },
	            _vm.popperClass
	          ]
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-picker-panel__body-wrapper" },
	            [
	              _vm._t("sidebar"),
	              _vm.shortcuts
	                ? _c(
	                    "div",
	                    { staticClass: "el-picker-panel__sidebar" },
	                    _vm._l(_vm.shortcuts, function(shortcut, key) {
	                      return _c(
	                        "button",
	                        {
	                          key: key,
	                          staticClass: "el-picker-panel__shortcut",
	                          attrs: { type: "button" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleShortcutClick(shortcut)
	                            }
	                          }
	                        },
	                        [_vm._v(_vm._s(shortcut.text))]
	                      )
	                    }),
	                    0
	                  )
	                : _vm._e(),
	              _c("div", { staticClass: "el-picker-panel__body" }, [
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-left"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                        attrs: { type: "button" },
	                        on: { click: _vm.leftPrevYear }
	                      }),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.leftNextYear }
	                          })
	                        : _vm._e(),
	                      _c("div", [_vm._v(_vm._s(_vm.leftLabel))])
	                    ]),
	                    _c("month-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.leftDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                ),
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-right"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.rightPrevYear }
	                          })
	                        : _vm._e(),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                        attrs: { type: "button" },
	                        on: { click: _vm.rightNextYear }
	                      }),
	                      _c("div", [_vm._v(_vm._s(_vm.rightLabel))])
	                    ]),
	                    _c("month-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.rightDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                )
	              ])
	            ],
	            2
	          )
	        ]
	      )
	    ]
	  )
	}
	var month_rangevue_type_template_id_f2645fb8_staticRenderFns = []
	month_rangevue_type_template_id_f2645fb8_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var month_rangevue_type_script_lang_js_calcDefaultValue = function calcDefaultValue(defaultValue) {
	  if (Array.isArray(defaultValue)) {
	    return [new Date(defaultValue[0]), new Date(defaultValue[1])];
	  } else if (defaultValue) {
	    return [new Date(defaultValue), Object(date_util_["nextMonth"])(new Date(defaultValue))];
	  } else {
	    return [new Date(), Object(date_util_["nextMonth"])(new Date())];
	  }
	};
	/* harmony default export */ var month_rangevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  computed: {
	    btnDisabled: function btnDisabled() {
	      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]));
	    },
	    leftLabel: function leftLabel() {
	      return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year');
	    },
	    rightLabel: function rightLabel() {
	      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year');
	    },
	    leftYear: function leftYear() {
	      return this.leftDate.getFullYear();
	    },
	    rightYear: function rightYear() {
	      return this.rightDate.getFullYear() === this.leftDate.getFullYear() ? this.leftDate.getFullYear() + 1 : this.rightDate.getFullYear();
	    },
	    enableYearArrow: function enableYearArrow() {
	      return this.unlinkPanels && this.rightYear > this.leftYear + 1;
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      value: [],
	      defaultValue: null,
	      defaultTime: null,
	      minDate: '',
	      maxDate: '',
	      leftDate: new Date(),
	      rightDate: Object(date_util_["nextYear"])(new Date()),
	      rangeState: {
	        endDate: null,
	        selecting: false,
	        row: null,
	        column: null
	      },
	      shortcuts: '',
	      visible: '',
	      disabledDate: '',
	      format: '',
	      arrowControl: false,
	      unlinkPanels: false
	    };
	  },
	
	
	  watch: {
	    value: function value(newVal) {
	      if (!newVal) {
	        this.minDate = null;
	        this.maxDate = null;
	      } else if (Array.isArray(newVal)) {
	        this.minDate = Object(date_util_["isDate"])(newVal[0]) ? new Date(newVal[0]) : null;
	        this.maxDate = Object(date_util_["isDate"])(newVal[1]) ? new Date(newVal[1]) : null;
	        if (this.minDate) {
	          this.leftDate = this.minDate;
	          if (this.unlinkPanels && this.maxDate) {
	            var minDateYear = this.minDate.getFullYear();
	            var maxDateYear = this.maxDate.getFullYear();
	            this.rightDate = minDateYear === maxDateYear ? Object(date_util_["nextYear"])(this.maxDate) : this.maxDate;
	          } else {
	            this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
	          }
	        } else {
	          this.leftDate = month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	          this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
	        }
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Array.isArray(this.value)) {
	        var _calcDefaultValue = month_rangevue_type_script_lang_js_calcDefaultValue(val),
	            left = _calcDefaultValue[0],
	            right = _calcDefaultValue[1];
	
	        this.leftDate = left;
	        this.rightDate = val && val[1] && left.getFullYear() !== right.getFullYear() && this.unlinkPanels ? right : Object(date_util_["nextYear"])(this.leftDate);
	      }
	    }
	  },
	
	  methods: {
	    handleClear: function handleClear() {
	      this.minDate = null;
	      this.maxDate = null;
	      this.leftDate = month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	      this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
	      this.$emit('pick', null);
	    },
	    handleChangeRange: function handleChangeRange(val) {
	      this.minDate = val.minDate;
	      this.maxDate = val.maxDate;
	      this.rangeState = val.rangeState;
	    },
	    handleRangePick: function handleRangePick(val) {
	      var _this = this;
	
	      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var defaultTime = this.defaultTime || [];
	      var minDate = Object(date_util_["modifyWithTimeString"])(val.minDate, defaultTime[0]);
	      var maxDate = Object(date_util_["modifyWithTimeString"])(val.maxDate, defaultTime[1]);
	      if (this.maxDate === maxDate && this.minDate === minDate) {
	        return;
	      }
	      this.onPick && this.onPick(val);
	      this.maxDate = maxDate;
	      this.minDate = minDate;
	
	      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
	      setTimeout(function () {
	        _this.maxDate = maxDate;
	        _this.minDate = minDate;
	      }, 10);
	      if (!close) return;
	      this.handleConfirm();
	    },
	    handleShortcutClick: function handleShortcutClick(shortcut) {
	      if (shortcut.onClick) {
	        shortcut.onClick(this);
	      }
	    },
	
	
	    // leftPrev*, rightNext* need to take care of `unlinkPanels`
	    leftPrevYear: function leftPrevYear() {
	      this.leftDate = Object(date_util_["prevYear"])(this.leftDate);
	      if (!this.unlinkPanels) {
	        this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
	      }
	    },
	    rightNextYear: function rightNextYear() {
	      if (!this.unlinkPanels) {
	        this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	      }
	      this.rightDate = Object(date_util_["nextYear"])(this.rightDate);
	    },
	
	
	    // leftNext*, rightPrev* are called when `unlinkPanels` is true
	    leftNextYear: function leftNextYear() {
	      this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	    },
	    rightPrevYear: function rightPrevYear() {
	      this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.isValidValue([this.minDate, this.maxDate])) {
	        this.$emit('pick', [this.minDate, this.maxDate], visible);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      return Array.isArray(value) && value && value[0] && value[1] && Object(date_util_["isDate"])(value[0]) && Object(date_util_["isDate"])(value[1]) && value[0].getTime() <= value[1].getTime() && (typeof this.disabledDate === 'function' ? !this.disabledDate(value[0]) && !this.disabledDate(value[1]) : true);
	    },
	    resetView: function resetView() {
	      // NOTE: this is a hack to reset {min, max}Date on picker open.
	      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
	      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
	      this.minDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[0]) : null;
	      this.maxDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[1]) : null;
	    }
	  },
	
	  components: { MonthTable: month_table, ElInput: input_default.a, ElButton: button_default.a }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_month_rangevue_type_script_lang_js_ = (month_rangevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue
	
	
	
	
	
	/* normalize component */
	
	var month_range_component = normalizeComponent(
	  panel_month_rangevue_type_script_lang_js_,
	  month_rangevue_type_template_id_f2645fb8_render,
	  month_rangevue_type_template_id_f2645fb8_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var month_range_api; }
	month_range_component.options.__file = "packages/date-picker/src/panel/month-range.vue"
	/* harmony default export */ var month_range = (month_range_component.exports);
	// CONCATENATED MODULE: ./packages/date-picker/src/picker/date-picker.js
	
	
	
	
	
	var date_picker_getPanel = function getPanel(type) {
	  if (type === 'daterange' || type === 'datetimerange') {
	    return date_range;
	  } else if (type === 'monthrange') {
	    return month_range;
	  }
	  return panel_date;
	};
	
	/* harmony default export */ var date_picker = ({
	  mixins: [picker],
	
	  name: 'ElDatePicker',
	
	  props: {
	    type: {
	      type: String,
	      default: 'date'
	    },
	    timeArrowControl: Boolean
	  },
	
	  watch: {
	    type: function type(_type) {
	      if (this.picker) {
	        this.unmountPicker();
	        this.panel = date_picker_getPanel(_type);
	        this.mountPicker();
	      } else {
	        this.panel = date_picker_getPanel(_type);
	      }
	    }
	  },
	
	  created: function created() {
	    this.panel = date_picker_getPanel(this.type);
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/index.js
	
	
	/* istanbul ignore next */
	date_picker.install = function install(Vue) {
	  Vue.component(date_picker.name, date_picker);
	};
	
	/* harmony default export */ var packages_date_picker = (date_picker);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
	var time_selectvue_type_template_id_51ab9320_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "before-enter": _vm.handleMenuEnter,
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          ref: "popper",
	          staticClass: "el-picker-panel time-select el-popper",
	          class: _vm.popperClass,
	          style: { width: _vm.width + "px" }
	        },
	        [
	          _c(
	            "el-scrollbar",
	            {
	              attrs: { noresize: "", "wrap-class": "el-picker-panel__content" }
	            },
	            _vm._l(_vm.items, function(item) {
	              return _c(
	                "div",
	                {
	                  key: item.value,
	                  staticClass: "time-select-item",
	                  class: {
	                    selected: _vm.value === item.value,
	                    disabled: item.disabled,
	                    default: item.value === _vm.defaultValue
	                  },
	                  attrs: { disabled: item.disabled },
	                  on: {
	                    click: function($event) {
	                      _vm.handleClick(item)
	                    }
	                  }
	                },
	                [_vm._v(_vm._s(item.value))]
	              )
	            }),
	            0
	          )
	        ],
	        1
	      )
	    ]
	  )
	}
	var time_selectvue_type_template_id_51ab9320_staticRenderFns = []
	time_selectvue_type_template_id_51ab9320_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	var parseTime = function parseTime(time) {
	  var values = (time || '').split(':');
	  if (values.length >= 2) {
	    var hours = parseInt(values[0], 10);
	    var minutes = parseInt(values[1], 10);
	
	    return {
	      hours: hours,
	      minutes: minutes
	    };
	  }
	  /* istanbul ignore next */
	  return null;
	};
	
	var compareTime = function compareTime(time1, time2) {
	  var value1 = parseTime(time1);
	  var value2 = parseTime(time2);
	
	  var minutes1 = value1.minutes + value1.hours * 60;
	  var minutes2 = value2.minutes + value2.hours * 60;
	
	  if (minutes1 === minutes2) {
	    return 0;
	  }
	
	  return minutes1 > minutes2 ? 1 : -1;
	};
	
	var formatTime = function formatTime(time) {
	  return (time.hours < 10 ? '0' + time.hours : time.hours) + ':' + (time.minutes < 10 ? '0' + time.minutes : time.minutes);
	};
	
	var nextTime = function nextTime(time, step) {
	  var timeValue = parseTime(time);
	  var stepValue = parseTime(step);
	
	  var next = {
	    hours: timeValue.hours,
	    minutes: timeValue.minutes
	  };
	
	  next.minutes += stepValue.minutes;
	  next.hours += stepValue.hours;
	
	  next.hours += Math.floor(next.minutes / 60);
	  next.minutes = next.minutes % 60;
	
	  return formatTime(next);
	};
	
	/* harmony default export */ var time_selectvue_type_script_lang_js_ = ({
	  components: { ElScrollbar: scrollbar_default.a },
	
	  watch: {
	    value: function value(val) {
	      var _this = this;
	
	      if (!val) return;
	      this.$nextTick(function () {
	        return _this.scrollToOption();
	      });
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(item) {
	      if (!item.disabled) {
	        this.$emit('pick', item.value);
	      }
	    },
	    handleClear: function handleClear() {
	      this.$emit('pick', null);
	    },
	    scrollToOption: function scrollToOption() {
	      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.selected';
	
	      var menu = this.$refs.popper.querySelector('.el-picker-panel__content');
	      scroll_into_view_default()(menu, menu.querySelector(selector));
	    },
	    handleMenuEnter: function handleMenuEnter() {
	      var _this2 = this;
	
	      var selected = this.items.map(function (item) {
	        return item.value;
	      }).indexOf(this.value) !== -1;
	      var hasDefault = this.items.map(function (item) {
	        return item.value;
	      }).indexOf(this.defaultValue) !== -1;
	      var option = selected && '.selected' || hasDefault && '.default' || '.time-select-item:not(.disabled)';
	      this.$nextTick(function () {
	        return _this2.scrollToOption(option);
	      });
	    },
	    scrollDown: function scrollDown(step) {
	      var items = this.items;
	      var length = items.length;
	      var total = items.length;
	      var index = items.map(function (item) {
	        return item.value;
	      }).indexOf(this.value);
	      while (total--) {
	        index = (index + step + length) % length;
	        if (!items[index].disabled) {
	          this.$emit('pick', items[index].value, true);
	          return;
	        }
	      }
	    },
	    isValidValue: function isValidValue(date) {
	      return this.items.filter(function (item) {
	        return !item.disabled;
	      }).map(function (item) {
	        return item.value;
	      }).indexOf(date) !== -1;
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      if (keyCode === 38 || keyCode === 40) {
	        var mapping = { 40: 1, 38: -1 };
	        var offset = mapping[keyCode.toString()];
	        this.scrollDown(offset);
	        event.stopPropagation();
	        return;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      start: '09:00',
	      end: '18:00',
	      step: '00:30',
	      value: '',
	      defaultValue: '',
	      visible: false,
	      minTime: '',
	      maxTime: '',
	      width: 0
	    };
	  },
	
	
	  computed: {
	    items: function items() {
	      var start = this.start;
	      var end = this.end;
	      var step = this.step;
	
	      var result = [];
	
	      if (start && end && step) {
	        var current = start;
	        while (compareTime(current, end) <= 0) {
	          result.push({
	            value: current,
	            disabled: compareTime(current, this.minTime || '-1:-1') <= 0 || compareTime(current, this.maxTime || '100:100') >= 0
	          });
	          current = nextTime(current, step);
	        }
	      }
	
	      return result;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_time_selectvue_type_script_lang_js_ = (time_selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue
	
	
	
	
	
	/* normalize component */
	
	var time_select_component = normalizeComponent(
	  panel_time_selectvue_type_script_lang_js_,
	  time_selectvue_type_template_id_51ab9320_render,
	  time_selectvue_type_template_id_51ab9320_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_select_api; }
	time_select_component.options.__file = "packages/date-picker/src/panel/time-select.vue"
	/* harmony default export */ var time_select = (time_select_component.exports);
	// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-select.js
	
	
	
	/* harmony default export */ var picker_time_select = ({
	  mixins: [picker],
	
	  name: 'ElTimeSelect',
	
	  componentName: 'ElTimeSelect',
	
	  props: {
	    type: {
	      type: String,
	      default: 'time-select'
	    }
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.panel = time_select;
	  }
	});
	// CONCATENATED MODULE: ./packages/time-select/index.js
	
	
	/* istanbul ignore next */
	picker_time_select.install = function (Vue) {
	  Vue.component(picker_time_select.name, picker_time_select);
	};
	
	/* harmony default export */ var packages_time_select = (picker_time_select);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
	var time_rangevue_type_template_id_fb28660e_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-time-range-picker el-picker-panel el-popper",
	          class: _vm.popperClass
	        },
	        [
	          _c("div", { staticClass: "el-time-range-picker__content" }, [
	            _c("div", { staticClass: "el-time-range-picker__cell" }, [
	              _c("div", { staticClass: "el-time-range-picker__header" }, [
	                _vm._v(_vm._s(_vm.t("el.datepicker.startTime")))
	              ]),
	              _c(
	                "div",
	                {
	                  staticClass:
	                    "el-time-range-picker__body el-time-panel__content",
	                  class: {
	                    "has-seconds": _vm.showSeconds,
	                    "is-arrow": _vm.arrowControl
	                  }
	                },
	                [
	                  _c("time-spinner", {
	                    ref: "minSpinner",
	                    attrs: {
	                      "show-seconds": _vm.showSeconds,
	                      "am-pm-mode": _vm.amPmMode,
	                      "arrow-control": _vm.arrowControl,
	                      date: _vm.minDate
	                    },
	                    on: {
	                      change: _vm.handleMinChange,
	                      "select-range": _vm.setMinSelectionRange
	                    }
	                  })
	                ],
	                1
	              )
	            ]),
	            _c("div", { staticClass: "el-time-range-picker__cell" }, [
	              _c("div", { staticClass: "el-time-range-picker__header" }, [
	                _vm._v(_vm._s(_vm.t("el.datepicker.endTime")))
	              ]),
	              _c(
	                "div",
	                {
	                  staticClass:
	                    "el-time-range-picker__body el-time-panel__content",
	                  class: {
	                    "has-seconds": _vm.showSeconds,
	                    "is-arrow": _vm.arrowControl
	                  }
	                },
	                [
	                  _c("time-spinner", {
	                    ref: "maxSpinner",
	                    attrs: {
	                      "show-seconds": _vm.showSeconds,
	                      "am-pm-mode": _vm.amPmMode,
	                      "arrow-control": _vm.arrowControl,
	                      date: _vm.maxDate
	                    },
	                    on: {
	                      change: _vm.handleMaxChange,
	                      "select-range": _vm.setMaxSelectionRange
	                    }
	                  })
	                ],
	                1
	              )
	            ])
	          ]),
	          _c("div", { staticClass: "el-time-panel__footer" }, [
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn cancel",
	                attrs: { type: "button" },
	                on: {
	                  click: function($event) {
	                    _vm.handleCancel()
	                  }
	                }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]
	            ),
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn confirm",
	                attrs: { type: "button", disabled: _vm.btnDisabled },
	                on: {
	                  click: function($event) {
	                    _vm.handleConfirm()
	                  }
	                }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))]
	            )
	          ])
	        ]
	      )
	    ]
	  )
	}
	var time_rangevue_type_template_id_fb28660e_staticRenderFns = []
	time_rangevue_type_template_id_fb28660e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var MIN_TIME = Object(date_util_["parseDate"])('00:00:00', 'HH:mm:ss');
	var MAX_TIME = Object(date_util_["parseDate"])('23:59:59', 'HH:mm:ss');
	
	var time_rangevue_type_script_lang_js_minTimeOfDay = function minTimeOfDay(date) {
	  return Object(date_util_["modifyDate"])(MIN_TIME, date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	var time_rangevue_type_script_lang_js_maxTimeOfDay = function maxTimeOfDay(date) {
	  return Object(date_util_["modifyDate"])(MAX_TIME, date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	// increase time by amount of milliseconds, but within the range of day
	var advanceTime = function advanceTime(date, amount) {
	  return new Date(Math.min(date.getTime() + amount, time_rangevue_type_script_lang_js_maxTimeOfDay(date).getTime()));
	};
	
	/* harmony default export */ var time_rangevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  components: { TimeSpinner: time_spinner },
	
	  computed: {
	    showSeconds: function showSeconds() {
	      return (this.format || '').indexOf('ss') !== -1;
	    },
	    offset: function offset() {
	      return this.showSeconds ? 11 : 8;
	    },
	    spinner: function spinner() {
	      return this.selectionRange[0] < this.offset ? this.$refs.minSpinner : this.$refs.maxSpinner;
	    },
	    btnDisabled: function btnDisabled() {
	      return this.minDate.getTime() > this.maxDate.getTime();
	    },
	    amPmMode: function amPmMode() {
	      if ((this.format || '').indexOf('A') !== -1) return 'A';
	      if ((this.format || '').indexOf('a') !== -1) return 'a';
	      return '';
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      minDate: new Date(),
	      maxDate: new Date(),
	      value: [],
	      oldValue: [new Date(), new Date()],
	      defaultValue: null,
	      format: 'HH:mm:ss',
	      visible: false,
	      selectionRange: [0, 2],
	      arrowControl: false
	    };
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      if (Array.isArray(_value)) {
	        this.minDate = new Date(_value[0]);
	        this.maxDate = new Date(_value[1]);
	      } else {
	        if (Array.isArray(this.defaultValue)) {
	          this.minDate = new Date(this.defaultValue[0]);
	          this.maxDate = new Date(this.defaultValue[1]);
	        } else if (this.defaultValue) {
	          this.minDate = new Date(this.defaultValue);
	          this.maxDate = advanceTime(new Date(this.defaultValue), 60 * 60 * 1000);
	        } else {
	          this.minDate = new Date();
	          this.maxDate = advanceTime(new Date(), 60 * 60 * 1000);
	        }
	      }
	    },
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.oldValue = this.value;
	        this.$nextTick(function () {
	          return _this.$refs.minSpinner.emitSelectRange('hours');
	        });
	      }
	    }
	  },
	
	  methods: {
	    handleClear: function handleClear() {
	      this.$emit('pick', null);
	    },
	    handleCancel: function handleCancel() {
	      this.$emit('pick', this.oldValue);
	    },
	    handleMinChange: function handleMinChange(date) {
	      this.minDate = Object(date_util_["clearMilliseconds"])(date);
	      this.handleChange();
	    },
	    handleMaxChange: function handleMaxChange(date) {
	      this.maxDate = Object(date_util_["clearMilliseconds"])(date);
	      this.handleChange();
	    },
	    handleChange: function handleChange() {
	      if (this.isValidValue([this.minDate, this.maxDate])) {
	        this.$refs.minSpinner.selectableRange = [[time_rangevue_type_script_lang_js_minTimeOfDay(this.minDate), this.maxDate]];
	        this.$refs.maxSpinner.selectableRange = [[this.minDate, time_rangevue_type_script_lang_js_maxTimeOfDay(this.maxDate)]];
	        this.$emit('pick', [this.minDate, this.maxDate], true);
	      }
	    },
	    setMinSelectionRange: function setMinSelectionRange(start, end) {
	      this.$emit('select-range', start, end, 'min');
	      this.selectionRange = [start, end];
	    },
	    setMaxSelectionRange: function setMaxSelectionRange(start, end) {
	      this.$emit('select-range', start, end, 'max');
	      this.selectionRange = [start + this.offset, end + this.offset];
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var minSelectableRange = this.$refs.minSpinner.selectableRange;
	      var maxSelectableRange = this.$refs.maxSpinner.selectableRange;
	
	      this.minDate = Object(date_util_["limitTimeRange"])(this.minDate, minSelectableRange, this.format);
	      this.maxDate = Object(date_util_["limitTimeRange"])(this.maxDate, maxSelectableRange, this.format);
	
	      this.$emit('pick', [this.minDate, this.maxDate], visible);
	    },
	    adjustSpinners: function adjustSpinners() {
	      this.$refs.minSpinner.adjustSpinners();
	      this.$refs.maxSpinner.adjustSpinners();
	    },
	    changeSelectionRange: function changeSelectionRange(step) {
	      var list = this.showSeconds ? [0, 3, 6, 11, 14, 17] : [0, 3, 8, 11];
	      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
	      var index = list.indexOf(this.selectionRange[0]);
	      var next = (index + step + list.length) % list.length;
	      var half = list.length / 2;
	      if (next < half) {
	        this.$refs.minSpinner.emitSelectRange(mapping[next]);
	      } else {
	        this.$refs.maxSpinner.emitSelectRange(mapping[next - half]);
	      }
	    },
	    isValidValue: function isValidValue(date) {
	      return Array.isArray(date) && Object(date_util_["timeWithinRange"])(this.minDate, this.$refs.minSpinner.selectableRange) && Object(date_util_["timeWithinRange"])(this.maxDate, this.$refs.maxSpinner.selectableRange);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      var mapping = { 38: -1, 40: 1, 37: -1, 39: 1 };
	
	      // Left or Right
	      if (keyCode === 37 || keyCode === 39) {
	        var step = mapping[keyCode];
	        this.changeSelectionRange(step);
	        event.preventDefault();
	        return;
	      }
	
	      // Up or Down
	      if (keyCode === 38 || keyCode === 40) {
	        var _step = mapping[keyCode];
	        this.spinner.scrollDown(_step);
	        event.preventDefault();
	        return;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_time_rangevue_type_script_lang_js_ = (time_rangevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue
	
	
	
	
	
	/* normalize component */
	
	var time_range_component = normalizeComponent(
	  panel_time_rangevue_type_script_lang_js_,
	  time_rangevue_type_template_id_fb28660e_render,
	  time_rangevue_type_template_id_fb28660e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_range_api; }
	time_range_component.options.__file = "packages/date-picker/src/panel/time-range.vue"
	/* harmony default export */ var time_range = (time_range_component.exports);
	// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-picker.js
	
	
	
	
	/* harmony default export */ var time_picker = ({
	  mixins: [picker],
	
	  name: 'ElTimePicker',
	
	  props: {
	    isRange: Boolean,
	    arrowControl: Boolean
	  },
	
	  data: function data() {
	    return {
	      type: ''
	    };
	  },
	
	
	  watch: {
	    isRange: function isRange(_isRange) {
	      if (this.picker) {
	        this.unmountPicker();
	        this.type = _isRange ? 'timerange' : 'time';
	        this.panel = _isRange ? time_range : panel_time;
	        this.mountPicker();
	      } else {
	        this.type = _isRange ? 'timerange' : 'time';
	        this.panel = _isRange ? time_range : panel_time;
	      }
	    }
	  },
	
	  created: function created() {
	    this.type = this.isRange ? 'timerange' : 'time';
	    this.panel = this.isRange ? time_range : panel_time;
	  }
	});
	// CONCATENATED MODULE: ./packages/time-picker/index.js
	
	
	/* istanbul ignore next */
	time_picker.install = function (Vue) {
	  Vue.component(time_picker.name, time_picker);
	};
	
	/* harmony default export */ var packages_time_picker = (time_picker);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
	var mainvue_type_template_id_52060272_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "span",
	    [
	      _c(
	        "transition",
	        {
	          attrs: { name: _vm.transition },
	          on: {
	            "after-enter": _vm.handleAfterEnter,
	            "after-leave": _vm.handleAfterLeave
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.disabled && _vm.showPopper,
	                  expression: "!disabled && showPopper"
	                }
	              ],
	              ref: "popper",
	              staticClass: "el-popover el-popper",
	              class: [_vm.popperClass, _vm.content && "el-popover--plain"],
	              style: { width: _vm.width + "px" },
	              attrs: {
	                role: "tooltip",
	                id: _vm.tooltipId,
	                "aria-hidden":
	                  _vm.disabled || !_vm.showPopper ? "true" : "false"
	              }
	            },
	            [
	              _vm.title
	                ? _c("div", {
	                    staticClass: "el-popover__title",
	                    domProps: { textContent: _vm._s(_vm.title) }
	                  })
	                : _vm._e(),
	              _vm._t("default", [_vm._v(_vm._s(_vm.content))])
	            ],
	            2
	          )
	        ]
	      ),
	      _vm._t("reference")
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_52060272_staticRenderFns = []
	mainvue_type_template_id_52060272_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var mainvue_type_script_lang_js_ = ({
	  name: 'ElPopover',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    trigger: {
	      type: String,
	      default: 'click',
	      validator: function validator(value) {
	        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
	      }
	    },
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    closeDelay: {
	      type: Number,
	      default: 200
	    },
	    title: String,
	    disabled: Boolean,
	    content: String,
	    reference: {},
	    popperClass: String,
	    width: {},
	    visibleArrow: {
	      default: true
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    transition: {
	      type: String,
	      default: 'fade-in-linear'
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  computed: {
	    tooltipId: function tooltipId() {
	      return 'el-popover-' + Object(util_["generateId"])();
	    }
	  },
	  watch: {
	    showPopper: function showPopper(val) {
	      if (this.disabled) {
	        return;
	      }
	      val ? this.$emit('show') : this.$emit('hide');
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var reference = this.referenceElm = this.reference || this.$refs.reference;
	    var popper = this.popper || this.$refs.popper;
	
	    if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	      reference = this.referenceElm = this.$slots.reference[0].elm;
	    }
	    // 可访问性
	    if (reference) {
	      Object(dom_["addClass"])(reference, 'el-popover__reference');
	      reference.setAttribute('aria-describedby', this.tooltipId);
	      reference.setAttribute('tabindex', this.tabindex); // tab序列
	      popper.setAttribute('tabindex', 0);
	
	      if (this.trigger !== 'click') {
	        Object(dom_["on"])(reference, 'focusin', function () {
	          _this.handleFocus();
	          var instance = reference.__vue__;
	          if (instance && typeof instance.focus === 'function') {
	            instance.focus();
	          }
	        });
	        Object(dom_["on"])(popper, 'focusin', this.handleFocus);
	        Object(dom_["on"])(reference, 'focusout', this.handleBlur);
	        Object(dom_["on"])(popper, 'focusout', this.handleBlur);
	      }
	      Object(dom_["on"])(reference, 'keydown', this.handleKeydown);
	      Object(dom_["on"])(reference, 'click', this.handleClick);
	    }
	    if (this.trigger === 'click') {
	      Object(dom_["on"])(reference, 'click', this.doToggle);
	      Object(dom_["on"])(document, 'click', this.handleDocumentClick);
	    } else if (this.trigger === 'hover') {
	      Object(dom_["on"])(reference, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(popper, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(reference, 'mouseleave', this.handleMouseLeave);
	      Object(dom_["on"])(popper, 'mouseleave', this.handleMouseLeave);
	    } else if (this.trigger === 'focus') {
	      if (this.tabindex < 0) {
	        console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');
	      }
	      if (reference.querySelector('input, textarea')) {
	        Object(dom_["on"])(reference, 'focusin', this.doShow);
	        Object(dom_["on"])(reference, 'focusout', this.doClose);
	      } else {
	        Object(dom_["on"])(reference, 'mousedown', this.doShow);
	        Object(dom_["on"])(reference, 'mouseup', this.doClose);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.cleanup();
	  },
	  deactivated: function deactivated() {
	    this.cleanup();
	  },
	
	
	  methods: {
	    doToggle: function doToggle() {
	      this.showPopper = !this.showPopper;
	    },
	    doShow: function doShow() {
	      this.showPopper = true;
	    },
	    doClose: function doClose() {
	      this.showPopper = false;
	    },
	    handleFocus: function handleFocus() {
	      Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = true;
	    },
	    handleClick: function handleClick() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	    },
	    handleBlur: function handleBlur() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = false;
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      var _this2 = this;
	
	      clearTimeout(this._timer);
	      if (this.openDelay) {
	        this._timer = setTimeout(function () {
	          _this2.showPopper = true;
	        }, this.openDelay);
	      } else {
	        this.showPopper = true;
	      }
	    },
	    handleKeydown: function handleKeydown(ev) {
	      if (ev.keyCode === 27 && this.trigger !== 'manual') {
	        // esc
	        this.doClose();
	      }
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      var _this3 = this;
	
	      clearTimeout(this._timer);
	      if (this.closeDelay) {
	        this._timer = setTimeout(function () {
	          _this3.showPopper = false;
	        }, this.closeDelay);
	      } else {
	        this.showPopper = false;
	      }
	    },
	    handleDocumentClick: function handleDocumentClick(e) {
	      var reference = this.reference || this.$refs.reference;
	      var popper = this.popper || this.$refs.popper;
	
	      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	        reference = this.referenceElm = this.$slots.reference[0].elm;
	      }
	      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
	      this.showPopper = false;
	    },
	    handleAfterEnter: function handleAfterEnter() {
	      this.$emit('after-enter');
	    },
	    handleAfterLeave: function handleAfterLeave() {
	      this.$emit('after-leave');
	      this.doDestroy();
	    },
	    cleanup: function cleanup() {
	      if (this.openDelay || this.closeDelay) {
	        clearTimeout(this._timer);
	      }
	    }
	  },
	
	  destroyed: function destroyed() {
	    var reference = this.reference;
	
	    Object(dom_["off"])(reference, 'click', this.doToggle);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'focusin', this.doShow);
	    Object(dom_["off"])(reference, 'focusout', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mouseleave', this.handleMouseLeave);
	    Object(dom_["off"])(reference, 'mouseenter', this.handleMouseEnter);
	    Object(dom_["off"])(document, 'click', this.handleDocumentClick);
	  }
	});
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/popover/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var main_component = normalizeComponent(
	  src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_52060272_render,
	  mainvue_type_template_id_52060272_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var main_api; }
	main_component.options.__file = "packages/popover/src/main.vue"
	/* harmony default export */ var main = (main_component.exports);
	// CONCATENATED MODULE: ./packages/popover/src/directive.js
	var getReference = function getReference(el, binding, vnode) {
	  var _ref = binding.expression ? binding.value : binding.arg;
	  var popper = vnode.context.$refs[_ref];
	  if (popper) {
	    if (Array.isArray(popper)) {
	      popper[0].$refs.reference = el;
	    } else {
	      popper.$refs.reference = el;
	    }
	  }
	};
	
	/* harmony default export */ var directive = ({
	  bind: function bind(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  },
	  inserted: function inserted(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  }
	});
	// CONCATENATED MODULE: ./packages/popover/index.js
	
	
	
	
	external_vue_default.a.directive('popover', directive);
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.directive('popover', directive);
	  Vue.component(main.name, main);
	};
	main.directive = directive;
	
	/* harmony default export */ var popover = (main);
	// CONCATENATED MODULE: ./packages/tooltip/src/main.js
	
	
	
	
	
	
	/* harmony default export */ var src_main = ({
	  name: 'ElTooltip',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    disabled: Boolean,
	    manual: Boolean,
	    effect: {
	      type: String,
	      default: 'dark'
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    popperClass: String,
	    content: String,
	    visibleArrow: {
	      default: true
	    },
	    transition: {
	      type: String,
	      default: 'el-fade-in-linear'
	    },
	    popperOptions: {
	      default: function _default() {
	        return {
	          boundariesPadding: 10,
	          gpuAcceleration: false
	        };
	      }
	    },
	    enterable: {
	      type: Boolean,
	      default: true
	    },
	    hideAfter: {
	      type: Number,
	      default: 0
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      tooltipId: 'el-tooltip-' + Object(util_["generateId"])(),
	      timeoutPending: null,
	      focusing: false
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    if (this.$isServer) return;
	
	    this.popperVM = new external_vue_default.a({
	      data: { node: '' },
	      render: function render(h) {
	        return this.node;
	      }
	    }).$mount();
	
	    this.debounceClose = debounce_default()(200, function () {
	      return _this.handleClosePopper();
	    });
	  },
	  render: function render(h) {
	    var _this2 = this;
	
	    if (this.popperVM) {
	      this.popperVM.node = h(
	        'transition',
	        {
	          attrs: {
	            name: this.transition
	          },
	          on: {
	            'afterLeave': this.doDestroy
	          }
	        },
	        [h(
	          'div',
	          {
	            on: {
	              'mouseleave': function mouseleave() {
	                _this2.setExpectedState(false);_this2.debounceClose();
	              },
	              'mouseenter': function mouseenter() {
	                _this2.setExpectedState(true);
	              }
	            },
	
	            ref: 'popper',
	            attrs: { role: 'tooltip',
	              id: this.tooltipId,
	              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
	            },
	            directives: [{
	              name: 'show',
	              value: !this.disabled && this.showPopper
	            }],
	
	            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] },
	          [this.$slots.content || this.content]
	        )]
	      );
	    }
	
	    var firstElement = this.getFirstElement();
	    if (!firstElement) return null;
	
	    var data = firstElement.data = firstElement.data || {};
	    data.staticClass = this.addTooltipClass(data.staticClass);
	
	    return firstElement;
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.referenceElm = this.$el;
	    if (this.$el.nodeType === 1) {
	      this.$el.setAttribute('aria-describedby', this.tooltipId);
	      this.$el.setAttribute('tabindex', this.tabindex);
	      Object(dom_["on"])(this.referenceElm, 'mouseenter', this.show);
	      Object(dom_["on"])(this.referenceElm, 'mouseleave', this.hide);
	      Object(dom_["on"])(this.referenceElm, 'focus', function () {
	        if (!_this3.$slots.default || !_this3.$slots.default.length) {
	          _this3.handleFocus();
	          return;
	        }
	        var instance = _this3.$slots.default[0].componentInstance;
	        if (instance && instance.focus) {
	          instance.focus();
	        } else {
	          _this3.handleFocus();
	        }
	      });
	      Object(dom_["on"])(this.referenceElm, 'blur', this.handleBlur);
	      Object(dom_["on"])(this.referenceElm, 'click', this.removeFocusing);
	    }
	    // fix issue https://github.com/ElemeFE/element/issues/14424
	    if (this.value && this.popperVM) {
	      this.popperVM.$nextTick(function () {
	        if (_this3.value) {
	          _this3.updatePopper();
	        }
	      });
	    }
	  },
	
	  watch: {
	    focusing: function focusing(val) {
	      if (val) {
	        Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      } else {
	        Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      }
	    }
	  },
	  methods: {
	    show: function show() {
	      this.setExpectedState(true);
	      this.handleShowPopper();
	    },
	    hide: function hide() {
	      this.setExpectedState(false);
	      this.debounceClose();
	    },
	    handleFocus: function handleFocus() {
	      this.focusing = true;
	      this.show();
	    },
	    handleBlur: function handleBlur() {
	      this.focusing = false;
	      this.hide();
	    },
	    removeFocusing: function removeFocusing() {
	      this.focusing = false;
	    },
	    addTooltipClass: function addTooltipClass(prev) {
	      if (!prev) {
	        return 'el-tooltip';
	      } else {
	        return 'el-tooltip ' + prev.replace('el-tooltip', '');
	      }
	    },
	    handleShowPopper: function handleShowPopper() {
	      var _this4 = this;
	
	      if (!this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this4.showPopper = true;
	      }, this.openDelay);
	
	      if (this.hideAfter > 0) {
	        this.timeoutPending = setTimeout(function () {
	          _this4.showPopper = false;
	        }, this.hideAfter);
	      }
	    },
	    handleClosePopper: function handleClosePopper() {
	      if (this.enterable && this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	
	      if (this.timeoutPending) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.showPopper = false;
	
	      if (this.disabled) {
	        this.doDestroy();
	      }
	    },
	    setExpectedState: function setExpectedState(expectedState) {
	      if (expectedState === false) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.expectedState = expectedState;
	    },
	    getFirstElement: function getFirstElement() {
	      var slots = this.$slots.default;
	      if (!Array.isArray(slots)) return null;
	      var element = null;
	      for (var index = 0; index < slots.length; index++) {
	        if (slots[index] && slots[index].tag) {
	          element = slots[index];
	        };
	      }
	      return element;
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.popperVM && this.popperVM.$destroy();
	  },
	  destroyed: function destroyed() {
	    var reference = this.referenceElm;
	    if (reference.nodeType === 1) {
	      Object(dom_["off"])(reference, 'mouseenter', this.show);
	      Object(dom_["off"])(reference, 'mouseleave', this.hide);
	      Object(dom_["off"])(reference, 'focus', this.handleFocus);
	      Object(dom_["off"])(reference, 'blur', this.handleBlur);
	      Object(dom_["off"])(reference, 'click', this.removeFocusing);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tooltip/index.js
	
	
	/* istanbul ignore next */
	src_main.install = function (Vue) {
	  Vue.component(src_main.name, src_main);
	};
	
	/* harmony default export */ var packages_tooltip = (src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
	var mainvue_type_template_id_6b29b012_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "msgbox-fade" } }, [
	    _c(
	      "div",
	      {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.visible,
	            expression: "visible"
	          }
	        ],
	        staticClass: "el-message-box__wrapper",
	        attrs: {
	          tabindex: "-1",
	          role: "dialog",
	          "aria-modal": "true",
	          "aria-label": _vm.title || "dialog"
	        },
	        on: {
	          click: function($event) {
	            if ($event.target !== $event.currentTarget) {
	              return null
	            }
	            return _vm.handleWrapperClick($event)
	          }
	        }
	      },
	      [
	        _c(
	          "div",
	          {
	            staticClass: "el-message-box",
	            class: [_vm.customClass, _vm.center && "el-message-box--center"]
	          },
	          [
	            _vm.title !== null
	              ? _c("div", { staticClass: "el-message-box__header" }, [
	                  _c("div", { staticClass: "el-message-box__title" }, [
	                    _vm.icon && _vm.center
	                      ? _c("div", {
	                          class: ["el-message-box__status", _vm.icon]
	                        })
	                      : _vm._e(),
	                    _c("span", [_vm._v(_vm._s(_vm.title))])
	                  ]),
	                  _vm.showClose
	                    ? _c(
	                        "button",
	                        {
	                          staticClass: "el-message-box__headerbtn",
	                          attrs: { type: "button", "aria-label": "Close" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleAction(
	                                _vm.distinguishCancelAndClose
	                                  ? "close"
	                                  : "cancel"
	                              )
	                            },
	                            keydown: function($event) {
	                              if (
	                                !("button" in $event) &&
	                                _vm._k(
	                                  $event.keyCode,
	                                  "enter",
	                                  13,
	                                  $event.key,
	                                  "Enter"
	                                )
	                              ) {
	                                return null
	                              }
	                              _vm.handleAction(
	                                _vm.distinguishCancelAndClose
	                                  ? "close"
	                                  : "cancel"
	                              )
	                            }
	                          }
	                        },
	                        [
	                          _c("i", {
	                            staticClass: "el-message-box__close el-icon-close"
	                          })
	                        ]
	                      )
	                    : _vm._e()
	                ])
	              : _vm._e(),
	            _c("div", { staticClass: "el-message-box__content" }, [
	              _c("div", { staticClass: "el-message-box__container" }, [
	                _vm.icon && !_vm.center && _vm.message !== ""
	                  ? _c("div", { class: ["el-message-box__status", _vm.icon] })
	                  : _vm._e(),
	                _vm.message !== ""
	                  ? _c(
	                      "div",
	                      { staticClass: "el-message-box__message" },
	                      [
	                        _vm._t("default", [
	                          !_vm.dangerouslyUseHTMLString
	                            ? _c("p", [_vm._v(_vm._s(_vm.message))])
	                            : _c("p", {
	                                domProps: { innerHTML: _vm._s(_vm.message) }
	                              })
	                        ])
	                      ],
	                      2
	                    )
	                  : _vm._e()
	              ]),
	              _c(
	                "div",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.showInput,
	                      expression: "showInput"
	                    }
	                  ],
	                  staticClass: "el-message-box__input"
	                },
	                [
	                  _c("el-input", {
	                    ref: "input",
	                    attrs: {
	                      type: _vm.inputType,
	                      placeholder: _vm.inputPlaceholder
	                    },
	                    nativeOn: {
	                      keydown: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "enter",
	                            13,
	                            $event.key,
	                            "Enter"
	                          )
	                        ) {
	                          return null
	                        }
	                        return _vm.handleInputEnter($event)
	                      }
	                    },
	                    model: {
	                      value: _vm.inputValue,
	                      callback: function($$v) {
	                        _vm.inputValue = $$v
	                      },
	                      expression: "inputValue"
	                    }
	                  }),
	                  _c(
	                    "div",
	                    {
	                      staticClass: "el-message-box__errormsg",
	                      style: {
	                        visibility: !!_vm.editorErrorMessage
	                          ? "visible"
	                          : "hidden"
	                      }
	                    },
	                    [_vm._v(_vm._s(_vm.editorErrorMessage))]
	                  )
	                ],
	                1
	              )
	            ]),
	            _c(
	              "div",
	              { staticClass: "el-message-box__btns" },
	              [
	                _vm.showCancelButton
	                  ? _c(
	                      "el-button",
	                      {
	                        class: [_vm.cancelButtonClasses],
	                        attrs: {
	                          loading: _vm.cancelButtonLoading,
	                          round: _vm.roundButton,
	                          size: "small"
	                        },
	                        on: {
	                          keydown: function($event) {
	                            if (
	                              !("button" in $event) &&
	                              _vm._k(
	                                $event.keyCode,
	                                "enter",
	                                13,
	                                $event.key,
	                                "Enter"
	                              )
	                            ) {
	                              return null
	                            }
	                            _vm.handleAction("cancel")
	                          }
	                        },
	                        nativeOn: {
	                          click: function($event) {
	                            _vm.handleAction("cancel")
	                          }
	                        }
	                      },
	                      [
	                        _vm._v(
	                          "\n          " +
	                            _vm._s(
	                              _vm.cancelButtonText ||
	                                _vm.t("el.messagebox.cancel")
	                            ) +
	                            "\n        "
	                        )
	                      ]
	                    )
	                  : _vm._e(),
	                _c(
	                  "el-button",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value: _vm.showConfirmButton,
	                        expression: "showConfirmButton"
	                      }
	                    ],
	                    ref: "confirm",
	                    class: [_vm.confirmButtonClasses],
	                    attrs: {
	                      loading: _vm.confirmButtonLoading,
	                      round: _vm.roundButton,
	                      size: "small"
	                    },
	                    on: {
	                      keydown: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "enter",
	                            13,
	                            $event.key,
	                            "Enter"
	                          )
	                        ) {
	                          return null
	                        }
	                        _vm.handleAction("confirm")
	                      }
	                    },
	                    nativeOn: {
	                      click: function($event) {
	                        _vm.handleAction("confirm")
	                      }
	                    }
	                  },
	                  [
	                    _vm._v(
	                      "\n          " +
	                        _vm._s(
	                          _vm.confirmButtonText ||
	                            _vm.t("el.messagebox.confirm")
	                        ) +
	                        "\n        "
	                    )
	                  ]
	                )
	              ],
	              1
	            )
	          ]
	        )
	      ]
	    )
	  ])
	}
	var mainvue_type_template_id_6b29b012_staticRenderFns = []
	mainvue_type_template_id_6b29b012_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/aria-dialog"
	var aria_dialog_ = __webpack_require__(39);
	var aria_dialog_default = /*#__PURE__*/__webpack_require__.n(aria_dialog_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	var messageBox = void 0;
	var typeMap = {
	  success: 'success',
	  info: 'info',
	  warning: 'warning',
	  error: 'error'
	};
	
	/* harmony default export */ var message_box_src_mainvue_type_script_lang_js_ = ({
	  mixins: [popup_default.a, locale_default.a],
	
	  props: {
	    modal: {
	      default: true
	    },
	    lockScroll: {
	      default: true
	    },
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    closeOnClickModal: {
	      default: true
	    },
	    closeOnPressEscape: {
	      default: true
	    },
	    closeOnHashChange: {
	      default: true
	    },
	    center: {
	      default: false,
	      type: Boolean
	    },
	    roundButton: {
	      default: false,
	      type: Boolean
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElButton: button_default.a
	  },
	
	  computed: {
	    icon: function icon() {
	      var type = this.type,
	          iconClass = this.iconClass;
	
	      return iconClass || (type && typeMap[type] ? 'el-icon-' + typeMap[type] : '');
	    },
	    confirmButtonClasses: function confirmButtonClasses() {
	      return 'el-button--primary ' + this.confirmButtonClass;
	    },
	    cancelButtonClasses: function cancelButtonClasses() {
	      return '' + this.cancelButtonClass;
	    }
	  },
	
	  methods: {
	    getSafeClose: function getSafeClose() {
	      var _this = this;
	
	      var currentId = this.uid;
	      return function () {
	        _this.$nextTick(function () {
	          if (currentId === _this.uid) _this.doClose();
	        });
	      };
	    },
	    doClose: function doClose() {
	      var _this2 = this;
	
	      if (!this.visible) return;
	      this.visible = false;
	      this._closing = true;
	
	      this.onClose && this.onClose();
	      messageBox.closeDialog(); // 解绑
	      if (this.lockScroll) {
	        setTimeout(this.restoreBodyStyle, 200);
	      }
	      this.opened = false;
	      this.doAfterClose();
	      setTimeout(function () {
	        if (_this2.action) _this2.callback(_this2.action, _this2);
	      });
	    },
	    handleWrapperClick: function handleWrapperClick() {
	      if (this.closeOnClickModal) {
	        this.handleAction(this.distinguishCancelAndClose ? 'close' : 'cancel');
	      }
	    },
	    handleInputEnter: function handleInputEnter() {
	      if (this.inputType !== 'textarea') {
	        return this.handleAction('confirm');
	      }
	    },
	    handleAction: function handleAction(action) {
	      if (this.$type === 'prompt' && action === 'confirm' && !this.validate()) {
	        return;
	      }
	      this.action = action;
	      if (typeof this.beforeClose === 'function') {
	        this.close = this.getSafeClose();
	        this.beforeClose(action, this, this.close);
	      } else {
	        this.doClose();
	      }
	    },
	    validate: function validate() {
	      if (this.$type === 'prompt') {
	        var inputPattern = this.inputPattern;
	        if (inputPattern && !inputPattern.test(this.inputValue || '')) {
	          this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])('el.messagebox.error');
	          Object(dom_["addClass"])(this.getInputElement(), 'invalid');
	          return false;
	        }
	        var inputValidator = this.inputValidator;
	        if (typeof inputValidator === 'function') {
	          var validateResult = inputValidator(this.inputValue);
	          if (validateResult === false) {
	            this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])('el.messagebox.error');
	            Object(dom_["addClass"])(this.getInputElement(), 'invalid');
	            return false;
	          }
	          if (typeof validateResult === 'string') {
	            this.editorErrorMessage = validateResult;
	            Object(dom_["addClass"])(this.getInputElement(), 'invalid');
	            return false;
	          }
	        }
	      }
	      this.editorErrorMessage = '';
	      Object(dom_["removeClass"])(this.getInputElement(), 'invalid');
	      return true;
	    },
	    getFirstFocus: function getFirstFocus() {
	      var btn = this.$el.querySelector('.el-message-box__btns .el-button');
	      var title = this.$el.querySelector('.el-message-box__btns .el-message-box__title');
	      return btn || title;
	    },
	    getInputElement: function getInputElement() {
	      var inputRefs = this.$refs.input.$refs;
	      return inputRefs.input || inputRefs.textarea;
	    },
	    handleClose: function handleClose() {
	      this.handleAction('close');
	    }
	  },
	
	  watch: {
	    inputValue: {
	      immediate: true,
	      handler: function handler(val) {
	        var _this3 = this;
	
	        this.$nextTick(function (_) {
	          if (_this3.$type === 'prompt' && val !== null) {
	            _this3.validate();
	          }
	        });
	      }
	    },
	
	    visible: function visible(val) {
	      var _this4 = this;
	
	      if (val) {
	        this.uid++;
	        if (this.$type === 'alert' || this.$type === 'confirm') {
	          this.$nextTick(function () {
	            _this4.$refs.confirm.$el.focus();
	          });
	        }
	        this.focusAfterClosed = document.activeElement;
	        messageBox = new aria_dialog_default.a(this.$el, this.focusAfterClosed, this.getFirstFocus());
	      }
	
	      // prompt
	      if (this.$type !== 'prompt') return;
	      if (val) {
	        setTimeout(function () {
	          if (_this4.$refs.input && _this4.$refs.input.$el) {
	            _this4.getInputElement().focus();
	          }
	        }, 500);
	      } else {
	        this.editorErrorMessage = '';
	        Object(dom_["removeClass"])(this.getInputElement(), 'invalid');
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.$nextTick(function () {
	      if (_this5.closeOnHashChange) {
	        window.addEventListener('hashchange', _this5.close);
	      }
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.closeOnHashChange) {
	      window.removeEventListener('hashchange', this.close);
	    }
	    setTimeout(function () {
	      messageBox.closeDialog();
	    });
	  },
	  data: function data() {
	    return {
	      uid: 1,
	      title: undefined,
	      message: '',
	      type: '',
	      iconClass: '',
	      customClass: '',
	      showInput: false,
	      inputValue: null,
	      inputPlaceholder: '',
	      inputType: 'text',
	      inputPattern: null,
	      inputValidator: null,
	      inputErrorMessage: '',
	      showConfirmButton: true,
	      showCancelButton: false,
	      action: '',
	      confirmButtonText: '',
	      cancelButtonText: '',
	      confirmButtonLoading: false,
	      cancelButtonLoading: false,
	      confirmButtonClass: '',
	      confirmButtonDisabled: false,
	      cancelButtonClass: '',
	      editorErrorMessage: null,
	      callback: null,
	      dangerouslyUseHTMLString: false,
	      focusAfterClosed: null,
	      isOnComposition: false,
	      distinguishCancelAndClose: false
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_message_box_src_mainvue_type_script_lang_js_ = (message_box_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/message-box/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var src_main_component = normalizeComponent(
	  packages_message_box_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_6b29b012_render,
	  mainvue_type_template_id_6b29b012_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_main_api; }
	src_main_component.options.__file = "packages/message-box/src/main.vue"
	/* harmony default export */ var message_box_src_main = (src_main_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/utils/vdom"
	var vdom_ = __webpack_require__(23);
	
	// CONCATENATED MODULE: ./packages/message-box/src/main.js
	var main_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var main_defaults = {
	  title: null,
	  message: '',
	  type: '',
	  iconClass: '',
	  showInput: false,
	  showClose: true,
	  modalFade: true,
	  lockScroll: true,
	  closeOnClickModal: true,
	  closeOnPressEscape: true,
	  closeOnHashChange: true,
	  inputValue: null,
	  inputPlaceholder: '',
	  inputType: 'text',
	  inputPattern: null,
	  inputValidator: null,
	  inputErrorMessage: '',
	  showConfirmButton: true,
	  showCancelButton: false,
	  confirmButtonPosition: 'right',
	  confirmButtonHighlight: false,
	  cancelButtonHighlight: false,
	  confirmButtonText: '',
	  cancelButtonText: '',
	  confirmButtonClass: '',
	  cancelButtonClass: '',
	  customClass: '',
	  beforeClose: null,
	  dangerouslyUseHTMLString: false,
	  center: false,
	  roundButton: false,
	  distinguishCancelAndClose: false
	};
	
	
	
	
	
	
	var MessageBoxConstructor = external_vue_default.a.extend(message_box_src_main);
	
	var currentMsg = void 0,
	    main_instance = void 0;
	var msgQueue = [];
	
	var defaultCallback = function defaultCallback(action) {
	  if (currentMsg) {
	    var callback = currentMsg.callback;
	    if (typeof callback === 'function') {
	      if (main_instance.showInput) {
	        callback(main_instance.inputValue, action);
	      } else {
	        callback(action);
	      }
	    }
	    if (currentMsg.resolve) {
	      if (action === 'confirm') {
	        if (main_instance.showInput) {
	          currentMsg.resolve({ value: main_instance.inputValue, action: action });
	        } else {
	          currentMsg.resolve(action);
	        }
	      } else if (currentMsg.reject && (action === 'cancel' || action === 'close')) {
	        currentMsg.reject(action);
	      }
	    }
	  }
	};
	
	var initInstance = function initInstance() {
	  main_instance = new MessageBoxConstructor({
	    el: document.createElement('div')
	  });
	
	  main_instance.callback = defaultCallback;
	};
	
	var main_showNextMsg = function showNextMsg() {
	  if (!main_instance) {
	    initInstance();
	  }
	  main_instance.action = '';
	
	  if (!main_instance.visible || main_instance.closeTimer) {
	    if (msgQueue.length > 0) {
	      currentMsg = msgQueue.shift();
	
	      var options = currentMsg.options;
	      for (var prop in options) {
	        if (options.hasOwnProperty(prop)) {
	          main_instance[prop] = options[prop];
	        }
	      }
	      if (options.callback === undefined) {
	        main_instance.callback = defaultCallback;
	      }
	
	      var oldCb = main_instance.callback;
	      main_instance.callback = function (action, instance) {
	        oldCb(action, instance);
	        showNextMsg();
	      };
	      if (Object(vdom_["isVNode"])(main_instance.message)) {
	        main_instance.$slots.default = [main_instance.message];
	        main_instance.message = null;
	      } else {
	        delete main_instance.$slots.default;
	      }
	      ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape', 'closeOnHashChange'].forEach(function (prop) {
	        if (main_instance[prop] === undefined) {
	          main_instance[prop] = true;
	        }
	      });
	      document.body.appendChild(main_instance.$el);
	
	      external_vue_default.a.nextTick(function () {
	        main_instance.visible = true;
	      });
	    }
	  }
	};
	
	var main_MessageBox = function MessageBox(options, callback) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  if (typeof options === 'string' || Object(vdom_["isVNode"])(options)) {
	    options = {
	      message: options
	    };
	    if (typeof arguments[1] === 'string') {
	      options.title = arguments[1];
	    }
	  } else if (options.callback && !callback) {
	    callback = options.callback;
	  }
	
	  if (typeof Promise !== 'undefined') {
	    return new Promise(function (resolve, reject) {
	      // eslint-disable-line
	      msgQueue.push({
	        options: merge_default()({}, main_defaults, MessageBox.defaults, options),
	        callback: callback,
	        resolve: resolve,
	        reject: reject
	      });
	
	      main_showNextMsg();
	    });
	  } else {
	    msgQueue.push({
	      options: merge_default()({}, main_defaults, MessageBox.defaults, options),
	      callback: callback
	    });
	
	    main_showNextMsg();
	  }
	};
	
	main_MessageBox.setDefaults = function (defaults) {
	  main_MessageBox.defaults = defaults;
	};
	
	main_MessageBox.alert = function (message, title, options) {
	  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
	    options = title;
	    title = '';
	  } else if (title === undefined) {
	    title = '';
	  }
	  return main_MessageBox(merge_default()({
	    title: title,
	    message: message,
	    $type: 'alert',
	    closeOnPressEscape: false,
	    closeOnClickModal: false
	  }, options));
	};
	
	main_MessageBox.confirm = function (message, title, options) {
	  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
	    options = title;
	    title = '';
	  } else if (title === undefined) {
	    title = '';
	  }
	  return main_MessageBox(merge_default()({
	    title: title,
	    message: message,
	    $type: 'confirm',
	    showCancelButton: true
	  }, options));
	};
	
	main_MessageBox.prompt = function (message, title, options) {
	  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
	    options = title;
	    title = '';
	  } else if (title === undefined) {
	    title = '';
	  }
	  return main_MessageBox(merge_default()({
	    title: title,
	    message: message,
	    showCancelButton: true,
	    showInput: true,
	    $type: 'prompt'
	  }, options));
	};
	
	main_MessageBox.close = function () {
	  main_instance.doClose();
	  main_instance.visible = false;
	  msgQueue = [];
	  currentMsg = null;
	};
	
	/* harmony default export */ var packages_message_box_src_main = (main_MessageBox);
	
	// CONCATENATED MODULE: ./packages/message-box/index.js
	
	/* harmony default export */ var message_box = (packages_message_box_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
	var breadcrumbvue_type_template_id_4b464c06_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-breadcrumb",
	      attrs: { "aria-label": "Breadcrumb", role: "navigation" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var breadcrumbvue_type_template_id_4b464c06_staticRenderFns = []
	breadcrumbvue_type_template_id_4b464c06_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var breadcrumbvue_type_script_lang_js_ = ({
	  name: 'ElBreadcrumb',
	
	  props: {
	    separator: {
	      type: String,
	      default: '/'
	    },
	    separatorClass: {
	      type: String,
	      default: ''
	    }
	  },
	
	  provide: function provide() {
	    return {
	      elBreadcrumb: this
	    };
	  },
	  mounted: function mounted() {
	    var items = this.$el.querySelectorAll('.el-breadcrumb__item');
	    if (items.length) {
	      items[items.length - 1].setAttribute('aria-current', 'page');
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_breadcrumbvue_type_script_lang_js_ = (breadcrumbvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue
	
	
	
	
	
	/* normalize component */
	
	var breadcrumb_component = normalizeComponent(
	  src_breadcrumbvue_type_script_lang_js_,
	  breadcrumbvue_type_template_id_4b464c06_render,
	  breadcrumbvue_type_template_id_4b464c06_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var breadcrumb_api; }
	breadcrumb_component.options.__file = "packages/breadcrumb/src/breadcrumb.vue"
	/* harmony default export */ var breadcrumb = (breadcrumb_component.exports);
	// CONCATENATED MODULE: ./packages/breadcrumb/index.js
	
	
	/* istanbul ignore next */
	breadcrumb.install = function (Vue) {
	  Vue.component(breadcrumb.name, breadcrumb);
	};
	
	/* harmony default export */ var packages_breadcrumb = (breadcrumb);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
	var breadcrumb_itemvue_type_template_id_fcf9eaac_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("span", { staticClass: "el-breadcrumb__item" }, [
	    _c(
	      "span",
	      {
	        ref: "link",
	        class: ["el-breadcrumb__inner", _vm.to ? "is-link" : ""],
	        attrs: { role: "link" }
	      },
	      [_vm._t("default")],
	      2
	    ),
	    _vm.separatorClass
	      ? _c("i", {
	          staticClass: "el-breadcrumb__separator",
	          class: _vm.separatorClass
	        })
	      : _c(
	          "span",
	          {
	            staticClass: "el-breadcrumb__separator",
	            attrs: { role: "presentation" }
	          },
	          [_vm._v(_vm._s(_vm.separator))]
	        )
	  ])
	}
	var breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns = []
	breadcrumb_itemvue_type_template_id_fcf9eaac_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var breadcrumb_itemvue_type_script_lang_js_ = ({
	  name: 'ElBreadcrumbItem',
	  props: {
	    to: {},
	    replace: Boolean
	  },
	  data: function data() {
	    return {
	      separator: '',
	      separatorClass: ''
	    };
	  },
	
	
	  inject: ['elBreadcrumb'],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.separator = this.elBreadcrumb.separator;
	    this.separatorClass = this.elBreadcrumb.separatorClass;
	    var link = this.$refs.link;
	    link.setAttribute('role', 'link');
	    link.addEventListener('click', function (_) {
	      var to = _this.to,
	          $router = _this.$router;
	
	      if (!to || !$router) return;
	      _this.replace ? $router.replace(to) : $router.push(to);
	    });
	  }
	});
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_breadcrumb_itemvue_type_script_lang_js_ = (breadcrumb_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue
	
	
	
	
	
	/* normalize component */
	
	var breadcrumb_item_component = normalizeComponent(
	  src_breadcrumb_itemvue_type_script_lang_js_,
	  breadcrumb_itemvue_type_template_id_fcf9eaac_render,
	  breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var breadcrumb_item_api; }
	breadcrumb_item_component.options.__file = "packages/breadcrumb/src/breadcrumb-item.vue"
	/* harmony default export */ var breadcrumb_item = (breadcrumb_item_component.exports);
	// CONCATENATED MODULE: ./packages/breadcrumb-item/index.js
	
	
	/* istanbul ignore next */
	breadcrumb_item.install = function (Vue) {
	  Vue.component(breadcrumb_item.name, breadcrumb_item);
	};
	
	/* harmony default export */ var packages_breadcrumb_item = (breadcrumb_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
	var formvue_type_template_id_a1b5ff34_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "form",
	    {
	      staticClass: "el-form",
	      class: [
	        _vm.labelPosition ? "el-form--label-" + _vm.labelPosition : "",
	        { "el-form--inline": _vm.inline }
	      ]
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var formvue_type_template_id_a1b5ff34_staticRenderFns = []
	formvue_type_template_id_a1b5ff34_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var formvue_type_script_lang_js_ = ({
	  name: 'ElForm',
	
	  componentName: 'ElForm',
	
	  provide: function provide() {
	    return {
	      elForm: this
	    };
	  },
	
	
	  props: {
	    model: Object,
	    rules: Object,
	    labelPosition: String,
	    labelWidth: String,
	    labelSuffix: {
	      type: String,
	      default: ''
	    },
	    inline: Boolean,
	    inlineMessage: Boolean,
	    statusIcon: Boolean,
	    showMessage: {
	      type: Boolean,
	      default: true
	    },
	    size: String,
	    disabled: Boolean,
	    validateOnRuleChange: {
	      type: Boolean,
	      default: true
	    },
	    hideRequiredAsterisk: {
	      type: Boolean,
	      default: false
	    }
	  },
	  watch: {
	    rules: function rules() {
	      // remove then add event listeners on form-item after form rules change
	      this.fields.forEach(function (field) {
	        field.removeValidateEvents();
	        field.addValidateEvents();
	      });
	
	      if (this.validateOnRuleChange) {
	        this.validate(function () {});
	      }
	    }
	  },
	  computed: {
	    autoLabelWidth: function autoLabelWidth() {
	      if (!this.potentialLabelWidthArr.length) return 0;
	      var max = Math.max.apply(Math, this.potentialLabelWidthArr);
	      return max ? max + 'px' : '';
	    }
	  },
	  data: function data() {
	    return {
	      fields: [],
	      potentialLabelWidthArr: [] // use this array to calculate auto width
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.$on('el.form.addField', function (field) {
	      if (field) {
	        _this.fields.push(field);
	      }
	    });
	    /* istanbul ignore next */
	    this.$on('el.form.removeField', function (field) {
	      if (field.prop) {
	        _this.fields.splice(_this.fields.indexOf(field), 1);
	      }
	    });
	  },
	
	  methods: {
	    resetFields: function resetFields() {
	      if (!this.model) {
	        console.warn('[Element Warn][Form]model is required for resetFields to work.');
	        return;
	      }
	      this.fields.forEach(function (field) {
	        field.resetField();
	      });
	    },
	    clearValidate: function clearValidate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var fields = props.length ? typeof props === 'string' ? this.fields.filter(function (field) {
	        return props === field.prop;
	      }) : this.fields.filter(function (field) {
	        return props.indexOf(field.prop) > -1;
	      }) : this.fields;
	      fields.forEach(function (field) {
	        field.clearValidate();
	      });
	    },
	    validate: function validate(callback) {
	      var _this2 = this;
	
	      if (!this.model) {
	        console.warn('[Element Warn][Form]model is required for validate to work!');
	        return;
	      }
	
	      var promise = void 0;
	      // if no callback, return promise
	      if (typeof callback !== 'function' && window.Promise) {
	        promise = new window.Promise(function (resolve, reject) {
	          callback = function callback(valid) {
	            valid ? resolve(valid) : reject(valid);
	          };
	        });
	      }
	
	      var valid = true;
	      var count = 0;
	      // 如果需要验证的fields为空，调用验证时立刻返回callback
	      if (this.fields.length === 0 && callback) {
	        callback(true);
	      }
	      var invalidFields = {};
	      this.fields.forEach(function (field) {
	        field.validate('', function (message, field) {
	          if (message) {
	            valid = false;
	          }
	          invalidFields = merge_default()({}, invalidFields, field);
	          if (typeof callback === 'function' && ++count === _this2.fields.length) {
	            callback(valid, invalidFields);
	          }
	        });
	      });
	
	      if (promise) {
	        return promise;
	      }
	    },
	    validateField: function validateField(props, cb) {
	      props = [].concat(props);
	      var fields = this.fields.filter(function (field) {
	        return props.indexOf(field.prop) !== -1;
	      });
	      if (!fields.length) {
	        console.warn('[Element Warn]please pass correct props!');
	        return;
	      }
	
	      fields.forEach(function (field) {
	        field.validate('', cb);
	      });
	    },
	    getLabelWidthIndex: function getLabelWidthIndex(width) {
	      var index = this.potentialLabelWidthArr.indexOf(width);
	      // it's impossible
	      if (index === -1) {
	        throw new Error('[ElementForm]unpected width ', width);
	      }
	      return index;
	    },
	    registerLabelWidth: function registerLabelWidth(val, oldVal) {
	      if (val && oldVal) {
	        var index = this.getLabelWidthIndex(oldVal);
	        this.potentialLabelWidthArr.splice(index, 1, val);
	      } else if (val) {
	        this.potentialLabelWidthArr.push(val);
	      }
	    },
	    deregisterLabelWidth: function deregisterLabelWidth(val) {
	      var index = this.getLabelWidthIndex(val);
	      this.potentialLabelWidthArr.splice(index, 1);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_formvue_type_script_lang_js_ = (formvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/form/src/form.vue
	
	
	
	
	
	/* normalize component */
	
	var form_component = normalizeComponent(
	  src_formvue_type_script_lang_js_,
	  formvue_type_template_id_a1b5ff34_render,
	  formvue_type_template_id_a1b5ff34_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var form_api; }
	form_component.options.__file = "packages/form/src/form.vue"
	/* harmony default export */ var src_form = (form_component.exports);
	// CONCATENATED MODULE: ./packages/form/index.js
	
	
	/* istanbul ignore next */
	src_form.install = function (Vue) {
	  Vue.component(src_form.name, src_form);
	};
	
	/* harmony default export */ var packages_form = (src_form);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
	var form_itemvue_type_template_id_b6f3db6c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-form-item",
	      class: [
	        {
	          "el-form-item--feedback": _vm.elForm && _vm.elForm.statusIcon,
	          "is-error": _vm.validateState === "error",
	          "is-validating": _vm.validateState === "validating",
	          "is-success": _vm.validateState === "success",
	          "is-required": _vm.isRequired || _vm.required,
	          "is-no-asterisk": _vm.elForm && _vm.elForm.hideRequiredAsterisk
	        },
	        _vm.sizeClass ? "el-form-item--" + _vm.sizeClass : ""
	      ]
	    },
	    [
	      _c(
	        "label-wrap",
	        {
	          attrs: {
	            "is-auto-width": _vm.labelStyle && _vm.labelStyle.width === "auto",
	            "update-all": _vm.form.labelWidth === "auto"
	          }
	        },
	        [
	          _vm.label || _vm.$slots.label
	            ? _c(
	                "label",
	                {
	                  staticClass: "el-form-item__label",
	                  style: _vm.labelStyle,
	                  attrs: { for: _vm.labelFor }
	                },
	                [
	                  _vm._t("label", [
	                    _vm._v(_vm._s(_vm.label + _vm.form.labelSuffix))
	                  ])
	                ],
	                2
	              )
	            : _vm._e()
	        ]
	      ),
	      _c(
	        "div",
	        { staticClass: "el-form-item__content", style: _vm.contentStyle },
	        [
	          _vm._t("default"),
	          _c(
	            "transition",
	            { attrs: { name: "el-zoom-in-top" } },
	            [
	              _vm.validateState === "error" &&
	              _vm.showMessage &&
	              _vm.form.showMessage
	                ? _vm._t(
	                    "error",
	                    [
	                      _c(
	                        "div",
	                        {
	                          staticClass: "el-form-item__error",
	                          class: {
	                            "el-form-item__error--inline":
	                              typeof _vm.inlineMessage === "boolean"
	                                ? _vm.inlineMessage
	                                : (_vm.elForm && _vm.elForm.inlineMessage) ||
	                                  false
	                          }
	                        },
	                        [
	                          _vm._v(
	                            "\n          " +
	                              _vm._s(_vm.validateMessage) +
	                              "\n        "
	                          )
	                        ]
	                      )
	                    ],
	                    { error: _vm.validateMessage }
	                  )
	                : _vm._e()
	            ],
	            2
	          )
	        ],
	        2
	      )
	    ],
	    1
	  )
	}
	var form_itemvue_type_template_id_b6f3db6c_staticRenderFns = []
	form_itemvue_type_template_id_b6f3db6c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
	
	// EXTERNAL MODULE: external "async-validator"
	var external_async_validator_ = __webpack_require__(40);
	var external_async_validator_default = /*#__PURE__*/__webpack_require__.n(external_async_validator_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
	
	
	/* harmony default export */ var label_wrapvue_type_script_lang_js_ = ({
	  props: {
	    isAutoWidth: Boolean,
	    updateAll: Boolean
	  },
	
	  inject: ['elForm', 'elFormItem'],
	
	  render: function render() {
	    var h = arguments[0];
	
	    var slots = this.$slots.default;
	    if (!slots) return null;
	    if (this.isAutoWidth) {
	      var autoLabelWidth = this.elForm.autoLabelWidth;
	      var style = {};
	      if (autoLabelWidth && autoLabelWidth !== 'auto') {
	        var marginLeft = parseInt(autoLabelWidth, 10) - this.computedWidth;
	        if (marginLeft) {
	          style.marginLeft = marginLeft + 'px';
	        }
	      }
	      return h(
	        'div',
	        { 'class': 'el-form-item__label-wrap', style: style },
	        [slots]
	      );
	    } else {
	      return slots[0];
	    }
	  },
	
	
	  methods: {
	    getLabelWidth: function getLabelWidth() {
	      if (this.$el && this.$el.firstElementChild) {
	        var computedWidth = window.getComputedStyle(this.$el.firstElementChild).width;
	        return Math.ceil(parseFloat(computedWidth));
	      } else {
	        return 0;
	      }
	    },
	    updateLabelWidth: function updateLabelWidth() {
	      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'update';
	
	      if (this.$slots.default && this.isAutoWidth && this.$el.firstElementChild) {
	        if (action === 'update') {
	          this.computedWidth = this.getLabelWidth();
	        } else if (action === 'remove') {
	          this.elForm.deregisterLabelWidth(this.computedWidth);
	        }
	      }
	    }
	  },
	
	  watch: {
	    computedWidth: function computedWidth(val, oldVal) {
	      if (this.updateAll) {
	        this.elForm.registerLabelWidth(val, oldVal);
	        this.elFormItem.updateComputedLabelWidth(val);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      computedWidth: 0
	    };
	  },
	  mounted: function mounted() {
	    this.updateLabelWidth('update');
	  },
	  updated: function updated() {
	    this.updateLabelWidth('update');
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.updateLabelWidth('remove');
	  }
	});
	// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_label_wrapvue_type_script_lang_js_ = (label_wrapvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue
	var label_wrap_render, label_wrap_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var label_wrap_component = normalizeComponent(
	  src_label_wrapvue_type_script_lang_js_,
	  label_wrap_render,
	  label_wrap_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var label_wrap_api; }
	label_wrap_component.options.__file = "packages/form/src/label-wrap.vue"
	/* harmony default export */ var label_wrap = (label_wrap_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var form_itemvue_type_script_lang_js_ = ({
	  name: 'ElFormItem',
	
	  componentName: 'ElFormItem',
	
	  mixins: [emitter_default.a],
	
	  provide: function provide() {
	    return {
	      elFormItem: this
	    };
	  },
	
	
	  inject: ['elForm'],
	
	  props: {
	    label: String,
	    labelWidth: String,
	    prop: String,
	    required: {
	      type: Boolean,
	      default: undefined
	    },
	    rules: [Object, Array],
	    error: String,
	    validateStatus: String,
	    for: String,
	    inlineMessage: {
	      type: [String, Boolean],
	      default: ''
	    },
	    showMessage: {
	      type: Boolean,
	      default: true
	    },
	    size: String
	  },
	  components: {
	    // use this component to calculate auto width
	    LabelWrap: label_wrap
	  },
	  watch: {
	    error: {
	      immediate: true,
	      handler: function handler(value) {
	        this.validateMessage = value;
	        this.validateState = value ? 'error' : '';
	      }
	    },
	    validateStatus: function validateStatus(value) {
	      this.validateState = value;
	    }
	  },
	  computed: {
	    labelFor: function labelFor() {
	      return this.for || this.prop;
	    },
	    labelStyle: function labelStyle() {
	      var ret = {};
	      if (this.form.labelPosition === 'top') return ret;
	      var labelWidth = this.labelWidth || this.form.labelWidth;
	      if (labelWidth) {
	        ret.width = labelWidth;
	      }
	      return ret;
	    },
	    contentStyle: function contentStyle() {
	      var ret = {};
	      var label = this.label;
	      if (this.form.labelPosition === 'top' || this.form.inline) return ret;
	      if (!label && !this.labelWidth && this.isNested) return ret;
	      var labelWidth = this.labelWidth || this.form.labelWidth;
	      if (labelWidth === 'auto') {
	        if (this.labelWidth === 'auto') {
	          ret.marginLeft = this.computedLabelWidth;
	        } else if (this.form.labelWidth === 'auto') {
	          ret.marginLeft = this.elForm.autoLabelWidth;
	        }
	      } else {
	        ret.marginLeft = labelWidth;
	      }
	      return ret;
	    },
	    form: function form() {
	      var parent = this.$parent;
	      var parentName = parent.$options.componentName;
	      while (parentName !== 'ElForm') {
	        if (parentName === 'ElFormItem') {
	          this.isNested = true;
	        }
	        parent = parent.$parent;
	        parentName = parent.$options.componentName;
	      }
	      return parent;
	    },
	    fieldValue: function fieldValue() {
	      var model = this.form.model;
	      if (!model || !this.prop) {
	        return;
	      }
	
	      var path = this.prop;
	      if (path.indexOf(':') !== -1) {
	        path = path.replace(/:/, '.');
	      }
	
	      return Object(util_["getPropByPath"])(model, path, true).v;
	    },
	    isRequired: function isRequired() {
	      var rules = this.getRules();
	      var isRequired = false;
	
	      if (rules && rules.length) {
	        rules.every(function (rule) {
	          if (rule.required) {
	            isRequired = true;
	            return false;
	          }
	          return true;
	        });
	      }
	      return isRequired;
	    },
	    _formSize: function _formSize() {
	      return this.elForm.size;
	    },
	    elFormItemSize: function elFormItemSize() {
	      return this.size || this._formSize;
	    },
	    sizeClass: function sizeClass() {
	      return this.elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	  data: function data() {
	    return {
	      validateState: '',
	      validateMessage: '',
	      validateDisabled: false,
	      validator: {},
	      isNested: false,
	      computedLabelWidth: ''
	    };
	  },
	
	  methods: {
	    validate: function validate(trigger) {
	      var _this = this;
	
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : util_["noop"];
	
	      this.validateDisabled = false;
	      var rules = this.getFilteredRule(trigger);
	      if ((!rules || rules.length === 0) && this.required === undefined) {
	        callback();
	        return true;
	      }
	
	      this.validateState = 'validating';
	
	      var descriptor = {};
	      if (rules && rules.length > 0) {
	        rules.forEach(function (rule) {
	          delete rule.trigger;
	        });
	      }
	      descriptor[this.prop] = rules;
	
	      var validator = new external_async_validator_default.a(descriptor);
	      var model = {};
	
	      model[this.prop] = this.fieldValue;
	
	      validator.validate(model, { firstFields: true }, function (errors, invalidFields) {
	        _this.validateState = !errors ? 'success' : 'error';
	        _this.validateMessage = errors ? errors[0].message : '';
	
	        callback(_this.validateMessage, invalidFields);
	        _this.elForm && _this.elForm.$emit('validate', _this.prop, !errors, _this.validateMessage || null);
	      });
	    },
	    clearValidate: function clearValidate() {
	      this.validateState = '';
	      this.validateMessage = '';
	      this.validateDisabled = false;
	    },
	    resetField: function resetField() {
	      var _this2 = this;
	
	      this.validateState = '';
	      this.validateMessage = '';
	
	      var model = this.form.model;
	      var value = this.fieldValue;
	      var path = this.prop;
	      if (path.indexOf(':') !== -1) {
	        path = path.replace(/:/, '.');
	      }
	
	      var prop = Object(util_["getPropByPath"])(model, path, true);
	
	      this.validateDisabled = true;
	      if (Array.isArray(value)) {
	        prop.o[prop.k] = [].concat(this.initialValue);
	      } else {
	        prop.o[prop.k] = this.initialValue;
	      }
	
	      // reset validateDisabled after onFieldChange triggered
	      this.$nextTick(function () {
	        _this2.validateDisabled = false;
	      });
	
	      this.broadcast('ElTimeSelect', 'fieldReset', this.initialValue);
	    },
	    getRules: function getRules() {
	      var formRules = this.form.rules;
	      var selfRules = this.rules;
	      var requiredRule = this.required !== undefined ? { required: !!this.required } : [];
	
	      var prop = Object(util_["getPropByPath"])(formRules, this.prop || '');
	      formRules = formRules ? prop.o[this.prop || ''] || prop.v : [];
	
	      return [].concat(selfRules || formRules || []).concat(requiredRule);
	    },
	    getFilteredRule: function getFilteredRule(trigger) {
	      var rules = this.getRules();
	
	      return rules.filter(function (rule) {
	        if (!rule.trigger || trigger === '') return true;
	        if (Array.isArray(rule.trigger)) {
	          return rule.trigger.indexOf(trigger) > -1;
	        } else {
	          return rule.trigger === trigger;
	        }
	      }).map(function (rule) {
	        return merge_default()({}, rule);
	      });
	    },
	    onFieldBlur: function onFieldBlur() {
	      this.validate('blur');
	    },
	    onFieldChange: function onFieldChange() {
	      if (this.validateDisabled) {
	        this.validateDisabled = false;
	        return;
	      }
	
	      this.validate('change');
	    },
	    updateComputedLabelWidth: function updateComputedLabelWidth(width) {
	      this.computedLabelWidth = width ? width + 'px' : '';
	    },
	    addValidateEvents: function addValidateEvents() {
	      var rules = this.getRules();
	
	      if (rules.length || this.required !== undefined) {
	        this.$on('el.form.blur', this.onFieldBlur);
	        this.$on('el.form.change', this.onFieldChange);
	      }
	    },
	    removeValidateEvents: function removeValidateEvents() {
	      this.$off();
	    }
	  },
	  mounted: function mounted() {
	    if (this.prop) {
	      this.dispatch('ElForm', 'el.form.addField', [this]);
	
	      var initialValue = this.fieldValue;
	      if (Array.isArray(initialValue)) {
	        initialValue = [].concat(initialValue);
	      }
	      Object.defineProperty(this, 'initialValue', {
	        value: initialValue
	      });
	
	      this.addValidateEvents();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.dispatch('ElForm', 'el.form.removeField', [this]);
	  }
	});
	// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_form_itemvue_type_script_lang_js_ = (form_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/form/src/form-item.vue
	
	
	
	
	
	/* normalize component */
	
	var form_item_component = normalizeComponent(
	  src_form_itemvue_type_script_lang_js_,
	  form_itemvue_type_template_id_b6f3db6c_render,
	  form_itemvue_type_template_id_b6f3db6c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var form_item_api; }
	form_item_component.options.__file = "packages/form/src/form-item.vue"
	/* harmony default export */ var form_item = (form_item_component.exports);
	// CONCATENATED MODULE: ./packages/form-item/index.js
	
	
	/* istanbul ignore next */
	form_item.install = function (Vue) {
	  Vue.component(form_item.name, form_item);
	};
	
	/* harmony default export */ var packages_form_item = (form_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
	var tab_barvue_type_template_id_2031f33a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", {
	    staticClass: "el-tabs__active-bar",
	    class: "is-" + _vm.rootTabs.tabPosition,
	    style: _vm.barStyle
	  })
	}
	var tab_barvue_type_template_id_2031f33a_staticRenderFns = []
	tab_barvue_type_template_id_2031f33a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
	//
	//
	//
	
	
	/* harmony default export */ var tab_barvue_type_script_lang_js_ = ({
	  name: 'TabBar',
	
	  props: {
	    tabs: Array
	  },
	
	  inject: ['rootTabs'],
	
	  computed: {
	    barStyle: {
	      get: function get() {
	        var _this = this;
	
	        var style = {};
	        var offset = 0;
	        var tabSize = 0;
	        var sizeName = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
	        var sizeDir = sizeName === 'width' ? 'x' : 'y';
	        var firstUpperCase = function firstUpperCase(str) {
	          return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
	            return L.toUpperCase();
	          });
	        };
	        this.tabs.every(function (tab, index) {
	          var $el = Object(util_["arrayFind"])(_this.$parent.$refs.tabs || [], function (t) {
	            return t.id.replace('tab-', '') === tab.paneName;
	          });
	          if (!$el) {
	            return false;
	          }
	
	          if (!tab.active) {
	            offset += $el['client' + firstUpperCase(sizeName)];
	            return true;
	          } else {
	            tabSize = $el['client' + firstUpperCase(sizeName)];
	            var tabStyles = window.getComputedStyle($el);
	            if (sizeName === 'width' && _this.tabs.length > 1) {
	              tabSize -= parseFloat(tabStyles.paddingLeft) + parseFloat(tabStyles.paddingRight);
	            }
	            if (sizeName === 'width') {
	              offset += parseFloat(tabStyles.paddingLeft);
	            }
	            return false;
	          }
	        });
	
	        var transform = 'translate' + firstUpperCase(sizeDir) + '(' + offset + 'px)';
	        style[sizeName] = tabSize + 'px';
	        style.transform = transform;
	        style.msTransform = transform;
	        style.webkitTransform = transform;
	
	        return style;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tab_barvue_type_script_lang_js_ = (tab_barvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue
	
	
	
	
	
	/* normalize component */
	
	var tab_bar_component = normalizeComponent(
	  src_tab_barvue_type_script_lang_js_,
	  tab_barvue_type_template_id_2031f33a_render,
	  tab_barvue_type_template_id_2031f33a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tab_bar_api; }
	tab_bar_component.options.__file = "packages/tabs/src/tab-bar.vue"
	/* harmony default export */ var tab_bar = (tab_bar_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
	
	
	
	
	function noop() {}
	var tab_navvue_type_script_lang_js_firstUpperCase = function firstUpperCase(str) {
	  return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
	    return L.toUpperCase();
	  });
	};
	
	/* harmony default export */ var tab_navvue_type_script_lang_js_ = ({
	  name: 'TabNav',
	
	  components: {
	    TabBar: tab_bar
	  },
	
	  inject: ['rootTabs'],
	
	  props: {
	    panes: Array,
	    currentName: String,
	    editable: Boolean,
	    onTabClick: {
	      type: Function,
	      default: noop
	    },
	    onTabRemove: {
	      type: Function,
	      default: noop
	    },
	    type: String,
	    stretch: Boolean
	  },
	
	  data: function data() {
	    return {
	      scrollable: false,
	      navOffset: 0,
	      isFocus: false,
	      focusable: true
	    };
	  },
	
	
	  computed: {
	    navStyle: function navStyle() {
	      var dir = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'X' : 'Y';
	      return {
	        transform: 'translate' + dir + '(-' + this.navOffset + 'px)'
	      };
	    },
	    sizeName: function sizeName() {
	      return ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
	    }
	  },
	
	  methods: {
	    scrollPrev: function scrollPrev() {
	      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
	      var currentOffset = this.navOffset;
	
	      if (!currentOffset) return;
	
	      var newOffset = currentOffset > containerSize ? currentOffset - containerSize : 0;
	
	      this.navOffset = newOffset;
	    },
	    scrollNext: function scrollNext() {
	      var navSize = this.$refs.nav['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
	      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
	      var currentOffset = this.navOffset;
	
	      if (navSize - currentOffset <= containerSize) return;
	
	      var newOffset = navSize - currentOffset > containerSize * 2 ? currentOffset + containerSize : navSize - containerSize;
	
	      this.navOffset = newOffset;
	    },
	    scrollToActiveTab: function scrollToActiveTab() {
	      if (!this.scrollable) return;
	      var nav = this.$refs.nav;
	      var activeTab = this.$el.querySelector('.is-active');
	      if (!activeTab) return;
	      var navScroll = this.$refs.navScroll;
	      var isHorizontal = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1;
	      var activeTabBounding = activeTab.getBoundingClientRect();
	      var navScrollBounding = navScroll.getBoundingClientRect();
	      var maxOffset = isHorizontal ? nav.offsetWidth - navScrollBounding.width : nav.offsetHeight - navScrollBounding.height;
	      var currentOffset = this.navOffset;
	      var newOffset = currentOffset;
	
	      if (isHorizontal) {
	        if (activeTabBounding.left < navScrollBounding.left) {
	          newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left);
	        }
	        if (activeTabBounding.right > navScrollBounding.right) {
	          newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right;
	        }
	      } else {
	        if (activeTabBounding.top < navScrollBounding.top) {
	          newOffset = currentOffset - (navScrollBounding.top - activeTabBounding.top);
	        }
	        if (activeTabBounding.bottom > navScrollBounding.bottom) {
	          newOffset = currentOffset + (activeTabBounding.bottom - navScrollBounding.bottom);
	        }
	      }
	      newOffset = Math.max(newOffset, 0);
	      this.navOffset = Math.min(newOffset, maxOffset);
	    },
	    update: function update() {
	      if (!this.$refs.nav) return;
	      var sizeName = this.sizeName;
	      var navSize = this.$refs.nav['offset' + tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];
	      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];
	      var currentOffset = this.navOffset;
	
	      if (containerSize < navSize) {
	        var _currentOffset = this.navOffset;
	        this.scrollable = this.scrollable || {};
	        this.scrollable.prev = _currentOffset;
	        this.scrollable.next = _currentOffset + containerSize < navSize;
	        if (navSize - _currentOffset < containerSize) {
	          this.navOffset = navSize - containerSize;
	        }
	      } else {
	        this.scrollable = false;
	        if (currentOffset > 0) {
	          this.navOffset = 0;
	        }
	      }
	    },
	    changeTab: function changeTab(e) {
	      var keyCode = e.keyCode;
	      var nextIndex = void 0;
	      var currentIndex = void 0,
	          tabList = void 0;
	      if ([37, 38, 39, 40].indexOf(keyCode) !== -1) {
	        // 左右上下键更换tab
	        tabList = e.currentTarget.querySelectorAll('[role=tab]');
	        currentIndex = Array.prototype.indexOf.call(tabList, e.target);
	      } else {
	        return;
	      }
	      if (keyCode === 37 || keyCode === 38) {
	        // left
	        if (currentIndex === 0) {
	          // first
	          nextIndex = tabList.length - 1;
	        } else {
	          nextIndex = currentIndex - 1;
	        }
	      } else {
	        // right
	        if (currentIndex < tabList.length - 1) {
	          // not last
	          nextIndex = currentIndex + 1;
	        } else {
	          nextIndex = 0;
	        }
	      }
	      tabList[nextIndex].focus(); // 改变焦点元素
	      tabList[nextIndex].click(); // 选中下一个tab
	      this.setFocus();
	    },
	    setFocus: function setFocus() {
	      if (this.focusable) {
	        this.isFocus = true;
	      }
	    },
	    removeFocus: function removeFocus() {
	      this.isFocus = false;
	    },
	    visibilityChangeHandler: function visibilityChangeHandler() {
	      var _this = this;
	
	      var visibility = document.visibilityState;
	      if (visibility === 'hidden') {
	        this.focusable = false;
	      } else if (visibility === 'visible') {
	        setTimeout(function () {
	          _this.focusable = true;
	        }, 50);
	      }
	    },
	    windowBlurHandler: function windowBlurHandler() {
	      this.focusable = false;
	    },
	    windowFocusHandler: function windowFocusHandler() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.focusable = true;
	      }, 50);
	    }
	  },
	
	  updated: function updated() {
	    this.update();
	  },
	  render: function render(h) {
	    var _this3 = this;
	
	    var type = this.type,
	        panes = this.panes,
	        editable = this.editable,
	        stretch = this.stretch,
	        onTabClick = this.onTabClick,
	        onTabRemove = this.onTabRemove,
	        navStyle = this.navStyle,
	        scrollable = this.scrollable,
	        scrollNext = this.scrollNext,
	        scrollPrev = this.scrollPrev,
	        changeTab = this.changeTab,
	        setFocus = this.setFocus,
	        removeFocus = this.removeFocus;
	
	    var scrollBtn = scrollable ? [h(
	      'span',
	      { 'class': ['el-tabs__nav-prev', scrollable.prev ? '' : 'is-disabled'], on: {
	          'click': scrollPrev
	        }
	      },
	      [h('i', { 'class': 'el-icon-arrow-left' })]
	    ), h(
	      'span',
	      { 'class': ['el-tabs__nav-next', scrollable.next ? '' : 'is-disabled'], on: {
	          'click': scrollNext
	        }
	      },
	      [h('i', { 'class': 'el-icon-arrow-right' })]
	    )] : null;
	
	    var tabs = this._l(panes, function (pane, index) {
	      var _ref;
	
	      var tabName = pane.name || pane.index || index;
	      var closable = pane.isClosable || editable;
	
	      pane.index = '' + index;
	
	      var btnClose = closable ? h('span', { 'class': 'el-icon-close', on: {
	          'click': function click(ev) {
	            onTabRemove(pane, ev);
	          }
	        }
	      }) : null;
	
	      var tabLabelContent = pane.$slots.label || pane.label;
	      var tabindex = pane.active ? 0 : -1;
	      return h(
	        'div',
	        {
	          'class': (_ref = {
	            'el-tabs__item': true
	          }, _ref['is-' + _this3.rootTabs.tabPosition] = true, _ref['is-active'] = pane.active, _ref['is-disabled'] = pane.disabled, _ref['is-closable'] = closable, _ref['is-focus'] = _this3.isFocus, _ref),
	          attrs: { id: 'tab-' + tabName,
	
	            'aria-controls': 'pane-' + tabName,
	            role: 'tab',
	            'aria-selected': pane.active,
	
	            tabindex: tabindex
	          },
	          key: 'tab-' + tabName, ref: 'tabs', refInFor: true,
	          on: {
	            'focus': function focus() {
	              setFocus();
	            },
	            'blur': function blur() {
	              removeFocus();
	            },
	            'click': function click(ev) {
	              removeFocus();onTabClick(pane, tabName, ev);
	            },
	            'keydown': function keydown(ev) {
	              if (closable && (ev.keyCode === 46 || ev.keyCode === 8)) {
	                onTabRemove(pane, ev);
	              }
	            }
	          }
	        },
	        [tabLabelContent, btnClose]
	      );
	    });
	    return h(
	      'div',
	      { 'class': ['el-tabs__nav-wrap', scrollable ? 'is-scrollable' : '', 'is-' + this.rootTabs.tabPosition] },
	      [scrollBtn, h(
	        'div',
	        { 'class': ['el-tabs__nav-scroll'], ref: 'navScroll' },
	        [h(
	          'div',
	          {
	            'class': ['el-tabs__nav', 'is-' + this.rootTabs.tabPosition, stretch && ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'is-stretch' : ''],
	            ref: 'nav',
	            style: navStyle,
	            attrs: { role: 'tablist'
	            },
	            on: {
	              'keydown': changeTab
	            }
	          },
	          [!type ? h('tab-bar', {
	            attrs: { tabs: panes }
	          }) : null, tabs]
	        )]
	      )]
	    );
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    Object(resize_event_["addResizeListener"])(this.$el, this.update);
	    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
	    window.addEventListener('blur', this.windowBlurHandler);
	    window.addEventListener('focus', this.windowFocusHandler);
	    setTimeout(function () {
	      _this4.scrollToActiveTab();
	    }, 0);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.update) Object(resize_event_["removeResizeListener"])(this.$el, this.update);
	    document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
	    window.removeEventListener('blur', this.windowBlurHandler);
	    window.removeEventListener('focus', this.windowFocusHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tab_navvue_type_script_lang_js_ = (tab_navvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue
	var tab_nav_render, tab_nav_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var tab_nav_component = normalizeComponent(
	  src_tab_navvue_type_script_lang_js_,
	  tab_nav_render,
	  tab_nav_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tab_nav_api; }
	tab_nav_component.options.__file = "packages/tabs/src/tab-nav.vue"
	/* harmony default export */ var tab_nav = (tab_nav_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
	
	
	
	/* harmony default export */ var tabsvue_type_script_lang_js_ = ({
	  name: 'ElTabs',
	
	  components: {
	    TabNav: tab_nav
	  },
	
	  props: {
	    type: String,
	    activeName: String,
	    closable: Boolean,
	    addable: Boolean,
	    value: {},
	    editable: Boolean,
	    tabPosition: {
	      type: String,
	      default: 'top'
	    },
	    beforeLeave: Function,
	    stretch: Boolean
	  },
	
	  provide: function provide() {
	    return {
	      rootTabs: this
	    };
	  },
	  data: function data() {
	    return {
	      currentName: this.value || this.activeName,
	      panes: []
	    };
	  },
	
	
	  watch: {
	    activeName: function activeName(value) {
	      this.setCurrentName(value);
	    },
	    value: function value(_value) {
	      this.setCurrentName(_value);
	    },
	    currentName: function currentName(value) {
	      var _this = this;
	
	      if (this.$refs.nav) {
	        this.$nextTick(function () {
	          _this.$refs.nav.$nextTick(function (_) {
	            _this.$refs.nav.scrollToActiveTab();
	          });
	        });
	      }
	    }
	  },
	
	  methods: {
	    calcPaneInstances: function calcPaneInstances() {
	      var _this2 = this;
	
	      var isForceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.$slots.default) {
	        var paneSlots = this.$slots.default.filter(function (vnode) {
	          return vnode.tag && vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'ElTabPane';
	        });
	        // update indeed
	        var panes = paneSlots.map(function (_ref) {
	          var componentInstance = _ref.componentInstance;
	          return componentInstance;
	        });
	        var panesChanged = !(panes.length === this.panes.length && panes.every(function (pane, index) {
	          return pane === _this2.panes[index];
	        }));
	        if (isForceUpdate || panesChanged) {
	          this.panes = panes;
	        }
	      } else if (this.panes.length !== 0) {
	        this.panes = [];
	      }
	    },
	    handleTabClick: function handleTabClick(tab, tabName, event) {
	      if (tab.disabled) return;
	      this.setCurrentName(tabName);
	      this.$emit('tab-click', tab, event);
	    },
	    handleTabRemove: function handleTabRemove(pane, ev) {
	      if (pane.disabled) return;
	      ev.stopPropagation();
	      this.$emit('edit', pane.name, 'remove');
	      this.$emit('tab-remove', pane.name);
	    },
	    handleTabAdd: function handleTabAdd() {
	      this.$emit('edit', null, 'add');
	      this.$emit('tab-add');
	    },
	    setCurrentName: function setCurrentName(value) {
	      var _this3 = this;
	
	      var changeCurrentName = function changeCurrentName() {
	        _this3.currentName = value;
	        _this3.$emit('input', value);
	      };
	      if (this.currentName !== value && this.beforeLeave) {
	        var before = this.beforeLeave(value, this.currentName);
	        if (before && before.then) {
	          before.then(function () {
	            changeCurrentName();
	            _this3.$refs.nav && _this3.$refs.nav.removeFocus();
	          }, function () {
	            // https://github.com/ElemeFE/element/pull/14816
	            // ignore promise rejection in `before-leave` hook
	          });
	        } else if (before !== false) {
	          changeCurrentName();
	        }
	      } else {
	        changeCurrentName();
	      }
	    }
	  },
	
	  render: function render(h) {
	    var _ref2;
	
	    var type = this.type,
	        handleTabClick = this.handleTabClick,
	        handleTabRemove = this.handleTabRemove,
	        handleTabAdd = this.handleTabAdd,
	        currentName = this.currentName,
	        panes = this.panes,
	        editable = this.editable,
	        addable = this.addable,
	        tabPosition = this.tabPosition,
	        stretch = this.stretch;
	
	
	    var newButton = editable || addable ? h(
	      'span',
	      {
	        'class': 'el-tabs__new-tab',
	        on: {
	          'click': handleTabAdd,
	          'keydown': function keydown(ev) {
	            if (ev.keyCode === 13) {
	              handleTabAdd();
	            }
	          }
	        },
	        attrs: {
	          tabindex: '0'
	        }
	      },
	      [h('i', { 'class': 'el-icon-plus' })]
	    ) : null;
	
	    var navData = {
	      props: {
	        currentName: currentName,
	        onTabClick: handleTabClick,
	        onTabRemove: handleTabRemove,
	        editable: editable,
	        type: type,
	        panes: panes,
	        stretch: stretch
	      },
	      ref: 'nav'
	    };
	    var header = h(
	      'div',
	      { 'class': ['el-tabs__header', 'is-' + tabPosition] },
	      [newButton, h('tab-nav', navData)]
	    );
	    var panels = h(
	      'div',
	      { 'class': 'el-tabs__content' },
	      [this.$slots.default]
	    );
	
	    return h(
	      'div',
	      { 'class': (_ref2 = {
	          'el-tabs': true,
	          'el-tabs--card': type === 'card'
	        }, _ref2['el-tabs--' + tabPosition] = true, _ref2['el-tabs--border-card'] = type === 'border-card', _ref2) },
	      [tabPosition !== 'bottom' ? [header, panels] : [panels, header]]
	    );
	  },
	  created: function created() {
	    if (!this.currentName) {
	      this.setCurrentName('0');
	    }
	
	    this.$on('tab-nav-update', this.calcPaneInstances.bind(null, true));
	  },
	  mounted: function mounted() {
	    this.calcPaneInstances();
	  },
	  updated: function updated() {
	    this.calcPaneInstances();
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tabsvue_type_script_lang_js_ = (tabsvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue
	var tabs_render, tabs_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var tabs_component = normalizeComponent(
	  src_tabsvue_type_script_lang_js_,
	  tabs_render,
	  tabs_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tabs_api; }
	tabs_component.options.__file = "packages/tabs/src/tabs.vue"
	/* harmony default export */ var tabs = (tabs_component.exports);
	// CONCATENATED MODULE: ./packages/tabs/index.js
	
	
	/* istanbul ignore next */
	tabs.install = function (Vue) {
	  Vue.component(tabs.name, tabs);
	};
	
	/* harmony default export */ var packages_tabs = (tabs);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
	var tab_panevue_type_template_id_9145a070_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return !_vm.lazy || _vm.loaded || _vm.active
	    ? _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.active,
	              expression: "active"
	            }
	          ],
	          staticClass: "el-tab-pane",
	          attrs: {
	            role: "tabpanel",
	            "aria-hidden": !_vm.active,
	            id: "pane-" + _vm.paneName,
	            "aria-labelledby": "tab-" + _vm.paneName
	          }
	        },
	        [_vm._t("default")],
	        2
	      )
	    : _vm._e()
	}
	var tab_panevue_type_template_id_9145a070_staticRenderFns = []
	tab_panevue_type_template_id_9145a070_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var tab_panevue_type_script_lang_js_ = ({
	  name: 'ElTabPane',
	
	  componentName: 'ElTabPane',
	
	  props: {
	    label: String,
	    labelContent: Function,
	    name: String,
	    closable: Boolean,
	    disabled: Boolean,
	    lazy: Boolean
	  },
	
	  data: function data() {
	    return {
	      index: null,
	      loaded: false
	    };
	  },
	
	
	  computed: {
	    isClosable: function isClosable() {
	      return this.closable || this.$parent.closable;
	    },
	    active: function active() {
	      var active = this.$parent.currentName === (this.name || this.index);
	      if (active) {
	        this.loaded = true;
	      }
	      return active;
	    },
	    paneName: function paneName() {
	      return this.name || this.index;
	    }
	  },
	
	  updated: function updated() {
	    this.$parent.$emit('tab-nav-update');
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tab_panevue_type_script_lang_js_ = (tab_panevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue
	
	
	
	
	
	/* normalize component */
	
	var tab_pane_component = normalizeComponent(
	  src_tab_panevue_type_script_lang_js_,
	  tab_panevue_type_template_id_9145a070_render,
	  tab_panevue_type_template_id_9145a070_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tab_pane_api; }
	tab_pane_component.options.__file = "packages/tabs/src/tab-pane.vue"
	/* harmony default export */ var tab_pane = (tab_pane_component.exports);
	// CONCATENATED MODULE: ./packages/tab-pane/index.js
	
	
	/* istanbul ignore next */
	tab_pane.install = function (Vue) {
	  Vue.component(tab_pane.name, tab_pane);
	};
	
	/* harmony default export */ var packages_tab_pane = (tab_pane);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var tagvue_type_script_lang_js_ = ({
	  name: 'ElTag',
	  props: {
	    text: String,
	    closable: Boolean,
	    type: String,
	    hit: Boolean,
	    disableTransitions: Boolean,
	    color: String,
	    size: String,
	    effect: {
	      type: String,
	      default: 'light',
	      validator: function validator(val) {
	        return ['dark', 'light', 'plain'].indexOf(val) !== -1;
	      }
	    }
	  },
	  methods: {
	    handleClose: function handleClose(event) {
	      event.stopPropagation();
	      this.$emit('close', event);
	    },
	    handleClick: function handleClick(event) {
	      this.$emit('click', event);
	    }
	  },
	  computed: {
	    tagSize: function tagSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    }
	  },
	  render: function render(h) {
	    var type = this.type,
	        tagSize = this.tagSize,
	        hit = this.hit,
	        effect = this.effect;
	
	    var classes = ['el-tag', type ? 'el-tag--' + type : '', tagSize ? 'el-tag--' + tagSize : '', effect ? 'el-tag--' + effect : '', hit && 'is-hit'];
	    var tagEl = h(
	      'span',
	      {
	        'class': classes,
	        style: { backgroundColor: this.color },
	        on: {
	          'click': this.handleClick
	        }
	      },
	      [this.$slots.default, this.closable && h('i', { 'class': 'el-tag__close el-icon-close', on: {
	          'click': this.handleClose
	        }
	      })]
	    );
	
	    return this.disableTransitions ? tagEl : h(
	      'transition',
	      {
	        attrs: { name: 'el-zoom-in-center' }
	      },
	      [tagEl]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue
	var tag_render, tag_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var tag_component = normalizeComponent(
	  src_tagvue_type_script_lang_js_,
	  tag_render,
	  tag_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tag_api; }
	tag_component.options.__file = "packages/tag/src/tag.vue"
	/* harmony default export */ var tag = (tag_component.exports);
	// CONCATENATED MODULE: ./packages/tag/index.js
	
	
	/* istanbul ignore next */
	tag.install = function (Vue) {
	  Vue.component(tag.name, tag);
	};
	
	/* harmony default export */ var packages_tag = (tag);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
	var treevue_type_template_id_547575a6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-tree",
	      class: {
	        "el-tree--highlight-current": _vm.highlightCurrent,
	        "is-dragging": !!_vm.dragState.draggingNode,
	        "is-drop-not-allow": !_vm.dragState.allowDrop,
	        "is-drop-inner": _vm.dragState.dropType === "inner"
	      },
	      attrs: { role: "tree" }
	    },
	    [
	      _vm._l(_vm.root.childNodes, function(child) {
	        return _c("el-tree-node", {
	          key: _vm.getNodeKey(child),
	          attrs: {
	            node: child,
	            props: _vm.props,
	            "render-after-expand": _vm.renderAfterExpand,
	            "show-checkbox": _vm.showCheckbox,
	            "render-content": _vm.renderContent
	          },
	          on: { "node-expand": _vm.handleNodeExpand }
	        })
	      }),
	      _vm.isEmpty
	        ? _c("div", { staticClass: "el-tree__empty-block" }, [
	            _c("span", { staticClass: "el-tree__empty-text" }, [
	              _vm._v(_vm._s(_vm.emptyText))
	            ])
	          ])
	        : _vm._e(),
	      _c("div", {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.dragState.showDropIndicator,
	            expression: "dragState.showDropIndicator"
	          }
	        ],
	        ref: "dropIndicator",
	        staticClass: "el-tree__drop-indicator"
	      })
	    ],
	    2
	  )
	}
	var treevue_type_template_id_547575a6_staticRenderFns = []
	treevue_type_template_id_547575a6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
	
	// CONCATENATED MODULE: ./packages/tree/src/model/util.js
	var NODE_KEY = '$treeNodeId';
	
	var markNodeData = function markNodeData(node, data) {
	  if (!data || data[NODE_KEY]) return;
	  Object.defineProperty(data, NODE_KEY, {
	    value: node.id,
	    enumerable: false,
	    configurable: false,
	    writable: false
	  });
	};
	
	var util_getNodeKey = function getNodeKey(key, data) {
	  if (!key) return data[NODE_KEY];
	  return data[key];
	};
	
	var findNearestComponent = function findNearestComponent(element, componentName) {
	  var target = element;
	  while (target && target.tagName !== 'BODY') {
	    if (target.__vue__ && target.__vue__.$options.name === componentName) {
	      return target.__vue__;
	    }
	    target = target.parentNode;
	  }
	  return null;
	};
	// CONCATENATED MODULE: ./packages/tree/src/model/node.js
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function node_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	
	var getChildState = function getChildState(node) {
	  var all = true;
	  var none = true;
	  var allWithoutDisable = true;
	  for (var i = 0, j = node.length; i < j; i++) {
	    var n = node[i];
	    if (n.checked !== true || n.indeterminate) {
	      all = false;
	      if (!n.disabled) {
	        allWithoutDisable = false;
	      }
	    }
	    if (n.checked !== false || n.indeterminate) {
	      none = false;
	    }
	  }
	
	  return { all: all, none: none, allWithoutDisable: allWithoutDisable, half: !all && !none };
	};
	
	var reInitChecked = function reInitChecked(node) {
	  if (node.childNodes.length === 0) return;
	
	  var _getChildState = getChildState(node.childNodes),
	      all = _getChildState.all,
	      none = _getChildState.none,
	      half = _getChildState.half;
	
	  if (all) {
	    node.checked = true;
	    node.indeterminate = false;
	  } else if (half) {
	    node.checked = false;
	    node.indeterminate = true;
	  } else if (none) {
	    node.checked = false;
	    node.indeterminate = false;
	  }
	
	  var parent = node.parent;
	  if (!parent || parent.level === 0) return;
	
	  if (!node.store.checkStrictly) {
	    reInitChecked(parent);
	  }
	};
	
	var getPropertyFromData = function getPropertyFromData(node, prop) {
	  var props = node.store.props;
	  var data = node.data || {};
	  var config = props[prop];
	
	  if (typeof config === 'function') {
	    return config(data, node);
	  } else if (typeof config === 'string') {
	    return data[config];
	  } else if (typeof config === 'undefined') {
	    var dataProp = data[prop];
	    return dataProp === undefined ? '' : dataProp;
	  }
	};
	
	var nodeIdSeed = 0;
	
	var node_Node = function () {
	  function Node(options) {
	    node_classCallCheck(this, Node);
	
	    this.id = nodeIdSeed++;
	    this.text = null;
	    this.checked = false;
	    this.indeterminate = false;
	    this.data = null;
	    this.expanded = false;
	    this.parent = null;
	    this.visible = true;
	    this.isCurrent = false;
	
	    for (var name in options) {
	      if (options.hasOwnProperty(name)) {
	        this[name] = options[name];
	      }
	    }
	
	    // internal
	    this.level = 0;
	    this.loaded = false;
	    this.childNodes = [];
	    this.loading = false;
	
	    if (this.parent) {
	      this.level = this.parent.level + 1;
	    }
	
	    var store = this.store;
	    if (!store) {
	      throw new Error('[Node]store is required!');
	    }
	    store.registerNode(this);
	
	    var props = store.props;
	    if (props && typeof props.isLeaf !== 'undefined') {
	      var isLeaf = getPropertyFromData(this, 'isLeaf');
	      if (typeof isLeaf === 'boolean') {
	        this.isLeafByUser = isLeaf;
	      }
	    }
	
	    if (store.lazy !== true && this.data) {
	      this.setData(this.data);
	
	      if (store.defaultExpandAll) {
	        this.expanded = true;
	      }
	    } else if (this.level > 0 && store.lazy && store.defaultExpandAll) {
	      this.expand();
	    }
	    if (!Array.isArray(this.data)) {
	      markNodeData(this, this.data);
	    }
	    if (!this.data) return;
	    var defaultExpandedKeys = store.defaultExpandedKeys;
	    var key = store.key;
	    if (key && defaultExpandedKeys && defaultExpandedKeys.indexOf(this.key) !== -1) {
	      this.expand(null, store.autoExpandParent);
	    }
	
	    if (key && store.currentNodeKey !== undefined && this.key === store.currentNodeKey) {
	      store.currentNode = this;
	      store.currentNode.isCurrent = true;
	    }
	
	    if (store.lazy) {
	      store._initDefaultCheckedNode(this);
	    }
	
	    this.updateLeafState();
	  }
	
	  Node.prototype.setData = function setData(data) {
	    if (!Array.isArray(data)) {
	      markNodeData(this, data);
	    }
	
	    this.data = data;
	    this.childNodes = [];
	
	    var children = void 0;
	    if (this.level === 0 && this.data instanceof Array) {
	      children = this.data;
	    } else {
	      children = getPropertyFromData(this, 'children') || [];
	    }
	
	    for (var i = 0, j = children.length; i < j; i++) {
	      this.insertChild({ data: children[i] });
	    }
	  };
	
	  Node.prototype.contains = function contains(target) {
	    var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var walk = function walk(parent) {
	      var children = parent.childNodes || [];
	      var result = false;
	      for (var i = 0, j = children.length; i < j; i++) {
	        var child = children[i];
	        if (child === target || deep && walk(child)) {
	          result = true;
	          break;
	        }
	      }
	      return result;
	    };
	
	    return walk(this);
	  };
	
	  Node.prototype.remove = function remove() {
	    var parent = this.parent;
	    if (parent) {
	      parent.removeChild(this);
	    }
	  };
	
	  Node.prototype.insertChild = function insertChild(child, index, batch) {
	    if (!child) throw new Error('insertChild error: child is required.');
	
	    if (!(child instanceof Node)) {
	      if (!batch) {
	        var children = this.getChildren(true);
	        if (children.indexOf(child.data) === -1) {
	          if (typeof index === 'undefined' || index < 0) {
	            children.push(child.data);
	          } else {
	            children.splice(index, 0, child.data);
	          }
	        }
	      }
	      merge_default()(child, {
	        parent: this,
	        store: this.store
	      });
	      child = new Node(child);
	    }
	
	    child.level = this.level + 1;
	
	    if (typeof index === 'undefined' || index < 0) {
	      this.childNodes.push(child);
	    } else {
	      this.childNodes.splice(index, 0, child);
	    }
	
	    this.updateLeafState();
	  };
	
	  Node.prototype.insertBefore = function insertBefore(child, ref) {
	    var index = void 0;
	    if (ref) {
	      index = this.childNodes.indexOf(ref);
	    }
	    this.insertChild(child, index);
	  };
	
	  Node.prototype.insertAfter = function insertAfter(child, ref) {
	    var index = void 0;
	    if (ref) {
	      index = this.childNodes.indexOf(ref);
	      if (index !== -1) index += 1;
	    }
	    this.insertChild(child, index);
	  };
	
	  Node.prototype.removeChild = function removeChild(child) {
	    var children = this.getChildren() || [];
	    var dataIndex = children.indexOf(child.data);
	    if (dataIndex > -1) {
	      children.splice(dataIndex, 1);
	    }
	
	    var index = this.childNodes.indexOf(child);
	
	    if (index > -1) {
	      this.store && this.store.deregisterNode(child);
	      child.parent = null;
	      this.childNodes.splice(index, 1);
	    }
	
	    this.updateLeafState();
	  };
	
	  Node.prototype.removeChildByData = function removeChildByData(data) {
	    var targetNode = null;
	
	    for (var i = 0; i < this.childNodes.length; i++) {
	      if (this.childNodes[i].data === data) {
	        targetNode = this.childNodes[i];
	        break;
	      }
	    }
	
	    if (targetNode) {
	      this.removeChild(targetNode);
	    }
	  };
	
	  Node.prototype.expand = function expand(callback, expandParent) {
	    var _this = this;
	
	    var done = function done() {
	      if (expandParent) {
	        var parent = _this.parent;
	        while (parent.level > 0) {
	          parent.expanded = true;
	          parent = parent.parent;
	        }
	      }
	      _this.expanded = true;
	      if (callback) callback();
	    };
	
	    if (this.shouldLoadData()) {
	      this.loadData(function (data) {
	        if (data instanceof Array) {
	          if (_this.checked) {
	            _this.setChecked(true, true);
	          } else if (!_this.store.checkStrictly) {
	            reInitChecked(_this);
	          }
	          done();
	        }
	      });
	    } else {
	      done();
	    }
	  };
	
	  Node.prototype.doCreateChildren = function doCreateChildren(array) {
	    var _this2 = this;
	
	    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    array.forEach(function (item) {
	      _this2.insertChild(merge_default()({ data: item }, defaultProps), undefined, true);
	    });
	  };
	
	  Node.prototype.collapse = function collapse() {
	    this.expanded = false;
	  };
	
	  Node.prototype.shouldLoadData = function shouldLoadData() {
	    return this.store.lazy === true && this.store.load && !this.loaded;
	  };
	
	  Node.prototype.updateLeafState = function updateLeafState() {
	    if (this.store.lazy === true && this.loaded !== true && typeof this.isLeafByUser !== 'undefined') {
	      this.isLeaf = this.isLeafByUser;
	      return;
	    }
	    var childNodes = this.childNodes;
	    if (!this.store.lazy || this.store.lazy === true && this.loaded === true) {
	      this.isLeaf = !childNodes || childNodes.length === 0;
	      return;
	    }
	    this.isLeaf = false;
	  };
	
	  Node.prototype.setChecked = function setChecked(value, deep, recursion, passValue) {
	    var _this3 = this;
	
	    this.indeterminate = value === 'half';
	    this.checked = value === true;
	
	    if (this.store.checkStrictly) return;
	
	    if (!(this.shouldLoadData() && !this.store.checkDescendants)) {
	      var _getChildState2 = getChildState(this.childNodes),
	          all = _getChildState2.all,
	          allWithoutDisable = _getChildState2.allWithoutDisable;
	
	      if (!this.isLeaf && !all && allWithoutDisable) {
	        this.checked = false;
	        value = false;
	      }
	
	      var handleDescendants = function handleDescendants() {
	        if (deep) {
	          var childNodes = _this3.childNodes;
	          for (var i = 0, j = childNodes.length; i < j; i++) {
	            var child = childNodes[i];
	            passValue = passValue || value !== false;
	            var isCheck = child.disabled ? child.checked : passValue;
	            child.setChecked(isCheck, deep, true, passValue);
	          }
	
	          var _getChildState3 = getChildState(childNodes),
	              half = _getChildState3.half,
	              _all = _getChildState3.all;
	
	          if (!_all) {
	            _this3.checked = _all;
	            _this3.indeterminate = half;
	          }
	        }
	      };
	
	      if (this.shouldLoadData()) {
	        // Only work on lazy load data.
	        this.loadData(function () {
	          handleDescendants();
	          reInitChecked(_this3);
	        }, {
	          checked: value !== false
	        });
	        return;
	      } else {
	        handleDescendants();
	      }
	    }
	
	    var parent = this.parent;
	    if (!parent || parent.level === 0) return;
	
	    if (!recursion) {
	      reInitChecked(parent);
	    }
	  };
	
	  Node.prototype.getChildren = function getChildren() {
	    var forceInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    // this is data
	    if (this.level === 0) return this.data;
	    var data = this.data;
	    if (!data) return null;
	
	    var props = this.store.props;
	    var children = 'children';
	    if (props) {
	      children = props.children || 'children';
	    }
	
	    if (data[children] === undefined) {
	      data[children] = null;
	    }
	
	    if (forceInit && !data[children]) {
	      data[children] = [];
	    }
	
	    return data[children];
	  };
	
	  Node.prototype.updateChildren = function updateChildren() {
	    var _this4 = this;
	
	    var newData = this.getChildren() || [];
	    var oldData = this.childNodes.map(function (node) {
	      return node.data;
	    });
	
	    var newDataMap = {};
	    var newNodes = [];
	
	    newData.forEach(function (item, index) {
	      var key = item[NODE_KEY];
	      var isNodeExists = !!key && Object(util_["arrayFindIndex"])(oldData, function (data) {
	        return data[NODE_KEY] === key;
	      }) >= 0;
	      if (isNodeExists) {
	        newDataMap[key] = { index: index, data: item };
	      } else {
	        newNodes.push({ index: index, data: item });
	      }
	    });
	
	    if (!this.store.lazy) {
	      oldData.forEach(function (item) {
	        if (!newDataMap[item[NODE_KEY]]) _this4.removeChildByData(item);
	      });
	    }
	
	    newNodes.forEach(function (_ref) {
	      var index = _ref.index,
	          data = _ref.data;
	
	      _this4.insertChild({ data: data }, index);
	    });
	
	    this.updateLeafState();
	  };
	
	  Node.prototype.loadData = function loadData(callback) {
	    var _this5 = this;
	
	    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (this.store.lazy === true && this.store.load && !this.loaded && (!this.loading || Object.keys(defaultProps).length)) {
	      this.loading = true;
	
	      var resolve = function resolve(children) {
	        _this5.loaded = true;
	        _this5.loading = false;
	        _this5.childNodes = [];
	
	        _this5.doCreateChildren(children, defaultProps);
	
	        _this5.updateLeafState();
	        if (callback) {
	          callback.call(_this5, children);
	        }
	      };
	
	      this.store.load(this, resolve);
	    } else {
	      if (callback) {
	        callback.call(this);
	      }
	    }
	  };
	
	  _createClass(Node, [{
	    key: 'label',
	    get: function get() {
	      return getPropertyFromData(this, 'label');
	    }
	  }, {
	    key: 'key',
	    get: function get() {
	      var nodeKey = this.store.key;
	      if (this.data) return this.data[nodeKey];
	      return null;
	    }
	  }, {
	    key: 'disabled',
	    get: function get() {
	      return getPropertyFromData(this, 'disabled');
	    }
	  }, {
	    key: 'nextSibling',
	    get: function get() {
	      var parent = this.parent;
	      if (parent) {
	        var index = parent.childNodes.indexOf(this);
	        if (index > -1) {
	          return parent.childNodes[index + 1];
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'previousSibling',
	    get: function get() {
	      var parent = this.parent;
	      if (parent) {
	        var index = parent.childNodes.indexOf(this);
	        if (index > -1) {
	          return index > 0 ? parent.childNodes[index - 1] : null;
	        }
	      }
	      return null;
	    }
	  }]);
	
	  return Node;
	}();
	
	/* harmony default export */ var model_node = (node_Node);
	// CONCATENATED MODULE: ./packages/tree/src/model/tree-store.js
	var tree_store_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function tree_store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var tree_store_TreeStore = function () {
	  function TreeStore(options) {
	    var _this = this;
	
	    tree_store_classCallCheck(this, TreeStore);
	
	    this.currentNode = null;
	    this.currentNodeKey = null;
	
	    for (var option in options) {
	      if (options.hasOwnProperty(option)) {
	        this[option] = options[option];
	      }
	    }
	
	    this.nodesMap = {};
	
	    this.root = new model_node({
	      data: this.data,
	      store: this
	    });
	
	    if (this.lazy && this.load) {
	      var loadFn = this.load;
	      loadFn(this.root, function (data) {
	        _this.root.doCreateChildren(data);
	        _this._initDefaultCheckedNodes();
	      });
	    } else {
	      this._initDefaultCheckedNodes();
	    }
	  }
	
	  TreeStore.prototype.filter = function filter(value) {
	    var filterNodeMethod = this.filterNodeMethod;
	    var lazy = this.lazy;
	    var traverse = function traverse(node) {
	      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
	      childNodes.forEach(function (child) {
	        child.visible = filterNodeMethod.call(child, value, child.data, child);
	
	        traverse(child);
	      });
	
	      if (!node.visible && childNodes.length) {
	        var allHidden = true;
	        allHidden = !childNodes.some(function (child) {
	          return child.visible;
	        });
	
	        if (node.root) {
	          node.root.visible = allHidden === false;
	        } else {
	          node.visible = allHidden === false;
	        }
	      }
	      if (!value) return;
	
	      if (node.visible && !node.isLeaf && !lazy) node.expand();
	    };
	
	    traverse(this);
	  };
	
	  TreeStore.prototype.setData = function setData(newVal) {
	    var instanceChanged = newVal !== this.root.data;
	    if (instanceChanged) {
	      this.root.setData(newVal);
	      this._initDefaultCheckedNodes();
	    } else {
	      this.root.updateChildren();
	    }
	  };
	
	  TreeStore.prototype.getNode = function getNode(data) {
	    if (data instanceof model_node) return data;
	    var key = (typeof data === 'undefined' ? 'undefined' : tree_store_typeof(data)) !== 'object' ? data : util_getNodeKey(this.key, data);
	    return this.nodesMap[key] || null;
	  };
	
	  TreeStore.prototype.insertBefore = function insertBefore(data, refData) {
	    var refNode = this.getNode(refData);
	    refNode.parent.insertBefore({ data: data }, refNode);
	  };
	
	  TreeStore.prototype.insertAfter = function insertAfter(data, refData) {
	    var refNode = this.getNode(refData);
	    refNode.parent.insertAfter({ data: data }, refNode);
	  };
	
	  TreeStore.prototype.remove = function remove(data) {
	    var node = this.getNode(data);
	
	    if (node && node.parent) {
	      if (node === this.currentNode) {
	        this.currentNode = null;
	      }
	      node.parent.removeChild(node);
	    }
	  };
	
	  TreeStore.prototype.append = function append(data, parentData) {
	    var parentNode = parentData ? this.getNode(parentData) : this.root;
	
	    if (parentNode) {
	      parentNode.insertChild({ data: data });
	    }
	  };
	
	  TreeStore.prototype._initDefaultCheckedNodes = function _initDefaultCheckedNodes() {
	    var _this2 = this;
	
	    var defaultCheckedKeys = this.defaultCheckedKeys || [];
	    var nodesMap = this.nodesMap;
	
	    defaultCheckedKeys.forEach(function (checkedKey) {
	      var node = nodesMap[checkedKey];
	
	      if (node) {
	        node.setChecked(true, !_this2.checkStrictly);
	      }
	    });
	  };
	
	  TreeStore.prototype._initDefaultCheckedNode = function _initDefaultCheckedNode(node) {
	    var defaultCheckedKeys = this.defaultCheckedKeys || [];
	
	    if (defaultCheckedKeys.indexOf(node.key) !== -1) {
	      node.setChecked(true, !this.checkStrictly);
	    }
	  };
	
	  TreeStore.prototype.setDefaultCheckedKey = function setDefaultCheckedKey(newVal) {
	    if (newVal !== this.defaultCheckedKeys) {
	      this.defaultCheckedKeys = newVal;
	      this._initDefaultCheckedNodes();
	    }
	  };
	
	  TreeStore.prototype.registerNode = function registerNode(node) {
	    var key = this.key;
	    if (!key || !node || !node.data) return;
	
	    var nodeKey = node.key;
	    if (nodeKey !== undefined) this.nodesMap[node.key] = node;
	  };
	
	  TreeStore.prototype.deregisterNode = function deregisterNode(node) {
	    var _this3 = this;
	
	    var key = this.key;
	    if (!key || !node || !node.data) return;
	
	    node.childNodes.forEach(function (child) {
	      _this3.deregisterNode(child);
	    });
	
	    delete this.nodesMap[node.key];
	  };
	
	  TreeStore.prototype.getCheckedNodes = function getCheckedNodes() {
	    var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var includeHalfChecked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var checkedNodes = [];
	    var traverse = function traverse(node) {
	      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
	      childNodes.forEach(function (child) {
	        if ((child.checked || includeHalfChecked && child.indeterminate) && (!leafOnly || leafOnly && child.isLeaf)) {
	          checkedNodes.push(child.data);
	        }
	
	        traverse(child);
	      });
	    };
	
	    traverse(this);
	
	    return checkedNodes;
	  };
	
	  TreeStore.prototype.getCheckedKeys = function getCheckedKeys() {
	    var _this4 = this;
	
	    var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return this.getCheckedNodes(leafOnly).map(function (data) {
	      return (data || {})[_this4.key];
	    });
	  };
	
	  TreeStore.prototype.getHalfCheckedNodes = function getHalfCheckedNodes() {
	    var nodes = [];
	    var traverse = function traverse(node) {
	      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
	      childNodes.forEach(function (child) {
	        if (child.indeterminate) {
	          nodes.push(child.data);
	        }
	
	        traverse(child);
	      });
	    };
	
	    traverse(this);
	
	    return nodes;
	  };
	
	  TreeStore.prototype.getHalfCheckedKeys = function getHalfCheckedKeys() {
	    var _this5 = this;
	
	    return this.getHalfCheckedNodes().map(function (data) {
	      return (data || {})[_this5.key];
	    });
	  };
	
	  TreeStore.prototype._getAllNodes = function _getAllNodes() {
	    var allNodes = [];
	    var nodesMap = this.nodesMap;
	    for (var nodeKey in nodesMap) {
	      if (nodesMap.hasOwnProperty(nodeKey)) {
	        allNodes.push(nodesMap[nodeKey]);
	      }
	    }
	
	    return allNodes;
	  };
	
	  TreeStore.prototype.updateChildren = function updateChildren(key, data) {
	    var node = this.nodesMap[key];
	    if (!node) return;
	    var childNodes = node.childNodes;
	    for (var i = childNodes.length - 1; i >= 0; i--) {
	      var child = childNodes[i];
	      this.remove(child.data);
	    }
	    for (var _i = 0, j = data.length; _i < j; _i++) {
	      var _child = data[_i];
	      this.append(_child, node.data);
	    }
	  };
	
	  TreeStore.prototype._setCheckedKeys = function _setCheckedKeys(key) {
	    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var checkedKeys = arguments[2];
	
	    var allNodes = this._getAllNodes().sort(function (a, b) {
	      return b.level - a.level;
	    });
	    var cache = Object.create(null);
	    var keys = Object.keys(checkedKeys);
	    allNodes.forEach(function (node) {
	      return node.setChecked(false, false);
	    });
	    for (var i = 0, j = allNodes.length; i < j; i++) {
	      var node = allNodes[i];
	      var nodeKey = node.data[key].toString();
	      var checked = keys.indexOf(nodeKey) > -1;
	      if (!checked) {
	        if (node.checked && !cache[nodeKey]) {
	          node.setChecked(false, false);
	        }
	        continue;
	      }
	
	      var parent = node.parent;
	      while (parent && parent.level > 0) {
	        cache[parent.data[key]] = true;
	        parent = parent.parent;
	      }
	
	      if (node.isLeaf || this.checkStrictly) {
	        node.setChecked(true, false);
	        continue;
	      }
	      node.setChecked(true, true);
	
	      if (leafOnly) {
	        (function () {
	          node.setChecked(false, false);
	          var traverse = function traverse(node) {
	            var childNodes = node.childNodes;
	            childNodes.forEach(function (child) {
	              if (!child.isLeaf) {
	                child.setChecked(false, false);
	              }
	              traverse(child);
	            });
	          };
	          traverse(node);
	        })();
	      }
	    }
	  };
	
	  TreeStore.prototype.setCheckedNodes = function setCheckedNodes(array) {
	    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var key = this.key;
	    var checkedKeys = {};
	    array.forEach(function (item) {
	      checkedKeys[(item || {})[key]] = true;
	    });
	
	    this._setCheckedKeys(key, leafOnly, checkedKeys);
	  };
	
	  TreeStore.prototype.setCheckedKeys = function setCheckedKeys(keys) {
	    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    this.defaultCheckedKeys = keys;
	    var key = this.key;
	    var checkedKeys = {};
	    keys.forEach(function (key) {
	      checkedKeys[key] = true;
	    });
	
	    this._setCheckedKeys(key, leafOnly, checkedKeys);
	  };
	
	  TreeStore.prototype.setDefaultExpandedKeys = function setDefaultExpandedKeys(keys) {
	    var _this6 = this;
	
	    keys = keys || [];
	    this.defaultExpandedKeys = keys;
	
	    keys.forEach(function (key) {
	      var node = _this6.getNode(key);
	      if (node) node.expand(null, _this6.autoExpandParent);
	    });
	  };
	
	  TreeStore.prototype.setChecked = function setChecked(data, checked, deep) {
	    var node = this.getNode(data);
	
	    if (node) {
	      node.setChecked(!!checked, deep);
	    }
	  };
	
	  TreeStore.prototype.getCurrentNode = function getCurrentNode() {
	    return this.currentNode;
	  };
	
	  TreeStore.prototype.setCurrentNode = function setCurrentNode(currentNode) {
	    var prevCurrentNode = this.currentNode;
	    if (prevCurrentNode) {
	      prevCurrentNode.isCurrent = false;
	    }
	    this.currentNode = currentNode;
	    this.currentNode.isCurrent = true;
	  };
	
	  TreeStore.prototype.setUserCurrentNode = function setUserCurrentNode(node) {
	    var key = node[this.key];
	    var currNode = this.nodesMap[key];
	    this.setCurrentNode(currNode);
	  };
	
	  TreeStore.prototype.setCurrentNodeKey = function setCurrentNodeKey(key) {
	    if (key === null || key === undefined) {
	      this.currentNode && (this.currentNode.isCurrent = false);
	      this.currentNode = null;
	      return;
	    }
	    var node = this.getNode(key);
	    if (node) {
	      this.setCurrentNode(node);
	    }
	  };
	
	  return TreeStore;
	}();
	
	/* harmony default export */ var tree_store = (tree_store_TreeStore);
	;
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
	var tree_nodevue_type_template_id_3ba3ef0e_render = function() {
	  var this$1 = this
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.node.visible,
	          expression: "node.visible"
	        }
	      ],
	      ref: "node",
	      staticClass: "el-tree-node",
	      class: {
	        "is-expanded": _vm.expanded,
	        "is-current": _vm.node.isCurrent,
	        "is-hidden": !_vm.node.visible,
	        "is-focusable": !_vm.node.disabled,
	        "is-checked": !_vm.node.disabled && _vm.node.checked
	      },
	      attrs: {
	        role: "treeitem",
	        tabindex: "-1",
	        "aria-expanded": _vm.expanded,
	        "aria-disabled": _vm.node.disabled,
	        "aria-checked": _vm.node.checked,
	        draggable: _vm.tree.draggable
	      },
	      on: {
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.handleClick($event)
	        },
	        contextmenu: function($event) {
	          return this$1.handleContextMenu($event)
	        },
	        dragstart: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDragStart($event)
	        },
	        dragover: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDragOver($event)
	        },
	        dragend: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDragEnd($event)
	        },
	        drop: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDrop($event)
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          staticClass: "el-tree-node__content",
	          style: {
	            "padding-left": (_vm.node.level - 1) * _vm.tree.indent + "px"
	          }
	        },
	        [
	          _c("span", {
	            class: [
	              {
	                "is-leaf": _vm.node.isLeaf,
	                expanded: !_vm.node.isLeaf && _vm.expanded
	              },
	              "el-tree-node__expand-icon",
	              _vm.tree.iconClass ? _vm.tree.iconClass : "el-icon-caret-right"
	            ],
	            on: {
	              click: function($event) {
	                $event.stopPropagation()
	                return _vm.handleExpandIconClick($event)
	              }
	            }
	          }),
	          _vm.showCheckbox
	            ? _c("el-checkbox", {
	                attrs: {
	                  indeterminate: _vm.node.indeterminate,
	                  disabled: !!_vm.node.disabled
	                },
	                on: { change: _vm.handleCheckChange },
	                nativeOn: {
	                  click: function($event) {
	                    $event.stopPropagation()
	                  }
	                },
	                model: {
	                  value: _vm.node.checked,
	                  callback: function($$v) {
	                    _vm.$set(_vm.node, "checked", $$v)
	                  },
	                  expression: "node.checked"
	                }
	              })
	            : _vm._e(),
	          _vm.node.loading
	            ? _c("span", {
	                staticClass: "el-tree-node__loading-icon el-icon-loading"
	              })
	            : _vm._e(),
	          _c("node-content", { attrs: { node: _vm.node } })
	        ],
	        1
	      ),
	      _c("el-collapse-transition", [
	        !_vm.renderAfterExpand || _vm.childNodeRendered
	          ? _c(
	              "div",
	              {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: _vm.expanded,
	                    expression: "expanded"
	                  }
	                ],
	                staticClass: "el-tree-node__children",
	                attrs: { role: "group", "aria-expanded": _vm.expanded }
	              },
	              _vm._l(_vm.node.childNodes, function(child) {
	                return _c("el-tree-node", {
	                  key: _vm.getNodeKey(child),
	                  attrs: {
	                    "render-content": _vm.renderContent,
	                    "render-after-expand": _vm.renderAfterExpand,
	                    "show-checkbox": _vm.showCheckbox,
	                    node: child
	                  },
	                  on: { "node-expand": _vm.handleChildNodeExpand }
	                })
	              }),
	              1
	            )
	          : _vm._e()
	      ])
	    ],
	    1
	  )
	}
	var tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns = []
	tree_nodevue_type_template_id_3ba3ef0e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var tree_nodevue_type_script_lang_js_ = ({
	  name: 'ElTreeNode',
	
	  componentName: 'ElTreeNode',
	
	  mixins: [emitter_default.a],
	
	  props: {
	    node: {
	      default: function _default() {
	        return {};
	      }
	    },
	    props: {},
	    renderContent: Function,
	    renderAfterExpand: {
	      type: Boolean,
	      default: true
	    },
	    showCheckbox: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  components: {
	    ElCollapseTransition: collapse_transition_default.a,
	    ElCheckbox: checkbox_default.a,
	    NodeContent: {
	      props: {
	        node: {
	          required: true
	        }
	      },
	      render: function render(h) {
	        var parent = this.$parent;
	        var tree = parent.tree;
	        var node = this.node;
	        var data = node.data,
	            store = node.store;
	
	        return parent.renderContent ? parent.renderContent.call(parent._renderProxy, h, { _self: tree.$vnode.context, node: node, data: data, store: store }) : tree.$scopedSlots.default ? tree.$scopedSlots.default({ node: node, data: data }) : h(
	          'span',
	          { 'class': 'el-tree-node__label' },
	          [node.label]
	        );
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      tree: null,
	      expanded: false,
	      childNodeRendered: false,
	      oldChecked: null,
	      oldIndeterminate: null
	    };
	  },
	
	
	  watch: {
	    'node.indeterminate': function nodeIndeterminate(val) {
	      this.handleSelectChange(this.node.checked, val);
	    },
	    'node.checked': function nodeChecked(val) {
	      this.handleSelectChange(val, this.node.indeterminate);
	    },
	    'node.expanded': function nodeExpanded(val) {
	      var _this = this;
	
	      this.$nextTick(function () {
	        return _this.expanded = val;
	      });
	      if (val) {
	        this.childNodeRendered = true;
	      }
	    }
	  },
	
	  methods: {
	    getNodeKey: function getNodeKey(node) {
	      return util_getNodeKey(this.tree.nodeKey, node.data);
	    },
	    handleSelectChange: function handleSelectChange(checked, indeterminate) {
	      if (this.oldChecked !== checked && this.oldIndeterminate !== indeterminate) {
	        this.tree.$emit('check-change', this.node.data, checked, indeterminate);
	      }
	      this.oldChecked = checked;
	      this.indeterminate = indeterminate;
	    },
	    handleClick: function handleClick() {
	      var store = this.tree.store;
	      store.setCurrentNode(this.node);
	      this.tree.$emit('current-change', store.currentNode ? store.currentNode.data : null, store.currentNode);
	      this.tree.currentNode = this;
	      if (this.tree.expandOnClickNode) {
	        this.handleExpandIconClick();
	      }
	      if (this.tree.checkOnClickNode && !this.node.disabled) {
	        this.handleCheckChange(null, {
	          target: { checked: !this.node.checked }
	        });
	      }
	      this.tree.$emit('node-click', this.node.data, this.node, this);
	    },
	    handleContextMenu: function handleContextMenu(event) {
	      if (this.tree._events['node-contextmenu'] && this.tree._events['node-contextmenu'].length > 0) {
	        event.stopPropagation();
	        event.preventDefault();
	      }
	      this.tree.$emit('node-contextmenu', event, this.node.data, this.node, this);
	    },
	    handleExpandIconClick: function handleExpandIconClick() {
	      if (this.node.isLeaf) return;
	      if (this.expanded) {
	        this.tree.$emit('node-collapse', this.node.data, this.node, this);
	        this.node.collapse();
	      } else {
	        this.node.expand();
	        this.$emit('node-expand', this.node.data, this.node, this);
	      }
	    },
	    handleCheckChange: function handleCheckChange(value, ev) {
	      var _this2 = this;
	
	      this.node.setChecked(ev.target.checked, !this.tree.checkStrictly);
	      this.$nextTick(function () {
	        var store = _this2.tree.store;
	        _this2.tree.$emit('check', _this2.node.data, {
	          checkedNodes: store.getCheckedNodes(),
	          checkedKeys: store.getCheckedKeys(),
	          halfCheckedNodes: store.getHalfCheckedNodes(),
	          halfCheckedKeys: store.getHalfCheckedKeys()
	        });
	      });
	    },
	    handleChildNodeExpand: function handleChildNodeExpand(nodeData, node, instance) {
	      this.broadcast('ElTreeNode', 'tree-node-expand', node);
	      this.tree.$emit('node-expand', nodeData, node, instance);
	    },
	    handleDragStart: function handleDragStart(event) {
	      if (!this.tree.draggable) return;
	      this.tree.$emit('tree-node-drag-start', event, this);
	    },
	    handleDragOver: function handleDragOver(event) {
	      if (!this.tree.draggable) return;
	      this.tree.$emit('tree-node-drag-over', event, this);
	      event.preventDefault();
	    },
	    handleDrop: function handleDrop(event) {
	      event.preventDefault();
	    },
	    handleDragEnd: function handleDragEnd(event) {
	      if (!this.tree.draggable) return;
	      this.tree.$emit('tree-node-drag-end', event, this);
	    }
	  },
	
	  created: function created() {
	    var _this3 = this;
	
	    var parent = this.$parent;
	
	    if (parent.isTree) {
	      this.tree = parent;
	    } else {
	      this.tree = parent.tree;
	    }
	
	    var tree = this.tree;
	    if (!tree) {
	      console.warn('Can not find node\'s tree.');
	    }
	
	    var props = tree.props || {};
	    var childrenKey = props['children'] || 'children';
	
	    this.$watch('node.data.' + childrenKey, function () {
	      _this3.node.updateChildren();
	    });
	
	    if (this.node.expanded) {
	      this.expanded = true;
	      this.childNodeRendered = true;
	    }
	
	    if (this.tree.accordion) {
	      this.$on('tree-node-expand', function (node) {
	        if (_this3.node !== node) {
	          _this3.node.collapse();
	        }
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tree_nodevue_type_script_lang_js_ = (tree_nodevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue
	
	
	
	
	
	/* normalize component */
	
	var tree_node_component = normalizeComponent(
	  src_tree_nodevue_type_script_lang_js_,
	  tree_nodevue_type_template_id_3ba3ef0e_render,
	  tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tree_node_api; }
	tree_node_component.options.__file = "packages/tree/src/tree-node.vue"
	/* harmony default export */ var tree_node = (tree_node_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	/* harmony default export */ var treevue_type_script_lang_js_ = ({
	  name: 'ElTree',
	
	  mixins: [emitter_default.a],
	
	  components: {
	    ElTreeNode: tree_node
	  },
	
	  data: function data() {
	    return {
	      store: null,
	      root: null,
	      currentNode: null,
	      treeItems: null,
	      checkboxItems: [],
	      dragState: {
	        showDropIndicator: false,
	        draggingNode: null,
	        dropNode: null,
	        allowDrop: true
	      }
	    };
	  },
	
	
	  props: {
	    data: {
	      type: Array
	    },
	    emptyText: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.tree.emptyText');
	      }
	    },
	    renderAfterExpand: {
	      type: Boolean,
	      default: true
	    },
	    nodeKey: String,
	    checkStrictly: Boolean,
	    defaultExpandAll: Boolean,
	    expandOnClickNode: {
	      type: Boolean,
	      default: true
	    },
	    checkOnClickNode: Boolean,
	    checkDescendants: {
	      type: Boolean,
	      default: false
	    },
	    autoExpandParent: {
	      type: Boolean,
	      default: true
	    },
	    defaultCheckedKeys: Array,
	    defaultExpandedKeys: Array,
	    currentNodeKey: [String, Number],
	    renderContent: Function,
	    showCheckbox: {
	      type: Boolean,
	      default: false
	    },
	    draggable: {
	      type: Boolean,
	      default: false
	    },
	    allowDrag: Function,
	    allowDrop: Function,
	    props: {
	      default: function _default() {
	        return {
	          children: 'children',
	          label: 'label',
	          disabled: 'disabled'
	        };
	      }
	    },
	    lazy: {
	      type: Boolean,
	      default: false
	    },
	    highlightCurrent: Boolean,
	    load: Function,
	    filterNodeMethod: Function,
	    accordion: Boolean,
	    indent: {
	      type: Number,
	      default: 18
	    },
	    iconClass: String
	  },
	
	  computed: {
	    children: {
	      set: function set(value) {
	        this.data = value;
	      },
	      get: function get() {
	        return this.data;
	      }
	    },
	
	    treeItemArray: function treeItemArray() {
	      return Array.prototype.slice.call(this.treeItems);
	    },
	    isEmpty: function isEmpty() {
	      var childNodes = this.root.childNodes;
	
	      return !childNodes || childNodes.length === 0 || childNodes.every(function (_ref) {
	        var visible = _ref.visible;
	        return !visible;
	      });
	    }
	  },
	
	  watch: {
	    defaultCheckedKeys: function defaultCheckedKeys(newVal) {
	      this.store.setDefaultCheckedKey(newVal);
	    },
	    defaultExpandedKeys: function defaultExpandedKeys(newVal) {
	      this.store.defaultExpandedKeys = newVal;
	      this.store.setDefaultExpandedKeys(newVal);
	    },
	    data: function data(newVal) {
	      this.store.setData(newVal);
	    },
	    checkboxItems: function checkboxItems(val) {
	      Array.prototype.forEach.call(val, function (checkbox) {
	        checkbox.setAttribute('tabindex', -1);
	      });
	    },
	    checkStrictly: function checkStrictly(newVal) {
	      this.store.checkStrictly = newVal;
	    }
	  },
	
	  methods: {
	    filter: function filter(value) {
	      if (!this.filterNodeMethod) throw new Error('[Tree] filterNodeMethod is required when filter');
	      this.store.filter(value);
	    },
	    getNodeKey: function getNodeKey(node) {
	      return util_getNodeKey(this.nodeKey, node.data);
	    },
	    getNodePath: function getNodePath(data) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in getNodePath');
	      var node = this.store.getNode(data);
	      if (!node) return [];
	      var path = [node.data];
	      var parent = node.parent;
	      while (parent && parent !== this.root) {
	        path.push(parent.data);
	        parent = parent.parent;
	      }
	      return path.reverse();
	    },
	    getCheckedNodes: function getCheckedNodes(leafOnly, includeHalfChecked) {
	      return this.store.getCheckedNodes(leafOnly, includeHalfChecked);
	    },
	    getCheckedKeys: function getCheckedKeys(leafOnly) {
	      return this.store.getCheckedKeys(leafOnly);
	    },
	    getCurrentNode: function getCurrentNode() {
	      var currentNode = this.store.getCurrentNode();
	      return currentNode ? currentNode.data : null;
	    },
	    getCurrentKey: function getCurrentKey() {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in getCurrentKey');
	      var currentNode = this.getCurrentNode();
	      return currentNode ? currentNode[this.nodeKey] : null;
	    },
	    setCheckedNodes: function setCheckedNodes(nodes, leafOnly) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedNodes');
	      this.store.setCheckedNodes(nodes, leafOnly);
	    },
	    setCheckedKeys: function setCheckedKeys(keys, leafOnly) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedKeys');
	      this.store.setCheckedKeys(keys, leafOnly);
	    },
	    setChecked: function setChecked(data, checked, deep) {
	      this.store.setChecked(data, checked, deep);
	    },
	    getHalfCheckedNodes: function getHalfCheckedNodes() {
	      return this.store.getHalfCheckedNodes();
	    },
	    getHalfCheckedKeys: function getHalfCheckedKeys() {
	      return this.store.getHalfCheckedKeys();
	    },
	    setCurrentNode: function setCurrentNode(node) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCurrentNode');
	      this.store.setUserCurrentNode(node);
	    },
	    setCurrentKey: function setCurrentKey(key) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCurrentKey');
	      this.store.setCurrentNodeKey(key);
	    },
	    getNode: function getNode(data) {
	      return this.store.getNode(data);
	    },
	    remove: function remove(data) {
	      this.store.remove(data);
	    },
	    append: function append(data, parentNode) {
	      this.store.append(data, parentNode);
	    },
	    insertBefore: function insertBefore(data, refNode) {
	      this.store.insertBefore(data, refNode);
	    },
	    insertAfter: function insertAfter(data, refNode) {
	      this.store.insertAfter(data, refNode);
	    },
	    handleNodeExpand: function handleNodeExpand(nodeData, node, instance) {
	      this.broadcast('ElTreeNode', 'tree-node-expand', node);
	      this.$emit('node-expand', nodeData, node, instance);
	    },
	    updateKeyChildren: function updateKeyChildren(key, data) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in updateKeyChild');
	      this.store.updateChildren(key, data);
	    },
	    initTabIndex: function initTabIndex() {
	      this.treeItems = this.$el.querySelectorAll('.is-focusable[role=treeitem]');
	      this.checkboxItems = this.$el.querySelectorAll('input[type=checkbox]');
	      var checkedItem = this.$el.querySelectorAll('.is-checked[role=treeitem]');
	      if (checkedItem.length) {
	        checkedItem[0].setAttribute('tabindex', 0);
	        return;
	      }
	      this.treeItems[0] && this.treeItems[0].setAttribute('tabindex', 0);
	    },
	    handleKeydown: function handleKeydown(ev) {
	      var currentItem = ev.target;
	      if (currentItem.className.indexOf('el-tree-node') === -1) return;
	      var keyCode = ev.keyCode;
	      this.treeItems = this.$el.querySelectorAll('.is-focusable[role=treeitem]');
	      var currentIndex = this.treeItemArray.indexOf(currentItem);
	      var nextIndex = void 0;
	      if ([38, 40].indexOf(keyCode) > -1) {
	        // up、down
	        ev.preventDefault();
	        if (keyCode === 38) {
	          // up
	          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
	        } else {
	          nextIndex = currentIndex < this.treeItemArray.length - 1 ? currentIndex + 1 : 0;
	        }
	        this.treeItemArray[nextIndex].focus(); // 选中
	      }
	      if ([37, 39].indexOf(keyCode) > -1) {
	        // left、right 展开
	        ev.preventDefault();
	        currentItem.click(); // 选中
	      }
	      var hasInput = currentItem.querySelector('[type="checkbox"]');
	      if ([13, 32].indexOf(keyCode) > -1 && hasInput) {
	        // space enter选中checkbox
	        ev.preventDefault();
	        hasInput.click();
	      }
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.isTree = true;
	
	    this.store = new tree_store({
	      key: this.nodeKey,
	      data: this.data,
	      lazy: this.lazy,
	      props: this.props,
	      load: this.load,
	      currentNodeKey: this.currentNodeKey,
	      checkStrictly: this.checkStrictly,
	      checkDescendants: this.checkDescendants,
	      defaultCheckedKeys: this.defaultCheckedKeys,
	      defaultExpandedKeys: this.defaultExpandedKeys,
	      autoExpandParent: this.autoExpandParent,
	      defaultExpandAll: this.defaultExpandAll,
	      filterNodeMethod: this.filterNodeMethod
	    });
	
	    this.root = this.store.root;
	
	    var dragState = this.dragState;
	    this.$on('tree-node-drag-start', function (event, treeNode) {
	      if (typeof _this.allowDrag === 'function' && !_this.allowDrag(treeNode.node)) {
	        event.preventDefault();
	        return false;
	      }
	      event.dataTransfer.effectAllowed = 'move';
	
	      // wrap in try catch to address IE's error when first param is 'text/plain'
	      try {
	        // setData is required for draggable to work in FireFox
	        // the content has to be '' so dragging a node out of the tree won't open a new tab in FireFox
	        event.dataTransfer.setData('text/plain', '');
	      } catch (e) {}
	      dragState.draggingNode = treeNode;
	      _this.$emit('node-drag-start', treeNode.node, event);
	    });
	
	    this.$on('tree-node-drag-over', function (event, treeNode) {
	      var dropNode = findNearestComponent(event.target, 'ElTreeNode');
	      var oldDropNode = dragState.dropNode;
	      if (oldDropNode && oldDropNode !== dropNode) {
	        Object(dom_["removeClass"])(oldDropNode.$el, 'is-drop-inner');
	      }
	      var draggingNode = dragState.draggingNode;
	      if (!draggingNode || !dropNode) return;
	
	      var dropPrev = true;
	      var dropInner = true;
	      var dropNext = true;
	      var userAllowDropInner = true;
	      if (typeof _this.allowDrop === 'function') {
	        dropPrev = _this.allowDrop(draggingNode.node, dropNode.node, 'prev');
	        userAllowDropInner = dropInner = _this.allowDrop(draggingNode.node, dropNode.node, 'inner');
	        dropNext = _this.allowDrop(draggingNode.node, dropNode.node, 'next');
	      }
	      event.dataTransfer.dropEffect = dropInner ? 'move' : 'none';
	      if ((dropPrev || dropInner || dropNext) && oldDropNode !== dropNode) {
	        if (oldDropNode) {
	          _this.$emit('node-drag-leave', draggingNode.node, oldDropNode.node, event);
	        }
	        _this.$emit('node-drag-enter', draggingNode.node, dropNode.node, event);
	      }
	
	      if (dropPrev || dropInner || dropNext) {
	        dragState.dropNode = dropNode;
	      }
	
	      if (dropNode.node.nextSibling === draggingNode.node) {
	        dropNext = false;
	      }
	      if (dropNode.node.previousSibling === draggingNode.node) {
	        dropPrev = false;
	      }
	      if (dropNode.node.contains(draggingNode.node, false)) {
	        dropInner = false;
	      }
	      if (draggingNode.node === dropNode.node || draggingNode.node.contains(dropNode.node)) {
	        dropPrev = false;
	        dropInner = false;
	        dropNext = false;
	      }
	
	      var targetPosition = dropNode.$el.getBoundingClientRect();
	      var treePosition = _this.$el.getBoundingClientRect();
	
	      var dropType = void 0;
	      var prevPercent = dropPrev ? dropInner ? 0.25 : dropNext ? 0.45 : 1 : -1;
	      var nextPercent = dropNext ? dropInner ? 0.75 : dropPrev ? 0.55 : 0 : 1;
	
	      var indicatorTop = -9999;
	      var distance = event.clientY - targetPosition.top;
	      if (distance < targetPosition.height * prevPercent) {
	        dropType = 'before';
	      } else if (distance > targetPosition.height * nextPercent) {
	        dropType = 'after';
	      } else if (dropInner) {
	        dropType = 'inner';
	      } else {
	        dropType = 'none';
	      }
	
	      var iconPosition = dropNode.$el.querySelector('.el-tree-node__expand-icon').getBoundingClientRect();
	      var dropIndicator = _this.$refs.dropIndicator;
	      if (dropType === 'before') {
	        indicatorTop = iconPosition.top - treePosition.top;
	      } else if (dropType === 'after') {
	        indicatorTop = iconPosition.bottom - treePosition.top;
	      }
	      dropIndicator.style.top = indicatorTop + 'px';
	      dropIndicator.style.left = iconPosition.right - treePosition.left + 'px';
	
	      if (dropType === 'inner') {
	        Object(dom_["addClass"])(dropNode.$el, 'is-drop-inner');
	      } else {
	        Object(dom_["removeClass"])(dropNode.$el, 'is-drop-inner');
	      }
	
	      dragState.showDropIndicator = dropType === 'before' || dropType === 'after';
	      dragState.allowDrop = dragState.showDropIndicator || userAllowDropInner;
	      dragState.dropType = dropType;
	      _this.$emit('node-drag-over', draggingNode.node, dropNode.node, event);
	    });
	
	    this.$on('tree-node-drag-end', function (event) {
	      var draggingNode = dragState.draggingNode,
	          dropType = dragState.dropType,
	          dropNode = dragState.dropNode;
	
	      event.preventDefault();
	      event.dataTransfer.dropEffect = 'move';
	
	      if (draggingNode && dropNode) {
	        var draggingNodeCopy = { data: draggingNode.node.data };
	        if (dropType !== 'none') {
	          draggingNode.node.remove();
	        }
	        if (dropType === 'before') {
	          dropNode.node.parent.insertBefore(draggingNodeCopy, dropNode.node);
	        } else if (dropType === 'after') {
	          dropNode.node.parent.insertAfter(draggingNodeCopy, dropNode.node);
	        } else if (dropType === 'inner') {
	          dropNode.node.insertChild(draggingNodeCopy);
	        }
	        if (dropType !== 'none') {
	          _this.store.registerNode(draggingNodeCopy);
	        }
	
	        Object(dom_["removeClass"])(dropNode.$el, 'is-drop-inner');
	
	        _this.$emit('node-drag-end', draggingNode.node, dropNode.node, dropType, event);
	        if (dropType !== 'none') {
	          _this.$emit('node-drop', draggingNode.node, dropNode.node, dropType, event);
	        }
	      }
	      if (draggingNode && !dropNode) {
	        _this.$emit('node-drag-end', draggingNode.node, null, dropType, event);
	      }
	
	      dragState.showDropIndicator = false;
	      dragState.draggingNode = null;
	      dragState.dropNode = null;
	      dragState.allowDrop = true;
	    });
	  },
	  mounted: function mounted() {
	    this.initTabIndex();
	    this.$el.addEventListener('keydown', this.handleKeydown);
	  },
	  updated: function updated() {
	    this.treeItems = this.$el.querySelectorAll('[role=treeitem]');
	    this.checkboxItems = this.$el.querySelectorAll('input[type=checkbox]');
	  }
	});
	// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_treevue_type_script_lang_js_ = (treevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tree/src/tree.vue
	
	
	
	
	
	/* normalize component */
	
	var tree_component = normalizeComponent(
	  src_treevue_type_script_lang_js_,
	  treevue_type_template_id_547575a6_render,
	  treevue_type_template_id_547575a6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tree_api; }
	tree_component.options.__file = "packages/tree/src/tree.vue"
	/* harmony default export */ var src_tree = (tree_component.exports);
	// CONCATENATED MODULE: ./packages/tree/index.js
	
	
	/* istanbul ignore next */
	src_tree.install = function (Vue) {
	  Vue.component(src_tree.name, src_tree);
	};
	
	/* harmony default export */ var packages_tree = (src_tree);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
	var mainvue_type_template_id_6e53341b_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-alert-fade" } }, [
	    _c(
	      "div",
	      {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.visible,
	            expression: "visible"
	          }
	        ],
	        staticClass: "el-alert",
	        class: [
	          _vm.typeClass,
	          _vm.center ? "is-center" : "",
	          "is-" + _vm.effect
	        ],
	        attrs: { role: "alert" }
	      },
	      [
	        _vm.showIcon
	          ? _c("i", {
	              staticClass: "el-alert__icon",
	              class: [_vm.iconClass, _vm.isBigIcon]
	            })
	          : _vm._e(),
	        _c("div", { staticClass: "el-alert__content" }, [
	          _vm.title || _vm.$slots.title
	            ? _c(
	                "span",
	                { staticClass: "el-alert__title", class: [_vm.isBoldTitle] },
	                [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
	                2
	              )
	            : _vm._e(),
	          _vm.$slots.default && !_vm.description
	            ? _c(
	                "p",
	                { staticClass: "el-alert__description" },
	                [_vm._t("default")],
	                2
	              )
	            : _vm._e(),
	          _vm.description && !_vm.$slots.default
	            ? _c("p", { staticClass: "el-alert__description" }, [
	                _vm._v(_vm._s(_vm.description))
	              ])
	            : _vm._e(),
	          _c(
	            "i",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.closable,
	                  expression: "closable"
	                }
	              ],
	              staticClass: "el-alert__closebtn",
	              class: {
	                "is-customed": _vm.closeText !== "",
	                "el-icon-close": _vm.closeText === ""
	              },
	              on: {
	                click: function($event) {
	                  _vm.close()
	                }
	              }
	            },
	            [_vm._v(_vm._s(_vm.closeText))]
	          )
	        ])
	      ]
	    )
	  ])
	}
	var mainvue_type_template_id_6e53341b_staticRenderFns = []
	mainvue_type_template_id_6e53341b_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var TYPE_CLASSES_MAP = {
	  'success': 'el-icon-success',
	  'warning': 'el-icon-warning',
	  'error': 'el-icon-error'
	};
	/* harmony default export */ var alert_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElAlert',
	
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	    description: {
	      type: String,
	      default: ''
	    },
	    type: {
	      type: String,
	      default: 'info'
	    },
	    closable: {
	      type: Boolean,
	      default: true
	    },
	    closeText: {
	      type: String,
	      default: ''
	    },
	    showIcon: Boolean,
	    center: Boolean,
	    effect: {
	      type: String,
	      default: 'light',
	      validator: function validator(value) {
	        return ['light', 'dark'].indexOf(value) !== -1;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      visible: true
	    };
	  },
	
	
	  methods: {
	    close: function close() {
	      this.visible = false;
	      this.$emit('close');
	    }
	  },
	
	  computed: {
	    typeClass: function typeClass() {
	      return 'el-alert--' + this.type;
	    },
	    iconClass: function iconClass() {
	      return TYPE_CLASSES_MAP[this.type] || 'el-icon-info';
	    },
	    isBigIcon: function isBigIcon() {
	      return this.description || this.$slots.default ? 'is-big' : '';
	    },
	    isBoldTitle: function isBoldTitle() {
	      return this.description || this.$slots.default ? 'is-bold' : '';
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_alert_src_mainvue_type_script_lang_js_ = (alert_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/alert/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var alert_src_main_component = normalizeComponent(
	  packages_alert_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_6e53341b_render,
	  mainvue_type_template_id_6e53341b_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var alert_src_main_api; }
	alert_src_main_component.options.__file = "packages/alert/src/main.vue"
	/* harmony default export */ var alert_src_main = (alert_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/alert/index.js
	
	
	/* istanbul ignore next */
	alert_src_main.install = function (Vue) {
	  Vue.component(alert_src_main.name, alert_src_main);
	};
	
	/* harmony default export */ var packages_alert = (alert_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
	var mainvue_type_template_id_43dbc3d8_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-notification-fade" } }, [
	    _c(
	      "div",
	      {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.visible,
	            expression: "visible"
	          }
	        ],
	        class: ["el-notification", _vm.customClass, _vm.horizontalClass],
	        style: _vm.positionStyle,
	        attrs: { role: "alert" },
	        on: {
	          mouseenter: function($event) {
	            _vm.clearTimer()
	          },
	          mouseleave: function($event) {
	            _vm.startTimer()
	          },
	          click: _vm.click
	        }
	      },
	      [
	        _vm.type || _vm.iconClass
	          ? _c("i", {
	              staticClass: "el-notification__icon",
	              class: [_vm.typeClass, _vm.iconClass]
	            })
	          : _vm._e(),
	        _c(
	          "div",
	          {
	            staticClass: "el-notification__group",
	            class: { "is-with-icon": _vm.typeClass || _vm.iconClass }
	          },
	          [
	            _c("h2", {
	              staticClass: "el-notification__title",
	              domProps: { textContent: _vm._s(_vm.title) }
	            }),
	            _c(
	              "div",
	              {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: _vm.message,
	                    expression: "message"
	                  }
	                ],
	                staticClass: "el-notification__content"
	              },
	              [
	                _vm._t("default", [
	                  !_vm.dangerouslyUseHTMLString
	                    ? _c("p", [_vm._v(_vm._s(_vm.message))])
	                    : _c("p", { domProps: { innerHTML: _vm._s(_vm.message) } })
	                ])
	              ],
	              2
	            ),
	            _vm.showClose
	              ? _c("div", {
	                  staticClass: "el-notification__closeBtn el-icon-close",
	                  on: {
	                    click: function($event) {
	                      $event.stopPropagation()
	                      return _vm.close($event)
	                    }
	                  }
	                })
	              : _vm._e()
	          ]
	        )
	      ]
	    )
	  ])
	}
	var mainvue_type_template_id_43dbc3d8_staticRenderFns = []
	mainvue_type_template_id_43dbc3d8_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var mainvue_type_script_lang_js_typeMap = {
	  success: 'success',
	  info: 'info',
	  warning: 'warning',
	  error: 'error'
	};
	
	/* harmony default export */ var notification_src_mainvue_type_script_lang_js_ = ({
	  data: function data() {
	    return {
	      visible: false,
	      title: '',
	      message: '',
	      duration: 4500,
	      type: '',
	      showClose: true,
	      customClass: '',
	      iconClass: '',
	      onClose: null,
	      onClick: null,
	      closed: false,
	      verticalOffset: 0,
	      timer: null,
	      dangerouslyUseHTMLString: false,
	      position: 'top-right'
	    };
	  },
	
	
	  computed: {
	    typeClass: function typeClass() {
	      return this.type && mainvue_type_script_lang_js_typeMap[this.type] ? 'el-icon-' + mainvue_type_script_lang_js_typeMap[this.type] : '';
	    },
	    horizontalClass: function horizontalClass() {
	      return this.position.indexOf('right') > -1 ? 'right' : 'left';
	    },
	    verticalProperty: function verticalProperty() {
	      return (/^top-/.test(this.position) ? 'top' : 'bottom'
	      );
	    },
	    positionStyle: function positionStyle() {
	      var _ref;
	
	      return _ref = {}, _ref[this.verticalProperty] = this.verticalOffset + 'px', _ref;
	    }
	  },
	
	  watch: {
	    closed: function closed(newVal) {
	      if (newVal) {
	        this.visible = false;
	        this.$el.addEventListener('transitionend', this.destroyElement);
	      }
	    }
	  },
	
	  methods: {
	    destroyElement: function destroyElement() {
	      this.$el.removeEventListener('transitionend', this.destroyElement);
	      this.$destroy(true);
	      this.$el.parentNode.removeChild(this.$el);
	    },
	    click: function click() {
	      if (typeof this.onClick === 'function') {
	        this.onClick();
	      }
	    },
	    close: function close() {
	      this.closed = true;
	      if (typeof this.onClose === 'function') {
	        this.onClose();
	      }
	    },
	    clearTimer: function clearTimer() {
	      clearTimeout(this.timer);
	    },
	    startTimer: function startTimer() {
	      var _this = this;
	
	      if (this.duration > 0) {
	        this.timer = setTimeout(function () {
	          if (!_this.closed) {
	            _this.close();
	          }
	        }, this.duration);
	      }
	    },
	    keydown: function keydown(e) {
	      if (e.keyCode === 46 || e.keyCode === 8) {
	        this.clearTimer(); // detele 取消倒计时
	      } else if (e.keyCode === 27) {
	        // esc关闭消息
	        if (!this.closed) {
	          this.close();
	        }
	      } else {
	        this.startTimer(); // 恢复倒计时
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    if (this.duration > 0) {
	      this.timer = setTimeout(function () {
	        if (!_this2.closed) {
	          _this2.close();
	        }
	      }, this.duration);
	    }
	    document.addEventListener('keydown', this.keydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.keydown);
	  }
	});
	// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_notification_src_mainvue_type_script_lang_js_ = (notification_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/notification/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var notification_src_main_component = normalizeComponent(
	  packages_notification_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_43dbc3d8_render,
	  mainvue_type_template_id_43dbc3d8_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var notification_src_main_api; }
	notification_src_main_component.options.__file = "packages/notification/src/main.vue"
	/* harmony default export */ var notification_src_main = (notification_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/notification/src/main.js
	
	
	
	
	
	var NotificationConstructor = external_vue_default.a.extend(notification_src_main);
	
	var src_main_instance = void 0;
	var instances = [];
	var seed = 1;
	
	var main_Notification = function Notification(options) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  options = merge_default()({}, options);
	  var userOnClose = options.onClose;
	  var id = 'notification_' + seed++;
	  var position = options.position || 'top-right';
	
	  options.onClose = function () {
	    Notification.close(id, userOnClose);
	  };
	
	  src_main_instance = new NotificationConstructor({
	    data: options
	  });
	
	  if (Object(vdom_["isVNode"])(options.message)) {
	    src_main_instance.$slots.default = [options.message];
	    options.message = 'REPLACED_BY_VNODE';
	  }
	  src_main_instance.id = id;
	  src_main_instance.$mount();
	  document.body.appendChild(src_main_instance.$el);
	  src_main_instance.visible = true;
	  src_main_instance.dom = src_main_instance.$el;
	  src_main_instance.dom.style.zIndex = popup_["PopupManager"].nextZIndex();
	
	  var verticalOffset = options.offset || 0;
	  instances.filter(function (item) {
	    return item.position === position;
	  }).forEach(function (item) {
	    verticalOffset += item.$el.offsetHeight + 16;
	  });
	  verticalOffset += 16;
	  src_main_instance.verticalOffset = verticalOffset;
	  instances.push(src_main_instance);
	  return src_main_instance;
	};
	
	['success', 'warning', 'info', 'error'].forEach(function (type) {
	  main_Notification[type] = function (options) {
	    if (typeof options === 'string' || Object(vdom_["isVNode"])(options)) {
	      options = {
	        message: options
	      };
	    }
	    options.type = type;
	    return main_Notification(options);
	  };
	});
	
	main_Notification.close = function (id, userOnClose) {
	  var index = -1;
	  var len = instances.length;
	  var instance = instances.filter(function (instance, i) {
	    if (instance.id === id) {
	      index = i;
	      return true;
	    }
	    return false;
	  })[0];
	  if (!instance) return;
	
	  if (typeof userOnClose === 'function') {
	    userOnClose(instance);
	  }
	  instances.splice(index, 1);
	
	  if (len <= 1) return;
	  var position = instance.position;
	  var removedHeight = instance.dom.offsetHeight;
	  for (var i = index; i < len - 1; i++) {
	    if (instances[i].position === position) {
	      instances[i].dom.style[instance.verticalProperty] = parseInt(instances[i].dom.style[instance.verticalProperty], 10) - removedHeight - 16 + 'px';
	    }
	  }
	};
	
	main_Notification.closeAll = function () {
	  for (var i = instances.length - 1; i >= 0; i--) {
	    instances[i].close();
	  }
	};
	
	/* harmony default export */ var packages_notification_src_main = (main_Notification);
	// CONCATENATED MODULE: ./packages/notification/index.js
	
	/* harmony default export */ var notification = (packages_notification_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=template&id=32708644&
	var mainvue_type_template_id_32708644_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-slider",
	      class: {
	        "is-vertical": _vm.vertical,
	        "el-slider--with-input": _vm.showInput
	      },
	      attrs: {
	        role: "slider",
	        "aria-valuemin": _vm.min,
	        "aria-valuemax": _vm.max,
	        "aria-orientation": _vm.vertical ? "vertical" : "horizontal",
	        "aria-disabled": _vm.sliderDisabled
	      }
	    },
	    [
	      _vm.showInput && !_vm.range
	        ? _c("el-input-number", {
	            ref: "input",
	            staticClass: "el-slider__input",
	            attrs: {
	              step: _vm.step,
	              disabled: _vm.sliderDisabled,
	              controls: _vm.showInputControls,
	              min: _vm.min,
	              max: _vm.max,
	              debounce: _vm.debounce,
	              size: _vm.inputSize
	            },
	            on: { change: _vm.emitChange },
	            model: {
	              value: _vm.firstValue,
	              callback: function($$v) {
	                _vm.firstValue = $$v
	              },
	              expression: "firstValue"
	            }
	          })
	        : _vm._e(),
	      _c(
	        "div",
	        {
	          ref: "slider",
	          staticClass: "el-slider__runway",
	          class: { "show-input": _vm.showInput, disabled: _vm.sliderDisabled },
	          style: _vm.runwayStyle,
	          on: { click: _vm.onSliderClick }
	        },
	        [
	          _c("div", { staticClass: "el-slider__bar", style: _vm.barStyle }),
	          _c("slider-button", {
	            ref: "button1",
	            attrs: {
	              vertical: _vm.vertical,
	              "tooltip-class": _vm.tooltipClass
	            },
	            model: {
	              value: _vm.firstValue,
	              callback: function($$v) {
	                _vm.firstValue = $$v
	              },
	              expression: "firstValue"
	            }
	          }),
	          _vm.range
	            ? _c("slider-button", {
	                ref: "button2",
	                attrs: {
	                  vertical: _vm.vertical,
	                  "tooltip-class": _vm.tooltipClass
	                },
	                model: {
	                  value: _vm.secondValue,
	                  callback: function($$v) {
	                    _vm.secondValue = $$v
	                  },
	                  expression: "secondValue"
	                }
	              })
	            : _vm._e(),
	          _vm._l(_vm.stops, function(item, key) {
	            return _vm.showStops
	              ? _c("div", {
	                  key: key,
	                  staticClass: "el-slider__stop",
	                  style: _vm.getStopStyle(item)
	                })
	              : _vm._e()
	          }),
	          _vm.markList.length > 0
	            ? [
	                _c(
	                  "div",
	                  _vm._l(_vm.markList, function(item, key) {
	                    return _c("div", {
	                      key: key,
	                      staticClass: "el-slider__stop el-slider__marks-stop",
	                      style: _vm.getStopStyle(item.position)
	                    })
	                  }),
	                  0
	                ),
	                _c(
	                  "div",
	                  { staticClass: "el-slider__marks" },
	                  _vm._l(_vm.markList, function(item, key) {
	                    return _c("slider-marker", {
	                      key: key,
	                      style: _vm.getStopStyle(item.position),
	                      attrs: { mark: item.mark }
	                    })
	                  }),
	                  1
	                )
	              ]
	            : _vm._e()
	        ],
	        2
	      )
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_32708644_staticRenderFns = []
	mainvue_type_template_id_32708644_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=template&id=32708644&
	
	// EXTERNAL MODULE: external "element-ui/lib/input-number"
	var input_number_ = __webpack_require__(41);
	var input_number_default = /*#__PURE__*/__webpack_require__.n(input_number_);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
	var buttonvue_type_template_id_e72d2ad2_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      ref: "button",
	      staticClass: "el-slider__button-wrapper",
	      class: { hover: _vm.hovering, dragging: _vm.dragging },
	      style: _vm.wrapperStyle,
	      attrs: { tabindex: "0" },
	      on: {
	        mouseenter: _vm.handleMouseEnter,
	        mouseleave: _vm.handleMouseLeave,
	        mousedown: _vm.onButtonDown,
	        touchstart: _vm.onButtonDown,
	        focus: _vm.handleMouseEnter,
	        blur: _vm.handleMouseLeave,
	        keydown: [
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "left", 37, $event.key, [
	                "Left",
	                "ArrowLeft"
	              ])
	            ) {
	              return null
	            }
	            if ("button" in $event && $event.button !== 0) {
	              return null
	            }
	            return _vm.onLeftKeyDown($event)
	          },
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "right", 39, $event.key, [
	                "Right",
	                "ArrowRight"
	              ])
	            ) {
	              return null
	            }
	            if ("button" in $event && $event.button !== 2) {
	              return null
	            }
	            return _vm.onRightKeyDown($event)
	          },
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "down", 40, $event.key, [
	                "Down",
	                "ArrowDown"
	              ])
	            ) {
	              return null
	            }
	            $event.preventDefault()
	            return _vm.onLeftKeyDown($event)
	          },
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
	            ) {
	              return null
	            }
	            $event.preventDefault()
	            return _vm.onRightKeyDown($event)
	          }
	        ]
	      }
	    },
	    [
	      _c(
	        "el-tooltip",
	        {
	          ref: "tooltip",
	          attrs: {
	            placement: "top",
	            "popper-class": _vm.tooltipClass,
	            disabled: !_vm.showTooltip
	          }
	        },
	        [
	          _c("span", { attrs: { slot: "content" }, slot: "content" }, [
	            _vm._v(_vm._s(_vm.formatValue))
	          ]),
	          _c("div", {
	            staticClass: "el-slider__button",
	            class: { hover: _vm.hovering, dragging: _vm.dragging }
	          })
	        ]
	      )
	    ],
	    1
	  )
	}
	var buttonvue_type_template_id_e72d2ad2_staticRenderFns = []
	buttonvue_type_template_id_e72d2ad2_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var slider_src_buttonvue_type_script_lang_js_ = ({
	  name: 'ElSliderButton',
	
	  components: {
	    ElTooltip: tooltip_default.a
	  },
	
	  props: {
	    value: {
	      type: Number,
	      default: 0
	    },
	    vertical: {
	      type: Boolean,
	      default: false
	    },
	    tooltipClass: String
	  },
	
	  data: function data() {
	    return {
	      hovering: false,
	      dragging: false,
	      isClick: false,
	      startX: 0,
	      currentX: 0,
	      startY: 0,
	      currentY: 0,
	      startPosition: 0,
	      newPosition: null,
	      oldValue: this.value
	    };
	  },
	
	
	  computed: {
	    disabled: function disabled() {
	      return this.$parent.sliderDisabled;
	    },
	    max: function max() {
	      return this.$parent.max;
	    },
	    min: function min() {
	      return this.$parent.min;
	    },
	    step: function step() {
	      return this.$parent.step;
	    },
	    showTooltip: function showTooltip() {
	      return this.$parent.showTooltip;
	    },
	    precision: function precision() {
	      return this.$parent.precision;
	    },
	    currentPosition: function currentPosition() {
	      return (this.value - this.min) / (this.max - this.min) * 100 + '%';
	    },
	    enableFormat: function enableFormat() {
	      return this.$parent.formatTooltip instanceof Function;
	    },
	    formatValue: function formatValue() {
	      return this.enableFormat && this.$parent.formatTooltip(this.value) || this.value;
	    },
	    wrapperStyle: function wrapperStyle() {
	      return this.vertical ? { bottom: this.currentPosition } : { left: this.currentPosition };
	    }
	  },
	
	  watch: {
	    dragging: function dragging(val) {
	      this.$parent.dragging = val;
	    }
	  },
	
	  methods: {
	    displayTooltip: function displayTooltip() {
	      this.$refs.tooltip && (this.$refs.tooltip.showPopper = true);
	    },
	    hideTooltip: function hideTooltip() {
	      this.$refs.tooltip && (this.$refs.tooltip.showPopper = false);
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      this.hovering = true;
	      this.displayTooltip();
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      this.hovering = false;
	      this.hideTooltip();
	    },
	    onButtonDown: function onButtonDown(event) {
	      if (this.disabled) return;
	      event.preventDefault();
	      this.onDragStart(event);
	      window.addEventListener('mousemove', this.onDragging);
	      window.addEventListener('touchmove', this.onDragging);
	      window.addEventListener('mouseup', this.onDragEnd);
	      window.addEventListener('touchend', this.onDragEnd);
	      window.addEventListener('contextmenu', this.onDragEnd);
	    },
	    onLeftKeyDown: function onLeftKeyDown() {
	      if (this.disabled) return;
	      this.newPosition = parseFloat(this.currentPosition) - this.step / (this.max - this.min) * 100;
	      this.setPosition(this.newPosition);
	      this.$parent.emitChange();
	    },
	    onRightKeyDown: function onRightKeyDown() {
	      if (this.disabled) return;
	      this.newPosition = parseFloat(this.currentPosition) + this.step / (this.max - this.min) * 100;
	      this.setPosition(this.newPosition);
	      this.$parent.emitChange();
	    },
	    onDragStart: function onDragStart(event) {
	      this.dragging = true;
	      this.isClick = true;
	      if (event.type === 'touchstart') {
	        event.clientY = event.touches[0].clientY;
	        event.clientX = event.touches[0].clientX;
	      }
	      if (this.vertical) {
	        this.startY = event.clientY;
	      } else {
	        this.startX = event.clientX;
	      }
	      this.startPosition = parseFloat(this.currentPosition);
	      this.newPosition = this.startPosition;
	    },
	    onDragging: function onDragging(event) {
	      if (this.dragging) {
	        this.isClick = false;
	        this.displayTooltip();
	        this.$parent.resetSize();
	        var diff = 0;
	        if (event.type === 'touchmove') {
	          event.clientY = event.touches[0].clientY;
	          event.clientX = event.touches[0].clientX;
	        }
	        if (this.vertical) {
	          this.currentY = event.clientY;
	          diff = (this.startY - this.currentY) / this.$parent.sliderSize * 100;
	        } else {
	          this.currentX = event.clientX;
	          diff = (this.currentX - this.startX) / this.$parent.sliderSize * 100;
	        }
	        this.newPosition = this.startPosition + diff;
	        this.setPosition(this.newPosition);
	      }
	    },
	    onDragEnd: function onDragEnd() {
	      var _this = this;
	
	      if (this.dragging) {
	        /*
	         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
	         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
	         */
	        setTimeout(function () {
	          _this.dragging = false;
	          _this.hideTooltip();
	          if (!_this.isClick) {
	            _this.setPosition(_this.newPosition);
	            _this.$parent.emitChange();
	          }
	        }, 0);
	        window.removeEventListener('mousemove', this.onDragging);
	        window.removeEventListener('touchmove', this.onDragging);
	        window.removeEventListener('mouseup', this.onDragEnd);
	        window.removeEventListener('touchend', this.onDragEnd);
	        window.removeEventListener('contextmenu', this.onDragEnd);
	      }
	    },
	    setPosition: function setPosition(newPosition) {
	      var _this2 = this;
	
	      if (newPosition === null || isNaN(newPosition)) return;
	      if (newPosition < 0) {
	        newPosition = 0;
	      } else if (newPosition > 100) {
	        newPosition = 100;
	      }
	      var lengthPerStep = 100 / ((this.max - this.min) / this.step);
	      var steps = Math.round(newPosition / lengthPerStep);
	      var value = steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min;
	      value = parseFloat(value.toFixed(this.precision));
	      this.$emit('input', value);
	      this.$nextTick(function () {
	        _this2.displayTooltip();
	        _this2.$refs.tooltip && _this2.$refs.tooltip.updatePopper();
	      });
	      if (!this.dragging && this.value !== this.oldValue) {
	        this.oldValue = this.value;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_slider_src_buttonvue_type_script_lang_js_ = (slider_src_buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/slider/src/button.vue
	
	
	
	
	
	/* normalize component */
	
	var src_button_component = normalizeComponent(
	  packages_slider_src_buttonvue_type_script_lang_js_,
	  buttonvue_type_template_id_e72d2ad2_render,
	  buttonvue_type_template_id_e72d2ad2_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_button_api; }
	src_button_component.options.__file = "packages/slider/src/button.vue"
	/* harmony default export */ var slider_src_button = (src_button_component.exports);
	// CONCATENATED MODULE: ./packages/slider/src/marker.js
	/* harmony default export */ var marker = ({
	  name: 'ElMarker',
	
	  props: {
	    mark: {
	      type: [String, Object]
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	
	    var label = typeof this.mark === 'string' ? this.mark : this.mark.label;
	
	    return h(
	      'div',
	      { 'class': 'el-slider__marks-text', style: this.mark.style || {} },
	      [label]
	    );
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var slider_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElSlider',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	
	  props: {
	    min: {
	      type: Number,
	      default: 0
	    },
	    max: {
	      type: Number,
	      default: 100
	    },
	    step: {
	      type: Number,
	      default: 1
	    },
	    value: {
	      type: [Number, Array],
	      default: 0
	    },
	    showInput: {
	      type: Boolean,
	      default: false
	    },
	    showInputControls: {
	      type: Boolean,
	      default: true
	    },
	    inputSize: {
	      type: String,
	      default: 'small'
	    },
	    showStops: {
	      type: Boolean,
	      default: false
	    },
	    showTooltip: {
	      type: Boolean,
	      default: true
	    },
	    formatTooltip: Function,
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    range: {
	      type: Boolean,
	      default: false
	    },
	    vertical: {
	      type: Boolean,
	      default: false
	    },
	    height: {
	      type: String
	    },
	    debounce: {
	      type: Number,
	      default: 300
	    },
	    label: {
	      type: String
	    },
	    tooltipClass: String,
	    marks: Object
	  },
	
	  components: {
	    ElInputNumber: input_number_default.a,
	    SliderButton: slider_src_button,
	    SliderMarker: marker
	  },
	
	  data: function data() {
	    return {
	      firstValue: null,
	      secondValue: null,
	      oldValue: null,
	      dragging: false,
	      sliderSize: 1
	    };
	  },
	
	
	  watch: {
	    value: function value(val, oldVal) {
	      if (this.dragging || Array.isArray(val) && Array.isArray(oldVal) && val.every(function (item, index) {
	        return item === oldVal[index];
	      })) {
	        return;
	      }
	      this.setValues();
	    },
	    dragging: function dragging(val) {
	      if (!val) {
	        this.setValues();
	      }
	    },
	    firstValue: function firstValue(val) {
	      if (this.range) {
	        this.$emit('input', [this.minValue, this.maxValue]);
	      } else {
	        this.$emit('input', val);
	      }
	    },
	    secondValue: function secondValue() {
	      if (this.range) {
	        this.$emit('input', [this.minValue, this.maxValue]);
	      }
	    },
	    min: function min() {
	      this.setValues();
	    },
	    max: function max() {
	      this.setValues();
	    }
	  },
	
	  methods: {
	    valueChanged: function valueChanged() {
	      var _this = this;
	
	      if (this.range) {
	        return ![this.minValue, this.maxValue].every(function (item, index) {
	          return item === _this.oldValue[index];
	        });
	      } else {
	        return this.value !== this.oldValue;
	      }
	    },
	    setValues: function setValues() {
	      if (this.min > this.max) {
	        console.error('[Element Error][Slider]min should not be greater than max.');
	        return;
	      }
	      var val = this.value;
	      if (this.range && Array.isArray(val)) {
	        if (val[1] < this.min) {
	          this.$emit('input', [this.min, this.min]);
	        } else if (val[0] > this.max) {
	          this.$emit('input', [this.max, this.max]);
	        } else if (val[0] < this.min) {
	          this.$emit('input', [this.min, val[1]]);
	        } else if (val[1] > this.max) {
	          this.$emit('input', [val[0], this.max]);
	        } else {
	          this.firstValue = val[0];
	          this.secondValue = val[1];
	          if (this.valueChanged()) {
	            this.dispatch('ElFormItem', 'el.form.change', [this.minValue, this.maxValue]);
	            this.oldValue = val.slice();
	          }
	        }
	      } else if (!this.range && typeof val === 'number' && !isNaN(val)) {
	        if (val < this.min) {
	          this.$emit('input', this.min);
	        } else if (val > this.max) {
	          this.$emit('input', this.max);
	        } else {
	          this.firstValue = val;
	          if (this.valueChanged()) {
	            this.dispatch('ElFormItem', 'el.form.change', val);
	            this.oldValue = val;
	          }
	        }
	      }
	    },
	    setPosition: function setPosition(percent) {
	      var targetValue = this.min + percent * (this.max - this.min) / 100;
	      if (!this.range) {
	        this.$refs.button1.setPosition(percent);
	        return;
	      }
	      var button = void 0;
	      if (Math.abs(this.minValue - targetValue) < Math.abs(this.maxValue - targetValue)) {
	        button = this.firstValue < this.secondValue ? 'button1' : 'button2';
	      } else {
	        button = this.firstValue > this.secondValue ? 'button1' : 'button2';
	      }
	      this.$refs[button].setPosition(percent);
	    },
	    onSliderClick: function onSliderClick(event) {
	      if (this.sliderDisabled || this.dragging) return;
	      this.resetSize();
	      if (this.vertical) {
	        var sliderOffsetBottom = this.$refs.slider.getBoundingClientRect().bottom;
	        this.setPosition((sliderOffsetBottom - event.clientY) / this.sliderSize * 100);
	      } else {
	        var sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
	        this.setPosition((event.clientX - sliderOffsetLeft) / this.sliderSize * 100);
	      }
	      this.emitChange();
	    },
	    resetSize: function resetSize() {
	      if (this.$refs.slider) {
	        this.sliderSize = this.$refs.slider['client' + (this.vertical ? 'Height' : 'Width')];
	      }
	    },
	    emitChange: function emitChange() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.$emit('change', _this2.range ? [_this2.minValue, _this2.maxValue] : _this2.value);
	      });
	    },
	    getStopStyle: function getStopStyle(position) {
	      return this.vertical ? { 'bottom': position + '%' } : { 'left': position + '%' };
	    }
	  },
	
	  computed: {
	    stops: function stops() {
	      var _this3 = this;
	
	      if (!this.showStops || this.min > this.max) return [];
	      if (this.step === 0) {
	         false && false;
	        return [];
	      }
	      var stopCount = (this.max - this.min) / this.step;
	      var stepWidth = 100 * this.step / (this.max - this.min);
	      var result = [];
	      for (var i = 1; i < stopCount; i++) {
	        result.push(i * stepWidth);
	      }
	      if (this.range) {
	        return result.filter(function (step) {
	          return step < 100 * (_this3.minValue - _this3.min) / (_this3.max - _this3.min) || step > 100 * (_this3.maxValue - _this3.min) / (_this3.max - _this3.min);
	        });
	      } else {
	        return result.filter(function (step) {
	          return step > 100 * (_this3.firstValue - _this3.min) / (_this3.max - _this3.min);
	        });
	      }
	    },
	    markList: function markList() {
	      var _this4 = this;
	
	      if (!this.marks) {
	        return [];
	      }
	
	      var marksKeys = Object.keys(this.marks);
	      return marksKeys.map(parseFloat).sort(function (a, b) {
	        return a - b;
	      }).filter(function (point) {
	        return point <= _this4.max && point >= _this4.min;
	      }).map(function (point) {
	        return {
	          point: point,
	          position: (point - _this4.min) * 100 / (_this4.max - _this4.min),
	          mark: _this4.marks[point]
	        };
	      });
	    },
	    minValue: function minValue() {
	      return Math.min(this.firstValue, this.secondValue);
	    },
	    maxValue: function maxValue() {
	      return Math.max(this.firstValue, this.secondValue);
	    },
	    barSize: function barSize() {
	      return this.range ? 100 * (this.maxValue - this.minValue) / (this.max - this.min) + '%' : 100 * (this.firstValue - this.min) / (this.max - this.min) + '%';
	    },
	    barStart: function barStart() {
	      return this.range ? 100 * (this.minValue - this.min) / (this.max - this.min) + '%' : '0%';
	    },
	    precision: function precision() {
	      var precisions = [this.min, this.max, this.step].map(function (item) {
	        var decimal = ('' + item).split('.')[1];
	        return decimal ? decimal.length : 0;
	      });
	      return Math.max.apply(null, precisions);
	    },
	    runwayStyle: function runwayStyle() {
	      return this.vertical ? { height: this.height } : {};
	    },
	    barStyle: function barStyle() {
	      return this.vertical ? {
	        height: this.barSize,
	        bottom: this.barStart
	      } : {
	        width: this.barSize,
	        left: this.barStart
	      };
	    },
	    sliderDisabled: function sliderDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  mounted: function mounted() {
	    var valuetext = void 0;
	    if (this.range) {
	      if (Array.isArray(this.value)) {
	        this.firstValue = Math.max(this.min, this.value[0]);
	        this.secondValue = Math.min(this.max, this.value[1]);
	      } else {
	        this.firstValue = this.min;
	        this.secondValue = this.max;
	      }
	      this.oldValue = [this.firstValue, this.secondValue];
	      valuetext = this.firstValue + '-' + this.secondValue;
	    } else {
	      if (typeof this.value !== 'number' || isNaN(this.value)) {
	        this.firstValue = this.min;
	      } else {
	        this.firstValue = Math.min(this.max, Math.max(this.min, this.value));
	      }
	      this.oldValue = this.firstValue;
	      valuetext = this.firstValue;
	    }
	    this.$el.setAttribute('aria-valuetext', valuetext);
	
	    // label screen reader
	    this.$el.setAttribute('aria-label', this.label ? this.label : 'slider between ' + this.min + ' and ' + this.max);
	
	    this.resetSize();
	    window.addEventListener('resize', this.resetSize);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.resetSize);
	  }
	});
	// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_slider_src_mainvue_type_script_lang_js_ = (slider_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/slider/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var slider_src_main_component = normalizeComponent(
	  packages_slider_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_32708644_render,
	  mainvue_type_template_id_32708644_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var slider_src_main_api; }
	slider_src_main_component.options.__file = "packages/slider/src/main.vue"
	/* harmony default export */ var slider_src_main = (slider_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/slider/index.js
	
	
	/* istanbul ignore next */
	slider_src_main.install = function (Vue) {
	  Vue.component(slider_src_main.name, slider_src_main);
	};
	
	/* harmony default export */ var slider = (slider_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
	var loadingvue_type_template_id_eee0a7ac_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-loading-fade" },
	      on: { "after-leave": _vm.handleAfterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-loading-mask",
	          class: [_vm.customClass, { "is-fullscreen": _vm.fullscreen }],
	          style: { backgroundColor: _vm.background || "" }
	        },
	        [
	          _c("div", { staticClass: "el-loading-spinner" }, [
	            !_vm.spinner
	              ? _c(
	                  "svg",
	                  {
	                    staticClass: "circular",
	                    attrs: { viewBox: "25 25 50 50" }
	                  },
	                  [
	                    _c("circle", {
	                      staticClass: "path",
	                      attrs: { cx: "50", cy: "50", r: "20", fill: "none" }
	                    })
	                  ]
	                )
	              : _c("i", { class: _vm.spinner }),
	            _vm.text
	              ? _c("p", { staticClass: "el-loading-text" }, [
	                  _vm._v(_vm._s(_vm.text))
	                ])
	              : _vm._e()
	          ])
	        ]
	      )
	    ]
	  )
	}
	var loadingvue_type_template_id_eee0a7ac_staticRenderFns = []
	loadingvue_type_template_id_eee0a7ac_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var loadingvue_type_script_lang_js_ = ({
	  data: function data() {
	    return {
	      text: null,
	      spinner: null,
	      background: null,
	      fullscreen: true,
	      visible: false,
	      customClass: ''
	    };
	  },
	
	
	  methods: {
	    handleAfterLeave: function handleAfterLeave() {
	      this.$emit('after-leave');
	    },
	    setText: function setText(text) {
	      this.text = text;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_loadingvue_type_script_lang_js_ = (loadingvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/loading/src/loading.vue
	
	
	
	
	
	/* normalize component */
	
	var loading_component = normalizeComponent(
	  src_loadingvue_type_script_lang_js_,
	  loadingvue_type_template_id_eee0a7ac_render,
	  loadingvue_type_template_id_eee0a7ac_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var loading_api; }
	loading_component.options.__file = "packages/loading/src/loading.vue"
	/* harmony default export */ var loading = (loading_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/utils/after-leave"
	var after_leave_ = __webpack_require__(33);
	var after_leave_default = /*#__PURE__*/__webpack_require__.n(after_leave_);
	
	// CONCATENATED MODULE: ./packages/loading/src/directive.js
	
	
	
	
	
	var Mask = external_vue_default.a.extend(loading);
	
	var loadingDirective = {};
	loadingDirective.install = function (Vue) {
	  if (Vue.prototype.$isServer) return;
	  var toggleLoading = function toggleLoading(el, binding) {
	    if (binding.value) {
	      Vue.nextTick(function () {
	        if (binding.modifiers.fullscreen) {
	          el.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	          el.originalOverflow = Object(dom_["getStyle"])(document.body, 'overflow');
	          el.maskStyle.zIndex = popup_["PopupManager"].nextZIndex();
	
	          Object(dom_["addClass"])(el.mask, 'is-fullscreen');
	          insertDom(document.body, el, binding);
	        } else {
	          Object(dom_["removeClass"])(el.mask, 'is-fullscreen');
	
	          if (binding.modifiers.body) {
	            el.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	
	            ['top', 'left'].forEach(function (property) {
	              var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
	              el.maskStyle[property] = el.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] - parseInt(Object(dom_["getStyle"])(document.body, 'margin-' + property), 10) + 'px';
	            });
	            ['height', 'width'].forEach(function (property) {
	              el.maskStyle[property] = el.getBoundingClientRect()[property] + 'px';
	            });
	
	            insertDom(document.body, el, binding);
	          } else {
	            el.originalPosition = Object(dom_["getStyle"])(el, 'position');
	            insertDom(el, el, binding);
	          }
	        }
	      });
	    } else {
	      after_leave_default()(el.instance, function (_) {
	        if (!el.instance.hiding) return;
	        el.domVisible = false;
	        var target = binding.modifiers.fullscreen || binding.modifiers.body ? document.body : el;
	        Object(dom_["removeClass"])(target, 'el-loading-parent--relative');
	        Object(dom_["removeClass"])(target, 'el-loading-parent--hidden');
	        el.instance.hiding = false;
	      }, 300, true);
	      el.instance.visible = false;
	      el.instance.hiding = true;
	    }
	  };
	  var insertDom = function insertDom(parent, el, binding) {
	    if (!el.domVisible && Object(dom_["getStyle"])(el, 'display') !== 'none' && Object(dom_["getStyle"])(el, 'visibility') !== 'hidden') {
	      Object.keys(el.maskStyle).forEach(function (property) {
	        el.mask.style[property] = el.maskStyle[property];
	      });
	
	      if (el.originalPosition !== 'absolute' && el.originalPosition !== 'fixed') {
	        Object(dom_["addClass"])(parent, 'el-loading-parent--relative');
	      }
	      if (binding.modifiers.fullscreen && binding.modifiers.lock) {
	        Object(dom_["addClass"])(parent, 'el-loading-parent--hidden');
	      }
	      el.domVisible = true;
	
	      parent.appendChild(el.mask);
	      Vue.nextTick(function () {
	        if (el.instance.hiding) {
	          el.instance.$emit('after-leave');
	        } else {
	          el.instance.visible = true;
	        }
	      });
	      el.domInserted = true;
	    } else if (el.domVisible && el.instance.hiding === true) {
	      el.instance.visible = true;
	      el.instance.hiding = false;
	    }
	  };
	
	  Vue.directive('loading', {
	    bind: function bind(el, binding, vnode) {
	      var textExr = el.getAttribute('element-loading-text');
	      var spinnerExr = el.getAttribute('element-loading-spinner');
	      var backgroundExr = el.getAttribute('element-loading-background');
	      var customClassExr = el.getAttribute('element-loading-custom-class');
	      var vm = vnode.context;
	      var mask = new Mask({
	        el: document.createElement('div'),
	        data: {
	          text: vm && vm[textExr] || textExr,
	          spinner: vm && vm[spinnerExr] || spinnerExr,
	          background: vm && vm[backgroundExr] || backgroundExr,
	          customClass: vm && vm[customClassExr] || customClassExr,
	          fullscreen: !!binding.modifiers.fullscreen
	        }
	      });
	      el.instance = mask;
	      el.mask = mask.$el;
	      el.maskStyle = {};
	
	      binding.value && toggleLoading(el, binding);
	    },
	
	    update: function update(el, binding) {
	      el.instance.setText(el.getAttribute('element-loading-text'));
	      if (binding.oldValue !== binding.value) {
	        toggleLoading(el, binding);
	      }
	    },
	
	    unbind: function unbind(el, binding) {
	      if (el.domInserted) {
	        el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
	        toggleLoading(el, { value: false, modifiers: binding.modifiers });
	      }
	      el.instance && el.instance.$destroy();
	    }
	  });
	};
	
	/* harmony default export */ var src_directive = (loadingDirective);
	// CONCATENATED MODULE: ./packages/loading/src/index.js
	
	
	
	
	
	
	
	var LoadingConstructor = external_vue_default.a.extend(loading);
	
	var src_defaults = {
	  text: null,
	  fullscreen: true,
	  body: false,
	  lock: false,
	  customClass: ''
	};
	
	var fullscreenLoading = void 0;
	
	LoadingConstructor.prototype.originalPosition = '';
	LoadingConstructor.prototype.originalOverflow = '';
	
	LoadingConstructor.prototype.close = function () {
	  var _this = this;
	
	  if (this.fullscreen) {
	    fullscreenLoading = undefined;
	  }
	  after_leave_default()(this, function (_) {
	    var target = _this.fullscreen || _this.body ? document.body : _this.target;
	    Object(dom_["removeClass"])(target, 'el-loading-parent--relative');
	    Object(dom_["removeClass"])(target, 'el-loading-parent--hidden');
	    if (_this.$el && _this.$el.parentNode) {
	      _this.$el.parentNode.removeChild(_this.$el);
	    }
	    _this.$destroy();
	  }, 300);
	  this.visible = false;
	};
	
	var src_addStyle = function addStyle(options, parent, instance) {
	  var maskStyle = {};
	  if (options.fullscreen) {
	    instance.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	    instance.originalOverflow = Object(dom_["getStyle"])(document.body, 'overflow');
	    maskStyle.zIndex = popup_["PopupManager"].nextZIndex();
	  } else if (options.body) {
	    instance.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	    ['top', 'left'].forEach(function (property) {
	      var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
	      maskStyle[property] = options.target.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + 'px';
	    });
	    ['height', 'width'].forEach(function (property) {
	      maskStyle[property] = options.target.getBoundingClientRect()[property] + 'px';
	    });
	  } else {
	    instance.originalPosition = Object(dom_["getStyle"])(parent, 'position');
	  }
	  Object.keys(maskStyle).forEach(function (property) {
	    instance.$el.style[property] = maskStyle[property];
	  });
	};
	
	var src_Loading = function Loading() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (external_vue_default.a.prototype.$isServer) return;
	  options = merge_default()({}, src_defaults, options);
	  if (typeof options.target === 'string') {
	    options.target = document.querySelector(options.target);
	  }
	  options.target = options.target || document.body;
	  if (options.target !== document.body) {
	    options.fullscreen = false;
	  } else {
	    options.body = true;
	  }
	  if (options.fullscreen && fullscreenLoading) {
	    return fullscreenLoading;
	  }
	
	  var parent = options.body ? document.body : options.target;
	  var instance = new LoadingConstructor({
	    el: document.createElement('div'),
	    data: options
	  });
	
	  src_addStyle(options, parent, instance);
	  if (instance.originalPosition !== 'absolute' && instance.originalPosition !== 'fixed') {
	    Object(dom_["addClass"])(parent, 'el-loading-parent--relative');
	  }
	  if (options.fullscreen && options.lock) {
	    Object(dom_["addClass"])(parent, 'el-loading-parent--hidden');
	  }
	  parent.appendChild(instance.$el);
	  external_vue_default.a.nextTick(function () {
	    instance.visible = true;
	  });
	  if (options.fullscreen) {
	    fullscreenLoading = instance;
	  }
	  return instance;
	};
	
	/* harmony default export */ var src = (src_Loading);
	// CONCATENATED MODULE: ./packages/loading/index.js
	
	
	
	/* harmony default export */ var packages_loading = ({
	  install: function install(Vue) {
	    Vue.use(src_directive);
	    Vue.prototype.$loading = src;
	  },
	
	  directive: src_directive,
	  service: src
	});
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
	var iconvue_type_template_id_cb3fe7f4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("i", { class: "el-icon-" + _vm.name })
	}
	var iconvue_type_template_id_cb3fe7f4_staticRenderFns = []
	iconvue_type_template_id_cb3fe7f4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	
	/* harmony default export */ var iconvue_type_script_lang_js_ = ({
	  name: 'ElIcon',
	
	  props: {
	    name: String
	  }
	});
	// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_iconvue_type_script_lang_js_ = (iconvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/icon/src/icon.vue
	
	
	
	
	
	/* normalize component */
	
	var icon_component = normalizeComponent(
	  src_iconvue_type_script_lang_js_,
	  iconvue_type_template_id_cb3fe7f4_render,
	  iconvue_type_template_id_cb3fe7f4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var icon_api; }
	icon_component.options.__file = "packages/icon/src/icon.vue"
	/* harmony default export */ var icon = (icon_component.exports);
	// CONCATENATED MODULE: ./packages/icon/index.js
	
	
	/* istanbul ignore next */
	icon.install = function (Vue) {
	  Vue.component(icon.name, icon);
	};
	
	/* harmony default export */ var packages_icon = (icon);
	// CONCATENATED MODULE: ./packages/row/src/row.js
	/* harmony default export */ var src_row = ({
	  name: 'ElRow',
	
	  componentName: 'ElRow',
	
	  props: {
	    tag: {
	      type: String,
	      default: 'div'
	    },
	    gutter: Number,
	    type: String,
	    justify: {
	      type: String,
	      default: 'start'
	    },
	    align: {
	      type: String,
	      default: 'top'
	    }
	  },
	
	  computed: {
	    style: function style() {
	      var ret = {};
	
	      if (this.gutter) {
	        ret.marginLeft = '-' + this.gutter / 2 + 'px';
	        ret.marginRight = ret.marginLeft;
	      }
	
	      return ret;
	    }
	  },
	
	  render: function render(h) {
	    return h(this.tag, {
	      class: ['el-row', this.justify !== 'start' ? 'is-justify-' + this.justify : '', this.align !== 'top' ? 'is-align-' + this.align : '', { 'el-row--flex': this.type === 'flex' }],
	      style: this.style
	    }, this.$slots.default);
	  }
	});
	// CONCATENATED MODULE: ./packages/row/index.js
	
	
	/* istanbul ignore next */
	src_row.install = function (Vue) {
	  Vue.component(src_row.name, src_row);
	};
	
	/* harmony default export */ var packages_row = (src_row);
	// CONCATENATED MODULE: ./packages/col/src/col.js
	var col_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* harmony default export */ var col = ({
	  name: 'ElCol',
	
	  props: {
	    span: {
	      type: Number,
	      default: 24
	    },
	    tag: {
	      type: String,
	      default: 'div'
	    },
	    offset: Number,
	    pull: Number,
	    push: Number,
	    xs: [Number, Object],
	    sm: [Number, Object],
	    md: [Number, Object],
	    lg: [Number, Object],
	    xl: [Number, Object]
	  },
	
	  computed: {
	    gutter: function gutter() {
	      var parent = this.$parent;
	      while (parent && parent.$options.componentName !== 'ElRow') {
	        parent = parent.$parent;
	      }
	      return parent ? parent.gutter : 0;
	    }
	  },
	  render: function render(h) {
	    var _this = this;
	
	    var classList = [];
	    var style = {};
	
	    if (this.gutter) {
	      style.paddingLeft = this.gutter / 2 + 'px';
	      style.paddingRight = style.paddingLeft;
	    }
	
	    ['span', 'offset', 'pull', 'push'].forEach(function (prop) {
	      if (_this[prop] || _this[prop] === 0) {
	        classList.push(prop !== 'span' ? 'el-col-' + prop + '-' + _this[prop] : 'el-col-' + _this[prop]);
	      }
	    });
	
	    ['xs', 'sm', 'md', 'lg', 'xl'].forEach(function (size) {
	      if (typeof _this[size] === 'number') {
	        classList.push('el-col-' + size + '-' + _this[size]);
	      } else if (col_typeof(_this[size]) === 'object') {
	        var props = _this[size];
	        Object.keys(props).forEach(function (prop) {
	          classList.push(prop !== 'span' ? 'el-col-' + size + '-' + prop + '-' + props[prop] : 'el-col-' + size + '-' + props[prop]);
	        });
	      }
	    });
	
	    return h(this.tag, {
	      class: ['el-col', classList],
	      style: style
	    }, this.$slots.default);
	  }
	});
	// CONCATENATED MODULE: ./packages/col/index.js
	
	
	/* istanbul ignore next */
	col.install = function (Vue) {
	  Vue.component(col.name, col);
	};
	
	/* harmony default export */ var packages_col = (col);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
	var upload_listvue_type_template_id_173fedf5_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition-group",
	    {
	      class: [
	        "el-upload-list",
	        "el-upload-list--" + _vm.listType,
	        { "is-disabled": _vm.disabled }
	      ],
	      attrs: { tag: "ul", name: "el-list" }
	    },
	    _vm._l(_vm.files, function(file) {
	      return _c(
	        "li",
	        {
	          key: file.uid,
	          class: [
	            "el-upload-list__item",
	            "is-" + file.status,
	            _vm.focusing ? "focusing" : ""
	          ],
	          attrs: { tabindex: "0" },
	          on: {
	            keydown: function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
	                  "Backspace",
	                  "Delete",
	                  "Del"
	                ])
	              ) {
	                return null
	              }
	              !_vm.disabled && _vm.$emit("remove", file)
	            },
	            focus: function($event) {
	              _vm.focusing = true
	            },
	            blur: function($event) {
	              _vm.focusing = false
	            },
	            click: function($event) {
	              _vm.focusing = false
	            }
	          }
	        },
	        [
	          _vm._t(
	            "default",
	            [
	              file.status !== "uploading" &&
	              ["picture-card", "picture"].indexOf(_vm.listType) > -1
	                ? _c("img", {
	                    staticClass: "el-upload-list__item-thumbnail",
	                    attrs: { src: file.url, alt: "" }
	                  })
	                : _vm._e(),
	              _c(
	                "a",
	                {
	                  staticClass: "el-upload-list__item-name",
	                  on: {
	                    click: function($event) {
	                      _vm.handleClick(file)
	                    }
	                  }
	                },
	                [
	                  _c("i", { staticClass: "el-icon-document" }),
	                  _vm._v(_vm._s(file.name) + "\n      ")
	                ]
	              ),
	              _c(
	                "label",
	                { staticClass: "el-upload-list__item-status-label" },
	                [
	                  _c("i", {
	                    class: {
	                      "el-icon-upload-success": true,
	                      "el-icon-circle-check": _vm.listType === "text",
	                      "el-icon-check":
	                        ["picture-card", "picture"].indexOf(_vm.listType) > -1
	                    }
	                  })
	                ]
	              ),
	              !_vm.disabled
	                ? _c("i", {
	                    staticClass: "el-icon-close",
	                    on: {
	                      click: function($event) {
	                        _vm.$emit("remove", file)
	                      }
	                    }
	                  })
	                : _vm._e(),
	              !_vm.disabled
	                ? _c("i", { staticClass: "el-icon-close-tip" }, [
	                    _vm._v(_vm._s(_vm.t("el.upload.deleteTip")))
	                  ])
	                : _vm._e(),
	              file.status === "uploading"
	                ? _c("el-progress", {
	                    attrs: {
	                      type: _vm.listType === "picture-card" ? "circle" : "line",
	                      "stroke-width": _vm.listType === "picture-card" ? 6 : 2,
	                      percentage: _vm.parsePercentage(file.percentage)
	                    }
	                  })
	                : _vm._e(),
	              _vm.listType === "picture-card"
	                ? _c("span", { staticClass: "el-upload-list__item-actions" }, [
	                    _vm.handlePreview && _vm.listType === "picture-card"
	                      ? _c(
	                          "span",
	                          {
	                            staticClass: "el-upload-list__item-preview",
	                            on: {
	                              click: function($event) {
	                                _vm.handlePreview(file)
	                              }
	                            }
	                          },
	                          [_c("i", { staticClass: "el-icon-zoom-in" })]
	                        )
	                      : _vm._e(),
	                    !_vm.disabled
	                      ? _c(
	                          "span",
	                          {
	                            staticClass: "el-upload-list__item-delete",
	                            on: {
	                              click: function($event) {
	                                _vm.$emit("remove", file)
	                              }
	                            }
	                          },
	                          [_c("i", { staticClass: "el-icon-delete" })]
	                        )
	                      : _vm._e()
	                  ])
	                : _vm._e()
	            ],
	            { file: file }
	          )
	        ],
	        2
	      )
	    }),
	    0
	  )
	}
	var upload_listvue_type_template_id_173fedf5_staticRenderFns = []
	upload_listvue_type_template_id_173fedf5_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
	
	// EXTERNAL MODULE: external "element-ui/lib/progress"
	var progress_ = __webpack_require__(34);
	var progress_default = /*#__PURE__*/__webpack_require__.n(progress_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var upload_listvue_type_script_lang_js_ = ({
	
	  name: 'ElUploadList',
	
	  mixins: [locale_default.a],
	
	  data: function data() {
	    return {
	      focusing: false
	    };
	  },
	
	  components: { ElProgress: progress_default.a },
	
	  props: {
	    files: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    handlePreview: Function,
	    listType: String
	  },
	  methods: {
	    parsePercentage: function parsePercentage(val) {
	      return parseInt(val, 10);
	    },
	    handleClick: function handleClick(file) {
	      this.handlePreview && this.handlePreview(file);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_upload_listvue_type_script_lang_js_ = (upload_listvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue
	
	
	
	
	
	/* normalize component */
	
	var upload_list_component = normalizeComponent(
	  src_upload_listvue_type_script_lang_js_,
	  upload_listvue_type_template_id_173fedf5_render,
	  upload_listvue_type_template_id_173fedf5_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var upload_list_api; }
	upload_list_component.options.__file = "packages/upload/src/upload-list.vue"
	/* harmony default export */ var upload_list = (upload_list_component.exports);
	// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
	var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(24);
	var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);
	
	// CONCATENATED MODULE: ./packages/upload/src/ajax.js
	function getError(action, option, xhr) {
	  var msg = void 0;
	  if (xhr.response) {
	    msg = '' + (xhr.response.error || xhr.response);
	  } else if (xhr.responseText) {
	    msg = '' + xhr.responseText;
	  } else {
	    msg = 'fail to post ' + action + ' ' + xhr.status;
	  }
	
	  var err = new Error(msg);
	  err.status = xhr.status;
	  err.method = 'post';
	  err.url = action;
	  return err;
	}
	
	function getBody(xhr) {
	  var text = xhr.responseText || xhr.response;
	  if (!text) {
	    return text;
	  }
	
	  try {
	    return JSON.parse(text);
	  } catch (e) {
	    return text;
	  }
	}
	
	function upload(option) {
	  if (typeof XMLHttpRequest === 'undefined') {
	    return;
	  }
	
	  var xhr = new XMLHttpRequest();
	  var action = option.action;
	
	  if (xhr.upload) {
	    xhr.upload.onprogress = function progress(e) {
	      if (e.total > 0) {
	        e.percent = e.loaded / e.total * 100;
	      }
	      option.onProgress(e);
	    };
	  }
	
	  var formData = new FormData();
	
	  if (option.data) {
	    Object.keys(option.data).forEach(function (key) {
	      formData.append(key, option.data[key]);
	    });
	  }
	
	  formData.append(option.filename, option.file, option.file.name);
	
	  xhr.onerror = function error(e) {
	    option.onError(e);
	  };
	
	  xhr.onload = function onload() {
	    if (xhr.status < 200 || xhr.status >= 300) {
	      return option.onError(getError(action, option, xhr));
	    }
	
	    option.onSuccess(getBody(xhr));
	  };
	
	  xhr.open('post', action, true);
	
	  if (option.withCredentials && 'withCredentials' in xhr) {
	    xhr.withCredentials = true;
	  }
	
	  var headers = option.headers || {};
	
	  for (var item in headers) {
	    if (headers.hasOwnProperty(item) && headers[item] !== null) {
	      xhr.setRequestHeader(item, headers[item]);
	    }
	  }
	  xhr.send(formData);
	  return xhr;
	}
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
	var upload_draggervue_type_template_id_7ebbf219_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-upload-dragger",
	      class: {
	        "is-dragover": _vm.dragover
	      },
	      on: {
	        drop: function($event) {
	          $event.preventDefault()
	          return _vm.onDrop($event)
	        },
	        dragover: function($event) {
	          $event.preventDefault()
	          return _vm.onDragover($event)
	        },
	        dragleave: function($event) {
	          $event.preventDefault()
	          _vm.dragover = false
	        }
	      }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var upload_draggervue_type_template_id_7ebbf219_staticRenderFns = []
	upload_draggervue_type_template_id_7ebbf219_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var upload_draggervue_type_script_lang_js_ = ({
	  name: 'ElUploadDrag',
	  props: {
	    disabled: Boolean
	  },
	  inject: {
	    uploader: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      dragover: false
	    };
	  },
	
	  methods: {
	    onDragover: function onDragover() {
	      if (!this.disabled) {
	        this.dragover = true;
	      }
	    },
	    onDrop: function onDrop(e) {
	      if (this.disabled || !this.uploader) return;
	      var accept = this.uploader.accept;
	      this.dragover = false;
	      if (!accept) {
	        this.$emit('file', e.dataTransfer.files);
	        return;
	      }
	      this.$emit('file', [].slice.call(e.dataTransfer.files).filter(function (file) {
	        var type = file.type,
	            name = file.name;
	
	        var extension = name.indexOf('.') > -1 ? '.' + name.split('.').pop() : '';
	        var baseType = type.replace(/\/.*$/, '');
	        return accept.split(',').map(function (type) {
	          return type.trim();
	        }).filter(function (type) {
	          return type;
	        }).some(function (acceptedType) {
	          if (/\..+$/.test(acceptedType)) {
	            return extension === acceptedType;
	          }
	          if (/\/\*$/.test(acceptedType)) {
	            return baseType === acceptedType.replace(/\/\*$/, '');
	          }
	          if (/^[^\/]+\/[^\/]+$/.test(acceptedType)) {
	            return type === acceptedType;
	          }
	          return false;
	        });
	      }));
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_upload_draggervue_type_script_lang_js_ = (upload_draggervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue
	
	
	
	
	
	/* normalize component */
	
	var upload_dragger_component = normalizeComponent(
	  src_upload_draggervue_type_script_lang_js_,
	  upload_draggervue_type_template_id_7ebbf219_render,
	  upload_draggervue_type_template_id_7ebbf219_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var upload_dragger_api; }
	upload_dragger_component.options.__file = "packages/upload/src/upload-dragger.vue"
	/* harmony default export */ var upload_dragger = (upload_dragger_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload.vue?vue&type=script&lang=js&
	
	
	
	
	
	/* harmony default export */ var uploadvue_type_script_lang_js_ = ({
	  inject: ['uploader'],
	  components: {
	    UploadDragger: upload_dragger
	  },
	  props: {
	    type: String,
	    action: {
	      type: String,
	      required: true
	    },
	    name: {
	      type: String,
	      default: 'file'
	    },
	    data: Object,
	    headers: Object,
	    withCredentials: Boolean,
	    multiple: Boolean,
	    accept: String,
	    onStart: Function,
	    onProgress: Function,
	    onSuccess: Function,
	    onError: Function,
	    beforeUpload: Function,
	    drag: Boolean,
	    onPreview: {
	      type: Function,
	      default: function _default() {}
	    },
	    onRemove: {
	      type: Function,
	      default: function _default() {}
	    },
	    fileList: Array,
	    autoUpload: Boolean,
	    listType: String,
	    httpRequest: {
	      type: Function,
	      default: upload
	    },
	    disabled: Boolean,
	    limit: Number,
	    onExceed: Function
	  },
	
	  data: function data() {
	    return {
	      mouseover: false,
	      reqs: {}
	    };
	  },
	
	
	  methods: {
	    isImage: function isImage(str) {
	      return str.indexOf('image') !== -1;
	    },
	    handleChange: function handleChange(ev) {
	      var files = ev.target.files;
	
	      if (!files) return;
	      this.uploadFiles(files);
	    },
	    uploadFiles: function uploadFiles(files) {
	      var _this = this;
	
	      if (this.limit && this.fileList.length + files.length > this.limit) {
	        this.onExceed && this.onExceed(files, this.fileList);
	        return;
	      }
	
	      var postFiles = Array.prototype.slice.call(files);
	      if (!this.multiple) {
	        postFiles = postFiles.slice(0, 1);
	      }
	
	      if (postFiles.length === 0) {
	        return;
	      }
	
	      postFiles.forEach(function (rawFile) {
	        _this.onStart(rawFile);
	        if (_this.autoUpload) _this.upload(rawFile);
	      });
	    },
	    upload: function upload(rawFile) {
	      var _this2 = this;
	
	      this.$refs.input.value = null;
	
	      if (!this.beforeUpload) {
	        return this.post(rawFile);
	      }
	
	      var before = this.beforeUpload(rawFile);
	      if (before && before.then) {
	        before.then(function (processedFile) {
	          var fileType = Object.prototype.toString.call(processedFile);
	
	          if (fileType === '[object File]' || fileType === '[object Blob]') {
	            if (fileType === '[object Blob]') {
	              processedFile = new File([processedFile], rawFile.name, {
	                type: rawFile.type
	              });
	            }
	            for (var p in rawFile) {
	              if (rawFile.hasOwnProperty(p)) {
	                processedFile[p] = rawFile[p];
	              }
	            }
	            _this2.post(processedFile);
	          } else {
	            _this2.post(rawFile);
	          }
	        }, function () {
	          _this2.onRemove(null, rawFile);
	        });
	      } else if (before !== false) {
	        this.post(rawFile);
	      } else {
	        this.onRemove(null, rawFile);
	      }
	    },
	    abort: function abort(file) {
	      var reqs = this.reqs;
	
	      if (file) {
	        var uid = file;
	        if (file.uid) uid = file.uid;
	        if (reqs[uid]) {
	          reqs[uid].abort();
	        }
	      } else {
	        Object.keys(reqs).forEach(function (uid) {
	          if (reqs[uid]) reqs[uid].abort();
	          delete reqs[uid];
	        });
	      }
	    },
	    post: function post(rawFile) {
	      var _this3 = this;
	
	      var uid = rawFile.uid;
	
	      var options = {
	        headers: this.headers,
	        withCredentials: this.withCredentials,
	        file: rawFile,
	        data: this.data,
	        filename: this.name,
	        action: this.action,
	        onProgress: function onProgress(e) {
	          _this3.onProgress(e, rawFile);
	        },
	        onSuccess: function onSuccess(res) {
	          _this3.onSuccess(res, rawFile);
	          delete _this3.reqs[uid];
	        },
	        onError: function onError(err) {
	          _this3.onError(err, rawFile);
	          delete _this3.reqs[uid];
	        }
	      };
	      var req = this.httpRequest(options);
	      this.reqs[uid] = req;
	      if (req && req.then) {
	        req.then(options.onSuccess, options.onError);
	      }
	    },
	    handleClick: function handleClick() {
	      if (!this.disabled) {
	        this.$refs.input.value = null;
	        this.$refs.input.click();
	      }
	    },
	    handleKeydown: function handleKeydown(e) {
	      if (e.target !== e.currentTarget) return;
	      if (e.keyCode === 13 || e.keyCode === 32) {
	        this.handleClick();
	      }
	    }
	  },
	
	  render: function render(h) {
	    var handleClick = this.handleClick,
	        drag = this.drag,
	        name = this.name,
	        handleChange = this.handleChange,
	        multiple = this.multiple,
	        accept = this.accept,
	        listType = this.listType,
	        uploadFiles = this.uploadFiles,
	        disabled = this.disabled,
	        handleKeydown = this.handleKeydown;
	
	    var data = {
	      class: {
	        'el-upload': true
	      },
	      on: {
	        click: handleClick,
	        keydown: handleKeydown
	      }
	    };
	    data.class['el-upload--' + listType] = true;
	    return h(
	      'div',
	      external_babel_helper_vue_jsx_merge_props_default()([data, {
	        attrs: { tabindex: '0' }
	      }]),
	      [drag ? h(
	        'upload-dragger',
	        {
	          attrs: { disabled: disabled },
	          on: {
	            'file': uploadFiles
	          }
	        },
	        [this.$slots.default]
	      ) : this.$slots.default, h('input', { 'class': 'el-upload__input', attrs: { type: 'file', name: name, multiple: multiple, accept: accept },
	        ref: 'input', on: {
	          'change': handleChange
	        }
	      })]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/upload.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_uploadvue_type_script_lang_js_ = (uploadvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/upload.vue
	var upload_render, upload_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var upload_component = normalizeComponent(
	  src_uploadvue_type_script_lang_js_,
	  upload_render,
	  upload_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var upload_api; }
	upload_component.options.__file = "packages/upload/src/upload.vue"
	/* harmony default export */ var src_upload = (upload_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/index.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	function srcvue_type_script_lang_js_noop() {}
	
	/* harmony default export */ var srcvue_type_script_lang_js_ = ({
	  name: 'ElUpload',
	
	  mixins: [migrating_default.a],
	
	  components: {
	    ElProgress: progress_default.a,
	    UploadList: upload_list,
	    Upload: src_upload
	  },
	
	  provide: function provide() {
	    return {
	      uploader: this
	    };
	  },
	
	
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	
	  props: {
	    action: {
	      type: String,
	      required: true
	    },
	    headers: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    data: Object,
	    multiple: Boolean,
	    name: {
	      type: String,
	      default: 'file'
	    },
	    drag: Boolean,
	    dragger: Boolean,
	    withCredentials: Boolean,
	    showFileList: {
	      type: Boolean,
	      default: true
	    },
	    accept: String,
	    type: {
	      type: String,
	      default: 'select'
	    },
	    beforeUpload: Function,
	    beforeRemove: Function,
	    onRemove: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onChange: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onPreview: {
	      type: Function
	    },
	    onSuccess: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onProgress: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onError: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    fileList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    autoUpload: {
	      type: Boolean,
	      default: true
	    },
	    listType: {
	      type: String,
	      default: 'text' // text,picture,picture-card
	    },
	    httpRequest: Function,
	    disabled: Boolean,
	    limit: Number,
	    onExceed: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    }
	  },
	
	  data: function data() {
	    return {
	      uploadFiles: [],
	      dragOver: false,
	      draging: false,
	      tempIndex: 1
	    };
	  },
	
	
	  computed: {
	    uploadDisabled: function uploadDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  watch: {
	    listType: function listType(type) {
	      if (type === 'picture-card' || type === 'picture') {
	        this.uploadFiles = this.uploadFiles.map(function (file) {
	          if (!file.url && file.raw) {
	            try {
	              file.url = URL.createObjectURL(file.raw);
	            } catch (err) {
	              console.error('[Element Error][Upload]', err);
	            }
	          }
	          return file;
	        });
	      }
	    },
	
	    fileList: {
	      immediate: true,
	      handler: function handler(fileList) {
	        var _this = this;
	
	        this.uploadFiles = fileList.map(function (item) {
	          item.uid = item.uid || Date.now() + _this.tempIndex++;
	          item.status = item.status || 'success';
	          return item;
	        });
	      }
	    }
	  },
	
	  methods: {
	    handleStart: function handleStart(rawFile) {
	      rawFile.uid = Date.now() + this.tempIndex++;
	      var file = {
	        status: 'ready',
	        name: rawFile.name,
	        size: rawFile.size,
	        percentage: 0,
	        uid: rawFile.uid,
	        raw: rawFile
	      };
	
	      if (this.listType === 'picture-card' || this.listType === 'picture') {
	        try {
	          file.url = URL.createObjectURL(rawFile);
	        } catch (err) {
	          console.error('[Element Error][Upload]', err);
	          return;
	        }
	      }
	
	      this.uploadFiles.push(file);
	      this.onChange(file, this.uploadFiles);
	    },
	    handleProgress: function handleProgress(ev, rawFile) {
	      var file = this.getFile(rawFile);
	      this.onProgress(ev, file, this.uploadFiles);
	      file.status = 'uploading';
	      file.percentage = ev.percent || 0;
	    },
	    handleSuccess: function handleSuccess(res, rawFile) {
	      var file = this.getFile(rawFile);
	
	      if (file) {
	        file.status = 'success';
	        file.response = res;
	
	        this.onSuccess(res, file, this.uploadFiles);
	        this.onChange(file, this.uploadFiles);
	      }
	    },
	    handleError: function handleError(err, rawFile) {
	      var file = this.getFile(rawFile);
	      var fileList = this.uploadFiles;
	
	      file.status = 'fail';
	
	      fileList.splice(fileList.indexOf(file), 1);
	
	      this.onError(err, file, this.uploadFiles);
	      this.onChange(file, this.uploadFiles);
	    },
	    handleRemove: function handleRemove(file, raw) {
	      var _this2 = this;
	
	      if (raw) {
	        file = this.getFile(raw);
	      }
	      var doRemove = function doRemove() {
	        _this2.abort(file);
	        var fileList = _this2.uploadFiles;
	        fileList.splice(fileList.indexOf(file), 1);
	        _this2.onRemove(file, fileList);
	      };
	
	      if (!this.beforeRemove) {
	        doRemove();
	      } else if (typeof this.beforeRemove === 'function') {
	        var before = this.beforeRemove(file, this.uploadFiles);
	        if (before && before.then) {
	          before.then(function () {
	            doRemove();
	          }, srcvue_type_script_lang_js_noop);
	        } else if (before !== false) {
	          doRemove();
	        }
	      }
	    },
	    getFile: function getFile(rawFile) {
	      var fileList = this.uploadFiles;
	      var target = void 0;
	      fileList.every(function (item) {
	        target = rawFile.uid === item.uid ? item : null;
	        return !target;
	      });
	      return target;
	    },
	    abort: function abort(file) {
	      this.$refs['upload-inner'].abort(file);
	    },
	    clearFiles: function clearFiles() {
	      this.uploadFiles = [];
	    },
	    submit: function submit() {
	      var _this3 = this;
	
	      this.uploadFiles.filter(function (file) {
	        return file.status === 'ready';
	      }).forEach(function (file) {
	        _this3.$refs['upload-inner'].upload(file.raw);
	      });
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'default-file-list': 'default-file-list is renamed to file-list.',
	          'show-upload-list': 'show-upload-list is renamed to show-file-list.',
	          'thumbnail-mode': 'thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan'
	        }
	      };
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.uploadFiles.forEach(function (file) {
	      if (file.url && file.url.indexOf('blob:') === 0) {
	        URL.revokeObjectURL(file.url);
	      }
	    });
	  },
	  render: function render(h) {
	    var _this4 = this;
	
	    var uploadList = void 0;
	
	    if (this.showFileList) {
	      uploadList = h(
	        upload_list,
	        {
	          attrs: {
	            disabled: this.uploadDisabled,
	            listType: this.listType,
	            files: this.uploadFiles,
	
	            handlePreview: this.onPreview },
	          on: {
	            'remove': this.handleRemove
	          }
	        },
	        [function (props) {
	          if (_this4.$scopedSlots.file) {
	            return _this4.$scopedSlots.file({
	              file: props.file
	            });
	          }
	        }]
	      );
	    }
	
	    var uploadData = {
	      props: {
	        type: this.type,
	        drag: this.drag,
	        action: this.action,
	        multiple: this.multiple,
	        'before-upload': this.beforeUpload,
	        'with-credentials': this.withCredentials,
	        headers: this.headers,
	        name: this.name,
	        data: this.data,
	        accept: this.accept,
	        fileList: this.uploadFiles,
	        autoUpload: this.autoUpload,
	        listType: this.listType,
	        disabled: this.uploadDisabled,
	        limit: this.limit,
	        'on-exceed': this.onExceed,
	        'on-start': this.handleStart,
	        'on-progress': this.handleProgress,
	        'on-success': this.handleSuccess,
	        'on-error': this.handleError,
	        'on-preview': this.onPreview,
	        'on-remove': this.handleRemove,
	        'http-request': this.httpRequest
	      },
	      ref: 'upload-inner'
	    };
	
	    var trigger = this.$slots.trigger || this.$slots.default;
	    var uploadComponent = h(
	      'upload',
	      uploadData,
	      [trigger]
	    );
	
	    return h('div', [this.listType === 'picture-card' ? uploadList : '', this.$slots.trigger ? [uploadComponent, this.$slots.default] : uploadComponent, this.$slots.tip, this.listType !== 'picture-card' ? uploadList : '']);
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/index.vue?vue&type=script&lang=js&
	 /* harmony default export */ var upload_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/index.vue
	var src_render, src_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var upload_src_component = normalizeComponent(
	  upload_srcvue_type_script_lang_js_,
	  src_render,
	  src_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_api; }
	upload_src_component.options.__file = "packages/upload/src/index.vue"
	/* harmony default export */ var upload_src = (upload_src_component.exports);
	// CONCATENATED MODULE: ./packages/upload/index.js
	
	
	/* istanbul ignore next */
	upload_src.install = function (Vue) {
	  Vue.component(upload_src.name, upload_src);
	};
	
	/* harmony default export */ var packages_upload = (upload_src);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	var progressvue_type_template_id_229ee406_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-progress",
	      class: [
	        "el-progress--" + _vm.type,
	        _vm.status ? "is-" + _vm.status : "",
	        {
	          "el-progress--without-text": !_vm.showText,
	          "el-progress--text-inside": _vm.textInside
	        }
	      ],
	      attrs: {
	        role: "progressbar",
	        "aria-valuenow": _vm.percentage,
	        "aria-valuemin": "0",
	        "aria-valuemax": "100"
	      }
	    },
	    [
	      _vm.type === "line"
	        ? _c("div", { staticClass: "el-progress-bar" }, [
	            _c(
	              "div",
	              {
	                staticClass: "el-progress-bar__outer",
	                style: { height: _vm.strokeWidth + "px" }
	              },
	              [
	                _c(
	                  "div",
	                  {
	                    staticClass: "el-progress-bar__inner",
	                    style: _vm.barStyle
	                  },
	                  [
	                    _vm.showText && _vm.textInside
	                      ? _c(
	                          "div",
	                          { staticClass: "el-progress-bar__innerText" },
	                          [_vm._v(_vm._s(_vm.content))]
	                        )
	                      : _vm._e()
	                  ]
	                )
	              ]
	            )
	          ])
	        : _c(
	            "div",
	            {
	              staticClass: "el-progress-circle",
	              style: { height: _vm.width + "px", width: _vm.width + "px" }
	            },
	            [
	              _c("svg", { attrs: { viewBox: "0 0 100 100" } }, [
	                _c("path", {
	                  staticClass: "el-progress-circle__track",
	                  style: _vm.trailPathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: "#e5e9f2",
	                    "stroke-width": _vm.relativeStrokeWidth,
	                    fill: "none"
	                  }
	                }),
	                _c("path", {
	                  staticClass: "el-progress-circle__path",
	                  style: _vm.circlePathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: _vm.stroke,
	                    fill: "none",
	                    "stroke-linecap": _vm.strokeLinecap,
	                    "stroke-width": _vm.percentage ? _vm.relativeStrokeWidth : 0
	                  }
	                })
	              ])
	            ]
	          ),
	      _vm.showText && !_vm.textInside
	        ? _c(
	            "div",
	            {
	              staticClass: "el-progress__text",
	              style: { fontSize: _vm.progressTextSize + "px" }
	            },
	            [
	              !_vm.status
	                ? [_vm._v(_vm._s(_vm.content))]
	                : _c("i", { class: _vm.iconClass })
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var progressvue_type_template_id_229ee406_staticRenderFns = []
	progressvue_type_template_id_229ee406_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var progressvue_type_script_lang_js_ = ({
	  name: 'ElProgress',
	  props: {
	    type: {
	      type: String,
	      default: 'line',
	      validator: function validator(val) {
	        return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
	      }
	    },
	    percentage: {
	      type: Number,
	      default: 0,
	      required: true,
	      validator: function validator(val) {
	        return val >= 0 && val <= 100;
	      }
	    },
	    status: {
	      type: String,
	      validator: function validator(val) {
	        return ['success', 'exception', 'warning'].indexOf(val) > -1;
	      }
	    },
	    strokeWidth: {
	      type: Number,
	      default: 6
	    },
	    strokeLinecap: {
	      type: String,
	      default: 'round'
	    },
	    textInside: {
	      type: Boolean,
	      default: false
	    },
	    width: {
	      type: Number,
	      default: 126
	    },
	    showText: {
	      type: Boolean,
	      default: true
	    },
	    color: {
	      type: [String, Array, Function],
	      default: ''
	    },
	    format: Function
	  },
	  computed: {
	    barStyle: function barStyle() {
	      var style = {};
	      style.width = this.percentage + '%';
	      style.backgroundColor = this.getCurrentColor(this.percentage);
	      return style;
	    },
	    relativeStrokeWidth: function relativeStrokeWidth() {
	      return (this.strokeWidth / this.width * 100).toFixed(1);
	    },
	    radius: function radius() {
	      if (this.type === 'circle' || this.type === 'dashboard') {
	        return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
	      } else {
	        return 0;
	      }
	    },
	    trackPath: function trackPath() {
	      var radius = this.radius;
	      var isDashboard = this.type === 'dashboard';
	      return '\n        M 50 50\n        m 0 ' + (isDashboard ? '' : '-') + radius + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '-' : '') + radius * 2 + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '' : '-') + radius * 2 + '\n        ';
	    },
	    perimeter: function perimeter() {
	      return 2 * Math.PI * this.radius;
	    },
	    rate: function rate() {
	      return this.type === 'dashboard' ? 0.75 : 1;
	    },
	    strokeDashoffset: function strokeDashoffset() {
	      var offset = -1 * this.perimeter * (1 - this.rate) / 2;
	      return offset + 'px';
	    },
	    trailPathStyle: function trailPathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset
	      };
	    },
	    circlePathStyle: function circlePathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate * (this.percentage / 100) + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset,
	        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
	      };
	    },
	    stroke: function stroke() {
	      var ret = void 0;
	      if (this.color) {
	        ret = this.getCurrentColor(this.percentage);
	      } else {
	        switch (this.status) {
	          case 'success':
	            ret = '#13ce66';
	            break;
	          case 'exception':
	            ret = '#ff4949';
	            break;
	          case 'warning':
	            ret = '#e6a23c';
	            break;
	          default:
	            ret = '#20a0ff';
	        }
	      }
	      return ret;
	    },
	    iconClass: function iconClass() {
	      if (this.status === 'warning') {
	        return 'el-icon-warning';
	      }
	      if (this.type === 'line') {
	        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
	      } else {
	        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
	      }
	    },
	    progressTextSize: function progressTextSize() {
	      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
	    },
	    content: function content() {
	      if (typeof this.format === 'function') {
	        return this.format(this.percentage) || '';
	      } else {
	        return this.percentage + '%';
	      }
	    }
	  },
	  methods: {
	    getCurrentColor: function getCurrentColor(percentage) {
	      if (typeof this.color === 'function') {
	        return this.color(percentage);
	      } else if (typeof this.color === 'string') {
	        return this.color;
	      } else {
	        return this.getLevelColor(percentage);
	      }
	    },
	    getLevelColor: function getLevelColor(percentage) {
	      var colorArray = this.getColorArray().sort(function (a, b) {
	        return a.percentage - b.percentage;
	      });
	
	      for (var i = 0; i < colorArray.length; i++) {
	        if (colorArray[i].percentage > percentage) {
	          return colorArray[i].color;
	        }
	      }
	      return colorArray[colorArray.length - 1].color;
	    },
	    getColorArray: function getColorArray() {
	      var color = this.color;
	      var span = 100 / color.length;
	      return color.map(function (seriesColor, index) {
	        if (typeof seriesColor === 'string') {
	          return {
	            color: seriesColor,
	            progress: (index + 1) * span
	          };
	        }
	        return seriesColor;
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_progressvue_type_script_lang_js_ = (progressvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue
	
	
	
	
	
	/* normalize component */
	
	var progress_component = normalizeComponent(
	  src_progressvue_type_script_lang_js_,
	  progressvue_type_template_id_229ee406_render,
	  progressvue_type_template_id_229ee406_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var progress_api; }
	progress_component.options.__file = "packages/progress/src/progress.vue"
	/* harmony default export */ var progress = (progress_component.exports);
	// CONCATENATED MODULE: ./packages/progress/index.js
	
	
	/* istanbul ignore next */
	progress.install = function (Vue) {
	  Vue.component(progress.name, progress);
	};
	
	/* harmony default export */ var packages_progress = (progress);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
	var spinnervue_type_template_id_697b8538_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("span", { staticClass: "el-spinner" }, [
	    _c(
	      "svg",
	      {
	        staticClass: "el-spinner-inner",
	        style: { width: _vm.radius / 2 + "px", height: _vm.radius / 2 + "px" },
	        attrs: { viewBox: "0 0 50 50" }
	      },
	      [
	        _c("circle", {
	          staticClass: "path",
	          attrs: {
	            cx: "25",
	            cy: "25",
	            r: "20",
	            fill: "none",
	            stroke: _vm.strokeColor,
	            "stroke-width": _vm.strokeWidth
	          }
	        })
	      ]
	    )
	  ])
	}
	var spinnervue_type_template_id_697b8538_staticRenderFns = []
	spinnervue_type_template_id_697b8538_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var spinnervue_type_script_lang_js_ = ({
	  name: 'ElSpinner',
	  props: {
	    type: String,
	    radius: {
	      type: Number,
	      default: 100
	    },
	    strokeWidth: {
	      type: Number,
	      default: 5
	    },
	    strokeColor: {
	      type: String,
	      default: '#efefef'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_spinnervue_type_script_lang_js_ = (spinnervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue
	
	
	
	
	
	/* normalize component */
	
	var spinner_component = normalizeComponent(
	  src_spinnervue_type_script_lang_js_,
	  spinnervue_type_template_id_697b8538_render,
	  spinnervue_type_template_id_697b8538_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var spinner_api; }
	spinner_component.options.__file = "packages/spinner/src/spinner.vue"
	/* harmony default export */ var spinner = (spinner_component.exports);
	// CONCATENATED MODULE: ./packages/spinner/index.js
	
	
	/* istanbul ignore next */
	spinner.install = function (Vue) {
	  Vue.component(spinner.name, spinner);
	};
	
	/* harmony default export */ var packages_spinner = (spinner);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=template&id=455b9f60&
	var mainvue_type_template_id_455b9f60_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-message-fade" },
	      on: { "after-leave": _vm.handleAfterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          class: [
	            "el-message",
	            _vm.type && !_vm.iconClass ? "el-message--" + _vm.type : "",
	            _vm.center ? "is-center" : "",
	            _vm.showClose ? "is-closable" : "",
	            _vm.customClass
	          ],
	          style: _vm.positionStyle,
	          attrs: { role: "alert" },
	          on: { mouseenter: _vm.clearTimer, mouseleave: _vm.startTimer }
	        },
	        [
	          _vm.iconClass
	            ? _c("i", { class: _vm.iconClass })
	            : _c("i", { class: _vm.typeClass }),
	          _vm._t("default", [
	            !_vm.dangerouslyUseHTMLString
	              ? _c("p", { staticClass: "el-message__content" }, [
	                  _vm._v(_vm._s(_vm.message))
	                ])
	              : _c("p", {
	                  staticClass: "el-message__content",
	                  domProps: { innerHTML: _vm._s(_vm.message) }
	                })
	          ]),
	          _vm.showClose
	            ? _c("i", {
	                staticClass: "el-message__closeBtn el-icon-close",
	                on: { click: _vm.close }
	              })
	            : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var mainvue_type_template_id_455b9f60_staticRenderFns = []
	mainvue_type_template_id_455b9f60_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=template&id=455b9f60&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var src_mainvue_type_script_lang_js_typeMap = {
	  success: 'success',
	  info: 'info',
	  warning: 'warning',
	  error: 'error'
	};
	
	/* harmony default export */ var message_src_mainvue_type_script_lang_js_ = ({
	  data: function data() {
	    return {
	      visible: false,
	      message: '',
	      duration: 3000,
	      type: 'info',
	      iconClass: '',
	      customClass: '',
	      onClose: null,
	      showClose: false,
	      closed: false,
	      verticalOffset: 20,
	      timer: null,
	      dangerouslyUseHTMLString: false,
	      center: false
	    };
	  },
	
	
	  computed: {
	    typeClass: function typeClass() {
	      return this.type && !this.iconClass ? 'el-message__icon el-icon-' + src_mainvue_type_script_lang_js_typeMap[this.type] : '';
	    },
	    positionStyle: function positionStyle() {
	      return {
	        'top': this.verticalOffset + 'px'
	      };
	    }
	  },
	
	  watch: {
	    closed: function closed(newVal) {
	      if (newVal) {
	        this.visible = false;
	      }
	    }
	  },
	
	  methods: {
	    handleAfterLeave: function handleAfterLeave() {
	      this.$destroy(true);
	      this.$el.parentNode.removeChild(this.$el);
	    },
	    close: function close() {
	      this.closed = true;
	      if (typeof this.onClose === 'function') {
	        this.onClose(this);
	      }
	    },
	    clearTimer: function clearTimer() {
	      clearTimeout(this.timer);
	    },
	    startTimer: function startTimer() {
	      var _this = this;
	
	      if (this.duration > 0) {
	        this.timer = setTimeout(function () {
	          if (!_this.closed) {
	            _this.close();
	          }
	        }, this.duration);
	      }
	    },
	    keydown: function keydown(e) {
	      if (e.keyCode === 27) {
	        // esc关闭消息
	        if (!this.closed) {
	          this.close();
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.startTimer();
	    document.addEventListener('keydown', this.keydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.keydown);
	  }
	});
	// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_message_src_mainvue_type_script_lang_js_ = (message_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/message/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var message_src_main_component = normalizeComponent(
	  packages_message_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_455b9f60_render,
	  mainvue_type_template_id_455b9f60_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var message_src_main_api; }
	message_src_main_component.options.__file = "packages/message/src/main.vue"
	/* harmony default export */ var message_src_main = (message_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/message/src/main.js
	
	
	
	
	var MessageConstructor = external_vue_default.a.extend(message_src_main);
	
	var message_src_main_instance = void 0;
	var main_instances = [];
	var main_seed = 1;
	
	var main_Message = function Message(options) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  options = options || {};
	  if (typeof options === 'string') {
	    options = {
	      message: options
	    };
	  }
	  var userOnClose = options.onClose;
	  var id = 'message_' + main_seed++;
	
	  options.onClose = function () {
	    Message.close(id, userOnClose);
	  };
	  message_src_main_instance = new MessageConstructor({
	    data: options
	  });
	  message_src_main_instance.id = id;
	  if (Object(vdom_["isVNode"])(message_src_main_instance.message)) {
	    message_src_main_instance.$slots.default = [message_src_main_instance.message];
	    message_src_main_instance.message = null;
	  }
	  message_src_main_instance.$mount();
	  document.body.appendChild(message_src_main_instance.$el);
	  var verticalOffset = options.offset || 20;
	  main_instances.forEach(function (item) {
	    verticalOffset += item.$el.offsetHeight + 16;
	  });
	  message_src_main_instance.verticalOffset = verticalOffset;
	  message_src_main_instance.visible = true;
	  message_src_main_instance.$el.style.zIndex = popup_["PopupManager"].nextZIndex();
	  main_instances.push(message_src_main_instance);
	  return message_src_main_instance;
	};
	
	['success', 'warning', 'info', 'error'].forEach(function (type) {
	  main_Message[type] = function (options) {
	    if (typeof options === 'string') {
	      options = {
	        message: options
	      };
	    }
	    options.type = type;
	    return main_Message(options);
	  };
	});
	
	main_Message.close = function (id, userOnClose) {
	  var len = main_instances.length;
	  var index = -1;
	  var removedHeight = void 0;
	  for (var i = 0; i < len; i++) {
	    if (id === main_instances[i].id) {
	      removedHeight = main_instances[i].$el.offsetHeight;
	      index = i;
	      if (typeof userOnClose === 'function') {
	        userOnClose(main_instances[i]);
	      }
	      main_instances.splice(i, 1);
	      break;
	    }
	  }
	  if (len <= 1 || index === -1 || index > main_instances.length - 1) return;
	  for (var _i = index; _i < len - 1; _i++) {
	    var dom = main_instances[_i].$el;
	    dom.style['top'] = parseInt(dom.style['top'], 10) - removedHeight - 16 + 'px';
	  }
	};
	
	main_Message.closeAll = function () {
	  for (var i = main_instances.length - 1; i >= 0; i--) {
	    main_instances[i].close();
	  }
	};
	
	/* harmony default export */ var packages_message_src_main = (main_Message);
	// CONCATENATED MODULE: ./packages/message/index.js
	
	/* harmony default export */ var packages_message = (packages_message_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
	var mainvue_type_template_id_7ccb6598_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    { staticClass: "el-badge" },
	    [
	      _vm._t("default"),
	      _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
	        _c("sup", {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value:
	                !_vm.hidden && (_vm.content || _vm.content === 0 || _vm.isDot),
	              expression: "!hidden && (content || content === 0 || isDot)"
	            }
	          ],
	          staticClass: "el-badge__content",
	          class: [
	            "el-badge__content--" + _vm.type,
	            {
	              "is-fixed": _vm.$slots.default,
	              "is-dot": _vm.isDot
	            }
	          ],
	          domProps: { textContent: _vm._s(_vm.content) }
	        })
	      ])
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_7ccb6598_staticRenderFns = []
	mainvue_type_template_id_7ccb6598_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var badge_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElBadge',
	
	  props: {
	    value: [String, Number],
	    max: Number,
	    isDot: Boolean,
	    hidden: Boolean,
	    type: {
	      type: String,
	      validator: function validator(val) {
	        return ['primary', 'success', 'warning', 'info', 'danger'].indexOf(val) > -1;
	      }
	    }
	  },
	
	  computed: {
	    content: function content() {
	      if (this.isDot) return;
	
	      var value = this.value;
	      var max = this.max;
	
	      if (typeof value === 'number' && typeof max === 'number') {
	        return max < value ? max + '+' : value;
	      }
	
	      return value;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_badge_src_mainvue_type_script_lang_js_ = (badge_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/badge/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var badge_src_main_component = normalizeComponent(
	  packages_badge_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_7ccb6598_render,
	  mainvue_type_template_id_7ccb6598_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var badge_src_main_api; }
	badge_src_main_component.options.__file = "packages/badge/src/main.vue"
	/* harmony default export */ var badge_src_main = (badge_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/badge/index.js
	
	
	/* istanbul ignore next */
	badge_src_main.install = function (Vue) {
	  Vue.component(badge_src_main.name, badge_src_main);
	};
	
	/* harmony default export */ var badge = (badge_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
	var mainvue_type_template_id_59a4a40f_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-card",
	      class: _vm.shadow ? "is-" + _vm.shadow + "-shadow" : "is-always-shadow"
	    },
	    [
	      _vm.$slots.header || _vm.header
	        ? _c(
	            "div",
	            { staticClass: "el-card__header" },
	            [_vm._t("header", [_vm._v(_vm._s(_vm.header))])],
	            2
	          )
	        : _vm._e(),
	      _c(
	        "div",
	        { staticClass: "el-card__body", style: _vm.bodyStyle },
	        [_vm._t("default")],
	        2
	      )
	    ]
	  )
	}
	var mainvue_type_template_id_59a4a40f_staticRenderFns = []
	mainvue_type_template_id_59a4a40f_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var card_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElCard',
	  props: {
	    header: {},
	    bodyStyle: {},
	    shadow: {
	      type: String
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_card_src_mainvue_type_script_lang_js_ = (card_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/card/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var card_src_main_component = normalizeComponent(
	  packages_card_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_59a4a40f_render,
	  mainvue_type_template_id_59a4a40f_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var card_src_main_api; }
	card_src_main_component.options.__file = "packages/card/src/main.vue"
	/* harmony default export */ var card_src_main = (card_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/card/index.js
	
	
	/* istanbul ignore next */
	card_src_main.install = function (Vue) {
	  Vue.component(card_src_main.name, card_src_main);
	};
	
	/* harmony default export */ var card = (card_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=template&id=ada57782&
	var mainvue_type_template_id_ada57782_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-rate",
	      attrs: {
	        role: "slider",
	        "aria-valuenow": _vm.currentValue,
	        "aria-valuetext": _vm.text,
	        "aria-valuemin": "0",
	        "aria-valuemax": _vm.max,
	        tabindex: "0"
	      },
	      on: { keydown: _vm.handleKey }
	    },
	    [
	      _vm._l(_vm.max, function(item, key) {
	        return _c(
	          "span",
	          {
	            key: key,
	            staticClass: "el-rate__item",
	            style: { cursor: _vm.rateDisabled ? "auto" : "pointer" },
	            on: {
	              mousemove: function($event) {
	                _vm.setCurrentValue(item, $event)
	              },
	              mouseleave: _vm.resetCurrentValue,
	              click: function($event) {
	                _vm.selectValue(item)
	              }
	            }
	          },
	          [
	            _c(
	              "i",
	              {
	                staticClass: "el-rate__icon",
	                class: [
	                  _vm.classes[item - 1],
	                  { hover: _vm.hoverIndex === item }
	                ],
	                style: _vm.getIconStyle(item)
	              },
	              [
	                _vm.showDecimalIcon(item)
	                  ? _c("i", {
	                      staticClass: "el-rate__decimal",
	                      class: _vm.decimalIconClass,
	                      style: _vm.decimalStyle
	                    })
	                  : _vm._e()
	              ]
	            )
	          ]
	        )
	      }),
	      _vm.showText || _vm.showScore
	        ? _c(
	            "span",
	            { staticClass: "el-rate__text", style: { color: _vm.textColor } },
	            [_vm._v(_vm._s(_vm.text))]
	          )
	        : _vm._e()
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_ada57782_staticRenderFns = []
	mainvue_type_template_id_ada57782_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=template&id=ada57782&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/types"
	var types_ = __webpack_require__(18);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var rate_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElRate',
	
	  mixins: [migrating_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      pointerAtLeftHalf: true,
	      currentValue: this.value,
	      hoverIndex: -1
	    };
	  },
	
	
	  props: {
	    value: {
	      type: Number,
	      default: 0
	    },
	    lowThreshold: {
	      type: Number,
	      default: 2
	    },
	    highThreshold: {
	      type: Number,
	      default: 4
	    },
	    max: {
	      type: Number,
	      default: 5
	    },
	    colors: {
	      type: [Array, Object],
	      default: function _default() {
	        return ['#F7BA2A', '#F7BA2A', '#F7BA2A'];
	      }
	    },
	    voidColor: {
	      type: String,
	      default: '#C6D1DE'
	    },
	    disabledVoidColor: {
	      type: String,
	      default: '#EFF2F7'
	    },
	    iconClasses: {
	      type: [Array, Object],
	      default: function _default() {
	        return ['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on'];
	      }
	    },
	    voidIconClass: {
	      type: String,
	      default: 'el-icon-star-off'
	    },
	    disabledVoidIconClass: {
	      type: String,
	      default: 'el-icon-star-on'
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    allowHalf: {
	      type: Boolean,
	      default: false
	    },
	    showText: {
	      type: Boolean,
	      default: false
	    },
	    showScore: {
	      type: Boolean,
	      default: false
	    },
	    textColor: {
	      type: String,
	      default: '#1f2d3d'
	    },
	    texts: {
	      type: Array,
	      default: function _default() {
	        return ['极差', '失望', '一般', '满意', '惊喜'];
	      }
	    },
	    scoreTemplate: {
	      type: String,
	      default: '{value}'
	    }
	  },
	
	  computed: {
	    text: function text() {
	      var result = '';
	      if (this.showScore) {
	        result = this.scoreTemplate.replace(/\{\s*value\s*\}/, this.rateDisabled ? this.value : this.currentValue);
	      } else if (this.showText) {
	        result = this.texts[Math.ceil(this.currentValue) - 1];
	      }
	      return result;
	    },
	    decimalStyle: function decimalStyle() {
	      var width = '';
	      if (this.rateDisabled) {
	        width = this.valueDecimal + '%';
	      } else if (this.allowHalf) {
	        width = '50%';
	      }
	      return {
	        color: this.activeColor,
	        width: width
	      };
	    },
	    valueDecimal: function valueDecimal() {
	      return this.value * 100 - Math.floor(this.value) * 100;
	    },
	    classMap: function classMap() {
	      var _ref;
	
	      return Array.isArray(this.iconClasses) ? (_ref = {}, _ref[this.lowThreshold] = this.iconClasses[0], _ref[this.highThreshold] = { value: this.iconClasses[1], excluded: true }, _ref[this.max] = this.iconClasses[2], _ref) : this.iconClasses;
	    },
	    decimalIconClass: function decimalIconClass() {
	      return this.getValueFromMap(this.value, this.classMap);
	    },
	    voidClass: function voidClass() {
	      return this.rateDisabled ? this.disabledVoidIconClass : this.voidIconClass;
	    },
	    activeClass: function activeClass() {
	      return this.getValueFromMap(this.currentValue, this.classMap);
	    },
	    colorMap: function colorMap() {
	      var _ref2;
	
	      return Array.isArray(this.colors) ? (_ref2 = {}, _ref2[this.lowThreshold] = this.colors[0], _ref2[this.highThreshold] = { value: this.colors[1], excluded: true }, _ref2[this.max] = this.colors[2], _ref2) : this.colors;
	    },
	    activeColor: function activeColor() {
	      return this.getValueFromMap(this.currentValue, this.colorMap);
	    },
	    classes: function classes() {
	      var result = [];
	      var i = 0;
	      var threshold = this.currentValue;
	      if (this.allowHalf && this.currentValue !== Math.floor(this.currentValue)) {
	        threshold--;
	      }
	      for (; i < threshold; i++) {
	        result.push(this.activeClass);
	      }
	      for (; i < this.max; i++) {
	        result.push(this.voidClass);
	      }
	      return result;
	    },
	    rateDisabled: function rateDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	      this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'text-template': 'text-template is renamed to score-template.'
	        }
	      };
	    },
	    getValueFromMap: function getValueFromMap(value, map) {
	      var matchedKeys = Object.keys(map).filter(function (key) {
	        var val = map[key];
	        var excluded = Object(types_["isObject"])(val) ? val.excluded : false;
	        return excluded ? value < key : value <= key;
	      }).sort(function (a, b) {
	        return a - b;
	      });
	      var matchedValue = map[matchedKeys[0]];
	      return Object(types_["isObject"])(matchedValue) ? matchedValue.value : matchedValue || '';
	    },
	    showDecimalIcon: function showDecimalIcon(item) {
	      var showWhenDisabled = this.rateDisabled && this.valueDecimal > 0 && item - 1 < this.value && item > this.value;
	      /* istanbul ignore next */
	      var showWhenAllowHalf = this.allowHalf && this.pointerAtLeftHalf && item - 0.5 <= this.currentValue && item > this.currentValue;
	      return showWhenDisabled || showWhenAllowHalf;
	    },
	    getIconStyle: function getIconStyle(item) {
	      var voidColor = this.rateDisabled ? this.disabledVoidColor : this.voidColor;
	      return {
	        color: item <= this.currentValue ? this.activeColor : voidColor
	      };
	    },
	    selectValue: function selectValue(value) {
	      if (this.rateDisabled) {
	        return;
	      }
	      if (this.allowHalf && this.pointerAtLeftHalf) {
	        this.$emit('input', this.currentValue);
	        this.$emit('change', this.currentValue);
	      } else {
	        this.$emit('input', value);
	        this.$emit('change', value);
	      }
	    },
	    handleKey: function handleKey(e) {
	      if (this.rateDisabled) {
	        return;
	      }
	      var currentValue = this.currentValue;
	      var keyCode = e.keyCode;
	      if (keyCode === 38 || keyCode === 39) {
	        // left / down
	        if (this.allowHalf) {
	          currentValue += 0.5;
	        } else {
	          currentValue += 1;
	        }
	        e.stopPropagation();
	        e.preventDefault();
	      } else if (keyCode === 37 || keyCode === 40) {
	        if (this.allowHalf) {
	          currentValue -= 0.5;
	        } else {
	          currentValue -= 1;
	        }
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      currentValue = currentValue < 0 ? 0 : currentValue;
	      currentValue = currentValue > this.max ? this.max : currentValue;
	
	      this.$emit('input', currentValue);
	      this.$emit('change', currentValue);
	    },
	    setCurrentValue: function setCurrentValue(value, event) {
	      if (this.rateDisabled) {
	        return;
	      }
	      /* istanbul ignore if */
	      if (this.allowHalf) {
	        var target = event.target;
	        if (Object(dom_["hasClass"])(target, 'el-rate__item')) {
	          target = target.querySelector('.el-rate__icon');
	        }
	        if (Object(dom_["hasClass"])(target, 'el-rate__decimal')) {
	          target = target.parentNode;
	        }
	        this.pointerAtLeftHalf = event.offsetX * 2 <= target.clientWidth;
	        this.currentValue = this.pointerAtLeftHalf ? value - 0.5 : value;
	      } else {
	        this.currentValue = value;
	      }
	      this.hoverIndex = value;
	    },
	    resetCurrentValue: function resetCurrentValue() {
	      if (this.rateDisabled) {
	        return;
	      }
	      if (this.allowHalf) {
	        this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
	      }
	      this.currentValue = this.value;
	      this.hoverIndex = -1;
	    }
	  },
	
	  created: function created() {
	    if (!this.value) {
	      this.$emit('input', 0);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_rate_src_mainvue_type_script_lang_js_ = (rate_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/rate/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var rate_src_main_component = normalizeComponent(
	  packages_rate_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_ada57782_render,
	  mainvue_type_template_id_ada57782_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var rate_src_main_api; }
	rate_src_main_component.options.__file = "packages/rate/src/main.vue"
	/* harmony default export */ var rate_src_main = (rate_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/rate/index.js
	
	
	/* istanbul ignore next */
	rate_src_main.install = function (Vue) {
	  Vue.component(rate_src_main.name, rate_src_main);
	};
	
	/* harmony default export */ var rate = (rate_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
	var stepsvue_type_template_id_3c6b6dc0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-steps",
	      class: [
	        !_vm.simple && "el-steps--" + _vm.direction,
	        _vm.simple && "el-steps--simple"
	      ]
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var stepsvue_type_template_id_3c6b6dc0_staticRenderFns = []
	stepsvue_type_template_id_3c6b6dc0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var stepsvue_type_script_lang_js_ = ({
	  name: 'ElSteps',
	
	  mixins: [migrating_default.a],
	
	  props: {
	    space: [Number, String],
	    active: Number,
	    direction: {
	      type: String,
	      default: 'horizontal'
	    },
	    alignCenter: Boolean,
	    simple: Boolean,
	    finishStatus: {
	      type: String,
	      default: 'finish'
	    },
	    processStatus: {
	      type: String,
	      default: 'process'
	    }
	  },
	
	  data: function data() {
	    return {
	      steps: [],
	      stepOffset: 0
	    };
	  },
	
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'center': 'center is removed.'
	        }
	      };
	    }
	  },
	
	  watch: {
	    active: function active(newVal, oldVal) {
	      this.$emit('change', newVal, oldVal);
	    },
	    steps: function steps(_steps) {
	      _steps.forEach(function (child, index) {
	        child.index = index;
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_stepsvue_type_script_lang_js_ = (stepsvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/steps/src/steps.vue
	
	
	
	
	
	/* normalize component */
	
	var steps_component = normalizeComponent(
	  src_stepsvue_type_script_lang_js_,
	  stepsvue_type_template_id_3c6b6dc0_render,
	  stepsvue_type_template_id_3c6b6dc0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var steps_api; }
	steps_component.options.__file = "packages/steps/src/steps.vue"
	/* harmony default export */ var steps = (steps_component.exports);
	// CONCATENATED MODULE: ./packages/steps/index.js
	
	
	/* istanbul ignore next */
	steps.install = function (Vue) {
	  Vue.component(steps.name, steps);
	};
	
	/* harmony default export */ var packages_steps = (steps);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
	var stepvue_type_template_id_f414a87a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-step",
	      class: [
	        !_vm.isSimple && "is-" + _vm.$parent.direction,
	        _vm.isSimple && "is-simple",
	        _vm.isLast && !_vm.space && !_vm.isCenter && "is-flex",
	        _vm.isCenter && !_vm.isVertical && !_vm.isSimple && "is-center"
	      ],
	      style: _vm.style
	    },
	    [
	      _c(
	        "div",
	        { staticClass: "el-step__head", class: "is-" + _vm.currentStatus },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-step__line",
	              style: _vm.isLast
	                ? ""
	                : { marginRight: _vm.$parent.stepOffset + "px" }
	            },
	            [
	              _c("i", {
	                staticClass: "el-step__line-inner",
	                style: _vm.lineStyle
	              })
	            ]
	          ),
	          _c(
	            "div",
	            {
	              staticClass: "el-step__icon",
	              class: "is-" + (_vm.icon ? "icon" : "text")
	            },
	            [
	              _vm.currentStatus !== "success" && _vm.currentStatus !== "error"
	                ? _vm._t("icon", [
	                    _vm.icon
	                      ? _c("i", {
	                          staticClass: "el-step__icon-inner",
	                          class: [_vm.icon]
	                        })
	                      : _vm._e(),
	                    !_vm.icon && !_vm.isSimple
	                      ? _c("div", { staticClass: "el-step__icon-inner" }, [
	                          _vm._v(_vm._s(_vm.index + 1))
	                        ])
	                      : _vm._e()
	                  ])
	                : _c("i", {
	                    staticClass: "el-step__icon-inner is-status",
	                    class: [
	                      "el-icon-" +
	                        (_vm.currentStatus === "success" ? "check" : "close")
	                    ]
	                  })
	            ],
	            2
	          )
	        ]
	      ),
	      _c("div", { staticClass: "el-step__main" }, [
	        _c(
	          "div",
	          {
	            ref: "title",
	            staticClass: "el-step__title",
	            class: ["is-" + _vm.currentStatus]
	          },
	          [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
	          2
	        ),
	        _vm.isSimple
	          ? _c("div", { staticClass: "el-step__arrow" })
	          : _c(
	              "div",
	              {
	                staticClass: "el-step__description",
	                class: ["is-" + _vm.currentStatus]
	              },
	              [_vm._t("description", [_vm._v(_vm._s(_vm.description))])],
	              2
	            )
	      ])
	    ]
	  )
	}
	var stepvue_type_template_id_f414a87a_staticRenderFns = []
	stepvue_type_template_id_f414a87a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var stepvue_type_script_lang_js_ = ({
	  name: 'ElStep',
	
	  props: {
	    title: String,
	    icon: String,
	    description: String,
	    status: String
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      lineStyle: {},
	      internalStatus: ''
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    this.$parent.steps.push(this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var steps = this.$parent.steps;
	    var index = steps.indexOf(this);
	    if (index >= 0) {
	      steps.splice(index, 1);
	    }
	  },
	
	
	  computed: {
	    currentStatus: function currentStatus() {
	      return this.status || this.internalStatus;
	    },
	    prevStatus: function prevStatus() {
	      var prevStep = this.$parent.steps[this.index - 1];
	      return prevStep ? prevStep.currentStatus : 'wait';
	    },
	    isCenter: function isCenter() {
	      return this.$parent.alignCenter;
	    },
	    isVertical: function isVertical() {
	      return this.$parent.direction === 'vertical';
	    },
	    isSimple: function isSimple() {
	      return this.$parent.simple;
	    },
	    isLast: function isLast() {
	      var parent = this.$parent;
	      return parent.steps[parent.steps.length - 1] === this;
	    },
	    stepsCount: function stepsCount() {
	      return this.$parent.steps.length;
	    },
	    space: function space() {
	      var isSimple = this.isSimple,
	          space = this.$parent.space;
	
	      return isSimple ? '' : space;
	    },
	
	    style: function style() {
	      var style = {};
	      var parent = this.$parent;
	      var len = parent.steps.length;
	
	      var space = typeof this.space === 'number' ? this.space + 'px' : this.space ? this.space : 100 / (len - (this.isCenter ? 0 : 1)) + '%';
	      style.flexBasis = space;
	      if (this.isVertical) return style;
	      if (this.isLast) {
	        style.maxWidth = 100 / this.stepsCount + '%';
	      } else {
	        style.marginRight = -this.$parent.stepOffset + 'px';
	      }
	
	      return style;
	    }
	  },
	
	  methods: {
	    updateStatus: function updateStatus(val) {
	      var prevChild = this.$parent.$children[this.index - 1];
	
	      if (val > this.index) {
	        this.internalStatus = this.$parent.finishStatus;
	      } else if (val === this.index && this.prevStatus !== 'error') {
	        this.internalStatus = this.$parent.processStatus;
	      } else {
	        this.internalStatus = 'wait';
	      }
	
	      if (prevChild) prevChild.calcProgress(this.internalStatus);
	    },
	    calcProgress: function calcProgress(status) {
	      var step = 100;
	      var style = {};
	
	      style.transitionDelay = 150 * this.index + 'ms';
	      if (status === this.$parent.processStatus) {
	        step = this.currentStatus !== 'error' ? 0 : 0;
	      } else if (status === 'wait') {
	        step = 0;
	        style.transitionDelay = -150 * this.index + 'ms';
	      }
	
	      style.borderWidth = step && !this.isSimple ? '1px' : 0;
	      this.$parent.direction === 'vertical' ? style.height = step + '%' : style.width = step + '%';
	
	      this.lineStyle = style;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var unwatch = this.$watch('index', function (val) {
	      _this.$watch('$parent.active', _this.updateStatus, { immediate: true });
	      _this.$watch('$parent.processStatus', function () {
	        var activeIndex = _this.$parent.active;
	        _this.updateStatus(activeIndex);
	      }, { immediate: true });
	      unwatch();
	    });
	  }
	});
	// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_stepvue_type_script_lang_js_ = (stepvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/steps/src/step.vue
	
	
	
	
	
	/* normalize component */
	
	var step_component = normalizeComponent(
	  src_stepvue_type_script_lang_js_,
	  stepvue_type_template_id_f414a87a_render,
	  stepvue_type_template_id_f414a87a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var step_api; }
	step_component.options.__file = "packages/steps/src/step.vue"
	/* harmony default export */ var step = (step_component.exports);
	// CONCATENATED MODULE: ./packages/step/index.js
	
	
	/* istanbul ignore next */
	step.install = function (Vue) {
	  Vue.component(step.name, step);
	};
	
	/* harmony default export */ var packages_step = (step);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
	var mainvue_type_template_id_5d5d1482_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: _vm.carouselClasses,
	      on: {
	        mouseenter: function($event) {
	          $event.stopPropagation()
	          return _vm.handleMouseEnter($event)
	        },
	        mouseleave: function($event) {
	          $event.stopPropagation()
	          return _vm.handleMouseLeave($event)
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          staticClass: "el-carousel__container",
	          style: { height: _vm.height }
	        },
	        [
	          _vm.arrowDisplay
	            ? _c("transition", { attrs: { name: "carousel-arrow-left" } }, [
	                _c(
	                  "button",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value:
	                          (_vm.arrow === "always" || _vm.hover) &&
	                          (_vm.loop || _vm.activeIndex > 0),
	                        expression:
	                          "(arrow === 'always' || hover) && (loop || activeIndex > 0)"
	                      }
	                    ],
	                    staticClass: "el-carousel__arrow el-carousel__arrow--left",
	                    attrs: { type: "button" },
	                    on: {
	                      mouseenter: function($event) {
	                        _vm.handleButtonEnter("left")
	                      },
	                      mouseleave: _vm.handleButtonLeave,
	                      click: function($event) {
	                        $event.stopPropagation()
	                        _vm.throttledArrowClick(_vm.activeIndex - 1)
	                      }
	                    }
	                  },
	                  [_c("i", { staticClass: "el-icon-arrow-left" })]
	                )
	              ])
	            : _vm._e(),
	          _vm.arrowDisplay
	            ? _c("transition", { attrs: { name: "carousel-arrow-right" } }, [
	                _c(
	                  "button",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value:
	                          (_vm.arrow === "always" || _vm.hover) &&
	                          (_vm.loop || _vm.activeIndex < _vm.items.length - 1),
	                        expression:
	                          "(arrow === 'always' || hover) && (loop || activeIndex < items.length - 1)"
	                      }
	                    ],
	                    staticClass: "el-carousel__arrow el-carousel__arrow--right",
	                    attrs: { type: "button" },
	                    on: {
	                      mouseenter: function($event) {
	                        _vm.handleButtonEnter("right")
	                      },
	                      mouseleave: _vm.handleButtonLeave,
	                      click: function($event) {
	                        $event.stopPropagation()
	                        _vm.throttledArrowClick(_vm.activeIndex + 1)
	                      }
	                    }
	                  },
	                  [_c("i", { staticClass: "el-icon-arrow-right" })]
	                )
	              ])
	            : _vm._e(),
	          _vm._t("default")
	        ],
	        2
	      ),
	      _vm.indicatorPosition !== "none"
	        ? _c(
	            "ul",
	            { class: _vm.indicatorsClasses },
	            _vm._l(_vm.items, function(item, index) {
	              return _c(
	                "li",
	                {
	                  key: index,
	                  class: [
	                    "el-carousel__indicator",
	                    "el-carousel__indicator--" + _vm.direction,
	                    { "is-active": index === _vm.activeIndex }
	                  ],
	                  on: {
	                    mouseenter: function($event) {
	                      _vm.throttledIndicatorHover(index)
	                    },
	                    click: function($event) {
	                      $event.stopPropagation()
	                      _vm.handleIndicatorClick(index)
	                    }
	                  }
	                },
	                [
	                  _c("button", { staticClass: "el-carousel__button" }, [
	                    _vm.hasLabel
	                      ? _c("span", [_vm._v(_vm._s(item.label))])
	                      : _vm._e()
	                  ])
	                ]
	              )
	            }),
	            0
	          )
	        : _vm._e()
	    ]
	  )
	}
	var mainvue_type_template_id_5d5d1482_staticRenderFns = []
	mainvue_type_template_id_5d5d1482_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
	
	// EXTERNAL MODULE: external "throttle-debounce/throttle"
	var throttle_ = __webpack_require__(25);
	var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var carousel_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElCarousel',
	
	  props: {
	    initialIndex: {
	      type: Number,
	      default: 0
	    },
	    height: String,
	    trigger: {
	      type: String,
	      default: 'hover'
	    },
	    autoplay: {
	      type: Boolean,
	      default: true
	    },
	    interval: {
	      type: Number,
	      default: 3000
	    },
	    indicatorPosition: String,
	    indicator: {
	      type: Boolean,
	      default: true
	    },
	    arrow: {
	      type: String,
	      default: 'hover'
	    },
	    type: String,
	    loop: {
	      type: Boolean,
	      default: true
	    },
	    direction: {
	      type: String,
	      default: 'horizontal',
	      validator: function validator(val) {
	        return ['horizontal', 'vertical'].indexOf(val) !== -1;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      items: [],
	      activeIndex: -1,
	      containerWidth: 0,
	      timer: null,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    arrowDisplay: function arrowDisplay() {
	      return this.arrow !== 'never' && this.direction !== 'vertical';
	    },
	    hasLabel: function hasLabel() {
	      return this.items.some(function (item) {
	        return item.label.toString().length > 0;
	      });
	    },
	    carouselClasses: function carouselClasses() {
	      var classes = ['el-carousel', 'el-carousel--' + this.direction];
	      if (this.type === 'card') {
	        classes.push('el-carousel--card');
	      }
	      return classes;
	    },
	    indicatorsClasses: function indicatorsClasses() {
	      var classes = ['el-carousel__indicators', 'el-carousel__indicators--' + this.direction];
	      if (this.hasLabel) {
	        classes.push('el-carousel__indicators--labels');
	      }
	      if (this.indicatorPosition === 'outside' || this.type === 'card') {
	        classes.push('el-carousel__indicators--outside');
	      }
	      return classes;
	    }
	  },
	
	  watch: {
	    items: function items(val) {
	      if (val.length > 0) this.setActiveItem(this.initialIndex);
	    },
	    activeIndex: function activeIndex(val, oldVal) {
	      this.resetItemPosition(oldVal);
	      if (oldVal > -1) {
	        this.$emit('change', val, oldVal);
	      }
	    },
	    autoplay: function autoplay(val) {
	      val ? this.startTimer() : this.pauseTimer();
	    },
	    loop: function loop() {
	      this.setActiveItem(this.activeIndex);
	    }
	  },
	
	  methods: {
	    handleMouseEnter: function handleMouseEnter() {
	      this.hover = true;
	      this.pauseTimer();
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      this.hover = false;
	      this.startTimer();
	    },
	    itemInStage: function itemInStage(item, index) {
	      var length = this.items.length;
	      if (index === length - 1 && item.inStage && this.items[0].active || item.inStage && this.items[index + 1] && this.items[index + 1].active) {
	        return 'left';
	      } else if (index === 0 && item.inStage && this.items[length - 1].active || item.inStage && this.items[index - 1] && this.items[index - 1].active) {
	        return 'right';
	      }
	      return false;
	    },
	    handleButtonEnter: function handleButtonEnter(arrow) {
	      var _this = this;
	
	      if (this.direction === 'vertical') return;
	      this.items.forEach(function (item, index) {
	        if (arrow === _this.itemInStage(item, index)) {
	          item.hover = true;
	        }
	      });
	    },
	    handleButtonLeave: function handleButtonLeave() {
	      if (this.direction === 'vertical') return;
	      this.items.forEach(function (item) {
	        item.hover = false;
	      });
	    },
	    updateItems: function updateItems() {
	      this.items = this.$children.filter(function (child) {
	        return child.$options.name === 'ElCarouselItem';
	      });
	    },
	    resetItemPosition: function resetItemPosition(oldIndex) {
	      var _this2 = this;
	
	      this.items.forEach(function (item, index) {
	        item.translateItem(index, _this2.activeIndex, oldIndex);
	      });
	    },
	    playSlides: function playSlides() {
	      if (this.activeIndex < this.items.length - 1) {
	        this.activeIndex++;
	      } else if (this.loop) {
	        this.activeIndex = 0;
	      }
	    },
	    pauseTimer: function pauseTimer() {
	      if (this.timer) {
	        clearInterval(this.timer);
	        this.timer = null;
	      }
	    },
	    startTimer: function startTimer() {
	      if (this.interval <= 0 || !this.autoplay || this.timer) return;
	      this.timer = setInterval(this.playSlides, this.interval);
	    },
	    setActiveItem: function setActiveItem(index) {
	      if (typeof index === 'string') {
	        var filteredItems = this.items.filter(function (item) {
	          return item.name === index;
	        });
	        if (filteredItems.length > 0) {
	          index = this.items.indexOf(filteredItems[0]);
	        }
	      }
	      index = Number(index);
	      if (isNaN(index) || index !== Math.floor(index)) {
	        console.warn('[Element Warn][Carousel]index must be an integer.');
	        return;
	      }
	      var length = this.items.length;
	      var oldIndex = this.activeIndex;
	      if (index < 0) {
	        this.activeIndex = this.loop ? length - 1 : 0;
	      } else if (index >= length) {
	        this.activeIndex = this.loop ? 0 : length - 1;
	      } else {
	        this.activeIndex = index;
	      }
	      if (oldIndex === this.activeIndex) {
	        this.resetItemPosition(oldIndex);
	      }
	    },
	    prev: function prev() {
	      this.setActiveItem(this.activeIndex - 1);
	    },
	    next: function next() {
	      this.setActiveItem(this.activeIndex + 1);
	    },
	    handleIndicatorClick: function handleIndicatorClick(index) {
	      this.activeIndex = index;
	    },
	    handleIndicatorHover: function handleIndicatorHover(index) {
	      if (this.trigger === 'hover' && index !== this.activeIndex) {
	        this.activeIndex = index;
	      }
	    }
	  },
	
	  created: function created() {
	    var _this3 = this;
	
	    this.throttledArrowClick = throttle_default()(300, true, function (index) {
	      _this3.setActiveItem(index);
	    });
	    this.throttledIndicatorHover = throttle_default()(300, function (index) {
	      _this3.handleIndicatorHover(index);
	    });
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.updateItems();
	    this.$nextTick(function () {
	      Object(resize_event_["addResizeListener"])(_this4.$el, _this4.resetItemPosition);
	      if (_this4.initialIndex < _this4.items.length && _this4.initialIndex >= 0) {
	        _this4.activeIndex = _this4.initialIndex;
	      }
	      _this4.startTimer();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el) Object(resize_event_["removeResizeListener"])(this.$el, this.resetItemPosition);
	    this.pauseTimer();
	  }
	});
	// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_carousel_src_mainvue_type_script_lang_js_ = (carousel_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/carousel/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var carousel_src_main_component = normalizeComponent(
	  packages_carousel_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5d5d1482_render,
	  mainvue_type_template_id_5d5d1482_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var carousel_src_main_api; }
	carousel_src_main_component.options.__file = "packages/carousel/src/main.vue"
	/* harmony default export */ var carousel_src_main = (carousel_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/carousel/index.js
	
	
	/* istanbul ignore next */
	carousel_src_main.install = function (Vue) {
	  Vue.component(carousel_src_main.name, carousel_src_main);
	};
	
	/* harmony default export */ var carousel = (carousel_src_main);
	// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
	var BAR_MAP = {
	  vertical: {
	    offset: 'offsetHeight',
	    scroll: 'scrollTop',
	    scrollSize: 'scrollHeight',
	    size: 'height',
	    key: 'vertical',
	    axis: 'Y',
	    client: 'clientY',
	    direction: 'top'
	  },
	  horizontal: {
	    offset: 'offsetWidth',
	    scroll: 'scrollLeft',
	    scrollSize: 'scrollWidth',
	    size: 'width',
	    key: 'horizontal',
	    axis: 'X',
	    client: 'clientX',
	    direction: 'left'
	  }
	};
	
	function renderThumbStyle(_ref) {
	  var move = _ref.move,
	      size = _ref.size,
	      bar = _ref.bar;
	
	  var style = {};
	  var translate = 'translate' + bar.axis + '(' + move + '%)';
	
	  style[bar.size] = size;
	  style.transform = translate;
	  style.msTransform = translate;
	  style.webkitTransform = translate;
	
	  return style;
	};
	// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var src_bar = ({
	  name: 'Bar',
	
	  props: {
	    vertical: Boolean,
	    size: String,
	    move: Number
	  },
	
	  computed: {
	    bar: function bar() {
	      return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
	    },
	    wrap: function wrap() {
	      return this.$parent.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var size = this.size,
	        move = this.move,
	        bar = this.bar;
	
	
	    return h(
	      'div',
	      {
	        'class': ['el-scrollbar__bar', 'is-' + bar.key],
	        on: {
	          'mousedown': this.clickTrackHandler
	        }
	      },
	      [h('div', {
	        ref: 'thumb',
	        'class': 'el-scrollbar__thumb',
	        on: {
	          'mousedown': this.clickThumbHandler
	        },
	
	        style: renderThumbStyle({ size: size, move: move, bar: bar }) })]
	    );
	  },
	
	
	  methods: {
	    clickThumbHandler: function clickThumbHandler(e) {
	      // prevent click event of right button
	      if (e.ctrlKey || e.button === 2) {
	        return;
	      }
	      this.startDrag(e);
	      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
	    },
	    clickTrackHandler: function clickTrackHandler(e) {
	      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
	      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
	      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    startDrag: function startDrag(e) {
	      e.stopImmediatePropagation();
	      this.cursorDown = true;
	
	      Object(dom_["on"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      Object(dom_["on"])(document, 'mouseup', this.mouseUpDocumentHandler);
	      document.onselectstart = function () {
	        return false;
	      };
	    },
	    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
	      if (this.cursorDown === false) return;
	      var prevPage = this[this.bar.axis];
	
	      if (!prevPage) return;
	
	      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
	      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
	      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
	      this.cursorDown = false;
	      this[this.bar.axis] = 0;
	      Object(dom_["off"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      document.onselectstart = null;
	    }
	  },
	
	  destroyed: function destroyed() {
	    Object(dom_["off"])(document, 'mouseup', this.mouseUpDocumentHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
	// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js
	
	
	
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var scrollbar_src_main = ({
	  name: 'ElScrollbar',
	
	  components: { Bar: src_bar },
	
	  props: {
	    native: Boolean,
	    wrapStyle: {},
	    wrapClass: {},
	    viewClass: {},
	    viewStyle: {},
	    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
	    tag: {
	      type: String,
	      default: 'div'
	    }
	  },
	
	  data: function data() {
	    return {
	      sizeWidth: '0',
	      sizeHeight: '0',
	      moveX: 0,
	      moveY: 0
	    };
	  },
	
	
	  computed: {
	    wrap: function wrap() {
	      return this.$refs.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var gutter = scrollbar_width_default()();
	    var style = this.wrapStyle;
	
	    if (gutter) {
	      var gutterWith = '-' + gutter + 'px';
	      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';
	
	      if (Array.isArray(this.wrapStyle)) {
	        style = Object(util_["toObject"])(this.wrapStyle);
	        style.marginRight = style.marginBottom = gutterWith;
	      } else if (typeof this.wrapStyle === 'string') {
	        style += gutterStyle;
	      } else {
	        style = gutterStyle;
	      }
	    }
	    var view = h(this.tag, {
	      class: ['el-scrollbar__view', this.viewClass],
	      style: this.viewStyle,
	      ref: 'resize'
	    }, this.$slots.default);
	    var wrap = h(
	      'div',
	      {
	        ref: 'wrap',
	        style: style,
	        on: {
	          'scroll': this.handleScroll
	        },
	
	        'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] },
	      [[view]]
	    );
	    var nodes = void 0;
	
	    if (!this.native) {
	      nodes = [wrap, h(src_bar, {
	        attrs: {
	          move: this.moveX,
	          size: this.sizeWidth }
	      }), h(src_bar, {
	        attrs: {
	          vertical: true,
	          move: this.moveY,
	          size: this.sizeHeight }
	      })];
	    } else {
	      nodes = [h(
	        'div',
	        {
	          ref: 'wrap',
	          'class': [this.wrapClass, 'el-scrollbar__wrap'],
	          style: style },
	        [[view]]
	      )];
	    }
	    return h('div', { class: 'el-scrollbar' }, nodes);
	  },
	
	
	  methods: {
	    handleScroll: function handleScroll() {
	      var wrap = this.wrap;
	
	      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
	      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
	    },
	    update: function update() {
	      var heightPercentage = void 0,
	          widthPercentage = void 0;
	      var wrap = this.wrap;
	      if (!wrap) return;
	
	      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
	      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
	
	      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
	      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.native) return;
	    this.$nextTick(this.update);
	    !this.noresize && Object(resize_event_["addResizeListener"])(this.$refs.resize, this.update);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.native) return;
	    !this.noresize && Object(resize_event_["removeResizeListener"])(this.$refs.resize, this.update);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/index.js
	
	
	/* istanbul ignore next */
	scrollbar_src_main.install = function (Vue) {
	  Vue.component(scrollbar_src_main.name, scrollbar_src_main);
	};
	
	/* harmony default export */ var scrollbar = (scrollbar_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
	var itemvue_type_template_id_1801ae19_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.ready,
	          expression: "ready"
	        }
	      ],
	      staticClass: "el-carousel__item",
	      class: {
	        "is-active": _vm.active,
	        "el-carousel__item--card": _vm.$parent.type === "card",
	        "is-in-stage": _vm.inStage,
	        "is-hover": _vm.hover,
	        "is-animating": _vm.animating
	      },
	      style: _vm.itemStyle,
	      on: { click: _vm.handleItemClick }
	    },
	    [
	      _vm.$parent.type === "card"
	        ? _c("div", {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: !_vm.active,
	                expression: "!active"
	              }
	            ],
	            staticClass: "el-carousel__mask"
	          })
	        : _vm._e(),
	      _vm._t("default")
	    ],
	    2
	  )
	}
	var itemvue_type_template_id_1801ae19_staticRenderFns = []
	itemvue_type_template_id_1801ae19_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	var CARD_SCALE = 0.83;
	/* harmony default export */ var itemvue_type_script_lang_js_ = ({
	  name: 'ElCarouselItem',
	
	  props: {
	    name: String,
	    label: {
	      type: [String, Number],
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      hover: false,
	      translate: 0,
	      scale: 1,
	      active: false,
	      ready: false,
	      inStage: false,
	      animating: false
	    };
	  },
	
	
	  methods: {
	    processIndex: function processIndex(index, activeIndex, length) {
	      if (activeIndex === 0 && index === length - 1) {
	        return -1;
	      } else if (activeIndex === length - 1 && index === 0) {
	        return length;
	      } else if (index < activeIndex - 1 && activeIndex - index >= length / 2) {
	        return length + 1;
	      } else if (index > activeIndex + 1 && index - activeIndex >= length / 2) {
	        return -2;
	      }
	      return index;
	    },
	    calcCardTranslate: function calcCardTranslate(index, activeIndex) {
	      var parentWidth = this.$parent.$el.offsetWidth;
	      if (this.inStage) {
	        return parentWidth * ((2 - CARD_SCALE) * (index - activeIndex) + 1) / 4;
	      } else if (index < activeIndex) {
	        return -(1 + CARD_SCALE) * parentWidth / 4;
	      } else {
	        return (3 + CARD_SCALE) * parentWidth / 4;
	      }
	    },
	    calcTranslate: function calcTranslate(index, activeIndex, isVertical) {
	      var distance = this.$parent.$el[isVertical ? 'offsetHeight' : 'offsetWidth'];
	      return distance * (index - activeIndex);
	    },
	    translateItem: function translateItem(index, activeIndex, oldIndex) {
	      var parentType = this.$parent.type;
	      var parentDirection = this.parentDirection;
	      var length = this.$parent.items.length;
	      if (parentType !== 'card' && oldIndex !== undefined) {
	        this.animating = index === activeIndex || index === oldIndex;
	      }
	      if (index !== activeIndex && length > 2 && this.$parent.loop) {
	        index = this.processIndex(index, activeIndex, length);
	      }
	      if (parentType === 'card') {
	        if (parentDirection === 'vertical') {
	          console.warn('[Element Warn][Carousel]vertical direction is not supported in card mode');
	        }
	        this.inStage = Math.round(Math.abs(index - activeIndex)) <= 1;
	        this.active = index === activeIndex;
	        this.translate = this.calcCardTranslate(index, activeIndex);
	        this.scale = this.active ? 1 : CARD_SCALE;
	      } else {
	        this.active = index === activeIndex;
	        var isVertical = parentDirection === 'vertical';
	        this.translate = this.calcTranslate(index, activeIndex, isVertical);
	      }
	      this.ready = true;
	    },
	    handleItemClick: function handleItemClick() {
	      var parent = this.$parent;
	      if (parent && parent.type === 'card') {
	        var index = parent.items.indexOf(this);
	        parent.setActiveItem(index);
	      }
	    }
	  },
	
	  computed: {
	    parentDirection: function parentDirection() {
	      return this.$parent.direction;
	    },
	    itemStyle: function itemStyle() {
	      var translateType = this.parentDirection === 'vertical' ? 'translateY' : 'translateX';
	      var value = translateType + '(' + this.translate + 'px) scale(' + this.scale + ')';
	      var style = {
	        transform: value
	      };
	      return Object(util_["autoprefixer"])(style);
	    }
	  },
	
	  created: function created() {
	    this.$parent && this.$parent.updateItems();
	  },
	  destroyed: function destroyed() {
	    this.$parent && this.$parent.updateItems();
	  }
	});
	// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_itemvue_type_script_lang_js_ = (itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/carousel/src/item.vue
	
	
	
	
	
	/* normalize component */
	
	var item_component = normalizeComponent(
	  src_itemvue_type_script_lang_js_,
	  itemvue_type_template_id_1801ae19_render,
	  itemvue_type_template_id_1801ae19_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var item_api; }
	item_component.options.__file = "packages/carousel/src/item.vue"
	/* harmony default export */ var src_item = (item_component.exports);
	// CONCATENATED MODULE: ./packages/carousel-item/index.js
	
	
	/* istanbul ignore next */
	src_item.install = function (Vue) {
	  Vue.component(src_item.name, src_item);
	};
	
	/* harmony default export */ var carousel_item = (src_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
	var collapsevue_type_template_id_461d57f4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-collapse",
	      attrs: { role: "tablist", "aria-multiselectable": "true" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var collapsevue_type_template_id_461d57f4_staticRenderFns = []
	collapsevue_type_template_id_461d57f4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var collapsevue_type_script_lang_js_ = ({
	  name: 'ElCollapse',
	
	  componentName: 'ElCollapse',
	
	  props: {
	    accordion: Boolean,
	    value: {
	      type: [Array, String, Number],
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      activeNames: [].concat(this.value)
	    };
	  },
	  provide: function provide() {
	    return {
	      collapse: this
	    };
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      this.activeNames = [].concat(_value);
	    }
	  },
	
	  methods: {
	    setActiveNames: function setActiveNames(activeNames) {
	      activeNames = [].concat(activeNames);
	      var value = this.accordion ? activeNames[0] : activeNames;
	      this.activeNames = activeNames;
	      this.$emit('input', value);
	      this.$emit('change', value);
	    },
	    handleItemClick: function handleItemClick(item) {
	      if (this.accordion) {
	        this.setActiveNames((this.activeNames[0] || this.activeNames[0] === 0) && this.activeNames[0] === item.name ? '' : item.name);
	      } else {
	        var activeNames = this.activeNames.slice(0);
	        var index = activeNames.indexOf(item.name);
	
	        if (index > -1) {
	          activeNames.splice(index, 1);
	        } else {
	          activeNames.push(item.name);
	        }
	        this.setActiveNames(activeNames);
	      }
	    }
	  },
	
	  created: function created() {
	    this.$on('item-click', this.handleItemClick);
	  }
	});
	// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_collapsevue_type_script_lang_js_ = (collapsevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue
	
	
	
	
	
	/* normalize component */
	
	var collapse_component = normalizeComponent(
	  src_collapsevue_type_script_lang_js_,
	  collapsevue_type_template_id_461d57f4_render,
	  collapsevue_type_template_id_461d57f4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var collapse_api; }
	collapse_component.options.__file = "packages/collapse/src/collapse.vue"
	/* harmony default export */ var collapse = (collapse_component.exports);
	// CONCATENATED MODULE: ./packages/collapse/index.js
	
	
	/* istanbul ignore next */
	collapse.install = function (Vue) {
	  Vue.component(collapse.name, collapse);
	};
	
	/* harmony default export */ var packages_collapse = (collapse);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
	var collapse_itemvue_type_template_id_2d05faac_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-collapse-item",
	      class: { "is-active": _vm.isActive, "is-disabled": _vm.disabled }
	    },
	    [
	      _c(
	        "div",
	        {
	          attrs: {
	            role: "tab",
	            "aria-expanded": _vm.isActive,
	            "aria-controls": "el-collapse-content-" + _vm.id,
	            "aria-describedby": "el-collapse-content-" + _vm.id
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-collapse-item__header",
	              class: {
	                focusing: _vm.focusing,
	                "is-active": _vm.isActive
	              },
	              attrs: {
	                role: "button",
	                id: "el-collapse-head-" + _vm.id,
	                tabindex: _vm.disabled ? undefined : 0
	              },
	              on: {
	                click: _vm.handleHeaderClick,
	                keyup: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "space", 32, $event.key, [
	                      " ",
	                      "Spacebar"
	                    ]) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  $event.stopPropagation()
	                  return _vm.handleEnterClick($event)
	                },
	                focus: _vm.handleFocus,
	                blur: function($event) {
	                  _vm.focusing = false
	                }
	              }
	            },
	            [
	              _vm._t("title", [_vm._v(_vm._s(_vm.title))]),
	              _c("i", {
	                staticClass: "el-collapse-item__arrow el-icon-arrow-right",
	                class: { "is-active": _vm.isActive }
	              })
	            ],
	            2
	          )
	        ]
	      ),
	      _c("el-collapse-transition", [
	        _c(
	          "div",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.isActive,
	                expression: "isActive"
	              }
	            ],
	            staticClass: "el-collapse-item__wrap",
	            attrs: {
	              role: "tabpanel",
	              "aria-hidden": !_vm.isActive,
	              "aria-labelledby": "el-collapse-head-" + _vm.id,
	              id: "el-collapse-content-" + _vm.id
	            }
	          },
	          [
	            _c(
	              "div",
	              { staticClass: "el-collapse-item__content" },
	              [_vm._t("default")],
	              2
	            )
	          ]
	        )
	      ])
	    ],
	    1
	  )
	}
	var collapse_itemvue_type_template_id_2d05faac_staticRenderFns = []
	collapse_itemvue_type_template_id_2d05faac_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var collapse_itemvue_type_script_lang_js_ = ({
	  name: 'ElCollapseItem',
	
	  componentName: 'ElCollapseItem',
	
	  mixins: [emitter_default.a],
	
	  components: { ElCollapseTransition: collapse_transition_default.a },
	
	  data: function data() {
	    return {
	      contentWrapStyle: {
	        height: 'auto',
	        display: 'block'
	      },
	      contentHeight: 0,
	      focusing: false,
	      isClick: false,
	      id: Object(util_["generateId"])()
	    };
	  },
	
	
	  inject: ['collapse'],
	
	  props: {
	    title: String,
	    name: {
	      type: [String, Number],
	      default: function _default() {
	        return this._uid;
	      }
	    },
	    disabled: Boolean
	  },
	
	  computed: {
	    isActive: function isActive() {
	      return this.collapse.activeNames.indexOf(this.name) > -1;
	    }
	  },
	
	  methods: {
	    handleFocus: function handleFocus() {
	      var _this = this;
	
	      setTimeout(function () {
	        if (!_this.isClick) {
	          _this.focusing = true;
	        } else {
	          _this.isClick = false;
	        }
	      }, 50);
	    },
	    handleHeaderClick: function handleHeaderClick() {
	      if (this.disabled) return;
	      this.dispatch('ElCollapse', 'item-click', this);
	      this.focusing = false;
	      this.isClick = true;
	    },
	    handleEnterClick: function handleEnterClick() {
	      this.dispatch('ElCollapse', 'item-click', this);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_collapse_itemvue_type_script_lang_js_ = (collapse_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue
	
	
	
	
	
	/* normalize component */
	
	var collapse_item_component = normalizeComponent(
	  src_collapse_itemvue_type_script_lang_js_,
	  collapse_itemvue_type_template_id_2d05faac_render,
	  collapse_itemvue_type_template_id_2d05faac_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var collapse_item_api; }
	collapse_item_component.options.__file = "packages/collapse/src/collapse-item.vue"
	/* harmony default export */ var collapse_item = (collapse_item_component.exports);
	// CONCATENATED MODULE: ./packages/collapse-item/index.js
	
	
	/* istanbul ignore next */
	collapse_item.install = function (Vue) {
	  Vue.component(collapse_item.name, collapse_item);
	};
	
	/* harmony default export */ var packages_collapse_item = (collapse_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
	var cascadervue_type_template_id_032537a6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: function() {
	            return _vm.toggleDropDownVisible(false)
	          },
	          expression: "() => toggleDropDownVisible(false)"
	        }
	      ],
	      ref: "reference",
	      class: [
	        "el-cascader",
	        _vm.realSize && "el-cascader--" + _vm.realSize,
	        { "is-disabled": _vm.isDisabled }
	      ],
	      on: {
	        mouseenter: function($event) {
	          _vm.inputHover = true
	        },
	        mouseleave: function($event) {
	          _vm.inputHover = false
	        },
	        click: function() {
	          return _vm.toggleDropDownVisible(_vm.readonly ? undefined : true)
	        },
	        keydown: _vm.handleKeyDown
	      }
	    },
	    [
	      _c(
	        "el-input",
	        {
	          ref: "input",
	          class: { "is-focus": _vm.dropDownVisible },
	          attrs: {
	            size: _vm.realSize,
	            placeholder: _vm.placeholder,
	            readonly: _vm.readonly,
	            disabled: _vm.isDisabled,
	            "validate-event": false
	          },
	          on: {
	            focus: _vm.handleFocus,
	            blur: _vm.handleBlur,
	            input: _vm.handleInput
	          },
	          model: {
	            value: _vm.multiple ? _vm.presentText : _vm.inputValue,
	            callback: function($$v) {
	              _vm.multiple ? _vm.presentText : (_vm.inputValue = $$v)
	            },
	            expression: "multiple ? presentText : inputValue"
	          }
	        },
	        [
	          _c("template", { slot: "suffix" }, [
	            _vm.clearBtnVisible
	              ? _c("i", {
	                  key: "clear",
	                  staticClass: "el-input__icon el-icon-circle-close",
	                  on: {
	                    click: function($event) {
	                      $event.stopPropagation()
	                      return _vm.handleClear($event)
	                    }
	                  }
	                })
	              : _c("i", {
	                  key: "arrow-down",
	                  class: [
	                    "el-input__icon",
	                    "el-icon-arrow-down",
	                    _vm.dropDownVisible && "is-reverse"
	                  ],
	                  on: {
	                    click: function($event) {
	                      $event.stopPropagation()
	                      _vm.toggleDropDownVisible()
	                    }
	                  }
	                })
	          ])
	        ],
	        2
	      ),
	      _vm.multiple
	        ? _c(
	            "div",
	            { staticClass: "el-cascader__tags" },
	            [
	              _vm._l(_vm.presentTags, function(tag, index) {
	                return _c(
	                  "el-tag",
	                  {
	                    key: tag.key,
	                    attrs: {
	                      type: "info",
	                      size: _vm.tagSize,
	                      hit: tag.hitState,
	                      closable: tag.closable,
	                      "disable-transitions": ""
	                    },
	                    on: {
	                      close: function($event) {
	                        _vm.deleteTag(index)
	                      }
	                    }
	                  },
	                  [_c("span", [_vm._v(_vm._s(tag.text))])]
	                )
	              }),
	              _vm.filterable && !_vm.isDisabled
	                ? _c("input", {
	                    directives: [
	                      {
	                        name: "model",
	                        rawName: "v-model.trim",
	                        value: _vm.inputValue,
	                        expression: "inputValue",
	                        modifiers: { trim: true }
	                      }
	                    ],
	                    staticClass: "el-cascader__search-input",
	                    attrs: {
	                      type: "text",
	                      placeholder: _vm.presentTags.length ? "" : _vm.placeholder
	                    },
	                    domProps: { value: _vm.inputValue },
	                    on: {
	                      input: [
	                        function($event) {
	                          if ($event.target.composing) {
	                            return
	                          }
	                          _vm.inputValue = $event.target.value.trim()
	                        },
	                        function(e) {
	                          return _vm.handleInput(_vm.inputValue, e)
	                        }
	                      ],
	                      click: function($event) {
	                        $event.stopPropagation()
	                        _vm.toggleDropDownVisible(true)
	                      },
	                      keydown: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "delete",
	                            [8, 46],
	                            $event.key,
	                            ["Backspace", "Delete", "Del"]
	                          )
	                        ) {
	                          return null
	                        }
	                        return _vm.handleDelete($event)
	                      },
	                      blur: function($event) {
	                        _vm.$forceUpdate()
	                      }
	                    }
	                  })
	                : _vm._e()
	            ],
	            2
	          )
	        : _vm._e(),
	      _c(
	        "transition",
	        {
	          attrs: { name: "el-zoom-in-top" },
	          on: { "after-leave": _vm.handleDropdownLeave }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.dropDownVisible,
	                  expression: "dropDownVisible"
	                }
	              ],
	              ref: "popper",
	              class: ["el-popper", "el-cascader__dropdown", _vm.popperClass]
	            },
	            [
	              _c("el-cascader-panel", {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: !_vm.filtering,
	                    expression: "!filtering"
	                  }
	                ],
	                ref: "panel",
	                attrs: {
	                  options: _vm.options,
	                  props: _vm.config,
	                  border: false,
	                  "render-label": _vm.$scopedSlots.default
	                },
	                on: {
	                  "expand-change": _vm.handleExpandChange,
	                  close: function($event) {
	                    _vm.toggleDropDownVisible(false)
	                  }
	                },
	                model: {
	                  value: _vm.checkedValue,
	                  callback: function($$v) {
	                    _vm.checkedValue = $$v
	                  },
	                  expression: "checkedValue"
	                }
	              }),
	              _vm.filterable
	                ? _c(
	                    "el-scrollbar",
	                    {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.filtering,
	                          expression: "filtering"
	                        }
	                      ],
	                      ref: "suggestionPanel",
	                      staticClass: "el-cascader__suggestion-panel",
	                      attrs: {
	                        tag: "ul",
	                        "view-class": "el-cascader__suggestion-list"
	                      },
	                      nativeOn: {
	                        keydown: function($event) {
	                          return _vm.handleSuggestionKeyDown($event)
	                        }
	                      }
	                    },
	                    [
	                      _vm.suggestions.length
	                        ? _vm._l(_vm.suggestions, function(item, index) {
	                            return _c(
	                              "li",
	                              {
	                                key: item.uid,
	                                class: [
	                                  "el-cascader__suggestion-item",
	                                  item.checked && "is-checked"
	                                ],
	                                attrs: { tabindex: -1 },
	                                on: {
	                                  click: function($event) {
	                                    _vm.handleSuggestionClick(index)
	                                  }
	                                }
	                              },
	                              [
	                                _c("span", [_vm._v(_vm._s(item.text))]),
	                                item.checked
	                                  ? _c("i", { staticClass: "el-icon-check" })
	                                  : _vm._e()
	                              ]
	                            )
	                          })
	                        : _vm._t("empty", [
	                            _c(
	                              "li",
	                              { staticClass: "el-cascader__empty-text" },
	                              [_vm._v(_vm._s(_vm.t("el.cascader.noMatch")))]
	                            )
	                          ])
	                    ],
	                    2
	                  )
	                : _vm._e()
	            ],
	            1
	          )
	        ]
	      )
	    ],
	    1
	  )
	}
	var cascadervue_type_template_id_032537a6_staticRenderFns = []
	cascadervue_type_template_id_032537a6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
	
	// EXTERNAL MODULE: external "element-ui/lib/cascader-panel"
	var cascader_panel_ = __webpack_require__(42);
	var cascader_panel_default = /*#__PURE__*/__webpack_require__.n(cascader_panel_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
	var aria_utils_ = __webpack_require__(28);
	var aria_utils_default = /*#__PURE__*/__webpack_require__.n(aria_utils_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var KeyCode = aria_utils_default.a.keys;
	
	var MigratingProps = {
	  expandTrigger: {
	    newProp: 'expandTrigger',
	    type: String
	  },
	  changeOnSelect: {
	    newProp: 'checkStrictly',
	    type: Boolean
	  },
	  hoverThreshold: {
	    newProp: 'hoverThreshold',
	    type: Number
	  }
	};
	
	var PopperMixin = {
	  props: {
	    placement: {
	      type: String,
	      default: 'bottom-start'
	    },
	    appendToBody: vue_popper_default.a.props.appendToBody,
	    visibleArrow: {
	      type: Boolean,
	      default: true
	    },
	    arrowOffset: vue_popper_default.a.props.arrowOffset,
	    offset: vue_popper_default.a.props.offset,
	    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
	    popperOptions: vue_popper_default.a.props.popperOptions
	  },
	  methods: vue_popper_default.a.methods,
	  data: vue_popper_default.a.data,
	  beforeDestroy: vue_popper_default.a.beforeDestroy
	};
	
	var InputSizeMap = {
	  medium: 36,
	  small: 32,
	  mini: 28
	};
	
	/* harmony default export */ var cascadervue_type_script_lang_js_ = ({
	  name: 'ElCascader',
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  mixins: [PopperMixin, emitter_default.a, locale_default.a, migrating_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElTag: tag_default.a,
	    ElScrollbar: scrollbar_default.a,
	    ElCascaderPanel: cascader_panel_default.a
	  },
	
	  props: {
	    value: {},
	    options: Array,
	    props: Object,
	    size: String,
	    placeholder: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.cascader.placeholder');
	      }
	    },
	    disabled: Boolean,
	    clearable: Boolean,
	    filterable: Boolean,
	    filterMethod: Function,
	    separator: {
	      type: String,
	      default: ' / '
	    },
	    showAllLevels: {
	      type: Boolean,
	      default: true
	    },
	    collapseTags: Boolean,
	    debounce: {
	      type: Number,
	      default: 300
	    },
	    beforeFilter: {
	      type: Function,
	      default: function _default() {
	        return function () {};
	      }
	    },
	    popperClass: String
	  },
	
	  data: function data() {
	    return {
	      dropDownVisible: false,
	      checkedValue: this.value || null,
	      inputHover: false,
	      inputValue: null,
	      presentText: null,
	      presentTags: [],
	      checkedNodes: [],
	      filtering: false,
	      suggestions: [],
	      inputInitialHeight: 0,
	      pressDeleteCount: 0
	    };
	  },
	
	
	  computed: {
	    realSize: function realSize() {
	      var _elFormItemSize = (this.elFormItem || {}).elFormItemSize;
	      return this.size || _elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    tagSize: function tagSize() {
	      return ['small', 'mini'].indexOf(this.realSize) > -1 ? 'mini' : 'small';
	    },
	    isDisabled: function isDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    config: function config() {
	      var config = this.props || {};
	      var $attrs = this.$attrs;
	
	
	      Object.keys(MigratingProps).forEach(function (oldProp) {
	        var _MigratingProps$oldPr = MigratingProps[oldProp],
	            newProp = _MigratingProps$oldPr.newProp,
	            type = _MigratingProps$oldPr.type;
	
	        var oldValue = $attrs[oldProp] || $attrs[Object(util_["kebabCase"])(oldProp)];
	        if (Object(shared_["isDef"])(oldProp) && !Object(shared_["isDef"])(config[newProp])) {
	          if (type === Boolean && oldValue === '') {
	            oldValue = true;
	          }
	          config[newProp] = oldValue;
	        }
	      });
	
	      return config;
	    },
	    multiple: function multiple() {
	      return this.config.multiple;
	    },
	    leafOnly: function leafOnly() {
	      return !this.config.checkStrictly;
	    },
	    readonly: function readonly() {
	      return !this.filterable || this.multiple;
	    },
	    clearBtnVisible: function clearBtnVisible() {
	      if (!this.clearable || this.isDisabled || this.filtering || !this.inputHover) {
	        return false;
	      }
	
	      return this.multiple ? !!this.checkedNodes.filter(function (node) {
	        return !node.isDisabled;
	      }).length : !!this.presentText;
	    },
	    panel: function panel() {
	      return this.$refs.panel;
	    }
	  },
	
	  watch: {
	    disabled: function disabled() {
	      this.computePresentContent();
	    },
	    value: function value(val) {
	      if (!Object(util_["isEqual"])(val, this.checkedValue)) {
	        this.checkedValue = val;
	        this.computePresentContent();
	      }
	    },
	    checkedValue: function checkedValue(val) {
	      var value = this.value,
	          dropDownVisible = this.dropDownVisible;
	      var _config = this.config,
	          checkStrictly = _config.checkStrictly,
	          multiple = _config.multiple;
	
	
	      if (!Object(util_["isEqual"])(val, value) || Object(types_["isUndefined"])(value)) {
	        this.computePresentContent();
	        // hide dropdown when single mode
	        if (!multiple && !checkStrictly && dropDownVisible) {
	          this.toggleDropDownVisible(false);
	        }
	
	        this.$emit('input', val);
	        this.$emit('change', val);
	        this.dispatch('ElFormItem', 'el.form.change', [val]);
	      }
	    },
	
	    options: {
	      handler: function handler() {
	        this.$nextTick(this.computePresentContent);
	      },
	      deep: true
	    },
	    presentText: function presentText(val) {
	      this.inputValue = val;
	    },
	    presentTags: function presentTags(val, oldVal) {
	      if (this.multiple && (val.length || oldVal.length)) {
	        this.$nextTick(this.updateStyle);
	      }
	    },
	    filtering: function filtering(val) {
	      this.$nextTick(this.updatePopper);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var input = this.$refs.input;
	
	    if (input && input.$el) {
	      this.inputInitialHeight = input.$el.offsetHeight || InputSizeMap[this.realSize] || 40;
	    }
	
	    if (!Object(util_["isEmpty"])(this.value)) {
	      this.computePresentContent();
	    }
	
	    this.filterHandler = debounce_default()(this.debounce, function () {
	      var inputValue = _this.inputValue;
	
	
	      if (!inputValue) {
	        _this.filtering = false;
	        return;
	      }
	
	      var before = _this.beforeFilter(inputValue);
	      if (before && before.then) {
	        before.then(_this.getSuggestions);
	      } else if (before !== false) {
	        _this.getSuggestions();
	      } else {
	        _this.filtering = false;
	      }
	    });
	
	    Object(resize_event_["addResizeListener"])(this.$el, this.updateStyle);
	  },
	  beforeDestroy: function beforeDestroy() {
	    Object(resize_event_["removeResizeListener"])(this.$el, this.updateStyle);
	  },
	
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'expand-trigger': 'expand-trigger is removed, use `props.expandTrigger` instead.',
	          'change-on-select': 'change-on-select is removed, use `props.checkStrictly` instead.',
	          'hover-threshold': 'hover-threshold is removed, use `props.hoverThreshold` instead'
	        },
	        events: {
	          'active-item-change': 'active-item-change is renamed to expand-change'
	        }
	      };
	    },
	    toggleDropDownVisible: function toggleDropDownVisible(visible) {
	      var _this2 = this;
	
	      if (this.isDisabled) return;
	
	      var dropDownVisible = this.dropDownVisible;
	      var input = this.$refs.input;
	
	      visible = Object(shared_["isDef"])(visible) ? visible : !dropDownVisible;
	      if (visible !== dropDownVisible) {
	        this.dropDownVisible = visible;
	        if (visible) {
	          this.$nextTick(function () {
	            _this2.updatePopper();
	            _this2.panel.scrollIntoView();
	          });
	        }
	        input.$refs.input.setAttribute('aria-expanded', visible);
	        this.$emit('visible-change', visible);
	      }
	    },
	    handleDropdownLeave: function handleDropdownLeave() {
	      this.filtering = false;
	      this.inputValue = this.presentText;
	    },
	    handleKeyDown: function handleKeyDown(event) {
	      switch (event.keyCode) {
	        case KeyCode.enter:
	          this.toggleDropDownVisible();
	          break;
	        case KeyCode.down:
	          this.toggleDropDownVisible(true);
	          this.focusFirstNode();
	          event.preventDefault();
	          break;
	        case KeyCode.esc:
	        case KeyCode.tab:
	          this.toggleDropDownVisible(false);
	          break;
	      }
	    },
	    handleFocus: function handleFocus(e) {
	      this.$emit('focus', e);
	    },
	    handleBlur: function handleBlur(e) {
	      this.$emit('blur', e);
	    },
	    handleInput: function handleInput(val, event) {
	      !this.dropDownVisible && this.toggleDropDownVisible(true);
	
	      if (event && event.isComposing) return;
	      if (val) {
	        this.filterHandler();
	      } else {
	        this.filtering = false;
	      }
	    },
	    handleClear: function handleClear() {
	      this.presentText = '';
	      this.panel.clearCheckedNodes();
	    },
	    handleExpandChange: function handleExpandChange(value) {
	      this.$nextTick(this.updatePopper.bind(this));
	      this.$emit('expand-change', value);
	      this.$emit('active-item-change', value); // Deprecated
	    },
	    focusFirstNode: function focusFirstNode() {
	      var _this3 = this;
	
	      this.$nextTick(function () {
	        var filtering = _this3.filtering;
	        var _$refs = _this3.$refs,
	            popper = _$refs.popper,
	            suggestionPanel = _$refs.suggestionPanel;
	
	        var firstNode = null;
	
	        if (filtering && suggestionPanel) {
	          firstNode = suggestionPanel.$el.querySelector('.el-cascader__suggestion-item');
	        } else {
	          var firstMenu = popper.querySelector('.el-cascader-menu');
	          firstNode = firstMenu.querySelector('.el-cascader-node[tabindex="-1"]');
	        }
	
	        if (firstNode) {
	          firstNode.focus();
	          !filtering && firstNode.click();
	        }
	      });
	    },
	    computePresentContent: function computePresentContent() {
	      var _this4 = this;
	
	      // nextTick is required, because checked nodes may not change right now
	      this.$nextTick(function () {
	        if (_this4.config.multiple) {
	          _this4.computePresentTags();
	          _this4.presentText = _this4.presentTags.length ? ' ' : null;
	        } else {
	          _this4.computePresentText();
	        }
	      });
	    },
	    computePresentText: function computePresentText() {
	      var checkedValue = this.checkedValue,
	          config = this.config;
	
	      if (!Object(util_["isEmpty"])(checkedValue)) {
	        var node = this.panel.getNodeByValue(checkedValue);
	        if (node && (config.checkStrictly || node.isLeaf)) {
	          this.presentText = node.getText(this.showAllLevels, this.separator);
	          return;
	        }
	      }
	      this.presentText = null;
	    },
	    computePresentTags: function computePresentTags() {
	      var isDisabled = this.isDisabled,
	          leafOnly = this.leafOnly,
	          showAllLevels = this.showAllLevels,
	          separator = this.separator,
	          collapseTags = this.collapseTags;
	
	      var checkedNodes = this.getCheckedNodes(leafOnly);
	      var tags = [];
	
	      var genTag = function genTag(node) {
	        return {
	          node: node,
	          key: node.uid,
	          text: node.getText(showAllLevels, separator),
	          hitState: false,
	          closable: !isDisabled && !node.isDisabled
	        };
	      };
	
	      if (checkedNodes.length) {
	        var first = checkedNodes[0],
	            rest = checkedNodes.slice(1);
	
	        var restCount = rest.length;
	        tags.push(genTag(first));
	
	        if (restCount) {
	          if (collapseTags) {
	            tags.push({
	              key: -1,
	              text: '+ ' + restCount,
	              closable: false
	            });
	          } else {
	            rest.forEach(function (node) {
	              return tags.push(genTag(node));
	            });
	          }
	        }
	      }
	
	      this.checkedNodes = checkedNodes;
	      this.presentTags = tags;
	    },
	    getSuggestions: function getSuggestions() {
	      var _this5 = this;
	
	      var filterMethod = this.filterMethod;
	
	
	      if (!Object(types_["isFunction"])(filterMethod)) {
	        filterMethod = function filterMethod(node, keyword) {
	          return node.text.includes(keyword);
	        };
	      }
	
	      var suggestions = this.panel.getFlattedNodes(this.leafOnly).filter(function (node) {
	        if (node.isDisabled) return false;
	        node.text = node.getText(_this5.showAllLevels, _this5.separator) || '';
	        return filterMethod(node, _this5.inputValue);
	      });
	
	      if (this.multiple) {
	        this.presentTags.forEach(function (tag) {
	          tag.hitState = false;
	        });
	      } else {
	        suggestions.forEach(function (node) {
	          node.checked = Object(util_["isEqual"])(_this5.checkedValue, node.getValueByOption());
	        });
	      }
	
	      this.filtering = true;
	      this.suggestions = suggestions;
	      this.$nextTick(this.updatePopper);
	    },
	    handleSuggestionKeyDown: function handleSuggestionKeyDown(event) {
	      var keyCode = event.keyCode,
	          target = event.target;
	
	      switch (keyCode) {
	        case KeyCode.enter:
	          target.click();
	          break;
	        case KeyCode.up:
	          var prev = target.previousElementSibling;
	          prev && prev.focus();
	          break;
	        case KeyCode.down:
	          var next = target.nextElementSibling;
	          next && next.focus();
	          break;
	        case KeyCode.esc:
	        case KeyCode.tab:
	          this.toggleDropDownVisible(false);
	          break;
	      }
	    },
	    handleDelete: function handleDelete() {
	      var inputValue = this.inputValue,
	          pressDeleteCount = this.pressDeleteCount,
	          presentTags = this.presentTags;
	
	      var lastIndex = presentTags.length - 1;
	      var lastTag = presentTags[lastIndex];
	      this.pressDeleteCount = inputValue ? 0 : pressDeleteCount + 1;
	
	      if (!lastTag) return;
	
	      if (this.pressDeleteCount) {
	        if (lastTag.hitState) {
	          this.deleteTag(lastIndex);
	        } else {
	          lastTag.hitState = true;
	        }
	      }
	    },
	    handleSuggestionClick: function handleSuggestionClick(index) {
	      var multiple = this.multiple;
	
	      var targetNode = this.suggestions[index];
	
	      if (multiple) {
	        var checked = targetNode.checked;
	
	        targetNode.doCheck(!checked);
	        this.panel.calculateMultiCheckedValue();
	      } else {
	        this.checkedValue = targetNode.getValueByOption();
	        this.toggleDropDownVisible(false);
	      }
	    },
	    deleteTag: function deleteTag(index) {
	      var checkedValue = this.checkedValue;
	
	      var val = checkedValue[index];
	      this.checkedValue = checkedValue.filter(function (n, i) {
	        return i !== index;
	      });
	      this.$emit('remove-tag', val);
	    },
	    updateStyle: function updateStyle() {
	      var $el = this.$el,
	          inputInitialHeight = this.inputInitialHeight;
	
	      if (this.$isServer || !$el) return;
	
	      var suggestionPanel = this.$refs.suggestionPanel;
	
	      var inputInner = $el.querySelector('.el-input__inner');
	
	      if (!inputInner) return;
	
	      var tags = $el.querySelector('.el-cascader__tags');
	      var suggestionPanelEl = null;
	
	      if (suggestionPanel && (suggestionPanelEl = suggestionPanel.$el)) {
	        var suggestionList = suggestionPanelEl.querySelector('.el-cascader__suggestion-list');
	        suggestionList.style.minWidth = inputInner.offsetWidth + 'px';
	      }
	
	      if (tags) {
	        var offsetHeight = tags.offsetHeight;
	
	        var height = Math.max(offsetHeight + 6, inputInitialHeight) + 'px';
	        inputInner.style.height = height;
	        this.updatePopper();
	      }
	    },
	
	
	    /**
	     * public methods
	    */
	    getCheckedNodes: function getCheckedNodes(leafOnly) {
	      return this.panel.getCheckedNodes(leafOnly);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascadervue_type_script_lang_js_ = (cascadervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue
	
	
	
	
	
	/* normalize component */
	
	var cascader_component = normalizeComponent(
	  src_cascadervue_type_script_lang_js_,
	  cascadervue_type_template_id_032537a6_render,
	  cascadervue_type_template_id_032537a6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_api; }
	cascader_component.options.__file = "packages/cascader/src/cascader.vue"
	/* harmony default export */ var cascader = (cascader_component.exports);
	// CONCATENATED MODULE: ./packages/cascader/index.js
	
	
	/* istanbul ignore next */
	cascader.install = function (Vue) {
	  Vue.component(cascader.name, cascader);
	};
	
	/* harmony default export */ var packages_cascader = (cascader);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
	var mainvue_type_template_id_55c8ade7_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.hide,
	          expression: "hide"
	        }
	      ],
	      class: [
	        "el-color-picker",
	        _vm.colorDisabled ? "is-disabled" : "",
	        _vm.colorSize ? "el-color-picker--" + _vm.colorSize : ""
	      ]
	    },
	    [
	      _vm.colorDisabled
	        ? _c("div", { staticClass: "el-color-picker__mask" })
	        : _vm._e(),
	      _c(
	        "div",
	        {
	          staticClass: "el-color-picker__trigger",
	          on: { click: _vm.handleTrigger }
	        },
	        [
	          _c(
	            "span",
	            {
	              staticClass: "el-color-picker__color",
	              class: { "is-alpha": _vm.showAlpha }
	            },
	            [
	              _c("span", {
	                staticClass: "el-color-picker__color-inner",
	                style: {
	                  backgroundColor: _vm.displayedColor
	                }
	              }),
	              !_vm.value && !_vm.showPanelColor
	                ? _c("span", {
	                    staticClass: "el-color-picker__empty el-icon-close"
	                  })
	                : _vm._e()
	            ]
	          ),
	          _c("span", {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.value || _vm.showPanelColor,
	                expression: "value || showPanelColor"
	              }
	            ],
	            staticClass: "el-color-picker__icon el-icon-arrow-down"
	          })
	        ]
	      ),
	      _c("picker-dropdown", {
	        ref: "dropdown",
	        class: ["el-color-picker__panel", _vm.popperClass || ""],
	        attrs: {
	          color: _vm.color,
	          "show-alpha": _vm.showAlpha,
	          predefine: _vm.predefine
	        },
	        on: { pick: _vm.confirmValue, clear: _vm.clearValue },
	        model: {
	          value: _vm.showPicker,
	          callback: function($$v) {
	            _vm.showPicker = $$v
	          },
	          expression: "showPicker"
	        }
	      })
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_55c8ade7_staticRenderFns = []
	mainvue_type_template_id_55c8ade7_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
	
	// CONCATENATED MODULE: ./packages/color-picker/src/color.js
	var color_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function color_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var hsv2hsl = function hsv2hsl(hue, sat, val) {
	  return [hue, sat * val / ((hue = (2 - sat) * val) < 1 ? hue : 2 - hue) || 0, hue / 2];
	};
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	var isOnePointZero = function isOnePointZero(n) {
	  return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
	};
	
	var isPercentage = function isPercentage(n) {
	  return typeof n === 'string' && n.indexOf('%') !== -1;
	};
	
	// Take input from [0, n] and return it as [0, 1]
	var bound01 = function bound01(value, max) {
	  if (isOnePointZero(value)) value = '100%';
	
	  var processPercent = isPercentage(value);
	  value = Math.min(max, Math.max(0, parseFloat(value)));
	
	  // Automatically convert percentage into number
	  if (processPercent) {
	    value = parseInt(value * max, 10) / 100;
	  }
	
	  // Handle floating point rounding errors
	  if (Math.abs(value - max) < 0.000001) {
	    return 1;
	  }
	
	  // Convert into [0, 1] range if it isn't already
	  return value % max / parseFloat(max);
	};
	
	var INT_HEX_MAP = { 10: 'A', 11: 'B', 12: 'C', 13: 'D', 14: 'E', 15: 'F' };
	
	var toHex = function toHex(_ref) {
	  var r = _ref.r,
	      g = _ref.g,
	      b = _ref.b;
	
	  var hexOne = function hexOne(value) {
	    value = Math.min(Math.round(value), 255);
	    var high = Math.floor(value / 16);
	    var low = value % 16;
	    return '' + (INT_HEX_MAP[high] || high) + (INT_HEX_MAP[low] || low);
	  };
	
	  if (isNaN(r) || isNaN(g) || isNaN(b)) return '';
	
	  return '#' + hexOne(r) + hexOne(g) + hexOne(b);
	};
	
	var HEX_INT_MAP = { A: 10, B: 11, C: 12, D: 13, E: 14, F: 15 };
	
	var parseHexChannel = function parseHexChannel(hex) {
	  if (hex.length === 2) {
	    return (HEX_INT_MAP[hex[0].toUpperCase()] || +hex[0]) * 16 + (HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1]);
	  }
	
	  return HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1];
	};
	
	var hsl2hsv = function hsl2hsv(hue, sat, light) {
	  sat = sat / 100;
	  light = light / 100;
	  var smin = sat;
	  var lmin = Math.max(light, 0.01);
	  var sv = void 0;
	  var v = void 0;
	
	  light *= 2;
	  sat *= light <= 1 ? light : 2 - light;
	  smin *= lmin <= 1 ? lmin : 2 - lmin;
	  v = (light + sat) / 2;
	  sv = light === 0 ? 2 * smin / (lmin + smin) : 2 * sat / (light + sat);
	
	  return {
	    h: hue,
	    s: sv * 100,
	    v: v * 100
	  };
	};
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	var rgb2hsv = function rgb2hsv(r, g, b) {
	  r = bound01(r, 255);
	  g = bound01(g, 255);
	  b = bound01(b, 255);
	
	  var max = Math.max(r, g, b);
	  var min = Math.min(r, g, b);
	  var h = void 0,
	      s = void 0;
	  var v = max;
	
	  var d = max - min;
	  s = max === 0 ? 0 : d / max;
	
	  if (max === min) {
	    h = 0; // achromatic
	  } else {
	    switch (max) {
	      case r:
	        h = (g - b) / d + (g < b ? 6 : 0);
	        break;
	      case g:
	        h = (b - r) / d + 2;
	        break;
	      case b:
	        h = (r - g) / d + 4;
	        break;
	    }
	    h /= 6;
	  }
	
	  return { h: h * 360, s: s * 100, v: v * 100 };
	};
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	var hsv2rgb = function hsv2rgb(h, s, v) {
	  h = bound01(h, 360) * 6;
	  s = bound01(s, 100);
	  v = bound01(v, 100);
	
	  var i = Math.floor(h);
	  var f = h - i;
	  var p = v * (1 - s);
	  var q = v * (1 - f * s);
	  var t = v * (1 - (1 - f) * s);
	  var mod = i % 6;
	  var r = [v, q, p, p, t, v][mod];
	  var g = [t, v, v, q, p, p][mod];
	  var b = [p, p, t, v, v, q][mod];
	
	  return {
	    r: Math.round(r * 255),
	    g: Math.round(g * 255),
	    b: Math.round(b * 255)
	  };
	};
	
	var Color = function () {
	  function Color(options) {
	    color_classCallCheck(this, Color);
	
	    this._hue = 0;
	    this._saturation = 100;
	    this._value = 100;
	    this._alpha = 100;
	
	    this.enableAlpha = false;
	    this.format = 'hex';
	    this.value = '';
	
	    options = options || {};
	
	    for (var option in options) {
	      if (options.hasOwnProperty(option)) {
	        this[option] = options[option];
	      }
	    }
	
	    this.doOnChange();
	  }
	
	  Color.prototype.set = function set(prop, value) {
	    if (arguments.length === 1 && (typeof prop === 'undefined' ? 'undefined' : color_typeof(prop)) === 'object') {
	      for (var p in prop) {
	        if (prop.hasOwnProperty(p)) {
	          this.set(p, prop[p]);
	        }
	      }
	
	      return;
	    }
	
	    this['_' + prop] = value;
	    this.doOnChange();
	  };
	
	  Color.prototype.get = function get(prop) {
	    return this['_' + prop];
	  };
	
	  Color.prototype.toRgb = function toRgb() {
	    return hsv2rgb(this._hue, this._saturation, this._value);
	  };
	
	  Color.prototype.fromString = function fromString(value) {
	    var _this = this;
	
	    if (!value) {
	      this._hue = 0;
	      this._saturation = 100;
	      this._value = 100;
	
	      this.doOnChange();
	      return;
	    }
	
	    var fromHSV = function fromHSV(h, s, v) {
	      _this._hue = Math.max(0, Math.min(360, h));
	      _this._saturation = Math.max(0, Math.min(100, s));
	      _this._value = Math.max(0, Math.min(100, v));
	
	      _this.doOnChange();
	    };
	
	    if (value.indexOf('hsl') !== -1) {
	      var parts = value.replace(/hsla|hsl|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
	        return val !== '';
	      }).map(function (val, index) {
	        return index > 2 ? parseFloat(val) : parseInt(val, 10);
	      });
	
	      if (parts.length === 4) {
	        this._alpha = Math.floor(parseFloat(parts[3]) * 100);
	      } else if (parts.length === 3) {
	        this._alpha = 100;
	      }
	      if (parts.length >= 3) {
	        var _hsl2hsv = hsl2hsv(parts[0], parts[1], parts[2]),
	            h = _hsl2hsv.h,
	            s = _hsl2hsv.s,
	            v = _hsl2hsv.v;
	
	        fromHSV(h, s, v);
	      }
	    } else if (value.indexOf('hsv') !== -1) {
	      var _parts = value.replace(/hsva|hsv|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
	        return val !== '';
	      }).map(function (val, index) {
	        return index > 2 ? parseFloat(val) : parseInt(val, 10);
	      });
	
	      if (_parts.length === 4) {
	        this._alpha = Math.floor(parseFloat(_parts[3]) * 100);
	      } else if (_parts.length === 3) {
	        this._alpha = 100;
	      }
	      if (_parts.length >= 3) {
	        fromHSV(_parts[0], _parts[1], _parts[2]);
	      }
	    } else if (value.indexOf('rgb') !== -1) {
	      var _parts2 = value.replace(/rgba|rgb|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
	        return val !== '';
	      }).map(function (val, index) {
	        return index > 2 ? parseFloat(val) : parseInt(val, 10);
	      });
	
	      if (_parts2.length === 4) {
	        this._alpha = Math.floor(parseFloat(_parts2[3]) * 100);
	      } else if (_parts2.length === 3) {
	        this._alpha = 100;
	      }
	      if (_parts2.length >= 3) {
	        var _rgb2hsv = rgb2hsv(_parts2[0], _parts2[1], _parts2[2]),
	            _h = _rgb2hsv.h,
	            _s = _rgb2hsv.s,
	            _v = _rgb2hsv.v;
	
	        fromHSV(_h, _s, _v);
	      }
	    } else if (value.indexOf('#') !== -1) {
	      var hex = value.replace('#', '').trim();
	      if (!/^(?:[0-9a-fA-F]{3}){1,2}$/.test(hex)) return;
	      var r = void 0,
	          g = void 0,
	          b = void 0;
	
	      if (hex.length === 3) {
	        r = parseHexChannel(hex[0] + hex[0]);
	        g = parseHexChannel(hex[1] + hex[1]);
	        b = parseHexChannel(hex[2] + hex[2]);
	      } else if (hex.length === 6 || hex.length === 8) {
	        r = parseHexChannel(hex.substring(0, 2));
	        g = parseHexChannel(hex.substring(2, 4));
	        b = parseHexChannel(hex.substring(4, 6));
	      }
	
	      if (hex.length === 8) {
	        this._alpha = Math.floor(parseHexChannel(hex.substring(6)) / 255 * 100);
	      } else if (hex.length === 3 || hex.length === 6) {
	        this._alpha = 100;
	      }
	
	      var _rgb2hsv2 = rgb2hsv(r, g, b),
	          _h2 = _rgb2hsv2.h,
	          _s2 = _rgb2hsv2.s,
	          _v2 = _rgb2hsv2.v;
	
	      fromHSV(_h2, _s2, _v2);
	    }
	  };
	
	  Color.prototype.compare = function compare(color) {
	    return Math.abs(color._hue - this._hue) < 2 && Math.abs(color._saturation - this._saturation) < 1 && Math.abs(color._value - this._value) < 1 && Math.abs(color._alpha - this._alpha) < 1;
	  };
	
	  Color.prototype.doOnChange = function doOnChange() {
	    var _hue = this._hue,
	        _saturation = this._saturation,
	        _value = this._value,
	        _alpha = this._alpha,
	        format = this.format;
	
	
	    if (this.enableAlpha) {
	      switch (format) {
	        case 'hsl':
	          var hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
	          this.value = 'hsla(' + _hue + ', ' + Math.round(hsl[1] * 100) + '%, ' + Math.round(hsl[2] * 100) + '%, ' + _alpha / 100 + ')';
	          break;
	        case 'hsv':
	          this.value = 'hsva(' + _hue + ', ' + Math.round(_saturation) + '%, ' + Math.round(_value) + '%, ' + _alpha / 100 + ')';
	          break;
	        default:
	          var _hsv2rgb = hsv2rgb(_hue, _saturation, _value),
	              r = _hsv2rgb.r,
	              g = _hsv2rgb.g,
	              b = _hsv2rgb.b;
	
	          this.value = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + _alpha / 100 + ')';
	      }
	    } else {
	      switch (format) {
	        case 'hsl':
	          var _hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
	          this.value = 'hsl(' + _hue + ', ' + Math.round(_hsl[1] * 100) + '%, ' + Math.round(_hsl[2] * 100) + '%)';
	          break;
	        case 'hsv':
	          this.value = 'hsv(' + _hue + ', ' + Math.round(_saturation) + '%, ' + Math.round(_value) + '%)';
	          break;
	        case 'rgb':
	          var _hsv2rgb2 = hsv2rgb(_hue, _saturation, _value),
	              _r = _hsv2rgb2.r,
	              _g = _hsv2rgb2.g,
	              _b = _hsv2rgb2.b;
	
	          this.value = 'rgb(' + _r + ', ' + _g + ', ' + _b + ')';
	          break;
	        default:
	          this.value = toHex(hsv2rgb(_hue, _saturation, _value));
	      }
	    }
	  };
	
	  return Color;
	}();
	
	/* harmony default export */ var src_color = (Color);
	;
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
	var picker_dropdownvue_type_template_id_06601625_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.showPopper,
	              expression: "showPopper"
	            }
	          ],
	          staticClass: "el-color-dropdown"
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-color-dropdown__main-wrapper" },
	            [
	              _c("hue-slider", {
	                ref: "hue",
	                staticStyle: { float: "right" },
	                attrs: { color: _vm.color, vertical: "" }
	              }),
	              _c("sv-panel", { ref: "sl", attrs: { color: _vm.color } })
	            ],
	            1
	          ),
	          _vm.showAlpha
	            ? _c("alpha-slider", { ref: "alpha", attrs: { color: _vm.color } })
	            : _vm._e(),
	          _vm.predefine
	            ? _c("predefine", {
	                attrs: { color: _vm.color, colors: _vm.predefine }
	              })
	            : _vm._e(),
	          _c(
	            "div",
	            { staticClass: "el-color-dropdown__btns" },
	            [
	              _c(
	                "span",
	                { staticClass: "el-color-dropdown__value" },
	                [
	                  _c("el-input", {
	                    attrs: { "validate-event": false, size: "mini" },
	                    on: { blur: _vm.handleConfirm },
	                    nativeOn: {
	                      keyup: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "enter",
	                            13,
	                            $event.key,
	                            "Enter"
	                          )
	                        ) {
	                          return null
	                        }
	                        return _vm.handleConfirm($event)
	                      }
	                    },
	                    model: {
	                      value: _vm.customInput,
	                      callback: function($$v) {
	                        _vm.customInput = $$v
	                      },
	                      expression: "customInput"
	                    }
	                  })
	                ],
	                1
	              ),
	              _c(
	                "el-button",
	                {
	                  staticClass: "el-color-dropdown__link-btn",
	                  attrs: { size: "mini", type: "text" },
	                  on: {
	                    click: function($event) {
	                      _vm.$emit("clear")
	                    }
	                  }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.colorpicker.clear")) +
	                      "\n      "
	                  )
	                ]
	              ),
	              _c(
	                "el-button",
	                {
	                  staticClass: "el-color-dropdown__btn",
	                  attrs: { plain: "", size: "mini" },
	                  on: { click: _vm.confirmValue }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.colorpicker.confirm")) +
	                      "\n      "
	                  )
	                ]
	              )
	            ],
	            1
	          )
	        ],
	        1
	      )
	    ]
	  )
	}
	var picker_dropdownvue_type_template_id_06601625_staticRenderFns = []
	picker_dropdownvue_type_template_id_06601625_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
	var sv_panelvue_type_template_id_d8583596_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-color-svpanel",
	      style: {
	        backgroundColor: _vm.background
	      }
	    },
	    [
	      _c("div", { staticClass: "el-color-svpanel__white" }),
	      _c("div", { staticClass: "el-color-svpanel__black" }),
	      _c(
	        "div",
	        {
	          staticClass: "el-color-svpanel__cursor",
	          style: {
	            top: _vm.cursorTop + "px",
	            left: _vm.cursorLeft + "px"
	          }
	        },
	        [_c("div")]
	      )
	    ]
	  )
	}
	var sv_panelvue_type_template_id_d8583596_staticRenderFns = []
	sv_panelvue_type_template_id_d8583596_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
	
	// CONCATENATED MODULE: ./packages/color-picker/src/draggable.js
	
	var isDragging = false;
	
	/* harmony default export */ var draggable = (function (element, options) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  var moveFn = function moveFn(event) {
	    if (options.drag) {
	      options.drag(event);
	    }
	  };
	  var upFn = function upFn(event) {
	    document.removeEventListener('mousemove', moveFn);
	    document.removeEventListener('mouseup', upFn);
	    document.onselectstart = null;
	    document.ondragstart = null;
	
	    isDragging = false;
	
	    if (options.end) {
	      options.end(event);
	    }
	  };
	  element.addEventListener('mousedown', function (event) {
	    if (isDragging) return;
	    document.onselectstart = function () {
	      return false;
	    };
	    document.ondragstart = function () {
	      return false;
	    };
	
	    document.addEventListener('mousemove', moveFn);
	    document.addEventListener('mouseup', upFn);
	    isDragging = true;
	
	    if (options.start) {
	      options.start(event);
	    }
	  });
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var sv_panelvue_type_script_lang_js_ = ({
	  name: 'el-sl-panel',
	
	  props: {
	    color: {
	      required: true
	    }
	  },
	
	  computed: {
	    colorValue: function colorValue() {
	      var hue = this.color.get('hue');
	      var value = this.color.get('value');
	      return { hue: hue, value: value };
	    }
	  },
	
	  watch: {
	    colorValue: function colorValue() {
	      this.update();
	    }
	  },
	
	  methods: {
	    update: function update() {
	      var saturation = this.color.get('saturation');
	      var value = this.color.get('value');
	
	      var el = this.$el;
	      var width = el.clientWidth,
	          height = el.clientHeight;
	
	
	      this.cursorLeft = saturation * width / 100;
	      this.cursorTop = (100 - value) * height / 100;
	
	      this.background = 'hsl(' + this.color.get('hue') + ', 100%, 50%)';
	    },
	    handleDrag: function handleDrag(event) {
	      var el = this.$el;
	      var rect = el.getBoundingClientRect();
	
	      var left = event.clientX - rect.left;
	      var top = event.clientY - rect.top;
	      left = Math.max(0, left);
	      left = Math.min(left, rect.width);
	
	      top = Math.max(0, top);
	      top = Math.min(top, rect.height);
	
	      this.cursorLeft = left;
	      this.cursorTop = top;
	      this.color.set({
	        saturation: left / rect.width * 100,
	        value: 100 - top / rect.height * 100
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    draggable(this.$el, {
	      drag: function drag(event) {
	        _this.handleDrag(event);
	      },
	      end: function end(event) {
	        _this.handleDrag(event);
	      }
	    });
	
	    this.update();
	  },
	  data: function data() {
	    return {
	      cursorTop: 0,
	      cursorLeft: 0,
	      background: 'hsl(0, 100%, 50%)'
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_sv_panelvue_type_script_lang_js_ = (sv_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var sv_panel_component = normalizeComponent(
	  components_sv_panelvue_type_script_lang_js_,
	  sv_panelvue_type_template_id_d8583596_render,
	  sv_panelvue_type_template_id_d8583596_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var sv_panel_api; }
	sv_panel_component.options.__file = "packages/color-picker/src/components/sv-panel.vue"
	/* harmony default export */ var sv_panel = (sv_panel_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
	var hue_slidervue_type_template_id_5cdc43b1_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-color-hue-slider",
	      class: { "is-vertical": _vm.vertical }
	    },
	    [
	      _c("div", {
	        ref: "bar",
	        staticClass: "el-color-hue-slider__bar",
	        on: { click: _vm.handleClick }
	      }),
	      _c("div", {
	        ref: "thumb",
	        staticClass: "el-color-hue-slider__thumb",
	        style: {
	          left: _vm.thumbLeft + "px",
	          top: _vm.thumbTop + "px"
	        }
	      })
	    ]
	  )
	}
	var hue_slidervue_type_template_id_5cdc43b1_staticRenderFns = []
	hue_slidervue_type_template_id_5cdc43b1_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var hue_slidervue_type_script_lang_js_ = ({
	  name: 'el-color-hue-slider',
	
	  props: {
	    color: {
	      required: true
	    },
	
	    vertical: Boolean
	  },
	
	  data: function data() {
	    return {
	      thumbLeft: 0,
	      thumbTop: 0
	    };
	  },
	
	
	  computed: {
	    hueValue: function hueValue() {
	      var hue = this.color.get('hue');
	      return hue;
	    }
	  },
	
	  watch: {
	    hueValue: function hueValue() {
	      this.update();
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(event) {
	      var thumb = this.$refs.thumb;
	      var target = event.target;
	
	      if (target !== thumb) {
	        this.handleDrag(event);
	      }
	    },
	    handleDrag: function handleDrag(event) {
	      var rect = this.$el.getBoundingClientRect();
	      var thumb = this.$refs.thumb;
	
	      var hue = void 0;
	
	      if (!this.vertical) {
	        var left = event.clientX - rect.left;
	        left = Math.min(left, rect.width - thumb.offsetWidth / 2);
	        left = Math.max(thumb.offsetWidth / 2, left);
	
	        hue = Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 360);
	      } else {
	        var top = event.clientY - rect.top;
	        top = Math.min(top, rect.height - thumb.offsetHeight / 2);
	        top = Math.max(thumb.offsetHeight / 2, top);
	
	        hue = Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 360);
	      }
	
	      this.color.set('hue', hue);
	    },
	    getThumbLeft: function getThumbLeft() {
	      if (this.vertical) return 0;
	      var el = this.$el;
	      var hue = this.color.get('hue');
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(hue * (el.offsetWidth - thumb.offsetWidth / 2) / 360);
	    },
	    getThumbTop: function getThumbTop() {
	      if (!this.vertical) return 0;
	      var el = this.$el;
	      var hue = this.color.get('hue');
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(hue * (el.offsetHeight - thumb.offsetHeight / 2) / 360);
	    },
	    update: function update() {
	      this.thumbLeft = this.getThumbLeft();
	      this.thumbTop = this.getThumbTop();
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var _$refs = this.$refs,
	        bar = _$refs.bar,
	        thumb = _$refs.thumb;
	
	
	    var dragConfig = {
	      drag: function drag(event) {
	        _this.handleDrag(event);
	      },
	      end: function end(event) {
	        _this.handleDrag(event);
	      }
	    };
	
	    draggable(bar, dragConfig);
	    draggable(thumb, dragConfig);
	    this.update();
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_hue_slidervue_type_script_lang_js_ = (hue_slidervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue
	
	
	
	
	
	/* normalize component */
	
	var hue_slider_component = normalizeComponent(
	  components_hue_slidervue_type_script_lang_js_,
	  hue_slidervue_type_template_id_5cdc43b1_render,
	  hue_slidervue_type_template_id_5cdc43b1_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var hue_slider_api; }
	hue_slider_component.options.__file = "packages/color-picker/src/components/hue-slider.vue"
	/* harmony default export */ var hue_slider = (hue_slider_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
	var alpha_slidervue_type_template_id_068c66cb_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-color-alpha-slider",
	      class: { "is-vertical": _vm.vertical }
	    },
	    [
	      _c("div", {
	        ref: "bar",
	        staticClass: "el-color-alpha-slider__bar",
	        style: {
	          background: _vm.background
	        },
	        on: { click: _vm.handleClick }
	      }),
	      _c("div", {
	        ref: "thumb",
	        staticClass: "el-color-alpha-slider__thumb",
	        style: {
	          left: _vm.thumbLeft + "px",
	          top: _vm.thumbTop + "px"
	        }
	      })
	    ]
	  )
	}
	var alpha_slidervue_type_template_id_068c66cb_staticRenderFns = []
	alpha_slidervue_type_template_id_068c66cb_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var alpha_slidervue_type_script_lang_js_ = ({
	  name: 'el-color-alpha-slider',
	
	  props: {
	    color: {
	      required: true
	    },
	    vertical: Boolean
	  },
	
	  watch: {
	    'color._alpha': function color_alpha() {
	      this.update();
	    },
	    'color.value': function colorValue() {
	      this.update();
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(event) {
	      var thumb = this.$refs.thumb;
	      var target = event.target;
	
	      if (target !== thumb) {
	        this.handleDrag(event);
	      }
	    },
	    handleDrag: function handleDrag(event) {
	      var rect = this.$el.getBoundingClientRect();
	      var thumb = this.$refs.thumb;
	
	
	      if (!this.vertical) {
	        var left = event.clientX - rect.left;
	        left = Math.max(thumb.offsetWidth / 2, left);
	        left = Math.min(left, rect.width - thumb.offsetWidth / 2);
	
	        this.color.set('alpha', Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 100));
	      } else {
	        var top = event.clientY - rect.top;
	        top = Math.max(thumb.offsetHeight / 2, top);
	        top = Math.min(top, rect.height - thumb.offsetHeight / 2);
	
	        this.color.set('alpha', Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 100));
	      }
	    },
	    getThumbLeft: function getThumbLeft() {
	      if (this.vertical) return 0;
	      var el = this.$el;
	      var alpha = this.color._alpha;
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(alpha * (el.offsetWidth - thumb.offsetWidth / 2) / 100);
	    },
	    getThumbTop: function getThumbTop() {
	      if (!this.vertical) return 0;
	      var el = this.$el;
	      var alpha = this.color._alpha;
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(alpha * (el.offsetHeight - thumb.offsetHeight / 2) / 100);
	    },
	    getBackground: function getBackground() {
	      if (this.color && this.color.value) {
	        var _color$toRgb = this.color.toRgb(),
	            r = _color$toRgb.r,
	            g = _color$toRgb.g,
	            b = _color$toRgb.b;
	
	        return 'linear-gradient(to right, rgba(' + r + ', ' + g + ', ' + b + ', 0) 0%, rgba(' + r + ', ' + g + ', ' + b + ', 1) 100%)';
	      }
	      return null;
	    },
	    update: function update() {
	      this.thumbLeft = this.getThumbLeft();
	      this.thumbTop = this.getThumbTop();
	      this.background = this.getBackground();
	    }
	  },
	
	  data: function data() {
	    return {
	      thumbLeft: 0,
	      thumbTop: 0,
	      background: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var _$refs = this.$refs,
	        bar = _$refs.bar,
	        thumb = _$refs.thumb;
	
	
	    var dragConfig = {
	      drag: function drag(event) {
	        _this.handleDrag(event);
	      },
	      end: function end(event) {
	        _this.handleDrag(event);
	      }
	    };
	
	    draggable(bar, dragConfig);
	    draggable(thumb, dragConfig);
	    this.update();
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_alpha_slidervue_type_script_lang_js_ = (alpha_slidervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue
	
	
	
	
	
	/* normalize component */
	
	var alpha_slider_component = normalizeComponent(
	  components_alpha_slidervue_type_script_lang_js_,
	  alpha_slidervue_type_template_id_068c66cb_render,
	  alpha_slidervue_type_template_id_068c66cb_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var alpha_slider_api; }
	alpha_slider_component.options.__file = "packages/color-picker/src/components/alpha-slider.vue"
	/* harmony default export */ var alpha_slider = (alpha_slider_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
	var predefinevue_type_template_id_06e03093_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-color-predefine" }, [
	    _c(
	      "div",
	      { staticClass: "el-color-predefine__colors" },
	      _vm._l(_vm.rgbaColors, function(item, index) {
	        return _c(
	          "div",
	          {
	            key: _vm.colors[index],
	            staticClass: "el-color-predefine__color-selector",
	            class: { selected: item.selected, "is-alpha": item._alpha < 100 },
	            on: {
	              click: function($event) {
	                _vm.handleSelect(index)
	              }
	            }
	          },
	          [_c("div", { style: { "background-color": item.value } })]
	        )
	      }),
	      0
	    )
	  ])
	}
	var predefinevue_type_template_id_06e03093_staticRenderFns = []
	predefinevue_type_template_id_06e03093_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var predefinevue_type_script_lang_js_ = ({
	  props: {
	    colors: { type: Array, required: true },
	    color: { required: true }
	  },
	  data: function data() {
	    return {
	      rgbaColors: this.parseColors(this.colors, this.color)
	    };
	  },
	
	  methods: {
	    handleSelect: function handleSelect(index) {
	      this.color.fromString(this.colors[index]);
	    },
	    parseColors: function parseColors(colors, color) {
	      return colors.map(function (value) {
	        var c = new src_color();
	        c.enableAlpha = true;
	        c.format = 'rgba';
	        c.fromString(value);
	        c.selected = c.value === color.value;
	        return c;
	      });
	    }
	  },
	  watch: {
	    '$parent.currentColor': function $parentCurrentColor(val) {
	      var color = new src_color();
	      color.fromString(val);
	
	      this.rgbaColors.forEach(function (item) {
	        item.selected = color.compare(item);
	      });
	    },
	    colors: function colors(newVal) {
	      this.rgbaColors = this.parseColors(newVal, this.color);
	    },
	    color: function color(newVal) {
	      this.rgbaColors = this.parseColors(this.colors, newVal);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_predefinevue_type_script_lang_js_ = (predefinevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue
	
	
	
	
	
	/* normalize component */
	
	var predefine_component = normalizeComponent(
	  components_predefinevue_type_script_lang_js_,
	  predefinevue_type_template_id_06e03093_render,
	  predefinevue_type_template_id_06e03093_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var predefine_api; }
	predefine_component.options.__file = "packages/color-picker/src/components/predefine.vue"
	/* harmony default export */ var predefine = (predefine_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var picker_dropdownvue_type_script_lang_js_ = ({
	  name: 'el-color-picker-dropdown',
	
	  mixins: [vue_popper_default.a, locale_default.a],
	
	  components: {
	    SvPanel: sv_panel,
	    HueSlider: hue_slider,
	    AlphaSlider: alpha_slider,
	    ElInput: input_default.a,
	    ElButton: button_default.a,
	    Predefine: predefine
	  },
	
	  props: {
	    color: {
	      required: true
	    },
	    showAlpha: Boolean,
	    predefine: Array
	  },
	
	  data: function data() {
	    return {
	      customInput: ''
	    };
	  },
	
	
	  computed: {
	    currentColor: function currentColor() {
	      var parent = this.$parent;
	      return !parent.value && !parent.showPanelColor ? '' : parent.color.value;
	    }
	  },
	
	  methods: {
	    confirmValue: function confirmValue() {
	      this.$emit('pick');
	    },
	    handleConfirm: function handleConfirm() {
	      this.color.fromString(this.customInput);
	    }
	  },
	
	  mounted: function mounted() {
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.referenceElm = this.$parent.$el;
	  },
	
	
	  watch: {
	    showPopper: function showPopper(val) {
	      var _this = this;
	
	      if (val === true) {
	        this.$nextTick(function () {
	          var _$refs = _this.$refs,
	              sl = _$refs.sl,
	              hue = _$refs.hue,
	              alpha = _$refs.alpha;
	
	          sl && sl.update();
	          hue && hue.update();
	          alpha && alpha.update();
	        });
	      }
	    },
	
	
	    currentColor: {
	      immediate: true,
	      handler: function handler(val) {
	        this.customInput = val;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_picker_dropdownvue_type_script_lang_js_ = (picker_dropdownvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue
	
	
	
	
	
	/* normalize component */
	
	var picker_dropdown_component = normalizeComponent(
	  components_picker_dropdownvue_type_script_lang_js_,
	  picker_dropdownvue_type_template_id_06601625_render,
	  picker_dropdownvue_type_template_id_06601625_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var picker_dropdown_api; }
	picker_dropdown_component.options.__file = "packages/color-picker/src/components/picker-dropdown.vue"
	/* harmony default export */ var picker_dropdown = (picker_dropdown_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var color_picker_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElColorPicker',
	
	  mixins: [emitter_default.a],
	
	  props: {
	    value: String,
	    showAlpha: Boolean,
	    colorFormat: String,
	    disabled: Boolean,
	    size: String,
	    popperClass: String,
	    predefine: Array
	  },
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  computed: {
	    displayedColor: function displayedColor() {
	      if (!this.value && !this.showPanelColor) {
	        return 'transparent';
	      }
	
	      return this.displayedRgb(this.color, this.showAlpha);
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    colorSize: function colorSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    colorDisabled: function colorDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      if (!val) {
	        this.showPanelColor = false;
	      } else if (val && val !== this.color.value) {
	        this.color.fromString(val);
	      }
	    },
	
	    color: {
	      deep: true,
	      handler: function handler() {
	        this.showPanelColor = true;
	      }
	    },
	    displayedColor: function displayedColor(val) {
	      if (!this.showPicker) return;
	      var currentValueColor = new src_color({
	        enableAlpha: this.showAlpha,
	        format: this.colorFormat
	      });
	      currentValueColor.fromString(this.value);
	
	      var currentValueColorRgb = this.displayedRgb(currentValueColor, this.showAlpha);
	      if (val !== currentValueColorRgb) {
	        this.$emit('active-change', val);
	      }
	    }
	  },
	
	  methods: {
	    handleTrigger: function handleTrigger() {
	      if (this.colorDisabled) return;
	      this.showPicker = !this.showPicker;
	    },
	    confirmValue: function confirmValue() {
	      var value = this.color.value;
	      this.$emit('input', value);
	      this.$emit('change', value);
	      this.dispatch('ElFormItem', 'el.form.change', value);
	      this.showPicker = false;
	    },
	    clearValue: function clearValue() {
	      this.$emit('input', null);
	      this.$emit('change', null);
	      if (this.value !== null) {
	        this.dispatch('ElFormItem', 'el.form.change', null);
	      }
	      this.showPanelColor = false;
	      this.showPicker = false;
	      this.resetColor();
	    },
	    hide: function hide() {
	      this.showPicker = false;
	      this.resetColor();
	    },
	    resetColor: function resetColor() {
	      var _this = this;
	
	      this.$nextTick(function (_) {
	        if (_this.value) {
	          _this.color.fromString(_this.value);
	        } else {
	          _this.showPanelColor = false;
	        }
	      });
	    },
	    displayedRgb: function displayedRgb(color, showAlpha) {
	      if (!(color instanceof src_color)) {
	        throw Error('color should be instance of Color Class');
	      }
	
	      var _color$toRgb = color.toRgb(),
	          r = _color$toRgb.r,
	          g = _color$toRgb.g,
	          b = _color$toRgb.b;
	
	      return showAlpha ? 'rgba(' + r + ', ' + g + ', ' + b + ', ' + color.get('alpha') / 100 + ')' : 'rgb(' + r + ', ' + g + ', ' + b + ')';
	    }
	  },
	
	  mounted: function mounted() {
	    var value = this.value;
	    if (value) {
	      this.color.fromString(value);
	    }
	    this.popperElm = this.$refs.dropdown.$el;
	  },
	  data: function data() {
	    var color = new src_color({
	      enableAlpha: this.showAlpha,
	      format: this.colorFormat
	    });
	
	    return {
	      color: color,
	      showPicker: false,
	      showPanelColor: false
	    };
	  },
	
	
	  components: {
	    PickerDropdown: picker_dropdown
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_color_picker_src_mainvue_type_script_lang_js_ = (color_picker_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var color_picker_src_main_component = normalizeComponent(
	  packages_color_picker_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_55c8ade7_render,
	  mainvue_type_template_id_55c8ade7_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var color_picker_src_main_api; }
	color_picker_src_main_component.options.__file = "packages/color-picker/src/main.vue"
	/* harmony default export */ var color_picker_src_main = (color_picker_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/color-picker/index.js
	
	
	/* istanbul ignore next */
	color_picker_src_main.install = function (Vue) {
	  Vue.component(color_picker_src_main.name, color_picker_src_main);
	};
	
	/* harmony default export */ var color_picker = (color_picker_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
	var mainvue_type_template_id_5c654dd8_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    { staticClass: "el-transfer" },
	    [
	      _c(
	        "transfer-panel",
	        _vm._b(
	          {
	            ref: "leftPanel",
	            attrs: {
	              data: _vm.sourceData,
	              title: _vm.titles[0] || _vm.t("el.transfer.titles.0"),
	              "default-checked": _vm.leftDefaultChecked,
	              placeholder:
	                _vm.filterPlaceholder || _vm.t("el.transfer.filterPlaceholder")
	            },
	            on: { "checked-change": _vm.onSourceCheckedChange }
	          },
	          "transfer-panel",
	          _vm.$props,
	          false
	        ),
	        [_vm._t("left-footer")],
	        2
	      ),
	      _c(
	        "div",
	        { staticClass: "el-transfer__buttons" },
	        [
	          _c(
	            "el-button",
	            {
	              class: [
	                "el-transfer__button",
	                _vm.hasButtonTexts ? "is-with-texts" : ""
	              ],
	              attrs: {
	                type: "primary",
	                disabled: _vm.rightChecked.length === 0
	              },
	              nativeOn: {
	                click: function($event) {
	                  return _vm.addToLeft($event)
	                }
	              }
	            },
	            [
	              _c("i", { staticClass: "el-icon-arrow-left" }),
	              _vm.buttonTexts[0] !== undefined
	                ? _c("span", [_vm._v(_vm._s(_vm.buttonTexts[0]))])
	                : _vm._e()
	            ]
	          ),
	          _c(
	            "el-button",
	            {
	              class: [
	                "el-transfer__button",
	                _vm.hasButtonTexts ? "is-with-texts" : ""
	              ],
	              attrs: {
	                type: "primary",
	                disabled: _vm.leftChecked.length === 0
	              },
	              nativeOn: {
	                click: function($event) {
	                  return _vm.addToRight($event)
	                }
	              }
	            },
	            [
	              _vm.buttonTexts[1] !== undefined
	                ? _c("span", [_vm._v(_vm._s(_vm.buttonTexts[1]))])
	                : _vm._e(),
	              _c("i", { staticClass: "el-icon-arrow-right" })
	            ]
	          )
	        ],
	        1
	      ),
	      _c(
	        "transfer-panel",
	        _vm._b(
	          {
	            ref: "rightPanel",
	            attrs: {
	              data: _vm.targetData,
	              title: _vm.titles[1] || _vm.t("el.transfer.titles.1"),
	              "default-checked": _vm.rightDefaultChecked,
	              placeholder:
	                _vm.filterPlaceholder || _vm.t("el.transfer.filterPlaceholder")
	            },
	            on: { "checked-change": _vm.onTargetCheckedChange }
	          },
	          "transfer-panel",
	          _vm.$props,
	          false
	        ),
	        [_vm._t("right-footer")],
	        2
	      )
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_5c654dd8_staticRenderFns = []
	mainvue_type_template_id_5c654dd8_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
	var transfer_panelvue_type_template_id_2ddab8bd_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-transfer-panel" }, [
	    _c(
	      "p",
	      { staticClass: "el-transfer-panel__header" },
	      [
	        _c(
	          "el-checkbox",
	          {
	            attrs: { indeterminate: _vm.isIndeterminate },
	            on: { change: _vm.handleAllCheckedChange },
	            model: {
	              value: _vm.allChecked,
	              callback: function($$v) {
	                _vm.allChecked = $$v
	              },
	              expression: "allChecked"
	            }
	          },
	          [
	            _vm._v("\n      " + _vm._s(_vm.title) + "\n      "),
	            _c("span", [_vm._v(_vm._s(_vm.checkedSummary))])
	          ]
	        )
	      ],
	      1
	    ),
	    _c(
	      "div",
	      {
	        class: [
	          "el-transfer-panel__body",
	          _vm.hasFooter ? "is-with-footer" : ""
	        ]
	      },
	      [
	        _vm.filterable
	          ? _c(
	              "el-input",
	              {
	                staticClass: "el-transfer-panel__filter",
	                attrs: { size: "small", placeholder: _vm.placeholder },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.inputHover = true
	                  },
	                  mouseleave: function($event) {
	                    _vm.inputHover = false
	                  }
	                },
	                model: {
	                  value: _vm.query,
	                  callback: function($$v) {
	                    _vm.query = $$v
	                  },
	                  expression: "query"
	                }
	              },
	              [
	                _c("i", {
	                  class: ["el-input__icon", "el-icon-" + _vm.inputIcon],
	                  attrs: { slot: "prefix" },
	                  on: { click: _vm.clearQuery },
	                  slot: "prefix"
	                })
	              ]
	            )
	          : _vm._e(),
	        _c(
	          "el-checkbox-group",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: !_vm.hasNoMatch && _vm.data.length > 0,
	                expression: "!hasNoMatch && data.length > 0"
	              }
	            ],
	            staticClass: "el-transfer-panel__list",
	            class: { "is-filterable": _vm.filterable },
	            model: {
	              value: _vm.checked,
	              callback: function($$v) {
	                _vm.checked = $$v
	              },
	              expression: "checked"
	            }
	          },
	          _vm._l(_vm.filteredData, function(item) {
	            return _c(
	              "el-checkbox",
	              {
	                key: item[_vm.keyProp],
	                staticClass: "el-transfer-panel__item",
	                attrs: {
	                  label: item[_vm.keyProp],
	                  disabled: item[_vm.disabledProp]
	                }
	              },
	              [_c("option-content", { attrs: { option: item } })],
	              1
	            )
	          }),
	          1
	        ),
	        _c(
	          "p",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.hasNoMatch,
	                expression: "hasNoMatch"
	              }
	            ],
	            staticClass: "el-transfer-panel__empty"
	          },
	          [_vm._v(_vm._s(_vm.t("el.transfer.noMatch")))]
	        ),
	        _c(
	          "p",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.data.length === 0 && !_vm.hasNoMatch,
	                expression: "data.length === 0 && !hasNoMatch"
	              }
	            ],
	            staticClass: "el-transfer-panel__empty"
	          },
	          [_vm._v(_vm._s(_vm.t("el.transfer.noData")))]
	        )
	      ],
	      1
	    ),
	    _vm.hasFooter
	      ? _c(
	          "p",
	          { staticClass: "el-transfer-panel__footer" },
	          [_vm._t("default")],
	          2
	        )
	      : _vm._e()
	  ])
	}
	var transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns = []
	transfer_panelvue_type_template_id_2ddab8bd_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var transfer_panelvue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  name: 'ElTransferPanel',
	
	  componentName: 'ElTransferPanel',
	
	  components: {
	    ElCheckboxGroup: checkbox_group_default.a,
	    ElCheckbox: checkbox_default.a,
	    ElInput: input_default.a,
	    OptionContent: {
	      props: {
	        option: Object
	      },
	      render: function render(h) {
	        var getParent = function getParent(vm) {
	          if (vm.$options.componentName === 'ElTransferPanel') {
	            return vm;
	          } else if (vm.$parent) {
	            return getParent(vm.$parent);
	          } else {
	            return vm;
	          }
	        };
	        var panel = getParent(this);
	        var transfer = panel.$parent || panel;
	        return panel.renderContent ? panel.renderContent(h, this.option) : transfer.$scopedSlots.default ? transfer.$scopedSlots.default({ option: this.option }) : h('span', [this.option[panel.labelProp] || this.option[panel.keyProp]]);
	      }
	    }
	  },
	
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    renderContent: Function,
	    placeholder: String,
	    title: String,
	    filterable: Boolean,
	    format: Object,
	    filterMethod: Function,
	    defaultChecked: Array,
	    props: Object
	  },
	
	  data: function data() {
	    return {
	      checked: [],
	      allChecked: false,
	      query: '',
	      inputHover: false,
	      checkChangeByUser: true
	    };
	  },
	
	
	  watch: {
	    checked: function checked(val, oldVal) {
	      this.updateAllChecked();
	      if (this.checkChangeByUser) {
	        var movedKeys = val.concat(oldVal).filter(function (v) {
	          return val.indexOf(v) === -1 || oldVal.indexOf(v) === -1;
	        });
	        this.$emit('checked-change', val, movedKeys);
	      } else {
	        this.$emit('checked-change', val);
	        this.checkChangeByUser = true;
	      }
	    },
	    data: function data() {
	      var _this = this;
	
	      var checked = [];
	      var filteredDataKeys = this.filteredData.map(function (item) {
	        return item[_this.keyProp];
	      });
	      this.checked.forEach(function (item) {
	        if (filteredDataKeys.indexOf(item) > -1) {
	          checked.push(item);
	        }
	      });
	      this.checkChangeByUser = false;
	      this.checked = checked;
	    },
	    checkableData: function checkableData() {
	      this.updateAllChecked();
	    },
	
	
	    defaultChecked: {
	      immediate: true,
	      handler: function handler(val, oldVal) {
	        var _this2 = this;
	
	        if (oldVal && val.length === oldVal.length && val.every(function (item) {
	          return oldVal.indexOf(item) > -1;
	        })) return;
	        var checked = [];
	        var checkableDataKeys = this.checkableData.map(function (item) {
	          return item[_this2.keyProp];
	        });
	        val.forEach(function (item) {
	          if (checkableDataKeys.indexOf(item) > -1) {
	            checked.push(item);
	          }
	        });
	        this.checkChangeByUser = false;
	        this.checked = checked;
	      }
	    }
	  },
	
	  computed: {
	    filteredData: function filteredData() {
	      var _this3 = this;
	
	      return this.data.filter(function (item) {
	        if (typeof _this3.filterMethod === 'function') {
	          return _this3.filterMethod(_this3.query, item);
	        } else {
	          var label = item[_this3.labelProp] || item[_this3.keyProp].toString();
	          return label.toLowerCase().indexOf(_this3.query.toLowerCase()) > -1;
	        }
	      });
	    },
	    checkableData: function checkableData() {
	      var _this4 = this;
	
	      return this.filteredData.filter(function (item) {
	        return !item[_this4.disabledProp];
	      });
	    },
	    checkedSummary: function checkedSummary() {
	      var checkedLength = this.checked.length;
	      var dataLength = this.data.length;
	      var _format = this.format,
	          noChecked = _format.noChecked,
	          hasChecked = _format.hasChecked;
	
	      if (noChecked && hasChecked) {
	        return checkedLength > 0 ? hasChecked.replace(/\${checked}/g, checkedLength).replace(/\${total}/g, dataLength) : noChecked.replace(/\${total}/g, dataLength);
	      } else {
	        return checkedLength + '/' + dataLength;
	      }
	    },
	    isIndeterminate: function isIndeterminate() {
	      var checkedLength = this.checked.length;
	      return checkedLength > 0 && checkedLength < this.checkableData.length;
	    },
	    hasNoMatch: function hasNoMatch() {
	      return this.query.length > 0 && this.filteredData.length === 0;
	    },
	    inputIcon: function inputIcon() {
	      return this.query.length > 0 && this.inputHover ? 'circle-close' : 'search';
	    },
	    labelProp: function labelProp() {
	      return this.props.label || 'label';
	    },
	    keyProp: function keyProp() {
	      return this.props.key || 'key';
	    },
	    disabledProp: function disabledProp() {
	      return this.props.disabled || 'disabled';
	    },
	    hasFooter: function hasFooter() {
	      return !!this.$slots.default;
	    }
	  },
	
	  methods: {
	    updateAllChecked: function updateAllChecked() {
	      var _this5 = this;
	
	      var checkableDataKeys = this.checkableData.map(function (item) {
	        return item[_this5.keyProp];
	      });
	      this.allChecked = checkableDataKeys.length > 0 && checkableDataKeys.every(function (item) {
	        return _this5.checked.indexOf(item) > -1;
	      });
	    },
	    handleAllCheckedChange: function handleAllCheckedChange(value) {
	      var _this6 = this;
	
	      this.checked = value ? this.checkableData.map(function (item) {
	        return item[_this6.keyProp];
	      }) : [];
	    },
	    clearQuery: function clearQuery() {
	      if (this.inputIcon === 'circle-close') {
	        this.query = '';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_transfer_panelvue_type_script_lang_js_ = (transfer_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var transfer_panel_component = normalizeComponent(
	  src_transfer_panelvue_type_script_lang_js_,
	  transfer_panelvue_type_template_id_2ddab8bd_render,
	  transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var transfer_panel_api; }
	transfer_panel_component.options.__file = "packages/transfer/src/transfer-panel.vue"
	/* harmony default export */ var transfer_panel = (transfer_panel_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	/* harmony default export */ var transfer_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElTransfer',
	
	  mixins: [emitter_default.a, locale_default.a, migrating_default.a],
	
	  components: {
	    TransferPanel: transfer_panel,
	    ElButton: button_default.a
	  },
	
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    titles: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    buttonTexts: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    filterPlaceholder: {
	      type: String,
	      default: ''
	    },
	    filterMethod: Function,
	    leftDefaultChecked: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    rightDefaultChecked: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    renderContent: Function,
	    value: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    format: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    filterable: Boolean,
	    props: {
	      type: Object,
	      default: function _default() {
	        return {
	          label: 'label',
	          key: 'key',
	          disabled: 'disabled'
	        };
	      }
	    },
	    targetOrder: {
	      type: String,
	      default: 'original'
	    }
	  },
	
	  data: function data() {
	    return {
	      leftChecked: [],
	      rightChecked: []
	    };
	  },
	
	
	  computed: {
	    dataObj: function dataObj() {
	      var key = this.props.key;
	      return this.data.reduce(function (o, cur) {
	        return (o[cur[key]] = cur) && o;
	      }, {});
	    },
	    sourceData: function sourceData() {
	      var _this = this;
	
	      return this.data.filter(function (item) {
	        return _this.value.indexOf(item[_this.props.key]) === -1;
	      });
	    },
	    targetData: function targetData() {
	      var _this2 = this;
	
	      if (this.targetOrder === 'original') {
	        return this.data.filter(function (item) {
	          return _this2.value.indexOf(item[_this2.props.key]) > -1;
	        });
	      } else {
	        return this.value.reduce(function (arr, cur) {
	          var val = _this2.dataObj[cur];
	          if (val) {
	            arr.push(val);
	          }
	          return arr;
	        }, []);
	      }
	    },
	    hasButtonTexts: function hasButtonTexts() {
	      return this.buttonTexts.length === 2;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.dispatch('ElFormItem', 'el.form.change', val);
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'footer-format': 'footer-format is renamed to format.'
	        }
	      };
	    },
	    onSourceCheckedChange: function onSourceCheckedChange(val, movedKeys) {
	      this.leftChecked = val;
	      if (movedKeys === undefined) return;
	      this.$emit('left-check-change', val, movedKeys);
	    },
	    onTargetCheckedChange: function onTargetCheckedChange(val, movedKeys) {
	      this.rightChecked = val;
	      if (movedKeys === undefined) return;
	      this.$emit('right-check-change', val, movedKeys);
	    },
	    addToLeft: function addToLeft() {
	      var currentValue = this.value.slice();
	      this.rightChecked.forEach(function (item) {
	        var index = currentValue.indexOf(item);
	        if (index > -1) {
	          currentValue.splice(index, 1);
	        }
	      });
	      this.$emit('input', currentValue);
	      this.$emit('change', currentValue, 'left', this.rightChecked);
	    },
	    addToRight: function addToRight() {
	      var _this3 = this;
	
	      var currentValue = this.value.slice();
	      var itemsToBeMoved = [];
	      var key = this.props.key;
	      this.data.forEach(function (item) {
	        var itemKey = item[key];
	        if (_this3.leftChecked.indexOf(itemKey) > -1 && _this3.value.indexOf(itemKey) === -1) {
	          itemsToBeMoved.push(itemKey);
	        }
	      });
	      currentValue = this.targetOrder === 'unshift' ? itemsToBeMoved.concat(currentValue) : currentValue.concat(itemsToBeMoved);
	      this.$emit('input', currentValue);
	      this.$emit('change', currentValue, 'right', this.leftChecked);
	    },
	    clearQuery: function clearQuery(which) {
	      if (which === 'left') {
	        this.$refs.leftPanel.query = '';
	      } else if (which === 'right') {
	        this.$refs.rightPanel.query = '';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_transfer_src_mainvue_type_script_lang_js_ = (transfer_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/transfer/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var transfer_src_main_component = normalizeComponent(
	  packages_transfer_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5c654dd8_render,
	  mainvue_type_template_id_5c654dd8_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var transfer_src_main_api; }
	transfer_src_main_component.options.__file = "packages/transfer/src/main.vue"
	/* harmony default export */ var transfer_src_main = (transfer_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/transfer/index.js
	
	
	/* istanbul ignore next */
	transfer_src_main.install = function (Vue) {
	  Vue.component(transfer_src_main.name, transfer_src_main);
	};
	
	/* harmony default export */ var transfer = (transfer_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
	var mainvue_type_template_id_5bf181d4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "section",
	    { staticClass: "el-container", class: { "is-vertical": _vm.isVertical } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_5bf181d4_staticRenderFns = []
	mainvue_type_template_id_5bf181d4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var container_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElContainer',
	
	  componentName: 'ElContainer',
	
	  props: {
	    direction: String
	  },
	
	  computed: {
	    isVertical: function isVertical() {
	      if (this.direction === 'vertical') {
	        return true;
	      } else if (this.direction === 'horizontal') {
	        return false;
	      }
	      return this.$slots && this.$slots.default ? this.$slots.default.some(function (vnode) {
	        var tag = vnode.componentOptions && vnode.componentOptions.tag;
	        return tag === 'el-header' || tag === 'el-footer';
	      }) : false;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_container_src_mainvue_type_script_lang_js_ = (container_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/container/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var container_src_main_component = normalizeComponent(
	  packages_container_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5bf181d4_render,
	  mainvue_type_template_id_5bf181d4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var container_src_main_api; }
	container_src_main_component.options.__file = "packages/container/src/main.vue"
	/* harmony default export */ var container_src_main = (container_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/container/index.js
	
	
	/* istanbul ignore next */
	container_src_main.install = function (Vue) {
	  Vue.component(container_src_main.name, container_src_main);
	};
	
	/* harmony default export */ var packages_container = (container_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
	var mainvue_type_template_id_2b296ab2_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "header",
	    { staticClass: "el-header", style: { height: _vm.height } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_2b296ab2_staticRenderFns = []
	mainvue_type_template_id_2b296ab2_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var header_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElHeader',
	
	  componentName: 'ElHeader',
	
	  props: {
	    height: {
	      type: String,
	      default: '60px'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_header_src_mainvue_type_script_lang_js_ = (header_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/header/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var header_src_main_component = normalizeComponent(
	  packages_header_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_2b296ab2_render,
	  mainvue_type_template_id_2b296ab2_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var header_src_main_api; }
	header_src_main_component.options.__file = "packages/header/src/main.vue"
	/* harmony default export */ var header_src_main = (header_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/header/index.js
	
	
	/* istanbul ignore next */
	header_src_main.install = function (Vue) {
	  Vue.component(header_src_main.name, header_src_main);
	};
	
	/* harmony default export */ var header = (header_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
	var mainvue_type_template_id_03411dbf_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "aside",
	    { staticClass: "el-aside", style: { width: _vm.width } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_03411dbf_staticRenderFns = []
	mainvue_type_template_id_03411dbf_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var aside_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElAside',
	
	  componentName: 'ElAside',
	
	  props: {
	    width: {
	      type: String,
	      default: '300px'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_aside_src_mainvue_type_script_lang_js_ = (aside_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/aside/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var aside_src_main_component = normalizeComponent(
	  packages_aside_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_03411dbf_render,
	  mainvue_type_template_id_03411dbf_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var aside_src_main_api; }
	aside_src_main_component.options.__file = "packages/aside/src/main.vue"
	/* harmony default export */ var aside_src_main = (aside_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/aside/index.js
	
	
	/* istanbul ignore next */
	aside_src_main.install = function (Vue) {
	  Vue.component(aside_src_main.name, aside_src_main);
	};
	
	/* harmony default export */ var aside = (aside_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
	var mainvue_type_template_id_2a3a7406_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("main", { staticClass: "el-main" }, [_vm._t("default")], 2)
	}
	var mainvue_type_template_id_2a3a7406_staticRenderFns = []
	mainvue_type_template_id_2a3a7406_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var main_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElMain',
	  componentName: 'ElMain'
	});
	// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_main_src_mainvue_type_script_lang_js_ = (main_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/main/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var main_src_main_component = normalizeComponent(
	  packages_main_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_2a3a7406_render,
	  mainvue_type_template_id_2a3a7406_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var main_src_main_api; }
	main_src_main_component.options.__file = "packages/main/src/main.vue"
	/* harmony default export */ var main_src_main = (main_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/main/index.js
	
	
	/* istanbul ignore next */
	main_src_main.install = function (Vue) {
	  Vue.component(main_src_main.name, main_src_main);
	};
	
	/* harmony default export */ var packages_main = (main_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=template&id=80210338&
	var mainvue_type_template_id_80210338_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "footer",
	    { staticClass: "el-footer", style: { height: _vm.height } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_80210338_staticRenderFns = []
	mainvue_type_template_id_80210338_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=template&id=80210338&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var footer_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElFooter',
	
	  componentName: 'ElFooter',
	
	  props: {
	    height: {
	      type: String,
	      default: '60px'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_footer_src_mainvue_type_script_lang_js_ = (footer_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/footer/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var footer_src_main_component = normalizeComponent(
	  packages_footer_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_80210338_render,
	  mainvue_type_template_id_80210338_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var footer_src_main_api; }
	footer_src_main_component.options.__file = "packages/footer/src/main.vue"
	/* harmony default export */ var footer_src_main = (footer_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/footer/index.js
	
	
	/* istanbul ignore next */
	footer_src_main.install = function (Vue) {
	  Vue.component(footer_src_main.name, footer_src_main);
	};
	
	/* harmony default export */ var footer = (footer_src_main);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/main.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var timeline_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElTimeline',
	
	  props: {
	    reverse: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  provide: function provide() {
	    return {
	      timeline: this
	    };
	  },
	  render: function render() {
	    var h = arguments[0];
	
	    var reverse = this.reverse;
	    var classes = {
	      'el-timeline': true,
	      'is-reverse': reverse
	    };
	    var slots = this.$slots.default || [];
	    if (reverse) {
	      slots = slots.reverse();
	    }
	    return h(
	      'ul',
	      { 'class': classes },
	      [slots]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/timeline/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_timeline_src_mainvue_type_script_lang_js_ = (timeline_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/timeline/src/main.vue
	var main_render, main_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var timeline_src_main_component = normalizeComponent(
	  packages_timeline_src_mainvue_type_script_lang_js_,
	  main_render,
	  main_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var timeline_src_main_api; }
	timeline_src_main_component.options.__file = "packages/timeline/src/main.vue"
	/* harmony default export */ var timeline_src_main = (timeline_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/timeline/index.js
	
	
	/* istanbul ignore next */
	timeline_src_main.install = function (Vue) {
	  Vue.component(timeline_src_main.name, timeline_src_main);
	};
	
	/* harmony default export */ var timeline = (timeline_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
	var itemvue_type_template_id_61a69e50_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("li", { staticClass: "el-timeline-item" }, [
	    _c("div", { staticClass: "el-timeline-item__tail" }),
	    !_vm.$slots.dot
	      ? _c(
	          "div",
	          {
	            staticClass: "el-timeline-item__node",
	            class: [
	              "el-timeline-item__node--" + (_vm.size || ""),
	              "el-timeline-item__node--" + (_vm.type || "")
	            ],
	            style: {
	              backgroundColor: _vm.color
	            }
	          },
	          [
	            _vm.icon
	              ? _c("i", {
	                  staticClass: "el-timeline-item__icon",
	                  class: _vm.icon
	                })
	              : _vm._e()
	          ]
	        )
	      : _vm._e(),
	    _vm.$slots.dot
	      ? _c("div", { staticClass: "el-timeline-item__dot" }, [_vm._t("dot")], 2)
	      : _vm._e(),
	    _c("div", { staticClass: "el-timeline-item__wrapper" }, [
	      !_vm.hideTimestamp && _vm.placement === "top"
	        ? _c("div", { staticClass: "el-timeline-item__timestamp is-top" }, [
	            _vm._v("\n      " + _vm._s(_vm.timestamp) + "\n    ")
	          ])
	        : _vm._e(),
	      _c(
	        "div",
	        { staticClass: "el-timeline-item__content" },
	        [_vm._t("default")],
	        2
	      ),
	      !_vm.hideTimestamp && _vm.placement === "bottom"
	        ? _c("div", { staticClass: "el-timeline-item__timestamp is-bottom" }, [
	            _vm._v("\n      " + _vm._s(_vm.timestamp) + "\n    ")
	          ])
	        : _vm._e()
	    ])
	  ])
	}
	var itemvue_type_template_id_61a69e50_staticRenderFns = []
	itemvue_type_template_id_61a69e50_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var timeline_src_itemvue_type_script_lang_js_ = ({
	  name: 'ElTimelineItem',
	
	  inject: ['timeline'],
	
	  props: {
	    timestamp: String,
	
	    hideTimestamp: {
	      type: Boolean,
	      default: false
	    },
	
	    placement: {
	      type: String,
	      default: 'bottom'
	    },
	
	    type: String,
	
	    color: String,
	
	    size: {
	      type: String,
	      default: 'normal'
	    },
	
	    icon: String
	  }
	});
	// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_timeline_src_itemvue_type_script_lang_js_ = (timeline_src_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/timeline/src/item.vue
	
	
	
	
	
	/* normalize component */
	
	var src_item_component = normalizeComponent(
	  packages_timeline_src_itemvue_type_script_lang_js_,
	  itemvue_type_template_id_61a69e50_render,
	  itemvue_type_template_id_61a69e50_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_item_api; }
	src_item_component.options.__file = "packages/timeline/src/item.vue"
	/* harmony default export */ var timeline_src_item = (src_item_component.exports);
	// CONCATENATED MODULE: ./packages/timeline-item/index.js
	
	
	/* istanbul ignore next */
	timeline_src_item.install = function (Vue) {
	  Vue.component(timeline_src_item.name, timeline_src_item);
	};
	
	/* harmony default export */ var timeline_item = (timeline_src_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
	var mainvue_type_template_id_01cf3b65_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "a",
	    _vm._b(
	      {
	        class: [
	          "el-link",
	          _vm.type ? "el-link--" + _vm.type : "",
	          _vm.disabled && "is-disabled",
	          _vm.underline && !_vm.disabled && "is-underline"
	        ],
	        attrs: { href: _vm.disabled ? null : _vm.href },
	        on: { click: _vm.handleClick }
	      },
	      "a",
	      _vm.$attrs,
	      false
	    ),
	    [
	      _vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(),
	      _vm.$slots.default
	        ? _c("span", { staticClass: "el-link--inner" }, [_vm._t("default")], 2)
	        : _vm._e(),
	      _vm.$slots.icon ? [_vm.$slots.icon ? _vm._t("icon") : _vm._e()] : _vm._e()
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_01cf3b65_staticRenderFns = []
	mainvue_type_template_id_01cf3b65_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	/* harmony default export */ var link_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElLink',
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    underline: {
	      type: Boolean,
	      default: true
	    },
	    disabled: Boolean,
	    href: String,
	    icon: String
	  },
	
	  methods: {
	    handleClick: function handleClick(event) {
	      if (!this.disabled) {
	        if (!this.href) {
	          this.$emit('click', event);
	        }
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_link_src_mainvue_type_script_lang_js_ = (link_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/link/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var link_src_main_component = normalizeComponent(
	  packages_link_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_01cf3b65_render,
	  mainvue_type_template_id_01cf3b65_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var link_src_main_api; }
	link_src_main_component.options.__file = "packages/link/src/main.vue"
	/* harmony default export */ var link_src_main = (link_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/link/index.js
	
	
	/* istanbul ignore next */
	link_src_main.install = function (Vue) {
	  Vue.component(link_src_main.name, link_src_main);
	};
	
	/* harmony default export */ var packages_link = (link_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
	var mainvue_type_template_id_7fa02a7e_functional_true_render = function(_h, _vm) {
	  var _c = _vm._c
	  return _c(
	    "div",
	    _vm._g(
	      _vm._b(
	        {
	          class: [
	            _vm.data.staticClass,
	            "el-divider",
	            "el-divider--" + _vm.props.direction
	          ]
	        },
	        "div",
	        _vm.data.attrs,
	        false
	      ),
	      _vm.listeners
	    ),
	    [
	      _vm.slots().default && _vm.props.direction !== "vertical"
	        ? _c(
	            "div",
	            { class: ["el-divider__text", "is-" + _vm.props.contentPosition] },
	            [_vm._t("default")],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns = []
	mainvue_type_template_id_7fa02a7e_functional_true_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var divider_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElDivider',
	  props: {
	    direction: {
	      type: String,
	      default: 'horizontal',
	      validator: function validator(val) {
	        return ['horizontal', 'vertical'].indexOf(val) !== -1;
	      }
	    },
	    contentPosition: {
	      type: String,
	      default: 'center',
	      validator: function validator(val) {
	        return ['left', 'center', 'right'].indexOf(val) !== -1;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_divider_src_mainvue_type_script_lang_js_ = (divider_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/divider/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var divider_src_main_component = normalizeComponent(
	  packages_divider_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_7fa02a7e_functional_true_render,
	  mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns,
	  true,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var divider_src_main_api; }
	divider_src_main_component.options.__file = "packages/divider/src/main.vue"
	/* harmony default export */ var divider_src_main = (divider_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/divider/index.js
	
	
	/* istanbul ignore next */
	divider_src_main.install = function (Vue) {
	  Vue.component(divider_src_main.name, divider_src_main);
	};
	
	/* harmony default export */ var divider = (divider_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
	var mainvue_type_template_id_44d84a7c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    { staticClass: "el-image" },
	    [
	      _vm.loading
	        ? _vm._t("placeholder", [
	            _c("div", { staticClass: "el-image__placeholder" })
	          ])
	        : _vm.error
	        ? _vm._t("error", [
	            _c("div", { staticClass: "el-image__error" }, [
	              _vm._v(_vm._s(_vm.t("el.image.error")))
	            ])
	          ])
	        : _c(
	            "img",
	            _vm._g(
	              _vm._b(
	                {
	                  staticClass: "el-image__inner",
	                  class: {
	                    "el-image__inner--center": _vm.alignCenter,
	                    "el-image__preview": _vm.preview
	                  },
	                  style: _vm.imageStyle,
	                  attrs: { src: _vm.src },
	                  on: { click: _vm.clickHandler }
	                },
	                "img",
	                _vm.$attrs,
	                false
	              ),
	              _vm.$listeners
	            )
	          ),
	      _vm.preview
	        ? [
	            _vm.showViewer
	              ? _c("image-viewer", {
	                  attrs: {
	                    "z-index": _vm.zIndex,
	                    "initial-index": _vm.imageIndex,
	                    "on-close": _vm.closeViewer,
	                    "url-list": _vm.previewSrcList
	                  }
	                })
	              : _vm._e()
	          ]
	        : _vm._e()
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_44d84a7c_staticRenderFns = []
	mainvue_type_template_id_44d84a7c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
	var image_viewervue_type_template_id_5e73b307_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "viewer-fade" } }, [
	    _c(
	      "div",
	      {
	        ref: "el-image-viewer__wrapper",
	        staticClass: "el-image-viewer__wrapper",
	        style: { "z-index": _vm.zIndex },
	        attrs: { tabindex: "-1" }
	      },
	      [
	        _c("div", { staticClass: "el-image-viewer__mask" }),
	        _c(
	          "span",
	          {
	            staticClass: "el-image-viewer__btn el-image-viewer__close",
	            on: { click: _vm.hide }
	          },
	          [_c("i", { staticClass: "el-icon-circle-close" })]
	        ),
	        !_vm.isSingle
	          ? [
	              _c(
	                "span",
	                {
	                  staticClass: "el-image-viewer__btn el-image-viewer__prev",
	                  class: { "is-disabled": !_vm.infinite && _vm.isFirst },
	                  on: { click: _vm.prev }
	                },
	                [_c("i", { staticClass: "el-icon-arrow-left" })]
	              ),
	              _c(
	                "span",
	                {
	                  staticClass: "el-image-viewer__btn el-image-viewer__next",
	                  class: { "is-disabled": !_vm.infinite && _vm.isLast },
	                  on: { click: _vm.next }
	                },
	                [_c("i", { staticClass: "el-icon-arrow-right" })]
	              )
	            ]
	          : _vm._e(),
	        _c(
	          "div",
	          { staticClass: "el-image-viewer__btn el-image-viewer__actions" },
	          [
	            _c("div", { staticClass: "el-image-viewer__actions__inner" }, [
	              _c("i", {
	                staticClass: "el-icon-zoom-out",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("zoomOut")
	                  }
	                }
	              }),
	              _c("i", {
	                staticClass: "el-icon-zoom-in",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("zoomIn")
	                  }
	                }
	              }),
	              _c("i", { staticClass: "el-image-viewer__actions__divider" }),
	              _c("i", { class: _vm.mode.icon, on: { click: _vm.toggleMode } }),
	              _c("i", { staticClass: "el-image-viewer__actions__divider" }),
	              _c("i", {
	                staticClass: "el-icon-refresh-left",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("anticlocelise")
	                  }
	                }
	              }),
	              _c("i", {
	                staticClass: "el-icon-refresh-right",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("clocelise")
	                  }
	                }
	              })
	            ])
	          ]
	        ),
	        _c(
	          "div",
	          { staticClass: "el-image-viewer__canvas" },
	          _vm._l(_vm.urlList, function(url, i) {
	            return i === _vm.index
	              ? _c("img", {
	                  key: url,
	                  ref: "img",
	                  refInFor: true,
	                  staticClass: "el-image-viewer__img",
	                  style: _vm.imgStyle,
	                  attrs: { src: _vm.currentImg },
	                  on: {
	                    load: _vm.handleImgLoad,
	                    error: _vm.handleImgError,
	                    mousedown: _vm.handleMouseDown
	                  }
	                })
	              : _vm._e()
	          }),
	          0
	        )
	      ],
	      2
	    )
	  ])
	}
	var image_viewervue_type_template_id_5e73b307_staticRenderFns = []
	image_viewervue_type_template_id_5e73b307_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
	var image_viewervue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	var Mode = {
	  CONTAIN: {
	    name: 'contain',
	    icon: 'el-icon-full-screen'
	  },
	  ORIGINAL: {
	    name: 'original',
	    icon: 'el-icon-c-scale-to-original'
	  }
	};
	
	var mousewheelEventName = Object(util_["isFirefox"])() ? 'DOMMouseScroll' : 'mousewheel';
	
	/* harmony default export */ var image_viewervue_type_script_lang_js_ = ({
	  name: 'elImageViewer',
	
	  props: {
	    urlList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    zIndex: {
	      type: Number,
	      default: 2000
	    },
	    onSwitch: {
	      type: Function,
	      default: function _default() {}
	    },
	    onClose: {
	      type: Function,
	      default: function _default() {}
	    },
	    initialIndex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      index: this.initialIndex,
	      isShow: false,
	      infinite: true,
	      loading: false,
	      mode: Mode.CONTAIN,
	      transform: {
	        scale: 1,
	        deg: 0,
	        offsetX: 0,
	        offsetY: 0,
	        enableTransition: false
	      }
	    };
	  },
	
	  computed: {
	    isSingle: function isSingle() {
	      return this.urlList.length <= 1;
	    },
	    isFirst: function isFirst() {
	      return this.index === 0;
	    },
	    isLast: function isLast() {
	      return this.index === this.urlList.length - 1;
	    },
	    currentImg: function currentImg() {
	      return this.urlList[this.index];
	    },
	    imgStyle: function imgStyle() {
	      var _transform = this.transform,
	          scale = _transform.scale,
	          deg = _transform.deg,
	          offsetX = _transform.offsetX,
	          offsetY = _transform.offsetY,
	          enableTransition = _transform.enableTransition;
	
	      var style = {
	        transform: 'scale(' + scale + ') rotate(' + deg + 'deg)',
	        transition: enableTransition ? 'transform .3s' : '',
	        'margin-left': offsetX + 'px',
	        'margin-top': offsetY + 'px'
	      };
	      if (this.mode === Mode.CONTAIN) {
	        style.maxWidth = style.maxHeight = '100%';
	      }
	      return style;
	    }
	  },
	  watch: {
	    index: {
	      handler: function handler(val) {
	        this.reset();
	        this.onSwitch(val);
	      }
	    },
	    currentImg: function currentImg(val) {
	      var _this = this;
	
	      this.$nextTick(function (_) {
	        var $img = _this.$refs.img[0];
	        if (!$img.complete) {
	          _this.loading = true;
	        }
	      });
	    }
	  },
	  methods: {
	    hide: function hide() {
	      this.deviceSupportUninstall();
	      this.onClose();
	    },
	    deviceSupportInstall: function deviceSupportInstall() {
	      var _this2 = this;
	
	      this._keyDownHandler = Object(util_["rafThrottle"])(function (e) {
	        var keyCode = e.keyCode;
	        switch (keyCode) {
	          // ESC
	          case 27:
	            _this2.hide();
	            break;
	          // SPACE
	          case 32:
	            _this2.toggleMode();
	            break;
	          // LEFT_ARROW
	          case 37:
	            _this2.prev();
	            break;
	          // UP_ARROW
	          case 38:
	            _this2.handleActions('zoomIn');
	            break;
	          // RIGHT_ARROW
	          case 39:
	            _this2.next();
	            break;
	          // DOWN_ARROW
	          case 40:
	            _this2.handleActions('zoomOut');
	            break;
	        }
	      });
	      this._mouseWheelHandler = Object(util_["rafThrottle"])(function (e) {
	        var delta = e.wheelDelta ? e.wheelDelta : -e.detail;
	        if (delta > 0) {
	          _this2.handleActions('zoomIn', {
	            zoomRate: 0.015,
	            enableTransition: false
	          });
	        } else {
	          _this2.handleActions('zoomOut', {
	            zoomRate: 0.015,
	            enableTransition: false
	          });
	        }
	      });
	      Object(dom_["on"])(document, 'keydown', this._keyDownHandler);
	      Object(dom_["on"])(document, mousewheelEventName, this._mouseWheelHandler);
	    },
	    deviceSupportUninstall: function deviceSupportUninstall() {
	      Object(dom_["off"])(document, 'keydown', this._keyDownHandler);
	      Object(dom_["off"])(document, mousewheelEventName, this._mouseWheelHandler);
	      this._keyDownHandler = null;
	      this._mouseWheelHandler = null;
	    },
	    handleImgLoad: function handleImgLoad(e) {
	      this.loading = false;
	    },
	    handleImgError: function handleImgError(e) {
	      this.loading = false;
	      e.target.alt = '加载失败';
	    },
	    handleMouseDown: function handleMouseDown(e) {
	      var _this3 = this;
	
	      if (this.loading || e.button !== 0) return;
	
	      var _transform2 = this.transform,
	          offsetX = _transform2.offsetX,
	          offsetY = _transform2.offsetY;
	
	      var startX = e.pageX;
	      var startY = e.pageY;
	      this._dragHandler = Object(util_["rafThrottle"])(function (ev) {
	        _this3.transform.offsetX = offsetX + ev.pageX - startX;
	        _this3.transform.offsetY = offsetY + ev.pageY - startY;
	      });
	      Object(dom_["on"])(document, 'mousemove', this._dragHandler);
	      Object(dom_["on"])(document, 'mouseup', function (ev) {
	        Object(dom_["off"])(document, 'mousemove', _this3._dragHandler);
	      });
	
	      e.preventDefault();
	    },
	    reset: function reset() {
	      this.transform = {
	        scale: 1,
	        deg: 0,
	        offsetX: 0,
	        offsetY: 0,
	        enableTransition: false
	      };
	    },
	    toggleMode: function toggleMode() {
	      if (this.loading) return;
	
	      var modeNames = Object.keys(Mode);
	      var modeValues = Object.values(Mode);
	      var index = modeValues.indexOf(this.mode);
	      var nextIndex = (index + 1) % modeNames.length;
	      this.mode = Mode[modeNames[nextIndex]];
	      this.reset();
	    },
	    prev: function prev() {
	      if (this.isFirst && !this.infinite) return;
	      var len = this.urlList.length;
	      this.index = (this.index - 1 + len) % len;
	    },
	    next: function next() {
	      if (this.isLast && !this.infinite) return;
	      var len = this.urlList.length;
	      this.index = (this.index + 1) % len;
	    },
	    handleActions: function handleActions(action) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.loading) return;
	
	      var _zoomRate$rotateDeg$e = image_viewervue_type_script_lang_js_extends({
	        zoomRate: 0.2,
	        rotateDeg: 90,
	        enableTransition: true
	      }, options),
	          zoomRate = _zoomRate$rotateDeg$e.zoomRate,
	          rotateDeg = _zoomRate$rotateDeg$e.rotateDeg,
	          enableTransition = _zoomRate$rotateDeg$e.enableTransition;
	
	      var transform = this.transform;
	
	      switch (action) {
	        case 'zoomOut':
	          if (transform.scale > 0.2) {
	            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
	          }
	          break;
	        case 'zoomIn':
	          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
	          break;
	        case 'clocelise':
	          transform.deg += rotateDeg;
	          break;
	        case 'anticlocelise':
	          transform.deg -= rotateDeg;
	          break;
	      }
	      transform.enableTransition = enableTransition;
	    }
	  },
	  mounted: function mounted() {
	    this.deviceSupportInstall();
	    // add tabindex then wrapper can be focusable via Javascript
	    // focus wrapper so arrow key can't cause inner scroll behavior underneath
	    this.$refs['el-image-viewer__wrapper'].focus();
	  }
	});
	// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_image_viewervue_type_script_lang_js_ = (image_viewervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue
	
	
	
	
	
	/* normalize component */
	
	var image_viewer_component = normalizeComponent(
	  src_image_viewervue_type_script_lang_js_,
	  image_viewervue_type_template_id_5e73b307_render,
	  image_viewervue_type_template_id_5e73b307_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var image_viewer_api; }
	image_viewer_component.options.__file = "packages/image/src/image-viewer.vue"
	/* harmony default export */ var image_viewer = (image_viewer_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	var isSupportObjectFit = function isSupportObjectFit() {
	  return document.documentElement.style.objectFit !== undefined;
	};
	
	var ObjectFit = {
	  NONE: 'none',
	  CONTAIN: 'contain',
	  COVER: 'cover',
	  FILL: 'fill',
	  SCALE_DOWN: 'scale-down'
	};
	
	var prevOverflow = '';
	
	/* harmony default export */ var image_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElImage',
	
	  mixins: [locale_default.a],
	  inheritAttrs: false,
	
	  components: {
	    ImageViewer: image_viewer
	  },
	
	  props: {
	    src: String,
	    fit: String,
	    lazy: Boolean,
	    scrollContainer: {},
	    previewSrcList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    zIndex: {
	      type: Number,
	      default: 2000
	    }
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      error: false,
	      show: !this.lazy,
	      imageWidth: 0,
	      imageHeight: 0,
	      showViewer: false
	    };
	  },
	
	
	  computed: {
	    imageStyle: function imageStyle() {
	      var fit = this.fit;
	
	      if (!this.$isServer && fit) {
	        return isSupportObjectFit() ? { 'object-fit': fit } : this.getImageStyle(fit);
	      }
	      return {};
	    },
	    alignCenter: function alignCenter() {
	      return !this.$isServer && !isSupportObjectFit() && this.fit !== ObjectFit.FILL;
	    },
	    preview: function preview() {
	      var previewSrcList = this.previewSrcList;
	
	      return Array.isArray(previewSrcList) && previewSrcList.length > 0;
	    },
	    imageIndex: function imageIndex() {
	      var previewIndex = 0;
	      var srcIndex = this.previewSrcList.indexOf(this.src);
	      if (srcIndex >= 0) {
	        previewIndex = srcIndex;
	      }
	      return previewIndex;
	    }
	  },
	
	  watch: {
	    src: function src(val) {
	      this.show && this.loadImage();
	    },
	    show: function show(val) {
	      val && this.loadImage();
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.lazy) {
	      this.addLazyLoadListener();
	    } else {
	      this.loadImage();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.lazy && this.removeLazyLoadListener();
	  },
	
	
	  methods: {
	    loadImage: function loadImage() {
	      var _this = this;
	
	      if (this.$isServer) return;
	
	      // reset status
	      this.loading = true;
	      this.error = false;
	
	      var img = new Image();
	      img.onload = function (e) {
	        return _this.handleLoad(e, img);
	      };
	      img.onerror = this.handleError.bind(this);
	
	      // bind html attrs
	      // so it can behave consistently
	      Object.keys(this.$attrs).forEach(function (key) {
	        var value = _this.$attrs[key];
	        img.setAttribute(key, value);
	      });
	      img.src = this.src;
	    },
	    handleLoad: function handleLoad(e, img) {
	      this.imageWidth = img.width;
	      this.imageHeight = img.height;
	      this.loading = false;
	      this.error = false;
	    },
	    handleError: function handleError(e) {
	      this.loading = false;
	      this.error = true;
	      this.$emit('error', e);
	    },
	    handleLazyLoad: function handleLazyLoad() {
	      if (Object(dom_["isInContainer"])(this.$el, this._scrollContainer)) {
	        this.show = true;
	        this.removeLazyLoadListener();
	      }
	    },
	    addLazyLoadListener: function addLazyLoadListener() {
	      if (this.$isServer) return;
	
	      var scrollContainer = this.scrollContainer;
	
	      var _scrollContainer = null;
	
	      if (Object(types_["isHtmlElement"])(scrollContainer)) {
	        _scrollContainer = scrollContainer;
	      } else if (Object(types_["isString"])(scrollContainer)) {
	        _scrollContainer = document.querySelector(scrollContainer);
	      } else {
	        _scrollContainer = Object(dom_["getScrollContainer"])(this.$el);
	      }
	
	      if (_scrollContainer) {
	        this._scrollContainer = _scrollContainer;
	        this._lazyLoadHandler = throttle_default()(200, this.handleLazyLoad);
	        Object(dom_["on"])(_scrollContainer, 'scroll', this._lazyLoadHandler);
	        this.handleLazyLoad();
	      }
	    },
	    removeLazyLoadListener: function removeLazyLoadListener() {
	      var _scrollContainer = this._scrollContainer,
	          _lazyLoadHandler = this._lazyLoadHandler;
	
	
	      if (this.$isServer || !_scrollContainer || !_lazyLoadHandler) return;
	
	      Object(dom_["off"])(_scrollContainer, 'scroll', _lazyLoadHandler);
	      this._scrollContainer = null;
	      this._lazyLoadHandler = null;
	    },
	
	    /**
	     * simulate object-fit behavior to compatible with IE11 and other browsers which not support object-fit
	     */
	    getImageStyle: function getImageStyle(fit) {
	      var imageWidth = this.imageWidth,
	          imageHeight = this.imageHeight;
	      var _$el = this.$el,
	          containerWidth = _$el.clientWidth,
	          containerHeight = _$el.clientHeight;
	
	
	      if (!imageWidth || !imageHeight || !containerWidth || !containerHeight) return {};
	
	      var vertical = imageWidth / imageHeight < 1;
	
	      if (fit === ObjectFit.SCALE_DOWN) {
	        var isSmaller = imageWidth < containerWidth && imageHeight < containerHeight;
	        fit = isSmaller ? ObjectFit.NONE : ObjectFit.CONTAIN;
	      }
	
	      switch (fit) {
	        case ObjectFit.NONE:
	          return { width: 'auto', height: 'auto' };
	        case ObjectFit.CONTAIN:
	          return vertical ? { width: 'auto' } : { height: 'auto' };
	        case ObjectFit.COVER:
	          return vertical ? { height: 'auto' } : { width: 'auto' };
	        default:
	          return {};
	      }
	    },
	    clickHandler: function clickHandler() {
	      // don't show viewer when preview is false
	      if (!this.preview) {
	        return;
	      }
	      // prevent body scroll
	      prevOverflow = document.body.style.overflow;
	      document.body.style.overflow = 'hidden';
	      this.showViewer = true;
	    },
	    closeViewer: function closeViewer() {
	      document.body.style.overflow = prevOverflow;
	      this.showViewer = false;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_image_src_mainvue_type_script_lang_js_ = (image_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/image/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var image_src_main_component = normalizeComponent(
	  packages_image_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_44d84a7c_render,
	  mainvue_type_template_id_44d84a7c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var image_src_main_api; }
	image_src_main_component.options.__file = "packages/image/src/main.vue"
	/* harmony default export */ var image_src_main = (image_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/image/index.js
	
	
	/* istanbul ignore next */
	image_src_main.install = function (Vue) {
	  Vue.component(image_src_main.name, image_src_main);
	};
	
	/* harmony default export */ var packages_image = (image_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
	var mainvue_type_template_id_6d9756be_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-calendar" }, [
	    _c("div", { staticClass: "el-calendar__header" }, [
	      _c("div", { staticClass: "el-calendar__title" }, [
	        _vm._v("\n      " + _vm._s(_vm.i18nDate) + "\n    ")
	      ]),
	      _vm.validatedRange.length === 0
	        ? _c(
	            "div",
	            { staticClass: "el-calendar__button-group" },
	            [
	              _c(
	                "el-button-group",
	                [
	                  _c(
	                    "el-button",
	                    {
	                      attrs: { type: "plain", size: "mini" },
	                      on: {
	                        click: function($event) {
	                          _vm.selectDate("prev-month")
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.t("el.datepicker.prevMonth")) +
	                          "\n        "
	                      )
	                    ]
	                  ),
	                  _c(
	                    "el-button",
	                    {
	                      attrs: { type: "plain", size: "mini" },
	                      on: {
	                        click: function($event) {
	                          _vm.selectDate("today")
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.t("el.datepicker.today")) +
	                          "\n        "
	                      )
	                    ]
	                  ),
	                  _c(
	                    "el-button",
	                    {
	                      attrs: { type: "plain", size: "mini" },
	                      on: {
	                        click: function($event) {
	                          _vm.selectDate("next-month")
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.t("el.datepicker.nextMonth")) +
	                          "\n        "
	                      )
	                    ]
	                  )
	                ],
	                1
	              )
	            ],
	            1
	          )
	        : _vm._e()
	    ]),
	    _vm.validatedRange.length === 0
	      ? _c(
	          "div",
	          { key: "no-range", staticClass: "el-calendar__body" },
	          [
	            _c("date-table", {
	              attrs: {
	                date: _vm.date,
	                "selected-day": _vm.realSelectedDay,
	                "first-day-of-week": _vm.realFirstDayOfWeek
	              },
	              on: { pick: _vm.pickDay }
	            })
	          ],
	          1
	        )
	      : _c(
	          "div",
	          { key: "has-range", staticClass: "el-calendar__body" },
	          _vm._l(_vm.validatedRange, function(range, index) {
	            return _c("date-table", {
	              key: index,
	              attrs: {
	                date: range[0],
	                "selected-day": _vm.realSelectedDay,
	                range: range,
	                "hide-header": index !== 0,
	                "first-day-of-week": _vm.realFirstDayOfWeek
	              },
	              on: { pick: _vm.pickDay }
	            })
	          }),
	          1
	        )
	  ])
	}
	var mainvue_type_template_id_6d9756be_staticRenderFns = []
	mainvue_type_template_id_6d9756be_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/date"
	var date_ = __webpack_require__(20);
	var date_default = /*#__PURE__*/__webpack_require__.n(date_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
	
	
	
	
	/* harmony default export */ var src_date_tablevue_type_script_lang_js_ = ({
	  props: {
	    selectedDay: String, // formated date yyyy-MM-dd
	    range: {
	      type: Array,
	      validator: function validator(val) {
	        if (!(val && val.length)) return true;
	        var start = val[0],
	            end = val[1];
	
	        return Object(date_util_["validateRangeInOneMonth"])(start, end);
	      }
	    },
	    date: Date,
	    hideHeader: Boolean,
	    firstDayOfWeek: Number
	  },
	
	  inject: ['elCalendar'],
	
	  data: function data() {
	    return {
	      WEEK_DAYS: Object(date_util_["getI18nSettings"])().dayNames
	    };
	  },
	
	
	  methods: {
	    toNestedArr: function toNestedArr(days) {
	      return Object(date_util_["range"])(days.length / 7).map(function (_, index) {
	        var start = index * 7;
	        return days.slice(start, start + 7);
	      });
	    },
	    getFormateDate: function getFormateDate(day, type) {
	      if (!day || ['prev', 'current', 'next'].indexOf(type) === -1) {
	        throw new Error('invalid day or type');
	      }
	      var prefix = this.curMonthDatePrefix;
	      if (type === 'prev') {
	        prefix = this.prevMonthDatePrefix;
	      } else if (type === 'next') {
	        prefix = this.nextMonthDatePrefix;
	      }
	      day = ('00' + day).slice(-2);
	      return prefix + '-' + day;
	    },
	    getCellClass: function getCellClass(_ref) {
	      var text = _ref.text,
	          type = _ref.type;
	
	      var classes = [type];
	      if (type === 'current') {
	        var date = this.getFormateDate(text, type);
	        if (date === this.selectedDay) {
	          classes.push('is-selected');
	        }
	        if (date === this.formatedToday) {
	          classes.push('is-today');
	        }
	      }
	      return classes;
	    },
	    pickDay: function pickDay(_ref2) {
	      var text = _ref2.text,
	          type = _ref2.type;
	
	      var date = this.getFormateDate(text, type);
	      this.$emit('pick', date);
	    },
	    cellRenderProxy: function cellRenderProxy(_ref3) {
	      var text = _ref3.text,
	          type = _ref3.type;
	      var h = this.$createElement;
	
	      var render = this.elCalendar.$scopedSlots.dateCell;
	      if (!render) return h('span', [text]);
	
	      var day = this.getFormateDate(text, type);
	      var date = new Date(day);
	      var data = {
	        isSelected: this.selectedDay === day,
	        type: type + '-month',
	        day: day
	      };
	      return render({ date: date, data: data });
	    }
	  },
	
	  computed: {
	    prevMonthDatePrefix: function prevMonthDatePrefix() {
	      var temp = new Date(this.date.getTime());
	      temp.setDate(0);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    curMonthDatePrefix: function curMonthDatePrefix() {
	      return date_default.a.format(this.date, 'yyyy-MM');
	    },
	    nextMonthDatePrefix: function nextMonthDatePrefix() {
	      var temp = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    formatedToday: function formatedToday() {
	      return this.elCalendar.formatedToday;
	    },
	    isInRange: function isInRange() {
	      return this.range && this.range.length;
	    },
	    rows: function rows() {
	      var days = [];
	      // if range exists, should render days in range.
	      if (this.isInRange) {
	        var _range = this.range,
	            start = _range[0],
	            end = _range[1];
	
	        var currentMonthRange = Object(date_util_["range"])(end.getDate() - start.getDate() + 1).map(function (_, index) {
	          return {
	            text: start.getDate() + index,
	            type: 'current'
	          };
	        });
	        var remaining = currentMonthRange.length % 7;
	        remaining = remaining === 0 ? 0 : 7 - remaining;
	        var nextMonthRange = Object(date_util_["range"])(remaining).map(function (_, index) {
	          return {
	            text: index + 1,
	            type: 'next'
	          };
	        });
	        days = currentMonthRange.concat(nextMonthRange);
	      } else {
	        var date = this.date;
	        var firstDay = Object(date_util_["getFirstDayOfMonth"])(date);
	        firstDay = firstDay === 0 ? 7 : firstDay;
	        var firstDayOfWeek = typeof this.firstDayOfWeek === 'number' ? this.firstDayOfWeek : 1;
	        var prevMonthDays = Object(date_util_["getPrevMonthLastDays"])(date, firstDay - firstDayOfWeek).map(function (day) {
	          return {
	            text: day,
	            type: 'prev'
	          };
	        });
	        var currentMonthDays = Object(date_util_["getMonthDays"])(date).map(function (day) {
	          return {
	            text: day,
	            type: 'current'
	          };
	        });
	        days = [].concat(prevMonthDays, currentMonthDays);
	        var nextMonthDays = Object(date_util_["range"])(42 - days.length).map(function (_, index) {
	          return {
	            text: index + 1,
	            type: 'next'
	          };
	        });
	        days = days.concat(nextMonthDays);
	      }
	      return this.toNestedArr(days);
	    },
	    weekDays: function weekDays() {
	      var start = this.firstDayOfWeek;
	      var WEEK_DAYS = this.WEEK_DAYS;
	
	
	      if (typeof start !== 'number' || start === 0) {
	        return WEEK_DAYS.slice();
	      } else {
	        return WEEK_DAYS.slice(start).concat(WEEK_DAYS.slice(0, start));
	      }
	    }
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var h = arguments[0];
	
	    var thead = this.hideHeader ? null : h('thead', [this.weekDays.map(function (day) {
	      return h(
	        'th',
	        { key: day },
	        [day]
	      );
	    })]);
	    return h(
	      'table',
	      {
	        'class': {
	          'el-calendar-table': true,
	          'is-range': this.isInRange
	        },
	        attrs: { cellspacing: '0',
	          cellpadding: '0' }
	      },
	      [thead, h('tbody', [this.rows.map(function (row, index) {
	        return h(
	          'tr',
	          {
	            'class': {
	              'el-calendar-table__row': true,
	              'el-calendar-table__row--hide-border': index === 0 && _this.hideHeader
	            },
	            key: index },
	          [row.map(function (cell, key) {
	            return h(
	              'td',
	              { key: key,
	                'class': _this.getCellClass(cell),
	                on: {
	                  'click': _this.pickDay.bind(_this, cell)
	                }
	              },
	              [h(
	                'div',
	                { 'class': 'el-calendar-day' },
	                [_this.cellRenderProxy(cell)]
	              )]
	            );
	          })]
	        );
	      })])]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var calendar_src_date_tablevue_type_script_lang_js_ = (src_date_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue
	var date_table_render, date_table_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var src_date_table_component = normalizeComponent(
	  calendar_src_date_tablevue_type_script_lang_js_,
	  date_table_render,
	  date_table_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_date_table_api; }
	src_date_table_component.options.__file = "packages/calendar/src/date-table.vue"
	/* harmony default export */ var src_date_table = (src_date_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var validTypes = ['prev-month', 'today', 'next-month'];
	var weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	var oneDay = 86400000;
	
	/* harmony default export */ var calendar_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElCalendar',
	
	  mixins: [locale_default.a],
	
	  components: {
	    DateTable: src_date_table,
	    ElButton: button_default.a,
	    ElButtonGroup: button_group_default.a
	  },
	
	  props: {
	    value: [Date, String, Number],
	    range: {
	      type: Array,
	      validator: function validator(range) {
	        if (Array.isArray(range)) {
	          return range.length === 2 && range.every(function (item) {
	            return typeof item === 'string' || typeof item === 'number' || item instanceof Date;
	          });
	        } else {
	          return true;
	        }
	      }
	    },
	    firstDayOfWeek: {
	      type: Number,
	      default: 1
	    }
	  },
	
	  provide: function provide() {
	    return {
	      elCalendar: this
	    };
	  },
	
	
	  methods: {
	    pickDay: function pickDay(day) {
	      this.realSelectedDay = day;
	    },
	    selectDate: function selectDate(type) {
	      if (validTypes.indexOf(type) === -1) {
	        throw new Error('invalid type ' + type);
	      }
	      var day = '';
	      if (type === 'prev-month') {
	        day = this.prevMonthDatePrefix + '-01';
	      } else if (type === 'next-month') {
	        day = this.nextMonthDatePrefix + '-01';
	      } else {
	        day = this.formatedToday;
	      }
	
	      if (day === this.formatedDate) return;
	      this.pickDay(day);
	    },
	    toDate: function toDate(val) {
	      if (!val) {
	        throw new Error('invalid val');
	      }
	      return val instanceof Date ? val : new Date(val);
	    },
	    rangeValidator: function rangeValidator(date, isStart) {
	      var firstDayOfWeek = this.realFirstDayOfWeek;
	      var expected = isStart ? firstDayOfWeek : firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
	      var message = (isStart ? 'start' : 'end') + ' of range should be ' + weekDays[expected] + '.';
	      if (date.getDay() !== expected) {
	        console.warn('[ElementCalendar]', message, 'Invalid range will be ignored.');
	        return false;
	      }
	      return true;
	    }
	  },
	
	  computed: {
	    prevMonthDatePrefix: function prevMonthDatePrefix() {
	      var temp = new Date(this.date.getTime());
	      temp.setDate(0);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    curMonthDatePrefix: function curMonthDatePrefix() {
	      return date_default.a.format(this.date, 'yyyy-MM');
	    },
	    nextMonthDatePrefix: function nextMonthDatePrefix() {
	      var temp = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    formatedDate: function formatedDate() {
	      return date_default.a.format(this.date, 'yyyy-MM-dd');
	    },
	    i18nDate: function i18nDate() {
	      var year = this.date.getFullYear();
	      var month = this.date.getMonth() + 1;
	      return year + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + month);
	    },
	    formatedToday: function formatedToday() {
	      return date_default.a.format(this.now, 'yyyy-MM-dd');
	    },
	
	
	    realSelectedDay: {
	      get: function get() {
	        if (!this.value) return this.selectedDay;
	        return this.formatedDate;
	      },
	      set: function set(val) {
	        this.selectedDay = val;
	        var date = new Date(val);
	        this.$emit('input', date);
	      }
	    },
	
	    date: function date() {
	      if (!this.value) {
	        if (this.realSelectedDay) {
	          var d = this.selectedDay.split('-');
	          return new Date(d[0], d[1] - 1, d[2]);
	        } else if (this.validatedRange.length) {
	          return this.validatedRange[0][0];
	        }
	        return this.now;
	      } else {
	        return this.toDate(this.value);
	      }
	    },
	
	
	    // if range is valid, we get a two-digit array
	    validatedRange: function validatedRange() {
	      var _this = this;
	
	      var range = this.range;
	      if (!range) return [];
	      range = range.reduce(function (prev, val, index) {
	        var date = _this.toDate(val);
	        if (_this.rangeValidator(date, index === 0)) {
	          prev = prev.concat(date);
	        }
	        return prev;
	      }, []);
	      if (range.length === 2) {
	        var _range = range,
	            start = _range[0],
	            end = _range[1];
	
	        if (start > end) {
	          console.warn('[ElementCalendar]end time should be greater than start time');
	          return [];
	        }
	        // start time and end time in one month
	        if (Object(date_util_["validateRangeInOneMonth"])(start, end)) {
	          return [[start, end]];
	        }
	        var data = [];
	        var startDay = new Date(start.getFullYear(), start.getMonth() + 1, 1);
	        var lastDay = this.toDate(startDay.getTime() - oneDay);
	        if (!Object(date_util_["validateRangeInOneMonth"])(startDay, end)) {
	          console.warn('[ElementCalendar]start time and end time interval must not exceed two months');
	          return [];
	        }
	        // 第一个月的时间范围
	        data.push([start, lastDay]);
	        // 下一月的时间范围，需要计算一下该月的第一个周起始日
	        var firstDayOfWeek = this.realFirstDayOfWeek;
	        var nextMontFirstDay = startDay.getDay();
	        var interval = 0;
	        if (nextMontFirstDay !== firstDayOfWeek) {
	          if (firstDayOfWeek === 0) {
	            interval = 7 - nextMontFirstDay;
	          } else {
	            interval = firstDayOfWeek - nextMontFirstDay;
	            interval = interval > 0 ? interval : 7 + interval;
	          }
	        }
	        startDay = this.toDate(startDay.getTime() + interval * oneDay);
	        if (startDay.getDate() < end.getDate()) {
	          data.push([startDay, end]);
	        }
	        return data;
	      }
	      return [];
	    },
	    realFirstDayOfWeek: function realFirstDayOfWeek() {
	      if (this.firstDayOfWeek < 1 || this.firstDayOfWeek > 6) {
	        return 0;
	      }
	      return Math.floor(this.firstDayOfWeek);
	    }
	  },
	
	  data: function data() {
	    return {
	      selectedDay: '',
	      now: new Date()
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_calendar_src_mainvue_type_script_lang_js_ = (calendar_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/calendar/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var calendar_src_main_component = normalizeComponent(
	  packages_calendar_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_6d9756be_render,
	  mainvue_type_template_id_6d9756be_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var calendar_src_main_api; }
	calendar_src_main_component.options.__file = "packages/calendar/src/main.vue"
	/* harmony default export */ var calendar_src_main = (calendar_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/calendar/index.js
	
	
	/* istanbul ignore next */
	calendar_src_main.install = function (Vue) {
	  Vue.component(calendar_src_main.name, calendar_src_main);
	};
	
	/* harmony default export */ var calendar = (calendar_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
	var mainvue_type_template_id_257dd4a9_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-fade-in" } }, [
	    _vm.visible
	      ? _c(
	          "div",
	          {
	            staticClass: "el-backtop",
	            style: {
	              right: _vm.styleRight,
	              bottom: _vm.styleBottom
	            },
	            on: {
	              click: function($event) {
	                $event.stopPropagation()
	                return _vm.handleClick($event)
	              }
	            }
	          },
	          [
	            _vm._t("default", [_c("el-icon", { attrs: { name: "caret-top" } })])
	          ],
	          2
	        )
	      : _vm._e()
	  ])
	}
	var mainvue_type_template_id_257dd4a9_staticRenderFns = []
	mainvue_type_template_id_257dd4a9_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	var cubic = function cubic(value) {
	  return Math.pow(value, 3);
	};
	var easeInOutCubic = function easeInOutCubic(value) {
	  return value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2;
	};
	
	/* harmony default export */ var backtop_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElBacktop',
	
	  props: {
	    visibilityHeight: {
	      type: Number,
	      default: 200
	    },
	    target: [String],
	    right: {
	      type: Number,
	      default: 40
	    },
	    bottom: {
	      type: Number,
	      default: 40
	    }
	  },
	
	  data: function data() {
	    return {
	      el: null,
	      container: null,
	      visible: false
	    };
	  },
	
	
	  computed: {
	    styleBottom: function styleBottom() {
	      return this.bottom + 'px';
	    },
	    styleRight: function styleRight() {
	      return this.right + 'px';
	    }
	  },
	
	  mounted: function mounted() {
	    this.init();
	    this.throttledScrollHandler = throttle_default()(300, this.onScroll);
	    this.container.addEventListener('scroll', this.throttledScrollHandler);
	  },
	
	
	  methods: {
	    init: function init() {
	      this.container = document;
	      this.el = document.documentElement;
	      if (this.target) {
	        this.el = document.querySelector(this.target);
	        if (!this.el) {
	          throw new Error('target is not existed: ' + this.target);
	        }
	        this.container = this.el;
	      }
	    },
	    onScroll: function onScroll() {
	      var scrollTop = this.el.scrollTop;
	      this.visible = scrollTop >= this.visibilityHeight;
	    },
	    handleClick: function handleClick(e) {
	      this.scrollToTop();
	      this.$emit('click', e);
	    },
	    scrollToTop: function scrollToTop() {
	      var el = this.el;
	      var beginTime = Date.now();
	      var beginValue = el.scrollTop;
	      var rAF = window.requestAnimationFrame || function (func) {
	        return setTimeout(func, 16);
	      };
	      var frameFunc = function frameFunc() {
	        var progress = (Date.now() - beginTime) / 500;
	        if (progress < 1) {
	          el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
	          rAF(frameFunc);
	        } else {
	          el.scrollTop = 0;
	        }
	      };
	      rAF(frameFunc);
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.container.removeEventListener('scroll', this.throttledScrollHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_backtop_src_mainvue_type_script_lang_js_ = (backtop_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/backtop/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var backtop_src_main_component = normalizeComponent(
	  packages_backtop_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_257dd4a9_render,
	  mainvue_type_template_id_257dd4a9_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var backtop_src_main_api; }
	backtop_src_main_component.options.__file = "packages/backtop/src/main.vue"
	/* harmony default export */ var backtop_src_main = (backtop_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/backtop/index.js
	
	
	/* istanbul ignore next */
	backtop_src_main.install = function (Vue) {
	  Vue.component(backtop_src_main.name, backtop_src_main);
	};
	
	/* harmony default export */ var backtop = (backtop_src_main);
	// CONCATENATED MODULE: ./packages/infinite-scroll/src/main.js
	
	
	
	
	var getStyleComputedProperty = function getStyleComputedProperty(element, property) {
	  if (element === window) {
	    element = document.documentElement;
	  }
	
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	};
	
	var entries = function entries(obj) {
	  return Object.keys(obj || {}).map(function (key) {
	    return [key, obj[key]];
	  });
	};
	
	var getPositionSize = function getPositionSize(el, prop) {
	  return el === window || el === document ? document.documentElement[prop] : el[prop];
	};
	
	var getOffsetHeight = function getOffsetHeight(el) {
	  return getPositionSize(el, 'offsetHeight');
	};
	
	var getClientHeight = function getClientHeight(el) {
	  return getPositionSize(el, 'clientHeight');
	};
	
	var scope = 'ElInfiniteScroll';
	var attributes = {
	  delay: {
	    type: Number,
	    default: 200
	  },
	  distance: {
	    type: Number,
	    default: 0
	  },
	  disabled: {
	    type: Boolean,
	    default: false
	  },
	  immediate: {
	    type: Boolean,
	    default: true
	  }
	};
	
	var main_getScrollOptions = function getScrollOptions(el, vm) {
	  if (!Object(types_["isHtmlElement"])(el)) return {};
	
	  return entries(attributes).reduce(function (map, _ref) {
	    var key = _ref[0],
	        option = _ref[1];
	    var type = option.type,
	        defaultValue = option.default;
	
	    var value = el.getAttribute('infinite-scroll-' + key);
	    value = Object(types_["isUndefined"])(vm[value]) ? value : vm[value];
	    switch (type) {
	      case Number:
	        value = Number(value);
	        value = Number.isNaN(value) ? defaultValue : value;
	        break;
	      case Boolean:
	        value = Object(types_["isDefined"])(value) ? value === 'false' ? false : Boolean(value) : defaultValue;
	        break;
	      default:
	        value = type(value);
	    }
	    map[key] = value;
	    return map;
	  }, {});
	};
	
	var getElementTop = function getElementTop(el) {
	  return el.getBoundingClientRect().top;
	};
	
	var main_handleScroll = function handleScroll(cb) {
	  var _scope = this[scope],
	      el = _scope.el,
	      vm = _scope.vm,
	      container = _scope.container,
	      observer = _scope.observer;
	
	  var _getScrollOptions = main_getScrollOptions(el, vm),
	      distance = _getScrollOptions.distance,
	      disabled = _getScrollOptions.disabled;
	
	  if (disabled) return;
	
	  var containerInfo = container.getBoundingClientRect();
	  if (!containerInfo.width && !containerInfo.height) return;
	
	  var shouldTrigger = false;
	
	  if (container === el) {
	    // be aware of difference between clientHeight & offsetHeight & window.getComputedStyle().height
	    var scrollBottom = container.scrollTop + getClientHeight(container);
	    shouldTrigger = container.scrollHeight - scrollBottom <= distance;
	  } else {
	    var heightBelowTop = getOffsetHeight(el) + getElementTop(el) - getElementTop(container);
	    var offsetHeight = getOffsetHeight(container);
	    var borderBottom = Number.parseFloat(getStyleComputedProperty(container, 'borderBottomWidth'));
	    shouldTrigger = heightBelowTop - offsetHeight + borderBottom <= distance;
	  }
	
	  if (shouldTrigger && Object(types_["isFunction"])(cb)) {
	    cb.call(vm);
	  } else if (observer) {
	    observer.disconnect();
	    this[scope].observer = null;
	  }
	};
	
	/* harmony default export */ var infinite_scroll_src_main = ({
	  name: 'InfiniteScroll',
	  inserted: function inserted(el, binding, vnode) {
	    var cb = binding.value;
	
	    var vm = vnode.context;
	    // only include vertical scroll
	    var container = Object(dom_["getScrollContainer"])(el, true);
	
	    var _getScrollOptions2 = main_getScrollOptions(el, vm),
	        delay = _getScrollOptions2.delay,
	        immediate = _getScrollOptions2.immediate;
	
	    var onScroll = debounce_default()(delay, main_handleScroll.bind(el, cb));
	
	    el[scope] = { el: el, vm: vm, container: container, onScroll: onScroll };
	
	    if (container) {
	      container.addEventListener('scroll', onScroll);
	
	      if (immediate) {
	        var observer = el[scope].observer = new MutationObserver(onScroll);
	        observer.observe(container, { childList: true, subtree: true });
	        onScroll();
	      }
	    }
	  },
	  unbind: function unbind(el) {
	    var _el$scope = el[scope],
	        container = _el$scope.container,
	        onScroll = _el$scope.onScroll;
	
	    if (container) {
	      container.removeEventListener('scroll', onScroll);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/infinite-scroll/index.js
	
	
	/* istanbul ignore next */
	infinite_scroll_src_main.install = function (Vue) {
	  Vue.directive(infinite_scroll_src_main.name, infinite_scroll_src_main);
	};
	
	/* harmony default export */ var infinite_scroll = (infinite_scroll_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
	var mainvue_type_template_id_5070954c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-page-header" }, [
	    _c(
	      "div",
	      {
	        staticClass: "el-page-header__left",
	        on: {
	          click: function($event) {
	            _vm.$emit("back")
	          }
	        }
	      },
	      [
	        _c("i", { staticClass: "el-icon-back" }),
	        _c(
	          "div",
	          { staticClass: "el-page-header__title" },
	          [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
	          2
	        )
	      ]
	    ),
	    _c(
	      "div",
	      { staticClass: "el-page-header__content" },
	      [_vm._t("content", [_vm._v(_vm._s(_vm.content))])],
	      2
	    )
	  ])
	}
	var mainvue_type_template_id_5070954c_staticRenderFns = []
	mainvue_type_template_id_5070954c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	/* harmony default export */ var page_header_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElPageHeader',
	
	  props: {
	    title: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.pageHeader.title');
	      }
	    },
	    content: String
	  }
	});
	// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_page_header_src_mainvue_type_script_lang_js_ = (page_header_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/page-header/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var page_header_src_main_component = normalizeComponent(
	  packages_page_header_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5070954c_render,
	  mainvue_type_template_id_5070954c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var page_header_src_main_api; }
	page_header_src_main_component.options.__file = "packages/page-header/src/main.vue"
	/* harmony default export */ var page_header_src_main = (page_header_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/page-header/index.js
	
	
	/* istanbul ignore next */
	page_header_src_main.install = function (Vue) {
	  Vue.component(page_header_src_main.name, page_header_src_main);
	};
	
	/* harmony default export */ var page_header = (page_header_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	var cascader_panelvue_type_template_id_34932346_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: ["el-cascader-panel", _vm.border && "is-bordered"],
	      on: { keydown: _vm.handleKeyDown }
	    },
	    _vm._l(_vm.menus, function(menu, index) {
	      return _c("cascader-menu", {
	        key: index,
	        ref: "menu",
	        refInFor: true,
	        attrs: { index: index, nodes: menu }
	      })
	    }),
	    1
	  )
	}
	var cascader_panelvue_type_template_id_34932346_staticRenderFns = []
	cascader_panelvue_type_template_id_34932346_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	
	// EXTERNAL MODULE: external "element-ui/lib/radio"
	var radio_ = __webpack_require__(43);
	var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	
	/* harmony default export */ var cascader_nodevue_type_script_lang_js_ = ({
	  inject: ['panel'],
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElRadio: radio_default.a
	  },
	
	  props: {
	    node: {
	      required: true
	    },
	    nodeId: String
	  },
	
	  computed: {
	    config: function config() {
	      return this.panel.config;
	    },
	    isLeaf: function isLeaf() {
	      return this.node.isLeaf;
	    },
	    isDisabled: function isDisabled() {
	      return this.node.isDisabled;
	    },
	    checkedValue: function checkedValue() {
	      return this.panel.checkedValue;
	    },
	    isChecked: function isChecked() {
	      return this.node.isSameNode(this.checkedValue);
	    },
	    inActivePath: function inActivePath() {
	      return this.isInPath(this.panel.activePath);
	    },
	    inCheckedPath: function inCheckedPath() {
	      var _this = this;
	
	      if (!this.config.checkStrictly) return false;
	
	      return this.panel.checkedNodePaths.some(function (checkedPath) {
	        return _this.isInPath(checkedPath);
	      });
	    },
	    value: function value() {
	      return this.node.getValueByOption();
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand() {
	      var _this2 = this;
	
	      var panel = this.panel,
	          node = this.node,
	          isDisabled = this.isDisabled,
	          config = this.config;
	      var multiple = config.multiple,
	          checkStrictly = config.checkStrictly;
	
	
	      if (!checkStrictly && isDisabled || node.loading) return;
	
	      if (config.lazy && !node.loaded) {
	        panel.lazyLoad(node, function () {
	          // do not use cached leaf value here, invoke this.isLeaf to get new value.
	          var isLeaf = _this2.isLeaf;
	
	
	          if (!isLeaf) _this2.handleExpand();
	          if (multiple) {
	            // if leaf sync checked state, else clear checked state
	            var checked = isLeaf ? node.checked : false;
	            _this2.handleMultiCheckChange(checked);
	          }
	        });
	      } else {
	        panel.handleExpand(node);
	      }
	    },
	    handleCheckChange: function handleCheckChange() {
	      var panel = this.panel,
	          value = this.value,
	          node = this.node;
	
	      panel.handleCheckChange(value);
	      panel.handleExpand(node);
	    },
	    handleMultiCheckChange: function handleMultiCheckChange(checked) {
	      this.node.doCheck(checked);
	      this.panel.calculateMultiCheckedValue();
	    },
	    isInPath: function isInPath(pathNodes) {
	      var node = this.node;
	
	      var selectedPathNode = pathNodes[node.level - 1] || {};
	      return selectedPathNode.uid === node.uid;
	    },
	    renderPrefix: function renderPrefix(h) {
	      var isLeaf = this.isLeaf,
	          isChecked = this.isChecked,
	          config = this.config;
	      var checkStrictly = config.checkStrictly,
	          multiple = config.multiple;
	
	
	      if (multiple) {
	        return this.renderCheckbox(h);
	      } else if (checkStrictly) {
	        return this.renderRadio(h);
	      } else if (isLeaf && isChecked) {
	        return this.renderCheckIcon(h);
	      }
	
	      return null;
	    },
	    renderPostfix: function renderPostfix(h) {
	      var node = this.node,
	          isLeaf = this.isLeaf;
	
	
	      if (node.loading) {
	        return this.renderLoadingIcon(h);
	      } else if (!isLeaf) {
	        return this.renderExpandIcon(h);
	      }
	
	      return null;
	    },
	    renderCheckbox: function renderCheckbox(h) {
	      var node = this.node,
	          config = this.config,
	          isDisabled = this.isDisabled;
	
	      var events = {
	        on: { change: this.handleMultiCheckChange },
	        nativeOn: {}
	      };
	
	      if (config.checkStrictly) {
	        // when every node is selectable, click event should not trigger expand event.
	        events.nativeOn.click = stopPropagation;
	      }
	
	      return h('el-checkbox', external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          value: node.checked,
	          indeterminate: node.indeterminate,
	          disabled: isDisabled
	        }
	      }, events]));
	    },
	    renderRadio: function renderRadio(h) {
	      var checkedValue = this.checkedValue,
	          value = this.value,
	          isDisabled = this.isDisabled;
	
	      // to keep same reference if value cause radio's checked state is calculated by reference comparision;
	
	      if (Object(util_["isEqual"])(value, checkedValue)) {
	        value = checkedValue;
	      }
	
	      return h(
	        'el-radio',
	        {
	          attrs: {
	            value: checkedValue,
	            label: value,
	            disabled: isDisabled
	          },
	          on: {
	            'change': this.handleCheckChange
	          },
	          nativeOn: {
	            'click': stopPropagation
	          }
	        },
	        [h('span')]
	      );
	    },
	    renderCheckIcon: function renderCheckIcon(h) {
	      return h('i', { 'class': 'el-icon-check el-cascader-node__prefix' });
	    },
	    renderLoadingIcon: function renderLoadingIcon(h) {
	      return h('i', { 'class': 'el-icon-loading el-cascader-node__postfix' });
	    },
	    renderExpandIcon: function renderExpandIcon(h) {
	      return h('i', { 'class': 'el-icon-arrow-right el-cascader-node__postfix' });
	    },
	    renderContent: function renderContent(h) {
	      var panel = this.panel,
	          node = this.node;
	
	      var render = panel.renderLabelFn;
	      var vnode = render ? render({ node: node, data: node.data }) : null;
	
	      return h(
	        'span',
	        { 'class': 'el-cascader-node__label' },
	        [vnode || node.label]
	      );
	    }
	  },
	
	  render: function render(h) {
	    var _this3 = this;
	
	    var inActivePath = this.inActivePath,
	        inCheckedPath = this.inCheckedPath,
	        isChecked = this.isChecked,
	        isLeaf = this.isLeaf,
	        isDisabled = this.isDisabled,
	        config = this.config,
	        nodeId = this.nodeId;
	    var expandTrigger = config.expandTrigger,
	        checkStrictly = config.checkStrictly,
	        multiple = config.multiple;
	
	    var disabled = !checkStrictly && isDisabled;
	    var events = { on: {} };
	
	    if (expandTrigger === 'click') {
	      events.on.click = this.handleExpand;
	    } else {
	      events.on.mouseenter = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	      events.on.focus = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	    }
	    if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
	      events.on.click = this.handleCheckChange;
	    }
	
	    return h(
	      'li',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          role: 'menuitem',
	          id: nodeId,
	          'aria-expanded': inActivePath,
	          tabindex: disabled ? null : -1
	        },
	        'class': {
	          'el-cascader-node': true,
	          'is-selectable': checkStrictly,
	          'in-active-path': inActivePath,
	          'in-checked-path': inCheckedPath,
	          'is-active': isChecked,
	          'is-disabled': disabled
	        }
	      }, events]),
	      [this.renderPrefix(h), this.renderContent(h), this.renderPostfix(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_nodevue_type_script_lang_js_ = (cascader_nodevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
	var cascader_node_render, cascader_node_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var cascader_node_component = normalizeComponent(
	  src_cascader_nodevue_type_script_lang_js_,
	  cascader_node_render,
	  cascader_node_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_node_api; }
	cascader_node_component.options.__file = "packages/cascader-panel/src/cascader-node.vue"
	/* harmony default export */ var cascader_node = (cascader_node_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	/* harmony default export */ var cascader_menuvue_type_script_lang_js_ = ({
	  name: 'ElCascaderMenu',
	
	  mixins: [locale_default.a],
	
	  inject: ['panel'],
	
	  components: {
	    ElScrollbar: scrollbar_default.a,
	    CascaderNode: cascader_node
	  },
	
	  props: {
	    nodes: {
	      type: Array,
	      required: true
	    },
	    index: Number
	  },
	
	  data: function data() {
	    return {
	      activeNode: null,
	      hoverTimer: null,
	      id: Object(util_["generateId"])()
	    };
	  },
	
	
	  computed: {
	    isEmpty: function isEmpty() {
	      return !this.nodes.length;
	    },
	    menuId: function menuId() {
	      return 'cascader-menu-' + this.id + '-' + this.index;
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand(e) {
	      this.activeNode = e.target;
	    },
	    handleMouseMove: function handleMouseMove(e) {
	      var activeNode = this.activeNode,
	          hoverTimer = this.hoverTimer;
	      var hoverZone = this.$refs.hoverZone;
	
	
	      if (!activeNode || !hoverZone) return;
	
	      if (activeNode.contains(e.target)) {
	        clearTimeout(hoverTimer);
	
	        var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
	            left = _$el$getBoundingClien.left;
	
	        var startX = e.clientX - left;
	        var _$el = this.$el,
	            offsetWidth = _$el.offsetWidth,
	            offsetHeight = _$el.offsetHeight;
	
	        var top = activeNode.offsetTop;
	        var bottom = top + activeNode.offsetHeight;
	
	        hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + top + ' L' + offsetWidth + ' 0 V' + top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + bottom + ' L' + offsetWidth + ' ' + offsetHeight + ' V' + bottom + ' Z" />\n        ';
	      } else if (!hoverTimer) {
	        this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold);
	      }
	    },
	    clearHoverZone: function clearHoverZone() {
	      var hoverZone = this.$refs.hoverZone;
	
	      if (!hoverZone) return;
	      hoverZone.innerHTML = '';
	    },
	    renderEmptyText: function renderEmptyText(h) {
	      return h(
	        'div',
	        { 'class': 'el-cascader-menu__empty-text' },
	        [this.t('el.cascader.noData')]
	      );
	    },
	    renderNodeList: function renderNodeList(h) {
	      var menuId = this.menuId;
	      var isHoverMenu = this.panel.isHoverMenu;
	
	      var events = { on: {} };
	
	      if (isHoverMenu) {
	        events.on.expand = this.handleExpand;
	      }
	
	      var nodes = this.nodes.map(function (node, index) {
	        var hasChildren = node.hasChildren;
	
	        return h('cascader-node', external_babel_helper_vue_jsx_merge_props_default()([{
	          key: node.uid,
	          attrs: { node: node,
	            'node-id': menuId + '-' + index,
	            'aria-haspopup': hasChildren,
	            'aria-owns': hasChildren ? menuId : null
	          }
	        }, events]));
	      });
	
	      return [].concat(nodes, [isHoverMenu ? h('svg', { ref: 'hoverZone', 'class': 'el-cascader-menu__hover-zone' }) : null]);
	    }
	  },
	
	  render: function render(h) {
	    var isEmpty = this.isEmpty,
	        menuId = this.menuId;
	
	    var events = { nativeOn: {} };
	
	    // optimize hover to expand experience (#8010)
	    if (this.panel.isHoverMenu) {
	      events.nativeOn.mousemove = this.handleMouseMove;
	      // events.nativeOn.mouseleave = this.clearHoverZone;
	    }
	
	    return h(
	      'el-scrollbar',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          tag: 'ul',
	          role: 'menu',
	          id: menuId,
	
	          'wrap-class': 'el-cascader-menu__wrap',
	          'view-class': {
	            'el-cascader-menu__list': true,
	            'is-empty': isEmpty
	          }
	        },
	        'class': 'el-cascader-menu' }, events]),
	      [isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_menuvue_type_script_lang_js_ = (cascader_menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
	var cascader_menu_render, cascader_menu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var cascader_menu_component = normalizeComponent(
	  src_cascader_menuvue_type_script_lang_js_,
	  cascader_menu_render,
	  cascader_menu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_menu_api; }
	cascader_menu_component.options.__file = "packages/cascader-panel/src/cascader-menu.vue"
	/* harmony default export */ var cascader_menu = (cascader_menu_component.exports);
	// CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
	var node_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function src_node_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var uid = 0;
	
	var src_node_Node = function () {
	  function Node(data, config, parentNode) {
	    src_node_classCallCheck(this, Node);
	
	    this.data = data;
	    this.config = config;
	    this.parent = parentNode || null;
	    this.level = !this.parent ? 1 : this.parent.level + 1;
	    this.uid = uid++;
	
	    this.initState();
	    this.initChildren();
	  }
	
	  Node.prototype.initState = function initState() {
	    var _config = this.config,
	        valueKey = _config.value,
	        labelKey = _config.label;
	
	
	    this.value = this.data[valueKey];
	    this.label = this.data[labelKey];
	    this.pathNodes = this.calculatePathNodes();
	    this.path = this.pathNodes.map(function (node) {
	      return node.value;
	    });
	    this.pathLabels = this.pathNodes.map(function (node) {
	      return node.label;
	    });
	
	    // lazy load
	    this.loading = false;
	    this.loaded = false;
	  };
	
	  Node.prototype.initChildren = function initChildren() {
	    var _this = this;
	
	    var config = this.config;
	
	    var childrenKey = config.children;
	    var childrenData = this.data[childrenKey];
	    this.hasChildren = Array.isArray(childrenData);
	    this.children = (childrenData || []).map(function (child) {
	      return new Node(child, config, _this);
	    });
	  };
	
	  Node.prototype.calculatePathNodes = function calculatePathNodes() {
	    var nodes = [this];
	    var parent = this.parent;
	
	    while (parent) {
	      nodes.unshift(parent);
	      parent = parent.parent;
	    }
	
	    return nodes;
	  };
	
	  Node.prototype.getPath = function getPath() {
	    return this.path;
	  };
	
	  Node.prototype.getValue = function getValue() {
	    return this.value;
	  };
	
	  Node.prototype.getValueByOption = function getValueByOption() {
	    return this.config.emitPath ? this.getPath() : this.getValue();
	  };
	
	  Node.prototype.getText = function getText(allLevels, separator) {
	    return allLevels ? this.pathLabels.join(separator) : this.label;
	  };
	
	  Node.prototype.isSameNode = function isSameNode(checkedValue) {
	    var value = this.getValueByOption();
	    return this.config.multiple && Array.isArray(checkedValue) ? checkedValue.some(function (val) {
	      return Object(util_["isEqual"])(val, value);
	    }) : Object(util_["isEqual"])(checkedValue, value);
	  };
	
	  Node.prototype.broadcast = function broadcast(event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var handlerName = 'onParent' + Object(util_["capitalize"])(event);
	
	    this.children.forEach(function (child) {
	      if (child) {
	        // bottom up
	        child.broadcast.apply(child, [event].concat(args));
	        child[handlerName] && child[handlerName].apply(child, args);
	      }
	    });
	  };
	
	  Node.prototype.emit = function emit(event) {
	    var parent = this.parent;
	
	    var handlerName = 'onChild' + Object(util_["capitalize"])(event);
	    if (parent) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      parent[handlerName] && parent[handlerName].apply(parent, args);
	      parent.emit.apply(parent, [event].concat(args));
	    }
	  };
	
	  Node.prototype.onParentCheck = function onParentCheck(checked) {
	    if (!this.isDisabled) {
	      this.setCheckState(checked);
	    }
	  };
	
	  Node.prototype.onChildCheck = function onChildCheck() {
	    var children = this.children;
	
	    var validChildren = children.filter(function (child) {
	      return !child.isDisabled;
	    });
	    var checked = validChildren.length ? validChildren.every(function (child) {
	      return child.checked;
	    }) : false;
	
	    this.setCheckState(checked);
	  };
	
	  Node.prototype.setCheckState = function setCheckState(checked) {
	    var totalNum = this.children.length;
	    var checkedNum = this.children.reduce(function (c, p) {
	      var num = p.checked ? 1 : p.indeterminate ? 0.5 : 0;
	      return c + num;
	    }, 0);
	
	    this.checked = checked;
	    this.indeterminate = checkedNum !== totalNum && checkedNum > 0;
	  };
	
	  Node.prototype.syncCheckState = function syncCheckState(checkedValue) {
	    var value = this.getValueByOption();
	    var checked = this.isSameNode(checkedValue, value);
	
	    this.doCheck(checked);
	  };
	
	  Node.prototype.doCheck = function doCheck(checked) {
	    if (this.checked !== checked) {
	      if (this.config.checkStrictly) {
	        this.checked = checked;
	      } else {
	        // bottom up to unify the calculation of the indeterminate state
	        this.broadcast('check', checked);
	        this.setCheckState(checked);
	        this.emit('check');
	      }
	    }
	  };
	
	  node_createClass(Node, [{
	    key: 'isDisabled',
	    get: function get() {
	      var data = this.data,
	          parent = this.parent,
	          config = this.config;
	
	      var disabledKey = config.disabled;
	      var checkStrictly = config.checkStrictly;
	
	      return data[disabledKey] || !checkStrictly && parent && parent.isDisabled;
	    }
	  }, {
	    key: 'isLeaf',
	    get: function get() {
	      var data = this.data,
	          loaded = this.loaded,
	          hasChildren = this.hasChildren,
	          children = this.children;
	      var _config2 = this.config,
	          lazy = _config2.lazy,
	          leafKey = _config2.leaf;
	
	      if (lazy) {
	        var isLeaf = Object(shared_["isDef"])(data[leafKey]) ? data[leafKey] : loaded ? !children.length : false;
	        this.hasChildren = !isLeaf;
	        return isLeaf;
	      }
	      return !hasChildren;
	    }
	  }]);
	
	  return Node;
	}();
	
	/* harmony default export */ var src_node = (src_node_Node);
	// CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
	function store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var flatNodes = function flatNodes(data, leafOnly) {
	  return data.reduce(function (res, node) {
	    if (node.isLeaf) {
	      res.push(node);
	    } else {
	      !leafOnly && res.push(node);
	      res = res.concat(flatNodes(node.children, leafOnly));
	    }
	    return res;
	  }, []);
	};
	
	var store_Store = function () {
	  function Store(data, config) {
	    store_classCallCheck(this, Store);
	
	    this.config = config;
	    this.initNodes(data);
	  }
	
	  Store.prototype.initNodes = function initNodes(data) {
	    var _this = this;
	
	    data = Object(util_["coerceTruthyValueToArray"])(data);
	    this.nodes = data.map(function (nodeData) {
	      return new src_node(nodeData, _this.config);
	    });
	    this.flattedNodes = this.getFlattedNodes(false, false);
	    this.leafNodes = this.getFlattedNodes(true, false);
	  };
	
	  Store.prototype.appendNode = function appendNode(nodeData, parentNode) {
	    var node = new src_node(nodeData, this.config, parentNode);
	    var children = parentNode ? parentNode.children : this.nodes;
	
	    children.push(node);
	  };
	
	  Store.prototype.appendNodes = function appendNodes(nodeDataList, parentNode) {
	    var _this2 = this;
	
	    nodeDataList = Object(util_["coerceTruthyValueToArray"])(nodeDataList);
	    nodeDataList.forEach(function (nodeData) {
	      return _this2.appendNode(nodeData, parentNode);
	    });
	  };
	
	  Store.prototype.getNodes = function getNodes() {
	    return this.nodes;
	  };
	
	  Store.prototype.getFlattedNodes = function getFlattedNodes(leafOnly) {
	    var cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var cachedNodes = leafOnly ? this.leafNodes : this.flattedNodes;
	    return cached ? cachedNodes : flatNodes(this.nodes, leafOnly);
	  };
	
	  Store.prototype.getNodeByValue = function getNodeByValue(value) {
	    if (value) {
	      var nodes = this.getFlattedNodes(false, !this.config.lazy).filter(function (node) {
	        return Object(util_["valueEquals"])(node.path, value) || node.value === value;
	      });
	      return nodes && nodes.length ? nodes[0] : null;
	    }
	    return null;
	  };
	
	  return Store;
	}();
	
	/* harmony default export */ var cascader_panel_src_store = (store_Store);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	var cascader_panelvue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var cascader_panelvue_type_script_lang_js_KeyCode = aria_utils_default.a.keys;
	
	var DefaultProps = {
	  expandTrigger: 'click', // or hover
	  multiple: false,
	  checkStrictly: false, // whether all nodes can be selected
	  emitPath: true, // wether to emit an array of all levels value in which node is located
	  lazy: false,
	  lazyLoad: util_["noop"],
	  value: 'value',
	  label: 'label',
	  children: 'children',
	  leaf: 'leaf',
	  disabled: 'disabled',
	  hoverThreshold: 500
	};
	
	var cascader_panelvue_type_script_lang_js_isLeaf = function isLeaf(el) {
	  return !el.getAttribute('aria-owns');
	};
	
	var getSibling = function getSibling(el, distance) {
	  var parentNode = el.parentNode;
	
	  if (parentNode) {
	    var siblings = parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');
	    var index = Array.prototype.indexOf.call(siblings, el);
	    return siblings[index + distance] || null;
	  }
	  return null;
	};
	
	var getMenuIndex = function getMenuIndex(el, distance) {
	  if (!el) return;
	  var pieces = el.id.split('-');
	  return Number(pieces[pieces.length - 2]);
	};
	
	var focusNode = function focusNode(el) {
	  if (!el) return;
	  el.focus();
	  !cascader_panelvue_type_script_lang_js_isLeaf(el) && el.click();
	};
	
	var checkNode = function checkNode(el) {
	  if (!el) return;
	
	  var input = el.querySelector('input');
	  if (input) {
	    input.click();
	  } else if (cascader_panelvue_type_script_lang_js_isLeaf(el)) {
	    el.click();
	  }
	};
	
	/* harmony default export */ var cascader_panelvue_type_script_lang_js_ = ({
	  name: 'ElCascaderPanel',
	
	  components: {
	    CascaderMenu: cascader_menu
	  },
	
	  props: {
	    value: {},
	    options: Array,
	    props: Object,
	    border: {
	      type: Boolean,
	      default: true
	    },
	    renderLabel: Function
	  },
	
	  provide: function provide() {
	    return {
	      panel: this
	    };
	  },
	  data: function data() {
	    return {
	      checkedValue: null,
	      checkedNodePaths: [],
	      store: [],
	      menus: [],
	      activePath: [],
	      loadCount: 0
	    };
	  },
	
	
	  computed: {
	    config: function config() {
	      return merge_default()(cascader_panelvue_type_script_lang_js_extends({}, DefaultProps), this.props || {});
	    },
	    multiple: function multiple() {
	      return this.config.multiple;
	    },
	    checkStrictly: function checkStrictly() {
	      return this.config.checkStrictly;
	    },
	    leafOnly: function leafOnly() {
	      return !this.checkStrictly;
	    },
	    isHoverMenu: function isHoverMenu() {
	      return this.config.expandTrigger === 'hover';
	    },
	    renderLabelFn: function renderLabelFn() {
	      return this.renderLabel || this.$scopedSlots.default;
	    }
	  },
	
	  watch: {
	    options: {
	      handler: function handler() {
	        this.initStore();
	      },
	      immediate: true,
	      deep: true
	    },
	    value: function value() {
	      this.syncCheckedValue();
	      this.checkStrictly && this.calculateCheckedNodePaths();
	    },
	    checkedValue: function checkedValue(val) {
	      if (!Object(util_["isEqual"])(val, this.value)) {
	        this.checkStrictly && this.calculateCheckedNodePaths();
	        this.$emit('input', val);
	        this.$emit('change', val);
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    if (!Object(util_["isEmpty"])(this.value)) {
	      this.syncCheckedValue();
	    }
	  },
	
	
	  methods: {
	    initStore: function initStore() {
	      var config = this.config,
	          options = this.options;
	
	      if (config.lazy && Object(util_["isEmpty"])(options)) {
	        this.lazyLoad();
	      } else {
	        this.store = new cascader_panel_src_store(options, config);
	        this.menus = [this.store.getNodes()];
	        this.syncMenuState();
	      }
	    },
	    syncCheckedValue: function syncCheckedValue() {
	      var value = this.value,
	          checkedValue = this.checkedValue;
	
	      if (!Object(util_["isEqual"])(value, checkedValue)) {
	        this.checkedValue = value;
	        this.syncMenuState();
	      }
	    },
	    syncMenuState: function syncMenuState() {
	      var multiple = this.multiple,
	          checkStrictly = this.checkStrictly;
	
	      this.syncActivePath();
	      multiple && this.syncMultiCheckState();
	      checkStrictly && this.calculateCheckedNodePaths();
	      this.$nextTick(this.scrollIntoView);
	    },
	    syncMultiCheckState: function syncMultiCheckState() {
	      var _this = this;
	
	      var nodes = this.getFlattedNodes(this.leafOnly);
	
	      nodes.forEach(function (node) {
	        node.syncCheckState(_this.checkedValue);
	      });
	    },
	    syncActivePath: function syncActivePath() {
	      var _this2 = this;
	
	      var store = this.store,
	          multiple = this.multiple,
	          activePath = this.activePath,
	          checkedValue = this.checkedValue;
	
	
	      if (!Object(util_["isEmpty"])(activePath)) {
	        var nodes = activePath.map(function (node) {
	          return _this2.getNodeByValue(node.getValue());
	        });
	        this.expandNodes(nodes);
	      } else if (!Object(util_["isEmpty"])(checkedValue)) {
	        var value = multiple ? checkedValue[0] : checkedValue;
	        var checkedNode = this.getNodeByValue(value) || {};
	        var _nodes = (checkedNode.pathNodes || []).slice(0, -1);
	        this.expandNodes(_nodes);
	      } else {
	        this.activePath = [];
	        this.menus = [store.getNodes()];
	      }
	    },
	    expandNodes: function expandNodes(nodes) {
	      var _this3 = this;
	
	      nodes.forEach(function (node) {
	        return _this3.handleExpand(node, true /* silent */);
	      });
	    },
	    calculateCheckedNodePaths: function calculateCheckedNodePaths() {
	      var _this4 = this;
	
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      var checkedValues = multiple ? Object(util_["coerceTruthyValueToArray"])(checkedValue) : [checkedValue];
	      this.checkedNodePaths = checkedValues.map(function (v) {
	        var checkedNode = _this4.getNodeByValue(v);
	        return checkedNode ? checkedNode.pathNodes : [];
	      });
	    },
	    handleKeyDown: function handleKeyDown(e) {
	      var target = e.target,
	          keyCode = e.keyCode;
	
	
	      switch (keyCode) {
	        case cascader_panelvue_type_script_lang_js_KeyCode.up:
	          var prev = getSibling(target, -1);
	          focusNode(prev);
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.down:
	          var next = getSibling(target, 1);
	          focusNode(next);
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.left:
	          var preMenu = this.$refs.menu[getMenuIndex(target) - 1];
	          if (preMenu) {
	            var expandedNode = preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
	            focusNode(expandedNode);
	          }
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.right:
	          var nextMenu = this.$refs.menu[getMenuIndex(target) + 1];
	          if (nextMenu) {
	            var firstNode = nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');
	            focusNode(firstNode);
	          }
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.enter:
	          checkNode(target);
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.esc:
	        case cascader_panelvue_type_script_lang_js_KeyCode.tab:
	          this.$emit('close');
	          break;
	        default:
	          return;
	      }
	    },
	    handleExpand: function handleExpand(node, silent) {
	      var activePath = this.activePath;
	      var level = node.level;
	
	      var path = activePath.slice(0, level - 1);
	      var menus = this.menus.slice(0, level);
	
	      if (!node.isLeaf) {
	        path.push(node);
	        menus.push(node.children);
	      }
	
	      this.activePath = path;
	      this.menus = menus;
	
	      if (!silent) {
	        var pathValues = path.map(function (node) {
	          return node.getValue();
	        });
	        var activePathValues = activePath.map(function (node) {
	          return node.getValue();
	        });
	        if (!Object(util_["valueEquals"])(pathValues, activePathValues)) {
	          this.$emit('active-item-change', pathValues); // Deprecated
	          this.$emit('expand-change', pathValues);
	        }
	      }
	    },
	    handleCheckChange: function handleCheckChange(value) {
	      this.checkedValue = value;
	    },
	    lazyLoad: function lazyLoad(node, onFullfiled) {
	      var _this5 = this;
	
	      var config = this.config;
	
	      if (!node) {
	        node = node || { root: true, level: 0 };
	        this.store = new cascader_panel_src_store([], config);
	        this.menus = [this.store.getNodes()];
	      }
	      node.loading = true;
	      var resolve = function resolve(dataList) {
	        var parent = node.root ? null : node;
	        dataList && dataList.length && _this5.store.appendNodes(dataList, parent);
	        node.loading = false;
	        node.loaded = true;
	
	        // dispose default value on lazy load mode
	        if (Array.isArray(_this5.checkedValue)) {
	          var nodeValue = _this5.checkedValue[_this5.loadCount++];
	          var valueKey = _this5.config.value;
	          var leafKey = _this5.config.leaf;
	
	          if (Array.isArray(dataList) && dataList.filter(function (item) {
	            return item[valueKey] === nodeValue;
	          }).length > 0) {
	            var checkedNode = _this5.store.getNodeByValue(nodeValue);
	
	            if (!checkedNode.data[leafKey]) {
	              _this5.lazyLoad(checkedNode, function () {
	                _this5.handleExpand(checkedNode);
	              });
	            }
	
	            if (_this5.loadCount === _this5.checkedValue.length) {
	              _this5.$parent.computePresentText();
	            }
	          }
	        }
	
	        onFullfiled && onFullfiled(dataList);
	      };
	      config.lazyLoad(node, resolve);
	    },
	
	
	    /**
	     * public methods
	    */
	    calculateMultiCheckedValue: function calculateMultiCheckedValue() {
	      this.checkedValue = this.getCheckedNodes(this.leafOnly).map(function (node) {
	        return node.getValueByOption();
	      });
	    },
	    scrollIntoView: function scrollIntoView() {
	      if (this.$isServer) return;
	
	      var menus = this.$refs.menu || [];
	      menus.forEach(function (menu) {
	        var menuElement = menu.$el;
	        if (menuElement) {
	          var container = menuElement.querySelector('.el-scrollbar__wrap');
	          var activeNode = menuElement.querySelector('.el-cascader-node.is-active') || menuElement.querySelector('.el-cascader-node.in-active-path');
	          scroll_into_view_default()(container, activeNode);
	        }
	      });
	    },
	    getNodeByValue: function getNodeByValue(val) {
	      return this.store.getNodeByValue(val);
	    },
	    getFlattedNodes: function getFlattedNodes(leafOnly) {
	      var cached = !this.config.lazy;
	      return this.store.getFlattedNodes(leafOnly, cached);
	    },
	    getCheckedNodes: function getCheckedNodes(leafOnly) {
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      if (multiple) {
	        var nodes = this.getFlattedNodes(leafOnly);
	        return nodes.filter(function (node) {
	          return node.checked;
	        });
	      } else {
	        return Object(util_["isEmpty"])(checkedValue) ? [] : [this.getNodeByValue(checkedValue)];
	      }
	    },
	    clearCheckedNodes: function clearCheckedNodes() {
	      var config = this.config,
	          leafOnly = this.leafOnly;
	      var multiple = config.multiple,
	          emitPath = config.emitPath;
	
	      if (multiple) {
	        this.getCheckedNodes(leafOnly).filter(function (node) {
	          return !node.isDisabled;
	        }).forEach(function (node) {
	          return node.doCheck(false);
	        });
	        this.calculateMultiCheckedValue();
	      } else {
	        this.checkedValue = emitPath ? [] : null;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_panelvue_type_script_lang_js_ = (cascader_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var cascader_panel_component = normalizeComponent(
	  src_cascader_panelvue_type_script_lang_js_,
	  cascader_panelvue_type_template_id_34932346_render,
	  cascader_panelvue_type_template_id_34932346_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_panel_api; }
	cascader_panel_component.options.__file = "packages/cascader-panel/src/cascader-panel.vue"
	/* harmony default export */ var cascader_panel = (cascader_panel_component.exports);
	// CONCATENATED MODULE: ./packages/cascader-panel/index.js
	
	
	/* istanbul ignore next */
	cascader_panel.install = function (Vue) {
	  Vue.component(cascader_panel.name, cascader_panel);
	};
	
	/* harmony default export */ var packages_cascader_panel = (cascader_panel);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/avatar/src/main.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var avatar_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElAvatar',
	
	  props: {
	    size: {
	      type: [Number, String],
	      validator: function validator(val) {
	        if (typeof val === 'string') {
	          return ['large', 'medium', 'small'].includes(val);
	        }
	        return typeof val === 'number';
	      }
	    },
	    shape: {
	      type: String,
	      default: 'circle',
	      validator: function validator(val) {
	        return ['circle', 'square'].includes(val);
	      }
	    },
	    icon: String,
	    src: String,
	    alt: String,
	    srcSet: String,
	    error: Function,
	    fit: {
	      type: String,
	      default: 'cover'
	    }
	  },
	
	  data: function data() {
	    return {
	      isImageExist: true
	    };
	  },
	
	
	  computed: {
	    avatarClass: function avatarClass() {
	      var size = this.size,
	          icon = this.icon,
	          shape = this.shape;
	
	      var classList = ['el-avatar'];
	
	      if (size && typeof size === 'string') {
	        classList.push('el-avatar--' + size);
	      }
	
	      if (icon) {
	        classList.push('el-avatar--icon');
	      }
	
	      if (shape) {
	        classList.push('el-avatar--' + shape);
	      }
	
	      return classList.join(' ');
	    }
	  },
	
	  methods: {
	    handleError: function handleError() {
	      var error = this.error;
	
	      var errorFlag = error ? error() : undefined;
	      if (errorFlag !== false) {
	        this.isImageExist = false;
	      }
	    },
	    renderAvatar: function renderAvatar() {
	      var h = this.$createElement;
	      var icon = this.icon,
	          src = this.src,
	          alt = this.alt,
	          isImageExist = this.isImageExist,
	          srcSet = this.srcSet,
	          fit = this.fit;
	
	
	      if (isImageExist && src) {
	        return h('img', {
	          attrs: {
	            src: src,
	
	            alt: alt,
	            srcSet: srcSet
	          },
	          on: {
	            'error': this.handleError
	          },
	          style: { 'object-fit': fit } });
	      }
	
	      if (icon) {
	        return h('i', { 'class': icon });
	      }
	
	      return this.$slots.default;
	    }
	  },
	
	  render: function render() {
	    var h = arguments[0];
	    var avatarClass = this.avatarClass,
	        size = this.size;
	
	
	    var sizeStyle = typeof size === 'number' ? {
	      height: size + 'px',
	      width: size + 'px',
	      lineHeight: size + 'px'
	    } : {};
	
	    return h(
	      'span',
	      { 'class': avatarClass, style: sizeStyle },
	      [this.renderAvatar()]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/avatar/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_avatar_src_mainvue_type_script_lang_js_ = (avatar_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/avatar/src/main.vue
	var src_main_render, src_main_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var avatar_src_main_component = normalizeComponent(
	  packages_avatar_src_mainvue_type_script_lang_js_,
	  src_main_render,
	  src_main_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var avatar_src_main_api; }
	avatar_src_main_component.options.__file = "packages/avatar/src/main.vue"
	/* harmony default export */ var avatar_src_main = (avatar_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/avatar/index.js
	
	
	/* istanbul ignore next */
	avatar_src_main.install = function (Vue) {
	  Vue.component(avatar_src_main.name, avatar_src_main);
	};
	
	/* harmony default export */ var avatar = (avatar_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
	var mainvue_type_template_id_a4885264_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-drawer-fade" },
	      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-drawer__wrapper",
	          attrs: { tabindex: "-1" }
	        },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-drawer__container",
	              class: _vm.visible && "el-drawer__open",
	              attrs: { role: "document", tabindex: "-1" },
	              on: {
	                click: function($event) {
	                  if ($event.target !== $event.currentTarget) {
	                    return null
	                  }
	                  return _vm.handleWrapperClick($event)
	                }
	              }
	            },
	            [
	              _c(
	                "div",
	                {
	                  ref: "drawer",
	                  staticClass: "el-drawer",
	                  class: [_vm.direction, _vm.customClass],
	                  style: _vm.isHorizontal
	                    ? "width: " + _vm.size
	                    : "height: " + _vm.size,
	                  attrs: {
	                    "aria-modal": "true",
	                    "aria-labelledby": "el-drawer__title",
	                    "aria-label": _vm.title,
	                    role: "dialog",
	                    tabindex: "-1"
	                  }
	                },
	                [
	                  _vm.withHeader
	                    ? _c(
	                        "header",
	                        {
	                          staticClass: "el-drawer__header",
	                          attrs: { id: "el-drawer__title" }
	                        },
	                        [
	                          _vm._t("title", [
	                            _c(
	                              "span",
	                              {
	                                attrs: {
	                                  role: "heading",
	                                  tabindex: "0",
	                                  title: _vm.title
	                                }
	                              },
	                              [_vm._v(_vm._s(_vm.title))]
	                            )
	                          ]),
	                          _vm.showClose
	                            ? _c(
	                                "button",
	                                {
	                                  staticClass: "el-drawer__close-btn",
	                                  attrs: {
	                                    "aria-label":
	                                      "close " + (_vm.title || "drawer"),
	                                    type: "button"
	                                  },
	                                  on: { click: _vm.closeDrawer }
	                                },
	                                [
	                                  _c("i", {
	                                    staticClass:
	                                      "el-dialog__close el-icon el-icon-close"
	                                  })
	                                ]
	                              )
	                            : _vm._e()
	                        ],
	                        2
	                      )
	                    : _vm._e(),
	                  _vm.rendered
	                    ? _c(
	                        "section",
	                        { staticClass: "el-drawer__body" },
	                        [_vm._t("default")],
	                        2
	                      )
	                    : _vm._e()
	                ]
	              )
	            ]
	          )
	        ]
	      )
	    ]
	  )
	}
	var mainvue_type_template_id_a4885264_staticRenderFns = []
	mainvue_type_template_id_a4885264_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var drawer_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElDrawer',
	  mixins: [popup_default.a, emitter_default.a],
	  props: {
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	    beforeClose: {
	      type: Function
	    },
	    customClass: {
	      type: String,
	      default: ''
	    },
	    closeOnPressEscape: {
	      type: Boolean,
	      default: true
	    },
	    destroyOnClose: {
	      type: Boolean,
	      default: false
	    },
	    modal: {
	      type: Boolean,
	      default: true
	    },
	    direction: {
	      type: String,
	      default: 'rtl',
	      validator: function validator(val) {
	        return ['ltr', 'rtl', 'ttb', 'btt'].indexOf(val) !== -1;
	      }
	    },
	    modalAppendToBody: {
	      type: Boolean,
	      default: true
	    },
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    size: {
	      type: String,
	      default: '30%'
	    },
	    title: {
	      type: String,
	      default: ''
	    },
	    visible: {
	      type: Boolean
	    },
	    wrapperClosable: {
	      type: Boolean,
	      default: true
	    },
	    withHeader: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    isHorizontal: function isHorizontal() {
	      return this.direction === 'rtl' || this.direction === 'ltr';
	    }
	  },
	  data: function data() {
	    return {
	      closed: false,
	      prevActiveElement: null
	    };
	  },
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.closed = false;
	        this.$emit('open');
	        if (this.appendToBody) {
	          document.body.appendChild(this.$el);
	        }
	        this.prevActiveElement = document.activeElement;
	        this.$nextTick(function () {
	          aria_utils_default.a.focusFirstDescendant(_this.$refs.drawer);
	        });
	      } else {
	        if (!this.closed) this.$emit('close');
	        this.$nextTick(function () {
	          if (_this.prevActiveElement) {
	            _this.prevActiveElement.focus();
	          }
	        });
	      }
	    }
	  },
	  methods: {
	    afterEnter: function afterEnter() {
	      this.$emit('opened');
	    },
	    afterLeave: function afterLeave() {
	      this.$emit('closed');
	    },
	    hide: function hide(cancel) {
	      if (cancel !== false) {
	        this.$emit('update:visible', false);
	        this.$emit('close');
	        if (this.destroyOnClose === true) {
	          this.rendered = false;
	        }
	        this.closed = true;
	      }
	    },
	    handleWrapperClick: function handleWrapperClick() {
	      if (this.wrapperClosable) {
	        this.closeDrawer();
	      }
	    },
	    closeDrawer: function closeDrawer() {
	      if (typeof this.beforeClose === 'function') {
	        this.beforeClose(this.hide);
	      } else {
	        this.hide();
	      }
	    },
	    handleClose: function handleClose() {
	      // This method here will be called by PopupManger, when the `closeOnPressEscape` was set to true
	      // pressing `ESC` will call this method, and also close the drawer.
	      // This method also calls `beforeClose` if there was one.
	      this.closeDrawer();
	    }
	  },
	  mounted: function mounted() {
	    if (this.visible) {
	      this.rendered = true;
	      this.open();
	    }
	  },
	  destroyed: function destroyed() {
	    // if appendToBody is true, remove DOM node after destroy
	    if (this.appendToBody && this.$el && this.$el.parentNode) {
	      this.$el.parentNode.removeChild(this.$el);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_drawer_src_mainvue_type_script_lang_js_ = (drawer_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/drawer/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var drawer_src_main_component = normalizeComponent(
	  packages_drawer_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_a4885264_render,
	  mainvue_type_template_id_a4885264_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var drawer_src_main_api; }
	drawer_src_main_component.options.__file = "packages/drawer/src/main.vue"
	/* harmony default export */ var drawer_src_main = (drawer_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/drawer/index.js
	
	
	/* istanbul ignore next */
	drawer_src_main.install = function (Vue) {
	  Vue.component(drawer_src_main.name, drawer_src_main);
	};
	
	/* harmony default export */ var drawer = (drawer_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
	var mainvue_type_template_id_048de730_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "el-popover",
	    _vm._b(
	      {
	        attrs: { trigger: "click" },
	        model: {
	          value: _vm.visible,
	          callback: function($$v) {
	            _vm.visible = $$v
	          },
	          expression: "visible"
	        }
	      },
	      "el-popover",
	      _vm.$attrs,
	      false
	    ),
	    [
	      _c("div", { staticClass: "el-popconfirm" }, [
	        _c("p", { staticClass: "el-popconfirm__main" }, [
	          !_vm.hideIcon
	            ? _c("i", {
	                staticClass: "el-popconfirm__icon",
	                class: _vm.icon,
	                style: { color: _vm.iconColor }
	              })
	            : _vm._e(),
	          _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
	        ]),
	        _c(
	          "div",
	          { staticClass: "el-popconfirm__action" },
	          [
	            _c(
	              "el-button",
	              {
	                attrs: { size: "mini", type: _vm.cancelButtonType },
	                on: { click: _vm.cancel }
	              },
	              [_vm._v("\n        " + _vm._s(_vm.cancelButtonText) + "\n      ")]
	            ),
	            _c(
	              "el-button",
	              {
	                attrs: { size: "mini", type: _vm.confirmButtonType },
	                on: { click: _vm.confirm }
	              },
	              [
	                _vm._v(
	                  "\n        " + _vm._s(_vm.confirmButtonText) + "\n      "
	                )
	              ]
	            )
	          ],
	          1
	        )
	      ]),
	      _vm._t("reference", null, { slot: "reference" })
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_048de730_staticRenderFns = []
	mainvue_type_template_id_048de730_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
	
	// EXTERNAL MODULE: external "element-ui/lib/popover"
	var popover_ = __webpack_require__(44);
	var popover_default = /*#__PURE__*/__webpack_require__.n(popover_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var popconfirm_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElPopconfirm',
	  props: {
	    title: {
	      type: String
	    },
	    confirmButtonText: {
	      type: String,
	      default: Object(lib_locale_["t"])('el.popconfirm.confirmButtonText')
	    },
	    cancelButtonText: {
	      type: String,
	      default: Object(lib_locale_["t"])('el.popconfirm.cancelButtonText')
	    },
	    confirmButtonType: {
	      type: String,
	      default: 'primary'
	    },
	    cancelButtonType: {
	      type: String,
	      default: 'text'
	    },
	    icon: {
	      type: String,
	      default: 'el-icon-question'
	    },
	    iconColor: {
	      type: String,
	      default: '#f90'
	    },
	    hideIcon: {
	      type: Boolean,
	      default: false
	    }
	  },
	  components: {
	    ElPopover: popover_default.a,
	    ElButton: button_default.a
	  },
	  data: function data() {
	    return {
	      visible: false
	    };
	  },
	
	  methods: {
	    confirm: function confirm() {
	      this.visible = false;
	      this.$emit('onConfirm');
	    },
	    cancel: function cancel() {
	      this.visible = false;
	      this.$emit('onCancel');
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_popconfirm_src_mainvue_type_script_lang_js_ = (popconfirm_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var popconfirm_src_main_component = normalizeComponent(
	  packages_popconfirm_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_048de730_render,
	  mainvue_type_template_id_048de730_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var popconfirm_src_main_api; }
	popconfirm_src_main_component.options.__file = "packages/popconfirm/src/main.vue"
	/* harmony default export */ var popconfirm_src_main = (popconfirm_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/popconfirm/index.js
	
	
	/* istanbul ignore next */
	popconfirm_src_main.install = function (Vue) {
	  Vue.component(popconfirm_src_main.name, popconfirm_src_main);
	};
	
	/* harmony default export */ var popconfirm = (popconfirm_src_main);
	// CONCATENATED MODULE: ./src/index.js
	/* Automatically generated by './build/bin/build-entry.js' */
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var components = [packages_pagination, dialog, packages_autocomplete, packages_dropdown, packages_dropdown_menu, packages_dropdown_item, packages_menu, packages_submenu, packages_menu_item, packages_menu_item_group, packages_input, packages_input_number, packages_radio, packages_radio_group, packages_radio_button, packages_checkbox, packages_checkbox_button, packages_checkbox_group, packages_switch, packages_select, packages_option, packages_option_group, packages_button, packages_button_group, packages_table, packages_table_column, packages_date_picker, packages_time_select, packages_time_picker, popover, packages_tooltip, packages_breadcrumb, packages_breadcrumb_item, packages_form, packages_form_item, packages_tabs, packages_tab_pane, packages_tag, packages_tree, packages_alert, slider, packages_icon, packages_row, packages_col, packages_upload, packages_progress, packages_spinner, badge, card, rate, packages_steps, packages_step, carousel, scrollbar, carousel_item, packages_collapse, packages_collapse_item, packages_cascader, color_picker, transfer, packages_container, header, aside, packages_main, footer, timeline, timeline_item, packages_link, divider, packages_image, calendar, backtop, page_header, packages_cascader_panel, avatar, drawer, popconfirm, collapse_transition_default.a];
	
	var src_install = function install(Vue) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  lib_locale_default.a.use(opts.locale);
	  lib_locale_default.a.i18n(opts.i18n);
	
	  components.forEach(function (component) {
	    Vue.component(component.name, component);
	  });
	
	  Vue.use(infinite_scroll);
	  Vue.use(packages_loading.directive);
	
	  Vue.prototype.$ELEMENT = {
	    size: opts.size || '',
	    zIndex: opts.zIndex || 2000
	  };
	
	  Vue.prototype.$loading = packages_loading.service;
	  Vue.prototype.$msgbox = message_box;
	  Vue.prototype.$alert = message_box.alert;
	  Vue.prototype.$confirm = message_box.confirm;
	  Vue.prototype.$prompt = message_box.prompt;
	  Vue.prototype.$notify = notification;
	  Vue.prototype.$message = packages_message;
	};
	
	/* istanbul ignore if */
	if (typeof window !== 'undefined' && window.Vue) {
	  src_install(window.Vue);
	}
	
	/* harmony default export */ var src_0 = __webpack_exports__["default"] = ({
	  version: '2.13.2',
	  locale: lib_locale_default.a.use,
	  i18n: lib_locale_default.a.i18n,
	  install: src_install,
	  CollapseTransition: collapse_transition_default.a,
	  Loading: packages_loading,
	  Pagination: packages_pagination,
	  Dialog: dialog,
	  Autocomplete: packages_autocomplete,
	  Dropdown: packages_dropdown,
	  DropdownMenu: packages_dropdown_menu,
	  DropdownItem: packages_dropdown_item,
	  Menu: packages_menu,
	  Submenu: packages_submenu,
	  MenuItem: packages_menu_item,
	  MenuItemGroup: packages_menu_item_group,
	  Input: packages_input,
	  InputNumber: packages_input_number,
	  Radio: packages_radio,
	  RadioGroup: packages_radio_group,
	  RadioButton: packages_radio_button,
	  Checkbox: packages_checkbox,
	  CheckboxButton: packages_checkbox_button,
	  CheckboxGroup: packages_checkbox_group,
	  Switch: packages_switch,
	  Select: packages_select,
	  Option: packages_option,
	  OptionGroup: packages_option_group,
	  Button: packages_button,
	  ButtonGroup: packages_button_group,
	  Table: packages_table,
	  TableColumn: packages_table_column,
	  DatePicker: packages_date_picker,
	  TimeSelect: packages_time_select,
	  TimePicker: packages_time_picker,
	  Popover: popover,
	  Tooltip: packages_tooltip,
	  MessageBox: message_box,
	  Breadcrumb: packages_breadcrumb,
	  BreadcrumbItem: packages_breadcrumb_item,
	  Form: packages_form,
	  FormItem: packages_form_item,
	  Tabs: packages_tabs,
	  TabPane: packages_tab_pane,
	  Tag: packages_tag,
	  Tree: packages_tree,
	  Alert: packages_alert,
	  Notification: notification,
	  Slider: slider,
	  Icon: packages_icon,
	  Row: packages_row,
	  Col: packages_col,
	  Upload: packages_upload,
	  Progress: packages_progress,
	  Spinner: packages_spinner,
	  Message: packages_message,
	  Badge: badge,
	  Card: card,
	  Rate: rate,
	  Steps: packages_steps,
	  Step: packages_step,
	  Carousel: carousel,
	  Scrollbar: scrollbar,
	  CarouselItem: carousel_item,
	  Collapse: packages_collapse,
	  CollapseItem: packages_collapse_item,
	  Cascader: packages_cascader,
	  ColorPicker: color_picker,
	  Transfer: transfer,
	  Container: packages_container,
	  Header: header,
	  Aside: aside,
	  Main: packages_main,
	  Footer: footer,
	  Timeline: timeline,
	  TimelineItem: timeline_item,
	  Link: packages_link,
	  Divider: divider,
	  Image: packages_image,
	  Calendar: calendar,
	  Backtop: backtop,
	  InfiniteScroll: infinite_scroll,
	  PageHeader: page_header,
	  CascaderPanel: packages_cascader_panel,
	  Avatar: avatar,
	  Drawer: drawer,
	  Popconfirm: popconfirm
	});
	
	/***/ })
	/******/ ])["default"];

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 114);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 10:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(177);
	
	/***/ }),
	
	/***/ 114:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        "el-input-number",
	        _vm.inputNumberSize ? "el-input-number--" + _vm.inputNumberSize : "",
	        { "is-disabled": _vm.inputNumberDisabled },
	        { "is-without-controls": !_vm.controls },
	        { "is-controls-right": _vm.controlsAtRight }
	      ],
	      on: {
	        dragstart: function($event) {
	          $event.preventDefault()
	        }
	      }
	    },
	    [
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.decrease,
	                  expression: "decrease"
	                }
	              ],
	              staticClass: "el-input-number__decrease",
	              class: { "is-disabled": _vm.minDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.decrease($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class:
	                  "el-icon-" + (_vm.controlsAtRight ? "arrow-down" : "minus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.increase,
	                  expression: "increase"
	                }
	              ],
	              staticClass: "el-input-number__increase",
	              class: { "is-disabled": _vm.maxDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.increase($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class: "el-icon-" + (_vm.controlsAtRight ? "arrow-up" : "plus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _c("el-input", {
	        ref: "input",
	        attrs: {
	          value: _vm.displayValue,
	          placeholder: _vm.placeholder,
	          disabled: _vm.inputNumberDisabled,
	          size: _vm.inputNumberSize,
	          max: _vm.max,
	          min: _vm.min,
	          name: _vm.name,
	          label: _vm.label
	        },
	        on: {
	          blur: _vm.handleBlur,
	          focus: _vm.handleFocus,
	          input: _vm.handleInput,
	          change: _vm.handleInputChange
	        },
	        nativeOn: {
	          keydown: [
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.increase($event)
	            },
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "down", 40, $event.key, [
	                  "Down",
	                  "ArrowDown"
	                ])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.decrease($event)
	            }
	          ]
	        }
	      })
	    ],
	    1
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	
	// EXTERNAL MODULE: external "element-ui/lib/input"
	var input_ = __webpack_require__(10);
	var input_default = /*#__PURE__*/__webpack_require__.n(input_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
	var focus_ = __webpack_require__(22);
	var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);
	
	// EXTERNAL MODULE: ./src/directives/repeat-click.js
	var repeat_click = __webpack_require__(30);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var input_numbervue_type_script_lang_js_ = ({
	  name: 'ElInputNumber',
	  mixins: [focus_default()('input')],
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	  directives: {
	    repeatClick: repeat_click["a" /* default */]
	  },
	  components: {
	    ElInput: input_default.a
	  },
	  props: {
	    step: {
	      type: Number,
	      default: 1
	    },
	    stepStrictly: {
	      type: Boolean,
	      default: false
	    },
	    max: {
	      type: Number,
	      default: Infinity
	    },
	    min: {
	      type: Number,
	      default: -Infinity
	    },
	    value: {},
	    disabled: Boolean,
	    size: String,
	    controls: {
	      type: Boolean,
	      default: true
	    },
	    controlsPosition: {
	      type: String,
	      default: ''
	    },
	    name: String,
	    label: String,
	    placeholder: String,
	    precision: {
	      type: Number,
	      validator: function validator(val) {
	        return val >= 0 && val === parseInt(val, 10);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: 0,
	      userInput: null
	    };
	  },
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(value) {
	        var newVal = value === undefined ? value : Number(value);
	        if (newVal !== undefined) {
	          if (isNaN(newVal)) {
	            return;
	          }
	
	          if (this.stepStrictly) {
	            var stepPrecision = this.getPrecision(this.step);
	            var precisionFactor = Math.pow(10, stepPrecision);
	            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
	          }
	
	          if (this.precision !== undefined) {
	            newVal = this.toPrecision(newVal, this.precision);
	          }
	        }
	        if (newVal >= this.max) newVal = this.max;
	        if (newVal <= this.min) newVal = this.min;
	        this.currentValue = newVal;
	        this.userInput = null;
	        this.$emit('input', newVal);
	      }
	    }
	  },
	  computed: {
	    minDisabled: function minDisabled() {
	      return this._decrease(this.value, this.step) < this.min;
	    },
	    maxDisabled: function maxDisabled() {
	      return this._increase(this.value, this.step) > this.max;
	    },
	    numPrecision: function numPrecision() {
	      var value = this.value,
	          step = this.step,
	          getPrecision = this.getPrecision,
	          precision = this.precision;
	
	      var stepPrecision = getPrecision(step);
	      if (precision !== undefined) {
	        if (stepPrecision > precision) {
	          console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
	        }
	        return precision;
	      } else {
	        return Math.max(getPrecision(value), stepPrecision);
	      }
	    },
	    controlsAtRight: function controlsAtRight() {
	      return this.controls && this.controlsPosition === 'right';
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    inputNumberSize: function inputNumberSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputNumberDisabled: function inputNumberDisabled() {
	      return this.disabled || !!(this.elForm || {}).disabled;
	    },
	    displayValue: function displayValue() {
	      if (this.userInput !== null) {
	        return this.userInput;
	      }
	
	      var currentValue = this.currentValue;
	
	      if (typeof currentValue === 'number') {
	        if (this.stepStrictly) {
	          var stepPrecision = this.getPrecision(this.step);
	          var precisionFactor = Math.pow(10, stepPrecision);
	          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
	        }
	
	        if (this.precision !== undefined) {
	          currentValue = currentValue.toFixed(this.precision);
	        }
	      }
	
	      return currentValue;
	    }
	  },
	  methods: {
	    toPrecision: function toPrecision(num, precision) {
	      if (precision === undefined) precision = this.numPrecision;
	      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
	    },
	    getPrecision: function getPrecision(value) {
	      if (value === undefined) return 0;
	      var valueString = value.toString();
	      var dotPosition = valueString.indexOf('.');
	      var precision = 0;
	      if (dotPosition !== -1) {
	        precision = valueString.length - dotPosition - 1;
	      }
	      return precision;
	    },
	    _increase: function _increase(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
	      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
	    },
	    _decrease: function _decrease(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	
	      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
	    },
	    increase: function increase() {
	      if (this.inputNumberDisabled || this.maxDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._increase(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    decrease: function decrease() {
	      if (this.inputNumberDisabled || this.minDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._decrease(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    handleBlur: function handleBlur(event) {
	      this.$emit('blur', event);
	    },
	    handleFocus: function handleFocus(event) {
	      this.$emit('focus', event);
	    },
	    setCurrentValue: function setCurrentValue(newVal) {
	      var oldVal = this.currentValue;
	      if (typeof newVal === 'number' && this.precision !== undefined) {
	        newVal = this.toPrecision(newVal, this.precision);
	      }
	      if (newVal >= this.max) newVal = this.max;
	      if (newVal <= this.min) newVal = this.min;
	      if (oldVal === newVal) return;
	      this.userInput = null;
	      this.$emit('input', newVal);
	      this.$emit('change', newVal, oldVal);
	      this.currentValue = newVal;
	    },
	    handleInput: function handleInput(value) {
	      this.userInput = value;
	    },
	    handleInputChange: function handleInputChange(value) {
	      var newVal = value === '' ? undefined : Number(value);
	      if (!isNaN(newVal) || value === '') {
	        this.setCurrentValue(newVal);
	      }
	      this.userInput = null;
	    },
	    select: function select() {
	      this.$refs.input.select();
	    }
	  },
	  mounted: function mounted() {
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('role', 'spinbutton');
	    innerInput.setAttribute('aria-valuemax', this.max);
	    innerInput.setAttribute('aria-valuemin', this.min);
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
	  },
	  updated: function updated() {
	    if (!this.$refs || !this.$refs.input) return;
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	  }
	});
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_input_numbervue_type_script_lang_js_ = (input_numbervue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_input_numbervue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/input-number/src/input-number.vue"
	/* harmony default export */ var input_number = (component.exports);
	// CONCATENATED MODULE: ./packages/input-number/index.js
	
	
	/* istanbul ignore next */
	input_number.install = function (Vue) {
	  Vue.component(input_number.name, input_number);
	};
	
	/* harmony default export */ var packages_input_number = __webpack_exports__["default"] = (input_number);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(50);
	
	/***/ }),
	
	/***/ 22:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(178);
	
	/***/ }),
	
	/***/ 30:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
	/* harmony import */ var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__);
	
	
	/* harmony default export */ __webpack_exports__["a"] = ({
	  bind: function bind(el, binding, vnode) {
	    var interval = null;
	    var startTime = void 0;
	    var handler = function handler() {
	      return vnode.context[binding.expression].apply();
	    };
	    var clear = function clear() {
	      if (Date.now() - startTime < 100) {
	        handler();
	      }
	      clearInterval(interval);
	      interval = null;
	    };
	
	    Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["on"])(el, 'mousedown', function (e) {
	      if (e.button !== 0) return;
	      startTime = Date.now();
	      Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["once"])(document, 'mouseup', clear);
	      clearInterval(interval);
	      interval = setInterval(handler, 100);
	    });
	  }
	});
	
	/***/ })
	
	/******/ });

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (Vue) {
	
	  /**
	   * template
	   *
	   * @param {String} string
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  function template(string) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (args.length === 1 && _typeof(args[0]) === 'object') {
	      args = args[0];
	    }
	
	    if (!args || !args.hasOwnProperty) {
	      args = {};
	    }
	
	    return string.replace(RE_NARGS, function (match, prefix, i, index) {
	      var result = void 0;
	
	      if (string[index - 1] === '{' && string[index + match.length] === '}') {
	        return i;
	      } else {
	        result = (0, _util.hasOwn)(args, i) ? args[i] : null;
	        if (result === null || result === undefined) {
	          return '';
	        }
	
	        return result;
	      }
	    });
	  }
	
	  return template;
	};
	
	var _util = __webpack_require__(45);
	
	var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
	/**
	 *  String format template
	 *  - Inspired:
	 *    https://github.com/Matt-Esch/string-template/index.js
	 */

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  el: {
	    colorpicker: {
	      confirm: '确定',
	      clear: '清空'
	    },
	    datepicker: {
	      now: '此刻',
	      today: '今天',
	      cancel: '取消',
	      clear: '清空',
	      confirm: '确定',
	      selectDate: '选择日期',
	      selectTime: '选择时间',
	      startDate: '开始日期',
	      startTime: '开始时间',
	      endDate: '结束日期',
	      endTime: '结束时间',
	      prevYear: '前一年',
	      nextYear: '后一年',
	      prevMonth: '上个月',
	      nextMonth: '下个月',
	      year: '年',
	      month1: '1 月',
	      month2: '2 月',
	      month3: '3 月',
	      month4: '4 月',
	      month5: '5 月',
	      month6: '6 月',
	      month7: '7 月',
	      month8: '8 月',
	      month9: '9 月',
	      month10: '10 月',
	      month11: '11 月',
	      month12: '12 月',
	      // week: '周次',
	      weeks: {
	        sun: '日',
	        mon: '一',
	        tue: '二',
	        wed: '三',
	        thu: '四',
	        fri: '五',
	        sat: '六'
	      },
	      months: {
	        jan: '一月',
	        feb: '二月',
	        mar: '三月',
	        apr: '四月',
	        may: '五月',
	        jun: '六月',
	        jul: '七月',
	        aug: '八月',
	        sep: '九月',
	        oct: '十月',
	        nov: '十一月',
	        dec: '十二月'
	      }
	    },
	    select: {
	      loading: '加载中',
	      noMatch: '无匹配数据',
	      noData: '无数据',
	      placeholder: '请选择'
	    },
	    cascader: {
	      noMatch: '无匹配数据',
	      loading: '加载中',
	      placeholder: '请选择',
	      noData: '暂无数据'
	    },
	    pagination: {
	      goto: '前往',
	      pagesize: '条/页',
	      total: '共 {total} 条',
	      pageClassifier: '页'
	    },
	    messagebox: {
	      title: '提示',
	      confirm: '确定',
	      cancel: '取消',
	      error: '输入的数据不合法!'
	    },
	    upload: {
	      deleteTip: '按 delete 键可删除',
	      delete: '删除',
	      preview: '查看图片',
	      continue: '继续上传'
	    },
	    table: {
	      emptyText: '暂无数据',
	      confirmFilter: '筛选',
	      resetFilter: '重置',
	      clearFilter: '全部',
	      sumText: '合计'
	    },
	    tree: {
	      emptyText: '暂无数据'
	    },
	    transfer: {
	      noMatch: '无匹配数据',
	      noData: '无数据',
	      titles: ['列表 1', '列表 2'],
	      filterPlaceholder: '请输入搜索内容',
	      noCheckedFormat: '共 {total} 项',
	      hasCheckedFormat: '已选 {checked}/{total} 项'
	    },
	    image: {
	      error: '加载失败'
	    },
	    pageHeader: {
	      title: '返回'
	    },
	    popconfirm: {
	      confirmButtonText: '确定',
	      cancelButtonText: '取消'
	    }
	  }
	};

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 53);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(45);
	
	/***/ }),
	
	/***/ 34:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-dropdown__item",
	      class: {
	        selected: _vm.itemSelected,
	        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
	        hover: _vm.hover
	      },
	      on: {
	        mouseenter: _vm.hoverItem,
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.selectOptionClick($event)
	        }
	      }
	    },
	    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var optionvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOption',
	
	  componentName: 'ElOption',
	
	  inject: ['select'],
	
	  props: {
	    value: {
	      required: true
	    },
	    label: [String, Number],
	    created: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      groupDisabled: false,
	      visible: true,
	      hitState: false,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    isObject: function isObject() {
	      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
	    },
	    currentLabel: function currentLabel() {
	      return this.label || (this.isObject ? '' : this.value);
	    },
	    currentValue: function currentValue() {
	      return this.value || this.label || '';
	    },
	    itemSelected: function itemSelected() {
	      if (!this.select.multiple) {
	        return this.isEqual(this.value, this.select.value);
	      } else {
	        return this.contains(this.select.value, this.value);
	      }
	    },
	    limitReached: function limitReached() {
	      if (this.select.multiple) {
	        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
	      } else {
	        return false;
	      }
	    }
	  },
	
	  watch: {
	    currentLabel: function currentLabel() {
	      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
	    },
	    value: function value(val, oldVal) {
	      var _select = this.select,
	          remote = _select.remote,
	          valueKey = _select.valueKey;
	
	      if (!this.created && !remote) {
	        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
	          return;
	        }
	        this.dispatch('ElSelect', 'setSelected');
	      }
	    }
	  },
	
	  methods: {
	    isEqual: function isEqual(a, b) {
	      if (!this.isObject) {
	        return a === b;
	      } else {
	        var valueKey = this.select.valueKey;
	        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
	      }
	    },
	    contains: function contains() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var target = arguments[1];
	
	      if (!this.isObject) {
	        return arr && arr.indexOf(target) > -1;
	      } else {
	        var valueKey = this.select.valueKey;
	        return arr && arr.some(function (item) {
	          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
	        });
	      }
	    },
	    handleGroupDisabled: function handleGroupDisabled(val) {
	      this.groupDisabled = val;
	    },
	    hoverItem: function hoverItem() {
	      if (!this.disabled && !this.groupDisabled) {
	        this.select.hoverIndex = this.select.options.indexOf(this);
	      }
	    },
	    selectOptionClick: function selectOptionClick() {
	      if (this.disabled !== true && this.groupDisabled !== true) {
	        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
	      }
	    },
	    queryChange: function queryChange(query) {
	      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
	      if (!this.visible) {
	        this.select.filteredOptionsCount--;
	      }
	    }
	  },
	
	  created: function created() {
	    this.select.options.push(this);
	    this.select.cachedOptions.push(this);
	    this.select.optionsCount++;
	    this.select.filteredOptionsCount++;
	
	    this.$on('queryChange', this.queryChange);
	    this.$on('handleGroupDisabled', this.handleGroupDisabled);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _select2 = this.select,
	        selected = _select2.selected,
	        multiple = _select2.multiple;
	
	    var selectedOptions = multiple ? selected : [selected];
	    var index = this.select.cachedOptions.indexOf(this);
	    var selectedIndex = selectedOptions.indexOf(this);
	
	    // if option is not selected, remove it from cache
	    if (index > -1 && selectedIndex < 0) {
	      this.select.cachedOptions.splice(index, 1);
	    }
	    this.select.onOptionDestroy(this.select.options.indexOf(this));
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_optionvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/select/src/option.vue"
	/* harmony default export */ var src_option = __webpack_exports__["a"] = (component.exports);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(74);
	
	/***/ }),
	
	/***/ 53:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _select_src_option__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34);
	
	
	/* istanbul ignore next */
	_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = function (Vue) {
	  Vue.component(_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 74);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(50);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(45);
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(124);
	
	/***/ }),
	
	/***/ 7:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(19);
	
	/***/ }),
	
	/***/ 74:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "span",
	    [
	      _c(
	        "transition",
	        {
	          attrs: { name: _vm.transition },
	          on: {
	            "after-enter": _vm.handleAfterEnter,
	            "after-leave": _vm.handleAfterLeave
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.disabled && _vm.showPopper,
	                  expression: "!disabled && showPopper"
	                }
	              ],
	              ref: "popper",
	              staticClass: "el-popover el-popper",
	              class: [_vm.popperClass, _vm.content && "el-popover--plain"],
	              style: { width: _vm.width + "px" },
	              attrs: {
	                role: "tooltip",
	                id: _vm.tooltipId,
	                "aria-hidden":
	                  _vm.disabled || !_vm.showPopper ? "true" : "false"
	              }
	            },
	            [
	              _vm.title
	                ? _c("div", {
	                    staticClass: "el-popover__title",
	                    domProps: { textContent: _vm._s(_vm.title) }
	                  })
	                : _vm._e(),
	              _vm._t("default", [_vm._v(_vm._s(_vm.content))])
	            ],
	            2
	          )
	        ]
	      ),
	      _vm._t("reference")
	    ],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(2);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var mainvue_type_script_lang_js_ = ({
	  name: 'ElPopover',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    trigger: {
	      type: String,
	      default: 'click',
	      validator: function validator(value) {
	        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
	      }
	    },
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    closeDelay: {
	      type: Number,
	      default: 200
	    },
	    title: String,
	    disabled: Boolean,
	    content: String,
	    reference: {},
	    popperClass: String,
	    width: {},
	    visibleArrow: {
	      default: true
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    transition: {
	      type: String,
	      default: 'fade-in-linear'
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  computed: {
	    tooltipId: function tooltipId() {
	      return 'el-popover-' + Object(util_["generateId"])();
	    }
	  },
	  watch: {
	    showPopper: function showPopper(val) {
	      if (this.disabled) {
	        return;
	      }
	      val ? this.$emit('show') : this.$emit('hide');
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var reference = this.referenceElm = this.reference || this.$refs.reference;
	    var popper = this.popper || this.$refs.popper;
	
	    if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	      reference = this.referenceElm = this.$slots.reference[0].elm;
	    }
	    // 可访问性
	    if (reference) {
	      Object(dom_["addClass"])(reference, 'el-popover__reference');
	      reference.setAttribute('aria-describedby', this.tooltipId);
	      reference.setAttribute('tabindex', this.tabindex); // tab序列
	      popper.setAttribute('tabindex', 0);
	
	      if (this.trigger !== 'click') {
	        Object(dom_["on"])(reference, 'focusin', function () {
	          _this.handleFocus();
	          var instance = reference.__vue__;
	          if (instance && typeof instance.focus === 'function') {
	            instance.focus();
	          }
	        });
	        Object(dom_["on"])(popper, 'focusin', this.handleFocus);
	        Object(dom_["on"])(reference, 'focusout', this.handleBlur);
	        Object(dom_["on"])(popper, 'focusout', this.handleBlur);
	      }
	      Object(dom_["on"])(reference, 'keydown', this.handleKeydown);
	      Object(dom_["on"])(reference, 'click', this.handleClick);
	    }
	    if (this.trigger === 'click') {
	      Object(dom_["on"])(reference, 'click', this.doToggle);
	      Object(dom_["on"])(document, 'click', this.handleDocumentClick);
	    } else if (this.trigger === 'hover') {
	      Object(dom_["on"])(reference, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(popper, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(reference, 'mouseleave', this.handleMouseLeave);
	      Object(dom_["on"])(popper, 'mouseleave', this.handleMouseLeave);
	    } else if (this.trigger === 'focus') {
	      if (this.tabindex < 0) {
	        console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');
	      }
	      if (reference.querySelector('input, textarea')) {
	        Object(dom_["on"])(reference, 'focusin', this.doShow);
	        Object(dom_["on"])(reference, 'focusout', this.doClose);
	      } else {
	        Object(dom_["on"])(reference, 'mousedown', this.doShow);
	        Object(dom_["on"])(reference, 'mouseup', this.doClose);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.cleanup();
	  },
	  deactivated: function deactivated() {
	    this.cleanup();
	  },
	
	
	  methods: {
	    doToggle: function doToggle() {
	      this.showPopper = !this.showPopper;
	    },
	    doShow: function doShow() {
	      this.showPopper = true;
	    },
	    doClose: function doClose() {
	      this.showPopper = false;
	    },
	    handleFocus: function handleFocus() {
	      Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = true;
	    },
	    handleClick: function handleClick() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	    },
	    handleBlur: function handleBlur() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = false;
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      var _this2 = this;
	
	      clearTimeout(this._timer);
	      if (this.openDelay) {
	        this._timer = setTimeout(function () {
	          _this2.showPopper = true;
	        }, this.openDelay);
	      } else {
	        this.showPopper = true;
	      }
	    },
	    handleKeydown: function handleKeydown(ev) {
	      if (ev.keyCode === 27 && this.trigger !== 'manual') {
	        // esc
	        this.doClose();
	      }
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      var _this3 = this;
	
	      clearTimeout(this._timer);
	      if (this.closeDelay) {
	        this._timer = setTimeout(function () {
	          _this3.showPopper = false;
	        }, this.closeDelay);
	      } else {
	        this.showPopper = false;
	      }
	    },
	    handleDocumentClick: function handleDocumentClick(e) {
	      var reference = this.reference || this.$refs.reference;
	      var popper = this.popper || this.$refs.popper;
	
	      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	        reference = this.referenceElm = this.$slots.reference[0].elm;
	      }
	      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
	      this.showPopper = false;
	    },
	    handleAfterEnter: function handleAfterEnter() {
	      this.$emit('after-enter');
	    },
	    handleAfterLeave: function handleAfterLeave() {
	      this.$emit('after-leave');
	      this.doDestroy();
	    },
	    cleanup: function cleanup() {
	      if (this.openDelay || this.closeDelay) {
	        clearTimeout(this._timer);
	      }
	    }
	  },
	
	  destroyed: function destroyed() {
	    var reference = this.reference;
	
	    Object(dom_["off"])(reference, 'click', this.doToggle);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'focusin', this.doShow);
	    Object(dom_["off"])(reference, 'focusout', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mouseleave', this.handleMouseLeave);
	    Object(dom_["off"])(reference, 'mouseenter', this.handleMouseEnter);
	    Object(dom_["off"])(document, 'click', this.handleDocumentClick);
	  }
	});
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/popover/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_mainvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/popover/src/main.vue"
	/* harmony default export */ var main = (component.exports);
	// CONCATENATED MODULE: ./packages/popover/src/directive.js
	var getReference = function getReference(el, binding, vnode) {
	  var _ref = binding.expression ? binding.value : binding.arg;
	  var popper = vnode.context.$refs[_ref];
	  if (popper) {
	    if (Array.isArray(popper)) {
	      popper[0].$refs.reference = el;
	    } else {
	      popper.$refs.reference = el;
	    }
	  }
	};
	
	/* harmony default export */ var directive = ({
	  bind: function bind(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  },
	  inserted: function inserted(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  }
	});
	// EXTERNAL MODULE: external "vue"
	var external_vue_ = __webpack_require__(7);
	var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
	
	// CONCATENATED MODULE: ./packages/popover/index.js
	
	
	
	
	external_vue_default.a.directive('popover', directive);
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.directive('popover', directive);
	  Vue.component(main.name, main);
	};
	main.directive = directive;
	
	/* harmony default export */ var popover = __webpack_exports__["default"] = (main);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 119);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 119:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-progress",
	      class: [
	        "el-progress--" + _vm.type,
	        _vm.status ? "is-" + _vm.status : "",
	        {
	          "el-progress--without-text": !_vm.showText,
	          "el-progress--text-inside": _vm.textInside
	        }
	      ],
	      attrs: {
	        role: "progressbar",
	        "aria-valuenow": _vm.percentage,
	        "aria-valuemin": "0",
	        "aria-valuemax": "100"
	      }
	    },
	    [
	      _vm.type === "line"
	        ? _c("div", { staticClass: "el-progress-bar" }, [
	            _c(
	              "div",
	              {
	                staticClass: "el-progress-bar__outer",
	                style: { height: _vm.strokeWidth + "px" }
	              },
	              [
	                _c(
	                  "div",
	                  {
	                    staticClass: "el-progress-bar__inner",
	                    style: _vm.barStyle
	                  },
	                  [
	                    _vm.showText && _vm.textInside
	                      ? _c(
	                          "div",
	                          { staticClass: "el-progress-bar__innerText" },
	                          [_vm._v(_vm._s(_vm.content))]
	                        )
	                      : _vm._e()
	                  ]
	                )
	              ]
	            )
	          ])
	        : _c(
	            "div",
	            {
	              staticClass: "el-progress-circle",
	              style: { height: _vm.width + "px", width: _vm.width + "px" }
	            },
	            [
	              _c("svg", { attrs: { viewBox: "0 0 100 100" } }, [
	                _c("path", {
	                  staticClass: "el-progress-circle__track",
	                  style: _vm.trailPathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: "#e5e9f2",
	                    "stroke-width": _vm.relativeStrokeWidth,
	                    fill: "none"
	                  }
	                }),
	                _c("path", {
	                  staticClass: "el-progress-circle__path",
	                  style: _vm.circlePathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: _vm.stroke,
	                    fill: "none",
	                    "stroke-linecap": _vm.strokeLinecap,
	                    "stroke-width": _vm.percentage ? _vm.relativeStrokeWidth : 0
	                  }
	                })
	              ])
	            ]
	          ),
	      _vm.showText && !_vm.textInside
	        ? _c(
	            "div",
	            {
	              staticClass: "el-progress__text",
	              style: { fontSize: _vm.progressTextSize + "px" }
	            },
	            [
	              !_vm.status
	                ? [_vm._v(_vm._s(_vm.content))]
	                : _c("i", { class: _vm.iconClass })
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var progressvue_type_script_lang_js_ = ({
	  name: 'ElProgress',
	  props: {
	    type: {
	      type: String,
	      default: 'line',
	      validator: function validator(val) {
	        return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
	      }
	    },
	    percentage: {
	      type: Number,
	      default: 0,
	      required: true,
	      validator: function validator(val) {
	        return val >= 0 && val <= 100;
	      }
	    },
	    status: {
	      type: String,
	      validator: function validator(val) {
	        return ['success', 'exception', 'warning'].indexOf(val) > -1;
	      }
	    },
	    strokeWidth: {
	      type: Number,
	      default: 6
	    },
	    strokeLinecap: {
	      type: String,
	      default: 'round'
	    },
	    textInside: {
	      type: Boolean,
	      default: false
	    },
	    width: {
	      type: Number,
	      default: 126
	    },
	    showText: {
	      type: Boolean,
	      default: true
	    },
	    color: {
	      type: [String, Array, Function],
	      default: ''
	    },
	    format: Function
	  },
	  computed: {
	    barStyle: function barStyle() {
	      var style = {};
	      style.width = this.percentage + '%';
	      style.backgroundColor = this.getCurrentColor(this.percentage);
	      return style;
	    },
	    relativeStrokeWidth: function relativeStrokeWidth() {
	      return (this.strokeWidth / this.width * 100).toFixed(1);
	    },
	    radius: function radius() {
	      if (this.type === 'circle' || this.type === 'dashboard') {
	        return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
	      } else {
	        return 0;
	      }
	    },
	    trackPath: function trackPath() {
	      var radius = this.radius;
	      var isDashboard = this.type === 'dashboard';
	      return '\n        M 50 50\n        m 0 ' + (isDashboard ? '' : '-') + radius + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '-' : '') + radius * 2 + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '' : '-') + radius * 2 + '\n        ';
	    },
	    perimeter: function perimeter() {
	      return 2 * Math.PI * this.radius;
	    },
	    rate: function rate() {
	      return this.type === 'dashboard' ? 0.75 : 1;
	    },
	    strokeDashoffset: function strokeDashoffset() {
	      var offset = -1 * this.perimeter * (1 - this.rate) / 2;
	      return offset + 'px';
	    },
	    trailPathStyle: function trailPathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset
	      };
	    },
	    circlePathStyle: function circlePathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate * (this.percentage / 100) + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset,
	        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
	      };
	    },
	    stroke: function stroke() {
	      var ret = void 0;
	      if (this.color) {
	        ret = this.getCurrentColor(this.percentage);
	      } else {
	        switch (this.status) {
	          case 'success':
	            ret = '#13ce66';
	            break;
	          case 'exception':
	            ret = '#ff4949';
	            break;
	          case 'warning':
	            ret = '#e6a23c';
	            break;
	          default:
	            ret = '#20a0ff';
	        }
	      }
	      return ret;
	    },
	    iconClass: function iconClass() {
	      if (this.status === 'warning') {
	        return 'el-icon-warning';
	      }
	      if (this.type === 'line') {
	        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
	      } else {
	        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
	      }
	    },
	    progressTextSize: function progressTextSize() {
	      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
	    },
	    content: function content() {
	      if (typeof this.format === 'function') {
	        return this.format(this.percentage) || '';
	      } else {
	        return this.percentage + '%';
	      }
	    }
	  },
	  methods: {
	    getCurrentColor: function getCurrentColor(percentage) {
	      if (typeof this.color === 'function') {
	        return this.color(percentage);
	      } else if (typeof this.color === 'string') {
	        return this.color;
	      } else {
	        return this.getLevelColor(percentage);
	      }
	    },
	    getLevelColor: function getLevelColor(percentage) {
	      var colorArray = this.getColorArray().sort(function (a, b) {
	        return a.percentage - b.percentage;
	      });
	
	      for (var i = 0; i < colorArray.length; i++) {
	        if (colorArray[i].percentage > percentage) {
	          return colorArray[i].color;
	        }
	      }
	      return colorArray[colorArray.length - 1].color;
	    },
	    getColorArray: function getColorArray() {
	      var color = this.color;
	      var span = 100 / color.length;
	      return color.map(function (seriesColor, index) {
	        if (typeof seriesColor === 'string') {
	          return {
	            color: seriesColor,
	            progress: (index + 1) * span
	          };
	        }
	        return seriesColor;
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_progressvue_type_script_lang_js_ = (progressvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_progressvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/progress/src/progress.vue"
	/* harmony default export */ var progress = (component.exports);
	// CONCATENATED MODULE: ./packages/progress/index.js
	
	
	/* istanbul ignore next */
	progress.install = function (Vue) {
	  Vue.component(progress.name, progress);
	};
	
	/* harmony default export */ var packages_progress = __webpack_exports__["default"] = (progress);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 61);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	/* 1 */,
	/* 2 */,
	/* 3 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(45);
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(74);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(124);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(179);
	
	/***/ }),
	/* 7 */,
	/* 8 */,
	/* 9 */,
	/* 10 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(177);
	
	/***/ }),
	/* 11 */,
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(264);
	
	/***/ }),
	/* 13 */,
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(180);
	
	/***/ }),
	/* 15 */,
	/* 16 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(182);
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(125);
	
	/***/ }),
	/* 18 */,
	/* 19 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(85);
	
	/***/ }),
	/* 20 */,
	/* 21 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(123);
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(178);
	
	/***/ }),
	/* 23 */,
	/* 24 */,
	/* 25 */,
	/* 26 */,
	/* 27 */,
	/* 28 */,
	/* 29 */,
	/* 30 */,
	/* 31 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(183);
	
	/***/ }),
	/* 32 */,
	/* 33 */,
	/* 34 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-dropdown__item",
	      class: {
	        selected: _vm.itemSelected,
	        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
	        hover: _vm.hover
	      },
	      on: {
	        mouseenter: _vm.hoverItem,
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.selectOptionClick($event)
	        }
	      }
	    },
	    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var optionvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOption',
	
	  componentName: 'ElOption',
	
	  inject: ['select'],
	
	  props: {
	    value: {
	      required: true
	    },
	    label: [String, Number],
	    created: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      groupDisabled: false,
	      visible: true,
	      hitState: false,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    isObject: function isObject() {
	      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
	    },
	    currentLabel: function currentLabel() {
	      return this.label || (this.isObject ? '' : this.value);
	    },
	    currentValue: function currentValue() {
	      return this.value || this.label || '';
	    },
	    itemSelected: function itemSelected() {
	      if (!this.select.multiple) {
	        return this.isEqual(this.value, this.select.value);
	      } else {
	        return this.contains(this.select.value, this.value);
	      }
	    },
	    limitReached: function limitReached() {
	      if (this.select.multiple) {
	        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
	      } else {
	        return false;
	      }
	    }
	  },
	
	  watch: {
	    currentLabel: function currentLabel() {
	      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
	    },
	    value: function value(val, oldVal) {
	      var _select = this.select,
	          remote = _select.remote,
	          valueKey = _select.valueKey;
	
	      if (!this.created && !remote) {
	        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
	          return;
	        }
	        this.dispatch('ElSelect', 'setSelected');
	      }
	    }
	  },
	
	  methods: {
	    isEqual: function isEqual(a, b) {
	      if (!this.isObject) {
	        return a === b;
	      } else {
	        var valueKey = this.select.valueKey;
	        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
	      }
	    },
	    contains: function contains() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var target = arguments[1];
	
	      if (!this.isObject) {
	        return arr && arr.indexOf(target) > -1;
	      } else {
	        var valueKey = this.select.valueKey;
	        return arr && arr.some(function (item) {
	          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
	        });
	      }
	    },
	    handleGroupDisabled: function handleGroupDisabled(val) {
	      this.groupDisabled = val;
	    },
	    hoverItem: function hoverItem() {
	      if (!this.disabled && !this.groupDisabled) {
	        this.select.hoverIndex = this.select.options.indexOf(this);
	      }
	    },
	    selectOptionClick: function selectOptionClick() {
	      if (this.disabled !== true && this.groupDisabled !== true) {
	        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
	      }
	    },
	    queryChange: function queryChange(query) {
	      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
	      if (!this.visible) {
	        this.select.filteredOptionsCount--;
	      }
	    }
	  },
	
	  created: function created() {
	    this.select.options.push(this);
	    this.select.cachedOptions.push(this);
	    this.select.optionsCount++;
	    this.select.filteredOptionsCount++;
	
	    this.$on('queryChange', this.queryChange);
	    this.$on('handleGroupDisabled', this.handleGroupDisabled);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _select2 = this.select,
	        selected = _select2.selected,
	        multiple = _select2.multiple;
	
	    var selectedOptions = multiple ? selected : [selected];
	    var index = this.select.cachedOptions.indexOf(this);
	    var selectedIndex = selectedOptions.indexOf(this);
	
	    // if option is not selected, remove it from cache
	    if (index > -1 && selectedIndex < 0) {
	      this.select.cachedOptions.splice(index, 1);
	    }
	    this.select.onOptionDestroy(this.select.options.indexOf(this));
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_optionvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/select/src/option.vue"
	/* harmony default export */ var src_option = __webpack_exports__["a"] = (component.exports);
	
	/***/ }),
	/* 35 */,
	/* 36 */,
	/* 37 */,
	/* 38 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(263);
	
	/***/ }),
	/* 39 */,
	/* 40 */,
	/* 41 */,
	/* 42 */,
	/* 43 */,
	/* 44 */,
	/* 45 */,
	/* 46 */,
	/* 47 */,
	/* 48 */,
	/* 49 */,
	/* 50 */,
	/* 51 */,
	/* 52 */,
	/* 53 */,
	/* 54 */,
	/* 55 */,
	/* 56 */,
	/* 57 */,
	/* 58 */,
	/* 59 */,
	/* 60 */,
	/* 61 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.handleClose,
	          expression: "handleClose"
	        }
	      ],
	      staticClass: "el-select",
	      class: [_vm.selectSize ? "el-select--" + _vm.selectSize : ""],
	      on: {
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.toggleMenu($event)
	        }
	      }
	    },
	    [
	      _vm.multiple
	        ? _c(
	            "div",
	            {
	              ref: "tags",
	              staticClass: "el-select__tags",
	              style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
	            },
	            [
	              _vm.collapseTags && _vm.selected.length
	                ? _c(
	                    "span",
	                    [
	                      _c(
	                        "el-tag",
	                        {
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: _vm.selected[0].hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, _vm.selected[0])
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(_vm.selected[0].currentLabel))
	                          ])
	                        ]
	                      ),
	                      _vm.selected.length > 1
	                        ? _c(
	                            "el-tag",
	                            {
	                              attrs: {
	                                closable: false,
	                                size: _vm.collapseTagSize,
	                                type: "info",
	                                "disable-transitions": ""
	                              }
	                            },
	                            [
	                              _c(
	                                "span",
	                                { staticClass: "el-select__tags-text" },
	                                [_vm._v("+ " + _vm._s(_vm.selected.length - 1))]
	                              )
	                            ]
	                          )
	                        : _vm._e()
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              !_vm.collapseTags
	                ? _c(
	                    "transition-group",
	                    { on: { "after-leave": _vm.resetInputHeight } },
	                    _vm._l(_vm.selected, function(item) {
	                      return _c(
	                        "el-tag",
	                        {
	                          key: _vm.getValueKey(item),
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: item.hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, item)
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(item.currentLabel))
	                          ])
	                        ]
	                      )
	                    }),
	                    1
	                  )
	                : _vm._e(),
	              _vm.filterable
	                ? _c("input", {
	                    directives: [
	                      {
	                        name: "model",
	                        rawName: "v-model",
	                        value: _vm.query,
	                        expression: "query"
	                      }
	                    ],
	                    ref: "input",
	                    staticClass: "el-select__input",
	                    class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
	                    style: {
	                      "flex-grow": "1",
	                      width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
	                      "max-width": _vm.inputWidth - 42 + "px"
	                    },
	                    attrs: {
	                      type: "text",
	                      disabled: _vm.selectDisabled,
	                      autocomplete: _vm.autoComplete || _vm.autocomplete
	                    },
	                    domProps: { value: _vm.query },
	                    on: {
	                      focus: _vm.handleFocus,
	                      blur: function($event) {
	                        _vm.softFocus = false
	                      },
	                      keyup: _vm.managePlaceholder,
	                      keydown: [
	                        _vm.resetInputState,
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "down", 40, $event.key, [
	                              "Down",
	                              "ArrowDown"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("next")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "up", 38, $event.key, [
	                              "Up",
	                              "ArrowUp"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("prev")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "enter",
	                              13,
	                              $event.key,
	                              "Enter"
	                            )
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          return _vm.selectOption($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "esc", 27, $event.key, [
	                              "Esc",
	                              "Escape"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.stopPropagation()
	                          $event.preventDefault()
	                          _vm.visible = false
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "delete",
	                              [8, 46],
	                              $event.key,
	                              ["Backspace", "Delete", "Del"]
	                            )
	                          ) {
	                            return null
	                          }
	                          return _vm.deletePrevTag($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                          ) {
	                            return null
	                          }
	                          _vm.visible = false
	                        }
	                      ],
	                      compositionstart: _vm.handleComposition,
	                      compositionupdate: _vm.handleComposition,
	                      compositionend: _vm.handleComposition,
	                      input: [
	                        function($event) {
	                          if ($event.target.composing) {
	                            return
	                          }
	                          _vm.query = $event.target.value
	                        },
	                        _vm.debouncedQueryChange
	                      ]
	                    }
	                  })
	                : _vm._e()
	            ],
	            1
	          )
	        : _vm._e(),
	      _c(
	        "el-input",
	        {
	          ref: "reference",
	          class: { "is-focus": _vm.visible },
	          attrs: {
	            type: "text",
	            placeholder: _vm.currentPlaceholder,
	            name: _vm.name,
	            id: _vm.id,
	            autocomplete: _vm.autoComplete || _vm.autocomplete,
	            size: _vm.selectSize,
	            disabled: _vm.selectDisabled,
	            readonly: _vm.readonly,
	            "validate-event": false,
	            tabindex: _vm.multiple && _vm.filterable ? "-1" : null
	          },
	          on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
	          nativeOn: {
	            keyup: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            keydown: [
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "down", 40, $event.key, [
	                    "Down",
	                    "ArrowDown"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("next")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "up", 38, $event.key, [
	                    "Up",
	                    "ArrowUp"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("prev")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                ) {
	                  return null
	                }
	                $event.preventDefault()
	                return _vm.selectOption($event)
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "esc", 27, $event.key, [
	                    "Esc",
	                    "Escape"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.visible = false
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                ) {
	                  return null
	                }
	                _vm.visible = false
	              }
	            ],
	            paste: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            mouseenter: function($event) {
	              _vm.inputHovering = true
	            },
	            mouseleave: function($event) {
	              _vm.inputHovering = false
	            }
	          },
	          model: {
	            value: _vm.selectedLabel,
	            callback: function($$v) {
	              _vm.selectedLabel = $$v
	            },
	            expression: "selectedLabel"
	          }
	        },
	        [
	          _vm.$slots.prefix
	            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
	            : _vm._e(),
	          _c("template", { slot: "suffix" }, [
	            _c("i", {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.showClose,
	                  expression: "!showClose"
	                }
	              ],
	              class: [
	                "el-select__caret",
	                "el-input__icon",
	                "el-icon-" + _vm.iconClass
	              ]
	            }),
	            _vm.showClose
	              ? _c("i", {
	                  staticClass:
	                    "el-select__caret el-input__icon el-icon-circle-close",
	                  on: { click: _vm.handleClearClick }
	                })
	              : _vm._e()
	          ])
	        ],
	        2
	      ),
	      _c(
	        "transition",
	        {
	          attrs: { name: "el-zoom-in-top" },
	          on: {
	            "before-enter": _vm.handleMenuEnter,
	            "after-leave": _vm.doDestroy
	          }
	        },
	        [
	          _c(
	            "el-select-menu",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.visible && _vm.emptyText !== false,
	                  expression: "visible && emptyText !== false"
	                }
	              ],
	              ref: "popper",
	              attrs: { "append-to-body": _vm.popperAppendToBody }
	            },
	            [
	              _c(
	                "el-scrollbar",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.options.length > 0 && !_vm.loading,
	                      expression: "options.length > 0 && !loading"
	                    }
	                  ],
	                  ref: "scrollbar",
	                  class: {
	                    "is-empty":
	                      !_vm.allowCreate &&
	                      _vm.query &&
	                      _vm.filteredOptionsCount === 0
	                  },
	                  attrs: {
	                    tag: "ul",
	                    "wrap-class": "el-select-dropdown__wrap",
	                    "view-class": "el-select-dropdown__list"
	                  }
	                },
	                [
	                  _vm.showNewOption
	                    ? _c("el-option", {
	                        attrs: { value: _vm.query, created: "" }
	                      })
	                    : _vm._e(),
	                  _vm._t("default")
	                ],
	                2
	              ),
	              _vm.emptyText &&
	              (!_vm.allowCreate ||
	                _vm.loading ||
	                (_vm.allowCreate && _vm.options.length === 0))
	                ? [
	                    _vm.$slots.empty
	                      ? _vm._t("empty")
	                      : _c("p", { staticClass: "el-select-dropdown__empty" }, [
	                          _vm._v(
	                            "\n          " +
	                              _vm._s(_vm.emptyText) +
	                              "\n        "
	                          )
	                        ])
	                  ]
	                : _vm._e()
	            ],
	            2
	          )
	        ],
	        1
	      )
	    ],
	    1
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
	var focus_ = __webpack_require__(22);
	var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
	var locale_ = __webpack_require__(6);
	var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);
	
	// EXTERNAL MODULE: external "element-ui/lib/input"
	var input_ = __webpack_require__(10);
	var input_default = /*#__PURE__*/__webpack_require__.n(input_);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	var select_dropdownvue_type_template_id_06828748_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-select-dropdown el-popper",
	      class: [{ "is-multiple": _vm.$parent.multiple }, _vm.popperClass],
	      style: { minWidth: _vm.minWidth }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var select_dropdownvue_type_template_id_06828748_staticRenderFns = []
	select_dropdownvue_type_template_id_06828748_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var select_dropdownvue_type_script_lang_js_ = ({
	  name: 'ElSelectDropdown',
	
	  componentName: 'ElSelectDropdown',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    placement: {
	      default: 'bottom-start'
	    },
	
	    boundariesPadding: {
	      default: 0
	    },
	
	    popperOptions: {
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    },
	
	    visibleArrow: {
	      default: true
	    },
	
	    appendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      minWidth: ''
	    };
	  },
	
	
	  computed: {
	    popperClass: function popperClass() {
	      return this.$parent.popperClass;
	    }
	  },
	
	  watch: {
	    '$parent.inputWidth': function $parentInputWidth() {
	      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.referenceElm = this.$parent.$refs.reference.$el;
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.$on('updatePopper', function () {
	      if (_this.$parent.visible) _this.updatePopper();
	    });
	    this.$on('destroyPopper', this.destroyPopper);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_select_dropdownvue_type_script_lang_js_ = (select_dropdownvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_select_dropdownvue_type_script_lang_js_,
	  select_dropdownvue_type_template_id_06828748_render,
	  select_dropdownvue_type_template_id_06828748_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/select/src/select-dropdown.vue"
	/* harmony default export */ var select_dropdown = (component.exports);
	// EXTERNAL MODULE: ./packages/select/src/option.vue + 4 modules
	var src_option = __webpack_require__(34);
	
	// EXTERNAL MODULE: external "element-ui/lib/tag"
	var tag_ = __webpack_require__(38);
	var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);
	
	// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
	var scrollbar_ = __webpack_require__(14);
	var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);
	
	// EXTERNAL MODULE: external "throttle-debounce/debounce"
	var debounce_ = __webpack_require__(17);
	var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
	var clickoutside_ = __webpack_require__(12);
	var clickoutside_default = /*#__PURE__*/__webpack_require__.n(clickoutside_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
	var resize_event_ = __webpack_require__(16);
	
	// EXTERNAL MODULE: external "element-ui/lib/locale"
	var lib_locale_ = __webpack_require__(19);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
	var scroll_into_view_ = __webpack_require__(31);
	var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
	/* harmony default export */ var navigation_mixin = ({
	  data: function data() {
	    return {
	      hoverOption: -1
	    };
	  },
	
	
	  computed: {
	    optionsAllDisabled: function optionsAllDisabled() {
	      return this.options.filter(function (option) {
	        return option.visible;
	      }).every(function (option) {
	        return option.disabled;
	      });
	    }
	  },
	
	  watch: {
	    hoverIndex: function hoverIndex(val) {
	      var _this = this;
	
	      if (typeof val === 'number' && val > -1) {
	        this.hoverOption = this.options[val] || {};
	      }
	      this.options.forEach(function (option) {
	        option.hover = _this.hoverOption === option;
	      });
	    }
	  },
	
	  methods: {
	    navigateOptions: function navigateOptions(direction) {
	      var _this2 = this;
	
	      if (!this.visible) {
	        this.visible = true;
	        return;
	      }
	      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
	      if (!this.optionsAllDisabled) {
	        if (direction === 'next') {
	          this.hoverIndex++;
	          if (this.hoverIndex === this.options.length) {
	            this.hoverIndex = 0;
	          }
	        } else if (direction === 'prev') {
	          this.hoverIndex--;
	          if (this.hoverIndex < 0) {
	            this.hoverIndex = this.options.length - 1;
	          }
	        }
	        var option = this.options[this.hoverIndex];
	        if (option.disabled === true || option.groupDisabled === true || !option.visible) {
	          this.navigateOptions(direction);
	        }
	        this.$nextTick(function () {
	          return _this2.scrollToOption(_this2.hoverOption);
	        });
	      }
	    }
	  }
	});
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(21);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var selectvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a, locale_default.a, focus_default()('reference'), navigation_mixin],
	
	  name: 'ElSelect',
	
	  componentName: 'ElSelect',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  provide: function provide() {
	    return {
	      'select': this
	    };
	  },
	
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    readonly: function readonly() {
	      return !this.filterable || this.multiple || !Object(util_["isIE"])() && !Object(util_["isEdge"])() && !this.visible;
	    },
	    showClose: function showClose() {
	      var hasValue = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
	      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && hasValue;
	      return criteria;
	    },
	    iconClass: function iconClass() {
	      return this.remote && this.filterable ? '' : this.visible ? 'arrow-up is-reverse' : 'arrow-up';
	    },
	    debounce: function debounce() {
	      return this.remote ? 300 : 0;
	    },
	    emptyText: function emptyText() {
	      if (this.loading) {
	        return this.loadingText || this.t('el.select.loading');
	      } else {
	        if (this.remote && this.query === '' && this.options.length === 0) return false;
	        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
	          return this.noMatchText || this.t('el.select.noMatch');
	        }
	        if (this.options.length === 0) {
	          return this.noDataText || this.t('el.select.noData');
	        }
	      }
	      return null;
	    },
	    showNewOption: function showNewOption() {
	      var _this = this;
	
	      var hasExistingOption = this.options.filter(function (option) {
	        return !option.created;
	      }).some(function (option) {
	        return option.currentLabel === _this.query;
	      });
	      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
	    },
	    selectSize: function selectSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    selectDisabled: function selectDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    collapseTagSize: function collapseTagSize() {
	      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElSelectMenu: select_dropdown,
	    ElOption: src_option["a" /* default */],
	    ElTag: tag_default.a,
	    ElScrollbar: scrollbar_default.a
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  props: {
	    name: String,
	    id: String,
	    value: {
	      required: true
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    automaticDropdown: Boolean,
	    size: String,
	    disabled: Boolean,
	    clearable: Boolean,
	    filterable: Boolean,
	    allowCreate: Boolean,
	    loading: Boolean,
	    popperClass: String,
	    remote: Boolean,
	    loadingText: String,
	    noMatchText: String,
	    noDataText: String,
	    remoteMethod: Function,
	    filterMethod: Function,
	    multiple: Boolean,
	    multipleLimit: {
	      type: Number,
	      default: 0
	    },
	    placeholder: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.select.placeholder');
	      }
	    },
	    defaultFirstOption: Boolean,
	    reserveKeyword: Boolean,
	    valueKey: {
	      type: String,
	      default: 'value'
	    },
	    collapseTags: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      options: [],
	      cachedOptions: [],
	      createdLabel: null,
	      createdSelected: false,
	      selected: this.multiple ? [] : {},
	      inputLength: 20,
	      inputWidth: 0,
	      initialInputHeight: 0,
	      cachedPlaceHolder: '',
	      optionsCount: 0,
	      filteredOptionsCount: 0,
	      visible: false,
	      softFocus: false,
	      selectedLabel: '',
	      hoverIndex: -1,
	      query: '',
	      previousQuery: null,
	      inputHovering: false,
	      currentPlaceholder: '',
	      menuVisibleOnFocus: false,
	      isOnComposition: false,
	      isSilentBlur: false
	    };
	  },
	
	
	  watch: {
	    selectDisabled: function selectDisabled() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.resetInputHeight();
	      });
	    },
	    placeholder: function placeholder(val) {
	      this.cachedPlaceHolder = this.currentPlaceholder = val;
	    },
	    value: function value(val, oldVal) {
	      if (this.multiple) {
	        this.resetInputHeight();
	        if (val && val.length > 0 || this.$refs.input && this.query !== '') {
	          this.currentPlaceholder = '';
	        } else {
	          this.currentPlaceholder = this.cachedPlaceHolder;
	        }
	        if (this.filterable && !this.reserveKeyword) {
	          this.query = '';
	          this.handleQueryChange(this.query);
	        }
	      }
	      this.setSelected();
	      if (this.filterable && !this.multiple) {
	        this.inputLength = 20;
	      }
	      if (!Object(util_["valueEquals"])(val, oldVal)) {
	        this.dispatch('ElFormItem', 'el.form.change', val);
	      }
	    },
	    visible: function visible(val) {
	      var _this3 = this;
	
	      if (!val) {
	        this.broadcast('ElSelectDropdown', 'destroyPopper');
	        if (this.$refs.input) {
	          this.$refs.input.blur();
	        }
	        this.query = '';
	        this.previousQuery = null;
	        this.selectedLabel = '';
	        this.inputLength = 20;
	        this.menuVisibleOnFocus = false;
	        this.resetHoverIndex();
	        this.$nextTick(function () {
	          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
	            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
	          }
	        });
	        if (!this.multiple) {
	          if (this.selected) {
	            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
	              this.selectedLabel = this.createdLabel;
	            } else {
	              this.selectedLabel = this.selected.currentLabel;
	            }
	            if (this.filterable) this.query = this.selectedLabel;
	          }
	
	          if (this.filterable) {
	            this.currentPlaceholder = this.cachedPlaceHolder;
	          }
	        }
	      } else {
	        this.broadcast('ElSelectDropdown', 'updatePopper');
	        if (this.filterable) {
	          this.query = this.remote ? '' : this.selectedLabel;
	          this.handleQueryChange(this.query);
	          if (this.multiple) {
	            this.$refs.input.focus();
	          } else {
	            if (!this.remote) {
	              this.broadcast('ElOption', 'queryChange', '');
	              this.broadcast('ElOptionGroup', 'queryChange');
	            }
	
	            if (this.selectedLabel) {
	              this.currentPlaceholder = this.selectedLabel;
	              this.selectedLabel = '';
	            }
	          }
	        }
	      }
	      this.$emit('visible-change', val);
	    },
	    options: function options() {
	      var _this4 = this;
	
	      if (this.$isServer) return;
	      this.$nextTick(function () {
	        _this4.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      if (this.multiple) {
	        this.resetInputHeight();
	      }
	      var inputs = this.$el.querySelectorAll('input');
	      if ([].indexOf.call(inputs, document.activeElement) === -1) {
	        this.setSelected();
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    }
	  },
	
	  methods: {
	    handleComposition: function handleComposition(event) {
	      var _this5 = this;
	
	      var text = event.target.value;
	      if (event.type === 'compositionend') {
	        this.isOnComposition = false;
	        this.$nextTick(function (_) {
	          return _this5.handleQueryChange(text);
	        });
	      } else {
	        var lastCharacter = text[text.length - 1] || '';
	        this.isOnComposition = !Object(shared_["isKorean"])(lastCharacter);
	      }
	    },
	    handleQueryChange: function handleQueryChange(val) {
	      var _this6 = this;
	
	      if (this.previousQuery === val || this.isOnComposition) return;
	      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
	        this.previousQuery = val;
	        return;
	      }
	      this.previousQuery = val;
	      this.$nextTick(function () {
	        if (_this6.visible) _this6.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      this.hoverIndex = -1;
	      if (this.multiple && this.filterable) {
	        this.$nextTick(function () {
	          var length = _this6.$refs.input.value.length * 15 + 20;
	          _this6.inputLength = _this6.collapseTags ? Math.min(50, length) : length;
	          _this6.managePlaceholder();
	          _this6.resetInputHeight();
	        });
	      }
	      if (this.remote && typeof this.remoteMethod === 'function') {
	        this.hoverIndex = -1;
	        this.remoteMethod(val);
	      } else if (typeof this.filterMethod === 'function') {
	        this.filterMethod(val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      } else {
	        this.filteredOptionsCount = this.optionsCount;
	        this.broadcast('ElOption', 'queryChange', val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    },
	    scrollToOption: function scrollToOption(option) {
	      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
	      if (this.$refs.popper && target) {
	        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
	        scroll_into_view_default()(menu, target);
	      }
	      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
	    },
	    handleMenuEnter: function handleMenuEnter() {
	      var _this7 = this;
	
	      this.$nextTick(function () {
	        return _this7.scrollToOption(_this7.selected);
	      });
	    },
	    emitChange: function emitChange(val) {
	      if (!Object(util_["valueEquals"])(this.value, val)) {
	        this.$emit('change', val);
	      }
	    },
	    getOption: function getOption(value) {
	      var option = void 0;
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
	      var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';
	
	      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
	        var cachedOption = this.cachedOptions[i];
	        var isEqual = isObject ? Object(util_["getValueByPath"])(cachedOption.value, this.valueKey) === Object(util_["getValueByPath"])(value, this.valueKey) : cachedOption.value === value;
	        if (isEqual) {
	          option = cachedOption;
	          break;
	        }
	      }
	      if (option) return option;
	      var label = !isObject && !isNull && !isUndefined ? value : '';
	      var newOption = {
	        value: value,
	        currentLabel: label
	      };
	      if (this.multiple) {
	        newOption.hitState = false;
	      }
	      return newOption;
	    },
	    setSelected: function setSelected() {
	      var _this8 = this;
	
	      if (!this.multiple) {
	        var option = this.getOption(this.value);
	        if (option.created) {
	          this.createdLabel = option.currentLabel;
	          this.createdSelected = true;
	        } else {
	          this.createdSelected = false;
	        }
	        this.selectedLabel = option.currentLabel;
	        this.selected = option;
	        if (this.filterable) this.query = this.selectedLabel;
	        return;
	      }
	      var result = [];
	      if (Array.isArray(this.value)) {
	        this.value.forEach(function (value) {
	          result.push(_this8.getOption(value));
	        });
	      }
	      this.selected = result;
	      this.$nextTick(function () {
	        _this8.resetInputHeight();
	      });
	    },
	    handleFocus: function handleFocus(event) {
	      if (!this.softFocus) {
	        if (this.automaticDropdown || this.filterable) {
	          this.visible = true;
	          if (this.filterable) {
	            this.menuVisibleOnFocus = true;
	          }
	        }
	        this.$emit('focus', event);
	      } else {
	        this.softFocus = false;
	      }
	    },
	    blur: function blur() {
	      this.visible = false;
	      this.$refs.reference.blur();
	    },
	    handleBlur: function handleBlur(event) {
	      var _this9 = this;
	
	      setTimeout(function () {
	        if (_this9.isSilentBlur) {
	          _this9.isSilentBlur = false;
	        } else {
	          _this9.$emit('blur', event);
	        }
	      }, 50);
	      this.softFocus = false;
	    },
	    handleClearClick: function handleClearClick(event) {
	      this.deleteSelected(event);
	    },
	    doDestroy: function doDestroy() {
	      this.$refs.popper && this.$refs.popper.doDestroy();
	    },
	    handleClose: function handleClose() {
	      this.visible = false;
	    },
	    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
	      if (!Array.isArray(this.selected)) return;
	      var option = this.selected[this.selected.length - 1];
	      if (!option) return;
	
	      if (hit === true || hit === false) {
	        option.hitState = hit;
	        return hit;
	      }
	
	      option.hitState = !option.hitState;
	      return option.hitState;
	    },
	    deletePrevTag: function deletePrevTag(e) {
	      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
	        var value = this.value.slice();
	        value.pop();
	        this.$emit('input', value);
	        this.emitChange(value);
	      }
	    },
	    managePlaceholder: function managePlaceholder() {
	      if (this.currentPlaceholder !== '') {
	        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
	      }
	    },
	    resetInputState: function resetInputState(e) {
	      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
	      this.inputLength = this.$refs.input.value.length * 15 + 20;
	      this.resetInputHeight();
	    },
	    resetInputHeight: function resetInputHeight() {
	      var _this10 = this;
	
	      if (this.collapseTags && !this.filterable) return;
	      this.$nextTick(function () {
	        if (!_this10.$refs.reference) return;
	        var inputChildNodes = _this10.$refs.reference.$el.childNodes;
	        var input = [].filter.call(inputChildNodes, function (item) {
	          return item.tagName === 'INPUT';
	        })[0];
	        var tags = _this10.$refs.tags;
	        var sizeInMap = _this10.initialInputHeight || 40;
	        input.style.height = _this10.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
	        if (_this10.visible && _this10.emptyText !== false) {
	          _this10.broadcast('ElSelectDropdown', 'updatePopper');
	        }
	      });
	    },
	    resetHoverIndex: function resetHoverIndex() {
	      var _this11 = this;
	
	      setTimeout(function () {
	        if (!_this11.multiple) {
	          _this11.hoverIndex = _this11.options.indexOf(_this11.selected);
	        } else {
	          if (_this11.selected.length > 0) {
	            _this11.hoverIndex = Math.min.apply(null, _this11.selected.map(function (item) {
	              return _this11.options.indexOf(item);
	            }));
	          } else {
	            _this11.hoverIndex = -1;
	          }
	        }
	      }, 300);
	    },
	    handleOptionSelect: function handleOptionSelect(option, byClick) {
	      var _this12 = this;
	
	      if (this.multiple) {
	        var value = (this.value || []).slice();
	        var optionIndex = this.getValueIndex(value, option.value);
	        if (optionIndex > -1) {
	          value.splice(optionIndex, 1);
	        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
	          value.push(option.value);
	        }
	        this.$emit('input', value);
	        this.emitChange(value);
	        if (option.created) {
	          this.query = '';
	          this.handleQueryChange('');
	          this.inputLength = 20;
	        }
	        if (this.filterable) this.$refs.input.focus();
	      } else {
	        this.$emit('input', option.value);
	        this.emitChange(option.value);
	        this.visible = false;
	      }
	      this.isSilentBlur = byClick;
	      this.setSoftFocus();
	      if (this.visible) return;
	      this.$nextTick(function () {
	        _this12.scrollToOption(option);
	      });
	    },
	    setSoftFocus: function setSoftFocus() {
	      this.softFocus = true;
	      var input = this.$refs.input || this.$refs.reference;
	      if (input) {
	        input.focus();
	      }
	    },
	    getValueIndex: function getValueIndex() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var value = arguments[1];
	
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      if (!isObject) {
	        return arr.indexOf(value);
	      } else {
	        var valueKey = this.valueKey;
	        var index = -1;
	        arr.some(function (item, i) {
	          if (Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(value, valueKey)) {
	            index = i;
	            return true;
	          }
	          return false;
	        });
	        return index;
	      }
	    },
	    toggleMenu: function toggleMenu() {
	      if (!this.selectDisabled) {
	        if (this.menuVisibleOnFocus) {
	          this.menuVisibleOnFocus = false;
	        } else {
	          this.visible = !this.visible;
	        }
	        if (this.visible) {
	          (this.$refs.input || this.$refs.reference).focus();
	        }
	      }
	    },
	    selectOption: function selectOption() {
	      if (!this.visible) {
	        this.toggleMenu();
	      } else {
	        if (this.options[this.hoverIndex]) {
	          this.handleOptionSelect(this.options[this.hoverIndex]);
	        }
	      }
	    },
	    deleteSelected: function deleteSelected(event) {
	      event.stopPropagation();
	      var value = this.multiple ? [] : '';
	      this.$emit('input', value);
	      this.emitChange(value);
	      this.visible = false;
	      this.$emit('clear');
	    },
	    deleteTag: function deleteTag(event, tag) {
	      var index = this.selected.indexOf(tag);
	      if (index > -1 && !this.selectDisabled) {
	        var value = this.value.slice();
	        value.splice(index, 1);
	        this.$emit('input', value);
	        this.emitChange(value);
	        this.$emit('remove-tag', tag.value);
	      }
	      event.stopPropagation();
	    },
	    onInputChange: function onInputChange() {
	      if (this.filterable && this.query !== this.selectedLabel) {
	        this.query = this.selectedLabel;
	        this.handleQueryChange(this.query);
	      }
	    },
	    onOptionDestroy: function onOptionDestroy(index) {
	      if (index > -1) {
	        this.optionsCount--;
	        this.filteredOptionsCount--;
	        this.options.splice(index, 1);
	      }
	    },
	    resetInputWidth: function resetInputWidth() {
	      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
	    },
	    handleResize: function handleResize() {
	      this.resetInputWidth();
	      if (this.multiple) this.resetInputHeight();
	    },
	    checkDefaultFirstOption: function checkDefaultFirstOption() {
	      this.hoverIndex = -1;
	      // highlight the created option
	      var hasCreated = false;
	      for (var i = this.options.length - 1; i >= 0; i--) {
	        if (this.options[i].created) {
	          hasCreated = true;
	          this.hoverIndex = i;
	          break;
	        }
	      }
	      if (hasCreated) return;
	      for (var _i = 0; _i !== this.options.length; ++_i) {
	        var option = this.options[_i];
	        if (this.query) {
	          // highlight first options that passes the filter
	          if (!option.disabled && !option.groupDisabled && option.visible) {
	            this.hoverIndex = _i;
	            break;
	          }
	        } else {
	          // highlight currently selected option
	          if (option.itemSelected) {
	            this.hoverIndex = _i;
	            break;
	          }
	        }
	      }
	    },
	    getValueKey: function getValueKey(item) {
	      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
	        return item.value;
	      } else {
	        return Object(util_["getValueByPath"])(item.value, this.valueKey);
	      }
	    }
	  },
	
	  created: function created() {
	    var _this13 = this;
	
	    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;
	    if (this.multiple && !Array.isArray(this.value)) {
	      this.$emit('input', []);
	    }
	    if (!this.multiple && Array.isArray(this.value)) {
	      this.$emit('input', '');
	    }
	
	    this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
	      _this13.onInputChange();
	    });
	
	    this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
	      _this13.handleQueryChange(e.target.value);
	    });
	
	    this.$on('handleOptionClick', this.handleOptionSelect);
	    this.$on('setSelected', this.setSelected);
	  },
	  mounted: function mounted() {
	    var _this14 = this;
	
	    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
	      this.currentPlaceholder = '';
	    }
	    Object(resize_event_["addResizeListener"])(this.$el, this.handleResize);
	
	    var reference = this.$refs.reference;
	    if (reference && reference.$el) {
	      var sizeMap = {
	        medium: 36,
	        small: 32,
	        mini: 28
	      };
	      var input = reference.$el.querySelector('input');
	      this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
	    }
	    if (this.remote && this.multiple) {
	      this.resetInputHeight();
	    }
	    this.$nextTick(function () {
	      if (reference && reference.$el) {
	        _this14.inputWidth = reference.$el.getBoundingClientRect().width;
	      }
	    });
	    this.setSelected();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.handleResize) Object(resize_event_["removeResizeListener"])(this.$el, this.handleResize);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/select.vue
	
	
	
	
	
	/* normalize component */
	
	var select_component = Object(componentNormalizer["a" /* default */])(
	  src_selectvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var select_api; }
	select_component.options.__file = "packages/select/src/select.vue"
	/* harmony default export */ var src_select = (select_component.exports);
	// CONCATENATED MODULE: ./packages/select/index.js
	
	
	/* istanbul ignore next */
	src_select.install = function (Vue) {
	  Vue.component(src_select.name, src_select);
	};
	
	/* harmony default export */ var packages_select = __webpack_exports__["default"] = (src_select);
	
	/***/ })
	/******/ ]);

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 131);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 131:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// EXTERNAL MODULE: external "throttle-debounce/debounce"
	var debounce_ = __webpack_require__(17);
	var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(2);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// EXTERNAL MODULE: external "vue"
	var external_vue_ = __webpack_require__(7);
	var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
	
	// CONCATENATED MODULE: ./packages/tooltip/src/main.js
	
	
	
	
	
	
	/* harmony default export */ var main = ({
	  name: 'ElTooltip',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    disabled: Boolean,
	    manual: Boolean,
	    effect: {
	      type: String,
	      default: 'dark'
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    popperClass: String,
	    content: String,
	    visibleArrow: {
	      default: true
	    },
	    transition: {
	      type: String,
	      default: 'el-fade-in-linear'
	    },
	    popperOptions: {
	      default: function _default() {
	        return {
	          boundariesPadding: 10,
	          gpuAcceleration: false
	        };
	      }
	    },
	    enterable: {
	      type: Boolean,
	      default: true
	    },
	    hideAfter: {
	      type: Number,
	      default: 0
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      tooltipId: 'el-tooltip-' + Object(util_["generateId"])(),
	      timeoutPending: null,
	      focusing: false
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    if (this.$isServer) return;
	
	    this.popperVM = new external_vue_default.a({
	      data: { node: '' },
	      render: function render(h) {
	        return this.node;
	      }
	    }).$mount();
	
	    this.debounceClose = debounce_default()(200, function () {
	      return _this.handleClosePopper();
	    });
	  },
	  render: function render(h) {
	    var _this2 = this;
	
	    if (this.popperVM) {
	      this.popperVM.node = h(
	        'transition',
	        {
	          attrs: {
	            name: this.transition
	          },
	          on: {
	            'afterLeave': this.doDestroy
	          }
	        },
	        [h(
	          'div',
	          {
	            on: {
	              'mouseleave': function mouseleave() {
	                _this2.setExpectedState(false);_this2.debounceClose();
	              },
	              'mouseenter': function mouseenter() {
	                _this2.setExpectedState(true);
	              }
	            },
	
	            ref: 'popper',
	            attrs: { role: 'tooltip',
	              id: this.tooltipId,
	              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
	            },
	            directives: [{
	              name: 'show',
	              value: !this.disabled && this.showPopper
	            }],
	
	            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] },
	          [this.$slots.content || this.content]
	        )]
	      );
	    }
	
	    var firstElement = this.getFirstElement();
	    if (!firstElement) return null;
	
	    var data = firstElement.data = firstElement.data || {};
	    data.staticClass = this.addTooltipClass(data.staticClass);
	
	    return firstElement;
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.referenceElm = this.$el;
	    if (this.$el.nodeType === 1) {
	      this.$el.setAttribute('aria-describedby', this.tooltipId);
	      this.$el.setAttribute('tabindex', this.tabindex);
	      Object(dom_["on"])(this.referenceElm, 'mouseenter', this.show);
	      Object(dom_["on"])(this.referenceElm, 'mouseleave', this.hide);
	      Object(dom_["on"])(this.referenceElm, 'focus', function () {
	        if (!_this3.$slots.default || !_this3.$slots.default.length) {
	          _this3.handleFocus();
	          return;
	        }
	        var instance = _this3.$slots.default[0].componentInstance;
	        if (instance && instance.focus) {
	          instance.focus();
	        } else {
	          _this3.handleFocus();
	        }
	      });
	      Object(dom_["on"])(this.referenceElm, 'blur', this.handleBlur);
	      Object(dom_["on"])(this.referenceElm, 'click', this.removeFocusing);
	    }
	    // fix issue https://github.com/ElemeFE/element/issues/14424
	    if (this.value && this.popperVM) {
	      this.popperVM.$nextTick(function () {
	        if (_this3.value) {
	          _this3.updatePopper();
	        }
	      });
	    }
	  },
	
	  watch: {
	    focusing: function focusing(val) {
	      if (val) {
	        Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      } else {
	        Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      }
	    }
	  },
	  methods: {
	    show: function show() {
	      this.setExpectedState(true);
	      this.handleShowPopper();
	    },
	    hide: function hide() {
	      this.setExpectedState(false);
	      this.debounceClose();
	    },
	    handleFocus: function handleFocus() {
	      this.focusing = true;
	      this.show();
	    },
	    handleBlur: function handleBlur() {
	      this.focusing = false;
	      this.hide();
	    },
	    removeFocusing: function removeFocusing() {
	      this.focusing = false;
	    },
	    addTooltipClass: function addTooltipClass(prev) {
	      if (!prev) {
	        return 'el-tooltip';
	      } else {
	        return 'el-tooltip ' + prev.replace('el-tooltip', '');
	      }
	    },
	    handleShowPopper: function handleShowPopper() {
	      var _this4 = this;
	
	      if (!this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this4.showPopper = true;
	      }, this.openDelay);
	
	      if (this.hideAfter > 0) {
	        this.timeoutPending = setTimeout(function () {
	          _this4.showPopper = false;
	        }, this.hideAfter);
	      }
	    },
	    handleClosePopper: function handleClosePopper() {
	      if (this.enterable && this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	
	      if (this.timeoutPending) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.showPopper = false;
	
	      if (this.disabled) {
	        this.doDestroy();
	      }
	    },
	    setExpectedState: function setExpectedState(expectedState) {
	      if (expectedState === false) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.expectedState = expectedState;
	    },
	    getFirstElement: function getFirstElement() {
	      var slots = this.$slots.default;
	      if (!Array.isArray(slots)) return null;
	      var element = null;
	      for (var index = 0; index < slots.length; index++) {
	        if (slots[index] && slots[index].tag) {
	          element = slots[index];
	        };
	      }
	      return element;
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.popperVM && this.popperVM.$destroy();
	  },
	  destroyed: function destroyed() {
	    var reference = this.referenceElm;
	    if (reference.nodeType === 1) {
	      Object(dom_["off"])(reference, 'mouseenter', this.show);
	      Object(dom_["off"])(reference, 'mouseleave', this.hide);
	      Object(dom_["off"])(reference, 'focus', this.handleFocus);
	      Object(dom_["off"])(reference, 'blur', this.handleBlur);
	      Object(dom_["off"])(reference, 'click', this.removeFocusing);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tooltip/index.js
	
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.component(main.name, main);
	};
	
	/* harmony default export */ var tooltip = __webpack_exports__["default"] = (main);
	
	/***/ }),
	
	/***/ 17:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(125);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(50);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(45);
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(124);
	
	/***/ }),
	
	/***/ 7:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(19);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dom = __webpack_require__(50);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Transition = function () {
	  function Transition() {
	    _classCallCheck(this, Transition);
	  }
	
	  Transition.prototype.beforeEnter = function beforeEnter(el) {
	    (0, _dom.addClass)(el, 'collapse-transition');
	    if (!el.dataset) el.dataset = {};
	
	    el.dataset.oldPaddingTop = el.style.paddingTop;
	    el.dataset.oldPaddingBottom = el.style.paddingBottom;
	
	    el.style.height = '0';
	    el.style.paddingTop = 0;
	    el.style.paddingBottom = 0;
	  };
	
	  Transition.prototype.enter = function enter(el) {
	    el.dataset.oldOverflow = el.style.overflow;
	    if (el.scrollHeight !== 0) {
	      el.style.height = el.scrollHeight + 'px';
	      el.style.paddingTop = el.dataset.oldPaddingTop;
	      el.style.paddingBottom = el.dataset.oldPaddingBottom;
	    } else {
	      el.style.height = '';
	      el.style.paddingTop = el.dataset.oldPaddingTop;
	      el.style.paddingBottom = el.dataset.oldPaddingBottom;
	    }
	
	    el.style.overflow = 'hidden';
	  };
	
	  Transition.prototype.afterEnter = function afterEnter(el) {
	    // for safari: remove class then reset height is necessary
	    (0, _dom.removeClass)(el, 'collapse-transition');
	    el.style.height = '';
	    el.style.overflow = el.dataset.oldOverflow;
	  };
	
	  Transition.prototype.beforeLeave = function beforeLeave(el) {
	    if (!el.dataset) el.dataset = {};
	    el.dataset.oldPaddingTop = el.style.paddingTop;
	    el.dataset.oldPaddingBottom = el.style.paddingBottom;
	    el.dataset.oldOverflow = el.style.overflow;
	
	    el.style.height = el.scrollHeight + 'px';
	    el.style.overflow = 'hidden';
	  };
	
	  Transition.prototype.leave = function leave(el) {
	    if (el.scrollHeight !== 0) {
	      // for safari: add class after set height, or it will jump to zero height suddenly, weired
	      (0, _dom.addClass)(el, 'collapse-transition');
	      el.style.height = 0;
	      el.style.paddingTop = 0;
	      el.style.paddingBottom = 0;
	    }
	  };
	
	  Transition.prototype.afterLeave = function afterLeave(el) {
	    (0, _dom.removeClass)(el, 'collapse-transition');
	    el.style.height = '';
	    el.style.overflow = el.dataset.oldOverflow;
	    el.style.paddingTop = el.dataset.oldPaddingTop;
	    el.style.paddingBottom = el.dataset.oldPaddingBottom;
	  };
	
	  return Transition;
	}();
	
	exports.default = {
	  name: 'ElCollapseTransition',
	  functional: true,
	  render: function render(h, _ref) {
	    var children = _ref.children;
	
	    var data = {
	      on: new Transition()
	    };
	
	    return h('transition', data, children);
	  }
	};

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (instance, callback) {
	  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	  var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!instance || !callback) throw new Error('instance & callback is required');
	  var called = false;
	  var afterLeaveCallback = function afterLeaveCallback() {
	    if (called) return;
	    called = true;
	    if (callback) {
	      callback.apply(null, arguments);
	    }
	  };
	  if (once) {
	    instance.$once('after-leave', afterLeaveCallback);
	  } else {
	    instance.$on('after-leave', afterLeaveCallback);
	  }
	  setTimeout(function () {
	    afterLeaveCallback();
	  }, speed + 100);
	};
	
	; /**
	   * Bind after-leave event for vue instance. Make sure after-leave is called in any browsers.
	   *
	   * @param {Vue} instance Vue instance.
	   * @param {Function} callback callback of after-leave event
	   * @param {Number} speed the speed of transition, default value is 300ms
	   * @param {Boolean} once weather bind after-leave once. default value is false.
	   */

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ariaUtils = __webpack_require__(181);
	
	var _ariaUtils2 = _interopRequireDefault(_ariaUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @constructor
	 * @desc Dialog object providing modal focus management.
	 *
	 * Assumptions: The element serving as the dialog container is present in the
	 * DOM and hidden. The dialog container has role='dialog'.
	 *
	 * @param dialogId
	 *          The ID of the element serving as the dialog container.
	 * @param focusAfterClosed
	 *          Either the DOM node or the ID of the DOM node to focus when the
	 *          dialog closes.
	 * @param focusFirst
	 *          Optional parameter containing either the DOM node or the ID of the
	 *          DOM node to focus when the dialog opens. If not specified, the
	 *          first focusable element in the dialog will receive focus.
	 */
	var aria = aria || {};
	var tabEvent;
	
	aria.Dialog = function (dialog, focusAfterClosed, focusFirst) {
	  var _this = this;
	
	  this.dialogNode = dialog;
	  if (this.dialogNode === null || this.dialogNode.getAttribute('role') !== 'dialog') {
	    throw new Error('Dialog() requires a DOM element with ARIA role of dialog.');
	  }
	
	  if (typeof focusAfterClosed === 'string') {
	    this.focusAfterClosed = document.getElementById(focusAfterClosed);
	  } else if ((typeof focusAfterClosed === 'undefined' ? 'undefined' : _typeof(focusAfterClosed)) === 'object') {
	    this.focusAfterClosed = focusAfterClosed;
	  } else {
	    this.focusAfterClosed = null;
	  }
	
	  if (typeof focusFirst === 'string') {
	    this.focusFirst = document.getElementById(focusFirst);
	  } else if ((typeof focusFirst === 'undefined' ? 'undefined' : _typeof(focusFirst)) === 'object') {
	    this.focusFirst = focusFirst;
	  } else {
	    this.focusFirst = null;
	  }
	
	  if (this.focusFirst) {
	    this.focusFirst.focus();
	  } else {
	    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
	  }
	
	  this.lastFocus = document.activeElement;
	  tabEvent = function tabEvent(e) {
	    _this.trapFocus(e);
	  };
	  this.addListeners();
	};
	
	aria.Dialog.prototype.addListeners = function () {
	  document.addEventListener('focus', tabEvent, true);
	};
	
	aria.Dialog.prototype.removeListeners = function () {
	  document.removeEventListener('focus', tabEvent, true);
	};
	
	aria.Dialog.prototype.closeDialog = function () {
	  var _this2 = this;
	
	  this.removeListeners();
	  if (this.focusAfterClosed) {
	    setTimeout(function () {
	      _this2.focusAfterClosed.focus();
	    });
	  }
	};
	
	aria.Dialog.prototype.trapFocus = function (event) {
	  if (_ariaUtils2.default.IgnoreUtilFocusChanges) {
	    return;
	  }
	  if (this.dialogNode.contains(event.target)) {
	    this.lastFocus = event.target;
	  } else {
	    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
	    if (this.lastFocus === document.activeElement) {
	      _ariaUtils2.default.focusLastDescendant(this.dialogNode);
	    }
	    this.lastFocus = document.activeElement;
	  }
	};
	
	exports.default = aria.Dialog;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.validateRangeInOneMonth = exports.extractTimeFormat = exports.extractDateFormat = exports.nextYear = exports.prevYear = exports.nextMonth = exports.prevMonth = exports.changeYearMonthAndClampDate = exports.timeWithinRange = exports.limitTimeRange = exports.clearMilliseconds = exports.clearTime = exports.modifyWithTimeString = exports.modifyTime = exports.modifyDate = exports.range = exports.getRangeMinutes = exports.getMonthDays = exports.getPrevMonthLastDays = exports.getRangeHours = exports.getWeekNumber = exports.getStartDateOfMonth = exports.nextDate = exports.prevDate = exports.getFirstDayOfMonth = exports.getDayCountOfYear = exports.getDayCountOfMonth = exports.parseDate = exports.formatDate = exports.isDateObject = exports.isDate = exports.toDate = exports.getI18nSettings = undefined;
	
	var _date = __webpack_require__(265);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _locale = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weeks = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
	var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
	
	var newArray = function newArray(start, end) {
	  var result = [];
	  for (var i = start; i <= end; i++) {
	    result.push(i);
	  }
	  return result;
	};
	
	var getI18nSettings = exports.getI18nSettings = function getI18nSettings() {
	  return {
	    dayNamesShort: weeks.map(function (week) {
	      return (0, _locale.t)('el.datepicker.weeks.' + week);
	    }),
	    dayNames: weeks.map(function (week) {
	      return (0, _locale.t)('el.datepicker.weeks.' + week);
	    }),
	    monthNamesShort: months.map(function (month) {
	      return (0, _locale.t)('el.datepicker.months.' + month);
	    }),
	    monthNames: months.map(function (month, index) {
	      return (0, _locale.t)('el.datepicker.month' + (index + 1));
	    }),
	    amPm: ['am', 'pm']
	  };
	};
	
	var toDate = exports.toDate = function toDate(date) {
	  return isDate(date) ? new Date(date) : null;
	};
	
	var isDate = exports.isDate = function isDate(date) {
	  if (date === null || date === undefined) return false;
	  if (isNaN(new Date(date).getTime())) return false;
	  if (Array.isArray(date)) return false; // deal with `new Date([ new Date() ]) -> new Date()`
	  return true;
	};
	
	var isDateObject = exports.isDateObject = function isDateObject(val) {
	  return val instanceof Date;
	};
	
	var formatDate = exports.formatDate = function formatDate(date, format) {
	  date = toDate(date);
	  if (!date) return '';
	  return _date2.default.format(date, format || 'yyyy-MM-dd', getI18nSettings());
	};
	
	var parseDate = exports.parseDate = function parseDate(string, format) {
	  return _date2.default.parse(string, format || 'yyyy-MM-dd', getI18nSettings());
	};
	
	var getDayCountOfMonth = exports.getDayCountOfMonth = function getDayCountOfMonth(year, month) {
	  if (month === 3 || month === 5 || month === 8 || month === 10) {
	    return 30;
	  }
	
	  if (month === 1) {
	    if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
	      return 29;
	    } else {
	      return 28;
	    }
	  }
	
	  return 31;
	};
	
	var getDayCountOfYear = exports.getDayCountOfYear = function getDayCountOfYear(year) {
	  var isLeapYear = year % 400 === 0 || year % 100 !== 0 && year % 4 === 0;
	  return isLeapYear ? 366 : 365;
	};
	
	var getFirstDayOfMonth = exports.getFirstDayOfMonth = function getFirstDayOfMonth(date) {
	  var temp = new Date(date.getTime());
	  temp.setDate(1);
	  return temp.getDay();
	};
	
	// see: https://stackoverflow.com/questions/3674539/incrementing-a-date-in-javascript
	// {prev, next} Date should work for Daylight Saving Time
	// Adding 24 * 60 * 60 * 1000 does not work in the above scenario
	var prevDate = exports.prevDate = function prevDate(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
	};
	
	var nextDate = exports.nextDate = function nextDate(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
	};
	
	var getStartDateOfMonth = exports.getStartDateOfMonth = function getStartDateOfMonth(year, month) {
	  var result = new Date(year, month, 1);
	  var day = result.getDay();
	
	  if (day === 0) {
	    return prevDate(result, 7);
	  } else {
	    return prevDate(result, day);
	  }
	};
	
	var getWeekNumber = exports.getWeekNumber = function getWeekNumber(src) {
	  if (!isDate(src)) return null;
	  var date = new Date(src.getTime());
	  date.setHours(0, 0, 0, 0);
	  // Thursday in current week decides the year.
	  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
	  // January 4 is always in week 1.
	  var week1 = new Date(date.getFullYear(), 0, 4);
	  // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
	  // Rounding should be fine for Daylight Saving Time. Its shift should never be more than 12 hours.
	  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
	};
	
	var getRangeHours = exports.getRangeHours = function getRangeHours(ranges) {
	  var hours = [];
	  var disabledHours = [];
	
	  (ranges || []).forEach(function (range) {
	    var value = range.map(function (date) {
	      return date.getHours();
	    });
	
	    disabledHours = disabledHours.concat(newArray(value[0], value[1]));
	  });
	
	  if (disabledHours.length) {
	    for (var i = 0; i < 24; i++) {
	      hours[i] = disabledHours.indexOf(i) === -1;
	    }
	  } else {
	    for (var _i = 0; _i < 24; _i++) {
	      hours[_i] = false;
	    }
	  }
	
	  return hours;
	};
	
	var getPrevMonthLastDays = exports.getPrevMonthLastDays = function getPrevMonthLastDays(date, amount) {
	  if (amount <= 0) return [];
	  var temp = new Date(date.getTime());
	  temp.setDate(0);
	  var lastDay = temp.getDate();
	  return range(amount).map(function (_, index) {
	    return lastDay - (amount - index - 1);
	  });
	};
	
	var getMonthDays = exports.getMonthDays = function getMonthDays(date) {
	  var temp = new Date(date.getFullYear(), date.getMonth() + 1, 0);
	  var days = temp.getDate();
	  return range(days).map(function (_, index) {
	    return index + 1;
	  });
	};
	
	function setRangeData(arr, start, end, value) {
	  for (var i = start; i < end; i++) {
	    arr[i] = value;
	  }
	}
	
	var getRangeMinutes = exports.getRangeMinutes = function getRangeMinutes(ranges, hour) {
	  var minutes = new Array(60);
	
	  if (ranges.length > 0) {
	    ranges.forEach(function (range) {
	      var start = range[0];
	      var end = range[1];
	      var startHour = start.getHours();
	      var startMinute = start.getMinutes();
	      var endHour = end.getHours();
	      var endMinute = end.getMinutes();
	      if (startHour === hour && endHour !== hour) {
	        setRangeData(minutes, startMinute, 60, true);
	      } else if (startHour === hour && endHour === hour) {
	        setRangeData(minutes, startMinute, endMinute + 1, true);
	      } else if (startHour !== hour && endHour === hour) {
	        setRangeData(minutes, 0, endMinute + 1, true);
	      } else if (startHour < hour && endHour > hour) {
	        setRangeData(minutes, 0, 60, true);
	      }
	    });
	  } else {
	    setRangeData(minutes, 0, 60, true);
	  }
	  return minutes;
	};
	
	var range = exports.range = function range(n) {
	  // see https://stackoverflow.com/questions/3746725/create-a-javascript-array-containing-1-n
	  return Array.apply(null, { length: n }).map(function (_, n) {
	    return n;
	  });
	};
	
	var modifyDate = exports.modifyDate = function modifyDate(date, y, m, d) {
	  return new Date(y, m, d, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
	};
	
	var modifyTime = exports.modifyTime = function modifyTime(date, h, m, s) {
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, m, s, date.getMilliseconds());
	};
	
	var modifyWithTimeString = exports.modifyWithTimeString = function modifyWithTimeString(date, time) {
	  if (date == null || !time) {
	    return date;
	  }
	  time = parseDate(time, 'HH:mm:ss');
	  return modifyTime(date, time.getHours(), time.getMinutes(), time.getSeconds());
	};
	
	var clearTime = exports.clearTime = function clearTime(date) {
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	var clearMilliseconds = exports.clearMilliseconds = function clearMilliseconds(date) {
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0);
	};
	
	var limitTimeRange = exports.limitTimeRange = function limitTimeRange(date, ranges) {
	  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'HH:mm:ss';
	
	  // TODO: refactory a more elegant solution
	  if (ranges.length === 0) return date;
	  var normalizeDate = function normalizeDate(date) {
	    return _date2.default.parse(_date2.default.format(date, format), format);
	  };
	  var ndate = normalizeDate(date);
	  var nranges = ranges.map(function (range) {
	    return range.map(normalizeDate);
	  });
	  if (nranges.some(function (nrange) {
	    return ndate >= nrange[0] && ndate <= nrange[1];
	  })) return date;
	
	  var minDate = nranges[0][0];
	  var maxDate = nranges[0][0];
	
	  nranges.forEach(function (nrange) {
	    minDate = new Date(Math.min(nrange[0], minDate));
	    maxDate = new Date(Math.max(nrange[1], minDate));
	  });
	
	  var ret = ndate < minDate ? minDate : maxDate;
	  // preserve Year/Month/Date
	  return modifyDate(ret, date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	var timeWithinRange = exports.timeWithinRange = function timeWithinRange(date, selectableRange, format) {
	  var limitedDate = limitTimeRange(date, selectableRange, format);
	  return limitedDate.getTime() === date.getTime();
	};
	
	var changeYearMonthAndClampDate = exports.changeYearMonthAndClampDate = function changeYearMonthAndClampDate(date, year, month) {
	  // clamp date to the number of days in `year`, `month`
	  // eg: (2010-1-31, 2010, 2) => 2010-2-28
	  var monthDate = Math.min(date.getDate(), getDayCountOfMonth(year, month));
	  return modifyDate(date, year, month, monthDate);
	};
	
	var prevMonth = exports.prevMonth = function prevMonth(date) {
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return month === 0 ? changeYearMonthAndClampDate(date, year - 1, 11) : changeYearMonthAndClampDate(date, year, month - 1);
	};
	
	var nextMonth = exports.nextMonth = function nextMonth(date) {
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return month === 11 ? changeYearMonthAndClampDate(date, year + 1, 0) : changeYearMonthAndClampDate(date, year, month + 1);
	};
	
	var prevYear = exports.prevYear = function prevYear(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return changeYearMonthAndClampDate(date, year - amount, month);
	};
	
	var nextYear = exports.nextYear = function nextYear(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return changeYearMonthAndClampDate(date, year + amount, month);
	};
	
	var extractDateFormat = exports.extractDateFormat = function extractDateFormat(format) {
	  return format.replace(/\W?m{1,2}|\W?ZZ/g, '').replace(/\W?h{1,2}|\W?s{1,3}|\W?a/gi, '').trim();
	};
	
	var extractTimeFormat = exports.extractTimeFormat = function extractTimeFormat(format) {
	  return format.replace(/\W?D{1,2}|\W?Do|\W?d{1,4}|\W?M{1,4}|\W?y{2,4}/g, '').trim();
	};
	
	var validateRangeInOneMonth = exports.validateRangeInOneMonth = function validateRangeInOneMonth(start, end) {
	  return start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
	};

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version {{version}}
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	
	//
	// Cross module loader
	// Supported: Node, AMD, Browser globals
	//
	;(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.Popper = factory();
	    }
	})(undefined, function () {
	
	    'use strict';
	
	    var root = window;
	
	    // default options
	    var DEFAULTS = {
	        // placement of the popper
	        placement: 'bottom',
	
	        gpuAcceleration: true,
	
	        // shift popper from its origin by the given amount of pixels (can be negative)
	        offset: 0,
	
	        // the element which will act as boundary of the popper
	        boundariesElement: 'viewport',
	
	        // amount of pixel used to define a minimum distance between the boundaries and the popper
	        boundariesPadding: 5,
	
	        // popper will try to prevent overflow following this order,
	        // by default, then, it could overflow on the left and on top of the boundariesElement
	        preventOverflowOrder: ['left', 'right', 'top', 'bottom'],
	
	        // the behavior used by flip to change the placement of the popper
	        flipBehavior: 'flip',
	
	        arrowElement: '[x-arrow]',
	
	        arrowOffset: 0,
	
	        // list of functions used to modify the offsets before they are applied to the popper
	        modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle'],
	
	        modifiersIgnored: [],
	
	        forceAbsolute: false
	    };
	
	    /**
	     * Create a new Popper.js instance
	     * @constructor Popper
	     * @param {HTMLElement} reference - The reference element used to position the popper
	     * @param {HTMLElement|Object} popper
	     *      The HTML element used as popper, or a configuration used to generate the popper.
	     * @param {String} [popper.tagName='div'] The tag name of the generated popper.
	     * @param {Array} [popper.classNames=['popper']] Array of classes to apply to the generated popper.
	     * @param {Array} [popper.attributes] Array of attributes to apply, specify `attr:value` to assign a value to it.
	     * @param {HTMLElement|String} [popper.parent=window.document.body] The parent element, given as HTMLElement or as query string.
	     * @param {String} [popper.content=''] The content of the popper, it can be text, html, or node; if it is not text, set `contentType` to `html` or `node`.
	     * @param {String} [popper.contentType='text'] If `html`, the `content` will be parsed as HTML. If `node`, it will be appended as-is.
	     * @param {String} [popper.arrowTagName='div'] Same as `popper.tagName` but for the arrow element.
	     * @param {Array} [popper.arrowClassNames='popper__arrow'] Same as `popper.classNames` but for the arrow element.
	     * @param {String} [popper.arrowAttributes=['x-arrow']] Same as `popper.attributes` but for the arrow element.
	     * @param {Object} options
	     * @param {String} [options.placement=bottom]
	     *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -right),
	     *      left(-start, -end)`
	     *
	     * @param {HTMLElement|String} [options.arrowElement='[x-arrow]']
	     *      The DOM Node used as arrow for the popper, or a CSS selector used to get the DOM node. It must be child of
	     *      its parent Popper. Popper.js will apply to the given element the style required to align the arrow with its
	     *      reference element.
	     *      By default, it will look for a child node of the popper with the `x-arrow` attribute.
	     *
	     * @param {Boolean} [options.gpuAcceleration=true]
	     *      When this property is set to true, the popper position will be applied using CSS3 translate3d, allowing the
	     *      browser to use the GPU to accelerate the rendering.
	     *      If set to false, the popper will be placed using `top` and `left` properties, not using the GPU.
	     *
	     * @param {Number} [options.offset=0]
	     *      Amount of pixels the popper will be shifted (can be negative).
	     *
	     * @param {String|Element} [options.boundariesElement='viewport']
	     *      The element which will define the boundaries of the popper position, the popper will never be placed outside
	     *      of the defined boundaries (except if `keepTogether` is enabled)
	     *
	     * @param {Number} [options.boundariesPadding=5]
	     *      Additional padding for the boundaries
	     *
	     * @param {Array} [options.preventOverflowOrder=['left', 'right', 'top', 'bottom']]
	     *      Order used when Popper.js tries to avoid overflows from the boundaries, they will be checked in order,
	     *      this means that the last ones will never overflow
	     *
	     * @param {String|Array} [options.flipBehavior='flip']
	     *      The behavior used by the `flip` modifier to change the placement of the popper when the latter is trying to
	     *      overlap its reference element. Defining `flip` as value, the placement will be flipped on
	     *      its axis (`right - left`, `top - bottom`).
	     *      You can even pass an array of placements (eg: `['right', 'left', 'top']` ) to manually specify
	     *      how alter the placement when a flip is needed. (eg. in the above example, it would first flip from right to left,
	     *      then, if even in its new placement, the popper is overlapping its reference element, it will be moved to top)
	     *
	     * @param {Array} [options.modifiers=[ 'shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle']]
	     *      List of functions used to modify the data before they are applied to the popper, add your custom functions
	     *      to this array to edit the offsets and placement.
	     *      The function should reflect the @params and @returns of preventOverflow
	     *
	     * @param {Array} [options.modifiersIgnored=[]]
	     *      Put here any built-in modifier name you want to exclude from the modifiers list
	     *      The function should reflect the @params and @returns of preventOverflow
	     *
	     * @param {Boolean} [options.removeOnDestroy=false]
	     *      Set to true if you want to automatically remove the popper when you call the `destroy` method.
	     */
	    function Popper(reference, popper, options) {
	        this._reference = reference.jquery ? reference[0] : reference;
	        this.state = {};
	
	        // if the popper variable is a configuration object, parse it to generate an HTMLElement
	        // generate a default popper if is not defined
	        var isNotDefined = typeof popper === 'undefined' || popper === null;
	        var isConfig = popper && Object.prototype.toString.call(popper) === '[object Object]';
	        if (isNotDefined || isConfig) {
	            this._popper = this.parse(isConfig ? popper : {});
	        }
	        // otherwise, use the given HTMLElement as popper
	        else {
	                this._popper = popper.jquery ? popper[0] : popper;
	            }
	
	        // with {} we create a new object with the options inside it
	        this._options = Object.assign({}, DEFAULTS, options);
	
	        // refactoring modifiers' list
	        this._options.modifiers = this._options.modifiers.map(function (modifier) {
	            // remove ignored modifiers
	            if (this._options.modifiersIgnored.indexOf(modifier) !== -1) return;
	
	            // set the x-placement attribute before everything else because it could be used to add margins to the popper
	            // margins needs to be calculated to get the correct popper offsets
	            if (modifier === 'applyStyle') {
	                this._popper.setAttribute('x-placement', this._options.placement);
	            }
	
	            // return predefined modifier identified by string or keep the custom one
	            return this.modifiers[modifier] || modifier;
	        }.bind(this));
	
	        // make sure to apply the popper position before any computation
	        this.state.position = this._getPosition(this._popper, this._reference);
	        setStyle(this._popper, { position: this.state.position, top: 0 });
	
	        // fire the first update to position the popper in the right place
	        this.update();
	
	        // setup event listeners, they will take care of update the position in specific situations
	        this._setupEventListeners();
	        return this;
	    }
	
	    //
	    // Methods
	    //
	    /**
	     * Destroy the popper
	     * @method
	     * @memberof Popper
	     */
	    Popper.prototype.destroy = function () {
	        this._popper.removeAttribute('x-placement');
	        this._popper.style.left = '';
	        this._popper.style.position = '';
	        this._popper.style.top = '';
	        this._popper.style[getSupportedPropertyName('transform')] = '';
	        this._removeEventListeners();
	
	        // remove the popper if user explicity asked for the deletion on destroy
	        if (this._options.removeOnDestroy) {
	            this._popper.remove();
	        }
	        return this;
	    };
	
	    /**
	     * Updates the position of the popper, computing the new offsets and applying the new style
	     * @method
	     * @memberof Popper
	     */
	    Popper.prototype.update = function () {
	        var data = { instance: this, styles: {} };
	
	        // store placement inside the data object, modifiers will be able to edit `placement` if needed
	        // and refer to _originalPlacement to know the original value
	        data.placement = this._options.placement;
	        data._originalPlacement = this._options.placement;
	
	        // compute the popper and reference offsets and put them inside data.offsets
	        data.offsets = this._getOffsets(this._popper, this._reference, data.placement);
	
	        // get boundaries
	        data.boundaries = this._getBoundaries(data, this._options.boundariesPadding, this._options.boundariesElement);
	
	        data = this.runModifiers(data, this._options.modifiers);
	
	        if (typeof this.state.updateCallback === 'function') {
	            this.state.updateCallback(data);
	        }
	    };
	
	    /**
	     * If a function is passed, it will be executed after the initialization of popper with as first argument the Popper instance.
	     * @method
	     * @memberof Popper
	     * @param {Function} callback
	     */
	    Popper.prototype.onCreate = function (callback) {
	        // the createCallbacks return as first argument the popper instance
	        callback(this);
	        return this;
	    };
	
	    /**
	     * If a function is passed, it will be executed after each update of popper with as first argument the set of coordinates and informations
	     * used to style popper and its arrow.
	     * NOTE: it doesn't get fired on the first call of the `Popper.update()` method inside the `Popper` constructor!
	     * @method
	     * @memberof Popper
	     * @param {Function} callback
	     */
	    Popper.prototype.onUpdate = function (callback) {
	        this.state.updateCallback = callback;
	        return this;
	    };
	
	    /**
	     * Helper used to generate poppers from a configuration file
	     * @method
	     * @memberof Popper
	     * @param config {Object} configuration
	     * @returns {HTMLElement} popper
	     */
	    Popper.prototype.parse = function (config) {
	        var defaultConfig = {
	            tagName: 'div',
	            classNames: ['popper'],
	            attributes: [],
	            parent: root.document.body,
	            content: '',
	            contentType: 'text',
	            arrowTagName: 'div',
	            arrowClassNames: ['popper__arrow'],
	            arrowAttributes: ['x-arrow']
	        };
	        config = Object.assign({}, defaultConfig, config);
	
	        var d = root.document;
	
	        var popper = d.createElement(config.tagName);
	        addClassNames(popper, config.classNames);
	        addAttributes(popper, config.attributes);
	        if (config.contentType === 'node') {
	            popper.appendChild(config.content.jquery ? config.content[0] : config.content);
	        } else if (config.contentType === 'html') {
	            popper.innerHTML = config.content;
	        } else {
	            popper.textContent = config.content;
	        }
	
	        if (config.arrowTagName) {
	            var arrow = d.createElement(config.arrowTagName);
	            addClassNames(arrow, config.arrowClassNames);
	            addAttributes(arrow, config.arrowAttributes);
	            popper.appendChild(arrow);
	        }
	
	        var parent = config.parent.jquery ? config.parent[0] : config.parent;
	
	        // if the given parent is a string, use it to match an element
	        // if more than one element is matched, the first one will be used as parent
	        // if no elements are matched, the script will throw an error
	        if (typeof parent === 'string') {
	            parent = d.querySelectorAll(config.parent);
	            if (parent.length > 1) {
	                console.warn('WARNING: the given `parent` query(' + config.parent + ') matched more than one element, the first one will be used');
	            }
	            if (parent.length === 0) {
	                throw 'ERROR: the given `parent` doesn\'t exists!';
	            }
	            parent = parent[0];
	        }
	        // if the given parent is a DOM nodes list or an array of nodes with more than one element,
	        // the first one will be used as parent
	        if (parent.length > 1 && parent instanceof Element === false) {
	            console.warn('WARNING: you have passed as parent a list of elements, the first one will be used');
	            parent = parent[0];
	        }
	
	        // append the generated popper to its parent
	        parent.appendChild(popper);
	
	        return popper;
	
	        /**
	         * Adds class names to the given element
	         * @function
	         * @ignore
	         * @param {HTMLElement} target
	         * @param {Array} classes
	         */
	        function addClassNames(element, classNames) {
	            classNames.forEach(function (className) {
	                element.classList.add(className);
	            });
	        }
	
	        /**
	         * Adds attributes to the given element
	         * @function
	         * @ignore
	         * @param {HTMLElement} target
	         * @param {Array} attributes
	         * @example
	         * addAttributes(element, [ 'data-info:foobar' ]);
	         */
	        function addAttributes(element, attributes) {
	            attributes.forEach(function (attribute) {
	                element.setAttribute(attribute.split(':')[0], attribute.split(':')[1] || '');
	            });
	        }
	    };
	
	    /**
	     * Helper used to get the position which will be applied to the popper
	     * @method
	     * @memberof Popper
	     * @param config {HTMLElement} popper element
	     * @param reference {HTMLElement} reference element
	     * @returns {String} position
	     */
	    Popper.prototype._getPosition = function (popper, reference) {
	        var container = getOffsetParent(reference);
	
	        if (this._options.forceAbsolute) {
	            return 'absolute';
	        }
	
	        // Decide if the popper will be fixed
	        // If the reference element is inside a fixed context, the popper will be fixed as well to allow them to scroll together
	        var isParentFixed = isFixed(reference, container);
	        return isParentFixed ? 'fixed' : 'absolute';
	    };
	
	    /**
	     * Get offsets to the popper
	     * @method
	     * @memberof Popper
	     * @access private
	     * @param {Element} popper - the popper element
	     * @param {Element} reference - the reference element (the popper will be relative to this)
	     * @returns {Object} An object containing the offsets which will be applied to the popper
	     */
	    Popper.prototype._getOffsets = function (popper, reference, placement) {
	        placement = placement.split('-')[0];
	        var popperOffsets = {};
	
	        popperOffsets.position = this.state.position;
	        var isParentFixed = popperOffsets.position === 'fixed';
	
	        //
	        // Get reference element position
	        //
	        var referenceOffsets = getOffsetRectRelativeToCustomParent(reference, getOffsetParent(popper), isParentFixed);
	
	        //
	        // Get popper sizes
	        //
	        var popperRect = getOuterSizes(popper);
	
	        //
	        // Compute offsets of popper
	        //
	
	        // depending by the popper placement we have to compute its offsets slightly differently
	        if (['right', 'left'].indexOf(placement) !== -1) {
	            popperOffsets.top = referenceOffsets.top + referenceOffsets.height / 2 - popperRect.height / 2;
	            if (placement === 'left') {
	                popperOffsets.left = referenceOffsets.left - popperRect.width;
	            } else {
	                popperOffsets.left = referenceOffsets.right;
	            }
	        } else {
	            popperOffsets.left = referenceOffsets.left + referenceOffsets.width / 2 - popperRect.width / 2;
	            if (placement === 'top') {
	                popperOffsets.top = referenceOffsets.top - popperRect.height;
	            } else {
	                popperOffsets.top = referenceOffsets.bottom;
	            }
	        }
	
	        // Add width and height to our offsets object
	        popperOffsets.width = popperRect.width;
	        popperOffsets.height = popperRect.height;
	
	        return {
	            popper: popperOffsets,
	            reference: referenceOffsets
	        };
	    };
	
	    /**
	     * Setup needed event listeners used to update the popper position
	     * @method
	     * @memberof Popper
	     * @access private
	     */
	    Popper.prototype._setupEventListeners = function () {
	        // NOTE: 1 DOM access here
	        this.state.updateBound = this.update.bind(this);
	        root.addEventListener('resize', this.state.updateBound);
	        // if the boundariesElement is window we don't need to listen for the scroll event
	        if (this._options.boundariesElement !== 'window') {
	            var target = getScrollParent(this._reference);
	            // here it could be both `body` or `documentElement` thanks to Firefox, we then check both
	            if (target === root.document.body || target === root.document.documentElement) {
	                target = root;
	            }
	            target.addEventListener('scroll', this.state.updateBound);
	            this.state.scrollTarget = target;
	        }
	    };
	
	    /**
	     * Remove event listeners used to update the popper position
	     * @method
	     * @memberof Popper
	     * @access private
	     */
	    Popper.prototype._removeEventListeners = function () {
	        // NOTE: 1 DOM access here
	        root.removeEventListener('resize', this.state.updateBound);
	        if (this._options.boundariesElement !== 'window' && this.state.scrollTarget) {
	            this.state.scrollTarget.removeEventListener('scroll', this.state.updateBound);
	            this.state.scrollTarget = null;
	        }
	        this.state.updateBound = null;
	    };
	
	    /**
	     * Computed the boundaries limits and return them
	     * @method
	     * @memberof Popper
	     * @access private
	     * @param {Object} data - Object containing the property "offsets" generated by `_getOffsets`
	     * @param {Number} padding - Boundaries padding
	     * @param {Element} boundariesElement - Element used to define the boundaries
	     * @returns {Object} Coordinates of the boundaries
	     */
	    Popper.prototype._getBoundaries = function (data, padding, boundariesElement) {
	        // NOTE: 1 DOM access here
	        var boundaries = {};
	        var width, height;
	        if (boundariesElement === 'window') {
	            var body = root.document.body,
	                html = root.document.documentElement;
	
	            height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	            width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
	
	            boundaries = {
	                top: 0,
	                right: width,
	                bottom: height,
	                left: 0
	            };
	        } else if (boundariesElement === 'viewport') {
	            var offsetParent = getOffsetParent(this._popper);
	            var scrollParent = getScrollParent(this._popper);
	            var offsetParentRect = getOffsetRect(offsetParent);
	
	            // Thanks the fucking native API, `document.body.scrollTop` & `document.documentElement.scrollTop`
	            var getScrollTopValue = function getScrollTopValue(element) {
	                return element == document.body ? Math.max(document.documentElement.scrollTop, document.body.scrollTop) : element.scrollTop;
	            };
	            var getScrollLeftValue = function getScrollLeftValue(element) {
	                return element == document.body ? Math.max(document.documentElement.scrollLeft, document.body.scrollLeft) : element.scrollLeft;
	            };
	
	            // if the popper is fixed we don't have to substract scrolling from the boundaries
	            var scrollTop = data.offsets.popper.position === 'fixed' ? 0 : getScrollTopValue(scrollParent);
	            var scrollLeft = data.offsets.popper.position === 'fixed' ? 0 : getScrollLeftValue(scrollParent);
	
	            boundaries = {
	                top: 0 - (offsetParentRect.top - scrollTop),
	                right: root.document.documentElement.clientWidth - (offsetParentRect.left - scrollLeft),
	                bottom: root.document.documentElement.clientHeight - (offsetParentRect.top - scrollTop),
	                left: 0 - (offsetParentRect.left - scrollLeft)
	            };
	        } else {
	            if (getOffsetParent(this._popper) === boundariesElement) {
	                boundaries = {
	                    top: 0,
	                    left: 0,
	                    right: boundariesElement.clientWidth,
	                    bottom: boundariesElement.clientHeight
	                };
	            } else {
	                boundaries = getOffsetRect(boundariesElement);
	            }
	        }
	        boundaries.left += padding;
	        boundaries.right -= padding;
	        boundaries.top = boundaries.top + padding;
	        boundaries.bottom = boundaries.bottom - padding;
	        return boundaries;
	    };
	
	    /**
	     * Loop trough the list of modifiers and run them in order, each of them will then edit the data object
	     * @method
	     * @memberof Popper
	     * @access public
	     * @param {Object} data
	     * @param {Array} modifiers
	     * @param {Function} ends
	     */
	    Popper.prototype.runModifiers = function (data, modifiers, ends) {
	        var modifiersToRun = modifiers.slice();
	        if (ends !== undefined) {
	            modifiersToRun = this._options.modifiers.slice(0, getArrayKeyIndex(this._options.modifiers, ends));
	        }
	
	        modifiersToRun.forEach(function (modifier) {
	            if (isFunction(modifier)) {
	                data = modifier.call(this, data);
	            }
	        }.bind(this));
	
	        return data;
	    };
	
	    /**
	     * Helper used to know if the given modifier depends from another one.
	     * @method
	     * @memberof Popper
	     * @param {String} requesting - name of requesting modifier
	     * @param {String} requested - name of requested modifier
	     * @returns {Boolean}
	     */
	    Popper.prototype.isModifierRequired = function (requesting, requested) {
	        var index = getArrayKeyIndex(this._options.modifiers, requesting);
	        return !!this._options.modifiers.slice(0, index).filter(function (modifier) {
	            return modifier === requested;
	        }).length;
	    };
	
	    //
	    // Modifiers
	    //
	
	    /**
	     * Modifiers list
	     * @namespace Popper.modifiers
	     * @memberof Popper
	     * @type {Object}
	     */
	    Popper.prototype.modifiers = {};
	
	    /**
	     * Apply the computed styles to the popper element
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The same data object
	     */
	    Popper.prototype.modifiers.applyStyle = function (data) {
	        // apply the final offsets to the popper
	        // NOTE: 1 DOM access here
	        var styles = {
	            position: data.offsets.popper.position
	        };
	
	        // round top and left to avoid blurry text
	        var left = Math.round(data.offsets.popper.left);
	        var top = Math.round(data.offsets.popper.top);
	
	        // if gpuAcceleration is set to true and transform is supported, we use `translate3d` to apply the position to the popper
	        // we automatically use the supported prefixed version if needed
	        var prefixedProperty;
	        if (this._options.gpuAcceleration && (prefixedProperty = getSupportedPropertyName('transform'))) {
	            styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	            styles.top = 0;
	            styles.left = 0;
	        }
	        // othwerise, we use the standard `left` and `top` properties
	        else {
	                styles.left = left;
	                styles.top = top;
	            }
	
	        // any property present in `data.styles` will be applied to the popper,
	        // in this way we can make the 3rd party modifiers add custom styles to it
	        // Be aware, modifiers could override the properties defined in the previous
	        // lines of this modifier!
	        Object.assign(styles, data.styles);
	
	        setStyle(this._popper, styles);
	
	        // set an attribute which will be useful to style the tooltip (use it to properly position its arrow)
	        // NOTE: 1 DOM access here
	        this._popper.setAttribute('x-placement', data.placement);
	
	        // if the arrow modifier is required and the arrow style has been computed, apply the arrow style
	        if (this.isModifierRequired(this.modifiers.applyStyle, this.modifiers.arrow) && data.offsets.arrow) {
	            setStyle(data.arrowElement, data.offsets.arrow);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to shift the popper on the start or end of its reference element side
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.shift = function (data) {
	        var placement = data.placement;
	        var basePlacement = placement.split('-')[0];
	        var shiftVariation = placement.split('-')[1];
	
	        // if shift shiftVariation is specified, run the modifier
	        if (shiftVariation) {
	            var reference = data.offsets.reference;
	            var popper = getPopperClientRect(data.offsets.popper);
	
	            var shiftOffsets = {
	                y: {
	                    start: { top: reference.top },
	                    end: { top: reference.top + reference.height - popper.height }
	                },
	                x: {
	                    start: { left: reference.left },
	                    end: { left: reference.left + reference.width - popper.width }
	                }
	            };
	
	            var axis = ['bottom', 'top'].indexOf(basePlacement) !== -1 ? 'x' : 'y';
	
	            data.offsets.popper = Object.assign(popper, shiftOffsets[axis][shiftVariation]);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to make sure the popper does not overflows from it's boundaries
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.preventOverflow = function (data) {
	        var order = this._options.preventOverflowOrder;
	        var popper = getPopperClientRect(data.offsets.popper);
	
	        var check = {
	            left: function left() {
	                var left = popper.left;
	                if (popper.left < data.boundaries.left) {
	                    left = Math.max(popper.left, data.boundaries.left);
	                }
	                return { left: left };
	            },
	            right: function right() {
	                var left = popper.left;
	                if (popper.right > data.boundaries.right) {
	                    left = Math.min(popper.left, data.boundaries.right - popper.width);
	                }
	                return { left: left };
	            },
	            top: function top() {
	                var top = popper.top;
	                if (popper.top < data.boundaries.top) {
	                    top = Math.max(popper.top, data.boundaries.top);
	                }
	                return { top: top };
	            },
	            bottom: function bottom() {
	                var top = popper.top;
	                if (popper.bottom > data.boundaries.bottom) {
	                    top = Math.min(popper.top, data.boundaries.bottom - popper.height);
	                }
	                return { top: top };
	            }
	        };
	
	        order.forEach(function (direction) {
	            data.offsets.popper = Object.assign(popper, check[direction]());
	        });
	
	        return data;
	    };
	
	    /**
	     * Modifier used to make sure the popper is always near its reference
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.keepTogether = function (data) {
	        var popper = getPopperClientRect(data.offsets.popper);
	        var reference = data.offsets.reference;
	        var f = Math.floor;
	
	        if (popper.right < f(reference.left)) {
	            data.offsets.popper.left = f(reference.left) - popper.width;
	        }
	        if (popper.left > f(reference.right)) {
	            data.offsets.popper.left = f(reference.right);
	        }
	        if (popper.bottom < f(reference.top)) {
	            data.offsets.popper.top = f(reference.top) - popper.height;
	        }
	        if (popper.top > f(reference.bottom)) {
	            data.offsets.popper.top = f(reference.bottom);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to flip the placement of the popper when the latter is starting overlapping its reference element.
	     * Requires the `preventOverflow` modifier before it in order to work.
	     * **NOTE:** This modifier will run all its previous modifiers everytime it tries to flip the popper!
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.flip = function (data) {
	        // check if preventOverflow is in the list of modifiers before the flip modifier.
	        // otherwise flip would not work as expected.
	        if (!this.isModifierRequired(this.modifiers.flip, this.modifiers.preventOverflow)) {
	            console.warn('WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!');
	            return data;
	        }
	
	        if (data.flipped && data.placement === data._originalPlacement) {
	            // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	            return data;
	        }
	
	        var placement = data.placement.split('-')[0];
	        var placementOpposite = getOppositePlacement(placement);
	        var variation = data.placement.split('-')[1] || '';
	
	        var flipOrder = [];
	        if (this._options.flipBehavior === 'flip') {
	            flipOrder = [placement, placementOpposite];
	        } else {
	            flipOrder = this._options.flipBehavior;
	        }
	
	        flipOrder.forEach(function (step, index) {
	            if (placement !== step || flipOrder.length === index + 1) {
	                return;
	            }
	
	            placement = data.placement.split('-')[0];
	            placementOpposite = getOppositePlacement(placement);
	
	            var popperOffsets = getPopperClientRect(data.offsets.popper);
	
	            // this boolean is used to distinguish right and bottom from top and left
	            // they need different computations to get flipped
	            var a = ['right', 'bottom'].indexOf(placement) !== -1;
	
	            // using Math.floor because the reference offsets may contain decimals we are not going to consider here
	            if (a && Math.floor(data.offsets.reference[placement]) > Math.floor(popperOffsets[placementOpposite]) || !a && Math.floor(data.offsets.reference[placement]) < Math.floor(popperOffsets[placementOpposite])) {
	                // we'll use this boolean to detect any flip loop
	                data.flipped = true;
	                data.placement = flipOrder[index + 1];
	                if (variation) {
	                    data.placement += '-' + variation;
	                }
	                data.offsets.popper = this._getOffsets(this._popper, this._reference, data.placement).popper;
	
	                data = this.runModifiers(data, this._options.modifiers, this._flip);
	            }
	        }.bind(this));
	        return data;
	    };
	
	    /**
	     * Modifier used to add an offset to the popper, useful if you more granularity positioning your popper.
	     * The offsets will shift the popper on the side of its reference element.
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.offset = function (data) {
	        var offset = this._options.offset;
	        var popper = data.offsets.popper;
	
	        if (data.placement.indexOf('left') !== -1) {
	            popper.top -= offset;
	        } else if (data.placement.indexOf('right') !== -1) {
	            popper.top += offset;
	        } else if (data.placement.indexOf('top') !== -1) {
	            popper.left -= offset;
	        } else if (data.placement.indexOf('bottom') !== -1) {
	            popper.left += offset;
	        }
	        return data;
	    };
	
	    /**
	     * Modifier used to move the arrows on the edge of the popper to make sure them are always between the popper and the reference element
	     * It will use the CSS outer size of the arrow element to know how many pixels of conjuction are needed
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.arrow = function (data) {
	        var arrow = this._options.arrowElement;
	        var arrowOffset = this._options.arrowOffset;
	
	        // if the arrowElement is a string, suppose it's a CSS selector
	        if (typeof arrow === 'string') {
	            arrow = this._popper.querySelector(arrow);
	        }
	
	        // if arrow element is not found, don't run the modifier
	        if (!arrow) {
	            return data;
	        }
	
	        // the arrow element must be child of its popper
	        if (!this._popper.contains(arrow)) {
	            console.warn('WARNING: `arrowElement` must be child of its popper element!');
	            return data;
	        }
	
	        // arrow depends on keepTogether in order to work
	        if (!this.isModifierRequired(this.modifiers.arrow, this.modifiers.keepTogether)) {
	            console.warn('WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!');
	            return data;
	        }
	
	        var arrowStyle = {};
	        var placement = data.placement.split('-')[0];
	        var popper = getPopperClientRect(data.offsets.popper);
	        var reference = data.offsets.reference;
	        var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	        var len = isVertical ? 'height' : 'width';
	        var side = isVertical ? 'top' : 'left';
	        var translate = isVertical ? 'translateY' : 'translateX';
	        var altSide = isVertical ? 'left' : 'top';
	        var opSide = isVertical ? 'bottom' : 'right';
	        var arrowSize = getOuterSizes(arrow)[len];
	
	        //
	        // extends keepTogether behavior making sure the popper and its reference have enough pixels in conjuction
	        //
	
	        // top/left side
	        if (reference[opSide] - arrowSize < popper[side]) {
	            data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowSize);
	        }
	        // bottom/right side
	        if (reference[side] + arrowSize > popper[opSide]) {
	            data.offsets.popper[side] += reference[side] + arrowSize - popper[opSide];
	        }
	
	        // compute center of the popper
	        var center = reference[side] + (arrowOffset || reference[len] / 2 - arrowSize / 2);
	
	        var sideValue = center - popper[side];
	
	        // prevent arrow from being placed not contiguously to its popper
	        sideValue = Math.max(Math.min(popper[len] - arrowSize - 8, sideValue), 8);
	        arrowStyle[side] = sideValue;
	        arrowStyle[altSide] = ''; // make sure to remove any old style from the arrow
	
	        data.offsets.arrow = arrowStyle;
	        data.arrowElement = arrow;
	
	        return data;
	    };
	
	    //
	    // Helpers
	    //
	
	    /**
	     * Get the outer sizes of the given element (offset size + margins)
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Object} object containing width and height properties
	     */
	    function getOuterSizes(element) {
	        // NOTE: 1 DOM access here
	        var _display = element.style.display,
	            _visibility = element.style.visibility;
	        element.style.display = 'block';element.style.visibility = 'hidden';
	        var calcWidthToForceRepaint = element.offsetWidth;
	
	        // original method
	        var styles = root.getComputedStyle(element);
	        var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	        var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	        var result = { width: element.offsetWidth + y, height: element.offsetHeight + x };
	
	        // reset element styles
	        element.style.display = _display;element.style.visibility = _visibility;
	        return result;
	    }
	
	    /**
	     * Get the opposite placement of the given one/
	     * @function
	     * @ignore
	     * @argument {String} placement
	     * @returns {String} flipped placement
	     */
	    function getOppositePlacement(placement) {
	        var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	        return placement.replace(/left|right|bottom|top/g, function (matched) {
	            return hash[matched];
	        });
	    }
	
	    /**
	     * Given the popper offsets, generate an output similar to getBoundingClientRect
	     * @function
	     * @ignore
	     * @argument {Object} popperOffsets
	     * @returns {Object} ClientRect like output
	     */
	    function getPopperClientRect(popperOffsets) {
	        var offsets = Object.assign({}, popperOffsets);
	        offsets.right = offsets.left + offsets.width;
	        offsets.bottom = offsets.top + offsets.height;
	        return offsets;
	    }
	
	    /**
	     * Given an array and the key to find, returns its index
	     * @function
	     * @ignore
	     * @argument {Array} arr
	     * @argument keyToFind
	     * @returns index or null
	     */
	    function getArrayKeyIndex(arr, keyToFind) {
	        var i = 0,
	            key;
	        for (key in arr) {
	            if (arr[key] === keyToFind) {
	                return i;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    /**
	     * Get CSS computed property of the given element
	     * @function
	     * @ignore
	     * @argument {Eement} element
	     * @argument {String} property
	     */
	    function getStyleComputedProperty(element, property) {
	        // NOTE: 1 DOM access here
	        var css = root.getComputedStyle(element, null);
	        return css[property];
	    }
	
	    /**
	     * Returns the offset parent of the given element
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Element} offset parent
	     */
	    function getOffsetParent(element) {
	        // NOTE: 1 DOM access here
	        var offsetParent = element.offsetParent;
	        return offsetParent === root.document.body || !offsetParent ? root.document.documentElement : offsetParent;
	    }
	
	    /**
	     * Returns the scrolling parent of the given element
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Element} offset parent
	     */
	    function getScrollParent(element) {
	        var parent = element.parentNode;
	
	        if (!parent) {
	            return element;
	        }
	
	        if (parent === root.document) {
	            // Firefox puts the scrollTOp value on `documentElement` instead of `body`, we then check which of them is
	            // greater than 0 and return the proper element
	            if (root.document.body.scrollTop || root.document.body.scrollLeft) {
	                return root.document.body;
	            } else {
	                return root.document.documentElement;
	            }
	        }
	
	        // Firefox want us to check `-x` and `-y` variations as well
	        if (['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1) {
	            // If the detected scrollParent is body, we perform an additional check on its parentNode
	            // in this way we'll get body if the browser is Chrome-ish, or documentElement otherwise
	            // fixes issue #65
	            return parent;
	        }
	        return getScrollParent(element.parentNode);
	    }
	
	    /**
	     * Check if the given element is fixed or is inside a fixed parent
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @argument {Element} customContainer
	     * @returns {Boolean} answer to "isFixed?"
	     */
	    function isFixed(element) {
	        if (element === root.document.body) {
	            return false;
	        }
	        if (getStyleComputedProperty(element, 'position') === 'fixed') {
	            return true;
	        }
	        return element.parentNode ? isFixed(element.parentNode) : element;
	    }
	
	    /**
	     * Set the style to the given popper
	     * @function
	     * @ignore
	     * @argument {Element} element - Element to apply the style to
	     * @argument {Object} styles - Object with a list of properties and values which will be applied to the element
	     */
	    function setStyle(element, styles) {
	        function is_numeric(n) {
	            return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	        }
	        Object.keys(styles).forEach(function (prop) {
	            var unit = '';
	            // add unit if the value is numeric and is one of the following
	            if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && is_numeric(styles[prop])) {
	                unit = 'px';
	            }
	            element.style[prop] = styles[prop] + unit;
	        });
	    }
	
	    /**
	     * Check if the given variable is a function
	     * @function
	     * @ignore
	     * @argument {*} functionToCheck - variable to check
	     * @returns {Boolean} answer to: is a function?
	     */
	    function isFunction(functionToCheck) {
	        var getType = {};
	        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	    }
	
	    /**
	     * Get the position of the given element, relative to its offset parent
	     * @function
	     * @ignore
	     * @param {Element} element
	     * @return {Object} position - Coordinates of the element and its `scrollTop`
	     */
	    function getOffsetRect(element) {
	        var elementRect = {
	            width: element.offsetWidth,
	            height: element.offsetHeight,
	            left: element.offsetLeft,
	            top: element.offsetTop
	        };
	
	        elementRect.right = elementRect.left + elementRect.width;
	        elementRect.bottom = elementRect.top + elementRect.height;
	
	        // position
	        return elementRect;
	    }
	
	    /**
	     * Get bounding client rect of given element
	     * @function
	     * @ignore
	     * @param {HTMLElement} element
	     * @return {Object} client rect
	     */
	    function getBoundingClientRect(element) {
	        var rect = element.getBoundingClientRect();
	
	        // whether the IE version is lower than 11
	        var isIE = navigator.userAgent.indexOf("MSIE") != -1;
	
	        // fix ie document bounding top always 0 bug
	        var rectTop = isIE && element.tagName === 'HTML' ? -element.scrollTop : rect.top;
	
	        return {
	            left: rect.left,
	            top: rectTop,
	            right: rect.right,
	            bottom: rect.bottom,
	            width: rect.right - rect.left,
	            height: rect.bottom - rectTop
	        };
	    }
	
	    /**
	     * Given an element and one of its parents, return the offset
	     * @function
	     * @ignore
	     * @param {HTMLElement} element
	     * @param {HTMLElement} parent
	     * @return {Object} rect
	     */
	    function getOffsetRectRelativeToCustomParent(element, parent, fixed) {
	        var elementRect = getBoundingClientRect(element);
	        var parentRect = getBoundingClientRect(parent);
	
	        if (fixed) {
	            var scrollParent = getScrollParent(parent);
	            parentRect.top += scrollParent.scrollTop;
	            parentRect.bottom += scrollParent.scrollTop;
	            parentRect.left += scrollParent.scrollLeft;
	            parentRect.right += scrollParent.scrollLeft;
	        }
	
	        var rect = {
	            top: elementRect.top - parentRect.top,
	            left: elementRect.left - parentRect.left,
	            bottom: elementRect.top - parentRect.top + elementRect.height,
	            right: elementRect.left - parentRect.left + elementRect.width,
	            width: elementRect.width,
	            height: elementRect.height
	        };
	        return rect;
	    }
	
	    /**
	     * Get the prefixed supported property name
	     * @function
	     * @ignore
	     * @argument {String} property (camelCase)
	     * @returns {String} prefixed property (camelCase)
	     */
	    function getSupportedPropertyName(property) {
	        var prefixes = ['', 'ms', 'webkit', 'moz', 'o'];
	
	        for (var i = 0; i < prefixes.length; i++) {
	            var toCheck = prefixes[i] ? prefixes[i] + property.charAt(0).toUpperCase() + property.slice(1) : property;
	            if (typeof root.document.body.style[toCheck] !== 'undefined') {
	                return toCheck;
	            }
	        }
	        return null;
	    }
	
	    /**
	     * The Object.assign() method is used to copy the values of all enumerable own properties from one or more source
	     * objects to a target object. It will return the target object.
	     * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
	     * Source: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	     * @function
	     * @ignore
	     */
	    if (!Object.assign) {
	        Object.defineProperty(Object, 'assign', {
	            enumerable: false,
	            configurable: true,
	            writable: true,
	            value: function value(target) {
	                if (target === undefined || target === null) {
	                    throw new TypeError('Cannot convert first argument to object');
	                }
	
	                var to = Object(target);
	                for (var i = 1; i < arguments.length; i++) {
	                    var nextSource = arguments[i];
	                    if (nextSource === undefined || nextSource === null) {
	                        continue;
	                    }
	                    nextSource = Object(nextSource);
	
	                    var keysArray = Object.keys(nextSource);
	                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	                        var nextKey = keysArray[nextIndex];
	                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	                        if (desc !== undefined && desc.enumerable) {
	                            to[nextKey] = nextSource[nextKey];
	                        }
	                    }
	                }
	                return to;
	            }
	        });
	    }
	
	    return Popper;
	});

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _dom = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasModal = false;
	var hasInitZIndex = false;
	var zIndex = void 0;
	
	var getModal = function getModal() {
	  if (_vue2.default.prototype.$isServer) return;
	  var modalDom = PopupManager.modalDom;
	  if (modalDom) {
	    hasModal = true;
	  } else {
	    hasModal = false;
	    modalDom = document.createElement('div');
	    PopupManager.modalDom = modalDom;
	
	    modalDom.addEventListener('touchmove', function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    modalDom.addEventListener('click', function () {
	      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
	    });
	  }
	
	  return modalDom;
	};
	
	var instances = {};
	
	var PopupManager = {
	  modalFade: true,
	
	  getInstance: function getInstance(id) {
	    return instances[id];
	  },
	
	  register: function register(id, instance) {
	    if (id && instance) {
	      instances[id] = instance;
	    }
	  },
	
	  deregister: function deregister(id) {
	    if (id) {
	      instances[id] = null;
	      delete instances[id];
	    }
	  },
	
	  nextZIndex: function nextZIndex() {
	    return PopupManager.zIndex++;
	  },
	
	  modalStack: [],
	
	  doOnModalClick: function doOnModalClick() {
	    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
	    if (!topItem) return;
	
	    var instance = PopupManager.getInstance(topItem.id);
	    if (instance && instance.closeOnClickModal) {
	      instance.close();
	    }
	  },
	
	  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
	    if (_vue2.default.prototype.$isServer) return;
	    if (!id || zIndex === undefined) return;
	    this.modalFade = modalFade;
	
	    var modalStack = this.modalStack;
	
	    for (var i = 0, j = modalStack.length; i < j; i++) {
	      var item = modalStack[i];
	      if (item.id === id) {
	        return;
	      }
	    }
	
	    var modalDom = getModal();
	
	    (0, _dom.addClass)(modalDom, 'v-modal');
	    if (this.modalFade && !hasModal) {
	      (0, _dom.addClass)(modalDom, 'v-modal-enter');
	    }
	    if (modalClass) {
	      var classArr = modalClass.trim().split(/\s+/);
	      classArr.forEach(function (item) {
	        return (0, _dom.addClass)(modalDom, item);
	      });
	    }
	    setTimeout(function () {
	      (0, _dom.removeClass)(modalDom, 'v-modal-enter');
	    }, 200);
	
	    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
	      dom.parentNode.appendChild(modalDom);
	    } else {
	      document.body.appendChild(modalDom);
	    }
	
	    if (zIndex) {
	      modalDom.style.zIndex = zIndex;
	    }
	    modalDom.tabIndex = 0;
	    modalDom.style.display = '';
	
	    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
	  },
	
	  closeModal: function closeModal(id) {
	    var modalStack = this.modalStack;
	    var modalDom = getModal();
	
	    if (modalStack.length > 0) {
	      var topItem = modalStack[modalStack.length - 1];
	      if (topItem.id === id) {
	        if (topItem.modalClass) {
	          var classArr = topItem.modalClass.trim().split(/\s+/);
	          classArr.forEach(function (item) {
	            return (0, _dom.removeClass)(modalDom, item);
	          });
	        }
	
	        modalStack.pop();
	        if (modalStack.length > 0) {
	          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
	        }
	      } else {
	        for (var i = modalStack.length - 1; i >= 0; i--) {
	          if (modalStack[i].id === id) {
	            modalStack.splice(i, 1);
	            break;
	          }
	        }
	      }
	    }
	
	    if (modalStack.length === 0) {
	      if (this.modalFade) {
	        (0, _dom.addClass)(modalDom, 'v-modal-leave');
	      }
	      setTimeout(function () {
	        if (modalStack.length === 0) {
	          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
	          modalDom.style.display = 'none';
	          PopupManager.modalDom = undefined;
	        }
	        (0, _dom.removeClass)(modalDom, 'v-modal-leave');
	      }, 200);
	    }
	  }
	};
	
	Object.defineProperty(PopupManager, 'zIndex', {
	  configurable: true,
	  get: function get() {
	    if (!hasInitZIndex) {
	      zIndex = zIndex || (_vue2.default.prototype.$ELEMENT || {}).zIndex || 2000;
	      hasInitZIndex = true;
	    }
	    return zIndex;
	  },
	  set: function set(value) {
	    zIndex = value;
	  }
	});
	
	var getTopPopup = function getTopPopup() {
	  if (_vue2.default.prototype.$isServer) return;
	  if (PopupManager.modalStack.length > 0) {
	    var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
	    if (!topPopup) return;
	    var instance = PopupManager.getInstance(topPopup.id);
	
	    return instance;
	  }
	};
	
	if (!_vue2.default.prototype.$isServer) {
	  // handle `esc` key when the popup is shown
	  window.addEventListener('keydown', function (event) {
	    if (event.keyCode === 27) {
	      var topPopup = getTopPopup();
	
	      if (topPopup && topPopup.closeOnPressEscape) {
	        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
	      }
	    }
	  });
	}
	
	exports.default = PopupManager;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isVNode = isVNode;
	
	var _util = __webpack_require__(45);
	
	function isVNode(node) {
	  return node !== null && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
	};

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(835);


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(836);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(86);


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(268);
	var Emitter = __webpack_require__(187);
	var debug = __webpack_require__(58)('engine.io-client:socket');
	var index = __webpack_require__(271);
	var parser = __webpack_require__(86);
	var parseuri = __webpack_require__(405);
	var parsejson = __webpack_require__(877);
	var parseqs = __webpack_require__(188);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (global.location && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (global.location ? location.hostname : 'localhost');
	  this.port = opts.port || (global.location && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // other options for Node.js client
	  var freeGlobal = typeof global === 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(185);
	Socket.transports = __webpack_require__(268);
	Socket.parser = __webpack_require__(86);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    agent: this.agent,
	    hostname: this.hostname,
	    port: this.port,
	    secure: this.secure,
	    path: this.path,
	    query: query,
	    forceJSONP: this.forceJSONP,
	    jsonp: this.jsonp,
	    forceBase64: this.forceBase64,
	    enablesXDR: this.enablesXDR,
	    timestampRequests: this.timestampRequests,
	    timestampParam: this.timestampParam,
	    policyPort: this.policyPort,
	    socket: this,
	    pfx: this.pfx,
	    key: this.key,
	    passphrase: this.passphrase,
	    cert: this.cert,
	    ca: this.ca,
	    ciphers: this.ciphers,
	    rejectUnauthorized: this.rejectUnauthorized,
	    perMessageDeflate: this.perMessageDeflate,
	    extraHeaders: this.extraHeaders,
	    forceNode: this.forceNode,
	    localAddress: this.localAddress
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(parsejson(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(269);
	var inherit = __webpack_require__(104);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    if (!global.___eio) global.___eio = [];
	    callbacks = global.___eio;
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (global.document && global.addEventListener) {
	    global.addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(186);
	var Polling = __webpack_require__(269);
	var Emitter = __webpack_require__(187);
	var inherit = __webpack_require__(104);
	var debug = __webpack_require__(58)('engine.io-client:polling-xhr');
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = opts.hostname !== global.location.hostname ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  } else {
	    this.extraHeaders = opts.extraHeaders;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	    if (this.supportsBinary) {
	      // This has to be done after open because Firefox is stupid
	      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
	      xhr.responseType = 'arraybuffer';
	    }
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = true;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(xhr.status);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (global.document) {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (global.document) {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
	    } catch (e) {}
	    if (contentType === 'application/octet-stream') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      if (!this.supportsBinary) {
	        data = this.xhr.responseText;
	      } else {
	        try {
	          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
	        } catch (e) {
	          var ui8Arr = new Uint8Array(this.xhr.response);
	          var dataArray = [];
	          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
	            dataArray.push(ui8Arr[idx]);
	          }
	
	          data = String.fromCharCode.apply(null, dataArray);
	        }
	      }
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (global.document) {
	  if (global.attachEvent) {
	    global.attachEvent('onunload', unloadHandler);
	  } else if (global.addEventListener) {
	    global.addEventListener('beforeunload', unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(185);
	var parser = __webpack_require__(86);
	var parseqs = __webpack_require__(188);
	var inherit = __webpack_require__(104);
	var yeast = __webpack_require__(419);
	var debug = __webpack_require__(58)('engine.io-client:websocket');
	var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
	var NodeWebSocket;
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(1048);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocket = BrowserWebSocket;
	if (!WebSocket && typeof window === 'undefined') {
	  WebSocket = NodeWebSocket;
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  if (!this.usingBrowserWebSocket) {
	    WebSocket = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = void (0);
	  var opts = {
	    agent: this.agent,
	    perMessageDeflate: this.perMessageDeflate
	  };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ }),
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	;(function () {
	  // Detect the `define` function exposed by asynchronous module loaders. The
	  // strict `define` check is necessary for compatibility with `r.js`.
	  var isLoader = "function" === "function" && __webpack_require__(1045);
	
	  // A set of types used to distinguish objects from primitives.
	  var objectTypes = {
	    "function": true,
	    "object": true
	  };
	
	  // Detect the `exports` object exposed by CommonJS implementations.
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  // Use the `global` object exposed by Node (including Browserify via
	  // `insert-module-globals`), Narwhal, and Ringo as the default context,
	  // and the `window` object in browsers. Rhino exports a `global` function
	  // instead.
	  var root = objectTypes[typeof window] && window || this,
	      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;
	
	  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  // Public: Initializes JSON 3 using the given `context` object, attaching the
	  // `stringify` and `parse` functions to the specified `exports` object.
	  function runInContext(context, exports) {
	    context || (context = root["Object"]());
	    exports || (exports = root["Object"]());
	
	    // Native constructor aliases.
	    var Number = context["Number"] || root["Number"],
	        String = context["String"] || root["String"],
	        Object = context["Object"] || root["Object"],
	        Date = context["Date"] || root["Date"],
	        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
	        TypeError = context["TypeError"] || root["TypeError"],
	        Math = context["Math"] || root["Math"],
	        nativeJSON = context["JSON"] || root["JSON"];
	
	    // Delegate to the native `stringify` and `parse` implementations.
	    if (typeof nativeJSON == "object" && nativeJSON) {
	      exports.stringify = nativeJSON.stringify;
	      exports.parse = nativeJSON.parse;
	    }
	
	    // Convenience aliases.
	    var objectProto = Object.prototype,
	        getClass = objectProto.toString,
	        isProperty, forEach, undef;
	
	    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
	    var isExtended = new Date(-3509827334573292);
	    try {
	      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
	      // results for certain dates in Opera >= 10.53.
	      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
	        // Safari < 2.0.2 stores the internal millisecond time value correctly,
	        // but clips the values returned by the date methods to the range of
	        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
	        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
	    } catch (exception) {}
	
	    // Internal: Determines whether the native `JSON.stringify` and `parse`
	    // implementations are spec-compliant. Based on work by Ken Snyder.
	    function has(name) {
	      if (has[name] !== undef) {
	        // Return cached feature test result.
	        return has[name];
	      }
	      var isSupported;
	      if (name == "bug-string-char-index") {
	        // IE <= 7 doesn't support accessing string characters using square
	        // bracket notation. IE 8 only supports this for primitives.
	        isSupported = "a"[0] != "a";
	      } else if (name == "json") {
	        // Indicates whether both `JSON.stringify` and `JSON.parse` are
	        // supported.
	        isSupported = has("json-stringify") && has("json-parse");
	      } else {
	        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
	        // Test `JSON.stringify`.
	        if (name == "json-stringify") {
	          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
	          if (stringifySupported) {
	            // A test function object with a custom `toJSON` method.
	            (value = function () {
	              return 1;
	            }).toJSON = value;
	            try {
	              stringifySupported =
	                // Firefox 3.1b1 and b2 serialize string, number, and boolean
	                // primitives as object literals.
	                stringify(0) === "0" &&
	                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
	                // literals.
	                stringify(new Number()) === "0" &&
	                stringify(new String()) == '""' &&
	                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
	                // does not define a canonical JSON representation (this applies to
	                // objects with `toJSON` properties as well, *unless* they are nested
	                // within an object or array).
	                stringify(getClass) === undef &&
	                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
	                // FF 3.1b3 pass this test.
	                stringify(undef) === undef &&
	                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
	                // respectively, if the value is omitted entirely.
	                stringify() === undef &&
	                // FF 3.1b1, 2 throw an error if the given value is not a number,
	                // string, array, object, Boolean, or `null` literal. This applies to
	                // objects with custom `toJSON` methods as well, unless they are nested
	                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
	                // methods entirely.
	                stringify(value) === "1" &&
	                stringify([value]) == "[1]" &&
	                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
	                // `"[null]"`.
	                stringify([undef]) == "[null]" &&
	                // YUI 3.0.0b1 fails to serialize `null` literals.
	                stringify(null) == "null" &&
	                // FF 3.1b1, 2 halts serialization if an array contains a function:
	                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
	                // elides non-JSON values from objects and arrays, unless they
	                // define custom `toJSON` methods.
	                stringify([undef, getClass, null]) == "[null,null,null]" &&
	                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
	                // where character escape codes are expected (e.g., `\b` => `\u0008`).
	                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
	                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
	                stringify(null, value) === "1" &&
	                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
	                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
	                // serialize extended years.
	                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
	                // The milliseconds are optional in ES 5, but required in 5.1.
	                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
	                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
	                // four-digit years instead of six-digit years. Credits: @Yaffle.
	                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
	                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
	                // values less than 1000. Credits: @Yaffle.
	                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
	            } catch (exception) {
	              stringifySupported = false;
	            }
	          }
	          isSupported = stringifySupported;
	        }
	        // Test `JSON.parse`.
	        if (name == "json-parse") {
	          var parse = exports.parse;
	          if (typeof parse == "function") {
	            try {
	              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
	              // Conforming implementations should also coerce the initial argument to
	              // a string prior to parsing.
	              if (parse("0") === 0 && !parse(false)) {
	                // Simple parsing test.
	                value = parse(serialized);
	                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
	                if (parseSupported) {
	                  try {
	                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
	                    parseSupported = !parse('"\t"');
	                  } catch (exception) {}
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
	                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
	                      // certain octal literals.
	                      parseSupported = parse("01") !== 1;
	                    } catch (exception) {}
	                  }
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
	                      // points. These environments, along with FF 3.1b1 and 2,
	                      // also allow trailing commas in JSON objects and arrays.
	                      parseSupported = parse("1.") !== 1;
	                    } catch (exception) {}
	                  }
	                }
	              }
	            } catch (exception) {
	              parseSupported = false;
	            }
	          }
	          isSupported = parseSupported;
	        }
	      }
	      return has[name] = !!isSupported;
	    }
	
	    if (!has("json")) {
	      // Common `[[Class]]` name aliases.
	      var functionClass = "[object Function]",
	          dateClass = "[object Date]",
	          numberClass = "[object Number]",
	          stringClass = "[object String]",
	          arrayClass = "[object Array]",
	          booleanClass = "[object Boolean]";
	
	      // Detect incomplete support for accessing string characters by index.
	      var charIndexBuggy = has("bug-string-char-index");
	
	      // Define additional utility methods if the `Date` methods are buggy.
	      if (!isExtended) {
	        var floor = Math.floor;
	        // A mapping between the months of the year and the number of days between
	        // January 1st and the first of the respective month.
	        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
	        // Internal: Calculates the number of days between the Unix epoch and the
	        // first day of the given month.
	        var getDay = function (year, month) {
	          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
	        };
	      }
	
	      // Internal: Determines if a property is a direct property of the given
	      // object. Delegates to the native `Object#hasOwnProperty` method.
	      if (!(isProperty = objectProto.hasOwnProperty)) {
	        isProperty = function (property) {
	          var members = {}, constructor;
	          if ((members.__proto__ = null, members.__proto__ = {
	            // The *proto* property cannot be set multiple times in recent
	            // versions of Firefox and SeaMonkey.
	            "toString": 1
	          }, members).toString != getClass) {
	            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
	            // supports the mutable *proto* property.
	            isProperty = function (property) {
	              // Capture and break the object's prototype chain (see section 8.6.2
	              // of the ES 5.1 spec). The parenthesized expression prevents an
	              // unsafe transformation by the Closure Compiler.
	              var original = this.__proto__, result = property in (this.__proto__ = null, this);
	              // Restore the original prototype chain.
	              this.__proto__ = original;
	              return result;
	            };
	          } else {
	            // Capture a reference to the top-level `Object` constructor.
	            constructor = members.constructor;
	            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
	            // other environments.
	            isProperty = function (property) {
	              var parent = (this.constructor || constructor).prototype;
	              return property in this && !(property in parent && this[property] === parent[property]);
	            };
	          }
	          members = null;
	          return isProperty.call(this, property);
	        };
	      }
	
	      // Internal: Normalizes the `for...in` iteration algorithm across
	      // environments. Each enumerated key is yielded to a `callback` function.
	      forEach = function (object, callback) {
	        var size = 0, Properties, members, property;
	
	        // Tests for bugs in the current environment's `for...in` algorithm. The
	        // `valueOf` property inherits the non-enumerable flag from
	        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
	        (Properties = function () {
	          this.valueOf = 0;
	        }).prototype.valueOf = 0;
	
	        // Iterate over a new instance of the `Properties` class.
	        members = new Properties();
	        for (property in members) {
	          // Ignore all properties inherited from `Object.prototype`.
	          if (isProperty.call(members, property)) {
	            size++;
	          }
	        }
	        Properties = members = null;
	
	        // Normalize the iteration algorithm.
	        if (!size) {
	          // A list of non-enumerable properties inherited from `Object.prototype`.
	          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
	          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
	          // properties.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, length;
	            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
	            for (property in object) {
	              // Gecko <= 1.0 enumerates the `prototype` property of functions under
	              // certain conditions; IE does not.
	              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for each non-enumerable property.
	            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
	          };
	        } else if (size == 2) {
	          // Safari <= 2.0.4 enumerates shadowed properties twice.
	          forEach = function (object, callback) {
	            // Create a set of iterated properties.
	            var members = {}, isFunction = getClass.call(object) == functionClass, property;
	            for (property in object) {
	              // Store each property name to prevent double enumeration. The
	              // `prototype` property of functions is not enumerated due to cross-
	              // environment inconsistencies.
	              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	          };
	        } else {
	          // No bugs detected; use the standard `for...in` algorithm.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
	            for (property in object) {
	              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for the `constructor` property due to
	            // cross-environment inconsistencies.
	            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
	              callback(property);
	            }
	          };
	        }
	        return forEach(object, callback);
	      };
	
	      // Public: Serializes a JavaScript `value` as a JSON string. The optional
	      // `filter` argument may specify either a function that alters how object and
	      // array members are serialized, or an array of strings and numbers that
	      // indicates which properties should be serialized. The optional `width`
	      // argument may be either a string or number that specifies the indentation
	      // level of the output.
	      if (!has("json-stringify")) {
	        // Internal: A map of control characters and their escaped equivalents.
	        var Escapes = {
	          92: "\\\\",
	          34: '\\"',
	          8: "\\b",
	          12: "\\f",
	          10: "\\n",
	          13: "\\r",
	          9: "\\t"
	        };
	
	        // Internal: Converts `value` into a zero-padded string such that its
	        // length is at least equal to `width`. The `width` must be <= 6.
	        var leadingZeroes = "000000";
	        var toPaddedString = function (width, value) {
	          // The `|| 0` expression is necessary to work around a bug in
	          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
	          return (leadingZeroes + (value || 0)).slice(-width);
	        };
	
	        // Internal: Double-quotes a string `value`, replacing all ASCII control
	        // characters (characters with code unit values between 0 and 31) with
	        // their escaped equivalents. This is an implementation of the
	        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
	        var unicodePrefix = "\\u00";
	        var quote = function (value) {
	          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
	          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
	          for (; index < length; index++) {
	            var charCode = value.charCodeAt(index);
	            // If the character is a control character, append its Unicode or
	            // shorthand escape sequence; otherwise, append the character as-is.
	            switch (charCode) {
	              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
	                result += Escapes[charCode];
	                break;
	              default:
	                if (charCode < 32) {
	                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
	                  break;
	                }
	                result += useCharIndex ? symbols[index] : value.charAt(index);
	            }
	          }
	          return result + '"';
	        };
	
	        // Internal: Recursively serializes an object. Implements the
	        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
	        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
	          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
	          try {
	            // Necessary for host object support.
	            value = object[property];
	          } catch (exception) {}
	          if (typeof value == "object" && value) {
	            className = getClass.call(value);
	            if (className == dateClass && !isProperty.call(value, "toJSON")) {
	              if (value > -1 / 0 && value < 1 / 0) {
	                // Dates are serialized according to the `Date#toJSON` method
	                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
	                // for the ISO 8601 date time string format.
	                if (getDay) {
	                  // Manually compute the year, month, date, hours, minutes,
	                  // seconds, and milliseconds if the `getUTC*` methods are
	                  // buggy. Adapted from @Yaffle's `date-shim` project.
	                  date = floor(value / 864e5);
	                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
	                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
	                  date = 1 + date - getDay(year, month);
	                  // The `time` value specifies the time within the day (see ES
	                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
	                  // to compute `A modulo B`, as the `%` operator does not
	                  // correspond to the `modulo` operation for negative numbers.
	                  time = (value % 864e5 + 864e5) % 864e5;
	                  // The hours, minutes, seconds, and milliseconds are obtained by
	                  // decomposing the time within the day. See section 15.9.1.10.
	                  hours = floor(time / 36e5) % 24;
	                  minutes = floor(time / 6e4) % 60;
	                  seconds = floor(time / 1e3) % 60;
	                  milliseconds = time % 1e3;
	                } else {
	                  year = value.getUTCFullYear();
	                  month = value.getUTCMonth();
	                  date = value.getUTCDate();
	                  hours = value.getUTCHours();
	                  minutes = value.getUTCMinutes();
	                  seconds = value.getUTCSeconds();
	                  milliseconds = value.getUTCMilliseconds();
	                }
	                // Serialize extended years correctly.
	                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
	                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
	                  // Months, dates, hours, minutes, and seconds should have two
	                  // digits; milliseconds should have three.
	                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
	                  // Milliseconds are optional in ES 5.0, but required in 5.1.
	                  "." + toPaddedString(3, milliseconds) + "Z";
	              } else {
	                value = null;
	              }
	            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
	              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
	              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
	              // ignores all `toJSON` methods on these objects unless they are
	              // defined directly on an instance.
	              value = value.toJSON(property);
	            }
	          }
	          if (callback) {
	            // If a replacement function was provided, call it to obtain the value
	            // for serialization.
	            value = callback.call(object, property, value);
	          }
	          if (value === null) {
	            return "null";
	          }
	          className = getClass.call(value);
	          if (className == booleanClass) {
	            // Booleans are represented literally.
	            return "" + value;
	          } else if (className == numberClass) {
	            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
	            // `"null"`.
	            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
	          } else if (className == stringClass) {
	            // Strings are double-quoted and escaped.
	            return quote("" + value);
	          }
	          // Recursively serialize objects and arrays.
	          if (typeof value == "object") {
	            // Check for cyclic structures. This is a linear search; performance
	            // is inversely proportional to the number of unique nested objects.
	            for (length = stack.length; length--;) {
	              if (stack[length] === value) {
	                // Cyclic structures cannot be serialized by `JSON.stringify`.
	                throw TypeError();
	              }
	            }
	            // Add the object to the stack of traversed objects.
	            stack.push(value);
	            results = [];
	            // Save the current indentation level and indent one additional level.
	            prefix = indentation;
	            indentation += whitespace;
	            if (className == arrayClass) {
	              // Recursively serialize array elements.
	              for (index = 0, length = value.length; index < length; index++) {
	                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
	                results.push(element === undef ? "null" : element);
	              }
	              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
	            } else {
	              // Recursively serialize object members. Members are selected from
	              // either a user-specified list of property names, or the object
	              // itself.
	              forEach(properties || value, function (property) {
	                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
	                if (element !== undef) {
	                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
	                  // is not the empty string, let `member` {quote(property) + ":"}
	                  // be the concatenation of `member` and the `space` character."
	                  // The "`space` character" refers to the literal space
	                  // character, not the `space` {width} argument provided to
	                  // `JSON.stringify`.
	                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
	                }
	              });
	              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
	            }
	            // Remove the object from the traversed object stack.
	            stack.pop();
	            return result;
	          }
	        };
	
	        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
	        exports.stringify = function (source, filter, width) {
	          var whitespace, callback, properties, className;
	          if (objectTypes[typeof filter] && filter) {
	            if ((className = getClass.call(filter)) == functionClass) {
	              callback = filter;
	            } else if (className == arrayClass) {
	              // Convert the property names array into a makeshift set.
	              properties = {};
	              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
	            }
	          }
	          if (width) {
	            if ((className = getClass.call(width)) == numberClass) {
	              // Convert the `width` to an integer and create a string containing
	              // `width` number of space characters.
	              if ((width -= width % 1) > 0) {
	                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
	              }
	            } else if (className == stringClass) {
	              whitespace = width.length <= 10 ? width : width.slice(0, 10);
	            }
	          }
	          // Opera <= 7.54u2 discards the values associated with empty string keys
	          // (`""`) only if they are used directly within an object member list
	          // (e.g., `!("" in { "": 1})`).
	          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
	        };
	      }
	
	      // Public: Parses a JSON source string.
	      if (!has("json-parse")) {
	        var fromCharCode = String.fromCharCode;
	
	        // Internal: A map of escaped control characters and their unescaped
	        // equivalents.
	        var Unescapes = {
	          92: "\\",
	          34: '"',
	          47: "/",
	          98: "\b",
	          116: "\t",
	          110: "\n",
	          102: "\f",
	          114: "\r"
	        };
	
	        // Internal: Stores the parser state.
	        var Index, Source;
	
	        // Internal: Resets the parser state and throws a `SyntaxError`.
	        var abort = function () {
	          Index = Source = null;
	          throw SyntaxError();
	        };
	
	        // Internal: Returns the next token, or `"$"` if the parser has reached
	        // the end of the source string. A token may be a string, number, `null`
	        // literal, or Boolean literal.
	        var lex = function () {
	          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
	          while (Index < length) {
	            charCode = source.charCodeAt(Index);
	            switch (charCode) {
	              case 9: case 10: case 13: case 32:
	                // Skip whitespace tokens, including tabs, carriage returns, line
	                // feeds, and space characters.
	                Index++;
	                break;
	              case 123: case 125: case 91: case 93: case 58: case 44:
	                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
	                // the current position.
	                value = charIndexBuggy ? source.charAt(Index) : source[Index];
	                Index++;
	                return value;
	              case 34:
	                // `"` delimits a JSON string; advance to the next character and
	                // begin parsing the string. String tokens are prefixed with the
	                // sentinel `@` character to distinguish them from punctuators and
	                // end-of-string tokens.
	                for (value = "@", Index++; Index < length;) {
	                  charCode = source.charCodeAt(Index);
	                  if (charCode < 32) {
	                    // Unescaped ASCII control characters (those with a code unit
	                    // less than the space character) are not permitted.
	                    abort();
	                  } else if (charCode == 92) {
	                    // A reverse solidus (`\`) marks the beginning of an escaped
	                    // control character (including `"`, `\`, and `/`) or Unicode
	                    // escape sequence.
	                    charCode = source.charCodeAt(++Index);
	                    switch (charCode) {
	                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
	                        // Revive escaped control characters.
	                        value += Unescapes[charCode];
	                        Index++;
	                        break;
	                      case 117:
	                        // `\u` marks the beginning of a Unicode escape sequence.
	                        // Advance to the first character and validate the
	                        // four-digit code point.
	                        begin = ++Index;
	                        for (position = Index + 4; Index < position; Index++) {
	                          charCode = source.charCodeAt(Index);
	                          // A valid sequence comprises four hexdigits (case-
	                          // insensitive) that form a single hexadecimal value.
	                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
	                            // Invalid Unicode escape sequence.
	                            abort();
	                          }
	                        }
	                        // Revive the escaped character.
	                        value += fromCharCode("0x" + source.slice(begin, Index));
	                        break;
	                      default:
	                        // Invalid escape sequence.
	                        abort();
	                    }
	                  } else {
	                    if (charCode == 34) {
	                      // An unescaped double-quote character marks the end of the
	                      // string.
	                      break;
	                    }
	                    charCode = source.charCodeAt(Index);
	                    begin = Index;
	                    // Optimize for the common case where a string is valid.
	                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
	                      charCode = source.charCodeAt(++Index);
	                    }
	                    // Append the string as-is.
	                    value += source.slice(begin, Index);
	                  }
	                }
	                if (source.charCodeAt(Index) == 34) {
	                  // Advance to the next character and return the revived string.
	                  Index++;
	                  return value;
	                }
	                // Unterminated string.
	                abort();
	              default:
	                // Parse numbers and literals.
	                begin = Index;
	                // Advance past the negative sign, if one is specified.
	                if (charCode == 45) {
	                  isSigned = true;
	                  charCode = source.charCodeAt(++Index);
	                }
	                // Parse an integer or floating-point value.
	                if (charCode >= 48 && charCode <= 57) {
	                  // Leading zeroes are interpreted as octal literals.
	                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
	                    // Illegal octal literal.
	                    abort();
	                  }
	                  isSigned = false;
	                  // Parse the integer component.
	                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
	                  // Floats cannot contain a leading decimal point; however, this
	                  // case is already accounted for by the parser.
	                  if (source.charCodeAt(Index) == 46) {
	                    position = ++Index;
	                    // Parse the decimal component.
	                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal trailing decimal.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Parse exponents. The `e` denoting the exponent is
	                  // case-insensitive.
	                  charCode = source.charCodeAt(Index);
	                  if (charCode == 101 || charCode == 69) {
	                    charCode = source.charCodeAt(++Index);
	                    // Skip past the sign following the exponent, if one is
	                    // specified.
	                    if (charCode == 43 || charCode == 45) {
	                      Index++;
	                    }
	                    // Parse the exponential component.
	                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal empty exponent.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Coerce the parsed value to a JavaScript number.
	                  return +source.slice(begin, Index);
	                }
	                // A negative sign may only precede numbers.
	                if (isSigned) {
	                  abort();
	                }
	                // `true`, `false`, and `null` literals.
	                if (source.slice(Index, Index + 4) == "true") {
	                  Index += 4;
	                  return true;
	                } else if (source.slice(Index, Index + 5) == "false") {
	                  Index += 5;
	                  return false;
	                } else if (source.slice(Index, Index + 4) == "null") {
	                  Index += 4;
	                  return null;
	                }
	                // Unrecognized token.
	                abort();
	            }
	          }
	          // Return the sentinel `$` character if the parser has reached the end
	          // of the source string.
	          return "$";
	        };
	
	        // Internal: Parses a JSON `value` token.
	        var get = function (value) {
	          var results, hasMembers;
	          if (value == "$") {
	            // Unexpected end of input.
	            abort();
	          }
	          if (typeof value == "string") {
	            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
	              // Remove the sentinel `@` character.
	              return value.slice(1);
	            }
	            // Parse object and array literals.
	            if (value == "[") {
	              // Parses a JSON array, returning a new JavaScript array.
	              results = [];
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing square bracket marks the end of the array literal.
	                if (value == "]") {
	                  break;
	                }
	                // If the array literal contains elements, the current token
	                // should be a comma separating the previous element from the
	                // next.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "]") {
	                      // Unexpected trailing `,` in array literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each array element.
	                    abort();
	                  }
	                }
	                // Elisions and leading commas are not permitted.
	                if (value == ",") {
	                  abort();
	                }
	                results.push(get(value));
	              }
	              return results;
	            } else if (value == "{") {
	              // Parses a JSON object, returning a new JavaScript object.
	              results = {};
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing curly brace marks the end of the object literal.
	                if (value == "}") {
	                  break;
	                }
	                // If the object literal contains members, the current token
	                // should be a comma separator.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "}") {
	                      // Unexpected trailing `,` in object literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each object member.
	                    abort();
	                  }
	                }
	                // Leading commas are not permitted, object property names must be
	                // double-quoted strings, and a `:` must separate each property
	                // name and value.
	                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
	                  abort();
	                }
	                results[value.slice(1)] = get(lex());
	              }
	              return results;
	            }
	            // Unexpected token encountered.
	            abort();
	          }
	          return value;
	        };
	
	        // Internal: Updates a traversed object member.
	        var update = function (source, property, callback) {
	          var element = walk(source, property, callback);
	          if (element === undef) {
	            delete source[property];
	          } else {
	            source[property] = element;
	          }
	        };
	
	        // Internal: Recursively traverses a parsed JSON object, invoking the
	        // `callback` function for each value. This is an implementation of the
	        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
	        var walk = function (source, property, callback) {
	          var value = source[property], length;
	          if (typeof value == "object" && value) {
	            // `forEach` can't be used to traverse an array in Opera <= 8.54
	            // because its `Object#hasOwnProperty` implementation returns `false`
	            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
	            if (getClass.call(value) == arrayClass) {
	              for (length = value.length; length--;) {
	                update(value, length, callback);
	              }
	            } else {
	              forEach(value, function (property) {
	                update(value, property, callback);
	              });
	            }
	          }
	          return callback.call(source, property, value);
	        };
	
	        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
	        exports.parse = function (source, callback) {
	          var result, value;
	          Index = 0;
	          Source = "" + source;
	          result = get(lex());
	          // If a JSON string contains multiple tokens, it is invalid.
	          if (lex() != "$") {
	            abort();
	          }
	          // Reset the parser state.
	          Index = Source = null;
	          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
	        };
	      }
	    }
	
	    exports["runInContext"] = runInContext;
	    return exports;
	  }
	
	  if (freeExports && !isLoader) {
	    // Export for CommonJS environments.
	    runInContext(root, freeExports);
	  } else {
	    // Export for web browsers and JavaScript engines.
	    var nativeJSON = root.JSON,
	        previousJSON = root["JSON3"],
	        isRestored = false;
	
	    var JSON3 = runInContext(root, (root["JSON3"] = {
	      // Public: Restores the original value of the global `JSON` object and
	      // returns a reference to the `JSON3` object.
	      "noConflict": function () {
	        if (!isRestored) {
	          isRestored = true;
	          root.JSON = nativeJSON;
	          root["JSON3"] = previousJSON;
	          nativeJSON = previousJSON = null;
	        }
	        return JSON3;
	      }
	    }));
	
	    root.JSON = {
	      "parse": JSON3.parse,
	      "stringify": JSON3.stringify
	    };
	  }
	
	  // Export for asynchronous module loaders.
	  if (isLoader) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return JSON3;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(126)(module), (function() { return this; }())))

/***/ }),
/* 870 */,
/* 871 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(876);


/***/ }),
/* 873 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	/*jslint evil: true */
	
	'use strict';
	
	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners:
	    canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;


/***/ }),
/* 874 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2004-present Facebook. All Rights Reserved.
	 *
	 * @providesModule UserAgent_DEPRECATED
	 */
	
	/**
	 *  Provides entirely client-side User Agent and OS detection. You should prefer
	 *  the non-deprecated UserAgent module when possible, which exposes our
	 *  authoritative server-side PHP-based detection to the client.
	 *
	 *  Usage is straightforward:
	 *
	 *    if (UserAgent_DEPRECATED.ie()) {
	 *      //  IE
	 *    }
	 *
	 *  You can also do version checks:
	 *
	 *    if (UserAgent_DEPRECATED.ie() >= 7) {
	 *      //  IE7 or better
	 *    }
	 *
	 *  The browser functions will return NaN if the browser does not match, so
	 *  you can also do version compares the other way:
	 *
	 *    if (UserAgent_DEPRECATED.ie() < 7) {
	 *      //  IE6 or worse
	 *    }
	 *
	 *  Note that the version is a float and may include a minor version number,
	 *  so you should always use range operators to perform comparisons, not
	 *  strict equality.
	 *
	 *  **Note:** You should **strongly** prefer capability detection to browser
	 *  version detection where it's reasonable:
	 *
	 *    http://www.quirksmode.org/js/support.html
	 *
	 *  Further, we have a large number of mature wrapper functions and classes
	 *  which abstract away many browser irregularities. Check the documentation,
	 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
	 *  another copy of "event || window.event".
	 *
	 */
	
	var _populated = false;
	
	// Browsers
	var _ie, _firefox, _opera, _webkit, _chrome;
	
	// Actual IE browser for compatibility mode
	var _ie_real_version;
	
	// Platforms
	var _osx, _windows, _linux, _android;
	
	// Architectures
	var _win64;
	
	// Devices
	var _iphone, _ipad, _native;
	
	var _mobile;
	
	function _populate() {
	  if (_populated) {
	    return;
	  }
	
	  _populated = true;
	
	  // To work around buggy JS libraries that can't handle multi-digit
	  // version numbers, Opera 10's user agent string claims it's Opera
	  // 9, then later includes a Version/X.Y field:
	  //
	  // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
	  var uas = navigator.userAgent;
	  var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
	  var os    = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);
	
	  _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
	  _ipad = /\b(iP[ao]d)/.exec(uas);
	  _android = /Android/i.exec(uas);
	  _native = /FBAN\/\w+;/i.exec(uas);
	  _mobile = /Mobile/i.exec(uas);
	
	  // Note that the IE team blog would have you believe you should be checking
	  // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
	  // from either x64 or ia64;  so ultimately, you should just check for Win64
	  // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
	  // Windows will send 'WOW64' instead.
	  _win64 = !!(/Win64/.exec(uas));
	
	  if (agent) {
	    _ie = agent[1] ? parseFloat(agent[1]) : (
	          agent[5] ? parseFloat(agent[5]) : NaN);
	    // IE compatibility mode
	    if (_ie && document && document.documentMode) {
	      _ie = document.documentMode;
	    }
	    // grab the "true" ie version from the trident token if available
	    var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
	    _ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie;
	
	    _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
	    _opera   = agent[3] ? parseFloat(agent[3]) : NaN;
	    _webkit  = agent[4] ? parseFloat(agent[4]) : NaN;
	    if (_webkit) {
	      // We do not add the regexp to the above test, because it will always
	      // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
	      // the userAgent string.
	      agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
	      _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
	    } else {
	      _chrome = NaN;
	    }
	  } else {
	    _ie = _firefox = _opera = _chrome = _webkit = NaN;
	  }
	
	  if (os) {
	    if (os[1]) {
	      // Detect OS X version.  If no version number matches, set _osx to true.
	      // Version examples:  10, 10_6_1, 10.7
	      // Parses version number as a float, taking only first two sets of
	      // digits.  If only one set of digits is found, returns just the major
	      // version number.
	      var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);
	
	      _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
	    } else {
	      _osx = false;
	    }
	    _windows = !!os[2];
	    _linux   = !!os[3];
	  } else {
	    _osx = _windows = _linux = false;
	  }
	}
	
	var UserAgent_DEPRECATED = {
	
	  /**
	   *  Check if the UA is Internet Explorer.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  ie: function() {
	    return _populate() || _ie;
	  },
	
	  /**
	   * Check if we're in Internet Explorer compatibility mode.
	   *
	   * @return bool true if in compatibility mode, false if
	   * not compatibility mode or not ie
	   */
	  ieCompatibilityMode: function() {
	    return _populate() || (_ie_real_version > _ie);
	  },
	
	
	  /**
	   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
	   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
	   * this when we don't need it -- tracked by #601957.
	   */
	  ie64: function() {
	    return UserAgent_DEPRECATED.ie() && _win64;
	  },
	
	  /**
	   *  Check if the UA is Firefox.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  firefox: function() {
	    return _populate() || _firefox;
	  },
	
	
	  /**
	   *  Check if the UA is Opera.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  opera: function() {
	    return _populate() || _opera;
	  },
	
	
	  /**
	   *  Check if the UA is WebKit.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  webkit: function() {
	    return _populate() || _webkit;
	  },
	
	  /**
	   *  For Push
	   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
	   */
	  safari: function() {
	    return UserAgent_DEPRECATED.webkit();
	  },
	
	  /**
	   *  Check if the UA is a Chrome browser.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  chrome : function() {
	    return _populate() || _chrome;
	  },
	
	
	  /**
	   *  Check if the user is running Windows.
	   *
	   *  @return bool `true' if the user's OS is Windows.
	   */
	  windows: function() {
	    return _populate() || _windows;
	  },
	
	
	  /**
	   *  Check if the user is running Mac OS X.
	   *
	   *  @return float|bool   Returns a float if a version number is detected,
	   *                       otherwise true/false.
	   */
	  osx: function() {
	    return _populate() || _osx;
	  },
	
	  /**
	   * Check if the user is running Linux.
	   *
	   * @return bool `true' if the user's OS is some flavor of Linux.
	   */
	  linux: function() {
	    return _populate() || _linux;
	  },
	
	  /**
	   * Check if the user is running on an iPhone or iPod platform.
	   *
	   * @return bool `true' if the user is running some flavor of the
	   *    iPhone OS.
	   */
	  iphone: function() {
	    return _populate() || _iphone;
	  },
	
	  mobile: function() {
	    return _populate() || (_iphone || _ipad || _android || _mobile);
	  },
	
	  nativeApp: function() {
	    // webviews inside of the native apps
	    return _populate() || _native;
	  },
	
	  android: function() {
	    return _populate() || _android;
	  },
	
	  ipad: function() {
	    return _populate() || _ipad;
	  }
	};
	
	module.exports = UserAgent_DEPRECATED;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(873);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature =
	    document.implementation &&
	    document.implementation.hasFeature &&
	    // always returns true in newer browsers as per the standard.
	    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	    document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM ||
	      capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule normalizeWheel
	 * @typechecks
	 */
	
	'use strict';
	
	var UserAgent_DEPRECATED = __webpack_require__(874);
	
	var isEventSupported = __webpack_require__(875);
	
	
	// Reasonable defaults
	var PIXEL_STEP  = 10;
	var LINE_HEIGHT = 40;
	var PAGE_HEIGHT = 800;
	
	/**
	 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
	 * complicated, thus this doc is long and (hopefully) detailed enough to answer
	 * your questions.
	 *
	 * If you need to react to the mouse wheel in a predictable way, this code is
	 * like your bestest friend. * hugs *
	 *
	 * As of today, there are 4 DOM event types you can listen to:
	 *
	 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
	 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
	 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
	 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
	 *
	 * So what to do?  The is the best:
	 *
	 *   normalizeWheel.getEventType();
	 *
	 * In your event callback, use this code to get sane interpretation of the
	 * deltas.  This code will return an object with properties:
	 *
	 *   spinX   -- normalized spin speed (use for zoom) - x plane
	 *   spinY   -- " - y plane
	 *   pixelX  -- normalized distance (to pixels) - x plane
	 *   pixelY  -- " - y plane
	 *
	 * Wheel values are provided by the browser assuming you are using the wheel to
	 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
	 * significantly on different platforms and browsers, forgetting that you can
	 * scroll at different speeds.  Some devices (like trackpads) emit more events
	 * at smaller increments with fine granularity, and some emit massive jumps with
	 * linear speed or acceleration.
	 *
	 * This code does its best to normalize the deltas for you:
	 *
	 *   - spin is trying to normalize how far the wheel was spun (or trackpad
	 *     dragged).  This is super useful for zoom support where you want to
	 *     throw away the chunky scroll steps on the PC and make those equal to
	 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
	 *     resolve a single slow step on a wheel to 1.
	 *
	 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
	 *     get the crazy differences between browsers, but at least it'll be in
	 *     pixels!
	 *
	 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
	 *     should translate to positive value zooming IN, negative zooming OUT.
	 *     This matches the newer 'wheel' event.
	 *
	 * Why are there spinX, spinY (or pixels)?
	 *
	 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
	 *     with a mouse.  It results in side-scrolling in the browser by default.
	 *
	 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
	 *
	 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
	 *     probably is by browsers in conjunction with fancy 3D controllers .. but
	 *     you know.
	 *
	 * Implementation info:
	 *
	 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
	 * average mouse:
	 *
	 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
	 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
	 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
	 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
	 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
	 *
	 * On the trackpad:
	 *
	 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
	 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
	 *
	 * On other/older browsers.. it's more complicated as there can be multiple and
	 * also missing delta values.
	 *
	 * The 'wheel' event is more standard:
	 *
	 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
	 *
	 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
	 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
	 * backward compatibility with older events.  Those other values help us
	 * better normalize spin speed.  Example of what the browsers provide:
	 *
	 *                          | event.wheelDelta | event.detail
	 *        ------------------+------------------+--------------
	 *          Safari v5/OS X  |       -120       |       0
	 *          Safari v5/Win7  |       -120       |       0
	 *         Chrome v17/OS X  |       -120       |       0
	 *         Chrome v17/Win7  |       -120       |       0
	 *                IE9/Win7  |       -120       |   undefined
	 *         Firefox v4/OS X  |     undefined    |       1
	 *         Firefox v4/Win7  |     undefined    |       3
	 *
	 */
	function normalizeWheel(/*object*/ event) /*object*/ {
	  var sX = 0, sY = 0,       // spinX, spinY
	      pX = 0, pY = 0;       // pixelX, pixelY
	
	  // Legacy
	  if ('detail'      in event) { sY = event.detail; }
	  if ('wheelDelta'  in event) { sY = -event.wheelDelta / 120; }
	  if ('wheelDeltaY' in event) { sY = -event.wheelDeltaY / 120; }
	  if ('wheelDeltaX' in event) { sX = -event.wheelDeltaX / 120; }
	
	  // side scrolling on FF with DOMMouseScroll
	  if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
	    sX = sY;
	    sY = 0;
	  }
	
	  pX = sX * PIXEL_STEP;
	  pY = sY * PIXEL_STEP;
	
	  if ('deltaY' in event) { pY = event.deltaY; }
	  if ('deltaX' in event) { pX = event.deltaX; }
	
	  if ((pX || pY) && event.deltaMode) {
	    if (event.deltaMode == 1) {          // delta in LINE units
	      pX *= LINE_HEIGHT;
	      pY *= LINE_HEIGHT;
	    } else {                             // delta in PAGE units
	      pX *= PAGE_HEIGHT;
	      pY *= PAGE_HEIGHT;
	    }
	  }
	
	  // Fall-back if spin cannot be determined
	  if (pX && !sX) { sX = (pX < 1) ? -1 : 1; }
	  if (pY && !sY) { sY = (pY < 1) ? -1 : 1; }
	
	  return { spinX  : sX,
	           spinY  : sY,
	           pixelX : pX,
	           pixelY : pY };
	}
	
	
	/**
	 * The best combination if you prefer spinX + spinY normalization.  It favors
	 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
	 * 'wheel' event, making spin speed determination impossible.
	 */
	normalizeWheel.getEventType = function() /*string*/ {
	  return (UserAgent_DEPRECATED.firefox())
	           ? 'DOMMouseScroll'
	           : (isEventSupported('wheel'))
	               ? 'wheel'
	               : 'mousewheel';
	};
	
	module.exports = normalizeWheel;


/***/ }),
/* 877 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * JSON parse.
	 *
	 * @see Based on jQuery#parseJSON (MIT) and JSON2
	 * @api private
	 */
	
	var rvalidchars = /^[\],:{}\s]*$/;
	var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
	var rtrimLeft = /^\s+/;
	var rtrimRight = /\s+$/;
	
	module.exports = function parsejson(data) {
	  if ('string' != typeof data || !data) {
	    return null;
	  }
	
	  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');
	
	  // Attempt to parse using the native JSON parser first
	  if (global.JSON && JSON.parse) {
	    return JSON.parse(data);
	  }
	
	  if (rvalidchars.test(data.replace(rvalidescape, '@')
	      .replace(rvalidtokens, ']')
	      .replace(rvalidbraces, ''))) {
	    return (new Function('return ' + data))();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(879);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 879 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(406)))

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(883);
	var parser = __webpack_require__(189);
	var Manager = __webpack_require__(407);
	var debug = __webpack_require__(58)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  } else if (opts && 'object' === typeof opts.query) {
	    opts.query = encodeQueryString(opts.query);
	  }
	  return io.socket(parsed.path, opts);
	}
	/**
	 *  Helper method to parse query objects to string.
	 * @param {object} query
	 * @returns {string}
	 */
	function encodeQueryString (obj) {
	  var str = [];
	  for (var p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	    }
	  }
	  return str.join('&');
	}
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(407);
	exports.Socket = __webpack_require__(409);


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(405);
	var debug = __webpack_require__(58)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || global.location;
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(272);
	var isBuf = __webpack_require__(411);
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet){
	  var buffers = [];
	  var packetData = packet.data;
	
	  function _deconstructPacket(data) {
	    if (!data) return data;
	
	    if (isBuf(data)) {
	      var placeholder = { _placeholder: true, num: buffers.length };
	      buffers.push(data);
	      return placeholder;
	    } else if (isArray(data)) {
	      var newData = new Array(data.length);
	      for (var i = 0; i < data.length; i++) {
	        newData[i] = _deconstructPacket(data[i]);
	      }
	      return newData;
	    } else if ('object' == typeof data && !(data instanceof Date)) {
	      var newData = {};
	      for (var key in data) {
	        newData[key] = _deconstructPacket(data[key]);
	      }
	      return newData;
	    }
	    return data;
	  }
	
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  var curPlaceHolder = 0;
	
	  function _reconstructPacket(data) {
	    if (data && data._placeholder) {
	      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
	      return buf;
	    } else if (isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        data[i] = _reconstructPacket(data[i]);
	      }
	      return data;
	    } else if (data && 'object' == typeof data) {
	      for (var key in data) {
	        data[key] = _reconstructPacket(data[key]);
	      }
	      return data;
	    }
	    return data;
	  }
	
	  packet.data = _reconstructPacket(packet.data);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((global.Blob && obj instanceof Blob) ||
	        (global.File && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(886);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(887);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 887 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	var throttle = __webpack_require__(190);
	var debounce = __webpack_require__(125);
	
	module.exports = {
		throttle: throttle,
		debounce: debounce
	};


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(881);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 890 */
/***/ (function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (global, factory) {
	  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (global = global || self, global.AsyncComputed = factory());
	})(this, function () {
	  'use strict';
	
	  function setAsyncState(vm, stateObject, state) {
	    vm.$set(vm.$data._asyncComputed[stateObject], 'state', state);
	    vm.$set(vm.$data._asyncComputed[stateObject], 'updating', state === 'updating');
	    vm.$set(vm.$data._asyncComputed[stateObject], 'error', state === 'error');
	    vm.$set(vm.$data._asyncComputed[stateObject], 'success', state === 'success');
	  }
	
	  function getterOnly(fn) {
	    if (typeof fn === 'function') return fn;
	
	    return fn.get;
	  }
	
	  function hasOwnProperty(object, property) {
	    return Object.prototype.hasOwnProperty.call(object, property);
	  }
	
	  function isComputedLazy(item) {
	    return hasOwnProperty(item, 'lazy') && item.lazy;
	  }
	
	  function isLazyActive(vm, key) {
	    return vm[lazyActivePrefix + key];
	  }
	
	  var lazyActivePrefix = 'async_computed$lazy_active$',
	      lazyDataPrefix = 'async_computed$lazy_data$';
	
	  function initLazy(data, key) {
	    data[lazyActivePrefix + key] = false;
	    data[lazyDataPrefix + key] = null;
	  }
	
	  function makeLazyComputed(key) {
	    return {
	      get: function get() {
	        this[lazyActivePrefix + key] = true;
	        return this[lazyDataPrefix + key];
	      },
	      set: function set(value) {
	        this[lazyDataPrefix + key] = value;
	      }
	    };
	  }
	
	  function silentSetLazy(vm, key, value) {
	    vm[lazyDataPrefix + key] = value;
	  }
	  function silentGetLazy(vm, key) {
	    return vm[lazyDataPrefix + key];
	  }
	
	  var getGetterWatchedByArray = function getGetterWatchedByArray(computedAsyncProperty) {
	    return function getter() {
	      var _this = this;
	
	      computedAsyncProperty.watch.forEach(function (key) {
	        // Check if nested key is watched.
	        var splittedByDot = key.split('.');
	        if (splittedByDot.length === 1) {
	          // If not, just access it.
	          // eslint-disable-next-line no-unused-expressions
	          _this[key];
	        } else {
	          // Access the nested propety.
	          try {
	            var start = _this;
	            splittedByDot.forEach(function (part) {
	              start = start[part];
	            });
	          } catch (error) {
	            console.error('AsyncComputed: bad path: ', key);
	            throw error;
	          }
	        }
	      });
	      return computedAsyncProperty.get.call(this);
	    };
	  };
	
	  var getGetterWatchedByFunction = function getGetterWatchedByFunction(computedAsyncProperty) {
	    return function getter() {
	      computedAsyncProperty.watch.call(this);
	      return computedAsyncProperty.get.call(this);
	    };
	  };
	
	  function getWatchedGetter(computedAsyncProperty) {
	    if (typeof computedAsyncProperty.watch === 'function') {
	      return getGetterWatchedByFunction(computedAsyncProperty);
	    } else if (Array.isArray(computedAsyncProperty.watch)) {
	      computedAsyncProperty.watch.forEach(function (key) {
	        if (typeof key !== 'string') {
	          throw new Error('AsyncComputed: watch elemnts must be strings');
	        }
	      });
	      return getGetterWatchedByArray(computedAsyncProperty);
	    } else {
	      throw Error('AsyncComputed: watch should be function or an array');
	    }
	  }
	
	  var DidNotUpdate = typeof Symbol === 'function' ? Symbol('did-not-update') : {};
	
	  var getGetterWithShouldUpdate = function getGetterWithShouldUpdate(asyncProprety, currentGetter) {
	    return function getter() {
	      return asyncProprety.shouldUpdate.call(this) ? currentGetter.call(this) : DidNotUpdate;
	    };
	  };
	
	  var shouldNotUpdate = function shouldNotUpdate(value) {
	    return DidNotUpdate === value;
	  };
	
	  var prefix = '_async_computed$';
	
	  var AsyncComputed = {
	    install: function install(Vue, pluginOptions) {
	      pluginOptions = pluginOptions || {};
	
	      Vue.config.optionMergeStrategies.asyncComputed = Vue.config.optionMergeStrategies.computed;
	
	      Vue.mixin({
	        data: function data() {
	          return {
	            _asyncComputed: {}
	          };
	        },
	
	        computed: {
	          $asyncComputed: function $asyncComputed() {
	            return this.$data._asyncComputed;
	          }
	        },
	        beforeCreate: function beforeCreate() {
	          var asyncComputed = this.$options.asyncComputed || {};
	
	          if (!Object.keys(asyncComputed).length) return;
	
	          for (var key in asyncComputed) {
	            var getter = getterFn(key, asyncComputed[key]);
	            this.$options.computed[prefix + key] = getter;
	          }
	
	          this.$options.data = initDataWithAsyncComputed(this.$options);
	        },
	        created: function created() {
	          for (var key in this.$options.asyncComputed || {}) {
	            var item = this.$options.asyncComputed[key],
	                value = generateDefault.call(this, item, pluginOptions);
	            if (isComputedLazy(item)) {
	              silentSetLazy(this, key, value);
	            } else {
	              this[key] = value;
	            }
	          }
	
	          for (var _key in this.$options.asyncComputed || {}) {
	            handleAsyncComputedPropetyChanges(this, _key, pluginOptions, Vue);
	          }
	        }
	      });
	    }
	  };
	
	  function handleAsyncComputedPropetyChanges(vm, key, pluginOptions, Vue) {
	    var promiseId = 0;
	    var watcher = function watcher(newPromise) {
	      var thisPromise = ++promiseId;
	
	      if (shouldNotUpdate(newPromise)) return;
	
	      if (!newPromise || !newPromise.then) {
	        newPromise = Promise.resolve(newPromise);
	      }
	      setAsyncState(vm, key, 'updating');
	
	      newPromise.then(function (value) {
	        if (thisPromise !== promiseId) return;
	        setAsyncState(vm, key, 'success');
	        vm[key] = value;
	      }).catch(function (err) {
	        if (thisPromise !== promiseId) return;
	
	        setAsyncState(vm, key, 'error');
	        Vue.set(vm.$data._asyncComputed[key], 'exception', err);
	        if (pluginOptions.errorHandler === false) return;
	
	        var handler = pluginOptions.errorHandler === undefined ? console.error.bind(console, 'Error evaluating async computed property:') : pluginOptions.errorHandler;
	
	        if (pluginOptions.useRawError) {
	          handler(err, vm, err.stack);
	        } else {
	          handler(err.stack);
	        }
	      });
	    };
	    Vue.set(vm.$data._asyncComputed, key, {
	      exception: null,
	      update: function update() {
	        if (!vm._isDestroyed) {
	          watcher(getterOnly(vm.$options.asyncComputed[key]).apply(vm));
	        }
	      }
	    });
	    setAsyncState(vm, key, 'updating');
	    vm.$watch(prefix + key, watcher, { immediate: true });
	  }
	
	  function initDataWithAsyncComputed(options) {
	    var optionData = options.data;
	    var asyncComputed = options.asyncComputed || {};
	
	    return function vueAsyncComputedInjectedDataFn(vm) {
	      var data = (typeof optionData === 'function' ? optionData.call(this, vm) : optionData) || {};
	      for (var key in asyncComputed) {
	        var item = this.$options.asyncComputed[key];
	        if (isComputedLazy(item)) {
	          initLazy(data, key);
	          this.$options.computed[key] = makeLazyComputed(key);
	        } else {
	          data[key] = null;
	        }
	      }
	      return data;
	    };
	  }
	
	  function getterFn(key, fn) {
	    if (typeof fn === 'function') return fn;
	
	    var getter = fn.get;
	
	    if (hasOwnProperty(fn, 'watch')) {
	      getter = getWatchedGetter(fn);
	    }
	
	    if (hasOwnProperty(fn, 'shouldUpdate')) {
	      getter = getGetterWithShouldUpdate(fn, getter);
	    }
	
	    if (isComputedLazy(fn)) {
	      var nonLazy = getter;
	      getter = function lazyGetter() {
	        if (isLazyActive(this, key)) {
	          return nonLazy.call(this);
	        } else {
	          return silentGetLazy(this, key);
	        }
	      };
	    }
	    return getter;
	  }
	
	  function generateDefault(fn, pluginOptions) {
	    var defaultValue = null;
	
	    if ('default' in fn) {
	      defaultValue = fn.default;
	    } else if ('default' in pluginOptions) {
	      defaultValue = pluginOptions.default;
	    }
	
	    if (typeof defaultValue === 'function') {
	      return defaultValue.call(this);
	    } else {
	      return defaultValue;
	    }
	  }
	
	  /* istanbul ignore if */
	  if (typeof window !== 'undefined' && window.Vue) {
	    // Auto install in dist mode
	    window.Vue.use(AsyncComputed);
	  }
	
	  return AsyncComputed;
	});


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-chartjs v2.8.7
	 * (c) 2017 Jakub Juszczak <jakub@posteo.de>
	 * http://vue-chartjs.org
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(19), __webpack_require__(549));
		else if(typeof define === 'function' && define.amd)
			define("VueChartJs", ["vue", "chart.js"], factory);
		else if(typeof exports === 'object')
			exports["VueChartJs"] = factory(require("vue"), require("chart.js"));
		else
			root["VueChartJs"] = factory(root["vue"], root["chart.js"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.mixins = exports.Scatter = exports.Bubble = exports.Radar = exports.PolarArea = exports.Pie = exports.Line = exports.Doughnut = exports.HorizontalBar = exports.Bar = exports.VueCharts = undefined;
	
		var _Bar = __webpack_require__(1);
	
		var _Bar2 = _interopRequireDefault(_Bar);
	
		var _HorizontalBar = __webpack_require__(7);
	
		var _HorizontalBar2 = _interopRequireDefault(_HorizontalBar);
	
		var _Doughnut = __webpack_require__(8);
	
		var _Doughnut2 = _interopRequireDefault(_Doughnut);
	
		var _Line = __webpack_require__(9);
	
		var _Line2 = _interopRequireDefault(_Line);
	
		var _Pie = __webpack_require__(10);
	
		var _Pie2 = _interopRequireDefault(_Pie);
	
		var _PolarArea = __webpack_require__(11);
	
		var _PolarArea2 = _interopRequireDefault(_PolarArea);
	
		var _Radar = __webpack_require__(12);
	
		var _Radar2 = _interopRequireDefault(_Radar);
	
		var _Bubble = __webpack_require__(13);
	
		var _Bubble2 = _interopRequireDefault(_Bubble);
	
		var _Scatter = __webpack_require__(14);
	
		var _Scatter2 = _interopRequireDefault(_Scatter);
	
		var _index = __webpack_require__(15);
	
		var _index2 = _interopRequireDefault(_index);
	
		var _package = __webpack_require__(55);
	
		var _package2 = _interopRequireDefault(_package);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var VueCharts = {
		  version: _package2.default.version,
		  Bar: _Bar2.default,
		  HorizontalBar: _HorizontalBar2.default,
		  Doughnut: _Doughnut2.default,
		  Line: _Line2.default,
		  Pie: _Pie2.default,
		  PolarArea: _PolarArea2.default,
		  Radar: _Radar2.default,
		  Bubble: _Bubble2.default,
		  Scatter: _Scatter2.default,
		  mixins: _index2.default
		};
	
		exports.default = VueCharts;
		exports.VueCharts = VueCharts;
		exports.Bar = _Bar2.default;
		exports.HorizontalBar = _HorizontalBar2.default;
		exports.Doughnut = _Doughnut2.default;
		exports.Line = _Line2.default;
		exports.Pie = _Pie2.default;
		exports.PolarArea = _PolarArea2.default;
		exports.Radar = _Radar2.default;
		exports.Bubble = _Bubble2.default;
		exports.Scatter = _Scatter2.default;
		exports.mixins = _index2.default;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
		  props: {
		    chartId: {
		      default: 'bar-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
		  data: function data() {
		    return {
		      defaultOptions: {
		        scales: {
		          yAxes: [{
		            ticks: {
		              beginAtZero: true
		            },
		            gridLines: {
		              display: false
		            }
		          }],
		          xAxes: [{
		            gridLines: {
		              display: false
		            },
		            categoryPercentage: 0.5,
		            barPercentage: 0.2
		          }]
		        }
		      },
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'bar',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.mergeOptions = mergeOptions;
	
		var _lodash = __webpack_require__(5);
	
		var _lodash2 = _interopRequireDefault(_lodash);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function mergeOptions(obj, src) {
		  return (0, _lodash2.default)(obj, src);
		}
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(global, module) {/**
		 * lodash (Custom Build) <https://lodash.com/>
		 * Build: `lodash modularize exports="npm" -o ./`
		 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
		 * Released under MIT license <https://lodash.com/license>
		 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
		 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
		 */
	
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]',
		    weakMapTag = '[object WeakMap]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';
	
		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
		/** Used to match `RegExp` flags from their coerced string values. */
		var reFlags = /\w*$/;
	
		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;
	
		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
		typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
		typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
		typedArrayTags[errorTag] = typedArrayTags[funcTag] =
		typedArrayTags[mapTag] = typedArrayTags[numberTag] =
		typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
		typedArrayTags[setTag] = typedArrayTags[stringTag] =
		typedArrayTags[weakMapTag] = false;
	
		/** Used to identify `toStringTag` values supported by `_.clone`. */
		var cloneableTags = {};
		cloneableTags[argsTag] = cloneableTags[arrayTag] =
		cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
		cloneableTags[boolTag] = cloneableTags[dateTag] =
		cloneableTags[float32Tag] = cloneableTags[float64Tag] =
		cloneableTags[int8Tag] = cloneableTags[int16Tag] =
		cloneableTags[int32Tag] = cloneableTags[mapTag] =
		cloneableTags[numberTag] = cloneableTags[objectTag] =
		cloneableTags[regexpTag] = cloneableTags[setTag] =
		cloneableTags[stringTag] = cloneableTags[symbolTag] =
		cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
		cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
		cloneableTags[errorTag] = cloneableTags[funcTag] =
		cloneableTags[weakMapTag] = false;
	
		/** Detect free variable `global` from Node.js. */
		var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
		/** Detect free variable `self`. */
		var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || Function('return this')();
	
		/** Detect free variable `exports`. */
		var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
		/** Detect free variable `module`. */
		var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;
	
		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;
	
		/** Used to access faster Node.js helpers. */
		var nodeUtil = (function() {
		  try {
		    return freeProcess && freeProcess.binding('util');
		  } catch (e) {}
		}());
	
		/* Node.js helper references. */
		var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
		/**
		 * Adds the key-value `pair` to `map`.
		 *
		 * @private
		 * @param {Object} map The map to modify.
		 * @param {Array} pair The key-value pair to add.
		 * @returns {Object} Returns `map`.
		 */
		function addMapEntry(map, pair) {
		  // Don't return `map.set` because it's not chainable in IE 11.
		  map.set(pair[0], pair[1]);
		  return map;
		}
	
		/**
		 * Adds `value` to `set`.
		 *
		 * @private
		 * @param {Object} set The set to modify.
		 * @param {*} value The value to add.
		 * @returns {Object} Returns `set`.
		 */
		function addSetEntry(set, value) {
		  // Don't return `set.add` because it's not chainable in IE 11.
		  set.add(value);
		  return set;
		}
	
		/**
		 * A faster alternative to `Function#apply`, this function invokes `func`
		 * with the `this` binding of `thisArg` and the arguments of `args`.
		 *
		 * @private
		 * @param {Function} func The function to invoke.
		 * @param {*} thisArg The `this` binding of `func`.
		 * @param {Array} args The arguments to invoke `func` with.
		 * @returns {*} Returns the result of `func`.
		 */
		function apply(func, thisArg, args) {
		  switch (args.length) {
		    case 0: return func.call(thisArg);
		    case 1: return func.call(thisArg, args[0]);
		    case 2: return func.call(thisArg, args[0], args[1]);
		    case 3: return func.call(thisArg, args[0], args[1], args[2]);
		  }
		  return func.apply(thisArg, args);
		}
	
		/**
		 * A specialized version of `_.forEach` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns `array`.
		 */
		function arrayEach(array, iteratee) {
		  var index = -1,
		      length = array ? array.length : 0;
	
		  while (++index < length) {
		    if (iteratee(array[index], index, array) === false) {
		      break;
		    }
		  }
		  return array;
		}
	
		/**
		 * Appends the elements of `values` to `array`.
		 *
		 * @private
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to append.
		 * @returns {Array} Returns `array`.
		 */
		function arrayPush(array, values) {
		  var index = -1,
		      length = values.length,
		      offset = array.length;
	
		  while (++index < length) {
		    array[offset + index] = values[index];
		  }
		  return array;
		}
	
		/**
		 * A specialized version of `_.reduce` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {*} [accumulator] The initial value.
		 * @param {boolean} [initAccum] Specify using the first element of `array` as
		 *  the initial value.
		 * @returns {*} Returns the accumulated value.
		 */
		function arrayReduce(array, iteratee, accumulator, initAccum) {
		  var index = -1,
		      length = array ? array.length : 0;
	
		  if (initAccum && length) {
		    accumulator = array[++index];
		  }
		  while (++index < length) {
		    accumulator = iteratee(accumulator, array[index], index, array);
		  }
		  return accumulator;
		}
	
		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);
	
		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}
	
		/**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */
		function baseUnary(func) {
		  return function(value) {
		    return func(value);
		  };
		}
	
		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}
	
		/**
		 * Checks if `value` is a host object in IE < 9.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
		 */
		function isHostObject(value) {
		  // Many host objects are `Object` objects that can coerce to strings
		  // despite having improperly defined `toString` methods.
		  var result = false;
		  if (value != null && typeof value.toString != 'function') {
		    try {
		      result = !!(value + '');
		    } catch (e) {}
		  }
		  return result;
		}
	
		/**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */
		function mapToArray(map) {
		  var index = -1,
		      result = Array(map.size);
	
		  map.forEach(function(value, key) {
		    result[++index] = [key, value];
		  });
		  return result;
		}
	
		/**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */
		function overArg(func, transform) {
		  return function(arg) {
		    return func(transform(arg));
		  };
		}
	
		/**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */
		function setToArray(set) {
		  var index = -1,
		      result = Array(set.size);
	
		  set.forEach(function(value) {
		    result[++index] = value;
		  });
		  return result;
		}
	
		/** Used for built-in method references. */
		var arrayProto = Array.prototype,
		    funcProto = Function.prototype,
		    objectProto = Object.prototype;
	
		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];
	
		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to infer the `Object` constructor. */
		var objectCtorString = funcToString.call(Object);
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);
	
		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined,
		    Symbol = root.Symbol,
		    Uint8Array = root.Uint8Array,
		    getPrototype = overArg(Object.getPrototypeOf, Object),
		    objectCreate = Object.create,
		    propertyIsEnumerable = objectProto.propertyIsEnumerable,
		    splice = arrayProto.splice;
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetSymbols = Object.getOwnPropertySymbols,
		    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
		    nativeKeys = overArg(Object.keys, Object),
		    nativeMax = Math.max;
	
		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView'),
		    Map = getNative(root, 'Map'),
		    Promise = getNative(root, 'Promise'),
		    Set = getNative(root, 'Set'),
		    WeakMap = getNative(root, 'WeakMap'),
		    nativeCreate = getNative(Object, 'create');
	
		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);
	
		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		}
	
		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  return this.has(key) && delete this.__data__[key];
		}
	
		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}
	
		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
		}
	
		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
		  return this;
		}
	
		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;
	
		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		}
	
		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  return true;
		}
	
		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  return index < 0 ? undefined : data[index][1];
		}
	
		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}
	
		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  if (index < 0) {
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}
	
		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;
	
		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.__data__ = {
		    'hash': new Hash,
		    'map': new (Map || ListCache),
		    'string': new Hash
		  };
		}
	
		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  return getMapData(this, key)['delete'](key);
		}
	
		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}
	
		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}
	
		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  getMapData(this, key).set(key, value);
		  return this;
		}
	
		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;
	
		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  this.__data__ = new ListCache(entries);
		}
	
		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache;
		}
	
		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  return this.__data__['delete'](key);
		}
	
		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}
	
		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}
	
		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var cache = this.__data__;
		  if (cache instanceof ListCache) {
		    var pairs = cache.__data__;
		    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
		      pairs.push([key, value]);
		      return this;
		    }
		    cache = this.__data__ = new MapCache(pairs);
		  }
		  cache.set(key, value);
		  return this;
		}
	
		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;
	
		/**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */
		function arrayLikeKeys(value, inherited) {
		  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
		  // Safari 9 makes `arguments.length` enumerable in strict mode.
		  var result = (isArray(value) || isArguments(value))
		    ? baseTimes(value.length, String)
		    : [];
	
		  var length = result.length,
		      skipIndexes = !!length;
	
		  for (var key in value) {
		    if ((inherited || hasOwnProperty.call(value, key)) &&
		        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		/**
		 * This function is like `assignValue` except that it doesn't assign
		 * `undefined` values.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignMergeValue(object, key, value) {
		  if ((value !== undefined && !eq(object[key], value)) ||
		      (typeof key == 'number' && value === undefined && !(key in object))) {
		    object[key] = value;
		  }
		}
	
		/**
		 * Assigns `value` to `key` of `object` if the existing value is not equivalent
		 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignValue(object, key, value) {
		  var objValue = object[key];
		  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
		      (value === undefined && !(key in object))) {
		    object[key] = value;
		  }
		}
	
		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}
	
		/**
		 * The base implementation of `_.assign` without support for multiple sources
		 * or `customizer` functions.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @returns {Object} Returns `object`.
		 */
		function baseAssign(object, source) {
		  return object && copyObject(source, keys(source), object);
		}
	
		/**
		 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
		 * traversed objects.
		 *
		 * @private
		 * @param {*} value The value to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @param {boolean} [isFull] Specify a clone including symbols.
		 * @param {Function} [customizer] The function to customize cloning.
		 * @param {string} [key] The key of `value`.
		 * @param {Object} [object] The parent object of `value`.
		 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
		 * @returns {*} Returns the cloned value.
		 */
		function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
		  var result;
		  if (customizer) {
		    result = object ? customizer(value, key, object, stack) : customizer(value);
		  }
		  if (result !== undefined) {
		    return result;
		  }
		  if (!isObject(value)) {
		    return value;
		  }
		  var isArr = isArray(value);
		  if (isArr) {
		    result = initCloneArray(value);
		    if (!isDeep) {
		      return copyArray(value, result);
		    }
		  } else {
		    var tag = getTag(value),
		        isFunc = tag == funcTag || tag == genTag;
	
		    if (isBuffer(value)) {
		      return cloneBuffer(value, isDeep);
		    }
		    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
		      if (isHostObject(value)) {
		        return object ? value : {};
		      }
		      result = initCloneObject(isFunc ? {} : value);
		      if (!isDeep) {
		        return copySymbols(value, baseAssign(result, value));
		      }
		    } else {
		      if (!cloneableTags[tag]) {
		        return object ? value : {};
		      }
		      result = initCloneByTag(value, tag, baseClone, isDeep);
		    }
		  }
		  // Check for circular references and return its corresponding clone.
		  stack || (stack = new Stack);
		  var stacked = stack.get(value);
		  if (stacked) {
		    return stacked;
		  }
		  stack.set(value, result);
	
		  if (!isArr) {
		    var props = isFull ? getAllKeys(value) : keys(value);
		  }
		  arrayEach(props || value, function(subValue, key) {
		    if (props) {
		      key = subValue;
		      subValue = value[key];
		    }
		    // Recursively populate clone (susceptible to call stack limits).
		    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
		  });
		  return result;
		}
	
		/**
		 * The base implementation of `_.create` without support for assigning
		 * properties to the created object.
		 *
		 * @private
		 * @param {Object} prototype The object to inherit from.
		 * @returns {Object} Returns the new object.
		 */
		function baseCreate(proto) {
		  return isObject(proto) ? objectCreate(proto) : {};
		}
	
		/**
		 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
		 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
		 * symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @param {Function} symbolsFunc The function to get the symbols of `object`.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function baseGetAllKeys(object, keysFunc, symbolsFunc) {
		  var result = keysFunc(object);
		  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
		}
	
		/**
		 * The base implementation of `getTag`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function baseGetTag(value) {
		  return objectToString.call(value);
		}
	
		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}
	
		/**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */
		function baseIsTypedArray(value) {
		  return isObjectLike(value) &&
		    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
		}
	
		/**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeys(object) {
		  if (!isPrototype(object)) {
		    return nativeKeys(object);
		  }
		  var result = [];
		  for (var key in Object(object)) {
		    if (hasOwnProperty.call(object, key) && key != 'constructor') {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		/**
		 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeysIn(object) {
		  if (!isObject(object)) {
		    return nativeKeysIn(object);
		  }
		  var isProto = isPrototype(object),
		      result = [];
	
		  for (var key in object) {
		    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		/**
		 * The base implementation of `_.merge` without support for multiple sources.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @param {number} srcIndex The index of `source`.
		 * @param {Function} [customizer] The function to customize merged values.
		 * @param {Object} [stack] Tracks traversed source values and their merged
		 *  counterparts.
		 */
		function baseMerge(object, source, srcIndex, customizer, stack) {
		  if (object === source) {
		    return;
		  }
		  if (!(isArray(source) || isTypedArray(source))) {
		    var props = baseKeysIn(source);
		  }
		  arrayEach(props || source, function(srcValue, key) {
		    if (props) {
		      key = srcValue;
		      srcValue = source[key];
		    }
		    if (isObject(srcValue)) {
		      stack || (stack = new Stack);
		      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
		    }
		    else {
		      var newValue = customizer
		        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
		        : undefined;
	
		      if (newValue === undefined) {
		        newValue = srcValue;
		      }
		      assignMergeValue(object, key, newValue);
		    }
		  });
		}
	
		/**
		 * A specialized version of `baseMerge` for arrays and objects which performs
		 * deep merges and tracks traversed objects enabling objects with circular
		 * references to be merged.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @param {string} key The key of the value to merge.
		 * @param {number} srcIndex The index of `source`.
		 * @param {Function} mergeFunc The function to merge values.
		 * @param {Function} [customizer] The function to customize assigned values.
		 * @param {Object} [stack] Tracks traversed source values and their merged
		 *  counterparts.
		 */
		function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
		  var objValue = object[key],
		      srcValue = source[key],
		      stacked = stack.get(srcValue);
	
		  if (stacked) {
		    assignMergeValue(object, key, stacked);
		    return;
		  }
		  var newValue = customizer
		    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
		    : undefined;
	
		  var isCommon = newValue === undefined;
	
		  if (isCommon) {
		    newValue = srcValue;
		    if (isArray(srcValue) || isTypedArray(srcValue)) {
		      if (isArray(objValue)) {
		        newValue = objValue;
		      }
		      else if (isArrayLikeObject(objValue)) {
		        newValue = copyArray(objValue);
		      }
		      else {
		        isCommon = false;
		        newValue = baseClone(srcValue, true);
		      }
		    }
		    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
		      if (isArguments(objValue)) {
		        newValue = toPlainObject(objValue);
		      }
		      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
		        isCommon = false;
		        newValue = baseClone(srcValue, true);
		      }
		      else {
		        newValue = objValue;
		      }
		    }
		    else {
		      isCommon = false;
		    }
		  }
		  if (isCommon) {
		    // Recursively merge objects and arrays (susceptible to call stack limits).
		    stack.set(srcValue, newValue);
		    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
		    stack['delete'](srcValue);
		  }
		  assignMergeValue(object, key, newValue);
		}
	
		/**
		 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
		 *
		 * @private
		 * @param {Function} func The function to apply a rest parameter to.
		 * @param {number} [start=func.length-1] The start position of the rest parameter.
		 * @returns {Function} Returns the new function.
		 */
		function baseRest(func, start) {
		  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
		  return function() {
		    var args = arguments,
		        index = -1,
		        length = nativeMax(args.length - start, 0),
		        array = Array(length);
	
		    while (++index < length) {
		      array[index] = args[start + index];
		    }
		    index = -1;
		    var otherArgs = Array(start + 1);
		    while (++index < start) {
		      otherArgs[index] = args[index];
		    }
		    otherArgs[start] = array;
		    return apply(func, this, otherArgs);
		  };
		}
	
		/**
		 * Creates a clone of  `buffer`.
		 *
		 * @private
		 * @param {Buffer} buffer The buffer to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Buffer} Returns the cloned buffer.
		 */
		function cloneBuffer(buffer, isDeep) {
		  if (isDeep) {
		    return buffer.slice();
		  }
		  var result = new buffer.constructor(buffer.length);
		  buffer.copy(result);
		  return result;
		}
	
		/**
		 * Creates a clone of `arrayBuffer`.
		 *
		 * @private
		 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
		 * @returns {ArrayBuffer} Returns the cloned array buffer.
		 */
		function cloneArrayBuffer(arrayBuffer) {
		  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
		  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
		  return result;
		}
	
		/**
		 * Creates a clone of `dataView`.
		 *
		 * @private
		 * @param {Object} dataView The data view to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned data view.
		 */
		function cloneDataView(dataView, isDeep) {
		  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
		  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
		}
	
		/**
		 * Creates a clone of `map`.
		 *
		 * @private
		 * @param {Object} map The map to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned map.
		 */
		function cloneMap(map, isDeep, cloneFunc) {
		  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
		  return arrayReduce(array, addMapEntry, new map.constructor);
		}
	
		/**
		 * Creates a clone of `regexp`.
		 *
		 * @private
		 * @param {Object} regexp The regexp to clone.
		 * @returns {Object} Returns the cloned regexp.
		 */
		function cloneRegExp(regexp) {
		  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
		  result.lastIndex = regexp.lastIndex;
		  return result;
		}
	
		/**
		 * Creates a clone of `set`.
		 *
		 * @private
		 * @param {Object} set The set to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned set.
		 */
		function cloneSet(set, isDeep, cloneFunc) {
		  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
		  return arrayReduce(array, addSetEntry, new set.constructor);
		}
	
		/**
		 * Creates a clone of the `symbol` object.
		 *
		 * @private
		 * @param {Object} symbol The symbol object to clone.
		 * @returns {Object} Returns the cloned symbol object.
		 */
		function cloneSymbol(symbol) {
		  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
		}
	
		/**
		 * Creates a clone of `typedArray`.
		 *
		 * @private
		 * @param {Object} typedArray The typed array to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned typed array.
		 */
		function cloneTypedArray(typedArray, isDeep) {
		  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
		  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
		}
	
		/**
		 * Copies the values of `source` to `array`.
		 *
		 * @private
		 * @param {Array} source The array to copy values from.
		 * @param {Array} [array=[]] The array to copy values to.
		 * @returns {Array} Returns `array`.
		 */
		function copyArray(source, array) {
		  var index = -1,
		      length = source.length;
	
		  array || (array = Array(length));
		  while (++index < length) {
		    array[index] = source[index];
		  }
		  return array;
		}
	
		/**
		 * Copies properties of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy properties from.
		 * @param {Array} props The property identifiers to copy.
		 * @param {Object} [object={}] The object to copy properties to.
		 * @param {Function} [customizer] The function to customize copied values.
		 * @returns {Object} Returns `object`.
		 */
		function copyObject(source, props, object, customizer) {
		  object || (object = {});
	
		  var index = -1,
		      length = props.length;
	
		  while (++index < length) {
		    var key = props[index];
	
		    var newValue = customizer
		      ? customizer(object[key], source[key], key, object, source)
		      : undefined;
	
		    assignValue(object, key, newValue === undefined ? source[key] : newValue);
		  }
		  return object;
		}
	
		/**
		 * Copies own symbol properties of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy symbols from.
		 * @param {Object} [object={}] The object to copy symbols to.
		 * @returns {Object} Returns `object`.
		 */
		function copySymbols(source, object) {
		  return copyObject(source, getSymbols(source), object);
		}
	
		/**
		 * Creates a function like `_.assign`.
		 *
		 * @private
		 * @param {Function} assigner The function to assign values.
		 * @returns {Function} Returns the new assigner function.
		 */
		function createAssigner(assigner) {
		  return baseRest(function(object, sources) {
		    var index = -1,
		        length = sources.length,
		        customizer = length > 1 ? sources[length - 1] : undefined,
		        guard = length > 2 ? sources[2] : undefined;
	
		    customizer = (assigner.length > 3 && typeof customizer == 'function')
		      ? (length--, customizer)
		      : undefined;
	
		    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
		      customizer = length < 3 ? undefined : customizer;
		      length = 1;
		    }
		    object = Object(object);
		    while (++index < length) {
		      var source = sources[index];
		      if (source) {
		        assigner(object, source, index, customizer);
		      }
		    }
		    return object;
		  });
		}
	
		/**
		 * Creates an array of own enumerable property names and symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function getAllKeys(object) {
		  return baseGetAllKeys(object, keys, getSymbols);
		}
	
		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key)
		    ? data[typeof key == 'string' ? 'string' : 'hash']
		    : data.map;
		}
	
		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}
	
		/**
		 * Creates an array of the own enumerable symbol properties of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of symbols.
		 */
		var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		var getTag = baseGetTag;
	
		// Fallback for data views, maps, sets, and weak maps in IE 11,
		// for data views in Edge < 14, and promises in Node.js.
		if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
		    (Map && getTag(new Map) != mapTag) ||
		    (Promise && getTag(Promise.resolve()) != promiseTag) ||
		    (Set && getTag(new Set) != setTag) ||
		    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
		  getTag = function(value) {
		    var result = objectToString.call(value),
		        Ctor = result == objectTag ? value.constructor : undefined,
		        ctorString = Ctor ? toSource(Ctor) : undefined;
	
		    if (ctorString) {
		      switch (ctorString) {
		        case dataViewCtorString: return dataViewTag;
		        case mapCtorString: return mapTag;
		        case promiseCtorString: return promiseTag;
		        case setCtorString: return setTag;
		        case weakMapCtorString: return weakMapTag;
		      }
		    }
		    return result;
		  };
		}
	
		/**
		 * Initializes an array clone.
		 *
		 * @private
		 * @param {Array} array The array to clone.
		 * @returns {Array} Returns the initialized clone.
		 */
		function initCloneArray(array) {
		  var length = array.length,
		      result = array.constructor(length);
	
		  // Add properties assigned by `RegExp#exec`.
		  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
		    result.index = array.index;
		    result.input = array.input;
		  }
		  return result;
		}
	
		/**
		 * Initializes an object clone.
		 *
		 * @private
		 * @param {Object} object The object to clone.
		 * @returns {Object} Returns the initialized clone.
		 */
		function initCloneObject(object) {
		  return (typeof object.constructor == 'function' && !isPrototype(object))
		    ? baseCreate(getPrototype(object))
		    : {};
		}
	
		/**
		 * Initializes an object clone based on its `toStringTag`.
		 *
		 * **Note:** This function only supports cloning values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to clone.
		 * @param {string} tag The `toStringTag` of the object to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the initialized clone.
		 */
		function initCloneByTag(object, tag, cloneFunc, isDeep) {
		  var Ctor = object.constructor;
		  switch (tag) {
		    case arrayBufferTag:
		      return cloneArrayBuffer(object);
	
		    case boolTag:
		    case dateTag:
		      return new Ctor(+object);
	
		    case dataViewTag:
		      return cloneDataView(object, isDeep);
	
		    case float32Tag: case float64Tag:
		    case int8Tag: case int16Tag: case int32Tag:
		    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
		      return cloneTypedArray(object, isDeep);
	
		    case mapTag:
		      return cloneMap(object, isDeep, cloneFunc);
	
		    case numberTag:
		    case stringTag:
		      return new Ctor(object);
	
		    case regexpTag:
		      return cloneRegExp(object);
	
		    case setTag:
		      return cloneSet(object, isDeep, cloneFunc);
	
		    case symbolTag:
		      return cloneSymbol(object);
		  }
		}
	
		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length &&
		    (typeof value == 'number' || reIsUint.test(value)) &&
		    (value > -1 && value % 1 == 0 && value < length);
		}
	
		/**
		 * Checks if the given arguments are from an iteratee call.
		 *
		 * @private
		 * @param {*} value The potential iteratee value argument.
		 * @param {*} index The potential iteratee index or key argument.
		 * @param {*} object The potential iteratee object argument.
		 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
		 *  else `false`.
		 */
		function isIterateeCall(value, index, object) {
		  if (!isObject(object)) {
		    return false;
		  }
		  var type = typeof index;
		  if (type == 'number'
		        ? (isArrayLike(object) && isIndex(index, object.length))
		        : (type == 'string' && index in object)
		      ) {
		    return eq(object[index], value);
		  }
		  return false;
		}
	
		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value;
		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
		    ? (value !== '__proto__')
		    : (value === null);
		}
	
		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}
	
		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
		  return value === proto;
		}
	
		/**
		 * This function is like
		 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * except that it includes inherited enumerable properties.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function nativeKeysIn(object) {
		  var result = [];
		  if (object != null) {
		    for (var key in Object(object)) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to process.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}
	
		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || (value !== value && other !== other);
		}
	
		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		function isArguments(value) {
		  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
		  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
		    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
		}
	
		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;
	
		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(value.length) && !isFunction(value);
		}
	
		/**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */
		function isArrayLikeObject(value) {
		  return isObjectLike(value) && isArrayLike(value);
		}
	
		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;
	
		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 8-9 which returns 'object' for typed array and other constructors.
		  var tag = isObject(value) ? objectToString.call(value) : '';
		  return tag == funcTag || tag == genTag;
		}
	
		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}
	
		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return !!value && (type == 'object' || type == 'function');
		}
	
		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return !!value && typeof value == 'object';
		}
	
		/**
		 * Checks if `value` is a plain object, that is, an object created by the
		 * `Object` constructor or one with a `[[Prototype]]` of `null`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.8.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 * }
		 *
		 * _.isPlainObject(new Foo);
		 * // => false
		 *
		 * _.isPlainObject([1, 2, 3]);
		 * // => false
		 *
		 * _.isPlainObject({ 'x': 0, 'y': 0 });
		 * // => true
		 *
		 * _.isPlainObject(Object.create(null));
		 * // => true
		 */
		function isPlainObject(value) {
		  if (!isObjectLike(value) ||
		      objectToString.call(value) != objectTag || isHostObject(value)) {
		    return false;
		  }
		  var proto = getPrototype(value);
		  if (proto === null) {
		    return true;
		  }
		  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
		  return (typeof Ctor == 'function' &&
		    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
		}
	
		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
		/**
		 * Converts `value` to a plain object flattening inherited enumerable string
		 * keyed properties of `value` to own properties of the plain object.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {Object} Returns the converted plain object.
		 * @example
		 *
		 * function Foo() {
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.assign({ 'a': 1 }, new Foo);
		 * // => { 'a': 1, 'b': 2 }
		 *
		 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
		 * // => { 'a': 1, 'b': 2, 'c': 3 }
		 */
		function toPlainObject(value) {
		  return copyObject(value, keysIn(value));
		}
	
		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
		}
	
		/**
		 * Creates an array of the own and inherited enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keysIn(new Foo);
		 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
		 */
		function keysIn(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
		}
	
		/**
		 * This method is like `_.assign` except that it recursively merges own and
		 * inherited enumerable string keyed properties of source objects into the
		 * destination object. Source properties that resolve to `undefined` are
		 * skipped if a destination value exists. Array and plain object properties
		 * are merged recursively. Other objects and value types are overridden by
		 * assignment. Source objects are applied from left to right. Subsequent
		 * sources overwrite property assignments of previous sources.
		 *
		 * **Note:** This method mutates `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.5.0
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} [sources] The source objects.
		 * @returns {Object} Returns `object`.
		 * @example
		 *
		 * var object = {
		 *   'a': [{ 'b': 2 }, { 'd': 4 }]
		 * };
		 *
		 * var other = {
		 *   'a': [{ 'c': 3 }, { 'e': 5 }]
		 * };
		 *
		 * _.merge(object, other);
		 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
		 */
		var merge = createAssigner(function(object, source, srcIndex) {
		  baseMerge(object, source, srcIndex);
		});
	
		/**
		 * This method returns a new empty array.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {Array} Returns the new empty array.
		 * @example
		 *
		 * var arrays = _.times(2, _.stubArray);
		 *
		 * console.log(arrays);
		 * // => [[], []]
		 *
		 * console.log(arrays[0] === arrays[1]);
		 * // => false
		 */
		function stubArray() {
		  return [];
		}
	
		/**
		 * This method returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}
	
		module.exports = merge;
	
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(6)(module)))
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		module.exports = function(module) {
			if(!module.webpackPolyfill) {
				module.deprecate = function() {};
				module.paths = [];
				// module.parent = undefined by default
				module.children = [];
				module.webpackPolyfill = 1;
			}
			return module;
		}
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'horizontalbar-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {
		        scales: {
		          yAxes: [{
		            ticks: {
		              beginAtZero: true
		            },
		            gridLines: {
		              display: false
		            }
		          }],
		          xAxes: [{
		            gridLines: {
		              display: false
		            },
		            categoryPercentage: 0.5,
		            barPercentage: 0.2
		          }]
		        }
		      },
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options, type) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'horizontalBar',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'doughnut-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {},
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'doughnut',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'line-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {
		        scales: {
		          yAxes: [{
		            ticks: {
		              beginAtZero: true
		            },
		            gridLines: {
		              display: false
		            }
		          }],
		          xAxes: [{
		            gridLines: {
		              display: false
		            }
		          }]
		        }
		      },
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'line',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'pie-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {},
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'pie',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'polar-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {},
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'polarArea',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'radar-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {},
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'radar',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'bubble-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {
		        scales: {
		          yAxes: [{
		            ticks: {
		              beginAtZero: true
		            },
		            gridLines: {
		              display: false
		            }
		          }],
		          xAxes: [{
		            gridLines: {
		              display: false
		            },
		            categoryPercentage: 0.5,
		            barPercentage: 0.2
		          }]
		        }
		      },
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'bubble',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'scatter-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {
		        scales: {
		          xAxes: [{
		            type: 'linear',
		            position: 'bottom'
		          }]
		        }
		      },
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'scatter',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _reactiveData = __webpack_require__(16);
	
		var _reactiveData2 = _interopRequireDefault(_reactiveData);
	
		var _reactiveProp = __webpack_require__(54);
	
		var _reactiveProp2 = _interopRequireDefault(_reactiveProp);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  reactiveData: _reactiveData2.default,
		  reactiveProp: _reactiveProp2.default
		};
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _keys = __webpack_require__(17);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _stringify = __webpack_require__(52);
	
		var _stringify2 = _interopRequireDefault(_stringify);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		module.exports = {
		  data: function data() {
		    return {
		      chartData: null
		    };
		  },
	
		  watch: {
		    'chartData': {
		      handler: function handler(newData, oldData) {
		        if (oldData) {
		          var chart = this._chart;
	
		          var newDatasetLabels = newData.datasets.map(function (dataset) {
		            return dataset.label;
		          });
	
		          var oldDatasetLabels = oldData.datasets.map(function (dataset) {
		            return dataset.label;
		          });
	
		          var oldLabels = (0, _stringify2.default)(oldDatasetLabels);
		          var newLabels = (0, _stringify2.default)(newDatasetLabels);
	
		          if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
		            newData.datasets.forEach(function (dataset, i) {
		              var oldDatasetKeys = (0, _keys2.default)(oldData.datasets[i]);
		              var newDatasetKeys = (0, _keys2.default)(dataset);
	
		              var deletionKeys = oldDatasetKeys.filter(function (key) {
		                return key !== '_meta' && newDatasetKeys.indexOf(key) === -1;
		              });
	
		              deletionKeys.forEach(function (deletionKey) {
		                delete chart.data.datasets[i][deletionKey];
		              });
	
		              for (var attribute in dataset) {
		                if (dataset.hasOwnProperty(attribute)) {
		                  chart.data.datasets[i][attribute] = dataset[attribute];
		                }
		              }
		            });
	
		            if (newData.hasOwnProperty('labels')) {
		              chart.data.labels = newData.labels;
		            }
		            if (newData.hasOwnProperty('xLabels')) {
		              chart.data.xLabels = newData.xLabels;
		            }
		            if (newData.hasOwnProperty('yLabels')) {
		              chart.data.yLabels = newData.yLabels;
		            }
		            chart.update();
		          } else {
		            chart.destroy();
		            this.renderChart(this.chartData, this.options);
		          }
		        } else {
		          this.renderChart(this.chartData, this.options);
		        }
		      }
		    }
		  }
		};
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(18), __esModule: true };
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(19);
		module.exports = __webpack_require__(39).Object.keys;
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.14 Object.keys(O)
		var toObject = __webpack_require__(20)
		  , $keys    = __webpack_require__(22);
	
		__webpack_require__(37)('keys', function(){
		  return function keys(it){
		    return $keys(toObject(it));
		  };
		});
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.13 ToObject(argument)
		var defined = __webpack_require__(21);
		module.exports = function(it){
		  return Object(defined(it));
		};
	
	/***/ },
	/* 21 */
	/***/ function(module, exports) {
	
		// 7.2.1 RequireObjectCoercible(argument)
		module.exports = function(it){
		  if(it == undefined)throw TypeError("Can't call method on  " + it);
		  return it;
		};
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.14 / 15.2.3.14 Object.keys(O)
		var $keys       = __webpack_require__(23)
		  , enumBugKeys = __webpack_require__(36);
	
		module.exports = Object.keys || function keys(O){
		  return $keys(O, enumBugKeys);
		};
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
		var has          = __webpack_require__(24)
		  , toIObject    = __webpack_require__(25)
		  , arrayIndexOf = __webpack_require__(28)(false)
		  , IE_PROTO     = __webpack_require__(32)('IE_PROTO');
	
		module.exports = function(object, names){
		  var O      = toIObject(object)
		    , i      = 0
		    , result = []
		    , key;
		  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
		  // Don't enum bug & hidden keys
		  while(names.length > i)if(has(O, key = names[i++])){
		    ~arrayIndexOf(result, key) || result.push(key);
		  }
		  return result;
		};
	
	/***/ },
	/* 24 */
	/***/ function(module, exports) {
	
		var hasOwnProperty = {}.hasOwnProperty;
		module.exports = function(it, key){
		  return hasOwnProperty.call(it, key);
		};
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		// to indexed object, toObject with fallback for non-array-like ES3 strings
		var IObject = __webpack_require__(26)
		  , defined = __webpack_require__(21);
		module.exports = function(it){
		  return IObject(defined(it));
		};
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		// fallback for non-array-like ES3 and non-enumerable old V8 strings
		var cof = __webpack_require__(27);
		module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
		  return cof(it) == 'String' ? it.split('') : Object(it);
		};
	
	/***/ },
	/* 27 */
	/***/ function(module, exports) {
	
		var toString = {}.toString;
	
		module.exports = function(it){
		  return toString.call(it).slice(8, -1);
		};
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		// false -> Array#indexOf
		// true  -> Array#includes
		var toIObject = __webpack_require__(25)
		  , toLength  = __webpack_require__(29)
		  , toIndex   = __webpack_require__(31);
		module.exports = function(IS_INCLUDES){
		  return function($this, el, fromIndex){
		    var O      = toIObject($this)
		      , length = toLength(O.length)
		      , index  = toIndex(fromIndex, length)
		      , value;
		    // Array#includes uses SameValueZero equality algorithm
		    if(IS_INCLUDES && el != el)while(length > index){
		      value = O[index++];
		      if(value != value)return true;
		    // Array#toIndex ignores holes, Array#includes - not
		    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
		      if(O[index] === el)return IS_INCLUDES || index || 0;
		    } return !IS_INCLUDES && -1;
		  };
		};
	
	/***/ },
	/* 29 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.15 ToLength
		var toInteger = __webpack_require__(30)
		  , min       = Math.min;
		module.exports = function(it){
		  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
		};
	
	/***/ },
	/* 30 */
	/***/ function(module, exports) {
	
		// 7.1.4 ToInteger
		var ceil  = Math.ceil
		  , floor = Math.floor;
		module.exports = function(it){
		  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
		};
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toInteger = __webpack_require__(30)
		  , max       = Math.max
		  , min       = Math.min;
		module.exports = function(index, length){
		  index = toInteger(index);
		  return index < 0 ? max(index + length, 0) : min(index, length);
		};
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		var shared = __webpack_require__(33)('keys')
		  , uid    = __webpack_require__(35);
		module.exports = function(key){
		  return shared[key] || (shared[key] = uid(key));
		};
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		var global = __webpack_require__(34)
		  , SHARED = '__core-js_shared__'
		  , store  = global[SHARED] || (global[SHARED] = {});
		module.exports = function(key){
		  return store[key] || (store[key] = {});
		};
	
	/***/ },
	/* 34 */
	/***/ function(module, exports) {
	
		// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
		var global = module.exports = typeof window != 'undefined' && window.Math == Math
		  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
		if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
	
	/***/ },
	/* 35 */
	/***/ function(module, exports) {
	
		var id = 0
		  , px = Math.random();
		module.exports = function(key){
		  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
		};
	
	/***/ },
	/* 36 */
	/***/ function(module, exports) {
	
		// IE 8- don't enum bug keys
		module.exports = (
		  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
		).split(',');
	
	/***/ },
	/* 37 */
	/***/ function(module, exports, __webpack_require__) {
	
		// most Object methods by ES6 should accept primitives
		var $export = __webpack_require__(38)
		  , core    = __webpack_require__(39)
		  , fails   = __webpack_require__(48);
		module.exports = function(KEY, exec){
		  var fn  = (core.Object || {})[KEY] || Object[KEY]
		    , exp = {};
		  exp[KEY] = exec(fn);
		  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
		};
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		var global    = __webpack_require__(34)
		  , core      = __webpack_require__(39)
		  , ctx       = __webpack_require__(40)
		  , hide      = __webpack_require__(42)
		  , PROTOTYPE = 'prototype';
	
		var $export = function(type, name, source){
		  var IS_FORCED = type & $export.F
		    , IS_GLOBAL = type & $export.G
		    , IS_STATIC = type & $export.S
		    , IS_PROTO  = type & $export.P
		    , IS_BIND   = type & $export.B
		    , IS_WRAP   = type & $export.W
		    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
		    , expProto  = exports[PROTOTYPE]
		    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
		    , key, own, out;
		  if(IS_GLOBAL)source = name;
		  for(key in source){
		    // contains in native
		    own = !IS_FORCED && target && target[key] !== undefined;
		    if(own && key in exports)continue;
		    // export native or passed
		    out = own ? target[key] : source[key];
		    // prevent global pollution for namespaces
		    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
		    // bind timers to global for call from export context
		    : IS_BIND && own ? ctx(out, global)
		    // wrap global constructors for prevent change them in library
		    : IS_WRAP && target[key] == out ? (function(C){
		      var F = function(a, b, c){
		        if(this instanceof C){
		          switch(arguments.length){
		            case 0: return new C;
		            case 1: return new C(a);
		            case 2: return new C(a, b);
		          } return new C(a, b, c);
		        } return C.apply(this, arguments);
		      };
		      F[PROTOTYPE] = C[PROTOTYPE];
		      return F;
		    // make static versions for prototype methods
		    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
		    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
		    if(IS_PROTO){
		      (exports.virtual || (exports.virtual = {}))[key] = out;
		      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
		      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
		    }
		  }
		};
		// type bitmap
		$export.F = 1;   // forced
		$export.G = 2;   // global
		$export.S = 4;   // static
		$export.P = 8;   // proto
		$export.B = 16;  // bind
		$export.W = 32;  // wrap
		$export.U = 64;  // safe
		$export.R = 128; // real proto method for `library` 
		module.exports = $export;
	
	/***/ },
	/* 39 */
	/***/ function(module, exports) {
	
		var core = module.exports = {version: '2.4.0'};
		if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
	
	/***/ },
	/* 40 */
	/***/ function(module, exports, __webpack_require__) {
	
		// optional / simple context binding
		var aFunction = __webpack_require__(41);
		module.exports = function(fn, that, length){
		  aFunction(fn);
		  if(that === undefined)return fn;
		  switch(length){
		    case 1: return function(a){
		      return fn.call(that, a);
		    };
		    case 2: return function(a, b){
		      return fn.call(that, a, b);
		    };
		    case 3: return function(a, b, c){
		      return fn.call(that, a, b, c);
		    };
		  }
		  return function(/* ...args */){
		    return fn.apply(that, arguments);
		  };
		};
	
	/***/ },
	/* 41 */
	/***/ function(module, exports) {
	
		module.exports = function(it){
		  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
		  return it;
		};
	
	/***/ },
	/* 42 */
	/***/ function(module, exports, __webpack_require__) {
	
		var dP         = __webpack_require__(43)
		  , createDesc = __webpack_require__(51);
		module.exports = __webpack_require__(47) ? function(object, key, value){
		  return dP.f(object, key, createDesc(1, value));
		} : function(object, key, value){
		  object[key] = value;
		  return object;
		};
	
	/***/ },
	/* 43 */
	/***/ function(module, exports, __webpack_require__) {
	
		var anObject       = __webpack_require__(44)
		  , IE8_DOM_DEFINE = __webpack_require__(46)
		  , toPrimitive    = __webpack_require__(50)
		  , dP             = Object.defineProperty;
	
		exports.f = __webpack_require__(47) ? Object.defineProperty : function defineProperty(O, P, Attributes){
		  anObject(O);
		  P = toPrimitive(P, true);
		  anObject(Attributes);
		  if(IE8_DOM_DEFINE)try {
		    return dP(O, P, Attributes);
		  } catch(e){ /* empty */ }
		  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
		  if('value' in Attributes)O[P] = Attributes.value;
		  return O;
		};
	
	/***/ },
	/* 44 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(45);
		module.exports = function(it){
		  if(!isObject(it))throw TypeError(it + ' is not an object!');
		  return it;
		};
	
	/***/ },
	/* 45 */
	/***/ function(module, exports) {
	
		module.exports = function(it){
		  return typeof it === 'object' ? it !== null : typeof it === 'function';
		};
	
	/***/ },
	/* 46 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = !__webpack_require__(47) && !__webpack_require__(48)(function(){
		  return Object.defineProperty(__webpack_require__(49)('div'), 'a', {get: function(){ return 7; }}).a != 7;
		});
	
	/***/ },
	/* 47 */
	/***/ function(module, exports, __webpack_require__) {
	
		// Thank's IE8 for his funny defineProperty
		module.exports = !__webpack_require__(48)(function(){
		  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
		});
	
	/***/ },
	/* 48 */
	/***/ function(module, exports) {
	
		module.exports = function(exec){
		  try {
		    return !!exec();
		  } catch(e){
		    return true;
		  }
		};
	
	/***/ },
	/* 49 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(45)
		  , document = __webpack_require__(34).document
		  // in old IE typeof document.createElement is 'object'
		  , is = isObject(document) && isObject(document.createElement);
		module.exports = function(it){
		  return is ? document.createElement(it) : {};
		};
	
	/***/ },
	/* 50 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.1 ToPrimitive(input [, PreferredType])
		var isObject = __webpack_require__(45);
		// instead of the ES6 spec version, we didn't implement @@toPrimitive case
		// and the second argument - flag - preferred type is a string
		module.exports = function(it, S){
		  if(!isObject(it))return it;
		  var fn, val;
		  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
		  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
		  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
		  throw TypeError("Can't convert object to primitive value");
		};
	
	/***/ },
	/* 51 */
	/***/ function(module, exports) {
	
		module.exports = function(bitmap, value){
		  return {
		    enumerable  : !(bitmap & 1),
		    configurable: !(bitmap & 2),
		    writable    : !(bitmap & 4),
		    value       : value
		  };
		};
	
	/***/ },
	/* 52 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(53), __esModule: true };
	
	/***/ },
	/* 53 */
	/***/ function(module, exports, __webpack_require__) {
	
		var core  = __webpack_require__(39)
		  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
		module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
		  return $JSON.stringify.apply($JSON, arguments);
		};
	
	/***/ },
	/* 54 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _keys = __webpack_require__(17);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _stringify = __webpack_require__(52);
	
		var _stringify2 = _interopRequireDefault(_stringify);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		module.exports = {
		  props: {
		    chartData: {
		      required: true
		    }
		  },
		  watch: {
		    'chartData': {
		      handler: function handler(newData, oldData) {
		        if (oldData) {
		          var chart = this._chart;
	
		          var newDatasetLabels = newData.datasets.map(function (dataset) {
		            return dataset.label;
		          });
	
		          var oldDatasetLabels = oldData.datasets.map(function (dataset) {
		            return dataset.label;
		          });
	
		          var oldLabels = (0, _stringify2.default)(oldDatasetLabels);
		          var newLabels = (0, _stringify2.default)(newDatasetLabels);
	
		          if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
		            newData.datasets.forEach(function (dataset, i) {
		              var oldDatasetKeys = (0, _keys2.default)(oldData.datasets[i]);
		              var newDatasetKeys = (0, _keys2.default)(dataset);
	
		              var deletionKeys = oldDatasetKeys.filter(function (key) {
		                return key !== '_meta' && newDatasetKeys.indexOf(key) === -1;
		              });
	
		              deletionKeys.forEach(function (deletionKey) {
		                delete chart.data.datasets[i][deletionKey];
		              });
	
		              for (var attribute in dataset) {
		                if (dataset.hasOwnProperty(attribute)) {
		                  chart.data.datasets[i][attribute] = dataset[attribute];
		                }
		              }
		            });
	
		            if (newData.hasOwnProperty('labels')) {
		              chart.data.labels = newData.labels;
		            }
		            if (newData.hasOwnProperty('xLabels')) {
		              chart.data.xLabels = newData.xLabels;
		            }
		            if (newData.hasOwnProperty('yLabels')) {
		              chart.data.yLabels = newData.yLabels;
		            }
		            chart.update();
		          } else {
		            chart.destroy();
		            this.renderChart(this.chartData, this.options);
		          }
		        } else {
		          this.renderChart(this.chartData, this.options);
		        }
		      }
		    }
		  }
		};
	
	/***/ },
	/* 55 */
	/***/ function(module, exports) {
	
		module.exports = {
			"name": "vue-chartjs",
			"version": "2.8.7",
			"description": "Vue.js wrapper for chart.js for creating beautiful charts.",
			"author": "Jakub Juszczak <jakub@posteo.de>",
			"homepage": "http://vue-chartjs.org",
			"license": "MIT",
			"contributors": [
				{
					"name": "Thorsten Lünborg",
					"web": "https://github.com/LinusBorg"
				},
				{
					"name": "Juan Carlos Alonso",
					"web": "https://github.com/jcalonso"
				}
			],
			"maintainers": [
				{
					"name": "Jakub Juszczak",
					"email": "jakub@posteo.de",
					"web": "http://www.jakubjuszczak.de"
				}
			],
			"repository": {
				"type": "git",
				"url": "git+ssh://git@github.com:apertureless/vue-chartjs.git"
			},
			"bugs": {
				"url": "https://github.com/apertureless/vue-chartjs/issues"
			},
			"keywords": [
				"ChartJs",
				"Vue",
				"Visualisation",
				"Wrapper",
				"Charts"
			],
			"main": "dist/vue-chartjs.js",
			"unpkg": "dist/vue-chartjs.full.min.js",
			"module": "es/index.js",
			"jsnext:main": "es/index.js",
			"files": [
				"src",
				"dist",
				"es"
			],
			"scripts": {
				"dev": "node build/dev-server.js",
				"build": "yarn run release && yarn run build:es",
				"build:es": "cross-env BABEL_ENV=es babel src --out-dir es",
				"unit": "karma start test/unit/karma.conf.js --single-run",
				"e2e": "node test/e2e/runner.js",
				"test": "npm run unit",
				"lint": "eslint --ext .js,.vue src test/unit/specs test/e2e/specs",
				"release": "webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js",
				"prepublish": "yarn run lint && yarn run test && yarn run build"
			},
			"dependencies": {
				"lodash.merge": "^4.6.0"
			},
			"peerDependencies": {
				"chart.js": "^2.7.0",
				"vue": "^2.4.4"
			},
			"devDependencies": {
				"babel-cli": "^6.24.1",
				"babel-core": "^6.25.0",
				"babel-loader": "^7.0.0",
				"babel-plugin-transform-object-assign": "^6.22.0",
				"babel-plugin-transform-runtime": "^6.23.0",
				"babel-preset-es2015": "^6.24.1",
				"babel-preset-stage-2": "^6.24.1",
				"babel-runtime": "^6.23.0",
				"chai": "^3.5.0",
				"chart.js": "^2.7.0",
				"chromedriver": "^2.28.0",
				"connect-history-api-fallback": "^1.1.0",
				"cross-env": "^3.2.4",
				"cross-spawn": "^5.1.0",
				"css-loader": "^0.28.0",
				"eslint": "^3.19.0",
				"eslint-config-standard": "^10.2.1",
				"eslint-friendly-formatter": "^2.0.7",
				"eslint-loader": "^1.7.1",
				"eslint-plugin-html": "^2.0.1",
				"eslint-plugin-import": "^2.2.0",
				"eslint-plugin-node": "^4.2.2",
				"eslint-plugin-promise": "^3.5.0",
				"eslint-plugin-standard": "^3.0.1",
				"eventsource-polyfill": "^0.9.6",
				"express": "^4.15.2",
				"extract-text-webpack-plugin": "^1.0.1",
				"file-loader": "^0.10.1",
				"function-bind": "^1.0.2",
				"html-webpack-plugin": "^2.28.0",
				"http-proxy-middleware": "^0.17.4",
				"inject-loader": "^3.0.0",
				"isparta-loader": "^2.0.0",
				"jasmine-core": "^2.5.2",
				"json-loader": "^0.5.4",
				"karma": "^1.5.0",
				"karma-coverage": "^1.1.1",
				"karma-jasmine": "^1.0.2",
				"karma-mocha": "^1.2.0",
				"karma-phantomjs-launcher": "^1.0.4",
				"karma-sinon-chai": "^1.2.0",
				"karma-sourcemap-loader": "^0.3.7",
				"karma-spec-reporter": "0.0.30",
				"karma-webpack": "1.8.1",
				"lolex": "^1.6.0",
				"mocha": "^3.1.0",
				"nightwatch": "^0.9.14",
				"ora": "^1.2.0",
				"phantomjs-prebuilt": "^2.1.13",
				"selenium-server": "^3.3.1",
				"shelljs": "^0.7.7",
				"sinon": "^2.1.0",
				"sinon-chai": "^2.9.0",
				"url-loader": "^0.5.8",
				"vue": "^2.4.4",
				"vue-hot-reload-api": "^2.1.0",
				"vue-html-loader": "^1.2.4",
				"vue-loader": "^12.2.2",
				"vue-style-loader": "^3.0.1",
				"vue-template-compiler": "^2.4.2",
				"webpack": "^1.13.2",
				"webpack-dev-middleware": "^1.10.1",
				"webpack-hot-middleware": "^2.17.1",
				"webpack-merge": "1.1.1"
			},
			"engines": {
				"node": ">=6.9.0"
			},
			"babel": {
				"presets": [
					"es2015"
				]
			},
			"browserify": {
				"transform": [
					"babelify"
				]
			},
			"greenkeeper": {
				"ignore": [
					"extract-text-webpack-plugin",
					"karma-webpack",
					"webpack",
					"webpack-merge"
				]
			}
		};
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["vue-filter"] = factory();
		else
			root["vue-filter"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 8);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*eslint no-console: ["error", { allow: ["warn", "error"] }] */
	
	var _ = __webpack_require__(0);
	var util = {};
	
	var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	util.isArrayLike = function (obj) {
	    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || !obj) {
	        return false;
	    }
	    var length = obj.length;
	    return typeof length === 'number' && length % 1 === 0 && length >= 0 && length <= MAX_ARRAY_INDEX;
	};
	
	util.get = function (obj, accessor) {
	    var ret = undefined;
	    if (!_.isObject(obj)) {
	        return obj;
	    }
	    if (accessor == undefined) {
	        return obj;
	    }
	    if (_.isString(accessor)) {
	        accessor = accessor.split('.');
	        ret = obj;
	        try {
	            for (var i = 0; i < accessor.length; i++) {
	                ret = ret[accessor[i]];
	            }
	        } catch (e) {
	            ret = undefined;
	        }
	    } else if (_.isFunction(accessor)) {
	        ret = accessor(obj);
	    }
	    return ret;
	};
	
	util.deprecated = function (filter, msg) {
	    console.warn('[filter - ' + filter + ']:this filter has deprecated, it will be remove at next minor version. ' + msg);
	};
	
	util.type = function (filter, input, type) {
	    console.warn('[filter - ' + filter + ']: expect input type is :' + type + 'but got ' + (typeof input === 'undefined' ? 'undefined' : _typeof(input)));
	};
	
	module.exports = util;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var collection = __webpack_require__(5);
	var math = __webpack_require__(10);
	var string = __webpack_require__(22);
	var other = __webpack_require__(19);
	var number = __webpack_require__(15);
	var _ = __webpack_require__(0);
	
	var filters = {};
	
	['map', 'reduce', 'find', 'filter', 'reject', 'every', 'some', 'contains', 'pluck', 'max', 'min', 'sortBy', 'groupBy', 'indexBy', 'countBy', 'shuffle', 'sample', 'toArray', 'size', 'first', 'initial', 'last', 'rest', 'flatten', 'without', 'union', 'intersection', 'difference', 'uniq', 'keys', 'allKeys', 'values', 'pairs', 'invert', 'extend', 'pick', 'omit', 'defaults', 'has', 'escape', 'unescape', 'result', 'nl2br'].forEach(function (key) {
	    filters[key] = _[key];
	});
	
	filters = _.extend(filters, collection, string, math, number, other);
	
	module.exports = filters;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	/**
	 * @filter at
	 * @description Return the item at the specified index in an array or a string.
	 * @example
	 * ```
	 * {{ ['a','b','c'] | at(1) }} => 'b'
	 * {{ 'hello' | at(0) }} => 'h'
	 * {{ 'js' | at(10) }} => undefined
	 * ```
	 */
	
	function at(collection, index) {
	    if (_.isArray(collection) || _.isString(collection)) {
	        index = Number(index);
	        return collection[index];
	    }
	    return undefined;
	}
	
	module.exports = at;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	var util = __webpack_require__(1);
	
	var base = {};
	
	/**
	 * @filter push, pop, shift, unshift
	 * @description return a new array with those native array method. notice: those filter won't change origin array.
	 * @example
	 * ```
	 * {{ [1,2,3] | push(4) }}  => [1,2,3,4]
	 * {{ [1,2,3,4] | shift }}  => [2,3,4]
	 * ```
	 */
	['push', 'pop', 'shift', 'unshift'].forEach(function (method) {
	    base[method] = function (collection) {
	        if (util.isArrayLike(collection)) {
	            collection = _.toArray(collection);
	        }
	        if (_.isArray(collection)) {
	            collection[method].apply(collection, _.rest(arguments));
	            return collection;
	        } else {
	            util.type(collection, 'array');
	            return collection;
	        }
	    };
	});
	
	/**
	 * @filter slice, indexOf, concat, join
	 * @description the same way with native array method.
	 * @example
	 * ```
	 * {{ [1,2,3] | indexOf(2) }}  => 1
	 * {{ [1,2] | concat([3,4]) }}  => [1,2,3,4]
	 * {{ [1,2,3] | join('-) }} => '1-2-3'
	 * {{ [1,2,3] | slice(1) }} => [2,3]
	 * ```
	 */
	['slice', 'indexOf', 'concat', 'join'].forEach(function (method) {
	    base[method] = function (collection) {
	        if (!_.isArray(collection)) {
	            collection = _.toArray(collection);
	        }
	        return collection[method].apply(collection, _.rest(arguments));
	    };
	});
	
	module.exports = base;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var base = __webpack_require__(4);
	var at = __webpack_require__(3);
	var reverse = __webpack_require__(7);
	var range = __webpack_require__(6);
	var _ = __webpack_require__(0);
	
	module.exports = _.extend({
	    at: at,
	    reverse: reverse,
	    range: range
	}, base);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var util = __webpack_require__(1);
	var _ = __webpack_require__(0);
	/**
	 *  Return a new collection from a given length
	 *
	 *  {{ [] | range 4 }} => [0,1,2,3]
	 */
	
	function range(arr, n) {
	  util.deprecated('range', 'Because range is use to generate an array, it doesn\'t need a input, you can use _.range(n) generate an array directly.');
	  return _.range(n);
	}
	module.exports = range;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	/**
	 * reverse an array or a string
	 *
	 * {{ 'abc' | reverse }} => 'cba'
	 * {{ [1,2,3] | reverse }} => [3,2,1]
	 */
	
	function reverse(collection) {
	    if (typeof collection === 'string') {
	        return collection.split('').reverse().join('');
	    }
	    if (_.isArray(collection)) {
	        return collection.concat().reverse();
	    }
	    return collection;
	}
	
	module.exports = reverse;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/*eslint no-console: ["error", { allow: ["warn", "error"] }] */
	
	var filters = __webpack_require__(2);
	var _ = __webpack_require__(0);
	
	function install(Vue) {
	    _.each(filters, function (value, key) {
	        if (Vue.filter(key)) {
	            console.warn('[filter duplication]: A filter named ' + key + 'has already been installed.');
	        } else {
	            Vue.filter(key, value);
	        }
	    });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	    Vue.use(install);
	}
	
	module.exports = install;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * 
	 * @description all the method in Math without random
	 * @example
	 * ```
	 * {{ -1.2 | abs }}  => 1.2
	 * {{ 1 | acos }}  => 0
	 * {{ 1.3 | ceil }} => 2
	 * {{ 3 | pow(2) }} => 9  i.e: Math.pow(3,2)
	 * ```
	 */
	
	var base = {};
	
	['abs', 'acos', 'asin', 'atan', 'atan2', 'ceil', 'cos', 'exp', 'floor', 'log', 'pow', 'round', 'sin', 'sqrt', 'tan'].forEach(function (method) {
	    base[method] = function (value, n) {
	        if (typeof value === 'number') {
	            return Math[method](value, n);
	        } else {
	            return value;
	        }
	    };
	});
	
	module.exports = base;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var base = __webpack_require__(9);
	var operator = __webpack_require__(12);
	
	var sum = __webpack_require__(13);
	var mean = __webpack_require__(11);
	
	var _ = __webpack_require__(0);
	
	module.exports = _.extend({
	    sum: sum,
	    mean: mean
	}, operator, base);
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	
	/**
	 * @param {array} arr - The array to iterate over.
	 * @description Returns the mean.
	 * @example
	 * ```
	 * {{ [1,2,3,4] | mean }} => 2.5
	 * ```
	 */
	
	function mean(arr) {
	    if (_.isArray(arr)) {
	        var sum = arr.reduce(function (prev, curr) {
	            return prev + curr;
	        }, 0);
	
	        var len = arr.length;
	        if (_.isNumber(sum) && len != 0) {
	            return sum / len;
	        } else {
	            return 0;
	        }
	    } else {
	        return arr;
	    }
	}
	
	module.exports = mean;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/*eslint no-console: ["error", { allow: ["warn", "error"] }] */
	
	/**
	 *
	 * @filter divide, minus, plus, multiply, mod, or, xor, and, not
	 * @description some math operator.
	 * @example
	 * ```
	 * {{ 10 | plus(1) }} => 11
	 * {{ 2 | or(1) }} => 3
	 * {{ 255 | not() }} => -256
	 * ```
	 */
	var operator = {};
	
	['divide', 'minus', 'plus', 'multiply', 'mod'].forEach(function (method) {
	    operator[method] = function (a, b) {
	        a = Number(a);
	        b = Number(b);
	
	        switch (method) {
	            case 'divide':
	                if (b === 0) {
	                    console.error('0 can\'t as a divisor');
	                }
	                return a / b;
	            case 'minus':
	                return a - b;
	            case 'plus':
	                return a + b;
	            case 'multiply':
	                return a * b;
	            case 'mod':
	                return a % b;
	            // case 'or':
	            //     return a | b;
	            // case 'xor':
	            //     return a ^ b;
	            // case 'and':
	            //     return a & b;
	        }
	    };
	});
	
	module.exports = operator;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	/**
	 * 
	 * @param {Array} list - the array to be summed.
	 * @param {number} base - base value(default 0).
	 * @return {number} Returns the sum.
	 * @example
	 * ```
	 * {{ [1,2,3,4] | sum }} => 10
	 * {{ [1,2,3,4] | sum 20 }} => 30
	 * ```
	 */
	
	function sum(list, base) {
	
	    if (!_.isArray(list)) {
	        return Number(list);
	    }
	
	    var ret = base || 0;
	    for (var i = 0; i < list.length; i++) {
	        var val = list[i];
	        if (_.isNumber(val)) {
	            ret = ret + val;
	        } else {
	            return NaN;
	        }
	    }
	    return ret;
	}
	module.exports = sum;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ = __webpack_require__(0);
	var util = __webpack_require__(1);
	
	var base = {};
	
	['toFixed', 'toPrecision'].forEach(function (method) {
	    base[method] = function (num) {
	        var type = typeof num === 'undefined' ? 'undefined' : _typeof(num);
	        if (type === 'number') {
	            return Number.prototype[method].apply(num, _.rest(arguments));
	        } else {
	            util.type(num, 'number');
	            return num;
	        }
	    };
	});
	
	module.exports = base;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var base = __webpack_require__(14);
	
	module.exports = base;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	Converts a timestamp into another date format.
	
	```html
	{{ Date.now() | date '%T' }}  => '13:34:36'
	{{ 'Wed Jan 20 2016 13:34:36 GMT+0800' | date '%T' }} => '13:34:36'
	{{ 1453268193752 | date '%Y-%m-%d' }} => '2016-01-20'
	{{ new Date | date '%I:%M:%s %p' }} => '1:39:22 PM'
	```
	
	**more date parameters are listed below:**
	
	
	| param | explanation | example |
	|:--:|:--|:--|
	|%a | Abbreviated weekday. |`{{ timestamp | date "%a" }} => "Sat" `|
	|%A |Full weekday name. |`{{ timestamp | date "%A" }} => "Tuesday" `|
	|%b |Abbreviated month name. |`{{ timestamp | date "%b" }} => "Jan" `|
	|%B |Full month name |`{{ timestamp | date "%B" }} => "January" `|
	|%c |Preferred local date and time representation |`{{ timestamp | date "%c" }} => "Tue Apr 22 11:16:09 2014" `|
	|%d |Day of the month, zero-padded (01, 02, 03, etc.). |`{{ timestamp | date "%d" }} => "04" `|
	%-d |Day of the month, not zero-padded (1,2,3, etc.). |`{{ timestamp | date "%-d" }} => "4" `|
	|%D |Formats the date (dd/mm/yy). |`{{ timestamp | date "%D" }} => "04/22/14" `|
	|%e |Day of the month, blank-padded ( 1, 2, 3, etc.). |`{{ timestamp | date "%e" }} => "3" `|
	|%F |Returns the date in ISO 8601 format (yyyy-mm-dd). |`{{ timestamp | date "%F" }} => "2014-04-22" `|
	|%H |Hour of the day, 24-hour clock (00 - 23). |`{{ timestamp | date "%H" }} => "15" `|
	|%I |Hour of the day, 12-hour clock (1 - 12). |`{{ timestamp | date "%I" }} => "7" `|
	|%j |Day of the year (001 - 366). |`{{ timestamp | date "%j" }} => "245" `|
	|%k |Hour of the day, 24-hour clock (1 - 24). |`{{ timestamp | date "%k" }} => "14" `|
	|%m |Month of the year (01 - 12). |`{{ timestamp | date "%m" }} => "04" `|
	|%M |Minute of the hour (00 - 59). |`{{ timestamp | date "%M" }} => "53" `|
	|%p |Meridian indicator (AM/PM). |`{{ timestamp | date "%p" }} => "PM" `|
	|%r |12-hour time (%I:%M:%S %p) |`{{ timestamp | date "%r" }} => "03:20:07 PM" `|
	|%R |24-hour time (%H:%M) |`{{ timestamp | date "%R" }} => "15:21" `|
	|%T |24-hour time (%H:%M:%S) |`{{ timestamp | date "%T" }} => "15:22:13" `|
	|%U |The number of the week in the current year, starting with the first Sunday as the first day of the first week. |`{{ timestamp | date "%U" }} => "16" `|
	|%W |The number of the week in the current year, starting with the first Monday as the first day of the first week. |`{{ timestamp | date "%W" }} => "16" `|
	|%w |Day of the week (0 - 6, with Sunday being 0). |`{{ timestamp | date "%w" }} => "2" `|
	|%x |Preferred representation for the date alone, no time. (mm/dd/yy). |`{{ timestamp | date "%x" }} => "04/22/14" `|
	|%X |Preferred representation for the time. (hh:mm:ss). |`{{ timestamp | date "%X" }} => "13:17:24" `|
	|%y |Year without a century (00.99). |`{{ timestamp | date "%y" }} => "14" `|
	|%Y |Year with a century. |`{{ timestamp | date "%Y" }} => "2014" `|
	
	 */
	var weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function date(date, formatString) {
	    var d = new Date(date);
	    var hours = 0;
	    var month = 0;
	
	    var zeroize = function zeroize(value, length) {
	
	        if (!length) length = 2;
	
	        value = '' + value;
	
	        for (var i = 0, zeros = ''; i < length - value.length; i++) {
	            zeros += '0';
	        }
	
	        return zeros + value;
	    };
	
	    function getDays() {
	        var days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	            year = d.getFullYear(),
	            month = d.getMonth(),
	            day = d.getDate();
	
	        if (year % 100 == 0 && year % 400 == 0 || year % 4 == 0) {
	            days[1] = 29;
	        }
	        var n = 0;
	        for (var i = 0; i < month; i++) {
	            n += days[i];
	        }
	        return n + day;
	    }
	
	    function cb(c) {
	        var ret = '';
	        switch (c) {
	            case '%a':
	                ret = weekdays[d.getDay()].slice(0, 3);
	                break;
	            case '%A':
	                ret = weekdays[d.getDay()];
	                break;
	            case '%b':
	                ret = months[d.getMonth()].slice(0, 3);
	                break;
	            case '%B':
	                ret = months[d.getMonth()];
	                break;
	            case '%c':
	                ret = d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
	                break;
	            case '%d':
	                var day = d.getDate();
	                ret = zeroize(day);
	                break;
	            case '%-d':
	                ret = d.getDate();
	                break;
	            case '%D':
	                ret = '%m/%d/%Y';
	                break;
	            case '%e':
	                ret = d.getDate();
	                break;
	            case '%F':
	                ret = '%Y-%m-%d';
	                break;
	            case '%H':
	                hours = d.getHours();
	                ret = zeroize(hours);
	                break;
	            case '%I':
	                hours = d.getHours();
	                if (hours != 12) {
	                    hours = hours % 12;
	                }
	                ret = zeroize(hours);
	                break;
	            case '%j':
	                ret = zeroize(getDays(), 3);
	                break;
	            case 'k':
	                ret = d.getHours();
	                break;
	            case '%m':
	                month = d.getMonth() + 1;
	                ret = zeroize(month, 2);
	                break;
	            case '%M':
	                ret = zeroize(d.getMinutes(), 2);
	                break;
	            case '%s':
	                ret = zeroize(d.getSeconds(), 2);
	                break;
	            case '%p':
	                ret = d.getHours() < 12 ? 'AM' : 'PM';
	                break;
	            case '%r':
	                ret = '%I:%M:%s %p';
	                break;
	            case '%R':
	                ret = '%H:%M';
	                break;
	            case '%T':
	                ret = '%H:%M:%s';
	                break;
	            case '%U':
	                ret = Math.ceil(getDays() / 7);
	                break;
	            case '%w':
	                ret = d.getDay();
	                break;
	            case '%x':
	                ret = '%m/%d/%y';
	                break;
	            case '%X':
	                ret = '%H:%M:%s';
	                break;
	            case '%y':
	                ret = d.getFullYear() % 100;
	                break;
	            case '%Y':
	                ret = d.getFullYear();
	                break;
	            default:
	                ret = c;
	        }
	        return ret;
	    }
	    var re = /%-?[\w]/g;
	    if (!formatString) {
	        formatString = '%c';
	    }
	    formatString = formatString.replace(re, cb);
	    formatString = formatString.replace(re, cb);
	    return formatString;
	}
	
	module.exports = date;
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	
	/**
	 * debounce a function, the default dalay is 300ms
	 * 
	 * {{ func | debounce(300) }}
	 */
	
	function debounce(handler, delay) {
	    if (!handler) {
	        return;
	    }
	    if (!delay) {
	        delay = 300;
	    }
	    return _.debounce(handler, delay);
	}
	module.exports = debounce;
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var util = __webpack_require__(1);
	
	/**
	 * Get a property inside an Object
	 * 
	 * james = {
	 *     contact:{
	 *         tel: 187xxxx0001
	 *     }
	 * }
	 * {{ james | get 'contact.tel' }} => 187xxxx0001
	 */
	
	function get(obj, accessor) {
	  return util.get(obj, accessor);
	}
	
	module.exports = get;
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var date = __webpack_require__(16);
	var get = __webpack_require__(18);
	var debounce = __webpack_require__(17);
	
	module.exports = {
	    date: date,
	    debounce: debounce,
	    get: get
	};
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Appends characters to a string.
	 *
	 * {{ 'sky' | append '.jpg' }} => 'sky.jpg'
	 */
	
	function append(str, postfix) {
	    if (!str && str !== 0) {
	        str = '';
	    } else {
	        str = str.toString();
	    }
	    return str + postfix;
	}
	
	module.exports = append;
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ = __webpack_require__(0);
	var util = __webpack_require__(1);
	
	/**
	 *
	 * @description some native method in string
	 * @example
	 * ```
	 * {{ 'ab-cd' | replace('-', '') }}  => 'abcd'
	 * {{ 'a-b-c' | split('-') }}  => ['a','b','c']
	 * {{ 'javascript' | substr(0, 4) }} => 'java'
	 * {{ 'javascript' | substring(0,2) }} => 'jav'
	 * ```
	 */
	
	var base = {};
	
	['replace', 'split', 'substr', 'substring'].forEach(function (method) {
	    base[method] = function (str) {
	        var type = typeof str === 'undefined' ? 'undefined' : _typeof(str);
	        if (type === 'string') {
	            return String.prototype[method].apply(str, _.rest(arguments));
	        } else {
	            util.type(method, str, 'string'.substring);
	            return str;
	        }
	    };
	});
	
	module.exports = base;
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var append = __webpack_require__(20);
	var prepend = __webpack_require__(24);
	var remove = __webpack_require__(25);
	var base = __webpack_require__(21);
	var test = __webpack_require__(27);
	var trimx = __webpack_require__(28);
	var truncate = __webpack_require__(29);
	var xpad = __webpack_require__(31);
	var repeat = __webpack_require__(26);
	var xcase = __webpack_require__(30);
	var nl2br = __webpack_require__(23);
	var _ = __webpack_require__(0);
	
	module.exports = _.extend({
	    append: append,
	    prepend: prepend,
	    remove: remove, // enhance
	    test: test,
	    truncate: truncate,
	    repeat: repeat,
	    nl2br: nl2br
	}, base, xcase, xpad, trimx);
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Replaces new line to br tag based on regex /\r\n/g -> this can be overwritten by passing
	 * your own regex as second param.
	 *
	 * returns a single sting best printed as raw html.
	 *
	 * Vue 1.0  <p> {{{ text | nl2br }}} </p>
	 *
	 * Vue 2.0  <p v-html="$options.filters.nl2br(text)"></p>
	 * NOTE: v-html does not support the piped filter syntax so directly access the filter function.
	 */
	
	function nl2br(text) {
	  var reg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\n\r/g;
	
	  if (text && text !== null) {
	    var i = void 0,
	        s = '',
	        lines = text.split(reg),
	        l = lines.length;
	
	    for (i = 0; i < l; ++i) {
	      s += lines[i];
	      i !== l - 1 && (s += '<br/>');
	    }
	
	    return s;
	  }
	  return text;
	}
	
	module.exports = nl2br;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Prepends characters to a string.
	 *
	 * {{ 'world' | prepend 'hello ' }} => 'hello world'
	 */
	
	function prepend(str, prefix) {
	    if (!str && str !== 0) {
	        str = '';
	    } else {
	        str = str.toString();
	    }
	    return prefix + str;
	}
	
	module.exports = prepend;
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	var util = __webpack_require__(1);
	/**
	 * @description Removes all occurrences of a substring from a string.
	 * @example
	 * ```
	 * {{ 'Hello JavaScript' | remove 'Hello' }} => ' JavaScript'
	 * ```
	 */
	
	function remove(str, substr) {
	    util.deprecated('remove', 'You can use `replace(substr, \'\')` instead of remove');
	    if (_.isString(str)) {
	        str = str.split(substr).join('');
	    }
	    return str;
	}
	
	module.exports = remove;
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * @description return a string which build by repeat the given str n times.
	 *
	 * {{ 'abc' | repeat 3 }} => 'abcabcabc'
	 */
	
	function repeat(str, n) {
	    n = n ? Number(n) : 0;
	    if (n != n) {
	        // NAN
	        n = 0;
	    }
	
	    n = Math.floor(n);
	
	    if (n <= -1) {
	        n = 0;
	    }
	
	    str = '' + str;
	
	    var ret = '';
	    while (n !== 0) {
	        if (n & 1 === 1) {
	            ret += str;
	        }
	        str += str;
	        n >>>= 1;
	    }
	    return ret;
	}
	
	module.exports = repeat;
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Test if a string match a pattern
	 *
	 * {{ "http://vuejs.org" | test /^http/ }} => true
	 */
	
	function test(str, re, flag) {
	  re = new RegExp(re, flag);
	  return re.test(str);
	}
	
	module.exports = test;
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var util = __webpack_require__(1);
	var _ = __webpack_require__(0);
	/**
	 * Strips tabs, spaces, and newlines (all whitespace)
	 * from the left or right or both side of a string.
	 * which depends on second argument. if it is 'r' will only
	 * trim right side,if it is 'l' will only trim left side
	 * otherwise trim both left and right side.
	 *
	 * {{ '   some spaces   ' | trim }} => 'some spaces'
	 * {{ '   some spaces   ' | trimRight }} => '   some spaces'
	 * {{ '   some spaces   ' | trimLeft }} => 'some spaces   '
	 */
	
	function _trim(str, re) {
	    if (_.isString(str)) {
	        return str.replace(re, '');
	    } else {
	        util.type('trim', str, 'string');
	        return str;
	    }
	}
	
	function trim(str) {
	    return _trim(str, /^\s+|\s+$/g);
	}
	
	function trimLeft(str) {
	    return _trim(str, /^\s+/);
	}
	
	function trimRight(str) {
	    return _trim(str, /\s+$/);
	}
	
	module.exports = {
	    trim: trim,
	    trimLeft: trimLeft,
	    trimRight: trimRight
	};
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * @description truncate text to a specified length.
	 * **notice: the length donot include the length of ellipses string, 
	 * this mean the origin string will but cat to specific length and then append the ellipses string**
	 * the default length is 30, default ellipses string is `'...'`
	 * @example
	 * ```
	 * {{ 'this is a big city!' | truncate(12) }} => 'this is a bi...`
	 * {{ 'this is a big city!' | truncate(12, '~~~') }} => 'this is a bi~~~`
	 * ```
	 */
	
	function truncate(str, length, ellipses) {
	    length = length || 30;
	
	    if (str.length <= length) {
	        return str;
	    }
	
	    if (ellipses === undefined) {
	        ellipses = '...';
	    }
	    ellipses = '' + ellipses;
	
	    str = str.slice(0, length);
	
	    return str + ellipses;
	}
	
	module.exports = truncate;
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * @description Uppercase a string
	 * @example
	 * ```
	 * {{ 'abC' | uppercase }} => 'ABC'
	 * ```
	 */
	function uppercase(value) {
	    return value || value === 0 ? value.toString().toUpperCase() : '';
	}
	
	/**
	 * @description Lowercase a string
	 * @example
	 * ```
	 * {{ 'abC' | uppercase }} => 'ABC'
	 * ```
	 */
	function lowercase(value) {
	    return value || value === 0 ? value.toString().toLowerCase() : '';
	}
	
	/**
	 * @description Converts a string into CamelCase.
	 * @example
	 * ```
	 * {{ 'some_else' | camelcase }} => 'SomeElse'
	 * {{ 'some-else' | camelcase }} => 'SomeElse'
	 * ```
	 */
	function camelcase(str) {
	    var re = /(?:^|[-_\/])(\w)/g;
	    return str.toString().replace(re, function (_, c) {
	        return c.toUpperCase();
	    });
	}
	
	module.exports = {
	    uppercase: uppercase,
	    lowercase: lowercase,
	    camelcase: camelcase
	};
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * return a string by repeat a char n times
	 */
	
	function padding(size, ch) {
	    var str = '';
	    if (!ch && ch !== 0) {
	        ch = ' ';
	    }
	    while (size !== 0) {
	        if (size & 1 === 1) {
	            str += ch;
	        }
	        ch += ch;
	        size >>>= 1;
	    }
	    return str;
	}
	
	/**
	 * @description leftPad
	 * @example
	 * ```
	 * {{ 'abc' | leftPad(5, '*') }} => '**abc'
	 * ```
	 */
	function leftPad(str, size, ch) {
	    size = +size || 0;
	    var padLength = size - str.length;
	    if (padLength <= 0) {
	        return str;
	    }
	    return padding(padLength, ch).concat(str);
	}
	
	/**
	 * @description rightPad
	 * ```
	 * {{ 'abc' | leftPad(5, '*') }} => 'abc**'
	 * ```
	 */
	function rightPad(str, size, ch) {
	    size = +size || 0;
	    var padLength = size - str.length;
	    if (padLength <= 0) {
	        return str;
	    }
	    return str.concat(padding(padLength, ch));
	}
	
	module.exports = {
	    leftPad: leftPad,
	    rightPad: rightPad
	};
	
	/***/ })
	/******/ ]);
	});

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ "01f9":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var LIBRARY = __webpack_require__("2d00");
	var $export = __webpack_require__("5ca1");
	var redefine = __webpack_require__("2aba");
	var hide = __webpack_require__("32e9");
	var Iterators = __webpack_require__("84f2");
	var $iterCreate = __webpack_require__("41a0");
	var setToStringTag = __webpack_require__("7f20");
	var getPrototypeOf = __webpack_require__("38fd");
	var ITERATOR = __webpack_require__("2b4c")('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};
	
	
	/***/ }),
	
	/***/ "02f4":
	/***/ (function(module, exports, __webpack_require__) {
	
	var toInteger = __webpack_require__("4588");
	var defined = __webpack_require__("be13");
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};
	
	
	/***/ }),
	
	/***/ "0390":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var at = __webpack_require__("02f4")(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};
	
	
	/***/ }),
	
	/***/ "07e3":
	/***/ (function(module, exports) {
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	
	/***/ }),
	
	/***/ "0bfb":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__("cb7c");
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};
	
	
	/***/ }),
	
	/***/ "0d58":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__("ce10");
	var enumBugKeys = __webpack_require__("e11e");
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};
	
	
	/***/ }),
	
	/***/ "1156":
	/***/ (function(module, exports, __webpack_require__) {
	
	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("ad20");
	if(typeof content === 'string') content = [[module.i, content, '']];
	if(content.locals) module.exports = content.locals;
	// add the styles to the DOM
	var add = __webpack_require__("499e").default
	var update = add("c1ec597e", content, true, {"sourceMap":false,"shadowMode":false});
	
	/***/ }),
	
	/***/ "11e9":
	/***/ (function(module, exports, __webpack_require__) {
	
	var pIE = __webpack_require__("52a7");
	var createDesc = __webpack_require__("4630");
	var toIObject = __webpack_require__("6821");
	var toPrimitive = __webpack_require__("6a99");
	var has = __webpack_require__("69a8");
	var IE8_DOM_DEFINE = __webpack_require__("c69a");
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__("9e1e") ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};
	
	
	/***/ }),
	
	/***/ "1495":
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__("86cc");
	var anObject = __webpack_require__("cb7c");
	var getKeys = __webpack_require__("0d58");
	
	module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};
	
	
	/***/ }),
	
	/***/ "18d2":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Resize detection strategy that injects objects to elements in order to detect resize events.
	 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
	 */
	
	
	
	var browserDetector = __webpack_require__("18e9");
	
	module.exports = function(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var batchProcessor  = options.batchProcessor;
	    var getState        = options.stateHandler.getState;
	
	    if(!reporter) {
	        throw new Error("Missing required dependency: reporter.");
	    }
	
	    /**
	     * Adds a resize event listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
	     */
	    function addListener(element, listener) {
	        if(!getObject(element)) {
	            throw new Error("Element is not detectable by this strategy.");
	        }
	
	        function listenerProxy() {
	            listener(element);
	        }
	
	        if(browserDetector.isIE(8)) {
	            //IE 8 does not support object, but supports the resize event directly on elements.
	            getState(element).object = {
	                proxy: listenerProxy
	            };
	            element.attachEvent("onresize", listenerProxy);
	        } else {
	            var object = getObject(element);
	            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
	        }
	    }
	
	    /**
	     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
	     * @private
	     * @param {object} options Optional options object.
	     * @param {element} element The element to make detectable
	     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
	     */
	    function makeDetectable(options, element, callback) {
	        if (!callback) {
	            callback = element;
	            element = options;
	            options = null;
	        }
	
	        options = options || {};
	        var debug = options.debug;
	
	        function injectObject(element, callback) {
	            var OBJECT_STYLE = "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; padding: 0; margin: 0; opacity: 0; z-index: -1000; pointer-events: none;";
	
	            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.
	
	            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
	            var positionCheckPerformed = false;
	
	            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
	            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
	            var style = window.getComputedStyle(element);
	            var width = element.offsetWidth;
	            var height = element.offsetHeight;
	
	            getState(element).startSize = {
	                width: width,
	                height: height
	            };
	
	            function mutateDom() {
	                function alterPositionStyles() {
	                    if(style.position === "static") {
	                        element.style.position = "relative";
	
	                        var removeRelativeStyles = function(reporter, element, style, property) {
	                            function getNumericalValue(value) {
	                                return value.replace(/[^-\d\.]/g, "");
	                            }
	
	                            var value = style[property];
	
	                            if(value !== "auto" && getNumericalValue(value) !== "0") {
	                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
	                                element.style[property] = 0;
	                            }
	                        };
	
	                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
	                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
	                        removeRelativeStyles(reporter, element, style, "top");
	                        removeRelativeStyles(reporter, element, style, "right");
	                        removeRelativeStyles(reporter, element, style, "bottom");
	                        removeRelativeStyles(reporter, element, style, "left");
	                    }
	                }
	
	                function onObjectLoad() {
	                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
	                    if (!positionCheckPerformed) {
	                        alterPositionStyles();
	                    }
	
	                    /*jshint validthis: true */
	
	                    function getDocument(element, callback) {
	                        //Opera 12 seem to call the object.onload before the actual document has been created.
	                        //So if it is not present, poll it with an timeout until it is present.
	                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
	                        if(!element.contentDocument) {
	                            setTimeout(function checkForObjectDocument() {
	                                getDocument(element, callback);
	                            }, 100);
	
	                            return;
	                        }
	
	                        callback(element.contentDocument);
	                    }
	
	                    //Mutating the object element here seems to fire another load event.
	                    //Mutating the inner document of the object element is fine though.
	                    var objectElement = this;
	
	                    //Create the style element to be added to the object.
	                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
	                        //Notify that the element is ready to be listened to.
	                        callback(element);
	                    });
	                }
	
	                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
	                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
	                if (style.position !== "") {
	                    alterPositionStyles(style);
	                    positionCheckPerformed = true;
	                }
	
	                //Add an object element as a child to the target element that will be listened to for resize events.
	                var object = document.createElement("object");
	                object.style.cssText = OBJECT_STYLE;
	                object.tabIndex = -1;
	                object.type = "text/html";
	                object.setAttribute("aria-hidden", "true");
	                object.onload = onObjectLoad;
	
	                //Safari: This must occur before adding the object to the DOM.
	                //IE: Does not like that this happens before, even if it is also added after.
	                if(!browserDetector.isIE()) {
	                    object.data = "about:blank";
	                }
	
	                element.appendChild(object);
	                getState(element).object = object;
	
	                //IE: This must occur after adding the object to the DOM.
	                if(browserDetector.isIE()) {
	                    object.data = "about:blank";
	                }
	            }
	
	            if(batchProcessor) {
	                batchProcessor.add(mutateDom);
	            } else {
	                mutateDom();
	            }
	        }
	
	        if(browserDetector.isIE(8)) {
	            //IE 8 does not support objects properly. Luckily they do support the resize event.
	            //So do not inject the object and notify that the element is already ready to be listened to.
	            //The event handler for the resize event is attached in the utils.addListener instead.
	            callback(element);
	        } else {
	            injectObject(element, callback);
	        }
	    }
	
	    /**
	     * Returns the child object of the target element.
	     * @private
	     * @param {element} element The target element.
	     * @returns The object element of the target.
	     */
	    function getObject(element) {
	        return getState(element).object;
	    }
	
	    function uninstall(element) {
	        if(browserDetector.isIE(8)) {
	            element.detachEvent("onresize", getState(element).object.proxy);
	        } else {
	            element.removeChild(getObject(element));
	        }
	        delete getState(element).object;
	    }
	
	    return {
	        makeDetectable: makeDetectable,
	        addListener: addListener,
	        uninstall: uninstall
	    };
	};
	
	
	/***/ }),
	
	/***/ "18e9":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var detector = module.exports = {};
	
	detector.isIE = function(version) {
	    function isAnyIeVersion() {
	        var agent = navigator.userAgent.toLowerCase();
	        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
	    }
	
	    if(!isAnyIeVersion()) {
	        return false;
	    }
	
	    if(!version) {
	        return true;
	    }
	
	    //Shamelessly stolen from https://gist.github.com/padolsey/527683
	    var ieVersion = (function(){
	        var undef,
	            v = 3,
	            div = document.createElement("div"),
	            all = div.getElementsByTagName("i");
	
	        do {
	            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
	        }
	        while (all[0]);
	
	        return v > 4 ? v : undef;
	    }());
	
	    return version === ieVersion;
	};
	
	detector.isLegacyOpera = function() {
	    return !!window.opera;
	};
	
	
	/***/ }),
	
	/***/ "1bc3":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__("f772");
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	
	/***/ }),
	
	/***/ "1ec9":
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__("f772");
	var document = __webpack_require__("e53d").document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};
	
	
	/***/ }),
	
	/***/ "214f":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	__webpack_require__("b0c5");
	var redefine = __webpack_require__("2aba");
	var hide = __webpack_require__("32e9");
	var fails = __webpack_require__("79e5");
	var defined = __webpack_require__("be13");
	var wks = __webpack_require__("2b4c");
	var regexpExec = __webpack_require__("520a");
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};
	
	
	/***/ }),
	
	/***/ "230e":
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__("d3f4");
	var document = __webpack_require__("7726").document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};
	
	
	/***/ }),
	
	/***/ "2350":
	/***/ (function(module, exports) {
	
	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}
	
		if (useSourceMap && typeof btoa === 'function') {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});
	
			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}
	
		return [content].join('\n');
	}
	
	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
		// eslint-disable-next-line no-undef
		var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
		var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	
		return '/*# ' + data + ' */';
	}
	
	
	/***/ }),
	
	/***/ "23c6":
	/***/ (function(module, exports, __webpack_require__) {
	
	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__("2d95");
	var TAG = __webpack_require__("2b4c")('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};
	
	
	/***/ }),
	
	/***/ "2621":
	/***/ (function(module, exports) {
	
	exports.f = Object.getOwnPropertySymbols;
	
	
	/***/ }),
	
	/***/ "294c":
	/***/ (function(module, exports) {
	
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};
	
	
	/***/ }),
	
	/***/ "2aba":
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__("7726");
	var hide = __webpack_require__("32e9");
	var has = __webpack_require__("69a8");
	var SRC = __webpack_require__("ca5a")('src');
	var $toString = __webpack_require__("fa5b");
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__("8378").inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});
	
	
	/***/ }),
	
	/***/ "2aeb":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__("cb7c");
	var dPs = __webpack_require__("1495");
	var enumBugKeys = __webpack_require__("e11e");
	var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__("230e")('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__("fab2").appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};
	
	
	/***/ }),
	
	/***/ "2b4c":
	/***/ (function(module, exports, __webpack_require__) {
	
	var store = __webpack_require__("5537")('wks');
	var uid = __webpack_require__("ca5a");
	var Symbol = __webpack_require__("7726").Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;
	
	
	/***/ }),
	
	/***/ "2cef":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function() {
	    var idCount = 1;
	
	    /**
	     * Generates a new unique id in the context.
	     * @public
	     * @returns {number} A unique id in the context.
	     */
	    function generate() {
	        return idCount++;
	    }
	
	    return {
	        generate: generate
	    };
	};
	
	
	/***/ }),
	
	/***/ "2d00":
	/***/ (function(module, exports) {
	
	module.exports = false;
	
	
	/***/ }),
	
	/***/ "2d95":
	/***/ (function(module, exports) {
	
	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};
	
	
	/***/ }),
	
	/***/ "2f21":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var fails = __webpack_require__("79e5");
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};
	
	
	/***/ }),
	
	/***/ "32e9":
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__("86cc");
	var createDesc = __webpack_require__("4630");
	module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	
	/***/ }),
	
	/***/ "35e8":
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__("d9f6");
	var createDesc = __webpack_require__("aebd");
	module.exports = __webpack_require__("8e60") ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	
	/***/ }),
	
	/***/ "38fd":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__("69a8");
	var toObject = __webpack_require__("4bf8");
	var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};
	
	
	/***/ }),
	
	/***/ "41a0":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var create = __webpack_require__("2aeb");
	var descriptor = __webpack_require__("4630");
	var setToStringTag = __webpack_require__("7f20");
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};
	
	
	/***/ }),
	
	/***/ "454f":
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__("46a7");
	var $Object = __webpack_require__("584a").Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};
	
	
	/***/ }),
	
	/***/ "456d":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__("4bf8");
	var $keys = __webpack_require__("0d58");
	
	__webpack_require__("5eda")('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});
	
	
	/***/ }),
	
	/***/ "4588":
	/***/ (function(module, exports) {
	
	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};
	
	
	/***/ }),
	
	/***/ "4630":
	/***/ (function(module, exports) {
	
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	
	/***/ }),
	
	/***/ "46a7":
	/***/ (function(module, exports, __webpack_require__) {
	
	var $export = __webpack_require__("63b6");
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__("8e60"), 'Object', { defineProperty: __webpack_require__("d9f6").f });
	
	
	/***/ }),
	
	/***/ "4917":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var anObject = __webpack_require__("cb7c");
	var toLength = __webpack_require__("9def");
	var advanceStringIndex = __webpack_require__("0390");
	var regExpExec = __webpack_require__("5f1b");
	
	// @@match logic
	__webpack_require__("214f")('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});
	
	
	/***/ }),
	
	/***/ "499e":
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
	/**
	 * Translates the list format produced by css-loader into something
	 * easier to manipulate.
	 */
	function listToStyles (parentId, list) {
	  var styles = []
	  var newStyles = {}
	  for (var i = 0; i < list.length; i++) {
	    var item = list[i]
	    var id = item[0]
	    var css = item[1]
	    var media = item[2]
	    var sourceMap = item[3]
	    var part = {
	      id: parentId + ':' + i,
	      css: css,
	      media: media,
	      sourceMap: sourceMap
	    }
	    if (!newStyles[id]) {
	      styles.push(newStyles[id] = { id: id, parts: [part] })
	    } else {
	      newStyles[id].parts.push(part)
	    }
	  }
	  return styles
	}
	
	// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return addStylesClient; });
	/*
	  MIT License http://www.opensource.org/licenses/mit-license.php
	  Author Tobias Koppers @sokra
	  Modified by Evan You @yyx990803
	*/
	
	
	
	var hasDocument = typeof document !== 'undefined'
	
	if (false) {
	  if (!hasDocument) {
	    throw new Error(
	    'vue-style-loader cannot be used in a non-browser environment. ' +
	    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
	  ) }
	}
	
	/*
	type StyleObject = {
	  id: number;
	  parts: Array<StyleObjectPart>
	}
	
	type StyleObjectPart = {
	  css: string;
	  media: string;
	  sourceMap: ?string
	}
	*/
	
	var stylesInDom = {/*
	  [id: number]: {
	    id: number,
	    refs: number,
	    parts: Array<(obj?: StyleObjectPart) => void>
	  }
	*/}
	
	var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
	var singletonElement = null
	var singletonCounter = 0
	var isProduction = false
	var noop = function () {}
	var options = null
	var ssrIdKey = 'data-vue-ssr-id'
	
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())
	
	function addStylesClient (parentId, list, _isProduction, _options) {
	  isProduction = _isProduction
	
	  options = _options || {}
	
	  var styles = listToStyles(parentId, list)
	  addStylesToDom(styles)
	
	  return function update (newList) {
	    var mayRemove = []
	    for (var i = 0; i < styles.length; i++) {
	      var item = styles[i]
	      var domStyle = stylesInDom[item.id]
	      domStyle.refs--
	      mayRemove.push(domStyle)
	    }
	    if (newList) {
	      styles = listToStyles(parentId, newList)
	      addStylesToDom(styles)
	    } else {
	      styles = []
	    }
	    for (var i = 0; i < mayRemove.length; i++) {
	      var domStyle = mayRemove[i]
	      if (domStyle.refs === 0) {
	        for (var j = 0; j < domStyle.parts.length; j++) {
	          domStyle.parts[j]()
	        }
	        delete stylesInDom[domStyle.id]
	      }
	    }
	  }
	}
	
	function addStylesToDom (styles /* Array<StyleObject> */) {
	  for (var i = 0; i < styles.length; i++) {
	    var item = styles[i]
	    var domStyle = stylesInDom[item.id]
	    if (domStyle) {
	      domStyle.refs++
	      for (var j = 0; j < domStyle.parts.length; j++) {
	        domStyle.parts[j](item.parts[j])
	      }
	      for (; j < item.parts.length; j++) {
	        domStyle.parts.push(addStyle(item.parts[j]))
	      }
	      if (domStyle.parts.length > item.parts.length) {
	        domStyle.parts.length = item.parts.length
	      }
	    } else {
	      var parts = []
	      for (var j = 0; j < item.parts.length; j++) {
	        parts.push(addStyle(item.parts[j]))
	      }
	      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
	    }
	  }
	}
	
	function createStyleElement () {
	  var styleElement = document.createElement('style')
	  styleElement.type = 'text/css'
	  head.appendChild(styleElement)
	  return styleElement
	}
	
	function addStyle (obj /* StyleObjectPart */) {
	  var update, remove
	  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')
	
	  if (styleElement) {
	    if (isProduction) {
	      // has SSR styles and in production mode.
	      // simply do nothing.
	      return noop
	    } else {
	      // has SSR styles but in dev mode.
	      // for some reason Chrome can't handle source map in server-rendered
	      // style tags - source maps in <style> only works if the style tag is
	      // created and inserted dynamically. So we remove the server rendered
	      // styles and inject new ones.
	      styleElement.parentNode.removeChild(styleElement)
	    }
	  }
	
	  if (isOldIE) {
	    // use singleton mode for IE9.
	    var styleIndex = singletonCounter++
	    styleElement = singletonElement || (singletonElement = createStyleElement())
	    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
	    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
	  } else {
	    // use multi-style-tag mode in all other cases
	    styleElement = createStyleElement()
	    update = applyToTag.bind(null, styleElement)
	    remove = function () {
	      styleElement.parentNode.removeChild(styleElement)
	    }
	  }
	
	  update(obj)
	
	  return function updateStyle (newObj /* StyleObjectPart */) {
	    if (newObj) {
	      if (newObj.css === obj.css &&
	          newObj.media === obj.media &&
	          newObj.sourceMap === obj.sourceMap) {
	        return
	      }
	      update(obj = newObj)
	    } else {
	      remove()
	    }
	  }
	}
	
	var replaceText = (function () {
	  var textStore = []
	
	  return function (index, replacement) {
	    textStore[index] = replacement
	    return textStore.filter(Boolean).join('\n')
	  }
	})()
	
	function applyToSingletonTag (styleElement, index, remove, obj) {
	  var css = remove ? '' : obj.css
	
	  if (styleElement.styleSheet) {
	    styleElement.styleSheet.cssText = replaceText(index, css)
	  } else {
	    var cssNode = document.createTextNode(css)
	    var childNodes = styleElement.childNodes
	    if (childNodes[index]) styleElement.removeChild(childNodes[index])
	    if (childNodes.length) {
	      styleElement.insertBefore(cssNode, childNodes[index])
	    } else {
	      styleElement.appendChild(cssNode)
	    }
	  }
	}
	
	function applyToTag (styleElement, obj) {
	  var css = obj.css
	  var media = obj.media
	  var sourceMap = obj.sourceMap
	
	  if (media) {
	    styleElement.setAttribute('media', media)
	  }
	  if (options.ssrId) {
	    styleElement.setAttribute(ssrIdKey, obj.id)
	  }
	
	  if (sourceMap) {
	    // https://developer.chrome.com/devtools/docs/javascript-debugging
	    // this makes source maps inside style tags work properly in Chrome
	    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
	    // http://stackoverflow.com/a/26603875
	    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
	  }
	
	  if (styleElement.styleSheet) {
	    styleElement.styleSheet.cssText = css
	  } else {
	    while (styleElement.firstChild) {
	      styleElement.removeChild(styleElement.firstChild)
	    }
	    styleElement.appendChild(document.createTextNode(css))
	  }
	}
	
	
	/***/ }),
	
	/***/ "49ad":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function(idHandler) {
	    var eventListeners = {};
	
	    /**
	     * Gets all listeners for the given element.
	     * @public
	     * @param {element} element The element to get all listeners for.
	     * @returns All listeners for the given element.
	     */
	    function getListeners(element) {
	        var id = idHandler.get(element);
	
	        if (id === undefined) {
	            return [];
	        }
	
	        return eventListeners[id] || [];
	    }
	
	    /**
	     * Stores the given listener for the given element. Will not actually add the listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The callback that the element has added.
	     */
	    function addListener(element, listener) {
	        var id = idHandler.get(element);
	
	        if(!eventListeners[id]) {
	            eventListeners[id] = [];
	        }
	
	        eventListeners[id].push(listener);
	    }
	
	    function removeListener(element, listener) {
	        var listeners = getListeners(element);
	        for (var i = 0, len = listeners.length; i < len; ++i) {
	            if (listeners[i] === listener) {
	              listeners.splice(i, 1);
	              break;
	            }
	        }
	    }
	
	    function removeAllListeners(element) {
	      var listeners = getListeners(element);
	      if (!listeners) { return; }
	      listeners.length = 0;
	    }
	
	    return {
	        get: getListeners,
	        add: addListener,
	        removeListener: removeListener,
	        removeAllListeners: removeAllListeners
	    };
	};
	
	
	/***/ }),
	
	/***/ "4bf8":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__("be13");
	module.exports = function (it) {
	  return Object(defined(it));
	};
	
	
	/***/ }),
	
	/***/ "5058":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function(options) {
	    var idGenerator     = options.idGenerator;
	    var getState        = options.stateHandler.getState;
	
	    /**
	     * Gets the resize detector id of the element.
	     * @public
	     * @param {element} element The target element to get the id of.
	     * @returns {string|number|null} The id of the element. Null if it has no id.
	     */
	    function getId(element) {
	        var state = getState(element);
	
	        if (state && state.id !== undefined) {
	            return state.id;
	        }
	
	        return null;
	    }
	
	    /**
	     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
	     * @public
	     * @param {element} element The target element to set the id of.
	     * @returns {string|number|null} The id of the element.
	     */
	    function setId(element) {
	        var state = getState(element);
	
	        if (!state) {
	            throw new Error("setId required the element to have a resize detection state.");
	        }
	
	        var id = idGenerator.generate();
	
	        state.id = id;
	
	        return id;
	    }
	
	    return {
	        get: getId,
	        set: setId
	    };
	};
	
	
	/***/ }),
	
	/***/ "50bf":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = module.exports = {};
	
	utils.getOption = getOption;
	
	function getOption(options, name, defaultValue) {
	    var value = options[name];
	
	    if((value === undefined || value === null) && defaultValue !== undefined) {
	        return defaultValue;
	    }
	
	    return value;
	}
	
	
	/***/ }),
	
	/***/ "520a":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var regexpFlags = __webpack_require__("0bfb");
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;
	
	
	/***/ }),
	
	/***/ "52a7":
	/***/ (function(module, exports) {
	
	exports.f = {}.propertyIsEnumerable;
	
	
	/***/ }),
	
	/***/ "5537":
	/***/ (function(module, exports, __webpack_require__) {
	
	var core = __webpack_require__("8378");
	var global = __webpack_require__("7726");
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__("2d00") ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});
	
	
	/***/ }),
	
	/***/ "55dd":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var $export = __webpack_require__("5ca1");
	var aFunction = __webpack_require__("d8e8");
	var toObject = __webpack_require__("4bf8");
	var fails = __webpack_require__("79e5");
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__("2f21")($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});
	
	
	/***/ }),
	
	/***/ "584a":
	/***/ (function(module, exports) {
	
	var core = module.exports = { version: '2.6.10' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	
	
	/***/ }),
	
	/***/ "5be5":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function(options) {
	    var getState = options.stateHandler.getState;
	
	    /**
	     * Tells if the element has been made detectable and ready to be listened for resize events.
	     * @public
	     * @param {element} The element to check.
	     * @returns {boolean} True or false depending on if the element is detectable or not.
	     */
	    function isDetectable(element) {
	        var state = getState(element);
	        return state && !!state.isDetectable;
	    }
	
	    /**
	     * Marks the element that it has been made detectable and ready to be listened for resize events.
	     * @public
	     * @param {element} The element to mark.
	     */
	    function markAsDetectable(element) {
	        getState(element).isDetectable = true;
	    }
	
	    /**
	     * Tells if the element is busy or not.
	     * @public
	     * @param {element} The element to check.
	     * @returns {boolean} True or false depending on if the element is busy or not.
	     */
	    function isBusy(element) {
	        return !!getState(element).busy;
	    }
	
	    /**
	     * Marks the object is busy and should not be made detectable.
	     * @public
	     * @param {element} element The element to mark.
	     * @param {boolean} busy If the element is busy or not.
	     */
	    function markBusy(element, busy) {
	        getState(element).busy = !!busy;
	    }
	
	    return {
	        isDetectable: isDetectable,
	        markAsDetectable: markAsDetectable,
	        isBusy: isBusy,
	        markBusy: markBusy
	    };
	};
	
	
	/***/ }),
	
	/***/ "5ca1":
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__("7726");
	var core = __webpack_require__("8378");
	var hide = __webpack_require__("32e9");
	var redefine = __webpack_require__("2aba");
	var ctx = __webpack_require__("9b43");
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;
	
	
	/***/ }),
	
	/***/ "5dbc":
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__("d3f4");
	var setPrototypeOf = __webpack_require__("8b97").set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};
	
	
	/***/ }),
	
	/***/ "5ed4":
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GridItem_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6e21");
	/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GridItem_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GridItem_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
	/* unused harmony reexport * */
	 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GridItem_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 
	
	/***/ }),
	
	/***/ "5eda":
	/***/ (function(module, exports, __webpack_require__) {
	
	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__("5ca1");
	var core = __webpack_require__("8378");
	var fails = __webpack_require__("79e5");
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};
	
	
	/***/ }),
	
	/***/ "5f1b":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var classof = __webpack_require__("23c6");
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};
	
	
	/***/ }),
	
	/***/ "613b":
	/***/ (function(module, exports, __webpack_require__) {
	
	var shared = __webpack_require__("5537")('keys');
	var uid = __webpack_require__("ca5a");
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};
	
	
	/***/ }),
	
	/***/ "626a":
	/***/ (function(module, exports, __webpack_require__) {
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__("2d95");
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};
	
	
	/***/ }),
	
	/***/ "63b6":
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__("e53d");
	var core = __webpack_require__("584a");
	var ctx = __webpack_require__("d864");
	var hide = __webpack_require__("35e8");
	var has = __webpack_require__("07e3");
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;
	
	
	/***/ }),
	
	/***/ "6821":
	/***/ (function(module, exports, __webpack_require__) {
	
	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__("626a");
	var defined = __webpack_require__("be13");
	module.exports = function (it) {
	  return IObject(defined(it));
	};
	
	
	/***/ }),
	
	/***/ "69a8":
	/***/ (function(module, exports) {
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	
	/***/ }),
	
	/***/ "6a99":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__("d3f4");
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	
	/***/ }),
	
	/***/ "6e21":
	/***/ (function(module, exports, __webpack_require__) {
	
	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("9cbe");
	if(typeof content === 'string') content = [[module.i, content, '']];
	if(content.locals) module.exports = content.locals;
	// add the styles to the DOM
	var add = __webpack_require__("499e").default
	var update = add("3cbd0c21", content, true, {"sourceMap":false,"shadowMode":false});
	
	/***/ }),
	
	/***/ "7726":
	/***/ (function(module, exports) {
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	
	
	/***/ }),
	
	/***/ "77f1":
	/***/ (function(module, exports, __webpack_require__) {
	
	var toInteger = __webpack_require__("4588");
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};
	
	
	/***/ }),
	
	/***/ "794b":
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = !__webpack_require__("8e60") && !__webpack_require__("294c")(function () {
	  return Object.defineProperty(__webpack_require__("1ec9")('div'), 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	
	/***/ "79aa":
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};
	
	
	/***/ }),
	
	/***/ "79e5":
	/***/ (function(module, exports) {
	
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};
	
	
	/***/ }),
	
	/***/ "7f20":
	/***/ (function(module, exports, __webpack_require__) {
	
	var def = __webpack_require__("86cc").f;
	var has = __webpack_require__("69a8");
	var TAG = __webpack_require__("2b4c")('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};
	
	
	/***/ }),
	
	/***/ "7f7f":
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__("86cc").f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__("9e1e") && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});
	
	
	/***/ }),
	
	/***/ "8378":
	/***/ (function(module, exports) {
	
	var core = module.exports = { version: '2.6.10' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	
	
	/***/ }),
	
	/***/ "84f2":
	/***/ (function(module, exports) {
	
	module.exports = {};
	
	
	/***/ }),
	
	/***/ "85f2":
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__("454f");
	
	/***/ }),
	
	/***/ "86cc":
	/***/ (function(module, exports, __webpack_require__) {
	
	var anObject = __webpack_require__("cb7c");
	var IE8_DOM_DEFINE = __webpack_require__("c69a");
	var toPrimitive = __webpack_require__("6a99");
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	
	/***/ }),
	
	/***/ "8b97":
	/***/ (function(module, exports, __webpack_require__) {
	
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__("d3f4");
	var anObject = __webpack_require__("cb7c");
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__("9b43")(Function.call, __webpack_require__("11e9").f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};
	
	
	/***/ }),
	
	/***/ "8bbf":
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(19);
	
	/***/ }),
	
	/***/ "8e60":
	/***/ (function(module, exports, __webpack_require__) {
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__("294c")(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	
	/***/ "8e6e":
	/***/ (function(module, exports, __webpack_require__) {
	
	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__("5ca1");
	var ownKeys = __webpack_require__("990b");
	var toIObject = __webpack_require__("6821");
	var gOPD = __webpack_require__("11e9");
	var createProperty = __webpack_require__("f1ae");
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});
	
	
	/***/ }),
	
	/***/ "9093":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__("ce10");
	var hiddenKeys = __webpack_require__("e11e").concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};
	
	
	/***/ }),
	
	/***/ "990b":
	/***/ (function(module, exports, __webpack_require__) {
	
	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__("9093");
	var gOPS = __webpack_require__("2621");
	var anObject = __webpack_require__("cb7c");
	var Reflect = __webpack_require__("7726").Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};
	
	
	/***/ }),
	
	/***/ "9b43":
	/***/ (function(module, exports, __webpack_require__) {
	
	// optional / simple context binding
	var aFunction = __webpack_require__("d8e8");
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};
	
	
	/***/ }),
	
	/***/ "9c6c":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};
	
	
	/***/ }),
	
	/***/ "9cbe":
	/***/ (function(module, exports, __webpack_require__) {
	
	exports = module.exports = __webpack_require__("2350")(false);
	// imports
	
	
	// module
	exports.push([module.i, ".vue-grid-item{-webkit-transition:all .2s ease;transition:all .2s ease;-webkit-transition-property:left,top,right;transition-property:left,top,right}.vue-grid-item.no-touch{-ms-touch-action:none;touch-action:none}.vue-grid-item.cssTransforms{-webkit-transition-property:-webkit-transform;transition-property:-webkit-transform;transition-property:transform;transition-property:transform,-webkit-transform;left:0;right:auto}.vue-grid-item.cssTransforms.render-rtl{left:auto;right:0}.vue-grid-item.resizing{opacity:.6;z-index:3}.vue-grid-item.vue-draggable-dragging{-webkit-transition:none;transition:none;z-index:3}.vue-grid-item.vue-grid-placeholder{background:red;opacity:.2;-webkit-transition-duration:.1s;transition-duration:.1s;z-index:2;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}.vue-grid-item>.vue-resizable-handle{position:absolute;width:20px;height:20px;bottom:0;right:0;background:url(\"data:image/svg+xml;base64,PHN2ZyBzdHlsZT0iYmFja2dyb3VuZC1jb2xvcjojZmZmZmZmMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjYiIGhlaWdodD0iNiI+PHBhdGggZD0iTTYgNkgwVjQuMmg0LjJWMEg2djZ6IiBvcGFjaXR5PSIuMzAyIi8+PC9zdmc+\");background-position:100% 100%;padding:0 3px 3px 0;background-repeat:no-repeat;background-origin:content-box;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:se-resize}.vue-grid-item>.vue-rtl-resizable-handle{bottom:0;left:0;background:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTS0xLTFoMTJ2MTJILTF6Ii8+PGc+PHBhdGggc3Ryb2tlLWxpbmVjYXA9InVuZGVmaW5lZCIgc3Ryb2tlLWxpbmVqb2luPSJ1bmRlZmluZWQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2U9IiMwMDAiIGZpbGw9Im5vbmUiIGQ9Ik0xNDQuODIxLTM4LjM5M2wtMjAuMzU3LTMxLjc4NSIvPjxwYXRoIHN0cm9rZT0iIzY2NiIgc3Ryb2tlLWxpbmVjYXA9InVuZGVmaW5lZCIgc3Ryb2tlLWxpbmVqb2luPSJ1bmRlZmluZWQiIHN0cm9rZS13aWR0aD0iMiIgZmlsbD0ibm9uZSIgZD0iTS45NDctLjAxOHY5LjEyNU0tLjY1NiA5aDEwLjczIi8+PC9nPjwvc3ZnPg==);background-position:0 100%;padding-left:3px;background-repeat:no-repeat;background-origin:content-box;cursor:sw-resize;right:auto}.vue-grid-item.disable-userselect{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);
	
	// exports
	
	
	/***/ }),
	
	/***/ "9def":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.15 ToLength
	var toInteger = __webpack_require__("4588");
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};
	
	
	/***/ }),
	
	/***/ "9e1e":
	/***/ (function(module, exports, __webpack_require__) {
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__("79e5")(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	
	/***/ "a481":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var anObject = __webpack_require__("cb7c");
	var toObject = __webpack_require__("4bf8");
	var toLength = __webpack_require__("9def");
	var toInteger = __webpack_require__("4588");
	var advanceStringIndex = __webpack_require__("0390");
	var regExpExec = __webpack_require__("5f1b");
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});
	
	
	/***/ }),
	
	/***/ "aa77":
	/***/ (function(module, exports, __webpack_require__) {
	
	var $export = __webpack_require__("5ca1");
	var defined = __webpack_require__("be13");
	var fails = __webpack_require__("79e5");
	var spaces = __webpack_require__("fdef");
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;
	
	
	/***/ }),
	
	/***/ "abb4":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/* global console: false */
	
	/**
	 * Reporter that handles the reporting of logs, warnings and errors.
	 * @public
	 * @param {boolean} quiet Tells if the reporter should be quiet or not.
	 */
	module.exports = function(quiet) {
	    function noop() {
	        //Does nothing.
	    }
	
	    var reporter = {
	        log: noop,
	        warn: noop,
	        error: noop
	    };
	
	    if(!quiet && window.console) {
	        var attachFunction = function(reporter, name) {
	            //The proxy is needed to be able to call the method with the console context,
	            //since we cannot use bind.
	            reporter[name] = function reporterProxy() {
	                var f = console[name];
	                if (f.apply) { //IE9 does not support console.log.apply :)
	                    f.apply(console, arguments);
	                } else {
	                    for (var i = 0; i < arguments.length; i++) {
	                        f(arguments[i]);
	                    }
	                }
	            };
	        };
	
	        attachFunction(reporter, "log");
	        attachFunction(reporter, "warn");
	        attachFunction(reporter, "error");
	    }
	
	    return reporter;
	};
	
	/***/ }),
	
	/***/ "ac6a":
	/***/ (function(module, exports, __webpack_require__) {
	
	var $iterators = __webpack_require__("cadf");
	var getKeys = __webpack_require__("0d58");
	var redefine = __webpack_require__("2aba");
	var global = __webpack_require__("7726");
	var hide = __webpack_require__("32e9");
	var Iterators = __webpack_require__("84f2");
	var wks = __webpack_require__("2b4c");
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}
	
	
	/***/ }),
	
	/***/ "ad20":
	/***/ (function(module, exports, __webpack_require__) {
	
	exports = module.exports = __webpack_require__("2350")(false);
	// imports
	
	
	// module
	exports.push([module.i, ".vue-grid-layout{position:relative;-webkit-transition:height .2s ease;transition:height .2s ease}", ""]);
	
	// exports
	
	
	/***/ }),
	
	/***/ "aebd":
	/***/ (function(module, exports) {
	
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	
	/***/ }),
	
	/***/ "b0c5":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var regexpExec = __webpack_require__("520a");
	__webpack_require__("5ca1")({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});
	
	
	/***/ }),
	
	/***/ "b770":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = module.exports = {};
	
	/**
	 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
	 * @public
	 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
	 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
	 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
	 */
	utils.forEach = function(collection, callback) {
	    for(var i = 0; i < collection.length; i++) {
	        var result = callback(collection[i]);
	        if(result) {
	            return result;
	        }
	    }
	};
	
	
	/***/ }),
	
	/***/ "be13":
	/***/ (function(module, exports) {
	
	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};
	
	
	/***/ }),
	
	/***/ "c274":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__("50bf");
	
	module.exports = function batchProcessorMaker(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var asyncProcess    = utils.getOption(options, "async", true);
	    var autoProcess     = utils.getOption(options, "auto", true);
	
	    if(autoProcess && !asyncProcess) {
	        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
	        asyncProcess = true;
	    }
	
	    var batch = Batch();
	    var asyncFrameHandler;
	    var isProcessing = false;
	
	    function addFunction(level, fn) {
	        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
	            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
	            // This needs to be done before, since we're checking the size of the batch to be 0.
	            processBatchAsync();
	        }
	
	        batch.add(level, fn);
	    }
	
	    function processBatch() {
	        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
	        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
	        isProcessing = true;
	        while (batch.size()) {
	            var processingBatch = batch;
	            batch = Batch();
	            processingBatch.process();
	        }
	        isProcessing = false;
	    }
	
	    function forceProcessBatch(localAsyncProcess) {
	        if (isProcessing) {
	            return;
	        }
	
	        if(localAsyncProcess === undefined) {
	            localAsyncProcess = asyncProcess;
	        }
	
	        if(asyncFrameHandler) {
	            cancelFrame(asyncFrameHandler);
	            asyncFrameHandler = null;
	        }
	
	        if(localAsyncProcess) {
	            processBatchAsync();
	        } else {
	            processBatch();
	        }
	    }
	
	    function processBatchAsync() {
	        asyncFrameHandler = requestFrame(processBatch);
	    }
	
	    function clearBatch() {
	        batch           = {};
	        batchSize       = 0;
	        topLevel        = 0;
	        bottomLevel     = 0;
	    }
	
	    function cancelFrame(listener) {
	        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
	        var cancel = clearTimeout;
	        return cancel(listener);
	    }
	
	    function requestFrame(callback) {
	        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
	        var raf = function(fn) { return setTimeout(fn, 0); };
	        return raf(callback);
	    }
	
	    return {
	        add: addFunction,
	        force: forceProcessBatch
	    };
	};
	
	function Batch() {
	    var batch       = {};
	    var size        = 0;
	    var topLevel    = 0;
	    var bottomLevel = 0;
	
	    function add(level, fn) {
	        if(!fn) {
	            fn = level;
	            level = 0;
	        }
	
	        if(level > topLevel) {
	            topLevel = level;
	        } else if(level < bottomLevel) {
	            bottomLevel = level;
	        }
	
	        if(!batch[level]) {
	            batch[level] = [];
	        }
	
	        batch[level].push(fn);
	        size++;
	    }
	
	    function process() {
	        for(var level = bottomLevel; level <= topLevel; level++) {
	            var fns = batch[level];
	
	            for(var i = 0; i < fns.length; i++) {
	                var fn = fns[i];
	                fn();
	            }
	        }
	    }
	
	    function getSize() {
	        return size;
	    }
	
	    return {
	        add: add,
	        process: process,
	        size: getSize
	    };
	}
	
	
	/***/ }),
	
	/***/ "c366":
	/***/ (function(module, exports, __webpack_require__) {
	
	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__("6821");
	var toLength = __webpack_require__("9def");
	var toAbsoluteIndex = __webpack_require__("77f1");
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	
	/***/ }),
	
	/***/ "c5f6":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var global = __webpack_require__("7726");
	var has = __webpack_require__("69a8");
	var cof = __webpack_require__("2d95");
	var inheritIfRequired = __webpack_require__("5dbc");
	var toPrimitive = __webpack_require__("6a99");
	var fails = __webpack_require__("79e5");
	var gOPN = __webpack_require__("9093").f;
	var gOPD = __webpack_require__("11e9").f;
	var dP = __webpack_require__("86cc").f;
	var $trim = __webpack_require__("aa77").trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__("2aeb")(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__("9e1e") ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__("2aba")(global, NUMBER, $Number);
	}
	
	
	/***/ }),
	
	/***/ "c69a":
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
	  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	
	/***/ "c946":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
	 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
	 */
	
	
	
	var forEach = __webpack_require__("b770").forEach;
	
	module.exports = function(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var batchProcessor  = options.batchProcessor;
	    var getState        = options.stateHandler.getState;
	    var hasState        = options.stateHandler.hasState;
	    var idHandler       = options.idHandler;
	
	    if (!batchProcessor) {
	        throw new Error("Missing required dependency: batchProcessor");
	    }
	
	    if (!reporter) {
	        throw new Error("Missing required dependency: reporter.");
	    }
	
	    //TODO: Could this perhaps be done at installation time?
	    var scrollbarSizes = getScrollbarSizes();
	
	    // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
	    // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
	    var styleId = "erd_scroll_detection_scrollbar_style";
	    var detectionContainerClass = "erd_scroll_detection_container";
	    injectScrollStyle(styleId, detectionContainerClass);
	
	    function getScrollbarSizes() {
	        var width = 500;
	        var height = 500;
	
	        var child = document.createElement("div");
	        child.style.cssText = "position: absolute; width: " + width*2 + "px; height: " + height*2 + "px; visibility: hidden; margin: 0; padding: 0;";
	
	        var container = document.createElement("div");
	        container.style.cssText = "position: absolute; width: " + width + "px; height: " + height + "px; overflow: scroll; visibility: none; top: " + -width*3 + "px; left: " + -height*3 + "px; visibility: hidden; margin: 0; padding: 0;";
	
	        container.appendChild(child);
	
	        document.body.insertBefore(container, document.body.firstChild);
	
	        var widthSize = width - container.clientWidth;
	        var heightSize = height - container.clientHeight;
	
	        document.body.removeChild(container);
	
	        return {
	            width: widthSize,
	            height: heightSize
	        };
	    }
	
	    function injectScrollStyle(styleId, containerClass) {
	        function injectStyle(style, method) {
	            method = method || function (element) {
	                document.head.appendChild(element);
	            };
	
	            var styleElement = document.createElement("style");
	            styleElement.innerHTML = style;
	            styleElement.id = styleId;
	            method(styleElement);
	            return styleElement;
	        }
	
	        if (!document.getElementById(styleId)) {
	            var containerAnimationClass = containerClass + "_animation";
	            var containerAnimationActiveClass = containerClass + "_animation_active";
	            var style = "/* Created by the element-resize-detector library. */\n";
	            style += "." + containerClass + " > div::-webkit-scrollbar { display: none; }\n\n";
	            style += "." + containerAnimationActiveClass + " { -webkit-animation-duration: 0.1s; animation-duration: 0.1s; -webkit-animation-name: " + containerAnimationClass + "; animation-name: " + containerAnimationClass + "; }\n";
	            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
	            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
	            injectStyle(style);
	        }
	    }
	
	    function addAnimationClass(element) {
	        element.className += " " + detectionContainerClass + "_animation_active";
	    }
	
	    function addEvent(el, name, cb) {
	        if (el.addEventListener) {
	            el.addEventListener(name, cb);
	        } else if(el.attachEvent) {
	            el.attachEvent("on" + name, cb);
	        } else {
	            return reporter.error("[scroll] Don't know how to add event listeners.");
	        }
	    }
	
	    function removeEvent(el, name, cb) {
	        if (el.removeEventListener) {
	            el.removeEventListener(name, cb);
	        } else if(el.detachEvent) {
	            el.detachEvent("on" + name, cb);
	        } else {
	            return reporter.error("[scroll] Don't know how to remove event listeners.");
	        }
	    }
	
	    function getExpandElement(element) {
	        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
	    }
	
	    function getShrinkElement(element) {
	        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
	    }
	
	    /**
	     * Adds a resize event listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
	     */
	    function addListener(element, listener) {
	        var listeners = getState(element).listeners;
	
	        if (!listeners.push) {
	            throw new Error("Cannot add listener to an element that is not detectable.");
	        }
	
	        getState(element).listeners.push(listener);
	    }
	
	    /**
	     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
	     * @private
	     * @param {object} options Optional options object.
	     * @param {element} element The element to make detectable
	     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
	     */
	    function makeDetectable(options, element, callback) {
	        if (!callback) {
	            callback = element;
	            element = options;
	            options = null;
	        }
	
	        options = options || {};
	
	        function debug() {
	            if (options.debug) {
	                var args = Array.prototype.slice.call(arguments);
	                args.unshift(idHandler.get(element), "Scroll: ");
	                if (reporter.log.apply) {
	                    reporter.log.apply(null, args);
	                } else {
	                    for (var i = 0; i < args.length; i++) {
	                        reporter.log(args[i]);
	                    }
	                }
	            }
	        }
	
	        function isDetached(element) {
	            function isInDocument(element) {
	                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element);
	            }
	
	            if (!isInDocument(element)) {
	                return true;
	            }
	
	            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
	            if (window.getComputedStyle(element) === null) {
	                return true;
	            }
	
	            return false;
	        }
	
	        function isUnrendered(element) {
	            // Check the absolute positioned container since the top level container is display: inline.
	            var container = getState(element).container.childNodes[0];
	            var style = window.getComputedStyle(container);
	            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
	        }
	
	        function getStyle() {
	            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
	            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
	            var elementStyle            = window.getComputedStyle(element);
	            var style                   = {};
	            style.position              = elementStyle.position;
	            style.width                 = element.offsetWidth;
	            style.height                = element.offsetHeight;
	            style.top                   = elementStyle.top;
	            style.right                 = elementStyle.right;
	            style.bottom                = elementStyle.bottom;
	            style.left                  = elementStyle.left;
	            style.widthCSS              = elementStyle.width;
	            style.heightCSS             = elementStyle.height;
	            return style;
	        }
	
	        function storeStartSize() {
	            var style = getStyle();
	            getState(element).startSize = {
	                width: style.width,
	                height: style.height
	            };
	            debug("Element start size", getState(element).startSize);
	        }
	
	        function initListeners() {
	            getState(element).listeners = [];
	        }
	
	        function storeStyle() {
	            debug("storeStyle invoked.");
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            var style = getStyle();
	            getState(element).style = style;
	        }
	
	        function storeCurrentSize(element, width, height) {
	            getState(element).lastWidth = width;
	            getState(element).lastHeight  = height;
	        }
	
	        function getExpandChildElement(element) {
	            return getExpandElement(element).childNodes[0];
	        }
	
	        function getWidthOffset() {
	            return 2 * scrollbarSizes.width + 1;
	        }
	
	        function getHeightOffset() {
	            return 2 * scrollbarSizes.height + 1;
	        }
	
	        function getExpandWidth(width) {
	            return width + 10 + getWidthOffset();
	        }
	
	        function getExpandHeight(height) {
	            return height + 10 + getHeightOffset();
	        }
	
	        function getShrinkWidth(width) {
	            return width * 2 + getWidthOffset();
	        }
	
	        function getShrinkHeight(height) {
	            return height * 2 + getHeightOffset();
	        }
	
	        function positionScrollbars(element, width, height) {
	            var expand          = getExpandElement(element);
	            var shrink          = getShrinkElement(element);
	            var expandWidth     = getExpandWidth(width);
	            var expandHeight    = getExpandHeight(height);
	            var shrinkWidth     = getShrinkWidth(width);
	            var shrinkHeight    = getShrinkHeight(height);
	            expand.scrollLeft   = expandWidth;
	            expand.scrollTop    = expandHeight;
	            shrink.scrollLeft   = shrinkWidth;
	            shrink.scrollTop    = shrinkHeight;
	        }
	
	        function injectContainerElement() {
	            var container = getState(element).container;
	
	            if (!container) {
	                container                   = document.createElement("div");
	                container.className         = detectionContainerClass;
	                container.style.cssText     = "visibility: hidden; display: inline; width: 0px; height: 0px; z-index: -1; overflow: hidden; margin: 0; padding: 0;";
	                getState(element).container = container;
	                addAnimationClass(container);
	                element.appendChild(container);
	
	                var onAnimationStart = function () {
	                    getState(element).onRendered && getState(element).onRendered();
	                };
	
	                addEvent(container, "animationstart", onAnimationStart);
	
	                // Store the event handler here so that they may be removed when uninstall is called.
	                // See uninstall function for an explanation why it is needed.
	                getState(element).onAnimationStart = onAnimationStart;
	            }
	
	            return container;
	        }
	
	        function injectScrollElements() {
	            function alterPositionStyles() {
	                var style = getState(element).style;
	
	                if(style.position === "static") {
	                    element.style.position = "relative";
	
	                    var removeRelativeStyles = function(reporter, element, style, property) {
	                        function getNumericalValue(value) {
	                            return value.replace(/[^-\d\.]/g, "");
	                        }
	
	                        var value = style[property];
	
	                        if(value !== "auto" && getNumericalValue(value) !== "0") {
	                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
	                            element.style[property] = 0;
	                        }
	                    };
	
	                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
	                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
	                    removeRelativeStyles(reporter, element, style, "top");
	                    removeRelativeStyles(reporter, element, style, "right");
	                    removeRelativeStyles(reporter, element, style, "bottom");
	                    removeRelativeStyles(reporter, element, style, "left");
	                }
	            }
	
	            function getLeftTopBottomRightCssText(left, top, bottom, right) {
	                left = (!left ? "0" : (left + "px"));
	                top = (!top ? "0" : (top + "px"));
	                bottom = (!bottom ? "0" : (bottom + "px"));
	                right = (!right ? "0" : (right + "px"));
	
	                return "left: " + left + "; top: " + top + "; right: " + right + "; bottom: " + bottom + ";";
	            }
	
	            debug("Injecting elements");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            alterPositionStyles();
	
	            var rootContainer = getState(element).container;
	
	            if (!rootContainer) {
	                rootContainer = injectContainerElement();
	            }
	
	            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
	            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
	            // the targeted element.
	            // When the bug is resolved, "containerContainer" may be removed.
	
	            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
	            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.
	
	            var scrollbarWidth          = scrollbarSizes.width;
	            var scrollbarHeight         = scrollbarSizes.height;
	            var containerContainerStyle = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; width: 100%; height: 100%; left: 0px; top: 0px;";
	            var containerStyle          = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; " + getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth);
	            var expandStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
	            var shrinkStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
	            var expandChildStyle        = "position: absolute; left: 0; top: 0;";
	            var shrinkChildStyle        = "position: absolute; width: 200%; height: 200%;";
	
	            var containerContainer      = document.createElement("div");
	            var container               = document.createElement("div");
	            var expand                  = document.createElement("div");
	            var expandChild             = document.createElement("div");
	            var shrink                  = document.createElement("div");
	            var shrinkChild             = document.createElement("div");
	
	            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
	            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
	            containerContainer.dir              = "ltr";
	
	            containerContainer.style.cssText    = containerContainerStyle;
	            containerContainer.className        = detectionContainerClass;
	            container.className                 = detectionContainerClass;
	            container.style.cssText             = containerStyle;
	            expand.style.cssText                = expandStyle;
	            expandChild.style.cssText           = expandChildStyle;
	            shrink.style.cssText                = shrinkStyle;
	            shrinkChild.style.cssText           = shrinkChildStyle;
	
	            expand.appendChild(expandChild);
	            shrink.appendChild(shrinkChild);
	            container.appendChild(expand);
	            container.appendChild(shrink);
	            containerContainer.appendChild(container);
	            rootContainer.appendChild(containerContainer);
	
	            function onExpandScroll() {
	                getState(element).onExpand && getState(element).onExpand();
	            }
	
	            function onShrinkScroll() {
	                getState(element).onShrink && getState(element).onShrink();
	            }
	
	            addEvent(expand, "scroll", onExpandScroll);
	            addEvent(shrink, "scroll", onShrinkScroll);
	
	            // Store the event handlers here so that they may be removed when uninstall is called.
	            // See uninstall function for an explanation why it is needed.
	            getState(element).onExpandScroll = onExpandScroll;
	            getState(element).onShrinkScroll = onShrinkScroll;
	        }
	
	        function registerListenersAndPositionElements() {
	            function updateChildSizes(element, width, height) {
	                var expandChild             = getExpandChildElement(element);
	                var expandWidth             = getExpandWidth(width);
	                var expandHeight            = getExpandHeight(height);
	                expandChild.style.width     = expandWidth + "px";
	                expandChild.style.height    = expandHeight + "px";
	            }
	
	            function updateDetectorElements(done) {
	                var width           = element.offsetWidth;
	                var height          = element.offsetHeight;
	
	                debug("Storing current size", width, height);
	
	                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
	                // Otherwise the if-check in handleScroll is useless.
	                storeCurrentSize(element, width, height);
	
	                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
	                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.
	
	                batchProcessor.add(0, function performUpdateChildSizes() {
	                    if (!getState(element)) {
	                        debug("Aborting because element has been uninstalled");
	                        return;
	                    }
	
	                    if (!areElementsInjected()) {
	                        debug("Aborting because element container has not been initialized");
	                        return;
	                    }
	
	                    if (options.debug) {
	                        var w = element.offsetWidth;
	                        var h = element.offsetHeight;
	
	                        if (w !== width || h !== height) {
	                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
	                        }
	                    }
	
	                    updateChildSizes(element, width, height);
	                });
	
	                batchProcessor.add(1, function updateScrollbars() {
	                    if (!getState(element)) {
	                        debug("Aborting because element has been uninstalled");
	                        return;
	                    }
	
	                    if (!areElementsInjected()) {
	                        debug("Aborting because element container has not been initialized");
	                        return;
	                    }
	
	                    positionScrollbars(element, width, height);
	                });
	
	                if (done) {
	                    batchProcessor.add(2, function () {
	                        if (!getState(element)) {
	                            debug("Aborting because element has been uninstalled");
	                            return;
	                        }
	
	                        if (!areElementsInjected()) {
	                          debug("Aborting because element container has not been initialized");
	                          return;
	                        }
	
	                        done();
	                    });
	                }
	            }
	
	            function areElementsInjected() {
	                return !!getState(element).container;
	            }
	
	            function notifyListenersIfNeeded() {
	                function isFirstNotify() {
	                    return getState(element).lastNotifiedWidth === undefined;
	                }
	
	                debug("notifyListenersIfNeeded invoked");
	
	                var state = getState(element);
	
	                // Don't notify the if the current size is the start size, and this is the first notification.
	                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
	                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
	                }
	
	                // Don't notify if the size already has been notified.
	                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
	                    return debug("Not notifying: Size already notified");
	                }
	
	
	                debug("Current size not notified, notifying...");
	                state.lastNotifiedWidth = state.lastWidth;
	                state.lastNotifiedHeight = state.lastHeight;
	                forEach(getState(element).listeners, function (listener) {
	                    listener(element);
	                });
	            }
	
	            function handleRender() {
	                debug("startanimation triggered.");
	
	                if (isUnrendered(element)) {
	                    debug("Ignoring since element is still unrendered...");
	                    return;
	                }
	
	                debug("Element rendered.");
	                var expand = getExpandElement(element);
	                var shrink = getShrinkElement(element);
	                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
	                    debug("Scrollbars out of sync. Updating detector elements...");
	                    updateDetectorElements(notifyListenersIfNeeded);
	                }
	            }
	
	            function handleScroll() {
	                debug("Scroll detected.");
	
	                if (isUnrendered(element)) {
	                    // Element is still unrendered. Skip this scroll event.
	                    debug("Scroll event fired while unrendered. Ignoring...");
	                    return;
	                }
	
	                var width = element.offsetWidth;
	                var height = element.offsetHeight;
	
	                if (width !== getState(element).lastWidth || height !== getState(element).lastHeight) {
	                    debug("Element size changed.");
	                    updateDetectorElements(notifyListenersIfNeeded);
	                } else {
	                    debug("Element size has not changed (" + width + "x" + height + ").");
	                }
	            }
	
	            debug("registerListenersAndPositionElements invoked.");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            getState(element).onRendered = handleRender;
	            getState(element).onExpand = handleScroll;
	            getState(element).onShrink = handleScroll;
	
	            var style = getState(element).style;
	            updateChildSizes(element, style.width, style.height);
	        }
	
	        function finalizeDomMutation() {
	            debug("finalizeDomMutation invoked.");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            var style = getState(element).style;
	            storeCurrentSize(element, style.width, style.height);
	            positionScrollbars(element, style.width, style.height);
	        }
	
	        function ready() {
	            callback(element);
	        }
	
	        function install() {
	            debug("Installing...");
	            initListeners();
	            storeStartSize();
	
	            batchProcessor.add(0, storeStyle);
	            batchProcessor.add(1, injectScrollElements);
	            batchProcessor.add(2, registerListenersAndPositionElements);
	            batchProcessor.add(3, finalizeDomMutation);
	            batchProcessor.add(4, ready);
	        }
	
	        debug("Making detectable...");
	
	        if (isDetached(element)) {
	            debug("Element is detached");
	
	            injectContainerElement();
	
	            debug("Waiting until element is attached...");
	
	            getState(element).onRendered = function () {
	                debug("Element is now attached");
	                install();
	            };
	        } else {
	            install();
	        }
	    }
	
	    function uninstall(element) {
	        var state = getState(element);
	
	        if (!state) {
	            // Uninstall has been called on a non-erd element.
	            return;
	        }
	
	        // Uninstall may have been called in the following scenarios:
	        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
	        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
	        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
	        // So to be on the safe side, let's check for each thing before removing.
	
	        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
	        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
	        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
	        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);
	
	        state.container && element.removeChild(state.container);
	    }
	
	    return {
	        makeDetectable: makeDetectable,
	        addListener: addListener,
	        uninstall: uninstall
	    };
	};
	
	
	/***/ }),
	
	/***/ "ca5a":
	/***/ (function(module, exports) {
	
	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};
	
	
	/***/ }),
	
	/***/ "cadf":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var addToUnscopables = __webpack_require__("9c6c");
	var step = __webpack_require__("d53b");
	var Iterators = __webpack_require__("84f2");
	var toIObject = __webpack_require__("6821");
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');
	
	
	/***/ }),
	
	/***/ "cb7c":
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__("d3f4");
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	
	
	/***/ }),
	
	/***/ "ce10":
	/***/ (function(module, exports, __webpack_require__) {
	
	var has = __webpack_require__("69a8");
	var toIObject = __webpack_require__("6821");
	var arrayIndexOf = __webpack_require__("c366")(false);
	var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};
	
	
	/***/ }),
	
	/***/ "d3f4":
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};
	
	
	/***/ }),
	
	/***/ "d53b":
	/***/ (function(module, exports) {
	
	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};
	
	
	/***/ }),
	
	/***/ "d6eb":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var prop = "_erd";
	
	function initState(element) {
	    element[prop] = {};
	    return getState(element);
	}
	
	function getState(element) {
	    return element[prop];
	}
	
	function cleanState(element) {
	    delete element[prop];
	}
	
	module.exports = {
	    initState: initState,
	    getState: getState,
	    cleanState: cleanState
	};
	
	
	/***/ }),
	
	/***/ "d864":
	/***/ (function(module, exports, __webpack_require__) {
	
	// optional / simple context binding
	var aFunction = __webpack_require__("79aa");
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};
	
	
	/***/ }),
	
	/***/ "d8e8":
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};
	
	
	/***/ }),
	
	/***/ "d9f6":
	/***/ (function(module, exports, __webpack_require__) {
	
	var anObject = __webpack_require__("e4ae");
	var IE8_DOM_DEFINE = __webpack_require__("794b");
	var toPrimitive = __webpack_require__("1bc3");
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__("8e60") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	
	/***/ }),
	
	/***/ "e11e":
	/***/ (function(module, exports) {
	
	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');
	
	
	/***/ }),
	
	/***/ "e279":
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GridLayout_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1156");
	/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GridLayout_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GridLayout_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
	/* unused harmony reexport * */
	 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GridLayout_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 
	
	/***/ }),
	
	/***/ "e4ae":
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__("f772");
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	
	
	/***/ }),
	
	/***/ "e53d":
	/***/ (function(module, exports) {
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	
	
	/***/ }),
	
	/***/ "eec4":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var forEach                 = __webpack_require__("b770").forEach;
	var elementUtilsMaker       = __webpack_require__("5be5");
	var listenerHandlerMaker    = __webpack_require__("49ad");
	var idGeneratorMaker        = __webpack_require__("2cef");
	var idHandlerMaker          = __webpack_require__("5058");
	var reporterMaker           = __webpack_require__("abb4");
	var browserDetector         = __webpack_require__("18e9");
	var batchProcessorMaker     = __webpack_require__("c274");
	var stateHandler            = __webpack_require__("d6eb");
	
	//Detection strategies.
	var objectStrategyMaker     = __webpack_require__("18d2");
	var scrollStrategyMaker     = __webpack_require__("c946");
	
	function isCollection(obj) {
	    return Array.isArray(obj) || obj.length !== undefined;
	}
	
	function toArray(collection) {
	    if (!Array.isArray(collection)) {
	        var array = [];
	        forEach(collection, function (obj) {
	            array.push(obj);
	        });
	        return array;
	    } else {
	        return collection;
	    }
	}
	
	function isElement(obj) {
	    return obj && obj.nodeType === 1;
	}
	
	/**
	 * @typedef idHandler
	 * @type {object}
	 * @property {function} get Gets the resize detector id of the element.
	 * @property {function} set Generate and sets the resize detector id of the element.
	 */
	
	/**
	 * @typedef Options
	 * @type {object}
	 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
	                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
	                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
	 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
	                                    If not provided, a default id handler will be used.
	 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
	                                    If not provided, a default id handler will be used.
	                                    If set to false, then nothing will be reported.
	 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
	 */
	
	/**
	 * Creates an element resize detector instance.
	 * @public
	 * @param {Options?} options Optional global options object that will decide how this instance will work.
	 */
	module.exports = function(options) {
	    options = options || {};
	
	    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var idHandler;
	
	    if (options.idHandler) {
	        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
	        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
	        idHandler = {
	            get: function (element) { return options.idHandler.get(element, true); },
	            set: options.idHandler.set
	        };
	    } else {
	        var idGenerator = idGeneratorMaker();
	        var defaultIdHandler = idHandlerMaker({
	            idGenerator: idGenerator,
	            stateHandler: stateHandler
	        });
	        idHandler = defaultIdHandler;
	    }
	
	    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var reporter = options.reporter;
	
	    if(!reporter) {
	        //If options.reporter is false, then the reporter should be quiet.
	        var quiet = reporter === false;
	        reporter = reporterMaker(quiet);
	    }
	
	    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));
	
	    //Options to be used as default for the listenTo function.
	    var globalOptions = {};
	    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
	    globalOptions.debug         = !!getOption(options, "debug", false);
	
	    var eventListenerHandler    = listenerHandlerMaker(idHandler);
	    var elementUtils            = elementUtilsMaker({
	        stateHandler: stateHandler
	    });
	
	    //The detection strategy to be used.
	    var detectionStrategy;
	    var desiredStrategy = getOption(options, "strategy", "object");
	    var strategyOptions = {
	        reporter: reporter,
	        batchProcessor: batchProcessor,
	        stateHandler: stateHandler,
	        idHandler: idHandler
	    };
	
	    if(desiredStrategy === "scroll") {
	        if (browserDetector.isLegacyOpera()) {
	            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
	            desiredStrategy = "object";
	        } else if (browserDetector.isIE(9)) {
	            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
	            desiredStrategy = "object";
	        }
	    }
	
	    if(desiredStrategy === "scroll") {
	        detectionStrategy = scrollStrategyMaker(strategyOptions);
	    } else if(desiredStrategy === "object") {
	        detectionStrategy = objectStrategyMaker(strategyOptions);
	    } else {
	        throw new Error("Invalid strategy name: " + desiredStrategy);
	    }
	
	    //Calls can be made to listenTo with elements that are still being installed.
	    //Also, same elements can occur in the elements list in the listenTo function.
	    //With this map, the ready callbacks can be synchronized between the calls
	    //so that the ready callback can always be called when an element is ready - even if
	    //it wasn't installed from the function itself.
	    var onReadyCallbacks = {};
	
	    /**
	     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
	     * @public
	     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
	     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
	     * @param {function} listener The callback to be executed for each resize event for each element.
	     */
	    function listenTo(options, elements, listener) {
	        function onResizeCallback(element) {
	            var listeners = eventListenerHandler.get(element);
	            forEach(listeners, function callListenerProxy(listener) {
	                listener(element);
	            });
	        }
	
	        function addListener(callOnAdd, element, listener) {
	            eventListenerHandler.add(element, listener);
	
	            if(callOnAdd) {
	                listener(element);
	            }
	        }
	
	        //Options object may be omitted.
	        if(!listener) {
	            listener = elements;
	            elements = options;
	            options = {};
	        }
	
	        if(!elements) {
	            throw new Error("At least one element required.");
	        }
	
	        if(!listener) {
	            throw new Error("Listener required.");
	        }
	
	        if (isElement(elements)) {
	            // A single element has been passed in.
	            elements = [elements];
	        } else if (isCollection(elements)) {
	            // Convert collection to array for plugins.
	            // TODO: May want to check so that all the elements in the collection are valid elements.
	            elements = toArray(elements);
	        } else {
	            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
	        }
	
	        var elementsReady = 0;
	
	        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
	        var onReadyCallback = getOption(options, "onReady", function noop() {});
	        var debug = getOption(options, "debug", globalOptions.debug);
	
	        forEach(elements, function attachListenerToElement(element) {
	            if (!stateHandler.getState(element)) {
	                stateHandler.initState(element);
	                idHandler.set(element);
	            }
	
	            var id = idHandler.get(element);
	
	            debug && reporter.log("Attaching listener to element", id, element);
	
	            if(!elementUtils.isDetectable(element)) {
	                debug && reporter.log(id, "Not detectable.");
	                if(elementUtils.isBusy(element)) {
	                    debug && reporter.log(id, "System busy making it detectable");
	
	                    //The element is being prepared to be detectable. Do not make it detectable.
	                    //Just add the listener, because the element will soon be detectable.
	                    addListener(callOnAdd, element, listener);
	                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
	                    onReadyCallbacks[id].push(function onReady() {
	                        elementsReady++;
	
	                        if(elementsReady === elements.length) {
	                            onReadyCallback();
	                        }
	                    });
	                    return;
	                }
	
	                debug && reporter.log(id, "Making detectable...");
	                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
	                elementUtils.markBusy(element, true);
	                return detectionStrategy.makeDetectable({ debug: debug }, element, function onElementDetectable(element) {
	                    debug && reporter.log(id, "onElementDetectable");
	
	                    if (stateHandler.getState(element)) {
	                        elementUtils.markAsDetectable(element);
	                        elementUtils.markBusy(element, false);
	                        detectionStrategy.addListener(element, onResizeCallback);
	                        addListener(callOnAdd, element, listener);
	
	                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
	                        // so that a resize event may be emitted.
	                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
	                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
	                        var state = stateHandler.getState(element);
	                        if (state && state.startSize) {
	                            var width = element.offsetWidth;
	                            var height = element.offsetHeight;
	                            if (state.startSize.width !== width || state.startSize.height !== height) {
	                                onResizeCallback(element);
	                            }
	                        }
	
	                        if(onReadyCallbacks[id]) {
	                            forEach(onReadyCallbacks[id], function(callback) {
	                                callback();
	                            });
	                        }
	                    } else {
	                        // The element has been unisntalled before being detectable.
	                        debug && reporter.log(id, "Element uninstalled before being detectable.");
	                    }
	
	                    delete onReadyCallbacks[id];
	
	                    elementsReady++;
	                    if(elementsReady === elements.length) {
	                        onReadyCallback();
	                    }
	                });
	            }
	
	            debug && reporter.log(id, "Already detecable, adding listener.");
	
	            //The element has been prepared to be detectable and is ready to be listened to.
	            addListener(callOnAdd, element, listener);
	            elementsReady++;
	        });
	
	        if(elementsReady === elements.length) {
	            onReadyCallback();
	        }
	    }
	
	    function uninstall(elements) {
	        if(!elements) {
	            return reporter.error("At least one element is required.");
	        }
	
	        if (isElement(elements)) {
	            // A single element has been passed in.
	            elements = [elements];
	        } else if (isCollection(elements)) {
	            // Convert collection to array for plugins.
	            // TODO: May want to check so that all the elements in the collection are valid elements.
	            elements = toArray(elements);
	        } else {
	            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
	        }
	
	        forEach(elements, function (element) {
	            eventListenerHandler.removeAllListeners(element);
	            detectionStrategy.uninstall(element);
	            stateHandler.cleanState(element);
	        });
	    }
	
	    return {
	        listenTo: listenTo,
	        removeListener: eventListenerHandler.removeListener,
	        removeAllListeners: eventListenerHandler.removeAllListeners,
	        uninstall: uninstall
	    };
	};
	
	function getOption(options, name, defaultValue) {
	    var value = options[name];
	
	    if((value === undefined || value === null) && defaultValue !== undefined) {
	        return defaultValue;
	    }
	
	    return value;
	}
	
	
	/***/ }),
	
	/***/ "f1ae":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var $defineProperty = __webpack_require__("86cc");
	var createDesc = __webpack_require__("4630");
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};
	
	
	/***/ }),
	
	/***/ "f6fd":
	/***/ (function(module, exports) {
	
	// document.currentScript polyfill by Adam Miller
	
	// MIT license
	
	(function(document){
	  var currentScript = "currentScript",
	      scripts = document.getElementsByTagName('script'); // Live NodeList collection
	
	  // If browser needs currentScript polyfill, add get currentScript() to the document object
	  if (!(currentScript in document)) {
	    Object.defineProperty(document, currentScript, {
	      get: function(){
	
	        // IE 6-10 supports script readyState
	        // IE 10+ support stack trace
	        try { throw new Error(); }
	        catch (err) {
	
	          // Find the second match for the "at" string to get file src url from stack.
	          // Specifically works with the format of stack traces in IE.
	          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];
	
	          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
	          for(i in scripts){
	            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
	              return scripts[i];
	            }
	          }
	
	          // If no match, return null
	          return null;
	        }
	      }
	    });
	  }
	})(document);
	
	
	/***/ }),
	
	/***/ "f772":
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};
	
	
	/***/ }),
	
	/***/ "fa5b":
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);
	
	
	/***/ }),
	
	/***/ "fab2":
	/***/ (function(module, exports, __webpack_require__) {
	
	var document = __webpack_require__("7726").document;
	module.exports = document && document.documentElement;
	
	
	/***/ }),
	
	/***/ "fb15":
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
	// This file is imported into lib/wc client bundles.
	
	if (typeof window !== 'undefined') {
	  if (true) {
	    __webpack_require__("f6fd")
	  }
	
	  var setPublicPath_i
	  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
	    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
	  }
	}
	
	// Indicate to webpack that this file can be concatenated
	/* harmony default export */ var setPublicPath = (null);
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
	var es6_function_name = __webpack_require__("7f7f");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
	var es6_array_iterator = __webpack_require__("cadf");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
	var es6_object_keys = __webpack_require__("456d");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
	var web_dom_iterable = __webpack_require__("ac6a");
	
	// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
	var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
	var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);
	
	// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0156aa68-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GridItem.vue?vue&type=template&id=e827a502&
	var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"item",staticClass:"vue-grid-item",class:_vm.classObj,style:(_vm.style)},[_vm._t("default"),(_vm.resizableAndNotStatic)?_c('span',{ref:"handle",class:_vm.resizableHandleClass}):_vm._e()],2)}
	var staticRenderFns = []
	
	
	// CONCATENATED MODULE: ./src/components/GridItem.vue?vue&type=template&id=e827a502&
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.match.js
	var es6_regexp_match = __webpack_require__("4917");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
	var es6_number_constructor = __webpack_require__("c5f6");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
	var es6_regexp_replace = __webpack_require__("a481");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.sort.js
	var es6_array_sort = __webpack_require__("55dd");
	
	// CONCATENATED MODULE: ./src/helpers/utils.js
	
	
	
	
	
	// @flow
	
	/*:: export type LayoutItemRequired = {w: number, h: number, x: number, y: number, i: string};*/
	
	/*:: export type LayoutItem = LayoutItemRequired &
	                         {minW?: number, minH?: number, maxW?: number, maxH?: number,
	                          moved?: boolean, static?: boolean,
	                          isDraggable?: ?boolean, isResizable?: ?boolean};*/
	
	// export type Position = {left: number, top: number, width: number, height: number};
	
	/*
	export type DragCallbackData = {
	  node: HTMLElement,
	  x: number, y: number,
	  deltaX: number, deltaY: number,
	  lastX: number, lastY: number
	};
	*/
	// export type DragEvent = {e: Event} & DragCallbackData;
	
	/*:: export type Layout = Array<LayoutItem>;*/
	
	// export type ResizeEvent = {e: Event, node: HTMLElement, size: Size};
	// const isProduction = process.env.NODE_ENV === 'production';
	
	/**
	 * Return the bottom coordinate of the layout.
	 *
	 * @param  {Array} layout Layout array.
	 * @return {Number}       Bottom coordinate.
	 */
	
	/*:: export type Size = {width: number, height: number};*/
	
	function bottom(layout
	/*: Layout*/
	)
	/*: number*/
	{
	  var max = 0,
	      bottomY;
	
	  for (var i = 0, len = layout.length; i < len; i++) {
	    bottomY = layout[i].y + layout[i].h;
	    if (bottomY > max) max = bottomY;
	  }
	
	  return max;
	}
	function cloneLayout(layout
	/*: Layout*/
	)
	/*: Layout*/
	{
	  var newLayout = Array(layout.length);
	
	  for (var i = 0, len = layout.length; i < len; i++) {
	    newLayout[i] = cloneLayoutItem(layout[i]);
	  }
	
	  return newLayout;
	} // Fast path to cloning, since this is monomorphic
	
	function cloneLayoutItem(layoutItem
	/*: LayoutItem*/
	)
	/*: LayoutItem*/
	{
	  /*return {
	    w: layoutItem.w, h: layoutItem.h, x: layoutItem.x, y: layoutItem.y, i: layoutItem.i,
	    minW: layoutItem.minW, maxW: layoutItem.maxW, minH: layoutItem.minH, maxH: layoutItem.maxH,
	    moved: Boolean(layoutItem.moved), static: Boolean(layoutItem.static),
	    // These can be null
	    isDraggable: layoutItem.isDraggable, isResizable: layoutItem.isResizable
	  };*/
	  return JSON.parse(JSON.stringify(layoutItem));
	}
	/**
	 * Given two layoutitems, check if they collide.
	 *
	 * @return {Boolean}   True if colliding.
	 */
	
	function collides(l1
	/*: LayoutItem*/
	, l2
	/*: LayoutItem*/
	)
	/*: boolean*/
	{
	  if (l1 === l2) return false; // same element
	
	  if (l1.x + l1.w <= l2.x) return false; // l1 is left of l2
	
	  if (l1.x >= l2.x + l2.w) return false; // l1 is right of l2
	
	  if (l1.y + l1.h <= l2.y) return false; // l1 is above l2
	
	  if (l1.y >= l2.y + l2.h) return false; // l1 is below l2
	
	  return true; // boxes overlap
	}
	/**
	 * Given a layout, compact it. This involves going down each y coordinate and removing gaps
	 * between items.
	 *
	 * @param  {Array} layout Layout.
	 * @param  {Boolean} verticalCompact Whether or not to compact the layout
	 *   vertically.
	 * @return {Array}       Compacted Layout.
	 */
	
	function compact(layout
	/*: Layout*/
	, verticalCompact
	/*: Boolean*/
	)
	/*: Layout*/
	{
	  // Statics go in the compareWith array right away so items flow around them.
	  var compareWith = getStatics(layout); // We go through the items by row and column.
	
	  var sorted = sortLayoutItemsByRowCol(layout); // Holding for new items.
	
	  var out = Array(layout.length);
	
	  for (var i = 0, len = sorted.length; i < len; i++) {
	    var l = sorted[i]; // Don't move static elements
	
	    if (!l.static) {
	      l = compactItem(compareWith, l, verticalCompact); // Add to comparison array. We only collide with items before this one.
	      // Statics are already in this array.
	
	      compareWith.push(l);
	    } // Add to output array to make sure they still come out in the right order.
	
	
	    out[layout.indexOf(l)] = l; // Clear moved flag, if it exists.
	
	    l.moved = false;
	  }
	
	  return out;
	}
	/**
	 * Compact an item in the layout.
	 */
	
	function compactItem(compareWith
	/*: Layout*/
	, l
	/*: LayoutItem*/
	, verticalCompact
	/*: boolean*/
	)
	/*: LayoutItem*/
	{
	  if (verticalCompact) {
	    // Move the element up as far as it can go without colliding.
	    while (l.y > 0 && !getFirstCollision(compareWith, l)) {
	      l.y--;
	    }
	  } // Move it down, and keep moving it down if it's colliding.
	
	
	  var collides;
	
	  while (collides = getFirstCollision(compareWith, l)) {
	    l.y = collides.y + collides.h;
	  }
	
	  return l;
	}
	/**
	 * Given a layout, make sure all elements fit within its bounds.
	 *
	 * @param  {Array} layout Layout array.
	 * @param  {Number} bounds Number of columns.
	 */
	
	function correctBounds(layout
	/*: Layout*/
	, bounds
	/*: {cols: number}*/
	)
	/*: Layout*/
	{
	  var collidesWith = getStatics(layout);
	
	  for (var i = 0, len = layout.length; i < len; i++) {
	    var l = layout[i]; // Overflows right
	
	    if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w; // Overflows left
	
	    if (l.x < 0) {
	      l.x = 0;
	      l.w = bounds.cols;
	    }
	
	    if (!l.static) collidesWith.push(l);else {
	      // If this is static and collides with other statics, we must move it down.
	      // We have to do something nicer than just letting them overlap.
	      while (getFirstCollision(collidesWith, l)) {
	        l.y++;
	      }
	    }
	  }
	
	  return layout;
	}
	/**
	 * Get a layout item by ID. Used so we can override later on if necessary.
	 *
	 * @param  {Array}  layout Layout array.
	 * @param  {String} id     ID
	 * @return {LayoutItem}    Item at ID.
	 */
	
	function getLayoutItem(layout
	/*: Layout*/
	, id
	/*: string*/
	)
	/*: ?LayoutItem*/
	{
	  for (var i = 0, len = layout.length; i < len; i++) {
	    if (layout[i].i === id) return layout[i];
	  }
	}
	/**
	 * Returns the first item this layout collides with.
	 * It doesn't appear to matter which order we approach this from, although
	 * perhaps that is the wrong thing to do.
	 *
	 * @param  {Object} layoutItem Layout item.
	 * @return {Object|undefined}  A colliding layout item, or undefined.
	 */
	
	function getFirstCollision(layout
	/*: Layout*/
	, layoutItem
	/*: LayoutItem*/
	)
	/*: ?LayoutItem*/
	{
	  for (var i = 0, len = layout.length; i < len; i++) {
	    if (collides(layout[i], layoutItem)) return layout[i];
	  }
	}
	function getAllCollisions(layout
	/*: Layout*/
	, layoutItem
	/*: LayoutItem*/
	)
	/*: Array<LayoutItem>*/
	{
	  return layout.filter(function (l) {
	    return collides(l, layoutItem);
	  });
	}
	/**
	 * Get all static elements.
	 * @param  {Array} layout Array of layout objects.
	 * @return {Array}        Array of static layout items..
	 */
	
	function getStatics(layout
	/*: Layout*/
	)
	/*: Array<LayoutItem>*/
	{
	  //return [];
	  return layout.filter(function (l) {
	    return l.static;
	  });
	}
	/**
	 * Move an element. Responsible for doing cascading movements of other elements.
	 *
	 * @param  {Array}      layout Full layout to modify.
	 * @param  {LayoutItem} l      element to move.
	 * @param  {Number}     [x]    X position in grid units.
	 * @param  {Number}     [y]    Y position in grid units.
	 * @param  {Boolean}    [isUserAction] If true, designates that the item we're moving is
	 *                                     being dragged/resized by th euser.
	 */
	
	function moveElement(layout
	/*: Layout*/
	, l
	/*: LayoutItem*/
	, x
	/*: Number*/
	, y
	/*: Number*/
	, isUserAction
	/*: Boolean*/
	, preventCollision
	/*: Boolean*/
	)
	/*: Layout*/
	{
	  if (l.static) return layout; // Short-circuit if nothing to do.
	  //if (l.y === y && l.x === x) return layout;
	
	  var oldX = l.x;
	  var oldY = l.y;
	  var movingUp = y && l.y > y; // This is quite a bit faster than extending the object
	
	  if (typeof x === 'number') l.x = x;
	  if (typeof y === 'number') l.y = y;
	  l.moved = true; // If this collides with anything, move it.
	  // When doing this comparison, we have to sort the items we compare with
	  // to ensure, in the case of multiple collisions, that we're getting the
	  // nearest collision.
	
	  var sorted = sortLayoutItemsByRowCol(layout);
	  if (movingUp) sorted = sorted.reverse();
	  var collisions = getAllCollisions(sorted, l);
	
	  if (preventCollision && collisions.length) {
	    l.x = oldX;
	    l.y = oldY;
	    l.moved = false;
	    return layout;
	  } // Move each item that collides away from this element.
	
	
	  for (var i = 0, len = collisions.length; i < len; i++) {
	    var collision = collisions[i]; // console.log('resolving collision between', l.i, 'at', l.y, 'and', collision.i, 'at', collision.y);
	    // Short circuit so we can't infinite loop
	
	    if (collision.moved) continue; // This makes it feel a bit more precise by waiting to swap for just a bit when moving up.
	
	    if (l.y > collision.y && l.y - collision.y > collision.h / 4) continue; // Don't move static items - we have to move *this* element away
	
	    if (collision.static) {
	      layout = moveElementAwayFromCollision(layout, collision, l, isUserAction);
	    } else {
	      layout = moveElementAwayFromCollision(layout, l, collision, isUserAction);
	    }
	  }
	
	  return layout;
	}
	/**
	 * This is where the magic needs to happen - given a collision, move an element away from the collision.
	 * We attempt to move it up if there's room, otherwise it goes below.
	 *
	 * @param  {Array} layout            Full layout to modify.
	 * @param  {LayoutItem} collidesWith Layout item we're colliding with.
	 * @param  {LayoutItem} itemToMove   Layout item we're moving.
	 * @param  {Boolean} [isUserAction]  If true, designates that the item we're moving is being dragged/resized
	 *                                   by the user.
	 */
	
	function moveElementAwayFromCollision(layout
	/*: Layout*/
	, collidesWith
	/*: LayoutItem*/
	, itemToMove
	/*: LayoutItem*/
	, isUserAction
	/*: ?boolean*/
	)
	/*: Layout*/
	{
	  var preventCollision = false; // we're already colliding
	  // If there is enough space above the collision to put this element, move it there.
	  // We only do this on the main collision as this can get funky in cascades and cause
	  // unwanted swapping behavior.
	
	  if (isUserAction) {
	    // Make a mock item so we don't modify the item here, only modify in moveElement.
	    var fakeItem
	    /*: LayoutItem*/
	    = {
	      x: itemToMove.x,
	      y: itemToMove.y,
	      w: itemToMove.w,
	      h: itemToMove.h,
	      i: '-1'
	    };
	    fakeItem.y = Math.max(collidesWith.y - itemToMove.h, 0);
	
	    if (!getFirstCollision(layout, fakeItem)) {
	      return moveElement(layout, itemToMove, undefined, fakeItem.y, preventCollision);
	    }
	  } // Previously this was optimized to move below the collision directly, but this can cause problems
	  // with cascading moves, as an item may actually leapflog a collision and cause a reversal in order.
	
	
	  return moveElement(layout, itemToMove, undefined, itemToMove.y + 1, preventCollision);
	}
	/**
	 * Helper to convert a number to a percentage string.
	 *
	 * @param  {Number} num Any number
	 * @return {String}     That number as a percentage.
	 */
	
	function perc(num
	/*: number*/
	)
	/*: string*/
	{
	  return num * 100 + '%';
	}
	function setTransform(top, left, width, height)
	/*: Object*/
	{
	  // Replace unitless items with px
	  var translate = "translate3d(" + left + "px," + top + "px, 0)";
	  return {
	    transform: translate,
	    WebkitTransform: translate,
	    MozTransform: translate,
	    msTransform: translate,
	    OTransform: translate,
	    width: width + "px",
	    height: height + "px",
	    position: 'absolute'
	  };
	}
	/**
	 * Just like the setTransform method, but instead it will return a negative value of right.
	 *
	 * @param top
	 * @param right
	 * @param width
	 * @param height
	 * @returns {{transform: string, WebkitTransform: string, MozTransform: string, msTransform: string, OTransform: string, width: string, height: string, position: string}}
	 */
	
	function setTransformRtl(top, right, width, height)
	/*: Object*/
	{
	  // Replace unitless items with px
	  var translate = "translate3d(" + right * -1 + "px," + top + "px, 0)";
	  return {
	    transform: translate,
	    WebkitTransform: translate,
	    MozTransform: translate,
	    msTransform: translate,
	    OTransform: translate,
	    width: width + "px",
	    height: height + "px",
	    position: 'absolute'
	  };
	}
	function setTopLeft(top, left, width, height)
	/*: Object*/
	{
	  return {
	    top: top + "px",
	    left: left + "px",
	    width: width + "px",
	    height: height + "px",
	    position: 'absolute'
	  };
	}
	/**
	 * Just like the setTopLeft method, but instead, it will return a right property instead of left.
	 *
	 * @param top
	 * @param right
	 * @param width
	 * @param height
	 * @returns {{top: string, right: string, width: string, height: string, position: string}}
	 */
	
	function setTopRight(top, right, width, height)
	/*: Object*/
	{
	  return {
	    top: top + "px",
	    right: right + "px",
	    width: width + "px",
	    height: height + "px",
	    position: 'absolute'
	  };
	}
	/**
	 * Get layout items sorted from top left to right and down.
	 *
	 * @return {Array} Array of layout objects.
	 * @return {Array}        Layout, sorted static items first.
	 */
	
	function sortLayoutItemsByRowCol(layout
	/*: Layout*/
	)
	/*: Layout*/
	{
	  return [].concat(layout).sort(function (a, b) {
	    if (a.y > b.y || a.y === b.y && a.x > b.x) {
	      return 1;
	    }
	
	    return -1;
	  });
	}
	/**
	 * Generate a layout using the initialLayout and children as a template.
	 * Missing entries will be added, extraneous ones will be truncated.
	 *
	 * @param  {Array}  initialLayout Layout passed in through props.
	 * @param  {String} breakpoint    Current responsive breakpoint.
	 * @param  {Boolean} verticalCompact Whether or not to compact the layout vertically.
	 * @return {Array}                Working layout.
	 */
	
	/*
	export function synchronizeLayoutWithChildren(initialLayout: Layout, children: Array<React.Element>|React.Element,
	                                              cols: number, verticalCompact: boolean): Layout {
	  // ensure 'children' is always an array
	  if (!Array.isArray(children)) {
	    children = [children];
	  }
	  initialLayout = initialLayout || [];
	
	  // Generate one layout item per child.
	  let layout: Layout = [];
	  for (let i = 0, len = children.length; i < len; i++) {
	    let newItem;
	    const child = children[i];
	
	    // Don't overwrite if it already exists.
	    const exists = getLayoutItem(initialLayout, child.key || "1" /!* FIXME satisfies Flow *!/);
	    if (exists) {
	      newItem = exists;
	    } else {
	      const g = child.props._grid;
	
	      // Hey, this item has a _grid property, use it.
	      if (g) {
	        if (!isProduction) {
	          validateLayout([g], 'ReactGridLayout.children');
	        }
	        // Validated; add it to the layout. Bottom 'y' possible is the bottom of the layout.
	        // This allows you to do nice stuff like specify {y: Infinity}
	        if (verticalCompact) {
	          newItem = cloneLayoutItem({...g, y: Math.min(bottom(layout), g.y), i: child.key});
	        } else {
	          newItem = cloneLayoutItem({...g, y: g.y, i: child.key});
	        }
	      }
	      // Nothing provided: ensure this is added to the bottom
	      else {
	        newItem = cloneLayoutItem({w: 1, h: 1, x: 0, y: bottom(layout), i: child.key || "1"});
	      }
	    }
	    layout[i] = newItem;
	  }
	
	  // Correct the layout.
	  layout = correctBounds(layout, {cols: cols});
	  layout = compact(layout, verticalCompact);
	
	  return layout;
	}
	*/
	
	/**
	 * Validate a layout. Throws errors.
	 *
	 * @param  {Array}  layout        Array of layout items.
	 * @param  {String} [contextName] Context name for errors.
	 * @throw  {Error}                Validation error.
	 */
	
	function validateLayout(layout
	/*: Layout*/
	, contextName
	/*: string*/
	)
	/*: void*/
	{
	  contextName = contextName || "Layout";
	  var subProps = ['x', 'y', 'w', 'h'];
	  if (!Array.isArray(layout)) throw new Error(contextName + " must be an array!");
	
	  for (var i = 0, len = layout.length; i < len; i++) {
	    var item = layout[i];
	
	    for (var j = 0; j < subProps.length; j++) {
	      if (typeof item[subProps[j]] !== 'number') {
	        throw new Error('VueGridLayout: ' + contextName + '[' + i + '].' + subProps[j] + ' must be a number!');
	      }
	    }
	
	    if (item.i && typeof item.i !== 'string') {// number is also ok, so comment the error
	      // TODO confirm if commenting the line below doesn't cause unexpected problems
	      // throw new Error('VueGridLayout: ' + contextName + '[' + i + '].i must be a string!');
	    }
	
	    if (item.static !== undefined && typeof item.static !== 'boolean') {
	      throw new Error('VueGridLayout: ' + contextName + '[' + i + '].static must be a boolean!');
	    }
	  }
	} // Flow can't really figure this out, so we just use Object
	
	function autoBindHandlers(el
	/*: Object*/
	, fns
	/*: Array<string>*/
	)
	/*: void*/
	{
	  fns.forEach(function (key) {
	    return el[key] = el[key].bind(el);
	  });
	}
	/**
	 * Convert a JS object to CSS string. Similar to React's output of CSS.
	 * @param obj
	 * @returns {string}
	 */
	
	function createMarkup(obj) {
	  var keys = Object.keys(obj);
	  if (!keys.length) return '';
	  var i,
	      len = keys.length;
	  var result = '';
	
	  for (i = 0; i < len; i++) {
	    var key = keys[i];
	    var val = obj[key];
	    result += hyphenate(key) + ':' + addPx(key, val) + ';';
	  }
	
	  return result;
	}
	/* The following list is defined in React's core */
	
	var IS_UNITLESS = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	/**
	 * Will add px to the end of style values which are Numbers.
	 * @param name
	 * @param value
	 * @returns {*}
	 */
	
	function addPx(name, value) {
	  if (typeof value === 'number' && !IS_UNITLESS[name]) {
	    return value + 'px';
	  } else {
	    return value;
	  }
	}
	/**
	 * Hyphenate a camelCase string.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	
	var hyphenateRE = /([a-z\d])([A-Z])/g;
	function hyphenate(str) {
	  return str.replace(hyphenateRE, '$1-$2').toLowerCase();
	}
	function findItemInArray(array, property, value) {
	  for (var i = 0; i < array.length; i++) {
	    if (array[i][property] == value) return true;
	  }
	
	  return false;
	}
	function findAndRemove(array, property, value) {
	  array.forEach(function (result, index) {
	    if (result[property] === value) {
	      //Remove from array
	      array.splice(index, 1);
	    }
	  });
	}
	// CONCATENATED MODULE: ./src/helpers/draggableUtils.js
	// Get {x, y} positions from event.
	function getControlPosition(e) {
	  return offsetXYFromParentOf(e);
	} // Get from offsetParent
	
	function offsetXYFromParentOf(evt) {
	  var offsetParent = evt.target.offsetParent || document.body;
	  var offsetParentRect = evt.offsetParent === document.body ? {
	    left: 0,
	    top: 0
	  } : offsetParent.getBoundingClientRect();
	  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
	  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;
	  /*const x = Math.round(evt.clientX + offsetParent.scrollLeft - offsetParentRect.left);
	  const y = Math.round(evt.clientY + offsetParent.scrollTop - offsetParentRect.top);*/
	
	  return {
	    x: x,
	    y: y
	  };
	} // Create an data object exposed by <DraggableCore>'s events
	
	function createCoreData(lastX, lastY, x, y) {
	  // State changes are often (but not always!) async. We want the latest value.
	  var isStart = !isNum(lastX);
	
	  if (isStart) {
	    // If this is our first move, use the x and y as last coords.
	    return {
	      deltaX: 0,
	      deltaY: 0,
	      lastX: x,
	      lastY: y,
	      x: x,
	      y: y
	    };
	  } else {
	    // Otherwise calculate proper values.
	    return {
	      deltaX: x - lastX,
	      deltaY: y - lastY,
	      lastX: lastX,
	      lastY: lastY,
	      x: x,
	      y: y
	    };
	  }
	}
	
	function isNum(num) {
	  return typeof num === 'number' && !isNaN(num);
	}
	// CONCATENATED MODULE: ./src/helpers/DOM.js
	var currentDir
	/*: "ltr" | "rtl" | "auto"*/
	= "auto"; // let currentDir = "auto";
	
	function hasDocument() {
	  return typeof document !== "undefined";
	}
	
	function hasWindow() {
	  return typeof window !== "undefined";
	}
	
	function getDocumentDir() {
	  if (!hasDocument()) {
	    return currentDir;
	  }
	
	  var direction = typeof document.dir !== "undefined" ? document.dir : document.getElementsByTagName("html")[0].getAttribute("dir");
	  return direction;
	}
	function setDocumentDir(dir
	/*: "ltr" | "rtl" | "auto"*/
	) {
	  // export function setDocumentDir(dir){
	  if (!hasDocument) {
	    currentDir = dir;
	    return;
	  }
	
	  var html = document.getElementsByTagName("html")[0];
	  html.setAttribute("dir", dir);
	}
	function addWindowEventListener(event
	/*:string*/
	, callback
	/*: () => mixed*/
	) {
	  if (!hasWindow) {
	    callback();
	    return;
	  }
	
	  window.addEventListener(event, callback);
	}
	function removeWindowEventListener(event
	/*:string*/
	, callback
	/*: () => mixed*/
	) {
	  if (!hasWindow) {
	    return;
	  }
	
	  window.removeEventListener(event, callback);
	}
	// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GridItem.vue?vue&type=script&lang=js&
	
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	 //    var eventBus = require('./eventBus');
	
	var interact = __webpack_require__("fb3a");
	
	/* harmony default export */ var GridItemvue_type_script_lang_js_ = ({
	  name: "GridItem",
	  props: {
	    /*cols: {
	     type: Number,
	     required: true
	     },*/
	
	    /*containerWidth: {
	     type: Number,
	     required: true
	      },
	     rowHeight: {
	     type: Number,
	     required: true
	     },
	     margin: {
	     type: Array,
	     required: true
	     },
	     maxRows: {
	     type: Number,
	     required: true
	     },*/
	    isDraggable: {
	      type: Boolean,
	      required: false,
	      default: null
	    },
	    isResizable: {
	      type: Boolean,
	      required: false,
	      default: null
	    },
	
	    /*useCssTransforms: {
	     type: Boolean,
	     required: true
	     },
	     */
	    static: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	    minH: {
	      type: Number,
	      required: false,
	      default: 1
	    },
	    minW: {
	      type: Number,
	      required: false,
	      default: 1
	    },
	    maxH: {
	      type: Number,
	      required: false,
	      default: Infinity
	    },
	    maxW: {
	      type: Number,
	      required: false,
	      default: Infinity
	    },
	    x: {
	      type: Number,
	      required: true
	    },
	    y: {
	      type: Number,
	      required: true
	    },
	    w: {
	      type: Number,
	      required: true
	    },
	    h: {
	      type: Number,
	      required: true
	    },
	    i: {
	      required: true
	    },
	    dragIgnoreFrom: {
	      type: String,
	      required: false,
	      default: 'a, button'
	    },
	    dragAllowFrom: {
	      type: String,
	      required: false,
	      default: null
	    },
	    resizeIgnoreFrom: {
	      type: String,
	      required: false,
	      default: 'a, button'
	    }
	  },
	  inject: ["eventBus"],
	  data: function data() {
	    return {
	      cols: 1,
	      containerWidth: 100,
	      rowHeight: 30,
	      margin: [10, 10],
	      maxRows: Infinity,
	      draggable: null,
	      resizable: null,
	      useCssTransforms: true,
	      isDragging: false,
	      dragging: null,
	      isResizing: false,
	      resizing: null,
	      lastX: NaN,
	      lastY: NaN,
	      lastW: NaN,
	      lastH: NaN,
	      style: {},
	      rtl: false,
	      dragEventSet: false,
	      resizeEventSet: false,
	      previousW: null,
	      previousH: null,
	      previousX: null,
	      previousY: null,
	      innerX: this.x,
	      innerY: this.y,
	      innerW: this.w,
	      innerH: this.h
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    var self = this; // Accessible refernces of functions for removing in beforeDestroy
	
	    self.updateWidthHandler = function (width) {
	      self.updateWidth(width);
	    };
	
	    self.compactHandler = function (layout) {
	      self.compact(layout);
	    };
	
	    self.setDraggableHandler = function (isDraggable) {
	      if (self.isDraggable === null) {
	        self.draggable = isDraggable;
	      }
	    };
	
	    self.setResizableHandler = function (isResizable) {
	      if (self.isResizable === null) {
	        self.resizable = isResizable;
	      }
	    };
	
	    self.setRowHeightHandler = function (rowHeight) {
	      self.rowHeight = rowHeight;
	    };
	
	    self.setMaxRowsHandler = function (maxRows) {
	      self.maxRows = maxRows;
	    };
	
	    self.directionchangeHandler = function () {
	      _this.rtl = getDocumentDir() === 'rtl';
	
	      _this.compact();
	    };
	
	    self.setColNum = function (colNum) {
	      self.cols = parseInt(colNum);
	    };
	
	    this.eventBus.$on('updateWidth', self.updateWidthHandler);
	    this.eventBus.$on('compact', self.compactHandler);
	    this.eventBus.$on('setDraggable', self.setDraggableHandler);
	    this.eventBus.$on('setResizable', self.setResizableHandler);
	    this.eventBus.$on('setRowHeight', self.setRowHeightHandler);
	    this.eventBus.$on('setMaxRows', self.setMaxRowsHandler);
	    this.eventBus.$on('directionchange', self.directionchangeHandler);
	    this.eventBus.$on('setColNum', self.setColNum);
	    this.rtl = getDocumentDir() === 'rtl';
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this; //Remove listeners
	
	    this.eventBus.$off('updateWidth', self.updateWidthHandler);
	    this.eventBus.$off('compact', self.compactHandler);
	    this.eventBus.$off('setDraggable', self.setDraggableHandler);
	    this.eventBus.$off('setResizable', self.setResizableHandler);
	    this.eventBus.$off('setRowHeight', self.setRowHeightHandler);
	    this.eventBus.$off('setMaxRows', self.setMaxRowsHandler);
	    this.eventBus.$off('directionchange', self.directionchangeHandler);
	    this.eventBus.$off('setColNum', self.setColNum);
	    this.interactObj.unset(); // destroy interact intance
	  },
	  mounted: function mounted() {
	    this.cols = this.$parent.colNum;
	    this.rowHeight = this.$parent.rowHeight;
	    this.containerWidth = this.$parent.width !== null ? this.$parent.width : 100;
	    this.margin = this.$parent.margin !== undefined ? this.$parent.margin : [10, 10];
	    this.maxRows = this.$parent.maxRows;
	
	    if (this.isDraggable === null) {
	      this.draggable = this.$parent.isDraggable;
	    } else {
	      this.draggable = this.isDraggable;
	    }
	
	    if (this.isResizable === null) {
	      this.resizable = this.$parent.isResizable;
	    } else {
	      this.resizable = this.isResizable;
	    }
	
	    this.useCssTransforms = this.$parent.useCssTransforms;
	    this.createStyle();
	  },
	  watch: {
	    isDraggable: function isDraggable() {
	      this.draggable = this.isDraggable;
	    },
	    static: function _static() {
	      this.tryMakeDraggable();
	      this.tryMakeResizable();
	    },
	    draggable: function draggable() {
	      this.tryMakeDraggable();
	    },
	    isResizable: function isResizable() {
	      this.resizable = this.isResizable;
	    },
	    resizable: function resizable() {
	      this.tryMakeResizable();
	    },
	    rowHeight: function rowHeight() {
	      this.createStyle();
	      this.emitContainerResized();
	    },
	    cols: function cols() {
	      this.tryMakeResizable();
	      this.createStyle();
	      this.emitContainerResized();
	    },
	    containerWidth: function containerWidth() {
	      this.tryMakeResizable();
	      this.createStyle();
	      this.emitContainerResized();
	    },
	    x: function x(newVal) {
	      this.innerX = newVal;
	      this.createStyle();
	    },
	    y: function y(newVal) {
	      this.innerY = newVal;
	      this.createStyle();
	    },
	    h: function h(newVal) {
	      this.innerH = newVal;
	      this.createStyle(); // this.emitContainerResized();
	    },
	    w: function w(newVal) {
	      this.innerW = newVal;
	      this.createStyle(); // this.emitContainerResized();
	    },
	    renderRtl: function renderRtl() {
	      // console.log("### renderRtl");
	      this.tryMakeResizable();
	      this.createStyle();
	    },
	    minH: function minH() {
	      this.tryMakeResizable();
	    },
	    maxH: function maxH() {
	      this.tryMakeResizable();
	    },
	    minW: function minW() {
	      this.tryMakeResizable();
	    },
	    maxW: function maxW() {
	      this.tryMakeResizable();
	    }
	  },
	  computed: {
	    classObj: function classObj() {
	      return {
	        'vue-resizable': this.resizableAndNotStatic,
	        'static': this.static,
	        'resizing': this.isResizing,
	        'vue-draggable-dragging': this.isDragging,
	        'cssTransforms': this.useCssTransforms,
	        'render-rtl': this.renderRtl,
	        'disable-userselect': this.isDragging,
	        'no-touch': this.isAndroid && this.draggableOrResizableAndNotStatic
	      };
	    },
	    resizableAndNotStatic: function resizableAndNotStatic() {
	      return this.resizable && !this.static;
	    },
	    draggableOrResizableAndNotStatic: function draggableOrResizableAndNotStatic() {
	      return (this.draggable || this.resizable) && !this.static;
	    },
	    isAndroid: function isAndroid() {
	      return navigator.userAgent.toLowerCase().indexOf("android") !== -1;
	    },
	    renderRtl: function renderRtl() {
	      return this.$parent.isMirrored ? !this.rtl : this.rtl;
	    },
	    resizableHandleClass: function resizableHandleClass() {
	      if (this.renderRtl) {
	        return 'vue-resizable-handle vue-rtl-resizable-handle';
	      } else {
	        return 'vue-resizable-handle';
	      }
	    }
	  },
	  methods: {
	    createStyle: function createStyle() {
	      if (this.x + this.w > this.cols) {
	        this.innerX = 0;
	        this.innerW = this.w > this.cols ? this.cols : this.w;
	      } else {
	        this.innerX = this.x;
	        this.innerW = this.w;
	      }
	
	      var pos = this.calcPosition(this.innerX, this.innerY, this.innerW, this.innerH);
	
	      if (this.isDragging) {
	        pos.top = this.dragging.top; //                    Add rtl support
	
	        if (this.renderRtl) {
	          pos.right = this.dragging.left;
	        } else {
	          pos.left = this.dragging.left;
	        }
	      }
	
	      if (this.isResizing) {
	        pos.width = this.resizing.width;
	        pos.height = this.resizing.height;
	      }
	
	      var style; // CSS Transforms support (default)
	
	      if (this.useCssTransforms) {
	        //                    Add rtl support
	        if (this.renderRtl) {
	          style = setTransformRtl(pos.top, pos.right, pos.width, pos.height);
	        } else {
	          style = setTransform(pos.top, pos.left, pos.width, pos.height);
	        }
	      } else {
	        // top,left (slow)
	        //                    Add rtl support
	        if (this.renderRtl) {
	          style = setTopRight(pos.top, pos.right, pos.width, pos.height);
	        } else {
	          style = setTopLeft(pos.top, pos.left, pos.width, pos.height);
	        }
	      }
	
	      this.style = style;
	    },
	    emitContainerResized: function emitContainerResized() {
	      // this.style has width and height with trailing 'px'. The
	      // resized event is without them
	      var styleProps = {};
	
	      for (var _i = 0, _arr = ['width', 'height']; _i < _arr.length; _i++) {
	        var prop = _arr[_i];
	        var val = this.style[prop];
	        var matches = val.match(/^(\d+)px$/);
	        if (!matches) return;
	        styleProps[prop] = matches[1];
	      }
	
	      this.$emit("container-resized", this.i, this.h, this.w, styleProps.height, styleProps.width);
	    },
	    handleResize: function handleResize(event) {
	      if (this.static) return;
	      var position = getControlPosition(event); // Get the current drag point from the event. This is used as the offset.
	
	      if (position == null) return; // not possible but satisfies flow
	
	      var x = position.x,
	          y = position.y;
	      var newSize = {
	        width: 0,
	        height: 0
	      };
	      var pos;
	
	      switch (event.type) {
	        case "resizestart":
	          {
	            this.previousW = this.innerW;
	            this.previousH = this.innerH;
	            pos = this.calcPosition(this.innerX, this.innerY, this.innerW, this.innerH);
	            newSize.width = pos.width;
	            newSize.height = pos.height;
	            this.resizing = newSize;
	            this.isResizing = true;
	            break;
	          }
	
	        case "resizemove":
	          {
	            //                        console.log("### resize => " + event.type + ", lastW=" + this.lastW + ", lastH=" + this.lastH);
	            var coreEvent = createCoreData(this.lastW, this.lastH, x, y);
	
	            if (this.renderRtl) {
	              newSize.width = this.resizing.width - coreEvent.deltaX;
	            } else {
	              newSize.width = this.resizing.width + coreEvent.deltaX;
	            }
	
	            newSize.height = this.resizing.height + coreEvent.deltaY; ///console.log("### resize => " + event.type + ", deltaX=" + coreEvent.deltaX + ", deltaY=" + coreEvent.deltaY);
	
	            this.resizing = newSize;
	            break;
	          }
	
	        case "resizeend":
	          {
	            //console.log("### resize end => x=" +this.innerX + " y=" + this.innerY + " w=" + this.innerW + " h=" + this.innerH);
	            pos = this.calcPosition(this.innerX, this.innerY, this.innerW, this.innerH);
	            newSize.width = pos.width;
	            newSize.height = pos.height; //                        console.log("### resize end => " + JSON.stringify(newSize));
	
	            this.resizing = null;
	            this.isResizing = false;
	            break;
	          }
	      } // Get new WH
	
	
	      pos = this.calcWH(newSize.height, newSize.width);
	
	      if (pos.w < this.minW) {
	        pos.w = this.minW;
	      }
	
	      if (pos.w > this.maxW) {
	        pos.w = this.maxW;
	      }
	
	      if (pos.h < this.minH) {
	        pos.h = this.minH;
	      }
	
	      if (pos.h > this.maxH) {
	        pos.h = this.maxH;
	      }
	
	      if (pos.h < 1) {
	        pos.h = 1;
	      }
	
	      if (pos.w < 1) {
	        pos.w = 1;
	      }
	
	      this.lastW = x;
	      this.lastH = y;
	
	      if (this.innerW !== pos.w || this.innerH !== pos.h) {
	        this.$emit("resize", this.i, pos.h, pos.w, newSize.height, newSize.width);
	      }
	
	      if (event.type === "resizeend" && (this.previousW !== this.innerW || this.previousH !== this.innerH)) {
	        this.$emit("resized", this.i, pos.h, pos.w, newSize.height, newSize.width);
	      }
	
	      this.eventBus.$emit("resizeEvent", event.type, this.i, this.innerX, this.innerY, pos.h, pos.w);
	    },
	    handleDrag: function handleDrag(event) {
	      if (this.static) return;
	      if (this.isResizing) return;
	      var position = getControlPosition(event); // Get the current drag point from the event. This is used as the offset.
	
	      if (position === null) return; // not possible but satisfies flow
	
	      var x = position.x,
	          y = position.y; // let shouldUpdate = false;
	
	      var newPosition = {
	        top: 0,
	        left: 0
	      };
	
	      switch (event.type) {
	        case "dragstart":
	          {
	            this.previousX = this.innerX;
	            this.previousY = this.innerY;
	            var parentRect = event.target.offsetParent.getBoundingClientRect();
	            var clientRect = event.target.getBoundingClientRect();
	
	            if (this.renderRtl) {
	              newPosition.left = (clientRect.right - parentRect.right) * -1;
	            } else {
	              newPosition.left = clientRect.left - parentRect.left;
	            }
	
	            newPosition.top = clientRect.top - parentRect.top;
	            this.dragging = newPosition;
	            this.isDragging = true;
	            break;
	          }
	
	        case "dragend":
	          {
	            if (!this.isDragging) return;
	
	            var _parentRect = event.target.offsetParent.getBoundingClientRect();
	
	            var _clientRect = event.target.getBoundingClientRect(); //                        Add rtl support
	
	
	            if (this.renderRtl) {
	              newPosition.left = (_clientRect.right - _parentRect.right) * -1;
	            } else {
	              newPosition.left = _clientRect.left - _parentRect.left;
	            }
	
	            newPosition.top = _clientRect.top - _parentRect.top; //                        console.log("### drag end => " + JSON.stringify(newPosition));
	            //                        console.log("### DROP: " + JSON.stringify(newPosition));
	
	            this.dragging = null;
	            this.isDragging = false; // shouldUpdate = true;
	
	            break;
	          }
	
	        case "dragmove":
	          {
	            var coreEvent = createCoreData(this.lastX, this.lastY, x, y); //                        Add rtl support
	
	            if (this.renderRtl) {
	              newPosition.left = this.dragging.left - coreEvent.deltaX;
	            } else {
	              newPosition.left = this.dragging.left + coreEvent.deltaX;
	            }
	
	            newPosition.top = this.dragging.top + coreEvent.deltaY; //                        console.log("### drag => " + event.type + ", x=" + x + ", y=" + y);
	            //                        console.log("### drag => " + event.type + ", deltaX=" + coreEvent.deltaX + ", deltaY=" + coreEvent.deltaY);
	            //                        console.log("### drag end => " + JSON.stringify(newPosition));
	
	            this.dragging = newPosition;
	            break;
	          }
	      } // Get new XY
	
	
	      var pos;
	
	      if (this.renderRtl) {
	        pos = this.calcXY(newPosition.top, newPosition.left);
	      } else {
	        pos = this.calcXY(newPosition.top, newPosition.left);
	      }
	
	      this.lastX = x;
	      this.lastY = y;
	
	      if (this.innerX !== pos.x || this.innerY !== pos.y) {
	        this.$emit("move", this.i, pos.x, pos.y);
	      }
	
	      if (event.type === "dragend" && (this.previousX !== this.innerX || this.previousY !== this.innerY)) {
	        this.$emit("moved", this.i, pos.x, pos.y);
	      }
	
	      this.eventBus.$emit("dragEvent", event.type, this.i, pos.x, pos.y, this.innerH, this.innerW);
	    },
	    calcPosition: function calcPosition(x, y, w, h) {
	      var colWidth = this.calcColWidth(); // add rtl support
	
	      var out;
	
	      if (this.renderRtl) {
	        out = {
	          right: Math.round(colWidth * x + (x + 1) * this.margin[0]),
	          top: Math.round(this.rowHeight * y + (y + 1) * this.margin[1]),
	          // 0 * Infinity === NaN, which causes problems with resize constriants;
	          // Fix this if it occurs.
	          // Note we do it here rather than later because Math.round(Infinity) causes deopt
	          width: w === Infinity ? w : Math.round(colWidth * w + Math.max(0, w - 1) * this.margin[0]),
	          height: h === Infinity ? h : Math.round(this.rowHeight * h + Math.max(0, h - 1) * this.margin[1])
	        };
	      } else {
	        out = {
	          left: Math.round(colWidth * x + (x + 1) * this.margin[0]),
	          top: Math.round(this.rowHeight * y + (y + 1) * this.margin[1]),
	          // 0 * Infinity === NaN, which causes problems with resize constriants;
	          // Fix this if it occurs.
	          // Note we do it here rather than later because Math.round(Infinity) causes deopt
	          width: w === Infinity ? w : Math.round(colWidth * w + Math.max(0, w - 1) * this.margin[0]),
	          height: h === Infinity ? h : Math.round(this.rowHeight * h + Math.max(0, h - 1) * this.margin[1])
	        };
	      }
	
	      return out;
	    },
	
	    /**
	     * Translate x and y coordinates from pixels to grid units.
	     * @param  {Number} top  Top position (relative to parent) in pixels.
	     * @param  {Number} left Left position (relative to parent) in pixels.
	     * @return {Object} x and y in grid units.
	     */
	    // TODO check if this function needs change in order to support rtl.
	    calcXY: function calcXY(top, left) {
	      var colWidth = this.calcColWidth(); // left = colWidth * x + margin * (x + 1)
	      // l = cx + m(x+1)
	      // l = cx + mx + m
	      // l - m = cx + mx
	      // l - m = x(c + m)
	      // (l - m) / (c + m) = x
	      // x = (left - margin) / (coldWidth + margin)
	
	      var x = Math.round((left - this.margin[0]) / (colWidth + this.margin[0]));
	      var y = Math.round((top - this.margin[1]) / (this.rowHeight + this.margin[1])); // Capping
	
	      x = Math.max(Math.min(x, this.cols - this.innerW), 0);
	      y = Math.max(Math.min(y, this.maxRows - this.innerH), 0);
	      return {
	        x: x,
	        y: y
	      };
	    },
	    // Helper for generating column width
	    calcColWidth: function calcColWidth() {
	      var colWidth = (this.containerWidth - this.margin[0] * (this.cols + 1)) / this.cols; // console.log("### COLS=" + this.cols + " COL WIDTH=" + colWidth + " MARGIN " + this.margin[0]);
	
	      return colWidth;
	    },
	
	    /**
	     * Given a height and width in pixel values, calculate grid units.
	     * @param  {Number} height Height in pixels.
	     * @param  {Number} width  Width in pixels.
	     * @return {Object} w, h as grid units.
	     */
	    calcWH: function calcWH(height, width) {
	      var colWidth = this.calcColWidth(); // width = colWidth * w - (margin * (w - 1))
	      // ...
	      // w = (width + margin) / (colWidth + margin)
	
	      var w = Math.round((width + this.margin[0]) / (colWidth + this.margin[0]));
	      var h = Math.round((height + this.margin[1]) / (this.rowHeight + this.margin[1])); // Capping
	
	      w = Math.max(Math.min(w, this.cols - this.innerX), 0);
	      h = Math.max(Math.min(h, this.maxRows - this.innerY), 0);
	      return {
	        w: w,
	        h: h
	      };
	    },
	    updateWidth: function updateWidth(width, colNum) {
	      this.containerWidth = width;
	
	      if (colNum !== undefined && colNum !== null) {
	        this.cols = colNum;
	      }
	    },
	    compact: function compact() {
	      this.createStyle();
	    },
	    tryMakeDraggable: function tryMakeDraggable() {
	      var self = this;
	
	      if (this.interactObj === null || this.interactObj === undefined) {
	        this.interactObj = interact(this.$refs.item);
	      }
	
	      if (this.draggable && !this.static) {
	        var opts = {
	          ignoreFrom: this.dragIgnoreFrom,
	          allowFrom: this.dragAllowFrom
	        };
	        this.interactObj.draggable(opts);
	        /*this.interactObj.draggable({allowFrom: '.vue-draggable-handle'});*/
	
	        if (!this.dragEventSet) {
	          this.dragEventSet = true;
	          this.interactObj.on('dragstart dragmove dragend', function (event) {
	            self.handleDrag(event);
	          });
	        }
	      } else {
	        this.interactObj.draggable({
	          enabled: false
	        });
	      }
	    },
	    tryMakeResizable: function tryMakeResizable() {
	      var self = this;
	
	      if (this.interactObj === null || this.interactObj === undefined) {
	        this.interactObj = interact(this.$refs.item);
	      }
	
	      if (this.resizable && !this.static) {
	        var maximum = this.calcPosition(0, 0, this.maxW, this.maxH);
	        var minimum = this.calcPosition(0, 0, this.minW, this.minH); // console.log("### MAX " + JSON.stringify(maximum));
	        // console.log("### MIN " + JSON.stringify(minimum));
	
	        var opts = {
	          preserveAspectRatio: true,
	          // allowFrom: "." + this.resizableHandleClass,
	          edges: {
	            left: false,
	            right: "." + this.resizableHandleClass,
	            bottom: "." + this.resizableHandleClass,
	            top: false
	          },
	          ignoreFrom: this.resizeIgnoreFrom,
	          restrictSize: {
	            min: {
	              height: minimum.height,
	              width: minimum.width
	            },
	            max: {
	              height: maximum.height,
	              width: maximum.width
	            }
	          }
	        };
	        this.interactObj.resizable(opts);
	
	        if (!this.resizeEventSet) {
	          this.resizeEventSet = true;
	          this.interactObj.on('resizestart resizemove resizeend', function (event) {
	            self.handleResize(event);
	          });
	        }
	      } else {
	        this.interactObj.resizable({
	          enabled: false
	        });
	      }
	    },
	    autoSize: function autoSize() {
	      // ok here we want to calculate if a resize is needed
	      this.previousW = this.innerW;
	      this.previousH = this.innerH;
	      var newSize = this.$slots.default[0].elm.getBoundingClientRect();
	      var pos = this.calcWH(newSize.height, newSize.width);
	
	      if (pos.w < this.minW) {
	        pos.w = this.minW;
	      }
	
	      if (pos.w > this.maxW) {
	        pos.w = this.maxW;
	      }
	
	      if (pos.h < this.minH) {
	        pos.h = this.minH;
	      }
	
	      if (pos.h > this.maxH) {
	        pos.h = this.maxH;
	      }
	
	      if (pos.h < 1) {
	        pos.h = 1;
	      }
	
	      if (pos.w < 1) {
	        pos.w = 1;
	      } // this.lastW = x; // basically, this is copied from resizehandler, but shouldn't be needed
	      // this.lastH = y;
	
	
	      if (this.innerW !== pos.w || this.innerH !== pos.h) {
	        this.$emit("resize", this.i, pos.h, pos.w, newSize.height, newSize.width);
	      }
	
	      if (this.previousW !== pos.w || this.previousH !== pos.h) {
	        this.$emit("resized", this.i, pos.h, pos.w, newSize.height, newSize.width);
	        this.eventBus.$emit("resizeEvent", "resizeend", this.i, this.innerX, this.innerY, pos.h, pos.w);
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./src/components/GridItem.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_GridItemvue_type_script_lang_js_ = (GridItemvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./src/components/GridItem.vue?vue&type=style&index=0&lang=css&
	var GridItemvue_type_style_index_0_lang_css_ = __webpack_require__("5ed4");
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	// CONCATENATED MODULE: ./src/components/GridItem.vue
	
	
	
	
	
	
	/* normalize component */
	
	var component = normalizeComponent(
	  components_GridItemvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* harmony default export */ var GridItem = (component.exports);
	// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0156aa68-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GridLayout.vue?vue&type=template&id=bff27f1c&
	var GridLayoutvue_type_template_id_bff27f1c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"item",staticClass:"vue-grid-layout",style:(_vm.mergedStyle)},[_vm._t("default"),_c('grid-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDragging),expression:"isDragging"}],staticClass:"vue-grid-placeholder",attrs:{"x":_vm.placeholder.x,"y":_vm.placeholder.y,"w":_vm.placeholder.w,"h":_vm.placeholder.h,"i":_vm.placeholder.i}})],2)}
	var GridLayoutvue_type_template_id_bff27f1c_staticRenderFns = []
	
	
	// CONCATENATED MODULE: ./src/components/GridLayout.vue?vue&type=template&id=bff27f1c&
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
	var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-finite.js
	var es6_number_is_finite = __webpack_require__("fca0");
	
	// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/define-property.js
	var define_property = __webpack_require__("85f2");
	var define_property_default = /*#__PURE__*/__webpack_require__.n(define_property);
	
	// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    define_property_default()(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	// CONCATENATED MODULE: ./src/helpers/responsiveUtils.js
	
	
	
	
	// @flow
	
	
	/*:: import type {Layout} from './utils';*/
	
	/*:: export type ResponsiveLayout = {lg?: Layout, md?: Layout, sm?: Layout, xs?: Layout, xxs?: Layout};*/
	
	/*:: type Breakpoint = string;*/
	
	/**
	 * Given a width, find the highest breakpoint that matches is valid for it (width > breakpoint).
	 *
	 * @param  {Object} breakpoints Breakpoints object (e.g. {lg: 1200, md: 960, ...})
	 * @param  {Number} width Screen width.
	 * @return {String}       Highest breakpoint that is less than width.
	 */
	
	/*:: type Breakpoints = {lg?: number, md?: number, sm?: number, xs?: number, xxs?: number};*/
	
	function getBreakpointFromWidth(breakpoints
	/*: Breakpoints*/
	, width
	/*: number*/
	)
	/*: Breakpoint*/
	{
	  var sorted = sortBreakpoints(breakpoints);
	  var matching = sorted[0];
	
	  for (var i = 1, len = sorted.length; i < len; i++) {
	    var breakpointName = sorted[i];
	    if (width > breakpoints[breakpointName]) matching = breakpointName;
	  }
	
	  return matching;
	}
	/**
	 * Given a breakpoint, get the # of cols set for it.
	 * @param  {String} breakpoint Breakpoint name.
	 * @param  {Object} cols       Map of breakpoints to cols.
	 * @return {Number}            Number of cols.
	 */
	
	function getColsFromBreakpoint(breakpoint
	/*: Breakpoint*/
	, cols
	/*: Breakpoints*/
	)
	/*: number*/
	{
	  if (!cols[breakpoint]) {
	    throw new Error("ResponsiveGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
	  }
	
	  return cols[breakpoint];
	}
	/**
	 * Given existing layouts and a new breakpoint, find or generate a new layout.
	 *
	 * This finds the layout above the new one and generates from it, if it exists.
	 *
	 * @param  {Array} orgLayout     Original layout.
	 * @param  {Object} layouts     Existing layouts.
	 * @param  {Array} breakpoints All breakpoints.
	 * @param  {String} breakpoint New breakpoint.
	 * @param  {String} breakpoint Last breakpoint (for fallback).
	 * @param  {Number} cols       Column count at new breakpoint.
	 * @param  {Boolean} verticalCompact Whether or not to compact the layout
	 *   vertically.
	 * @return {Array}             New layout.
	 */
	
	function findOrGenerateResponsiveLayout(orgLayout
	/*: Layout*/
	, layouts
	/*: ResponsiveLayout*/
	, breakpoints
	/*: Breakpoints*/
	, breakpoint
	/*: Breakpoint*/
	, lastBreakpoint
	/*: Breakpoint*/
	, cols
	/*: number*/
	, verticalCompact
	/*: boolean*/
	)
	/*: Layout*/
	{
	  // If it already exists, just return it.
	  if (layouts[breakpoint]) return cloneLayout(layouts[breakpoint]); // Find or generate the next layout
	
	  var layout = orgLayout;
	  var breakpointsSorted = sortBreakpoints(breakpoints);
	  var breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
	
	  for (var i = 0, len = breakpointsAbove.length; i < len; i++) {
	    var b = breakpointsAbove[i];
	
	    if (layouts[b]) {
	      layout = layouts[b];
	      break;
	    }
	  }
	
	  layout = cloneLayout(layout || []); // clone layout so we don't modify existing items
	
	  return compact(correctBounds(layout, {
	    cols: cols
	  }), verticalCompact);
	}
	function generateResponsiveLayout(layout
	/*: Layout*/
	, breakpoints
	/*: Breakpoints*/
	, breakpoint
	/*: Breakpoint*/
	, lastBreakpoint
	/*: Breakpoint*/
	, cols
	/*: number*/
	, verticalCompact
	/*: boolean*/
	)
	/*: Layout*/
	{
	  // If it already exists, just return it.
	
	  /*if (layouts[breakpoint]) return cloneLayout(layouts[breakpoint]);
	  // Find or generate the next layout
	  let layout = layouts[lastBreakpoint];*/
	
	  /*const breakpointsSorted = sortBreakpoints(breakpoints);
	  const breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
	  for (let i = 0, len = breakpointsAbove.length; i < len; i++) {
	  const b = breakpointsAbove[i];
	  if (layouts[b]) {
	    layout = layouts[b];
	    break;
	  }
	  }*/
	  layout = cloneLayout(layout || []); // clone layout so we don't modify existing items
	
	  return compact(correctBounds(layout, {
	    cols: cols
	  }), verticalCompact);
	}
	/**
	 * Given breakpoints, return an array of breakpoints sorted by width. This is usually
	 * e.g. ['xxs', 'xs', 'sm', ...]
	 *
	 * @param  {Object} breakpoints Key/value pair of breakpoint names to widths.
	 * @return {Array}              Sorted breakpoints.
	 */
	
	function sortBreakpoints(breakpoints
	/*: Breakpoints*/
	)
	/*: Array<Breakpoint>*/
	{
	  var keys
	  /*: Array<string>*/
	  = Object.keys(breakpoints);
	  return keys.sort(function (a, b) {
	    return breakpoints[a] - breakpoints[b];
	  });
	}
	// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GridLayout.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	var elementResizeDetectorMaker = __webpack_require__("eec4");
	
	
	 //var eventBus = require('./eventBus');
	
	
	
	/* harmony default export */ var GridLayoutvue_type_script_lang_js_ = ({
	  name: "GridLayout",
	  provide: function provide() {
	    return {
	      eventBus: null
	    };
	  },
	  components: {
	    GridItem: GridItem
	  },
	  props: {
	    // If true, the container height swells and contracts to fit contents
	    autoSize: {
	      type: Boolean,
	      default: true
	    },
	    colNum: {
	      type: Number,
	      default: 12
	    },
	    rowHeight: {
	      type: Number,
	      default: 150
	    },
	    maxRows: {
	      type: Number,
	      default: Infinity
	    },
	    margin: {
	      type: Array,
	      default: function _default() {
	        return [10, 10];
	      }
	    },
	    isDraggable: {
	      type: Boolean,
	      default: true
	    },
	    isResizable: {
	      type: Boolean,
	      default: true
	    },
	    isMirrored: {
	      type: Boolean,
	      default: false
	    },
	    useCssTransforms: {
	      type: Boolean,
	      default: true
	    },
	    verticalCompact: {
	      type: Boolean,
	      default: true
	    },
	    layout: {
	      type: Array,
	      required: true
	    },
	    responsive: {
	      type: Boolean,
	      default: false
	    },
	    breakpoints: {
	      type: Object,
	      default: function _default() {
	        return {
	          lg: 1200,
	          md: 996,
	          sm: 768,
	          xs: 480,
	          xxs: 0
	        };
	      }
	    },
	    cols: {
	      type: Object,
	      default: function _default() {
	        return {
	          lg: 12,
	          md: 10,
	          sm: 6,
	          xs: 4,
	          xxs: 2
	        };
	      }
	    },
	    preventCollision: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      width: null,
	      mergedStyle: {},
	      lastLayoutLength: 0,
	      isDragging: false,
	      placeholder: {
	        x: 0,
	        y: 0,
	        w: 0,
	        h: 0,
	        i: -1
	      },
	      layouts: {},
	      // array to store all layouts from different breakpoints
	      lastBreakpoint: null,
	      // store last active breakpoint
	      originalLayout: null // store original Layout
	
	    };
	  },
	  created: function created() {
	    var self = this; // Accessible refernces of functions for removing in beforeDestroy
	
	    self.resizeEventHandler = function (eventType, i, x, y, h, w) {
	      self.resizeEvent(eventType, i, x, y, h, w);
	    };
	
	    self.dragEventHandler = function (eventType, i, x, y, h, w) {
	      self.dragEvent(eventType, i, x, y, h, w);
	    };
	
	    self._provided.eventBus = new external_commonjs_vue_commonjs2_vue_root_Vue_default.a();
	    self.eventBus = self._provided.eventBus;
	    self.eventBus.$on('resizeEvent', self.resizeEventHandler);
	    self.eventBus.$on('dragEvent', self.dragEventHandler);
	    self.$emit('layout-created', self.layout);
	  },
	  beforeDestroy: function beforeDestroy() {
	    //Remove listeners
	    this.eventBus.$off('resizeEvent', this.resizeEventHandler);
	    this.eventBus.$off('dragEvent', this.dragEventHandler);
	    this.eventBus.$destroy();
	    removeWindowEventListener("resize", this.onWindowResize);
	    this.erd.uninstall(this.$refs.item);
	  },
	  beforeMount: function beforeMount() {
	    this.$emit('layout-before-mount', this.layout);
	  },
	  mounted: function mounted() {
	    this.$emit('layout-mounted', this.layout);
	    this.$nextTick(function () {
	      validateLayout(this.layout);
	      this.originalLayout = this.layout;
	      var self = this;
	      this.$nextTick(function () {
	        self.onWindowResize();
	        self.initResponsiveFeatures(); //self.width = self.$el.offsetWidth;
	
	        addWindowEventListener('resize', self.onWindowResize);
	        compact(self.layout, self.verticalCompact);
	        self.updateHeight();
	        self.$nextTick(function () {
	          this.erd = elementResizeDetectorMaker({
	            strategy: "scroll",
	            //<- For ultra performance.
	            // See https://github.com/wnr/element-resize-detector/issues/110 about callOnAdd.
	            callOnAdd: false
	          });
	          this.erd.listenTo(self.$refs.item, function () {
	            self.onWindowResize();
	          });
	        });
	      });
	    });
	  },
	  watch: {
	    width: function width(newval, oldval) {
	      var self = this;
	      this.$nextTick(function () {
	        var _this = this;
	
	        //this.$broadcast("updateWidth", this.width);
	        this.eventBus.$emit("updateWidth", this.width);
	
	        if (oldval === null) {
	          /*
	              If oldval == null is when the width has never been
	              set before. That only occurs when mouting is
	              finished, and onWindowResize has been called and
	              this.width has been changed the first time after it
	              got set to null in the constructor. It is now time
	              to issue layout-ready events as the GridItems have
	              their sizes configured properly.
	               The reason for emitting the layout-ready events on
	              the next tick is to allow for the newly-emitted
	              updateWidth event (above) to have reached the
	              children GridItem-s and had their effect, so we're
	              sure that they have the final size before we emit
	              layout-ready (for this GridLayout) and
	              item-layout-ready (for the GridItem-s).
	               This way any client event handlers can reliably
	              invistigate stable sizes of GridItem-s.
	          */
	          this.$nextTick(function () {
	            _this.$emit('layout-ready', self.layout);
	          });
	        }
	
	        this.updateHeight();
	      });
	    },
	    layout: function layout() {
	      this.layoutUpdate();
	    },
	    colNum: function colNum(val) {
	      this.eventBus.$emit("setColNum", val);
	    },
	    rowHeight: function rowHeight() {
	      this.eventBus.$emit("setRowHeight", this.rowHeight);
	    },
	    isDraggable: function isDraggable() {
	      this.eventBus.$emit("setDraggable", this.isDraggable);
	    },
	    isResizable: function isResizable() {
	      this.eventBus.$emit("setResizable", this.isResizable);
	    },
	    responsive: function responsive() {
	      if (!this.responsive) {
	        this.$emit('update:layout', this.originalLayout);
	        this.eventBus.$emit("setColNum", this.colNum);
	      }
	
	      this.onWindowResize();
	    },
	    maxRows: function maxRows() {
	      this.eventBus.$emit("setMaxRows", this.maxRows);
	    }
	  },
	  methods: {
	    layoutUpdate: function layoutUpdate() {
	      if (this.layout !== undefined && this.originalLayout !== null) {
	        if (this.layout.length !== this.originalLayout.length) {
	          // console.log("### LAYOUT UPDATE!", this.layout.length, this.originalLayout.length);
	          var diff = this.findDifference(this.layout, this.originalLayout);
	
	          if (diff.length > 0) {
	            // console.log(diff);
	            if (this.layout.length > this.originalLayout.length) {
	              this.originalLayout = this.originalLayout.concat(diff);
	            } else {
	              this.originalLayout = this.originalLayout.filter(function (obj) {
	                return !diff.some(function (obj2) {
	                  return obj.i === obj2.i;
	                });
	              });
	            }
	          }
	
	          this.lastLayoutLength = this.layout.length;
	          this.initResponsiveFeatures();
	        }
	
	        compact(this.layout, this.verticalCompact);
	        this.eventBus.$emit("updateWidth", this.width);
	        this.updateHeight();
	      }
	    },
	    updateHeight: function updateHeight() {
	      this.mergedStyle = {
	        height: this.containerHeight()
	      };
	    },
	    onWindowResize: function onWindowResize() {
	      if (this.$refs !== null && this.$refs.item !== null && this.$refs.item !== undefined) {
	        this.width = this.$refs.item.offsetWidth;
	      }
	
	      this.eventBus.$emit("resizeEvent");
	    },
	    containerHeight: function containerHeight() {
	      if (!this.autoSize) return;
	      return bottom(this.layout) * (this.rowHeight + this.margin[1]) + this.margin[1] + 'px';
	    },
	    dragEvent: function dragEvent(eventName, id, x, y, h, w) {
	      //console.log(eventName + " id=" + id + ", x=" + x + ", y=" + y);
	      var l = getLayoutItem(this.layout, id); //GetLayoutItem sometimes returns null object
	
	      if (l === undefined || l === null) {
	        l = {
	          x: 0,
	          y: 0
	        };
	      }
	
	      if (eventName === "dragmove" || eventName === "dragstart") {
	        this.placeholder.i = id;
	        this.placeholder.x = l.x;
	        this.placeholder.y = l.y;
	        this.placeholder.w = w;
	        this.placeholder.h = h;
	        this.$nextTick(function () {
	          this.isDragging = true;
	        }); //this.$broadcast("updateWidth", this.width);
	
	        this.eventBus.$emit("updateWidth", this.width);
	      } else {
	        this.$nextTick(function () {
	          this.isDragging = false;
	        });
	      } // Move the element to the dragged location.
	
	
	      this.layout = moveElement(this.layout, l, x, y, true, this.preventCollision);
	      compact(this.layout, this.verticalCompact); // needed because vue can't detect changes on array element properties
	
	      this.eventBus.$emit("compact");
	      this.updateHeight();
	      if (eventName === 'dragend') this.$emit('layout-updated', this.layout);
	    },
	    resizeEvent: function resizeEvent(eventName, id, x, y, h, w) {
	      var l = getLayoutItem(this.layout, id); //GetLayoutItem sometimes return null object
	
	      if (l === undefined || l === null) {
	        l = {
	          h: 0,
	          w: 0
	        };
	      }
	
	      var hasCollisions;
	
	      if (this.preventCollision) {
	        var collisions = getAllCollisions(this.layout, _objectSpread({}, l, {
	          w: w,
	          h: h
	        })).filter(function (layoutItem) {
	          return layoutItem.i !== l.i;
	        });
	        hasCollisions = collisions.length > 0; // If we're colliding, we need adjust the placeholder.
	
	        if (hasCollisions) {
	          // adjust w && h to maximum allowed space
	          var leastX = Infinity,
	              leastY = Infinity;
	          collisions.forEach(function (layoutItem) {
	            if (layoutItem.x > l.x) leastX = Math.min(leastX, layoutItem.x);
	            if (layoutItem.y > l.y) leastY = Math.min(leastY, layoutItem.y);
	          });
	          if (Number.isFinite(leastX)) l.w = leastX - l.x;
	          if (Number.isFinite(leastY)) l.h = leastY - l.y;
	        }
	      }
	
	      if (!hasCollisions) {
	        // Set new width and height.
	        l.w = w;
	        l.h = h;
	      }
	
	      if (eventName === "resizestart" || eventName === "resizemove") {
	        this.placeholder.i = id;
	        this.placeholder.x = x;
	        this.placeholder.y = y;
	        this.placeholder.w = l.w;
	        this.placeholder.h = l.h;
	        this.$nextTick(function () {
	          this.isDragging = true;
	        }); //this.$broadcast("updateWidth", this.width);
	
	        this.eventBus.$emit("updateWidth", this.width);
	      } else {
	        this.$nextTick(function () {
	          this.isDragging = false;
	        });
	      }
	
	      if (this.responsive) this.responsiveGridLayout();
	      compact(this.layout, this.verticalCompact);
	      this.eventBus.$emit("compact");
	      this.updateHeight();
	      if (eventName === 'resizeend') this.$emit('layout-updated', this.layout);
	    },
	    // finds or generates new layouts for set breakpoints
	    responsiveGridLayout: function responsiveGridLayout() {
	      var newBreakpoint = getBreakpointFromWidth(this.breakpoints, this.width);
	      var newCols = getColsFromBreakpoint(newBreakpoint, this.cols); // save actual layout in layouts
	
	      if (this.lastBreakpoint != null && !this.layouts[this.lastBreakpoint]) this.layouts[this.lastBreakpoint] = cloneLayout(this.layout); // Find or generate a new layout.
	
	      var layout = findOrGenerateResponsiveLayout(this.originalLayout, this.layouts, this.breakpoints, newBreakpoint, this.lastBreakpoint, newCols, this.verticalCompact); // Store the new layout.
	
	      this.layouts[newBreakpoint] = layout; // new prop sync
	
	      this.$emit('update:layout', layout);
	      this.lastBreakpoint = newBreakpoint;
	      this.eventBus.$emit("setColNum", getColsFromBreakpoint(newBreakpoint, this.cols));
	    },
	    // clear all responsive layouts
	    initResponsiveFeatures: function initResponsiveFeatures() {
	      // clear layouts
	      this.layouts = {};
	    },
	    // find difference in layouts
	    findDifference: function findDifference(layout, originalLayout) {
	      //Find values that are in result1 but not in result2
	      var uniqueResultOne = layout.filter(function (obj) {
	        return !originalLayout.some(function (obj2) {
	          return obj.i === obj2.i;
	        });
	      }); //Find values that are in result2 but not in result1
	
	      var uniqueResultTwo = originalLayout.filter(function (obj) {
	        return !layout.some(function (obj2) {
	          return obj.i === obj2.i;
	        });
	      }); //Combine the two arrays of unique entries#
	
	      return uniqueResultOne.concat(uniqueResultTwo);
	    }
	  }
	});
	// CONCATENATED MODULE: ./src/components/GridLayout.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_GridLayoutvue_type_script_lang_js_ = (GridLayoutvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./src/components/GridLayout.vue?vue&type=style&index=0&lang=css&
	var GridLayoutvue_type_style_index_0_lang_css_ = __webpack_require__("e279");
	
	// CONCATENATED MODULE: ./src/components/GridLayout.vue
	
	
	
	
	
	
	/* normalize component */
	
	var GridLayout_component = normalizeComponent(
	  components_GridLayoutvue_type_script_lang_js_,
	  GridLayoutvue_type_template_id_bff27f1c_render,
	  GridLayoutvue_type_template_id_bff27f1c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* harmony default export */ var GridLayout = (GridLayout_component.exports);
	// CONCATENATED MODULE: ./src/components/index.js
	
	
	
	
	
	
	 // import ResponsiveGridLayout from './ResponsiveGridLayout.vue';
	
	var VueGridLayout = {
	  // ResponsiveGridLayout,
	  GridLayout: GridLayout,
	  GridItem: GridItem
	}; // module.exports = VueGridLayout;
	
	Object.keys(VueGridLayout).forEach(function (name) {
	  external_commonjs_vue_commonjs2_vue_root_Vue_default.a.component(name, VueGridLayout[name]);
	});
	/* harmony default export */ var components = (VueGridLayout);
	
	// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
	/* concated harmony reexport GridLayout */__webpack_require__.d(__webpack_exports__, "GridLayout", function() { return GridLayout; });
	/* concated harmony reexport GridItem */__webpack_require__.d(__webpack_exports__, "GridItem", function() { return GridItem; });
	
	
	/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (components);
	
	
	
	/***/ }),
	
	/***/ "fb3a":
	/***/ (function(module, exports, __webpack_require__) {
	
	/**
	 * interact.js 1.6.3
	 *
	 * Copyright (c) 2012-2019 Taye Adeyemi <dev@taye.me>
	 * Released under the MIT License.
	 * https://raw.github.com/taye/interact.js/master/LICENSE
	 */
	(function(f){if(true){module.exports=f()}else { var g; }})(function(){var define,module,exports;
	var createModuleFactory = function createModuleFactory(t){var e;return function(r){return e||t(e={exports:{},parent:r},e.exports),e.exports}};
	var _$scope_24 = createModuleFactory(function (module, exports) {
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* common-shake removed: exports.createScope = */ void createScope;
	/* common-shake removed: exports.initScope = */ void initScope;
	exports.Scope = exports.ActionName = void 0;
	
	var utils = _interopRequireWildcard(_$utils_56);
	
	var _domObjects = _interopRequireDefault(_$domObjects_50);
	
	var _defaultOptions = _interopRequireDefault(_$defaultOptions_20);
	
	var _Eventable = _interopRequireDefault(_$Eventable_14);
	
	var _Interactable = _interopRequireDefault(_$Interactable_16);
	
	var _InteractableSet = _interopRequireDefault(_$InteractableSet_17);
	
	var _InteractEvent = _interopRequireDefault(_$InteractEvent_15);
	
	var _interactions = _interopRequireDefault(_$interactions_23({}));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }
	
	function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var win = utils.win,
	    browser = utils.browser,
	    raf = utils.raf,
	    Signals = utils.Signals,
	    events = utils.events;
	var ActionName;
	exports.ActionName = ActionName;
	
	(function (ActionName) {})(ActionName || (exports.ActionName = ActionName = {}));
	
	function createScope() {
	  return new Scope();
	}
	
	var Scope =
	/*#__PURE__*/
	function () {
	  function Scope() {
	    var _this = this;
	
	    _classCallCheck(this, Scope);
	
	    this.id = "__interact_scope_".concat(Math.floor(Math.random() * 100));
	    this.signals = new Signals();
	    this.browser = browser;
	    this.events = events;
	    this.utils = utils;
	    this.defaults = utils.clone(_defaultOptions["default"]);
	    this.Eventable = _Eventable["default"];
	    this.actions = {
	      names: [],
	      methodDict: {},
	      eventTypes: []
	    };
	    this.InteractEvent = _InteractEvent["default"];
	    this.interactables = new _InteractableSet["default"](this); // all documents being listened to
	
	    this.documents = [];
	    this._plugins = [];
	    this._pluginMap = {};
	
	    this.onWindowUnload = function (event) {
	      return _this.removeDocument(event.target);
	    };
	
	    var scope = this;
	
	    this.Interactable =
	    /*#__PURE__*/
	    function (_InteractableBase) {
	      _inherits(Interactable, _InteractableBase);
	
	      function Interactable() {
	        _classCallCheck(this, Interactable);
	
	        return _possibleConstructorReturn(this, _getPrototypeOf(Interactable).apply(this, arguments));
	      }
	
	      _createClass(Interactable, [{
	        key: "set",
	        value: function set(options) {
	          _get(_getPrototypeOf(Interactable.prototype), "set", this).call(this, options);
	
	          scope.interactables.signals.fire('set', {
	            options: options,
	            interactable: this
	          });
	          return this;
	        }
	      }, {
	        key: "unset",
	        value: function unset() {
	          _get(_getPrototypeOf(Interactable.prototype), "unset", this).call(this);
	
	          for (var i = scope.interactions.list.length - 1; i >= 0; i--) {
	            var interaction = scope.interactions.list[i];
	
	            if (interaction.interactable === this) {
	              interaction.stop();
	              scope.interactions.signals.fire('destroy', {
	                interaction: interaction
	              });
	              interaction.destroy();
	
	              if (scope.interactions.list.length > 2) {
	                scope.interactions.list.splice(i, 1);
	              }
	            }
	          }
	
	          scope.interactables.signals.fire('unset', {
	            interactable: this
	          });
	        }
	      }, {
	        key: "_defaults",
	        get: function get() {
	          return scope.defaults;
	        }
	      }]);
	
	      return Interactable;
	    }(_Interactable["default"]);
	  }
	
	  _createClass(Scope, [{
	    key: "init",
	    value: function init(window) {
	      return initScope(this, window);
	    }
	  }, {
	    key: "pluginIsInstalled",
	    value: function pluginIsInstalled(plugin) {
	      return this._pluginMap[plugin.id] || this._plugins.indexOf(plugin) !== -1;
	    }
	  }, {
	    key: "usePlugin",
	    value: function usePlugin(plugin, options) {
	      if (this.pluginIsInstalled(plugin)) {
	        return this;
	      }
	
	      if (plugin.id) {
	        this._pluginMap[plugin.id] = plugin;
	      }
	
	      plugin.install(this, options);
	
	      this._plugins.push(plugin);
	
	      return this;
	    }
	  }, {
	    key: "addDocument",
	    value: function addDocument(doc, options) {
	      // do nothing if document is already known
	      if (this.getDocIndex(doc) !== -1) {
	        return false;
	      }
	
	      var window = win.getWindow(doc);
	      options = options ? utils.extend({}, options) : {};
	      this.documents.push({
	        doc: doc,
	        options: options
	      });
	      events.documents.push(doc); // don't add an unload event for the main document
	      // so that the page may be cached in browser history
	
	      if (doc !== this.document) {
	        events.add(window, 'unload', this.onWindowUnload);
	      }
	
	      this.signals.fire('add-document', {
	        doc: doc,
	        window: window,
	        scope: this,
	        options: options
	      });
	    }
	  }, {
	    key: "removeDocument",
	    value: function removeDocument(doc) {
	      var index = this.getDocIndex(doc);
	      var window = win.getWindow(doc);
	      var options = this.documents[index].options;
	      events.remove(window, 'unload', this.onWindowUnload);
	      this.documents.splice(index, 1);
	      events.documents.splice(index, 1);
	      this.signals.fire('remove-document', {
	        doc: doc,
	        window: window,
	        scope: this,
	        options: options
	      });
	    }
	  }, {
	    key: "getDocIndex",
	    value: function getDocIndex(doc) {
	      for (var i = 0; i < this.documents.length; i++) {
	        if (this.documents[i].doc === doc) {
	          return i;
	        }
	      }
	
	      return -1;
	    }
	  }, {
	    key: "getDocOptions",
	    value: function getDocOptions(doc) {
	      var docIndex = this.getDocIndex(doc);
	      return docIndex === -1 ? null : this.documents[docIndex].options;
	    }
	  }, {
	    key: "now",
	    value: function now() {
	      return (this.window.Date || Date).now();
	    }
	  }]);
	
	  return Scope;
	}();
	
	exports.Scope = Scope;
	
	function initScope(scope, window) {
	  win.init(window);
	
	  _domObjects["default"].init(window);
	
	  browser.init(window);
	  raf.init(window);
	  events.init(window);
	  scope.usePlugin(_interactions["default"]);
	  scope.document = window.document;
	  scope.window = window;
	  return scope;
	}
	
	});
	var _$interactions_23 = createModuleFactory(function (module, exports) {
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _browser = _interopRequireDefault(_$browser_48);
	
	var _domObjects = _interopRequireDefault(_$domObjects_50);
	
	/* removed: var _$domUtils_51 = require("@interactjs/utils/domUtils"); */;
	
	var _events = _interopRequireDefault(_$events_52);
	
	var _pointerUtils = _interopRequireDefault(_$pointerUtils_61);
	
	var _Signals = _interopRequireDefault(_$Signals_46);
	
	var _Interaction = _interopRequireDefault(_$Interaction_18({}));
	
	var _interactionFinder = _interopRequireDefault(_$interactionFinder_22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var methodNames = ['pointerDown', 'pointerMove', 'pointerUp', 'updatePointer', 'removePointer', 'windowBlur'];
	
	function install(scope) {
	  var signals = new _Signals["default"]();
	  var listeners = {};
	
	  for (var _i = 0; _i < methodNames.length; _i++) {
	    var _ref;
	
	    _ref = methodNames[_i];
	    var method = _ref;
	    listeners[method] = doOnInteractions(method, scope);
	  }
	
	  var pEventTypes = _browser["default"].pEventTypes;
	  var docEvents;
	
	  if (_domObjects["default"].PointerEvent) {
	    docEvents = [{
	      type: pEventTypes.down,
	      listener: releasePointersOnRemovedEls
	    }, {
	      type: pEventTypes.down,
	      listener: listeners.pointerDown
	    }, {
	      type: pEventTypes.move,
	      listener: listeners.pointerMove
	    }, {
	      type: pEventTypes.up,
	      listener: listeners.pointerUp
	    }, {
	      type: pEventTypes.cancel,
	      listener: listeners.pointerUp
	    }];
	  } else {
	    docEvents = [{
	      type: 'mousedown',
	      listener: listeners.pointerDown
	    }, {
	      type: 'mousemove',
	      listener: listeners.pointerMove
	    }, {
	      type: 'mouseup',
	      listener: listeners.pointerUp
	    }, {
	      type: 'touchstart',
	      listener: releasePointersOnRemovedEls
	    }, {
	      type: 'touchstart',
	      listener: listeners.pointerDown
	    }, {
	      type: 'touchmove',
	      listener: listeners.pointerMove
	    }, {
	      type: 'touchend',
	      listener: listeners.pointerUp
	    }, {
	      type: 'touchcancel',
	      listener: listeners.pointerUp
	    }];
	  }
	
	  docEvents.push({
	    type: 'blur',
	    listener: function listener(event) {
	      for (var _i2 = 0; _i2 < scope.interactions.list.length; _i2++) {
	        var _ref2;
	
	        _ref2 = scope.interactions.list[_i2];
	        var interaction = _ref2;
	        interaction.documentBlur(event);
	      }
	    }
	  });
	  scope.signals.on('add-document', onDocSignal);
	  scope.signals.on('remove-document', onDocSignal); // for ignoring browser's simulated mouse events
	
	  scope.prevTouchTime = 0;
	
	  scope.Interaction =
	  /*#__PURE__*/
	  function (_InteractionBase) {
	    _inherits(Interaction, _InteractionBase);
	
	    function Interaction() {
	      _classCallCheck(this, Interaction);
	
	      return _possibleConstructorReturn(this, _getPrototypeOf(Interaction).apply(this, arguments));
	    }
	
	    _createClass(Interaction, [{
	      key: "_now",
	      value: function _now() {
	        return scope.now();
	      }
	    }, {
	      key: "pointerMoveTolerance",
	      get: function get() {
	        return scope.interactions.pointerMoveTolerance;
	      },
	      set: function set(value) {
	        scope.interactions.pointerMoveTolerance = value;
	      }
	    }]);
	
	    return Interaction;
	  }(_Interaction["default"]);
	
	  scope.interactions = {
	    signals: signals,
	    // all active and idle interactions
	    list: [],
	    "new": function _new(options) {
	      options.signals = signals;
	      var interaction = new scope.Interaction(options);
	      scope.interactions.list.push(interaction);
	      return interaction;
	    },
	    listeners: listeners,
	    docEvents: docEvents,
	    pointerMoveTolerance: 1
	  };
	
	  function releasePointersOnRemovedEls() {
	    // for all inactive touch interactions with pointers down
	    for (var _i3 = 0; _i3 < scope.interactions.list.length; _i3++) {
	      var _ref3;
	
	      _ref3 = scope.interactions.list[_i3];
	      var interaction = _ref3;
	
	      if (!interaction.pointerIsDown || interaction.pointerType !== 'touch' || interaction._interacting) {
	        continue;
	      } // if a pointer is down on an element that is no longer in the DOM tree
	
	
	      var _loop = function _loop() {
	        _ref4 = interaction.pointers[_i4];
	        var pointer = _ref4;
	
	        if (!scope.documents.some(function (_ref5) {
	          var doc = _ref5.doc;
	          return (0, _$domUtils_51.nodeContains)(doc, pointer.downTarget);
	        })) {
	          // remove the pointer from the interaction
	          interaction.removePointer(pointer.pointer, pointer.event);
	        }
	      };
	
	      for (var _i4 = 0; _i4 < interaction.pointers.length; _i4++) {
	        var _ref4;
	
	        _loop();
	      }
	    }
	  }
	}
	
	function doOnInteractions(method, scope) {
	  return function (event) {
	    var interactions = scope.interactions.list;
	
	    var pointerType = _pointerUtils["default"].getPointerType(event);
	
	    var _pointerUtils$getEven = _pointerUtils["default"].getEventTargets(event),
	        _pointerUtils$getEven2 = _slicedToArray(_pointerUtils$getEven, 2),
	        eventTarget = _pointerUtils$getEven2[0],
	        curEventTarget = _pointerUtils$getEven2[1];
	
	    var matches = []; // [ [pointer, interaction], ...]
	
	    if (/^touch/.test(event.type)) {
	      scope.prevTouchTime = scope.now();
	
	      for (var _i5 = 0; _i5 < event.changedTouches.length; _i5++) {
	        var _ref6;
	
	        _ref6 = event.changedTouches[_i5];
	        var changedTouch = _ref6;
	        var pointer = changedTouch;
	
	        var pointerId = _pointerUtils["default"].getPointerId(pointer);
	
	        var searchDetails = {
	          pointer: pointer,
	          pointerId: pointerId,
	          pointerType: pointerType,
	          eventType: event.type,
	          eventTarget: eventTarget,
	          curEventTarget: curEventTarget,
	          scope: scope
	        };
	        var interaction = getInteraction(searchDetails);
	        matches.push([searchDetails.pointer, searchDetails.eventTarget, searchDetails.curEventTarget, interaction]);
	      }
	    } else {
	      var invalidPointer = false;
	
	      if (!_browser["default"].supportsPointerEvent && /mouse/.test(event.type)) {
	        // ignore mouse events while touch interactions are active
	        for (var i = 0; i < interactions.length && !invalidPointer; i++) {
	          invalidPointer = interactions[i].pointerType !== 'mouse' && interactions[i].pointerIsDown;
	        } // try to ignore mouse events that are simulated by the browser
	        // after a touch event
	
	
	        invalidPointer = invalidPointer || scope.now() - scope.prevTouchTime < 500 || // on iOS and Firefox Mobile, MouseEvent.timeStamp is zero if simulated
	        event.timeStamp === 0;
	      }
	
	      if (!invalidPointer) {
	        var _searchDetails = {
	          pointer: event,
	          pointerId: _pointerUtils["default"].getPointerId(event),
	          pointerType: pointerType,
	          eventType: event.type,
	          curEventTarget: curEventTarget,
	          eventTarget: eventTarget,
	          scope: scope
	        };
	
	        var _interaction = getInteraction(_searchDetails);
	
	        matches.push([_searchDetails.pointer, _searchDetails.eventTarget, _searchDetails.curEventTarget, _interaction]);
	      }
	    } // eslint-disable-next-line no-shadow
	
	
	    for (var _i6 = 0; _i6 < matches.length; _i6++) {
	      var _matches$_i = _slicedToArray(matches[_i6], 4),
	          _pointer = _matches$_i[0],
	          _eventTarget = _matches$_i[1],
	          _curEventTarget = _matches$_i[2],
	          _interaction2 = _matches$_i[3];
	
	      _interaction2[method](_pointer, event, _eventTarget, _curEventTarget);
	    }
	  };
	}
	
	function getInteraction(searchDetails) {
	  var pointerType = searchDetails.pointerType,
	      scope = searchDetails.scope;
	
	  var foundInteraction = _interactionFinder["default"].search(searchDetails);
	
	  var signalArg = {
	    interaction: foundInteraction,
	    searchDetails: searchDetails
	  };
	  scope.interactions.signals.fire('find', signalArg);
	  return signalArg.interaction || scope.interactions["new"]({
	    pointerType: pointerType
	  });
	}
	
	function onDocSignal(_ref7, signalName) {
	  var doc = _ref7.doc,
	      scope = _ref7.scope,
	      options = _ref7.options;
	  var docEvents = scope.interactions.docEvents;
	  var eventMethod = signalName.indexOf('add') === 0 ? _events["default"].add : _events["default"].remove;
	
	  if (scope.browser.isIOS && !options.events) {
	    options.events = {
	      passive: false
	    };
	  } // delegate event listener
	
	
	  for (var eventType in _events["default"].delegatedEvents) {
	    eventMethod(doc, eventType, _events["default"].delegateListener);
	    eventMethod(doc, eventType, _events["default"].delegateUseCapture, true);
	  }
	
	  var eventOptions = options && options.events;
	
	  for (var _i7 = 0; _i7 < docEvents.length; _i7++) {
	    var _ref8;
	
	    _ref8 = docEvents[_i7];
	    var _ref9 = _ref8,
	        type = _ref9.type,
	        listener = _ref9.listener;
	    eventMethod(doc, type, listener, eventOptions);
	  }
	}
	
	var _default = {
	  id: 'core/interactions',
	  install: install,
	  onDocSignal: onDocSignal,
	  doOnInteractions: doOnInteractions,
	  methodNames: methodNames
	};
	exports["default"] = _default;
	
	});
	var _$Interaction_18 = createModuleFactory(function (module, exports) {
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "PointerInfo", {
	  enumerable: true,
	  get: function get() {
	    return _PointerInfo["default"];
	  }
	});
	exports["default"] = exports.Interaction = exports._ProxyMethods = exports._ProxyValues = void 0;
	
	var utils = _interopRequireWildcard(_$utils_56);
	
	var _InteractEvent = _interopRequireWildcard(_$InteractEvent_15);
	
	var _PointerInfo = _interopRequireDefault(_$PointerInfo_19);
	
	var _scope = _$scope_24({});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var _ProxyValues;
	
	exports._ProxyValues = _ProxyValues;
	
	(function (_ProxyValues) {
	  _ProxyValues["interactable"] = "";
	  _ProxyValues["element"] = "";
	  _ProxyValues["prepared"] = "";
	  _ProxyValues["pointerIsDown"] = "";
	  _ProxyValues["pointerWasMoved"] = "";
	  _ProxyValues["_proxy"] = "";
	})(_ProxyValues || (exports._ProxyValues = _ProxyValues = {}));
	
	var _ProxyMethods;
	
	exports._ProxyMethods = _ProxyMethods;
	
	(function (_ProxyMethods) {
	  _ProxyMethods["start"] = "";
	  _ProxyMethods["move"] = "";
	  _ProxyMethods["end"] = "";
	  _ProxyMethods["stop"] = "";
	  _ProxyMethods["interacting"] = "";
	})(_ProxyMethods || (exports._ProxyMethods = _ProxyMethods = {}));
	
	var Interaction =
	/*#__PURE__*/
	function () {
	  /** */
	  function Interaction(_ref) {
	    var _this = this;
	
	    var pointerType = _ref.pointerType,
	        signals = _ref.signals;
	
	    _classCallCheck(this, Interaction);
	
	    // current interactable being interacted with
	    this.interactable = null; // the target element of the interactable
	
	    this.element = null; // action that's ready to be fired on next move event
	
	    this.prepared = {
	      name: null,
	      axis: null,
	      edges: null
	    }; // keep track of added pointers
	
	    this.pointers = []; // pointerdown/mousedown/touchstart event
	
	    this.downEvent = null;
	    this.downPointer = {};
	    this._latestPointer = {
	      pointer: null,
	      event: null,
	      eventTarget: null
	    }; // previous action event
	
	    this.prevEvent = null;
	    this.pointerIsDown = false;
	    this.pointerWasMoved = false;
	    this._interacting = false;
	    this._ending = false;
	    this._stopped = true;
	    this._proxy = null;
	    this.simulation = null;
	    /**
	     * @alias Interaction.prototype.move
	     */
	
	    this.doMove = utils.warnOnce(function (signalArg) {
	      this.move(signalArg);
	    }, 'The interaction.doMove() method has been renamed to interaction.move()');
	    this.coords = {
	      // Starting InteractEvent pointer coordinates
	      start: utils.pointer.newCoords(),
	      // Previous native pointer move event coordinates
	      prev: utils.pointer.newCoords(),
	      // current native pointer move event coordinates
	      cur: utils.pointer.newCoords(),
	      // Change in coordinates and time of the pointer
	      delta: utils.pointer.newCoords(),
	      // pointer velocity
	      velocity: utils.pointer.newCoords()
	    };
	    this._signals = signals;
	    this.pointerType = pointerType;
	    var that = this;
	    this._proxy = {};
	
	    var _loop = function _loop(key) {
	      Object.defineProperty(_this._proxy, key, {
	        get: function get() {
	          return that[key];
	        }
	      });
	    };
	
	    for (var key in _ProxyValues) {
	      _loop(key);
	    }
	
	    var _loop2 = function _loop2(_key) {
	      Object.defineProperty(_this._proxy, _key, {
	        value: function value() {
	          return that[_key].apply(that, arguments);
	        }
	      });
	    };
	
	    for (var _key in _ProxyMethods) {
	      _loop2(_key);
	    }
	
	    this._signals.fire('new', {
	      interaction: this
	    });
	  }
	
	  _createClass(Interaction, [{
	    key: "pointerDown",
	    value: function pointerDown(pointer, event, eventTarget) {
	      var pointerIndex = this.updatePointer(pointer, event, eventTarget, true);
	
	      this._signals.fire('down', {
	        pointer: pointer,
	        event: event,
	        eventTarget: eventTarget,
	        pointerIndex: pointerIndex,
	        interaction: this
	      });
	    }
	    /**
	     * ```js
	     * interact(target)
	     *   .draggable({
	     *     // disable the default drag start by down->move
	     *     manualStart: true
	     *   })
	     *   // start dragging after the user holds the pointer down
	     *   .on('hold', function (event) {
	     *     var interaction = event.interaction
	     *
	     *     if (!interaction.interacting()) {
	     *       interaction.start({ name: 'drag' },
	     *                         event.interactable,
	     *                         event.currentTarget)
	     *     }
	     * })
	     * ```
	     *
	     * Start an action with the given Interactable and Element as tartgets. The
	     * action must be enabled for the target Interactable and an appropriate
	     * number of pointers must be held down - 1 for drag/resize, 2 for gesture.
	     *
	     * Use it with `interactable.<action>able({ manualStart: false })` to always
	     * [start actions manually](https://github.com/taye/interact.js/issues/114)
	     *
	     * @param {object} action   The action to be performed - drag, resize, etc.
	     * @param {Interactable} target  The Interactable to target
	     * @param {Element} element The DOM Element to target
	     * @return {object} interact
	     */
	
	  }, {
	    key: "start",
	    value: function start(action, interactable, element) {
	      if (this.interacting() || !this.pointerIsDown || this.pointers.length < (action.name === _scope.ActionName.Gesture ? 2 : 1) || !interactable.options[action.name].enabled) {
	        return false;
	      }
	
	      utils.copyAction(this.prepared, action);
	      this.interactable = interactable;
	      this.element = element;
	      this.rect = interactable.getRect(element);
	      this.edges = this.prepared.edges;
	      this._stopped = false;
	      this._interacting = this._doPhase({
	        interaction: this,
	        event: this.downEvent,
	        phase: _InteractEvent.EventPhase.Start
	      }) && !this._stopped;
	      return this._interacting;
	    }
	  }, {
	    key: "pointerMove",
	    value: function pointerMove(pointer, event, eventTarget) {
	      if (!this.simulation && !(this.modifiers && this.modifiers.endPrevented)) {
	        this.updatePointer(pointer, event, eventTarget, false);
	        utils.pointer.setCoords(this.coords.cur, this.pointers.map(function (p) {
	          return p.pointer;
	        }), this._now());
	      }
	
	      var duplicateMove = this.coords.cur.page.x === this.coords.prev.page.x && this.coords.cur.page.y === this.coords.prev.page.y && this.coords.cur.client.x === this.coords.prev.client.x && this.coords.cur.client.y === this.coords.prev.client.y;
	      var dx;
	      var dy; // register movement greater than pointerMoveTolerance
	
	      if (this.pointerIsDown && !this.pointerWasMoved) {
	        dx = this.coords.cur.client.x - this.coords.start.client.x;
	        dy = this.coords.cur.client.y - this.coords.start.client.y;
	        this.pointerWasMoved = utils.hypot(dx, dy) > this.pointerMoveTolerance;
	      }
	
	      var signalArg = {
	        pointer: pointer,
	        pointerIndex: this.getPointerIndex(pointer),
	        event: event,
	        eventTarget: eventTarget,
	        dx: dx,
	        dy: dy,
	        duplicate: duplicateMove,
	        interaction: this
	      };
	
	      if (!duplicateMove) {
	        // set pointer coordinate, time changes and velocity
	        utils.pointer.setCoordDeltas(this.coords.delta, this.coords.prev, this.coords.cur);
	        utils.pointer.setCoordVelocity(this.coords.velocity, this.coords.delta);
	      }
	
	      this._signals.fire('move', signalArg);
	
	      if (!duplicateMove) {
	        // if interacting, fire an 'action-move' signal etc
	        if (this.interacting()) {
	          this.move(signalArg);
	        }
	
	        if (this.pointerWasMoved) {
	          utils.pointer.copyCoords(this.coords.prev, this.coords.cur);
	        }
	      }
	    }
	    /**
	     * ```js
	     * interact(target)
	     *   .draggable(true)
	     *   .on('dragmove', function (event) {
	     *     if (someCondition) {
	     *       // change the snap settings
	     *       event.interactable.draggable({ snap: { targets: [] }})
	     *       // fire another move event with re-calculated snap
	     *       event.interaction.move()
	     *     }
	     *   })
	     * ```
	     *
	     * Force a move of the current action at the same coordinates. Useful if
	     * snap/restrict has been changed and you want a movement with the new
	     * settings.
	     */
	
	  }, {
	    key: "move",
	    value: function move(signalArg) {
	      signalArg = utils.extend({
	        pointer: this._latestPointer.pointer,
	        event: this._latestPointer.event,
	        eventTarget: this._latestPointer.eventTarget,
	        interaction: this
	      }, signalArg || {});
	      signalArg.phase = _InteractEvent.EventPhase.Move;
	
	      this._doPhase(signalArg);
	    } // End interact move events and stop auto-scroll unless simulation is running
	
	  }, {
	    key: "pointerUp",
	    value: function pointerUp(pointer, event, eventTarget, curEventTarget) {
	      var pointerIndex = this.getPointerIndex(pointer);
	
	      if (pointerIndex === -1) {
	        pointerIndex = this.updatePointer(pointer, event, eventTarget, false);
	      }
	
	      this._signals.fire(/cancel$/i.test(event.type) ? 'cancel' : 'up', {
	        pointer: pointer,
	        pointerIndex: pointerIndex,
	        event: event,
	        eventTarget: eventTarget,
	        curEventTarget: curEventTarget,
	        interaction: this
	      });
	
	      if (!this.simulation) {
	        this.end(event);
	      }
	
	      this.pointerIsDown = false;
	      this.removePointer(pointer, event);
	    }
	  }, {
	    key: "documentBlur",
	    value: function documentBlur(event) {
	      this.end(event);
	
	      this._signals.fire('blur', {
	        event: event,
	        interaction: this
	      });
	    }
	    /**
	     * ```js
	     * interact(target)
	     *   .draggable(true)
	     *   .on('move', function (event) {
	     *     if (event.pageX > 1000) {
	     *       // end the current action
	     *       event.interaction.end()
	     *       // stop all further listeners from being called
	     *       event.stopImmediatePropagation()
	     *     }
	     *   })
	     * ```
	     *
	     * @param {PointerEvent} [event]
	     */
	
	  }, {
	    key: "end",
	    value: function end(event) {
	      this._ending = true;
	      event = event || this._latestPointer.event;
	      var endPhaseResult;
	
	      if (this.interacting()) {
	        endPhaseResult = this._doPhase({
	          event: event,
	          interaction: this,
	          phase: _InteractEvent.EventPhase.End
	        });
	      }
	
	      this._ending = false;
	
	      if (endPhaseResult === true) {
	        this.stop();
	      }
	    }
	  }, {
	    key: "currentAction",
	    value: function currentAction() {
	      return this._interacting ? this.prepared.name : null;
	    }
	  }, {
	    key: "interacting",
	    value: function interacting() {
	      return this._interacting;
	    }
	    /** */
	
	  }, {
	    key: "stop",
	    value: function stop() {
	      this._signals.fire('stop', {
	        interaction: this
	      });
	
	      this.interactable = this.element = null;
	      this._interacting = false;
	      this._stopped = true;
	      this.prepared.name = this.prevEvent = null;
	    }
	  }, {
	    key: "getPointerIndex",
	    value: function getPointerIndex(pointer) {
	      var pointerId = utils.pointer.getPointerId(pointer); // mouse and pen interactions may have only one pointer
	
	      return this.pointerType === 'mouse' || this.pointerType === 'pen' ? this.pointers.length - 1 : utils.arr.findIndex(this.pointers, function (curPointer) {
	        return curPointer.id === pointerId;
	      });
	    }
	  }, {
	    key: "getPointerInfo",
	    value: function getPointerInfo(pointer) {
	      return this.pointers[this.getPointerIndex(pointer)];
	    }
	  }, {
	    key: "updatePointer",
	    value: function updatePointer(pointer, event, eventTarget, down) {
	      var id = utils.pointer.getPointerId(pointer);
	      var pointerIndex = this.getPointerIndex(pointer);
	      var pointerInfo = this.pointers[pointerIndex];
	      down = down === false ? false : down || /(down|start)$/i.test(event.type);
	
	      if (!pointerInfo) {
	        pointerInfo = new _PointerInfo["default"](id, pointer, event, null, null);
	        pointerIndex = this.pointers.length;
	        this.pointers.push(pointerInfo);
	      } else {
	        pointerInfo.pointer = pointer;
	      }
	
	      if (down) {
	        this.pointerIsDown = true;
	
	        if (!this.interacting()) {
	          utils.pointer.setCoords(this.coords.start, this.pointers.map(function (p) {
	            return p.pointer;
	          }), this._now());
	          utils.pointer.copyCoords(this.coords.cur, this.coords.start);
	          utils.pointer.copyCoords(this.coords.prev, this.coords.start);
	          utils.pointer.pointerExtend(this.downPointer, pointer);
	          this.downEvent = event;
	          pointerInfo.downTime = this.coords.cur.timeStamp;
	          pointerInfo.downTarget = eventTarget;
	          this.pointerWasMoved = false;
	        }
	      }
	
	      this._updateLatestPointer(pointer, event, eventTarget);
	
	      this._signals.fire('update-pointer', {
	        pointer: pointer,
	        event: event,
	        eventTarget: eventTarget,
	        down: down,
	        pointerInfo: pointerInfo,
	        pointerIndex: pointerIndex,
	        interaction: this
	      });
	
	      return pointerIndex;
	    }
	  }, {
	    key: "removePointer",
	    value: function removePointer(pointer, event) {
	      var pointerIndex = this.getPointerIndex(pointer);
	
	      if (pointerIndex === -1) {
	        return;
	      }
	
	      var pointerInfo = this.pointers[pointerIndex];
	
	      this._signals.fire('remove-pointer', {
	        pointer: pointer,
	        event: event,
	        pointerIndex: pointerIndex,
	        pointerInfo: pointerInfo,
	        interaction: this
	      });
	
	      this.pointers.splice(pointerIndex, 1);
	    }
	  }, {
	    key: "_updateLatestPointer",
	    value: function _updateLatestPointer(pointer, event, eventTarget) {
	      this._latestPointer.pointer = pointer;
	      this._latestPointer.event = event;
	      this._latestPointer.eventTarget = eventTarget;
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this._latestPointer.pointer = null;
	      this._latestPointer.event = null;
	      this._latestPointer.eventTarget = null;
	    }
	  }, {
	    key: "_createPreparedEvent",
	    value: function _createPreparedEvent(event, phase, preEnd, type) {
	      var actionName = this.prepared.name;
	      return new _InteractEvent["default"](this, event, actionName, phase, this.element, null, preEnd, type);
	    }
	  }, {
	    key: "_fireEvent",
	    value: function _fireEvent(iEvent) {
	      this.interactable.fire(iEvent);
	
	      if (!this.prevEvent || iEvent.timeStamp >= this.prevEvent.timeStamp) {
	        this.prevEvent = iEvent;
	      }
	    }
	  }, {
	    key: "_doPhase",
	    value: function _doPhase(signalArg) {
	      var event = signalArg.event,
	          phase = signalArg.phase,
	          preEnd = signalArg.preEnd,
	          type = signalArg.type;
	
	      var beforeResult = this._signals.fire("before-action-".concat(phase), signalArg);
	
	      if (beforeResult === false) {
	        return false;
	      }
	
	      var iEvent = signalArg.iEvent = this._createPreparedEvent(event, phase, preEnd, type);
	
	      var rect = this.rect;
	
	      if (rect) {
	        // update the rect modifications
	        var edges = this.edges || this.prepared.edges || {
	          left: true,
	          right: true,
	          top: true,
	          bottom: true
	        };
	
	        if (edges.top) {
	          rect.top += iEvent.delta.y;
	        }
	
	        if (edges.bottom) {
	          rect.bottom += iEvent.delta.y;
	        }
	
	        if (edges.left) {
	          rect.left += iEvent.delta.x;
	        }
	
	        if (edges.right) {
	          rect.right += iEvent.delta.x;
	        }
	
	        rect.width = rect.right - rect.left;
	        rect.height = rect.bottom - rect.top;
	      }
	
	      this._signals.fire("action-".concat(phase), signalArg);
	
	      this._fireEvent(iEvent);
	
	      this._signals.fire("after-action-".concat(phase), signalArg);
	
	      return true;
	    }
	  }, {
	    key: "_now",
	    value: function _now() {
	      return Date.now();
	    }
	  }, {
	    key: "pointerMoveTolerance",
	    get: function get() {
	      return 1;
	    }
	  }]);
	
	  return Interaction;
	}();
	
	exports.Interaction = Interaction;
	var _default = Interaction;
	exports["default"] = _default;
	
	});
	var _$arr_47 = {};
	"use strict";
	
	Object.defineProperty(_$arr_47, "__esModule", {
	  value: true
	});
	_$arr_47.contains = contains;
	_$arr_47.remove = remove;
	_$arr_47.merge = merge;
	_$arr_47.from = from;
	_$arr_47.findIndex = findIndex;
	_$arr_47.find = find;
	
	function contains(array, target) {
	  return array.indexOf(target) !== -1;
	}
	
	function remove(array, target) {
	  return array.splice(array.indexOf(target), 1);
	}
	
	function merge(target, source) {
	  for (var _i = 0; _i < source.length; _i++) {
	    var _ref;
	
	    _ref = source[_i];
	    var item = _ref;
	    target.push(item);
	  }
	
	  return target;
	}
	
	function from(source) {
	  return merge([], source);
	}
	
	function findIndex(array, func) {
	  for (var i = 0; i < array.length; i++) {
	    if (func(array[i], i, array)) {
	      return i;
	    }
	  }
	
	  return -1;
	}
	
	function find(array, func) {
	  return array[findIndex(array, func)];
	}
	
	var _$domObjects_50 = {};
	"use strict";
	
	Object.defineProperty(_$domObjects_50, "__esModule", {
	  value: true
	});
	_$domObjects_50["default"] = void 0;
	var domObjects = {
	  init: init,
	  document: null,
	  DocumentFragment: null,
	  SVGElement: null,
	  SVGSVGElement: null,
	  // eslint-disable-next-line no-undef
	  SVGElementInstance: null,
	  Element: null,
	  HTMLElement: null,
	  Event: null,
	  Touch: null,
	  PointerEvent: null
	};
	
	function blank() {}
	
	var _default = domObjects;
	_$domObjects_50["default"] = _default;
	
	function init(window) {
	  var win = window;
	  domObjects.document = win.document;
	  domObjects.DocumentFragment = win.DocumentFragment || blank;
	  domObjects.SVGElement = win.SVGElement || blank;
	  domObjects.SVGSVGElement = win.SVGSVGElement || blank;
	  domObjects.SVGElementInstance = win.SVGElementInstance || blank;
	  domObjects.Element = win.Element || blank;
	  domObjects.HTMLElement = win.HTMLElement || domObjects.Element;
	  domObjects.Event = win.Event;
	  domObjects.Touch = win.Touch || blank;
	  domObjects.PointerEvent = win.PointerEvent || win.MSPointerEvent;
	}
	
	var _$isWindow_58 = {};
	"use strict";
	
	Object.defineProperty(_$isWindow_58, "__esModule", {
	  value: true
	});
	_$isWindow_58["default"] = void 0;
	
	var ___default_58 = function _default(thing) {
	  return !!(thing && thing.Window) && thing instanceof thing.Window;
	};
	
	_$isWindow_58["default"] = ___default_58;
	
	var _$window_66 = {};
	"use strict";
	
	Object.defineProperty(_$window_66, "__esModule", {
	  value: true
	});
	_$window_66.init = __init_66;
	_$window_66.getWindow = getWindow;
	_$window_66["default"] = void 0;
	
	var _isWindow = _interopRequireDefault(_$isWindow_58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var win = {
	  realWindow: undefined,
	  window: undefined,
	  getWindow: getWindow,
	  init: __init_66
	};
	
	function __init_66(window) {
	  // get wrapped window if using Shadow DOM polyfill
	  win.realWindow = window; // create a TextNode
	
	  var el = window.document.createTextNode(''); // check if it's wrapped by a polyfill
	
	  if (el.ownerDocument !== window.document && typeof window.wrap === 'function' && window.wrap(el) === el) {
	    // use wrapped window
	    window = window.wrap(window);
	  }
	
	  win.window = window;
	}
	
	if (typeof window === 'undefined') {
	  win.window = undefined;
	  win.realWindow = undefined;
	} else {
	  __init_66(window);
	}
	
	function getWindow(node) {
	  if ((0, _isWindow["default"])(node)) {
	    return node;
	  }
	
	  var rootNode = node.ownerDocument || node;
	  return rootNode.defaultView || win.window;
	}
	
	win.init = __init_66;
	var ___default_66 = win;
	_$window_66["default"] = ___default_66;
	
	var _$is_57 = {};
	"use strict";
	
	Object.defineProperty(_$is_57, "__esModule", {
	  value: true
	});
	_$is_57.array = _$is_57.plainObject = _$is_57.element = _$is_57.string = _$is_57.bool = _$is_57.number = _$is_57.func = _$is_57.object = _$is_57.docFrag = _$is_57.window = void 0;
	
	var ___isWindow_57 = ___interopRequireDefault_57(_$isWindow_58);
	
	var _window2 = ___interopRequireDefault_57(_$window_66);
	
	function ___interopRequireDefault_57(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var __window_57 = function window(thing) {
	  return thing === _window2["default"].window || (0, ___isWindow_57["default"])(thing);
	};
	
	_$is_57.window = __window_57;
	
	var docFrag = function docFrag(thing) {
	  return object(thing) && thing.nodeType === 11;
	};
	
	_$is_57.docFrag = docFrag;
	
	var object = function object(thing) {
	  return !!thing && _typeof(thing) === 'object';
	};
	
	_$is_57.object = object;
	
	var func = function func(thing) {
	  return typeof thing === 'function';
	};
	
	_$is_57.func = func;
	
	var number = function number(thing) {
	  return typeof thing === 'number';
	};
	
	_$is_57.number = number;
	
	var bool = function bool(thing) {
	  return typeof thing === 'boolean';
	};
	
	_$is_57.bool = bool;
	
	var string = function string(thing) {
	  return typeof thing === 'string';
	};
	
	_$is_57.string = string;
	
	var element = function element(thing) {
	  if (!thing || _typeof(thing) !== 'object') {
	    return false;
	  }
	
	  var _window = _window2["default"].getWindow(thing) || _window2["default"].window;
	
	  return /object|function/.test(_typeof(_window.Element)) ? thing instanceof _window.Element // DOM2
	  : thing.nodeType === 1 && typeof thing.nodeName === 'string';
	};
	
	_$is_57.element = element;
	
	var plainObject = function plainObject(thing) {
	  return object(thing) && !!thing.constructor && /function Object\b/.test(thing.constructor.toString());
	};
	
	_$is_57.plainObject = plainObject;
	
	var array = function array(thing) {
	  return object(thing) && typeof thing.length !== 'undefined' && func(thing.splice);
	};
	
	_$is_57.array = array;
	
	var _$browser_48 = {};
	"use strict";
	
	Object.defineProperty(_$browser_48, "__esModule", {
	  value: true
	});
	_$browser_48["default"] = void 0;
	
	var _domObjects = ___interopRequireDefault_48(_$domObjects_50);
	
	var is = _interopRequireWildcard(_$is_57);
	
	var _window = ___interopRequireDefault_48(_$window_66);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___interopRequireDefault_48(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var browser = {
	  init: __init_48,
	  supportsTouch: null,
	  supportsPointerEvent: null,
	  isIOS7: null,
	  isIOS: null,
	  isIe9: null,
	  isOperaMobile: null,
	  prefixedMatchesSelector: null,
	  pEventTypes: null,
	  wheelEvent: null
	};
	
	function __init_48(window) {
	  var Element = _domObjects["default"].Element;
	  var navigator = _window["default"].window.navigator; // Does the browser support touch input?
	
	  browser.supportsTouch = 'ontouchstart' in window || is.func(window.DocumentTouch) && _domObjects["default"].document instanceof window.DocumentTouch; // Does the browser support PointerEvents
	
	  browser.supportsPointerEvent = navigator.pointerEnabled !== false && !!_domObjects["default"].PointerEvent;
	  browser.isIOS = /iP(hone|od|ad)/.test(navigator.platform); // scrolling doesn't change the result of getClientRects on iOS 7
	
	  browser.isIOS7 = /iP(hone|od|ad)/.test(navigator.platform) && /OS 7[^\d]/.test(navigator.appVersion);
	  browser.isIe9 = /MSIE 9/.test(navigator.userAgent); // Opera Mobile must be handled differently
	
	  browser.isOperaMobile = navigator.appName === 'Opera' && browser.supportsTouch && /Presto/.test(navigator.userAgent); // prefix matchesSelector
	
	  browser.prefixedMatchesSelector = 'matches' in Element.prototype ? 'matches' : 'webkitMatchesSelector' in Element.prototype ? 'webkitMatchesSelector' : 'mozMatchesSelector' in Element.prototype ? 'mozMatchesSelector' : 'oMatchesSelector' in Element.prototype ? 'oMatchesSelector' : 'msMatchesSelector';
	  browser.pEventTypes = browser.supportsPointerEvent ? _domObjects["default"].PointerEvent === window.MSPointerEvent ? {
	    up: 'MSPointerUp',
	    down: 'MSPointerDown',
	    over: 'mouseover',
	    out: 'mouseout',
	    move: 'MSPointerMove',
	    cancel: 'MSPointerCancel'
	  } : {
	    up: 'pointerup',
	    down: 'pointerdown',
	    over: 'pointerover',
	    out: 'pointerout',
	    move: 'pointermove',
	    cancel: 'pointercancel'
	  } : null; // because Webkit and Opera still use 'mousewheel' event type
	
	  browser.wheelEvent = 'onmousewheel' in _domObjects["default"].document ? 'mousewheel' : 'wheel';
	}
	
	var ___default_48 = browser;
	_$browser_48["default"] = ___default_48;
	
	var _$domUtils_51 = {};
	"use strict";
	
	Object.defineProperty(_$domUtils_51, "__esModule", {
	  value: true
	});
	_$domUtils_51.nodeContains = nodeContains;
	_$domUtils_51.closest = closest;
	_$domUtils_51.parentNode = parentNode;
	_$domUtils_51.matchesSelector = matchesSelector;
	_$domUtils_51.indexOfDeepestElement = indexOfDeepestElement;
	_$domUtils_51.matchesUpTo = matchesUpTo;
	_$domUtils_51.getActualElement = getActualElement;
	_$domUtils_51.getScrollXY = getScrollXY;
	_$domUtils_51.getElementClientRect = getElementClientRect;
	_$domUtils_51.getElementRect = getElementRect;
	_$domUtils_51.getPath = getPath;
	_$domUtils_51.trySelector = trySelector;
	
	var _browser = ___interopRequireDefault_51(_$browser_48);
	
	var ___domObjects_51 = ___interopRequireDefault_51(_$domObjects_50);
	
	var __is_51 = ___interopRequireWildcard_51(_$is_57);
	
	var ___window_51 = ___interopRequireWildcard_51(_$window_66);
	
	function ___getRequireWildcardCache_51() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_51 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_51(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_51(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___interopRequireDefault_51(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function nodeContains(parent, child) {
	  while (child) {
	    if (child === parent) {
	      return true;
	    }
	
	    child = child.parentNode;
	  }
	
	  return false;
	}
	
	function closest(element, selector) {
	  while (__is_51.element(element)) {
	    if (matchesSelector(element, selector)) {
	      return element;
	    }
	
	    element = parentNode(element);
	  }
	
	  return null;
	}
	
	function parentNode(node) {
	  var parent = node.parentNode;
	
	  if (__is_51.docFrag(parent)) {
	    // skip past #shado-root fragments
	    // tslint:disable-next-line
	    while ((parent = parent.host) && __is_51.docFrag(parent)) {
	      continue;
	    }
	
	    return parent;
	  }
	
	  return parent;
	}
	
	function matchesSelector(element, selector) {
	  // remove /deep/ from selectors if shadowDOM polyfill is used
	  if (___window_51["default"].window !== ___window_51["default"].realWindow) {
	    selector = selector.replace(/\/deep\//g, ' ');
	  }
	
	  return element[_browser["default"].prefixedMatchesSelector](selector);
	}
	
	var getParent = function getParent(el) {
	  return el.parentNode ? el.parentNode : el.host;
	}; // Test for the element that's "above" all other qualifiers
	
	
	function indexOfDeepestElement(elements) {
	  var deepestZoneParents = [];
	  var deepestZone = elements[0];
	  var index = deepestZone ? 0 : -1;
	  var i;
	  var n;
	
	  for (i = 1; i < elements.length; i++) {
	    var dropzone = elements[i]; // an element might belong to multiple selector dropzones
	
	    if (!dropzone || dropzone === deepestZone) {
	      continue;
	    }
	
	    if (!deepestZone) {
	      deepestZone = dropzone;
	      index = i;
	      continue;
	    } // check if the deepest or current are document.documentElement or document.rootElement
	    // - if the current dropzone is, do nothing and continue
	
	
	    if (dropzone.parentNode === dropzone.ownerDocument) {
	      continue;
	    } // - if deepest is, update with the current dropzone and continue to next
	    else if (deepestZone.parentNode === dropzone.ownerDocument) {
	        deepestZone = dropzone;
	        index = i;
	        continue;
	      } // compare zIndex of siblings
	
	
	    if (dropzone.parentNode === deepestZone.parentNode) {
	      var deepestZIndex = parseInt((0, ___window_51.getWindow)(deepestZone).getComputedStyle(deepestZone).zIndex, 10) || 0;
	      var dropzoneZIndex = parseInt((0, ___window_51.getWindow)(dropzone).getComputedStyle(dropzone).zIndex, 10) || 0;
	
	      if (dropzoneZIndex >= deepestZIndex) {
	        deepestZone = dropzone;
	        index = i;
	      }
	
	      continue;
	    } // populate the ancestry array for the latest deepest dropzone
	
	
	    if (!deepestZoneParents.length) {
	      var _parent = deepestZone;
	      var parentParent = void 0;
	
	      while ((parentParent = getParent(_parent)) && parentParent !== _parent.ownerDocument) {
	        deepestZoneParents.unshift(_parent);
	        _parent = parentParent;
	      }
	    }
	
	    var parent = void 0; // if this element is an svg element and the current deepest is an
	    // HTMLElement
	
	    if (deepestZone instanceof ___domObjects_51["default"].HTMLElement && dropzone instanceof ___domObjects_51["default"].SVGElement && !(dropzone instanceof ___domObjects_51["default"].SVGSVGElement)) {
	      if (dropzone === deepestZone.parentNode) {
	        continue;
	      }
	
	      parent = dropzone.ownerSVGElement;
	    } else {
	      parent = dropzone;
	    }
	
	    var dropzoneParents = [];
	
	    while (parent.parentNode !== parent.ownerDocument) {
	      dropzoneParents.unshift(parent);
	      parent = getParent(parent);
	    }
	
	    n = 0; // get (position of last common ancestor) + 1
	
	    while (dropzoneParents[n] && dropzoneParents[n] === deepestZoneParents[n]) {
	      n++;
	    }
	
	    var parents = [dropzoneParents[n - 1], dropzoneParents[n], deepestZoneParents[n]];
	    var child = parents[0].lastChild;
	
	    while (child) {
	      if (child === parents[1]) {
	        deepestZone = dropzone;
	        index = i;
	        deepestZoneParents = dropzoneParents;
	        break;
	      } else if (child === parents[2]) {
	        break;
	      }
	
	      child = child.previousSibling;
	    }
	  }
	
	  return index;
	}
	
	function matchesUpTo(element, selector, limit) {
	  while (__is_51.element(element)) {
	    if (matchesSelector(element, selector)) {
	      return true;
	    }
	
	    element = parentNode(element);
	
	    if (element === limit) {
	      return matchesSelector(element, selector);
	    }
	  }
	
	  return false;
	}
	
	function getActualElement(element) {
	  return element instanceof ___domObjects_51["default"].SVGElementInstance ? element.correspondingUseElement : element;
	}
	
	function getScrollXY(relevantWindow) {
	  relevantWindow = relevantWindow || ___window_51["default"].window;
	  return {
	    x: relevantWindow.scrollX || relevantWindow.document.documentElement.scrollLeft,
	    y: relevantWindow.scrollY || relevantWindow.document.documentElement.scrollTop
	  };
	}
	
	function getElementClientRect(element) {
	  var clientRect = element instanceof ___domObjects_51["default"].SVGElement ? element.getBoundingClientRect() : element.getClientRects()[0];
	  return clientRect && {
	    left: clientRect.left,
	    right: clientRect.right,
	    top: clientRect.top,
	    bottom: clientRect.bottom,
	    width: clientRect.width || clientRect.right - clientRect.left,
	    height: clientRect.height || clientRect.bottom - clientRect.top
	  };
	}
	
	function getElementRect(element) {
	  var clientRect = getElementClientRect(element);
	
	  if (!_browser["default"].isIOS7 && clientRect) {
	    var scroll = getScrollXY(___window_51["default"].getWindow(element));
	    clientRect.left += scroll.x;
	    clientRect.right += scroll.x;
	    clientRect.top += scroll.y;
	    clientRect.bottom += scroll.y;
	  }
	
	  return clientRect;
	}
	
	function getPath(node) {
	  var path = [];
	
	  while (node) {
	    path.push(node);
	    node = parentNode(node);
	  }
	
	  return path;
	}
	
	function trySelector(value) {
	  if (!__is_51.string(value)) {
	    return false;
	  } // an exception will be raised if it is invalid
	
	
	  ___domObjects_51["default"].document.querySelector(value);
	
	  return true;
	}
	
	var _$clone_49 = {};
	"use strict";
	
	Object.defineProperty(_$clone_49, "__esModule", {
	  value: true
	});
	_$clone_49["default"] = clone;
	
	var arr = ___interopRequireWildcard_49(_$arr_47);
	
	var __is_49 = ___interopRequireWildcard_49(_$is_57);
	
	function ___getRequireWildcardCache_49() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_49 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_49(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_49(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function clone(source) {
	  var dest = {};
	
	  for (var prop in source) {
	    var value = source[prop];
	
	    if (__is_49.plainObject(value)) {
	      dest[prop] = clone(value);
	    } else if (__is_49.array(value)) {
	      dest[prop] = arr.from(value);
	    } else {
	      dest[prop] = value;
	    }
	  }
	
	  return dest;
	}
	
	var _$pointerExtend_60 = {};
	"use strict";
	
	Object.defineProperty(_$pointerExtend_60, "__esModule", {
	  value: true
	});
	_$pointerExtend_60["default"] = void 0;
	
	function pointerExtend(dest, source) {
	  for (var prop in source) {
	    var prefixedPropREs = pointerExtend.prefixedPropREs;
	    var deprecated = false; // skip deprecated prefixed properties
	
	    for (var vendor in prefixedPropREs) {
	      if (prop.indexOf(vendor) === 0 && prefixedPropREs[vendor].test(prop)) {
	        deprecated = true;
	        break;
	      }
	    }
	
	    if (!deprecated && typeof source[prop] !== 'function') {
	      dest[prop] = source[prop];
	    }
	  }
	
	  return dest;
	}
	
	pointerExtend.prefixedPropREs = {
	  webkit: /(Movement[XY]|Radius[XY]|RotationAngle|Force)$/,
	  moz: /(Pressure)$/
	};
	var ___default_60 = pointerExtend;
	_$pointerExtend_60["default"] = ___default_60;
	
	var _$hypot_55 = {};
	"use strict";
	
	Object.defineProperty(_$hypot_55, "__esModule", {
	  value: true
	});
	_$hypot_55["default"] = void 0;
	
	var ___default_55 = function _default(x, y) {
	  return Math.sqrt(x * x + y * y);
	};
	
	_$hypot_55["default"] = ___default_55;
	
	var _$pointerUtils_61 = {};
	"use strict";
	
	Object.defineProperty(_$pointerUtils_61, "__esModule", {
	  value: true
	});
	_$pointerUtils_61["default"] = void 0;
	
	var ___browser_61 = ___interopRequireDefault_61(_$browser_48);
	
	var ___domObjects_61 = ___interopRequireDefault_61(_$domObjects_50);
	
	var domUtils = ___interopRequireWildcard_61(_$domUtils_51);
	
	var _hypot = ___interopRequireDefault_61(_$hypot_55);
	
	var __is_61 = ___interopRequireWildcard_61(_$is_57);
	
	var _pointerExtend = ___interopRequireDefault_61(_$pointerExtend_60);
	
	function ___getRequireWildcardCache_61() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_61 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_61(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_61(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___interopRequireDefault_61(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var pointerUtils = {
	  copyCoords: function copyCoords(dest, src) {
	    dest.page = dest.page || {};
	    dest.page.x = src.page.x;
	    dest.page.y = src.page.y;
	    dest.client = dest.client || {};
	    dest.client.x = src.client.x;
	    dest.client.y = src.client.y;
	    dest.timeStamp = src.timeStamp;
	  },
	  setCoordDeltas: function setCoordDeltas(targetObj, prev, cur) {
	    targetObj.page.x = cur.page.x - prev.page.x;
	    targetObj.page.y = cur.page.y - prev.page.y;
	    targetObj.client.x = cur.client.x - prev.client.x;
	    targetObj.client.y = cur.client.y - prev.client.y;
	    targetObj.timeStamp = cur.timeStamp - prev.timeStamp;
	  },
	  setCoordVelocity: function setCoordVelocity(targetObj, delta) {
	    var dt = Math.max(delta.timeStamp / 1000, 0.001);
	    targetObj.page.x = delta.page.x / dt;
	    targetObj.page.y = delta.page.y / dt;
	    targetObj.client.x = delta.client.x / dt;
	    targetObj.client.y = delta.client.y / dt;
	    targetObj.timeStamp = dt;
	  },
	  isNativePointer: function isNativePointer(pointer) {
	    return pointer instanceof ___domObjects_61["default"].Event || pointer instanceof ___domObjects_61["default"].Touch;
	  },
	  // Get specified X/Y coords for mouse or event.touches[0]
	  getXY: function getXY(type, pointer, xy) {
	    xy = xy || {};
	    type = type || 'page';
	    xy.x = pointer[type + 'X'];
	    xy.y = pointer[type + 'Y'];
	    return xy;
	  },
	  getPageXY: function getPageXY(pointer, page) {
	    page = page || {
	      x: 0,
	      y: 0
	    }; // Opera Mobile handles the viewport and scrolling oddly
	
	    if (___browser_61["default"].isOperaMobile && pointerUtils.isNativePointer(pointer)) {
	      pointerUtils.getXY('screen', pointer, page);
	      page.x += window.scrollX;
	      page.y += window.scrollY;
	    } else {
	      pointerUtils.getXY('page', pointer, page);
	    }
	
	    return page;
	  },
	  getClientXY: function getClientXY(pointer, client) {
	    client = client || {};
	
	    if (___browser_61["default"].isOperaMobile && pointerUtils.isNativePointer(pointer)) {
	      // Opera Mobile handles the viewport and scrolling oddly
	      pointerUtils.getXY('screen', pointer, client);
	    } else {
	      pointerUtils.getXY('client', pointer, client);
	    }
	
	    return client;
	  },
	  getPointerId: function getPointerId(pointer) {
	    return __is_61.number(pointer.pointerId) ? pointer.pointerId : pointer.identifier;
	  },
	  setCoords: function setCoords(targetObj, pointers, timeStamp) {
	    var pointer = pointers.length > 1 ? pointerUtils.pointerAverage(pointers) : pointers[0];
	    var tmpXY = {};
	    pointerUtils.getPageXY(pointer, tmpXY);
	    targetObj.page.x = tmpXY.x;
	    targetObj.page.y = tmpXY.y;
	    pointerUtils.getClientXY(pointer, tmpXY);
	    targetObj.client.x = tmpXY.x;
	    targetObj.client.y = tmpXY.y;
	    targetObj.timeStamp = timeStamp;
	  },
	  pointerExtend: _pointerExtend["default"],
	  getTouchPair: function getTouchPair(event) {
	    var touches = []; // array of touches is supplied
	
	    if (__is_61.array(event)) {
	      touches[0] = event[0];
	      touches[1] = event[1];
	    } // an event
	    else {
	        if (event.type === 'touchend') {
	          if (event.touches.length === 1) {
	            touches[0] = event.touches[0];
	            touches[1] = event.changedTouches[0];
	          } else if (event.touches.length === 0) {
	            touches[0] = event.changedTouches[0];
	            touches[1] = event.changedTouches[1];
	          }
	        } else {
	          touches[0] = event.touches[0];
	          touches[1] = event.touches[1];
	        }
	      }
	
	    return touches;
	  },
	  pointerAverage: function pointerAverage(pointers) {
	    var average = {
	      pageX: 0,
	      pageY: 0,
	      clientX: 0,
	      clientY: 0,
	      screenX: 0,
	      screenY: 0
	    };
	
	    for (var _i = 0; _i < pointers.length; _i++) {
	      var _ref;
	
	      _ref = pointers[_i];
	      var pointer = _ref;
	
	      for (var _prop in average) {
	        average[_prop] += pointer[_prop];
	      }
	    }
	
	    for (var prop in average) {
	      average[prop] /= pointers.length;
	    }
	
	    return average;
	  },
	  touchBBox: function touchBBox(event) {
	    if (!event.length && !(event.touches && event.touches.length > 1)) {
	      return null;
	    }
	
	    var touches = pointerUtils.getTouchPair(event);
	    var minX = Math.min(touches[0].pageX, touches[1].pageX);
	    var minY = Math.min(touches[0].pageY, touches[1].pageY);
	    var maxX = Math.max(touches[0].pageX, touches[1].pageX);
	    var maxY = Math.max(touches[0].pageY, touches[1].pageY);
	    return {
	      x: minX,
	      y: minY,
	      left: minX,
	      top: minY,
	      right: maxX,
	      bottom: maxY,
	      width: maxX - minX,
	      height: maxY - minY
	    };
	  },
	  touchDistance: function touchDistance(event, deltaSource) {
	    var sourceX = deltaSource + 'X';
	    var sourceY = deltaSource + 'Y';
	    var touches = pointerUtils.getTouchPair(event);
	    var dx = touches[0][sourceX] - touches[1][sourceX];
	    var dy = touches[0][sourceY] - touches[1][sourceY];
	    return (0, _hypot["default"])(dx, dy);
	  },
	  touchAngle: function touchAngle(event, deltaSource) {
	    var sourceX = deltaSource + 'X';
	    var sourceY = deltaSource + 'Y';
	    var touches = pointerUtils.getTouchPair(event);
	    var dx = touches[1][sourceX] - touches[0][sourceX];
	    var dy = touches[1][sourceY] - touches[0][sourceY];
	    var angle = 180 * Math.atan2(dy, dx) / Math.PI;
	    return angle;
	  },
	  getPointerType: function getPointerType(pointer) {
	    return __is_61.string(pointer.pointerType) ? pointer.pointerType : __is_61.number(pointer.pointerType) ? [undefined, undefined, 'touch', 'pen', 'mouse'][pointer.pointerType] // if the PointerEvent API isn't available, then the "pointer" must
	    // be either a MouseEvent, TouchEvent, or Touch object
	    : /touch/.test(pointer.type) || pointer instanceof ___domObjects_61["default"].Touch ? 'touch' : 'mouse';
	  },
	  // [ event.target, event.currentTarget ]
	  getEventTargets: function getEventTargets(event) {
	    var path = __is_61.func(event.composedPath) ? event.composedPath() : event.path;
	    return [domUtils.getActualElement(path ? path[0] : event.target), domUtils.getActualElement(event.currentTarget)];
	  },
	  newCoords: function newCoords() {
	    return {
	      page: {
	        x: 0,
	        y: 0
	      },
	      client: {
	        x: 0,
	        y: 0
	      },
	      timeStamp: 0
	    };
	  },
	  coordsToEvent: function coordsToEvent(coords) {
	    var event = {
	      coords: coords,
	
	      get page() {
	        return this.coords.page;
	      },
	
	      get client() {
	        return this.coords.client;
	      },
	
	      get timeStamp() {
	        return this.coords.timeStamp;
	      },
	
	      get pageX() {
	        return this.coords.page.x;
	      },
	
	      get pageY() {
	        return this.coords.page.y;
	      },
	
	      get clientX() {
	        return this.coords.client.x;
	      },
	
	      get clientY() {
	        return this.coords.client.y;
	      },
	
	      get pointerId() {
	        return this.coords.pointerId;
	      },
	
	      get target() {
	        return this.coords.target;
	      },
	
	      get type() {
	        return this.coords.type;
	      },
	
	      get pointerType() {
	        return this.coords.pointerType;
	      },
	
	      get buttons() {
	        return this.coords.buttons;
	      }
	
	    };
	    return event;
	  }
	};
	var ___default_61 = pointerUtils;
	_$pointerUtils_61["default"] = ___default_61;
	
	var _$events_52 = {};
	"use strict";
	
	Object.defineProperty(_$events_52, "__esModule", {
	  value: true
	});
	_$events_52["default"] = _$events_52.FakeEvent = void 0;
	
	/* removed: var _$arr_47 = require("./arr"); */;
	
	var __domUtils_52 = ___interopRequireWildcard_52(_$domUtils_51);
	
	var __is_52 = ___interopRequireWildcard_52(_$is_57);
	
	var ___pointerExtend_52 = ___interopRequireDefault_52(_$pointerExtend_60);
	
	var _pointerUtils = ___interopRequireDefault_52(_$pointerUtils_61);
	
	function ___interopRequireDefault_52(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_52() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_52 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_52(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_52(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var elements = [];
	var targets = [];
	var delegatedEvents = {};
	var documents = [];
	
	function add(element, type, listener, optionalArg) {
	  var options = getOptions(optionalArg);
	  var elementIndex = elements.indexOf(element);
	  var target = targets[elementIndex];
	
	  if (!target) {
	    target = {
	      events: {},
	      typeCount: 0
	    };
	    elementIndex = elements.push(element) - 1;
	    targets.push(target);
	  }
	
	  if (!target.events[type]) {
	    target.events[type] = [];
	    target.typeCount++;
	  }
	
	  if (!(0, _$arr_47.contains)(target.events[type], listener)) {
	    element.addEventListener(type, listener, events.supportsOptions ? options : !!options.capture);
	    target.events[type].push(listener);
	  }
	}
	
	function __remove_52(element, type, listener, optionalArg) {
	  var options = getOptions(optionalArg);
	  var elementIndex = elements.indexOf(element);
	  var target = targets[elementIndex];
	
	  if (!target || !target.events) {
	    return;
	  }
	
	  if (type === 'all') {
	    for (type in target.events) {
	      if (target.events.hasOwnProperty(type)) {
	        __remove_52(element, type, 'all');
	      }
	    }
	
	    return;
	  }
	
	  if (target.events[type]) {
	    var len = target.events[type].length;
	
	    if (listener === 'all') {
	      for (var i = 0; i < len; i++) {
	        __remove_52(element, type, target.events[type][i], options);
	      }
	
	      return;
	    } else {
	      for (var _i = 0; _i < len; _i++) {
	        if (target.events[type][_i] === listener) {
	          element.removeEventListener(type, listener, events.supportsOptions ? options : !!options.capture);
	          target.events[type].splice(_i, 1);
	          break;
	        }
	      }
	    }
	
	    if (target.events[type] && target.events[type].length === 0) {
	      target.events[type] = null;
	      target.typeCount--;
	    }
	  }
	
	  if (!target.typeCount) {
	    targets.splice(elementIndex, 1);
	    elements.splice(elementIndex, 1);
	  }
	}
	
	function addDelegate(selector, context, type, listener, optionalArg) {
	  var options = getOptions(optionalArg);
	
	  if (!delegatedEvents[type]) {
	    delegatedEvents[type] = {
	      contexts: [],
	      listeners: [],
	      selectors: []
	    }; // add delegate listener functions
	
	    for (var _i2 = 0; _i2 < documents.length; _i2++) {
	      var _ref;
	
	      _ref = documents[_i2];
	      var doc = _ref;
	      add(doc, type, delegateListener);
	      add(doc, type, delegateUseCapture, true);
	    }
	  }
	
	  var delegated = delegatedEvents[type];
	  var index;
	
	  for (index = delegated.selectors.length - 1; index >= 0; index--) {
	    if (delegated.selectors[index] === selector && delegated.contexts[index] === context) {
	      break;
	    }
	  }
	
	  if (index === -1) {
	    index = delegated.selectors.length;
	    delegated.selectors.push(selector);
	    delegated.contexts.push(context);
	    delegated.listeners.push([]);
	  } // keep listener and capture and passive flags
	
	
	  delegated.listeners[index].push([listener, !!options.capture, options.passive]);
	}
	
	function removeDelegate(selector, context, type, listener, optionalArg) {
	  var options = getOptions(optionalArg);
	  var delegated = delegatedEvents[type];
	  var matchFound = false;
	  var index;
	
	  if (!delegated) {
	    return;
	  } // count from last index of delegated to 0
	
	
	  for (index = delegated.selectors.length - 1; index >= 0; index--) {
	    // look for matching selector and context Node
	    if (delegated.selectors[index] === selector && delegated.contexts[index] === context) {
	      var listeners = delegated.listeners[index]; // each item of the listeners array is an array: [function, capture, passive]
	
	      for (var i = listeners.length - 1; i >= 0; i--) {
	        var _listeners$i = _slicedToArray(listeners[i], 3),
	            fn = _listeners$i[0],
	            capture = _listeners$i[1],
	            passive = _listeners$i[2]; // check if the listener functions and capture and passive flags match
	
	
	        if (fn === listener && capture === !!options.capture && passive === options.passive) {
	          // remove the listener from the array of listeners
	          listeners.splice(i, 1); // if all listeners for this interactable have been removed
	          // remove the interactable from the delegated arrays
	
	          if (!listeners.length) {
	            delegated.selectors.splice(index, 1);
	            delegated.contexts.splice(index, 1);
	            delegated.listeners.splice(index, 1); // remove delegate function from context
	
	            __remove_52(context, type, delegateListener);
	            __remove_52(context, type, delegateUseCapture, true); // remove the arrays if they are empty
	
	            if (!delegated.selectors.length) {
	              delegatedEvents[type] = null;
	            }
	          } // only remove one listener
	
	
	          matchFound = true;
	          break;
	        }
	      }
	
	      if (matchFound) {
	        break;
	      }
	    }
	  }
	} // bound to the interactable context when a DOM event
	// listener is added to a selector interactable
	
	
	function delegateListener(event, optionalArg) {
	  var options = getOptions(optionalArg);
	  var fakeEvent = new FakeEvent(event);
	  var delegated = delegatedEvents[event.type];
	
	  var _pointerUtils$getEven = _pointerUtils["default"].getEventTargets(event),
	      _pointerUtils$getEven2 = _slicedToArray(_pointerUtils$getEven, 1),
	      eventTarget = _pointerUtils$getEven2[0];
	
	  var element = eventTarget; // climb up document tree looking for selector matches
	
	  while (__is_52.element(element)) {
	    for (var i = 0; i < delegated.selectors.length; i++) {
	      var selector = delegated.selectors[i];
	      var context = delegated.contexts[i];
	
	      if (__domUtils_52.matchesSelector(element, selector) && __domUtils_52.nodeContains(context, eventTarget) && __domUtils_52.nodeContains(context, element)) {
	        var listeners = delegated.listeners[i];
	        fakeEvent.currentTarget = element;
	
	        for (var _i3 = 0; _i3 < listeners.length; _i3++) {
	          var _ref2;
	
	          _ref2 = listeners[_i3];
	
	          var _ref3 = _ref2,
	              _ref4 = _slicedToArray(_ref3, 3),
	              fn = _ref4[0],
	              capture = _ref4[1],
	              passive = _ref4[2];
	
	          if (capture === !!options.capture && passive === options.passive) {
	            fn(fakeEvent);
	          }
	        }
	      }
	    }
	
	    element = __domUtils_52.parentNode(element);
	  }
	}
	
	function delegateUseCapture(event) {
	  return delegateListener.call(this, event, true);
	}
	
	function getOptions(param) {
	  return __is_52.object(param) ? param : {
	    capture: param
	  };
	}
	
	var FakeEvent =
	/*#__PURE__*/
	function () {
	  function FakeEvent(originalEvent) {
	    _classCallCheck(this, FakeEvent);
	
	    this.originalEvent = originalEvent; // duplicate the event so that currentTarget can be changed
	
	    (0, ___pointerExtend_52["default"])(this, originalEvent);
	  }
	
	  _createClass(FakeEvent, [{
	    key: "preventOriginalDefault",
	    value: function preventOriginalDefault() {
	      this.originalEvent.preventDefault();
	    }
	  }, {
	    key: "stopPropagation",
	    value: function stopPropagation() {
	      this.originalEvent.stopPropagation();
	    }
	  }, {
	    key: "stopImmediatePropagation",
	    value: function stopImmediatePropagation() {
	      this.originalEvent.stopImmediatePropagation();
	    }
	  }]);
	
	  return FakeEvent;
	}();
	
	_$events_52.FakeEvent = FakeEvent;
	var events = {
	  add: add,
	  remove: __remove_52,
	  addDelegate: addDelegate,
	  removeDelegate: removeDelegate,
	  delegateListener: delegateListener,
	  delegateUseCapture: delegateUseCapture,
	  delegatedEvents: delegatedEvents,
	  documents: documents,
	  supportsOptions: false,
	  supportsPassive: false,
	  _elements: elements,
	  _targets: targets,
	  init: function init(window) {
	    window.document.createElement('div').addEventListener('test', null, {
	      get capture() {
	        return events.supportsOptions = true;
	      },
	
	      get passive() {
	        return events.supportsPassive = true;
	      }
	
	    });
	  }
	};
	var ___default_52 = events;
	_$events_52["default"] = ___default_52;
	
	var _$extend_53 = {};
	"use strict";
	
	Object.defineProperty(_$extend_53, "__esModule", {
	  value: true
	});
	_$extend_53["default"] = extend;
	
	function extend(dest, source) {
	  for (var prop in source) {
	    dest[prop] = source[prop];
	  }
	
	  return dest;
	}
	
	var _$rect_63 = {};
	"use strict";
	
	Object.defineProperty(_$rect_63, "__esModule", {
	  value: true
	});
	_$rect_63.getStringOptionResult = getStringOptionResult;
	_$rect_63.resolveRectLike = resolveRectLike;
	_$rect_63.rectToXY = rectToXY;
	_$rect_63.xywhToTlbr = xywhToTlbr;
	_$rect_63.tlbrToXywh = tlbrToXywh;
	_$rect_63["default"] = void 0;
	
	/* removed: var _$domUtils_51 = require("./domUtils"); */;
	
	var _extend = ___interopRequireDefault_63(_$extend_53);
	
	var __is_63 = ___interopRequireWildcard_63(_$is_57);
	
	function ___getRequireWildcardCache_63() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_63 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_63(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_63(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___interopRequireDefault_63(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function getStringOptionResult(value, target, element) {
	  if (value === 'parent') {
	    return (0, _$domUtils_51.parentNode)(element);
	  }
	
	  if (value === 'self') {
	    return target.getRect(element);
	  }
	
	  return (0, _$domUtils_51.closest)(element, value);
	}
	
	function resolveRectLike(value, target, element, functionArgs) {
	  if (__is_63.string(value)) {
	    value = getStringOptionResult(value, target, element);
	  } else if (__is_63.func(value)) {
	    value = value.apply(void 0, _toConsumableArray(functionArgs));
	  }
	
	  if (__is_63.element(value)) {
	    value = (0, _$domUtils_51.getElementRect)(value);
	  }
	
	  return value;
	}
	
	function rectToXY(rect) {
	  return rect && {
	    x: 'x' in rect ? rect.x : rect.left,
	    y: 'y' in rect ? rect.y : rect.top
	  };
	}
	
	function xywhToTlbr(rect) {
	  if (rect && !('left' in rect && 'top' in rect)) {
	    rect = (0, _extend["default"])({}, rect);
	    rect.left = rect.x || 0;
	    rect.top = rect.y || 0;
	    rect.right = rect.right || rect.left + rect.width;
	    rect.bottom = rect.bottom || rect.top + rect.height;
	  }
	
	  return rect;
	}
	
	function tlbrToXywh(rect) {
	  if (rect && !('x' in rect && 'y' in rect)) {
	    rect = (0, _extend["default"])({}, rect);
	    rect.x = rect.left || 0;
	    rect.y = rect.top || 0;
	    rect.width = rect.width || rect.right - rect.x;
	    rect.height = rect.height || rect.bottom - rect.y;
	  }
	
	  return rect;
	}
	
	var ___default_63 = {
	  getStringOptionResult: getStringOptionResult,
	  resolveRectLike: resolveRectLike,
	  rectToXY: rectToXY,
	  xywhToTlbr: xywhToTlbr,
	  tlbrToXywh: tlbrToXywh
	};
	_$rect_63["default"] = ___default_63;
	
	var _$getOriginXY_54 = {};
	"use strict";
	
	Object.defineProperty(_$getOriginXY_54, "__esModule", {
	  value: true
	});
	_$getOriginXY_54["default"] = ___default_54;
	
	/* removed: var _$rect_63 = require("./rect"); */;
	
	function ___default_54(target, element, action) {
	  var actionOptions = target.options[action];
	  var actionOrigin = actionOptions && actionOptions.origin;
	  var origin = actionOrigin || target.options.origin;
	  var originRect = (0, _$rect_63.resolveRectLike)(origin, target, element, [target && element]);
	  return (0, _$rect_63.rectToXY)(originRect) || {
	    x: 0,
	    y: 0
	  };
	}
	
	var _$normalizeListeners_59 = {};
	"use strict";
	
	Object.defineProperty(_$normalizeListeners_59, "__esModule", {
	  value: true
	});
	_$normalizeListeners_59["default"] = normalize;
	
	var ___extend_59 = ___interopRequireDefault_59(_$extend_53);
	
	var __is_59 = ___interopRequireWildcard_59(_$is_57);
	
	function ___getRequireWildcardCache_59() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_59 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_59(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_59(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___interopRequireDefault_59(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function normalize(type, listeners, result) {
	  result = result || {};
	
	  if (__is_59.string(type) && type.search(' ') !== -1) {
	    type = split(type);
	  }
	
	  if (__is_59.array(type)) {
	    return type.reduce(function (acc, t) {
	      return (0, ___extend_59["default"])(acc, normalize(t, listeners, result));
	    }, result);
	  } // ({ type: fn }) -> ('', { type: fn })
	
	
	  if (__is_59.object(type)) {
	    listeners = type;
	    type = '';
	  }
	
	  if (__is_59.func(listeners)) {
	    result[type] = result[type] || [];
	    result[type].push(listeners);
	  } else if (__is_59.array(listeners)) {
	    for (var _i = 0; _i < listeners.length; _i++) {
	      var _ref;
	
	      _ref = listeners[_i];
	      var l = _ref;
	      normalize(type, l, result);
	    }
	  } else if (__is_59.object(listeners)) {
	    for (var prefix in listeners) {
	      var combinedTypes = split(prefix).map(function (p) {
	        return "".concat(type).concat(p);
	      });
	      normalize(combinedTypes, listeners[prefix], result);
	    }
	  }
	
	  return result;
	}
	
	function split(type) {
	  return type.trim().split(/ +/);
	}
	
	var _$raf_62 = {};
	"use strict";
	
	Object.defineProperty(_$raf_62, "__esModule", {
	  value: true
	});
	_$raf_62["default"] = void 0;
	var lastTime = 0;
	
	var _request;
	
	var _cancel;
	
	function __init_62(window) {
	  _request = window.requestAnimationFrame;
	  _cancel = window.cancelAnimationFrame;
	
	  if (!_request) {
	    var vendors = ['ms', 'moz', 'webkit', 'o'];
	
	    for (var _i = 0; _i < vendors.length; _i++) {
	      var vendor = vendors[_i];
	      _request = window["".concat(vendor, "RequestAnimationFrame")];
	      _cancel = window["".concat(vendor, "CancelAnimationFrame")] || window["".concat(vendor, "CancelRequestAnimationFrame")];
	    }
	  }
	
	  if (!_request) {
	    _request = function request(callback) {
	      var currTime = Date.now();
	      var timeToCall = Math.max(0, 16 - (currTime - lastTime)); // eslint-disable-next-line standard/no-callback-literal
	
	      var token = setTimeout(function () {
	        callback(currTime + timeToCall);
	      }, timeToCall);
	      lastTime = currTime + timeToCall;
	      return token;
	    };
	
	    _cancel = function cancel(token) {
	      return clearTimeout(token);
	    };
	  }
	}
	
	var ___default_62 = {
	  request: function request(callback) {
	    return _request(callback);
	  },
	  cancel: function cancel(token) {
	    return _cancel(token);
	  },
	  init: __init_62
	};
	_$raf_62["default"] = ___default_62;
	
	var _$Signals_46 = {};
	"use strict";
	
	Object.defineProperty(_$Signals_46, "__esModule", {
	  value: true
	});
	_$Signals_46["default"] = void 0;
	
	function ___classCallCheck_46(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ___defineProperties_46(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function ___createClass_46(Constructor, protoProps, staticProps) { if (protoProps) ___defineProperties_46(Constructor.prototype, protoProps); if (staticProps) ___defineProperties_46(Constructor, staticProps); return Constructor; }
	
	var Signals =
	/*#__PURE__*/
	function () {
	  function Signals() {
	    ___classCallCheck_46(this, Signals);
	
	    this.listeners = {};
	  }
	
	  ___createClass_46(Signals, [{
	    key: "on",
	    value: function on(name, listener) {
	      if (!this.listeners[name]) {
	        this.listeners[name] = [listener];
	        return;
	      }
	
	      this.listeners[name].push(listener);
	    }
	  }, {
	    key: "off",
	    value: function off(name, listener) {
	      if (!this.listeners[name]) {
	        return;
	      }
	
	      var index = this.listeners[name].indexOf(listener);
	
	      if (index !== -1) {
	        this.listeners[name].splice(index, 1);
	      }
	    }
	  }, {
	    key: "fire",
	    value: function fire(name, arg) {
	      var targetListeners = this.listeners[name];
	
	      if (!targetListeners) {
	        return;
	      }
	
	      for (var _i = 0; _i < targetListeners.length; _i++) {
	        var _ref;
	
	        _ref = targetListeners[_i];
	        var listener = _ref;
	
	        if (listener(arg, name) === false) {
	          return false;
	        }
	      }
	    }
	  }]);
	
	  return Signals;
	}();
	
	var ___default_46 = Signals;
	_$Signals_46["default"] = ___default_46;
	
	var _$utils_56 = {};
	"use strict";
	
	Object.defineProperty(_$utils_56, "__esModule", {
	  value: true
	});
	_$utils_56.warnOnce = warnOnce;
	_$utils_56._getQBezierValue = _getQBezierValue;
	_$utils_56.getQuadraticCurvePoint = getQuadraticCurvePoint;
	_$utils_56.easeOutQuad = easeOutQuad;
	_$utils_56.copyAction = copyAction;
	Object.defineProperty(_$utils_56, "win", {
	  enumerable: true,
	  get: function get() {
	    return ___window_56["default"];
	  }
	});
	Object.defineProperty(_$utils_56, "browser", {
	  enumerable: true,
	  get: function get() {
	    return ___browser_56["default"];
	  }
	});
	Object.defineProperty(_$utils_56, "clone", {
	  enumerable: true,
	  get: function get() {
	    return _clone["default"];
	  }
	});
	Object.defineProperty(_$utils_56, "events", {
	  enumerable: true,
	  get: function get() {
	    return _events["default"];
	  }
	});
	Object.defineProperty(_$utils_56, "extend", {
	  enumerable: true,
	  get: function get() {
	    return ___extend_56["default"];
	  }
	});
	Object.defineProperty(_$utils_56, "getOriginXY", {
	  enumerable: true,
	  get: function get() {
	    return _getOriginXY["default"];
	  }
	});
	Object.defineProperty(_$utils_56, "hypot", {
	  enumerable: true,
	  get: function get() {
	    return ___hypot_56["default"];
	  }
	});
	Object.defineProperty(_$utils_56, "normalizeListeners", {
	  enumerable: true,
	  get: function get() {
	    return _normalizeListeners["default"];
	  }
	});
	Object.defineProperty(_$utils_56, "pointer", {
	  enumerable: true,
	  get: function get() {
	    return ___pointerUtils_56["default"];
	  }
	});
	Object.defineProperty(_$utils_56, "raf", {
	  enumerable: true,
	  get: function get() {
	    return _raf["default"];
	  }
	});
	Object.defineProperty(_$utils_56, "rect", {
	  enumerable: true,
	  get: function get() {
	    return ___rect_56["default"];
	  }
	});
	Object.defineProperty(_$utils_56, "Signals", {
	  enumerable: true,
	  get: function get() {
	    return _Signals["default"];
	  }
	});
	_$utils_56.is = _$utils_56.dom = _$utils_56.arr = void 0;
	
	var __arr_56 = ___interopRequireWildcard_56(_$arr_47);
	
	_$utils_56.arr = __arr_56;
	
	var dom = ___interopRequireWildcard_56(_$domUtils_51);
	
	_$utils_56.dom = dom;
	
	var __is_56 = ___interopRequireWildcard_56(_$is_57);
	
	_$utils_56.is = __is_56;
	
	var ___window_56 = ___interopRequireDefault_56(_$window_66);
	
	var ___browser_56 = ___interopRequireDefault_56(_$browser_48);
	
	var _clone = ___interopRequireDefault_56(_$clone_49);
	
	var _events = ___interopRequireDefault_56(_$events_52);
	
	var ___extend_56 = ___interopRequireDefault_56(_$extend_53);
	
	var _getOriginXY = ___interopRequireDefault_56(_$getOriginXY_54);
	
	var ___hypot_56 = ___interopRequireDefault_56(_$hypot_55);
	
	var _normalizeListeners = ___interopRequireDefault_56(_$normalizeListeners_59);
	
	var ___pointerUtils_56 = ___interopRequireDefault_56(_$pointerUtils_61);
	
	var _raf = ___interopRequireDefault_56(_$raf_62);
	
	var ___rect_56 = ___interopRequireDefault_56(_$rect_63);
	
	var _Signals = ___interopRequireDefault_56(_$Signals_46);
	
	function ___interopRequireDefault_56(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_56() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_56 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_56(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_56(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function warnOnce(method, message) {
	  var warned = false; // eslint-disable-next-line no-shadow
	
	  return function () {
	    if (!warned) {
	      ___window_56["default"].window.console.warn(message);
	
	      warned = true;
	    }
	
	    return method.apply(this, arguments);
	  };
	} // http://stackoverflow.com/a/5634528/2280888
	
	
	function _getQBezierValue(t, p1, p2, p3) {
	  var iT = 1 - t;
	  return iT * iT * p1 + 2 * iT * t * p2 + t * t * p3;
	}
	
	function getQuadraticCurvePoint(startX, startY, cpX, cpY, endX, endY, position) {
	  return {
	    x: _getQBezierValue(position, startX, cpX, endX),
	    y: _getQBezierValue(position, startY, cpY, endY)
	  };
	} // http://gizma.com/easing/
	
	
	function easeOutQuad(t, b, c, d) {
	  t /= d;
	  return -c * t * (t - 2) + b;
	}
	
	function copyAction(dest, src) {
	  dest.name = src.name;
	  dest.axis = src.axis;
	  dest.edges = src.edges;
	  return dest;
	}
	
	var _$defaultOptions_20 = {};
	"use strict";
	
	Object.defineProperty(_$defaultOptions_20, "__esModule", {
	  value: true
	});
	_$defaultOptions_20["default"] = _$defaultOptions_20.defaults = void 0;
	// tslint:disable no-empty-interface
	var defaults = {
	  base: {
	    preventDefault: 'auto',
	    deltaSource: 'page'
	  },
	  perAction: {
	    enabled: false,
	    origin: {
	      x: 0,
	      y: 0
	    }
	  },
	  actions: {}
	};
	_$defaultOptions_20.defaults = defaults;
	var ___default_20 = defaults;
	_$defaultOptions_20["default"] = ___default_20;
	
	var _$Eventable_14 = {};
	"use strict";
	
	Object.defineProperty(_$Eventable_14, "__esModule", {
	  value: true
	});
	_$Eventable_14["default"] = void 0;
	
	var __arr_14 = ___interopRequireWildcard_14(_$arr_47);
	
	var ___extend_14 = ___interopRequireDefault_14(_$extend_53);
	
	var ___normalizeListeners_14 = ___interopRequireDefault_14(_$normalizeListeners_59);
	
	function ___interopRequireDefault_14(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_14() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_14 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_14(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_14(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___classCallCheck_14(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ___defineProperties_14(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function ___createClass_14(Constructor, protoProps, staticProps) { if (protoProps) ___defineProperties_14(Constructor.prototype, protoProps); if (staticProps) ___defineProperties_14(Constructor, staticProps); return Constructor; }
	
	function fireUntilImmediateStopped(event, listeners) {
	  for (var _i = 0; _i < listeners.length; _i++) {
	    var _ref;
	
	    _ref = listeners[_i];
	    var listener = _ref;
	
	    if (event.immediatePropagationStopped) {
	      break;
	    }
	
	    listener(event);
	  }
	}
	
	var Eventable =
	/*#__PURE__*/
	function () {
	  function Eventable(options) {
	    ___classCallCheck_14(this, Eventable);
	
	    this.types = {};
	    this.propagationStopped = false;
	    this.immediatePropagationStopped = false;
	    this.options = (0, ___extend_14["default"])({}, options || {});
	  }
	
	  ___createClass_14(Eventable, [{
	    key: "fire",
	    value: function fire(event) {
	      var listeners;
	      var global = this.global; // Interactable#on() listeners
	      // tslint:disable no-conditional-assignment
	
	      if (listeners = this.types[event.type]) {
	        fireUntilImmediateStopped(event, listeners);
	      } // interact.on() listeners
	
	
	      if (!event.propagationStopped && global && (listeners = global[event.type])) {
	        fireUntilImmediateStopped(event, listeners);
	      }
	    }
	  }, {
	    key: "on",
	    value: function on(type, listener) {
	      var listeners = (0, ___normalizeListeners_14["default"])(type, listener);
	
	      for (type in listeners) {
	        this.types[type] = __arr_14.merge(this.types[type] || [], listeners[type]);
	      }
	    }
	  }, {
	    key: "off",
	    value: function off(type, listener) {
	      var listeners = (0, ___normalizeListeners_14["default"])(type, listener);
	
	      for (type in listeners) {
	        var eventList = this.types[type];
	
	        if (!eventList || !eventList.length) {
	          continue;
	        }
	
	        for (var _i2 = 0; _i2 < listeners[type].length; _i2++) {
	          var _ref2;
	
	          _ref2 = listeners[type][_i2];
	          var subListener = _ref2;
	          var index = eventList.indexOf(subListener);
	
	          if (index !== -1) {
	            eventList.splice(index, 1);
	          }
	        }
	      }
	    }
	  }, {
	    key: "getRect",
	    value: function getRect(_element) {
	      return null;
	    }
	  }]);
	
	  return Eventable;
	}();
	
	var ___default_14 = Eventable;
	_$Eventable_14["default"] = ___default_14;
	
	var _$Interactable_16 = {};
	"use strict";
	
	Object.defineProperty(_$Interactable_16, "__esModule", {
	  value: true
	});
	_$Interactable_16["default"] = _$Interactable_16.Interactable = void 0;
	
	var __arr_16 = ___interopRequireWildcard_16(_$arr_47);
	
	var ___browser_16 = ___interopRequireDefault_16(_$browser_48);
	
	var ___clone_16 = ___interopRequireDefault_16(_$clone_49);
	
	/* removed: var _$domUtils_51 = require("@interactjs/utils/domUtils"); */;
	
	var ___events_16 = ___interopRequireDefault_16(_$events_52);
	
	var ___extend_16 = ___interopRequireDefault_16(_$extend_53);
	
	var __is_16 = ___interopRequireWildcard_16(_$is_57);
	
	var ___normalizeListeners_16 = ___interopRequireDefault_16(_$normalizeListeners_59);
	
	/* removed: var _$window_66 = require("@interactjs/utils/window"); */;
	
	var _Eventable = ___interopRequireDefault_16(_$Eventable_14);
	
	function ___interopRequireDefault_16(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_16() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_16 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_16(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_16(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___classCallCheck_16(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ___defineProperties_16(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function ___createClass_16(Constructor, protoProps, staticProps) { if (protoProps) ___defineProperties_16(Constructor.prototype, protoProps); if (staticProps) ___defineProperties_16(Constructor, staticProps); return Constructor; }
	
	/** */
	var Interactable =
	/*#__PURE__*/
	function () {
	  /** */
	  function Interactable(target, options, defaultContext) {
	    ___classCallCheck_16(this, Interactable);
	
	    this.events = new _Eventable["default"]();
	    this._actions = options.actions;
	    this.target = target;
	    this._context = options.context || defaultContext;
	    this._win = (0, _$window_66.getWindow)((0, _$domUtils_51.trySelector)(target) ? this._context : target);
	    this._doc = this._win.document;
	    this.set(options);
	  }
	
	  ___createClass_16(Interactable, [{
	    key: "setOnEvents",
	    value: function setOnEvents(actionName, phases) {
	      if (__is_16.func(phases.onstart)) {
	        this.on("".concat(actionName, "start"), phases.onstart);
	      }
	
	      if (__is_16.func(phases.onmove)) {
	        this.on("".concat(actionName, "move"), phases.onmove);
	      }
	
	      if (__is_16.func(phases.onend)) {
	        this.on("".concat(actionName, "end"), phases.onend);
	      }
	
	      if (__is_16.func(phases.oninertiastart)) {
	        this.on("".concat(actionName, "inertiastart"), phases.oninertiastart);
	      }
	
	      return this;
	    }
	  }, {
	    key: "updatePerActionListeners",
	    value: function updatePerActionListeners(actionName, prev, cur) {
	      if (__is_16.array(prev) || __is_16.object(prev)) {
	        this.off(actionName, prev);
	      }
	
	      if (__is_16.array(cur) || __is_16.object(cur)) {
	        this.on(actionName, cur);
	      }
	    }
	  }, {
	    key: "setPerAction",
	    value: function setPerAction(actionName, options) {
	      var defaults = this._defaults; // for all the default per-action options
	
	      for (var optionName in options) {
	        var actionOptions = this.options[actionName];
	        var optionValue = options[optionName];
	        var isArray = __is_16.array(optionValue); // remove old event listeners and add new ones
	
	        if (optionName === 'listeners') {
	          this.updatePerActionListeners(actionName, actionOptions.listeners, optionValue);
	        } // if the option value is an array
	
	
	        if (isArray) {
	          actionOptions[optionName] = __arr_16.from(optionValue);
	        } // if the option value is an object
	        else if (!isArray && __is_16.plainObject(optionValue)) {
	            // copy the object
	            actionOptions[optionName] = (0, ___extend_16["default"])(actionOptions[optionName] || {}, (0, ___clone_16["default"])(optionValue)); // set anabled field to true if it exists in the defaults
	
	            if (__is_16.object(defaults.perAction[optionName]) && 'enabled' in defaults.perAction[optionName]) {
	              actionOptions[optionName].enabled = optionValue.enabled !== false;
	            }
	          } // if the option value is a boolean and the default is an object
	          else if (__is_16.bool(optionValue) && __is_16.object(defaults.perAction[optionName])) {
	              actionOptions[optionName].enabled = optionValue;
	            } // if it's anything else, do a plain assignment
	            else {
	                actionOptions[optionName] = optionValue;
	              }
	      }
	    }
	    /**
	     * The default function to get an Interactables bounding rect. Can be
	     * overridden using {@link Interactable.rectChecker}.
	     *
	     * @param {Element} [element] The element to measure.
	     * @return {object} The object's bounding rectangle.
	     */
	
	  }, {
	    key: "getRect",
	    value: function getRect(element) {
	      element = element || (__is_16.element(this.target) ? this.target : null);
	
	      if (__is_16.string(this.target)) {
	        element = element || this._context.querySelector(this.target);
	      }
	
	      return (0, _$domUtils_51.getElementRect)(element);
	    }
	    /**
	     * Returns or sets the function used to calculate the interactable's
	     * element's rectangle
	     *
	     * @param {function} [checker] A function which returns this Interactable's
	     * bounding rectangle. See {@link Interactable.getRect}
	     * @return {function | object} The checker function or this Interactable
	     */
	
	  }, {
	    key: "rectChecker",
	    value: function rectChecker(checker) {
	      if (__is_16.func(checker)) {
	        this.getRect = checker;
	        return this;
	      }
	
	      if (checker === null) {
	        delete this.getRect;
	        return this;
	      }
	
	      return this.getRect;
	    }
	  }, {
	    key: "_backCompatOption",
	    value: function _backCompatOption(optionName, newValue) {
	      if ((0, _$domUtils_51.trySelector)(newValue) || __is_16.object(newValue)) {
	        this.options[optionName] = newValue;
	
	        for (var _i = 0; _i < this._actions.names.length; _i++) {
	          var _ref;
	
	          _ref = this._actions.names[_i];
	          var action = _ref;
	          this.options[action][optionName] = newValue;
	        }
	
	        return this;
	      }
	
	      return this.options[optionName];
	    }
	    /**
	     * Gets or sets the origin of the Interactable's element.  The x and y
	     * of the origin will be subtracted from action event coordinates.
	     *
	     * @param {Element | object | string} [origin] An HTML or SVG Element whose
	     * rect will be used, an object eg. { x: 0, y: 0 } or string 'parent', 'self'
	     * or any CSS selector
	     *
	     * @return {object} The current origin or this Interactable
	     */
	
	  }, {
	    key: "origin",
	    value: function origin(newValue) {
	      return this._backCompatOption('origin', newValue);
	    }
	    /**
	     * Returns or sets the mouse coordinate types used to calculate the
	     * movement of the pointer.
	     *
	     * @param {string} [newValue] Use 'client' if you will be scrolling while
	     * interacting; Use 'page' if you want autoScroll to work
	     * @return {string | object} The current deltaSource or this Interactable
	     */
	
	  }, {
	    key: "deltaSource",
	    value: function deltaSource(newValue) {
	      if (newValue === 'page' || newValue === 'client') {
	        this.options.deltaSource = newValue;
	        return this;
	      }
	
	      return this.options.deltaSource;
	    }
	    /**
	     * Gets the selector context Node of the Interactable. The default is
	     * `window.document`.
	     *
	     * @return {Node} The context Node of this Interactable
	     */
	
	  }, {
	    key: "context",
	    value: function context() {
	      return this._context;
	    }
	  }, {
	    key: "inContext",
	    value: function inContext(element) {
	      return this._context === element.ownerDocument || (0, _$domUtils_51.nodeContains)(this._context, element);
	    }
	  }, {
	    key: "testIgnoreAllow",
	    value: function testIgnoreAllow(options, targetNode, eventTarget) {
	      return !this.testIgnore(options.ignoreFrom, targetNode, eventTarget) && this.testAllow(options.allowFrom, targetNode, eventTarget);
	    }
	  }, {
	    key: "testAllow",
	    value: function testAllow(allowFrom, targetNode, element) {
	      if (!allowFrom) {
	        return true;
	      }
	
	      if (!__is_16.element(element)) {
	        return false;
	      }
	
	      if (__is_16.string(allowFrom)) {
	        return (0, _$domUtils_51.matchesUpTo)(element, allowFrom, targetNode);
	      } else if (__is_16.element(allowFrom)) {
	        return (0, _$domUtils_51.nodeContains)(allowFrom, element);
	      }
	
	      return false;
	    }
	  }, {
	    key: "testIgnore",
	    value: function testIgnore(ignoreFrom, targetNode, element) {
	      if (!ignoreFrom || !__is_16.element(element)) {
	        return false;
	      }
	
	      if (__is_16.string(ignoreFrom)) {
	        return (0, _$domUtils_51.matchesUpTo)(element, ignoreFrom, targetNode);
	      } else if (__is_16.element(ignoreFrom)) {
	        return (0, _$domUtils_51.nodeContains)(ignoreFrom, element);
	      }
	
	      return false;
	    }
	    /**
	     * Calls listeners for the given InteractEvent type bound globally
	     * and directly to this Interactable
	     *
	     * @param {InteractEvent} iEvent The InteractEvent object to be fired on this
	     * Interactable
	     * @return {Interactable} this Interactable
	     */
	
	  }, {
	    key: "fire",
	    value: function fire(iEvent) {
	      this.events.fire(iEvent);
	      return this;
	    }
	  }, {
	    key: "_onOff",
	    value: function _onOff(method, typeArg, listenerArg, options) {
	      if (__is_16.object(typeArg) && !__is_16.array(typeArg)) {
	        options = listenerArg;
	        listenerArg = null;
	      }
	
	      var addRemove = method === 'on' ? 'add' : 'remove';
	      var listeners = (0, ___normalizeListeners_16["default"])(typeArg, listenerArg);
	
	      for (var type in listeners) {
	        if (type === 'wheel') {
	          type = ___browser_16["default"].wheelEvent;
	        }
	
	        for (var _i2 = 0; _i2 < listeners[type].length; _i2++) {
	          var _ref2;
	
	          _ref2 = listeners[type][_i2];
	          var listener = _ref2;
	
	          // if it is an action event type
	          if (__arr_16.contains(this._actions.eventTypes, type)) {
	            this.events[method](type, listener);
	          } // delegated event
	          else if (__is_16.string(this.target)) {
	              ___events_16["default"]["".concat(addRemove, "Delegate")](this.target, this._context, type, listener, options);
	            } // remove listener from this Interactable's element
	            else {
	                ___events_16["default"][addRemove](this.target, type, listener, options);
	              }
	        }
	      }
	
	      return this;
	    }
	    /**
	     * Binds a listener for an InteractEvent, pointerEvent or DOM event.
	     *
	     * @param {string | array | object} types The types of events to listen
	     * for
	     * @param {function | array | object} [listener] The event listener function(s)
	     * @param {object | boolean} [options] options object or useCapture flag for
	     * addEventListener
	     * @return {Interactable} This Interactable
	     */
	
	  }, {
	    key: "on",
	    value: function on(types, listener, options) {
	      return this._onOff('on', types, listener, options);
	    }
	    /**
	     * Removes an InteractEvent, pointerEvent or DOM event listener.
	     *
	     * @param {string | array | object} types The types of events that were
	     * listened for
	     * @param {function | array | object} [listener] The event listener function(s)
	     * @param {object | boolean} [options] options object or useCapture flag for
	     * removeEventListener
	     * @return {Interactable} This Interactable
	     */
	
	  }, {
	    key: "off",
	    value: function off(types, listener, options) {
	      return this._onOff('off', types, listener, options);
	    }
	    /**
	     * Reset the options of this Interactable
	     *
	     * @param {object} options The new settings to apply
	     * @return {object} This Interactable
	     */
	
	  }, {
	    key: "set",
	    value: function set(options) {
	      var defaults = this._defaults;
	
	      if (!__is_16.object(options)) {
	        options = {};
	      }
	
	      this.options = (0, ___clone_16["default"])(defaults.base);
	
	      for (var actionName in this._actions.methodDict) {
	        var methodName = this._actions.methodDict[actionName];
	        this.options[actionName] = {};
	        this.setPerAction(actionName, (0, ___extend_16["default"])((0, ___extend_16["default"])({}, defaults.perAction), defaults.actions[actionName]));
	        this[methodName](options[actionName]);
	      }
	
	      for (var setting in options) {
	        if (__is_16.func(this[setting])) {
	          this[setting](options[setting]);
	        }
	      }
	
	      return this;
	    }
	    /**
	     * Remove this interactable from the list of interactables and remove it's
	     * action capabilities and event listeners
	     *
	     * @return {interact}
	     */
	
	  }, {
	    key: "unset",
	    value: function unset() {
	      ___events_16["default"].remove(this.target, 'all');
	
	      if (__is_16.string(this.target)) {
	        // remove delegated events
	        for (var type in ___events_16["default"].delegatedEvents) {
	          var delegated = ___events_16["default"].delegatedEvents[type];
	
	          if (delegated.selectors[0] === this.target && delegated.contexts[0] === this._context) {
	            delegated.selectors.splice(0, 1);
	            delegated.contexts.splice(0, 1);
	            delegated.listeners.splice(0, 1); // remove the arrays if they are empty
	
	            if (!delegated.selectors.length) {
	              delegated[type] = null;
	            }
	          }
	
	          ___events_16["default"].remove(this._context, type, ___events_16["default"].delegateListener);
	
	          ___events_16["default"].remove(this._context, type, ___events_16["default"].delegateUseCapture, true);
	        }
	      } else {
	        ___events_16["default"].remove(this.target, 'all');
	      }
	    }
	  }, {
	    key: "_defaults",
	    get: function get() {
	      return {
	        base: {},
	        perAction: {},
	        actions: {}
	      };
	    }
	  }]);
	
	  return Interactable;
	}();
	
	_$Interactable_16.Interactable = Interactable;
	var ___default_16 = Interactable;
	_$Interactable_16["default"] = ___default_16;
	
	var _$InteractableSet_17 = {};
	"use strict";
	
	Object.defineProperty(_$InteractableSet_17, "__esModule", {
	  value: true
	});
	_$InteractableSet_17["default"] = void 0;
	
	var __arr_17 = ___interopRequireWildcard_17(_$arr_47);
	
	var __domUtils_17 = ___interopRequireWildcard_17(_$domUtils_51);
	
	var ___extend_17 = ___interopRequireDefault_17(_$extend_53);
	
	var __is_17 = ___interopRequireWildcard_17(_$is_57);
	
	var ___Signals_17 = ___interopRequireDefault_17(_$Signals_46);
	
	function ___interopRequireDefault_17(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_17() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_17 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_17(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_17(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___classCallCheck_17(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ___defineProperties_17(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function ___createClass_17(Constructor, protoProps, staticProps) { if (protoProps) ___defineProperties_17(Constructor.prototype, protoProps); if (staticProps) ___defineProperties_17(Constructor, staticProps); return Constructor; }
	
	var InteractableSet =
	/*#__PURE__*/
	function () {
	  function InteractableSet(scope) {
	    var _this = this;
	
	    ___classCallCheck_17(this, InteractableSet);
	
	    this.scope = scope;
	    this.signals = new ___Signals_17["default"](); // all set interactables
	
	    this.list = [];
	    this.selectorMap = {};
	    this.signals.on('unset', function (_ref) {
	      var interactable = _ref.interactable;
	      var target = interactable.target,
	          context = interactable._context;
	      var targetMappings = __is_17.string(target) ? _this.selectorMap[target] : target[_this.scope.id];
	      var targetIndex = targetMappings.findIndex(function (m) {
	        return m.context === context;
	      });
	
	      if (targetMappings[targetIndex]) {
	        // Destroying mappingInfo's context and interactable
	        targetMappings[targetIndex].context = null;
	        targetMappings[targetIndex].interactable = null;
	      }
	
	      targetMappings.splice(targetIndex, 1);
	    });
	  }
	
	  ___createClass_17(InteractableSet, [{
	    key: "new",
	    value: function _new(target, options) {
	      options = (0, ___extend_17["default"])(options || {}, {
	        actions: this.scope.actions
	      });
	      var interactable = new this.scope.Interactable(target, options, this.scope.document);
	      var mappingInfo = {
	        context: interactable._context,
	        interactable: interactable
	      };
	      this.scope.addDocument(interactable._doc);
	      this.list.push(interactable);
	
	      if (__is_17.string(target)) {
	        if (!this.selectorMap[target]) {
	          this.selectorMap[target] = [];
	        }
	
	        this.selectorMap[target].push(mappingInfo);
	      } else {
	        if (!interactable.target[this.scope.id]) {
	          Object.defineProperty(target, this.scope.id, {
	            value: [],
	            configurable: true
	          });
	        }
	
	        target[this.scope.id].push(mappingInfo);
	      }
	
	      this.signals.fire('new', {
	        target: target,
	        options: options,
	        interactable: interactable,
	        win: this.scope._win
	      });
	      return interactable;
	    }
	  }, {
	    key: "get",
	    value: function get(target, options) {
	      var context = options && options.context || this.scope.document;
	      var isSelector = __is_17.string(target);
	      var targetMappings = isSelector ? this.selectorMap[target] : target[this.scope.id];
	
	      if (!targetMappings) {
	        return null;
	      }
	
	      var found = __arr_17.find(targetMappings, function (m) {
	        return m.context === context && (isSelector || m.interactable.inContext(target));
	      });
	      return found && found.interactable;
	    }
	  }, {
	    key: "forEachMatch",
	    value: function forEachMatch(node, callback) {
	      for (var _i = 0; _i < this.list.length; _i++) {
	        var _ref2;
	
	        _ref2 = this.list[_i];
	        var interactable = _ref2;
	        var ret = void 0;
	
	        if ((__is_17.string(interactable.target) // target is a selector and the element matches
	        ? __is_17.element(node) && __domUtils_17.matchesSelector(node, interactable.target) : // target is the element
	        node === interactable.target) && // the element is in context
	        interactable.inContext(node)) {
	          ret = callback(interactable);
	        }
	
	        if (ret !== undefined) {
	          return ret;
	        }
	      }
	    }
	  }]);
	
	  return InteractableSet;
	}();
	
	_$InteractableSet_17["default"] = InteractableSet;
	
	var _$BaseEvent_13 = {};
	"use strict";
	
	Object.defineProperty(_$BaseEvent_13, "__esModule", {
	  value: true
	});
	_$BaseEvent_13["default"] = _$BaseEvent_13.BaseEvent = _$BaseEvent_13.EventPhase = void 0;
	
	function ___classCallCheck_13(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ___defineProperties_13(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function ___createClass_13(Constructor, protoProps, staticProps) { if (protoProps) ___defineProperties_13(Constructor.prototype, protoProps); if (staticProps) ___defineProperties_13(Constructor, staticProps); return Constructor; }
	
	var EventPhase;
	_$BaseEvent_13.EventPhase = EventPhase;
	
	(function (EventPhase) {
	  EventPhase["Start"] = "start";
	  EventPhase["Move"] = "move";
	  EventPhase["End"] = "end";
	  EventPhase["_NONE"] = "";
	})(EventPhase || (_$BaseEvent_13.EventPhase = EventPhase = {}));
	
	var BaseEvent =
	/*#__PURE__*/
	function () {
	  function BaseEvent(interaction) {
	    ___classCallCheck_13(this, BaseEvent);
	
	    this.immediatePropagationStopped = false;
	    this.propagationStopped = false;
	    this._interaction = interaction;
	  }
	
	  ___createClass_13(BaseEvent, [{
	    key: "preventDefault",
	    value: function preventDefault() {}
	    /**
	     * Don't call any other listeners (even on the current target)
	     */
	
	  }, {
	    key: "stopPropagation",
	    value: function stopPropagation() {
	      this.propagationStopped = true;
	    }
	    /**
	     * Don't call listeners on the remaining targets
	     */
	
	  }, {
	    key: "stopImmediatePropagation",
	    value: function stopImmediatePropagation() {
	      this.immediatePropagationStopped = this.propagationStopped = true;
	    }
	  }, {
	    key: "interaction",
	    get: function get() {
	      return this._interaction._proxy;
	    }
	  }]);
	
	  return BaseEvent;
	}();
	
	_$BaseEvent_13.BaseEvent = BaseEvent;
	var ___default_13 = BaseEvent;
	_$BaseEvent_13["default"] = ___default_13;
	
	var _$InteractEvent_15 = {};
	"use strict";
	
	Object.defineProperty(_$InteractEvent_15, "__esModule", {
	  value: true
	});
	_$InteractEvent_15["default"] = _$InteractEvent_15.InteractEvent = _$InteractEvent_15.EventPhase = void 0;
	
	var ___extend_15 = ___interopRequireDefault_15(_$extend_53);
	
	var ___getOriginXY_15 = ___interopRequireDefault_15(_$getOriginXY_54);
	
	var ___hypot_15 = ___interopRequireDefault_15(_$hypot_55);
	
	var _BaseEvent2 = ___interopRequireDefault_15(_$BaseEvent_13);
	
	var _defaultOptions = ___interopRequireDefault_15(_$defaultOptions_20);
	
	function ___interopRequireDefault_15(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___typeof_15(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ___typeof_15 = function _typeof(obj) { return typeof obj; }; } else { ___typeof_15 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ___typeof_15(obj); }
	
	function ___classCallCheck_15(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ___defineProperties_15(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function ___createClass_15(Constructor, protoProps, staticProps) { if (protoProps) ___defineProperties_15(Constructor.prototype, protoProps); if (staticProps) ___defineProperties_15(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (___typeof_15(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var __EventPhase_15;
	_$InteractEvent_15.EventPhase = __EventPhase_15;
	
	(function (EventPhase) {
	  EventPhase["Start"] = "start";
	  EventPhase["Move"] = "move";
	  EventPhase["End"] = "end";
	  EventPhase["_NONE"] = "";
	})(__EventPhase_15 || (_$InteractEvent_15.EventPhase = __EventPhase_15 = {}));
	
	var InteractEvent =
	/*#__PURE__*/
	function (_BaseEvent) {
	  _inherits(InteractEvent, _BaseEvent);
	
	  /** */
	  function InteractEvent(interaction, event, actionName, phase, element, related, preEnd, type) {
	    var _this;
	
	    ___classCallCheck_15(this, InteractEvent);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(InteractEvent).call(this, interaction));
	    element = element || interaction.element;
	    var target = interaction.interactable;
	    var deltaSource = (target && target.options || _defaultOptions["default"]).deltaSource;
	    var origin = (0, ___getOriginXY_15["default"])(target, element, actionName);
	    var starting = phase === 'start';
	    var ending = phase === 'end';
	    var prevEvent = starting ? _assertThisInitialized(_this) : interaction.prevEvent;
	    var coords = starting ? interaction.coords.start : ending ? {
	      page: prevEvent.page,
	      client: prevEvent.client,
	      timeStamp: interaction.coords.cur.timeStamp
	    } : interaction.coords.cur;
	    _this.page = (0, ___extend_15["default"])({}, coords.page);
	    _this.client = (0, ___extend_15["default"])({}, coords.client);
	    _this.rect = (0, ___extend_15["default"])({}, interaction.rect);
	    _this.timeStamp = coords.timeStamp;
	
	    if (!ending) {
	      _this.page.x -= origin.x;
	      _this.page.y -= origin.y;
	      _this.client.x -= origin.x;
	      _this.client.y -= origin.y;
	    }
	
	    _this.ctrlKey = event.ctrlKey;
	    _this.altKey = event.altKey;
	    _this.shiftKey = event.shiftKey;
	    _this.metaKey = event.metaKey;
	    _this.button = event.button;
	    _this.buttons = event.buttons;
	    _this.target = element;
	    _this.currentTarget = element;
	    _this.relatedTarget = related || null;
	    _this.preEnd = preEnd;
	    _this.type = type || actionName + (phase || '');
	    _this.interactable = target;
	    _this.t0 = starting ? interaction.pointers[interaction.pointers.length - 1].downTime : prevEvent.t0;
	    _this.x0 = interaction.coords.start.page.x - origin.x;
	    _this.y0 = interaction.coords.start.page.y - origin.y;
	    _this.clientX0 = interaction.coords.start.client.x - origin.x;
	    _this.clientY0 = interaction.coords.start.client.y - origin.y;
	
	    if (starting || ending) {
	      _this.delta = {
	        x: 0,
	        y: 0
	      };
	    } else {
	      _this.delta = {
	        x: _this[deltaSource].x - prevEvent[deltaSource].x,
	        y: _this[deltaSource].y - prevEvent[deltaSource].y
	      };
	    }
	
	    _this.dt = interaction.coords.delta.timeStamp;
	    _this.duration = _this.timeStamp - _this.t0; // velocity and speed in pixels per second
	
	    _this.velocity = (0, ___extend_15["default"])({}, interaction.coords.velocity[deltaSource]);
	    _this.speed = (0, ___hypot_15["default"])(_this.velocity.x, _this.velocity.y);
	    _this.swipe = ending || phase === 'inertiastart' ? _this.getSwipe() : null;
	    return _this;
	  }
	
	  ___createClass_15(InteractEvent, [{
	    key: "getSwipe",
	    value: function getSwipe() {
	      var interaction = this._interaction;
	
	      if (interaction.prevEvent.speed < 600 || this.timeStamp - interaction.prevEvent.timeStamp > 150) {
	        return null;
	      }
	
	      var angle = 180 * Math.atan2(interaction.prevEvent.velocityY, interaction.prevEvent.velocityX) / Math.PI;
	      var overlap = 22.5;
	
	      if (angle < 0) {
	        angle += 360;
	      }
	
	      var left = 135 - overlap <= angle && angle < 225 + overlap;
	      var up = 225 - overlap <= angle && angle < 315 + overlap;
	      var right = !left && (315 - overlap <= angle || angle < 45 + overlap);
	      var down = !up && 45 - overlap <= angle && angle < 135 + overlap;
	      return {
	        up: up,
	        down: down,
	        left: left,
	        right: right,
	        angle: angle,
	        speed: interaction.prevEvent.speed,
	        velocity: {
	          x: interaction.prevEvent.velocityX,
	          y: interaction.prevEvent.velocityY
	        }
	      };
	    }
	  }, {
	    key: "preventDefault",
	    value: function preventDefault() {}
	    /**
	     * Don't call listeners on the remaining targets
	     */
	
	  }, {
	    key: "stopImmediatePropagation",
	    value: function stopImmediatePropagation() {
	      this.immediatePropagationStopped = this.propagationStopped = true;
	    }
	    /**
	     * Don't call any other listeners (even on the current target)
	     */
	
	  }, {
	    key: "stopPropagation",
	    value: function stopPropagation() {
	      this.propagationStopped = true;
	    }
	  }, {
	    key: "pageX",
	    get: function get() {
	      return this.page.x;
	    },
	    set: function set(value) {
	      this.page.x = value;
	    }
	  }, {
	    key: "pageY",
	    get: function get() {
	      return this.page.y;
	    },
	    set: function set(value) {
	      this.page.y = value;
	    }
	  }, {
	    key: "clientX",
	    get: function get() {
	      return this.client.x;
	    },
	    set: function set(value) {
	      this.client.x = value;
	    }
	  }, {
	    key: "clientY",
	    get: function get() {
	      return this.client.y;
	    },
	    set: function set(value) {
	      this.client.y = value;
	    }
	  }, {
	    key: "dx",
	    get: function get() {
	      return this.delta.x;
	    },
	    set: function set(value) {
	      this.delta.x = value;
	    }
	  }, {
	    key: "dy",
	    get: function get() {
	      return this.delta.y;
	    },
	    set: function set(value) {
	      this.delta.y = value;
	    }
	  }, {
	    key: "velocityX",
	    get: function get() {
	      return this.velocity.x;
	    },
	    set: function set(value) {
	      this.velocity.x = value;
	    }
	  }, {
	    key: "velocityY",
	    get: function get() {
	      return this.velocity.y;
	    },
	    set: function set(value) {
	      this.velocity.y = value;
	    }
	  }]);
	
	  return InteractEvent;
	}(_BaseEvent2["default"]);
	
	_$InteractEvent_15.InteractEvent = InteractEvent;
	var ___default_15 = InteractEvent;
	_$InteractEvent_15["default"] = ___default_15;
	
	var _$PointerInfo_19 = {};
	"use strict";
	
	Object.defineProperty(_$PointerInfo_19, "__esModule", {
	  value: true
	});
	_$PointerInfo_19["default"] = _$PointerInfo_19.PointerInfo = void 0;
	
	function ___classCallCheck_19(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable @typescript-eslint/no-parameter-properties */
	var PointerInfo = function PointerInfo(id, pointer, event, downTime, downTarget) {
	  ___classCallCheck_19(this, PointerInfo);
	
	  this.id = id;
	  this.pointer = pointer;
	  this.event = event;
	  this.downTime = downTime;
	  this.downTarget = downTarget;
	};
	
	_$PointerInfo_19.PointerInfo = PointerInfo;
	var ___default_19 = PointerInfo;
	_$PointerInfo_19["default"] = ___default_19;
	
	var _$interactionFinder_22 = {};
	"use strict";
	
	Object.defineProperty(_$interactionFinder_22, "__esModule", {
	  value: true
	});
	_$interactionFinder_22["default"] = void 0;
	
	var __dom_22 = ___interopRequireWildcard_22(_$domUtils_51);
	
	function ___getRequireWildcardCache_22() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_22 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_22(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_22(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var finder = {
	  methodOrder: ['simulationResume', 'mouseOrPen', 'hasPointer', 'idle'],
	  search: function search(details) {
	    for (var _i = 0; _i < finder.methodOrder.length; _i++) {
	      var _ref;
	
	      _ref = finder.methodOrder[_i];
	      var method = _ref;
	      var interaction = finder[method](details);
	
	      if (interaction) {
	        return interaction;
	      }
	    }
	  },
	  // try to resume simulation with a new pointer
	  simulationResume: function simulationResume(_ref2) {
	    var pointerType = _ref2.pointerType,
	        eventType = _ref2.eventType,
	        eventTarget = _ref2.eventTarget,
	        scope = _ref2.scope;
	
	    if (!/down|start/i.test(eventType)) {
	      return null;
	    }
	
	    for (var _i2 = 0; _i2 < scope.interactions.list.length; _i2++) {
	      var _ref3;
	
	      _ref3 = scope.interactions.list[_i2];
	      var interaction = _ref3;
	      var element = eventTarget;
	
	      if (interaction.simulation && interaction.simulation.allowResume && interaction.pointerType === pointerType) {
	        while (element) {
	          // if the element is the interaction element
	          if (element === interaction.element) {
	            return interaction;
	          }
	
	          element = __dom_22.parentNode(element);
	        }
	      }
	    }
	
	    return null;
	  },
	  // if it's a mouse or pen interaction
	  mouseOrPen: function mouseOrPen(_ref4) {
	    var pointerId = _ref4.pointerId,
	        pointerType = _ref4.pointerType,
	        eventType = _ref4.eventType,
	        scope = _ref4.scope;
	
	    if (pointerType !== 'mouse' && pointerType !== 'pen') {
	      return null;
	    }
	
	    var firstNonActive;
	
	    for (var _i3 = 0; _i3 < scope.interactions.list.length; _i3++) {
	      var _ref5;
	
	      _ref5 = scope.interactions.list[_i3];
	      var interaction = _ref5;
	
	      if (interaction.pointerType === pointerType) {
	        // if it's a down event, skip interactions with running simulations
	        if (interaction.simulation && !hasPointerId(interaction, pointerId)) {
	          continue;
	        } // if the interaction is active, return it immediately
	
	
	        if (interaction.interacting()) {
	          return interaction;
	        } // otherwise save it and look for another active interaction
	        else if (!firstNonActive) {
	            firstNonActive = interaction;
	          }
	      }
	    } // if no active mouse interaction was found use the first inactive mouse
	    // interaction
	
	
	    if (firstNonActive) {
	      return firstNonActive;
	    } // find any mouse or pen interaction.
	    // ignore the interaction if the eventType is a *down, and a simulation
	    // is active
	
	
	    for (var _i4 = 0; _i4 < scope.interactions.list.length; _i4++) {
	      var _ref6;
	
	      _ref6 = scope.interactions.list[_i4];
	      var _interaction = _ref6;
	
	      if (_interaction.pointerType === pointerType && !(/down/i.test(eventType) && _interaction.simulation)) {
	        return _interaction;
	      }
	    }
	
	    return null;
	  },
	  // get interaction that has this pointer
	  hasPointer: function hasPointer(_ref7) {
	    var pointerId = _ref7.pointerId,
	        scope = _ref7.scope;
	
	    for (var _i5 = 0; _i5 < scope.interactions.list.length; _i5++) {
	      var _ref8;
	
	      _ref8 = scope.interactions.list[_i5];
	      var interaction = _ref8;
	
	      if (hasPointerId(interaction, pointerId)) {
	        return interaction;
	      }
	    }
	
	    return null;
	  },
	  // get first idle interaction with a matching pointerType
	  idle: function idle(_ref9) {
	    var pointerType = _ref9.pointerType,
	        scope = _ref9.scope;
	
	    for (var _i6 = 0; _i6 < scope.interactions.list.length; _i6++) {
	      var _ref10;
	
	      _ref10 = scope.interactions.list[_i6];
	      var interaction = _ref10;
	
	      // if there's already a pointer held down
	      if (interaction.pointers.length === 1) {
	        var target = interaction.interactable; // don't add this pointer if there is a target interactable and it
	        // isn't gesturable
	
	        if (target && !(target.options.gesture && target.options.gesture.enabled)) {
	          continue;
	        }
	      } // maximum of 2 pointers per interaction
	      else if (interaction.pointers.length >= 2) {
	          continue;
	        }
	
	      if (!interaction.interacting() && pointerType === interaction.pointerType) {
	        return interaction;
	      }
	    }
	
	    return null;
	  }
	};
	
	function hasPointerId(interaction, pointerId) {
	  return interaction.pointers.some(function (_ref11) {
	    var id = _ref11.id;
	    return id === pointerId;
	  });
	}
	
	var ___default_22 = finder;
	_$interactionFinder_22["default"] = ___default_22;
	
	var _$drag_1 = {};
	"use strict";
	
	Object.defineProperty(_$drag_1, "__esModule", {
	  value: true
	});
	_$drag_1["default"] = void 0;
	
	var ___scope_1 = _$scope_24({});
	
	var __arr_1 = ___interopRequireWildcard_1(_$arr_47);
	
	var __is_1 = ___interopRequireWildcard_1(_$is_57);
	
	function ___getRequireWildcardCache_1() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_1 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_1(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_1(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	___scope_1.ActionName.Drag = 'drag';
	
	function __install_1(scope) {
	  var actions = scope.actions,
	      Interactable = scope.Interactable,
	      interactions = scope.interactions,
	      defaults = scope.defaults;
	  interactions.signals.on('before-action-move', beforeMove);
	  interactions.signals.on('action-resume', beforeMove); // dragmove
	
	  interactions.signals.on('action-move', move);
	  Interactable.prototype.draggable = drag.draggable;
	  actions[___scope_1.ActionName.Drag] = drag;
	  actions.names.push(___scope_1.ActionName.Drag);
	  __arr_1.merge(actions.eventTypes, ['dragstart', 'dragmove', 'draginertiastart', 'dragresume', 'dragend']);
	  actions.methodDict.drag = 'draggable';
	  defaults.actions.drag = drag.defaults;
	}
	
	function beforeMove(_ref) {
	  var interaction = _ref.interaction;
	
	  if (interaction.prepared.name !== 'drag') {
	    return;
	  }
	
	  var axis = interaction.prepared.axis;
	
	  if (axis === 'x') {
	    interaction.coords.cur.page.y = interaction.coords.start.page.y;
	    interaction.coords.cur.client.y = interaction.coords.start.client.y;
	    interaction.coords.velocity.client.y = 0;
	    interaction.coords.velocity.page.y = 0;
	  } else if (axis === 'y') {
	    interaction.coords.cur.page.x = interaction.coords.start.page.x;
	    interaction.coords.cur.client.x = interaction.coords.start.client.x;
	    interaction.coords.velocity.client.x = 0;
	    interaction.coords.velocity.page.x = 0;
	  }
	}
	
	function move(_ref2) {
	  var iEvent = _ref2.iEvent,
	      interaction = _ref2.interaction;
	
	  if (interaction.prepared.name !== 'drag') {
	    return;
	  }
	
	  var axis = interaction.prepared.axis;
	
	  if (axis === 'x' || axis === 'y') {
	    var opposite = axis === 'x' ? 'y' : 'x';
	    iEvent.page[opposite] = interaction.coords.start.page[opposite];
	    iEvent.client[opposite] = interaction.coords.start.client[opposite];
	    iEvent.delta[opposite] = 0;
	  }
	}
	/**
	 * ```js
	 * interact(element).draggable({
	 *     onstart: function (event) {},
	 *     onmove : function (event) {},
	 *     onend  : function (event) {},
	 *
	 *     // the axis in which the first movement must be
	 *     // for the drag sequence to start
	 *     // 'xy' by default - any direction
	 *     startAxis: 'x' || 'y' || 'xy',
	 *
	 *     // 'xy' by default - don't restrict to one axis (move in any direction)
	 *     // 'x' or 'y' to restrict movement to either axis
	 *     // 'start' to restrict movement to the axis the drag started in
	 *     lockAxis: 'x' || 'y' || 'xy' || 'start',
	 *
	 *     // max number of drags that can happen concurrently
	 *     // with elements of this Interactable. Infinity by default
	 *     max: Infinity,
	 *
	 *     // max number of drags that can target the same element+Interactable
	 *     // 1 by default
	 *     maxPerElement: 2
	 * })
	 *
	 * var isDraggable = interact('element').draggable(); // true
	 * ```
	 *
	 * Get or set whether drag actions can be performed on the target
	 *
	 * @alias Interactable.prototype.draggable
	 *
	 * @param {boolean | object} [options] true/false or An object with event
	 * listeners to be fired on drag events (object makes the Interactable
	 * draggable)
	 * @return {boolean | Interactable} boolean indicating if this can be the
	 * target of drag events, or this Interctable
	 */
	
	
	var draggable = function draggable(options) {
	  if (__is_1.object(options)) {
	    this.options.drag.enabled = options.enabled !== false;
	    this.setPerAction('drag', options);
	    this.setOnEvents('drag', options);
	
	    if (/^(xy|x|y|start)$/.test(options.lockAxis)) {
	      this.options.drag.lockAxis = options.lockAxis;
	    }
	
	    if (/^(xy|x|y)$/.test(options.startAxis)) {
	      this.options.drag.startAxis = options.startAxis;
	    }
	
	    return this;
	  }
	
	  if (__is_1.bool(options)) {
	    this.options.drag.enabled = options;
	    return this;
	  }
	
	  return this.options.drag;
	};
	
	var drag = {
	  id: 'actions/drag',
	  install: __install_1,
	  draggable: draggable,
	  beforeMove: beforeMove,
	  move: move,
	  defaults: {
	    startAxis: 'xy',
	    lockAxis: 'xy'
	  },
	  checker: function checker(_pointer, _event, interactable) {
	    var dragOptions = interactable.options.drag;
	    return dragOptions.enabled ? {
	      name: 'drag',
	      axis: dragOptions.lockAxis === 'start' ? dragOptions.startAxis : dragOptions.lockAxis
	    } : null;
	  },
	  getCursor: function getCursor() {
	    return 'move';
	  }
	};
	var ___default_1 = drag;
	_$drag_1["default"] = ___default_1;
	
	var _$DropEvent_2 = {};
	"use strict";
	
	Object.defineProperty(_$DropEvent_2, "__esModule", {
	  value: true
	});
	_$DropEvent_2["default"] = void 0;
	
	var ___BaseEvent2_2 = ___interopRequireDefault_2(_$BaseEvent_13);
	
	var __arr_2 = ___interopRequireWildcard_2(_$arr_47);
	
	function ___getRequireWildcardCache_2() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_2 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_2(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_2(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___interopRequireDefault_2(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___typeof_2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ___typeof_2 = function _typeof(obj) { return typeof obj; }; } else { ___typeof_2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ___typeof_2(obj); }
	
	function ___toConsumableArray_2(arr) { return ___arrayWithoutHoles_2(arr) || ___iterableToArray_2(arr) || ___nonIterableSpread_2(); }
	
	function ___nonIterableSpread_2() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function ___iterableToArray_2(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function ___arrayWithoutHoles_2(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ___classCallCheck_2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ___defineProperties_2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function ___createClass_2(Constructor, protoProps, staticProps) { if (protoProps) ___defineProperties_2(Constructor.prototype, protoProps); if (staticProps) ___defineProperties_2(Constructor, staticProps); return Constructor; }
	
	function ___possibleConstructorReturn_2(self, call) { if (call && (___typeof_2(call) === "object" || typeof call === "function")) { return call; } return ___assertThisInitialized_2(self); }
	
	function ___assertThisInitialized_2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function ___getPrototypeOf_2(o) { ___getPrototypeOf_2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ___getPrototypeOf_2(o); }
	
	function ___inherits_2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ___setPrototypeOf_2(subClass, superClass); }
	
	function ___setPrototypeOf_2(o, p) { ___setPrototypeOf_2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ___setPrototypeOf_2(o, p); }
	
	var DropEvent =
	/*#__PURE__*/
	function (_BaseEvent) {
	  ___inherits_2(DropEvent, _BaseEvent);
	
	  /**
	   * Class of events fired on dropzones during drags with acceptable targets.
	   */
	  function DropEvent(dropState, dragEvent, type) {
	    var _this;
	
	    ___classCallCheck_2(this, DropEvent);
	
	    _this = ___possibleConstructorReturn_2(this, ___getPrototypeOf_2(DropEvent).call(this, dragEvent._interaction));
	    _this.propagationStopped = false;
	    _this.immediatePropagationStopped = false;
	
	    var _ref = type === 'dragleave' ? dropState.prev : dropState.cur,
	        element = _ref.element,
	        dropzone = _ref.dropzone;
	
	    _this.type = type;
	    _this.target = element;
	    _this.currentTarget = element;
	    _this.dropzone = dropzone;
	    _this.dragEvent = dragEvent;
	    _this.relatedTarget = dragEvent.target;
	    _this.draggable = dragEvent.interactable;
	    _this.timeStamp = dragEvent.timeStamp;
	    return _this;
	  }
	  /**
	   * If this is a `dropactivate` event, the dropzone element will be
	   * deactivated.
	   *
	   * If this is a `dragmove` or `dragenter`, a `dragleave` will be fired on the
	   * dropzone element and more.
	   */
	
	
	  ___createClass_2(DropEvent, [{
	    key: "reject",
	    value: function reject() {
	      var _this2 = this;
	
	      var dropState = this._interaction.dropState;
	
	      if (this.type !== 'dropactivate' && (!this.dropzone || dropState.cur.dropzone !== this.dropzone || dropState.cur.element !== this.target)) {
	        return;
	      }
	
	      dropState.prev.dropzone = this.dropzone;
	      dropState.prev.element = this.target;
	      dropState.rejected = true;
	      dropState.events.enter = null;
	      this.stopImmediatePropagation();
	
	      if (this.type === 'dropactivate') {
	        var activeDrops = dropState.activeDrops;
	        var index = __arr_2.findIndex(activeDrops, function (_ref2) {
	          var dropzone = _ref2.dropzone,
	              element = _ref2.element;
	          return dropzone === _this2.dropzone && element === _this2.target;
	        });
	        dropState.activeDrops = [].concat(___toConsumableArray_2(activeDrops.slice(0, index)), ___toConsumableArray_2(activeDrops.slice(index + 1)));
	        var deactivateEvent = new DropEvent(dropState, this.dragEvent, 'dropdeactivate');
	        deactivateEvent.dropzone = this.dropzone;
	        deactivateEvent.target = this.target;
	        this.dropzone.fire(deactivateEvent);
	      } else {
	        this.dropzone.fire(new DropEvent(dropState, this.dragEvent, 'dragleave'));
	      }
	    }
	  }, {
	    key: "preventDefault",
	    value: function preventDefault() {}
	  }, {
	    key: "stopPropagation",
	    value: function stopPropagation() {
	      this.propagationStopped = true;
	    }
	  }, {
	    key: "stopImmediatePropagation",
	    value: function stopImmediatePropagation() {
	      this.immediatePropagationStopped = this.propagationStopped = true;
	    }
	  }]);
	
	  return DropEvent;
	}(___BaseEvent2_2["default"]);
	
	var ___default_2 = DropEvent;
	_$DropEvent_2["default"] = ___default_2;
	
	var _$drop_3 = {};
	"use strict";
	
	Object.defineProperty(_$drop_3, "__esModule", {
	  value: true
	});
	_$drop_3["default"] = void 0;
	
	var __utils_3 = ___interopRequireWildcard_3(_$utils_56);
	
	var _drag = ___interopRequireDefault_3(_$drag_1);
	
	var _DropEvent = ___interopRequireDefault_3(_$DropEvent_2);
	
	function ___interopRequireDefault_3(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_3() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_3 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_3(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_3(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function __install_3(scope) {
	  var actions = scope.actions,
	      interact = scope.interact,
	      Interactable = scope.Interactable,
	      interactions = scope.interactions,
	      defaults = scope.defaults;
	  scope.usePlugin(_drag["default"]);
	  interactions.signals.on('before-action-start', function (_ref) {
	    var interaction = _ref.interaction;
	
	    if (interaction.prepared.name !== 'drag') {
	      return;
	    }
	
	    interaction.dropState = {
	      cur: {
	        dropzone: null,
	        element: null
	      },
	      prev: {
	        dropzone: null,
	        element: null
	      },
	      rejected: null,
	      events: null,
	      activeDrops: null
	    };
	  });
	  interactions.signals.on('after-action-start', function (_ref2) {
	    var interaction = _ref2.interaction,
	        event = _ref2.event,
	        dragEvent = _ref2.iEvent;
	
	    if (interaction.prepared.name !== 'drag') {
	      return;
	    }
	
	    var dropState = interaction.dropState; // reset active dropzones
	
	    dropState.activeDrops = null;
	    dropState.events = null;
	    dropState.activeDrops = getActiveDrops(scope, interaction.element);
	    dropState.events = getDropEvents(interaction, event, dragEvent);
	
	    if (dropState.events.activate) {
	      fireActivationEvents(dropState.activeDrops, dropState.events.activate);
	    }
	  }); // FIXME proper signal types
	
	  interactions.signals.on('action-move', function (arg) {
	    return onEventCreated(arg, scope);
	  });
	  interactions.signals.on('action-end', function (arg) {
	    return onEventCreated(arg, scope);
	  });
	  interactions.signals.on('after-action-move', function (_ref3) {
	    var interaction = _ref3.interaction;
	
	    if (interaction.prepared.name !== 'drag') {
	      return;
	    }
	
	    fireDropEvents(interaction, interaction.dropState.events);
	    interaction.dropState.events = {};
	  });
	  interactions.signals.on('after-action-end', function (_ref4) {
	    var interaction = _ref4.interaction;
	
	    if (interaction.prepared.name !== 'drag') {
	      return;
	    }
	
	    fireDropEvents(interaction, interaction.dropState.events);
	  });
	  interactions.signals.on('stop', function (_ref5) {
	    var interaction = _ref5.interaction;
	
	    if (interaction.prepared.name !== 'drag') {
	      return;
	    }
	
	    var dropState = interaction.dropState;
	
	    if (dropState) {
	      dropState.activeDrops = null;
	      dropState.events = null;
	      dropState.cur.dropzone = null;
	      dropState.cur.element = null;
	      dropState.prev.dropzone = null;
	      dropState.prev.element = null;
	      dropState.rejected = false;
	    }
	  });
	  /**
	   *
	   * ```js
	   * interact('.drop').dropzone({
	   *   accept: '.can-drop' || document.getElementById('single-drop'),
	   *   overlap: 'pointer' || 'center' || zeroToOne
	   * }
	   * ```
	   *
	   * Returns or sets whether draggables can be dropped onto this target to
	   * trigger drop events
	   *
	   * Dropzones can receive the following events:
	   *  - `dropactivate` and `dropdeactivate` when an acceptable drag starts and ends
	   *  - `dragenter` and `dragleave` when a draggable enters and leaves the dropzone
	   *  - `dragmove` when a draggable that has entered the dropzone is moved
	   *  - `drop` when a draggable is dropped into this dropzone
	   *
	   * Use the `accept` option to allow only elements that match the given CSS
	   * selector or element. The value can be:
	   *
	   *  - **an Element** - only that element can be dropped into this dropzone.
	   *  - **a string**, - the element being dragged must match it as a CSS selector.
	   *  - **`null`** - accept options is cleared - it accepts any element.
	   *
	   * Use the `overlap` option to set how drops are checked for. The allowed
	   * values are:
	   *
	   *   - `'pointer'`, the pointer must be over the dropzone (default)
	   *   - `'center'`, the draggable element's center must be over the dropzone
	   *   - a number from 0-1 which is the `(intersection area) / (draggable area)`.
	   *   e.g. `0.5` for drop to happen when half of the area of the draggable is
	   *   over the dropzone
	   *
	   * Use the `checker` option to specify a function to check if a dragged element
	   * is over this Interactable.
	   *
	   * @param {boolean | object | null} [options] The new options to be set.
	   * @return {boolean | Interactable} The current setting or this Interactable
	   */
	
	  Interactable.prototype.dropzone = function (options) {
	    return dropzoneMethod(this, options);
	  };
	  /**
	   * ```js
	   * interact(target)
	   * .dropChecker(function(dragEvent,         // related dragmove or dragend event
	   *                       event,             // TouchEvent/PointerEvent/MouseEvent
	   *                       dropped,           // bool result of the default checker
	   *                       dropzone,          // dropzone Interactable
	   *                       dropElement,       // dropzone elemnt
	   *                       draggable,         // draggable Interactable
	   *                       draggableElement) {// draggable element
	   *
	   *   return dropped && event.target.hasAttribute('allow-drop')
	   * }
	   * ```
	   */
	
	
	  Interactable.prototype.dropCheck = function (dragEvent, event, draggable, draggableElement, dropElement, rect) {
	    return dropCheckMethod(this, dragEvent, event, draggable, draggableElement, dropElement, rect);
	  };
	  /**
	   * Returns or sets whether the dimensions of dropzone elements are calculated
	   * on every dragmove or only on dragstart for the default dropChecker
	   *
	   * @param {boolean} [newValue] True to check on each move. False to check only
	   * before start
	   * @return {boolean | interact} The current setting or interact
	   */
	
	
	  interact.dynamicDrop = function (newValue) {
	    if (__utils_3.is.bool(newValue)) {
	      // if (dragging && scope.dynamicDrop !== newValue && !newValue) {
	      //  calcRects(dropzones)
	      // }
	      scope.dynamicDrop = newValue;
	      return interact;
	    }
	
	    return scope.dynamicDrop;
	  };
	
	  __utils_3.arr.merge(actions.eventTypes, ['dragenter', 'dragleave', 'dropactivate', 'dropdeactivate', 'dropmove', 'drop']);
	  actions.methodDict.drop = 'dropzone';
	  scope.dynamicDrop = false;
	  defaults.actions.drop = drop.defaults;
	}
	
	function collectDrops(_ref6, draggableElement) {
	  var interactables = _ref6.interactables;
	  var drops = []; // collect all dropzones and their elements which qualify for a drop
	
	  for (var _i = 0; _i < interactables.list.length; _i++) {
	    var _ref7;
	
	    _ref7 = interactables.list[_i];
	    var dropzone = _ref7;
	
	    if (!dropzone.options.drop.enabled) {
	      continue;
	    }
	
	    var accept = dropzone.options.drop.accept; // test the draggable draggableElement against the dropzone's accept setting
	
	    if (__utils_3.is.element(accept) && accept !== draggableElement || __utils_3.is.string(accept) && !__utils_3.dom.matchesSelector(draggableElement, accept) || __utils_3.is.func(accept) && !accept({
	      dropzone: dropzone,
	      draggableElement: draggableElement
	    })) {
	      continue;
	    } // query for new elements if necessary
	
	
	    var dropElements = __utils_3.is.string(dropzone.target) ? dropzone._context.querySelectorAll(dropzone.target) : __utils_3.is.array(dropzone.target) ? dropzone.target : [dropzone.target];
	
	    for (var _i2 = 0; _i2 < dropElements.length; _i2++) {
	      var _ref8;
	
	      _ref8 = dropElements[_i2];
	      var dropzoneElement = _ref8;
	
	      if (dropzoneElement !== draggableElement) {
	        drops.push({
	          dropzone: dropzone,
	          element: dropzoneElement
	        });
	      }
	    }
	  }
	
	  return drops;
	}
	
	function fireActivationEvents(activeDrops, event) {
	  // loop through all active dropzones and trigger event
	  for (var _i3 = 0; _i3 < activeDrops.length; _i3++) {
	    var _ref9;
	
	    _ref9 = activeDrops[_i3];
	    var _ref10 = _ref9,
	        dropzone = _ref10.dropzone,
	        element = _ref10.element;
	    event.dropzone = dropzone; // set current element as event target
	
	    event.target = element;
	    dropzone.fire(event);
	    event.propagationStopped = event.immediatePropagationStopped = false;
	  }
	} // return a new array of possible drops. getActiveDrops should always be
	// called when a drag has just started or a drag event happens while
	// dynamicDrop is true
	
	
	function getActiveDrops(scope, dragElement) {
	  // get dropzones and their elements that could receive the draggable
	  var activeDrops = collectDrops(scope, dragElement);
	
	  for (var _i4 = 0; _i4 < activeDrops.length; _i4++) {
	    var _ref11;
	
	    _ref11 = activeDrops[_i4];
	    var activeDrop = _ref11;
	    activeDrop.rect = activeDrop.dropzone.getRect(activeDrop.element);
	  }
	
	  return activeDrops;
	}
	
	function getDrop(_ref12, dragEvent, pointerEvent) {
	  var dropState = _ref12.dropState,
	      draggable = _ref12.interactable,
	      dragElement = _ref12.element;
	  var validDrops = []; // collect all dropzones and their elements which qualify for a drop
	
	  for (var _i5 = 0; _i5 < dropState.activeDrops.length; _i5++) {
	    var _ref13;
	
	    _ref13 = dropState.activeDrops[_i5];
	    var _ref14 = _ref13,
	        dropzone = _ref14.dropzone,
	        dropzoneElement = _ref14.element,
	        rect = _ref14.rect;
	    validDrops.push(dropzone.dropCheck(dragEvent, pointerEvent, draggable, dragElement, dropzoneElement, rect) ? dropzoneElement : null);
	  } // get the most appropriate dropzone based on DOM depth and order
	
	
	  var dropIndex = __utils_3.dom.indexOfDeepestElement(validDrops);
	  return dropState.activeDrops[dropIndex] || null;
	}
	
	function getDropEvents(interaction, _pointerEvent, dragEvent) {
	  var dropState = interaction.dropState;
	  var dropEvents = {
	    enter: null,
	    leave: null,
	    activate: null,
	    deactivate: null,
	    move: null,
	    drop: null
	  };
	
	  if (dragEvent.type === 'dragstart') {
	    dropEvents.activate = new _DropEvent["default"](dropState, dragEvent, 'dropactivate');
	    dropEvents.activate.target = null;
	    dropEvents.activate.dropzone = null;
	  }
	
	  if (dragEvent.type === 'dragend') {
	    dropEvents.deactivate = new _DropEvent["default"](dropState, dragEvent, 'dropdeactivate');
	    dropEvents.deactivate.target = null;
	    dropEvents.deactivate.dropzone = null;
	  }
	
	  if (dropState.rejected) {
	    return dropEvents;
	  }
	
	  if (dropState.cur.element !== dropState.prev.element) {
	    // if there was a previous dropzone, create a dragleave event
	    if (dropState.prev.dropzone) {
	      dropEvents.leave = new _DropEvent["default"](dropState, dragEvent, 'dragleave');
	      dragEvent.dragLeave = dropEvents.leave.target = dropState.prev.element;
	      dragEvent.prevDropzone = dropEvents.leave.dropzone = dropState.prev.dropzone;
	    } // if dropzone is not null, create a dragenter event
	
	
	    if (dropState.cur.dropzone) {
	      dropEvents.enter = new _DropEvent["default"](dropState, dragEvent, 'dragenter');
	      dragEvent.dragEnter = dropState.cur.element;
	      dragEvent.dropzone = dropState.cur.dropzone;
	    }
	  }
	
	  if (dragEvent.type === 'dragend' && dropState.cur.dropzone) {
	    dropEvents.drop = new _DropEvent["default"](dropState, dragEvent, 'drop');
	    dragEvent.dropzone = dropState.cur.dropzone;
	    dragEvent.relatedTarget = dropState.cur.element;
	  }
	
	  if (dragEvent.type === 'dragmove' && dropState.cur.dropzone) {
	    dropEvents.move = new _DropEvent["default"](dropState, dragEvent, 'dropmove');
	    dropEvents.move.dragmove = dragEvent;
	    dragEvent.dropzone = dropState.cur.dropzone;
	  }
	
	  return dropEvents;
	}
	
	function fireDropEvents(interaction, events) {
	  var dropState = interaction.dropState;
	  var activeDrops = dropState.activeDrops,
	      cur = dropState.cur,
	      prev = dropState.prev;
	
	  if (events.leave) {
	    prev.dropzone.fire(events.leave);
	  }
	
	  if (events.move) {
	    cur.dropzone.fire(events.move);
	  }
	
	  if (events.enter) {
	    cur.dropzone.fire(events.enter);
	  }
	
	  if (events.drop) {
	    cur.dropzone.fire(events.drop);
	  }
	
	  if (events.deactivate) {
	    fireActivationEvents(activeDrops, events.deactivate);
	  }
	
	  dropState.prev.dropzone = cur.dropzone;
	  dropState.prev.element = cur.element;
	}
	
	function onEventCreated(_ref15, scope) {
	  var interaction = _ref15.interaction,
	      iEvent = _ref15.iEvent,
	      event = _ref15.event;
	
	  if (iEvent.type !== 'dragmove' && iEvent.type !== 'dragend') {
	    return;
	  }
	
	  var dropState = interaction.dropState;
	
	  if (scope.dynamicDrop) {
	    dropState.activeDrops = getActiveDrops(scope, interaction.element);
	  }
	
	  var dragEvent = iEvent;
	  var dropResult = getDrop(interaction, dragEvent, event); // update rejected status
	
	  dropState.rejected = dropState.rejected && !!dropResult && dropResult.dropzone === dropState.cur.dropzone && dropResult.element === dropState.cur.element;
	  dropState.cur.dropzone = dropResult && dropResult.dropzone;
	  dropState.cur.element = dropResult && dropResult.element;
	  dropState.events = getDropEvents(interaction, event, dragEvent);
	}
	
	function dropzoneMethod(interactable, options) {
	  if (__utils_3.is.object(options)) {
	    interactable.options.drop.enabled = options.enabled !== false;
	
	    if (options.listeners) {
	      var normalized = __utils_3.normalizeListeners(options.listeners); // rename 'drop' to '' as it will be prefixed with 'drop'
	
	      var corrected = Object.keys(normalized).reduce(function (acc, type) {
	        var correctedType = /^(enter|leave)/.test(type) ? "drag".concat(type) : /^(activate|deactivate|move)/.test(type) ? "drop".concat(type) : type;
	        acc[correctedType] = normalized[type];
	        return acc;
	      }, {});
	      interactable.off(interactable.options.drop.listeners);
	      interactable.on(corrected);
	      interactable.options.drop.listeners = corrected;
	    }
	
	    if (__utils_3.is.func(options.ondrop)) {
	      interactable.on('drop', options.ondrop);
	    }
	
	    if (__utils_3.is.func(options.ondropactivate)) {
	      interactable.on('dropactivate', options.ondropactivate);
	    }
	
	    if (__utils_3.is.func(options.ondropdeactivate)) {
	      interactable.on('dropdeactivate', options.ondropdeactivate);
	    }
	
	    if (__utils_3.is.func(options.ondragenter)) {
	      interactable.on('dragenter', options.ondragenter);
	    }
	
	    if (__utils_3.is.func(options.ondragleave)) {
	      interactable.on('dragleave', options.ondragleave);
	    }
	
	    if (__utils_3.is.func(options.ondropmove)) {
	      interactable.on('dropmove', options.ondropmove);
	    }
	
	    if (/^(pointer|center)$/.test(options.overlap)) {
	      interactable.options.drop.overlap = options.overlap;
	    } else if (__utils_3.is.number(options.overlap)) {
	      interactable.options.drop.overlap = Math.max(Math.min(1, options.overlap), 0);
	    }
	
	    if ('accept' in options) {
	      interactable.options.drop.accept = options.accept;
	    }
	
	    if ('checker' in options) {
	      interactable.options.drop.checker = options.checker;
	    }
	
	    return interactable;
	  }
	
	  if (__utils_3.is.bool(options)) {
	    interactable.options.drop.enabled = options;
	    return interactable;
	  }
	
	  return interactable.options.drop;
	}
	
	function dropCheckMethod(interactable, dragEvent, event, draggable, draggableElement, dropElement, rect) {
	  var dropped = false; // if the dropzone has no rect (eg. display: none)
	  // call the custom dropChecker or just return false
	
	  if (!(rect = rect || interactable.getRect(dropElement))) {
	    return interactable.options.drop.checker ? interactable.options.drop.checker(dragEvent, event, dropped, interactable, dropElement, draggable, draggableElement) : false;
	  }
	
	  var dropOverlap = interactable.options.drop.overlap;
	
	  if (dropOverlap === 'pointer') {
	    var origin = __utils_3.getOriginXY(draggable, draggableElement, 'drag');
	    var page = __utils_3.pointer.getPageXY(dragEvent);
	    page.x += origin.x;
	    page.y += origin.y;
	    var horizontal = page.x > rect.left && page.x < rect.right;
	    var vertical = page.y > rect.top && page.y < rect.bottom;
	    dropped = horizontal && vertical;
	  }
	
	  var dragRect = draggable.getRect(draggableElement);
	
	  if (dragRect && dropOverlap === 'center') {
	    var cx = dragRect.left + dragRect.width / 2;
	    var cy = dragRect.top + dragRect.height / 2;
	    dropped = cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom;
	  }
	
	  if (dragRect && __utils_3.is.number(dropOverlap)) {
	    var overlapArea = Math.max(0, Math.min(rect.right, dragRect.right) - Math.max(rect.left, dragRect.left)) * Math.max(0, Math.min(rect.bottom, dragRect.bottom) - Math.max(rect.top, dragRect.top));
	    var overlapRatio = overlapArea / (dragRect.width * dragRect.height);
	    dropped = overlapRatio >= dropOverlap;
	  }
	
	  if (interactable.options.drop.checker) {
	    dropped = interactable.options.drop.checker(dragEvent, event, dropped, interactable, dropElement, draggable, draggableElement);
	  }
	
	  return dropped;
	}
	
	var drop = {
	  id: 'actions/drop',
	  install: __install_3,
	  getActiveDrops: getActiveDrops,
	  getDrop: getDrop,
	  getDropEvents: getDropEvents,
	  fireDropEvents: fireDropEvents,
	  defaults: {
	    enabled: false,
	    accept: null,
	    overlap: 'pointer'
	  }
	};
	var ___default_3 = drop;
	_$drop_3["default"] = ___default_3;
	
	var _$gesture_4 = {};
	"use strict";
	
	Object.defineProperty(_$gesture_4, "__esModule", {
	  value: true
	});
	_$gesture_4["default"] = void 0;
	
	var ___InteractEvent_4 = ___interopRequireDefault_4(_$InteractEvent_15);
	
	var ___scope_4 = _$scope_24({});
	
	var __utils_4 = ___interopRequireWildcard_4(_$utils_56);
	
	function ___getRequireWildcardCache_4() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_4 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_4(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_4(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___interopRequireDefault_4(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	___scope_4.ActionName.Gesture = 'gesture';
	
	function __install_4(scope) {
	  var actions = scope.actions,
	      Interactable = scope.Interactable,
	      interactions = scope.interactions,
	      defaults = scope.defaults;
	  /**
	   * ```js
	   * interact(element).gesturable({
	   *     onstart: function (event) {},
	   *     onmove : function (event) {},
	   *     onend  : function (event) {},
	   *
	   *     // limit multiple gestures.
	   *     // See the explanation in {@link Interactable.draggable} example
	   *     max: Infinity,
	   *     maxPerElement: 1,
	   * })
	   *
	   * var isGestureable = interact(element).gesturable()
	   * ```
	   *
	   * Gets or sets whether multitouch gestures can be performed on the target
	   *
	   * @param {boolean | object} [options] true/false or An object with event
	   * listeners to be fired on gesture events (makes the Interactable gesturable)
	   * @return {boolean | Interactable} A boolean indicating if this can be the
	   * target of gesture events, or this Interactable
	   */
	
	  Interactable.prototype.gesturable = function (options) {
	    if (__utils_4.is.object(options)) {
	      this.options.gesture.enabled = options.enabled !== false;
	      this.setPerAction('gesture', options);
	      this.setOnEvents('gesture', options);
	      return this;
	    }
	
	    if (__utils_4.is.bool(options)) {
	      this.options.gesture.enabled = options;
	      return this;
	    }
	
	    return this.options.gesture;
	  };
	
	  interactions.signals.on('action-start', updateGestureProps);
	  interactions.signals.on('action-move', updateGestureProps);
	  interactions.signals.on('action-end', updateGestureProps);
	  interactions.signals.on('new', function (_ref) {
	    var interaction = _ref.interaction;
	    interaction.gesture = {
	      angle: 0,
	      distance: 0,
	      scale: 1,
	      startAngle: 0,
	      startDistance: 0
	    };
	  });
	  actions[___scope_4.ActionName.Gesture] = gesture;
	  actions.names.push(___scope_4.ActionName.Gesture);
	  __utils_4.arr.merge(actions.eventTypes, ['gesturestart', 'gesturemove', 'gestureend']);
	  actions.methodDict.gesture = 'gesturable';
	  defaults.actions.gesture = gesture.defaults;
	}
	
	var gesture = {
	  id: 'actions/gesture',
	  install: __install_4,
	  defaults: {},
	  checker: function checker(_pointer, _event, _interactable, _element, interaction) {
	    if (interaction.pointers.length >= 2) {
	      return {
	        name: 'gesture'
	      };
	    }
	
	    return null;
	  },
	  getCursor: function getCursor() {
	    return '';
	  }
	};
	
	function updateGestureProps(_ref2) {
	  var interaction = _ref2.interaction,
	      iEvent = _ref2.iEvent,
	      event = _ref2.event,
	      phase = _ref2.phase;
	
	  if (interaction.prepared.name !== 'gesture') {
	    return;
	  }
	
	  var pointers = interaction.pointers.map(function (p) {
	    return p.pointer;
	  });
	  var starting = phase === 'start';
	  var ending = phase === 'end';
	  var deltaSource = interaction.interactable.options.deltaSource;
	  iEvent.touches = [pointers[0], pointers[1]];
	
	  if (starting) {
	    iEvent.distance = __utils_4.pointer.touchDistance(pointers, deltaSource);
	    iEvent.box = __utils_4.pointer.touchBBox(pointers);
	    iEvent.scale = 1;
	    iEvent.ds = 0;
	    iEvent.angle = __utils_4.pointer.touchAngle(pointers, deltaSource);
	    iEvent.da = 0;
	    interaction.gesture.startDistance = iEvent.distance;
	    interaction.gesture.startAngle = iEvent.angle;
	  } else if (ending || event instanceof ___InteractEvent_4["default"]) {
	    var prevEvent = interaction.prevEvent;
	    iEvent.distance = prevEvent.distance;
	    iEvent.box = prevEvent.box;
	    iEvent.scale = prevEvent.scale;
	    iEvent.ds = 0;
	    iEvent.angle = prevEvent.angle;
	    iEvent.da = 0;
	  } else {
	    iEvent.distance = __utils_4.pointer.touchDistance(pointers, deltaSource);
	    iEvent.box = __utils_4.pointer.touchBBox(pointers);
	    iEvent.scale = iEvent.distance / interaction.gesture.startDistance;
	    iEvent.angle = __utils_4.pointer.touchAngle(pointers, deltaSource);
	    iEvent.ds = iEvent.scale - interaction.gesture.scale;
	    iEvent.da = iEvent.angle - interaction.gesture.angle;
	  }
	
	  interaction.gesture.distance = iEvent.distance;
	  interaction.gesture.angle = iEvent.angle;
	
	  if (__utils_4.is.number(iEvent.scale) && iEvent.scale !== Infinity && !isNaN(iEvent.scale)) {
	    interaction.gesture.scale = iEvent.scale;
	  }
	}
	
	var ___default_4 = gesture;
	_$gesture_4["default"] = ___default_4;
	
	var _$resize_6 = {};
	"use strict";
	
	Object.defineProperty(_$resize_6, "__esModule", {
	  value: true
	});
	_$resize_6["default"] = void 0;
	
	var ___scope_6 = _$scope_24({});
	
	var __arr_6 = ___interopRequireWildcard_6(_$arr_47);
	
	var __dom_6 = ___interopRequireWildcard_6(_$domUtils_51);
	
	var ___extend_6 = ___interopRequireDefault_6(_$extend_53);
	
	var __is_6 = ___interopRequireWildcard_6(_$is_57);
	
	function ___interopRequireDefault_6(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_6() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_6 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_6(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_6(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	___scope_6.ActionName.Resize = 'resize';
	
	function __install_6(scope) {
	  var actions = scope.actions,
	      browser = scope.browser,
	      Interactable = scope.Interactable,
	      interactions = scope.interactions,
	      defaults = scope.defaults; // Less Precision with touch input
	
	  interactions.signals.on('new', function (interaction) {
	    interaction.resizeAxes = 'xy';
	  });
	  interactions.signals.on('action-start', start);
	  interactions.signals.on('action-move', __move_6);
	  interactions.signals.on('action-end', end);
	  interactions.signals.on('action-start', updateEventAxes);
	  interactions.signals.on('action-move', updateEventAxes);
	  resize.cursors = initCursors(browser);
	  resize.defaultMargin = browser.supportsTouch || browser.supportsPointerEvent ? 20 : 10;
	  /**
	   * ```js
	   * interact(element).resizable({
	   *   onstart: function (event) {},
	   *   onmove : function (event) {},
	   *   onend  : function (event) {},
	   *
	   *   edges: {
	   *     top   : true,       // Use pointer coords to check for resize.
	   *     left  : false,      // Disable resizing from left edge.
	   *     bottom: '.resize-s',// Resize if pointer target matches selector
	   *     right : handleEl    // Resize if pointer target is the given Element
	   *   },
	   *
	   *     // Width and height can be adjusted independently. When `true`, width and
	   *     // height are adjusted at a 1:1 ratio.
	   *     square: false,
	   *
	   *     // Width and height can be adjusted independently. When `true`, width and
	   *     // height maintain the aspect ratio they had when resizing started.
	   *     preserveAspectRatio: false,
	   *
	   *   // a value of 'none' will limit the resize rect to a minimum of 0x0
	   *   // 'negate' will allow the rect to have negative width/height
	   *   // 'reposition' will keep the width/height positive by swapping
	   *   // the top and bottom edges and/or swapping the left and right edges
	   *   invert: 'none' || 'negate' || 'reposition'
	   *
	   *   // limit multiple resizes.
	   *   // See the explanation in the {@link Interactable.draggable} example
	   *   max: Infinity,
	   *   maxPerElement: 1,
	   * })
	   *
	   * var isResizeable = interact(element).resizable()
	   * ```
	   *
	   * Gets or sets whether resize actions can be performed on the target
	   *
	   * @param {boolean | object} [options] true/false or An object with event
	   * listeners to be fired on resize events (object makes the Interactable
	   * resizable)
	   * @return {boolean | Interactable} A boolean indicating if this can be the
	   * target of resize elements, or this Interactable
	   */
	
	  Interactable.prototype.resizable = function (options) {
	    return resizable(this, options, scope);
	  };
	
	  actions[___scope_6.ActionName.Resize] = resize;
	  actions.names.push(___scope_6.ActionName.Resize);
	  __arr_6.merge(actions.eventTypes, ['resizestart', 'resizemove', 'resizeinertiastart', 'resizeresume', 'resizeend']);
	  actions.methodDict.resize = 'resizable';
	  defaults.actions.resize = resize.defaults;
	}
	
	var resize = {
	  id: 'actions/resize',
	  install: __install_6,
	  defaults: {
	    square: false,
	    preserveAspectRatio: false,
	    axis: 'xy',
	    // use default margin
	    margin: NaN,
	    // object with props left, right, top, bottom which are
	    // true/false values to resize when the pointer is over that edge,
	    // CSS selectors to match the handles for each direction
	    // or the Elements for each handle
	    edges: null,
	    // a value of 'none' will limit the resize rect to a minimum of 0x0
	    // 'negate' will alow the rect to have negative width/height
	    // 'reposition' will keep the width/height positive by swapping
	    // the top and bottom edges and/or swapping the left and right edges
	    invert: 'none'
	  },
	  checker: function checker(_pointer, _event, interactable, element, interaction, rect) {
	    if (!rect) {
	      return null;
	    }
	
	    var page = (0, ___extend_6["default"])({}, interaction.coords.cur.page);
	    var options = interactable.options;
	
	    if (options.resize.enabled) {
	      var resizeOptions = options.resize;
	      var resizeEdges = {
	        left: false,
	        right: false,
	        top: false,
	        bottom: false
	      }; // if using resize.edges
	
	      if (__is_6.object(resizeOptions.edges)) {
	        for (var edge in resizeEdges) {
	          resizeEdges[edge] = checkResizeEdge(edge, resizeOptions.edges[edge], page, interaction._latestPointer.eventTarget, element, rect, resizeOptions.margin || this.defaultMargin);
	        }
	
	        resizeEdges.left = resizeEdges.left && !resizeEdges.right;
	        resizeEdges.top = resizeEdges.top && !resizeEdges.bottom;
	
	        if (resizeEdges.left || resizeEdges.right || resizeEdges.top || resizeEdges.bottom) {
	          return {
	            name: 'resize',
	            edges: resizeEdges
	          };
	        }
	      } else {
	        var right = options.resize.axis !== 'y' && page.x > rect.right - this.defaultMargin;
	        var bottom = options.resize.axis !== 'x' && page.y > rect.bottom - this.defaultMargin;
	
	        if (right || bottom) {
	          return {
	            name: 'resize',
	            axes: (right ? 'x' : '') + (bottom ? 'y' : '')
	          };
	        }
	      }
	    }
	
	    return null;
	  },
	  cursors: null,
	  getCursor: function getCursor(_ref) {
	    var edges = _ref.edges,
	        axis = _ref.axis,
	        name = _ref.name;
	    var cursors = resize.cursors;
	    var result = null;
	
	    if (axis) {
	      result = cursors[name + axis];
	    } else if (edges) {
	      var cursorKey = '';
	      var _arr = ['top', 'bottom', 'left', 'right'];
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var edge = _arr[_i];
	
	        if (edges[edge]) {
	          cursorKey += edge;
	        }
	      }
	
	      result = cursors[cursorKey];
	    }
	
	    return result;
	  },
	  defaultMargin: null
	};
	
	function resizable(interactable, options, scope) {
	  if (__is_6.object(options)) {
	    interactable.options.resize.enabled = options.enabled !== false;
	    interactable.setPerAction('resize', options);
	    interactable.setOnEvents('resize', options);
	
	    if (__is_6.string(options.axis) && /^x$|^y$|^xy$/.test(options.axis)) {
	      interactable.options.resize.axis = options.axis;
	    } else if (options.axis === null) {
	      interactable.options.resize.axis = scope.defaults.actions.resize.axis;
	    }
	
	    if (__is_6.bool(options.preserveAspectRatio)) {
	      interactable.options.resize.preserveAspectRatio = options.preserveAspectRatio;
	    } else if (__is_6.bool(options.square)) {
	      interactable.options.resize.square = options.square;
	    }
	
	    return interactable;
	  }
	
	  if (__is_6.bool(options)) {
	    interactable.options.resize.enabled = options;
	    return interactable;
	  }
	
	  return interactable.options.resize;
	}
	
	function checkResizeEdge(name, value, page, element, interactableElement, rect, margin) {
	  // false, '', undefined, null
	  if (!value) {
	    return false;
	  } // true value, use pointer coords and element rect
	
	
	  if (value === true) {
	    // if dimensions are negative, "switch" edges
	    var width = __is_6.number(rect.width) ? rect.width : rect.right - rect.left;
	    var height = __is_6.number(rect.height) ? rect.height : rect.bottom - rect.top; // don't use margin greater than half the relevent dimension
	
	    margin = Math.min(margin, (name === 'left' || name === 'right' ? width : height) / 2);
	
	    if (width < 0) {
	      if (name === 'left') {
	        name = 'right';
	      } else if (name === 'right') {
	        name = 'left';
	      }
	    }
	
	    if (height < 0) {
	      if (name === 'top') {
	        name = 'bottom';
	      } else if (name === 'bottom') {
	        name = 'top';
	      }
	    }
	
	    if (name === 'left') {
	      return page.x < (width >= 0 ? rect.left : rect.right) + margin;
	    }
	
	    if (name === 'top') {
	      return page.y < (height >= 0 ? rect.top : rect.bottom) + margin;
	    }
	
	    if (name === 'right') {
	      return page.x > (width >= 0 ? rect.right : rect.left) - margin;
	    }
	
	    if (name === 'bottom') {
	      return page.y > (height >= 0 ? rect.bottom : rect.top) - margin;
	    }
	  } // the remaining checks require an element
	
	
	  if (!__is_6.element(element)) {
	    return false;
	  }
	
	  return __is_6.element(value) // the value is an element to use as a resize handle
	  ? value === element // otherwise check if element matches value as selector
	  : __dom_6.matchesUpTo(element, value, interactableElement);
	}
	
	function initCursors(browser) {
	  return browser.isIe9 ? {
	    x: 'e-resize',
	    y: 's-resize',
	    xy: 'se-resize',
	    top: 'n-resize',
	    left: 'w-resize',
	    bottom: 's-resize',
	    right: 'e-resize',
	    topleft: 'se-resize',
	    bottomright: 'se-resize',
	    topright: 'ne-resize',
	    bottomleft: 'ne-resize'
	  } : {
	    x: 'ew-resize',
	    y: 'ns-resize',
	    xy: 'nwse-resize',
	    top: 'ns-resize',
	    left: 'ew-resize',
	    bottom: 'ns-resize',
	    right: 'ew-resize',
	    topleft: 'nwse-resize',
	    bottomright: 'nwse-resize',
	    topright: 'nesw-resize',
	    bottomleft: 'nesw-resize'
	  };
	}
	
	function start(_ref2) {
	  var iEvent = _ref2.iEvent,
	      interaction = _ref2.interaction;
	
	  if (interaction.prepared.name !== 'resize' || !interaction.prepared.edges) {
	    return;
	  }
	
	  var startRect = (0, ___extend_6["default"])({}, interaction.rect);
	  var resizeOptions = interaction.interactable.options.resize;
	  /*
	   * When using the `resizable.square` or `resizable.preserveAspectRatio` options, resizing from one edge
	   * will affect another. E.g. with `resizable.square`, resizing to make the right edge larger will make
	   * the bottom edge larger by the same amount. We call these 'linked' edges. Any linked edges will depend
	   * on the active edges and the edge being interacted with.
	   */
	
	  if (resizeOptions.square || resizeOptions.preserveAspectRatio) {
	    var linkedEdges = (0, ___extend_6["default"])({}, interaction.prepared.edges);
	    linkedEdges.top = linkedEdges.top || linkedEdges.left && !linkedEdges.bottom;
	    linkedEdges.left = linkedEdges.left || linkedEdges.top && !linkedEdges.right;
	    linkedEdges.bottom = linkedEdges.bottom || linkedEdges.right && !linkedEdges.top;
	    linkedEdges.right = linkedEdges.right || linkedEdges.bottom && !linkedEdges.left;
	    interaction.prepared._linkedEdges = linkedEdges;
	  } else {
	    interaction.prepared._linkedEdges = null;
	  } // if using `resizable.preserveAspectRatio` option, record aspect ratio at the start of the resize
	
	
	  if (resizeOptions.preserveAspectRatio) {
	    interaction.resizeStartAspectRatio = startRect.width / startRect.height;
	  }
	
	  interaction.resizeRects = {
	    start: startRect,
	    current: {
	      left: startRect.left,
	      right: startRect.right,
	      top: startRect.top,
	      bottom: startRect.bottom
	    },
	    inverted: (0, ___extend_6["default"])({}, startRect),
	    previous: (0, ___extend_6["default"])({}, startRect),
	    delta: {
	      left: 0,
	      right: 0,
	      width: 0,
	      top: 0,
	      bottom: 0,
	      height: 0
	    }
	  };
	  iEvent.edges = interaction.prepared.edges;
	  iEvent.rect = interaction.resizeRects.inverted;
	  iEvent.deltaRect = interaction.resizeRects.delta;
	}
	
	function __move_6(_ref3) {
	  var iEvent = _ref3.iEvent,
	      interaction = _ref3.interaction;
	
	  if (interaction.prepared.name !== 'resize' || !interaction.prepared.edges) {
	    return;
	  }
	
	  var resizeOptions = interaction.interactable.options.resize;
	  var invert = resizeOptions.invert;
	  var invertible = invert === 'reposition' || invert === 'negate';
	  var edges = interaction.prepared.edges; // eslint-disable-next-line no-shadow
	
	  var start = interaction.resizeRects.start;
	  var current = interaction.resizeRects.current;
	  var inverted = interaction.resizeRects.inverted;
	  var deltaRect = interaction.resizeRects.delta;
	  var previous = (0, ___extend_6["default"])(interaction.resizeRects.previous, inverted);
	  var originalEdges = edges;
	  var eventDelta = (0, ___extend_6["default"])({}, iEvent.delta);
	
	  if (resizeOptions.preserveAspectRatio || resizeOptions.square) {
	    // `resize.preserveAspectRatio` takes precedence over `resize.square`
	    var startAspectRatio = resizeOptions.preserveAspectRatio ? interaction.resizeStartAspectRatio : 1;
	    edges = interaction.prepared._linkedEdges;
	
	    if (originalEdges.left && originalEdges.bottom || originalEdges.right && originalEdges.top) {
	      eventDelta.y = -eventDelta.x / startAspectRatio;
	    } else if (originalEdges.left || originalEdges.right) {
	      eventDelta.y = eventDelta.x / startAspectRatio;
	    } else if (originalEdges.top || originalEdges.bottom) {
	      eventDelta.x = eventDelta.y * startAspectRatio;
	    }
	  } // update the 'current' rect without modifications
	
	
	  if (edges.top) {
	    current.top += eventDelta.y;
	  }
	
	  if (edges.bottom) {
	    current.bottom += eventDelta.y;
	  }
	
	  if (edges.left) {
	    current.left += eventDelta.x;
	  }
	
	  if (edges.right) {
	    current.right += eventDelta.x;
	  }
	
	  if (invertible) {
	    // if invertible, copy the current rect
	    (0, ___extend_6["default"])(inverted, current);
	
	    if (invert === 'reposition') {
	      // swap edge values if necessary to keep width/height positive
	      var swap;
	
	      if (inverted.top > inverted.bottom) {
	        swap = inverted.top;
	        inverted.top = inverted.bottom;
	        inverted.bottom = swap;
	      }
	
	      if (inverted.left > inverted.right) {
	        swap = inverted.left;
	        inverted.left = inverted.right;
	        inverted.right = swap;
	      }
	    }
	  } else {
	    // if not invertible, restrict to minimum of 0x0 rect
	    inverted.top = Math.min(current.top, start.bottom);
	    inverted.bottom = Math.max(current.bottom, start.top);
	    inverted.left = Math.min(current.left, start.right);
	    inverted.right = Math.max(current.right, start.left);
	  }
	
	  inverted.width = inverted.right - inverted.left;
	  inverted.height = inverted.bottom - inverted.top;
	
	  for (var edge in inverted) {
	    deltaRect[edge] = inverted[edge] - previous[edge];
	  }
	
	  iEvent.edges = interaction.prepared.edges;
	  iEvent.rect = inverted;
	  iEvent.deltaRect = deltaRect;
	}
	
	function end(_ref4) {
	  var iEvent = _ref4.iEvent,
	      interaction = _ref4.interaction;
	
	  if (interaction.prepared.name !== 'resize' || !interaction.prepared.edges) {
	    return;
	  }
	
	  iEvent.edges = interaction.prepared.edges;
	  iEvent.rect = interaction.resizeRects.inverted;
	  iEvent.deltaRect = interaction.resizeRects.delta;
	}
	
	function updateEventAxes(_ref5) {
	  var iEvent = _ref5.iEvent,
	      interaction = _ref5.interaction,
	      action = _ref5.action;
	
	  if (action !== ___scope_6.ActionName.Resize || !interaction.resizeAxes) {
	    return;
	  }
	
	  var options = interaction.interactable.options;
	
	  if (options.resize.square) {
	    if (interaction.resizeAxes === 'y') {
	      iEvent.delta.x = iEvent.delta.y;
	    } else {
	      iEvent.delta.y = iEvent.delta.x;
	    }
	
	    iEvent.axes = 'xy';
	  } else {
	    iEvent.axes = interaction.resizeAxes;
	
	    if (interaction.resizeAxes === 'x') {
	      iEvent.delta.y = 0;
	    } else if (interaction.resizeAxes === 'y') {
	      iEvent.delta.x = 0;
	    }
	  }
	}
	
	var ___default_6 = resize;
	_$resize_6["default"] = ___default_6;
	
	var _$actions_5 = {};
	"use strict";
	
	Object.defineProperty(_$actions_5, "__esModule", {
	  value: true
	});
	_$actions_5.install = __install_5;
	Object.defineProperty(_$actions_5, "drag", {
	  enumerable: true,
	  get: function get() {
	    return ___drag_5["default"];
	  }
	});
	Object.defineProperty(_$actions_5, "drop", {
	  enumerable: true,
	  get: function get() {
	    return _drop["default"];
	  }
	});
	Object.defineProperty(_$actions_5, "gesture", {
	  enumerable: true,
	  get: function get() {
	    return _gesture["default"];
	  }
	});
	Object.defineProperty(_$actions_5, "resize", {
	  enumerable: true,
	  get: function get() {
	    return _resize["default"];
	  }
	});
	_$actions_5.id = void 0;
	
	var ___drag_5 = ___interopRequireDefault_5(_$drag_1);
	
	var _drop = ___interopRequireDefault_5(_$drop_3);
	
	var _gesture = ___interopRequireDefault_5(_$gesture_4);
	
	var _resize = ___interopRequireDefault_5(_$resize_6);
	
	function ___interopRequireDefault_5(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function __install_5(scope) {
	  scope.usePlugin(_gesture["default"]);
	  scope.usePlugin(_resize["default"]);
	  scope.usePlugin(___drag_5["default"]);
	  scope.usePlugin(_drop["default"]);
	}
	
	var id = 'actions';
	_$actions_5.id = id;
	
	var _$autoScroll_7 = {};
	"use strict";
	
	Object.defineProperty(_$autoScroll_7, "__esModule", {
	  value: true
	});
	_$autoScroll_7.getContainer = getContainer;
	_$autoScroll_7.getScroll = getScroll;
	_$autoScroll_7.getScrollSize = getScrollSize;
	_$autoScroll_7.getScrollSizeDelta = getScrollSizeDelta;
	_$autoScroll_7["default"] = void 0;
	
	var __domUtils_7 = ___interopRequireWildcard_7(_$domUtils_51);
	
	var __is_7 = ___interopRequireWildcard_7(_$is_57);
	
	var ___raf_7 = ___interopRequireDefault_7(_$raf_62);
	
	/* removed: var _$rect_63 = require("@interactjs/utils/rect"); */;
	
	/* removed: var _$window_66 = require("@interactjs/utils/window"); */;
	
	function ___interopRequireDefault_7(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_7() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_7 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_7(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_7(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function __install_7(scope) {
	  var interactions = scope.interactions,
	      defaults = scope.defaults,
	      actions = scope.actions;
	  scope.autoScroll = autoScroll;
	
	  autoScroll.now = function () {
	    return scope.now();
	  };
	
	  interactions.signals.on('new', function (_ref) {
	    var interaction = _ref.interaction;
	    interaction.autoScroll = null;
	  });
	  interactions.signals.on('destroy', function (_ref2) {
	    var interaction = _ref2.interaction;
	    interaction.autoScroll = null;
	    autoScroll.stop();
	
	    if (autoScroll.interaction) {
	      autoScroll.interaction = null;
	    }
	  });
	  interactions.signals.on('stop', autoScroll.stop);
	  interactions.signals.on('action-move', function (arg) {
	    return autoScroll.onInteractionMove(arg);
	  });
	  actions.eventTypes.push('autoscroll');
	  defaults.perAction.autoScroll = autoScroll.defaults;
	}
	
	var autoScroll = {
	  defaults: {
	    enabled: false,
	    margin: 60,
	    // the item that is scrolled (Window or HTMLElement)
	    container: null,
	    // the scroll speed in pixels per second
	    speed: 300
	  },
	  now: Date.now,
	  interaction: null,
	  i: null,
	  x: 0,
	  y: 0,
	  isScrolling: false,
	  prevTime: 0,
	  margin: 0,
	  speed: 0,
	  start: function start(interaction) {
	    autoScroll.isScrolling = true;
	
	    ___raf_7["default"].cancel(autoScroll.i);
	
	    interaction.autoScroll = autoScroll;
	    autoScroll.interaction = interaction;
	    autoScroll.prevTime = autoScroll.now();
	    autoScroll.i = ___raf_7["default"].request(autoScroll.scroll);
	  },
	  stop: function stop() {
	    autoScroll.isScrolling = false;
	
	    if (autoScroll.interaction) {
	      autoScroll.interaction.autoScroll = null;
	    }
	
	    ___raf_7["default"].cancel(autoScroll.i);
	  },
	  // scroll the window by the values in scroll.x/y
	  scroll: function scroll() {
	    var interaction = autoScroll.interaction;
	    var interactable = interaction.interactable,
	        element = interaction.element;
	    var options = interactable.options[autoScroll.interaction.prepared.name].autoScroll;
	    var container = getContainer(options.container, interactable, element);
	    var now = autoScroll.now(); // change in time in seconds
	
	    var dt = (now - autoScroll.prevTime) / 1000; // displacement
	
	    var s = options.speed * dt;
	
	    if (s >= 1) {
	      var scrollBy = {
	        x: autoScroll.x * s,
	        y: autoScroll.y * s
	      };
	
	      if (scrollBy.x || scrollBy.y) {
	        var prevScroll = getScroll(container);
	
	        if (__is_7.window(container)) {
	          container.scrollBy(scrollBy.x, scrollBy.y);
	        } else if (container) {
	          container.scrollLeft += scrollBy.x;
	          container.scrollTop += scrollBy.y;
	        }
	
	        var curScroll = getScroll(container);
	        var delta = {
	          x: curScroll.x - prevScroll.x,
	          y: curScroll.y - prevScroll.y
	        };
	
	        if (delta.x || delta.y) {
	          interactable.fire({
	            type: 'autoscroll',
	            target: element,
	            interactable: interactable,
	            delta: delta,
	            interaction: interaction,
	            container: container
	          });
	        }
	      }
	
	      autoScroll.prevTime = now;
	    }
	
	    if (autoScroll.isScrolling) {
	      ___raf_7["default"].cancel(autoScroll.i);
	
	      autoScroll.i = ___raf_7["default"].request(autoScroll.scroll);
	    }
	  },
	  check: function check(interactable, actionName) {
	    var options = interactable.options;
	    return options[actionName].autoScroll && options[actionName].autoScroll.enabled;
	  },
	  onInteractionMove: function onInteractionMove(_ref3) {
	    var interaction = _ref3.interaction,
	        pointer = _ref3.pointer;
	
	    if (!(interaction.interacting() && autoScroll.check(interaction.interactable, interaction.prepared.name))) {
	      return;
	    }
	
	    if (interaction.simulation) {
	      autoScroll.x = autoScroll.y = 0;
	      return;
	    }
	
	    var top;
	    var right;
	    var bottom;
	    var left;
	    var interactable = interaction.interactable,
	        element = interaction.element;
	    var options = interactable.options[interaction.prepared.name].autoScroll;
	    var container = getContainer(options.container, interactable, element);
	
	    if (__is_7.window(container)) {
	      left = pointer.clientX < autoScroll.margin;
	      top = pointer.clientY < autoScroll.margin;
	      right = pointer.clientX > container.innerWidth - autoScroll.margin;
	      bottom = pointer.clientY > container.innerHeight - autoScroll.margin;
	    } else {
	      var rect = __domUtils_7.getElementClientRect(container);
	      left = pointer.clientX < rect.left + autoScroll.margin;
	      top = pointer.clientY < rect.top + autoScroll.margin;
	      right = pointer.clientX > rect.right - autoScroll.margin;
	      bottom = pointer.clientY > rect.bottom - autoScroll.margin;
	    }
	
	    autoScroll.x = right ? 1 : left ? -1 : 0;
	    autoScroll.y = bottom ? 1 : top ? -1 : 0;
	
	    if (!autoScroll.isScrolling) {
	      // set the autoScroll properties to those of the target
	      autoScroll.margin = options.margin;
	      autoScroll.speed = options.speed;
	      autoScroll.start(interaction);
	    }
	  }
	};
	
	function getContainer(value, interactable, element) {
	  return (__is_7.string(value) ? (0, _$rect_63.getStringOptionResult)(value, interactable, element) : value) || (0, _$window_66.getWindow)(element);
	}
	
	function getScroll(container) {
	  if (__is_7.window(container)) {
	    container = window.document.body;
	  }
	
	  return {
	    x: container.scrollLeft,
	    y: container.scrollTop
	  };
	}
	
	function getScrollSize(container) {
	  if (__is_7.window(container)) {
	    container = window.document.body;
	  }
	
	  return {
	    x: container.scrollWidth,
	    y: container.scrollHeight
	  };
	}
	
	function getScrollSizeDelta(_ref4, func) {
	  var interaction = _ref4.interaction,
	      element = _ref4.element;
	  var scrollOptions = interaction && interaction.interactable.options[interaction.prepared.name].autoScroll;
	
	  if (!scrollOptions || !scrollOptions.enabled) {
	    func();
	    return {
	      x: 0,
	      y: 0
	    };
	  }
	
	  var scrollContainer = getContainer(scrollOptions.container, interaction.interactable, element);
	  var prevSize = getScroll(scrollContainer);
	  func();
	  var curSize = getScroll(scrollContainer);
	  return {
	    x: curSize.x - prevSize.x,
	    y: curSize.y - prevSize.y
	  };
	}
	
	var ___default_7 = {
	  id: 'auto-scroll',
	  install: __install_7
	};
	_$autoScroll_7["default"] = ___default_7;
	
	var _$InteractableMethods_8 = {};
	"use strict";
	
	Object.defineProperty(_$InteractableMethods_8, "__esModule", {
	  value: true
	});
	_$InteractableMethods_8["default"] = void 0;
	
	/* removed: var _$utils_56 = require("@interactjs/utils"); */;
	
	var __is_8 = ___interopRequireWildcard_8(_$is_57);
	
	function ___getRequireWildcardCache_8() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_8 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_8(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_8(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function __install_8(scope) {
	  var Interactable = scope.Interactable,
	      actions = scope.actions;
	  Interactable.prototype.getAction = getAction;
	  /**
	   * ```js
	   * interact(element, { ignoreFrom: document.getElementById('no-action') })
	   * // or
	   * interact(element).ignoreFrom('input, textarea, a')
	   * ```
	   * @deprecated
	   * If the target of the `mousedown`, `pointerdown` or `touchstart` event or any
	   * of it's parents match the given CSS selector or Element, no
	   * drag/resize/gesture is started.
	   *
	   * Don't use this method. Instead set the `ignoreFrom` option for each action
	   * or for `pointerEvents`
	   *
	   * @example
	   * interact(targett)
	   *   .draggable({
	   *     ignoreFrom: 'input, textarea, a[href]'',
	   *   })
	   *   .pointerEvents({
	   *     ignoreFrom: '[no-pointer]',
	   *   })
	   *
	   * @param {string | Element | null} [newValue] a CSS selector string, an
	   * Element or `null` to not ignore any elements
	   * @return {string | Element | object} The current ignoreFrom value or this
	   * Interactable
	   */
	
	  Interactable.prototype.ignoreFrom = (0, _$utils_56.warnOnce)(function (newValue) {
	    return this._backCompatOption('ignoreFrom', newValue);
	  }, 'Interactable.ignoreFrom() has been deprecated. Use Interactble.draggable({ignoreFrom: newValue}).');
	  /**
	   * @deprecated
	   *
	   * A drag/resize/gesture is started only If the target of the `mousedown`,
	   * `pointerdown` or `touchstart` event or any of it's parents match the given
	   * CSS selector or Element.
	   *
	   * Don't use this method. Instead set the `allowFrom` option for each action
	   * or for `pointerEvents`
	   *
	   * @example
	   * interact(targett)
	   *   .resizable({
	   *     allowFrom: '.resize-handle',
	   *   .pointerEvents({
	   *     allowFrom: '.handle',,
	   *   })
	   *
	   * @param {string | Element | null} [newValue] a CSS selector string, an
	   * Element or `null` to allow from any element
	   * @return {string | Element | object} The current allowFrom value or this
	   * Interactable
	   */
	
	  Interactable.prototype.allowFrom = (0, _$utils_56.warnOnce)(function (newValue) {
	    return this._backCompatOption('allowFrom', newValue);
	  }, 'Interactable.allowFrom() has been deprecated. Use Interactble.draggable({allowFrom: newValue}).');
	  /**
	   * ```js
	   * interact('.resize-drag')
	   *   .resizable(true)
	   *   .draggable(true)
	   *   .actionChecker(function (pointer, event, action, interactable, element, interaction) {
	   *
	   *   if (interact.matchesSelector(event.target, '.drag-handle')) {
	   *     // force drag with handle target
	   *     action.name = drag
	   *   }
	   *   else {
	   *     // resize from the top and right edges
	   *     action.name  = 'resize'
	   *     action.edges = { top: true, right: true }
	   *   }
	   *
	   *   return action
	   * })
	   * ```
	   *
	   * Returns or sets the function used to check action to be performed on
	   * pointerDown
	   *
	   * @param {function | null} [checker] A function which takes a pointer event,
	   * defaultAction string, interactable, element and interaction as parameters
	   * and returns an object with name property 'drag' 'resize' or 'gesture' and
	   * optionally an `edges` object with boolean 'top', 'left', 'bottom' and right
	   * props.
	   * @return {Function | Interactable} The checker function or this Interactable
	   */
	
	  Interactable.prototype.actionChecker = actionChecker;
	  /**
	   * Returns or sets whether the the cursor should be changed depending on the
	   * action that would be performed if the mouse were pressed and dragged.
	   *
	   * @param {boolean} [newValue]
	   * @return {boolean | Interactable} The current setting or this Interactable
	   */
	
	  Interactable.prototype.styleCursor = styleCursor;
	
	  Interactable.prototype.defaultActionChecker = function (pointer, event, interaction, element) {
	    return defaultActionChecker(this, pointer, event, interaction, element, actions);
	  };
	}
	
	function getAction(pointer, event, interaction, element) {
	  var action = this.defaultActionChecker(pointer, event, interaction, element);
	
	  if (this.options.actionChecker) {
	    return this.options.actionChecker(pointer, event, action, this, element, interaction);
	  }
	
	  return action;
	}
	
	function defaultActionChecker(interactable, pointer, event, interaction, element, actions) {
	  var rect = interactable.getRect(element);
	  var buttons = event.buttons || {
	    0: 1,
	    1: 4,
	    3: 8,
	    4: 16
	  }[event.button];
	  var action = null;
	
	  for (var _i = 0; _i < actions.names.length; _i++) {
	    var _ref;
	
	    _ref = actions.names[_i];
	    var actionName = _ref;
	
	    // check mouseButton setting if the pointer is down
	    if (interaction.pointerIsDown && /mouse|pointer/.test(interaction.pointerType) && (buttons & interactable.options[actionName].mouseButtons) === 0) {
	      continue;
	    }
	
	    action = actions[actionName].checker(pointer, event, interactable, element, interaction, rect);
	
	    if (action) {
	      return action;
	    }
	  }
	}
	
	function styleCursor(newValue) {
	  if (__is_8.bool(newValue)) {
	    this.options.styleCursor = newValue;
	    return this;
	  }
	
	  if (newValue === null) {
	    delete this.options.styleCursor;
	    return this;
	  }
	
	  return this.options.styleCursor;
	}
	
	function actionChecker(checker) {
	  if (__is_8.func(checker)) {
	    this.options.actionChecker = checker;
	    return this;
	  }
	
	  if (checker === null) {
	    delete this.options.actionChecker;
	    return this;
	  }
	
	  return this.options.actionChecker;
	}
	
	var ___default_8 = {
	  id: 'auto-start/interactableMethods',
	  install: __install_8
	};
	_$InteractableMethods_8["default"] = ___default_8;
	
	var _$base_9 = {};
	"use strict";
	
	Object.defineProperty(_$base_9, "__esModule", {
	  value: true
	});
	_$base_9["default"] = void 0;
	
	var __utils_9 = ___interopRequireWildcard_9(_$utils_56);
	
	var _InteractableMethods = ___interopRequireDefault_9(_$InteractableMethods_8);
	
	function ___interopRequireDefault_9(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_9() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_9 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_9(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_9(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function __install_9(scope) {
	  var interact = scope.interact,
	      interactions = scope.interactions,
	      defaults = scope.defaults;
	  scope.usePlugin(_InteractableMethods["default"]); // set cursor style on mousedown
	
	  interactions.signals.on('down', function (_ref) {
	    var interaction = _ref.interaction,
	        pointer = _ref.pointer,
	        event = _ref.event,
	        eventTarget = _ref.eventTarget;
	
	    if (interaction.interacting()) {
	      return;
	    }
	
	    var actionInfo = getActionInfo(interaction, pointer, event, eventTarget, scope);
	    prepare(interaction, actionInfo, scope);
	  }); // set cursor style on mousemove
	
	  interactions.signals.on('move', function (_ref2) {
	    var interaction = _ref2.interaction,
	        pointer = _ref2.pointer,
	        event = _ref2.event,
	        eventTarget = _ref2.eventTarget;
	
	    if (interaction.pointerType !== 'mouse' || interaction.pointerIsDown || interaction.interacting()) {
	      return;
	    }
	
	    var actionInfo = getActionInfo(interaction, pointer, event, eventTarget, scope);
	    prepare(interaction, actionInfo, scope);
	  });
	  interactions.signals.on('move', function (arg) {
	    var interaction = arg.interaction;
	
	    if (!interaction.pointerIsDown || interaction.interacting() || !interaction.pointerWasMoved || !interaction.prepared.name) {
	      return;
	    }
	
	    scope.autoStart.signals.fire('before-start', arg);
	    var interactable = interaction.interactable;
	
	    if (interaction.prepared.name && interactable) {
	      // check manualStart and interaction limit
	      if (interactable.options[interaction.prepared.name].manualStart || !withinInteractionLimit(interactable, interaction.element, interaction.prepared, scope)) {
	        interaction.stop();
	      } else {
	        interaction.start(interaction.prepared, interactable, interaction.element);
	        setInteractionCursor(interaction, scope);
	      }
	    }
	  });
	  interactions.signals.on('stop', function (_ref3) {
	    var interaction = _ref3.interaction;
	    var interactable = interaction.interactable;
	
	    if (interactable && interactable.options.styleCursor) {
	      setCursor(interaction.element, '', scope);
	    }
	  });
	  defaults.base.actionChecker = null;
	  defaults.base.styleCursor = true;
	  __utils_9.extend(defaults.perAction, {
	    manualStart: false,
	    max: Infinity,
	    maxPerElement: 1,
	    allowFrom: null,
	    ignoreFrom: null,
	    // only allow left button by default
	    // see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons#Return_value
	    mouseButtons: 1
	  });
	  /**
	   * Returns or sets the maximum number of concurrent interactions allowed.  By
	   * default only 1 interaction is allowed at a time (for backwards
	   * compatibility). To allow multiple interactions on the same Interactables and
	   * elements, you need to enable it in the draggable, resizable and gesturable
	   * `'max'` and `'maxPerElement'` options.
	   *
	   * @alias module:interact.maxInteractions
	   *
	   * @param {number} [newValue] Any number. newValue <= 0 means no interactions.
	   */
	
	  interact.maxInteractions = function (newValue) {
	    return maxInteractions(newValue, scope);
	  };
	
	  scope.autoStart = {
	    // Allow this many interactions to happen simultaneously
	    maxInteractions: Infinity,
	    withinInteractionLimit: withinInteractionLimit,
	    cursorElement: null,
	    signals: new __utils_9.Signals()
	  };
	} // Check if the current interactable supports the action.
	// If so, return the validated action. Otherwise, return null
	
	
	function validateAction(action, interactable, element, eventTarget, scope) {
	  if (interactable.testIgnoreAllow(interactable.options[action.name], element, eventTarget) && interactable.options[action.name].enabled && withinInteractionLimit(interactable, element, action, scope)) {
	    return action;
	  }
	
	  return null;
	}
	
	function validateMatches(interaction, pointer, event, matches, matchElements, eventTarget, scope) {
	  for (var i = 0, len = matches.length; i < len; i++) {
	    var match = matches[i];
	    var matchElement = matchElements[i];
	    var matchAction = match.getAction(pointer, event, interaction, matchElement);
	
	    if (!matchAction) {
	      continue;
	    }
	
	    var action = validateAction(matchAction, match, matchElement, eventTarget, scope);
	
	    if (action) {
	      return {
	        action: action,
	        interactable: match,
	        element: matchElement
	      };
	    }
	  }
	
	  return {
	    action: null,
	    interactable: null,
	    element: null
	  };
	}
	
	function getActionInfo(interaction, pointer, event, eventTarget, scope) {
	  var matches = [];
	  var matchElements = [];
	  var element = eventTarget;
	
	  function pushMatches(interactable) {
	    matches.push(interactable);
	    matchElements.push(element);
	  }
	
	  while (__utils_9.is.element(element)) {
	    matches = [];
	    matchElements = [];
	    scope.interactables.forEachMatch(element, pushMatches);
	    var actionInfo = validateMatches(interaction, pointer, event, matches, matchElements, eventTarget, scope);
	
	    if (actionInfo.action && !actionInfo.interactable.options[actionInfo.action.name].manualStart) {
	      return actionInfo;
	    }
	
	    element = __utils_9.dom.parentNode(element);
	  }
	
	  return {
	    action: null,
	    interactable: null,
	    element: null
	  };
	}
	
	function prepare(interaction, _ref4, scope) {
	  var action = _ref4.action,
	      interactable = _ref4.interactable,
	      element = _ref4.element;
	  action = action || {
	    name: null
	  }; // clear previous target element cursor
	
	  if (interaction.interactable && interaction.interactable.options.styleCursor) {
	    setCursor(interaction.element, '', scope);
	  }
	
	  interaction.interactable = interactable;
	  interaction.element = element;
	  __utils_9.copyAction(interaction.prepared, action);
	  interaction.rect = interactable && action.name ? interactable.getRect(element) : null;
	  setInteractionCursor(interaction, scope);
	  scope.autoStart.signals.fire('prepared', {
	    interaction: interaction
	  });
	}
	
	function withinInteractionLimit(interactable, element, action, scope) {
	  var options = interactable.options;
	  var maxActions = options[action.name].max;
	  var maxPerElement = options[action.name].maxPerElement;
	  var autoStartMax = scope.autoStart.maxInteractions;
	  var activeInteractions = 0;
	  var interactableCount = 0;
	  var elementCount = 0; // no actions if any of these values == 0
	
	  if (!(maxActions && maxPerElement && autoStartMax)) {
	    return false;
	  }
	
	  for (var _i = 0; _i < scope.interactions.list.length; _i++) {
	    var _ref5;
	
	    _ref5 = scope.interactions.list[_i];
	    var interaction = _ref5;
	    var otherAction = interaction.prepared.name;
	
	    if (!interaction.interacting()) {
	      continue;
	    }
	
	    activeInteractions++;
	
	    if (activeInteractions >= autoStartMax) {
	      return false;
	    }
	
	    if (interaction.interactable !== interactable) {
	      continue;
	    }
	
	    interactableCount += otherAction === action.name ? 1 : 0;
	
	    if (interactableCount >= maxActions) {
	      return false;
	    }
	
	    if (interaction.element === element) {
	      elementCount++;
	
	      if (otherAction === action.name && elementCount >= maxPerElement) {
	        return false;
	      }
	    }
	  }
	
	  return autoStartMax > 0;
	}
	
	function maxInteractions(newValue, scope) {
	  if (__utils_9.is.number(newValue)) {
	    scope.autoStart.maxInteractions = newValue;
	    return this;
	  }
	
	  return scope.autoStart.maxInteractions;
	}
	
	function setCursor(element, cursor, scope) {
	  if (scope.autoStart.cursorElement) {
	    scope.autoStart.cursorElement.style.cursor = '';
	  }
	
	  element.ownerDocument.documentElement.style.cursor = cursor;
	  element.style.cursor = cursor;
	  scope.autoStart.cursorElement = cursor ? element : null;
	}
	
	function setInteractionCursor(interaction, scope) {
	  var interactable = interaction.interactable,
	      element = interaction.element,
	      prepared = interaction.prepared;
	
	  if (!(interaction.pointerType === 'mouse' && interactable && interactable.options.styleCursor)) {
	    return;
	  }
	
	  var cursor = '';
	
	  if (prepared.name) {
	    var cursorChecker = interactable.options[prepared.name].cursorChecker;
	
	    if (__utils_9.is.func(cursorChecker)) {
	      cursor = cursorChecker(prepared, interactable, element, interaction._interacting);
	    } else {
	      cursor = scope.actions[prepared.name].getCursor(prepared);
	    }
	  }
	
	  setCursor(interaction.element, cursor || '', scope);
	}
	
	var ___default_9 = {
	  id: 'auto-start/base',
	  install: __install_9,
	  maxInteractions: maxInteractions,
	  withinInteractionLimit: withinInteractionLimit,
	  validateAction: validateAction
	};
	_$base_9["default"] = ___default_9;
	
	var _$dragAxis_10 = {};
	"use strict";
	
	Object.defineProperty(_$dragAxis_10, "__esModule", {
	  value: true
	});
	_$dragAxis_10["default"] = void 0;
	
	var ___scope_10 = _$scope_24({});
	
	/* removed: var _$domUtils_51 = require("@interactjs/utils/domUtils"); */;
	
	var __is_10 = ___interopRequireWildcard_10(_$is_57);
	
	var _base = ___interopRequireDefault_10(_$base_9);
	
	function ___interopRequireDefault_10(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_10() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_10 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_10(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_10(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function __install_10(scope) {
	  scope.autoStart.signals.on('before-start', function (_ref) {
	    var interaction = _ref.interaction,
	        eventTarget = _ref.eventTarget,
	        dx = _ref.dx,
	        dy = _ref.dy;
	
	    if (interaction.prepared.name !== 'drag') {
	      return;
	    } // check if a drag is in the correct axis
	
	
	    var absX = Math.abs(dx);
	    var absY = Math.abs(dy);
	    var targetOptions = interaction.interactable.options.drag;
	    var startAxis = targetOptions.startAxis;
	    var currentAxis = absX > absY ? 'x' : absX < absY ? 'y' : 'xy';
	    interaction.prepared.axis = targetOptions.lockAxis === 'start' ? currentAxis[0] // always lock to one axis even if currentAxis === 'xy'
	    : targetOptions.lockAxis; // if the movement isn't in the startAxis of the interactable
	
	    if (currentAxis !== 'xy' && startAxis !== 'xy' && startAxis !== currentAxis) {
	      // cancel the prepared action
	      interaction.prepared.name = null; // then try to get a drag from another ineractable
	
	      var element = eventTarget;
	
	      var getDraggable = function getDraggable(interactable) {
	        if (interactable === interaction.interactable) {
	          return;
	        }
	
	        var options = interaction.interactable.options.drag;
	
	        if (!options.manualStart && interactable.testIgnoreAllow(options, element, eventTarget)) {
	          var action = interactable.getAction(interaction.downPointer, interaction.downEvent, interaction, element);
	
	          if (action && action.name === ___scope_10.ActionName.Drag && checkStartAxis(currentAxis, interactable) && _base["default"].validateAction(action, interactable, element, eventTarget, scope)) {
	            return interactable;
	          }
	        }
	      }; // check all interactables
	
	
	      while (__is_10.element(element)) {
	        var interactable = scope.interactables.forEachMatch(element, getDraggable);
	
	        if (interactable) {
	          interaction.prepared.name = ___scope_10.ActionName.Drag;
	          interaction.interactable = interactable;
	          interaction.element = element;
	          break;
	        }
	
	        element = (0, _$domUtils_51.parentNode)(element);
	      }
	    }
	  });
	
	  function checkStartAxis(startAxis, interactable) {
	    if (!interactable) {
	      return false;
	    }
	
	    var thisAxis = interactable.options[___scope_10.ActionName.Drag].startAxis;
	    return startAxis === 'xy' || thisAxis === 'xy' || thisAxis === startAxis;
	  }
	}
	
	var ___default_10 = {
	  id: 'auto-start/dragAxis',
	  install: __install_10
	};
	_$dragAxis_10["default"] = ___default_10;
	
	var _$hold_11 = {};
	"use strict";
	
	Object.defineProperty(_$hold_11, "__esModule", {
	  value: true
	});
	_$hold_11["default"] = void 0;
	
	var ___base_11 = ___interopRequireDefault_11(_$base_9);
	
	function ___interopRequireDefault_11(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function __install_11(scope) {
	  var autoStart = scope.autoStart,
	      interactions = scope.interactions,
	      defaults = scope.defaults;
	  scope.usePlugin(___base_11["default"]);
	  defaults.perAction.hold = 0;
	  defaults.perAction.delay = 0;
	  interactions.signals.on('new', function (interaction) {
	    interaction.autoStartHoldTimer = null;
	  });
	  autoStart.signals.on('prepared', function (_ref) {
	    var interaction = _ref.interaction;
	    var hold = getHoldDuration(interaction);
	
	    if (hold > 0) {
	      interaction.autoStartHoldTimer = setTimeout(function () {
	        interaction.start(interaction.prepared, interaction.interactable, interaction.element);
	      }, hold);
	    }
	  });
	  interactions.signals.on('move', function (_ref2) {
	    var interaction = _ref2.interaction,
	        duplicate = _ref2.duplicate;
	
	    if (interaction.pointerWasMoved && !duplicate) {
	      clearTimeout(interaction.autoStartHoldTimer);
	    }
	  }); // prevent regular down->move autoStart
	
	  autoStart.signals.on('before-start', function (_ref3) {
	    var interaction = _ref3.interaction;
	    var hold = getHoldDuration(interaction);
	
	    if (hold > 0) {
	      interaction.prepared.name = null;
	    }
	  });
	}
	
	function getHoldDuration(interaction) {
	  var actionName = interaction.prepared && interaction.prepared.name;
	
	  if (!actionName) {
	    return null;
	  }
	
	  var options = interaction.interactable.options;
	  return options[actionName].hold || options[actionName].delay;
	}
	
	var ___default_11 = {
	  id: 'auto-start/hold',
	  install: __install_11,
	  getHoldDuration: getHoldDuration
	};
	_$hold_11["default"] = ___default_11;
	
	var _$autoStart_12 = {};
	"use strict";
	
	Object.defineProperty(_$autoStart_12, "__esModule", {
	  value: true
	});
	_$autoStart_12.install = __install_12;
	Object.defineProperty(_$autoStart_12, "autoStart", {
	  enumerable: true,
	  get: function get() {
	    return ___base_12["default"];
	  }
	});
	Object.defineProperty(_$autoStart_12, "dragAxis", {
	  enumerable: true,
	  get: function get() {
	    return _dragAxis["default"];
	  }
	});
	Object.defineProperty(_$autoStart_12, "hold", {
	  enumerable: true,
	  get: function get() {
	    return _hold["default"];
	  }
	});
	_$autoStart_12.id = void 0;
	
	var ___base_12 = ___interopRequireDefault_12(_$base_9);
	
	var _dragAxis = ___interopRequireDefault_12(_$dragAxis_10);
	
	var _hold = ___interopRequireDefault_12(_$hold_11);
	
	function ___interopRequireDefault_12(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function __install_12(scope) {
	  scope.usePlugin(___base_12["default"]);
	  scope.usePlugin(_hold["default"]);
	  scope.usePlugin(_dragAxis["default"]);
	}
	
	var __id_12 = 'auto-start';
	_$autoStart_12.id = __id_12;
	
	var _$interactablePreventDefault_21 = {};
	"use strict";
	
	Object.defineProperty(_$interactablePreventDefault_21, "__esModule", {
	  value: true
	});
	_$interactablePreventDefault_21.install = __install_21;
	_$interactablePreventDefault_21["default"] = void 0;
	
	/* removed: var _$domUtils_51 = require("@interactjs/utils/domUtils"); */;
	
	var ___events_21 = ___interopRequireDefault_21(_$events_52);
	
	var __is_21 = ___interopRequireWildcard_21(_$is_57);
	
	/* removed: var _$window_66 = require("@interactjs/utils/window"); */;
	
	function ___getRequireWildcardCache_21() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_21 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_21(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_21(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___interopRequireDefault_21(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function preventDefault(newValue) {
	  if (/^(always|never|auto)$/.test(newValue)) {
	    this.options.preventDefault = newValue;
	    return this;
	  }
	
	  if (__is_21.bool(newValue)) {
	    this.options.preventDefault = newValue ? 'always' : 'never';
	    return this;
	  }
	
	  return this.options.preventDefault;
	}
	
	function checkAndPreventDefault(interactable, scope, event) {
	  var setting = interactable.options.preventDefault;
	
	  if (setting === 'never') {
	    return;
	  }
	
	  if (setting === 'always') {
	    event.preventDefault();
	    return;
	  } // setting === 'auto'
	  // if the browser supports passive event listeners and isn't running on iOS,
	  // don't preventDefault of touch{start,move} events. CSS touch-action and
	  // user-select should be used instead of calling event.preventDefault().
	
	
	  if (___events_21["default"].supportsPassive && /^touch(start|move)$/.test(event.type)) {
	    var doc = (0, _$window_66.getWindow)(event.target).document;
	    var docOptions = scope.getDocOptions(doc);
	
	    if (!(docOptions && docOptions.events) || docOptions.events.passive !== false) {
	      return;
	    }
	  } // don't preventDefault of pointerdown events
	
	
	  if (/^(mouse|pointer|touch)*(down|start)/i.test(event.type)) {
	    return;
	  } // don't preventDefault on editable elements
	
	
	  if (__is_21.element(event.target) && (0, _$domUtils_51.matchesSelector)(event.target, 'input,select,textarea,[contenteditable=true],[contenteditable=true] *')) {
	    return;
	  }
	
	  event.preventDefault();
	}
	
	function onInteractionEvent(_ref) {
	  var interaction = _ref.interaction,
	      event = _ref.event;
	
	  if (interaction.interactable) {
	    interaction.interactable.checkAndPreventDefault(event);
	  }
	}
	
	function __install_21(scope) {
	  /** @lends Interactable */
	  var Interactable = scope.Interactable;
	  /**
	   * Returns or sets whether to prevent the browser's default behaviour in
	   * response to pointer events. Can be set to:
	   *  - `'always'` to always prevent
	   *  - `'never'` to never prevent
	   *  - `'auto'` to let interact.js try to determine what would be best
	   *
	   * @param {string} [newValue] `'always'`, `'never'` or `'auto'`
	   * @return {string | Interactable} The current setting or this Interactable
	   */
	
	  Interactable.prototype.preventDefault = preventDefault;
	
	  Interactable.prototype.checkAndPreventDefault = function (event) {
	    return checkAndPreventDefault(this, scope, event);
	  };
	
	  var _arr = ['down', 'move', 'up', 'cancel'];
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    var eventSignal = _arr[_i];
	    scope.interactions.signals.on(eventSignal, onInteractionEvent);
	  } // prevent native HTML5 drag on interact.js target elements
	
	
	  scope.interactions.docEvents.push({
	    type: 'dragstart',
	    listener: function listener(event) {
	      for (var _i2 = 0; _i2 < scope.interactions.list.length; _i2++) {
	        var _ref2;
	
	        _ref2 = scope.interactions.list[_i2];
	        var interaction = _ref2;
	
	        if (interaction.element && (interaction.element === event.target || (0, _$domUtils_51.nodeContains)(interaction.element, event.target))) {
	          interaction.interactable.checkAndPreventDefault(event);
	          return;
	        }
	      }
	    }
	  });
	}
	
	var ___default_21 = {
	  id: 'core/interactablePreventDefault',
	  install: __install_21
	};
	_$interactablePreventDefault_21["default"] = ___default_21;
	
	var _$devTools_25 = {};
	"use strict";
	
	Object.defineProperty(_$devTools_25, "__esModule", {
	  value: true
	});
	_$devTools_25["default"] = void 0;
	
	var ___domObjects_25 = ___interopRequireDefault_25(_$domObjects_50);
	
	/* removed: var _$domUtils_51 = require("@interactjs/utils/domUtils"); */;
	
	var ___extend_25 = ___interopRequireDefault_25(_$extend_53);
	
	var __is_25 = ___interopRequireWildcard_25(_$is_57);
	
	var ___window_25 = ___interopRequireDefault_25(_$window_66);
	
	function ___getRequireWildcardCache_25() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_25 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_25(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_25(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___interopRequireDefault_25(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___toConsumableArray_25(arr) { return ___arrayWithoutHoles_25(arr) || ___iterableToArray_25(arr) || ___nonIterableSpread_25(); }
	
	function ___nonIterableSpread_25() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function ___iterableToArray_25(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function ___arrayWithoutHoles_25(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var CheckName;
	
	(function (CheckName) {
	  CheckName["touchAction"] = "";
	  CheckName["boxSizing"] = "";
	  CheckName["noListeners"] = "";
	})(CheckName || (CheckName = {}));
	
	var prefix = '[interact.js] ';
	var links = {
	  touchAction: 'https://developer.mozilla.org/en-US/docs/Web/CSS/touch-action',
	  boxSizing: 'https://developer.mozilla.org/en-US/docs/Web/CSS/box-sizing'
	};
	var isProduction = "production" === 'production'; // eslint-disable-next-line no-restricted-syntax
	
	function __install_25(scope) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      logger = _ref.logger;
	
	  var interactions = scope.interactions,
	      Interactable = scope.Interactable,
	      defaults = scope.defaults;
	  logger = logger || console;
	  interactions.signals.on('action-start', function (_ref2) {
	    var interaction = _ref2.interaction;
	
	    for (var _i = 0; _i < checks.length; _i++) {
	      var _ref3;
	
	      _ref3 = checks[_i];
	      var check = _ref3;
	      var options = interaction.interactable && interaction.interactable.options[interaction.prepared.name];
	
	      if (!(options && options.devTools && options.devTools.ignore[check.name]) && check.perform(interaction)) {
	        var _logger;
	
	        (_logger = logger).warn.apply(_logger, [prefix + check.text].concat(___toConsumableArray_25(check.getInfo(interaction))));
	      }
	    }
	  });
	  defaults.base.devTools = {
	    ignore: {}
	  };
	
	  Interactable.prototype.devTools = function (options) {
	    if (options) {
	      (0, ___extend_25["default"])(this.options.devTools, options);
	      return this;
	    }
	
	    return this.options.devTools;
	  };
	}
	
	var checks = [{
	  name: 'touchAction',
	  perform: function perform(_ref4) {
	    var element = _ref4.element;
	    return !parentHasStyle(element, 'touchAction', /pan-|pinch|none/);
	  },
	  getInfo: function getInfo(_ref5) {
	    var element = _ref5.element;
	    return [element, links.touchAction];
	  },
	  text: 'Consider adding CSS "touch-action: none" to this element\n'
	}, {
	  name: 'boxSizing',
	  perform: function perform(interaction) {
	    var element = interaction.element;
	    return interaction.prepared.name === 'resize' && element instanceof ___domObjects_25["default"].HTMLElement && !hasStyle(element, 'boxSizing', /border-box/);
	  },
	  text: 'Consider adding CSS "box-sizing: border-box" to this resizable element',
	  getInfo: function getInfo(_ref6) {
	    var element = _ref6.element;
	    return [element, links.boxSizing];
	  }
	}, {
	  name: 'noListeners',
	  perform: function perform(interaction) {
	    var actionName = interaction.prepared.name;
	    var moveListeners = interaction.interactable.events.types["".concat(actionName, "move")] || [];
	    return !moveListeners.length;
	  },
	  getInfo: function getInfo(interaction) {
	    return [interaction.prepared.name, interaction.interactable];
	  },
	  text: 'There are no listeners set for this action'
	}];
	
	function hasStyle(element, prop, styleRe) {
	  return styleRe.test(element.style[prop] || ___window_25["default"].window.getComputedStyle(element)[prop]);
	}
	
	function parentHasStyle(element, prop, styleRe) {
	  var parent = element;
	
	  while (__is_25.element(parent)) {
	    if (hasStyle(parent, prop, styleRe)) {
	      return true;
	    }
	
	    parent = (0, _$domUtils_51.parentNode)(parent);
	  }
	
	  return false;
	}
	
	var __id_25 = 'dev-tools';
	var defaultExport = isProduction ? {
	  id: __id_25,
	  install: function install() {}
	} : {
	  id: __id_25,
	  install: __install_25,
	  checks: checks,
	  CheckName: CheckName,
	  links: links,
	  prefix: prefix
	};
	var ___default_25 = defaultExport;
	_$devTools_25["default"] = ___default_25;
	
	var _$base_30 = {};
	"use strict";
	
	Object.defineProperty(_$base_30, "__esModule", {
	  value: true
	});
	_$base_30.startAll = startAll;
	_$base_30.setAll = setAll;
	_$base_30.prepareStates = prepareStates;
	_$base_30.setCoords = setCoords;
	_$base_30.restoreCoords = restoreCoords;
	_$base_30.makeModifier = makeModifier;
	_$base_30["default"] = void 0;
	
	var ___extend_30 = ___interopRequireDefault_30(_$extend_53);
	
	function ___interopRequireDefault_30(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___slicedToArray_30(arr, i) { return ___arrayWithHoles_30(arr) || ___iterableToArrayLimit_30(arr, i) || ___nonIterableRest_30(); }
	
	function ___nonIterableRest_30() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function ___iterableToArrayLimit_30(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function ___arrayWithHoles_30(arr) { if (Array.isArray(arr)) return arr; }
	
	function __install_30(scope) {
	  var interactions = scope.interactions;
	  scope.defaults.perAction.modifiers = [];
	  interactions.signals.on('new', function (_ref) {
	    var interaction = _ref.interaction;
	    interaction.modifiers = {
	      startOffset: {
	        left: 0,
	        right: 0,
	        top: 0,
	        bottom: 0
	      },
	      offsets: {},
	      states: null,
	      result: null,
	      endPrevented: false,
	      startDelta: null
	    };
	  });
	  interactions.signals.on('before-action-start', function (arg) {
	    __start_30(arg, arg.interaction.coords.start.page, arg.interaction.coords.prev.page);
	  });
	  interactions.signals.on('action-resume', function (arg) {
	    stop(arg);
	    __start_30(arg, arg.interaction.coords.cur.page, arg.interaction.modifiers.result.coords);
	    __beforeMove_30(arg);
	  });
	  interactions.signals.on('after-action-move', restoreCoords);
	  interactions.signals.on('before-action-move', __beforeMove_30);
	  interactions.signals.on('before-action-start', setCoords);
	  interactions.signals.on('after-action-start', restoreCoords);
	  interactions.signals.on('before-action-end', beforeEnd);
	  interactions.signals.on('stop', stop);
	}
	
	function __start_30(_ref2, pageCoords, prevCoords) {
	  var interaction = _ref2.interaction,
	      phase = _ref2.phase;
	  var interactable = interaction.interactable,
	      element = interaction.element;
	  var modifierList = getModifierList(interaction);
	  var states = prepareStates(modifierList);
	  var rect = (0, ___extend_30["default"])({}, interaction.rect);
	
	  if (!('width' in rect)) {
	    rect.width = rect.right - rect.left;
	  }
	
	  if (!('height' in rect)) {
	    rect.height = rect.bottom - rect.top;
	  }
	
	  var startOffset = getRectOffset(rect, pageCoords);
	  interaction.modifiers.startOffset = startOffset;
	  interaction.modifiers.startDelta = {
	    x: 0,
	    y: 0
	  };
	  var arg = {
	    interaction: interaction,
	    interactable: interactable,
	    element: element,
	    pageCoords: pageCoords,
	    phase: phase,
	    rect: rect,
	    startOffset: startOffset,
	    states: states,
	    preEnd: false,
	    requireEndOnly: false,
	    prevCoords: prevCoords || (interaction.modifiers.result ? interaction.modifiers.result.coords : interaction.coords.prev.page)
	  };
	  interaction.modifiers.states = states;
	  interaction.modifiers.result = null;
	  startAll(arg);
	  var result = interaction.modifiers.result = setAll(arg);
	  return result;
	}
	
	function startAll(arg) {
	  var states = arg.states;
	
	  for (var _i = 0; _i < states.length; _i++) {
	    var _ref3;
	
	    _ref3 = states[_i];
	    var state = _ref3;
	
	    if (state.methods.start) {
	      arg.state = state;
	      state.methods.start(arg);
	    }
	  }
	}
	
	function setAll(arg) {
	  var prevCoords = arg.prevCoords,
	      phase = arg.phase,
	      preEnd = arg.preEnd,
	      requireEndOnly = arg.requireEndOnly,
	      rect = arg.rect,
	      states = arg.states;
	  arg.coords = (0, ___extend_30["default"])({}, arg.pageCoords);
	  arg.rect = (0, ___extend_30["default"])({}, rect);
	  var result = {
	    delta: {
	      x: 0,
	      y: 0
	    },
	    rectDelta: {
	      left: 0,
	      right: 0,
	      top: 0,
	      bottom: 0
	    },
	    coords: arg.coords,
	    changed: true
	  };
	
	  for (var _i2 = 0; _i2 < states.length; _i2++) {
	    var _ref4;
	
	    _ref4 = states[_i2];
	    var state = _ref4;
	    var options = state.options;
	
	    if (!state.methods.set || !shouldDo(options, preEnd, requireEndOnly, phase)) {
	      continue;
	    }
	
	    arg.state = state;
	    state.methods.set(arg);
	  }
	
	  result.delta.x = arg.coords.x - arg.pageCoords.x;
	  result.delta.y = arg.coords.y - arg.pageCoords.y;
	  var rectChanged = false;
	
	  if (rect) {
	    result.rectDelta.left = arg.rect.left - rect.left;
	    result.rectDelta.right = arg.rect.right - rect.right;
	    result.rectDelta.top = arg.rect.top - rect.top;
	    result.rectDelta.bottom = arg.rect.bottom - rect.bottom;
	    rectChanged = result.rectDelta.left !== 0 || result.rectDelta.right !== 0 || result.rectDelta.top !== 0 || result.rectDelta.bottom !== 0;
	  }
	
	  result.changed = !prevCoords || prevCoords.x !== result.coords.x || prevCoords.y !== result.coords.y || rectChanged;
	  return result;
	}
	
	function __beforeMove_30(arg) {
	  var interaction = arg.interaction,
	      phase = arg.phase,
	      preEnd = arg.preEnd,
	      skipModifiers = arg.skipModifiers;
	  var interactable = interaction.interactable,
	      element = interaction.element;
	  var states = skipModifiers ? interaction.modifiers.states.slice(skipModifiers) : interaction.modifiers.states;
	  var prevCoords = arg.prevCoords || (interaction.modifiers.result ? interaction.modifiers.result.coords : interaction.coords.prev.page);
	  var modifierResult = setAll({
	    interaction: interaction,
	    interactable: interactable,
	    element: element,
	    preEnd: preEnd,
	    phase: phase,
	    pageCoords: arg.modifiedCoords || interaction.coords.cur.page,
	    prevCoords: prevCoords,
	    rect: interaction.rect,
	    states: states,
	    requireEndOnly: false
	  });
	  interaction.modifiers.result = modifierResult; // don't fire an action move if a modifier would keep the event in the same
	  // cordinates as before
	
	  if (!modifierResult.changed && interaction.interacting()) {
	    return false;
	  }
	
	  if (arg.modifiedCoords) {
	    var page = interaction.coords.cur.page;
	    var adjustment = {
	      x: arg.modifiedCoords.x - page.x,
	      y: arg.modifiedCoords.y - page.y
	    };
	    modifierResult.coords.x += adjustment.x;
	    modifierResult.coords.y += adjustment.y;
	    modifierResult.delta.x += adjustment.x;
	    modifierResult.delta.y += adjustment.y;
	  }
	
	  setCoords(arg);
	}
	
	function beforeEnd(arg) {
	  var interaction = arg.interaction,
	      event = arg.event,
	      noPreEnd = arg.noPreEnd;
	  var states = interaction.modifiers.states;
	
	  if (noPreEnd || !states || !states.length) {
	    return;
	  }
	
	  var didPreEnd = false;
	
	  for (var _i3 = 0; _i3 < states.length; _i3++) {
	    var _ref5;
	
	    _ref5 = states[_i3];
	    var state = _ref5;
	    arg.state = state;
	    var options = state.options,
	        methods = state.methods;
	    var endResult = methods.beforeEnd && methods.beforeEnd(arg);
	
	    if (endResult === false) {
	      interaction.modifiers.endPrevented = true;
	      return false;
	    } // if the endOnly option is true for any modifier
	
	
	    if (!didPreEnd && shouldDo(options, true, true)) {
	      // fire a move event at the modified coordinates
	      interaction.move({
	        event: event,
	        preEnd: true
	      });
	      didPreEnd = true;
	    }
	  }
	}
	
	function stop(arg) {
	  var interaction = arg.interaction;
	  var states = interaction.modifiers.states;
	
	  if (!states || !states.length) {
	    return;
	  }
	
	  var modifierArg = (0, ___extend_30["default"])({
	    states: states,
	    interactable: interaction.interactable,
	    element: interaction.element,
	    rect: null
	  }, arg);
	
	  for (var _i4 = 0; _i4 < states.length; _i4++) {
	    var _ref6;
	
	    _ref6 = states[_i4];
	    var state = _ref6;
	    modifierArg.state = state;
	
	    if (state.methods.stop) {
	      state.methods.stop(modifierArg);
	    }
	  }
	
	  arg.interaction.modifiers.states = null;
	  arg.interaction.modifiers.endPrevented = false;
	}
	
	function getModifierList(interaction) {
	  var actionOptions = interaction.interactable.options[interaction.prepared.name];
	  var actionModifiers = actionOptions.modifiers;
	
	  if (actionModifiers && actionModifiers.length) {
	    return actionModifiers.filter(function (modifier) {
	      return !modifier.options || modifier.options.enabled !== false;
	    });
	  }
	
	  return ['snap', 'snapSize', 'snapEdges', 'restrict', 'restrictEdges', 'restrictSize'].map(function (type) {
	    var options = actionOptions[type];
	    return options && options.enabled && {
	      options: options,
	      methods: options._methods
	    };
	  }).filter(function (m) {
	    return !!m;
	  });
	}
	
	function prepareStates(modifierList) {
	  var states = [];
	
	  for (var index = 0; index < modifierList.length; index++) {
	    var _modifierList$index = modifierList[index],
	        options = _modifierList$index.options,
	        methods = _modifierList$index.methods,
	        name = _modifierList$index.name;
	
	    if (options && options.enabled === false) {
	      continue;
	    }
	
	    states.push({
	      options: options,
	      methods: methods,
	      index: index,
	      name: name
	    });
	  }
	
	  return states;
	}
	
	function setCoords(arg) {
	  var interaction = arg.interaction,
	      phase = arg.phase;
	  var curCoords = interaction.coords.cur;
	  var startCoords = interaction.coords.start;
	  var _interaction$modifier = interaction.modifiers,
	      result = _interaction$modifier.result,
	      startDelta = _interaction$modifier.startDelta;
	  var curDelta = result.delta;
	
	  if (phase === 'start') {
	    (0, ___extend_30["default"])(interaction.modifiers.startDelta, result.delta);
	  }
	
	  var _arr = [[startCoords, startDelta], [curCoords, curDelta]];
	
	  for (var _i5 = 0; _i5 < _arr.length; _i5++) {
	    var _arr$_i = ___slicedToArray_30(_arr[_i5], 2),
	        coordsSet = _arr$_i[0],
	        delta = _arr$_i[1];
	
	    coordsSet.page.x += delta.x;
	    coordsSet.page.y += delta.y;
	    coordsSet.client.x += delta.x;
	    coordsSet.client.y += delta.y;
	  }
	
	  var rectDelta = interaction.modifiers.result.rectDelta;
	  var rect = arg.rect || interaction.rect;
	  rect.left += rectDelta.left;
	  rect.right += rectDelta.right;
	  rect.top += rectDelta.top;
	  rect.bottom += rectDelta.bottom;
	  rect.width = rect.right - rect.left;
	  rect.height = rect.bottom - rect.top;
	}
	
	function restoreCoords(_ref7) {
	  var _ref7$interaction = _ref7.interaction,
	      coords = _ref7$interaction.coords,
	      rect = _ref7$interaction.rect,
	      modifiers = _ref7$interaction.modifiers;
	
	  if (!modifiers.result) {
	    return;
	  }
	
	  var startDelta = modifiers.startDelta;
	  var _modifiers$result = modifiers.result,
	      curDelta = _modifiers$result.delta,
	      rectDelta = _modifiers$result.rectDelta;
	  var coordsAndDeltas = [[coords.start, startDelta], [coords.cur, curDelta]];
	
	  for (var _i6 = 0; _i6 < coordsAndDeltas.length; _i6++) {
	    var _coordsAndDeltas$_i = ___slicedToArray_30(coordsAndDeltas[_i6], 2),
	        coordsSet = _coordsAndDeltas$_i[0],
	        delta = _coordsAndDeltas$_i[1];
	
	    coordsSet.page.x -= delta.x;
	    coordsSet.page.y -= delta.y;
	    coordsSet.client.x -= delta.x;
	    coordsSet.client.y -= delta.y;
	  }
	
	  rect.left -= rectDelta.left;
	  rect.right -= rectDelta.right;
	  rect.top -= rectDelta.top;
	  rect.bottom -= rectDelta.bottom;
	}
	
	function shouldDo(options, preEnd, requireEndOnly, phase) {
	  return options ? options.enabled !== false && (preEnd || !options.endOnly) && (!requireEndOnly || options.endOnly || options.alwaysOnEnd) && (options.setStart || phase !== 'start') : !requireEndOnly;
	}
	
	function getRectOffset(rect, coords) {
	  return rect ? {
	    left: coords.x - rect.left,
	    top: coords.y - rect.top,
	    right: rect.right - coords.x,
	    bottom: rect.bottom - coords.y
	  } : {
	    left: 0,
	    top: 0,
	    right: 0,
	    bottom: 0
	  };
	}
	
	function makeModifier(module, name) {
	  var defaults = module.defaults;
	  var methods = {
	    start: module.start,
	    set: module.set,
	    beforeEnd: module.beforeEnd,
	    stop: module.stop
	  };
	
	  var modifier = function modifier(_options) {
	    var options = _options || {};
	    options.enabled = options.enabled !== false; // add missing defaults to options
	
	    for (var prop in defaults) {
	      if (!(prop in options)) {
	        options[prop] = defaults[prop];
	      }
	    }
	
	    var m = {
	      options: options,
	      methods: methods,
	      name: name
	    };
	    return m;
	  };
	
	  if (name && typeof name === 'string') {
	    // for backwrads compatibility
	    modifier._defaults = defaults;
	    modifier._methods = methods;
	  }
	
	  return modifier;
	}
	
	var ___default_30 = {
	  id: 'modifiers/base',
	  install: __install_30,
	  startAll: startAll,
	  setAll: setAll,
	  prepareStates: prepareStates,
	  start: __start_30,
	  beforeMove: __beforeMove_30,
	  beforeEnd: beforeEnd,
	  stop: stop,
	  shouldDo: shouldDo,
	  getModifierList: getModifierList,
	  getRectOffset: getRectOffset,
	  makeModifier: makeModifier
	};
	_$base_30["default"] = ___default_30;
	
	var _$inertia_26 = {};
	"use strict";
	
	Object.defineProperty(_$inertia_26, "__esModule", {
	  value: true
	});
	_$inertia_26["default"] = void 0;
	
	/* removed: var _$InteractEvent_15 = require("@interactjs/core/InteractEvent"); */;
	
	var ___base_26 = ___interopRequireWildcard_26(_$base_30);
	
	var __utils_26 = ___interopRequireWildcard_26(_$utils_56);
	
	var ___raf_26 = ___interopRequireDefault_26(_$raf_62);
	
	function ___interopRequireDefault_26(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_26() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_26 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_26(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_26(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	_$InteractEvent_15.EventPhase.Resume = 'resume';
	_$InteractEvent_15.EventPhase.InertiaStart = 'inertiastart';
	
	function __install_26(scope) {
	  var interactions = scope.interactions,
	      defaults = scope.defaults;
	  interactions.signals.on('new', function (_ref) {
	    var interaction = _ref.interaction;
	    interaction.inertia = {
	      active: false,
	      smoothEnd: false,
	      allowResume: false,
	      upCoords: {},
	      timeout: null
	    };
	  });
	  interactions.signals.on('before-action-end', function (arg) {
	    return release(arg, scope);
	  });
	  interactions.signals.on('down', function (arg) {
	    return resume(arg, scope);
	  });
	  interactions.signals.on('stop', __stop_26);
	  defaults.perAction.inertia = {
	    enabled: false,
	    resistance: 10,
	    minSpeed: 100,
	    endSpeed: 10,
	    allowResume: true,
	    smoothEndDuration: 300
	  };
	  scope.usePlugin(___base_26["default"]);
	}
	
	function resume(_ref2, scope) {
	  var interaction = _ref2.interaction,
	      event = _ref2.event,
	      pointer = _ref2.pointer,
	      eventTarget = _ref2.eventTarget;
	  var state = interaction.inertia; // Check if the down event hits the current inertia target
	
	  if (state.active) {
	    var element = eventTarget; // climb up the DOM tree from the event target
	
	    while (__utils_26.is.element(element)) {
	      // if interaction element is the current inertia target element
	      if (element === interaction.element) {
	        // stop inertia
	        ___raf_26["default"].cancel(state.timeout);
	
	        state.active = false;
	        interaction.simulation = null; // update pointers to the down event's coordinates
	
	        interaction.updatePointer(pointer, event, eventTarget, true);
	        __utils_26.pointer.setCoords(interaction.coords.cur, interaction.pointers.map(function (p) {
	          return p.pointer;
	        }), interaction._now()); // fire appropriate signals
	
	        var signalArg = {
	          interaction: interaction,
	          phase: _$InteractEvent_15.EventPhase.Resume
	        };
	        scope.interactions.signals.fire('action-resume', signalArg); // fire a reume event
	
	        var resumeEvent = new scope.InteractEvent(interaction, event, interaction.prepared.name, _$InteractEvent_15.EventPhase.Resume, interaction.element);
	
	        interaction._fireEvent(resumeEvent);
	
	        __utils_26.pointer.copyCoords(interaction.coords.prev, interaction.coords.cur);
	        break;
	      }
	
	      element = __utils_26.dom.parentNode(element);
	    }
	  }
	}
	
	function release(_ref3, scope) {
	  var interaction = _ref3.interaction,
	      event = _ref3.event,
	      noPreEnd = _ref3.noPreEnd;
	  var state = interaction.inertia;
	
	  if (!interaction.interacting() || interaction.simulation && interaction.simulation.active || noPreEnd) {
	    return null;
	  }
	
	  var options = __getOptions_26(interaction);
	
	  var now = interaction._now();
	
	  var velocityClient = interaction.coords.velocity.client;
	  var pointerSpeed = __utils_26.hypot(velocityClient.x, velocityClient.y);
	  var smoothEnd = false;
	  var modifierResult; // check if inertia should be started
	
	  var inertiaPossible = options && options.enabled && interaction.prepared.name !== 'gesture' && event !== state.startEvent;
	  var inertia = inertiaPossible && now - interaction.coords.cur.timeStamp < 50 && pointerSpeed > options.minSpeed && pointerSpeed > options.endSpeed;
	  var modifierArg = {
	    interaction: interaction,
	    pageCoords: interaction.coords.cur.page,
	    states: inertiaPossible && interaction.modifiers.states.map(function (modifierStatus) {
	      return __utils_26.extend({}, modifierStatus);
	    }),
	    preEnd: true,
	    prevCoords: null,
	    requireEndOnly: null,
	    phase: _$InteractEvent_15.EventPhase.InertiaStart
	  }; // smoothEnd
	
	  if (inertiaPossible && !inertia) {
	    modifierArg.prevCoords = interaction.modifiers.result ? interaction.modifiers.result.coords : interaction.prevEvent.page;
	    modifierArg.requireEndOnly = false;
	    modifierResult = ___base_26["default"].setAll(modifierArg);
	
	    if (modifierResult.changed) {
	      smoothEnd = true;
	    }
	  }
	
	  if (!(inertia || smoothEnd)) {
	    return null;
	  }
	
	  __utils_26.pointer.copyCoords(state.upCoords, interaction.coords.cur);
	  (0, ___base_26.setCoords)(modifierArg);
	  interaction.pointers[0].pointer = state.startEvent = new scope.InteractEvent(interaction, event, // FIXME add proper typing Action.name
	  interaction.prepared.name, _$InteractEvent_15.EventPhase.InertiaStart, interaction.element);
	  (0, ___base_26.restoreCoords)(modifierArg);
	  state.t0 = now;
	  state.active = true;
	  state.allowResume = options.allowResume;
	  interaction.simulation = state;
	  interaction.interactable.fire(state.startEvent);
	
	  if (inertia) {
	    state.vx0 = interaction.coords.velocity.client.x;
	    state.vy0 = interaction.coords.velocity.client.y;
	    state.v0 = pointerSpeed;
	    calcInertia(interaction, state);
	    __utils_26.extend(modifierArg.pageCoords, interaction.coords.cur.page);
	    modifierArg.pageCoords.x += state.xe;
	    modifierArg.pageCoords.y += state.ye;
	    modifierArg.prevCoords = null;
	    modifierArg.requireEndOnly = true;
	    modifierResult = ___base_26["default"].setAll(modifierArg);
	    state.modifiedXe += modifierResult.delta.x;
	    state.modifiedYe += modifierResult.delta.y;
	    state.timeout = ___raf_26["default"].request(function () {
	      return inertiaTick(interaction);
	    });
	  } else {
	    state.smoothEnd = true;
	    state.xe = modifierResult.delta.x;
	    state.ye = modifierResult.delta.y;
	    state.sx = state.sy = 0;
	    state.timeout = ___raf_26["default"].request(function () {
	      return smothEndTick(interaction);
	    });
	  }
	
	  return false;
	}
	
	function __stop_26(_ref4) {
	  var interaction = _ref4.interaction;
	  var state = interaction.inertia;
	
	  if (state.active) {
	    ___raf_26["default"].cancel(state.timeout);
	
	    state.active = false;
	    interaction.simulation = null;
	  }
	}
	
	function calcInertia(interaction, state) {
	  var options = __getOptions_26(interaction);
	  var lambda = options.resistance;
	  var inertiaDur = -Math.log(options.endSpeed / state.v0) / lambda;
	  state.x0 = interaction.prevEvent.page.x;
	  state.y0 = interaction.prevEvent.page.y;
	  state.t0 = state.startEvent.timeStamp / 1000;
	  state.sx = state.sy = 0;
	  state.modifiedXe = state.xe = (state.vx0 - inertiaDur) / lambda;
	  state.modifiedYe = state.ye = (state.vy0 - inertiaDur) / lambda;
	  state.te = inertiaDur;
	  state.lambda_v0 = lambda / state.v0;
	  state.one_ve_v0 = 1 - options.endSpeed / state.v0;
	}
	
	function inertiaTick(interaction) {
	  updateInertiaCoords(interaction);
	  __utils_26.pointer.setCoordDeltas(interaction.coords.delta, interaction.coords.prev, interaction.coords.cur);
	  __utils_26.pointer.setCoordVelocity(interaction.coords.velocity, interaction.coords.delta);
	  var state = interaction.inertia;
	  var options = __getOptions_26(interaction);
	  var lambda = options.resistance;
	  var t = interaction._now() / 1000 - state.t0;
	
	  if (t < state.te) {
	    var progress = 1 - (Math.exp(-lambda * t) - state.lambda_v0) / state.one_ve_v0;
	
	    if (state.modifiedXe === state.xe && state.modifiedYe === state.ye) {
	      state.sx = state.xe * progress;
	      state.sy = state.ye * progress;
	    } else {
	      var quadPoint = __utils_26.getQuadraticCurvePoint(0, 0, state.xe, state.ye, state.modifiedXe, state.modifiedYe, progress);
	      state.sx = quadPoint.x;
	      state.sy = quadPoint.y;
	    }
	
	    interaction.move();
	    state.timeout = ___raf_26["default"].request(function () {
	      return inertiaTick(interaction);
	    });
	  } else {
	    state.sx = state.modifiedXe;
	    state.sy = state.modifiedYe;
	    interaction.move();
	    interaction.end(state.startEvent);
	    state.active = false;
	    interaction.simulation = null;
	  }
	
	  __utils_26.pointer.copyCoords(interaction.coords.prev, interaction.coords.cur);
	}
	
	function smothEndTick(interaction) {
	  updateInertiaCoords(interaction);
	  var state = interaction.inertia;
	  var t = interaction._now() - state.t0;
	
	  var _getOptions = __getOptions_26(interaction),
	      duration = _getOptions.smoothEndDuration;
	
	  if (t < duration) {
	    state.sx = __utils_26.easeOutQuad(t, 0, state.xe, duration);
	    state.sy = __utils_26.easeOutQuad(t, 0, state.ye, duration);
	    interaction.move();
	    state.timeout = ___raf_26["default"].request(function () {
	      return smothEndTick(interaction);
	    });
	  } else {
	    state.sx = state.xe;
	    state.sy = state.ye;
	    interaction.move();
	    interaction.end(state.startEvent);
	    state.smoothEnd = state.active = false;
	    interaction.simulation = null;
	  }
	}
	
	function updateInertiaCoords(interaction) {
	  var state = interaction.inertia; // return if inertia isn't running
	
	  if (!state.active) {
	    return;
	  }
	
	  var pageUp = state.upCoords.page;
	  var clientUp = state.upCoords.client;
	  __utils_26.pointer.setCoords(interaction.coords.cur, [{
	    pageX: pageUp.x + state.sx,
	    pageY: pageUp.y + state.sy,
	    clientX: clientUp.x + state.sx,
	    clientY: clientUp.y + state.sy
	  }], interaction._now());
	}
	
	function __getOptions_26(_ref5) {
	  var interactable = _ref5.interactable,
	      prepared = _ref5.prepared;
	  return interactable && interactable.options && prepared.name && interactable.options[prepared.name].inertia;
	}
	
	var ___default_26 = {
	  id: 'inertia',
	  install: __install_26,
	  calcInertia: calcInertia,
	  inertiaTick: inertiaTick,
	  smothEndTick: smothEndTick,
	  updateInertiaCoords: updateInertiaCoords
	};
	_$inertia_26["default"] = ___default_26;
	
	var _$pointer_33 = {};
	"use strict";
	
	Object.defineProperty(_$pointer_33, "__esModule", {
	  value: true
	});
	_$pointer_33["default"] = void 0;
	
	var ___extend_33 = ___interopRequireDefault_33(_$extend_53);
	
	var __is_33 = ___interopRequireWildcard_33(_$is_57);
	
	var ___rect_33 = ___interopRequireDefault_33(_$rect_63);
	
	function ___getRequireWildcardCache_33() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_33 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_33(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_33(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___interopRequireDefault_33(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function __start_33(_ref) {
	  var rect = _ref.rect,
	      startOffset = _ref.startOffset,
	      state = _ref.state,
	      interaction = _ref.interaction,
	      pageCoords = _ref.pageCoords;
	  var options = state.options;
	  var elementRect = options.elementRect;
	  var offset = (0, ___extend_33["default"])({
	    left: 0,
	    top: 0,
	    right: 0,
	    bottom: 0
	  }, options.offset || {});
	
	  if (rect && elementRect) {
	    var restriction = getRestrictionRect(options.restriction, interaction, pageCoords);
	
	    if (restriction) {
	      var widthDiff = restriction.right - restriction.left - rect.width;
	      var heightDiff = restriction.bottom - restriction.top - rect.height;
	
	      if (widthDiff < 0) {
	        offset.left += widthDiff;
	        offset.right += widthDiff;
	      }
	
	      if (heightDiff < 0) {
	        offset.top += heightDiff;
	        offset.bottom += heightDiff;
	      }
	    }
	
	    offset.left += startOffset.left - rect.width * elementRect.left;
	    offset.top += startOffset.top - rect.height * elementRect.top;
	    offset.right += startOffset.right - rect.width * (1 - elementRect.right);
	    offset.bottom += startOffset.bottom - rect.height * (1 - elementRect.bottom);
	  }
	
	  state.offset = offset;
	}
	
	function set(_ref2) {
	  var coords = _ref2.coords,
	      interaction = _ref2.interaction,
	      state = _ref2.state;
	  var options = state.options,
	      offset = state.offset;
	  var restriction = getRestrictionRect(options.restriction, interaction, coords);
	
	  if (!restriction) {
	    return;
	  }
	
	  var rect = ___rect_33["default"].xywhToTlbr(restriction);
	
	  coords.x = Math.max(Math.min(rect.right - offset.right, coords.x), rect.left + offset.left);
	  coords.y = Math.max(Math.min(rect.bottom - offset.bottom, coords.y), rect.top + offset.top);
	}
	
	function getRestrictionRect(value, interaction, coords) {
	  if (__is_33.func(value)) {
	    return ___rect_33["default"].resolveRectLike(value, interaction.interactable, interaction.element, [coords.x, coords.y, interaction]);
	  } else {
	    return ___rect_33["default"].resolveRectLike(value, interaction.interactable, interaction.element);
	  }
	}
	
	var __defaults_33 = {
	  restriction: null,
	  elementRect: null,
	  offset: null,
	  endOnly: false,
	  enabled: false
	};
	var restrict = {
	  start: __start_33,
	  set: set,
	  getRestrictionRect: getRestrictionRect,
	  defaults: __defaults_33
	};
	var ___default_33 = restrict;
	_$pointer_33["default"] = ___default_33;
	
	var _$edges_32 = {};
	"use strict";
	
	Object.defineProperty(_$edges_32, "__esModule", {
	  value: true
	});
	_$edges_32["default"] = void 0;
	
	var ___extend_32 = ___interopRequireDefault_32(_$extend_53);
	
	var ___rect_32 = ___interopRequireDefault_32(_$rect_63);
	
	var _pointer = ___interopRequireDefault_32(_$pointer_33);
	
	function ___interopRequireDefault_32(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// This module adds the options.resize.restrictEdges setting which sets min and
	// max for the top, left, bottom and right edges of the target being resized.
	//
	// interact(target).resize({
	//   edges: { top: true, left: true },
	//   restrictEdges: {
	//     inner: { top: 200, left: 200, right: 400, bottom: 400 },
	//     outer: { top:   0, left:   0, right: 600, bottom: 600 },
	//   },
	// })
	var __getRestrictionRect_32 = _pointer["default"].getRestrictionRect;
	var noInner = {
	  top: +Infinity,
	  left: +Infinity,
	  bottom: -Infinity,
	  right: -Infinity
	};
	var noOuter = {
	  top: -Infinity,
	  left: -Infinity,
	  bottom: +Infinity,
	  right: +Infinity
	};
	
	function __start_32(_ref) {
	  var interaction = _ref.interaction,
	      state = _ref.state;
	  var options = state.options;
	  var startOffset = interaction.modifiers.startOffset;
	  var offset;
	
	  if (options) {
	    var offsetRect = __getRestrictionRect_32(options.offset, interaction, interaction.coords.start.page);
	    offset = ___rect_32["default"].rectToXY(offsetRect);
	  }
	
	  offset = offset || {
	    x: 0,
	    y: 0
	  };
	  state.offset = {
	    top: offset.y + startOffset.top,
	    left: offset.x + startOffset.left,
	    bottom: offset.y - startOffset.bottom,
	    right: offset.x - startOffset.right
	  };
	}
	
	function __set_32(_ref2) {
	  var coords = _ref2.coords,
	      interaction = _ref2.interaction,
	      state = _ref2.state;
	  var offset = state.offset,
	      options = state.options;
	  var edges = interaction.prepared._linkedEdges || interaction.prepared.edges;
	
	  if (!edges) {
	    return;
	  }
	
	  var page = (0, ___extend_32["default"])({}, coords);
	  var inner = __getRestrictionRect_32(options.inner, interaction, page) || {};
	  var outer = __getRestrictionRect_32(options.outer, interaction, page) || {};
	  fixRect(inner, noInner);
	  fixRect(outer, noOuter);
	
	  if (edges.top) {
	    coords.y = Math.min(Math.max(outer.top + offset.top, page.y), inner.top + offset.top);
	  } else if (edges.bottom) {
	    coords.y = Math.max(Math.min(outer.bottom + offset.bottom, page.y), inner.bottom + offset.bottom);
	  }
	
	  if (edges.left) {
	    coords.x = Math.min(Math.max(outer.left + offset.left, page.x), inner.left + offset.left);
	  } else if (edges.right) {
	    coords.x = Math.max(Math.min(outer.right + offset.right, page.x), inner.right + offset.right);
	  }
	}
	
	function fixRect(rect, defaults) {
	  var _arr = ['top', 'left', 'bottom', 'right'];
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    var edge = _arr[_i];
	
	    if (!(edge in rect)) {
	      rect[edge] = defaults[edge];
	    }
	  }
	
	  return rect;
	}
	
	var __defaults_32 = {
	  inner: null,
	  outer: null,
	  offset: null,
	  endOnly: false,
	  enabled: false
	};
	var restrictEdges = {
	  noInner: noInner,
	  noOuter: noOuter,
	  getRestrictionRect: __getRestrictionRect_32,
	  start: __start_32,
	  set: __set_32,
	  defaults: __defaults_32
	};
	var ___default_32 = restrictEdges;
	_$edges_32["default"] = ___default_32;
	
	var _$rect_34 = {};
	"use strict";
	
	Object.defineProperty(_$rect_34, "__esModule", {
	  value: true
	});
	_$rect_34["default"] = void 0;
	
	var ___extend_34 = ___interopRequireDefault_34(_$extend_53);
	
	var ___pointer_34 = ___interopRequireDefault_34(_$pointer_33);
	
	function ___interopRequireDefault_34(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var __defaults_34 = (0, ___extend_34["default"])({
	  get elementRect() {
	    return {
	      top: 0,
	      left: 0,
	      bottom: 1,
	      right: 1
	    };
	  },
	
	  set elementRect(_) {}
	
	}, ___pointer_34["default"].defaults);
	var restrictRect = {
	  start: ___pointer_34["default"].start,
	  set: ___pointer_34["default"].set,
	  defaults: __defaults_34
	};
	var ___default_34 = restrictRect;
	_$rect_34["default"] = ___default_34;
	
	var _$size_35 = {};
	"use strict";
	
	Object.defineProperty(_$size_35, "__esModule", {
	  value: true
	});
	_$size_35["default"] = void 0;
	
	var ___extend_35 = ___interopRequireDefault_35(_$extend_53);
	
	var ___rect_35 = ___interopRequireDefault_35(_$rect_63);
	
	var _edges = ___interopRequireDefault_35(_$edges_32);
	
	function ___interopRequireDefault_35(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var noMin = {
	  width: -Infinity,
	  height: -Infinity
	};
	var noMax = {
	  width: +Infinity,
	  height: +Infinity
	};
	
	function __start_35(arg) {
	  return _edges["default"].start(arg);
	}
	
	function __set_35(arg) {
	  var interaction = arg.interaction,
	      state = arg.state;
	  var options = state.options;
	  var edges = interaction.prepared._linkedEdges || interaction.prepared.edges;
	
	  if (!edges) {
	    return;
	  }
	
	  var rect = ___rect_35["default"].xywhToTlbr(interaction.resizeRects.inverted);
	
	  var minSize = ___rect_35["default"].tlbrToXywh(_edges["default"].getRestrictionRect(options.min, interaction, arg.coords)) || noMin;
	  var maxSize = ___rect_35["default"].tlbrToXywh(_edges["default"].getRestrictionRect(options.max, interaction, arg.coords)) || noMax;
	  state.options = {
	    endOnly: options.endOnly,
	    inner: (0, ___extend_35["default"])({}, _edges["default"].noInner),
	    outer: (0, ___extend_35["default"])({}, _edges["default"].noOuter)
	  };
	
	  if (edges.top) {
	    state.options.inner.top = rect.bottom - minSize.height;
	    state.options.outer.top = rect.bottom - maxSize.height;
	  } else if (edges.bottom) {
	    state.options.inner.bottom = rect.top + minSize.height;
	    state.options.outer.bottom = rect.top + maxSize.height;
	  }
	
	  if (edges.left) {
	    state.options.inner.left = rect.right - minSize.width;
	    state.options.outer.left = rect.right - maxSize.width;
	  } else if (edges.right) {
	    state.options.inner.right = rect.left + minSize.width;
	    state.options.outer.right = rect.left + maxSize.width;
	  }
	
	  _edges["default"].set(arg);
	
	  state.options = options;
	}
	
	var __defaults_35 = {
	  min: null,
	  max: null,
	  endOnly: false,
	  enabled: false
	};
	var restrictSize = {
	  start: __start_35,
	  set: __set_35,
	  defaults: __defaults_35
	};
	var ___default_35 = restrictSize;
	_$size_35["default"] = ___default_35;
	
	var _$pointer_37 = {};
	"use strict";
	
	Object.defineProperty(_$pointer_37, "__esModule", {
	  value: true
	});
	_$pointer_37["default"] = void 0;
	
	var __utils_37 = ___interopRequireWildcard_37(_$utils_56);
	
	function ___getRequireWildcardCache_37() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_37 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_37(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_37(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function __start_37(arg) {
	  var interaction = arg.interaction,
	      interactable = arg.interactable,
	      element = arg.element,
	      rect = arg.rect,
	      state = arg.state,
	      startOffset = arg.startOffset;
	  var options = state.options;
	  var offsets = [];
	  var origin = options.offsetWithOrigin ? getOrigin(arg) : {
	    x: 0,
	    y: 0
	  };
	  var snapOffset;
	
	  if (options.offset === 'startCoords') {
	    snapOffset = {
	      x: interaction.coords.start.page.x,
	      y: interaction.coords.start.page.y
	    };
	  } else {
	    var offsetRect = __utils_37.rect.resolveRectLike(options.offset, interactable, element, [interaction]);
	    snapOffset = __utils_37.rect.rectToXY(offsetRect) || {
	      x: 0,
	      y: 0
	    };
	    snapOffset.x += origin.x;
	    snapOffset.y += origin.y;
	  }
	
	  var relativePoints = options.relativePoints || [];
	
	  if (rect && options.relativePoints && options.relativePoints.length) {
	    for (var index = 0; index < relativePoints.length; index++) {
	      var relativePoint = relativePoints[index];
	      offsets.push({
	        index: index,
	        relativePoint: relativePoint,
	        x: startOffset.left - rect.width * relativePoint.x + snapOffset.x,
	        y: startOffset.top - rect.height * relativePoint.y + snapOffset.y
	      });
	    }
	  } else {
	    offsets.push(__utils_37.extend({
	      index: 0,
	      relativePoint: null
	    }, snapOffset));
	  }
	
	  state.offsets = offsets;
	}
	
	function __set_37(arg) {
	  var interaction = arg.interaction,
	      coords = arg.coords,
	      state = arg.state;
	  var options = state.options,
	      offsets = state.offsets;
	  var origin = __utils_37.getOriginXY(interaction.interactable, interaction.element, interaction.prepared.name);
	  var page = __utils_37.extend({}, coords);
	  var targets = [];
	  var target;
	
	  if (!options.offsetWithOrigin) {
	    page.x -= origin.x;
	    page.y -= origin.y;
	  }
	
	  state.realX = page.x;
	  state.realY = page.y;
	
	  for (var _i = 0; _i < offsets.length; _i++) {
	    var _ref;
	
	    _ref = offsets[_i];
	    var offset = _ref;
	    var relativeX = page.x - offset.x;
	    var relativeY = page.y - offset.y;
	
	    for (var index = 0, _len = options.targets.length; index < _len; index++) {
	      var snapTarget = options.targets[index];
	
	      if (__utils_37.is.func(snapTarget)) {
	        target = snapTarget(relativeX, relativeY, interaction, offset, index);
	      } else {
	        target = snapTarget;
	      }
	
	      if (!target) {
	        continue;
	      }
	
	      targets.push({
	        x: (__utils_37.is.number(target.x) ? target.x : relativeX) + offset.x,
	        y: (__utils_37.is.number(target.y) ? target.y : relativeY) + offset.y,
	        range: __utils_37.is.number(target.range) ? target.range : options.range
	      });
	    }
	  }
	
	  var closest = {
	    target: null,
	    inRange: false,
	    distance: 0,
	    range: 0,
	    dx: 0,
	    dy: 0
	  };
	
	  for (var i = 0, len = targets.length; i < len; i++) {
	    target = targets[i];
	    var range = target.range;
	    var dx = target.x - page.x;
	    var dy = target.y - page.y;
	    var distance = __utils_37.hypot(dx, dy);
	    var inRange = distance <= range; // Infinite targets count as being out of range
	    // compared to non infinite ones that are in range
	
	    if (range === Infinity && closest.inRange && closest.range !== Infinity) {
	      inRange = false;
	    }
	
	    if (!closest.target || (inRange // is the closest target in range?
	    ? closest.inRange && range !== Infinity // the pointer is relatively deeper in this target
	    ? distance / range < closest.distance / closest.range // this target has Infinite range and the closest doesn't
	    : range === Infinity && closest.range !== Infinity || // OR this target is closer that the previous closest
	    distance < closest.distance : // The other is not in range and the pointer is closer to this target
	    !closest.inRange && distance < closest.distance)) {
	      closest.target = target;
	      closest.distance = distance;
	      closest.range = range;
	      closest.inRange = inRange;
	      closest.dx = dx;
	      closest.dy = dy;
	      state.range = range;
	    }
	  }
	
	  if (closest.inRange) {
	    coords.x = closest.target.x;
	    coords.y = closest.target.y;
	  }
	
	  state.closest = closest;
	}
	
	function getOrigin(arg) {
	  var element = arg.interaction.element;
	  var optionsOrigin = __utils_37.rect.rectToXY(__utils_37.rect.resolveRectLike(arg.state.options.origin, null, null, [element]));
	  var origin = optionsOrigin || __utils_37.getOriginXY(arg.interactable, element, arg.interaction.prepared.name);
	  return origin;
	}
	
	var __defaults_37 = {
	  range: Infinity,
	  targets: null,
	  offset: null,
	  offsetWithOrigin: true,
	  origin: null,
	  relativePoints: null,
	  endOnly: false,
	  enabled: false
	};
	var snap = {
	  start: __start_37,
	  set: __set_37,
	  defaults: __defaults_37
	};
	var ___default_37 = snap;
	_$pointer_37["default"] = ___default_37;
	
	var _$size_38 = {};
	"use strict";
	
	Object.defineProperty(_$size_38, "__esModule", {
	  value: true
	});
	_$size_38["default"] = void 0;
	
	var ___extend_38 = ___interopRequireDefault_38(_$extend_53);
	
	var __is_38 = ___interopRequireWildcard_38(_$is_57);
	
	var ___pointer_38 = ___interopRequireDefault_38(_$pointer_37);
	
	function ___getRequireWildcardCache_38() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_38 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_38(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_38(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___interopRequireDefault_38(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___slicedToArray_38(arr, i) { return ___arrayWithHoles_38(arr) || ___iterableToArrayLimit_38(arr, i) || ___nonIterableRest_38(); }
	
	function ___nonIterableRest_38() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function ___iterableToArrayLimit_38(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function ___arrayWithHoles_38(arr) { if (Array.isArray(arr)) return arr; }
	
	function __start_38(arg) {
	  var interaction = arg.interaction,
	      state = arg.state;
	  var options = state.options;
	  var edges = interaction.prepared.edges;
	
	  if (!edges) {
	    return null;
	  }
	
	  arg.state = {
	    options: {
	      targets: null,
	      relativePoints: [{
	        x: edges.left ? 0 : 1,
	        y: edges.top ? 0 : 1
	      }],
	      offset: options.offset || 'self',
	      origin: {
	        x: 0,
	        y: 0
	      },
	      range: options.range
	    }
	  };
	  state.targetFields = state.targetFields || [['width', 'height'], ['x', 'y']];
	
	  ___pointer_38["default"].start(arg);
	
	  state.offsets = arg.state.offsets;
	  arg.state = state;
	}
	
	function __set_38(arg) {
	  var interaction = arg.interaction,
	      state = arg.state,
	      coords = arg.coords;
	  var options = state.options,
	      offsets = state.offsets;
	  var relative = {
	    x: coords.x - offsets[0].x,
	    y: coords.y - offsets[0].y
	  };
	  state.options = (0, ___extend_38["default"])({}, options);
	  state.options.targets = [];
	
	  for (var _i = 0; _i < (options.targets || []).length; _i++) {
	    var _ref;
	
	    _ref = (options.targets || [])[_i];
	    var snapTarget = _ref;
	    var target = void 0;
	
	    if (__is_38.func(snapTarget)) {
	      target = snapTarget(relative.x, relative.y, interaction);
	    } else {
	      target = snapTarget;
	    }
	
	    if (!target) {
	      continue;
	    }
	
	    for (var _i2 = 0; _i2 < state.targetFields.length; _i2++) {
	      var _ref2;
	
	      _ref2 = state.targetFields[_i2];
	
	      var _ref3 = _ref2,
	          _ref4 = ___slicedToArray_38(_ref3, 2),
	          xField = _ref4[0],
	          yField = _ref4[1];
	
	      if (xField in target || yField in target) {
	        target.x = target[xField];
	        target.y = target[yField];
	        break;
	      }
	    }
	
	    state.options.targets.push(target);
	  }
	
	  ___pointer_38["default"].set(arg);
	
	  state.options = options;
	}
	
	var __defaults_38 = {
	  range: Infinity,
	  targets: null,
	  offset: null,
	  endOnly: false,
	  enabled: false
	};
	var snapSize = {
	  start: __start_38,
	  set: __set_38,
	  defaults: __defaults_38
	};
	var ___default_38 = snapSize;
	_$size_38["default"] = ___default_38;
	
	var _$edges_36 = {};
	"use strict";
	
	Object.defineProperty(_$edges_36, "__esModule", {
	  value: true
	});
	_$edges_36["default"] = void 0;
	
	var ___clone_36 = ___interopRequireDefault_36(_$clone_49);
	
	var ___extend_36 = ___interopRequireDefault_36(_$extend_53);
	
	var _size = ___interopRequireDefault_36(_$size_38);
	
	function ___interopRequireDefault_36(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @module modifiers/snapEdges
	 *
	 * @description
	 * This module allows snapping of the edges of targets during resize
	 * interactions.
	 *
	 * @example
	 * interact(target).resizable({
	 *   snapEdges: {
	 *     targets: [interact.snappers.grid({ x: 100, y: 50 })],
	 *   },
	 * })
	 *
	 * interact(target).resizable({
	 *   snapEdges: {
	 *     targets: [
	 *       interact.snappers.grid({
	 *        top: 50,
	 *        left: 50,
	 *        bottom: 100,
	 *        right: 100,
	 *       }),
	 *     ],
	 *   },
	 * })
	 */
	function __start_36(arg) {
	  var edges = arg.interaction.prepared.edges;
	
	  if (!edges) {
	    return null;
	  }
	
	  arg.state.targetFields = arg.state.targetFields || [[edges.left ? 'left' : 'right', edges.top ? 'top' : 'bottom']];
	  return _size["default"].start(arg);
	}
	
	function __set_36(arg) {
	  return _size["default"].set(arg);
	}
	
	var snapEdges = {
	  start: __start_36,
	  set: __set_36,
	  defaults: (0, ___extend_36["default"])((0, ___clone_36["default"])(_size["default"].defaults), {
	    offset: {
	      x: 0,
	      y: 0
	    }
	  })
	};
	var ___default_36 = snapEdges;
	_$edges_36["default"] = ___default_36;
	
	var _$modifiers_31 = {};
	"use strict";
	
	Object.defineProperty(_$modifiers_31, "__esModule", {
	  value: true
	});
	_$modifiers_31.restrictSize = _$modifiers_31.restrictEdges = _$modifiers_31.restrictRect = _$modifiers_31.restrict = _$modifiers_31.snapEdges = _$modifiers_31.snapSize = _$modifiers_31.snap = void 0;
	
	var ___base_31 = ___interopRequireDefault_31(_$base_30);
	
	var ___edges_31 = ___interopRequireDefault_31(_$edges_32);
	
	var ___pointer_31 = ___interopRequireDefault_31(_$pointer_33);
	
	var ___rect_31 = ___interopRequireDefault_31(_$rect_34);
	
	var ___size_31 = ___interopRequireDefault_31(_$size_35);
	
	var _edges2 = ___interopRequireDefault_31(_$edges_36);
	
	var _pointer2 = ___interopRequireDefault_31(_$pointer_37);
	
	var _size2 = ___interopRequireDefault_31(_$size_38);
	
	function ___interopRequireDefault_31(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var __makeModifier_31 = ___base_31["default"].makeModifier;
	var __snap_31 = __makeModifier_31(_pointer2["default"], 'snap');
	_$modifiers_31.snap = __snap_31;
	var __snapSize_31 = __makeModifier_31(_size2["default"], 'snapSize');
	_$modifiers_31.snapSize = __snapSize_31;
	var __snapEdges_31 = __makeModifier_31(_edges2["default"], 'snapEdges');
	_$modifiers_31.snapEdges = __snapEdges_31;
	var __restrict_31 = __makeModifier_31(___pointer_31["default"], 'restrict');
	_$modifiers_31.restrict = __restrict_31;
	var __restrictRect_31 = __makeModifier_31(___rect_31["default"], 'restrictRect');
	_$modifiers_31.restrictRect = __restrictRect_31;
	var __restrictEdges_31 = __makeModifier_31(___edges_31["default"], 'restrictEdges');
	_$modifiers_31.restrictEdges = __restrictEdges_31;
	var __restrictSize_31 = __makeModifier_31(___size_31["default"], 'restrictSize');
	_$modifiers_31.restrictSize = __restrictSize_31;
	
	var _$PointerEvent_39 = {};
	"use strict";
	
	Object.defineProperty(_$PointerEvent_39, "__esModule", {
	  value: true
	});
	_$PointerEvent_39["default"] = void 0;
	
	var ___BaseEvent2_39 = ___interopRequireDefault_39(_$BaseEvent_13);
	
	var ___pointerUtils_39 = ___interopRequireDefault_39(_$pointerUtils_61);
	
	function ___interopRequireDefault_39(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___typeof_39(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ___typeof_39 = function _typeof(obj) { return typeof obj; }; } else { ___typeof_39 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ___typeof_39(obj); }
	
	function ___classCallCheck_39(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ___defineProperties_39(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function ___createClass_39(Constructor, protoProps, staticProps) { if (protoProps) ___defineProperties_39(Constructor.prototype, protoProps); if (staticProps) ___defineProperties_39(Constructor, staticProps); return Constructor; }
	
	function ___possibleConstructorReturn_39(self, call) { if (call && (___typeof_39(call) === "object" || typeof call === "function")) { return call; } return ___assertThisInitialized_39(self); }
	
	function ___getPrototypeOf_39(o) { ___getPrototypeOf_39 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ___getPrototypeOf_39(o); }
	
	function ___assertThisInitialized_39(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function ___inherits_39(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ___setPrototypeOf_39(subClass, superClass); }
	
	function ___setPrototypeOf_39(o, p) { ___setPrototypeOf_39 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ___setPrototypeOf_39(o, p); }
	
	/** */
	var PointerEvent =
	/*#__PURE__*/
	function (_BaseEvent) {
	  ___inherits_39(PointerEvent, _BaseEvent);
	
	  /** */
	  function PointerEvent(type, pointer, event, eventTarget, interaction, timeStamp) {
	    var _this;
	
	    ___classCallCheck_39(this, PointerEvent);
	
	    _this = ___possibleConstructorReturn_39(this, ___getPrototypeOf_39(PointerEvent).call(this, interaction));
	
	    ___pointerUtils_39["default"].pointerExtend(___assertThisInitialized_39(_this), event);
	
	    if (event !== pointer) {
	      ___pointerUtils_39["default"].pointerExtend(___assertThisInitialized_39(_this), pointer);
	    }
	
	    _this.timeStamp = timeStamp;
	    _this.originalEvent = event;
	    _this.type = type;
	    _this.pointerId = ___pointerUtils_39["default"].getPointerId(pointer);
	    _this.pointerType = ___pointerUtils_39["default"].getPointerType(pointer);
	    _this.target = eventTarget;
	    _this.currentTarget = null;
	
	    if (type === 'tap') {
	      var pointerIndex = interaction.getPointerIndex(pointer);
	      _this.dt = _this.timeStamp - interaction.pointers[pointerIndex].downTime;
	      var interval = _this.timeStamp - interaction.tapTime;
	      _this["double"] = !!(interaction.prevTap && interaction.prevTap.type !== 'doubletap' && interaction.prevTap.target === _this.target && interval < 500);
	    } else if (type === 'doubletap') {
	      _this.dt = pointer.timeStamp - interaction.tapTime;
	    }
	
	    return _this;
	  }
	
	  ___createClass_39(PointerEvent, [{
	    key: "_subtractOrigin",
	    value: function _subtractOrigin(_ref) {
	      var originX = _ref.x,
	          originY = _ref.y;
	      this.pageX -= originX;
	      this.pageY -= originY;
	      this.clientX -= originX;
	      this.clientY -= originY;
	      return this;
	    }
	  }, {
	    key: "_addOrigin",
	    value: function _addOrigin(_ref2) {
	      var originX = _ref2.x,
	          originY = _ref2.y;
	      this.pageX += originX;
	      this.pageY += originY;
	      this.clientX += originX;
	      this.clientY += originY;
	      return this;
	    }
	    /**
	     * Prevent the default behaviour of the original Event
	     */
	
	  }, {
	    key: "preventDefault",
	    value: function preventDefault() {
	      this.originalEvent.preventDefault();
	    }
	  }]);
	
	  return PointerEvent;
	}(___BaseEvent2_39["default"]);
	
	_$PointerEvent_39["default"] = PointerEvent;
	
	var _$base_40 = {};
	"use strict";
	
	Object.defineProperty(_$base_40, "__esModule", {
	  value: true
	});
	_$base_40["default"] = void 0;
	
	var __utils_40 = ___interopRequireWildcard_40(_$utils_56);
	
	var _PointerEvent = ___interopRequireDefault_40(_$PointerEvent_39);
	
	function ___interopRequireDefault_40(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_40() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_40 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_40(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_40(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var signals = new __utils_40.Signals();
	var simpleSignals = ['down', 'up', 'cancel'];
	var simpleEvents = ['down', 'up', 'cancel'];
	var __defaults_40 = {
	  holdDuration: 600,
	  ignoreFrom: null,
	  allowFrom: null,
	  origin: {
	    x: 0,
	    y: 0
	  }
	};
	var pointerEvents = {
	  id: 'pointer-events/base',
	  install: __install_40,
	  signals: signals,
	  PointerEvent: _PointerEvent["default"],
	  fire: fire,
	  collectEventTargets: collectEventTargets,
	  createSignalListener: createSignalListener,
	  defaults: __defaults_40,
	  types: ['down', 'move', 'up', 'cancel', 'tap', 'doubletap', 'hold']
	};
	
	function fire(arg, scope) {
	  var interaction = arg.interaction,
	      pointer = arg.pointer,
	      event = arg.event,
	      eventTarget = arg.eventTarget,
	      _arg$type = arg.type,
	      type = _arg$type === void 0 ? arg.pointerEvent.type : _arg$type,
	      _arg$targets = arg.targets,
	      targets = _arg$targets === void 0 ? collectEventTargets(arg) : _arg$targets;
	  var _arg$pointerEvent = arg.pointerEvent,
	      pointerEvent = _arg$pointerEvent === void 0 ? new _PointerEvent["default"](type, pointer, event, eventTarget, interaction, scope.now()) : _arg$pointerEvent;
	  var signalArg = {
	    interaction: interaction,
	    pointer: pointer,
	    event: event,
	    eventTarget: eventTarget,
	    targets: targets,
	    type: type,
	    pointerEvent: pointerEvent
	  };
	
	  for (var i = 0; i < targets.length; i++) {
	    var target = targets[i];
	
	    for (var prop in target.props || {}) {
	      pointerEvent[prop] = target.props[prop];
	    }
	
	    var origin = __utils_40.getOriginXY(target.eventable, target.node);
	
	    pointerEvent._subtractOrigin(origin);
	
	    pointerEvent.eventable = target.eventable;
	    pointerEvent.currentTarget = target.node;
	    target.eventable.fire(pointerEvent);
	
	    pointerEvent._addOrigin(origin);
	
	    if (pointerEvent.immediatePropagationStopped || pointerEvent.propagationStopped && i + 1 < targets.length && targets[i + 1].node !== pointerEvent.currentTarget) {
	      break;
	    }
	  }
	
	  signals.fire('fired', signalArg);
	
	  if (type === 'tap') {
	    // if pointerEvent should make a double tap, create and fire a doubletap
	    // PointerEvent and use that as the prevTap
	    var prevTap = pointerEvent["double"] ? fire({
	      interaction: interaction,
	      pointer: pointer,
	      event: event,
	      eventTarget: eventTarget,
	      type: 'doubletap'
	    }, scope) : pointerEvent;
	    interaction.prevTap = prevTap;
	    interaction.tapTime = prevTap.timeStamp;
	  }
	
	  return pointerEvent;
	}
	
	function collectEventTargets(_ref) {
	  var interaction = _ref.interaction,
	      pointer = _ref.pointer,
	      event = _ref.event,
	      eventTarget = _ref.eventTarget,
	      type = _ref.type;
	  var pointerIndex = interaction.getPointerIndex(pointer);
	  var pointerInfo = interaction.pointers[pointerIndex]; // do not fire a tap event if the pointer was moved before being lifted
	
	  if (type === 'tap' && (interaction.pointerWasMoved || // or if the pointerup target is different to the pointerdown target
	  !(pointerInfo && pointerInfo.downTarget === eventTarget))) {
	    return [];
	  }
	
	  var path = __utils_40.dom.getPath(eventTarget);
	  var signalArg = {
	    interaction: interaction,
	    pointer: pointer,
	    event: event,
	    eventTarget: eventTarget,
	    type: type,
	    path: path,
	    targets: [],
	    node: null
	  };
	
	  for (var _i = 0; _i < path.length; _i++) {
	    var _ref2;
	
	    _ref2 = path[_i];
	    var node = _ref2;
	    signalArg.node = node;
	    signals.fire('collect-targets', signalArg);
	  }
	
	  if (type === 'hold') {
	    signalArg.targets = signalArg.targets.filter(function (target) {
	      return target.eventable.options.holdDuration === interaction.pointers[pointerIndex].hold.duration;
	    });
	  }
	
	  return signalArg.targets;
	}
	
	function __install_40(scope) {
	  var interactions = scope.interactions;
	  scope.pointerEvents = pointerEvents;
	  scope.defaults.actions.pointerEvents = pointerEvents.defaults;
	  interactions.signals.on('new', function (_ref3) {
	    var interaction = _ref3.interaction;
	    interaction.prevTap = null; // the most recent tap event on this interaction
	
	    interaction.tapTime = 0; // time of the most recent tap event
	  });
	  interactions.signals.on('update-pointer', function (_ref4) {
	    var down = _ref4.down,
	        pointerInfo = _ref4.pointerInfo;
	
	    if (!down && pointerInfo.hold) {
	      return;
	    }
	
	    pointerInfo.hold = {
	      duration: Infinity,
	      timeout: null
	    };
	  });
	  interactions.signals.on('move', function (_ref5) {
	    var interaction = _ref5.interaction,
	        pointer = _ref5.pointer,
	        event = _ref5.event,
	        eventTarget = _ref5.eventTarget,
	        duplicateMove = _ref5.duplicateMove;
	    var pointerIndex = interaction.getPointerIndex(pointer);
	
	    if (!duplicateMove && (!interaction.pointerIsDown || interaction.pointerWasMoved)) {
	      if (interaction.pointerIsDown) {
	        clearTimeout(interaction.pointers[pointerIndex].hold.timeout);
	      }
	
	      fire({
	        interaction: interaction,
	        pointer: pointer,
	        event: event,
	        eventTarget: eventTarget,
	        type: 'move'
	      }, scope);
	    }
	  });
	  interactions.signals.on('down', function (_ref6) {
	    var interaction = _ref6.interaction,
	        pointer = _ref6.pointer,
	        event = _ref6.event,
	        eventTarget = _ref6.eventTarget,
	        pointerIndex = _ref6.pointerIndex;
	    var timer = interaction.pointers[pointerIndex].hold;
	    var path = __utils_40.dom.getPath(eventTarget);
	    var signalArg = {
	      interaction: interaction,
	      pointer: pointer,
	      event: event,
	      eventTarget: eventTarget,
	      type: 'hold',
	      targets: [],
	      path: path,
	      node: null
	    };
	
	    for (var _i2 = 0; _i2 < path.length; _i2++) {
	      var _ref7;
	
	      _ref7 = path[_i2];
	      var node = _ref7;
	      signalArg.node = node;
	      signals.fire('collect-targets', signalArg);
	    }
	
	    if (!signalArg.targets.length) {
	      return;
	    }
	
	    var minDuration = Infinity;
	
	    for (var _i3 = 0; _i3 < signalArg.targets.length; _i3++) {
	      var _ref8;
	
	      _ref8 = signalArg.targets[_i3];
	      var target = _ref8;
	      var holdDuration = target.eventable.options.holdDuration;
	
	      if (holdDuration < minDuration) {
	        minDuration = holdDuration;
	      }
	    }
	
	    timer.duration = minDuration;
	    timer.timeout = setTimeout(function () {
	      fire({
	        interaction: interaction,
	        eventTarget: eventTarget,
	        pointer: pointer,
	        event: event,
	        type: 'hold'
	      }, scope);
	    }, minDuration);
	  });
	  var _arr = ['up', 'cancel'];
	
	  for (var _i4 = 0; _i4 < _arr.length; _i4++) {
	    var signalName = _arr[_i4];
	    interactions.signals.on(signalName, function (_ref10) {
	      var interaction = _ref10.interaction,
	          pointerIndex = _ref10.pointerIndex;
	
	      if (interaction.pointers[pointerIndex].hold) {
	        clearTimeout(interaction.pointers[pointerIndex].hold.timeout);
	      }
	    });
	  }
	
	  for (var i = 0; i < simpleSignals.length; i++) {
	    interactions.signals.on(simpleSignals[i], createSignalListener(simpleEvents[i], scope));
	  }
	
	  interactions.signals.on('up', function (_ref9) {
	    var interaction = _ref9.interaction,
	        pointer = _ref9.pointer,
	        event = _ref9.event,
	        eventTarget = _ref9.eventTarget;
	
	    if (!interaction.pointerWasMoved) {
	      fire({
	        interaction: interaction,
	        eventTarget: eventTarget,
	        pointer: pointer,
	        event: event,
	        type: 'tap'
	      }, scope);
	    }
	  });
	}
	
	function createSignalListener(type, scope) {
	  return function (_ref11) {
	    var interaction = _ref11.interaction,
	        pointer = _ref11.pointer,
	        event = _ref11.event,
	        eventTarget = _ref11.eventTarget;
	    fire({
	      interaction: interaction,
	      eventTarget: eventTarget,
	      pointer: pointer,
	      event: event,
	      type: type
	    }, scope);
	  };
	}
	
	var ___default_40 = pointerEvents;
	_$base_40["default"] = ___default_40;
	
	var _$holdRepeat_41 = {};
	"use strict";
	
	Object.defineProperty(_$holdRepeat_41, "__esModule", {
	  value: true
	});
	_$holdRepeat_41["default"] = void 0;
	
	var ___base_41 = ___interopRequireDefault_41(_$base_40);
	
	function ___interopRequireDefault_41(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function __install_41(scope) {
	  var pointerEvents = scope.pointerEvents,
	      interactions = scope.interactions;
	  scope.usePlugin(___base_41["default"]);
	  pointerEvents.signals.on('new', onNew);
	  pointerEvents.signals.on('fired', function (arg) {
	    return onFired(arg, scope);
	  });
	  var _arr = ['move', 'up', 'cancel', 'endall'];
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    var signal = _arr[_i];
	    interactions.signals.on(signal, endHoldRepeat);
	  } // don't repeat by default
	
	
	  pointerEvents.defaults.holdRepeatInterval = 0;
	  pointerEvents.types.push('holdrepeat');
	}
	
	function onNew(_ref) {
	  var pointerEvent = _ref.pointerEvent;
	
	  if (pointerEvent.type !== 'hold') {
	    return;
	  }
	
	  pointerEvent.count = (pointerEvent.count || 0) + 1;
	}
	
	function onFired(_ref2, scope) {
	  var interaction = _ref2.interaction,
	      pointerEvent = _ref2.pointerEvent,
	      eventTarget = _ref2.eventTarget,
	      targets = _ref2.targets;
	
	  if (pointerEvent.type !== 'hold' || !targets.length) {
	    return;
	  } // get the repeat interval from the first eventable
	
	
	  var interval = targets[0].eventable.options.holdRepeatInterval; // don't repeat if the interval is 0 or less
	
	  if (interval <= 0) {
	    return;
	  } // set a timeout to fire the holdrepeat event
	
	
	  interaction.holdIntervalHandle = setTimeout(function () {
	    scope.pointerEvents.fire({
	      interaction: interaction,
	      eventTarget: eventTarget,
	      type: 'hold',
	      pointer: pointerEvent,
	      event: pointerEvent
	    }, scope);
	  }, interval);
	}
	
	function endHoldRepeat(_ref3) {
	  var interaction = _ref3.interaction;
	
	  // set the interaction's holdStopTime property
	  // to stop further holdRepeat events
	  if (interaction.holdIntervalHandle) {
	    clearInterval(interaction.holdIntervalHandle);
	    interaction.holdIntervalHandle = null;
	  }
	}
	
	var ___default_41 = {
	  id: 'pointer-events/holdRepeat',
	  install: __install_41
	};
	_$holdRepeat_41["default"] = ___default_41;
	
	var _$interactableTargets_43 = {};
	"use strict";
	
	Object.defineProperty(_$interactableTargets_43, "__esModule", {
	  value: true
	});
	_$interactableTargets_43["default"] = void 0;
	
	/* removed: var _$arr_47 = require("@interactjs/utils/arr"); */;
	
	var ___extend_43 = ___interopRequireDefault_43(_$extend_53);
	
	function ___interopRequireDefault_43(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function __install_43(scope) {
	  var pointerEvents = scope.pointerEvents,
	      actions = scope.actions,
	      Interactable = scope.Interactable,
	      interactables = scope.interactables;
	  pointerEvents.signals.on('collect-targets', function (_ref) {
	    var targets = _ref.targets,
	        node = _ref.node,
	        type = _ref.type,
	        eventTarget = _ref.eventTarget;
	    scope.interactables.forEachMatch(node, function (interactable) {
	      var eventable = interactable.events;
	      var options = eventable.options;
	
	      if (eventable.types[type] && eventable.types[type].length && interactable.testIgnoreAllow(options, node, eventTarget)) {
	        targets.push({
	          node: node,
	          eventable: eventable,
	          props: {
	            interactable: interactable
	          }
	        });
	      }
	    });
	  });
	  interactables.signals.on('new', function (_ref2) {
	    var interactable = _ref2.interactable;
	
	    interactable.events.getRect = function (element) {
	      return interactable.getRect(element);
	    };
	  });
	  interactables.signals.on('set', function (_ref3) {
	    var interactable = _ref3.interactable,
	        options = _ref3.options;
	    (0, ___extend_43["default"])(interactable.events.options, pointerEvents.defaults);
	    (0, ___extend_43["default"])(interactable.events.options, options.pointerEvents || {});
	  });
	  (0, _$arr_47.merge)(actions.eventTypes, pointerEvents.types);
	  Interactable.prototype.pointerEvents = pointerEventsMethod;
	  var __backCompatOption = Interactable.prototype._backCompatOption;
	
	  Interactable.prototype._backCompatOption = function (optionName, newValue) {
	    var ret = __backCompatOption.call(this, optionName, newValue);
	
	    if (ret === this) {
	      this.events.options[optionName] = newValue;
	    }
	
	    return ret;
	  };
	}
	
	function pointerEventsMethod(options) {
	  (0, ___extend_43["default"])(this.events.options, options);
	  return this;
	}
	
	var ___default_43 = {
	  id: 'pointer-events/interactableTargets',
	  install: __install_43
	};
	_$interactableTargets_43["default"] = ___default_43;
	
	var _$pointerEvents_42 = {};
	"use strict";
	
	Object.defineProperty(_$pointerEvents_42, "__esModule", {
	  value: true
	});
	_$pointerEvents_42.install = __install_42;
	Object.defineProperty(_$pointerEvents_42, "pointerEvents", {
	  enumerable: true,
	  get: function get() {
	    return ___base_42["default"];
	  }
	});
	Object.defineProperty(_$pointerEvents_42, "holdRepeat", {
	  enumerable: true,
	  get: function get() {
	    return _holdRepeat["default"];
	  }
	});
	Object.defineProperty(_$pointerEvents_42, "interactableTargets", {
	  enumerable: true,
	  get: function get() {
	    return _interactableTargets["default"];
	  }
	});
	_$pointerEvents_42.id = void 0;
	
	var ___base_42 = ___interopRequireDefault_42(_$base_40);
	
	var _holdRepeat = ___interopRequireDefault_42(_$holdRepeat_41);
	
	var _interactableTargets = ___interopRequireDefault_42(_$interactableTargets_43);
	
	function ___interopRequireDefault_42(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function __install_42(scope) {
	  scope.usePlugin(___base_42["default"]);
	  scope.usePlugin(_holdRepeat["default"]);
	  scope.usePlugin(_interactableTargets["default"]);
	}
	
	var __id_42 = 'pointer-events';
	_$pointerEvents_42.id = __id_42;
	
	var _$reflow_44 = {};
	"use strict";
	
	Object.defineProperty(_$reflow_44, "__esModule", {
	  value: true
	});
	_$reflow_44.install = __install_44;
	_$reflow_44["default"] = void 0;
	
	/* removed: var _$InteractEvent_15 = require("@interactjs/core/InteractEvent"); */;
	
	/* removed: var _$utils_56 = require("@interactjs/utils"); */;
	
	_$InteractEvent_15.EventPhase.Reflow = 'reflow';
	
	function __install_44(scope) {
	  var actions = scope.actions,
	      interactions = scope.interactions,
	      Interactable = scope.Interactable; // add action reflow event types
	
	  for (var _i = 0; _i < actions.names.length; _i++) {
	    var _ref;
	
	    _ref = actions.names[_i];
	    var actionName = _ref;
	    actions.eventTypes.push("".concat(actionName, "reflow"));
	  } // remove completed reflow interactions
	
	
	  interactions.signals.on('stop', function (_ref2) {
	    var interaction = _ref2.interaction;
	
	    if (interaction.pointerType === _$InteractEvent_15.EventPhase.Reflow) {
	      if (interaction._reflowResolve) {
	        interaction._reflowResolve();
	      }
	
	      _$utils_56.arr.remove(scope.interactions.list, interaction);
	    }
	  });
	  /**
	   * ```js
	   * const interactable = interact(target)
	   * const drag = { name: drag, axis: 'x' }
	   * const resize = { name: resize, edges: { left: true, bottom: true }
	   *
	   * interactable.reflow(drag)
	   * interactable.reflow(resize)
	   * ```
	   *
	   * Start an action sequence to re-apply modifiers, check drops, etc.
	   *
	   * @param { Object } action The action to begin
	   * @param { string } action.name The name of the action
	   * @returns { Promise<Interactable> }
	   */
	
	  Interactable.prototype.reflow = function (action) {
	    return reflow(this, action, scope);
	  };
	}
	
	function reflow(interactable, action, scope) {
	  var elements = _$utils_56.is.string(interactable.target) ? _$utils_56.arr.from(interactable._context.querySelectorAll(interactable.target)) : [interactable.target]; // tslint:disable-next-line variable-name
	
	  var Promise = _$utils_56.win.window.Promise;
	  var promises = Promise ? [] : null;
	
	  var _loop = function _loop() {
	    _ref3 = elements[_i2];
	    var element = _ref3;
	    var rect = interactable.getRect(element);
	
	    if (!rect) {
	      return "break";
	    }
	
	    var runningInteraction = _$utils_56.arr.find(scope.interactions.list, function (interaction) {
	      return interaction.interacting() && interaction.interactable === interactable && interaction.element === element && interaction.prepared.name === action.name;
	    });
	
	    var reflowPromise = void 0;
	
	    if (runningInteraction) {
	      runningInteraction.move();
	
	      if (promises) {
	        reflowPromise = runningInteraction._reflowPromise || new Promise(function (resolve) {
	          runningInteraction._reflowResolve = resolve;
	        });
	      }
	    } else {
	      var xywh = _$utils_56.rect.tlbrToXywh(rect);
	
	      var coords = {
	        page: {
	          x: xywh.x,
	          y: xywh.y
	        },
	        client: {
	          x: xywh.x,
	          y: xywh.y
	        },
	        timeStamp: scope.now()
	      };
	
	      var event = _$utils_56.pointer.coordsToEvent(coords);
	
	      reflowPromise = startReflow(scope, interactable, element, action, event);
	    }
	
	    if (promises) {
	      promises.push(reflowPromise);
	    }
	  };
	
	  for (var _i2 = 0; _i2 < elements.length; _i2++) {
	    var _ref3;
	
	    var _ret = _loop();
	
	    if (_ret === "break") break;
	  }
	
	  return promises && Promise.all(promises).then(function () {
	    return interactable;
	  });
	}
	
	function startReflow(scope, interactable, element, action, event) {
	  var interaction = scope.interactions["new"]({
	    pointerType: 'reflow'
	  });
	  var signalArg = {
	    interaction: interaction,
	    event: event,
	    pointer: event,
	    eventTarget: element,
	    phase: _$InteractEvent_15.EventPhase.Reflow
	  };
	  interaction.interactable = interactable;
	  interaction.element = element;
	  interaction.prepared = (0, _$utils_56.extend)({}, action);
	  interaction.prevEvent = event;
	  interaction.updatePointer(event, event, element, true);
	
	  interaction._doPhase(signalArg);
	
	  var reflowPromise = _$utils_56.win.window.Promise ? new _$utils_56.win.window.Promise(function (resolve) {
	    interaction._reflowResolve = resolve;
	  }) : null;
	  interaction._reflowPromise = reflowPromise;
	  interaction.start(action, interactable, element);
	
	  if (interaction._interacting) {
	    interaction.move(signalArg);
	    interaction.end(event);
	  } else {
	    interaction.stop();
	  }
	
	  interaction.removePointer(event, event);
	  interaction.pointerIsDown = false;
	  return reflowPromise;
	}
	
	var ___default_44 = {
	  id: 'reflow',
	  install: __install_44
	};
	_$reflow_44["default"] = ___default_44;
	
	var _$interact_28 = {};
	"use strict";
	
	Object.defineProperty(_$interact_28, "__esModule", {
	  value: true
	});
	_$interact_28["default"] = _$interact_28.scope = _$interact_28.interact = void 0;
	
	var ___scope_28 = _$scope_24({});
	
	var __utils_28 = ___interopRequireWildcard_28(_$utils_56);
	
	var ___browser_28 = ___interopRequireDefault_28(_$browser_48);
	
	var ___events_28 = ___interopRequireDefault_28(_$events_52);
	
	function ___interopRequireDefault_28(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_28() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_28 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_28(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_28(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	/** @module interact */
	var globalEvents = {};
	var scope = new ___scope_28.Scope();
	/**
	 * ```js
	 * interact('#draggable').draggable(true)
	 *
	 * var rectables = interact('rect')
	 * rectables
	 *   .gesturable(true)
	 *   .on('gesturemove', function (event) {
	 *       // ...
	 *   })
	 * ```
	 *
	 * The methods of this variable can be used to set elements as interactables
	 * and also to change various default settings.
	 *
	 * Calling it as a function and passing an element or a valid CSS selector
	 * string returns an Interactable object which has various methods to configure
	 * it.
	 *
	 * @global
	 *
	 * @param {Element | string} target The HTML or SVG Element to interact with
	 * or CSS selector
	 * @return {Interactable}
	 */
	
	_$interact_28.scope = scope;
	
	var interact = function interact(target, options) {
	  var interactable = scope.interactables.get(target, options);
	
	  if (!interactable) {
	    interactable = scope.interactables["new"](target, options);
	    interactable.events.global = globalEvents;
	  }
	
	  return interactable;
	};
	/**
	 * Use a plugin
	 *
	 * @alias module:interact.use
	 *
	 * @param {Object} plugin
	 * @param {function} plugin.install
	 * @return {interact}
	 */
	
	
	_$interact_28.interact = interact;
	interact.use = use;
	
	function use(plugin, options) {
	  scope.usePlugin(plugin, options);
	  return interact;
	}
	/**
	 * Check if an element or selector has been set with the {@link interact}
	 * function
	 *
	 * @alias module:interact.isSet
	 *
	 * @param {Element} element The Element being searched for
	 * @return {boolean} Indicates if the element or CSS selector was previously
	 * passed to interact
	 */
	
	
	interact.isSet = isSet;
	
	function isSet(target, options) {
	  return !!scope.interactables.get(target, options && options.context);
	}
	/**
	 * Add a global listener for an InteractEvent or adds a DOM event to `document`
	 *
	 * @alias module:interact.on
	 *
	 * @param {string | array | object} type The types of events to listen for
	 * @param {function} listener The function event (s)
	 * @param {object | boolean} [options] object or useCapture flag for
	 * addEventListener
	 * @return {object} interact
	 */
	
	
	interact.on = on;
	
	function on(type, listener, options) {
	  if (__utils_28.is.string(type) && type.search(' ') !== -1) {
	    type = type.trim().split(/ +/);
	  }
	
	  if (__utils_28.is.array(type)) {
	    for (var _i = 0; _i < type.length; _i++) {
	      var _ref;
	
	      _ref = type[_i];
	      var eventType = _ref;
	      interact.on(eventType, listener, options);
	    }
	
	    return interact;
	  }
	
	  if (__utils_28.is.object(type)) {
	    for (var prop in type) {
	      interact.on(prop, type[prop], listener);
	    }
	
	    return interact;
	  } // if it is an InteractEvent type, add listener to globalEvents
	
	
	  if (__utils_28.arr.contains(scope.actions.eventTypes, type)) {
	    // if this type of event was never bound
	    if (!globalEvents[type]) {
	      globalEvents[type] = [listener];
	    } else {
	      globalEvents[type].push(listener);
	    }
	  } // If non InteractEvent type, addEventListener to document
	  else {
	      ___events_28["default"].add(scope.document, type, listener, {
	        options: options
	      });
	    }
	
	  return interact;
	}
	/**
	 * Removes a global InteractEvent listener or DOM event from `document`
	 *
	 * @alias module:interact.off
	 *
	 * @param {string | array | object} type The types of events that were listened
	 * for
	 * @param {function} listener The listener function to be removed
	 * @param {object | boolean} options [options] object or useCapture flag for
	 * removeEventListener
	 * @return {object} interact
	 */
	
	
	interact.off = off;
	
	function off(type, listener, options) {
	  if (__utils_28.is.string(type) && type.search(' ') !== -1) {
	    type = type.trim().split(/ +/);
	  }
	
	  if (__utils_28.is.array(type)) {
	    for (var _i2 = 0; _i2 < type.length; _i2++) {
	      var _ref2;
	
	      _ref2 = type[_i2];
	      var eventType = _ref2;
	      interact.off(eventType, listener, options);
	    }
	
	    return interact;
	  }
	
	  if (__utils_28.is.object(type)) {
	    for (var prop in type) {
	      interact.off(prop, type[prop], listener);
	    }
	
	    return interact;
	  }
	
	  if (!__utils_28.arr.contains(scope.actions.eventTypes, type)) {
	    ___events_28["default"].remove(scope.document, type, listener, options);
	  } else {
	    var index;
	
	    if (type in globalEvents && (index = globalEvents[type].indexOf(listener)) !== -1) {
	      globalEvents[type].splice(index, 1);
	    }
	  }
	
	  return interact;
	}
	/**
	 * Returns an object which exposes internal data
	 * @alias module:interact.debug
	 *
	 * @return {object} An object with properties that outline the current state
	 * and expose internal functions and variables
	 */
	
	
	interact.debug = debug;
	
	function debug() {
	  return scope;
	} // expose the functions used to calculate multi-touch properties
	
	
	interact.getPointerAverage = __utils_28.pointer.pointerAverage;
	interact.getTouchBBox = __utils_28.pointer.touchBBox;
	interact.getTouchDistance = __utils_28.pointer.touchDistance;
	interact.getTouchAngle = __utils_28.pointer.touchAngle;
	interact.getElementRect = __utils_28.dom.getElementRect;
	interact.getElementClientRect = __utils_28.dom.getElementClientRect;
	interact.matchesSelector = __utils_28.dom.matchesSelector;
	interact.closest = __utils_28.dom.closest;
	/**
	 * @alias module:interact.supportsTouch
	 *
	 * @return {boolean} Whether or not the browser supports touch input
	 */
	
	interact.supportsTouch = supportsTouch;
	
	function supportsTouch() {
	  return ___browser_28["default"].supportsTouch;
	}
	/**
	 * @alias module:interact.supportsPointerEvent
	 *
	 * @return {boolean} Whether or not the browser supports PointerEvents
	 */
	
	
	interact.supportsPointerEvent = supportsPointerEvent;
	
	function supportsPointerEvent() {
	  return ___browser_28["default"].supportsPointerEvent;
	}
	/**
	 * Cancels all interactions (end events are not fired)
	 *
	 * @alias module:interact.stop
	 *
	 * @return {object} interact
	 */
	
	
	interact.stop = __stop_28;
	
	function __stop_28() {
	  for (var _i3 = 0; _i3 < scope.interactions.list.length; _i3++) {
	    var _ref3;
	
	    _ref3 = scope.interactions.list[_i3];
	    var interaction = _ref3;
	    interaction.stop();
	  }
	
	  return interact;
	}
	/**
	 * Returns or sets the distance the pointer must be moved before an action
	 * sequence occurs. This also affects tolerance for tap events.
	 *
	 * @alias module:interact.pointerMoveTolerance
	 *
	 * @param {number} [newValue] The movement from the start position must be greater than this value
	 * @return {interact | number}
	 */
	
	
	interact.pointerMoveTolerance = pointerMoveTolerance;
	
	function pointerMoveTolerance(newValue) {
	  if (__utils_28.is.number(newValue)) {
	    scope.interactions.pointerMoveTolerance = newValue;
	    return interact;
	  }
	
	  return scope.interactions.pointerMoveTolerance;
	}
	
	scope.interactables.signals.on('unset', function (_ref4) {
	  var interactable = _ref4.interactable;
	  scope.interactables.list.splice(scope.interactables.list.indexOf(interactable), 1); // Stop related interactions when an Interactable is unset
	
	  for (var _i4 = 0; _i4 < scope.interactions.list.length; _i4++) {
	    var _ref5;
	
	    _ref5 = scope.interactions.list[_i4];
	    var interaction = _ref5;
	
	    if (interaction.interactable === interactable && interaction.interacting() && !interaction._ending) {
	      interaction.stop();
	    }
	  }
	});
	
	interact.addDocument = function (doc, options) {
	  return scope.addDocument(doc, options);
	};
	
	interact.removeDocument = function (doc) {
	  return scope.removeDocument(doc);
	};
	
	scope.interact = interact;
	var ___default_28 = interact;
	_$interact_28["default"] = ___default_28;
	
	var _$interact_27 = {};
	"use strict";
	
	Object.defineProperty(_$interact_27, "__esModule", {
	  value: true
	});
	_$interact_27.init = __init_27;
	Object.defineProperty(_$interact_27, "autoScroll", {
	  enumerable: true,
	  get: function get() {
	    return _autoScroll["default"];
	  }
	});
	Object.defineProperty(_$interact_27, "interactablePreventDefault", {
	  enumerable: true,
	  get: function get() {
	    return _interactablePreventDefault["default"];
	  }
	});
	Object.defineProperty(_$interact_27, "inertia", {
	  enumerable: true,
	  get: function get() {
	    return _inertia["default"];
	  }
	});
	Object.defineProperty(_$interact_27, "modifiers", {
	  enumerable: true,
	  get: function get() {
	    return ___base_27["default"];
	  }
	});
	Object.defineProperty(_$interact_27, "reflow", {
	  enumerable: true,
	  get: function get() {
	    return _reflow["default"];
	  }
	});
	Object.defineProperty(_$interact_27, "interact", {
	  enumerable: true,
	  get: function get() {
	    return _interact["default"];
	  }
	});
	_$interact_27.pointerEvents = _$interact_27.actions = _$interact_27["default"] = void 0;
	
	var actions = ___interopRequireWildcard_27(_$actions_5);
	
	_$interact_27.actions = actions;
	
	var _autoScroll = ___interopRequireDefault_27(_$autoScroll_7);
	
	var autoStart = ___interopRequireWildcard_27(_$autoStart_12);
	
	var _interactablePreventDefault = ___interopRequireDefault_27(_$interactablePreventDefault_21);
	
	var _devTools = ___interopRequireDefault_27(_$devTools_25);
	
	var _inertia = ___interopRequireDefault_27(_$inertia_26);
	
	var modifiers = ___interopRequireWildcard_27(_$modifiers_31);
	
	var ___base_27 = ___interopRequireDefault_27(_$base_30);
	
	var __pointerEvents_27 = ___interopRequireWildcard_27(_$pointerEvents_42);
	
	_$interact_27.pointerEvents = __pointerEvents_27;
	
	var _reflow = ___interopRequireDefault_27(_$reflow_44);
	
	var _interact = ___interopRequireWildcard_27(_$interact_28);
	
	function ___interopRequireDefault_27(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_27() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_27 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_27(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_27(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function __init_27(window) {
	  _interact.scope.init(window);
	
	  _interact["default"].use(_interactablePreventDefault["default"]); // pointerEvents
	
	
	  _interact["default"].use(__pointerEvents_27); // inertia
	
	
	  _interact["default"].use(_inertia["default"]); // autoStart, hold
	
	
	  _interact["default"].use(autoStart); // drag and drop, resize, gesture
	
	
	  _interact["default"].use(actions); // snap, resize, etc.
	
	
	  _interact["default"].use(___base_27["default"]); // for backwrads compatibility
	
	
	  for (var type in modifiers) {
	    var _modifiers$type = modifiers[type],
	        _defaults = _modifiers$type._defaults,
	        _methods = _modifiers$type._methods;
	    _defaults._methods = _methods;
	    _interact.scope.defaults.perAction[type] = _defaults;
	  } // autoScroll
	
	
	  _interact["default"].use(_autoScroll["default"]); // reflow
	
	
	  _interact["default"].use(_reflow["default"]); // eslint-disable-next-line no-undef
	
	
	  if (false) {}
	
	  return _interact["default"];
	} // eslint-disable-next-line no-undef
	
	
	_interact["default"].version = "1.6.3";
	var ___default_27 = _interact["default"];
	_$interact_27["default"] = ___default_27;
	
	var _$types_45 = {};
	/// <reference path="./types.d.ts" />
	"use strict";
	
	var _$grid_64 = {};
	"use strict";
	
	Object.defineProperty(_$grid_64, "__esModule", {
	  value: true
	});
	_$grid_64["default"] = void 0;
	
	function ___slicedToArray_64(arr, i) { return ___arrayWithHoles_64(arr) || ___iterableToArrayLimit_64(arr, i) || ___nonIterableRest_64(); }
	
	function ___nonIterableRest_64() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function ___iterableToArrayLimit_64(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function ___arrayWithHoles_64(arr) { if (Array.isArray(arr)) return arr; }
	
	function createGrid(grid) {
	  var coordFields = [['x', 'y'], ['left', 'top'], ['right', 'bottom'], ['width', 'height']].filter(function (_ref) {
	    var _ref2 = ___slicedToArray_64(_ref, 2),
	        xField = _ref2[0],
	        yField = _ref2[1];
	
	    return xField in grid || yField in grid;
	  });
	  return function (x, y) {
	    var range = grid.range,
	        _grid$limits = grid.limits,
	        limits = _grid$limits === void 0 ? {
	      left: -Infinity,
	      right: Infinity,
	      top: -Infinity,
	      bottom: Infinity
	    } : _grid$limits,
	        _grid$offset = grid.offset,
	        offset = _grid$offset === void 0 ? {
	      x: 0,
	      y: 0
	    } : _grid$offset;
	    var result = {
	      range: range
	    };
	
	    for (var _i2 = 0; _i2 < coordFields.length; _i2++) {
	      var _ref3;
	
	      _ref3 = coordFields[_i2];
	
	      var _ref4 = _ref3,
	          _ref5 = ___slicedToArray_64(_ref4, 2),
	          xField = _ref5[0],
	          yField = _ref5[1];
	
	      var gridx = Math.round((x - offset.x) / grid[xField]);
	      var gridy = Math.round((y - offset.y) / grid[yField]);
	      result[xField] = Math.max(limits.left, Math.min(limits.right, gridx * grid[xField] + offset.x));
	      result[yField] = Math.max(limits.top, Math.min(limits.bottom, gridy * grid[yField] + offset.y));
	    }
	
	    return result;
	  };
	}
	
	var ___default_64 = createGrid;
	_$grid_64["default"] = ___default_64;
	
	var _$snappers_65 = {};
	"use strict";
	
	Object.defineProperty(_$snappers_65, "__esModule", {
	  value: true
	});
	Object.defineProperty(_$snappers_65, "grid", {
	  enumerable: true,
	  get: function get() {
	    return _grid["default"];
	  }
	});
	
	var _grid = ___interopRequireDefault_65(_$grid_64);
	
	function ___interopRequireDefault_65(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _$index_29 = { exports: {} };
	"use strict";
	
	Object.defineProperty(_$index_29.exports, "__esModule", {
	  value: true
	});
	_$index_29.exports.init = __init_29;
	_$index_29.exports["default"] = void 0;
	
	var ___interact_29 = ___interopRequireWildcard_29(_$interact_27);
	
	var __modifiers_29 = ___interopRequireWildcard_29(_$modifiers_31);
	
	_$types_45;
	
	var ___extend_29 = ___interopRequireDefault_29(_$extend_53);
	
	var snappers = ___interopRequireWildcard_29(_$snappers_65);
	
	function ___interopRequireDefault_29(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ___getRequireWildcardCache_29() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); ___getRequireWildcardCache_29 = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function ___interopRequireWildcard_29(obj) { if (obj && obj.__esModule) { return obj; } var cache = ___getRequireWildcardCache_29(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ___typeof_29(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ___typeof_29 = function _typeof(obj) { return typeof obj; }; } else { ___typeof_29 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ___typeof_29(obj); }
	
	if ((typeof window === "undefined" ? "undefined" : ___typeof_29(window)) === 'object' && !!window) {
	  __init_29(window);
	}
	
	function __init_29(win) {
	  (0, ___interact_29.init)(win);
	  return ___interact_29["default"].use({
	    id: 'interactjs',
	    install: function install() {
	      ___interact_29["default"].modifiers = (0, ___extend_29["default"])({}, __modifiers_29);
	      ___interact_29["default"].snappers = snappers;
	      ___interact_29["default"].createSnapGrid = ___interact_29["default"].snappers.grid;
	    }
	  });
	}
	
	var ___default_29 = ___interact_29["default"];
	_$index_29.exports["default"] = ___default_29;
	___interact_29["default"]["default"] = ___interact_29["default"] // tslint:disable-line no-string-literal
	;
	___interact_29["default"].init = __init_29; // tslint:disable-line no-string-literal
	
	if (( false ? undefined : ___typeof_29(_$index_29)) === 'object' && !!_$index_29) {
	  _$index_29.exports = ___interact_29["default"];
	}
	
	_$index_29 = _$index_29.exports
	return _$index_29;
	
	});
	
	
	//# sourceMappingURL=interact.js.map
	
	
	/***/ }),
	
	/***/ "fca0":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__("5ca1");
	var _isFinite = __webpack_require__("7726").isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});
	
	
	/***/ }),
	
	/***/ "fdef":
	/***/ (function(module, exports) {
	
	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';
	
	
	/***/ })
	
	/******/ })["default"];
	//# sourceMappingURL=vue-grid-layout.common.js.map

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-i18n v5.0.3 
	 * (c) 2017 kazuya kawaguchi
	 * Released under the MIT License.
	 */
	'use strict';
	
	/**
	 * warn
	 *
	 * @param {String} msg
	 * @param {Error} [err]
	 *
	 */
	
	function warn (msg, err) {
	  if (window.console) {
	    console.warn('[vue-i18n] ' + msg);
	    if (err) {
	      console.warn(err.stack);
	    }
	  }
	}
	
	var Asset = function (Vue, langVM) {
	  /**
	   * Register or retrieve a global locale definition.
	   *
	   * @param {String} id
	   * @param {Object | Function | Promise} definition
	   * @param {Function} cb
	   */
	
	  Vue.locale = function (id, definition, cb) {
	    if (definition === undefined) { // getter
	      return langVM.locales[id]
	    } else { // setter
	      if (definition === null) {
	        langVM.locales[id] = undefined;
	        delete langVM.locales[id];
	      } else {
	        setLocale(id, definition, function (locale) {
	          if (locale) {
	            langVM.$set(langVM.locales, id, locale);
	          } else {
	            warn('failed set `' + id + '` locale');
	          }
	          cb && cb();
	        });
	      }
	    }
	  };
	};
	
	
	function setLocale (id, definition, cb) {
	  if (typeof definition === 'object') { // sync
	    cb(definition);
	  } else {
	    var future = definition.call(this);
	    if (typeof future === 'function') {
	      if (future.resolved) {
	        // cached
	        cb(future.resolved);
	      } else if (future.requested) {
	        // pool callbacks
	        future.pendingCallbacks.push(cb);
	      } else {
	        future.requested = true;
	        var cbs = future.pendingCallbacks = [cb];
	        future(function (locale) { // resolve
	          future.resolved = locale;
	          for (var i = 0, l = cbs.length; i < l; i++) {
	            cbs[i](locale);
	          }
	        }, function () { // reject
	          cb();
	        });
	      }
	    } else if (isPromise(future)) { // promise
	      future.then(function (locale) { // resolve
	        cb(locale);
	      }, function () { // reject
	        cb();
	      }).catch(function (err) {
	        console.error(err);
	        cb();
	      });
	    }
	  }
	}
	
	/**
	 * Forgiving check for a promise
	 *
	 * @param {Object} p
	 * @return {Boolean}
	 */
	
	function isPromise (p) {
	  return p && typeof p.then === 'function'
	}
	
	var Override = function (Vue, langVM) {
	  // override _init
	  var init = Vue.prototype._init;
	  Vue.prototype._init = function (options) {
	    var this$1 = this;
	
	    init.call(this, options);
	
	    if (!this.$parent) { // root
	      this._$lang = langVM;
	      this._langUnwatch = this._$lang.$watch('$data', function (val, old) {
	        this$1.$forceUpdate();
	      }, { deep: true });
	    }
	  };
	
	  // override _destroy
	  var destroy = Vue.prototype._destroy;
	  Vue.prototype._destroy = function () {
	    if (!this.$parent && this._langUnwatch) {
	      this._langUnwatch();
	      this._langUnwatch = null;
	      this._$lang = null;
	    }
	
	    destroy.apply(this, arguments);
	  };
	};
	
	/**
	 * Observer
	 */
	
	var Watcher;
	/**
	 * getWatcher
	 *
	 * @param {Vue} vm
	 * @return {Watcher}
	 */
	
	function getWatcher (vm) {
	  if (!Watcher) {
	    var unwatch = vm.$watch('__watcher__', function (a) {});
	    Watcher = vm._watchers[0].constructor;
	    unwatch();
	  }
	  return Watcher
	}
	
	var Dep;
	/**
	 * getDep
	 *
	 * @param {Vue} vm
	 * @return {Dep}
	 */
	
	function getDep (vm) {
	  if (!Dep && vm && vm._data && vm._data.__ob__ && vm._data.__ob__.dep) {
	    Dep = vm._data.__ob__.dep.constructor;
	  }
	  return Dep
	}
	
	/**
	 * utilites
	 */
	
	/**
	 * isNil
	 *
	 * @param {*} val
	 * @return Boolean
	 */
	function isNil (val) {
	  return val === null || val === undefined
	}
	
	/**
	 * Simple bind, faster than native
	 *
	 * @param {Function} fn
	 * @param {Object} ctx
	 * @return Function
	 */
	function bind (fn, ctx) {
	  function boundFn (a) {
	    var l = arguments.length;
	    return l
	      ? l > 1
	        ? fn.apply(ctx, arguments)
	        : fn.call(ctx, a)
	      : fn.call(ctx)
	  }
	  // record original fn length
	  boundFn._length = fn.length;
	  return boundFn
	}
	
	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 *
	 * @param {Object} obj
	 * @return Boolean
	 */
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 *
	 * @param {Object} obj
	 * @return Boolean
	 */
	var toString = Object.prototype.toString;
	var OBJECT_STRING = '[object Object]';
	function isPlainObject (obj) {
	  return toString.call(obj) === OBJECT_STRING
	}
	
	/**
	 * Check whether the object has the property.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 * @return Boolean
	 */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn (obj, key) {
	  return hasOwnProperty.call(obj, key)
	}
	
	var fallback; // fallback lang
	var missingHandler = null; // missing handler
	var i18nFormatter = null; // custom formatter
	
	var Config = function (Vue, langVM, lang) {
	  var Watcher = getWatcher(langVM);
	  var Dep = getDep(langVM);
	
	  function makeComputedGetter (getter, owner) {
	    var watcher = new Watcher(owner, getter, null, {
	      lazy: true
	    });
	
	    return function computedGetter () {
	      watcher.dirty && watcher.evaluate();
	      Dep && Dep.target && watcher.depend();
	      return watcher.value
	    }
	  }
	
	  // define Vue.config.lang configration
	  Object.defineProperty(Vue.config, 'lang', {
	    enumerable: true,
	    configurable: true,
	    get: makeComputedGetter(function () { return langVM.lang }, langVM),
	    set: bind(function (val) { langVM.lang = val; }, langVM)
	  });
	
	  // define Vue.config.fallbackLang configration
	  fallback = lang;
	  Object.defineProperty(Vue.config, 'fallbackLang', {
	    enumerable: true,
	    configurable: true,
	    get: function () { return fallback },
	    set: function (val) { fallback = val; }
	  });
	
	  // define Vue.config.missingHandler configration
	  Object.defineProperty(Vue.config, 'missingHandler', {
	    enumerable: true,
	    configurable: true,
	    get: function () { return missingHandler },
	    set: function (val) { missingHandler = val; }
	  });
	
	  // define Vue.config.i18Formatter configration
	  Object.defineProperty(Vue.config, 'i18nFormatter', {
	    enumerable: true,
	    configurable: true,
	    get: function () { return i18nFormatter },
	    set: function (val) { i18nFormatter = val; }
	  });
	};
	
	/**
	 *  String format template
	 *  - Inspired:
	 *    https://github.com/Matt-Esch/string-template/index.js
	 */
	
	var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
	
	
	var Format = function (Vue) {
	  /**
	   * template
	   *
	   * @param {String} string
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  function template (string) {
	    var args = [], len = arguments.length - 1;
	    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
	
	    if (args.length === 1 && typeof args[0] === 'object') {
	      args = args[0];
	    } else {
	      args = {};
	    }
	
	    if (!args || !args.hasOwnProperty) {
	      args = {};
	    }
	
	    return string.replace(RE_NARGS, function (match, prefix, i, index) {
	      var result;
	
	      if (string[index - 1] === '{' &&
	        string[index + match.length] === '}') {
	        return i
	      } else {
	        result = hasOwn(args, i) ? args[i] : match;
	        if (isNil(result)) {
	          return ''
	        }
	
	        return result
	      }
	    })
	  }
	
	  return template
	};
	
	/**
	 *  Path paerser
	 *  - Inspired:
	 *    Vue.js Path parser
	 */
	
	// cache
	var pathCache = Object.create(null);
	
	// actions
	var APPEND = 0;
	var PUSH = 1;
	var INC_SUB_PATH_DEPTH = 2;
	var PUSH_SUB_PATH = 3;
	
	// states
	var BEFORE_PATH = 0;
	var IN_PATH = 1;
	var BEFORE_IDENT = 2;
	var IN_IDENT = 3;
	var IN_SUB_PATH = 4;
	var IN_SINGLE_QUOTE = 5;
	var IN_DOUBLE_QUOTE = 6;
	var AFTER_PATH = 7;
	var ERROR = 8;
	
	var pathStateMachine = [];
	
	pathStateMachine[BEFORE_PATH] = {
	  'ws': [BEFORE_PATH],
	  'ident': [IN_IDENT, APPEND],
	  '[': [IN_SUB_PATH],
	  'eof': [AFTER_PATH]
	};
	
	pathStateMachine[IN_PATH] = {
	  'ws': [IN_PATH],
	  '.': [BEFORE_IDENT],
	  '[': [IN_SUB_PATH],
	  'eof': [AFTER_PATH]
	};
	
	pathStateMachine[BEFORE_IDENT] = {
	  'ws': [BEFORE_IDENT],
	  'ident': [IN_IDENT, APPEND],
	  '0': [IN_IDENT, APPEND],
	  'number': [IN_IDENT, APPEND]
	};
	
	pathStateMachine[IN_IDENT] = {
	  'ident': [IN_IDENT, APPEND],
	  '0': [IN_IDENT, APPEND],
	  'number': [IN_IDENT, APPEND],
	  'ws': [IN_PATH, PUSH],
	  '.': [BEFORE_IDENT, PUSH],
	  '[': [IN_SUB_PATH, PUSH],
	  'eof': [AFTER_PATH, PUSH]
	};
	
	pathStateMachine[IN_SUB_PATH] = {
	  "'": [IN_SINGLE_QUOTE, APPEND],
	  '"': [IN_DOUBLE_QUOTE, APPEND],
	  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
	  ']': [IN_PATH, PUSH_SUB_PATH],
	  'eof': ERROR,
	  'else': [IN_SUB_PATH, APPEND]
	};
	
	pathStateMachine[IN_SINGLE_QUOTE] = {
	  "'": [IN_SUB_PATH, APPEND],
	  'eof': ERROR,
	  'else': [IN_SINGLE_QUOTE, APPEND]
	};
	
	pathStateMachine[IN_DOUBLE_QUOTE] = {
	  '"': [IN_SUB_PATH, APPEND],
	  'eof': ERROR,
	  'else': [IN_DOUBLE_QUOTE, APPEND]
	};
	
	/**
	 * Check if an expression is a literal value.
	 *
	 * @param {String} exp
	 * @return {Boolean}
	 */
	
	var literalValueRE = /^\s?(true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
	function isLiteral (exp) {
	  return literalValueRE.test(exp)
	}
	
	/**
	 * Strip quotes from a string
	 *
	 * @param {String} str
	 * @return {String | false}
	 */
	
	function stripQuotes (str) {
	  var a = str.charCodeAt(0);
	  var b = str.charCodeAt(str.length - 1);
	  return a === b && (a === 0x22 || a === 0x27)
	    ? str.slice(1, -1)
	    : str
	}
	
	/**
	 * Determine the type of a character in a keypath.
	 *
	 * @param {Char} ch
	 * @return {String} type
	 */
	
	function getPathCharType (ch) {
	  if (ch === undefined) { return 'eof' }
	
	  var code = ch.charCodeAt(0);
	
	  switch (code) {
	    case 0x5B: // [
	    case 0x5D: // ]
	    case 0x2E: // .
	    case 0x22: // "
	    case 0x27: // '
	    case 0x30: // 0
	      return ch
	
	    case 0x5F: // _
	    case 0x24: // $
	    case 0x2D: // -
	      return 'ident'
	
	    case 0x20: // Space
	    case 0x09: // Tab
	    case 0x0A: // Newline
	    case 0x0D: // Return
	    case 0xA0:  // No-break space
	    case 0xFEFF:  // Byte Order Mark
	    case 0x2028:  // Line Separator
	    case 0x2029:  // Paragraph Separator
	      return 'ws'
	  }
	
	  // a-z, A-Z
	  if ((code >= 0x61 && code <= 0x7A) || (code >= 0x41 && code <= 0x5A)) {
	    return 'ident'
	  }
	
	  // 1-9
	  if (code >= 0x31 && code <= 0x39) { return 'number' }
	
	  return 'else'
	}
	
	/**
	 * Format a subPath, return its plain form if it is
	 * a literal string or number. Otherwise prepend the
	 * dynamic indicator (*).
	 *
	 * @param {String} path
	 * @return {String}
	 */
	
	function formatSubPath (path) {
	  var trimmed = path.trim();
	  // invalid leading 0
	  if (path.charAt(0) === '0' && isNaN(path)) { return false }
	
	  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
	}
	
	/**
	 * Parse a string path into an array of segments
	 *
	 * @param {String} path
	 * @return {Array|undefined}
	 */
	
	function parse (path) {
	  var keys = [];
	  var index = -1;
	  var mode = BEFORE_PATH;
	  var subPathDepth = 0;
	  var c, newChar, key, type, transition, action, typeMap;
	
	  var actions = [];
	
	  actions[PUSH] = function () {
	    if (key !== undefined) {
	      keys.push(key);
	      key = undefined;
	    }
	  };
	
	  actions[APPEND] = function () {
	    if (key === undefined) {
	      key = newChar;
	    } else {
	      key += newChar;
	    }
	  };
	
	  actions[INC_SUB_PATH_DEPTH] = function () {
	    actions[APPEND]();
	    subPathDepth++;
	  };
	
	  actions[PUSH_SUB_PATH] = function () {
	    if (subPathDepth > 0) {
	      subPathDepth--;
	      mode = IN_SUB_PATH;
	      actions[APPEND]();
	    } else {
	      subPathDepth = 0;
	      key = formatSubPath(key);
	      if (key === false) {
	        return false
	      } else {
	        actions[PUSH]();
	      }
	    }
	  };
	
	  function maybeUnescapeQuote () {
	    var nextChar = path[index + 1];
	    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
	      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
	      index++;
	      newChar = '\\' + nextChar;
	      actions[APPEND]();
	      return true
	    }
	  }
	
	  while (mode != null) {
	    index++;
	    c = path[index];
	
	    if (c === '\\' && maybeUnescapeQuote()) {
	      continue
	    }
	
	    type = getPathCharType(c);
	    typeMap = pathStateMachine[mode];
	    transition = typeMap[type] || typeMap['else'] || ERROR;
	
	    if (transition === ERROR) {
	      return // parse error
	    }
	
	    mode = transition[0];
	    action = actions[transition[1]];
	    if (action) {
	      newChar = transition[2];
	      newChar = newChar === undefined
	        ? c
	        : newChar;
	      if (action() === false) {
	        return
	      }
	    }
	
	    if (mode === AFTER_PATH) {
	      keys.raw = path;
	      return keys
	    }
	  }
	}
	
	/**
	 * External parse that check for a cache hit first
	 *
	 * @param {String} path
	 * @return {Array|undefined}
	 */
	
	function parsePath (path) {
	  var hit = pathCache[path];
	  if (!hit) {
	    hit = parse(path);
	    if (hit) {
	      pathCache[path] = hit;
	    }
	  }
	  return hit
	}
	
	var Path = function (Vue) {
	  function empty (target) {
	    if (target === null || target === undefined) { return true }
	
	    if (Array.isArray(target)) {
	      if (target.length > 0) { return false }
	      if (target.length === 0) { return true }
	    } else if (isPlainObject(target)) {
	      /* eslint-disable prefer-const */
	      for (var key in target) {
	        if (hasOwn(target, key)) { return false }
	      }
	      /* eslint-enable prefer-const */
	    }
	
	    return true
	  }
	
	  /**
	   * Get value from path string
	   *
	   * @param {Object} obj
	   * @param {String} path
	   * @return value
	   */
	
	  function getValue (obj, path) {
	    if (!isObject(obj)) { return null }
	
	    var paths = parsePath(path);
	    if (empty(paths)) { return null }
	
	    var length = paths.length;
	    var ret = null;
	    var last = obj;
	    var i = 0;
	    while (i < length) {
	      var value = last[paths[i]];
	      if (value === undefined) {
	        last = null;
	        break
	      }
	      last = value;
	      i++;
	    }
	
	    ret = last;
	    return ret
	  }
	
	  return getValue
	};
	
	/**
	 * extend
	 *
	 * @param {Vue} Vue
	 * @return {Vue}
	 */
	
	var Extend = function (Vue) {
	  var format = Format(Vue);
	  var getValue = Path(Vue);
	
	  function parseArgs () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var lang = Vue.config.lang;
	    var fallback = Vue.config.fallbackLang;
	
	    if (args.length === 1) {
	      if (isObject(args[0]) || Array.isArray(args[0])) {
	        args = args[0];
	      } else if (typeof args[0] === 'string') {
	        lang = args[0];
	      }
	    } else if (args.length === 2) {
	      if (typeof args[0] === 'string') {
	        lang = args[0];
	      }
	      if (isObject(args[1]) || Array.isArray(args[1])) {
	        args = args[1];
	      }
	    }
	
	    return { lang: lang, fallback: fallback, params: args }
	  }
	
	  function exist (locale, key) {
	    if (!locale || !key) { return false }
	    return !isNil(getValue(locale, key))
	  }
	
	  function interpolate (locale, key, args) {
	    if (!locale) { return null }
	
	    var val = getValue(locale, key);
	    if (Array.isArray(val)) { return val }
	    if (isNil(val)) { val = locale[key]; }
	    if (isNil(val)) { return null }
	    if (typeof val !== 'string') { warn("Value of key '" + key + "' is not a string!"); return null }
	
	    // Check for the existance of links within the translated string
	    if (val.indexOf('@:') >= 0) {
	      // Match all the links within the local
	      // We are going to replace each of
	      // them with its translation
	      var matches = val.match(/(@:[\w|.]+)/g);
	      for (var idx in matches) {
	        var link = matches[idx];
	        // Remove the leading @:
	        var linkPlaceholder = link.substr(2);
	        // Translate the link
	        var translatedstring = interpolate(locale, linkPlaceholder, args);
	        // Replace the link with the translated string
	        val = val.replace(link, translatedstring);
	      }
	    }
	
	    return !args
	      ? val
	      : Vue.config.i18nFormatter
	        ? Vue.config.i18nFormatter.apply(null, [val].concat(args))
	        : format(val, args)
	  }
	
	  function translate (getter, lang, fallback, key, params) {
	    var res = null;
	    res = interpolate(getter(lang), key, params);
	    if (!isNil(res)) { return res }
	
	    res = interpolate(getter(fallback), key, params);
	    if (!isNil(res)) {
	      if (false) {
	        warn('Fall back to translate the keypath "' + key + '" with "' +
	          fallback + '" language.');
	      }
	      return res
	    } else {
	      return null
	    }
	  }
	
	
	  function warnDefault (lang, key, vm, result) {
	    if (!isNil(result)) { return result }
	    if (Vue.config.missingHandler) {
	      Vue.config.missingHandler.apply(null, [lang, key, vm]);
	    } else {
	      if (false) {
	        warn('Cannot translate the value of keypath "' + key + '". ' +
	          'Use the value of keypath as default');
	      }
	    }
	    return key
	  }
	
	  function getAssetLocale (lang) {
	    return Vue.locale(lang)
	  }
	
	  function getComponentLocale (lang) {
	    return this.$options.locales[lang]
	  }
	
	  function getOldChoiceIndexFixed (choice) {
	    return choice ? choice > 1 ? 1 : 0 : 1
	  }
	
	  function getChoiceIndex (choice, choicesLength) {
	    choice = Math.abs(choice);
	
	    if (choicesLength === 2) { return getOldChoiceIndexFixed(choice) }
	
	    return choice ? Math.min(choice, 2) : 0
	  }
	
	  function fetchChoice (locale, choice) {
	    if (!locale && typeof locale !== 'string') { return null }
	    var choices = locale.split('|');
	
	    choice = getChoiceIndex(choice, choices.length);
	    if (!choices[choice]) { return locale }
	    return choices[choice].trim()
	  }
	
	  /**
	   * Vue.t
	   *
	   * @param {String} key
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  Vue.t = function (key) {
	    var args = [], len = arguments.length - 1;
	    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
	
	    if (!key) { return '' }
	    var ref = parseArgs.apply(void 0, args);
	    var lang = ref.lang;
	    var fallback = ref.fallback;
	    var params = ref.params;
	    return warnDefault(lang, key, null, translate(getAssetLocale, lang, fallback, key, params))
	  };
	
	  /**
	   * Vue.tc
	   *
	   * @param {String} key
	   * @param {number|undefined} choice
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  Vue.tc = function (key, choice) {
	    var args = [], len = arguments.length - 2;
	    while ( len-- > 0 ) args[ len ] = arguments[ len + 2 ];
	
	    return fetchChoice(Vue.t.apply(Vue, [ key ].concat( args )), choice)
	  };
	
	  /**
	   * Vue.te
	   *
	   * @param {String} key
	   * @param {Array} ...args
	   * @return {Boolean}
	   */
	
	  Vue.te = function (key) {
	    var args = [], len = arguments.length - 1;
	    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
	
	    var ref = parseArgs.apply(void 0, args);
	    var lang = ref.lang;
	    return exist(getAssetLocale(lang), key)
	  };
	
	  /**
	   * $t
	   *
	   * @param {String} key
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  Vue.prototype.$t = function (key) {
	    var args = [], len = arguments.length - 1;
	    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
	
	    if (!key) { return '' }
	    var ref = parseArgs.apply(void 0, args);
	    var lang = ref.lang;
	    var fallback = ref.fallback;
	    var params = ref.params;
	    var res = null;
	    if (this.$options.locales) {
	      res = translate(
	        bind(getComponentLocale, this), lang, fallback, key, params
	      );
	      if (res) { return res }
	    }
	    return warnDefault(lang, key, this, translate(getAssetLocale, lang, fallback, key, params))
	  };
	
	  /**
	   * $tc
	   *
	   * @param {String} key
	   * @param {number|undefined} choice
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  Vue.prototype.$tc = function (key, choice) {
	    var args = [], len = arguments.length - 2;
	    while ( len-- > 0 ) args[ len ] = arguments[ len + 2 ];
	
	    if (typeof choice !== 'number' && typeof choice !== 'undefined') {
	      return key
	    }
	    return fetchChoice((ref = this).$t.apply(ref, [ key ].concat( args )), choice)
	    var ref;
	  };
	
	  /**
	   * $te
	   *
	   * @param {String} key
	   * @param {Array} ...args
	   * @return {Boolean}
	   *
	   */
	
	  Vue.prototype.$te = function (key) {
	    var args = [], len = arguments.length - 1;
	    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
	
	    var ref = parseArgs.apply(void 0, args);
	    var lang = ref.lang;
	    var found = false;
	    if (this.$options.locales) { // exist component locale
	      found = exist(bind(getComponentLocale)(lang), key);
	    }
	    if (!found) {
	      found = exist(getAssetLocale(lang), key);
	    }
	    return found
	  };
	
	  Vue.mixin({
	    computed: {
	      $lang: function $lang () {
	        return Vue.config.lang
	      }
	    }
	  });
	
	  return Vue
	};
	
	var langVM; // singleton
	
	
	/**
	 * plugin
	 *
	 * @param {Object} Vue
	 * @param {Object} opts
	 */
	
	function plugin (Vue, opts) {
	  if ( opts === void 0 ) opts = {};
	
	  var version = (Vue.version && Number(Vue.version.split('.')[0])) || -1;
	
	  if (false) {
	    warn('already installed.');
	    return
	  }
	
	  if (false) {
	    warn(("vue-i18n (" + (plugin.version) + ") need to use Vue 2.0 or later (Vue: " + (Vue.version) + ")."));
	    return
	  }
	
	  var lang = 'en';
	  setupLangVM(Vue, lang);
	
	  Asset(Vue, langVM);
	  Override(Vue, langVM);
	  Config(Vue, langVM, lang);
	  Extend(Vue);
	}
	
	function setupLangVM (Vue, lang) {
	  var silent = Vue.config.silent;
	  Vue.config.silent = true;
	  if (!langVM) {
	    langVM = new Vue({ data: { lang: lang, locales: {} } });
	  }
	  Vue.config.silent = silent;
	}
	
	plugin.version = '__VERSION__';
	
	if (typeof window !== 'undefined' && window.Vue) {
	  window.Vue.use(plugin);
	}
	
	module.exports = plugin;


/***/ }),
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,o){ true?module.exports=o():"function"==typeof define&&define.amd?define(o):t.VueProgressBar=o()}(this,function(){"use strict";!function(){if("undefined"!=typeof document){var t=document.head||document.getElementsByTagName("head")[0],o=document.createElement("style"),i=" .__cov-progress { opacity: 1; z-index: 999999; } ";o.type="text/css",o.styleSheet?o.styleSheet.cssText=i:o.appendChild(document.createTextNode(i)),t.appendChild(o)}}();var t="undefined"!=typeof window,r={render:function(){var t=this,o=t.$createElement;return(t._self._c||o)("div",{staticClass:"__cov-progress",style:t.style})},staticRenderFns:[],name:"VueProgress",serverCacheKey:function(){return"Progress"},computed:{style:function(){var t=this.progress,o=t.options,i=!!o.show,e=o.location,s={"background-color":o.canSuccess?o.color:o.failedColor,opacity:o.show?1:0,position:o.position};return"top"===e||"bottom"===e?("top"===e?s.top="0px":s.bottom="0px",o.inverse?s.right="0px":s.left="0px",s.width=t.percent+"%",s.height=o.thickness,s.transition=(i?"width "+o.transition.speed+", ":"")+"opacity "+o.transition.opacity):"left"!==e&&"right"!==e||("left"===e?s.left="0px":s.right="0px",o.inverse?s.top="0px":s.bottom="0px",s.height=t.percent+"%",s.width=o.thickness,s.transition=(i?"height "+o.transition.speed+", ":"")+"opacity "+o.transition.opacity),s},progress:function(){return t?window.VueProgressBarEventBus.RADON_LOADING_BAR:{percent:0,options:{canSuccess:!0,show:!1,color:"rgb(19, 91, 55)",failedColor:"red",thickness:"2px",transition:{speed:"0.2s",opacity:"0.6s",termination:300},location:"top",autoRevert:!0,inverse:!1}}}}};return{install:function(o){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},i=(o.version.split(".")[0],"undefined"!=typeof window),e={$vm:null,state:{tFailColor:"",tColor:"",timer:null,cut:0},init:function(t){this.$vm=t},start:function(t){var o=this;this.$vm&&(t||(t=3e3),this.$vm.RADON_LOADING_BAR.percent=0,this.$vm.RADON_LOADING_BAR.options.show=!0,this.$vm.RADON_LOADING_BAR.options.canSuccess=!0,this.state.cut=1e4/Math.floor(t),clearInterval(this.state.timer),this.state.timer=setInterval(function(){o.increase(o.state.cut*Math.random()),95<o.$vm.RADON_LOADING_BAR.percent&&o.$vm.RADON_LOADING_BAR.options.autoFinish&&o.finish()},100))},set:function(t){this.$vm.RADON_LOADING_BAR.options.show=!0,this.$vm.RADON_LOADING_BAR.options.canSuccess=!0,this.$vm.RADON_LOADING_BAR.percent=Math.floor(t)},get:function(){return Math.floor(this.$vm.RADON_LOADING_BAR.percent)},increase:function(t){this.$vm.RADON_LOADING_BAR.percent=Math.min(99,this.$vm.RADON_LOADING_BAR.percent+Math.floor(t))},decrease:function(t){this.$vm.RADON_LOADING_BAR.percent=this.$vm.RADON_LOADING_BAR.percent-Math.floor(t)},hide:function(){var t=this;clearInterval(this.state.timer),this.state.timer=null,setTimeout(function(){t.$vm.RADON_LOADING_BAR.options.show=!1,o.nextTick(function(){setTimeout(function(){t.$vm.RADON_LOADING_BAR.percent=0},100),t.$vm.RADON_LOADING_BAR.options.autoRevert&&setTimeout(function(){t.revert()},300)})},this.$vm.RADON_LOADING_BAR.options.transition.termination)},pause:function(){clearInterval(this.state.timer)},finish:function(){this.$vm&&(this.$vm.RADON_LOADING_BAR.percent=100,this.hide())},fail:function(){this.$vm.RADON_LOADING_BAR.options.canSuccess=!1,this.$vm.RADON_LOADING_BAR.percent=100,this.hide()},setFailColor:function(t){this.$vm.RADON_LOADING_BAR.options.failedColor=t},setColor:function(t){this.$vm.RADON_LOADING_BAR.options.color=t},setLocation:function(t){this.$vm.RADON_LOADING_BAR.options.location=t},setTransition:function(t){this.$vm.RADON_LOADING_BAR.options.transition=t},tempFailColor:function(t){this.state.tFailColor=this.$vm.RADON_LOADING_BAR.options.failedColor,this.$vm.RADON_LOADING_BAR.options.failedColor=t},tempColor:function(t){this.state.tColor=this.$vm.RADON_LOADING_BAR.options.color,this.$vm.RADON_LOADING_BAR.options.color=t},tempLocation:function(t){this.state.tLocation=this.$vm.RADON_LOADING_BAR.options.location,this.$vm.RADON_LOADING_BAR.options.location=t},tempTransition:function(t){this.state.tTransition=this.$vm.RADON_LOADING_BAR.options.transition,this.$vm.RADON_LOADING_BAR.options.transition=t},revertColor:function(){this.$vm.RADON_LOADING_BAR.options.color=this.state.tColor,this.state.tColor=""},revertFailColor:function(){this.$vm.RADON_LOADING_BAR.options.failedColor=this.state.tFailColor,this.state.tFailColor=""},revertLocation:function(){this.$vm.RADON_LOADING_BAR.options.location=this.state.tLocation,this.state.tLocation=""},revertTransition:function(){this.$vm.RADON_LOADING_BAR.options.transition=this.state.tTransition,this.state.tTransition={}},revert:function(){this.$vm.RADON_LOADING_BAR.options.autoRevert&&(this.state.tColor&&this.revertColor(),this.state.tFailColor&&this.revertFailColor(),this.state.tLocation&&this.revertLocation(),!this.state.tTransition||void 0===this.state.tTransition.speed&&void 0===this.state.tTransition.opacity||this.revertTransition())},parseMeta:function(t){for(var o in t.func){var i=t.func[o];switch(i.call){case"color":switch(i.modifier){case"set":this.setColor(i.argument);break;case"temp":this.tempColor(i.argument)}break;case"fail":switch(i.modifier){case"set":this.setFailColor(i.argument);break;case"temp":this.tempFailColor(i.argument)}break;case"location":switch(i.modifier){case"set":this.setLocation(i.argument);break;case"temp":this.tempLocation(i.argument)}break;case"transition":switch(i.modifier){case"set":this.setTransition(i.argument);break;case"temp":this.tempTransition(i.argument)}}}}},s=function(t,o){for(var i,e,s=1;s<arguments.length;++s)for(i in e=arguments[s])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}({canSuccess:!0,show:!1,color:"#73ccec",position:"fixed",failedColor:"red",thickness:"2px",transition:{speed:"0.2s",opacity:"0.6s",termination:300},autoRevert:!0,location:"top",inverse:!1,autoFinish:!0},t),n=new o({data:{RADON_LOADING_BAR:{percent:0,options:s}}});i&&(window.VueProgressBarEventBus=n,e.init(n)),o.component("vue-progress-bar",r),o.prototype.$Progress=e}}});


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	  * vue-router v2.8.1
	  * (c) 2017 Evan You
	  * @license MIT
	  */
	'use strict';
	
	/*  */
	
	function assert (condition, message) {
	  if (!condition) {
	    throw new Error(("[vue-router] " + message))
	  }
	}
	
	function warn (condition, message) {
	  if (false) {
	    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
	  }
	}
	
	function isError (err) {
	  return Object.prototype.toString.call(err).indexOf('Error') > -1
	}
	
	var View = {
	  name: 'router-view',
	  functional: true,
	  props: {
	    name: {
	      type: String,
	      default: 'default'
	    }
	  },
	  render: function render (_, ref) {
	    var props = ref.props;
	    var children = ref.children;
	    var parent = ref.parent;
	    var data = ref.data;
	
	    data.routerView = true;
	
	    // directly use parent context's createElement() function
	    // so that components rendered by router-view can resolve named slots
	    var h = parent.$createElement;
	    var name = props.name;
	    var route = parent.$route;
	    var cache = parent._routerViewCache || (parent._routerViewCache = {});
	
	    // determine current view depth, also check to see if the tree
	    // has been toggled inactive but kept-alive.
	    var depth = 0;
	    var inactive = false;
	    while (parent && parent._routerRoot !== parent) {
	      if (parent.$vnode && parent.$vnode.data.routerView) {
	        depth++;
	      }
	      if (parent._inactive) {
	        inactive = true;
	      }
	      parent = parent.$parent;
	    }
	    data.routerViewDepth = depth;
	
	    // render previous view if the tree is inactive and kept-alive
	    if (inactive) {
	      return h(cache[name], data, children)
	    }
	
	    var matched = route.matched[depth];
	    // render empty node if no matched route
	    if (!matched) {
	      cache[name] = null;
	      return h()
	    }
	
	    var component = cache[name] = matched.components[name];
	
	    // attach instance registration hook
	    // this will be called in the instance's injected lifecycle hooks
	    data.registerRouteInstance = function (vm, val) {
	      // val could be undefined for unregistration
	      var current = matched.instances[name];
	      if (
	        (val && current !== vm) ||
	        (!val && current === vm)
	      ) {
	        matched.instances[name] = val;
	      }
	    }
	
	    // also register instance in prepatch hook
	    // in case the same component instance is reused across different routes
	    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
	      matched.instances[name] = vnode.componentInstance;
	    };
	
	    // resolve props
	    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
	    if (propsToPass) {
	      // clone to prevent mutation
	      propsToPass = data.props = extend({}, propsToPass);
	      // pass non-declared props as attrs
	      var attrs = data.attrs = data.attrs || {};
	      for (var key in propsToPass) {
	        if (!component.props || !(key in component.props)) {
	          attrs[key] = propsToPass[key];
	          delete propsToPass[key];
	        }
	      }
	    }
	
	    return h(component, data, children)
	  }
	};
	
	function resolveProps (route, config) {
	  switch (typeof config) {
	    case 'undefined':
	      return
	    case 'object':
	      return config
	    case 'function':
	      return config(route)
	    case 'boolean':
	      return config ? route.params : undefined
	    default:
	      if (false) {
	        warn(
	          false,
	          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
	          "expecting an object, function or boolean."
	        );
	      }
	  }
	}
	
	function extend (to, from) {
	  for (var key in from) {
	    to[key] = from[key];
	  }
	  return to
	}
	
	/*  */
	
	var encodeReserveRE = /[!'()*]/g;
	var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
	var commaRE = /%2C/g;
	
	// fixed encodeURIComponent which is more conformant to RFC3986:
	// - escapes [!'()*]
	// - preserve commas
	var encode = function (str) { return encodeURIComponent(str)
	  .replace(encodeReserveRE, encodeReserveReplacer)
	  .replace(commaRE, ','); };
	
	var decode = decodeURIComponent;
	
	function resolveQuery (
	  query,
	  extraQuery,
	  _parseQuery
	) {
	  if ( extraQuery === void 0 ) extraQuery = {};
	
	  var parse = _parseQuery || parseQuery;
	  var parsedQuery;
	  try {
	    parsedQuery = parse(query || '');
	  } catch (e) {
	    ("production") !== 'production' && warn(false, e.message);
	    parsedQuery = {};
	  }
	  for (var key in extraQuery) {
	    parsedQuery[key] = extraQuery[key];
	  }
	  return parsedQuery
	}
	
	function parseQuery (query) {
	  var res = {};
	
	  query = query.trim().replace(/^(\?|#|&)/, '');
	
	  if (!query) {
	    return res
	  }
	
	  query.split('&').forEach(function (param) {
	    var parts = param.replace(/\+/g, ' ').split('=');
	    var key = decode(parts.shift());
	    var val = parts.length > 0
	      ? decode(parts.join('='))
	      : null;
	
	    if (res[key] === undefined) {
	      res[key] = val;
	    } else if (Array.isArray(res[key])) {
	      res[key].push(val);
	    } else {
	      res[key] = [res[key], val];
	    }
	  });
	
	  return res
	}
	
	function stringifyQuery (obj) {
	  var res = obj ? Object.keys(obj).map(function (key) {
	    var val = obj[key];
	
	    if (val === undefined) {
	      return ''
	    }
	
	    if (val === null) {
	      return encode(key)
	    }
	
	    if (Array.isArray(val)) {
	      var result = [];
	      val.forEach(function (val2) {
	        if (val2 === undefined) {
	          return
	        }
	        if (val2 === null) {
	          result.push(encode(key));
	        } else {
	          result.push(encode(key) + '=' + encode(val2));
	        }
	      });
	      return result.join('&')
	    }
	
	    return encode(key) + '=' + encode(val)
	  }).filter(function (x) { return x.length > 0; }).join('&') : null;
	  return res ? ("?" + res) : ''
	}
	
	/*  */
	
	
	var trailingSlashRE = /\/?$/;
	
	function createRoute (
	  record,
	  location,
	  redirectedFrom,
	  router
	) {
	  var stringifyQuery$$1 = router && router.options.stringifyQuery;
	
	  var query = location.query || {};
	  try {
	    query = clone(query);
	  } catch (e) {}
	
	  var route = {
	    name: location.name || (record && record.name),
	    meta: (record && record.meta) || {},
	    path: location.path || '/',
	    hash: location.hash || '',
	    query: query,
	    params: location.params || {},
	    fullPath: getFullPath(location, stringifyQuery$$1),
	    matched: record ? formatMatch(record) : []
	  };
	  if (redirectedFrom) {
	    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
	  }
	  return Object.freeze(route)
	}
	
	function clone (value) {
	  if (Array.isArray(value)) {
	    return value.map(clone)
	  } else if (value && typeof value === 'object') {
	    var res = {};
	    for (var key in value) {
	      res[key] = clone(value[key]);
	    }
	    return res
	  } else {
	    return value
	  }
	}
	
	// the starting route that represents the initial state
	var START = createRoute(null, {
	  path: '/'
	});
	
	function formatMatch (record) {
	  var res = [];
	  while (record) {
	    res.unshift(record);
	    record = record.parent;
	  }
	  return res
	}
	
	function getFullPath (
	  ref,
	  _stringifyQuery
	) {
	  var path = ref.path;
	  var query = ref.query; if ( query === void 0 ) query = {};
	  var hash = ref.hash; if ( hash === void 0 ) hash = '';
	
	  var stringify = _stringifyQuery || stringifyQuery;
	  return (path || '/') + stringify(query) + hash
	}
	
	function isSameRoute (a, b) {
	  if (b === START) {
	    return a === b
	  } else if (!b) {
	    return false
	  } else if (a.path && b.path) {
	    return (
	      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query)
	    )
	  } else if (a.name && b.name) {
	    return (
	      a.name === b.name &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query) &&
	      isObjectEqual(a.params, b.params)
	    )
	  } else {
	    return false
	  }
	}
	
	function isObjectEqual (a, b) {
	  if ( a === void 0 ) a = {};
	  if ( b === void 0 ) b = {};
	
	  // handle null value #1566
	  if (!a || !b) { return a === b }
	  var aKeys = Object.keys(a);
	  var bKeys = Object.keys(b);
	  if (aKeys.length !== bKeys.length) {
	    return false
	  }
	  return aKeys.every(function (key) {
	    var aVal = a[key];
	    var bVal = b[key];
	    // check nested equality
	    if (typeof aVal === 'object' && typeof bVal === 'object') {
	      return isObjectEqual(aVal, bVal)
	    }
	    return String(aVal) === String(bVal)
	  })
	}
	
	function isIncludedRoute (current, target) {
	  return (
	    current.path.replace(trailingSlashRE, '/').indexOf(
	      target.path.replace(trailingSlashRE, '/')
	    ) === 0 &&
	    (!target.hash || current.hash === target.hash) &&
	    queryIncludes(current.query, target.query)
	  )
	}
	
	function queryIncludes (current, target) {
	  for (var key in target) {
	    if (!(key in current)) {
	      return false
	    }
	  }
	  return true
	}
	
	/*  */
	
	// work around weird flow bug
	var toTypes = [String, Object];
	var eventTypes = [String, Array];
	
	var Link = {
	  name: 'router-link',
	  props: {
	    to: {
	      type: toTypes,
	      required: true
	    },
	    tag: {
	      type: String,
	      default: 'a'
	    },
	    exact: Boolean,
	    append: Boolean,
	    replace: Boolean,
	    activeClass: String,
	    exactActiveClass: String,
	    event: {
	      type: eventTypes,
	      default: 'click'
	    }
	  },
	  render: function render (h) {
	    var this$1 = this;
	
	    var router = this.$router;
	    var current = this.$route;
	    var ref = router.resolve(this.to, current, this.append);
	    var location = ref.location;
	    var route = ref.route;
	    var href = ref.href;
	
	    var classes = {};
	    var globalActiveClass = router.options.linkActiveClass;
	    var globalExactActiveClass = router.options.linkExactActiveClass;
	    // Support global empty active class
	    var activeClassFallback = globalActiveClass == null
	            ? 'router-link-active'
	            : globalActiveClass;
	    var exactActiveClassFallback = globalExactActiveClass == null
	            ? 'router-link-exact-active'
	            : globalExactActiveClass;
	    var activeClass = this.activeClass == null
	            ? activeClassFallback
	            : this.activeClass;
	    var exactActiveClass = this.exactActiveClass == null
	            ? exactActiveClassFallback
	            : this.exactActiveClass;
	    var compareTarget = location.path
	      ? createRoute(null, location, null, router)
	      : route;
	
	    classes[exactActiveClass] = isSameRoute(current, compareTarget);
	    classes[activeClass] = this.exact
	      ? classes[exactActiveClass]
	      : isIncludedRoute(current, compareTarget);
	
	    var handler = function (e) {
	      if (guardEvent(e)) {
	        if (this$1.replace) {
	          router.replace(location);
	        } else {
	          router.push(location);
	        }
	      }
	    };
	
	    var on = { click: guardEvent };
	    if (Array.isArray(this.event)) {
	      this.event.forEach(function (e) { on[e] = handler; });
	    } else {
	      on[this.event] = handler;
	    }
	
	    var data = {
	      class: classes
	    };
	
	    if (this.tag === 'a') {
	      data.on = on;
	      data.attrs = { href: href };
	    } else {
	      // find the first <a> child and apply listener and href
	      var a = findAnchor(this.$slots.default);
	      if (a) {
	        // in case the <a> is a static node
	        a.isStatic = false;
	        var extend = _Vue.util.extend;
	        var aData = a.data = extend({}, a.data);
	        aData.on = on;
	        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
	        aAttrs.href = href;
	      } else {
	        // doesn't have <a> child, apply listener to self
	        data.on = on;
	      }
	    }
	
	    return h(this.tag, data, this.$slots.default)
	  }
	};
	
	function guardEvent (e) {
	  // don't redirect with control keys
	  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
	  // don't redirect when preventDefault called
	  if (e.defaultPrevented) { return }
	  // don't redirect on right click
	  if (e.button !== undefined && e.button !== 0) { return }
	  // don't redirect if `target="_blank"`
	  if (e.currentTarget && e.currentTarget.getAttribute) {
	    var target = e.currentTarget.getAttribute('target');
	    if (/\b_blank\b/i.test(target)) { return }
	  }
	  // this may be a Weex event which doesn't have this method
	  if (e.preventDefault) {
	    e.preventDefault();
	  }
	  return true
	}
	
	function findAnchor (children) {
	  if (children) {
	    var child;
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      if (child.tag === 'a') {
	        return child
	      }
	      if (child.children && (child = findAnchor(child.children))) {
	        return child
	      }
	    }
	  }
	}
	
	var _Vue;
	
	function install (Vue) {
	  if (install.installed && _Vue === Vue) { return }
	  install.installed = true;
	
	  _Vue = Vue;
	
	  var isDef = function (v) { return v !== undefined; };
	
	  var registerInstance = function (vm, callVal) {
	    var i = vm.$options._parentVnode;
	    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
	      i(vm, callVal);
	    }
	  };
	
	  Vue.mixin({
	    beforeCreate: function beforeCreate () {
	      if (isDef(this.$options.router)) {
	        this._routerRoot = this;
	        this._router = this.$options.router;
	        this._router.init(this);
	        Vue.util.defineReactive(this, '_route', this._router.history.current);
	      } else {
	        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
	      }
	      registerInstance(this, this);
	    },
	    destroyed: function destroyed () {
	      registerInstance(this);
	    }
	  });
	
	  Object.defineProperty(Vue.prototype, '$router', {
	    get: function get () { return this._routerRoot._router }
	  });
	
	  Object.defineProperty(Vue.prototype, '$route', {
	    get: function get () { return this._routerRoot._route }
	  });
	
	  Vue.component('router-view', View);
	  Vue.component('router-link', Link);
	
	  var strats = Vue.config.optionMergeStrategies;
	  // use the same hook merging strategy for route hooks
	  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
	}
	
	/*  */
	
	var inBrowser = typeof window !== 'undefined';
	
	/*  */
	
	function resolvePath (
	  relative,
	  base,
	  append
	) {
	  var firstChar = relative.charAt(0);
	  if (firstChar === '/') {
	    return relative
	  }
	
	  if (firstChar === '?' || firstChar === '#') {
	    return base + relative
	  }
	
	  var stack = base.split('/');
	
	  // remove trailing segment if:
	  // - not appending
	  // - appending to trailing slash (last segment is empty)
	  if (!append || !stack[stack.length - 1]) {
	    stack.pop();
	  }
	
	  // resolve relative path
	  var segments = relative.replace(/^\//, '').split('/');
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	    if (segment === '..') {
	      stack.pop();
	    } else if (segment !== '.') {
	      stack.push(segment);
	    }
	  }
	
	  // ensure leading slash
	  if (stack[0] !== '') {
	    stack.unshift('');
	  }
	
	  return stack.join('/')
	}
	
	function parsePath (path) {
	  var hash = '';
	  var query = '';
	
	  var hashIndex = path.indexOf('#');
	  if (hashIndex >= 0) {
	    hash = path.slice(hashIndex);
	    path = path.slice(0, hashIndex);
	  }
	
	  var queryIndex = path.indexOf('?');
	  if (queryIndex >= 0) {
	    query = path.slice(queryIndex + 1);
	    path = path.slice(0, queryIndex);
	  }
	
	  return {
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function cleanPath (path) {
	  return path.replace(/\/\//g, '/')
	}
	
	var isarray = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};
	
	/**
	 * Expose `pathToRegexp`.
	 */
	var pathToRegexp_1 = pathToRegexp;
	var parse_1 = parse;
	var compile_1 = compile;
	var tokensToFunction_1 = tokensToFunction;
	var tokensToRegExp_1 = tokensToRegExp;
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g');
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = [];
	  var key = 0;
	  var index = 0;
	  var path = '';
	  var defaultDelimiter = options && options.delimiter || '/';
	  var res;
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0];
	    var escaped = res[1];
	    var offset = res.index;
	    path += str.slice(index, offset);
	    index = offset + m.length;
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1];
	      continue
	    }
	
	    var next = str[index];
	    var prefix = res[2];
	    var name = res[3];
	    var capture = res[4];
	    var group = res[5];
	    var modifier = res[6];
	    var asterisk = res[7];
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path);
	      path = '';
	    }
	
	    var partial = prefix != null && next != null && next !== prefix;
	    var repeat = modifier === '+' || modifier === '*';
	    var optional = modifier === '?' || modifier === '*';
	    var delimiter = res[2] || defaultDelimiter;
	    var pattern = capture || group;
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    });
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index);
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path);
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length);
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
	    }
	  }
	
	  return function (obj, opts) {
	    var path = '';
	    var data = obj || {};
	    var options = opts || {};
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i];
	
	      if (typeof token === 'string') {
	        path += token;
	
	        continue
	      }
	
	      var value = data[token.name];
	      var segment;
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix;
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j]);
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment;
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value);
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment;
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys;
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g);
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      });
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = [];
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source);
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  var strict = options.strict;
	  var end = options.end !== false;
	  var route = '';
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (typeof token === 'string') {
	      route += escapeString(token);
	    } else {
	      var prefix = escapeString(token.prefix);
	      var capture = '(?:' + token.pattern + ')';
	
	      keys.push(token);
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*';
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?';
	        } else {
	          capture = prefix + '(' + capture + ')?';
	        }
	      } else {
	        capture = prefix + '(' + capture + ')';
	      }
	
	      route += capture;
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/');
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
	  }
	
	  if (end) {
	    route += '$';
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}
	
	pathToRegexp_1.parse = parse_1;
	pathToRegexp_1.compile = compile_1;
	pathToRegexp_1.tokensToFunction = tokensToFunction_1;
	pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;
	
	/*  */
	
	// $flow-disable-line
	var regexpCompileCache = Object.create(null);
	
	function fillParams (
	  path,
	  params,
	  routeMsg
	) {
	  try {
	    var filler =
	      regexpCompileCache[path] ||
	      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
	    return filler(params || {}, { pretty: true })
	  } catch (e) {
	    if (false) {
	      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
	    }
	    return ''
	  }
	}
	
	/*  */
	
	function createRouteMap (
	  routes,
	  oldPathList,
	  oldPathMap,
	  oldNameMap
	) {
	  // the path list is used to control path matching priority
	  var pathList = oldPathList || [];
	  // $flow-disable-line
	  var pathMap = oldPathMap || Object.create(null);
	  // $flow-disable-line
	  var nameMap = oldNameMap || Object.create(null);
	
	  routes.forEach(function (route) {
	    addRouteRecord(pathList, pathMap, nameMap, route);
	  });
	
	  // ensure wildcard routes are always at the end
	  for (var i = 0, l = pathList.length; i < l; i++) {
	    if (pathList[i] === '*') {
	      pathList.push(pathList.splice(i, 1)[0]);
	      l--;
	      i--;
	    }
	  }
	
	  return {
	    pathList: pathList,
	    pathMap: pathMap,
	    nameMap: nameMap
	  }
	}
	
	function addRouteRecord (
	  pathList,
	  pathMap,
	  nameMap,
	  route,
	  parent,
	  matchAs
	) {
	  var path = route.path;
	  var name = route.name;
	  if (false) {
	    assert(path != null, "\"path\" is required in a route configuration.");
	    assert(
	      typeof route.component !== 'string',
	      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
	      "string id. Use an actual component instead."
	    );
	  }
	
	  var pathToRegexpOptions = route.pathToRegexpOptions || {};
	  var normalizedPath = normalizePath(
	    path,
	    parent,
	    pathToRegexpOptions.strict
	  );
	
	  if (typeof route.caseSensitive === 'boolean') {
	    pathToRegexpOptions.sensitive = route.caseSensitive;
	  }
	
	  var record = {
	    path: normalizedPath,
	    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
	    components: route.components || { default: route.component },
	    instances: {},
	    name: name,
	    parent: parent,
	    matchAs: matchAs,
	    redirect: route.redirect,
	    beforeEnter: route.beforeEnter,
	    meta: route.meta || {},
	    props: route.props == null
	      ? {}
	      : route.components
	        ? route.props
	        : { default: route.props }
	  };
	
	  if (route.children) {
	    // Warn if route is named, does not redirect and has a default child route.
	    // If users navigate to this route by name, the default child will
	    // not be rendered (GH Issue #629)
	    if (false) {
	      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
	        warn(
	          false,
	          "Named Route '" + (route.name) + "' has a default child route. " +
	          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
	          "the default child route will not be rendered. Remove the name from " +
	          "this route and use the name of the default child route for named " +
	          "links instead."
	        );
	      }
	    }
	    route.children.forEach(function (child) {
	      var childMatchAs = matchAs
	        ? cleanPath((matchAs + "/" + (child.path)))
	        : undefined;
	      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
	    });
	  }
	
	  if (route.alias !== undefined) {
	    var aliases = Array.isArray(route.alias)
	      ? route.alias
	      : [route.alias];
	
	    aliases.forEach(function (alias) {
	      var aliasRoute = {
	        path: alias,
	        children: route.children
	      };
	      addRouteRecord(
	        pathList,
	        pathMap,
	        nameMap,
	        aliasRoute,
	        parent,
	        record.path || '/' // matchAs
	      );
	    });
	  }
	
	  if (!pathMap[record.path]) {
	    pathList.push(record.path);
	    pathMap[record.path] = record;
	  }
	
	  if (name) {
	    if (!nameMap[name]) {
	      nameMap[name] = record;
	    } else if (false) {
	      warn(
	        false,
	        "Duplicate named routes definition: " +
	        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
	      );
	    }
	  }
	}
	
	function compileRouteRegex (path, pathToRegexpOptions) {
	  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
	  if (false) {
	    var keys = Object.create(null);
	    regex.keys.forEach(function (key) {
	      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
	      keys[key.name] = true;
	    });
	  }
	  return regex
	}
	
	function normalizePath (path, parent, strict) {
	  if (!strict) { path = path.replace(/\/$/, ''); }
	  if (path[0] === '/') { return path }
	  if (parent == null) { return path }
	  return cleanPath(((parent.path) + "/" + path))
	}
	
	/*  */
	
	
	function normalizeLocation (
	  raw,
	  current,
	  append,
	  router
	) {
	  var next = typeof raw === 'string' ? { path: raw } : raw;
	  // named target
	  if (next.name || next._normalized) {
	    return next
	  }
	
	  // relative params
	  if (!next.path && next.params && current) {
	    next = assign({}, next);
	    next._normalized = true;
	    var params = assign(assign({}, current.params), next.params);
	    if (current.name) {
	      next.name = current.name;
	      next.params = params;
	    } else if (current.matched.length) {
	      var rawPath = current.matched[current.matched.length - 1].path;
	      next.path = fillParams(rawPath, params, ("path " + (current.path)));
	    } else if (false) {
	      warn(false, "relative params navigation requires a current route.");
	    }
	    return next
	  }
	
	  var parsedPath = parsePath(next.path || '');
	  var basePath = (current && current.path) || '/';
	  var path = parsedPath.path
	    ? resolvePath(parsedPath.path, basePath, append || next.append)
	    : basePath;
	
	  var query = resolveQuery(
	    parsedPath.query,
	    next.query,
	    router && router.options.parseQuery
	  );
	
	  var hash = next.hash || parsedPath.hash;
	  if (hash && hash.charAt(0) !== '#') {
	    hash = "#" + hash;
	  }
	
	  return {
	    _normalized: true,
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function assign (a, b) {
	  for (var key in b) {
	    a[key] = b[key];
	  }
	  return a
	}
	
	/*  */
	
	
	function createMatcher (
	  routes,
	  router
	) {
	  var ref = createRouteMap(routes);
	  var pathList = ref.pathList;
	  var pathMap = ref.pathMap;
	  var nameMap = ref.nameMap;
	
	  function addRoutes (routes) {
	    createRouteMap(routes, pathList, pathMap, nameMap);
	  }
	
	  function match (
	    raw,
	    currentRoute,
	    redirectedFrom
	  ) {
	    var location = normalizeLocation(raw, currentRoute, false, router);
	    var name = location.name;
	
	    if (name) {
	      var record = nameMap[name];
	      if (false) {
	        warn(record, ("Route with name '" + name + "' does not exist"));
	      }
	      if (!record) { return _createRoute(null, location) }
	      var paramNames = record.regex.keys
	        .filter(function (key) { return !key.optional; })
	        .map(function (key) { return key.name; });
	
	      if (typeof location.params !== 'object') {
	        location.params = {};
	      }
	
	      if (currentRoute && typeof currentRoute.params === 'object') {
	        for (var key in currentRoute.params) {
	          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
	            location.params[key] = currentRoute.params[key];
	          }
	        }
	      }
	
	      if (record) {
	        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
	        return _createRoute(record, location, redirectedFrom)
	      }
	    } else if (location.path) {
	      location.params = {};
	      for (var i = 0; i < pathList.length; i++) {
	        var path = pathList[i];
	        var record$1 = pathMap[path];
	        if (matchRoute(record$1.regex, location.path, location.params)) {
	          return _createRoute(record$1, location, redirectedFrom)
	        }
	      }
	    }
	    // no match
	    return _createRoute(null, location)
	  }
	
	  function redirect (
	    record,
	    location
	  ) {
	    var originalRedirect = record.redirect;
	    var redirect = typeof originalRedirect === 'function'
	        ? originalRedirect(createRoute(record, location, null, router))
	        : originalRedirect;
	
	    if (typeof redirect === 'string') {
	      redirect = { path: redirect };
	    }
	
	    if (!redirect || typeof redirect !== 'object') {
	      if (false) {
	        warn(
	          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
	        );
	      }
	      return _createRoute(null, location)
	    }
	
	    var re = redirect;
	    var name = re.name;
	    var path = re.path;
	    var query = location.query;
	    var hash = location.hash;
	    var params = location.params;
	    query = re.hasOwnProperty('query') ? re.query : query;
	    hash = re.hasOwnProperty('hash') ? re.hash : hash;
	    params = re.hasOwnProperty('params') ? re.params : params;
	
	    if (name) {
	      // resolved named direct
	      var targetRecord = nameMap[name];
	      if (false) {
	        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
	      }
	      return match({
	        _normalized: true,
	        name: name,
	        query: query,
	        hash: hash,
	        params: params
	      }, undefined, location)
	    } else if (path) {
	      // 1. resolve relative redirect
	      var rawPath = resolveRecordPath(path, record);
	      // 2. resolve params
	      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
	      // 3. rematch with existing query and hash
	      return match({
	        _normalized: true,
	        path: resolvedPath,
	        query: query,
	        hash: hash
	      }, undefined, location)
	    } else {
	      if (false) {
	        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
	      }
	      return _createRoute(null, location)
	    }
	  }
	
	  function alias (
	    record,
	    location,
	    matchAs
	  ) {
	    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
	    var aliasedMatch = match({
	      _normalized: true,
	      path: aliasedPath
	    });
	    if (aliasedMatch) {
	      var matched = aliasedMatch.matched;
	      var aliasedRecord = matched[matched.length - 1];
	      location.params = aliasedMatch.params;
	      return _createRoute(aliasedRecord, location)
	    }
	    return _createRoute(null, location)
	  }
	
	  function _createRoute (
	    record,
	    location,
	    redirectedFrom
	  ) {
	    if (record && record.redirect) {
	      return redirect(record, redirectedFrom || location)
	    }
	    if (record && record.matchAs) {
	      return alias(record, location, record.matchAs)
	    }
	    return createRoute(record, location, redirectedFrom, router)
	  }
	
	  return {
	    match: match,
	    addRoutes: addRoutes
	  }
	}
	
	function matchRoute (
	  regex,
	  path,
	  params
	) {
	  var m = path.match(regex);
	
	  if (!m) {
	    return false
	  } else if (!params) {
	    return true
	  }
	
	  for (var i = 1, len = m.length; i < len; ++i) {
	    var key = regex.keys[i - 1];
	    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
	    if (key) {
	      params[key.name] = val;
	    }
	  }
	
	  return true
	}
	
	function resolveRecordPath (path, record) {
	  return resolvePath(path, record.parent ? record.parent.path : '/', true)
	}
	
	/*  */
	
	
	var positionStore = Object.create(null);
	
	function setupScroll () {
	  // Fix for #1585 for Firefox
	  window.history.replaceState({ key: getStateKey() }, '');
	  window.addEventListener('popstate', function (e) {
	    saveScrollPosition();
	    if (e.state && e.state.key) {
	      setStateKey(e.state.key);
	    }
	  });
	}
	
	function handleScroll (
	  router,
	  to,
	  from,
	  isPop
	) {
	  if (!router.app) {
	    return
	  }
	
	  var behavior = router.options.scrollBehavior;
	  if (!behavior) {
	    return
	  }
	
	  if (false) {
	    assert(typeof behavior === 'function', "scrollBehavior must be a function");
	  }
	
	  // wait until re-render finishes before scrolling
	  router.app.$nextTick(function () {
	    var position = getScrollPosition();
	    var shouldScroll = behavior(to, from, isPop ? position : null);
	
	    if (!shouldScroll) {
	      return
	    }
	
	    if (typeof shouldScroll.then === 'function') {
	      shouldScroll.then(function (shouldScroll) {
	        scrollToPosition((shouldScroll), position);
	      }).catch(function (err) {
	        if (false) {
	          assert(false, err.toString());
	        }
	      });
	    } else {
	      scrollToPosition(shouldScroll, position);
	    }
	  });
	}
	
	function saveScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    positionStore[key] = {
	      x: window.pageXOffset,
	      y: window.pageYOffset
	    };
	  }
	}
	
	function getScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    return positionStore[key]
	  }
	}
	
	function getElementPosition (el, offset) {
	  var docEl = document.documentElement;
	  var docRect = docEl.getBoundingClientRect();
	  var elRect = el.getBoundingClientRect();
	  return {
	    x: elRect.left - docRect.left - offset.x,
	    y: elRect.top - docRect.top - offset.y
	  }
	}
	
	function isValidPosition (obj) {
	  return isNumber(obj.x) || isNumber(obj.y)
	}
	
	function normalizePosition (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
	    y: isNumber(obj.y) ? obj.y : window.pageYOffset
	  }
	}
	
	function normalizeOffset (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : 0,
	    y: isNumber(obj.y) ? obj.y : 0
	  }
	}
	
	function isNumber (v) {
	  return typeof v === 'number'
	}
	
	function scrollToPosition (shouldScroll, position) {
	  var isObject = typeof shouldScroll === 'object';
	  if (isObject && typeof shouldScroll.selector === 'string') {
	    var el = document.querySelector(shouldScroll.selector);
	    if (el) {
	      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
	      offset = normalizeOffset(offset);
	      position = getElementPosition(el, offset);
	    } else if (isValidPosition(shouldScroll)) {
	      position = normalizePosition(shouldScroll);
	    }
	  } else if (isObject && isValidPosition(shouldScroll)) {
	    position = normalizePosition(shouldScroll);
	  }
	
	  if (position) {
	    window.scrollTo(position.x, position.y);
	  }
	}
	
	/*  */
	
	var supportsPushState = inBrowser && (function () {
	  var ua = window.navigator.userAgent;
	
	  if (
	    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
	    ua.indexOf('Mobile Safari') !== -1 &&
	    ua.indexOf('Chrome') === -1 &&
	    ua.indexOf('Windows Phone') === -1
	  ) {
	    return false
	  }
	
	  return window.history && 'pushState' in window.history
	})();
	
	// use User Timing api (if present) for more accurate key precision
	var Time = inBrowser && window.performance && window.performance.now
	  ? window.performance
	  : Date;
	
	var _key = genKey();
	
	function genKey () {
	  return Time.now().toFixed(3)
	}
	
	function getStateKey () {
	  return _key
	}
	
	function setStateKey (key) {
	  _key = key;
	}
	
	function pushState (url, replace) {
	  saveScrollPosition();
	  // try...catch the pushState call to get around Safari
	  // DOM Exception 18 where it limits to 100 pushState calls
	  var history = window.history;
	  try {
	    if (replace) {
	      history.replaceState({ key: _key }, '', url);
	    } else {
	      _key = genKey();
	      history.pushState({ key: _key }, '', url);
	    }
	  } catch (e) {
	    window.location[replace ? 'replace' : 'assign'](url);
	  }
	}
	
	function replaceState (url) {
	  pushState(url, true);
	}
	
	/*  */
	
	function runQueue (queue, fn, cb) {
	  var step = function (index) {
	    if (index >= queue.length) {
	      cb();
	    } else {
	      if (queue[index]) {
	        fn(queue[index], function () {
	          step(index + 1);
	        });
	      } else {
	        step(index + 1);
	      }
	    }
	  };
	  step(0);
	}
	
	/*  */
	
	function resolveAsyncComponents (matched) {
	  return function (to, from, next) {
	    var hasAsync = false;
	    var pending = 0;
	    var error = null;
	
	    flatMapComponents(matched, function (def, _, match, key) {
	      // if it's a function and doesn't have cid attached,
	      // assume it's an async component resolve function.
	      // we are not using Vue's default async resolving mechanism because
	      // we want to halt the navigation until the incoming component has been
	      // resolved.
	      if (typeof def === 'function' && def.cid === undefined) {
	        hasAsync = true;
	        pending++;
	
	        var resolve = once(function (resolvedDef) {
	          if (isESModule(resolvedDef)) {
	            resolvedDef = resolvedDef.default;
	          }
	          // save resolved on async factory in case it's used elsewhere
	          def.resolved = typeof resolvedDef === 'function'
	            ? resolvedDef
	            : _Vue.extend(resolvedDef);
	          match.components[key] = resolvedDef;
	          pending--;
	          if (pending <= 0) {
	            next();
	          }
	        });
	
	        var reject = once(function (reason) {
	          var msg = "Failed to resolve async component " + key + ": " + reason;
	          ("production") !== 'production' && warn(false, msg);
	          if (!error) {
	            error = isError(reason)
	              ? reason
	              : new Error(msg);
	            next(error);
	          }
	        });
	
	        var res;
	        try {
	          res = def(resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        if (res) {
	          if (typeof res.then === 'function') {
	            res.then(resolve, reject);
	          } else {
	            // new syntax in Vue 2.3
	            var comp = res.component;
	            if (comp && typeof comp.then === 'function') {
	              comp.then(resolve, reject);
	            }
	          }
	        }
	      }
	    });
	
	    if (!hasAsync) { next(); }
	  }
	}
	
	function flatMapComponents (
	  matched,
	  fn
	) {
	  return flatten(matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) { return fn(
	      m.components[key],
	      m.instances[key],
	      m, key
	    ); })
	  }))
	}
	
	function flatten (arr) {
	  return Array.prototype.concat.apply([], arr)
	}
	
	var hasSymbol =
	  typeof Symbol === 'function' &&
	  typeof Symbol.toStringTag === 'symbol';
	
	function isESModule (obj) {
	  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
	}
	
	// in Webpack 2, require.ensure now also returns a Promise
	// so the resolve/reject functions may get called an extra time
	// if the user uses an arrow function shorthand that happens to
	// return that Promise.
	function once (fn) {
	  var called = false;
	  return function () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    if (called) { return }
	    called = true;
	    return fn.apply(this, args)
	  }
	}
	
	/*  */
	
	var History = function History (router, base) {
	  this.router = router;
	  this.base = normalizeBase(base);
	  // start with a route object that stands for "nowhere"
	  this.current = START;
	  this.pending = null;
	  this.ready = false;
	  this.readyCbs = [];
	  this.readyErrorCbs = [];
	  this.errorCbs = [];
	};
	
	History.prototype.listen = function listen (cb) {
	  this.cb = cb;
	};
	
	History.prototype.onReady = function onReady (cb, errorCb) {
	  if (this.ready) {
	    cb();
	  } else {
	    this.readyCbs.push(cb);
	    if (errorCb) {
	      this.readyErrorCbs.push(errorCb);
	    }
	  }
	};
	
	History.prototype.onError = function onError (errorCb) {
	  this.errorCbs.push(errorCb);
	};
	
	History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
	    var this$1 = this;
	
	  var route = this.router.match(location, this.current);
	  this.confirmTransition(route, function () {
	    this$1.updateRoute(route);
	    onComplete && onComplete(route);
	    this$1.ensureURL();
	
	    // fire ready cbs once
	    if (!this$1.ready) {
	      this$1.ready = true;
	      this$1.readyCbs.forEach(function (cb) { cb(route); });
	    }
	  }, function (err) {
	    if (onAbort) {
	      onAbort(err);
	    }
	    if (err && !this$1.ready) {
	      this$1.ready = true;
	      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
	    }
	  });
	};
	
	History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
	    var this$1 = this;
	
	  var current = this.current;
	  var abort = function (err) {
	    if (isError(err)) {
	      if (this$1.errorCbs.length) {
	        this$1.errorCbs.forEach(function (cb) { cb(err); });
	      } else {
	        warn(false, 'uncaught error during route navigation:');
	        console.error(err);
	      }
	    }
	    onAbort && onAbort(err);
	  };
	  if (
	    isSameRoute(route, current) &&
	    // in the case the route map has been dynamically appended to
	    route.matched.length === current.matched.length
	  ) {
	    this.ensureURL();
	    return abort()
	  }
	
	  var ref = resolveQueue(this.current.matched, route.matched);
	    var updated = ref.updated;
	    var deactivated = ref.deactivated;
	    var activated = ref.activated;
	
	  var queue = [].concat(
	    // in-component leave guards
	    extractLeaveGuards(deactivated),
	    // global before hooks
	    this.router.beforeHooks,
	    // in-component update hooks
	    extractUpdateHooks(updated),
	    // in-config enter guards
	    activated.map(function (m) { return m.beforeEnter; }),
	    // async components
	    resolveAsyncComponents(activated)
	  );
	
	  this.pending = route;
	  var iterator = function (hook, next) {
	    if (this$1.pending !== route) {
	      return abort()
	    }
	    try {
	      hook(route, current, function (to) {
	        if (to === false || isError(to)) {
	          // next(false) -> abort navigation, ensure current URL
	          this$1.ensureURL(true);
	          abort(to);
	        } else if (
	          typeof to === 'string' ||
	          (typeof to === 'object' && (
	            typeof to.path === 'string' ||
	            typeof to.name === 'string'
	          ))
	        ) {
	          // next('/') or next({ path: '/' }) -> redirect
	          abort();
	          if (typeof to === 'object' && to.replace) {
	            this$1.replace(to);
	          } else {
	            this$1.push(to);
	          }
	        } else {
	          // confirm transition and pass on the value
	          next(to);
	        }
	      });
	    } catch (e) {
	      abort(e);
	    }
	  };
	
	  runQueue(queue, iterator, function () {
	    var postEnterCbs = [];
	    var isValid = function () { return this$1.current === route; };
	    // wait until async components are resolved before
	    // extracting in-component enter guards
	    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
	    var queue = enterGuards.concat(this$1.router.resolveHooks);
	    runQueue(queue, iterator, function () {
	      if (this$1.pending !== route) {
	        return abort()
	      }
	      this$1.pending = null;
	      onComplete(route);
	      if (this$1.router.app) {
	        this$1.router.app.$nextTick(function () {
	          postEnterCbs.forEach(function (cb) { cb(); });
	        });
	      }
	    });
	  });
	};
	
	History.prototype.updateRoute = function updateRoute (route) {
	  var prev = this.current;
	  this.current = route;
	  this.cb && this.cb(route);
	  this.router.afterHooks.forEach(function (hook) {
	    hook && hook(route, prev);
	  });
	};
	
	function normalizeBase (base) {
	  if (!base) {
	    if (inBrowser) {
	      // respect <base> tag
	      var baseEl = document.querySelector('base');
	      base = (baseEl && baseEl.getAttribute('href')) || '/';
	      // strip full URL origin
	      base = base.replace(/^https?:\/\/[^\/]+/, '');
	    } else {
	      base = '/';
	    }
	  }
	  // make sure there's the starting slash
	  if (base.charAt(0) !== '/') {
	    base = '/' + base;
	  }
	  // remove trailing slash
	  return base.replace(/\/$/, '')
	}
	
	function resolveQueue (
	  current,
	  next
	) {
	  var i;
	  var max = Math.max(current.length, next.length);
	  for (i = 0; i < max; i++) {
	    if (current[i] !== next[i]) {
	      break
	    }
	  }
	  return {
	    updated: next.slice(0, i),
	    activated: next.slice(i),
	    deactivated: current.slice(i)
	  }
	}
	
	function extractGuards (
	  records,
	  name,
	  bind,
	  reverse
	) {
	  var guards = flatMapComponents(records, function (def, instance, match, key) {
	    var guard = extractGuard(def, name);
	    if (guard) {
	      return Array.isArray(guard)
	        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
	        : bind(guard, instance, match, key)
	    }
	  });
	  return flatten(reverse ? guards.reverse() : guards)
	}
	
	function extractGuard (
	  def,
	  key
	) {
	  if (typeof def !== 'function') {
	    // extend now so that global mixins are applied.
	    def = _Vue.extend(def);
	  }
	  return def.options[key]
	}
	
	function extractLeaveGuards (deactivated) {
	  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
	}
	
	function extractUpdateHooks (updated) {
	  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
	}
	
	function bindGuard (guard, instance) {
	  if (instance) {
	    return function boundRouteGuard () {
	      return guard.apply(instance, arguments)
	    }
	  }
	}
	
	function extractEnterGuards (
	  activated,
	  cbs,
	  isValid
	) {
	  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
	    return bindEnterGuard(guard, match, key, cbs, isValid)
	  })
	}
	
	function bindEnterGuard (
	  guard,
	  match,
	  key,
	  cbs,
	  isValid
	) {
	  return function routeEnterGuard (to, from, next) {
	    return guard(to, from, function (cb) {
	      next(cb);
	      if (typeof cb === 'function') {
	        cbs.push(function () {
	          // #750
	          // if a router-view is wrapped with an out-in transition,
	          // the instance may not have been registered at this time.
	          // we will need to poll for registration until current route
	          // is no longer valid.
	          poll(cb, match.instances, key, isValid);
	        });
	      }
	    })
	  }
	}
	
	function poll (
	  cb, // somehow flow cannot infer this is a function
	  instances,
	  key,
	  isValid
	) {
	  if (instances[key]) {
	    cb(instances[key]);
	  } else if (isValid()) {
	    setTimeout(function () {
	      poll(cb, instances, key, isValid);
	    }, 16);
	  }
	}
	
	/*  */
	
	
	var HTML5History = (function (History$$1) {
	  function HTML5History (router, base) {
	    var this$1 = this;
	
	    History$$1.call(this, router, base);
	
	    var expectScroll = router.options.scrollBehavior;
	
	    if (expectScroll) {
	      setupScroll();
	    }
	
	    var initLocation = getLocation(this.base);
	    window.addEventListener('popstate', function (e) {
	      var current = this$1.current;
	
	      // Avoiding first `popstate` event dispatched in some browsers but first
	      // history route not updated since async guard at the same time.
	      var location = getLocation(this$1.base);
	      if (this$1.current === START && location === initLocation) {
	        return
	      }
	
	      this$1.transitionTo(location, function (route) {
	        if (expectScroll) {
	          handleScroll(router, route, current, true);
	        }
	      });
	    });
	  }
	
	  if ( History$$1 ) HTML5History.__proto__ = History$$1;
	  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
	  HTML5History.prototype.constructor = HTML5History;
	
	  HTML5History.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.ensureURL = function ensureURL (push) {
	    if (getLocation(this.base) !== this.current.fullPath) {
	      var current = cleanPath(this.base + this.current.fullPath);
	      push ? pushState(current) : replaceState(current);
	    }
	  };
	
	  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getLocation(this.base)
	  };
	
	  return HTML5History;
	}(History));
	
	function getLocation (base) {
	  var path = window.location.pathname;
	  if (base && path.indexOf(base) === 0) {
	    path = path.slice(base.length);
	  }
	  return (path || '/') + window.location.search + window.location.hash
	}
	
	/*  */
	
	
	var HashHistory = (function (History$$1) {
	  function HashHistory (router, base, fallback) {
	    History$$1.call(this, router, base);
	    // check history fallback deeplinking
	    if (fallback && checkFallback(this.base)) {
	      return
	    }
	    ensureSlash();
	  }
	
	  if ( History$$1 ) HashHistory.__proto__ = History$$1;
	  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  HashHistory.prototype.constructor = HashHistory;
	
	  // this is delayed until the app mounts
	  // to avoid the hashchange listener being fired too early
	  HashHistory.prototype.setupListeners = function setupListeners () {
	    var this$1 = this;
	
	    var router = this.router;
	    var expectScroll = router.options.scrollBehavior;
	    var supportsScroll = supportsPushState && expectScroll;
	
	    if (supportsScroll) {
	      setupScroll();
	    }
	
	    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
	      var current = this$1.current;
	      if (!ensureSlash()) {
	        return
	      }
	      this$1.transitionTo(getHash(), function (route) {
	        if (supportsScroll) {
	          handleScroll(this$1.router, route, current, true);
	        }
	        if (!supportsPushState) {
	          replaceHash(route.fullPath);
	        }
	      });
	    });
	  };
	
	  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HashHistory.prototype.ensureURL = function ensureURL (push) {
	    var current = this.current.fullPath;
	    if (getHash() !== current) {
	      push ? pushHash(current) : replaceHash(current);
	    }
	  };
	
	  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getHash()
	  };
	
	  return HashHistory;
	}(History));
	
	function checkFallback (base) {
	  var location = getLocation(base);
	  if (!/^\/#/.test(location)) {
	    window.location.replace(
	      cleanPath(base + '/#' + location)
	    );
	    return true
	  }
	}
	
	function ensureSlash () {
	  var path = getHash();
	  if (path.charAt(0) === '/') {
	    return true
	  }
	  replaceHash('/' + path);
	  return false
	}
	
	function getHash () {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var index = href.indexOf('#');
	  return index === -1 ? '' : href.slice(index + 1)
	}
	
	function getUrl (path) {
	  var href = window.location.href;
	  var i = href.indexOf('#');
	  var base = i >= 0 ? href.slice(0, i) : href;
	  return (base + "#" + path)
	}
	
	function pushHash (path) {
	  if (supportsPushState) {
	    pushState(getUrl(path));
	  } else {
	    window.location.hash = path;
	  }
	}
	
	function replaceHash (path) {
	  if (supportsPushState) {
	    replaceState(getUrl(path));
	  } else {
	    window.location.replace(getUrl(path));
	  }
	}
	
	/*  */
	
	
	var AbstractHistory = (function (History$$1) {
	  function AbstractHistory (router, base) {
	    History$$1.call(this, router, base);
	    this.stack = [];
	    this.index = -1;
	  }
	
	  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
	  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  AbstractHistory.prototype.constructor = AbstractHistory;
	
	  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
	      this$1.index++;
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.go = function go (n) {
	    var this$1 = this;
	
	    var targetIndex = this.index + n;
	    if (targetIndex < 0 || targetIndex >= this.stack.length) {
	      return
	    }
	    var route = this.stack[targetIndex];
	    this.confirmTransition(route, function () {
	      this$1.index = targetIndex;
	      this$1.updateRoute(route);
	    });
	  };
	
	  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    var current = this.stack[this.stack.length - 1];
	    return current ? current.fullPath : '/'
	  };
	
	  AbstractHistory.prototype.ensureURL = function ensureURL () {
	    // noop
	  };
	
	  return AbstractHistory;
	}(History));
	
	/*  */
	
	var VueRouter = function VueRouter (options) {
	  if ( options === void 0 ) options = {};
	
	  this.app = null;
	  this.apps = [];
	  this.options = options;
	  this.beforeHooks = [];
	  this.resolveHooks = [];
	  this.afterHooks = [];
	  this.matcher = createMatcher(options.routes || [], this);
	
	  var mode = options.mode || 'hash';
	  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
	  if (this.fallback) {
	    mode = 'hash';
	  }
	  if (!inBrowser) {
	    mode = 'abstract';
	  }
	  this.mode = mode;
	
	  switch (mode) {
	    case 'history':
	      this.history = new HTML5History(this, options.base);
	      break
	    case 'hash':
	      this.history = new HashHistory(this, options.base, this.fallback);
	      break
	    case 'abstract':
	      this.history = new AbstractHistory(this, options.base);
	      break
	    default:
	      if (false) {
	        assert(false, ("invalid mode: " + mode));
	      }
	  }
	};
	
	var prototypeAccessors = { currentRoute: { configurable: true } };
	
	VueRouter.prototype.match = function match (
	  raw,
	  current,
	  redirectedFrom
	) {
	  return this.matcher.match(raw, current, redirectedFrom)
	};
	
	prototypeAccessors.currentRoute.get = function () {
	  return this.history && this.history.current
	};
	
	VueRouter.prototype.init = function init (app /* Vue component instance */) {
	    var this$1 = this;
	
	  ("production") !== 'production' && assert(
	    install.installed,
	    "not installed. Make sure to call `Vue.use(VueRouter)` " +
	    "before creating root instance."
	  );
	
	  this.apps.push(app);
	
	  // main app already initialized.
	  if (this.app) {
	    return
	  }
	
	  this.app = app;
	
	  var history = this.history;
	
	  if (history instanceof HTML5History) {
	    history.transitionTo(history.getCurrentLocation());
	  } else if (history instanceof HashHistory) {
	    var setupHashListener = function () {
	      history.setupListeners();
	    };
	    history.transitionTo(
	      history.getCurrentLocation(),
	      setupHashListener,
	      setupHashListener
	    );
	  }
	
	  history.listen(function (route) {
	    this$1.apps.forEach(function (app) {
	      app._route = route;
	    });
	  });
	};
	
	VueRouter.prototype.beforeEach = function beforeEach (fn) {
	  return registerHook(this.beforeHooks, fn)
	};
	
	VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
	  return registerHook(this.resolveHooks, fn)
	};
	
	VueRouter.prototype.afterEach = function afterEach (fn) {
	  return registerHook(this.afterHooks, fn)
	};
	
	VueRouter.prototype.onReady = function onReady (cb, errorCb) {
	  this.history.onReady(cb, errorCb);
	};
	
	VueRouter.prototype.onError = function onError (errorCb) {
	  this.history.onError(errorCb);
	};
	
	VueRouter.prototype.push = function push (location, onComplete, onAbort) {
	  this.history.push(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
	  this.history.replace(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.go = function go (n) {
	  this.history.go(n);
	};
	
	VueRouter.prototype.back = function back () {
	  this.go(-1);
	};
	
	VueRouter.prototype.forward = function forward () {
	  this.go(1);
	};
	
	VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
	  var route = to
	    ? to.matched
	      ? to
	      : this.resolve(to).route
	    : this.currentRoute;
	  if (!route) {
	    return []
	  }
	  return [].concat.apply([], route.matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) {
	      return m.components[key]
	    })
	  }))
	};
	
	VueRouter.prototype.resolve = function resolve (
	  to,
	  current,
	  append
	) {
	  var location = normalizeLocation(
	    to,
	    current || this.history.current,
	    append,
	    this
	  );
	  var route = this.match(location, current);
	  var fullPath = route.redirectedFrom || route.fullPath;
	  var base = this.history.base;
	  var href = createHref(base, fullPath, this.mode);
	  return {
	    location: location,
	    route: route,
	    href: href,
	    // for backwards compat
	    normalizedTo: location,
	    resolved: route
	  }
	};
	
	VueRouter.prototype.addRoutes = function addRoutes (routes) {
	  this.matcher.addRoutes(routes);
	  if (this.history.current !== START) {
	    this.history.transitionTo(this.history.getCurrentLocation());
	  }
	};
	
	Object.defineProperties( VueRouter.prototype, prototypeAccessors );
	
	function registerHook (list, fn) {
	  list.push(fn);
	  return function () {
	    var i = list.indexOf(fn);
	    if (i > -1) { list.splice(i, 1); }
	  }
	}
	
	function createHref (base, fullPath, mode) {
	  var path = mode === 'hash' ? '#' + fullPath : fullPath;
	  return base ? cleanPath(base + '/' + path) : path
	}
	
	VueRouter.install = install;
	VueRouter.version = '2.8.1';
	
	if (inBrowser && window.Vue) {
	  window.Vue.use(VueRouter);
	}
	
	module.exports = VueRouter;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
	 * Vue.js v2.6.11
	 * (c) 2014-2019 Evan You
	 * Released under the MIT License.
	 */
	"use strict";var e=Object.freeze({});function t(e){return null==e}function n(e){return null!=e}function r(e){return!0===e}function i(e){return"string"==typeof e||"number"==typeof e||"symbol"==typeof e||"boolean"==typeof e}function o(e){return null!==e&&"object"==typeof e}var a=Object.prototype.toString;function s(e){return"[object Object]"===a.call(e)}function c(e){var t=parseFloat(String(e));return t>=0&&Math.floor(t)===t&&isFinite(e)}function u(e){return n(e)&&"function"==typeof e.then&&"function"==typeof e.catch}function l(e){return null==e?"":Array.isArray(e)||s(e)&&e.toString===a?JSON.stringify(e,null,2):String(e)}function f(e){var t=parseFloat(e);return isNaN(t)?e:t}function p(e,t){for(var n=Object.create(null),r=e.split(","),i=0;i<r.length;i++)n[r[i]]=!0;return t?function(e){return n[e.toLowerCase()]}:function(e){return n[e]}}var d=p("slot,component",!0),v=p("key,ref,slot,slot-scope,is");function h(e,t){if(e.length){var n=e.indexOf(t);if(n>-1)return e.splice(n,1)}}var m=Object.prototype.hasOwnProperty;function y(e,t){return m.call(e,t)}function g(e){var t=Object.create(null);return function(n){return t[n]||(t[n]=e(n))}}var _=/-(\w)/g,b=g(function(e){return e.replace(_,function(e,t){return t?t.toUpperCase():""})}),$=g(function(e){return e.charAt(0).toUpperCase()+e.slice(1)}),w=/\B([A-Z])/g,C=g(function(e){return e.replace(w,"-$1").toLowerCase()});var x=Function.prototype.bind?function(e,t){return e.bind(t)}:function(e,t){function n(n){var r=arguments.length;return r?r>1?e.apply(t,arguments):e.call(t,n):e.call(t)}return n._length=e.length,n};function k(e,t){t=t||0;for(var n=e.length-t,r=new Array(n);n--;)r[n]=e[n+t];return r}function A(e,t){for(var n in t)e[n]=t[n];return e}function O(e){for(var t={},n=0;n<e.length;n++)e[n]&&A(t,e[n]);return t}function S(e,t,n){}var T=function(e,t,n){return!1},E=function(e){return e};function N(e,t){if(e===t)return!0;var n=o(e),r=o(t);if(!n||!r)return!n&&!r&&String(e)===String(t);try{var i=Array.isArray(e),a=Array.isArray(t);if(i&&a)return e.length===t.length&&e.every(function(e,n){return N(e,t[n])});if(e instanceof Date&&t instanceof Date)return e.getTime()===t.getTime();if(i||a)return!1;var s=Object.keys(e),c=Object.keys(t);return s.length===c.length&&s.every(function(n){return N(e[n],t[n])})}catch(e){return!1}}function j(e,t){for(var n=0;n<e.length;n++)if(N(e[n],t))return n;return-1}function D(e){var t=!1;return function(){t||(t=!0,e.apply(this,arguments))}}var L="data-server-rendered",M=["component","directive","filter"],I=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch"],F={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:T,isReservedAttr:T,isUnknownElement:T,getTagNamespace:S,parsePlatformTagName:E,mustUseProp:T,async:!0,_lifecycleHooks:I},P=/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;function R(e,t,n,r){Object.defineProperty(e,t,{value:n,enumerable:!!r,writable:!0,configurable:!0})}var H=new RegExp("[^"+P.source+".$_\\d]");var B,U="__proto__"in{},z="undefined"!=typeof window,V="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,K=V&&WXEnvironment.platform.toLowerCase(),J=z&&window.navigator.userAgent.toLowerCase(),q=J&&/msie|trident/.test(J),W=J&&J.indexOf("msie 9.0")>0,Z=J&&J.indexOf("edge/")>0,G=(J&&J.indexOf("android"),J&&/iphone|ipad|ipod|ios/.test(J)||"ios"===K),X=(J&&/chrome\/\d+/.test(J),J&&/phantomjs/.test(J),J&&J.match(/firefox\/(\d+)/)),Y={}.watch,Q=!1;if(z)try{var ee={};Object.defineProperty(ee,"passive",{get:function(){Q=!0}}),window.addEventListener("test-passive",null,ee)}catch(e){}var te=function(){return void 0===B&&(B=!z&&!V&&"undefined"!=typeof global&&(global.process&&"server"===global.process.env.VUE_ENV)),B},ne=z&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function re(e){return"function"==typeof e&&/native code/.test(e.toString())}var ie,oe="undefined"!=typeof Symbol&&re(Symbol)&&"undefined"!=typeof Reflect&&re(Reflect.ownKeys);ie="undefined"!=typeof Set&&re(Set)?Set:function(){function e(){this.set=Object.create(null)}return e.prototype.has=function(e){return!0===this.set[e]},e.prototype.add=function(e){this.set[e]=!0},e.prototype.clear=function(){this.set=Object.create(null)},e}();var ae=S,se=0,ce=function(){this.id=se++,this.subs=[]};ce.prototype.addSub=function(e){this.subs.push(e)},ce.prototype.removeSub=function(e){h(this.subs,e)},ce.prototype.depend=function(){ce.target&&ce.target.addDep(this)},ce.prototype.notify=function(){for(var e=this.subs.slice(),t=0,n=e.length;t<n;t++)e[t].update()},ce.target=null;var ue=[];function le(e){ue.push(e),ce.target=e}function fe(){ue.pop(),ce.target=ue[ue.length-1]}var pe=function(e,t,n,r,i,o,a,s){this.tag=e,this.data=t,this.children=n,this.text=r,this.elm=i,this.ns=void 0,this.context=o,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=t&&t.key,this.componentOptions=a,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},de={child:{configurable:!0}};de.child.get=function(){return this.componentInstance},Object.defineProperties(pe.prototype,de);var ve=function(e){void 0===e&&(e="");var t=new pe;return t.text=e,t.isComment=!0,t};function he(e){return new pe(void 0,void 0,void 0,String(e))}function me(e){var t=new pe(e.tag,e.data,e.children&&e.children.slice(),e.text,e.elm,e.context,e.componentOptions,e.asyncFactory);return t.ns=e.ns,t.isStatic=e.isStatic,t.key=e.key,t.isComment=e.isComment,t.fnContext=e.fnContext,t.fnOptions=e.fnOptions,t.fnScopeId=e.fnScopeId,t.asyncMeta=e.asyncMeta,t.isCloned=!0,t}var ye=Array.prototype,ge=Object.create(ye);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(e){var t=ye[e];R(ge,e,function(){for(var n=[],r=arguments.length;r--;)n[r]=arguments[r];var i,o=t.apply(this,n),a=this.__ob__;switch(e){case"push":case"unshift":i=n;break;case"splice":i=n.slice(2)}return i&&a.observeArray(i),a.dep.notify(),o})});var _e=Object.getOwnPropertyNames(ge),be=!0;function $e(e){be=e}var we=function(e){var t;this.value=e,this.dep=new ce,this.vmCount=0,R(e,"__ob__",this),Array.isArray(e)?(U?(t=ge,e.__proto__=t):function(e,t,n){for(var r=0,i=n.length;r<i;r++){var o=n[r];R(e,o,t[o])}}(e,ge,_e),this.observeArray(e)):this.walk(e)};function Ce(e,t){var n;if(o(e)&&!(e instanceof pe))return y(e,"__ob__")&&e.__ob__ instanceof we?n=e.__ob__:be&&!te()&&(Array.isArray(e)||s(e))&&Object.isExtensible(e)&&!e._isVue&&(n=new we(e)),t&&n&&n.vmCount++,n}function xe(e,t,n,r,i){var o=new ce,a=Object.getOwnPropertyDescriptor(e,t);if(!a||!1!==a.configurable){var s=a&&a.get,c=a&&a.set;s&&!c||2!==arguments.length||(n=e[t]);var u=!i&&Ce(n);Object.defineProperty(e,t,{enumerable:!0,configurable:!0,get:function(){var t=s?s.call(e):n;return ce.target&&(o.depend(),u&&(u.dep.depend(),Array.isArray(t)&&function e(t){for(var n=void 0,r=0,i=t.length;r<i;r++)(n=t[r])&&n.__ob__&&n.__ob__.dep.depend(),Array.isArray(n)&&e(n)}(t))),t},set:function(t){var r=s?s.call(e):n;t===r||t!=t&&r!=r||s&&!c||(c?c.call(e,t):n=t,u=!i&&Ce(t),o.notify())}})}}function ke(e,t,n){if(Array.isArray(e)&&c(t))return e.length=Math.max(e.length,t),e.splice(t,1,n),n;if(t in e&&!(t in Object.prototype))return e[t]=n,n;var r=e.__ob__;return e._isVue||r&&r.vmCount?n:r?(xe(r.value,t,n),r.dep.notify(),n):(e[t]=n,n)}function Ae(e,t){if(Array.isArray(e)&&c(t))e.splice(t,1);else{var n=e.__ob__;e._isVue||n&&n.vmCount||y(e,t)&&(delete e[t],n&&n.dep.notify())}}we.prototype.walk=function(e){for(var t=Object.keys(e),n=0;n<t.length;n++)xe(e,t[n])},we.prototype.observeArray=function(e){for(var t=0,n=e.length;t<n;t++)Ce(e[t])};var Oe=F.optionMergeStrategies;function Se(e,t){if(!t)return e;for(var n,r,i,o=oe?Reflect.ownKeys(t):Object.keys(t),a=0;a<o.length;a++)"__ob__"!==(n=o[a])&&(r=e[n],i=t[n],y(e,n)?r!==i&&s(r)&&s(i)&&Se(r,i):ke(e,n,i));return e}function Te(e,t,n){return n?function(){var r="function"==typeof t?t.call(n,n):t,i="function"==typeof e?e.call(n,n):e;return r?Se(r,i):i}:t?e?function(){return Se("function"==typeof t?t.call(this,this):t,"function"==typeof e?e.call(this,this):e)}:t:e}function Ee(e,t){var n=t?e?e.concat(t):Array.isArray(t)?t:[t]:e;return n?function(e){for(var t=[],n=0;n<e.length;n++)-1===t.indexOf(e[n])&&t.push(e[n]);return t}(n):n}function Ne(e,t,n,r){var i=Object.create(e||null);return t?A(i,t):i}Oe.data=function(e,t,n){return n?Te(e,t,n):t&&"function"!=typeof t?e:Te(e,t)},I.forEach(function(e){Oe[e]=Ee}),M.forEach(function(e){Oe[e+"s"]=Ne}),Oe.watch=function(e,t,n,r){if(e===Y&&(e=void 0),t===Y&&(t=void 0),!t)return Object.create(e||null);if(!e)return t;var i={};for(var o in A(i,e),t){var a=i[o],s=t[o];a&&!Array.isArray(a)&&(a=[a]),i[o]=a?a.concat(s):Array.isArray(s)?s:[s]}return i},Oe.props=Oe.methods=Oe.inject=Oe.computed=function(e,t,n,r){if(!e)return t;var i=Object.create(null);return A(i,e),t&&A(i,t),i},Oe.provide=Te;var je=function(e,t){return void 0===t?e:t};function De(e,t,n){if("function"==typeof t&&(t=t.options),function(e,t){var n=e.props;if(n){var r,i,o={};if(Array.isArray(n))for(r=n.length;r--;)"string"==typeof(i=n[r])&&(o[b(i)]={type:null});else if(s(n))for(var a in n)i=n[a],o[b(a)]=s(i)?i:{type:i};e.props=o}}(t),function(e,t){var n=e.inject;if(n){var r=e.inject={};if(Array.isArray(n))for(var i=0;i<n.length;i++)r[n[i]]={from:n[i]};else if(s(n))for(var o in n){var a=n[o];r[o]=s(a)?A({from:o},a):{from:a}}}}(t),function(e){var t=e.directives;if(t)for(var n in t){var r=t[n];"function"==typeof r&&(t[n]={bind:r,update:r})}}(t),!t._base&&(t.extends&&(e=De(e,t.extends,n)),t.mixins))for(var r=0,i=t.mixins.length;r<i;r++)e=De(e,t.mixins[r],n);var o,a={};for(o in e)c(o);for(o in t)y(e,o)||c(o);function c(r){var i=Oe[r]||je;a[r]=i(e[r],t[r],n,r)}return a}function Le(e,t,n,r){if("string"==typeof n){var i=e[t];if(y(i,n))return i[n];var o=b(n);if(y(i,o))return i[o];var a=$(o);return y(i,a)?i[a]:i[n]||i[o]||i[a]}}function Me(e,t,n,r){var i=t[e],o=!y(n,e),a=n[e],s=Pe(Boolean,i.type);if(s>-1)if(o&&!y(i,"default"))a=!1;else if(""===a||a===C(e)){var c=Pe(String,i.type);(c<0||s<c)&&(a=!0)}if(void 0===a){a=function(e,t,n){if(!y(t,"default"))return;var r=t.default;if(e&&e.$options.propsData&&void 0===e.$options.propsData[n]&&void 0!==e._props[n])return e._props[n];return"function"==typeof r&&"Function"!==Ie(t.type)?r.call(e):r}(r,i,e);var u=be;$e(!0),Ce(a),$e(u)}return a}function Ie(e){var t=e&&e.toString().match(/^\s*function (\w+)/);return t?t[1]:""}function Fe(e,t){return Ie(e)===Ie(t)}function Pe(e,t){if(!Array.isArray(t))return Fe(t,e)?0:-1;for(var n=0,r=t.length;n<r;n++)if(Fe(t[n],e))return n;return-1}function Re(e,t,n){le();try{if(t)for(var r=t;r=r.$parent;){var i=r.$options.errorCaptured;if(i)for(var o=0;o<i.length;o++)try{if(!1===i[o].call(r,e,t,n))return}catch(e){Be(e,r,"errorCaptured hook")}}Be(e,t,n)}finally{fe()}}function He(e,t,n,r,i){var o;try{(o=n?e.apply(t,n):e.call(t))&&!o._isVue&&u(o)&&!o._handled&&(o.catch(function(e){return Re(e,r,i+" (Promise/async)")}),o._handled=!0)}catch(e){Re(e,r,i)}return o}function Be(e,t,n){if(F.errorHandler)try{return F.errorHandler.call(null,e,t,n)}catch(t){t!==e&&Ue(t,null,"config.errorHandler")}Ue(e,t,n)}function Ue(e,t,n){if(!z&&!V||"undefined"==typeof console)throw e;console.error(e)}var ze,Ve=!1,Ke=[],Je=!1;function qe(){Je=!1;var e=Ke.slice(0);Ke.length=0;for(var t=0;t<e.length;t++)e[t]()}if("undefined"!=typeof Promise&&re(Promise)){var We=Promise.resolve();ze=function(){We.then(qe),G&&setTimeout(S)},Ve=!0}else if(q||"undefined"==typeof MutationObserver||!re(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())ze="undefined"!=typeof setImmediate&&re(setImmediate)?function(){setImmediate(qe)}:function(){setTimeout(qe,0)};else{var Ze=1,Ge=new MutationObserver(qe),Xe=document.createTextNode(String(Ze));Ge.observe(Xe,{characterData:!0}),ze=function(){Ze=(Ze+1)%2,Xe.data=String(Ze)},Ve=!0}function Ye(e,t){var n;if(Ke.push(function(){if(e)try{e.call(t)}catch(e){Re(e,t,"nextTick")}else n&&n(t)}),Je||(Je=!0,ze()),!e&&"undefined"!=typeof Promise)return new Promise(function(e){n=e})}var Qe=new ie;function et(e){!function e(t,n){var r,i;var a=Array.isArray(t);if(!a&&!o(t)||Object.isFrozen(t)||t instanceof pe)return;if(t.__ob__){var s=t.__ob__.dep.id;if(n.has(s))return;n.add(s)}if(a)for(r=t.length;r--;)e(t[r],n);else for(i=Object.keys(t),r=i.length;r--;)e(t[i[r]],n)}(e,Qe),Qe.clear()}var tt=g(function(e){var t="&"===e.charAt(0),n="~"===(e=t?e.slice(1):e).charAt(0),r="!"===(e=n?e.slice(1):e).charAt(0);return{name:e=r?e.slice(1):e,once:n,capture:r,passive:t}});function nt(e,t){function n(){var e=arguments,r=n.fns;if(!Array.isArray(r))return He(r,null,arguments,t,"v-on handler");for(var i=r.slice(),o=0;o<i.length;o++)He(i[o],null,e,t,"v-on handler")}return n.fns=e,n}function rt(e,n,i,o,a,s){var c,u,l,f;for(c in e)u=e[c],l=n[c],f=tt(c),t(u)||(t(l)?(t(u.fns)&&(u=e[c]=nt(u,s)),r(f.once)&&(u=e[c]=a(f.name,u,f.capture)),i(f.name,u,f.capture,f.passive,f.params)):u!==l&&(l.fns=u,e[c]=l));for(c in n)t(e[c])&&o((f=tt(c)).name,n[c],f.capture)}function it(e,i,o){var a;e instanceof pe&&(e=e.data.hook||(e.data.hook={}));var s=e[i];function c(){o.apply(this,arguments),h(a.fns,c)}t(s)?a=nt([c]):n(s.fns)&&r(s.merged)?(a=s).fns.push(c):a=nt([s,c]),a.merged=!0,e[i]=a}function ot(e,t,r,i,o){if(n(t)){if(y(t,r))return e[r]=t[r],o||delete t[r],!0;if(y(t,i))return e[r]=t[i],o||delete t[i],!0}return!1}function at(e){return i(e)?[he(e)]:Array.isArray(e)?function e(o,a){var s=[];var c,u,l,f;for(c=0;c<o.length;c++)t(u=o[c])||"boolean"==typeof u||(l=s.length-1,f=s[l],Array.isArray(u)?u.length>0&&(st((u=e(u,(a||"")+"_"+c))[0])&&st(f)&&(s[l]=he(f.text+u[0].text),u.shift()),s.push.apply(s,u)):i(u)?st(f)?s[l]=he(f.text+u):""!==u&&s.push(he(u)):st(u)&&st(f)?s[l]=he(f.text+u.text):(r(o._isVList)&&n(u.tag)&&t(u.key)&&n(a)&&(u.key="__vlist"+a+"_"+c+"__"),s.push(u)));return s}(e):void 0}function st(e){return n(e)&&n(e.text)&&!1===e.isComment}function ct(e,t){if(e){for(var n=Object.create(null),r=oe?Reflect.ownKeys(e):Object.keys(e),i=0;i<r.length;i++){var o=r[i];if("__ob__"!==o){for(var a=e[o].from,s=t;s;){if(s._provided&&y(s._provided,a)){n[o]=s._provided[a];break}s=s.$parent}if(!s&&"default"in e[o]){var c=e[o].default;n[o]="function"==typeof c?c.call(t):c}}}return n}}function ut(e,t){if(!e||!e.length)return{};for(var n={},r=0,i=e.length;r<i;r++){var o=e[r],a=o.data;if(a&&a.attrs&&a.attrs.slot&&delete a.attrs.slot,o.context!==t&&o.fnContext!==t||!a||null==a.slot)(n.default||(n.default=[])).push(o);else{var s=a.slot,c=n[s]||(n[s]=[]);"template"===o.tag?c.push.apply(c,o.children||[]):c.push(o)}}for(var u in n)n[u].every(lt)&&delete n[u];return n}function lt(e){return e.isComment&&!e.asyncFactory||" "===e.text}function ft(t,n,r){var i,o=Object.keys(n).length>0,a=t?!!t.$stable:!o,s=t&&t.$key;if(t){if(t._normalized)return t._normalized;if(a&&r&&r!==e&&s===r.$key&&!o&&!r.$hasNormal)return r;for(var c in i={},t)t[c]&&"$"!==c[0]&&(i[c]=pt(n,c,t[c]))}else i={};for(var u in n)u in i||(i[u]=dt(n,u));return t&&Object.isExtensible(t)&&(t._normalized=i),R(i,"$stable",a),R(i,"$key",s),R(i,"$hasNormal",o),i}function pt(e,t,n){var r=function(){var e=arguments.length?n.apply(null,arguments):n({});return(e=e&&"object"==typeof e&&!Array.isArray(e)?[e]:at(e))&&(0===e.length||1===e.length&&e[0].isComment)?void 0:e};return n.proxy&&Object.defineProperty(e,t,{get:r,enumerable:!0,configurable:!0}),r}function dt(e,t){return function(){return e[t]}}function vt(e,t){var r,i,a,s,c;if(Array.isArray(e)||"string"==typeof e)for(r=new Array(e.length),i=0,a=e.length;i<a;i++)r[i]=t(e[i],i);else if("number"==typeof e)for(r=new Array(e),i=0;i<e;i++)r[i]=t(i+1,i);else if(o(e))if(oe&&e[Symbol.iterator]){r=[];for(var u=e[Symbol.iterator](),l=u.next();!l.done;)r.push(t(l.value,r.length)),l=u.next()}else for(s=Object.keys(e),r=new Array(s.length),i=0,a=s.length;i<a;i++)c=s[i],r[i]=t(e[c],c,i);return n(r)||(r=[]),r._isVList=!0,r}function ht(e,t,n,r){var i,o=this.$scopedSlots[e];o?(n=n||{},r&&(n=A(A({},r),n)),i=o(n)||t):i=this.$slots[e]||t;var a=n&&n.slot;return a?this.$createElement("template",{slot:a},i):i}function mt(e){return Le(this.$options,"filters",e)||E}function yt(e,t){return Array.isArray(e)?-1===e.indexOf(t):e!==t}function gt(e,t,n,r,i){var o=F.keyCodes[t]||n;return i&&r&&!F.keyCodes[t]?yt(i,r):o?yt(o,e):r?C(r)!==t:void 0}function _t(e,t,n,r,i){if(n)if(o(n)){var a;Array.isArray(n)&&(n=O(n));var s=function(o){if("class"===o||"style"===o||v(o))a=e;else{var s=e.attrs&&e.attrs.type;a=r||F.mustUseProp(t,s,o)?e.domProps||(e.domProps={}):e.attrs||(e.attrs={})}var c=b(o),u=C(o);c in a||u in a||(a[o]=n[o],i&&((e.on||(e.on={}))["update:"+o]=function(e){n[o]=e}))};for(var c in n)s(c)}else;return e}function bt(e,t){var n=this._staticTrees||(this._staticTrees=[]),r=n[e];return r&&!t?r:(wt(r=n[e]=this.$options.staticRenderFns[e].call(this._renderProxy,null,this),"__static__"+e,!1),r)}function $t(e,t,n){return wt(e,"__once__"+t+(n?"_"+n:""),!0),e}function wt(e,t,n){if(Array.isArray(e))for(var r=0;r<e.length;r++)e[r]&&"string"!=typeof e[r]&&Ct(e[r],t+"_"+r,n);else Ct(e,t,n)}function Ct(e,t,n){e.isStatic=!0,e.key=t,e.isOnce=n}function xt(e,t){if(t)if(s(t)){var n=e.on=e.on?A({},e.on):{};for(var r in t){var i=n[r],o=t[r];n[r]=i?[].concat(i,o):o}}else;return e}function kt(e,t,n,r){t=t||{$stable:!n};for(var i=0;i<e.length;i++){var o=e[i];Array.isArray(o)?kt(o,t,n):o&&(o.proxy&&(o.fn.proxy=!0),t[o.key]=o.fn)}return r&&(t.$key=r),t}function At(e,t){for(var n=0;n<t.length;n+=2){var r=t[n];"string"==typeof r&&r&&(e[t[n]]=t[n+1])}return e}function Ot(e,t){return"string"==typeof e?t+e:e}function St(e){e._o=$t,e._n=f,e._s=l,e._l=vt,e._t=ht,e._q=N,e._i=j,e._m=bt,e._f=mt,e._k=gt,e._b=_t,e._v=he,e._e=ve,e._u=kt,e._g=xt,e._d=At,e._p=Ot}function Tt(t,n,i,o,a){var s,c=this,u=a.options;y(o,"_uid")?(s=Object.create(o))._original=o:(s=o,o=o._original);var l=r(u._compiled),f=!l;this.data=t,this.props=n,this.children=i,this.parent=o,this.listeners=t.on||e,this.injections=ct(u.inject,o),this.slots=function(){return c.$slots||ft(t.scopedSlots,c.$slots=ut(i,o)),c.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return ft(t.scopedSlots,this.slots())}}),l&&(this.$options=u,this.$slots=this.slots(),this.$scopedSlots=ft(t.scopedSlots,this.$slots)),u._scopeId?this._c=function(e,t,n,r){var i=Pt(s,e,t,n,r,f);return i&&!Array.isArray(i)&&(i.fnScopeId=u._scopeId,i.fnContext=o),i}:this._c=function(e,t,n,r){return Pt(s,e,t,n,r,f)}}function Et(e,t,n,r,i){var o=me(e);return o.fnContext=n,o.fnOptions=r,t.slot&&((o.data||(o.data={})).slot=t.slot),o}function Nt(e,t){for(var n in t)e[b(n)]=t[n]}St(Tt.prototype);var jt={init:function(e,t){if(e.componentInstance&&!e.componentInstance._isDestroyed&&e.data.keepAlive){var r=e;jt.prepatch(r,r)}else{(e.componentInstance=function(e,t){var r={_isComponent:!0,_parentVnode:e,parent:t},i=e.data.inlineTemplate;n(i)&&(r.render=i.render,r.staticRenderFns=i.staticRenderFns);return new e.componentOptions.Ctor(r)}(e,Wt)).$mount(t?e.elm:void 0,t)}},prepatch:function(t,n){var r=n.componentOptions;!function(t,n,r,i,o){var a=i.data.scopedSlots,s=t.$scopedSlots,c=!!(a&&!a.$stable||s!==e&&!s.$stable||a&&t.$scopedSlots.$key!==a.$key),u=!!(o||t.$options._renderChildren||c);t.$options._parentVnode=i,t.$vnode=i,t._vnode&&(t._vnode.parent=i);if(t.$options._renderChildren=o,t.$attrs=i.data.attrs||e,t.$listeners=r||e,n&&t.$options.props){$e(!1);for(var l=t._props,f=t.$options._propKeys||[],p=0;p<f.length;p++){var d=f[p],v=t.$options.props;l[d]=Me(d,v,n,t)}$e(!0),t.$options.propsData=n}r=r||e;var h=t.$options._parentListeners;t.$options._parentListeners=r,qt(t,r,h),u&&(t.$slots=ut(o,i.context),t.$forceUpdate())}(n.componentInstance=t.componentInstance,r.propsData,r.listeners,n,r.children)},insert:function(e){var t,n=e.context,r=e.componentInstance;r._isMounted||(r._isMounted=!0,Yt(r,"mounted")),e.data.keepAlive&&(n._isMounted?((t=r)._inactive=!1,en.push(t)):Xt(r,!0))},destroy:function(e){var t=e.componentInstance;t._isDestroyed||(e.data.keepAlive?function e(t,n){if(n&&(t._directInactive=!0,Gt(t)))return;if(!t._inactive){t._inactive=!0;for(var r=0;r<t.$children.length;r++)e(t.$children[r]);Yt(t,"deactivated")}}(t,!0):t.$destroy())}},Dt=Object.keys(jt);function Lt(i,a,s,c,l){if(!t(i)){var f=s.$options._base;if(o(i)&&(i=f.extend(i)),"function"==typeof i){var p;if(t(i.cid)&&void 0===(i=function(e,i){if(r(e.error)&&n(e.errorComp))return e.errorComp;if(n(e.resolved))return e.resolved;var a=Ht;a&&n(e.owners)&&-1===e.owners.indexOf(a)&&e.owners.push(a);if(r(e.loading)&&n(e.loadingComp))return e.loadingComp;if(a&&!n(e.owners)){var s=e.owners=[a],c=!0,l=null,f=null;a.$on("hook:destroyed",function(){return h(s,a)});var p=function(e){for(var t=0,n=s.length;t<n;t++)s[t].$forceUpdate();e&&(s.length=0,null!==l&&(clearTimeout(l),l=null),null!==f&&(clearTimeout(f),f=null))},d=D(function(t){e.resolved=Bt(t,i),c?s.length=0:p(!0)}),v=D(function(t){n(e.errorComp)&&(e.error=!0,p(!0))}),m=e(d,v);return o(m)&&(u(m)?t(e.resolved)&&m.then(d,v):u(m.component)&&(m.component.then(d,v),n(m.error)&&(e.errorComp=Bt(m.error,i)),n(m.loading)&&(e.loadingComp=Bt(m.loading,i),0===m.delay?e.loading=!0:l=setTimeout(function(){l=null,t(e.resolved)&&t(e.error)&&(e.loading=!0,p(!1))},m.delay||200)),n(m.timeout)&&(f=setTimeout(function(){f=null,t(e.resolved)&&v(null)},m.timeout)))),c=!1,e.loading?e.loadingComp:e.resolved}}(p=i,f)))return function(e,t,n,r,i){var o=ve();return o.asyncFactory=e,o.asyncMeta={data:t,context:n,children:r,tag:i},o}(p,a,s,c,l);a=a||{},$n(i),n(a.model)&&function(e,t){var r=e.model&&e.model.prop||"value",i=e.model&&e.model.event||"input";(t.attrs||(t.attrs={}))[r]=t.model.value;var o=t.on||(t.on={}),a=o[i],s=t.model.callback;n(a)?(Array.isArray(a)?-1===a.indexOf(s):a!==s)&&(o[i]=[s].concat(a)):o[i]=s}(i.options,a);var d=function(e,r,i){var o=r.options.props;if(!t(o)){var a={},s=e.attrs,c=e.props;if(n(s)||n(c))for(var u in o){var l=C(u);ot(a,c,u,l,!0)||ot(a,s,u,l,!1)}return a}}(a,i);if(r(i.options.functional))return function(t,r,i,o,a){var s=t.options,c={},u=s.props;if(n(u))for(var l in u)c[l]=Me(l,u,r||e);else n(i.attrs)&&Nt(c,i.attrs),n(i.props)&&Nt(c,i.props);var f=new Tt(i,c,a,o,t),p=s.render.call(null,f._c,f);if(p instanceof pe)return Et(p,i,f.parent,s);if(Array.isArray(p)){for(var d=at(p)||[],v=new Array(d.length),h=0;h<d.length;h++)v[h]=Et(d[h],i,f.parent,s);return v}}(i,d,a,s,c);var v=a.on;if(a.on=a.nativeOn,r(i.options.abstract)){var m=a.slot;a={},m&&(a.slot=m)}!function(e){for(var t=e.hook||(e.hook={}),n=0;n<Dt.length;n++){var r=Dt[n],i=t[r],o=jt[r];i===o||i&&i._merged||(t[r]=i?Mt(o,i):o)}}(a);var y=i.options.name||l;return new pe("vue-component-"+i.cid+(y?"-"+y:""),a,void 0,void 0,void 0,s,{Ctor:i,propsData:d,listeners:v,tag:l,children:c},p)}}}function Mt(e,t){var n=function(n,r){e(n,r),t(n,r)};return n._merged=!0,n}var It=1,Ft=2;function Pt(e,a,s,c,u,l){return(Array.isArray(s)||i(s))&&(u=c,c=s,s=void 0),r(l)&&(u=Ft),function(e,i,a,s,c){if(n(a)&&n(a.__ob__))return ve();n(a)&&n(a.is)&&(i=a.is);if(!i)return ve();Array.isArray(s)&&"function"==typeof s[0]&&((a=a||{}).scopedSlots={default:s[0]},s.length=0);c===Ft?s=at(s):c===It&&(s=function(e){for(var t=0;t<e.length;t++)if(Array.isArray(e[t]))return Array.prototype.concat.apply([],e);return e}(s));var u,l;if("string"==typeof i){var f;l=e.$vnode&&e.$vnode.ns||F.getTagNamespace(i),u=F.isReservedTag(i)?new pe(F.parsePlatformTagName(i),a,s,void 0,void 0,e):a&&a.pre||!n(f=Le(e.$options,"components",i))?new pe(i,a,s,void 0,void 0,e):Lt(f,a,e,s,i)}else u=Lt(i,a,e,s);return Array.isArray(u)?u:n(u)?(n(l)&&function e(i,o,a){i.ns=o;"foreignObject"===i.tag&&(o=void 0,a=!0);if(n(i.children))for(var s=0,c=i.children.length;s<c;s++){var u=i.children[s];n(u.tag)&&(t(u.ns)||r(a)&&"svg"!==u.tag)&&e(u,o,a)}}(u,l),n(a)&&function(e){o(e.style)&&et(e.style);o(e.class)&&et(e.class)}(a),u):ve()}(e,a,s,c,u)}var Rt,Ht=null;function Bt(e,t){return(e.__esModule||oe&&"Module"===e[Symbol.toStringTag])&&(e=e.default),o(e)?t.extend(e):e}function Ut(e){return e.isComment&&e.asyncFactory}function zt(e){if(Array.isArray(e))for(var t=0;t<e.length;t++){var r=e[t];if(n(r)&&(n(r.componentOptions)||Ut(r)))return r}}function Vt(e,t){Rt.$on(e,t)}function Kt(e,t){Rt.$off(e,t)}function Jt(e,t){var n=Rt;return function r(){null!==t.apply(null,arguments)&&n.$off(e,r)}}function qt(e,t,n){Rt=e,rt(t,n||{},Vt,Kt,Jt,e),Rt=void 0}var Wt=null;function Zt(e){var t=Wt;return Wt=e,function(){Wt=t}}function Gt(e){for(;e&&(e=e.$parent);)if(e._inactive)return!0;return!1}function Xt(e,t){if(t){if(e._directInactive=!1,Gt(e))return}else if(e._directInactive)return;if(e._inactive||null===e._inactive){e._inactive=!1;for(var n=0;n<e.$children.length;n++)Xt(e.$children[n]);Yt(e,"activated")}}function Yt(e,t){le();var n=e.$options[t],r=t+" hook";if(n)for(var i=0,o=n.length;i<o;i++)He(n[i],e,null,e,r);e._hasHookEvent&&e.$emit("hook:"+t),fe()}var Qt=[],en=[],tn={},nn=!1,rn=!1,on=0;var an=0,sn=Date.now;if(z&&!q){var cn=window.performance;cn&&"function"==typeof cn.now&&sn()>document.createEvent("Event").timeStamp&&(sn=function(){return cn.now()})}function un(){var e,t;for(an=sn(),rn=!0,Qt.sort(function(e,t){return e.id-t.id}),on=0;on<Qt.length;on++)(e=Qt[on]).before&&e.before(),t=e.id,tn[t]=null,e.run();var n=en.slice(),r=Qt.slice();on=Qt.length=en.length=0,tn={},nn=rn=!1,function(e){for(var t=0;t<e.length;t++)e[t]._inactive=!0,Xt(e[t],!0)}(n),function(e){var t=e.length;for(;t--;){var n=e[t],r=n.vm;r._watcher===n&&r._isMounted&&!r._isDestroyed&&Yt(r,"updated")}}(r),ne&&F.devtools&&ne.emit("flush")}var ln=0,fn=function(e,t,n,r,i){this.vm=e,i&&(e._watcher=this),e._watchers.push(this),r?(this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync,this.before=r.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++ln,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new ie,this.newDepIds=new ie,this.expression="","function"==typeof t?this.getter=t:(this.getter=function(e){if(!H.test(e)){var t=e.split(".");return function(e){for(var n=0;n<t.length;n++){if(!e)return;e=e[t[n]]}return e}}}(t),this.getter||(this.getter=S)),this.value=this.lazy?void 0:this.get()};fn.prototype.get=function(){var e;le(this);var t=this.vm;try{e=this.getter.call(t,t)}catch(e){if(!this.user)throw e;Re(e,t,'getter for watcher "'+this.expression+'"')}finally{this.deep&&et(e),fe(),this.cleanupDeps()}return e},fn.prototype.addDep=function(e){var t=e.id;this.newDepIds.has(t)||(this.newDepIds.add(t),this.newDeps.push(e),this.depIds.has(t)||e.addSub(this))},fn.prototype.cleanupDeps=function(){for(var e=this.deps.length;e--;){var t=this.deps[e];this.newDepIds.has(t.id)||t.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},fn.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(e){var t=e.id;if(null==tn[t]){if(tn[t]=!0,rn){for(var n=Qt.length-1;n>on&&Qt[n].id>e.id;)n--;Qt.splice(n+1,0,e)}else Qt.push(e);nn||(nn=!0,Ye(un))}}(this)},fn.prototype.run=function(){if(this.active){var e=this.get();if(e!==this.value||o(e)||this.deep){var t=this.value;if(this.value=e,this.user)try{this.cb.call(this.vm,e,t)}catch(e){Re(e,this.vm,'callback for watcher "'+this.expression+'"')}else this.cb.call(this.vm,e,t)}}},fn.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},fn.prototype.depend=function(){for(var e=this.deps.length;e--;)this.deps[e].depend()},fn.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||h(this.vm._watchers,this);for(var e=this.deps.length;e--;)this.deps[e].removeSub(this);this.active=!1}};var pn={enumerable:!0,configurable:!0,get:S,set:S};function dn(e,t,n){pn.get=function(){return this[t][n]},pn.set=function(e){this[t][n]=e},Object.defineProperty(e,n,pn)}function vn(e){e._watchers=[];var t=e.$options;t.props&&function(e,t){var n=e.$options.propsData||{},r=e._props={},i=e.$options._propKeys=[];e.$parent&&$e(!1);var o=function(o){i.push(o);var a=Me(o,t,n,e);xe(r,o,a),o in e||dn(e,"_props",o)};for(var a in t)o(a);$e(!0)}(e,t.props),t.methods&&function(e,t){e.$options.props;for(var n in t)e[n]="function"!=typeof t[n]?S:x(t[n],e)}(e,t.methods),t.data?function(e){var t=e.$options.data;s(t=e._data="function"==typeof t?function(e,t){le();try{return e.call(t,t)}catch(e){return Re(e,t,"data()"),{}}finally{fe()}}(t,e):t||{})||(t={});var n=Object.keys(t),r=e.$options.props,i=(e.$options.methods,n.length);for(;i--;){var o=n[i];r&&y(r,o)||(a=void 0,36!==(a=(o+"").charCodeAt(0))&&95!==a&&dn(e,"_data",o))}var a;Ce(t,!0)}(e):Ce(e._data={},!0),t.computed&&function(e,t){var n=e._computedWatchers=Object.create(null),r=te();for(var i in t){var o=t[i],a="function"==typeof o?o:o.get;r||(n[i]=new fn(e,a||S,S,hn)),i in e||mn(e,i,o)}}(e,t.computed),t.watch&&t.watch!==Y&&function(e,t){for(var n in t){var r=t[n];if(Array.isArray(r))for(var i=0;i<r.length;i++)_n(e,n,r[i]);else _n(e,n,r)}}(e,t.watch)}var hn={lazy:!0};function mn(e,t,n){var r=!te();"function"==typeof n?(pn.get=r?yn(t):gn(n),pn.set=S):(pn.get=n.get?r&&!1!==n.cache?yn(t):gn(n.get):S,pn.set=n.set||S),Object.defineProperty(e,t,pn)}function yn(e){return function(){var t=this._computedWatchers&&this._computedWatchers[e];if(t)return t.dirty&&t.evaluate(),ce.target&&t.depend(),t.value}}function gn(e){return function(){return e.call(this,this)}}function _n(e,t,n,r){return s(n)&&(r=n,n=n.handler),"string"==typeof n&&(n=e[n]),e.$watch(t,n,r)}var bn=0;function $n(e){var t=e.options;if(e.super){var n=$n(e.super);if(n!==e.superOptions){e.superOptions=n;var r=function(e){var t,n=e.options,r=e.sealedOptions;for(var i in n)n[i]!==r[i]&&(t||(t={}),t[i]=n[i]);return t}(e);r&&A(e.extendOptions,r),(t=e.options=De(n,e.extendOptions)).name&&(t.components[t.name]=e)}}return t}function wn(e){this._init(e)}function Cn(e){e.cid=0;var t=1;e.extend=function(e){e=e||{};var n=this,r=n.cid,i=e._Ctor||(e._Ctor={});if(i[r])return i[r];var o=e.name||n.options.name,a=function(e){this._init(e)};return(a.prototype=Object.create(n.prototype)).constructor=a,a.cid=t++,a.options=De(n.options,e),a.super=n,a.options.props&&function(e){var t=e.options.props;for(var n in t)dn(e.prototype,"_props",n)}(a),a.options.computed&&function(e){var t=e.options.computed;for(var n in t)mn(e.prototype,n,t[n])}(a),a.extend=n.extend,a.mixin=n.mixin,a.use=n.use,M.forEach(function(e){a[e]=n[e]}),o&&(a.options.components[o]=a),a.superOptions=n.options,a.extendOptions=e,a.sealedOptions=A({},a.options),i[r]=a,a}}function xn(e){return e&&(e.Ctor.options.name||e.tag)}function kn(e,t){return Array.isArray(e)?e.indexOf(t)>-1:"string"==typeof e?e.split(",").indexOf(t)>-1:(n=e,"[object RegExp]"===a.call(n)&&e.test(t));var n}function An(e,t){var n=e.cache,r=e.keys,i=e._vnode;for(var o in n){var a=n[o];if(a){var s=xn(a.componentOptions);s&&!t(s)&&On(n,o,r,i)}}}function On(e,t,n,r){var i=e[t];!i||r&&i.tag===r.tag||i.componentInstance.$destroy(),e[t]=null,h(n,t)}!function(t){t.prototype._init=function(t){var n=this;n._uid=bn++,n._isVue=!0,t&&t._isComponent?function(e,t){var n=e.$options=Object.create(e.constructor.options),r=t._parentVnode;n.parent=t.parent,n._parentVnode=r;var i=r.componentOptions;n.propsData=i.propsData,n._parentListeners=i.listeners,n._renderChildren=i.children,n._componentTag=i.tag,t.render&&(n.render=t.render,n.staticRenderFns=t.staticRenderFns)}(n,t):n.$options=De($n(n.constructor),t||{},n),n._renderProxy=n,n._self=n,function(e){var t=e.$options,n=t.parent;if(n&&!t.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(e)}e.$parent=n,e.$root=n?n.$root:e,e.$children=[],e.$refs={},e._watcher=null,e._inactive=null,e._directInactive=!1,e._isMounted=!1,e._isDestroyed=!1,e._isBeingDestroyed=!1}(n),function(e){e._events=Object.create(null),e._hasHookEvent=!1;var t=e.$options._parentListeners;t&&qt(e,t)}(n),function(t){t._vnode=null,t._staticTrees=null;var n=t.$options,r=t.$vnode=n._parentVnode,i=r&&r.context;t.$slots=ut(n._renderChildren,i),t.$scopedSlots=e,t._c=function(e,n,r,i){return Pt(t,e,n,r,i,!1)},t.$createElement=function(e,n,r,i){return Pt(t,e,n,r,i,!0)};var o=r&&r.data;xe(t,"$attrs",o&&o.attrs||e,null,!0),xe(t,"$listeners",n._parentListeners||e,null,!0)}(n),Yt(n,"beforeCreate"),function(e){var t=ct(e.$options.inject,e);t&&($e(!1),Object.keys(t).forEach(function(n){xe(e,n,t[n])}),$e(!0))}(n),vn(n),function(e){var t=e.$options.provide;t&&(e._provided="function"==typeof t?t.call(e):t)}(n),Yt(n,"created"),n.$options.el&&n.$mount(n.$options.el)}}(wn),function(e){var t={get:function(){return this._data}},n={get:function(){return this._props}};Object.defineProperty(e.prototype,"$data",t),Object.defineProperty(e.prototype,"$props",n),e.prototype.$set=ke,e.prototype.$delete=Ae,e.prototype.$watch=function(e,t,n){if(s(t))return _n(this,e,t,n);(n=n||{}).user=!0;var r=new fn(this,e,t,n);if(n.immediate)try{t.call(this,r.value)}catch(e){Re(e,this,'callback for immediate watcher "'+r.expression+'"')}return function(){r.teardown()}}}(wn),function(e){var t=/^hook:/;e.prototype.$on=function(e,n){var r=this;if(Array.isArray(e))for(var i=0,o=e.length;i<o;i++)r.$on(e[i],n);else(r._events[e]||(r._events[e]=[])).push(n),t.test(e)&&(r._hasHookEvent=!0);return r},e.prototype.$once=function(e,t){var n=this;function r(){n.$off(e,r),t.apply(n,arguments)}return r.fn=t,n.$on(e,r),n},e.prototype.$off=function(e,t){var n=this;if(!arguments.length)return n._events=Object.create(null),n;if(Array.isArray(e)){for(var r=0,i=e.length;r<i;r++)n.$off(e[r],t);return n}var o,a=n._events[e];if(!a)return n;if(!t)return n._events[e]=null,n;for(var s=a.length;s--;)if((o=a[s])===t||o.fn===t){a.splice(s,1);break}return n},e.prototype.$emit=function(e){var t=this._events[e];if(t){t=t.length>1?k(t):t;for(var n=k(arguments,1),r='event handler for "'+e+'"',i=0,o=t.length;i<o;i++)He(t[i],this,n,this,r)}return this}}(wn),function(e){e.prototype._update=function(e,t){var n=this,r=n.$el,i=n._vnode,o=Zt(n);n._vnode=e,n.$el=i?n.__patch__(i,e):n.__patch__(n.$el,e,t,!1),o(),r&&(r.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},e.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},e.prototype.$destroy=function(){var e=this;if(!e._isBeingDestroyed){Yt(e,"beforeDestroy"),e._isBeingDestroyed=!0;var t=e.$parent;!t||t._isBeingDestroyed||e.$options.abstract||h(t.$children,e),e._watcher&&e._watcher.teardown();for(var n=e._watchers.length;n--;)e._watchers[n].teardown();e._data.__ob__&&e._data.__ob__.vmCount--,e._isDestroyed=!0,e.__patch__(e._vnode,null),Yt(e,"destroyed"),e.$off(),e.$el&&(e.$el.__vue__=null),e.$vnode&&(e.$vnode.parent=null)}}}(wn),function(e){St(e.prototype),e.prototype.$nextTick=function(e){return Ye(e,this)},e.prototype._render=function(){var e,t=this,n=t.$options,r=n.render,i=n._parentVnode;i&&(t.$scopedSlots=ft(i.data.scopedSlots,t.$slots,t.$scopedSlots)),t.$vnode=i;try{Ht=t,e=r.call(t._renderProxy,t.$createElement)}catch(n){Re(n,t,"render"),e=t._vnode}finally{Ht=null}return Array.isArray(e)&&1===e.length&&(e=e[0]),e instanceof pe||(e=ve()),e.parent=i,e}}(wn);var Sn=[String,RegExp,Array],Tn={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:Sn,exclude:Sn,max:[String,Number]},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var e in this.cache)On(this.cache,e,this.keys)},mounted:function(){var e=this;this.$watch("include",function(t){An(e,function(e){return kn(t,e)})}),this.$watch("exclude",function(t){An(e,function(e){return!kn(t,e)})})},render:function(){var e=this.$slots.default,t=zt(e),n=t&&t.componentOptions;if(n){var r=xn(n),i=this.include,o=this.exclude;if(i&&(!r||!kn(i,r))||o&&r&&kn(o,r))return t;var a=this.cache,s=this.keys,c=null==t.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):t.key;a[c]?(t.componentInstance=a[c].componentInstance,h(s,c),s.push(c)):(a[c]=t,s.push(c),this.max&&s.length>parseInt(this.max)&&On(a,s[0],s,this._vnode)),t.data.keepAlive=!0}return t||e&&e[0]}}};!function(e){var t={get:function(){return F}};Object.defineProperty(e,"config",t),e.util={warn:ae,extend:A,mergeOptions:De,defineReactive:xe},e.set=ke,e.delete=Ae,e.nextTick=Ye,e.observable=function(e){return Ce(e),e},e.options=Object.create(null),M.forEach(function(t){e.options[t+"s"]=Object.create(null)}),e.options._base=e,A(e.options.components,Tn),function(e){e.use=function(e){var t=this._installedPlugins||(this._installedPlugins=[]);if(t.indexOf(e)>-1)return this;var n=k(arguments,1);return n.unshift(this),"function"==typeof e.install?e.install.apply(e,n):"function"==typeof e&&e.apply(null,n),t.push(e),this}}(e),function(e){e.mixin=function(e){return this.options=De(this.options,e),this}}(e),Cn(e),function(e){M.forEach(function(t){e[t]=function(e,n){return n?("component"===t&&s(n)&&(n.name=n.name||e,n=this.options._base.extend(n)),"directive"===t&&"function"==typeof n&&(n={bind:n,update:n}),this.options[t+"s"][e]=n,n):this.options[t+"s"][e]}})}(e)}(wn),Object.defineProperty(wn.prototype,"$isServer",{get:te}),Object.defineProperty(wn.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(wn,"FunctionalRenderContext",{value:Tt}),wn.version="2.6.11";var En=p("style,class"),Nn=p("input,textarea,option,select,progress"),jn=function(e,t,n){return"value"===n&&Nn(e)&&"button"!==t||"selected"===n&&"option"===e||"checked"===n&&"input"===e||"muted"===n&&"video"===e},Dn=p("contenteditable,draggable,spellcheck"),Ln=p("events,caret,typing,plaintext-only"),Mn=function(e,t){return Hn(t)||"false"===t?"false":"contenteditable"===e&&Ln(t)?t:"true"},In=p("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),Fn="http://www.w3.org/1999/xlink",Pn=function(e){return":"===e.charAt(5)&&"xlink"===e.slice(0,5)},Rn=function(e){return Pn(e)?e.slice(6,e.length):""},Hn=function(e){return null==e||!1===e};function Bn(e){for(var t=e.data,r=e,i=e;n(i.componentInstance);)(i=i.componentInstance._vnode)&&i.data&&(t=Un(i.data,t));for(;n(r=r.parent);)r&&r.data&&(t=Un(t,r.data));return function(e,t){if(n(e)||n(t))return zn(e,Vn(t));return""}(t.staticClass,t.class)}function Un(e,t){return{staticClass:zn(e.staticClass,t.staticClass),class:n(e.class)?[e.class,t.class]:t.class}}function zn(e,t){return e?t?e+" "+t:e:t||""}function Vn(e){return Array.isArray(e)?function(e){for(var t,r="",i=0,o=e.length;i<o;i++)n(t=Vn(e[i]))&&""!==t&&(r&&(r+=" "),r+=t);return r}(e):o(e)?function(e){var t="";for(var n in e)e[n]&&(t&&(t+=" "),t+=n);return t}(e):"string"==typeof e?e:""}var Kn={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},Jn=p("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),qn=p("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Wn=function(e){return Jn(e)||qn(e)};function Zn(e){return qn(e)?"svg":"math"===e?"math":void 0}var Gn=Object.create(null);var Xn=p("text,number,password,search,email,tel,url");function Yn(e){if("string"==typeof e){var t=document.querySelector(e);return t||document.createElement("div")}return e}var Qn=Object.freeze({createElement:function(e,t){var n=document.createElement(e);return"select"!==e?n:(t.data&&t.data.attrs&&void 0!==t.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)},createElementNS:function(e,t){return document.createElementNS(Kn[e],t)},createTextNode:function(e){return document.createTextNode(e)},createComment:function(e){return document.createComment(e)},insertBefore:function(e,t,n){e.insertBefore(t,n)},removeChild:function(e,t){e.removeChild(t)},appendChild:function(e,t){e.appendChild(t)},parentNode:function(e){return e.parentNode},nextSibling:function(e){return e.nextSibling},tagName:function(e){return e.tagName},setTextContent:function(e,t){e.textContent=t},setStyleScope:function(e,t){e.setAttribute(t,"")}}),er={create:function(e,t){tr(t)},update:function(e,t){e.data.ref!==t.data.ref&&(tr(e,!0),tr(t))},destroy:function(e){tr(e,!0)}};function tr(e,t){var r=e.data.ref;if(n(r)){var i=e.context,o=e.componentInstance||e.elm,a=i.$refs;t?Array.isArray(a[r])?h(a[r],o):a[r]===o&&(a[r]=void 0):e.data.refInFor?Array.isArray(a[r])?a[r].indexOf(o)<0&&a[r].push(o):a[r]=[o]:a[r]=o}}var nr=new pe("",{},[]),rr=["create","activate","update","remove","destroy"];function ir(e,i){return e.key===i.key&&(e.tag===i.tag&&e.isComment===i.isComment&&n(e.data)===n(i.data)&&function(e,t){if("input"!==e.tag)return!0;var r,i=n(r=e.data)&&n(r=r.attrs)&&r.type,o=n(r=t.data)&&n(r=r.attrs)&&r.type;return i===o||Xn(i)&&Xn(o)}(e,i)||r(e.isAsyncPlaceholder)&&e.asyncFactory===i.asyncFactory&&t(i.asyncFactory.error))}function or(e,t,r){var i,o,a={};for(i=t;i<=r;++i)n(o=e[i].key)&&(a[o]=i);return a}var ar={create:sr,update:sr,destroy:function(e){sr(e,nr)}};function sr(e,t){(e.data.directives||t.data.directives)&&function(e,t){var n,r,i,o=e===nr,a=t===nr,s=ur(e.data.directives,e.context),c=ur(t.data.directives,t.context),u=[],l=[];for(n in c)r=s[n],i=c[n],r?(i.oldValue=r.value,i.oldArg=r.arg,fr(i,"update",t,e),i.def&&i.def.componentUpdated&&l.push(i)):(fr(i,"bind",t,e),i.def&&i.def.inserted&&u.push(i));if(u.length){var f=function(){for(var n=0;n<u.length;n++)fr(u[n],"inserted",t,e)};o?it(t,"insert",f):f()}l.length&&it(t,"postpatch",function(){for(var n=0;n<l.length;n++)fr(l[n],"componentUpdated",t,e)});if(!o)for(n in s)c[n]||fr(s[n],"unbind",e,e,a)}(e,t)}var cr=Object.create(null);function ur(e,t){var n,r,i=Object.create(null);if(!e)return i;for(n=0;n<e.length;n++)(r=e[n]).modifiers||(r.modifiers=cr),i[lr(r)]=r,r.def=Le(t.$options,"directives",r.name);return i}function lr(e){return e.rawName||e.name+"."+Object.keys(e.modifiers||{}).join(".")}function fr(e,t,n,r,i){var o=e.def&&e.def[t];if(o)try{o(n.elm,e,n,r,i)}catch(r){Re(r,n.context,"directive "+e.name+" "+t+" hook")}}var pr=[er,ar];function dr(e,r){var i=r.componentOptions;if(!(n(i)&&!1===i.Ctor.options.inheritAttrs||t(e.data.attrs)&&t(r.data.attrs))){var o,a,s=r.elm,c=e.data.attrs||{},u=r.data.attrs||{};for(o in n(u.__ob__)&&(u=r.data.attrs=A({},u)),u)a=u[o],c[o]!==a&&vr(s,o,a);for(o in(q||Z)&&u.value!==c.value&&vr(s,"value",u.value),c)t(u[o])&&(Pn(o)?s.removeAttributeNS(Fn,Rn(o)):Dn(o)||s.removeAttribute(o))}}function vr(e,t,n){e.tagName.indexOf("-")>-1?hr(e,t,n):In(t)?Hn(n)?e.removeAttribute(t):(n="allowfullscreen"===t&&"EMBED"===e.tagName?"true":t,e.setAttribute(t,n)):Dn(t)?e.setAttribute(t,Mn(t,n)):Pn(t)?Hn(n)?e.removeAttributeNS(Fn,Rn(t)):e.setAttributeNS(Fn,t,n):hr(e,t,n)}function hr(e,t,n){if(Hn(n))e.removeAttribute(t);else{if(q&&!W&&"TEXTAREA"===e.tagName&&"placeholder"===t&&""!==n&&!e.__ieph){var r=function(t){t.stopImmediatePropagation(),e.removeEventListener("input",r)};e.addEventListener("input",r),e.__ieph=!0}e.setAttribute(t,n)}}var mr={create:dr,update:dr};function yr(e,r){var i=r.elm,o=r.data,a=e.data;if(!(t(o.staticClass)&&t(o.class)&&(t(a)||t(a.staticClass)&&t(a.class)))){var s=Bn(r),c=i._transitionClasses;n(c)&&(s=zn(s,Vn(c))),s!==i._prevClass&&(i.setAttribute("class",s),i._prevClass=s)}}var gr,_r,br,$r,wr,Cr,xr={create:yr,update:yr},kr=/[\w).+\-_$\]]/;function Ar(e){var t,n,r,i,o,a=!1,s=!1,c=!1,u=!1,l=0,f=0,p=0,d=0;for(r=0;r<e.length;r++)if(n=t,t=e.charCodeAt(r),a)39===t&&92!==n&&(a=!1);else if(s)34===t&&92!==n&&(s=!1);else if(c)96===t&&92!==n&&(c=!1);else if(u)47===t&&92!==n&&(u=!1);else if(124!==t||124===e.charCodeAt(r+1)||124===e.charCodeAt(r-1)||l||f||p){switch(t){case 34:s=!0;break;case 39:a=!0;break;case 96:c=!0;break;case 40:p++;break;case 41:p--;break;case 91:f++;break;case 93:f--;break;case 123:l++;break;case 125:l--}if(47===t){for(var v=r-1,h=void 0;v>=0&&" "===(h=e.charAt(v));v--);h&&kr.test(h)||(u=!0)}}else void 0===i?(d=r+1,i=e.slice(0,r).trim()):m();function m(){(o||(o=[])).push(e.slice(d,r).trim()),d=r+1}if(void 0===i?i=e.slice(0,r).trim():0!==d&&m(),o)for(r=0;r<o.length;r++)i=Or(i,o[r]);return i}function Or(e,t){var n=t.indexOf("(");if(n<0)return'_f("'+t+'")('+e+")";var r=t.slice(0,n),i=t.slice(n+1);return'_f("'+r+'")('+e+(")"!==i?","+i:i)}function Sr(e,t){console.error("[Vue compiler]: "+e)}function Tr(e,t){return e?e.map(function(e){return e[t]}).filter(function(e){return e}):[]}function Er(e,t,n,r,i){(e.props||(e.props=[])).push(Rr({name:t,value:n,dynamic:i},r)),e.plain=!1}function Nr(e,t,n,r,i){(i?e.dynamicAttrs||(e.dynamicAttrs=[]):e.attrs||(e.attrs=[])).push(Rr({name:t,value:n,dynamic:i},r)),e.plain=!1}function jr(e,t,n,r){e.attrsMap[t]=n,e.attrsList.push(Rr({name:t,value:n},r))}function Dr(e,t,n,r,i,o,a,s){(e.directives||(e.directives=[])).push(Rr({name:t,rawName:n,value:r,arg:i,isDynamicArg:o,modifiers:a},s)),e.plain=!1}function Lr(e,t,n){return n?"_p("+t+',"'+e+'")':e+t}function Mr(t,n,r,i,o,a,s,c){var u;(i=i||e).right?c?n="("+n+")==='click'?'contextmenu':("+n+")":"click"===n&&(n="contextmenu",delete i.right):i.middle&&(c?n="("+n+")==='click'?'mouseup':("+n+")":"click"===n&&(n="mouseup")),i.capture&&(delete i.capture,n=Lr("!",n,c)),i.once&&(delete i.once,n=Lr("~",n,c)),i.passive&&(delete i.passive,n=Lr("&",n,c)),i.native?(delete i.native,u=t.nativeEvents||(t.nativeEvents={})):u=t.events||(t.events={});var l=Rr({value:r.trim(),dynamic:c},s);i!==e&&(l.modifiers=i);var f=u[n];Array.isArray(f)?o?f.unshift(l):f.push(l):u[n]=f?o?[l,f]:[f,l]:l,t.plain=!1}function Ir(e,t,n){var r=Fr(e,":"+t)||Fr(e,"v-bind:"+t);if(null!=r)return Ar(r);if(!1!==n){var i=Fr(e,t);if(null!=i)return JSON.stringify(i)}}function Fr(e,t,n){var r;if(null!=(r=e.attrsMap[t]))for(var i=e.attrsList,o=0,a=i.length;o<a;o++)if(i[o].name===t){i.splice(o,1);break}return n&&delete e.attrsMap[t],r}function Pr(e,t){for(var n=e.attrsList,r=0,i=n.length;r<i;r++){var o=n[r];if(t.test(o.name))return n.splice(r,1),o}}function Rr(e,t){return t&&(null!=t.start&&(e.start=t.start),null!=t.end&&(e.end=t.end)),e}function Hr(e,t,n){var r=n||{},i=r.number,o="$$v";r.trim&&(o="(typeof $$v === 'string'? $$v.trim(): $$v)"),i&&(o="_n("+o+")");var a=Br(t,o);e.model={value:"("+t+")",expression:JSON.stringify(t),callback:"function ($$v) {"+a+"}"}}function Br(e,t){var n=function(e){if(e=e.trim(),gr=e.length,e.indexOf("[")<0||e.lastIndexOf("]")<gr-1)return($r=e.lastIndexOf("."))>-1?{exp:e.slice(0,$r),key:'"'+e.slice($r+1)+'"'}:{exp:e,key:null};_r=e,$r=wr=Cr=0;for(;!zr();)Vr(br=Ur())?Jr(br):91===br&&Kr(br);return{exp:e.slice(0,wr),key:e.slice(wr+1,Cr)}}(e);return null===n.key?e+"="+t:"$set("+n.exp+", "+n.key+", "+t+")"}function Ur(){return _r.charCodeAt(++$r)}function zr(){return $r>=gr}function Vr(e){return 34===e||39===e}function Kr(e){var t=1;for(wr=$r;!zr();)if(Vr(e=Ur()))Jr(e);else if(91===e&&t++,93===e&&t--,0===t){Cr=$r;break}}function Jr(e){for(var t=e;!zr()&&(e=Ur())!==t;);}var qr,Wr="__r",Zr="__c";function Gr(e,t,n){var r=qr;return function i(){null!==t.apply(null,arguments)&&Qr(e,i,n,r)}}var Xr=Ve&&!(X&&Number(X[1])<=53);function Yr(e,t,n,r){if(Xr){var i=an,o=t;t=o._wrapper=function(e){if(e.target===e.currentTarget||e.timeStamp>=i||e.timeStamp<=0||e.target.ownerDocument!==document)return o.apply(this,arguments)}}qr.addEventListener(e,t,Q?{capture:n,passive:r}:n)}function Qr(e,t,n,r){(r||qr).removeEventListener(e,t._wrapper||t,n)}function ei(e,r){if(!t(e.data.on)||!t(r.data.on)){var i=r.data.on||{},o=e.data.on||{};qr=r.elm,function(e){if(n(e[Wr])){var t=q?"change":"input";e[t]=[].concat(e[Wr],e[t]||[]),delete e[Wr]}n(e[Zr])&&(e.change=[].concat(e[Zr],e.change||[]),delete e[Zr])}(i),rt(i,o,Yr,Qr,Gr,r.context),qr=void 0}}var ti,ni={create:ei,update:ei};function ri(e,r){if(!t(e.data.domProps)||!t(r.data.domProps)){var i,o,a=r.elm,s=e.data.domProps||{},c=r.data.domProps||{};for(i in n(c.__ob__)&&(c=r.data.domProps=A({},c)),s)i in c||(a[i]="");for(i in c){if(o=c[i],"textContent"===i||"innerHTML"===i){if(r.children&&(r.children.length=0),o===s[i])continue;1===a.childNodes.length&&a.removeChild(a.childNodes[0])}if("value"===i&&"PROGRESS"!==a.tagName){a._value=o;var u=t(o)?"":String(o);ii(a,u)&&(a.value=u)}else if("innerHTML"===i&&qn(a.tagName)&&t(a.innerHTML)){(ti=ti||document.createElement("div")).innerHTML="<svg>"+o+"</svg>";for(var l=ti.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;l.firstChild;)a.appendChild(l.firstChild)}else if(o!==s[i])try{a[i]=o}catch(e){}}}}function ii(e,t){return!e.composing&&("OPTION"===e.tagName||function(e,t){var n=!0;try{n=document.activeElement!==e}catch(e){}return n&&e.value!==t}(e,t)||function(e,t){var r=e.value,i=e._vModifiers;if(n(i)){if(i.number)return f(r)!==f(t);if(i.trim)return r.trim()!==t.trim()}return r!==t}(e,t))}var oi={create:ri,update:ri},ai=g(function(e){var t={},n=/:(.+)/;return e.split(/;(?![^(]*\))/g).forEach(function(e){if(e){var r=e.split(n);r.length>1&&(t[r[0].trim()]=r[1].trim())}}),t});function si(e){var t=ci(e.style);return e.staticStyle?A(e.staticStyle,t):t}function ci(e){return Array.isArray(e)?O(e):"string"==typeof e?ai(e):e}var ui,li=/^--/,fi=/\s*!important$/,pi=function(e,t,n){if(li.test(t))e.style.setProperty(t,n);else if(fi.test(n))e.style.setProperty(C(t),n.replace(fi,""),"important");else{var r=vi(t);if(Array.isArray(n))for(var i=0,o=n.length;i<o;i++)e.style[r]=n[i];else e.style[r]=n}},di=["Webkit","Moz","ms"],vi=g(function(e){if(ui=ui||document.createElement("div").style,"filter"!==(e=b(e))&&e in ui)return e;for(var t=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<di.length;n++){var r=di[n]+t;if(r in ui)return r}});function hi(e,r){var i=r.data,o=e.data;if(!(t(i.staticStyle)&&t(i.style)&&t(o.staticStyle)&&t(o.style))){var a,s,c=r.elm,u=o.staticStyle,l=o.normalizedStyle||o.style||{},f=u||l,p=ci(r.data.style)||{};r.data.normalizedStyle=n(p.__ob__)?A({},p):p;var d=function(e,t){var n,r={};if(t)for(var i=e;i.componentInstance;)(i=i.componentInstance._vnode)&&i.data&&(n=si(i.data))&&A(r,n);(n=si(e.data))&&A(r,n);for(var o=e;o=o.parent;)o.data&&(n=si(o.data))&&A(r,n);return r}(r,!0);for(s in f)t(d[s])&&pi(c,s,"");for(s in d)(a=d[s])!==f[s]&&pi(c,s,null==a?"":a)}}var mi={create:hi,update:hi},yi=/\s+/;function gi(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(yi).forEach(function(t){return e.classList.add(t)}):e.classList.add(t);else{var n=" "+(e.getAttribute("class")||"")+" ";n.indexOf(" "+t+" ")<0&&e.setAttribute("class",(n+t).trim())}}function _i(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(yi).forEach(function(t){return e.classList.remove(t)}):e.classList.remove(t),e.classList.length||e.removeAttribute("class");else{for(var n=" "+(e.getAttribute("class")||"")+" ",r=" "+t+" ";n.indexOf(r)>=0;)n=n.replace(r," ");(n=n.trim())?e.setAttribute("class",n):e.removeAttribute("class")}}function bi(e){if(e){if("object"==typeof e){var t={};return!1!==e.css&&A(t,$i(e.name||"v")),A(t,e),t}return"string"==typeof e?$i(e):void 0}}var $i=g(function(e){return{enterClass:e+"-enter",enterToClass:e+"-enter-to",enterActiveClass:e+"-enter-active",leaveClass:e+"-leave",leaveToClass:e+"-leave-to",leaveActiveClass:e+"-leave-active"}}),wi=z&&!W,Ci="transition",xi="animation",ki="transition",Ai="transitionend",Oi="animation",Si="animationend";wi&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(ki="WebkitTransition",Ai="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Oi="WebkitAnimation",Si="webkitAnimationEnd"));var Ti=z?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(e){return e()};function Ei(e){Ti(function(){Ti(e)})}function Ni(e,t){var n=e._transitionClasses||(e._transitionClasses=[]);n.indexOf(t)<0&&(n.push(t),gi(e,t))}function ji(e,t){e._transitionClasses&&h(e._transitionClasses,t),_i(e,t)}function Di(e,t,n){var r=Mi(e,t),i=r.type,o=r.timeout,a=r.propCount;if(!i)return n();var s=i===Ci?Ai:Si,c=0,u=function(){e.removeEventListener(s,l),n()},l=function(t){t.target===e&&++c>=a&&u()};setTimeout(function(){c<a&&u()},o+1),e.addEventListener(s,l)}var Li=/\b(transform|all)(,|$)/;function Mi(e,t){var n,r=window.getComputedStyle(e),i=(r[ki+"Delay"]||"").split(", "),o=(r[ki+"Duration"]||"").split(", "),a=Ii(i,o),s=(r[Oi+"Delay"]||"").split(", "),c=(r[Oi+"Duration"]||"").split(", "),u=Ii(s,c),l=0,f=0;return t===Ci?a>0&&(n=Ci,l=a,f=o.length):t===xi?u>0&&(n=xi,l=u,f=c.length):f=(n=(l=Math.max(a,u))>0?a>u?Ci:xi:null)?n===Ci?o.length:c.length:0,{type:n,timeout:l,propCount:f,hasTransform:n===Ci&&Li.test(r[ki+"Property"])}}function Ii(e,t){for(;e.length<t.length;)e=e.concat(e);return Math.max.apply(null,t.map(function(t,n){return Fi(t)+Fi(e[n])}))}function Fi(e){return 1e3*Number(e.slice(0,-1).replace(",","."))}function Pi(e,r){var i=e.elm;n(i._leaveCb)&&(i._leaveCb.cancelled=!0,i._leaveCb());var a=bi(e.data.transition);if(!t(a)&&!n(i._enterCb)&&1===i.nodeType){for(var s=a.css,c=a.type,u=a.enterClass,l=a.enterToClass,p=a.enterActiveClass,d=a.appearClass,v=a.appearToClass,h=a.appearActiveClass,m=a.beforeEnter,y=a.enter,g=a.afterEnter,_=a.enterCancelled,b=a.beforeAppear,$=a.appear,w=a.afterAppear,C=a.appearCancelled,x=a.duration,k=Wt,A=Wt.$vnode;A&&A.parent;)k=A.context,A=A.parent;var O=!k._isMounted||!e.isRootInsert;if(!O||$||""===$){var S=O&&d?d:u,T=O&&h?h:p,E=O&&v?v:l,N=O&&b||m,j=O&&"function"==typeof $?$:y,L=O&&w||g,M=O&&C||_,I=f(o(x)?x.enter:x),F=!1!==s&&!W,P=Bi(j),R=i._enterCb=D(function(){F&&(ji(i,E),ji(i,T)),R.cancelled?(F&&ji(i,S),M&&M(i)):L&&L(i),i._enterCb=null});e.data.show||it(e,"insert",function(){var t=i.parentNode,n=t&&t._pending&&t._pending[e.key];n&&n.tag===e.tag&&n.elm._leaveCb&&n.elm._leaveCb(),j&&j(i,R)}),N&&N(i),F&&(Ni(i,S),Ni(i,T),Ei(function(){ji(i,S),R.cancelled||(Ni(i,E),P||(Hi(I)?setTimeout(R,I):Di(i,c,R)))})),e.data.show&&(r&&r(),j&&j(i,R)),F||P||R()}}}function Ri(e,r){var i=e.elm;n(i._enterCb)&&(i._enterCb.cancelled=!0,i._enterCb());var a=bi(e.data.transition);if(t(a)||1!==i.nodeType)return r();if(!n(i._leaveCb)){var s=a.css,c=a.type,u=a.leaveClass,l=a.leaveToClass,p=a.leaveActiveClass,d=a.beforeLeave,v=a.leave,h=a.afterLeave,m=a.leaveCancelled,y=a.delayLeave,g=a.duration,_=!1!==s&&!W,b=Bi(v),$=f(o(g)?g.leave:g),w=i._leaveCb=D(function(){i.parentNode&&i.parentNode._pending&&(i.parentNode._pending[e.key]=null),_&&(ji(i,l),ji(i,p)),w.cancelled?(_&&ji(i,u),m&&m(i)):(r(),h&&h(i)),i._leaveCb=null});y?y(C):C()}function C(){w.cancelled||(!e.data.show&&i.parentNode&&((i.parentNode._pending||(i.parentNode._pending={}))[e.key]=e),d&&d(i),_&&(Ni(i,u),Ni(i,p),Ei(function(){ji(i,u),w.cancelled||(Ni(i,l),b||(Hi($)?setTimeout(w,$):Di(i,c,w)))})),v&&v(i,w),_||b||w())}}function Hi(e){return"number"==typeof e&&!isNaN(e)}function Bi(e){if(t(e))return!1;var r=e.fns;return n(r)?Bi(Array.isArray(r)?r[0]:r):(e._length||e.length)>1}function Ui(e,t){!0!==t.data.show&&Pi(t)}var zi=function(e){var o,a,s={},c=e.modules,u=e.nodeOps;for(o=0;o<rr.length;++o)for(s[rr[o]]=[],a=0;a<c.length;++a)n(c[a][rr[o]])&&s[rr[o]].push(c[a][rr[o]]);function l(e){var t=u.parentNode(e);n(t)&&u.removeChild(t,e)}function f(e,t,i,o,a,c,l){if(n(e.elm)&&n(c)&&(e=c[l]=me(e)),e.isRootInsert=!a,!function(e,t,i,o){var a=e.data;if(n(a)){var c=n(e.componentInstance)&&a.keepAlive;if(n(a=a.hook)&&n(a=a.init)&&a(e,!1),n(e.componentInstance))return d(e,t),v(i,e.elm,o),r(c)&&function(e,t,r,i){for(var o,a=e;a.componentInstance;)if(a=a.componentInstance._vnode,n(o=a.data)&&n(o=o.transition)){for(o=0;o<s.activate.length;++o)s.activate[o](nr,a);t.push(a);break}v(r,e.elm,i)}(e,t,i,o),!0}}(e,t,i,o)){var f=e.data,p=e.children,m=e.tag;n(m)?(e.elm=e.ns?u.createElementNS(e.ns,m):u.createElement(m,e),g(e),h(e,p,t),n(f)&&y(e,t),v(i,e.elm,o)):r(e.isComment)?(e.elm=u.createComment(e.text),v(i,e.elm,o)):(e.elm=u.createTextNode(e.text),v(i,e.elm,o))}}function d(e,t){n(e.data.pendingInsert)&&(t.push.apply(t,e.data.pendingInsert),e.data.pendingInsert=null),e.elm=e.componentInstance.$el,m(e)?(y(e,t),g(e)):(tr(e),t.push(e))}function v(e,t,r){n(e)&&(n(r)?u.parentNode(r)===e&&u.insertBefore(e,t,r):u.appendChild(e,t))}function h(e,t,n){if(Array.isArray(t))for(var r=0;r<t.length;++r)f(t[r],n,e.elm,null,!0,t,r);else i(e.text)&&u.appendChild(e.elm,u.createTextNode(String(e.text)))}function m(e){for(;e.componentInstance;)e=e.componentInstance._vnode;return n(e.tag)}function y(e,t){for(var r=0;r<s.create.length;++r)s.create[r](nr,e);n(o=e.data.hook)&&(n(o.create)&&o.create(nr,e),n(o.insert)&&t.push(e))}function g(e){var t;if(n(t=e.fnScopeId))u.setStyleScope(e.elm,t);else for(var r=e;r;)n(t=r.context)&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t),r=r.parent;n(t=Wt)&&t!==e.context&&t!==e.fnContext&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t)}function _(e,t,n,r,i,o){for(;r<=i;++r)f(n[r],o,e,t,!1,n,r)}function b(e){var t,r,i=e.data;if(n(i))for(n(t=i.hook)&&n(t=t.destroy)&&t(e),t=0;t<s.destroy.length;++t)s.destroy[t](e);if(n(t=e.children))for(r=0;r<e.children.length;++r)b(e.children[r])}function $(e,t,r){for(;t<=r;++t){var i=e[t];n(i)&&(n(i.tag)?(w(i),b(i)):l(i.elm))}}function w(e,t){if(n(t)||n(e.data)){var r,i=s.remove.length+1;for(n(t)?t.listeners+=i:t=function(e,t){function n(){0==--n.listeners&&l(e)}return n.listeners=t,n}(e.elm,i),n(r=e.componentInstance)&&n(r=r._vnode)&&n(r.data)&&w(r,t),r=0;r<s.remove.length;++r)s.remove[r](e,t);n(r=e.data.hook)&&n(r=r.remove)?r(e,t):t()}else l(e.elm)}function C(e,t,r,i){for(var o=r;o<i;o++){var a=t[o];if(n(a)&&ir(e,a))return o}}function x(e,i,o,a,c,l){if(e!==i){n(i.elm)&&n(a)&&(i=a[c]=me(i));var p=i.elm=e.elm;if(r(e.isAsyncPlaceholder))n(i.asyncFactory.resolved)?O(e.elm,i,o):i.isAsyncPlaceholder=!0;else if(r(i.isStatic)&&r(e.isStatic)&&i.key===e.key&&(r(i.isCloned)||r(i.isOnce)))i.componentInstance=e.componentInstance;else{var d,v=i.data;n(v)&&n(d=v.hook)&&n(d=d.prepatch)&&d(e,i);var h=e.children,y=i.children;if(n(v)&&m(i)){for(d=0;d<s.update.length;++d)s.update[d](e,i);n(d=v.hook)&&n(d=d.update)&&d(e,i)}t(i.text)?n(h)&&n(y)?h!==y&&function(e,r,i,o,a){for(var s,c,l,p=0,d=0,v=r.length-1,h=r[0],m=r[v],y=i.length-1,g=i[0],b=i[y],w=!a;p<=v&&d<=y;)t(h)?h=r[++p]:t(m)?m=r[--v]:ir(h,g)?(x(h,g,o,i,d),h=r[++p],g=i[++d]):ir(m,b)?(x(m,b,o,i,y),m=r[--v],b=i[--y]):ir(h,b)?(x(h,b,o,i,y),w&&u.insertBefore(e,h.elm,u.nextSibling(m.elm)),h=r[++p],b=i[--y]):ir(m,g)?(x(m,g,o,i,d),w&&u.insertBefore(e,m.elm,h.elm),m=r[--v],g=i[++d]):(t(s)&&(s=or(r,p,v)),t(c=n(g.key)?s[g.key]:C(g,r,p,v))?f(g,o,e,h.elm,!1,i,d):ir(l=r[c],g)?(x(l,g,o,i,d),r[c]=void 0,w&&u.insertBefore(e,l.elm,h.elm)):f(g,o,e,h.elm,!1,i,d),g=i[++d]);p>v?_(e,t(i[y+1])?null:i[y+1].elm,i,d,y,o):d>y&&$(r,p,v)}(p,h,y,o,l):n(y)?(n(e.text)&&u.setTextContent(p,""),_(p,null,y,0,y.length-1,o)):n(h)?$(h,0,h.length-1):n(e.text)&&u.setTextContent(p,""):e.text!==i.text&&u.setTextContent(p,i.text),n(v)&&n(d=v.hook)&&n(d=d.postpatch)&&d(e,i)}}}function k(e,t,i){if(r(i)&&n(e.parent))e.parent.data.pendingInsert=t;else for(var o=0;o<t.length;++o)t[o].data.hook.insert(t[o])}var A=p("attrs,class,staticClass,staticStyle,key");function O(e,t,i,o){var a,s=t.tag,c=t.data,u=t.children;if(o=o||c&&c.pre,t.elm=e,r(t.isComment)&&n(t.asyncFactory))return t.isAsyncPlaceholder=!0,!0;if(n(c)&&(n(a=c.hook)&&n(a=a.init)&&a(t,!0),n(a=t.componentInstance)))return d(t,i),!0;if(n(s)){if(n(u))if(e.hasChildNodes())if(n(a=c)&&n(a=a.domProps)&&n(a=a.innerHTML)){if(a!==e.innerHTML)return!1}else{for(var l=!0,f=e.firstChild,p=0;p<u.length;p++){if(!f||!O(f,u[p],i,o)){l=!1;break}f=f.nextSibling}if(!l||f)return!1}else h(t,u,i);if(n(c)){var v=!1;for(var m in c)if(!A(m)){v=!0,y(t,i);break}!v&&c.class&&et(c.class)}}else e.data!==t.text&&(e.data=t.text);return!0}return function(e,i,o,a){if(!t(i)){var c,l=!1,p=[];if(t(e))l=!0,f(i,p);else{var d=n(e.nodeType);if(!d&&ir(e,i))x(e,i,p,null,null,a);else{if(d){if(1===e.nodeType&&e.hasAttribute(L)&&(e.removeAttribute(L),o=!0),r(o)&&O(e,i,p))return k(i,p,!0),e;c=e,e=new pe(u.tagName(c).toLowerCase(),{},[],void 0,c)}var v=e.elm,h=u.parentNode(v);if(f(i,p,v._leaveCb?null:h,u.nextSibling(v)),n(i.parent))for(var y=i.parent,g=m(i);y;){for(var _=0;_<s.destroy.length;++_)s.destroy[_](y);if(y.elm=i.elm,g){for(var w=0;w<s.create.length;++w)s.create[w](nr,y);var C=y.data.hook.insert;if(C.merged)for(var A=1;A<C.fns.length;A++)C.fns[A]()}else tr(y);y=y.parent}n(h)?$([e],0,0):n(e.tag)&&b(e)}}return k(i,p,l),i.elm}n(e)&&b(e)}}({nodeOps:Qn,modules:[mr,xr,ni,oi,mi,z?{create:Ui,activate:Ui,remove:function(e,t){!0!==e.data.show?Ri(e,t):t()}}:{}].concat(pr)});W&&document.addEventListener("selectionchange",function(){var e=document.activeElement;e&&e.vmodel&&Xi(e,"input")});var Vi={inserted:function(e,t,n,r){"select"===n.tag?(r.elm&&!r.elm._vOptions?it(n,"postpatch",function(){Vi.componentUpdated(e,t,n)}):Ki(e,t,n.context),e._vOptions=[].map.call(e.options,Wi)):("textarea"===n.tag||Xn(e.type))&&(e._vModifiers=t.modifiers,t.modifiers.lazy||(e.addEventListener("compositionstart",Zi),e.addEventListener("compositionend",Gi),e.addEventListener("change",Gi),W&&(e.vmodel=!0)))},componentUpdated:function(e,t,n){if("select"===n.tag){Ki(e,t,n.context);var r=e._vOptions,i=e._vOptions=[].map.call(e.options,Wi);if(i.some(function(e,t){return!N(e,r[t])}))(e.multiple?t.value.some(function(e){return qi(e,i)}):t.value!==t.oldValue&&qi(t.value,i))&&Xi(e,"change")}}};function Ki(e,t,n){Ji(e,t,n),(q||Z)&&setTimeout(function(){Ji(e,t,n)},0)}function Ji(e,t,n){var r=t.value,i=e.multiple;if(!i||Array.isArray(r)){for(var o,a,s=0,c=e.options.length;s<c;s++)if(a=e.options[s],i)o=j(r,Wi(a))>-1,a.selected!==o&&(a.selected=o);else if(N(Wi(a),r))return void(e.selectedIndex!==s&&(e.selectedIndex=s));i||(e.selectedIndex=-1)}}function qi(e,t){return t.every(function(t){return!N(t,e)})}function Wi(e){return"_value"in e?e._value:e.value}function Zi(e){e.target.composing=!0}function Gi(e){e.target.composing&&(e.target.composing=!1,Xi(e.target,"input"))}function Xi(e,t){var n=document.createEvent("HTMLEvents");n.initEvent(t,!0,!0),e.dispatchEvent(n)}function Yi(e){return!e.componentInstance||e.data&&e.data.transition?e:Yi(e.componentInstance._vnode)}var Qi={model:Vi,show:{bind:function(e,t,n){var r=t.value,i=(n=Yi(n)).data&&n.data.transition,o=e.__vOriginalDisplay="none"===e.style.display?"":e.style.display;r&&i?(n.data.show=!0,Pi(n,function(){e.style.display=o})):e.style.display=r?o:"none"},update:function(e,t,n){var r=t.value;!r!=!t.oldValue&&((n=Yi(n)).data&&n.data.transition?(n.data.show=!0,r?Pi(n,function(){e.style.display=e.__vOriginalDisplay}):Ri(n,function(){e.style.display="none"})):e.style.display=r?e.__vOriginalDisplay:"none")},unbind:function(e,t,n,r,i){i||(e.style.display=e.__vOriginalDisplay)}}},eo={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function to(e){var t=e&&e.componentOptions;return t&&t.Ctor.options.abstract?to(zt(t.children)):e}function no(e){var t={},n=e.$options;for(var r in n.propsData)t[r]=e[r];var i=n._parentListeners;for(var o in i)t[b(o)]=i[o];return t}function ro(e,t){if(/\d-keep-alive$/.test(t.tag))return e("keep-alive",{props:t.componentOptions.propsData})}var io=function(e){return e.tag||Ut(e)},oo=function(e){return"show"===e.name},ao={name:"transition",props:eo,abstract:!0,render:function(e){var t=this,n=this.$slots.default;if(n&&(n=n.filter(io)).length){var r=this.mode,o=n[0];if(function(e){for(;e=e.parent;)if(e.data.transition)return!0}(this.$vnode))return o;var a=to(o);if(!a)return o;if(this._leaving)return ro(e,o);var s="__transition-"+this._uid+"-";a.key=null==a.key?a.isComment?s+"comment":s+a.tag:i(a.key)?0===String(a.key).indexOf(s)?a.key:s+a.key:a.key;var c=(a.data||(a.data={})).transition=no(this),u=this._vnode,l=to(u);if(a.data.directives&&a.data.directives.some(oo)&&(a.data.show=!0),l&&l.data&&!function(e,t){return t.key===e.key&&t.tag===e.tag}(a,l)&&!Ut(l)&&(!l.componentInstance||!l.componentInstance._vnode.isComment)){var f=l.data.transition=A({},c);if("out-in"===r)return this._leaving=!0,it(f,"afterLeave",function(){t._leaving=!1,t.$forceUpdate()}),ro(e,o);if("in-out"===r){if(Ut(a))return u;var p,d=function(){p()};it(c,"afterEnter",d),it(c,"enterCancelled",d),it(f,"delayLeave",function(e){p=e})}}return o}}},so=A({tag:String,moveClass:String},eo);function co(e){e.elm._moveCb&&e.elm._moveCb(),e.elm._enterCb&&e.elm._enterCb()}function uo(e){e.data.newPos=e.elm.getBoundingClientRect()}function lo(e){var t=e.data.pos,n=e.data.newPos,r=t.left-n.left,i=t.top-n.top;if(r||i){e.data.moved=!0;var o=e.elm.style;o.transform=o.WebkitTransform="translate("+r+"px,"+i+"px)",o.transitionDuration="0s"}}delete so.mode;var fo={Transition:ao,TransitionGroup:{props:so,beforeMount:function(){var e=this,t=this._update;this._update=function(n,r){var i=Zt(e);e.__patch__(e._vnode,e.kept,!1,!0),e._vnode=e.kept,i(),t.call(e,n,r)}},render:function(e){for(var t=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,i=this.$slots.default||[],o=this.children=[],a=no(this),s=0;s<i.length;s++){var c=i[s];c.tag&&null!=c.key&&0!==String(c.key).indexOf("__vlist")&&(o.push(c),n[c.key]=c,(c.data||(c.data={})).transition=a)}if(r){for(var u=[],l=[],f=0;f<r.length;f++){var p=r[f];p.data.transition=a,p.data.pos=p.elm.getBoundingClientRect(),n[p.key]?u.push(p):l.push(p)}this.kept=e(t,null,u),this.removed=l}return e(t,null,o)},updated:function(){var e=this.prevChildren,t=this.moveClass||(this.name||"v")+"-move";e.length&&this.hasMove(e[0].elm,t)&&(e.forEach(co),e.forEach(uo),e.forEach(lo),this._reflow=document.body.offsetHeight,e.forEach(function(e){if(e.data.moved){var n=e.elm,r=n.style;Ni(n,t),r.transform=r.WebkitTransform=r.transitionDuration="",n.addEventListener(Ai,n._moveCb=function e(r){r&&r.target!==n||r&&!/transform$/.test(r.propertyName)||(n.removeEventListener(Ai,e),n._moveCb=null,ji(n,t))})}}))},methods:{hasMove:function(e,t){if(!wi)return!1;if(this._hasMove)return this._hasMove;var n=e.cloneNode();e._transitionClasses&&e._transitionClasses.forEach(function(e){_i(n,e)}),gi(n,t),n.style.display="none",this.$el.appendChild(n);var r=Mi(n);return this.$el.removeChild(n),this._hasMove=r.hasTransform}}}};wn.config.mustUseProp=jn,wn.config.isReservedTag=Wn,wn.config.isReservedAttr=En,wn.config.getTagNamespace=Zn,wn.config.isUnknownElement=function(e){if(!z)return!0;if(Wn(e))return!1;if(e=e.toLowerCase(),null!=Gn[e])return Gn[e];var t=document.createElement(e);return e.indexOf("-")>-1?Gn[e]=t.constructor===window.HTMLUnknownElement||t.constructor===window.HTMLElement:Gn[e]=/HTMLUnknownElement/.test(t.toString())},A(wn.options.directives,Qi),A(wn.options.components,fo),wn.prototype.__patch__=z?zi:S,wn.prototype.$mount=function(e,t){return function(e,t,n){var r;return e.$el=t,e.$options.render||(e.$options.render=ve),Yt(e,"beforeMount"),r=function(){e._update(e._render(),n)},new fn(e,r,S,{before:function(){e._isMounted&&!e._isDestroyed&&Yt(e,"beforeUpdate")}},!0),n=!1,null==e.$vnode&&(e._isMounted=!0,Yt(e,"mounted")),e}(this,e=e&&z?Yn(e):void 0,t)},z&&setTimeout(function(){F.devtools&&ne&&ne.emit("init",wn)},0);var po=/\{\{((?:.|\r?\n)+?)\}\}/g,vo=/[-.*+?^${}()|[\]\/\\]/g,ho=g(function(e){var t=e[0].replace(vo,"\\$&"),n=e[1].replace(vo,"\\$&");return new RegExp(t+"((?:.|\\n)+?)"+n,"g")});var mo={staticKeys:["staticClass"],transformNode:function(e,t){t.warn;var n=Fr(e,"class");n&&(e.staticClass=JSON.stringify(n));var r=Ir(e,"class",!1);r&&(e.classBinding=r)},genData:function(e){var t="";return e.staticClass&&(t+="staticClass:"+e.staticClass+","),e.classBinding&&(t+="class:"+e.classBinding+","),t}};var yo,go={staticKeys:["staticStyle"],transformNode:function(e,t){t.warn;var n=Fr(e,"style");n&&(e.staticStyle=JSON.stringify(ai(n)));var r=Ir(e,"style",!1);r&&(e.styleBinding=r)},genData:function(e){var t="";return e.staticStyle&&(t+="staticStyle:"+e.staticStyle+","),e.styleBinding&&(t+="style:("+e.styleBinding+"),"),t}},_o=function(e){return(yo=yo||document.createElement("div")).innerHTML=e,yo.textContent},bo=p("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),$o=p("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),wo=p("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),Co=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,xo=/^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,ko="[a-zA-Z_][\\-\\.0-9_a-zA-Z"+P.source+"]*",Ao="((?:"+ko+"\\:)?"+ko+")",Oo=new RegExp("^<"+Ao),So=/^\s*(\/?)>/,To=new RegExp("^<\\/"+Ao+"[^>]*>"),Eo=/^<!DOCTYPE [^>]+>/i,No=/^<!\--/,jo=/^<!\[/,Do=p("script,style,textarea",!0),Lo={},Mo={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t","&#39;":"'"},Io=/&(?:lt|gt|quot|amp|#39);/g,Fo=/&(?:lt|gt|quot|amp|#39|#10|#9);/g,Po=p("pre,textarea",!0),Ro=function(e,t){return e&&Po(e)&&"\n"===t[0]};function Ho(e,t){var n=t?Fo:Io;return e.replace(n,function(e){return Mo[e]})}var Bo,Uo,zo,Vo,Ko,Jo,qo,Wo,Zo=/^@|^v-on:/,Go=/^v-|^@|^:|^#/,Xo=/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,Yo=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,Qo=/^\(|\)$/g,ea=/^\[.*\]$/,ta=/:(.*)$/,na=/^:|^\.|^v-bind:/,ra=/\.[^.\]]+(?=[^\]]*$)/g,ia=/^v-slot(:|$)|^#/,oa=/[\r\n]/,aa=/\s+/g,sa=g(_o),ca="_empty_";function ua(e,t,n){return{type:1,tag:e,attrsList:t,attrsMap:ma(t),rawAttrsMap:{},parent:n,children:[]}}function la(e,t){Bo=t.warn||Sr,Jo=t.isPreTag||T,qo=t.mustUseProp||T,Wo=t.getTagNamespace||T;t.isReservedTag;zo=Tr(t.modules,"transformNode"),Vo=Tr(t.modules,"preTransformNode"),Ko=Tr(t.modules,"postTransformNode"),Uo=t.delimiters;var n,r,i=[],o=!1!==t.preserveWhitespace,a=t.whitespace,s=!1,c=!1;function u(e){if(l(e),s||e.processed||(e=fa(e,t)),i.length||e===n||n.if&&(e.elseif||e.else)&&da(n,{exp:e.elseif,block:e}),r&&!e.forbidden)if(e.elseif||e.else)a=e,(u=function(e){var t=e.length;for(;t--;){if(1===e[t].type)return e[t];e.pop()}}(r.children))&&u.if&&da(u,{exp:a.elseif,block:a});else{if(e.slotScope){var o=e.slotTarget||'"default"';(r.scopedSlots||(r.scopedSlots={}))[o]=e}r.children.push(e),e.parent=r}var a,u;e.children=e.children.filter(function(e){return!e.slotScope}),l(e),e.pre&&(s=!1),Jo(e.tag)&&(c=!1);for(var f=0;f<Ko.length;f++)Ko[f](e,t)}function l(e){if(!c)for(var t;(t=e.children[e.children.length-1])&&3===t.type&&" "===t.text;)e.children.pop()}return function(e,t){for(var n,r,i=[],o=t.expectHTML,a=t.isUnaryTag||T,s=t.canBeLeftOpenTag||T,c=0;e;){if(n=e,r&&Do(r)){var u=0,l=r.toLowerCase(),f=Lo[l]||(Lo[l]=new RegExp("([\\s\\S]*?)(</"+l+"[^>]*>)","i")),p=e.replace(f,function(e,n,r){return u=r.length,Do(l)||"noscript"===l||(n=n.replace(/<!\--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),Ro(l,n)&&(n=n.slice(1)),t.chars&&t.chars(n),""});c+=e.length-p.length,e=p,A(l,c-u,c)}else{var d=e.indexOf("<");if(0===d){if(No.test(e)){var v=e.indexOf("--\x3e");if(v>=0){t.shouldKeepComment&&t.comment(e.substring(4,v),c,c+v+3),C(v+3);continue}}if(jo.test(e)){var h=e.indexOf("]>");if(h>=0){C(h+2);continue}}var m=e.match(Eo);if(m){C(m[0].length);continue}var y=e.match(To);if(y){var g=c;C(y[0].length),A(y[1],g,c);continue}var _=x();if(_){k(_),Ro(_.tagName,e)&&C(1);continue}}var b=void 0,$=void 0,w=void 0;if(d>=0){for($=e.slice(d);!(To.test($)||Oo.test($)||No.test($)||jo.test($)||(w=$.indexOf("<",1))<0);)d+=w,$=e.slice(d);b=e.substring(0,d)}d<0&&(b=e),b&&C(b.length),t.chars&&b&&t.chars(b,c-b.length,c)}if(e===n){t.chars&&t.chars(e);break}}function C(t){c+=t,e=e.substring(t)}function x(){var t=e.match(Oo);if(t){var n,r,i={tagName:t[1],attrs:[],start:c};for(C(t[0].length);!(n=e.match(So))&&(r=e.match(xo)||e.match(Co));)r.start=c,C(r[0].length),r.end=c,i.attrs.push(r);if(n)return i.unarySlash=n[1],C(n[0].length),i.end=c,i}}function k(e){var n=e.tagName,c=e.unarySlash;o&&("p"===r&&wo(n)&&A(r),s(n)&&r===n&&A(n));for(var u=a(n)||!!c,l=e.attrs.length,f=new Array(l),p=0;p<l;p++){var d=e.attrs[p],v=d[3]||d[4]||d[5]||"",h="a"===n&&"href"===d[1]?t.shouldDecodeNewlinesForHref:t.shouldDecodeNewlines;f[p]={name:d[1],value:Ho(v,h)}}u||(i.push({tag:n,lowerCasedTag:n.toLowerCase(),attrs:f,start:e.start,end:e.end}),r=n),t.start&&t.start(n,f,u,e.start,e.end)}function A(e,n,o){var a,s;if(null==n&&(n=c),null==o&&(o=c),e)for(s=e.toLowerCase(),a=i.length-1;a>=0&&i[a].lowerCasedTag!==s;a--);else a=0;if(a>=0){for(var u=i.length-1;u>=a;u--)t.end&&t.end(i[u].tag,n,o);i.length=a,r=a&&i[a-1].tag}else"br"===s?t.start&&t.start(e,[],!0,n,o):"p"===s&&(t.start&&t.start(e,[],!1,n,o),t.end&&t.end(e,n,o))}A()}(e,{warn:Bo,expectHTML:t.expectHTML,isUnaryTag:t.isUnaryTag,canBeLeftOpenTag:t.canBeLeftOpenTag,shouldDecodeNewlines:t.shouldDecodeNewlines,shouldDecodeNewlinesForHref:t.shouldDecodeNewlinesForHref,shouldKeepComment:t.comments,outputSourceRange:t.outputSourceRange,start:function(e,o,a,l,f){var p=r&&r.ns||Wo(e);q&&"svg"===p&&(o=function(e){for(var t=[],n=0;n<e.length;n++){var r=e[n];ya.test(r.name)||(r.name=r.name.replace(ga,""),t.push(r))}return t}(o));var d,v=ua(e,o,r);p&&(v.ns=p),"style"!==(d=v).tag&&("script"!==d.tag||d.attrsMap.type&&"text/javascript"!==d.attrsMap.type)||te()||(v.forbidden=!0);for(var h=0;h<Vo.length;h++)v=Vo[h](v,t)||v;s||(!function(e){null!=Fr(e,"v-pre")&&(e.pre=!0)}(v),v.pre&&(s=!0)),Jo(v.tag)&&(c=!0),s?function(e){var t=e.attrsList,n=t.length;if(n)for(var r=e.attrs=new Array(n),i=0;i<n;i++)r[i]={name:t[i].name,value:JSON.stringify(t[i].value)},null!=t[i].start&&(r[i].start=t[i].start,r[i].end=t[i].end);else e.pre||(e.plain=!0)}(v):v.processed||(pa(v),function(e){var t=Fr(e,"v-if");if(t)e.if=t,da(e,{exp:t,block:e});else{null!=Fr(e,"v-else")&&(e.else=!0);var n=Fr(e,"v-else-if");n&&(e.elseif=n)}}(v),function(e){null!=Fr(e,"v-once")&&(e.once=!0)}(v)),n||(n=v),a?u(v):(r=v,i.push(v))},end:function(e,t,n){var o=i[i.length-1];i.length-=1,r=i[i.length-1],u(o)},chars:function(e,t,n){if(r&&(!q||"textarea"!==r.tag||r.attrsMap.placeholder!==e)){var i,u,l,f=r.children;if(e=c||e.trim()?"script"===(i=r).tag||"style"===i.tag?e:sa(e):f.length?a?"condense"===a&&oa.test(e)?"":" ":o?" ":"":"")c||"condense"!==a||(e=e.replace(aa," ")),!s&&" "!==e&&(u=function(e,t){var n=t?ho(t):po;if(n.test(e)){for(var r,i,o,a=[],s=[],c=n.lastIndex=0;r=n.exec(e);){(i=r.index)>c&&(s.push(o=e.slice(c,i)),a.push(JSON.stringify(o)));var u=Ar(r[1].trim());a.push("_s("+u+")"),s.push({"@binding":u}),c=i+r[0].length}return c<e.length&&(s.push(o=e.slice(c)),a.push(JSON.stringify(o))),{expression:a.join("+"),tokens:s}}}(e,Uo))?l={type:2,expression:u.expression,tokens:u.tokens,text:e}:" "===e&&f.length&&" "===f[f.length-1].text||(l={type:3,text:e}),l&&f.push(l)}},comment:function(e,t,n){if(r){var i={type:3,text:e,isComment:!0};r.children.push(i)}}}),n}function fa(e,t){var n,r;(r=Ir(n=e,"key"))&&(n.key=r),e.plain=!e.key&&!e.scopedSlots&&!e.attrsList.length,function(e){var t=Ir(e,"ref");t&&(e.ref=t,e.refInFor=function(e){var t=e;for(;t;){if(void 0!==t.for)return!0;t=t.parent}return!1}(e))}(e),function(e){var t;"template"===e.tag?(t=Fr(e,"scope"),e.slotScope=t||Fr(e,"slot-scope")):(t=Fr(e,"slot-scope"))&&(e.slotScope=t);var n=Ir(e,"slot");n&&(e.slotTarget='""'===n?'"default"':n,e.slotTargetDynamic=!(!e.attrsMap[":slot"]&&!e.attrsMap["v-bind:slot"]),"template"===e.tag||e.slotScope||Nr(e,"slot",n,function(e,t){return e.rawAttrsMap[":"+t]||e.rawAttrsMap["v-bind:"+t]||e.rawAttrsMap[t]}(e,"slot")));if("template"===e.tag){var r=Pr(e,ia);if(r){var i=va(r),o=i.name,a=i.dynamic;e.slotTarget=o,e.slotTargetDynamic=a,e.slotScope=r.value||ca}}else{var s=Pr(e,ia);if(s){var c=e.scopedSlots||(e.scopedSlots={}),u=va(s),l=u.name,f=u.dynamic,p=c[l]=ua("template",[],e);p.slotTarget=l,p.slotTargetDynamic=f,p.children=e.children.filter(function(e){if(!e.slotScope)return e.parent=p,!0}),p.slotScope=s.value||ca,e.children=[],e.plain=!1}}}(e),function(e){"slot"===e.tag&&(e.slotName=Ir(e,"name"))}(e),function(e){var t;(t=Ir(e,"is"))&&(e.component=t);null!=Fr(e,"inline-template")&&(e.inlineTemplate=!0)}(e);for(var i=0;i<zo.length;i++)e=zo[i](e,t)||e;return function(e){var t,n,r,i,o,a,s,c,u=e.attrsList;for(t=0,n=u.length;t<n;t++)if(r=i=u[t].name,o=u[t].value,Go.test(r))if(e.hasBindings=!0,(a=ha(r.replace(Go,"")))&&(r=r.replace(ra,"")),na.test(r))r=r.replace(na,""),o=Ar(o),(c=ea.test(r))&&(r=r.slice(1,-1)),a&&(a.prop&&!c&&"innerHtml"===(r=b(r))&&(r="innerHTML"),a.camel&&!c&&(r=b(r)),a.sync&&(s=Br(o,"$event"),c?Mr(e,'"update:"+('+r+")",s,null,!1,0,u[t],!0):(Mr(e,"update:"+b(r),s,null,!1,0,u[t]),C(r)!==b(r)&&Mr(e,"update:"+C(r),s,null,!1,0,u[t])))),a&&a.prop||!e.component&&qo(e.tag,e.attrsMap.type,r)?Er(e,r,o,u[t],c):Nr(e,r,o,u[t],c);else if(Zo.test(r))r=r.replace(Zo,""),(c=ea.test(r))&&(r=r.slice(1,-1)),Mr(e,r,o,a,!1,0,u[t],c);else{var l=(r=r.replace(Go,"")).match(ta),f=l&&l[1];c=!1,f&&(r=r.slice(0,-(f.length+1)),ea.test(f)&&(f=f.slice(1,-1),c=!0)),Dr(e,r,i,o,f,c,a,u[t])}else Nr(e,r,JSON.stringify(o),u[t]),!e.component&&"muted"===r&&qo(e.tag,e.attrsMap.type,r)&&Er(e,r,"true",u[t])}(e),e}function pa(e){var t;if(t=Fr(e,"v-for")){var n=function(e){var t=e.match(Xo);if(!t)return;var n={};n.for=t[2].trim();var r=t[1].trim().replace(Qo,""),i=r.match(Yo);i?(n.alias=r.replace(Yo,"").trim(),n.iterator1=i[1].trim(),i[2]&&(n.iterator2=i[2].trim())):n.alias=r;return n}(t);n&&A(e,n)}}function da(e,t){e.ifConditions||(e.ifConditions=[]),e.ifConditions.push(t)}function va(e){var t=e.name.replace(ia,"");return t||"#"!==e.name[0]&&(t="default"),ea.test(t)?{name:t.slice(1,-1),dynamic:!0}:{name:'"'+t+'"',dynamic:!1}}function ha(e){var t=e.match(ra);if(t){var n={};return t.forEach(function(e){n[e.slice(1)]=!0}),n}}function ma(e){for(var t={},n=0,r=e.length;n<r;n++)t[e[n].name]=e[n].value;return t}var ya=/^xmlns:NS\d+/,ga=/^NS\d+:/;function _a(e){return ua(e.tag,e.attrsList.slice(),e.parent)}var ba=[mo,go,{preTransformNode:function(e,t){if("input"===e.tag){var n,r=e.attrsMap;if(!r["v-model"])return;if((r[":type"]||r["v-bind:type"])&&(n=Ir(e,"type")),r.type||n||!r["v-bind"]||(n="("+r["v-bind"]+").type"),n){var i=Fr(e,"v-if",!0),o=i?"&&("+i+")":"",a=null!=Fr(e,"v-else",!0),s=Fr(e,"v-else-if",!0),c=_a(e);pa(c),jr(c,"type","checkbox"),fa(c,t),c.processed=!0,c.if="("+n+")==='checkbox'"+o,da(c,{exp:c.if,block:c});var u=_a(e);Fr(u,"v-for",!0),jr(u,"type","radio"),fa(u,t),da(c,{exp:"("+n+")==='radio'"+o,block:u});var l=_a(e);return Fr(l,"v-for",!0),jr(l,":type",n),fa(l,t),da(c,{exp:i,block:l}),a?c.else=!0:s&&(c.elseif=s),c}}}}];var $a,wa,Ca={expectHTML:!0,modules:ba,directives:{model:function(e,t,n){var r=t.value,i=t.modifiers,o=e.tag,a=e.attrsMap.type;if(e.component)return Hr(e,r,i),!1;if("select"===o)!function(e,t,n){var r='var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '+(n&&n.number?"_n(val)":"val")+"});";r=r+" "+Br(t,"$event.target.multiple ? $$selectedVal : $$selectedVal[0]"),Mr(e,"change",r,null,!0)}(e,r,i);else if("input"===o&&"checkbox"===a)!function(e,t,n){var r=n&&n.number,i=Ir(e,"value")||"null",o=Ir(e,"true-value")||"true",a=Ir(e,"false-value")||"false";Er(e,"checked","Array.isArray("+t+")?_i("+t+","+i+")>-1"+("true"===o?":("+t+")":":_q("+t+","+o+")")),Mr(e,"change","var $$a="+t+",$$el=$event.target,$$c=$$el.checked?("+o+"):("+a+");if(Array.isArray($$a)){var $$v="+(r?"_n("+i+")":i)+",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&("+Br(t,"$$a.concat([$$v])")+")}else{$$i>-1&&("+Br(t,"$$a.slice(0,$$i).concat($$a.slice($$i+1))")+")}}else{"+Br(t,"$$c")+"}",null,!0)}(e,r,i);else if("input"===o&&"radio"===a)!function(e,t,n){var r=n&&n.number,i=Ir(e,"value")||"null";Er(e,"checked","_q("+t+","+(i=r?"_n("+i+")":i)+")"),Mr(e,"change",Br(t,i),null,!0)}(e,r,i);else if("input"===o||"textarea"===o)!function(e,t,n){var r=e.attrsMap.type,i=n||{},o=i.lazy,a=i.number,s=i.trim,c=!o&&"range"!==r,u=o?"change":"range"===r?Wr:"input",l="$event.target.value";s&&(l="$event.target.value.trim()"),a&&(l="_n("+l+")");var f=Br(t,l);c&&(f="if($event.target.composing)return;"+f),Er(e,"value","("+t+")"),Mr(e,u,f,null,!0),(s||a)&&Mr(e,"blur","$forceUpdate()")}(e,r,i);else if(!F.isReservedTag(o))return Hr(e,r,i),!1;return!0},text:function(e,t){t.value&&Er(e,"textContent","_s("+t.value+")",t)},html:function(e,t){t.value&&Er(e,"innerHTML","_s("+t.value+")",t)}},isPreTag:function(e){return"pre"===e},isUnaryTag:bo,mustUseProp:jn,canBeLeftOpenTag:$o,isReservedTag:Wn,getTagNamespace:Zn,staticKeys:function(e){return e.reduce(function(e,t){return e.concat(t.staticKeys||[])},[]).join(",")}(ba)},xa=g(function(e){return p("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap"+(e?","+e:""))});function ka(e,t){e&&($a=xa(t.staticKeys||""),wa=t.isReservedTag||T,function e(t){t.static=function(e){if(2===e.type)return!1;if(3===e.type)return!0;return!(!e.pre&&(e.hasBindings||e.if||e.for||d(e.tag)||!wa(e.tag)||function(e){for(;e.parent;){if("template"!==(e=e.parent).tag)return!1;if(e.for)return!0}return!1}(e)||!Object.keys(e).every($a)))}(t);if(1===t.type){if(!wa(t.tag)&&"slot"!==t.tag&&null==t.attrsMap["inline-template"])return;for(var n=0,r=t.children.length;n<r;n++){var i=t.children[n];e(i),i.static||(t.static=!1)}if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++){var s=t.ifConditions[o].block;e(s),s.static||(t.static=!1)}}}(e),function e(t,n){if(1===t.type){if((t.static||t.once)&&(t.staticInFor=n),t.static&&t.children.length&&(1!==t.children.length||3!==t.children[0].type))return void(t.staticRoot=!0);if(t.staticRoot=!1,t.children)for(var r=0,i=t.children.length;r<i;r++)e(t.children[r],n||!!t.for);if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++)e(t.ifConditions[o].block,n)}}(e,!1))}var Aa=/^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,Oa=/\([^)]*?\);*$/,Sa=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,Ta={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},Ea={esc:["Esc","Escape"],tab:"Tab",enter:"Enter",space:[" ","Spacebar"],up:["Up","ArrowUp"],left:["Left","ArrowLeft"],right:["Right","ArrowRight"],down:["Down","ArrowDown"],delete:["Backspace","Delete","Del"]},Na=function(e){return"if("+e+")return null;"},ja={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:Na("$event.target !== $event.currentTarget"),ctrl:Na("!$event.ctrlKey"),shift:Na("!$event.shiftKey"),alt:Na("!$event.altKey"),meta:Na("!$event.metaKey"),left:Na("'button' in $event && $event.button !== 0"),middle:Na("'button' in $event && $event.button !== 1"),right:Na("'button' in $event && $event.button !== 2")};function Da(e,t){var n=t?"nativeOn:":"on:",r="",i="";for(var o in e){var a=La(e[o]);e[o]&&e[o].dynamic?i+=o+","+a+",":r+='"'+o+'":'+a+","}return r="{"+r.slice(0,-1)+"}",i?n+"_d("+r+",["+i.slice(0,-1)+"])":n+r}function La(e){if(!e)return"function(){}";if(Array.isArray(e))return"["+e.map(function(e){return La(e)}).join(",")+"]";var t=Sa.test(e.value),n=Aa.test(e.value),r=Sa.test(e.value.replace(Oa,""));if(e.modifiers){var i="",o="",a=[];for(var s in e.modifiers)if(ja[s])o+=ja[s],Ta[s]&&a.push(s);else if("exact"===s){var c=e.modifiers;o+=Na(["ctrl","shift","alt","meta"].filter(function(e){return!c[e]}).map(function(e){return"$event."+e+"Key"}).join("||"))}else a.push(s);return a.length&&(i+=function(e){return"if(!$event.type.indexOf('key')&&"+e.map(Ma).join("&&")+")return null;"}(a)),o&&(i+=o),"function($event){"+i+(t?"return "+e.value+"($event)":n?"return ("+e.value+")($event)":r?"return "+e.value:e.value)+"}"}return t||n?e.value:"function($event){"+(r?"return "+e.value:e.value)+"}"}function Ma(e){var t=parseInt(e,10);if(t)return"$event.keyCode!=="+t;var n=Ta[e],r=Ea[e];return"_k($event.keyCode,"+JSON.stringify(e)+","+JSON.stringify(n)+",$event.key,"+JSON.stringify(r)+")"}var Ia={on:function(e,t){e.wrapListeners=function(e){return"_g("+e+","+t.value+")"}},bind:function(e,t){e.wrapData=function(n){return"_b("+n+",'"+e.tag+"',"+t.value+","+(t.modifiers&&t.modifiers.prop?"true":"false")+(t.modifiers&&t.modifiers.sync?",true":"")+")"}},cloak:S},Fa=function(e){this.options=e,this.warn=e.warn||Sr,this.transforms=Tr(e.modules,"transformCode"),this.dataGenFns=Tr(e.modules,"genData"),this.directives=A(A({},Ia),e.directives);var t=e.isReservedTag||T;this.maybeComponent=function(e){return!!e.component||!t(e.tag)},this.onceId=0,this.staticRenderFns=[],this.pre=!1};function Pa(e,t){var n=new Fa(t);return{render:"with(this){return "+(e?Ra(e,n):'_c("div")')+"}",staticRenderFns:n.staticRenderFns}}function Ra(e,t){if(e.parent&&(e.pre=e.pre||e.parent.pre),e.staticRoot&&!e.staticProcessed)return Ha(e,t);if(e.once&&!e.onceProcessed)return Ba(e,t);if(e.for&&!e.forProcessed)return za(e,t);if(e.if&&!e.ifProcessed)return Ua(e,t);if("template"!==e.tag||e.slotTarget||t.pre){if("slot"===e.tag)return function(e,t){var n=e.slotName||'"default"',r=qa(e,t),i="_t("+n+(r?","+r:""),o=e.attrs||e.dynamicAttrs?Ga((e.attrs||[]).concat(e.dynamicAttrs||[]).map(function(e){return{name:b(e.name),value:e.value,dynamic:e.dynamic}})):null,a=e.attrsMap["v-bind"];!o&&!a||r||(i+=",null");o&&(i+=","+o);a&&(i+=(o?"":",null")+","+a);return i+")"}(e,t);var n;if(e.component)n=function(e,t,n){var r=t.inlineTemplate?null:qa(t,n,!0);return"_c("+e+","+Va(t,n)+(r?","+r:"")+")"}(e.component,e,t);else{var r;(!e.plain||e.pre&&t.maybeComponent(e))&&(r=Va(e,t));var i=e.inlineTemplate?null:qa(e,t,!0);n="_c('"+e.tag+"'"+(r?","+r:"")+(i?","+i:"")+")"}for(var o=0;o<t.transforms.length;o++)n=t.transforms[o](e,n);return n}return qa(e,t)||"void 0"}function Ha(e,t){e.staticProcessed=!0;var n=t.pre;return e.pre&&(t.pre=e.pre),t.staticRenderFns.push("with(this){return "+Ra(e,t)+"}"),t.pre=n,"_m("+(t.staticRenderFns.length-1)+(e.staticInFor?",true":"")+")"}function Ba(e,t){if(e.onceProcessed=!0,e.if&&!e.ifProcessed)return Ua(e,t);if(e.staticInFor){for(var n="",r=e.parent;r;){if(r.for){n=r.key;break}r=r.parent}return n?"_o("+Ra(e,t)+","+t.onceId+++","+n+")":Ra(e,t)}return Ha(e,t)}function Ua(e,t,n,r){return e.ifProcessed=!0,function e(t,n,r,i){if(!t.length)return i||"_e()";var o=t.shift();return o.exp?"("+o.exp+")?"+a(o.block)+":"+e(t,n,r,i):""+a(o.block);function a(e){return r?r(e,n):e.once?Ba(e,n):Ra(e,n)}}(e.ifConditions.slice(),t,n,r)}function za(e,t,n,r){var i=e.for,o=e.alias,a=e.iterator1?","+e.iterator1:"",s=e.iterator2?","+e.iterator2:"";return e.forProcessed=!0,(r||"_l")+"(("+i+"),function("+o+a+s+"){return "+(n||Ra)(e,t)+"})"}function Va(e,t){var n="{",r=function(e,t){var n=e.directives;if(!n)return;var r,i,o,a,s="directives:[",c=!1;for(r=0,i=n.length;r<i;r++){o=n[r],a=!0;var u=t.directives[o.name];u&&(a=!!u(e,o,t.warn)),a&&(c=!0,s+='{name:"'+o.name+'",rawName:"'+o.rawName+'"'+(o.value?",value:("+o.value+"),expression:"+JSON.stringify(o.value):"")+(o.arg?",arg:"+(o.isDynamicArg?o.arg:'"'+o.arg+'"'):"")+(o.modifiers?",modifiers:"+JSON.stringify(o.modifiers):"")+"},")}if(c)return s.slice(0,-1)+"]"}(e,t);r&&(n+=r+","),e.key&&(n+="key:"+e.key+","),e.ref&&(n+="ref:"+e.ref+","),e.refInFor&&(n+="refInFor:true,"),e.pre&&(n+="pre:true,"),e.component&&(n+='tag:"'+e.tag+'",');for(var i=0;i<t.dataGenFns.length;i++)n+=t.dataGenFns[i](e);if(e.attrs&&(n+="attrs:"+Ga(e.attrs)+","),e.props&&(n+="domProps:"+Ga(e.props)+","),e.events&&(n+=Da(e.events,!1)+","),e.nativeEvents&&(n+=Da(e.nativeEvents,!0)+","),e.slotTarget&&!e.slotScope&&(n+="slot:"+e.slotTarget+","),e.scopedSlots&&(n+=function(e,t,n){var r=e.for||Object.keys(t).some(function(e){var n=t[e];return n.slotTargetDynamic||n.if||n.for||Ka(n)}),i=!!e.if;if(!r)for(var o=e.parent;o;){if(o.slotScope&&o.slotScope!==ca||o.for){r=!0;break}o.if&&(i=!0),o=o.parent}var a=Object.keys(t).map(function(e){return Ja(t[e],n)}).join(",");return"scopedSlots:_u(["+a+"]"+(r?",null,true":"")+(!r&&i?",null,false,"+function(e){var t=5381,n=e.length;for(;n;)t=33*t^e.charCodeAt(--n);return t>>>0}(a):"")+")"}(e,e.scopedSlots,t)+","),e.model&&(n+="model:{value:"+e.model.value+",callback:"+e.model.callback+",expression:"+e.model.expression+"},"),e.inlineTemplate){var o=function(e,t){var n=e.children[0];if(n&&1===n.type){var r=Pa(n,t.options);return"inlineTemplate:{render:function(){"+r.render+"},staticRenderFns:["+r.staticRenderFns.map(function(e){return"function(){"+e+"}"}).join(",")+"]}"}}(e,t);o&&(n+=o+",")}return n=n.replace(/,$/,"")+"}",e.dynamicAttrs&&(n="_b("+n+',"'+e.tag+'",'+Ga(e.dynamicAttrs)+")"),e.wrapData&&(n=e.wrapData(n)),e.wrapListeners&&(n=e.wrapListeners(n)),n}function Ka(e){return 1===e.type&&("slot"===e.tag||e.children.some(Ka))}function Ja(e,t){var n=e.attrsMap["slot-scope"];if(e.if&&!e.ifProcessed&&!n)return Ua(e,t,Ja,"null");if(e.for&&!e.forProcessed)return za(e,t,Ja);var r=e.slotScope===ca?"":String(e.slotScope),i="function("+r+"){return "+("template"===e.tag?e.if&&n?"("+e.if+")?"+(qa(e,t)||"undefined")+":undefined":qa(e,t)||"undefined":Ra(e,t))+"}",o=r?"":",proxy:true";return"{key:"+(e.slotTarget||'"default"')+",fn:"+i+o+"}"}function qa(e,t,n,r,i){var o=e.children;if(o.length){var a=o[0];if(1===o.length&&a.for&&"template"!==a.tag&&"slot"!==a.tag){var s=n?t.maybeComponent(a)?",1":",0":"";return""+(r||Ra)(a,t)+s}var c=n?function(e,t){for(var n=0,r=0;r<e.length;r++){var i=e[r];if(1===i.type){if(Wa(i)||i.ifConditions&&i.ifConditions.some(function(e){return Wa(e.block)})){n=2;break}(t(i)||i.ifConditions&&i.ifConditions.some(function(e){return t(e.block)}))&&(n=1)}}return n}(o,t.maybeComponent):0,u=i||Za;return"["+o.map(function(e){return u(e,t)}).join(",")+"]"+(c?","+c:"")}}function Wa(e){return void 0!==e.for||"template"===e.tag||"slot"===e.tag}function Za(e,t){return 1===e.type?Ra(e,t):3===e.type&&e.isComment?(r=e,"_e("+JSON.stringify(r.text)+")"):"_v("+(2===(n=e).type?n.expression:Xa(JSON.stringify(n.text)))+")";var n,r}function Ga(e){for(var t="",n="",r=0;r<e.length;r++){var i=e[r],o=Xa(i.value);i.dynamic?n+=i.name+","+o+",":t+='"'+i.name+'":'+o+","}return t="{"+t.slice(0,-1)+"}",n?"_d("+t+",["+n.slice(0,-1)+"])":t}function Xa(e){return e.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b");function Ya(e,t){try{return new Function(e)}catch(n){return t.push({err:n,code:e}),S}}function Qa(e){var t=Object.create(null);return function(n,r,i){(r=A({},r)).warn;delete r.warn;var o=r.delimiters?String(r.delimiters)+n:n;if(t[o])return t[o];var a=e(n,r),s={},c=[];return s.render=Ya(a.render,c),s.staticRenderFns=a.staticRenderFns.map(function(e){return Ya(e,c)}),t[o]=s}}var es,ts,ns=(es=function(e,t){var n=la(e.trim(),t);!1!==t.optimize&&ka(n,t);var r=Pa(n,t);return{ast:n,render:r.render,staticRenderFns:r.staticRenderFns}},function(e){function t(t,n){var r=Object.create(e),i=[],o=[];if(n)for(var a in n.modules&&(r.modules=(e.modules||[]).concat(n.modules)),n.directives&&(r.directives=A(Object.create(e.directives||null),n.directives)),n)"modules"!==a&&"directives"!==a&&(r[a]=n[a]);r.warn=function(e,t,n){(n?o:i).push(e)};var s=es(t.trim(),r);return s.errors=i,s.tips=o,s}return{compile:t,compileToFunctions:Qa(t)}})(Ca),rs=(ns.compile,ns.compileToFunctions);function is(e){return(ts=ts||document.createElement("div")).innerHTML=e?'<a href="\n"/>':'<div a="\n"/>',ts.innerHTML.indexOf("&#10;")>0}var os=!!z&&is(!1),as=!!z&&is(!0),ss=g(function(e){var t=Yn(e);return t&&t.innerHTML}),cs=wn.prototype.$mount;wn.prototype.$mount=function(e,t){if((e=e&&Yn(e))===document.body||e===document.documentElement)return this;var n=this.$options;if(!n.render){var r=n.template;if(r)if("string"==typeof r)"#"===r.charAt(0)&&(r=ss(r));else{if(!r.nodeType)return this;r=r.innerHTML}else e&&(r=function(e){if(e.outerHTML)return e.outerHTML;var t=document.createElement("div");return t.appendChild(e.cloneNode(!0)),t.innerHTML}(e));if(r){var i=rs(r,{outputSourceRange:!1,shouldDecodeNewlines:os,shouldDecodeNewlinesForHref:as,delimiters:n.delimiters,comments:n.comments},this),o=i.render,a=i.staticRenderFns;n.render=o,n.staticRenderFns=a}}return cs.call(this,e,t)},wn.compile=rs,module.exports=wn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(889).setImmediate))

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

	/*!
	 * VUEX-LOCALSTORAGE v1.0.0
	 * (c) 2017 crossjs
	 * Released under the MIT License.
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var index = Date.now();
	
	/**
	 * createStorage
	 *
	 * @param  {String} namespace       namespace
	 * @param  {Object} [initialState]  初始值/默认值
	 * @param  {Object} [config]         自定义 provider/serialize/deserialize/expires
	 * @return {Object}                 get/set 方法
	 */
	function createStorage (ref) {
	  if ( ref === void 0 ) ref = {};
	  var namespace = ref.namespace;
	  var initialState = ref.initialState; if ( initialState === void 0 ) initialState = {};
	  var provider = ref.provider; if ( provider === void 0 ) provider = localStorage;
	  var serialize = ref.serialize; if ( serialize === void 0 ) serialize = JSON.stringify;
	  var deserialize = ref.deserialize; if ( deserialize === void 0 ) deserialize = JSON.parse;
	  var expires = ref.expires; if ( expires === void 0 ) expires = 0;
	  var merge = ref.merge; if ( merge === void 0 ) merge = defaultMerge;
	
	  if (!namespace) {
	    namespace = "vuex-" + (++index);
	  }
	
	  return {
	    /**
	     * get
	     *
	     * @param  {String} key   key, defaults to 'default'
	     * @return {Object}       plain object
	     */
	    get: function get (key) {
	      if ( key === void 0 ) key = 'default';
	
	      var state;
	
	      try {
	        var ref = deserialize(provider.getItem((namespace + "-" + key)));
	        var value = ref.value;
	        var expires = ref.expires;
	        if (expires === 0 || expires > Date.now()) {
	          // always a plain object
	          state = deserialize(value);
	        }
	      } catch (e) {
	        // console.log(e)
	      }
	
	      return merge(key === 'default' ? initialState : initialState[key], state)
	    },
	    /**
	     * set
	     *
	     * @param  {String} key   key
	     * @param  {Object} value plain object
	     * @return {undifined}
	     */
	    set: function set (key, value) {
	      if (arguments.length === 1) {
	        value = key;
	        key = 'default';
	      }
	      try {
	        provider.setItem((namespace + "-" + key), serialize({
	          value: serialize(value),
	          expires: expires ? expires + Date.now() : expires
	        }));
	      } catch (e) {
	        // console.log(e)
	      }
	    }
	  }
	}
	
	function createPersist (ref) {
	  if ( ref === void 0 ) ref = {};
	  var namespace = ref.namespace;
	  var initialState = ref.initialState;
	  var provider = ref.provider;
	  var serialize = ref.serialize;
	  var deserialize = ref.deserialize;
	  var expires = ref.expires;
	  var merge = ref.merge; if ( merge === void 0 ) merge = defaultMerge;
	  var reducer = ref.reducer; if ( reducer === void 0 ) reducer = defaultReducer;
	  var paths = ref.paths; if ( paths === void 0 ) paths = [];
	
	  return function (store) {
	    var storage = createStorage({
	      namespace: namespace,
	      initialState: initialState,
	      provider: provider,
	      serialize: serialize,
	      deserialize: deserialize,
	      merge: merge,
	      expires: expires
	    });
	
	    store.replaceState(
	      merge(store.state, storage.get())
	    );
	
	    store.subscribe(function (mutation, state) {
	      storage.set(reducer(state, paths));
	    });
	  }
	}
	
	function defaultMerge () {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];
	
	  return Object.assign.apply(Object, [ {} ].concat( args ))
	}
	
	function defaultReducer (state, paths) {
	  return paths.length === 0
	  ? state
	  : paths.reduce(function (substate, path) {
	    if (state.hasOwnProperty(path)) {
	      var obj;
	      return Object.assign(substate, ( obj = {}, obj[path] = state[path], obj ))
	    }
	    return substate
	  }, {})
	}
	
	exports.createStorage = createStorage;
	exports['default'] = createPersist;


/***/ }),
/* 1045 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/wtf8 v1.0.0 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function wtf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte.
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read the first byte.
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				var byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid WTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function wtf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var wtf8 = {
			'version': '1.0.0',
			'encode': wtf8encode,
			'decode': wtf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return wtf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = wtf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in wtf8) {
					hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.wtf8 = wtf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(126)(module), (function() { return this; }())))

/***/ }),
/* 1048 */,
/* 1049 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ })
]);


// WEBPACK FOOTER //
// static/js/vendor.9fbde88b7fc841d6aa54.js